import "./index.css";
import * as React$2 from "react";
import React__default, { forwardRef, useContext, Children, isValidElement, cloneElement, useState, useEffect, useMemo, useRef, useReducer, useCallback, useImperativeHandle, Fragment, Component } from "react";
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function getAugmentedNamespace(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function o() {
      return this instanceof o ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(o) {
    var s = Object.getOwnPropertyDescriptor(e, o);
    Object.defineProperty(n, o, s.get ? s : {
      enumerable: !0,
      get: function() {
        return e[o];
      }
    });
  }), n;
}
var jsxRuntime = { exports: {} }, reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min)
    return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var e = React__default, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), o = Object.prototype.hasOwnProperty, s = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, l = { key: !0, ref: !0, __self: !0, __source: !0 };
  function c(p, m, C) {
    var P, w = {}, R = null, L = null;
    C !== void 0 && (R = "" + C), m.key !== void 0 && (R = "" + m.key), m.ref !== void 0 && (L = m.ref);
    for (P in m)
      o.call(m, P) && !l.hasOwnProperty(P) && (w[P] = m[P]);
    if (p && p.defaultProps)
      for (P in m = p.defaultProps, m)
        w[P] === void 0 && (w[P] = m[P]);
    return { $$typeof: t, type: p, key: R, ref: L, props: w, _owner: s.current };
  }
  return reactJsxRuntime_production_min.Fragment = n, reactJsxRuntime_production_min.jsx = c, reactJsxRuntime_production_min.jsxs = c, reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  return hasRequiredReactJsxRuntime_development || (hasRequiredReactJsxRuntime_development = 1, process.env.NODE_ENV !== "production" && function() {
    var e = React__default, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), l = Symbol.for("react.profiler"), c = Symbol.for("react.provider"), p = Symbol.for("react.context"), m = Symbol.for("react.forward_ref"), C = Symbol.for("react.suspense"), P = Symbol.for("react.suspense_list"), w = Symbol.for("react.memo"), R = Symbol.for("react.lazy"), L = Symbol.for("react.offscreen"), M = Symbol.iterator, $ = "@@iterator";
    function W(Me) {
      if (Me === null || typeof Me != "object")
        return null;
      var wt = M && Me[M] || Me[$];
      return typeof wt == "function" ? wt : null;
    }
    var H = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function V(Me) {
      {
        for (var wt = arguments.length, ur = new Array(wt > 1 ? wt - 1 : 0), jr = 1; jr < wt; jr++)
          ur[jr - 1] = arguments[jr];
        N("error", Me, ur);
      }
    }
    function N(Me, wt, ur) {
      {
        var jr = H.ReactDebugCurrentFrame, Qr = jr.getStackAddendum();
        Qr !== "" && (wt += "%s", ur = ur.concat([Qr]));
        var Ir = ur.map(function($r) {
          return String($r);
        });
        Ir.unshift("Warning: " + wt), Function.prototype.apply.call(console[Me], console, Ir);
      }
    }
    var B = !1, K = !1, ue = !1, de = !1, ve = !1, Te;
    Te = Symbol.for("react.module.reference");
    function Pe(Me) {
      return !!(typeof Me == "string" || typeof Me == "function" || Me === o || Me === l || ve || Me === s || Me === C || Me === P || de || Me === L || B || K || ue || typeof Me == "object" && Me !== null && (Me.$$typeof === R || Me.$$typeof === w || Me.$$typeof === c || Me.$$typeof === p || Me.$$typeof === m || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Me.$$typeof === Te || Me.getModuleId !== void 0));
    }
    function Ce(Me, wt, ur) {
      var jr = Me.displayName;
      if (jr)
        return jr;
      var Qr = wt.displayName || wt.name || "";
      return Qr !== "" ? ur + "(" + Qr + ")" : ur;
    }
    function Re(Me) {
      return Me.displayName || "Context";
    }
    function ke(Me) {
      if (Me == null)
        return null;
      if (typeof Me.tag == "number" && V("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof Me == "function")
        return Me.displayName || Me.name || null;
      if (typeof Me == "string")
        return Me;
      switch (Me) {
        case o:
          return "Fragment";
        case n:
          return "Portal";
        case l:
          return "Profiler";
        case s:
          return "StrictMode";
        case C:
          return "Suspense";
        case P:
          return "SuspenseList";
      }
      if (typeof Me == "object")
        switch (Me.$$typeof) {
          case p:
            var wt = Me;
            return Re(wt) + ".Consumer";
          case c:
            var ur = Me;
            return Re(ur._context) + ".Provider";
          case m:
            return Ce(Me, Me.render, "ForwardRef");
          case w:
            var jr = Me.displayName || null;
            return jr !== null ? jr : ke(Me.type) || "Memo";
          case R: {
            var Qr = Me, Ir = Qr._payload, $r = Qr._init;
            try {
              return ke($r(Ir));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Ae = Object.assign, we = 0, he, be, le, fe, ye, Ee, Ie;
    function Fe() {
    }
    Fe.__reactDisabledLog = !0;
    function De() {
      {
        if (we === 0) {
          he = console.log, be = console.info, le = console.warn, fe = console.error, ye = console.group, Ee = console.groupCollapsed, Ie = console.groupEnd;
          var Me = {
            configurable: !0,
            enumerable: !0,
            value: Fe,
            writable: !0
          };
          Object.defineProperties(console, {
            info: Me,
            log: Me,
            warn: Me,
            error: Me,
            group: Me,
            groupCollapsed: Me,
            groupEnd: Me
          });
        }
        we++;
      }
    }
    function Ve() {
      {
        if (we--, we === 0) {
          var Me = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Ae({}, Me, {
              value: he
            }),
            info: Ae({}, Me, {
              value: be
            }),
            warn: Ae({}, Me, {
              value: le
            }),
            error: Ae({}, Me, {
              value: fe
            }),
            group: Ae({}, Me, {
              value: ye
            }),
            groupCollapsed: Ae({}, Me, {
              value: Ee
            }),
            groupEnd: Ae({}, Me, {
              value: Ie
            })
          });
        }
        we < 0 && V("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = H.ReactCurrentDispatcher, Ze;
    function et(Me, wt, ur) {
      {
        if (Ze === void 0)
          try {
            throw Error();
          } catch (Qr) {
            var jr = Qr.stack.trim().match(/\n( *(at )?)/);
            Ze = jr && jr[1] || "";
          }
        return `
` + Ze + Me;
      }
    }
    var bt = !1, rr;
    {
      var St = typeof WeakMap == "function" ? WeakMap : Map;
      rr = new St();
    }
    function Qe(Me, wt) {
      if (!Me || bt)
        return "";
      {
        var ur = rr.get(Me);
        if (ur !== void 0)
          return ur;
      }
      var jr;
      bt = !0;
      var Qr = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Ir;
      Ir = Oe.current, Oe.current = null, De();
      try {
        if (wt) {
          var $r = function() {
            throw Error();
          };
          if (Object.defineProperty($r.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct($r, []);
            } catch (yn) {
              jr = yn;
            }
            Reflect.construct(Me, [], $r);
          } else {
            try {
              $r.call();
            } catch (yn) {
              jr = yn;
            }
            Me.call($r.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (yn) {
            jr = yn;
          }
          Me();
        }
      } catch (yn) {
        if (yn && jr && typeof yn.stack == "string") {
          for (var Dr = yn.stack.split(`
`), An = jr.stack.split(`
`), mr = Dr.length - 1, on = An.length - 1; mr >= 1 && on >= 0 && Dr[mr] !== An[on]; )
            on--;
          for (; mr >= 1 && on >= 0; mr--, on--)
            if (Dr[mr] !== An[on]) {
              if (mr !== 1 || on !== 1)
                do
                  if (mr--, on--, on < 0 || Dr[mr] !== An[on]) {
                    var zo = `
` + Dr[mr].replace(" at new ", " at ");
                    return Me.displayName && zo.includes("<anonymous>") && (zo = zo.replace("<anonymous>", Me.displayName)), typeof Me == "function" && rr.set(Me, zo), zo;
                  }
                while (mr >= 1 && on >= 0);
              break;
            }
        }
      } finally {
        bt = !1, Oe.current = Ir, Ve(), Error.prepareStackTrace = Qr;
      }
      var ea = Me ? Me.displayName || Me.name : "", $c = ea ? et(ea) : "";
      return typeof Me == "function" && rr.set(Me, $c), $c;
    }
    function xt(Me, wt, ur) {
      return Qe(Me, !1);
    }
    function je(Me) {
      var wt = Me.prototype;
      return !!(wt && wt.isReactComponent);
    }
    function kt(Me, wt, ur) {
      if (Me == null)
        return "";
      if (typeof Me == "function")
        return Qe(Me, je(Me));
      if (typeof Me == "string")
        return et(Me);
      switch (Me) {
        case C:
          return et("Suspense");
        case P:
          return et("SuspenseList");
      }
      if (typeof Me == "object")
        switch (Me.$$typeof) {
          case m:
            return xt(Me.render);
          case w:
            return kt(Me.type, wt, ur);
          case R: {
            var jr = Me, Qr = jr._payload, Ir = jr._init;
            try {
              return kt(Ir(Qr), wt, ur);
            } catch {
            }
          }
        }
      return "";
    }
    var cr = Object.prototype.hasOwnProperty, Tr = {}, Er = H.ReactDebugCurrentFrame;
    function Hr(Me) {
      if (Me) {
        var wt = Me._owner, ur = kt(Me.type, Me._source, wt ? wt.type : null);
        Er.setExtraStackFrame(ur);
      } else
        Er.setExtraStackFrame(null);
    }
    function Br(Me, wt, ur, jr, Qr) {
      {
        var Ir = Function.call.bind(cr);
        for (var $r in Me)
          if (Ir(Me, $r)) {
            var Dr = void 0;
            try {
              if (typeof Me[$r] != "function") {
                var An = Error((jr || "React class") + ": " + ur + " type `" + $r + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof Me[$r] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw An.name = "Invariant Violation", An;
              }
              Dr = Me[$r](wt, $r, jr, ur, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (mr) {
              Dr = mr;
            }
            Dr && !(Dr instanceof Error) && (Hr(Qr), V("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", jr || "React class", ur, $r, typeof Dr), Hr(null)), Dr instanceof Error && !(Dr.message in Tr) && (Tr[Dr.message] = !0, Hr(Qr), V("Failed %s type: %s", ur, Dr.message), Hr(null));
          }
      }
    }
    var hr = Array.isArray;
    function Gr(Me) {
      return hr(Me);
    }
    function Yr(Me) {
      {
        var wt = typeof Symbol == "function" && Symbol.toStringTag, ur = wt && Me[Symbol.toStringTag] || Me.constructor.name || "Object";
        return ur;
      }
    }
    function tt(Me) {
      try {
        return ar(Me), !1;
      } catch {
        return !0;
      }
    }
    function ar(Me) {
      return "" + Me;
    }
    function wr(Me) {
      if (tt(Me))
        return V("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Yr(Me)), ar(Me);
    }
    var Sr = H.ReactCurrentOwner, Ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Je, tr, pt;
    pt = {};
    function ir(Me) {
      if (cr.call(Me, "ref")) {
        var wt = Object.getOwnPropertyDescriptor(Me, "ref").get;
        if (wt && wt.isReactWarning)
          return !1;
      }
      return Me.ref !== void 0;
    }
    function nr(Me) {
      if (cr.call(Me, "key")) {
        var wt = Object.getOwnPropertyDescriptor(Me, "key").get;
        if (wt && wt.isReactWarning)
          return !1;
      }
      return Me.key !== void 0;
    }
    function er(Me, wt) {
      if (typeof Me.ref == "string" && Sr.current && wt && Sr.current.stateNode !== wt) {
        var ur = ke(Sr.current.type);
        pt[ur] || (V('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', ke(Sr.current.type), Me.ref), pt[ur] = !0);
      }
    }
    function pr(Me, wt) {
      {
        var ur = function() {
          Je || (Je = !0, V("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", wt));
        };
        ur.isReactWarning = !0, Object.defineProperty(Me, "key", {
          get: ur,
          configurable: !0
        });
      }
    }
    function kr(Me, wt) {
      {
        var ur = function() {
          tr || (tr = !0, V("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", wt));
        };
        ur.isReactWarning = !0, Object.defineProperty(Me, "ref", {
          get: ur,
          configurable: !0
        });
      }
    }
    var Nr = function(Me, wt, ur, jr, Qr, Ir, $r) {
      var Dr = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: Me,
        key: wt,
        ref: ur,
        props: $r,
        // Record the component responsible for creating this element.
        _owner: Ir
      };
      return Dr._store = {}, Object.defineProperty(Dr._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Dr, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: jr
      }), Object.defineProperty(Dr, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Qr
      }), Object.freeze && (Object.freeze(Dr.props), Object.freeze(Dr)), Dr;
    };
    function hn(Me, wt, ur, jr, Qr) {
      {
        var Ir, $r = {}, Dr = null, An = null;
        ur !== void 0 && (wr(ur), Dr = "" + ur), nr(wt) && (wr(wt.key), Dr = "" + wt.key), ir(wt) && (An = wt.ref, er(wt, Qr));
        for (Ir in wt)
          cr.call(wt, Ir) && !Ye.hasOwnProperty(Ir) && ($r[Ir] = wt[Ir]);
        if (Me && Me.defaultProps) {
          var mr = Me.defaultProps;
          for (Ir in mr)
            $r[Ir] === void 0 && ($r[Ir] = mr[Ir]);
        }
        if (Dr || An) {
          var on = typeof Me == "function" ? Me.displayName || Me.name || "Unknown" : Me;
          Dr && pr($r, on), An && kr($r, on);
        }
        return Nr(Me, Dr, An, Qr, jr, Sr.current, $r);
      }
    }
    var fn = H.ReactCurrentOwner, uo = H.ReactDebugCurrentFrame;
    function mn(Me) {
      if (Me) {
        var wt = Me._owner, ur = kt(Me.type, Me._source, wt ? wt.type : null);
        uo.setExtraStackFrame(ur);
      } else
        uo.setExtraStackFrame(null);
    }
    var vn;
    vn = !1;
    function mi(Me) {
      return typeof Me == "object" && Me !== null && Me.$$typeof === t;
    }
    function Jo() {
      {
        if (fn.current) {
          var Me = ke(fn.current.type);
          if (Me)
            return `

Check the render method of \`` + Me + "`.";
        }
        return "";
      }
    }
    function $i(Me) {
      {
        if (Me !== void 0) {
          var wt = Me.fileName.replace(/^.*[\\\/]/, ""), ur = Me.lineNumber;
          return `

Check your code at ` + wt + ":" + ur + ".";
        }
        return "";
      }
    }
    var Ji = {};
    function Zs(Me) {
      {
        var wt = Jo();
        if (!wt) {
          var ur = typeof Me == "string" ? Me : Me.displayName || Me.name;
          ur && (wt = `

Check the top-level render call using <` + ur + ">.");
        }
        return wt;
      }
    }
    function yi(Me, wt) {
      {
        if (!Me._store || Me._store.validated || Me.key != null)
          return;
        Me._store.validated = !0;
        var ur = Zs(wt);
        if (Ji[ur])
          return;
        Ji[ur] = !0;
        var jr = "";
        Me && Me._owner && Me._owner !== fn.current && (jr = " It was passed a child from " + ke(Me._owner.type) + "."), mn(Me), V('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ur, jr), mn(null);
      }
    }
    function Zo(Me, wt) {
      {
        if (typeof Me != "object")
          return;
        if (Gr(Me))
          for (var ur = 0; ur < Me.length; ur++) {
            var jr = Me[ur];
            mi(jr) && yi(jr, wt);
          }
        else if (mi(Me))
          Me._store && (Me._store.validated = !0);
        else if (Me) {
          var Qr = W(Me);
          if (typeof Qr == "function" && Qr !== Me.entries)
            for (var Ir = Qr.call(Me), $r; !($r = Ir.next()).done; )
              mi($r.value) && yi($r.value, wt);
        }
      }
    }
    function gi(Me) {
      {
        var wt = Me.type;
        if (wt == null || typeof wt == "string")
          return;
        var ur;
        if (typeof wt == "function")
          ur = wt.propTypes;
        else if (typeof wt == "object" && (wt.$$typeof === m || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        wt.$$typeof === w))
          ur = wt.propTypes;
        else
          return;
        if (ur) {
          var jr = ke(wt);
          Br(ur, Me.props, "prop", jr, Me);
        } else if (wt.PropTypes !== void 0 && !vn) {
          vn = !0;
          var Qr = ke(wt);
          V("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Qr || "Unknown");
        }
        typeof wt.getDefaultProps == "function" && !wt.getDefaultProps.isReactClassApproved && V("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ei(Me) {
      {
        for (var wt = Object.keys(Me.props), ur = 0; ur < wt.length; ur++) {
          var jr = wt[ur];
          if (jr !== "children" && jr !== "key") {
            mn(Me), V("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", jr), mn(null);
            break;
          }
        }
        Me.ref !== null && (mn(Me), V("Invalid attribute `ref` supplied to `React.Fragment`."), mn(null));
      }
    }
    function Ao(Me, wt, ur, jr, Qr, Ir) {
      {
        var $r = Pe(Me);
        if (!$r) {
          var Dr = "";
          (Me === void 0 || typeof Me == "object" && Me !== null && Object.keys(Me).length === 0) && (Dr += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var An = $i(Qr);
          An ? Dr += An : Dr += Jo();
          var mr;
          Me === null ? mr = "null" : Gr(Me) ? mr = "array" : Me !== void 0 && Me.$$typeof === t ? (mr = "<" + (ke(Me.type) || "Unknown") + " />", Dr = " Did you accidentally export a JSX literal instead of a component?") : mr = typeof Me, V("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", mr, Dr);
        }
        var on = hn(Me, wt, ur, Qr, Ir);
        if (on == null)
          return on;
        if ($r) {
          var zo = wt.children;
          if (zo !== void 0)
            if (jr)
              if (Gr(zo)) {
                for (var ea = 0; ea < zo.length; ea++)
                  Zo(zo[ea], Me);
                Object.freeze && Object.freeze(zo);
              } else
                V("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Zo(zo, Me);
        }
        return Me === o ? ei(on) : gi(on), on;
      }
    }
    function Fn(Me, wt, ur) {
      return Ao(Me, wt, ur, !0);
    }
    function Gn(Me, wt, ur) {
      return Ao(Me, wt, ur, !1);
    }
    var Bo = Gn, $o = Fn;
    reactJsxRuntime_development.Fragment = o, reactJsxRuntime_development.jsx = Bo, reactJsxRuntime_development.jsxs = $o;
  }()), reactJsxRuntime_development;
}
process.env.NODE_ENV === "production" ? jsxRuntime.exports = requireReactJsxRuntime_production_min() : jsxRuntime.exports = requireReactJsxRuntime_development();
var jsxRuntimeExports = jsxRuntime.exports;
const IconMask = ({
  width: e,
  height: t,
  name: n,
  icon: o,
  styleName: s,
  color: l,
  onClick: c
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "div",
  {
    className: `mask-icon icon-${n} ${s || ""}`,
    style: {
      maskImage: `url("${o}")`,
      WebkitMaskImage: `url("${o}")`,
      maskRepeat: "no-repeat",
      WebkitMaskRepeat: "no-repeat",
      maskPosition: "center",
      WebkitMaskPosition: "center",
      maskSize: "contain",
      WebkitMaskSize: "contain",
      width: e,
      height: t,
      backgroundColor: l
    },
    onClick: c
  }
);
var IconType = /* @__PURE__ */ ((e) => (e.Add = "add", e.AddFolder = "addFolder", e.AddUser = "addUser", e.Apple = "apple", e.Arrow = "arrow", e.ArtGallery = "artGallery", e.Back = "back", e.Book = "book", e.Brackets = "brackets", e.BurgerMenu = "burgerMenu", e.Calendar = "calendar", e.Camera = "camera", e.Clip = "clip", e.Clock = "clock", e.Close = "close", e.Colapse = "colapse", e.Copy = "copy", e.Cross = "cross", e.Crown = "crown", e.Comments = "comments", e.Cloud = "cloud", e.Discord = "discord", e.Edit = "edit", e.Error = "error", e.Eye = "eye", e.EyeCrossed = "eyeCrossed", e.Facebook = "facebook", e.Feed = "feed", e.FileUpload = "fileUpload", e.Filters = "filters", e.Gift = "gift", e.Google = "google", e.GoToLink = "goToLink", e.GoToPreviousPage = "goToPreviousPage", e.Heart = "heart", e.Home = "home", e.Info = "info", e.Instagram = "instagram", e.Linkedin = "linkedin", e.LeftArrow = "leftArrow", e.Lock = "lock", e.Login = "login", e.Maximize = "maximize", e.Mission = "mission", e.Minimize = "minimize", e.Mobile = "mobile", e.Move = "move", e.Notification = "notification", e.NotificationWithStatus = "notificationWithStatus", e.Park = "park", e.Pause = "pause", e.Pen = "pen", e.People = "people", e.Play = "play", e.Plus = "plus", e.Premium = "premium", e.Prize = "prize", e.Refresh = "refresh", e.RightIcon = "rightIcon", e.Search = "search", e.Send = "send", e.Settings = "settings", e.Share = "share", e.ShareNew = "shareNew", e.SliderControl = "sliderControl", e.SliderControlPrimary = "sliderControlPrimary", e.Stream = "stream", e.Success = "success", e.Sword = "sword", e.Ticket = "ticket", e.Times = "times", e.Tournament = "tournament", e.Training = "training", e.Trashcan = "trashcan", e.Twitch = "twitch", e.Twitter = "twitter", e.TwitterVerified = "twitterVerified", e.UnavailableLocation = "unavailableLocation", e.UpArrow = "upArrow", e.UploadCloud = "uploadCloud", e.User = "user", e.WaffleMenu = "waffleMenu", e.Warning = "warning", e.YouTube = "youtube", e))(IconType || {});
const Icon = ({
  width: e,
  height: t,
  icon: n,
  styleName: o,
  color: s,
  onClick: l
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  IconMask,
  {
    icon: `https://assets.next.wolfiesports.com/media/icons/${n}.svg`,
    name: n,
    width: e,
    height: t,
    styleName: o,
    color: s,
    onClick: l
  }
), FingerIndicator$1 = "", FingerIndicator = (e) => e.show ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "finger-indicator position-relative", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "finger-indicator-background position-absolute" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { icon: IconType.Park, width: 40, height: 40 })
] }) : null;
FingerIndicator.defaultProps = {
  show: !0
};
const Button$2 = "";
var ButtonTheme = /* @__PURE__ */ ((e) => (e.CLASSIC = "classic", e.TOURNAMENT = "tournament", e.TRAINING = "training", e.TRACKING = "tracking", e.PREMIUM = "premium", e.RED = "red", e.CUSTOM = "custom", e))(ButtonTheme || {}), ButtonType = /* @__PURE__ */ ((e) => (e.PRIMARY = "primary", e.SECONDARY = "secondary", e.TEXT = "text", e))(ButtonType || {}), ButtonSize = /* @__PURE__ */ ((e) => (e.SMALL = "small", e.MEDIUM = "medium", e.BIG = "big", e))(ButtonSize || {});
const Button$1 = (e) => {
  const t = e.theme ?? "classic", n = e.type ?? "primary", o = e.size ?? "medium", s = (l) => {
    e.setClick && e.setClick(l);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: `button-container ${e.containerClass}`,
      style: { borderColor: e.color },
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "button",
        {
          className: `button d-flex align-items-center justify-content-center ${t} ${n} ${o} ${e.styleClass ?? ""}${!e.disabled && e.color ? " custom-hover" : ""}`,
          disabled: e.disabled,
          onClick: s,
          type: e.buttonAtomType,
          style: {
            background: t === "custom" ? e.color : [
              "secondary"
              /* SECONDARY */
            ].includes(n) ? void 0 : e.color
          },
          children: [
            e.icon && /* @__PURE__ */ jsxRuntimeExports.jsx(
              Icon,
              {
                styleName: "mr-2",
                icon: e.icon.type,
                width: e.icon.width,
                height: e.icon.height
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(
              "span",
              {
                className: `h-100${e.disabled ? " disabled" : ""}${[
                  "tournament",
                  "tracking",
                  "training"
                  /* TRAINING */
                ].includes(t) && n === "secondary" ? ` ${t} ${n}` : void 0}`,
                style: {
                  color: e.disabled ? void 0 : (e == null ? void 0 : e.textColor) || [
                    "secondary"
                    /* SECONDARY */
                  ].includes(n) && (e == null ? void 0 : e.color) || void 0,
                  WebkitTextFillColor: e.disabled ? void 0 : (e == null ? void 0 : e.textColor) || [
                    "secondary"
                    /* SECONDARY */
                  ].includes(n) && (e == null ? void 0 : e.color) || void 0
                },
                children: [
                  e.label || e.children,
                  e.showFinger && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "position-absolute", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FingerIndicator, {}) })
                ]
              }
            )
          ]
        }
      )
    }
  );
}, ButtonIcon$1 = "", common = {
  black: "#000",
  white: "#fff"
}, common$1 = common, red$1 = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, red$2 = red$1, purple = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
}, purple$1 = purple, blue$1 = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, blue$2 = blue$1, lightBlue = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
}, lightBlue$1 = lightBlue, green$1 = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
}, green$2 = green$1, orange$1 = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, orange$2 = orange$1, grey$1 = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, grey$2 = grey$1;
function formatMuiErrorMessage$1(e) {
  let t = "https://mui.com/production-error/?code=" + e;
  for (let n = 1; n < arguments.length; n += 1)
    t += "&args[]=" + encodeURIComponent(arguments[n]);
  return "Minified MUI error #" + e + "; visit " + t + " for the full message.";
}
const formatMuiErrorMessage = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: formatMuiErrorMessage$1
}, Symbol.toStringTag, { value: "Module" })), THEME_ID = "$$material";
function _extends$5() {
  return _extends$5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, _extends$5.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$3(e, t) {
  if (e == null)
    return {};
  var n = {}, o = Object.keys(e), s, l;
  for (l = 0; l < o.length; l++)
    s = o[l], !(t.indexOf(s) >= 0) && (n[s] = e[s]);
  return n;
}
function memoize$1(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, isPropValid = /* @__PURE__ */ memoize$1(
  function(e) {
    return reactPropsRegex.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
);
function sheetForTag(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function createStyleElement(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var StyleSheet = /* @__PURE__ */ function() {
  function e(n) {
    var o = this;
    this._insertTag = function(s) {
      var l;
      o.tags.length === 0 ? o.insertionPoint ? l = o.insertionPoint.nextSibling : o.prepend ? l = o.container.firstChild : l = o.before : l = o.tags[o.tags.length - 1].nextSibling, o.container.insertBefore(s, l), o.tags.push(s);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(o) {
    o.forEach(this._insertTag);
  }, t.insert = function(o) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(createStyleElement(this));
    var s = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var l = o.charCodeAt(0) === 64 && o.charCodeAt(1) === 105;
      l && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + o + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !l;
    }
    if (this.isSpeedy) {
      var c = sheetForTag(s);
      try {
        c.insertRule(o, c.cssRules.length);
      } catch (p) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(o) && console.error('There was a problem inserting the following rule: "' + o + '"', p);
      }
    } else
      s.appendChild(document.createTextNode(o));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(o) {
      return o.parentNode && o.parentNode.removeChild(o);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), MS = "-ms-", MOZ = "-moz-", WEBKIT = "-webkit-", COMMENT = "comm", RULESET = "rule", DECLARATION = "decl", IMPORT = "@import", KEYFRAMES = "@keyframes", LAYER = "@layer", abs$2 = Math.abs, from$1 = String.fromCharCode, assign$1 = Object.assign;
function hash$2(e, t) {
  return charat(e, 0) ^ 45 ? (((t << 2 ^ charat(e, 0)) << 2 ^ charat(e, 1)) << 2 ^ charat(e, 2)) << 2 ^ charat(e, 3) : 0;
}
function trim$1(e) {
  return e.trim();
}
function match(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function replace(e, t, n) {
  return e.replace(t, n);
}
function indexof(e, t) {
  return e.indexOf(t);
}
function charat(e, t) {
  return e.charCodeAt(t) | 0;
}
function substr(e, t, n) {
  return e.slice(t, n);
}
function strlen(e) {
  return e.length;
}
function sizeof(e) {
  return e.length;
}
function append(e, t) {
  return t.push(e), e;
}
function combine(e, t) {
  return e.map(t).join("");
}
var line = 1, column = 1, length = 0, position = 0, character = 0, characters = "";
function node(e, t, n, o, s, l, c) {
  return { value: e, root: t, parent: n, type: o, props: s, children: l, line, column, length: c, return: "" };
}
function copy(e, t) {
  return assign$1(node("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function char() {
  return character;
}
function prev() {
  return character = position > 0 ? charat(characters, --position) : 0, column--, character === 10 && (column = 1, line--), character;
}
function next() {
  return character = position < length ? charat(characters, position++) : 0, column++, character === 10 && (column = 1, line++), character;
}
function peek() {
  return charat(characters, position);
}
function caret() {
  return position;
}
function slice(e, t) {
  return substr(characters, e, t);
}
function token$1(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(e) {
  return line = column = 1, length = strlen(characters = e), position = 0, [];
}
function dealloc(e) {
  return characters = "", e;
}
function delimit(e) {
  return trim$1(slice(position - 1, delimiter(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function whitespace(e) {
  for (; (character = peek()) && character < 33; )
    next();
  return token$1(e) > 2 || token$1(character) > 3 ? "" : " ";
}
function escaping(e, t) {
  for (; --t && next() && !(character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97); )
    ;
  return slice(e, caret() + (t < 6 && peek() == 32 && next() == 32));
}
function delimiter(e) {
  for (; next(); )
    switch (character) {
      case e:
        return position;
      case 34:
      case 39:
        e !== 34 && e !== 39 && delimiter(character);
        break;
      case 40:
        e === 41 && delimiter(e);
        break;
      case 92:
        next();
        break;
    }
  return position;
}
function commenter(e, t) {
  for (; next() && e + character !== 47 + 10; )
    if (e + character === 42 + 42 && peek() === 47)
      break;
  return "/*" + slice(t, position - 1) + "*" + from$1(e === 47 ? e : next());
}
function identifier(e) {
  for (; !token$1(peek()); )
    next();
  return slice(e, position);
}
function compile(e) {
  return dealloc(parse("", null, null, null, [""], e = alloc(e), 0, [0], e));
}
function parse(e, t, n, o, s, l, c, p, m) {
  for (var C = 0, P = 0, w = c, R = 0, L = 0, M = 0, $ = 1, W = 1, H = 1, V = 0, N = "", B = s, K = l, ue = o, de = N; W; )
    switch (M = V, V = next()) {
      case 40:
        if (M != 108 && charat(de, w - 1) == 58) {
          indexof(de += replace(delimit(V), "&", "&\f"), "&\f") != -1 && (H = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        de += delimit(V);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        de += whitespace(M);
        break;
      case 92:
        de += escaping(caret() - 1, 7);
        continue;
      case 47:
        switch (peek()) {
          case 42:
          case 47:
            append(comment(commenter(next(), caret()), t, n), m);
            break;
          default:
            de += "/";
        }
        break;
      case 123 * $:
        p[C++] = strlen(de) * H;
      case 125 * $:
      case 59:
      case 0:
        switch (V) {
          case 0:
          case 125:
            W = 0;
          case 59 + P:
            H == -1 && (de = replace(de, /\f/g, "")), L > 0 && strlen(de) - w && append(L > 32 ? declaration(de + ";", o, n, w - 1) : declaration(replace(de, " ", "") + ";", o, n, w - 2), m);
            break;
          case 59:
            de += ";";
          default:
            if (append(ue = ruleset(de, t, n, C, P, s, p, N, B = [], K = [], w), l), V === 123)
              if (P === 0)
                parse(de, t, ue, ue, B, l, w, p, K);
              else
                switch (R === 99 && charat(de, 3) === 110 ? 100 : R) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    parse(e, ue, ue, o && append(ruleset(e, ue, ue, 0, 0, s, p, N, s, B = [], w), K), s, K, w, p, o ? B : K);
                    break;
                  default:
                    parse(de, ue, ue, ue, [""], K, 0, p, K);
                }
        }
        C = P = L = 0, $ = H = 1, N = de = "", w = c;
        break;
      case 58:
        w = 1 + strlen(de), L = M;
      default:
        if ($ < 1) {
          if (V == 123)
            --$;
          else if (V == 125 && $++ == 0 && prev() == 125)
            continue;
        }
        switch (de += from$1(V), V * $) {
          case 38:
            H = P > 0 ? 1 : (de += "\f", -1);
            break;
          case 44:
            p[C++] = (strlen(de) - 1) * H, H = 1;
            break;
          case 64:
            peek() === 45 && (de += delimit(next())), R = peek(), P = w = strlen(N = de += identifier(caret())), V++;
            break;
          case 45:
            M === 45 && strlen(de) == 2 && ($ = 0);
        }
    }
  return l;
}
function ruleset(e, t, n, o, s, l, c, p, m, C, P) {
  for (var w = s - 1, R = s === 0 ? l : [""], L = sizeof(R), M = 0, $ = 0, W = 0; M < o; ++M)
    for (var H = 0, V = substr(e, w + 1, w = abs$2($ = c[M])), N = e; H < L; ++H)
      (N = trim$1($ > 0 ? R[H] + " " + V : replace(V, /&\f/g, R[H]))) && (m[W++] = N);
  return node(e, t, n, s === 0 ? RULESET : p, m, C, P);
}
function comment(e, t, n) {
  return node(e, t, n, COMMENT, from$1(char()), substr(e, 2, -2), 0);
}
function declaration(e, t, n, o) {
  return node(e, t, n, DECLARATION, substr(e, 0, o), substr(e, o + 1, -1), o);
}
function serialize(e, t) {
  for (var n = "", o = sizeof(e), s = 0; s < o; s++)
    n += t(e[s], s, e, t) || "";
  return n;
}
function stringify(e, t, n, o) {
  switch (e.type) {
    case LAYER:
      if (e.children.length)
        break;
    case IMPORT:
    case DECLARATION:
      return e.return = e.return || e.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return e.return = e.value + "{" + serialize(e.children, o) + "}";
    case RULESET:
      e.value = e.props.join(",");
  }
  return strlen(n = serialize(e.children, o)) ? e.return = e.value + "{" + n + "}" : "";
}
function middleware(e) {
  var t = sizeof(e);
  return function(n, o, s, l) {
    for (var c = "", p = 0; p < t; p++)
      c += e[p](n, o, s, l) || "";
    return c;
  };
}
function rulesheet(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
var identifierWithPointTracking = function(t, n, o) {
  for (var s = 0, l = 0; s = l, l = peek(), s === 38 && l === 12 && (n[o] = 1), !token$1(l); )
    next();
  return slice(t, position);
}, toRules = function(t, n) {
  var o = -1, s = 44;
  do
    switch (token$1(s)) {
      case 0:
        s === 38 && peek() === 12 && (n[o] = 1), t[o] += identifierWithPointTracking(position - 1, n, o);
        break;
      case 2:
        t[o] += delimit(s);
        break;
      case 4:
        if (s === 44) {
          t[++o] = peek() === 58 ? "&\f" : "", n[o] = t[o].length;
          break;
        }
      default:
        t[o] += from$1(s);
    }
  while (s = next());
  return t;
}, getRules = function(t, n) {
  return dealloc(toRules(alloc(t), n));
}, fixedElements = /* @__PURE__ */ new WeakMap(), compat = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var n = t.value, o = t.parent, s = t.column === o.column && t.line === o.line; o.type !== "rule"; )
      if (o = o.parent, !o)
        return;
    if (!(t.props.length === 1 && n.charCodeAt(0) !== 58 && !fixedElements.get(o)) && !s) {
      fixedElements.set(t, !0);
      for (var l = [], c = getRules(n, l), p = o.props, m = 0, C = 0; m < c.length; m++)
        for (var P = 0; P < p.length; P++, C++)
          t.props[C] = l[m] ? c[m].replace(/&\f/g, p[P]) : p[P] + " " + c[m];
    }
  }
}, removeLabel = function(t) {
  if (t.type === "decl") {
    var n = t.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
}, ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", isIgnoringComment = function(t) {
  return t.type === "comm" && t.children.indexOf(ignoreFlag) > -1;
}, createUnsafeSelectorsAlarm = function(t) {
  return function(n, o, s) {
    if (!(n.type !== "rule" || t.compat)) {
      var l = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (l) {
        for (var c = !!n.parent, p = c ? n.parent.children : (
          // global rule at the root level
          s
        ), m = p.length - 1; m >= 0; m--) {
          var C = p[m];
          if (C.line < n.line)
            break;
          if (C.column < n.column) {
            if (isIgnoringComment(C))
              return;
            break;
          }
        }
        l.forEach(function(P) {
          console.error('The pseudo class "' + P + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + P.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, isImportRule = function(t) {
  return t.type.charCodeAt(1) === 105 && t.type.charCodeAt(0) === 64;
}, isPrependedWithRegularRules = function(t, n) {
  for (var o = t - 1; o >= 0; o--)
    if (!isImportRule(n[o]))
      return !0;
  return !1;
}, nullifyElement = function(t) {
  t.type = "", t.value = "", t.return = "", t.children = "", t.props = "";
}, incorrectImportAlarm = function(t, n, o) {
  isImportRule(t) && (t.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), nullifyElement(t)) : isPrependedWithRegularRules(n, o) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), nullifyElement(t)));
};
function prefix(e, t) {
  switch (hash$2(e, t)) {
    case 5103:
      return WEBKIT + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + e + MOZ + e + MS + e + e;
    case 6828:
    case 4268:
      return WEBKIT + e + MS + e + e;
    case 6165:
      return WEBKIT + e + MS + "flex-" + e + e;
    case 5187:
      return WEBKIT + e + replace(e, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + e;
    case 5443:
      return WEBKIT + e + MS + "flex-item-" + replace(e, /flex-|-self/, "") + e;
    case 4675:
      return WEBKIT + e + MS + "flex-line-pack" + replace(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return WEBKIT + e + MS + replace(e, "shrink", "negative") + e;
    case 5292:
      return WEBKIT + e + MS + replace(e, "basis", "preferred-size") + e;
    case 6060:
      return WEBKIT + "box-" + replace(e, "-grow", "") + WEBKIT + e + MS + replace(e, "grow", "positive") + e;
    case 4554:
      return WEBKIT + replace(e, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + e;
    case 6187:
      return replace(replace(replace(e, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return replace(e, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    case 4968:
      return replace(replace(e, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(e, /(.+)-inline(.+)/, WEBKIT + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen(e) - 1 - t > 6)
        switch (charat(e, t + 1)) {
          case 109:
            if (charat(e, t + 4) !== 45)
              break;
          case 102:
            return replace(e, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~indexof(e, "stretch") ? prefix(replace(e, "stretch", "fill-available"), t) + e : e;
        }
      break;
    case 4949:
      if (charat(e, t + 1) !== 115)
        break;
    case 6444:
      switch (charat(e, strlen(e) - 3 - (~indexof(e, "!important") && 10))) {
        case 107:
          return replace(e, ":", ":" + WEBKIT) + e;
        case 101:
          return replace(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(e, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (charat(e, t + 11)) {
        case 114:
          return WEBKIT + e + MS + replace(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return WEBKIT + e + MS + replace(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return WEBKIT + e + MS + replace(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return WEBKIT + e + MS + e + e;
  }
  return e;
}
var prefixer = function(t, n, o, s) {
  if (t.length > -1 && !t.return)
    switch (t.type) {
      case DECLARATION:
        t.return = prefix(t.value, t.length);
        break;
      case KEYFRAMES:
        return serialize([copy(t, {
          value: replace(t.value, "@", "@" + WEBKIT)
        })], s);
      case RULESET:
        if (t.length)
          return combine(t.props, function(l) {
            switch (match(l, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return serialize([copy(t, {
                  props: [replace(l, /:(read-\w+)/, ":" + MOZ + "$1")]
                })], s);
              case "::placeholder":
                return serialize([copy(t, {
                  props: [replace(l, /:(plac\w+)/, ":" + WEBKIT + "input-$1")]
                }), copy(t, {
                  props: [replace(l, /:(plac\w+)/, ":" + MOZ + "$1")]
                }), copy(t, {
                  props: [replace(l, /:(plac\w+)/, MS + "input-$1")]
                })], s);
            }
            return "";
          });
    }
}, defaultStylisPlugins = [prefixer], createCache = function(t) {
  var n = t.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var o = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(o, function($) {
      var W = $.getAttribute("data-emotion");
      W.indexOf(" ") !== -1 && (document.head.appendChild($), $.setAttribute("data-s", ""));
    });
  }
  var s = t.stylisPlugins || defaultStylisPlugins;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var l = {}, c, p = [];
  c = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function($) {
      for (var W = $.getAttribute("data-emotion").split(" "), H = 1; H < W.length; H++)
        l[W[H]] = !0;
      p.push($);
    }
  );
  var m, C = [compat, removeLabel];
  process.env.NODE_ENV !== "production" && C.push(createUnsafeSelectorsAlarm({
    get compat() {
      return M.compat;
    }
  }), incorrectImportAlarm);
  {
    var P, w = [stringify, process.env.NODE_ENV !== "production" ? function($) {
      $.root || ($.return ? P.insert($.return) : $.value && $.type !== COMMENT && P.insert($.value + "{}"));
    } : rulesheet(function($) {
      P.insert($);
    })], R = middleware(C.concat(s, w)), L = function(W) {
      return serialize(compile(W), R);
    };
    m = function(W, H, V, N) {
      P = V, process.env.NODE_ENV !== "production" && H.map !== void 0 && (P = {
        insert: function(K) {
          V.insert(K + H.map);
        }
      }), L(W ? W + "{" + H.styles + "}" : H.styles), N && (M.inserted[H.name] = !0);
    };
  }
  var M = {
    key: n,
    sheet: new StyleSheet({
      key: n,
      container: c,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: l,
    registered: {},
    insert: m
  };
  return M.sheet.hydrate(p), M;
}, reactIs$3 = { exports: {} }, reactIs_production_min$2 = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min$2;
function requireReactIs_production_min$2() {
  if (hasRequiredReactIs_production_min$2)
    return reactIs_production_min$2;
  hasRequiredReactIs_production_min$2 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, s = e ? Symbol.for("react.strict_mode") : 60108, l = e ? Symbol.for("react.profiler") : 60114, c = e ? Symbol.for("react.provider") : 60109, p = e ? Symbol.for("react.context") : 60110, m = e ? Symbol.for("react.async_mode") : 60111, C = e ? Symbol.for("react.concurrent_mode") : 60111, P = e ? Symbol.for("react.forward_ref") : 60112, w = e ? Symbol.for("react.suspense") : 60113, R = e ? Symbol.for("react.suspense_list") : 60120, L = e ? Symbol.for("react.memo") : 60115, M = e ? Symbol.for("react.lazy") : 60116, $ = e ? Symbol.for("react.block") : 60121, W = e ? Symbol.for("react.fundamental") : 60117, H = e ? Symbol.for("react.responder") : 60118, V = e ? Symbol.for("react.scope") : 60119;
  function N(K) {
    if (typeof K == "object" && K !== null) {
      var ue = K.$$typeof;
      switch (ue) {
        case t:
          switch (K = K.type, K) {
            case m:
            case C:
            case o:
            case l:
            case s:
            case w:
              return K;
            default:
              switch (K = K && K.$$typeof, K) {
                case p:
                case P:
                case M:
                case L:
                case c:
                  return K;
                default:
                  return ue;
              }
          }
        case n:
          return ue;
      }
    }
  }
  function B(K) {
    return N(K) === C;
  }
  return reactIs_production_min$2.AsyncMode = m, reactIs_production_min$2.ConcurrentMode = C, reactIs_production_min$2.ContextConsumer = p, reactIs_production_min$2.ContextProvider = c, reactIs_production_min$2.Element = t, reactIs_production_min$2.ForwardRef = P, reactIs_production_min$2.Fragment = o, reactIs_production_min$2.Lazy = M, reactIs_production_min$2.Memo = L, reactIs_production_min$2.Portal = n, reactIs_production_min$2.Profiler = l, reactIs_production_min$2.StrictMode = s, reactIs_production_min$2.Suspense = w, reactIs_production_min$2.isAsyncMode = function(K) {
    return B(K) || N(K) === m;
  }, reactIs_production_min$2.isConcurrentMode = B, reactIs_production_min$2.isContextConsumer = function(K) {
    return N(K) === p;
  }, reactIs_production_min$2.isContextProvider = function(K) {
    return N(K) === c;
  }, reactIs_production_min$2.isElement = function(K) {
    return typeof K == "object" && K !== null && K.$$typeof === t;
  }, reactIs_production_min$2.isForwardRef = function(K) {
    return N(K) === P;
  }, reactIs_production_min$2.isFragment = function(K) {
    return N(K) === o;
  }, reactIs_production_min$2.isLazy = function(K) {
    return N(K) === M;
  }, reactIs_production_min$2.isMemo = function(K) {
    return N(K) === L;
  }, reactIs_production_min$2.isPortal = function(K) {
    return N(K) === n;
  }, reactIs_production_min$2.isProfiler = function(K) {
    return N(K) === l;
  }, reactIs_production_min$2.isStrictMode = function(K) {
    return N(K) === s;
  }, reactIs_production_min$2.isSuspense = function(K) {
    return N(K) === w;
  }, reactIs_production_min$2.isValidElementType = function(K) {
    return typeof K == "string" || typeof K == "function" || K === o || K === C || K === l || K === s || K === w || K === R || typeof K == "object" && K !== null && (K.$$typeof === M || K.$$typeof === L || K.$$typeof === c || K.$$typeof === p || K.$$typeof === P || K.$$typeof === W || K.$$typeof === H || K.$$typeof === V || K.$$typeof === $);
  }, reactIs_production_min$2.typeOf = N, reactIs_production_min$2;
}
var reactIs_development$2 = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development$2;
function requireReactIs_development$2() {
  return hasRequiredReactIs_development$2 || (hasRequiredReactIs_development$2 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, s = e ? Symbol.for("react.strict_mode") : 60108, l = e ? Symbol.for("react.profiler") : 60114, c = e ? Symbol.for("react.provider") : 60109, p = e ? Symbol.for("react.context") : 60110, m = e ? Symbol.for("react.async_mode") : 60111, C = e ? Symbol.for("react.concurrent_mode") : 60111, P = e ? Symbol.for("react.forward_ref") : 60112, w = e ? Symbol.for("react.suspense") : 60113, R = e ? Symbol.for("react.suspense_list") : 60120, L = e ? Symbol.for("react.memo") : 60115, M = e ? Symbol.for("react.lazy") : 60116, $ = e ? Symbol.for("react.block") : 60121, W = e ? Symbol.for("react.fundamental") : 60117, H = e ? Symbol.for("react.responder") : 60118, V = e ? Symbol.for("react.scope") : 60119;
    function N(Qe) {
      return typeof Qe == "string" || typeof Qe == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      Qe === o || Qe === C || Qe === l || Qe === s || Qe === w || Qe === R || typeof Qe == "object" && Qe !== null && (Qe.$$typeof === M || Qe.$$typeof === L || Qe.$$typeof === c || Qe.$$typeof === p || Qe.$$typeof === P || Qe.$$typeof === W || Qe.$$typeof === H || Qe.$$typeof === V || Qe.$$typeof === $);
    }
    function B(Qe) {
      if (typeof Qe == "object" && Qe !== null) {
        var xt = Qe.$$typeof;
        switch (xt) {
          case t:
            var je = Qe.type;
            switch (je) {
              case m:
              case C:
              case o:
              case l:
              case s:
              case w:
                return je;
              default:
                var kt = je && je.$$typeof;
                switch (kt) {
                  case p:
                  case P:
                  case M:
                  case L:
                  case c:
                    return kt;
                  default:
                    return xt;
                }
            }
          case n:
            return xt;
        }
      }
    }
    var K = m, ue = C, de = p, ve = c, Te = t, Pe = P, Ce = o, Re = M, ke = L, Ae = n, we = l, he = s, be = w, le = !1;
    function fe(Qe) {
      return le || (le = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), ye(Qe) || B(Qe) === m;
    }
    function ye(Qe) {
      return B(Qe) === C;
    }
    function Ee(Qe) {
      return B(Qe) === p;
    }
    function Ie(Qe) {
      return B(Qe) === c;
    }
    function Fe(Qe) {
      return typeof Qe == "object" && Qe !== null && Qe.$$typeof === t;
    }
    function De(Qe) {
      return B(Qe) === P;
    }
    function Ve(Qe) {
      return B(Qe) === o;
    }
    function Oe(Qe) {
      return B(Qe) === M;
    }
    function Ze(Qe) {
      return B(Qe) === L;
    }
    function et(Qe) {
      return B(Qe) === n;
    }
    function bt(Qe) {
      return B(Qe) === l;
    }
    function rr(Qe) {
      return B(Qe) === s;
    }
    function St(Qe) {
      return B(Qe) === w;
    }
    reactIs_development$2.AsyncMode = K, reactIs_development$2.ConcurrentMode = ue, reactIs_development$2.ContextConsumer = de, reactIs_development$2.ContextProvider = ve, reactIs_development$2.Element = Te, reactIs_development$2.ForwardRef = Pe, reactIs_development$2.Fragment = Ce, reactIs_development$2.Lazy = Re, reactIs_development$2.Memo = ke, reactIs_development$2.Portal = Ae, reactIs_development$2.Profiler = we, reactIs_development$2.StrictMode = he, reactIs_development$2.Suspense = be, reactIs_development$2.isAsyncMode = fe, reactIs_development$2.isConcurrentMode = ye, reactIs_development$2.isContextConsumer = Ee, reactIs_development$2.isContextProvider = Ie, reactIs_development$2.isElement = Fe, reactIs_development$2.isForwardRef = De, reactIs_development$2.isFragment = Ve, reactIs_development$2.isLazy = Oe, reactIs_development$2.isMemo = Ze, reactIs_development$2.isPortal = et, reactIs_development$2.isProfiler = bt, reactIs_development$2.isStrictMode = rr, reactIs_development$2.isSuspense = St, reactIs_development$2.isValidElementType = N, reactIs_development$2.typeOf = B;
  }()), reactIs_development$2;
}
process.env.NODE_ENV === "production" ? reactIs$3.exports = requireReactIs_production_min$2() : reactIs$3.exports = requireReactIs_development$2();
var reactIsExports$2 = reactIs$3.exports, reactIs$2 = reactIsExports$2, FORWARD_REF_STATICS = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, MEMO_STATICS = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, TYPE_STATICS = {};
TYPE_STATICS[reactIs$2.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs$2.Memo] = MEMO_STATICS;
var isBrowser$2 = !0;
function getRegisteredStyles(e, t, n) {
  var o = "";
  return n.split(" ").forEach(function(s) {
    e[s] !== void 0 ? t.push(e[s] + ";") : o += s + " ";
  }), o;
}
var registerStyles = function(t, n, o) {
  var s = t.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (o === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$2 === !1) && t.registered[s] === void 0 && (t.registered[s] = n.styles);
}, insertStyles = function(t, n, o) {
  registerStyles(t, n, o);
  var s = t.key + "-" + n.name;
  if (t.inserted[n.name] === void 0) {
    var l = n;
    do
      t.insert(n === l ? "." + s : "", l, t.sheet, !0), l = l.next;
    while (l !== void 0);
  }
};
function murmur2(e) {
  for (var t = 0, n, o = 0, s = e.length; s >= 4; ++o, s -= 4)
    n = e.charCodeAt(o) & 255 | (e.charCodeAt(++o) & 255) << 8 | (e.charCodeAt(++o) & 255) << 16 | (e.charCodeAt(++o) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (s) {
    case 3:
      t ^= (e.charCodeAt(o + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(o + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(o) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, ILLEGAL_ESCAPE_SEQUENCE_ERROR$1 = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", hyphenateRegex = /[A-Z]|^ms/g, animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g, isCustomProperty = function(t) {
  return t.charCodeAt(1) === 45;
}, isProcessableValue = function(t) {
  return t != null && typeof t != "boolean";
}, processStyleName = /* @__PURE__ */ memoize$1(function(e) {
  return isCustomProperty(e) ? e : e.replace(hyphenateRegex, "-$&").toLowerCase();
}), processStyleValue = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(animationRegex, function(o, s, l) {
          return cursor = {
            name: s,
            styles: l,
            next: cursor
          }, s;
        });
  }
  return unitlessKeys[t] !== 1 && !isCustomProperty(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var contentValuePattern = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, contentValues = ["normal", "none", "initial", "inherit", "unset"], oldProcessStyleValue = processStyleValue, msPattern = /^-ms-/, hyphenPattern = /-(.)/g, hyphenatedCache = {};
  processStyleValue = function(t, n) {
    if (t === "content" && (typeof n != "string" || contentValues.indexOf(n) === -1 && !contentValuePattern.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var o = oldProcessStyleValue(t, n);
    return o !== "" && !isCustomProperty(t) && t.indexOf("-") !== -1 && hyphenatedCache[t] === void 0 && (hyphenatedCache[t] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + t.replace(msPattern, "ms-").replace(hyphenPattern, function(s, l) {
      return l.toUpperCase();
    }) + "?")), o;
  };
}
var noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(e, t, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(noComponentSelectorMessage);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return cursor = {
          name: n.name,
          styles: n.styles,
          next: cursor
        }, n.name;
      if (n.styles !== void 0) {
        var o = n.next;
        if (o !== void 0)
          for (; o !== void 0; )
            cursor = {
              name: o.name,
              styles: o.styles,
              next: cursor
            }, o = o.next;
        var s = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (s += n.map), s;
      }
      return createStringFromObject(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var l = cursor, c = n(e);
        return cursor = l, handleInterpolation(e, t, c);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var p = [], m = n.replace(animationRegex, function(P, w, R) {
          var L = "animation" + p.length;
          return p.push("const " + L + " = keyframes`" + R.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + L + "}";
        });
        p.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(p, ["`" + m + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + m + "`"));
      }
      break;
  }
  if (t == null)
    return n;
  var C = t[n];
  return C !== void 0 ? C : n;
}
function createStringFromObject(e, t, n) {
  var o = "";
  if (Array.isArray(n))
    for (var s = 0; s < n.length; s++)
      o += handleInterpolation(e, t, n[s]) + ";";
  else
    for (var l in n) {
      var c = n[l];
      if (typeof c != "object")
        t != null && t[c] !== void 0 ? o += l + "{" + t[c] + "}" : isProcessableValue(c) && (o += processStyleName(l) + ":" + processStyleValue(l, c) + ";");
      else {
        if (l === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(noComponentSelectorMessage);
        if (Array.isArray(c) && typeof c[0] == "string" && (t == null || t[c[0]] === void 0))
          for (var p = 0; p < c.length; p++)
            isProcessableValue(c[p]) && (o += processStyleName(l) + ":" + processStyleValue(l, c[p]) + ";");
        else {
          var m = handleInterpolation(e, t, c);
          switch (l) {
            case "animation":
            case "animationName": {
              o += processStyleName(l) + ":" + m + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && l === "undefined" && console.error(UNDEFINED_AS_OBJECT_KEY_ERROR), o += l + "{" + m + "}";
          }
        }
      }
    }
  return o;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g, sourceMapPattern;
process.env.NODE_ENV !== "production" && (sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var cursor, serializeStyles = function(t, n, o) {
  if (t.length === 1 && typeof t[0] == "object" && t[0] !== null && t[0].styles !== void 0)
    return t[0];
  var s = !0, l = "";
  cursor = void 0;
  var c = t[0];
  c == null || c.raw === void 0 ? (s = !1, l += handleInterpolation(o, n, c)) : (process.env.NODE_ENV !== "production" && c[0] === void 0 && console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1), l += c[0]);
  for (var p = 1; p < t.length; p++)
    l += handleInterpolation(o, n, t[p]), s && (process.env.NODE_ENV !== "production" && c[p] === void 0 && console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1), l += c[p]);
  var m;
  process.env.NODE_ENV !== "production" && (l = l.replace(sourceMapPattern, function(R) {
    return m = R, "";
  })), labelPattern.lastIndex = 0;
  for (var C = "", P; (P = labelPattern.exec(l)) !== null; )
    C += "-" + // $FlowFixMe we know it's not null
    P[1];
  var w = murmur2(l) + C;
  return process.env.NODE_ENV !== "production" ? {
    name: w,
    styles: l,
    map: m,
    next: cursor,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: w,
    styles: l,
    next: cursor
  };
}, syncFallback = function(t) {
  return t();
}, useInsertionEffect = React$2["useInsertionEffect"] ? React$2["useInsertionEffect"] : !1, useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback, useInsertionEffectWithLayoutFallback = useInsertionEffect || React$2.useLayoutEffect, hasOwn = {}.hasOwnProperty, EmotionCacheContext = /* @__PURE__ */ React$2.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ createCache({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (EmotionCacheContext.displayName = "EmotionCacheContext");
var CacheProvider = EmotionCacheContext.Provider, withEmotionCache = function(t) {
  return /* @__PURE__ */ forwardRef(function(n, o) {
    var s = useContext(EmotionCacheContext);
    return t(n, s, o);
  });
}, ThemeContext$2 = /* @__PURE__ */ React$2.createContext({});
process.env.NODE_ENV !== "production" && (ThemeContext$2.displayName = "EmotionThemeContext");
var typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", Insertion$2 = function(t) {
  var n = t.cache, o = t.serialized, s = t.isStringTag;
  return registerStyles(n, o, s), useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(n, o, s);
  }), null;
}, Emotion = /* @__PURE__ */ withEmotionCache(function(e, t, n) {
  var o = e.css;
  typeof o == "string" && t.registered[o] !== void 0 && (o = t.registered[o]);
  var s = e[typePropName], l = [o], c = "";
  typeof e.className == "string" ? c = getRegisteredStyles(t.registered, l, e.className) : e.className != null && (c = e.className + " ");
  var p = serializeStyles(l, void 0, React$2.useContext(ThemeContext$2));
  if (process.env.NODE_ENV !== "production" && p.name.indexOf("-") === -1) {
    var m = e[labelPropName];
    m && (p = serializeStyles([p, "label:" + m + ";"]));
  }
  c += t.key + "-" + p.name;
  var C = {};
  for (var P in e)
    hasOwn.call(e, P) && P !== "css" && P !== typePropName && (process.env.NODE_ENV === "production" || P !== labelPropName) && (C[P] = e[P]);
  return C.ref = n, C.className = c, /* @__PURE__ */ React$2.createElement(React$2.Fragment, null, /* @__PURE__ */ React$2.createElement(Insertion$2, {
    cache: t,
    serialized: p,
    isStringTag: typeof s == "string"
  }), /* @__PURE__ */ React$2.createElement(s, C));
});
process.env.NODE_ENV !== "production" && (Emotion.displayName = "EmotionCssPropInternal");
var _extends$4 = { exports: {} }, hasRequired_extends;
function require_extends() {
  return hasRequired_extends || (hasRequired_extends = 1, function(e) {
    function t() {
      return e.exports = t = Object.assign ? Object.assign.bind() : function(n) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var l in s)
            Object.prototype.hasOwnProperty.call(s, l) && (n[l] = s[l]);
        }
        return n;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t.apply(this, arguments);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(_extends$4)), _extends$4.exports;
}
require_extends();
var pkg = {
  name: "@emotion/react",
  version: "11.11.4",
  main: "dist/emotion-react.cjs.js",
  module: "dist/emotion-react.esm.js",
  browser: {
    "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
  },
  exports: {
    ".": {
      module: {
        worker: "./dist/emotion-react.worker.esm.js",
        browser: "./dist/emotion-react.browser.esm.js",
        default: "./dist/emotion-react.esm.js"
      },
      import: "./dist/emotion-react.cjs.mjs",
      default: "./dist/emotion-react.cjs.js"
    },
    "./jsx-runtime": {
      module: {
        worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
        browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
        default: "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
      },
      import: "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
      default: "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
    },
    "./_isolated-hnrs": {
      module: {
        worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
        browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
        default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
      },
      import: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
      default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
    },
    "./jsx-dev-runtime": {
      module: {
        worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
        browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
        default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
      },
      import: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
      default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
    },
    "./package.json": "./package.json",
    "./types/css-prop": "./types/css-prop.d.ts",
    "./macro": {
      types: {
        import: "./macro.d.mts",
        default: "./macro.d.ts"
      },
      default: "./macro.js"
    }
  },
  types: "types/index.d.ts",
  files: [
    "src",
    "dist",
    "jsx-runtime",
    "jsx-dev-runtime",
    "_isolated-hnrs",
    "types/*.d.ts",
    "macro.*"
  ],
  sideEffects: !1,
  author: "Emotion Contributors",
  license: "MIT",
  scripts: {
    "test:typescript": "dtslint types"
  },
  dependencies: {
    "@babel/runtime": "^7.18.3",
    "@emotion/babel-plugin": "^11.11.0",
    "@emotion/cache": "^11.11.0",
    "@emotion/serialize": "^1.1.3",
    "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
    "@emotion/utils": "^1.2.1",
    "@emotion/weak-memoize": "^0.3.1",
    "hoist-non-react-statics": "^3.3.1"
  },
  peerDependencies: {
    react: ">=16.8.0"
  },
  peerDependenciesMeta: {
    "@types/react": {
      optional: !0
    }
  },
  devDependencies: {
    "@definitelytyped/dtslint": "0.0.112",
    "@emotion/css": "11.11.2",
    "@emotion/css-prettifier": "1.1.3",
    "@emotion/server": "11.11.0",
    "@emotion/styled": "11.11.0",
    "html-tag-names": "^1.1.2",
    react: "16.14.0",
    "svg-tag-names": "^1.1.1",
    typescript: "^4.5.5"
  },
  repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
  publishConfig: {
    access: "public"
  },
  "umd:main": "dist/emotion-react.umd.min.js",
  preconstruct: {
    entrypoints: [
      "./index.js",
      "./jsx-runtime.js",
      "./jsx-dev-runtime.js",
      "./_isolated-hnrs.js"
    ],
    umdName: "emotionReact",
    exports: {
      envConditions: [
        "browser",
        "worker"
      ],
      extra: {
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
          types: {
            import: "./macro.d.mts",
            default: "./macro.d.ts"
          },
          default: "./macro.js"
        }
      }
    }
  }
}, warnedAboutCssPropForGlobal = !1, Global = /* @__PURE__ */ withEmotionCache(function(e, t) {
  process.env.NODE_ENV !== "production" && !warnedAboutCssPropForGlobal && // check for className as well since the user is
  // probably using the custom createElement which
  // means it will be turned into a className prop
  // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
  (e.className || e.css) && (console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?"), warnedAboutCssPropForGlobal = !0);
  var n = e.styles, o = serializeStyles([n], void 0, React$2.useContext(ThemeContext$2)), s = React$2.useRef();
  return useInsertionEffectWithLayoutFallback(function() {
    var l = t.key + "-global", c = new t.sheet.constructor({
      key: l,
      nonce: t.sheet.nonce,
      container: t.sheet.container,
      speedy: t.sheet.isSpeedy
    }), p = !1, m = document.querySelector('style[data-emotion="' + l + " " + o.name + '"]');
    return t.sheet.tags.length && (c.before = t.sheet.tags[0]), m !== null && (p = !0, m.setAttribute("data-emotion", l), c.hydrate([m])), s.current = [c, p], function() {
      c.flush();
    };
  }, [t]), useInsertionEffectWithLayoutFallback(function() {
    var l = s.current, c = l[0], p = l[1];
    if (p) {
      l[1] = !1;
      return;
    }
    if (o.next !== void 0 && insertStyles(t, o.next, !0), c.tags.length) {
      var m = c.tags[c.tags.length - 1].nextElementSibling;
      c.before = m, c.flush();
    }
    t.insert("", o, c, !1);
  }, [t, o.name]), null;
});
process.env.NODE_ENV !== "production" && (Global.displayName = "EmotionGlobal");
function css() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return serializeStyles(t);
}
var keyframes = function() {
  var t = css.apply(void 0, arguments), n = "animation-" + t.name;
  return {
    name: n,
    styles: "@keyframes " + n + "{" + t.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}, classnames = function e(t) {
  for (var n = t.length, o = 0, s = ""; o < n; o++) {
    var l = t[o];
    if (l != null) {
      var c = void 0;
      switch (typeof l) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(l))
            c = e(l);
          else {
            process.env.NODE_ENV !== "production" && l.styles !== void 0 && l.name !== void 0 && console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component."), c = "";
            for (var p in l)
              l[p] && p && (c && (c += " "), c += p);
          }
          break;
        }
        default:
          c = l;
      }
      c && (s && (s += " "), s += c);
    }
  }
  return s;
};
function merge$2(e, t, n) {
  var o = [], s = getRegisteredStyles(e, o, n);
  return o.length < 2 ? n : s + t(o);
}
var Insertion$1 = function(t) {
  var n = t.cache, o = t.serializedArr;
  return useInsertionEffectAlwaysWithSyncFallback(function() {
    for (var s = 0; s < o.length; s++)
      insertStyles(n, o[s], !1);
  }), null;
}, ClassNames = /* @__PURE__ */ withEmotionCache(function(e, t) {
  var n = !1, o = [], s = function() {
    if (n && process.env.NODE_ENV !== "production")
      throw new Error("css can only be used during render");
    for (var C = arguments.length, P = new Array(C), w = 0; w < C; w++)
      P[w] = arguments[w];
    var R = serializeStyles(P, t.registered);
    return o.push(R), registerStyles(t, R, !1), t.key + "-" + R.name;
  }, l = function() {
    if (n && process.env.NODE_ENV !== "production")
      throw new Error("cx can only be used during render");
    for (var C = arguments.length, P = new Array(C), w = 0; w < C; w++)
      P[w] = arguments[w];
    return merge$2(t.registered, s, classnames(P));
  }, c = {
    css: s,
    cx: l,
    theme: React$2.useContext(ThemeContext$2)
  }, p = e.children(c);
  return n = !0, /* @__PURE__ */ React$2.createElement(React$2.Fragment, null, /* @__PURE__ */ React$2.createElement(Insertion$1, {
    cache: t,
    serializedArr: o
  }), p);
});
process.env.NODE_ENV !== "production" && (ClassNames.displayName = "EmotionClassNames");
if (process.env.NODE_ENV !== "production") {
  var isBrowser$1 = !0, isTestEnv = typeof jest < "u" || typeof vi < "u";
  if (isBrowser$1 && !isTestEnv) {
    var globalContext = (
      // $FlowIgnore
      typeof globalThis < "u" ? globalThis : isBrowser$1 ? window : global
    ), globalKey = "__EMOTION_REACT_" + pkg.version.split(".")[0] + "__";
    globalContext[globalKey] && console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used."), globalContext[globalKey] = !0;
  }
}
var testOmitPropsOnStringTag = isPropValid, testOmitPropsOnComponent = function(t) {
  return t !== "theme";
}, getDefaultShouldForwardProp = function(t) {
  return typeof t == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  t.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
}, composeShouldForwardProps = function(t, n, o) {
  var s;
  if (n) {
    var l = n.shouldForwardProp;
    s = t.__emotion_forwardProp && l ? function(c) {
      return t.__emotion_forwardProp(c) && l(c);
    } : l;
  }
  return typeof s != "function" && o && (s = t.__emotion_forwardProp), s;
}, ILLEGAL_ESCAPE_SEQUENCE_ERROR = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, Insertion = function(t) {
  var n = t.cache, o = t.serialized, s = t.isStringTag;
  return registerStyles(n, o, s), useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(n, o, s);
  }), null;
}, createStyled$3 = function e(t, n) {
  if (process.env.NODE_ENV !== "production" && t === void 0)
    throw new Error(`You are trying to create a styled element with an undefined component.
You may have forgotten to import it.`);
  var o = t.__emotion_real === t, s = o && t.__emotion_base || t, l, c;
  n !== void 0 && (l = n.label, c = n.target);
  var p = composeShouldForwardProps(t, n, o), m = p || getDefaultShouldForwardProp(s), C = !m("as");
  return function() {
    var P = arguments, w = o && t.__emotion_styles !== void 0 ? t.__emotion_styles.slice(0) : [];
    if (l !== void 0 && w.push("label:" + l + ";"), P[0] == null || P[0].raw === void 0)
      w.push.apply(w, P);
    else {
      process.env.NODE_ENV !== "production" && P[0][0] === void 0 && console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR), w.push(P[0][0]);
      for (var R = P.length, L = 1; L < R; L++)
        process.env.NODE_ENV !== "production" && P[0][L] === void 0 && console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR), w.push(P[L], P[0][L]);
    }
    var M = withEmotionCache(function($, W, H) {
      var V = C && $.as || s, N = "", B = [], K = $;
      if ($.theme == null) {
        K = {};
        for (var ue in $)
          K[ue] = $[ue];
        K.theme = React$2.useContext(ThemeContext$2);
      }
      typeof $.className == "string" ? N = getRegisteredStyles(W.registered, B, $.className) : $.className != null && (N = $.className + " ");
      var de = serializeStyles(w.concat(B), W.registered, K);
      N += W.key + "-" + de.name, c !== void 0 && (N += " " + c);
      var ve = C && p === void 0 ? getDefaultShouldForwardProp(V) : m, Te = {};
      for (var Pe in $)
        C && Pe === "as" || // $FlowFixMe
        ve(Pe) && (Te[Pe] = $[Pe]);
      return Te.className = N, Te.ref = H, /* @__PURE__ */ React$2.createElement(React$2.Fragment, null, /* @__PURE__ */ React$2.createElement(Insertion, {
        cache: W,
        serialized: de,
        isStringTag: typeof V == "string"
      }), /* @__PURE__ */ React$2.createElement(V, Te));
    });
    return M.displayName = l !== void 0 ? l : "Styled(" + (typeof s == "string" ? s : s.displayName || s.name || "Component") + ")", M.defaultProps = t.defaultProps, M.__emotion_real = M, M.__emotion_base = s, M.__emotion_styles = w, M.__emotion_forwardProp = p, Object.defineProperty(M, "toString", {
      value: function() {
        return c === void 0 && process.env.NODE_ENV !== "production" ? "NO_COMPONENT_SELECTOR" : "." + c;
      }
    }), M.withComponent = function($, W) {
      return e($, _extends$5({}, n, W, {
        shouldForwardProp: composeShouldForwardProps(M, W, !0)
      })).apply(void 0, w);
    }, M;
  };
}, tags = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], newStyled = createStyled$3.bind();
tags.forEach(function(e) {
  newStyled[e] = newStyled(e);
});
var propTypes$1 = { exports: {} };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign, hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign)
    return objectAssign;
  hasRequiredObjectAssign = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function o(l) {
    if (l == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(l);
  }
  function s() {
    try {
      if (!Object.assign)
        return !1;
      var l = new String("abc");
      if (l[5] = "de", Object.getOwnPropertyNames(l)[0] === "5")
        return !1;
      for (var c = {}, p = 0; p < 10; p++)
        c["_" + String.fromCharCode(p)] = p;
      var m = Object.getOwnPropertyNames(c).map(function(P) {
        return c[P];
      });
      if (m.join("") !== "0123456789")
        return !1;
      var C = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(P) {
        C[P] = P;
      }), Object.keys(Object.assign({}, C)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return objectAssign = s() ? Object.assign : function(l, c) {
    for (var p, m = o(l), C, P = 1; P < arguments.length; P++) {
      p = Object(arguments[P]);
      for (var w in p)
        t.call(p, w) && (m[w] = p[w]);
      if (e) {
        C = e(p);
        for (var R = 0; R < C.length; R++)
          n.call(p, C[R]) && (m[C[R]] = p[C[R]]);
      }
    }
    return m;
  }, objectAssign;
}
var ReactPropTypesSecret_1, hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret)
    return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ReactPropTypesSecret_1 = e, ReactPropTypesSecret_1;
}
var has, hasRequiredHas;
function requireHas() {
  return hasRequiredHas || (hasRequiredHas = 1, has = Function.call.bind(Object.prototype.hasOwnProperty)), has;
}
var checkPropTypes_1, hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes)
    return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = requireReactPropTypesSecret(), n = {}, o = requireHas();
    e = function(l) {
      var c = "Warning: " + l;
      typeof console < "u" && console.error(c);
      try {
        throw new Error(c);
      } catch {
      }
    };
  }
  function s(l, c, p, m, C) {
    if (process.env.NODE_ENV !== "production") {
      for (var P in l)
        if (o(l, P)) {
          var w;
          try {
            if (typeof l[P] != "function") {
              var R = Error(
                (m || "React class") + ": " + p + " type `" + P + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof l[P] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw R.name = "Invariant Violation", R;
            }
            w = l[P](c, P, m, p, null, t);
          } catch (M) {
            w = M;
          }
          if (w && !(w instanceof Error) && e(
            (m || "React class") + ": type specification of " + p + " `" + P + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof w + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), w instanceof Error && !(w.message in n)) {
            n[w.message] = !0;
            var L = C ? C() : "";
            e(
              "Failed " + p + " type: " + w.message + (L ?? "")
            );
          }
        }
    }
  }
  return s.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, checkPropTypes_1 = s, checkPropTypes_1;
}
var factoryWithTypeCheckers, hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers)
    return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var e = reactIsExports$2, t = requireObjectAssign(), n = requireReactPropTypesSecret(), o = requireHas(), s = requireCheckPropTypes(), l = function() {
  };
  process.env.NODE_ENV !== "production" && (l = function(p) {
    var m = "Warning: " + p;
    typeof console < "u" && console.error(m);
    try {
      throw new Error(m);
    } catch {
    }
  });
  function c() {
    return null;
  }
  return factoryWithTypeCheckers = function(p, m) {
    var C = typeof Symbol == "function" && Symbol.iterator, P = "@@iterator";
    function w(ye) {
      var Ee = ye && (C && ye[C] || ye[P]);
      if (typeof Ee == "function")
        return Ee;
    }
    var R = "<<anonymous>>", L = {
      array: H("array"),
      bigint: H("bigint"),
      bool: H("boolean"),
      func: H("function"),
      number: H("number"),
      object: H("object"),
      string: H("string"),
      symbol: H("symbol"),
      any: V(),
      arrayOf: N,
      element: B(),
      elementType: K(),
      instanceOf: ue,
      node: Pe(),
      objectOf: ve,
      oneOf: de,
      oneOfType: Te,
      shape: Re,
      exact: ke
    };
    function M(ye, Ee) {
      return ye === Ee ? ye !== 0 || 1 / ye === 1 / Ee : ye !== ye && Ee !== Ee;
    }
    function $(ye, Ee) {
      this.message = ye, this.data = Ee && typeof Ee == "object" ? Ee : {}, this.stack = "";
    }
    $.prototype = Error.prototype;
    function W(ye) {
      if (process.env.NODE_ENV !== "production")
        var Ee = {}, Ie = 0;
      function Fe(Ve, Oe, Ze, et, bt, rr, St) {
        if (et = et || R, rr = rr || Ze, St !== n) {
          if (m) {
            var Qe = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw Qe.name = "Invariant Violation", Qe;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var xt = et + ":" + Ze;
            !Ee[xt] && // Avoid spamming the console because they are often not actionable except for lib authors
            Ie < 3 && (l(
              "You are manually calling a React.PropTypes validation function for the `" + rr + "` prop on `" + et + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), Ee[xt] = !0, Ie++);
          }
        }
        return Oe[Ze] == null ? Ve ? Oe[Ze] === null ? new $("The " + bt + " `" + rr + "` is marked as required " + ("in `" + et + "`, but its value is `null`.")) : new $("The " + bt + " `" + rr + "` is marked as required in " + ("`" + et + "`, but its value is `undefined`.")) : null : ye(Oe, Ze, et, bt, rr);
      }
      var De = Fe.bind(null, !1);
      return De.isRequired = Fe.bind(null, !0), De;
    }
    function H(ye) {
      function Ee(Ie, Fe, De, Ve, Oe, Ze) {
        var et = Ie[Fe], bt = he(et);
        if (bt !== ye) {
          var rr = be(et);
          return new $(
            "Invalid " + Ve + " `" + Oe + "` of type " + ("`" + rr + "` supplied to `" + De + "`, expected ") + ("`" + ye + "`."),
            { expectedType: ye }
          );
        }
        return null;
      }
      return W(Ee);
    }
    function V() {
      return W(c);
    }
    function N(ye) {
      function Ee(Ie, Fe, De, Ve, Oe) {
        if (typeof ye != "function")
          return new $("Property `" + Oe + "` of component `" + De + "` has invalid PropType notation inside arrayOf.");
        var Ze = Ie[Fe];
        if (!Array.isArray(Ze)) {
          var et = he(Ze);
          return new $("Invalid " + Ve + " `" + Oe + "` of type " + ("`" + et + "` supplied to `" + De + "`, expected an array."));
        }
        for (var bt = 0; bt < Ze.length; bt++) {
          var rr = ye(Ze, bt, De, Ve, Oe + "[" + bt + "]", n);
          if (rr instanceof Error)
            return rr;
        }
        return null;
      }
      return W(Ee);
    }
    function B() {
      function ye(Ee, Ie, Fe, De, Ve) {
        var Oe = Ee[Ie];
        if (!p(Oe)) {
          var Ze = he(Oe);
          return new $("Invalid " + De + " `" + Ve + "` of type " + ("`" + Ze + "` supplied to `" + Fe + "`, expected a single ReactElement."));
        }
        return null;
      }
      return W(ye);
    }
    function K() {
      function ye(Ee, Ie, Fe, De, Ve) {
        var Oe = Ee[Ie];
        if (!e.isValidElementType(Oe)) {
          var Ze = he(Oe);
          return new $("Invalid " + De + " `" + Ve + "` of type " + ("`" + Ze + "` supplied to `" + Fe + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return W(ye);
    }
    function ue(ye) {
      function Ee(Ie, Fe, De, Ve, Oe) {
        if (!(Ie[Fe] instanceof ye)) {
          var Ze = ye.name || R, et = fe(Ie[Fe]);
          return new $("Invalid " + Ve + " `" + Oe + "` of type " + ("`" + et + "` supplied to `" + De + "`, expected ") + ("instance of `" + Ze + "`."));
        }
        return null;
      }
      return W(Ee);
    }
    function de(ye) {
      if (!Array.isArray(ye))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? l(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : l("Invalid argument supplied to oneOf, expected an array.")), c;
      function Ee(Ie, Fe, De, Ve, Oe) {
        for (var Ze = Ie[Fe], et = 0; et < ye.length; et++)
          if (M(Ze, ye[et]))
            return null;
        var bt = JSON.stringify(ye, function(St, Qe) {
          var xt = be(Qe);
          return xt === "symbol" ? String(Qe) : Qe;
        });
        return new $("Invalid " + Ve + " `" + Oe + "` of value `" + String(Ze) + "` " + ("supplied to `" + De + "`, expected one of " + bt + "."));
      }
      return W(Ee);
    }
    function ve(ye) {
      function Ee(Ie, Fe, De, Ve, Oe) {
        if (typeof ye != "function")
          return new $("Property `" + Oe + "` of component `" + De + "` has invalid PropType notation inside objectOf.");
        var Ze = Ie[Fe], et = he(Ze);
        if (et !== "object")
          return new $("Invalid " + Ve + " `" + Oe + "` of type " + ("`" + et + "` supplied to `" + De + "`, expected an object."));
        for (var bt in Ze)
          if (o(Ze, bt)) {
            var rr = ye(Ze, bt, De, Ve, Oe + "." + bt, n);
            if (rr instanceof Error)
              return rr;
          }
        return null;
      }
      return W(Ee);
    }
    function Te(ye) {
      if (!Array.isArray(ye))
        return process.env.NODE_ENV !== "production" && l("Invalid argument supplied to oneOfType, expected an instance of array."), c;
      for (var Ee = 0; Ee < ye.length; Ee++) {
        var Ie = ye[Ee];
        if (typeof Ie != "function")
          return l(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + le(Ie) + " at index " + Ee + "."
          ), c;
      }
      function Fe(De, Ve, Oe, Ze, et) {
        for (var bt = [], rr = 0; rr < ye.length; rr++) {
          var St = ye[rr], Qe = St(De, Ve, Oe, Ze, et, n);
          if (Qe == null)
            return null;
          Qe.data && o(Qe.data, "expectedType") && bt.push(Qe.data.expectedType);
        }
        var xt = bt.length > 0 ? ", expected one of type [" + bt.join(", ") + "]" : "";
        return new $("Invalid " + Ze + " `" + et + "` supplied to " + ("`" + Oe + "`" + xt + "."));
      }
      return W(Fe);
    }
    function Pe() {
      function ye(Ee, Ie, Fe, De, Ve) {
        return Ae(Ee[Ie]) ? null : new $("Invalid " + De + " `" + Ve + "` supplied to " + ("`" + Fe + "`, expected a ReactNode."));
      }
      return W(ye);
    }
    function Ce(ye, Ee, Ie, Fe, De) {
      return new $(
        (ye || "React class") + ": " + Ee + " type `" + Ie + "." + Fe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + De + "`."
      );
    }
    function Re(ye) {
      function Ee(Ie, Fe, De, Ve, Oe) {
        var Ze = Ie[Fe], et = he(Ze);
        if (et !== "object")
          return new $("Invalid " + Ve + " `" + Oe + "` of type `" + et + "` " + ("supplied to `" + De + "`, expected `object`."));
        for (var bt in ye) {
          var rr = ye[bt];
          if (typeof rr != "function")
            return Ce(De, Ve, Oe, bt, be(rr));
          var St = rr(Ze, bt, De, Ve, Oe + "." + bt, n);
          if (St)
            return St;
        }
        return null;
      }
      return W(Ee);
    }
    function ke(ye) {
      function Ee(Ie, Fe, De, Ve, Oe) {
        var Ze = Ie[Fe], et = he(Ze);
        if (et !== "object")
          return new $("Invalid " + Ve + " `" + Oe + "` of type `" + et + "` " + ("supplied to `" + De + "`, expected `object`."));
        var bt = t({}, Ie[Fe], ye);
        for (var rr in bt) {
          var St = ye[rr];
          if (o(ye, rr) && typeof St != "function")
            return Ce(De, Ve, Oe, rr, be(St));
          if (!St)
            return new $(
              "Invalid " + Ve + " `" + Oe + "` key `" + rr + "` supplied to `" + De + "`.\nBad object: " + JSON.stringify(Ie[Fe], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(ye), null, "  ")
            );
          var Qe = St(Ze, rr, De, Ve, Oe + "." + rr, n);
          if (Qe)
            return Qe;
        }
        return null;
      }
      return W(Ee);
    }
    function Ae(ye) {
      switch (typeof ye) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !ye;
        case "object":
          if (Array.isArray(ye))
            return ye.every(Ae);
          if (ye === null || p(ye))
            return !0;
          var Ee = w(ye);
          if (Ee) {
            var Ie = Ee.call(ye), Fe;
            if (Ee !== ye.entries) {
              for (; !(Fe = Ie.next()).done; )
                if (!Ae(Fe.value))
                  return !1;
            } else
              for (; !(Fe = Ie.next()).done; ) {
                var De = Fe.value;
                if (De && !Ae(De[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function we(ye, Ee) {
      return ye === "symbol" ? !0 : Ee ? Ee["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && Ee instanceof Symbol : !1;
    }
    function he(ye) {
      var Ee = typeof ye;
      return Array.isArray(ye) ? "array" : ye instanceof RegExp ? "object" : we(Ee, ye) ? "symbol" : Ee;
    }
    function be(ye) {
      if (typeof ye > "u" || ye === null)
        return "" + ye;
      var Ee = he(ye);
      if (Ee === "object") {
        if (ye instanceof Date)
          return "date";
        if (ye instanceof RegExp)
          return "regexp";
      }
      return Ee;
    }
    function le(ye) {
      var Ee = be(ye);
      switch (Ee) {
        case "array":
        case "object":
          return "an " + Ee;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + Ee;
        default:
          return Ee;
      }
    }
    function fe(ye) {
      return !ye.constructor || !ye.constructor.name ? R : ye.constructor.name;
    }
    return L.checkPropTypes = s, L.resetWarningCache = s.resetWarningCache, L.PropTypes = L, L;
  }, factoryWithTypeCheckers;
}
var factoryWithThrowingShims, hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims)
    return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var e = requireReactPropTypesSecret();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, factoryWithThrowingShims = function() {
    function o(c, p, m, C, P, w) {
      if (w !== e) {
        var R = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw R.name = "Invariant Violation", R;
      }
    }
    o.isRequired = o;
    function s() {
      return o;
    }
    var l = {
      array: o,
      bigint: o,
      bool: o,
      func: o,
      number: o,
      object: o,
      string: o,
      symbol: o,
      any: o,
      arrayOf: s,
      element: o,
      elementType: o,
      instanceOf: s,
      node: o,
      objectOf: s,
      oneOf: s,
      oneOfType: s,
      shape: s,
      exact: s,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return l.PropTypes = l, l;
  }, factoryWithThrowingShims;
}
if (process.env.NODE_ENV !== "production") {
  var ReactIs = reactIsExports$2, throwOnDirectAccess = !0;
  propTypes$1.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else
  propTypes$1.exports = requireFactoryWithThrowingShims()();
var propTypesExports = propTypes$1.exports;
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
let cache;
typeof document == "object" && (cache = createCache({
  key: "css",
  prepend: !0
}));
function StyledEngineProvider(e) {
  const {
    injectFirst: t,
    children: n
  } = e;
  return t && cache ? /* @__PURE__ */ jsxRuntimeExports.jsx(CacheProvider, {
    value: cache,
    children: n
  }) : n;
}
process.env.NODE_ENV !== "production" && (StyledEngineProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */
  injectFirst: PropTypes.bool
});
function isEmpty$4(e) {
  return e == null || Object.keys(e).length === 0;
}
function GlobalStyles$2(e) {
  const {
    styles: t,
    defaultTheme: n = {}
  } = e, o = typeof t == "function" ? (s) => t(isEmpty$4(s) ? n : s) : t;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Global, {
    styles: o
  });
}
process.env.NODE_ENV !== "production" && (GlobalStyles$2.propTypes = {
  defaultTheme: PropTypes.object,
  styles: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.object, PropTypes.func])
});
/**
 * @mui/styled-engine v5.15.11
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function styled$2(e, t) {
  const n = newStyled(e, t);
  return process.env.NODE_ENV !== "production" ? (...o) => {
    const s = typeof e == "string" ? `"${e}"` : "component";
    return o.length === 0 ? console.error([`MUI: Seems like you called \`styled(${s})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : o.some((l) => l === void 0) && console.error(`MUI: the styled(${s})(...args) API requires all its args to be defined.`), n(...o);
  } : n;
}
const internal_processStyles = (e, t) => {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}, styledEngine = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GlobalStyles: GlobalStyles$2,
  StyledEngineProvider,
  ThemeContext: ThemeContext$2,
  css,
  default: styled$2,
  internal_processStyles,
  keyframes
}, Symbol.toStringTag, { value: "Module" }));
function isPlainObject$1(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function deepClone(e) {
  if (!isPlainObject$1(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((n) => {
    t[n] = deepClone(e[n]);
  }), t;
}
function deepmerge$1(e, t, n = {
  clone: !0
}) {
  const o = n.clone ? _extends$5({}, e) : e;
  return isPlainObject$1(e) && isPlainObject$1(t) && Object.keys(t).forEach((s) => {
    s !== "__proto__" && (isPlainObject$1(t[s]) && s in e && isPlainObject$1(e[s]) ? o[s] = deepmerge$1(e[s], t[s], n) : n.clone ? o[s] = isPlainObject$1(t[s]) ? deepClone(t[s]) : t[s] : o[s] = t[s]);
  }), o;
}
const deepmerge = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: deepmerge$1,
  isPlainObject: isPlainObject$1
}, Symbol.toStringTag, { value: "Module" })), _excluded$_ = ["values", "unit", "step"], sortBreakpointsValues = (e) => {
  const t = Object.keys(e).map((n) => ({
    key: n,
    val: e[n]
  })) || [];
  return t.sort((n, o) => n.val - o.val), t.reduce((n, o) => _extends$5({}, n, {
    [o.key]: o.val
  }), {});
};
function createBreakpoints(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: n = "px",
    step: o = 5
  } = e, s = _objectWithoutPropertiesLoose$3(e, _excluded$_), l = sortBreakpointsValues(t), c = Object.keys(l);
  function p(R) {
    return `@media (min-width:${typeof t[R] == "number" ? t[R] : R}${n})`;
  }
  function m(R) {
    return `@media (max-width:${(typeof t[R] == "number" ? t[R] : R) - o / 100}${n})`;
  }
  function C(R, L) {
    const M = c.indexOf(L);
    return `@media (min-width:${typeof t[R] == "number" ? t[R] : R}${n}) and (max-width:${(M !== -1 && typeof t[c[M]] == "number" ? t[c[M]] : L) - o / 100}${n})`;
  }
  function P(R) {
    return c.indexOf(R) + 1 < c.length ? C(R, c[c.indexOf(R) + 1]) : p(R);
  }
  function w(R) {
    const L = c.indexOf(R);
    return L === 0 ? p(c[1]) : L === c.length - 1 ? m(c[L]) : C(R, c[c.indexOf(R) + 1]).replace("@media", "@media not all and");
  }
  return _extends$5({
    keys: c,
    values: l,
    up: p,
    down: m,
    between: C,
    only: P,
    not: w,
    unit: n
  }, s);
}
const shape = {
  borderRadius: 4
}, shape$1 = shape, responsivePropType = process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {}, responsivePropType$1 = responsivePropType;
function merge$1(e, t) {
  return t ? deepmerge$1(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const values$1 = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${values$1[e]}px)`
};
function handleBreakpoints(e, t, n) {
  const o = e.theme || {};
  if (Array.isArray(t)) {
    const l = o.breakpoints || defaultBreakpoints;
    return t.reduce((c, p, m) => (c[l.up(l.keys[m])] = n(t[m]), c), {});
  }
  if (typeof t == "object") {
    const l = o.breakpoints || defaultBreakpoints;
    return Object.keys(t).reduce((c, p) => {
      if (Object.keys(l.values || values$1).indexOf(p) !== -1) {
        const m = l.up(p);
        c[m] = n(t[p], p);
      } else {
        const m = p;
        c[m] = t[m];
      }
      return c;
    }, {});
  }
  return n(t);
}
function createEmptyBreakpointObject(e = {}) {
  var t;
  return ((t = e.keys) == null ? void 0 : t.reduce((o, s) => {
    const l = e.up(s);
    return o[l] = {}, o;
  }, {})) || {};
}
function removeUnusedBreakpoints(e, t) {
  return e.reduce((n, o) => {
    const s = n[o];
    return (!s || Object.keys(s).length === 0) && delete n[o], n;
  }, t);
}
function mergeBreakpointsInOrder(e, ...t) {
  const n = createEmptyBreakpointObject(e), o = [n, ...t].reduce((s, l) => deepmerge$1(s, l), {});
  return removeUnusedBreakpoints(Object.keys(n), o);
}
function computeBreakpointsBase(e, t) {
  if (typeof e != "object")
    return {};
  const n = {}, o = Object.keys(t);
  return Array.isArray(e) ? o.forEach((s, l) => {
    l < e.length && (n[s] = !0);
  }) : o.forEach((s) => {
    e[s] != null && (n[s] = !0);
  }), n;
}
function resolveBreakpointValues({
  values: e,
  breakpoints: t,
  base: n
}) {
  const o = n || computeBreakpointsBase(e, t), s = Object.keys(o);
  if (s.length === 0)
    return e;
  let l;
  return s.reduce((c, p, m) => (Array.isArray(e) ? (c[p] = e[m] != null ? e[m] : e[l], l = m) : typeof e == "object" ? (c[p] = e[p] != null ? e[p] : e[l], l = p) : c[p] = e, c), {});
}
function capitalize$1(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : formatMuiErrorMessage$1(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const capitalize = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: capitalize$1
}, Symbol.toStringTag, { value: "Module" }));
function getPath(e, t, n = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && n) {
    const o = `vars.${t}`.split(".").reduce((s, l) => s && s[l] ? s[l] : null, e);
    if (o != null)
      return o;
  }
  return t.split(".").reduce((o, s) => o && o[s] != null ? o[s] : null, e);
}
function getStyleValue$1(e, t, n, o = n) {
  let s;
  return typeof e == "function" ? s = e(n) : Array.isArray(e) ? s = e[n] || o : s = getPath(e, n) || o, t && (s = t(s, o, e)), s;
}
function style$2(e) {
  const {
    prop: t,
    cssProperty: n = e.prop,
    themeKey: o,
    transform: s
  } = e, l = (c) => {
    if (c[t] == null)
      return null;
    const p = c[t], m = c.theme, C = getPath(m, o) || {};
    return handleBreakpoints(c, p, (w) => {
      let R = getStyleValue$1(C, s, w);
      return w === R && typeof w == "string" && (R = getStyleValue$1(C, s, `${t}${w === "default" ? "" : capitalize$1(w)}`, w)), n === !1 ? R : {
        [n]: R
      };
    });
  };
  return l.propTypes = process.env.NODE_ENV !== "production" ? {
    [t]: responsivePropType$1
  } : {}, l.filterProps = [t], l;
}
function memoize(e) {
  const t = {};
  return (n) => (t[n] === void 0 && (t[n] = e(n)), t[n]);
}
const properties = {
  m: "margin",
  p: "padding"
}, directions = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, aliases$1 = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, getCssProperties = memoize((e) => {
  if (e.length > 2)
    if (aliases$1[e])
      e = aliases$1[e];
    else
      return [e];
  const [t, n] = e.split(""), o = properties[t], s = directions[n] || "";
  return Array.isArray(s) ? s.map((l) => o + l) : [o + s];
}), marginKeys = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], paddingKeys = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], spacingKeys = [...marginKeys, ...paddingKeys];
function createUnaryUnit(e, t, n, o) {
  var s;
  const l = (s = getPath(e, t, !1)) != null ? s : n;
  return typeof l == "number" ? (c) => typeof c == "string" ? c : (process.env.NODE_ENV !== "production" && typeof c != "number" && console.error(`MUI: Expected ${o} argument to be a number or a string, got ${c}.`), l * c) : Array.isArray(l) ? (c) => typeof c == "string" ? c : (process.env.NODE_ENV !== "production" && (Number.isInteger(c) ? c > l.length - 1 && console.error([`MUI: The value provided (${c}) overflows.`, `The supported values are: ${JSON.stringify(l)}.`, `${c} > ${l.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${t}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${t}\` as a number.`].join(`
`))), l[c]) : typeof l == "function" ? l : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${t}\` value (${l}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function createUnarySpacing(e) {
  return createUnaryUnit(e, "spacing", 8, "spacing");
}
function getValue(e, t) {
  if (typeof t == "string" || t == null)
    return t;
  const n = Math.abs(t), o = e(n);
  return t >= 0 ? o : typeof o == "number" ? -o : `-${o}`;
}
function getStyleFromPropValue(e, t) {
  return (n) => e.reduce((o, s) => (o[s] = getValue(t, n), o), {});
}
function resolveCssProperty(e, t, n, o) {
  if (t.indexOf(n) === -1)
    return null;
  const s = getCssProperties(n), l = getStyleFromPropValue(s, o), c = e[n];
  return handleBreakpoints(e, c, l);
}
function style$1(e, t) {
  const n = createUnarySpacing(e.theme);
  return Object.keys(e).map((o) => resolveCssProperty(e, t, o, n)).reduce(merge$1, {});
}
function margin(e) {
  return style$1(e, marginKeys);
}
margin.propTypes = process.env.NODE_ENV !== "production" ? marginKeys.reduce((e, t) => (e[t] = responsivePropType$1, e), {}) : {};
margin.filterProps = marginKeys;
function padding(e) {
  return style$1(e, paddingKeys);
}
padding.propTypes = process.env.NODE_ENV !== "production" ? paddingKeys.reduce((e, t) => (e[t] = responsivePropType$1, e), {}) : {};
padding.filterProps = paddingKeys;
process.env.NODE_ENV !== "production" && spacingKeys.reduce((e, t) => (e[t] = responsivePropType$1, e), {});
function createSpacing(e = 8) {
  if (e.mui)
    return e;
  const t = createUnarySpacing({
    spacing: e
  }), n = (...o) => (process.env.NODE_ENV !== "production" && (o.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${o.length}`)), (o.length === 0 ? [1] : o).map((l) => {
    const c = t(l);
    return typeof c == "number" ? `${c}px` : c;
  }).join(" "));
  return n.mui = !0, n;
}
function compose(...e) {
  const t = e.reduce((o, s) => (s.filterProps.forEach((l) => {
    o[l] = s;
  }), o), {}), n = (o) => Object.keys(o).reduce((s, l) => t[l] ? merge$1(s, t[l](o)) : s, {});
  return n.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((o, s) => Object.assign(o, s.propTypes), {}) : {}, n.filterProps = e.reduce((o, s) => o.concat(s.filterProps), []), n;
}
function borderTransform(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function createBorderStyle(e, t) {
  return style$2({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const border = createBorderStyle("border", borderTransform), borderTop = createBorderStyle("borderTop", borderTransform), borderRight = createBorderStyle("borderRight", borderTransform), borderBottom = createBorderStyle("borderBottom", borderTransform), borderLeft = createBorderStyle("borderLeft", borderTransform), borderColor = createBorderStyle("borderColor"), borderTopColor = createBorderStyle("borderTopColor"), borderRightColor = createBorderStyle("borderRightColor"), borderBottomColor = createBorderStyle("borderBottomColor"), borderLeftColor = createBorderStyle("borderLeftColor"), outline = createBorderStyle("outline", borderTransform), outlineColor = createBorderStyle("outlineColor"), borderRadius = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = createUnaryUnit(e.theme, "shape.borderRadius", 4, "borderRadius"), n = (o) => ({
      borderRadius: getValue(t, o)
    });
    return handleBreakpoints(e, e.borderRadius, n);
  }
  return null;
};
borderRadius.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: responsivePropType$1
} : {};
borderRadius.filterProps = ["borderRadius"];
compose(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius, outline, outlineColor);
const gap = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = createUnaryUnit(e.theme, "spacing", 8, "gap"), n = (o) => ({
      gap: getValue(t, o)
    });
    return handleBreakpoints(e, e.gap, n);
  }
  return null;
};
gap.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: responsivePropType$1
} : {};
gap.filterProps = ["gap"];
const columnGap = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = createUnaryUnit(e.theme, "spacing", 8, "columnGap"), n = (o) => ({
      columnGap: getValue(t, o)
    });
    return handleBreakpoints(e, e.columnGap, n);
  }
  return null;
};
columnGap.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: responsivePropType$1
} : {};
columnGap.filterProps = ["columnGap"];
const rowGap = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = createUnaryUnit(e.theme, "spacing", 8, "rowGap"), n = (o) => ({
      rowGap: getValue(t, o)
    });
    return handleBreakpoints(e, e.rowGap, n);
  }
  return null;
};
rowGap.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: responsivePropType$1
} : {};
rowGap.filterProps = ["rowGap"];
const gridColumn = style$2({
  prop: "gridColumn"
}), gridRow = style$2({
  prop: "gridRow"
}), gridAutoFlow = style$2({
  prop: "gridAutoFlow"
}), gridAutoColumns = style$2({
  prop: "gridAutoColumns"
}), gridAutoRows = style$2({
  prop: "gridAutoRows"
}), gridTemplateColumns = style$2({
  prop: "gridTemplateColumns"
}), gridTemplateRows = style$2({
  prop: "gridTemplateRows"
}), gridTemplateAreas = style$2({
  prop: "gridTemplateAreas"
}), gridArea = style$2({
  prop: "gridArea"
});
compose(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
function paletteTransform(e, t) {
  return t === "grey" ? t : e;
}
const color = style$2({
  prop: "color",
  themeKey: "palette",
  transform: paletteTransform
}), bgcolor = style$2({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: paletteTransform
}), backgroundColor = style$2({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: paletteTransform
});
compose(color, bgcolor, backgroundColor);
function sizingTransform(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const width = style$2({
  prop: "width",
  transform: sizingTransform
}), maxWidth = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (n) => {
      var o, s;
      const l = ((o = e.theme) == null || (o = o.breakpoints) == null || (o = o.values) == null ? void 0 : o[n]) || values$1[n];
      return l ? ((s = e.theme) == null || (s = s.breakpoints) == null ? void 0 : s.unit) !== "px" ? {
        maxWidth: `${l}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: l
      } : {
        maxWidth: sizingTransform(n)
      };
    };
    return handleBreakpoints(e, e.maxWidth, t);
  }
  return null;
};
maxWidth.filterProps = ["maxWidth"];
const minWidth = style$2({
  prop: "minWidth",
  transform: sizingTransform
}), height = style$2({
  prop: "height",
  transform: sizingTransform
}), maxHeight = style$2({
  prop: "maxHeight",
  transform: sizingTransform
}), minHeight = style$2({
  prop: "minHeight",
  transform: sizingTransform
});
style$2({
  prop: "size",
  cssProperty: "width",
  transform: sizingTransform
});
style$2({
  prop: "size",
  cssProperty: "height",
  transform: sizingTransform
});
const boxSizing = style$2({
  prop: "boxSizing"
});
compose(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
const defaultSxConfig = {
  // borders
  border: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderTop: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderRight: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderBottom: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderLeft: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: borderTransform
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: borderRadius
  },
  // palette
  color: {
    themeKey: "palette",
    transform: paletteTransform
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: paletteTransform
  },
  backgroundColor: {
    themeKey: "palette",
    transform: paletteTransform
  },
  // spacing
  p: {
    style: padding
  },
  pt: {
    style: padding
  },
  pr: {
    style: padding
  },
  pb: {
    style: padding
  },
  pl: {
    style: padding
  },
  px: {
    style: padding
  },
  py: {
    style: padding
  },
  padding: {
    style: padding
  },
  paddingTop: {
    style: padding
  },
  paddingRight: {
    style: padding
  },
  paddingBottom: {
    style: padding
  },
  paddingLeft: {
    style: padding
  },
  paddingX: {
    style: padding
  },
  paddingY: {
    style: padding
  },
  paddingInline: {
    style: padding
  },
  paddingInlineStart: {
    style: padding
  },
  paddingInlineEnd: {
    style: padding
  },
  paddingBlock: {
    style: padding
  },
  paddingBlockStart: {
    style: padding
  },
  paddingBlockEnd: {
    style: padding
  },
  m: {
    style: margin
  },
  mt: {
    style: margin
  },
  mr: {
    style: margin
  },
  mb: {
    style: margin
  },
  ml: {
    style: margin
  },
  mx: {
    style: margin
  },
  my: {
    style: margin
  },
  margin: {
    style: margin
  },
  marginTop: {
    style: margin
  },
  marginRight: {
    style: margin
  },
  marginBottom: {
    style: margin
  },
  marginLeft: {
    style: margin
  },
  marginX: {
    style: margin
  },
  marginY: {
    style: margin
  },
  marginInline: {
    style: margin
  },
  marginInlineStart: {
    style: margin
  },
  marginInlineEnd: {
    style: margin
  },
  marginBlock: {
    style: margin
  },
  marginBlockStart: {
    style: margin
  },
  marginBlockEnd: {
    style: margin
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: gap
  },
  rowGap: {
    style: rowGap
  },
  columnGap: {
    style: columnGap
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: sizingTransform
  },
  maxWidth: {
    style: maxWidth
  },
  minWidth: {
    transform: sizingTransform
  },
  height: {
    transform: sizingTransform
  },
  maxHeight: {
    transform: sizingTransform
  },
  minHeight: {
    transform: sizingTransform
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
}, defaultSxConfig$1 = defaultSxConfig;
function objectsHaveSameKeys(...e) {
  const t = e.reduce((o, s) => o.concat(Object.keys(s)), []), n = new Set(t);
  return e.every((o) => n.size === Object.keys(o).length);
}
function callIfFn(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function unstable_createStyleFunctionSx() {
  function e(n, o, s, l) {
    const c = {
      [n]: o,
      theme: s
    }, p = l[n];
    if (!p)
      return {
        [n]: o
      };
    const {
      cssProperty: m = n,
      themeKey: C,
      transform: P,
      style: w
    } = p;
    if (o == null)
      return null;
    if (C === "typography" && o === "inherit")
      return {
        [n]: o
      };
    const R = getPath(s, C) || {};
    return w ? w(c) : handleBreakpoints(c, o, (M) => {
      let $ = getStyleValue$1(R, P, M);
      return M === $ && typeof M == "string" && ($ = getStyleValue$1(R, P, `${n}${M === "default" ? "" : capitalize$1(M)}`, M)), m === !1 ? $ : {
        [m]: $
      };
    });
  }
  function t(n) {
    var o;
    const {
      sx: s,
      theme: l = {}
    } = n || {};
    if (!s)
      return null;
    const c = (o = l.unstable_sxConfig) != null ? o : defaultSxConfig$1;
    function p(m) {
      let C = m;
      if (typeof m == "function")
        C = m(l);
      else if (typeof m != "object")
        return m;
      if (!C)
        return null;
      const P = createEmptyBreakpointObject(l.breakpoints), w = Object.keys(P);
      let R = P;
      return Object.keys(C).forEach((L) => {
        const M = callIfFn(C[L], l);
        if (M != null)
          if (typeof M == "object")
            if (c[L])
              R = merge$1(R, e(L, M, l, c));
            else {
              const $ = handleBreakpoints({
                theme: l
              }, M, (W) => ({
                [L]: W
              }));
              objectsHaveSameKeys($, M) ? R[L] = t({
                sx: M,
                theme: l
              }) : R = merge$1(R, $);
            }
          else
            R = merge$1(R, e(L, M, l, c));
      }), removeUnusedBreakpoints(w, R);
    }
    return Array.isArray(s) ? s.map(p) : p(s);
  }
  return t;
}
const styleFunctionSx$1 = unstable_createStyleFunctionSx();
styleFunctionSx$1.filterProps = ["sx"];
const styleFunctionSx$2 = styleFunctionSx$1;
function applyStyles$2(e, t) {
  const n = this;
  return n.vars && typeof n.getColorSchemeSelector == "function" ? {
    [n.getColorSchemeSelector(e).replace(/(\[[^\]]+\])/, "*:where($1)")]: t
  } : n.palette.mode === e ? t : {};
}
const _excluded$Z = ["breakpoints", "palette", "spacing", "shape"];
function createTheme$2(e = {}, ...t) {
  const {
    breakpoints: n = {},
    palette: o = {},
    spacing: s,
    shape: l = {}
  } = e, c = _objectWithoutPropertiesLoose$3(e, _excluded$Z), p = createBreakpoints(n), m = createSpacing(s);
  let C = deepmerge$1({
    breakpoints: p,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: _extends$5({
      mode: "light"
    }, o),
    spacing: m,
    shape: _extends$5({}, shape$1, l)
  }, c);
  return C.applyStyles = applyStyles$2, C = t.reduce((P, w) => deepmerge$1(P, w), C), C.unstable_sxConfig = _extends$5({}, defaultSxConfig$1, c == null ? void 0 : c.unstable_sxConfig), C.unstable_sx = function(w) {
    return styleFunctionSx$2({
      sx: w,
      theme: this
    });
  }, C;
}
const createTheme$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: createTheme$2,
  private_createBreakpoints: createBreakpoints,
  unstable_applyStyles: applyStyles$2
}, Symbol.toStringTag, { value: "Module" }));
function isObjectEmpty$2(e) {
  return Object.keys(e).length === 0;
}
function useTheme$4(e = null) {
  const t = React$2.useContext(ThemeContext$2);
  return !t || isObjectEmpty$2(t) ? e : t;
}
const systemDefaultTheme$2 = createTheme$2();
function useTheme$3(e = systemDefaultTheme$2) {
  return useTheme$4(e);
}
function GlobalStyles$1({
  styles: e,
  themeId: t,
  defaultTheme: n = {}
}) {
  const o = useTheme$3(n), s = typeof e == "function" ? e(t && o[t] || o) : e;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GlobalStyles$2, {
    styles: s
  });
}
process.env.NODE_ENV !== "production" && (GlobalStyles$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  defaultTheme: PropTypes.object,
  /**
   * @ignore
   */
  styles: PropTypes.oneOfType([PropTypes.array, PropTypes.func, PropTypes.number, PropTypes.object, PropTypes.string, PropTypes.bool]),
  /**
   * @ignore
   */
  themeId: PropTypes.string
});
const _excluded$Y = ["sx"], splitProps = (e) => {
  var t, n;
  const o = {
    systemProps: {},
    otherProps: {}
  }, s = (t = e == null || (n = e.theme) == null ? void 0 : n.unstable_sxConfig) != null ? t : defaultSxConfig$1;
  return Object.keys(e).forEach((l) => {
    s[l] ? o.systemProps[l] = e[l] : o.otherProps[l] = e[l];
  }), o;
};
function extendSxProp(e) {
  const {
    sx: t
  } = e, n = _objectWithoutPropertiesLoose$3(e, _excluded$Y), {
    systemProps: o,
    otherProps: s
  } = splitProps(n);
  let l;
  return Array.isArray(t) ? l = [o, ...t] : typeof t == "function" ? l = (...c) => {
    const p = t(...c);
    return isPlainObject$1(p) ? _extends$5({}, o, p) : o;
  } : l = _extends$5({}, o, t), _extends$5({}, s, {
    sx: l
  });
}
const styleFunctionSx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: styleFunctionSx$2,
  extendSxProp,
  unstable_createStyleFunctionSx,
  unstable_defaultSxConfig: defaultSxConfig$1
}, Symbol.toStringTag, { value: "Module" })), defaultGenerator = (e) => e, createClassNameGenerator = () => {
  let e = defaultGenerator;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = defaultGenerator;
    }
  };
}, ClassNameGenerator = createClassNameGenerator(), ClassNameGenerator$1 = ClassNameGenerator;
function r$1(e) {
  var t, n, o = "";
  if (typeof e == "string" || typeof e == "number")
    o += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var s = e.length;
      for (t = 0; t < s; t++)
        e[t] && (n = r$1(e[t])) && (o && (o += " "), o += n);
    } else
      for (n in e)
        e[n] && (o && (o += " "), o += n);
  return o;
}
function clsx$1() {
  for (var e, t, n = 0, o = "", s = arguments.length; n < s; n++)
    (e = arguments[n]) && (t = r$1(e)) && (o && (o += " "), o += t);
  return o;
}
const _excluded$X = ["className", "component"];
function createBox(e = {}) {
  const {
    themeId: t,
    defaultTheme: n,
    defaultClassName: o = "MuiBox-root",
    generateClassName: s
  } = e, l = styled$2("div", {
    shouldForwardProp: (p) => p !== "theme" && p !== "sx" && p !== "as"
  })(styleFunctionSx$2);
  return /* @__PURE__ */ React$2.forwardRef(function(m, C) {
    const P = useTheme$3(n), w = extendSxProp(m), {
      className: R,
      component: L = "div"
    } = w, M = _objectWithoutPropertiesLoose$3(w, _excluded$X);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(l, _extends$5({
      as: L,
      ref: C,
      className: clsx$1(R, s ? s(o) : o),
      theme: t && P[t] || P
    }, M));
  });
}
const globalStateClasses = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function generateUtilityClass$1(e, t, n = "Mui") {
  const o = globalStateClasses[t];
  return o ? `${n}-${o}` : `${ClassNameGenerator$1.generate(e)}-${t}`;
}
function generateUtilityClasses$1(e, t, n = "Mui") {
  const o = {};
  return t.forEach((s) => {
    o[s] = generateUtilityClass$1(e, s, n);
  }), o;
}
var reactIs$1 = { exports: {} }, reactIs_production_min$1 = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min$1;
function requireReactIs_production_min$1() {
  if (hasRequiredReactIs_production_min$1)
    return reactIs_production_min$1;
  hasRequiredReactIs_production_min$1 = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), c = Symbol.for("react.context"), p = Symbol.for("react.server_context"), m = Symbol.for("react.forward_ref"), C = Symbol.for("react.suspense"), P = Symbol.for("react.suspense_list"), w = Symbol.for("react.memo"), R = Symbol.for("react.lazy"), L = Symbol.for("react.offscreen"), M;
  M = Symbol.for("react.module.reference");
  function $(W) {
    if (typeof W == "object" && W !== null) {
      var H = W.$$typeof;
      switch (H) {
        case e:
          switch (W = W.type, W) {
            case n:
            case s:
            case o:
            case C:
            case P:
              return W;
            default:
              switch (W = W && W.$$typeof, W) {
                case p:
                case c:
                case m:
                case R:
                case w:
                case l:
                  return W;
                default:
                  return H;
              }
          }
        case t:
          return H;
      }
    }
  }
  return reactIs_production_min$1.ContextConsumer = c, reactIs_production_min$1.ContextProvider = l, reactIs_production_min$1.Element = e, reactIs_production_min$1.ForwardRef = m, reactIs_production_min$1.Fragment = n, reactIs_production_min$1.Lazy = R, reactIs_production_min$1.Memo = w, reactIs_production_min$1.Portal = t, reactIs_production_min$1.Profiler = s, reactIs_production_min$1.StrictMode = o, reactIs_production_min$1.Suspense = C, reactIs_production_min$1.SuspenseList = P, reactIs_production_min$1.isAsyncMode = function() {
    return !1;
  }, reactIs_production_min$1.isConcurrentMode = function() {
    return !1;
  }, reactIs_production_min$1.isContextConsumer = function(W) {
    return $(W) === c;
  }, reactIs_production_min$1.isContextProvider = function(W) {
    return $(W) === l;
  }, reactIs_production_min$1.isElement = function(W) {
    return typeof W == "object" && W !== null && W.$$typeof === e;
  }, reactIs_production_min$1.isForwardRef = function(W) {
    return $(W) === m;
  }, reactIs_production_min$1.isFragment = function(W) {
    return $(W) === n;
  }, reactIs_production_min$1.isLazy = function(W) {
    return $(W) === R;
  }, reactIs_production_min$1.isMemo = function(W) {
    return $(W) === w;
  }, reactIs_production_min$1.isPortal = function(W) {
    return $(W) === t;
  }, reactIs_production_min$1.isProfiler = function(W) {
    return $(W) === s;
  }, reactIs_production_min$1.isStrictMode = function(W) {
    return $(W) === o;
  }, reactIs_production_min$1.isSuspense = function(W) {
    return $(W) === C;
  }, reactIs_production_min$1.isSuspenseList = function(W) {
    return $(W) === P;
  }, reactIs_production_min$1.isValidElementType = function(W) {
    return typeof W == "string" || typeof W == "function" || W === n || W === s || W === o || W === C || W === P || W === L || typeof W == "object" && W !== null && (W.$$typeof === R || W.$$typeof === w || W.$$typeof === l || W.$$typeof === c || W.$$typeof === m || W.$$typeof === M || W.getModuleId !== void 0);
  }, reactIs_production_min$1.typeOf = $, reactIs_production_min$1;
}
var reactIs_development$1 = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development$1;
function requireReactIs_development$1() {
  return hasRequiredReactIs_development$1 || (hasRequiredReactIs_development$1 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), c = Symbol.for("react.context"), p = Symbol.for("react.server_context"), m = Symbol.for("react.forward_ref"), C = Symbol.for("react.suspense"), P = Symbol.for("react.suspense_list"), w = Symbol.for("react.memo"), R = Symbol.for("react.lazy"), L = Symbol.for("react.offscreen"), M = !1, $ = !1, W = !1, H = !1, V = !1, N;
    N = Symbol.for("react.module.reference");
    function B(je) {
      return !!(typeof je == "string" || typeof je == "function" || je === n || je === s || V || je === o || je === C || je === P || H || je === L || M || $ || W || typeof je == "object" && je !== null && (je.$$typeof === R || je.$$typeof === w || je.$$typeof === l || je.$$typeof === c || je.$$typeof === m || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      je.$$typeof === N || je.getModuleId !== void 0));
    }
    function K(je) {
      if (typeof je == "object" && je !== null) {
        var kt = je.$$typeof;
        switch (kt) {
          case e:
            var cr = je.type;
            switch (cr) {
              case n:
              case s:
              case o:
              case C:
              case P:
                return cr;
              default:
                var Tr = cr && cr.$$typeof;
                switch (Tr) {
                  case p:
                  case c:
                  case m:
                  case R:
                  case w:
                  case l:
                    return Tr;
                  default:
                    return kt;
                }
            }
          case t:
            return kt;
        }
      }
    }
    var ue = c, de = l, ve = e, Te = m, Pe = n, Ce = R, Re = w, ke = t, Ae = s, we = o, he = C, be = P, le = !1, fe = !1;
    function ye(je) {
      return le || (le = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Ee(je) {
      return fe || (fe = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Ie(je) {
      return K(je) === c;
    }
    function Fe(je) {
      return K(je) === l;
    }
    function De(je) {
      return typeof je == "object" && je !== null && je.$$typeof === e;
    }
    function Ve(je) {
      return K(je) === m;
    }
    function Oe(je) {
      return K(je) === n;
    }
    function Ze(je) {
      return K(je) === R;
    }
    function et(je) {
      return K(je) === w;
    }
    function bt(je) {
      return K(je) === t;
    }
    function rr(je) {
      return K(je) === s;
    }
    function St(je) {
      return K(je) === o;
    }
    function Qe(je) {
      return K(je) === C;
    }
    function xt(je) {
      return K(je) === P;
    }
    reactIs_development$1.ContextConsumer = ue, reactIs_development$1.ContextProvider = de, reactIs_development$1.Element = ve, reactIs_development$1.ForwardRef = Te, reactIs_development$1.Fragment = Pe, reactIs_development$1.Lazy = Ce, reactIs_development$1.Memo = Re, reactIs_development$1.Portal = ke, reactIs_development$1.Profiler = Ae, reactIs_development$1.StrictMode = we, reactIs_development$1.Suspense = he, reactIs_development$1.SuspenseList = be, reactIs_development$1.isAsyncMode = ye, reactIs_development$1.isConcurrentMode = Ee, reactIs_development$1.isContextConsumer = Ie, reactIs_development$1.isContextProvider = Fe, reactIs_development$1.isElement = De, reactIs_development$1.isForwardRef = Ve, reactIs_development$1.isFragment = Oe, reactIs_development$1.isLazy = Ze, reactIs_development$1.isMemo = et, reactIs_development$1.isPortal = bt, reactIs_development$1.isProfiler = rr, reactIs_development$1.isStrictMode = St, reactIs_development$1.isSuspense = Qe, reactIs_development$1.isSuspenseList = xt, reactIs_development$1.isValidElementType = B, reactIs_development$1.typeOf = K;
  }()), reactIs_development$1;
}
process.env.NODE_ENV === "production" ? reactIs$1.exports = requireReactIs_production_min$1() : reactIs$1.exports = requireReactIs_development$1();
var reactIsExports$1 = reactIs$1.exports;
const fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(e) {
  const t = `${e}`.match(fnNameMatchRegex);
  return t && t[1] || "";
}
function getFunctionComponentName(e, t = "") {
  return e.displayName || e.name || getFunctionName(e) || t;
}
function getWrappedName(e, t, n) {
  const o = getFunctionComponentName(t);
  return e.displayName || (o !== "" ? `${n}(${o})` : n);
}
function getDisplayName$1(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return getFunctionComponentName(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case reactIsExports$1.ForwardRef:
          return getWrappedName(e, e.render, "ForwardRef");
        case reactIsExports$1.Memo:
          return getWrappedName(e, e.type, "memo");
        default:
          return;
      }
  }
}
const getDisplayName = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: getDisplayName$1,
  getFunctionName
}, Symbol.toStringTag, { value: "Module" })), _excluded$W = ["ownerState"], _excluded2$8 = ["variants"], _excluded3$5 = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function isEmpty$3(e) {
  return Object.keys(e).length === 0;
}
function isStringTag$1(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function shouldForwardProp$1(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const systemDefaultTheme$1 = createTheme$2(), lowercaseFirstLetter$1 = (e) => e && e.charAt(0).toLowerCase() + e.slice(1);
function resolveTheme$1({
  defaultTheme: e,
  theme: t,
  themeId: n
}) {
  return isEmpty$3(t) ? e : t[n] || t;
}
function defaultOverridesResolver$1(e) {
  return e ? (t, n) => n[e] : null;
}
function processStyleArg$1(e, t) {
  let {
    ownerState: n
  } = t, o = _objectWithoutPropertiesLoose$3(t, _excluded$W);
  const s = typeof e == "function" ? e(_extends$5({
    ownerState: n
  }, o)) : e;
  if (Array.isArray(s))
    return s.flatMap((l) => processStyleArg$1(l, _extends$5({
      ownerState: n
    }, o)));
  if (s && typeof s == "object" && Array.isArray(s.variants)) {
    const {
      variants: l = []
    } = s;
    let p = _objectWithoutPropertiesLoose$3(s, _excluded2$8);
    return l.forEach((m) => {
      let C = !0;
      typeof m.props == "function" ? C = m.props(_extends$5({
        ownerState: n
      }, o, n)) : Object.keys(m.props).forEach((P) => {
        (n == null ? void 0 : n[P]) !== m.props[P] && o[P] !== m.props[P] && (C = !1);
      }), C && (Array.isArray(p) || (p = [p]), p.push(typeof m.style == "function" ? m.style(_extends$5({
        ownerState: n
      }, o, n)) : m.style));
    }), p;
  }
  return s;
}
function createStyled$2(e = {}) {
  const {
    themeId: t,
    defaultTheme: n = systemDefaultTheme$1,
    rootShouldForwardProp: o = shouldForwardProp$1,
    slotShouldForwardProp: s = shouldForwardProp$1
  } = e, l = (c) => styleFunctionSx$2(_extends$5({}, c, {
    theme: resolveTheme$1(_extends$5({}, c, {
      defaultTheme: n,
      themeId: t
    }))
  }));
  return l.__mui_systemSx = !0, (c, p = {}) => {
    internal_processStyles(c, (K) => K.filter((ue) => !(ue != null && ue.__mui_systemSx)));
    const {
      name: m,
      slot: C,
      skipVariantsResolver: P,
      skipSx: w,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: R = defaultOverridesResolver$1(lowercaseFirstLetter$1(C))
    } = p, L = _objectWithoutPropertiesLoose$3(p, _excluded3$5), M = P !== void 0 ? P : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      C && C !== "Root" && C !== "root" || !1
    ), $ = w || !1;
    let W;
    process.env.NODE_ENV !== "production" && m && (W = `${m}-${lowercaseFirstLetter$1(C || "Root")}`);
    let H = shouldForwardProp$1;
    C === "Root" || C === "root" ? H = o : C ? H = s : isStringTag$1(c) && (H = void 0);
    const V = styled$2(c, _extends$5({
      shouldForwardProp: H,
      label: W
    }, L)), N = (K) => typeof K == "function" && K.__emotion_real !== K || isPlainObject$1(K) ? (ue) => processStyleArg$1(K, _extends$5({}, ue, {
      theme: resolveTheme$1({
        theme: ue.theme,
        defaultTheme: n,
        themeId: t
      })
    })) : K, B = (K, ...ue) => {
      let de = N(K);
      const ve = ue ? ue.map(N) : [];
      m && R && ve.push((Ce) => {
        const Re = resolveTheme$1(_extends$5({}, Ce, {
          defaultTheme: n,
          themeId: t
        }));
        if (!Re.components || !Re.components[m] || !Re.components[m].styleOverrides)
          return null;
        const ke = Re.components[m].styleOverrides, Ae = {};
        return Object.entries(ke).forEach(([we, he]) => {
          Ae[we] = processStyleArg$1(he, _extends$5({}, Ce, {
            theme: Re
          }));
        }), R(Ce, Ae);
      }), m && !M && ve.push((Ce) => {
        var Re;
        const ke = resolveTheme$1(_extends$5({}, Ce, {
          defaultTheme: n,
          themeId: t
        })), Ae = ke == null || (Re = ke.components) == null || (Re = Re[m]) == null ? void 0 : Re.variants;
        return processStyleArg$1({
          variants: Ae
        }, _extends$5({}, Ce, {
          theme: ke
        }));
      }), $ || ve.push(l);
      const Te = ve.length - ue.length;
      if (Array.isArray(K) && Te > 0) {
        const Ce = new Array(Te).fill("");
        de = [...K, ...Ce], de.raw = [...K.raw, ...Ce];
      }
      const Pe = V(de, ...ve);
      if (process.env.NODE_ENV !== "production") {
        let Ce;
        m && (Ce = `${m}${capitalize$1(C || "")}`), Ce === void 0 && (Ce = `Styled(${getDisplayName$1(c)})`), Pe.displayName = Ce;
      }
      return c.muiName && (Pe.muiName = c.muiName), Pe;
    };
    return V.withConfig && (B.withConfig = V.withConfig), B;
  };
}
const styled$1 = createStyled$2(), systemStyled = styled$1;
function resolveProps(e, t) {
  const n = _extends$5({}, t);
  return Object.keys(e).forEach((o) => {
    if (o.toString().match(/^(components|slots)$/))
      n[o] = _extends$5({}, e[o], n[o]);
    else if (o.toString().match(/^(componentsProps|slotProps)$/)) {
      const s = e[o] || {}, l = t[o];
      n[o] = {}, !l || !Object.keys(l) ? n[o] = s : !s || !Object.keys(s) ? n[o] = l : (n[o] = _extends$5({}, l), Object.keys(s).forEach((c) => {
        n[o][c] = resolveProps(s[c], l[c]);
      }));
    } else
      n[o] === void 0 && (n[o] = e[o]);
  }), n;
}
function getThemeProps(e) {
  const {
    theme: t,
    name: n,
    props: o
  } = e;
  return !t || !t.components || !t.components[n] || !t.components[n].defaultProps ? o : resolveProps(t.components[n].defaultProps, o);
}
function useThemeProps$1({
  props: e,
  name: t,
  defaultTheme: n,
  themeId: o
}) {
  let s = useTheme$3(n);
  return o && (s = s[o] || s), getThemeProps({
    theme: s,
    name: t,
    props: e
  });
}
const useEnhancedEffect = typeof window < "u" ? React$2.useLayoutEffect : React$2.useEffect, useEnhancedEffect$1 = useEnhancedEffect;
function clamp$1(e, t = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, n));
}
const clamp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: clamp$1
}, Symbol.toStringTag, { value: "Module" }));
function chainPropTypes(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : function(...o) {
    return e(...o) || t(...o);
  };
}
function isClassComponent$1(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function acceptingRef(e, t, n, o, s) {
  const l = e[t], c = s || t;
  if (l == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let p;
  const m = l.type;
  return typeof m == "function" && !isClassComponent$1(m) && (p = "Did you accidentally use a plain function component for an element instead?"), p !== void 0 ? new Error(`Invalid ${o} \`${c}\` supplied to \`${n}\`. Expected an element that can hold a ref. ${p} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const elementAcceptingRef = chainPropTypes(PropTypes.element, acceptingRef);
elementAcceptingRef.isRequired = chainPropTypes(PropTypes.element.isRequired, acceptingRef);
const elementAcceptingRef$1 = elementAcceptingRef;
function isClassComponent(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function elementTypeAcceptingRef(e, t, n, o, s) {
  const l = e[t], c = s || t;
  if (l == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let p;
  return typeof l == "function" && !isClassComponent(l) && (p = "Did you accidentally provide a plain function component instead?"), p !== void 0 ? new Error(`Invalid ${o} \`${c}\` supplied to \`${n}\`. Expected an element type that can hold a ref. ${p} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const elementTypeAcceptingRef$1 = chainPropTypes(PropTypes.elementType, elementTypeAcceptingRef), specialProperty = "exact-prop: ​";
function exactProp(e) {
  return process.env.NODE_ENV === "production" ? e : _extends$5({}, e, {
    [specialProperty]: (t) => {
      const n = Object.keys(t).filter((o) => !e.hasOwnProperty(o));
      return n.length > 0 ? new Error(`The following props are not supported: ${n.map((o) => `\`${o}\``).join(", ")}. Please remove them.`) : null;
    }
  });
}
function HTMLElementType(e, t, n, o, s) {
  if (process.env.NODE_ENV === "production")
    return null;
  const l = e[t], c = s || t;
  return l == null ? null : l && l.nodeType !== 1 ? new Error(`Invalid ${o} \`${c}\` supplied to \`${n}\`. Expected an HTMLElement.`) : null;
}
const refType = PropTypes.oneOfType([PropTypes.func, PropTypes.object]), refType$1 = refType;
function createChainedFunction(...e) {
  return e.reduce((t, n) => n == null ? t : function(...s) {
    t.apply(this, s), n.apply(this, s);
  }, () => {
  });
}
function debounce$1(e, t = 166) {
  let n;
  function o(...s) {
    const l = () => {
      e.apply(this, s);
    };
    clearTimeout(n), n = setTimeout(l, t);
  }
  return o.clear = () => {
    clearTimeout(n);
  }, o;
}
function isMuiElement(e, t) {
  var n, o;
  return /* @__PURE__ */ React$2.isValidElement(e) && t.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (n = e.type.muiName) != null ? n : (o = e.type) == null || (o = o._payload) == null || (o = o.value) == null ? void 0 : o.muiName
  ) !== -1;
}
function ownerDocument(e) {
  return e && e.ownerDocument || document;
}
function ownerWindow(e) {
  return ownerDocument(e).defaultView || window;
}
function setRef(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
let globalId = 0;
function useGlobalId(e) {
  const [t, n] = React$2.useState(e), o = e || t;
  return React$2.useEffect(() => {
    t == null && (globalId += 1, n(`mui-${globalId}`));
  }, [t]), o;
}
const maybeReactUseId = React$2["useId".toString()];
function useId(e) {
  if (maybeReactUseId !== void 0) {
    const t = maybeReactUseId();
    return e ?? t;
  }
  return useGlobalId(e);
}
function unsupportedProp(e, t, n, o, s) {
  if (process.env.NODE_ENV === "production")
    return null;
  const l = s || t;
  return typeof e[t] < "u" ? new Error(`The prop \`${l}\` is not supported. Please remove it.`) : null;
}
function useControlled({
  controlled: e,
  default: t,
  name: n,
  state: o = "value"
}) {
  const {
    current: s
  } = React$2.useRef(e !== void 0), [l, c] = React$2.useState(t), p = s ? e : l;
  if (process.env.NODE_ENV !== "production") {
    React$2.useEffect(() => {
      s !== (e !== void 0) && console.error([`MUI: A component is changing the ${s ? "" : "un"}controlled ${o} state of ${n} to be ${s ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [o, n, e]);
    const {
      current: C
    } = React$2.useRef(t);
    React$2.useEffect(() => {
      !s && C !== t && console.error([`MUI: A component is changing the default ${o} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const m = React$2.useCallback((C) => {
    s || c(C);
  }, []);
  return [p, m];
}
function useEventCallback(e) {
  const t = React$2.useRef(e);
  return useEnhancedEffect$1(() => {
    t.current = e;
  }), React$2.useRef((...n) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...n)
  )).current;
}
function useForkRef(...e) {
  return React$2.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((n) => {
      setRef(n, t);
    });
  }, e);
}
const UNINITIALIZED = {};
function useLazyRef(e, t) {
  const n = React$2.useRef(UNINITIALIZED);
  return n.current === UNINITIALIZED && (n.current = e(t)), n;
}
const EMPTY = [];
function useOnMount(e) {
  React$2.useEffect(e, EMPTY);
}
class Timeout {
  constructor() {
    this.currentId = 0, this.clear = () => {
      this.currentId !== 0 && (clearTimeout(this.currentId), this.currentId = 0);
    }, this.disposeEffect = () => this.clear;
  }
  static create() {
    return new Timeout();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, n) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = 0, n();
    }, t);
  }
}
function useTimeout() {
  const e = useLazyRef(Timeout.create).current;
  return useOnMount(e.disposeEffect), e;
}
let hadKeyboardEvent = !0, hadFocusVisibleRecently = !1;
const hadFocusVisibleRecentlyTimeout = new Timeout(), inputTypesWhitelist = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function focusTriggersKeyboardModality(e) {
  const {
    type: t,
    tagName: n
  } = e;
  return !!(n === "INPUT" && inputTypesWhitelist[t] && !e.readOnly || n === "TEXTAREA" && !e.readOnly || e.isContentEditable);
}
function handleKeyDown(e) {
  e.metaKey || e.altKey || e.ctrlKey || (hadKeyboardEvent = !0);
}
function handlePointerDown() {
  hadKeyboardEvent = !1;
}
function handleVisibilityChange() {
  this.visibilityState === "hidden" && hadFocusVisibleRecently && (hadKeyboardEvent = !0);
}
function prepare(e) {
  e.addEventListener("keydown", handleKeyDown, !0), e.addEventListener("mousedown", handlePointerDown, !0), e.addEventListener("pointerdown", handlePointerDown, !0), e.addEventListener("touchstart", handlePointerDown, !0), e.addEventListener("visibilitychange", handleVisibilityChange, !0);
}
function isFocusVisible(e) {
  const {
    target: t
  } = e;
  try {
    return t.matches(":focus-visible");
  } catch {
  }
  return hadKeyboardEvent || focusTriggersKeyboardModality(t);
}
function useIsFocusVisible() {
  const e = React$2.useCallback((s) => {
    s != null && prepare(s.ownerDocument);
  }, []), t = React$2.useRef(!1);
  function n() {
    return t.current ? (hadFocusVisibleRecently = !0, hadFocusVisibleRecentlyTimeout.start(100, () => {
      hadFocusVisibleRecently = !1;
    }), t.current = !1, !0) : !1;
  }
  function o(s) {
    return isFocusVisible(s) ? (t.current = !0, !0) : !1;
  }
  return {
    isFocusVisibleRef: t,
    onFocus: o,
    onBlur: n,
    ref: e
  };
}
function getScrollbarSize(e) {
  const t = e.documentElement.clientWidth;
  return Math.abs(window.innerWidth - t);
}
const visuallyHidden = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: -1,
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px"
}, visuallyHidden$1 = visuallyHidden;
function getTypeByValue(e) {
  const t = typeof e;
  switch (t) {
    case "number":
      return Number.isNaN(e) ? "NaN" : Number.isFinite(e) ? e !== Math.floor(e) ? "float" : "number" : "Infinity";
    case "object":
      return e === null ? "null" : e.constructor.name;
    default:
      return t;
  }
}
function ponyfillIsInteger(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e;
}
const isInteger = Number.isInteger || ponyfillIsInteger;
function requiredInteger(e, t, n, o) {
  const s = e[t];
  if (s == null || !isInteger(s)) {
    const l = getTypeByValue(s);
    return new RangeError(`Invalid ${o} \`${t}\` of type \`${l}\` supplied to \`${n}\`, expected \`integer\`.`);
  }
  return null;
}
function validator$1(e, t, ...n) {
  return e[t] === void 0 ? null : requiredInteger(e, t, ...n);
}
function validatorNoop() {
  return null;
}
validator$1.isRequired = requiredInteger;
validatorNoop.isRequired = validatorNoop;
const integerPropType = process.env.NODE_ENV === "production" ? validatorNoop : validator$1;
function composeClasses(e, t, n = void 0) {
  const o = {};
  return Object.keys(e).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (s) => {
      o[s] = e[s].reduce((l, c) => {
        if (c) {
          const p = t(c);
          p !== "" && l.push(p), n && n[c] && l.push(n[c]);
        }
        return l;
      }, []).join(" ");
    }
  ), o;
}
const ThemeContext = /* @__PURE__ */ React$2.createContext(null);
process.env.NODE_ENV !== "production" && (ThemeContext.displayName = "ThemeContext");
const ThemeContext$1 = ThemeContext;
function useTheme$2() {
  const e = React$2.useContext(ThemeContext$1);
  return process.env.NODE_ENV !== "production" && React$2.useDebugValue(e), e;
}
const hasSymbol = typeof Symbol == "function" && Symbol.for, nested = hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";
function mergeOuterLocalTheme(e, t) {
  if (typeof t == "function") {
    const n = t(e);
    return process.env.NODE_ENV !== "production" && (n || console.error(["MUI: You should return an object from your theme function, i.e.", "<ThemeProvider theme={() => ({})} />"].join(`
`))), n;
  }
  return _extends$5({}, e, t);
}
function ThemeProvider$2(e) {
  const {
    children: t,
    theme: n
  } = e, o = useTheme$2();
  process.env.NODE_ENV !== "production" && o === null && typeof n == "function" && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const s = React$2.useMemo(() => {
    const l = o === null ? n : mergeOuterLocalTheme(o, n);
    return l != null && (l[nested] = o !== null), l;
  }, [n, o]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeContext$1.Provider, {
    value: s,
    children: t
  });
}
process.env.NODE_ENV !== "production" && (ThemeProvider$2.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (ThemeProvider$2.propTypes = exactProp(ThemeProvider$2.propTypes));
const EMPTY_THEME = {};
function useThemeScoping(e, t, n, o = !1) {
  return React$2.useMemo(() => {
    const s = e && t[e] || t;
    if (typeof n == "function") {
      const l = n(s), c = e ? _extends$5({}, t, {
        [e]: l
      }) : l;
      return o ? () => c : c;
    }
    return e ? _extends$5({}, t, {
      [e]: n
    }) : _extends$5({}, t, n);
  }, [e, t, n, o]);
}
function ThemeProvider$1(e) {
  const {
    children: t,
    theme: n,
    themeId: o
  } = e, s = useTheme$4(EMPTY_THEME), l = useTheme$2() || EMPTY_THEME;
  process.env.NODE_ENV !== "production" && (s === null && typeof n == "function" || o && s && !s[o] && typeof n == "function") && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const c = useThemeScoping(o, s, n), p = useThemeScoping(o, l, n, !0);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider$2, {
    theme: p,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeContext$2.Provider, {
      value: c,
      children: t
    })
  });
}
process.env.NODE_ENV !== "production" && (ThemeProvider$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Your component tree.
   */
  children: PropTypes.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  /**
   * The design system's unique id for getting the corresponded theme when there are multiple design systems.
   */
  themeId: PropTypes.string
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (ThemeProvider$1.propTypes = exactProp(ThemeProvider$1.propTypes));
const _excluded$V = ["component", "direction", "spacing", "divider", "children", "className", "useFlexGap"], defaultTheme$3 = createTheme$2(), defaultCreateStyledComponent = systemStyled("div", {
  name: "MuiStack",
  slot: "Root",
  overridesResolver: (e, t) => t.root
});
function useThemePropsDefault(e) {
  return useThemeProps$1({
    props: e,
    name: "MuiStack",
    defaultTheme: defaultTheme$3
  });
}
function joinChildren(e, t) {
  const n = React$2.Children.toArray(e).filter(Boolean);
  return n.reduce((o, s, l) => (o.push(s), l < n.length - 1 && o.push(/* @__PURE__ */ React$2.cloneElement(t, {
    key: `separator-${l}`
  })), o), []);
}
const getSideFromDirection = (e) => ({
  row: "Left",
  "row-reverse": "Right",
  column: "Top",
  "column-reverse": "Bottom"
})[e], style = ({
  ownerState: e,
  theme: t
}) => {
  let n = _extends$5({
    display: "flex",
    flexDirection: "column"
  }, handleBreakpoints({
    theme: t
  }, resolveBreakpointValues({
    values: e.direction,
    breakpoints: t.breakpoints.values
  }), (o) => ({
    flexDirection: o
  })));
  if (e.spacing) {
    const o = createUnarySpacing(t), s = Object.keys(t.breakpoints.values).reduce((m, C) => ((typeof e.spacing == "object" && e.spacing[C] != null || typeof e.direction == "object" && e.direction[C] != null) && (m[C] = !0), m), {}), l = resolveBreakpointValues({
      values: e.direction,
      base: s
    }), c = resolveBreakpointValues({
      values: e.spacing,
      base: s
    });
    typeof l == "object" && Object.keys(l).forEach((m, C, P) => {
      if (!l[m]) {
        const R = C > 0 ? l[P[C - 1]] : "column";
        l[m] = R;
      }
    }), n = deepmerge$1(n, handleBreakpoints({
      theme: t
    }, c, (m, C) => e.useFlexGap ? {
      gap: getValue(o, m)
    } : {
      // The useFlexGap={false} implement relies on each child to give up control of the margin.
      // We need to reset the margin to avoid double spacing.
      "& > :not(style):not(style)": {
        margin: 0
      },
      "& > :not(style) ~ :not(style)": {
        [`margin${getSideFromDirection(C ? l[C] : e.direction)}`]: getValue(o, m)
      }
    }));
  }
  return n = mergeBreakpointsInOrder(t.breakpoints, n), n;
};
function createStack(e = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: t = defaultCreateStyledComponent,
    useThemeProps: n = useThemePropsDefault,
    componentName: o = "MuiStack"
  } = e, s = () => composeClasses({
    root: ["root"]
  }, (m) => generateUtilityClass$1(o, m), {}), l = t(style), c = /* @__PURE__ */ React$2.forwardRef(function(m, C) {
    const P = n(m), w = extendSxProp(P), {
      component: R = "div",
      direction: L = "column",
      spacing: M = 0,
      divider: $,
      children: W,
      className: H,
      useFlexGap: V = !1
    } = w, N = _objectWithoutPropertiesLoose$3(w, _excluded$V), B = {
      direction: L,
      spacing: M,
      useFlexGap: V
    }, K = s();
    return /* @__PURE__ */ jsxRuntimeExports.jsx(l, _extends$5({
      as: R,
      ownerState: B,
      ref: C,
      className: clsx$1(K.root, H)
    }, N, {
      children: $ ? joinChildren(W, $) : W
    }));
  });
  return process.env.NODE_ENV !== "production" && (c.propTypes = {
    children: PropTypes.node,
    direction: PropTypes.oneOfType([PropTypes.oneOf(["column-reverse", "column", "row-reverse", "row"]), PropTypes.arrayOf(PropTypes.oneOf(["column-reverse", "column", "row-reverse", "row"])), PropTypes.object]),
    divider: PropTypes.node,
    spacing: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.string]),
    sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
  }), c;
}
function createMixins(e, t) {
  return _extends$5({
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    }
  }, t);
}
var colorManipulator = {}, interopRequireDefault = { exports: {} };
(function(e) {
  function t(n) {
    return n && n.__esModule ? n : {
      default: n
    };
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(interopRequireDefault);
var interopRequireDefaultExports = interopRequireDefault.exports;
const require$$1$1 = /* @__PURE__ */ getAugmentedNamespace(formatMuiErrorMessage), require$$2 = /* @__PURE__ */ getAugmentedNamespace(clamp);
var _interopRequireDefault$2 = interopRequireDefaultExports;
Object.defineProperty(colorManipulator, "__esModule", {
  value: !0
});
var alpha_1 = colorManipulator.alpha = alpha;
colorManipulator.blend = blend;
colorManipulator.colorChannel = void 0;
var darken_1 = colorManipulator.darken = darken;
colorManipulator.decomposeColor = decomposeColor;
colorManipulator.emphasize = emphasize;
var getContrastRatio_1 = colorManipulator.getContrastRatio = getContrastRatio;
colorManipulator.getLuminance = getLuminance;
colorManipulator.hexToRgb = hexToRgb;
colorManipulator.hslToRgb = hslToRgb;
var lighten_1 = colorManipulator.lighten = lighten;
colorManipulator.private_safeAlpha = private_safeAlpha;
colorManipulator.private_safeColorChannel = void 0;
colorManipulator.private_safeDarken = private_safeDarken;
colorManipulator.private_safeEmphasize = private_safeEmphasize;
colorManipulator.private_safeLighten = private_safeLighten;
colorManipulator.recomposeColor = recomposeColor;
colorManipulator.rgbToHex = rgbToHex;
var _formatMuiErrorMessage2 = _interopRequireDefault$2(require$$1$1), _clamp = _interopRequireDefault$2(require$$2);
function clampWrapper(e, t = 0, n = 1) {
  return process.env.NODE_ENV !== "production" && (e < t || e > n) && console.error(`MUI: The value provided ${e} is out of range [${t}, ${n}].`), (0, _clamp.default)(e, t, n);
}
function hexToRgb(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let n = e.match(t);
  return n && n[0].length === 1 && (n = n.map((o) => o + o)), n ? `rgb${n.length === 4 ? "a" : ""}(${n.map((o, s) => s < 3 ? parseInt(o, 16) : Math.round(parseInt(o, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function intToHex(e) {
  const t = e.toString(16);
  return t.length === 1 ? `0${t}` : t;
}
function decomposeColor(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return decomposeColor(hexToRgb(e));
  const t = e.indexOf("("), n = e.substring(0, t);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(n) === -1)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : (0, _formatMuiErrorMessage2.default)(9, e));
  let o = e.substring(t + 1, e.length - 1), s;
  if (n === "color") {
    if (o = o.split(" "), s = o.shift(), o.length === 4 && o[3].charAt(0) === "/" && (o[3] = o[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(s) === -1)
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${s}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : (0, _formatMuiErrorMessage2.default)(10, s));
  } else
    o = o.split(",");
  return o = o.map((l) => parseFloat(l)), {
    type: n,
    values: o,
    colorSpace: s
  };
}
const colorChannel = (e) => {
  const t = decomposeColor(e);
  return t.values.slice(0, 3).map((n, o) => t.type.indexOf("hsl") !== -1 && o !== 0 ? `${n}%` : n).join(" ");
};
colorManipulator.colorChannel = colorChannel;
const private_safeColorChannel = (e, t) => {
  try {
    return colorChannel(e);
  } catch {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
};
colorManipulator.private_safeColorChannel = private_safeColorChannel;
function recomposeColor(e) {
  const {
    type: t,
    colorSpace: n
  } = e;
  let {
    values: o
  } = e;
  return t.indexOf("rgb") !== -1 ? o = o.map((s, l) => l < 3 ? parseInt(s, 10) : s) : t.indexOf("hsl") !== -1 && (o[1] = `${o[1]}%`, o[2] = `${o[2]}%`), t.indexOf("color") !== -1 ? o = `${n} ${o.join(" ")}` : o = `${o.join(", ")}`, `${t}(${o})`;
}
function rgbToHex(e) {
  if (e.indexOf("#") === 0)
    return e;
  const {
    values: t
  } = decomposeColor(e);
  return `#${t.map((n, o) => intToHex(o === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function hslToRgb(e) {
  e = decomposeColor(e);
  const {
    values: t
  } = e, n = t[0], o = t[1] / 100, s = t[2] / 100, l = o * Math.min(s, 1 - s), c = (C, P = (C + n / 30) % 12) => s - l * Math.max(Math.min(P - 3, 9 - P, 1), -1);
  let p = "rgb";
  const m = [Math.round(c(0) * 255), Math.round(c(8) * 255), Math.round(c(4) * 255)];
  return e.type === "hsla" && (p += "a", m.push(t[3])), recomposeColor({
    type: p,
    values: m
  });
}
function getLuminance(e) {
  e = decomposeColor(e);
  let t = e.type === "hsl" || e.type === "hsla" ? decomposeColor(hslToRgb(e)).values : e.values;
  return t = t.map((n) => (e.type !== "color" && (n /= 255), n <= 0.03928 ? n / 12.92 : ((n + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function getContrastRatio(e, t) {
  const n = getLuminance(e), o = getLuminance(t);
  return (Math.max(n, o) + 0.05) / (Math.min(n, o) + 0.05);
}
function alpha(e, t) {
  return e = decomposeColor(e), t = clampWrapper(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, recomposeColor(e);
}
function private_safeAlpha(e, t, n) {
  try {
    return alpha(e, t);
  } catch {
    return n && process.env.NODE_ENV !== "production" && console.warn(n), e;
  }
}
function darken(e, t) {
  if (e = decomposeColor(e), t = clampWrapper(t), e.type.indexOf("hsl") !== -1)
    e.values[2] *= 1 - t;
  else if (e.type.indexOf("rgb") !== -1 || e.type.indexOf("color") !== -1)
    for (let n = 0; n < 3; n += 1)
      e.values[n] *= 1 - t;
  return recomposeColor(e);
}
function private_safeDarken(e, t, n) {
  try {
    return darken(e, t);
  } catch {
    return n && process.env.NODE_ENV !== "production" && console.warn(n), e;
  }
}
function lighten(e, t) {
  if (e = decomposeColor(e), t = clampWrapper(t), e.type.indexOf("hsl") !== -1)
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.indexOf("rgb") !== -1)
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (255 - e.values[n]) * t;
  else if (e.type.indexOf("color") !== -1)
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (1 - e.values[n]) * t;
  return recomposeColor(e);
}
function private_safeLighten(e, t, n) {
  try {
    return lighten(e, t);
  } catch {
    return n && process.env.NODE_ENV !== "production" && console.warn(n), e;
  }
}
function emphasize(e, t = 0.15) {
  return getLuminance(e) > 0.5 ? darken(e, t) : lighten(e, t);
}
function private_safeEmphasize(e, t, n) {
  try {
    return private_safeEmphasize(e, t);
  } catch {
    return n && process.env.NODE_ENV !== "production" && console.warn(n), e;
  }
}
function blend(e, t, n, o = 1) {
  const s = (m, C) => Math.round((m ** (1 / o) * (1 - n) + C ** (1 / o) * n) ** o), l = decomposeColor(e), c = decomposeColor(t), p = [s(l.values[0], c.values[0]), s(l.values[1], c.values[1]), s(l.values[2], c.values[2])];
  return recomposeColor({
    type: "rgb",
    values: p
  });
}
const _excluded$U = ["mode", "contrastThreshold", "tonalOffset"], light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.6)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: common$1.white,
    default: common$1.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, dark = {
  text: {
    primary: common$1.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: common$1.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function addLightOrDark(e, t, n, o) {
  const s = o.light || o, l = o.dark || o * 1.5;
  e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : t === "light" ? e.light = lighten_1(e.main, s) : t === "dark" && (e.dark = darken_1(e.main, l)));
}
function getDefaultPrimary(e = "light") {
  return e === "dark" ? {
    main: blue$2[200],
    light: blue$2[50],
    dark: blue$2[400]
  } : {
    main: blue$2[700],
    light: blue$2[400],
    dark: blue$2[800]
  };
}
function getDefaultSecondary(e = "light") {
  return e === "dark" ? {
    main: purple$1[200],
    light: purple$1[50],
    dark: purple$1[400]
  } : {
    main: purple$1[500],
    light: purple$1[300],
    dark: purple$1[700]
  };
}
function getDefaultError(e = "light") {
  return e === "dark" ? {
    main: red$2[500],
    light: red$2[300],
    dark: red$2[700]
  } : {
    main: red$2[700],
    light: red$2[400],
    dark: red$2[800]
  };
}
function getDefaultInfo(e = "light") {
  return e === "dark" ? {
    main: lightBlue$1[400],
    light: lightBlue$1[300],
    dark: lightBlue$1[700]
  } : {
    main: lightBlue$1[700],
    light: lightBlue$1[500],
    dark: lightBlue$1[900]
  };
}
function getDefaultSuccess(e = "light") {
  return e === "dark" ? {
    main: green$2[400],
    light: green$2[300],
    dark: green$2[700]
  } : {
    main: green$2[800],
    light: green$2[500],
    dark: green$2[900]
  };
}
function getDefaultWarning(e = "light") {
  return e === "dark" ? {
    main: orange$2[400],
    light: orange$2[300],
    dark: orange$2[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: orange$2[500],
    dark: orange$2[900]
  };
}
function createPalette(e) {
  const {
    mode: t = "light",
    contrastThreshold: n = 3,
    tonalOffset: o = 0.2
  } = e, s = _objectWithoutPropertiesLoose$3(e, _excluded$U), l = e.primary || getDefaultPrimary(t), c = e.secondary || getDefaultSecondary(t), p = e.error || getDefaultError(t), m = e.info || getDefaultInfo(t), C = e.success || getDefaultSuccess(t), P = e.warning || getDefaultWarning(t);
  function w($) {
    const W = getContrastRatio_1($, dark.text.primary) >= n ? dark.text.primary : light.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const H = getContrastRatio_1($, W);
      H < 3 && console.error([`MUI: The contrast ratio of ${H}:1 for ${W} on ${$}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return W;
  }
  const R = ({
    color: $,
    name: W,
    mainShade: H = 500,
    lightShade: V = 300,
    darkShade: N = 700
  }) => {
    if ($ = _extends$5({}, $), !$.main && $[H] && ($.main = $[H]), !$.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${W ? ` (${W})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${H}\` property.` : formatMuiErrorMessage$1(11, W ? ` (${W})` : "", H));
    if (typeof $.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${W ? ` (${W})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify($.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : formatMuiErrorMessage$1(12, W ? ` (${W})` : "", JSON.stringify($.main)));
    return addLightOrDark($, "light", V, o), addLightOrDark($, "dark", N, o), $.contrastText || ($.contrastText = w($.main)), $;
  }, L = {
    dark,
    light
  };
  return process.env.NODE_ENV !== "production" && (L[t] || console.error(`MUI: The palette mode \`${t}\` is not supported.`)), deepmerge$1(_extends$5({
    // A collection of common colors.
    common: _extends$5({}, common$1),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: R({
      color: l,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: R({
      color: c,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: R({
      color: p,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: R({
      color: P,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: R({
      color: m,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: R({
      color: C,
      name: "success"
    }),
    // The grey colors.
    grey: grey$2,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: n,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: w,
    // Generate a rich color object.
    augmentColor: R,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: o
  }, L[t]), s);
}
const _excluded$T = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function round$3(e) {
  return Math.round(e * 1e5) / 1e5;
}
const caseAllCaps = {
  textTransform: "uppercase"
}, defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function createTypography(e, t) {
  const n = typeof t == "function" ? t(e) : t, {
    fontFamily: o = defaultFontFamily,
    // The default font size of the Material Specification.
    fontSize: s = 14,
    // px
    fontWeightLight: l = 300,
    fontWeightRegular: c = 400,
    fontWeightMedium: p = 500,
    fontWeightBold: m = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: C = 16,
    // Apply the CSS properties to all the variants.
    allVariants: P,
    pxToRem: w
  } = n, R = _objectWithoutPropertiesLoose$3(n, _excluded$T);
  process.env.NODE_ENV !== "production" && (typeof s != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof C != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const L = s / 14, M = w || ((H) => `${H / C * L}rem`), $ = (H, V, N, B, K) => _extends$5({
    fontFamily: o,
    fontWeight: H,
    fontSize: M(V),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: N
  }, o === defaultFontFamily ? {
    letterSpacing: `${round$3(B / V)}em`
  } : {}, K, P), W = {
    h1: $(l, 96, 1.167, -1.5),
    h2: $(l, 60, 1.2, -0.5),
    h3: $(c, 48, 1.167, 0),
    h4: $(c, 34, 1.235, 0.25),
    h5: $(c, 24, 1.334, 0),
    h6: $(p, 20, 1.6, 0.15),
    subtitle1: $(c, 16, 1.75, 0.15),
    subtitle2: $(p, 14, 1.57, 0.1),
    body1: $(c, 16, 1.5, 0.15),
    body2: $(c, 14, 1.43, 0.15),
    button: $(p, 14, 1.75, 0.4, caseAllCaps),
    caption: $(c, 12, 1.66, 0.4),
    overline: $(c, 12, 2.66, 1, caseAllCaps),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return deepmerge$1(_extends$5({
    htmlFontSize: C,
    pxToRem: M,
    fontFamily: o,
    fontSize: s,
    fontWeightLight: l,
    fontWeightRegular: c,
    fontWeightMedium: p,
    fontWeightBold: m
  }, W), R, {
    clone: !1
    // No need to clone deep
  });
}
const shadowKeyUmbraOpacity = 0.2, shadowKeyPenumbraOpacity = 0.14, shadowAmbientShadowOpacity = 0.12;
function createShadow(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${shadowKeyUmbraOpacity})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${shadowKeyPenumbraOpacity})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${shadowAmbientShadowOpacity})`].join(",");
}
const shadows = ["none", createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], shadows$1 = shadows, _excluded$S = ["duration", "easing", "delay"], easing = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function formatMs(e) {
  return `${Math.round(e)}ms`;
}
function getAutoHeightDuration(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.round((4 + 15 * t ** 0.25 + t / 5) * 10);
}
function createTransitions(e) {
  const t = _extends$5({}, easing, e.easing), n = _extends$5({}, duration, e.duration);
  return _extends$5({
    getAutoHeightDuration,
    create: (s = ["all"], l = {}) => {
      const {
        duration: c = n.standard,
        easing: p = t.easeInOut,
        delay: m = 0
      } = l, C = _objectWithoutPropertiesLoose$3(l, _excluded$S);
      if (process.env.NODE_ENV !== "production") {
        const P = (R) => typeof R == "string", w = (R) => !isNaN(parseFloat(R));
        !P(s) && !Array.isArray(s) && console.error('MUI: Argument "props" must be a string or Array.'), !w(c) && !P(c) && console.error(`MUI: Argument "duration" must be a number or a string but found ${c}.`), P(p) || console.error('MUI: Argument "easing" must be a string.'), !w(m) && !P(m) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof l != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(C).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(C).join(",")}].`);
      }
      return (Array.isArray(s) ? s : [s]).map((P) => `${P} ${typeof c == "string" ? c : formatMs(c)} ${p} ${typeof m == "string" ? m : formatMs(m)}`).join(",");
    }
  }, e, {
    easing: t,
    duration: n
  });
}
const zIndex = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
}, zIndex$1 = zIndex, _excluded$R = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function createTheme(e = {}, ...t) {
  const {
    mixins: n = {},
    palette: o = {},
    transitions: s = {},
    typography: l = {}
  } = e, c = _objectWithoutPropertiesLoose$3(e, _excluded$R);
  if (e.vars)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name." : formatMuiErrorMessage$1(18));
  const p = createPalette(o), m = createTheme$2(e);
  let C = deepmerge$1(m, {
    mixins: createMixins(m.breakpoints, n),
    palette: p,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: shadows$1.slice(),
    typography: createTypography(p, l),
    transitions: createTransitions(s),
    zIndex: _extends$5({}, zIndex$1)
  });
  if (C = deepmerge$1(C, c), C = t.reduce((P, w) => deepmerge$1(P, w), C), process.env.NODE_ENV !== "production") {
    const P = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], w = (R, L) => {
      let M;
      for (M in R) {
        const $ = R[M];
        if (P.indexOf(M) !== -1 && Object.keys($).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const W = generateUtilityClass$1("", M);
            console.error([`MUI: The \`${L}\` component increases the CSS specificity of the \`${M}\` internal state.`, "You can not override it like this: ", JSON.stringify(R, null, 2), "", `Instead, you need to use the '&.${W}' syntax:`, JSON.stringify({
              root: {
                [`&.${W}`]: $
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          R[M] = {};
        }
      }
    };
    Object.keys(C.components).forEach((R) => {
      const L = C.components[R].styleOverrides;
      L && R.indexOf("Mui") === 0 && w(L, R);
    });
  }
  return C.unstable_sxConfig = _extends$5({}, defaultSxConfig$1, c == null ? void 0 : c.unstable_sxConfig), C.unstable_sx = function(w) {
    return styleFunctionSx$2({
      sx: w,
      theme: this
    });
  }, C;
}
const defaultTheme$1 = createTheme(), defaultTheme$2 = defaultTheme$1;
function useTheme$1() {
  const e = useTheme$3(defaultTheme$2);
  return process.env.NODE_ENV !== "production" && React$2.useDebugValue(e), e[THEME_ID] || e;
}
function useThemeProps({
  props: e,
  name: t
}) {
  return useThemeProps$1({
    props: e,
    name: t,
    defaultTheme: defaultTheme$2,
    themeId: THEME_ID
  });
}
var createStyled$1 = {}, objectWithoutPropertiesLoose = { exports: {} }, hasRequiredObjectWithoutPropertiesLoose;
function requireObjectWithoutPropertiesLoose() {
  return hasRequiredObjectWithoutPropertiesLoose || (hasRequiredObjectWithoutPropertiesLoose = 1, function(e) {
    function t(n, o) {
      if (n == null)
        return {};
      var s = {}, l = Object.keys(n), c, p;
      for (p = 0; p < l.length; p++)
        c = l[p], !(o.indexOf(c) >= 0) && (s[c] = n[c]);
      return s;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(objectWithoutPropertiesLoose)), objectWithoutPropertiesLoose.exports;
}
const require$$1 = /* @__PURE__ */ getAugmentedNamespace(styledEngine), require$$4 = /* @__PURE__ */ getAugmentedNamespace(deepmerge), require$$5 = /* @__PURE__ */ getAugmentedNamespace(capitalize), require$$6 = /* @__PURE__ */ getAugmentedNamespace(getDisplayName), require$$7 = /* @__PURE__ */ getAugmentedNamespace(createTheme$1), require$$8 = /* @__PURE__ */ getAugmentedNamespace(styleFunctionSx);
var _interopRequireDefault$1 = interopRequireDefaultExports;
Object.defineProperty(createStyled$1, "__esModule", {
  value: !0
});
var _default$1 = createStyled$1.default = createStyled, shouldForwardProp_1 = createStyled$1.shouldForwardProp = shouldForwardProp;
createStyled$1.systemDefaultTheme = void 0;
var _extends2 = _interopRequireDefault$1(require_extends()), _objectWithoutPropertiesLoose2 = _interopRequireDefault$1(requireObjectWithoutPropertiesLoose()), _styledEngine$1 = _interopRequireWildcard$3(require$$1), _deepmerge = require$$4, _capitalize = _interopRequireDefault$1(require$$5), _getDisplayName = _interopRequireDefault$1(require$$6), _createTheme = _interopRequireDefault$1(require$$7), _styleFunctionSx = _interopRequireDefault$1(require$$8);
const _excluded$Q = ["ownerState"], _excluded2$7 = ["variants"], _excluded3$4 = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function _getRequireWildcardCache$3(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache$3 = function(o) {
    return o ? n : t;
  })(e);
}
function _interopRequireWildcard$3(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var n = _getRequireWildcardCache$3(t);
  if (n && n.has(e))
    return n.get(e);
  var o = { __proto__: null }, s = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var l in e)
    if (l !== "default" && Object.prototype.hasOwnProperty.call(e, l)) {
      var c = s ? Object.getOwnPropertyDescriptor(e, l) : null;
      c && (c.get || c.set) ? Object.defineProperty(o, l, c) : o[l] = e[l];
    }
  return o.default = e, n && n.set(e, o), o;
}
function isEmpty$2(e) {
  return Object.keys(e).length === 0;
}
function isStringTag(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function shouldForwardProp(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const systemDefaultTheme = createStyled$1.systemDefaultTheme = (0, _createTheme.default)(), lowercaseFirstLetter = (e) => e && e.charAt(0).toLowerCase() + e.slice(1);
function resolveTheme({
  defaultTheme: e,
  theme: t,
  themeId: n
}) {
  return isEmpty$2(t) ? e : t[n] || t;
}
function defaultOverridesResolver(e) {
  return e ? (t, n) => n[e] : null;
}
function processStyleArg(e, t) {
  let {
    ownerState: n
  } = t, o = (0, _objectWithoutPropertiesLoose2.default)(t, _excluded$Q);
  const s = typeof e == "function" ? e((0, _extends2.default)({
    ownerState: n
  }, o)) : e;
  if (Array.isArray(s))
    return s.flatMap((l) => processStyleArg(l, (0, _extends2.default)({
      ownerState: n
    }, o)));
  if (s && typeof s == "object" && Array.isArray(s.variants)) {
    const {
      variants: l = []
    } = s;
    let p = (0, _objectWithoutPropertiesLoose2.default)(s, _excluded2$7);
    return l.forEach((m) => {
      let C = !0;
      typeof m.props == "function" ? C = m.props((0, _extends2.default)({
        ownerState: n
      }, o, n)) : Object.keys(m.props).forEach((P) => {
        (n == null ? void 0 : n[P]) !== m.props[P] && o[P] !== m.props[P] && (C = !1);
      }), C && (Array.isArray(p) || (p = [p]), p.push(typeof m.style == "function" ? m.style((0, _extends2.default)({
        ownerState: n
      }, o, n)) : m.style));
    }), p;
  }
  return s;
}
function createStyled(e = {}) {
  const {
    themeId: t,
    defaultTheme: n = systemDefaultTheme,
    rootShouldForwardProp: o = shouldForwardProp,
    slotShouldForwardProp: s = shouldForwardProp
  } = e, l = (c) => (0, _styleFunctionSx.default)((0, _extends2.default)({}, c, {
    theme: resolveTheme((0, _extends2.default)({}, c, {
      defaultTheme: n,
      themeId: t
    }))
  }));
  return l.__mui_systemSx = !0, (c, p = {}) => {
    (0, _styledEngine$1.internal_processStyles)(c, (K) => K.filter((ue) => !(ue != null && ue.__mui_systemSx)));
    const {
      name: m,
      slot: C,
      skipVariantsResolver: P,
      skipSx: w,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: R = defaultOverridesResolver(lowercaseFirstLetter(C))
    } = p, L = (0, _objectWithoutPropertiesLoose2.default)(p, _excluded3$4), M = P !== void 0 ? P : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      C && C !== "Root" && C !== "root" || !1
    ), $ = w || !1;
    let W;
    process.env.NODE_ENV !== "production" && m && (W = `${m}-${lowercaseFirstLetter(C || "Root")}`);
    let H = shouldForwardProp;
    C === "Root" || C === "root" ? H = o : C ? H = s : isStringTag(c) && (H = void 0);
    const V = (0, _styledEngine$1.default)(c, (0, _extends2.default)({
      shouldForwardProp: H,
      label: W
    }, L)), N = (K) => typeof K == "function" && K.__emotion_real !== K || (0, _deepmerge.isPlainObject)(K) ? (ue) => processStyleArg(K, (0, _extends2.default)({}, ue, {
      theme: resolveTheme({
        theme: ue.theme,
        defaultTheme: n,
        themeId: t
      })
    })) : K, B = (K, ...ue) => {
      let de = N(K);
      const ve = ue ? ue.map(N) : [];
      m && R && ve.push((Ce) => {
        const Re = resolveTheme((0, _extends2.default)({}, Ce, {
          defaultTheme: n,
          themeId: t
        }));
        if (!Re.components || !Re.components[m] || !Re.components[m].styleOverrides)
          return null;
        const ke = Re.components[m].styleOverrides, Ae = {};
        return Object.entries(ke).forEach(([we, he]) => {
          Ae[we] = processStyleArg(he, (0, _extends2.default)({}, Ce, {
            theme: Re
          }));
        }), R(Ce, Ae);
      }), m && !M && ve.push((Ce) => {
        var Re;
        const ke = resolveTheme((0, _extends2.default)({}, Ce, {
          defaultTheme: n,
          themeId: t
        })), Ae = ke == null || (Re = ke.components) == null || (Re = Re[m]) == null ? void 0 : Re.variants;
        return processStyleArg({
          variants: Ae
        }, (0, _extends2.default)({}, Ce, {
          theme: ke
        }));
      }), $ || ve.push(l);
      const Te = ve.length - ue.length;
      if (Array.isArray(K) && Te > 0) {
        const Ce = new Array(Te).fill("");
        de = [...K, ...Ce], de.raw = [...K.raw, ...Ce];
      }
      const Pe = V(de, ...ve);
      if (process.env.NODE_ENV !== "production") {
        let Ce;
        m && (Ce = `${m}${(0, _capitalize.default)(C || "")}`), Ce === void 0 && (Ce = `Styled(${(0, _getDisplayName.default)(c)})`), Pe.displayName = Ce;
      }
      return c.muiName && (Pe.muiName = c.muiName), Pe;
    };
    return V.withConfig && (B.withConfig = V.withConfig), B;
  };
}
const rootShouldForwardProp = (e) => shouldForwardProp_1(e) && e !== "classes", slotShouldForwardProp = shouldForwardProp_1, styled = _default$1({
  themeId: THEME_ID,
  defaultTheme: defaultTheme$2,
  rootShouldForwardProp
}), E = styled, _excluded$P = ["theme"];
function ThemeProvider(e) {
  let {
    theme: t
  } = e, n = _objectWithoutPropertiesLoose$3(e, _excluded$P);
  const o = t[THEME_ID];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider$1, _extends$5({}, n, {
    themeId: o ? THEME_ID : void 0,
    theme: o || t
  }));
}
process.env.NODE_ENV !== "production" && (ThemeProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired
});
const getOverlayAlpha = (e) => {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, (t / 100).toFixed(2);
}, getOverlayAlpha$1 = getOverlayAlpha;
function getSvgIconUtilityClass(e) {
  return generateUtilityClass$1("MuiSvgIcon", e);
}
generateUtilityClasses$1("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const _excluded$O = ["children", "className", "color", "component", "fontSize", "htmlColor", "inheritViewBox", "titleAccess", "viewBox"], useUtilityClasses$B = (e) => {
  const {
    color: t,
    fontSize: n,
    classes: o
  } = e, s = {
    root: ["root", t !== "inherit" && `color${capitalize$1(t)}`, `fontSize${capitalize$1(n)}`]
  };
  return composeClasses(s, getSvgIconUtilityClass, o);
}, SvgIconRoot = E("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "inherit" && t[`color${capitalize$1(n.color)}`], t[`fontSize${capitalize$1(n.fontSize)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var n, o, s, l, c, p, m, C, P, w, R, L, M;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    // the <svg> will define the property that has `currentColor`
    // e.g. heroicons uses fill="none" and stroke="currentColor"
    fill: t.hasSvgAsChild ? void 0 : "currentColor",
    flexShrink: 0,
    transition: (n = e.transitions) == null || (o = n.create) == null ? void 0 : o.call(n, "fill", {
      duration: (s = e.transitions) == null || (s = s.duration) == null ? void 0 : s.shorter
    }),
    fontSize: {
      inherit: "inherit",
      small: ((l = e.typography) == null || (c = l.pxToRem) == null ? void 0 : c.call(l, 20)) || "1.25rem",
      medium: ((p = e.typography) == null || (m = p.pxToRem) == null ? void 0 : m.call(p, 24)) || "1.5rem",
      large: ((C = e.typography) == null || (P = C.pxToRem) == null ? void 0 : P.call(C, 35)) || "2.1875rem"
    }[t.fontSize],
    // TODO v5 deprecate, v6 remove for sx
    color: (w = (R = (e.vars || e).palette) == null || (R = R[t.color]) == null ? void 0 : R.main) != null ? w : {
      action: (L = (e.vars || e).palette) == null || (L = L.action) == null ? void 0 : L.active,
      disabled: (M = (e.vars || e).palette) == null || (M = M.action) == null ? void 0 : M.disabled,
      inherit: void 0
    }[t.color]
  };
}), SvgIcon = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  const o = useThemeProps({
    props: t,
    name: "MuiSvgIcon"
  }), {
    children: s,
    className: l,
    color: c = "inherit",
    component: p = "svg",
    fontSize: m = "medium",
    htmlColor: C,
    inheritViewBox: P = !1,
    titleAccess: w,
    viewBox: R = "0 0 24 24"
  } = o, L = _objectWithoutPropertiesLoose$3(o, _excluded$O), M = /* @__PURE__ */ React$2.isValidElement(s) && s.type === "svg", $ = _extends$5({}, o, {
    color: c,
    component: p,
    fontSize: m,
    instanceFontSize: t.fontSize,
    inheritViewBox: P,
    viewBox: R,
    hasSvgAsChild: M
  }), W = {};
  P || (W.viewBox = R);
  const H = useUtilityClasses$B($);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(SvgIconRoot, _extends$5({
    as: p,
    className: clsx$1(H.root, l),
    focusable: "false",
    color: C,
    "aria-hidden": w ? void 0 : !0,
    role: w ? "img" : void 0,
    ref: n
  }, W, L, M && s.props, {
    ownerState: $,
    children: [M ? s.props.children : s, w ? /* @__PURE__ */ jsxRuntimeExports.jsx("title", {
      children: w
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && (SvgIcon.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "large", "medium", "small"]), PropTypes.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: PropTypes.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: PropTypes.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: PropTypes.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: PropTypes.string
});
SvgIcon.muiName = "SvgIcon";
const SvgIcon$1 = SvgIcon;
function createSvgIcon(e, t) {
  function n(o, s) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(SvgIcon$1, _extends$5({
      "data-testid": `${t}Icon`,
      ref: s
    }, o, {
      children: e
    }));
  }
  return process.env.NODE_ENV !== "production" && (n.displayName = `${t}Icon`), n.muiName = SvgIcon$1.muiName, /* @__PURE__ */ React$2.memo(/* @__PURE__ */ React$2.forwardRef(n));
}
var reactIs = { exports: {} }, reactIs_production_min = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min)
    return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), c = Symbol.for("react.context"), p = Symbol.for("react.server_context"), m = Symbol.for("react.forward_ref"), C = Symbol.for("react.suspense"), P = Symbol.for("react.suspense_list"), w = Symbol.for("react.memo"), R = Symbol.for("react.lazy"), L = Symbol.for("react.offscreen"), M;
  M = Symbol.for("react.module.reference");
  function $(W) {
    if (typeof W == "object" && W !== null) {
      var H = W.$$typeof;
      switch (H) {
        case e:
          switch (W = W.type, W) {
            case n:
            case s:
            case o:
            case C:
            case P:
              return W;
            default:
              switch (W = W && W.$$typeof, W) {
                case p:
                case c:
                case m:
                case R:
                case w:
                case l:
                  return W;
                default:
                  return H;
              }
          }
        case t:
          return H;
      }
    }
  }
  return reactIs_production_min.ContextConsumer = c, reactIs_production_min.ContextProvider = l, reactIs_production_min.Element = e, reactIs_production_min.ForwardRef = m, reactIs_production_min.Fragment = n, reactIs_production_min.Lazy = R, reactIs_production_min.Memo = w, reactIs_production_min.Portal = t, reactIs_production_min.Profiler = s, reactIs_production_min.StrictMode = o, reactIs_production_min.Suspense = C, reactIs_production_min.SuspenseList = P, reactIs_production_min.isAsyncMode = function() {
    return !1;
  }, reactIs_production_min.isConcurrentMode = function() {
    return !1;
  }, reactIs_production_min.isContextConsumer = function(W) {
    return $(W) === c;
  }, reactIs_production_min.isContextProvider = function(W) {
    return $(W) === l;
  }, reactIs_production_min.isElement = function(W) {
    return typeof W == "object" && W !== null && W.$$typeof === e;
  }, reactIs_production_min.isForwardRef = function(W) {
    return $(W) === m;
  }, reactIs_production_min.isFragment = function(W) {
    return $(W) === n;
  }, reactIs_production_min.isLazy = function(W) {
    return $(W) === R;
  }, reactIs_production_min.isMemo = function(W) {
    return $(W) === w;
  }, reactIs_production_min.isPortal = function(W) {
    return $(W) === t;
  }, reactIs_production_min.isProfiler = function(W) {
    return $(W) === s;
  }, reactIs_production_min.isStrictMode = function(W) {
    return $(W) === o;
  }, reactIs_production_min.isSuspense = function(W) {
    return $(W) === C;
  }, reactIs_production_min.isSuspenseList = function(W) {
    return $(W) === P;
  }, reactIs_production_min.isValidElementType = function(W) {
    return typeof W == "string" || typeof W == "function" || W === n || W === s || W === o || W === C || W === P || W === L || typeof W == "object" && W !== null && (W.$$typeof === R || W.$$typeof === w || W.$$typeof === l || W.$$typeof === c || W.$$typeof === m || W.$$typeof === M || W.getModuleId !== void 0);
  }, reactIs_production_min.typeOf = $, reactIs_production_min;
}
var reactIs_development = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  return hasRequiredReactIs_development || (hasRequiredReactIs_development = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), c = Symbol.for("react.context"), p = Symbol.for("react.server_context"), m = Symbol.for("react.forward_ref"), C = Symbol.for("react.suspense"), P = Symbol.for("react.suspense_list"), w = Symbol.for("react.memo"), R = Symbol.for("react.lazy"), L = Symbol.for("react.offscreen"), M = !1, $ = !1, W = !1, H = !1, V = !1, N;
    N = Symbol.for("react.module.reference");
    function B(je) {
      return !!(typeof je == "string" || typeof je == "function" || je === n || je === s || V || je === o || je === C || je === P || H || je === L || M || $ || W || typeof je == "object" && je !== null && (je.$$typeof === R || je.$$typeof === w || je.$$typeof === l || je.$$typeof === c || je.$$typeof === m || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      je.$$typeof === N || je.getModuleId !== void 0));
    }
    function K(je) {
      if (typeof je == "object" && je !== null) {
        var kt = je.$$typeof;
        switch (kt) {
          case e:
            var cr = je.type;
            switch (cr) {
              case n:
              case s:
              case o:
              case C:
              case P:
                return cr;
              default:
                var Tr = cr && cr.$$typeof;
                switch (Tr) {
                  case p:
                  case c:
                  case m:
                  case R:
                  case w:
                  case l:
                    return Tr;
                  default:
                    return kt;
                }
            }
          case t:
            return kt;
        }
      }
    }
    var ue = c, de = l, ve = e, Te = m, Pe = n, Ce = R, Re = w, ke = t, Ae = s, we = o, he = C, be = P, le = !1, fe = !1;
    function ye(je) {
      return le || (le = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Ee(je) {
      return fe || (fe = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Ie(je) {
      return K(je) === c;
    }
    function Fe(je) {
      return K(je) === l;
    }
    function De(je) {
      return typeof je == "object" && je !== null && je.$$typeof === e;
    }
    function Ve(je) {
      return K(je) === m;
    }
    function Oe(je) {
      return K(je) === n;
    }
    function Ze(je) {
      return K(je) === R;
    }
    function et(je) {
      return K(je) === w;
    }
    function bt(je) {
      return K(je) === t;
    }
    function rr(je) {
      return K(je) === s;
    }
    function St(je) {
      return K(je) === o;
    }
    function Qe(je) {
      return K(je) === C;
    }
    function xt(je) {
      return K(je) === P;
    }
    reactIs_development.ContextConsumer = ue, reactIs_development.ContextProvider = de, reactIs_development.Element = ve, reactIs_development.ForwardRef = Te, reactIs_development.Fragment = Pe, reactIs_development.Lazy = Ce, reactIs_development.Memo = Re, reactIs_development.Portal = ke, reactIs_development.Profiler = Ae, reactIs_development.StrictMode = we, reactIs_development.Suspense = he, reactIs_development.SuspenseList = be, reactIs_development.isAsyncMode = ye, reactIs_development.isConcurrentMode = Ee, reactIs_development.isContextConsumer = Ie, reactIs_development.isContextProvider = Fe, reactIs_development.isElement = De, reactIs_development.isForwardRef = Ve, reactIs_development.isFragment = Oe, reactIs_development.isLazy = Ze, reactIs_development.isMemo = et, reactIs_development.isPortal = bt, reactIs_development.isProfiler = rr, reactIs_development.isStrictMode = St, reactIs_development.isSuspense = Qe, reactIs_development.isSuspenseList = xt, reactIs_development.isValidElementType = B, reactIs_development.typeOf = K;
  }()), reactIs_development;
}
process.env.NODE_ENV === "production" ? reactIs.exports = requireReactIs_production_min() : reactIs.exports = requireReactIs_development();
var reactIsExports = reactIs.exports;
function _setPrototypeOf$1(e, t) {
  return _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(o, s) {
    return o.__proto__ = s, o;
  }, _setPrototypeOf$1(e, t);
}
function _inheritsLoose$1(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, _setPrototypeOf$1(e, t);
}
var reactDom = { exports: {} }, reactDom_production_min = {}, scheduler = { exports: {} }, scheduler_production_min = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredScheduler_production_min;
function requireScheduler_production_min() {
  return hasRequiredScheduler_production_min || (hasRequiredScheduler_production_min = 1, function(e) {
    function t(le, fe) {
      var ye = le.length;
      le.push(fe);
      e:
        for (; 0 < ye; ) {
          var Ee = ye - 1 >>> 1, Ie = le[Ee];
          if (0 < s(Ie, fe))
            le[Ee] = fe, le[ye] = Ie, ye = Ee;
          else
            break e;
        }
    }
    function n(le) {
      return le.length === 0 ? null : le[0];
    }
    function o(le) {
      if (le.length === 0)
        return null;
      var fe = le[0], ye = le.pop();
      if (ye !== fe) {
        le[0] = ye;
        e:
          for (var Ee = 0, Ie = le.length, Fe = Ie >>> 1; Ee < Fe; ) {
            var De = 2 * (Ee + 1) - 1, Ve = le[De], Oe = De + 1, Ze = le[Oe];
            if (0 > s(Ve, ye))
              Oe < Ie && 0 > s(Ze, Ve) ? (le[Ee] = Ze, le[Oe] = ye, Ee = Oe) : (le[Ee] = Ve, le[De] = ye, Ee = De);
            else if (Oe < Ie && 0 > s(Ze, ye))
              le[Ee] = Ze, le[Oe] = ye, Ee = Oe;
            else
              break e;
          }
      }
      return fe;
    }
    function s(le, fe) {
      var ye = le.sortIndex - fe.sortIndex;
      return ye !== 0 ? ye : le.id - fe.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var l = performance;
      e.unstable_now = function() {
        return l.now();
      };
    } else {
      var c = Date, p = c.now();
      e.unstable_now = function() {
        return c.now() - p;
      };
    }
    var m = [], C = [], P = 1, w = null, R = 3, L = !1, M = !1, $ = !1, W = typeof setTimeout == "function" ? setTimeout : null, H = typeof clearTimeout == "function" ? clearTimeout : null, V = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function N(le) {
      for (var fe = n(C); fe !== null; ) {
        if (fe.callback === null)
          o(C);
        else if (fe.startTime <= le)
          o(C), fe.sortIndex = fe.expirationTime, t(m, fe);
        else
          break;
        fe = n(C);
      }
    }
    function B(le) {
      if ($ = !1, N(le), !M)
        if (n(m) !== null)
          M = !0, he(K);
        else {
          var fe = n(C);
          fe !== null && be(B, fe.startTime - le);
        }
    }
    function K(le, fe) {
      M = !1, $ && ($ = !1, H(ve), ve = -1), L = !0;
      var ye = R;
      try {
        for (N(fe), w = n(m); w !== null && (!(w.expirationTime > fe) || le && !Ce()); ) {
          var Ee = w.callback;
          if (typeof Ee == "function") {
            w.callback = null, R = w.priorityLevel;
            var Ie = Ee(w.expirationTime <= fe);
            fe = e.unstable_now(), typeof Ie == "function" ? w.callback = Ie : w === n(m) && o(m), N(fe);
          } else
            o(m);
          w = n(m);
        }
        if (w !== null)
          var Fe = !0;
        else {
          var De = n(C);
          De !== null && be(B, De.startTime - fe), Fe = !1;
        }
        return Fe;
      } finally {
        w = null, R = ye, L = !1;
      }
    }
    var ue = !1, de = null, ve = -1, Te = 5, Pe = -1;
    function Ce() {
      return !(e.unstable_now() - Pe < Te);
    }
    function Re() {
      if (de !== null) {
        var le = e.unstable_now();
        Pe = le;
        var fe = !0;
        try {
          fe = de(!0, le);
        } finally {
          fe ? ke() : (ue = !1, de = null);
        }
      } else
        ue = !1;
    }
    var ke;
    if (typeof V == "function")
      ke = function() {
        V(Re);
      };
    else if (typeof MessageChannel < "u") {
      var Ae = new MessageChannel(), we = Ae.port2;
      Ae.port1.onmessage = Re, ke = function() {
        we.postMessage(null);
      };
    } else
      ke = function() {
        W(Re, 0);
      };
    function he(le) {
      de = le, ue || (ue = !0, ke());
    }
    function be(le, fe) {
      ve = W(function() {
        le(e.unstable_now());
      }, fe);
    }
    e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(le) {
      le.callback = null;
    }, e.unstable_continueExecution = function() {
      M || L || (M = !0, he(K));
    }, e.unstable_forceFrameRate = function(le) {
      0 > le || 125 < le ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : Te = 0 < le ? Math.floor(1e3 / le) : 5;
    }, e.unstable_getCurrentPriorityLevel = function() {
      return R;
    }, e.unstable_getFirstCallbackNode = function() {
      return n(m);
    }, e.unstable_next = function(le) {
      switch (R) {
        case 1:
        case 2:
        case 3:
          var fe = 3;
          break;
        default:
          fe = R;
      }
      var ye = R;
      R = fe;
      try {
        return le();
      } finally {
        R = ye;
      }
    }, e.unstable_pauseExecution = function() {
    }, e.unstable_requestPaint = function() {
    }, e.unstable_runWithPriority = function(le, fe) {
      switch (le) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          le = 3;
      }
      var ye = R;
      R = le;
      try {
        return fe();
      } finally {
        R = ye;
      }
    }, e.unstable_scheduleCallback = function(le, fe, ye) {
      var Ee = e.unstable_now();
      switch (typeof ye == "object" && ye !== null ? (ye = ye.delay, ye = typeof ye == "number" && 0 < ye ? Ee + ye : Ee) : ye = Ee, le) {
        case 1:
          var Ie = -1;
          break;
        case 2:
          Ie = 250;
          break;
        case 5:
          Ie = 1073741823;
          break;
        case 4:
          Ie = 1e4;
          break;
        default:
          Ie = 5e3;
      }
      return Ie = ye + Ie, le = { id: P++, callback: fe, priorityLevel: le, startTime: ye, expirationTime: Ie, sortIndex: -1 }, ye > Ee ? (le.sortIndex = ye, t(C, le), n(m) === null && le === n(C) && ($ ? (H(ve), ve = -1) : $ = !0, be(B, ye - Ee))) : (le.sortIndex = Ie, t(m, le), M || L || (M = !0, he(K))), le;
    }, e.unstable_shouldYield = Ce, e.unstable_wrapCallback = function(le) {
      var fe = R;
      return function() {
        var ye = R;
        R = fe;
        try {
          return le.apply(this, arguments);
        } finally {
          R = ye;
        }
      };
    };
  }(scheduler_production_min)), scheduler_production_min;
}
var scheduler_development = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredScheduler_development;
function requireScheduler_development() {
  return hasRequiredScheduler_development || (hasRequiredScheduler_development = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var t = !1, n = !1, o = 5;
      function s(pt, ir) {
        var nr = pt.length;
        pt.push(ir), p(pt, ir, nr);
      }
      function l(pt) {
        return pt.length === 0 ? null : pt[0];
      }
      function c(pt) {
        if (pt.length === 0)
          return null;
        var ir = pt[0], nr = pt.pop();
        return nr !== ir && (pt[0] = nr, m(pt, nr, 0)), ir;
      }
      function p(pt, ir, nr) {
        for (var er = nr; er > 0; ) {
          var pr = er - 1 >>> 1, kr = pt[pr];
          if (C(kr, ir) > 0)
            pt[pr] = ir, pt[er] = kr, er = pr;
          else
            return;
        }
      }
      function m(pt, ir, nr) {
        for (var er = nr, pr = pt.length, kr = pr >>> 1; er < kr; ) {
          var Nr = (er + 1) * 2 - 1, hn = pt[Nr], fn = Nr + 1, uo = pt[fn];
          if (C(hn, ir) < 0)
            fn < pr && C(uo, hn) < 0 ? (pt[er] = uo, pt[fn] = ir, er = fn) : (pt[er] = hn, pt[Nr] = ir, er = Nr);
          else if (fn < pr && C(uo, ir) < 0)
            pt[er] = uo, pt[fn] = ir, er = fn;
          else
            return;
        }
      }
      function C(pt, ir) {
        var nr = pt.sortIndex - ir.sortIndex;
        return nr !== 0 ? nr : pt.id - ir.id;
      }
      var P = 1, w = 2, R = 3, L = 4, M = 5;
      function $(pt, ir) {
      }
      var W = typeof performance == "object" && typeof performance.now == "function";
      if (W) {
        var H = performance;
        e.unstable_now = function() {
          return H.now();
        };
      } else {
        var V = Date, N = V.now();
        e.unstable_now = function() {
          return V.now() - N;
        };
      }
      var B = 1073741823, K = -1, ue = 250, de = 5e3, ve = 1e4, Te = B, Pe = [], Ce = [], Re = 1, ke = null, Ae = R, we = !1, he = !1, be = !1, le = typeof setTimeout == "function" ? setTimeout : null, fe = typeof clearTimeout == "function" ? clearTimeout : null, ye = typeof setImmediate < "u" ? setImmediate : null;
      typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
      function Ee(pt) {
        for (var ir = l(Ce); ir !== null; ) {
          if (ir.callback === null)
            c(Ce);
          else if (ir.startTime <= pt)
            c(Ce), ir.sortIndex = ir.expirationTime, s(Pe, ir);
          else
            return;
          ir = l(Ce);
        }
      }
      function Ie(pt) {
        if (be = !1, Ee(pt), !he)
          if (l(Pe) !== null)
            he = !0, wr(Fe);
          else {
            var ir = l(Ce);
            ir !== null && Sr(Ie, ir.startTime - pt);
          }
      }
      function Fe(pt, ir) {
        he = !1, be && (be = !1, Ye()), we = !0;
        var nr = Ae;
        try {
          var er;
          if (!n)
            return De(pt, ir);
        } finally {
          ke = null, Ae = nr, we = !1;
        }
      }
      function De(pt, ir) {
        var nr = ir;
        for (Ee(nr), ke = l(Pe); ke !== null && !t && !(ke.expirationTime > nr && (!pt || Hr())); ) {
          var er = ke.callback;
          if (typeof er == "function") {
            ke.callback = null, Ae = ke.priorityLevel;
            var pr = ke.expirationTime <= nr, kr = er(pr);
            nr = e.unstable_now(), typeof kr == "function" ? ke.callback = kr : ke === l(Pe) && c(Pe), Ee(nr);
          } else
            c(Pe);
          ke = l(Pe);
        }
        if (ke !== null)
          return !0;
        var Nr = l(Ce);
        return Nr !== null && Sr(Ie, Nr.startTime - nr), !1;
      }
      function Ve(pt, ir) {
        switch (pt) {
          case P:
          case w:
          case R:
          case L:
          case M:
            break;
          default:
            pt = R;
        }
        var nr = Ae;
        Ae = pt;
        try {
          return ir();
        } finally {
          Ae = nr;
        }
      }
      function Oe(pt) {
        var ir;
        switch (Ae) {
          case P:
          case w:
          case R:
            ir = R;
            break;
          default:
            ir = Ae;
            break;
        }
        var nr = Ae;
        Ae = ir;
        try {
          return pt();
        } finally {
          Ae = nr;
        }
      }
      function Ze(pt) {
        var ir = Ae;
        return function() {
          var nr = Ae;
          Ae = ir;
          try {
            return pt.apply(this, arguments);
          } finally {
            Ae = nr;
          }
        };
      }
      function et(pt, ir, nr) {
        var er = e.unstable_now(), pr;
        if (typeof nr == "object" && nr !== null) {
          var kr = nr.delay;
          typeof kr == "number" && kr > 0 ? pr = er + kr : pr = er;
        } else
          pr = er;
        var Nr;
        switch (pt) {
          case P:
            Nr = K;
            break;
          case w:
            Nr = ue;
            break;
          case M:
            Nr = Te;
            break;
          case L:
            Nr = ve;
            break;
          case R:
          default:
            Nr = de;
            break;
        }
        var hn = pr + Nr, fn = {
          id: Re++,
          callback: ir,
          priorityLevel: pt,
          startTime: pr,
          expirationTime: hn,
          sortIndex: -1
        };
        return pr > er ? (fn.sortIndex = pr, s(Ce, fn), l(Pe) === null && fn === l(Ce) && (be ? Ye() : be = !0, Sr(Ie, pr - er))) : (fn.sortIndex = hn, s(Pe, fn), !he && !we && (he = !0, wr(Fe))), fn;
      }
      function bt() {
      }
      function rr() {
        !he && !we && (he = !0, wr(Fe));
      }
      function St() {
        return l(Pe);
      }
      function Qe(pt) {
        pt.callback = null;
      }
      function xt() {
        return Ae;
      }
      var je = !1, kt = null, cr = -1, Tr = o, Er = -1;
      function Hr() {
        var pt = e.unstable_now() - Er;
        return !(pt < Tr);
      }
      function Br() {
      }
      function hr(pt) {
        if (pt < 0 || pt > 125) {
          console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
          return;
        }
        pt > 0 ? Tr = Math.floor(1e3 / pt) : Tr = o;
      }
      var Gr = function() {
        if (kt !== null) {
          var pt = e.unstable_now();
          Er = pt;
          var ir = !0, nr = !0;
          try {
            nr = kt(ir, pt);
          } finally {
            nr ? Yr() : (je = !1, kt = null);
          }
        } else
          je = !1;
      }, Yr;
      if (typeof ye == "function")
        Yr = function() {
          ye(Gr);
        };
      else if (typeof MessageChannel < "u") {
        var tt = new MessageChannel(), ar = tt.port2;
        tt.port1.onmessage = Gr, Yr = function() {
          ar.postMessage(null);
        };
      } else
        Yr = function() {
          le(Gr, 0);
        };
      function wr(pt) {
        kt = pt, je || (je = !0, Yr());
      }
      function Sr(pt, ir) {
        cr = le(function() {
          pt(e.unstable_now());
        }, ir);
      }
      function Ye() {
        fe(cr), cr = -1;
      }
      var Je = Br, tr = null;
      e.unstable_IdlePriority = M, e.unstable_ImmediatePriority = P, e.unstable_LowPriority = L, e.unstable_NormalPriority = R, e.unstable_Profiling = tr, e.unstable_UserBlockingPriority = w, e.unstable_cancelCallback = Qe, e.unstable_continueExecution = rr, e.unstable_forceFrameRate = hr, e.unstable_getCurrentPriorityLevel = xt, e.unstable_getFirstCallbackNode = St, e.unstable_next = Oe, e.unstable_pauseExecution = bt, e.unstable_requestPaint = Je, e.unstable_runWithPriority = Ve, e.unstable_scheduleCallback = et, e.unstable_shouldYield = Hr, e.unstable_wrapCallback = Ze, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(scheduler_development)), scheduler_development;
}
var hasRequiredScheduler;
function requireScheduler() {
  return hasRequiredScheduler || (hasRequiredScheduler = 1, process.env.NODE_ENV === "production" ? scheduler.exports = requireScheduler_production_min() : scheduler.exports = requireScheduler_development()), scheduler.exports;
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactDom_production_min;
function requireReactDom_production_min() {
  if (hasRequiredReactDom_production_min)
    return reactDom_production_min;
  hasRequiredReactDom_production_min = 1;
  var e = React__default, t = requireScheduler();
  function n(u) {
    for (var d = "https://reactjs.org/docs/error-decoder.html?invariant=" + u, T = 1; T < arguments.length; T++)
      d += "&args[]=" + encodeURIComponent(arguments[T]);
    return "Minified React error #" + u + "; visit " + d + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var o = /* @__PURE__ */ new Set(), s = {};
  function l(u, d) {
    c(u, d), c(u + "Capture", d);
  }
  function c(u, d) {
    for (s[u] = d, u = 0; u < d.length; u++)
      o.add(d[u]);
  }
  var p = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), m = Object.prototype.hasOwnProperty, C = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, P = {}, w = {};
  function R(u) {
    return m.call(w, u) ? !0 : m.call(P, u) ? !1 : C.test(u) ? w[u] = !0 : (P[u] = !0, !1);
  }
  function L(u, d, T, k) {
    if (T !== null && T.type === 0)
      return !1;
    switch (typeof d) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return k ? !1 : T !== null ? !T.acceptsBooleans : (u = u.toLowerCase().slice(0, 5), u !== "data-" && u !== "aria-");
      default:
        return !1;
    }
  }
  function M(u, d, T, k) {
    if (d === null || typeof d > "u" || L(u, d, T, k))
      return !0;
    if (k)
      return !1;
    if (T !== null)
      switch (T.type) {
        case 3:
          return !d;
        case 4:
          return d === !1;
        case 5:
          return isNaN(d);
        case 6:
          return isNaN(d) || 1 > d;
      }
    return !1;
  }
  function $(u, d, T, k, Q, ce, ge) {
    this.acceptsBooleans = d === 2 || d === 3 || d === 4, this.attributeName = k, this.attributeNamespace = Q, this.mustUseProperty = T, this.propertyName = u, this.type = d, this.sanitizeURL = ce, this.removeEmptyString = ge;
  }
  var W = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(u) {
    W[u] = new $(u, 0, !1, u, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(u) {
    var d = u[0];
    W[d] = new $(d, 1, !1, u[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(u) {
    W[u] = new $(u, 2, !1, u.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(u) {
    W[u] = new $(u, 2, !1, u, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(u) {
    W[u] = new $(u, 3, !1, u.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(u) {
    W[u] = new $(u, 3, !0, u, null, !1, !1);
  }), ["capture", "download"].forEach(function(u) {
    W[u] = new $(u, 4, !1, u, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(u) {
    W[u] = new $(u, 6, !1, u, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(u) {
    W[u] = new $(u, 5, !1, u.toLowerCase(), null, !1, !1);
  });
  var H = /[\-:]([a-z])/g;
  function V(u) {
    return u[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(u) {
    var d = u.replace(
      H,
      V
    );
    W[d] = new $(d, 1, !1, u, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(u) {
    var d = u.replace(H, V);
    W[d] = new $(d, 1, !1, u, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(u) {
    var d = u.replace(H, V);
    W[d] = new $(d, 1, !1, u, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(u) {
    W[u] = new $(u, 1, !1, u.toLowerCase(), null, !1, !1);
  }), W.xlinkHref = new $("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(u) {
    W[u] = new $(u, 1, !1, u.toLowerCase(), null, !0, !0);
  });
  function N(u, d, T, k) {
    var Q = W.hasOwnProperty(d) ? W[d] : null;
    (Q !== null ? Q.type !== 0 : k || !(2 < d.length) || d[0] !== "o" && d[0] !== "O" || d[1] !== "n" && d[1] !== "N") && (M(d, T, Q, k) && (T = null), k || Q === null ? R(d) && (T === null ? u.removeAttribute(d) : u.setAttribute(d, "" + T)) : Q.mustUseProperty ? u[Q.propertyName] = T === null ? Q.type === 3 ? !1 : "" : T : (d = Q.attributeName, k = Q.attributeNamespace, T === null ? u.removeAttribute(d) : (Q = Q.type, T = Q === 3 || Q === 4 && T === !0 ? "" : "" + T, k ? u.setAttributeNS(k, d, T) : u.setAttribute(d, T))));
  }
  var B = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, K = Symbol.for("react.element"), ue = Symbol.for("react.portal"), de = Symbol.for("react.fragment"), ve = Symbol.for("react.strict_mode"), Te = Symbol.for("react.profiler"), Pe = Symbol.for("react.provider"), Ce = Symbol.for("react.context"), Re = Symbol.for("react.forward_ref"), ke = Symbol.for("react.suspense"), Ae = Symbol.for("react.suspense_list"), we = Symbol.for("react.memo"), he = Symbol.for("react.lazy"), be = Symbol.for("react.offscreen"), le = Symbol.iterator;
  function fe(u) {
    return u === null || typeof u != "object" ? null : (u = le && u[le] || u["@@iterator"], typeof u == "function" ? u : null);
  }
  var ye = Object.assign, Ee;
  function Ie(u) {
    if (Ee === void 0)
      try {
        throw Error();
      } catch (T) {
        var d = T.stack.trim().match(/\n( *(at )?)/);
        Ee = d && d[1] || "";
      }
    return `
` + Ee + u;
  }
  var Fe = !1;
  function De(u, d) {
    if (!u || Fe)
      return "";
    Fe = !0;
    var T = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (d)
        if (d = function() {
          throw Error();
        }, Object.defineProperty(d.prototype, "props", { set: function() {
          throw Error();
        } }), typeof Reflect == "object" && Reflect.construct) {
          try {
            Reflect.construct(d, []);
          } catch (Xe) {
            var k = Xe;
          }
          Reflect.construct(u, [], d);
        } else {
          try {
            d.call();
          } catch (Xe) {
            k = Xe;
          }
          u.call(d.prototype);
        }
      else {
        try {
          throw Error();
        } catch (Xe) {
          k = Xe;
        }
        u();
      }
    } catch (Xe) {
      if (Xe && k && typeof Xe.stack == "string") {
        for (var Q = Xe.stack.split(`
`), ce = k.stack.split(`
`), ge = Q.length - 1, $e = ce.length - 1; 1 <= ge && 0 <= $e && Q[ge] !== ce[$e]; )
          $e--;
        for (; 1 <= ge && 0 <= $e; ge--, $e--)
          if (Q[ge] !== ce[$e]) {
            if (ge !== 1 || $e !== 1)
              do
                if (ge--, $e--, 0 > $e || Q[ge] !== ce[$e]) {
                  var Ne = `
` + Q[ge].replace(" at new ", " at ");
                  return u.displayName && Ne.includes("<anonymous>") && (Ne = Ne.replace("<anonymous>", u.displayName)), Ne;
                }
              while (1 <= ge && 0 <= $e);
            break;
          }
      }
    } finally {
      Fe = !1, Error.prepareStackTrace = T;
    }
    return (u = u ? u.displayName || u.name : "") ? Ie(u) : "";
  }
  function Ve(u) {
    switch (u.tag) {
      case 5:
        return Ie(u.type);
      case 16:
        return Ie("Lazy");
      case 13:
        return Ie("Suspense");
      case 19:
        return Ie("SuspenseList");
      case 0:
      case 2:
      case 15:
        return u = De(u.type, !1), u;
      case 11:
        return u = De(u.type.render, !1), u;
      case 1:
        return u = De(u.type, !0), u;
      default:
        return "";
    }
  }
  function Oe(u) {
    if (u == null)
      return null;
    if (typeof u == "function")
      return u.displayName || u.name || null;
    if (typeof u == "string")
      return u;
    switch (u) {
      case de:
        return "Fragment";
      case ue:
        return "Portal";
      case Te:
        return "Profiler";
      case ve:
        return "StrictMode";
      case ke:
        return "Suspense";
      case Ae:
        return "SuspenseList";
    }
    if (typeof u == "object")
      switch (u.$$typeof) {
        case Ce:
          return (u.displayName || "Context") + ".Consumer";
        case Pe:
          return (u._context.displayName || "Context") + ".Provider";
        case Re:
          var d = u.render;
          return u = u.displayName, u || (u = d.displayName || d.name || "", u = u !== "" ? "ForwardRef(" + u + ")" : "ForwardRef"), u;
        case we:
          return d = u.displayName || null, d !== null ? d : Oe(u.type) || "Memo";
        case he:
          d = u._payload, u = u._init;
          try {
            return Oe(u(d));
          } catch {
          }
      }
    return null;
  }
  function Ze(u) {
    var d = u.type;
    switch (u.tag) {
      case 24:
        return "Cache";
      case 9:
        return (d.displayName || "Context") + ".Consumer";
      case 10:
        return (d._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return u = d.render, u = u.displayName || u.name || "", d.displayName || (u !== "" ? "ForwardRef(" + u + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return d;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return Oe(d);
      case 8:
        return d === ve ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof d == "function")
          return d.displayName || d.name || null;
        if (typeof d == "string")
          return d;
    }
    return null;
  }
  function et(u) {
    switch (typeof u) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return u;
      case "object":
        return u;
      default:
        return "";
    }
  }
  function bt(u) {
    var d = u.type;
    return (u = u.nodeName) && u.toLowerCase() === "input" && (d === "checkbox" || d === "radio");
  }
  function rr(u) {
    var d = bt(u) ? "checked" : "value", T = Object.getOwnPropertyDescriptor(u.constructor.prototype, d), k = "" + u[d];
    if (!u.hasOwnProperty(d) && typeof T < "u" && typeof T.get == "function" && typeof T.set == "function") {
      var Q = T.get, ce = T.set;
      return Object.defineProperty(u, d, { configurable: !0, get: function() {
        return Q.call(this);
      }, set: function(ge) {
        k = "" + ge, ce.call(this, ge);
      } }), Object.defineProperty(u, d, { enumerable: T.enumerable }), { getValue: function() {
        return k;
      }, setValue: function(ge) {
        k = "" + ge;
      }, stopTracking: function() {
        u._valueTracker = null, delete u[d];
      } };
    }
  }
  function St(u) {
    u._valueTracker || (u._valueTracker = rr(u));
  }
  function Qe(u) {
    if (!u)
      return !1;
    var d = u._valueTracker;
    if (!d)
      return !0;
    var T = d.getValue(), k = "";
    return u && (k = bt(u) ? u.checked ? "true" : "false" : u.value), u = k, u !== T ? (d.setValue(u), !0) : !1;
  }
  function xt(u) {
    if (u = u || (typeof document < "u" ? document : void 0), typeof u > "u")
      return null;
    try {
      return u.activeElement || u.body;
    } catch {
      return u.body;
    }
  }
  function je(u, d) {
    var T = d.checked;
    return ye({}, d, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: T ?? u._wrapperState.initialChecked });
  }
  function kt(u, d) {
    var T = d.defaultValue == null ? "" : d.defaultValue, k = d.checked != null ? d.checked : d.defaultChecked;
    T = et(d.value != null ? d.value : T), u._wrapperState = { initialChecked: k, initialValue: T, controlled: d.type === "checkbox" || d.type === "radio" ? d.checked != null : d.value != null };
  }
  function cr(u, d) {
    d = d.checked, d != null && N(u, "checked", d, !1);
  }
  function Tr(u, d) {
    cr(u, d);
    var T = et(d.value), k = d.type;
    if (T != null)
      k === "number" ? (T === 0 && u.value === "" || u.value != T) && (u.value = "" + T) : u.value !== "" + T && (u.value = "" + T);
    else if (k === "submit" || k === "reset") {
      u.removeAttribute("value");
      return;
    }
    d.hasOwnProperty("value") ? Hr(u, d.type, T) : d.hasOwnProperty("defaultValue") && Hr(u, d.type, et(d.defaultValue)), d.checked == null && d.defaultChecked != null && (u.defaultChecked = !!d.defaultChecked);
  }
  function Er(u, d, T) {
    if (d.hasOwnProperty("value") || d.hasOwnProperty("defaultValue")) {
      var k = d.type;
      if (!(k !== "submit" && k !== "reset" || d.value !== void 0 && d.value !== null))
        return;
      d = "" + u._wrapperState.initialValue, T || d === u.value || (u.value = d), u.defaultValue = d;
    }
    T = u.name, T !== "" && (u.name = ""), u.defaultChecked = !!u._wrapperState.initialChecked, T !== "" && (u.name = T);
  }
  function Hr(u, d, T) {
    (d !== "number" || xt(u.ownerDocument) !== u) && (T == null ? u.defaultValue = "" + u._wrapperState.initialValue : u.defaultValue !== "" + T && (u.defaultValue = "" + T));
  }
  var Br = Array.isArray;
  function hr(u, d, T, k) {
    if (u = u.options, d) {
      d = {};
      for (var Q = 0; Q < T.length; Q++)
        d["$" + T[Q]] = !0;
      for (T = 0; T < u.length; T++)
        Q = d.hasOwnProperty("$" + u[T].value), u[T].selected !== Q && (u[T].selected = Q), Q && k && (u[T].defaultSelected = !0);
    } else {
      for (T = "" + et(T), d = null, Q = 0; Q < u.length; Q++) {
        if (u[Q].value === T) {
          u[Q].selected = !0, k && (u[Q].defaultSelected = !0);
          return;
        }
        d !== null || u[Q].disabled || (d = u[Q]);
      }
      d !== null && (d.selected = !0);
    }
  }
  function Gr(u, d) {
    if (d.dangerouslySetInnerHTML != null)
      throw Error(n(91));
    return ye({}, d, { value: void 0, defaultValue: void 0, children: "" + u._wrapperState.initialValue });
  }
  function Yr(u, d) {
    var T = d.value;
    if (T == null) {
      if (T = d.children, d = d.defaultValue, T != null) {
        if (d != null)
          throw Error(n(92));
        if (Br(T)) {
          if (1 < T.length)
            throw Error(n(93));
          T = T[0];
        }
        d = T;
      }
      d == null && (d = ""), T = d;
    }
    u._wrapperState = { initialValue: et(T) };
  }
  function tt(u, d) {
    var T = et(d.value), k = et(d.defaultValue);
    T != null && (T = "" + T, T !== u.value && (u.value = T), d.defaultValue == null && u.defaultValue !== T && (u.defaultValue = T)), k != null && (u.defaultValue = "" + k);
  }
  function ar(u) {
    var d = u.textContent;
    d === u._wrapperState.initialValue && d !== "" && d !== null && (u.value = d);
  }
  function wr(u) {
    switch (u) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function Sr(u, d) {
    return u == null || u === "http://www.w3.org/1999/xhtml" ? wr(d) : u === "http://www.w3.org/2000/svg" && d === "foreignObject" ? "http://www.w3.org/1999/xhtml" : u;
  }
  var Ye, Je = function(u) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(d, T, k, Q) {
      MSApp.execUnsafeLocalFunction(function() {
        return u(d, T, k, Q);
      });
    } : u;
  }(function(u, d) {
    if (u.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in u)
      u.innerHTML = d;
    else {
      for (Ye = Ye || document.createElement("div"), Ye.innerHTML = "<svg>" + d.valueOf().toString() + "</svg>", d = Ye.firstChild; u.firstChild; )
        u.removeChild(u.firstChild);
      for (; d.firstChild; )
        u.appendChild(d.firstChild);
    }
  });
  function tr(u, d) {
    if (d) {
      var T = u.firstChild;
      if (T && T === u.lastChild && T.nodeType === 3) {
        T.nodeValue = d;
        return;
      }
    }
    u.textContent = d;
  }
  var pt = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, ir = ["Webkit", "ms", "Moz", "O"];
  Object.keys(pt).forEach(function(u) {
    ir.forEach(function(d) {
      d = d + u.charAt(0).toUpperCase() + u.substring(1), pt[d] = pt[u];
    });
  });
  function nr(u, d, T) {
    return d == null || typeof d == "boolean" || d === "" ? "" : T || typeof d != "number" || d === 0 || pt.hasOwnProperty(u) && pt[u] ? ("" + d).trim() : d + "px";
  }
  function er(u, d) {
    u = u.style;
    for (var T in d)
      if (d.hasOwnProperty(T)) {
        var k = T.indexOf("--") === 0, Q = nr(T, d[T], k);
        T === "float" && (T = "cssFloat"), k ? u.setProperty(T, Q) : u[T] = Q;
      }
  }
  var pr = ye({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
  function kr(u, d) {
    if (d) {
      if (pr[u] && (d.children != null || d.dangerouslySetInnerHTML != null))
        throw Error(n(137, u));
      if (d.dangerouslySetInnerHTML != null) {
        if (d.children != null)
          throw Error(n(60));
        if (typeof d.dangerouslySetInnerHTML != "object" || !("__html" in d.dangerouslySetInnerHTML))
          throw Error(n(61));
      }
      if (d.style != null && typeof d.style != "object")
        throw Error(n(62));
    }
  }
  function Nr(u, d) {
    if (u.indexOf("-") === -1)
      return typeof d.is == "string";
    switch (u) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var hn = null;
  function fn(u) {
    return u = u.target || u.srcElement || window, u.correspondingUseElement && (u = u.correspondingUseElement), u.nodeType === 3 ? u.parentNode : u;
  }
  var uo = null, mn = null, vn = null;
  function mi(u) {
    if (u = Uu(u)) {
      if (typeof uo != "function")
        throw Error(n(280));
      var d = u.stateNode;
      d && (d = Lr(d), uo(u.stateNode, u.type, d));
    }
  }
  function Jo(u) {
    mn ? vn ? vn.push(u) : vn = [u] : mn = u;
  }
  function $i() {
    if (mn) {
      var u = mn, d = vn;
      if (vn = mn = null, mi(u), d)
        for (u = 0; u < d.length; u++)
          mi(d[u]);
    }
  }
  function Ji(u, d) {
    return u(d);
  }
  function Zs() {
  }
  var yi = !1;
  function Zo(u, d, T) {
    if (yi)
      return u(d, T);
    yi = !0;
    try {
      return Ji(u, d, T);
    } finally {
      yi = !1, (mn !== null || vn !== null) && (Zs(), $i());
    }
  }
  function gi(u, d) {
    var T = u.stateNode;
    if (T === null)
      return null;
    var k = Lr(T);
    if (k === null)
      return null;
    T = k[d];
    e:
      switch (d) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          (k = !k.disabled) || (u = u.type, k = !(u === "button" || u === "input" || u === "select" || u === "textarea")), u = !k;
          break e;
        default:
          u = !1;
      }
    if (u)
      return null;
    if (T && typeof T != "function")
      throw Error(n(231, d, typeof T));
    return T;
  }
  var ei = !1;
  if (p)
    try {
      var Ao = {};
      Object.defineProperty(Ao, "passive", { get: function() {
        ei = !0;
      } }), window.addEventListener("test", Ao, Ao), window.removeEventListener("test", Ao, Ao);
    } catch {
      ei = !1;
    }
  function Fn(u, d, T, k, Q, ce, ge, $e, Ne) {
    var Xe = Array.prototype.slice.call(arguments, 3);
    try {
      d.apply(T, Xe);
    } catch (Mt) {
      this.onError(Mt);
    }
  }
  var Gn = !1, Bo = null, $o = !1, Me = null, wt = { onError: function(u) {
    Gn = !0, Bo = u;
  } };
  function ur(u, d, T, k, Q, ce, ge, $e, Ne) {
    Gn = !1, Bo = null, Fn.apply(wt, arguments);
  }
  function jr(u, d, T, k, Q, ce, ge, $e, Ne) {
    if (ur.apply(this, arguments), Gn) {
      if (Gn) {
        var Xe = Bo;
        Gn = !1, Bo = null;
      } else
        throw Error(n(198));
      $o || ($o = !0, Me = Xe);
    }
  }
  function Qr(u) {
    var d = u, T = u;
    if (u.alternate)
      for (; d.return; )
        d = d.return;
    else {
      u = d;
      do
        d = u, d.flags & 4098 && (T = d.return), u = d.return;
      while (u);
    }
    return d.tag === 3 ? T : null;
  }
  function Ir(u) {
    if (u.tag === 13) {
      var d = u.memoizedState;
      if (d === null && (u = u.alternate, u !== null && (d = u.memoizedState)), d !== null)
        return d.dehydrated;
    }
    return null;
  }
  function $r(u) {
    if (Qr(u) !== u)
      throw Error(n(188));
  }
  function Dr(u) {
    var d = u.alternate;
    if (!d) {
      if (d = Qr(u), d === null)
        throw Error(n(188));
      return d !== u ? null : u;
    }
    for (var T = u, k = d; ; ) {
      var Q = T.return;
      if (Q === null)
        break;
      var ce = Q.alternate;
      if (ce === null) {
        if (k = Q.return, k !== null) {
          T = k;
          continue;
        }
        break;
      }
      if (Q.child === ce.child) {
        for (ce = Q.child; ce; ) {
          if (ce === T)
            return $r(Q), u;
          if (ce === k)
            return $r(Q), d;
          ce = ce.sibling;
        }
        throw Error(n(188));
      }
      if (T.return !== k.return)
        T = Q, k = ce;
      else {
        for (var ge = !1, $e = Q.child; $e; ) {
          if ($e === T) {
            ge = !0, T = Q, k = ce;
            break;
          }
          if ($e === k) {
            ge = !0, k = Q, T = ce;
            break;
          }
          $e = $e.sibling;
        }
        if (!ge) {
          for ($e = ce.child; $e; ) {
            if ($e === T) {
              ge = !0, T = ce, k = Q;
              break;
            }
            if ($e === k) {
              ge = !0, k = ce, T = Q;
              break;
            }
            $e = $e.sibling;
          }
          if (!ge)
            throw Error(n(189));
        }
      }
      if (T.alternate !== k)
        throw Error(n(190));
    }
    if (T.tag !== 3)
      throw Error(n(188));
    return T.stateNode.current === T ? u : d;
  }
  function An(u) {
    return u = Dr(u), u !== null ? mr(u) : null;
  }
  function mr(u) {
    if (u.tag === 5 || u.tag === 6)
      return u;
    for (u = u.child; u !== null; ) {
      var d = mr(u);
      if (d !== null)
        return d;
      u = u.sibling;
    }
    return null;
  }
  var on = t.unstable_scheduleCallback, zo = t.unstable_cancelCallback, ea = t.unstable_shouldYield, $c = t.unstable_requestPaint, yn = t.unstable_now, By = t.unstable_getCurrentPriorityLevel, Ps = t.unstable_ImmediatePriority, sn = t.unstable_UserBlockingPriority, ta = t.unstable_NormalPriority, zh = t.unstable_LowPriority, Pf = t.unstable_IdlePriority, Eu = null, Zi = null;
  function Vh(u) {
    if (Zi && typeof Zi.onCommitFiberRoot == "function")
      try {
        Zi.onCommitFiberRoot(Eu, u, void 0, (u.current.flags & 128) === 128);
      } catch {
      }
  }
  var ji = Math.clz32 ? Math.clz32 : zy, Uh = Math.log, Hh = Math.LN2;
  function zy(u) {
    return u >>>= 0, u === 0 ? 32 : 31 - (Uh(u) / Hh | 0) | 0;
  }
  var jc = 64, Sl = 4194304;
  function Oa(u) {
    switch (u & -u) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return u & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return u & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return u;
    }
  }
  function es(u, d) {
    var T = u.pendingLanes;
    if (T === 0)
      return 0;
    var k = 0, Q = u.suspendedLanes, ce = u.pingedLanes, ge = T & 268435455;
    if (ge !== 0) {
      var $e = ge & ~Q;
      $e !== 0 ? k = Oa($e) : (ce &= ge, ce !== 0 && (k = Oa(ce)));
    } else
      ge = T & ~Q, ge !== 0 ? k = Oa(ge) : ce !== 0 && (k = Oa(ce));
    if (k === 0)
      return 0;
    if (d !== 0 && d !== k && !(d & Q) && (Q = k & -k, ce = d & -d, Q >= ce || Q === 16 && (ce & 4194240) !== 0))
      return d;
    if (k & 4 && (k |= T & 16), d = u.entangledLanes, d !== 0)
      for (u = u.entanglements, d &= k; 0 < d; )
        T = 31 - ji(d), Q = 1 << T, k |= u[T], d &= ~Q;
    return k;
  }
  function Rf(u, d) {
    switch (u) {
      case 1:
      case 2:
      case 4:
        return d + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return d + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function Mc(u, d) {
    for (var T = u.suspendedLanes, k = u.pingedLanes, Q = u.expirationTimes, ce = u.pendingLanes; 0 < ce; ) {
      var ge = 31 - ji(ce), $e = 1 << ge, Ne = Q[ge];
      Ne === -1 ? (!($e & T) || $e & k) && (Q[ge] = Rf($e, d)) : Ne <= d && (u.expiredLanes |= $e), ce &= ~$e;
    }
  }
  function _f(u) {
    return u = u.pendingLanes & -1073741825, u !== 0 ? u : u & 1073741824 ? 1073741824 : 0;
  }
  function Nc() {
    var u = jc;
    return jc <<= 1, !(jc & 4194240) && (jc = 64), u;
  }
  function wf(u) {
    for (var d = [], T = 0; 31 > T; T++)
      d.push(u);
    return d;
  }
  function Da(u, d, T) {
    u.pendingLanes |= d, d !== 536870912 && (u.suspendedLanes = 0, u.pingedLanes = 0), u = u.eventTimes, d = 31 - ji(d), u[d] = T;
  }
  function Vy(u, d) {
    var T = u.pendingLanes & ~d;
    u.pendingLanes = d, u.suspendedLanes = 0, u.pingedLanes = 0, u.expiredLanes &= d, u.mutableReadLanes &= d, u.entangledLanes &= d, d = u.entanglements;
    var k = u.eventTimes;
    for (u = u.expirationTimes; 0 < T; ) {
      var Q = 31 - ji(T), ce = 1 << Q;
      d[Q] = 0, k[Q] = -1, u[Q] = -1, T &= ~ce;
    }
  }
  function Cu(u, d) {
    var T = u.entangledLanes |= d;
    for (u = u.entanglements; T; ) {
      var k = 31 - ji(T), Q = 1 << k;
      Q & d | u[k] & d && (u[k] |= d), T &= ~Q;
    }
  }
  var Cn = 0;
  function kf(u) {
    return u &= -u, 1 < u ? 4 < u ? u & 268435455 ? 16 : 536870912 : 4 : 1;
  }
  var Wh, Oc, _n, Gh, Af, en = !1, Su = [], Xn = null, Mi = null, Ni = null, Pu = /* @__PURE__ */ new Map(), ro = /* @__PURE__ */ new Map(), Sn = [], Uy = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function ts(u, d) {
    switch (u) {
      case "focusin":
      case "focusout":
        Xn = null;
        break;
      case "dragenter":
      case "dragleave":
        Mi = null;
        break;
      case "mouseover":
      case "mouseout":
        Ni = null;
        break;
      case "pointerover":
      case "pointerout":
        Pu.delete(d.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        ro.delete(d.pointerId);
    }
  }
  function jo(u, d, T, k, Q, ce) {
    return u === null || u.nativeEvent !== ce ? (u = { blockedOn: d, domEventName: T, eventSystemFlags: k, nativeEvent: ce, targetContainers: [Q] }, d !== null && (d = Uu(d), d !== null && Oc(d)), u) : (u.eventSystemFlags |= k, d = u.targetContainers, Q !== null && d.indexOf(Q) === -1 && d.push(Q), u);
  }
  function ra(u, d, T, k, Q) {
    switch (d) {
      case "focusin":
        return Xn = jo(Xn, u, d, T, k, Q), !0;
      case "dragenter":
        return Mi = jo(Mi, u, d, T, k, Q), !0;
      case "mouseover":
        return Ni = jo(Ni, u, d, T, k, Q), !0;
      case "pointerover":
        var ce = Q.pointerId;
        return Pu.set(ce, jo(Pu.get(ce) || null, u, d, T, k, Q)), !0;
      case "gotpointercapture":
        return ce = Q.pointerId, ro.set(ce, jo(ro.get(ce) || null, u, d, T, k, Q)), !0;
    }
    return !1;
  }
  function Yh(u) {
    var d = Di(u.target);
    if (d !== null) {
      var T = Qr(d);
      if (T !== null) {
        if (d = T.tag, d === 13) {
          if (d = Ir(T), d !== null) {
            u.blockedOn = d, Af(u.priority, function() {
              _n(T);
            });
            return;
          }
        } else if (d === 3 && T.stateNode.current.memoizedState.isDehydrated) {
          u.blockedOn = T.tag === 3 ? T.stateNode.containerInfo : null;
          return;
        }
      }
    }
    u.blockedOn = null;
  }
  function Pl(u) {
    if (u.blockedOn !== null)
      return !1;
    for (var d = u.targetContainers; 0 < d.length; ) {
      var T = Fc(u.domEventName, u.eventSystemFlags, d[0], u.nativeEvent);
      if (T === null) {
        T = u.nativeEvent;
        var k = new T.constructor(T.type, T);
        hn = k, T.target.dispatchEvent(k), hn = null;
      } else
        return d = Uu(T), d !== null && Oc(d), u.blockedOn = T, !1;
      d.shift();
    }
    return !0;
  }
  function $f(u, d, T) {
    Pl(u) && T.delete(d);
  }
  function qh() {
    en = !1, Xn !== null && Pl(Xn) && (Xn = null), Mi !== null && Pl(Mi) && (Mi = null), Ni !== null && Pl(Ni) && (Ni = null), Pu.forEach($f), ro.forEach($f);
  }
  function Ru(u, d) {
    u.blockedOn === d && (u.blockedOn = null, en || (en = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, qh)));
  }
  function _u(u) {
    function d(Q) {
      return Ru(Q, u);
    }
    if (0 < Su.length) {
      Ru(Su[0], u);
      for (var T = 1; T < Su.length; T++) {
        var k = Su[T];
        k.blockedOn === u && (k.blockedOn = null);
      }
    }
    for (Xn !== null && Ru(Xn, u), Mi !== null && Ru(Mi, u), Ni !== null && Ru(Ni, u), Pu.forEach(d), ro.forEach(d), T = 0; T < Sn.length; T++)
      k = Sn[T], k.blockedOn === u && (k.blockedOn = null);
    for (; 0 < Sn.length && (T = Sn[0], T.blockedOn === null); )
      Yh(T), T.blockedOn === null && Sn.shift();
  }
  var Rl = B.ReactCurrentBatchConfig, Ia = !0;
  function Kh(u, d, T, k) {
    var Q = Cn, ce = Rl.transition;
    Rl.transition = null;
    try {
      Cn = 1, Ic(u, d, T, k);
    } finally {
      Cn = Q, Rl.transition = ce;
    }
  }
  function Dc(u, d, T, k) {
    var Q = Cn, ce = Rl.transition;
    Rl.transition = null;
    try {
      Cn = 4, Ic(u, d, T, k);
    } finally {
      Cn = Q, Rl.transition = ce;
    }
  }
  function Ic(u, d, T, k) {
    if (Ia) {
      var Q = Fc(u, d, T, k);
      if (Q === null)
        Xc(u, d, k, wu, T), ts(u, k);
      else if (ra(Q, u, d, T, k))
        k.stopPropagation();
      else if (ts(u, k), d & 4 && -1 < Uy.indexOf(u)) {
        for (; Q !== null; ) {
          var ce = Uu(Q);
          if (ce !== null && Wh(ce), ce = Fc(u, d, T, k), ce === null && Xc(u, d, k, wu, T), ce === Q)
            break;
          Q = ce;
        }
        Q !== null && k.stopPropagation();
      } else
        Xc(u, d, k, null, T);
    }
  }
  var wu = null;
  function Fc(u, d, T, k) {
    if (wu = null, u = fn(k), u = Di(u), u !== null)
      if (d = Qr(u), d === null)
        u = null;
      else if (T = d.tag, T === 13) {
        if (u = Ir(d), u !== null)
          return u;
        u = null;
      } else if (T === 3) {
        if (d.stateNode.current.memoizedState.isDehydrated)
          return d.tag === 3 ? d.stateNode.containerInfo : null;
        u = null;
      } else
        d !== u && (u = null);
    return wu = u, null;
  }
  function jf(u) {
    switch (u) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (By()) {
          case Ps:
            return 1;
          case sn:
            return 4;
          case ta:
          case zh:
            return 16;
          case Pf:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var Rs = null, ku = null, Au = null;
  function Mf() {
    if (Au)
      return Au;
    var u, d = ku, T = d.length, k, Q = "value" in Rs ? Rs.value : Rs.textContent, ce = Q.length;
    for (u = 0; u < T && d[u] === Q[u]; u++)
      ;
    var ge = T - u;
    for (k = 1; k <= ge && d[T - k] === Q[ce - k]; k++)
      ;
    return Au = Q.slice(u, 1 < k ? 1 - k : void 0);
  }
  function _l(u) {
    var d = u.keyCode;
    return "charCode" in u ? (u = u.charCode, u === 0 && d === 13 && (u = 13)) : u = d, u === 10 && (u = 13), 32 <= u || u === 13 ? u : 0;
  }
  function $u() {
    return !0;
  }
  function Xh() {
    return !1;
  }
  function xi(u) {
    function d(T, k, Q, ce, ge) {
      this._reactName = T, this._targetInst = Q, this.type = k, this.nativeEvent = ce, this.target = ge, this.currentTarget = null;
      for (var $e in u)
        u.hasOwnProperty($e) && (T = u[$e], this[$e] = T ? T(ce) : ce[$e]);
      return this.isDefaultPrevented = (ce.defaultPrevented != null ? ce.defaultPrevented : ce.returnValue === !1) ? $u : Xh, this.isPropagationStopped = Xh, this;
    }
    return ye(d.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var T = this.nativeEvent;
      T && (T.preventDefault ? T.preventDefault() : typeof T.returnValue != "unknown" && (T.returnValue = !1), this.isDefaultPrevented = $u);
    }, stopPropagation: function() {
      var T = this.nativeEvent;
      T && (T.stopPropagation ? T.stopPropagation() : typeof T.cancelBubble != "unknown" && (T.cancelBubble = !0), this.isPropagationStopped = $u);
    }, persist: function() {
    }, isPersistent: $u }), d;
  }
  var na = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(u) {
    return u.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, Lc = xi(na), wl = ye({}, na, { view: 0, detail: 0 }), Qh = xi(wl), Bc, Nf, ju, co = ye({}, wl, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: Ff, button: 0, buttons: 0, relatedTarget: function(u) {
    return u.relatedTarget === void 0 ? u.fromElement === u.srcElement ? u.toElement : u.fromElement : u.relatedTarget;
  }, movementX: function(u) {
    return "movementX" in u ? u.movementX : (u !== ju && (ju && u.type === "mousemove" ? (Bc = u.screenX - ju.screenX, Nf = u.screenY - ju.screenY) : Nf = Bc = 0, ju = u), Bc);
  }, movementY: function(u) {
    return "movementY" in u ? u.movementY : Nf;
  } }), zc = xi(co), Jh = ye({}, co, { dataTransfer: 0 }), Zh = xi(Jh), Hy = ye({}, wl, { relatedTarget: 0 }), oa = xi(Hy), Of = ye({}, na, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), em = xi(Of), Wy = ye({}, na, { clipboardData: function(u) {
    return "clipboardData" in u ? u.clipboardData : window.clipboardData;
  } }), Gy = xi(Wy), Yy = ye({}, na, { data: 0 }), Df = xi(Yy), If = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, tm = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, rm = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function nm(u) {
    var d = this.nativeEvent;
    return d.getModifierState ? d.getModifierState(u) : (u = rm[u]) ? !!d[u] : !1;
  }
  function Ff() {
    return nm;
  }
  var _s = ye({}, wl, { key: function(u) {
    if (u.key) {
      var d = If[u.key] || u.key;
      if (d !== "Unidentified")
        return d;
    }
    return u.type === "keypress" ? (u = _l(u), u === 13 ? "Enter" : String.fromCharCode(u)) : u.type === "keydown" || u.type === "keyup" ? tm[u.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: Ff, charCode: function(u) {
    return u.type === "keypress" ? _l(u) : 0;
  }, keyCode: function(u) {
    return u.type === "keydown" || u.type === "keyup" ? u.keyCode : 0;
  }, which: function(u) {
    return u.type === "keypress" ? _l(u) : u.type === "keydown" || u.type === "keyup" ? u.keyCode : 0;
  } }), qy = xi(_s), Lf = ye({}, co, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), Vc = xi(Lf), Bf = ye({}, wl, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: Ff }), Ky = xi(Bf), Uc = ye({}, na, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), om = xi(Uc), ti = ye({}, co, {
    deltaX: function(u) {
      return "deltaX" in u ? u.deltaX : "wheelDeltaX" in u ? -u.wheelDeltaX : 0;
    },
    deltaY: function(u) {
      return "deltaY" in u ? u.deltaY : "wheelDeltaY" in u ? -u.wheelDeltaY : "wheelDelta" in u ? -u.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), ws = xi(ti), Qn = [9, 13, 27, 32], rs = p && "CompositionEvent" in window, Fa = null;
  p && "documentMode" in document && (Fa = document.documentMode);
  var Hc = p && "TextEvent" in window && !Fa, im = p && (!rs || Fa && 8 < Fa && 11 >= Fa), kl = String.fromCharCode(32), sm = !1;
  function am(u, d) {
    switch (u) {
      case "keyup":
        return Qn.indexOf(d.keyCode) !== -1;
      case "keydown":
        return d.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function Wc(u) {
    return u = u.detail, typeof u == "object" && "data" in u ? u.data : null;
  }
  var Al = !1;
  function Xy(u, d) {
    switch (u) {
      case "compositionend":
        return Wc(d);
      case "keypress":
        return d.which !== 32 ? null : (sm = !0, kl);
      case "textInput":
        return u = d.data, u === kl && sm ? null : u;
      default:
        return null;
    }
  }
  function Qy(u, d) {
    if (Al)
      return u === "compositionend" || !rs && am(u, d) ? (u = Mf(), Au = ku = Rs = null, Al = !1, u) : null;
    switch (u) {
      case "paste":
        return null;
      case "keypress":
        if (!(d.ctrlKey || d.altKey || d.metaKey) || d.ctrlKey && d.altKey) {
          if (d.char && 1 < d.char.length)
            return d.char;
          if (d.which)
            return String.fromCharCode(d.which);
        }
        return null;
      case "compositionend":
        return im && d.locale !== "ko" ? null : d.data;
      default:
        return null;
    }
  }
  var lm = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function um(u) {
    var d = u && u.nodeName && u.nodeName.toLowerCase();
    return d === "input" ? !!lm[u.type] : d === "textarea";
  }
  function cm(u, d, T, k) {
    Jo(k), d = Bu(d, "onChange"), 0 < d.length && (T = new Lc("onChange", "change", null, T, k), u.push({ event: T, listeners: d }));
  }
  var Mu = null, $l = null;
  function jl(u) {
    Kc(u, 0);
  }
  function Ml(u) {
    var d = Ol(u);
    if (Qe(d))
      return u;
  }
  function dm(u, d) {
    if (u === "change")
      return d;
  }
  var zf = !1;
  if (p) {
    var Vf;
    if (p) {
      var Uf = "oninput" in document;
      if (!Uf) {
        var fm = document.createElement("div");
        fm.setAttribute("oninput", "return;"), Uf = typeof fm.oninput == "function";
      }
      Vf = Uf;
    } else
      Vf = !1;
    zf = Vf && (!document.documentMode || 9 < document.documentMode);
  }
  function pm() {
    Mu && (Mu.detachEvent("onpropertychange", hm), $l = Mu = null);
  }
  function hm(u) {
    if (u.propertyName === "value" && Ml($l)) {
      var d = [];
      cm(d, $l, u, fn(u)), Zo(jl, d);
    }
  }
  function Jy(u, d, T) {
    u === "focusin" ? (pm(), Mu = d, $l = T, Mu.attachEvent("onpropertychange", hm)) : u === "focusout" && pm();
  }
  function Zy(u) {
    if (u === "selectionchange" || u === "keyup" || u === "keydown")
      return Ml($l);
  }
  function eg(u, d) {
    if (u === "click")
      return Ml(d);
  }
  function mm(u, d) {
    if (u === "input" || u === "change")
      return Ml(d);
  }
  function tg(u, d) {
    return u === d && (u !== 0 || 1 / u === 1 / d) || u !== u && d !== d;
  }
  var Oi = typeof Object.is == "function" ? Object.is : tg;
  function Nu(u, d) {
    if (Oi(u, d))
      return !0;
    if (typeof u != "object" || u === null || typeof d != "object" || d === null)
      return !1;
    var T = Object.keys(u), k = Object.keys(d);
    if (T.length !== k.length)
      return !1;
    for (k = 0; k < T.length; k++) {
      var Q = T[k];
      if (!m.call(d, Q) || !Oi(u[Q], d[Q]))
        return !1;
    }
    return !0;
  }
  function vm(u) {
    for (; u && u.firstChild; )
      u = u.firstChild;
    return u;
  }
  function ym(u, d) {
    var T = vm(u);
    u = 0;
    for (var k; T; ) {
      if (T.nodeType === 3) {
        if (k = u + T.textContent.length, u <= d && k >= d)
          return { node: T, offset: d - u };
        u = k;
      }
      e: {
        for (; T; ) {
          if (T.nextSibling) {
            T = T.nextSibling;
            break e;
          }
          T = T.parentNode;
        }
        T = void 0;
      }
      T = vm(T);
    }
  }
  function gm(u, d) {
    return u && d ? u === d ? !0 : u && u.nodeType === 3 ? !1 : d && d.nodeType === 3 ? gm(u, d.parentNode) : "contains" in u ? u.contains(d) : u.compareDocumentPosition ? !!(u.compareDocumentPosition(d) & 16) : !1 : !1;
  }
  function Gc() {
    for (var u = window, d = xt(); d instanceof u.HTMLIFrameElement; ) {
      try {
        var T = typeof d.contentWindow.location.href == "string";
      } catch {
        T = !1;
      }
      if (T)
        u = d.contentWindow;
      else
        break;
      d = xt(u.document);
    }
    return d;
  }
  function ks(u) {
    var d = u && u.nodeName && u.nodeName.toLowerCase();
    return d && (d === "input" && (u.type === "text" || u.type === "search" || u.type === "tel" || u.type === "url" || u.type === "password") || d === "textarea" || u.contentEditable === "true");
  }
  function Yc(u) {
    var d = Gc(), T = u.focusedElem, k = u.selectionRange;
    if (d !== T && T && T.ownerDocument && gm(T.ownerDocument.documentElement, T)) {
      if (k !== null && ks(T)) {
        if (d = k.start, u = k.end, u === void 0 && (u = d), "selectionStart" in T)
          T.selectionStart = d, T.selectionEnd = Math.min(u, T.value.length);
        else if (u = (d = T.ownerDocument || document) && d.defaultView || window, u.getSelection) {
          u = u.getSelection();
          var Q = T.textContent.length, ce = Math.min(k.start, Q);
          k = k.end === void 0 ? ce : Math.min(k.end, Q), !u.extend && ce > k && (Q = k, k = ce, ce = Q), Q = ym(T, ce);
          var ge = ym(
            T,
            k
          );
          Q && ge && (u.rangeCount !== 1 || u.anchorNode !== Q.node || u.anchorOffset !== Q.offset || u.focusNode !== ge.node || u.focusOffset !== ge.offset) && (d = d.createRange(), d.setStart(Q.node, Q.offset), u.removeAllRanges(), ce > k ? (u.addRange(d), u.extend(ge.node, ge.offset)) : (d.setEnd(ge.node, ge.offset), u.addRange(d)));
        }
      }
      for (d = [], u = T; u = u.parentNode; )
        u.nodeType === 1 && d.push({ element: u, left: u.scrollLeft, top: u.scrollTop });
      for (typeof T.focus == "function" && T.focus(), T = 0; T < d.length; T++)
        u = d[T], u.element.scrollLeft = u.left, u.element.scrollTop = u.top;
    }
  }
  var xm = p && "documentMode" in document && 11 >= document.documentMode, ns = null, Hf = null, Ou = null, Wf = !1;
  function bm(u, d, T) {
    var k = T.window === T ? T.document : T.nodeType === 9 ? T : T.ownerDocument;
    Wf || ns == null || ns !== xt(k) || (k = ns, "selectionStart" in k && ks(k) ? k = { start: k.selectionStart, end: k.selectionEnd } : (k = (k.ownerDocument && k.ownerDocument.defaultView || window).getSelection(), k = { anchorNode: k.anchorNode, anchorOffset: k.anchorOffset, focusNode: k.focusNode, focusOffset: k.focusOffset }), Ou && Nu(Ou, k) || (Ou = k, k = Bu(Hf, "onSelect"), 0 < k.length && (d = new Lc("onSelect", "select", null, d, T), u.push({ event: d, listeners: k }), d.target = ns)));
  }
  function qc(u, d) {
    var T = {};
    return T[u.toLowerCase()] = d.toLowerCase(), T["Webkit" + u] = "webkit" + d, T["Moz" + u] = "moz" + d, T;
  }
  var La = { animationend: qc("Animation", "AnimationEnd"), animationiteration: qc("Animation", "AnimationIteration"), animationstart: qc("Animation", "AnimationStart"), transitionend: qc("Transition", "TransitionEnd") }, Gf = {}, Yf = {};
  p && (Yf = document.createElement("div").style, "AnimationEvent" in window || (delete La.animationend.animation, delete La.animationiteration.animation, delete La.animationstart.animation), "TransitionEvent" in window || delete La.transitionend.transition);
  function fo(u) {
    if (Gf[u])
      return Gf[u];
    if (!La[u])
      return u;
    var d = La[u], T;
    for (T in d)
      if (d.hasOwnProperty(T) && T in Yf)
        return Gf[u] = d[T];
    return u;
  }
  var qf = fo("animationend"), Tm = fo("animationiteration"), Em = fo("animationstart"), Cm = fo("transitionend"), Sm = /* @__PURE__ */ new Map(), Pm = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function As(u, d) {
    Sm.set(u, d), l(d, [u]);
  }
  for (var Du = 0; Du < Pm.length; Du++) {
    var Ba = Pm[Du], rg = Ba.toLowerCase(), Iu = Ba[0].toUpperCase() + Ba.slice(1);
    As(rg, "on" + Iu);
  }
  As(qf, "onAnimationEnd"), As(Tm, "onAnimationIteration"), As(Em, "onAnimationStart"), As("dblclick", "onDoubleClick"), As("focusin", "onFocus"), As("focusout", "onBlur"), As(Cm, "onTransitionEnd"), c("onMouseEnter", ["mouseout", "mouseover"]), c("onMouseLeave", ["mouseout", "mouseover"]), c("onPointerEnter", ["pointerout", "pointerover"]), c("onPointerLeave", ["pointerout", "pointerover"]), l("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), l("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), l("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), l("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), l("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), l("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var Fu = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), ng = new Set("cancel close invalid load scroll toggle".split(" ").concat(Fu));
  function Rm(u, d, T) {
    var k = u.type || "unknown-event";
    u.currentTarget = T, jr(k, d, void 0, u), u.currentTarget = null;
  }
  function Kc(u, d) {
    d = (d & 4) !== 0;
    for (var T = 0; T < u.length; T++) {
      var k = u[T], Q = k.event;
      k = k.listeners;
      e: {
        var ce = void 0;
        if (d)
          for (var ge = k.length - 1; 0 <= ge; ge--) {
            var $e = k[ge], Ne = $e.instance, Xe = $e.currentTarget;
            if ($e = $e.listener, Ne !== ce && Q.isPropagationStopped())
              break e;
            Rm(Q, $e, Xe), ce = Ne;
          }
        else
          for (ge = 0; ge < k.length; ge++) {
            if ($e = k[ge], Ne = $e.instance, Xe = $e.currentTarget, $e = $e.listener, Ne !== ce && Q.isPropagationStopped())
              break e;
            Rm(Q, $e, Xe), ce = Ne;
          }
      }
    }
    if ($o)
      throw u = Me, $o = !1, Me = null, u;
  }
  function wn(u, d) {
    var T = d[tp];
    T === void 0 && (T = d[tp] = /* @__PURE__ */ new Set());
    var k = u + "__bubble";
    T.has(k) || (_m(d, u, 2, !1), T.add(k));
  }
  function ia(u, d, T) {
    var k = 0;
    d && (k |= 4), _m(T, u, k, d);
  }
  var $s = "_reactListening" + Math.random().toString(36).slice(2);
  function Nl(u) {
    if (!u[$s]) {
      u[$s] = !0, o.forEach(function(T) {
        T !== "selectionchange" && (ng.has(T) || ia(T, !1, u), ia(T, !0, u));
      });
      var d = u.nodeType === 9 ? u : u.ownerDocument;
      d === null || d[$s] || (d[$s] = !0, ia("selectionchange", !1, d));
    }
  }
  function _m(u, d, T, k) {
    switch (jf(d)) {
      case 1:
        var Q = Kh;
        break;
      case 4:
        Q = Dc;
        break;
      default:
        Q = Ic;
    }
    T = Q.bind(null, d, T, u), Q = void 0, !ei || d !== "touchstart" && d !== "touchmove" && d !== "wheel" || (Q = !0), k ? Q !== void 0 ? u.addEventListener(d, T, { capture: !0, passive: Q }) : u.addEventListener(d, T, !0) : Q !== void 0 ? u.addEventListener(d, T, { passive: Q }) : u.addEventListener(d, T, !1);
  }
  function Xc(u, d, T, k, Q) {
    var ce = k;
    if (!(d & 1) && !(d & 2) && k !== null)
      e:
        for (; ; ) {
          if (k === null)
            return;
          var ge = k.tag;
          if (ge === 3 || ge === 4) {
            var $e = k.stateNode.containerInfo;
            if ($e === Q || $e.nodeType === 8 && $e.parentNode === Q)
              break;
            if (ge === 4)
              for (ge = k.return; ge !== null; ) {
                var Ne = ge.tag;
                if ((Ne === 3 || Ne === 4) && (Ne = ge.stateNode.containerInfo, Ne === Q || Ne.nodeType === 8 && Ne.parentNode === Q))
                  return;
                ge = ge.return;
              }
            for (; $e !== null; ) {
              if (ge = Di($e), ge === null)
                return;
              if (Ne = ge.tag, Ne === 5 || Ne === 6) {
                k = ce = ge;
                continue e;
              }
              $e = $e.parentNode;
            }
          }
          k = k.return;
        }
    Zo(function() {
      var Xe = ce, Mt = fn(T), or = [];
      e: {
        var At = Sm.get(u);
        if (At !== void 0) {
          var yr = Lc, Pr = u;
          switch (u) {
            case "keypress":
              if (_l(T) === 0)
                break e;
            case "keydown":
            case "keyup":
              yr = qy;
              break;
            case "focusin":
              Pr = "focus", yr = oa;
              break;
            case "focusout":
              Pr = "blur", yr = oa;
              break;
            case "beforeblur":
            case "afterblur":
              yr = oa;
              break;
            case "click":
              if (T.button === 2)
                break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              yr = zc;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              yr = Zh;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              yr = Ky;
              break;
            case qf:
            case Tm:
            case Em:
              yr = em;
              break;
            case Cm:
              yr = om;
              break;
            case "scroll":
              yr = Qh;
              break;
            case "wheel":
              yr = ws;
              break;
            case "copy":
            case "cut":
            case "paste":
              yr = Gy;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              yr = Vc;
          }
          var Ar = (d & 4) !== 0, qn = !Ar && u === "scroll", Ue = Ar ? At !== null ? At + "Capture" : null : At;
          Ar = [];
          for (var Be = Xe, Ge; Be !== null; ) {
            Ge = Be;
            var lr = Ge.stateNode;
            if (Ge.tag === 5 && lr !== null && (Ge = lr, Ue !== null && (lr = gi(Be, Ue), lr != null && Ar.push(Lu(Be, lr, Ge)))), qn)
              break;
            Be = Be.return;
          }
          0 < Ar.length && (At = new yr(At, Pr, null, T, Mt), or.push({ event: At, listeners: Ar }));
        }
      }
      if (!(d & 7)) {
        e: {
          if (At = u === "mouseover" || u === "pointerover", yr = u === "mouseout" || u === "pointerout", At && T !== hn && (Pr = T.relatedTarget || T.fromElement) && (Di(Pr) || Pr[js]))
            break e;
          if ((yr || At) && (At = Mt.window === Mt ? Mt : (At = Mt.ownerDocument) ? At.defaultView || At.parentWindow : window, yr ? (Pr = T.relatedTarget || T.toElement, yr = Xe, Pr = Pr ? Di(Pr) : null, Pr !== null && (qn = Qr(Pr), Pr !== qn || Pr.tag !== 5 && Pr.tag !== 6) && (Pr = null)) : (yr = null, Pr = Xe), yr !== Pr)) {
            if (Ar = zc, lr = "onMouseLeave", Ue = "onMouseEnter", Be = "mouse", (u === "pointerout" || u === "pointerover") && (Ar = Vc, lr = "onPointerLeave", Ue = "onPointerEnter", Be = "pointer"), qn = yr == null ? At : Ol(yr), Ge = Pr == null ? At : Ol(Pr), At = new Ar(lr, Be + "leave", yr, T, Mt), At.target = qn, At.relatedTarget = Ge, lr = null, Di(Mt) === Xe && (Ar = new Ar(Ue, Be + "enter", Pr, T, Mt), Ar.target = Ge, Ar.relatedTarget = qn, lr = Ar), qn = lr, yr && Pr)
              t: {
                for (Ar = yr, Ue = Pr, Be = 0, Ge = Ar; Ge; Ge = za(Ge))
                  Be++;
                for (Ge = 0, lr = Ue; lr; lr = za(lr))
                  Ge++;
                for (; 0 < Be - Ge; )
                  Ar = za(Ar), Be--;
                for (; 0 < Ge - Be; )
                  Ue = za(Ue), Ge--;
                for (; Be--; ) {
                  if (Ar === Ue || Ue !== null && Ar === Ue.alternate)
                    break t;
                  Ar = za(Ar), Ue = za(Ue);
                }
                Ar = null;
              }
            else
              Ar = null;
            yr !== null && Kf(or, At, yr, Ar, !1), Pr !== null && qn !== null && Kf(or, qn, Pr, Ar, !0);
          }
        }
        e: {
          if (At = Xe ? Ol(Xe) : window, yr = At.nodeName && At.nodeName.toLowerCase(), yr === "select" || yr === "input" && At.type === "file")
            var Mr = dm;
          else if (um(At))
            if (zf)
              Mr = mm;
            else {
              Mr = Zy;
              var Rr = Jy;
            }
          else
            (yr = At.nodeName) && yr.toLowerCase() === "input" && (At.type === "checkbox" || At.type === "radio") && (Mr = eg);
          if (Mr && (Mr = Mr(u, Xe))) {
            cm(or, Mr, T, Mt);
            break e;
          }
          Rr && Rr(u, At, Xe), u === "focusout" && (Rr = At._wrapperState) && Rr.controlled && At.type === "number" && Hr(At, "number", At.value);
        }
        switch (Rr = Xe ? Ol(Xe) : window, u) {
          case "focusin":
            (um(Rr) || Rr.contentEditable === "true") && (ns = Rr, Hf = Xe, Ou = null);
            break;
          case "focusout":
            Ou = Hf = ns = null;
            break;
          case "mousedown":
            Wf = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            Wf = !1, bm(or, T, Mt);
            break;
          case "selectionchange":
            if (xm)
              break;
          case "keydown":
          case "keyup":
            bm(or, T, Mt);
        }
        var Fr;
        if (rs)
          e: {
            switch (u) {
              case "compositionstart":
                var Xr = "onCompositionStart";
                break e;
              case "compositionend":
                Xr = "onCompositionEnd";
                break e;
              case "compositionupdate":
                Xr = "onCompositionUpdate";
                break e;
            }
            Xr = void 0;
          }
        else
          Al ? am(u, T) && (Xr = "onCompositionEnd") : u === "keydown" && T.keyCode === 229 && (Xr = "onCompositionStart");
        Xr && (im && T.locale !== "ko" && (Al || Xr !== "onCompositionStart" ? Xr === "onCompositionEnd" && Al && (Fr = Mf()) : (Rs = Mt, ku = "value" in Rs ? Rs.value : Rs.textContent, Al = !0)), Rr = Bu(Xe, Xr), 0 < Rr.length && (Xr = new Df(Xr, u, null, T, Mt), or.push({ event: Xr, listeners: Rr }), Fr ? Xr.data = Fr : (Fr = Wc(T), Fr !== null && (Xr.data = Fr)))), (Fr = Hc ? Xy(u, T) : Qy(u, T)) && (Xe = Bu(Xe, "onBeforeInput"), 0 < Xe.length && (Mt = new Df("onBeforeInput", "beforeinput", null, T, Mt), or.push({ event: Mt, listeners: Xe }), Mt.data = Fr));
      }
      Kc(or, d);
    });
  }
  function Lu(u, d, T) {
    return { instance: u, listener: d, currentTarget: T };
  }
  function Bu(u, d) {
    for (var T = d + "Capture", k = []; u !== null; ) {
      var Q = u, ce = Q.stateNode;
      Q.tag === 5 && ce !== null && (Q = ce, ce = gi(u, T), ce != null && k.unshift(Lu(u, ce, Q)), ce = gi(u, d), ce != null && k.push(Lu(u, ce, Q))), u = u.return;
    }
    return k;
  }
  function za(u) {
    if (u === null)
      return null;
    do
      u = u.return;
    while (u && u.tag !== 5);
    return u || null;
  }
  function Kf(u, d, T, k, Q) {
    for (var ce = d._reactName, ge = []; T !== null && T !== k; ) {
      var $e = T, Ne = $e.alternate, Xe = $e.stateNode;
      if (Ne !== null && Ne === k)
        break;
      $e.tag === 5 && Xe !== null && ($e = Xe, Q ? (Ne = gi(T, ce), Ne != null && ge.unshift(Lu(T, Ne, $e))) : Q || (Ne = gi(T, ce), Ne != null && ge.push(Lu(T, Ne, $e)))), T = T.return;
    }
    ge.length !== 0 && u.push({ event: d, listeners: ge });
  }
  var Xf = /\r\n?/g, og = /\u0000|\uFFFD/g;
  function Qf(u) {
    return (typeof u == "string" ? u : "" + u).replace(Xf, `
`).replace(og, "");
  }
  function Qc(u, d, T) {
    if (d = Qf(d), Qf(u) !== d && T)
      throw Error(n(425));
  }
  function Jc() {
  }
  var Jf = null, Va = null;
  function zu(u, d) {
    return u === "textarea" || u === "noscript" || typeof d.children == "string" || typeof d.children == "number" || typeof d.dangerouslySetInnerHTML == "object" && d.dangerouslySetInnerHTML !== null && d.dangerouslySetInnerHTML.__html != null;
  }
  var Ua = typeof setTimeout == "function" ? setTimeout : void 0, wm = typeof clearTimeout == "function" ? clearTimeout : void 0, Zf = typeof Promise == "function" ? Promise : void 0, ep = typeof queueMicrotask == "function" ? queueMicrotask : typeof Zf < "u" ? function(u) {
    return Zf.resolve(null).then(u).catch(ig);
  } : Ua;
  function ig(u) {
    setTimeout(function() {
      throw u;
    });
  }
  function sa(u, d) {
    var T = d, k = 0;
    do {
      var Q = T.nextSibling;
      if (u.removeChild(T), Q && Q.nodeType === 8)
        if (T = Q.data, T === "/$") {
          if (k === 0) {
            u.removeChild(Q), _u(d);
            return;
          }
          k--;
        } else
          T !== "$" && T !== "$?" && T !== "$!" || k++;
      T = Q;
    } while (T);
    _u(d);
  }
  function os(u) {
    for (; u != null; u = u.nextSibling) {
      var d = u.nodeType;
      if (d === 1 || d === 3)
        break;
      if (d === 8) {
        if (d = u.data, d === "$" || d === "$!" || d === "$?")
          break;
        if (d === "/$")
          return null;
      }
    }
    return u;
  }
  function Vu(u) {
    u = u.previousSibling;
    for (var d = 0; u; ) {
      if (u.nodeType === 8) {
        var T = u.data;
        if (T === "$" || T === "$!" || T === "$?") {
          if (d === 0)
            return u;
          d--;
        } else
          T === "/$" && d++;
      }
      u = u.previousSibling;
    }
    return null;
  }
  var aa = Math.random().toString(36).slice(2), ds = "__reactFiber$" + aa, Ha = "__reactProps$" + aa, js = "__reactContainer$" + aa, tp = "__reactEvents$" + aa, sg = "__reactListeners$" + aa, rp = "__reactHandles$" + aa;
  function Di(u) {
    var d = u[ds];
    if (d)
      return d;
    for (var T = u.parentNode; T; ) {
      if (d = T[js] || T[ds]) {
        if (T = d.alternate, d.child !== null || T !== null && T.child !== null)
          for (u = Vu(u); u !== null; ) {
            if (T = u[ds])
              return T;
            u = Vu(u);
          }
        return d;
      }
      u = T, T = u.parentNode;
    }
    return null;
  }
  function Uu(u) {
    return u = u[ds] || u[js], !u || u.tag !== 5 && u.tag !== 6 && u.tag !== 13 && u.tag !== 3 ? null : u;
  }
  function Ol(u) {
    if (u.tag === 5 || u.tag === 6)
      return u.stateNode;
    throw Error(n(33));
  }
  function Lr(u) {
    return u[Ha] || null;
  }
  var la = [], $n = -1;
  function tn(u) {
    return { current: u };
  }
  function bn(u) {
    0 > $n || (u.current = la[$n], la[$n] = null, $n--);
  }
  function Tn(u, d) {
    $n++, la[$n] = u.current, u.current = d;
  }
  var fs = {}, Kr = tn(fs), Un = tn(!1), ri = fs;
  function Ii(u, d) {
    var T = u.type.contextTypes;
    if (!T)
      return fs;
    var k = u.stateNode;
    if (k && k.__reactInternalMemoizedUnmaskedChildContext === d)
      return k.__reactInternalMemoizedMaskedChildContext;
    var Q = {}, ce;
    for (ce in T)
      Q[ce] = d[ce];
    return k && (u = u.stateNode, u.__reactInternalMemoizedUnmaskedChildContext = d, u.__reactInternalMemoizedMaskedChildContext = Q), Q;
  }
  function Dn(u) {
    return u = u.childContextTypes, u != null;
  }
  function Fi() {
    bn(Un), bn(Kr);
  }
  function ua(u, d, T) {
    if (Kr.current !== fs)
      throw Error(n(168));
    Tn(Kr, d), Tn(Un, T);
  }
  function Hu(u, d, T) {
    var k = u.stateNode;
    if (d = d.childContextTypes, typeof k.getChildContext != "function")
      return T;
    k = k.getChildContext();
    for (var Q in k)
      if (!(Q in d))
        throw Error(n(108, Ze(u) || "Unknown", Q));
    return ye({}, T, k);
  }
  function Zc(u) {
    return u = (u = u.stateNode) && u.__reactInternalMemoizedMergedChildContext || fs, ri = Kr.current, Tn(Kr, u), Tn(Un, Un.current), !0;
  }
  function km(u, d, T) {
    var k = u.stateNode;
    if (!k)
      throw Error(n(169));
    T ? (u = Hu(u, d, ri), k.__reactInternalMemoizedMergedChildContext = u, bn(Un), bn(Kr), Tn(Kr, u)) : bn(Un), Tn(Un, T);
  }
  var bi = null, po = !1, Wu = !1;
  function np(u) {
    bi === null ? bi = [u] : bi.push(u);
  }
  function op(u) {
    po = !0, np(u);
  }
  function ni() {
    if (!Wu && bi !== null) {
      Wu = !0;
      var u = 0, d = Cn;
      try {
        var T = bi;
        for (Cn = 1; u < T.length; u++) {
          var k = T[u];
          do
            k = k(!0);
          while (k !== null);
        }
        bi = null, po = !1;
      } catch (Q) {
        throw bi !== null && (bi = bi.slice(u + 1)), on(Ps, ni), Q;
      } finally {
        Cn = d, Wu = !1;
      }
    }
    return null;
  }
  var ca = [], oi = 0, Wa = null, Dl = 0, ii = [], Mo = 0, Li = null, xo = 1, Ms = "";
  function Ti(u, d) {
    ca[oi++] = Dl, ca[oi++] = Wa, Wa = u, Dl = d;
  }
  function ip(u, d, T) {
    ii[Mo++] = xo, ii[Mo++] = Ms, ii[Mo++] = Li, Li = u;
    var k = xo;
    u = Ms;
    var Q = 32 - ji(k) - 1;
    k &= ~(1 << Q), T += 1;
    var ce = 32 - ji(d) + Q;
    if (30 < ce) {
      var ge = Q - Q % 5;
      ce = (k & (1 << ge) - 1).toString(32), k >>= ge, Q -= ge, xo = 1 << 32 - ji(d) + Q | T << Q | k, Ms = ce + u;
    } else
      xo = 1 << ce | T << Q | k, Ms = u;
  }
  function ed(u) {
    u.return !== null && (Ti(u, 1), ip(u, 1, 0));
  }
  function sp(u) {
    for (; u === Wa; )
      Wa = ca[--oi], ca[oi] = null, Dl = ca[--oi], ca[oi] = null;
    for (; u === Li; )
      Li = ii[--Mo], ii[Mo] = null, Ms = ii[--Mo], ii[Mo] = null, xo = ii[--Mo], ii[Mo] = null;
  }
  var Ei = null, si = null, jn = !1, Bi = null;
  function ap(u, d) {
    var T = Gi(5, null, null, 0);
    T.elementType = "DELETED", T.stateNode = d, T.return = u, d = u.deletions, d === null ? (u.deletions = [T], u.flags |= 16) : d.push(T);
  }
  function Am(u, d) {
    switch (u.tag) {
      case 5:
        var T = u.type;
        return d = d.nodeType !== 1 || T.toLowerCase() !== d.nodeName.toLowerCase() ? null : d, d !== null ? (u.stateNode = d, Ei = u, si = os(d.firstChild), !0) : !1;
      case 6:
        return d = u.pendingProps === "" || d.nodeType !== 3 ? null : d, d !== null ? (u.stateNode = d, Ei = u, si = null, !0) : !1;
      case 13:
        return d = d.nodeType !== 8 ? null : d, d !== null ? (T = Li !== null ? { id: xo, overflow: Ms } : null, u.memoizedState = { dehydrated: d, treeContext: T, retryLane: 1073741824 }, T = Gi(18, null, null, 0), T.stateNode = d, T.return = u, u.child = T, Ei = u, si = null, !0) : !1;
      default:
        return !1;
    }
  }
  function td(u) {
    return (u.mode & 1) !== 0 && (u.flags & 128) === 0;
  }
  function rd(u) {
    if (jn) {
      var d = si;
      if (d) {
        var T = d;
        if (!Am(u, d)) {
          if (td(u))
            throw Error(n(418));
          d = os(T.nextSibling);
          var k = Ei;
          d && Am(u, d) ? ap(k, T) : (u.flags = u.flags & -4097 | 2, jn = !1, Ei = u);
        }
      } else {
        if (td(u))
          throw Error(n(418));
        u.flags = u.flags & -4097 | 2, jn = !1, Ei = u;
      }
    }
  }
  function $m(u) {
    for (u = u.return; u !== null && u.tag !== 5 && u.tag !== 3 && u.tag !== 13; )
      u = u.return;
    Ei = u;
  }
  function nd(u) {
    if (u !== Ei)
      return !1;
    if (!jn)
      return $m(u), jn = !0, !1;
    var d;
    if ((d = u.tag !== 3) && !(d = u.tag !== 5) && (d = u.type, d = d !== "head" && d !== "body" && !zu(u.type, u.memoizedProps)), d && (d = si)) {
      if (td(u))
        throw jm(), Error(n(418));
      for (; d; )
        ap(u, d), d = os(d.nextSibling);
    }
    if ($m(u), u.tag === 13) {
      if (u = u.memoizedState, u = u !== null ? u.dehydrated : null, !u)
        throw Error(n(317));
      e: {
        for (u = u.nextSibling, d = 0; u; ) {
          if (u.nodeType === 8) {
            var T = u.data;
            if (T === "/$") {
              if (d === 0) {
                si = os(u.nextSibling);
                break e;
              }
              d--;
            } else
              T !== "$" && T !== "$!" && T !== "$?" || d++;
          }
          u = u.nextSibling;
        }
        si = null;
      }
    } else
      si = Ei ? os(u.stateNode.nextSibling) : null;
    return !0;
  }
  function jm() {
    for (var u = si; u; )
      u = os(u.nextSibling);
  }
  function Ln() {
    si = Ei = null, jn = !1;
  }
  function lp(u) {
    Bi === null ? Bi = [u] : Bi.push(u);
  }
  var od = B.ReactCurrentBatchConfig;
  function Ci(u, d) {
    if (u && u.defaultProps) {
      d = ye({}, d), u = u.defaultProps;
      for (var T in u)
        d[T] === void 0 && (d[T] = u[T]);
      return d;
    }
    return d;
  }
  var ps = tn(null), id = null, da = null, up = null;
  function cp() {
    up = da = id = null;
  }
  function fa(u) {
    var d = ps.current;
    bn(ps), u._currentValue = d;
  }
  function ho(u, d, T) {
    for (; u !== null; ) {
      var k = u.alternate;
      if ((u.childLanes & d) !== d ? (u.childLanes |= d, k !== null && (k.childLanes |= d)) : k !== null && (k.childLanes & d) !== d && (k.childLanes |= d), u === T)
        break;
      u = u.return;
    }
  }
  function dr(u, d) {
    id = u, up = da = null, u = u.dependencies, u !== null && u.firstContext !== null && (u.lanes & d && (Jn = !0), u.firstContext = null);
  }
  function Yn(u) {
    var d = u._currentValue;
    if (up !== u)
      if (u = { context: u, memoizedValue: d, next: null }, da === null) {
        if (id === null)
          throw Error(n(308));
        da = u, id.dependencies = { lanes: 0, firstContext: u };
      } else
        da = da.next = u;
    return d;
  }
  var bo = null;
  function dp(u) {
    bo === null ? bo = [u] : bo.push(u);
  }
  function Mm(u, d, T, k) {
    var Q = d.interleaved;
    return Q === null ? (T.next = T, dp(d)) : (T.next = Q.next, Q.next = T), d.interleaved = T, Ns(u, k);
  }
  function Ns(u, d) {
    u.lanes |= d;
    var T = u.alternate;
    for (T !== null && (T.lanes |= d), T = u, u = u.return; u !== null; )
      u.childLanes |= d, T = u.alternate, T !== null && (T.childLanes |= d), T = u, u = u.return;
    return T.tag === 3 ? T.stateNode : null;
  }
  var pa = !1;
  function fp(u) {
    u.updateQueue = { baseState: u.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
  }
  function no(u, d) {
    u = u.updateQueue, d.updateQueue === u && (d.updateQueue = { baseState: u.baseState, firstBaseUpdate: u.firstBaseUpdate, lastBaseUpdate: u.lastBaseUpdate, shared: u.shared, effects: u.effects });
  }
  function Os(u, d) {
    return { eventTime: u, lane: d, tag: 0, payload: null, callback: null, next: null };
  }
  function ha(u, d, T) {
    var k = u.updateQueue;
    if (k === null)
      return null;
    if (k = k.shared, an & 2) {
      var Q = k.pending;
      return Q === null ? d.next = d : (d.next = Q.next, Q.next = d), k.pending = d, Ns(u, T);
    }
    return Q = k.interleaved, Q === null ? (d.next = d, dp(k)) : (d.next = Q.next, Q.next = d), k.interleaved = d, Ns(u, T);
  }
  function sd(u, d, T) {
    if (d = d.updateQueue, d !== null && (d = d.shared, (T & 4194240) !== 0)) {
      var k = d.lanes;
      k &= u.pendingLanes, T |= k, d.lanes = T, Cu(u, T);
    }
  }
  function pp(u, d) {
    var T = u.updateQueue, k = u.alternate;
    if (k !== null && (k = k.updateQueue, T === k)) {
      var Q = null, ce = null;
      if (T = T.firstBaseUpdate, T !== null) {
        do {
          var ge = { eventTime: T.eventTime, lane: T.lane, tag: T.tag, payload: T.payload, callback: T.callback, next: null };
          ce === null ? Q = ce = ge : ce = ce.next = ge, T = T.next;
        } while (T !== null);
        ce === null ? Q = ce = d : ce = ce.next = d;
      } else
        Q = ce = d;
      T = { baseState: k.baseState, firstBaseUpdate: Q, lastBaseUpdate: ce, shared: k.shared, effects: k.effects }, u.updateQueue = T;
      return;
    }
    u = T.lastBaseUpdate, u === null ? T.firstBaseUpdate = d : u.next = d, T.lastBaseUpdate = d;
  }
  function ma(u, d, T, k) {
    var Q = u.updateQueue;
    pa = !1;
    var ce = Q.firstBaseUpdate, ge = Q.lastBaseUpdate, $e = Q.shared.pending;
    if ($e !== null) {
      Q.shared.pending = null;
      var Ne = $e, Xe = Ne.next;
      Ne.next = null, ge === null ? ce = Xe : ge.next = Xe, ge = Ne;
      var Mt = u.alternate;
      Mt !== null && (Mt = Mt.updateQueue, $e = Mt.lastBaseUpdate, $e !== ge && ($e === null ? Mt.firstBaseUpdate = Xe : $e.next = Xe, Mt.lastBaseUpdate = Ne));
    }
    if (ce !== null) {
      var or = Q.baseState;
      ge = 0, Mt = Xe = Ne = null, $e = ce;
      do {
        var At = $e.lane, yr = $e.eventTime;
        if ((k & At) === At) {
          Mt !== null && (Mt = Mt.next = {
            eventTime: yr,
            lane: 0,
            tag: $e.tag,
            payload: $e.payload,
            callback: $e.callback,
            next: null
          });
          e: {
            var Pr = u, Ar = $e;
            switch (At = d, yr = T, Ar.tag) {
              case 1:
                if (Pr = Ar.payload, typeof Pr == "function") {
                  or = Pr.call(yr, or, At);
                  break e;
                }
                or = Pr;
                break e;
              case 3:
                Pr.flags = Pr.flags & -65537 | 128;
              case 0:
                if (Pr = Ar.payload, At = typeof Pr == "function" ? Pr.call(yr, or, At) : Pr, At == null)
                  break e;
                or = ye({}, or, At);
                break e;
              case 2:
                pa = !0;
            }
          }
          $e.callback !== null && $e.lane !== 0 && (u.flags |= 64, At = Q.effects, At === null ? Q.effects = [$e] : At.push($e));
        } else
          yr = { eventTime: yr, lane: At, tag: $e.tag, payload: $e.payload, callback: $e.callback, next: null }, Mt === null ? (Xe = Mt = yr, Ne = or) : Mt = Mt.next = yr, ge |= At;
        if ($e = $e.next, $e === null) {
          if ($e = Q.shared.pending, $e === null)
            break;
          At = $e, $e = At.next, At.next = null, Q.lastBaseUpdate = At, Q.shared.pending = null;
        }
      } while (1);
      if (Mt === null && (Ne = or), Q.baseState = Ne, Q.firstBaseUpdate = Xe, Q.lastBaseUpdate = Mt, d = Q.shared.interleaved, d !== null) {
        Q = d;
        do
          ge |= Q.lane, Q = Q.next;
        while (Q !== d);
      } else
        ce === null && (Q.shared.lanes = 0);
      Ls |= ge, u.lanes = ge, u.memoizedState = or;
    }
  }
  function Ga(u, d, T) {
    if (u = d.effects, d.effects = null, u !== null)
      for (d = 0; d < u.length; d++) {
        var k = u[d], Q = k.callback;
        if (Q !== null) {
          if (k.callback = null, k = T, typeof Q != "function")
            throw Error(n(191, Q));
          Q.call(k);
        }
      }
  }
  var Nm = new e.Component().refs;
  function hp(u, d, T, k) {
    d = u.memoizedState, T = T(k, d), T = T == null ? d : ye({}, d, T), u.memoizedState = T, u.lanes === 0 && (u.updateQueue.baseState = T);
  }
  var ad = { isMounted: function(u) {
    return (u = u._reactInternals) ? Qr(u) === u : !1;
  }, enqueueSetState: function(u, d, T) {
    u = u._reactInternals;
    var k = Io(), Q = Zn(u), ce = Os(k, Q);
    ce.payload = d, T != null && (ce.callback = T), d = ha(u, ce, Q), d !== null && (Fo(d, u, Q, k), sd(d, u, Q));
  }, enqueueReplaceState: function(u, d, T) {
    u = u._reactInternals;
    var k = Io(), Q = Zn(u), ce = Os(k, Q);
    ce.tag = 1, ce.payload = d, T != null && (ce.callback = T), d = ha(u, ce, Q), d !== null && (Fo(d, u, Q, k), sd(d, u, Q));
  }, enqueueForceUpdate: function(u, d) {
    u = u._reactInternals;
    var T = Io(), k = Zn(u), Q = Os(T, k);
    Q.tag = 2, d != null && (Q.callback = d), d = ha(u, Q, k), d !== null && (Fo(d, u, k, T), sd(d, u, k));
  } };
  function Om(u, d, T, k, Q, ce, ge) {
    return u = u.stateNode, typeof u.shouldComponentUpdate == "function" ? u.shouldComponentUpdate(k, ce, ge) : d.prototype && d.prototype.isPureReactComponent ? !Nu(T, k) || !Nu(Q, ce) : !0;
  }
  function Dm(u, d, T) {
    var k = !1, Q = fs, ce = d.contextType;
    return typeof ce == "object" && ce !== null ? ce = Yn(ce) : (Q = Dn(d) ? ri : Kr.current, k = d.contextTypes, ce = (k = k != null) ? Ii(u, Q) : fs), d = new d(T, ce), u.memoizedState = d.state !== null && d.state !== void 0 ? d.state : null, d.updater = ad, u.stateNode = d, d._reactInternals = u, k && (u = u.stateNode, u.__reactInternalMemoizedUnmaskedChildContext = Q, u.__reactInternalMemoizedMaskedChildContext = ce), d;
  }
  function Im(u, d, T, k) {
    u = d.state, typeof d.componentWillReceiveProps == "function" && d.componentWillReceiveProps(T, k), typeof d.UNSAFE_componentWillReceiveProps == "function" && d.UNSAFE_componentWillReceiveProps(T, k), d.state !== u && ad.enqueueReplaceState(d, d.state, null);
  }
  function ld(u, d, T, k) {
    var Q = u.stateNode;
    Q.props = T, Q.state = u.memoizedState, Q.refs = Nm, fp(u);
    var ce = d.contextType;
    typeof ce == "object" && ce !== null ? Q.context = Yn(ce) : (ce = Dn(d) ? ri : Kr.current, Q.context = Ii(u, ce)), Q.state = u.memoizedState, ce = d.getDerivedStateFromProps, typeof ce == "function" && (hp(u, d, ce, T), Q.state = u.memoizedState), typeof d.getDerivedStateFromProps == "function" || typeof Q.getSnapshotBeforeUpdate == "function" || typeof Q.UNSAFE_componentWillMount != "function" && typeof Q.componentWillMount != "function" || (d = Q.state, typeof Q.componentWillMount == "function" && Q.componentWillMount(), typeof Q.UNSAFE_componentWillMount == "function" && Q.UNSAFE_componentWillMount(), d !== Q.state && ad.enqueueReplaceState(Q, Q.state, null), ma(u, T, Q, k), Q.state = u.memoizedState), typeof Q.componentDidMount == "function" && (u.flags |= 4194308);
  }
  function Il(u, d, T) {
    if (u = T.ref, u !== null && typeof u != "function" && typeof u != "object") {
      if (T._owner) {
        if (T = T._owner, T) {
          if (T.tag !== 1)
            throw Error(n(309));
          var k = T.stateNode;
        }
        if (!k)
          throw Error(n(147, u));
        var Q = k, ce = "" + u;
        return d !== null && d.ref !== null && typeof d.ref == "function" && d.ref._stringRef === ce ? d.ref : (d = function(ge) {
          var $e = Q.refs;
          $e === Nm && ($e = Q.refs = {}), ge === null ? delete $e[ce] : $e[ce] = ge;
        }, d._stringRef = ce, d);
      }
      if (typeof u != "string")
        throw Error(n(284));
      if (!T._owner)
        throw Error(n(290, u));
    }
    return u;
  }
  function ud(u, d) {
    throw u = Object.prototype.toString.call(d), Error(n(31, u === "[object Object]" ? "object with keys {" + Object.keys(d).join(", ") + "}" : u));
  }
  function Fm(u) {
    var d = u._init;
    return d(u._payload);
  }
  function Lm(u) {
    function d(Ue, Be) {
      if (u) {
        var Ge = Ue.deletions;
        Ge === null ? (Ue.deletions = [Be], Ue.flags |= 16) : Ge.push(Be);
      }
    }
    function T(Ue, Be) {
      if (!u)
        return null;
      for (; Be !== null; )
        d(Ue, Be), Be = Be.sibling;
      return null;
    }
    function k(Ue, Be) {
      for (Ue = /* @__PURE__ */ new Map(); Be !== null; )
        Be.key !== null ? Ue.set(Be.key, Be) : Ue.set(Be.index, Be), Be = Be.sibling;
      return Ue;
    }
    function Q(Ue, Be) {
      return Ue = Ca(Ue, Be), Ue.index = 0, Ue.sibling = null, Ue;
    }
    function ce(Ue, Be, Ge) {
      return Ue.index = Ge, u ? (Ge = Ue.alternate, Ge !== null ? (Ge = Ge.index, Ge < Be ? (Ue.flags |= 2, Be) : Ge) : (Ue.flags |= 2, Be)) : (Ue.flags |= 1048576, Be);
    }
    function ge(Ue) {
      return u && Ue.alternate === null && (Ue.flags |= 2), Ue;
    }
    function $e(Ue, Be, Ge, lr) {
      return Be === null || Be.tag !== 6 ? (Be = cc(Ge, Ue.mode, lr), Be.return = Ue, Be) : (Be = Q(Be, Ge), Be.return = Ue, Be);
    }
    function Ne(Ue, Be, Ge, lr) {
      var Mr = Ge.type;
      return Mr === de ? Mt(Ue, Be, Ge.props.children, lr, Ge.key) : Be !== null && (Be.elementType === Mr || typeof Mr == "object" && Mr !== null && Mr.$$typeof === he && Fm(Mr) === Be.type) ? (lr = Q(Be, Ge.props), lr.ref = Il(Ue, Be, Ge), lr.return = Ue, lr) : (lr = zd(Ge.type, Ge.key, Ge.props, null, Ue.mode, lr), lr.ref = Il(Ue, Be, Ge), lr.return = Ue, lr);
    }
    function Xe(Ue, Be, Ge, lr) {
      return Be === null || Be.tag !== 4 || Be.stateNode.containerInfo !== Ge.containerInfo || Be.stateNode.implementation !== Ge.implementation ? (Be = dl(Ge, Ue.mode, lr), Be.return = Ue, Be) : (Be = Q(Be, Ge.children || []), Be.return = Ue, Be);
    }
    function Mt(Ue, Be, Ge, lr, Mr) {
      return Be === null || Be.tag !== 7 ? (Be = cl(Ge, Ue.mode, lr, Mr), Be.return = Ue, Be) : (Be = Q(Be, Ge), Be.return = Ue, Be);
    }
    function or(Ue, Be, Ge) {
      if (typeof Be == "string" && Be !== "" || typeof Be == "number")
        return Be = cc("" + Be, Ue.mode, Ge), Be.return = Ue, Be;
      if (typeof Be == "object" && Be !== null) {
        switch (Be.$$typeof) {
          case K:
            return Ge = zd(Be.type, Be.key, Be.props, null, Ue.mode, Ge), Ge.ref = Il(Ue, null, Be), Ge.return = Ue, Ge;
          case ue:
            return Be = dl(Be, Ue.mode, Ge), Be.return = Ue, Be;
          case he:
            var lr = Be._init;
            return or(Ue, lr(Be._payload), Ge);
        }
        if (Br(Be) || fe(Be))
          return Be = cl(Be, Ue.mode, Ge, null), Be.return = Ue, Be;
        ud(Ue, Be);
      }
      return null;
    }
    function At(Ue, Be, Ge, lr) {
      var Mr = Be !== null ? Be.key : null;
      if (typeof Ge == "string" && Ge !== "" || typeof Ge == "number")
        return Mr !== null ? null : $e(Ue, Be, "" + Ge, lr);
      if (typeof Ge == "object" && Ge !== null) {
        switch (Ge.$$typeof) {
          case K:
            return Ge.key === Mr ? Ne(Ue, Be, Ge, lr) : null;
          case ue:
            return Ge.key === Mr ? Xe(Ue, Be, Ge, lr) : null;
          case he:
            return Mr = Ge._init, At(
              Ue,
              Be,
              Mr(Ge._payload),
              lr
            );
        }
        if (Br(Ge) || fe(Ge))
          return Mr !== null ? null : Mt(Ue, Be, Ge, lr, null);
        ud(Ue, Ge);
      }
      return null;
    }
    function yr(Ue, Be, Ge, lr, Mr) {
      if (typeof lr == "string" && lr !== "" || typeof lr == "number")
        return Ue = Ue.get(Ge) || null, $e(Be, Ue, "" + lr, Mr);
      if (typeof lr == "object" && lr !== null) {
        switch (lr.$$typeof) {
          case K:
            return Ue = Ue.get(lr.key === null ? Ge : lr.key) || null, Ne(Be, Ue, lr, Mr);
          case ue:
            return Ue = Ue.get(lr.key === null ? Ge : lr.key) || null, Xe(Be, Ue, lr, Mr);
          case he:
            var Rr = lr._init;
            return yr(Ue, Be, Ge, Rr(lr._payload), Mr);
        }
        if (Br(lr) || fe(lr))
          return Ue = Ue.get(Ge) || null, Mt(Be, Ue, lr, Mr, null);
        ud(Be, lr);
      }
      return null;
    }
    function Pr(Ue, Be, Ge, lr) {
      for (var Mr = null, Rr = null, Fr = Be, Xr = Be = 0, yo = null; Fr !== null && Xr < Ge.length; Xr++) {
        Fr.index > Xr ? (yo = Fr, Fr = null) : yo = Fr.sibling;
        var pn = At(Ue, Fr, Ge[Xr], lr);
        if (pn === null) {
          Fr === null && (Fr = yo);
          break;
        }
        u && Fr && pn.alternate === null && d(Ue, Fr), Be = ce(pn, Be, Xr), Rr === null ? Mr = pn : Rr.sibling = pn, Rr = pn, Fr = yo;
      }
      if (Xr === Ge.length)
        return T(Ue, Fr), jn && Ti(Ue, Xr), Mr;
      if (Fr === null) {
        for (; Xr < Ge.length; Xr++)
          Fr = or(Ue, Ge[Xr], lr), Fr !== null && (Be = ce(Fr, Be, Xr), Rr === null ? Mr = Fr : Rr.sibling = Fr, Rr = Fr);
        return jn && Ti(Ue, Xr), Mr;
      }
      for (Fr = k(Ue, Fr); Xr < Ge.length; Xr++)
        yo = yr(Fr, Ue, Xr, Ge[Xr], lr), yo !== null && (u && yo.alternate !== null && Fr.delete(yo.key === null ? Xr : yo.key), Be = ce(yo, Be, Xr), Rr === null ? Mr = yo : Rr.sibling = yo, Rr = yo);
      return u && Fr.forEach(function(Sa) {
        return d(Ue, Sa);
      }), jn && Ti(Ue, Xr), Mr;
    }
    function Ar(Ue, Be, Ge, lr) {
      var Mr = fe(Ge);
      if (typeof Mr != "function")
        throw Error(n(150));
      if (Ge = Mr.call(Ge), Ge == null)
        throw Error(n(151));
      for (var Rr = Mr = null, Fr = Be, Xr = Be = 0, yo = null, pn = Ge.next(); Fr !== null && !pn.done; Xr++, pn = Ge.next()) {
        Fr.index > Xr ? (yo = Fr, Fr = null) : yo = Fr.sibling;
        var Sa = At(Ue, Fr, pn.value, lr);
        if (Sa === null) {
          Fr === null && (Fr = yo);
          break;
        }
        u && Fr && Sa.alternate === null && d(Ue, Fr), Be = ce(Sa, Be, Xr), Rr === null ? Mr = Sa : Rr.sibling = Sa, Rr = Sa, Fr = yo;
      }
      if (pn.done)
        return T(
          Ue,
          Fr
        ), jn && Ti(Ue, Xr), Mr;
      if (Fr === null) {
        for (; !pn.done; Xr++, pn = Ge.next())
          pn = or(Ue, pn.value, lr), pn !== null && (Be = ce(pn, Be, Xr), Rr === null ? Mr = pn : Rr.sibling = pn, Rr = pn);
        return jn && Ti(Ue, Xr), Mr;
      }
      for (Fr = k(Ue, Fr); !pn.done; Xr++, pn = Ge.next())
        pn = yr(Fr, Ue, Xr, pn.value, lr), pn !== null && (u && pn.alternate !== null && Fr.delete(pn.key === null ? Xr : pn.key), Be = ce(pn, Be, Xr), Rr === null ? Mr = pn : Rr.sibling = pn, Rr = pn);
      return u && Fr.forEach(function(Rg) {
        return d(Ue, Rg);
      }), jn && Ti(Ue, Xr), Mr;
    }
    function qn(Ue, Be, Ge, lr) {
      if (typeof Ge == "object" && Ge !== null && Ge.type === de && Ge.key === null && (Ge = Ge.props.children), typeof Ge == "object" && Ge !== null) {
        switch (Ge.$$typeof) {
          case K:
            e: {
              for (var Mr = Ge.key, Rr = Be; Rr !== null; ) {
                if (Rr.key === Mr) {
                  if (Mr = Ge.type, Mr === de) {
                    if (Rr.tag === 7) {
                      T(Ue, Rr.sibling), Be = Q(Rr, Ge.props.children), Be.return = Ue, Ue = Be;
                      break e;
                    }
                  } else if (Rr.elementType === Mr || typeof Mr == "object" && Mr !== null && Mr.$$typeof === he && Fm(Mr) === Rr.type) {
                    T(Ue, Rr.sibling), Be = Q(Rr, Ge.props), Be.ref = Il(Ue, Rr, Ge), Be.return = Ue, Ue = Be;
                    break e;
                  }
                  T(Ue, Rr);
                  break;
                } else
                  d(Ue, Rr);
                Rr = Rr.sibling;
              }
              Ge.type === de ? (Be = cl(Ge.props.children, Ue.mode, lr, Ge.key), Be.return = Ue, Ue = Be) : (lr = zd(Ge.type, Ge.key, Ge.props, null, Ue.mode, lr), lr.ref = Il(Ue, Be, Ge), lr.return = Ue, Ue = lr);
            }
            return ge(Ue);
          case ue:
            e: {
              for (Rr = Ge.key; Be !== null; ) {
                if (Be.key === Rr)
                  if (Be.tag === 4 && Be.stateNode.containerInfo === Ge.containerInfo && Be.stateNode.implementation === Ge.implementation) {
                    T(Ue, Be.sibling), Be = Q(Be, Ge.children || []), Be.return = Ue, Ue = Be;
                    break e;
                  } else {
                    T(Ue, Be);
                    break;
                  }
                else
                  d(Ue, Be);
                Be = Be.sibling;
              }
              Be = dl(Ge, Ue.mode, lr), Be.return = Ue, Ue = Be;
            }
            return ge(Ue);
          case he:
            return Rr = Ge._init, qn(Ue, Be, Rr(Ge._payload), lr);
        }
        if (Br(Ge))
          return Pr(Ue, Be, Ge, lr);
        if (fe(Ge))
          return Ar(Ue, Be, Ge, lr);
        ud(Ue, Ge);
      }
      return typeof Ge == "string" && Ge !== "" || typeof Ge == "number" ? (Ge = "" + Ge, Be !== null && Be.tag === 6 ? (T(Ue, Be.sibling), Be = Q(Be, Ge), Be.return = Ue, Ue = Be) : (T(Ue, Be), Be = cc(Ge, Ue.mode, lr), Be.return = Ue, Ue = Be), ge(Ue)) : T(Ue, Be);
    }
    return qn;
  }
  var Fl = Lm(!0), Bm = Lm(!1), Gu = {}, is = tn(Gu), Yu = tn(Gu), Ll = tn(Gu);
  function Ya(u) {
    if (u === Gu)
      throw Error(n(174));
    return u;
  }
  function mp(u, d) {
    switch (Tn(Ll, d), Tn(Yu, u), Tn(is, Gu), u = d.nodeType, u) {
      case 9:
      case 11:
        d = (d = d.documentElement) ? d.namespaceURI : Sr(null, "");
        break;
      default:
        u = u === 8 ? d.parentNode : d, d = u.namespaceURI || null, u = u.tagName, d = Sr(d, u);
    }
    bn(is), Tn(is, d);
  }
  function va() {
    bn(is), bn(Yu), bn(Ll);
  }
  function Vr(u) {
    Ya(Ll.current);
    var d = Ya(is.current), T = Sr(d, u.type);
    d !== T && (Tn(Yu, u), Tn(is, T));
  }
  function nn(u) {
    Yu.current === u && (bn(is), bn(Yu));
  }
  var Ur = tn(0);
  function Bn(u) {
    for (var d = u; d !== null; ) {
      if (d.tag === 13) {
        var T = d.memoizedState;
        if (T !== null && (T = T.dehydrated, T === null || T.data === "$?" || T.data === "$!"))
          return d;
      } else if (d.tag === 19 && d.memoizedProps.revealOrder !== void 0) {
        if (d.flags & 128)
          return d;
      } else if (d.child !== null) {
        d.child.return = d, d = d.child;
        continue;
      }
      if (d === u)
        break;
      for (; d.sibling === null; ) {
        if (d.return === null || d.return === u)
          return null;
        d = d.return;
      }
      d.sibling.return = d.return, d = d.sibling;
    }
    return null;
  }
  var zi = [];
  function cd() {
    for (var u = 0; u < zi.length; u++)
      zi[u]._workInProgressVersionPrimary = null;
    zi.length = 0;
  }
  var dd = B.ReactCurrentDispatcher, vp = B.ReactCurrentBatchConfig, qa = 0, Mn = null, mt = null, un = null, Wr = !1, hs = !1, Si = 0, Ka = 0;
  function Nn() {
    throw Error(n(321));
  }
  function Xa(u, d) {
    if (d === null)
      return !1;
    for (var T = 0; T < d.length && T < u.length; T++)
      if (!Oi(u[T], d[T]))
        return !1;
    return !0;
  }
  function ya(u, d, T, k, Q, ce) {
    if (qa = ce, Mn = d, d.memoizedState = null, d.updateQueue = null, d.lanes = 0, dd.current = u === null || u.memoizedState === null ? lg : ug, u = T(k, Q), hs) {
      ce = 0;
      do {
        if (hs = !1, Si = 0, 25 <= ce)
          throw Error(n(301));
        ce += 1, un = mt = null, d.updateQueue = null, dd.current = gp, u = T(k, Q);
      } while (hs);
    }
    if (dd.current = _d, d = mt !== null && mt.next !== null, qa = 0, un = mt = Mn = null, Wr = !1, d)
      throw Error(n(300));
    return u;
  }
  function Qa() {
    var u = Si !== 0;
    return Si = 0, u;
  }
  function Vi() {
    var u = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return un === null ? Mn.memoizedState = un = u : un = un.next = u, un;
  }
  function ai() {
    if (mt === null) {
      var u = Mn.alternate;
      u = u !== null ? u.memoizedState : null;
    } else
      u = mt.next;
    var d = un === null ? Mn.memoizedState : un.next;
    if (d !== null)
      un = d, mt = u;
    else {
      if (u === null)
        throw Error(n(310));
      mt = u, u = { memoizedState: mt.memoizedState, baseState: mt.baseState, baseQueue: mt.baseQueue, queue: mt.queue, next: null }, un === null ? Mn.memoizedState = un = u : un = un.next = u;
    }
    return un;
  }
  function Ja(u, d) {
    return typeof d == "function" ? d(u) : d;
  }
  function qu(u) {
    var d = ai(), T = d.queue;
    if (T === null)
      throw Error(n(311));
    T.lastRenderedReducer = u;
    var k = mt, Q = k.baseQueue, ce = T.pending;
    if (ce !== null) {
      if (Q !== null) {
        var ge = Q.next;
        Q.next = ce.next, ce.next = ge;
      }
      k.baseQueue = Q = ce, T.pending = null;
    }
    if (Q !== null) {
      ce = Q.next, k = k.baseState;
      var $e = ge = null, Ne = null, Xe = ce;
      do {
        var Mt = Xe.lane;
        if ((qa & Mt) === Mt)
          Ne !== null && (Ne = Ne.next = { lane: 0, action: Xe.action, hasEagerState: Xe.hasEagerState, eagerState: Xe.eagerState, next: null }), k = Xe.hasEagerState ? Xe.eagerState : u(k, Xe.action);
        else {
          var or = {
            lane: Mt,
            action: Xe.action,
            hasEagerState: Xe.hasEagerState,
            eagerState: Xe.eagerState,
            next: null
          };
          Ne === null ? ($e = Ne = or, ge = k) : Ne = Ne.next = or, Mn.lanes |= Mt, Ls |= Mt;
        }
        Xe = Xe.next;
      } while (Xe !== null && Xe !== ce);
      Ne === null ? ge = k : Ne.next = $e, Oi(k, d.memoizedState) || (Jn = !0), d.memoizedState = k, d.baseState = ge, d.baseQueue = Ne, T.lastRenderedState = k;
    }
    if (u = T.interleaved, u !== null) {
      Q = u;
      do
        ce = Q.lane, Mn.lanes |= ce, Ls |= ce, Q = Q.next;
      while (Q !== u);
    } else
      Q === null && (T.lanes = 0);
    return [d.memoizedState, T.dispatch];
  }
  function Ku(u) {
    var d = ai(), T = d.queue;
    if (T === null)
      throw Error(n(311));
    T.lastRenderedReducer = u;
    var k = T.dispatch, Q = T.pending, ce = d.memoizedState;
    if (Q !== null) {
      T.pending = null;
      var ge = Q = Q.next;
      do
        ce = u(ce, ge.action), ge = ge.next;
      while (ge !== Q);
      Oi(ce, d.memoizedState) || (Jn = !0), d.memoizedState = ce, d.baseQueue === null && (d.baseState = ce), T.lastRenderedState = ce;
    }
    return [ce, k];
  }
  function fd() {
  }
  function pd(u, d) {
    var T = Mn, k = ai(), Q = d(), ce = !Oi(k.memoizedState, Q);
    if (ce && (k.memoizedState = Q, Jn = !0), k = k.queue, Xu(vd.bind(null, T, k, u), [u]), k.getSnapshot !== d || ce || un !== null && un.memoizedState.tag & 1) {
      if (T.flags |= 2048, Za(9, md.bind(null, T, k, Q, d), void 0, null), zn === null)
        throw Error(n(349));
      qa & 30 || hd(T, d, Q);
    }
    return Q;
  }
  function hd(u, d, T) {
    u.flags |= 16384, u = { getSnapshot: d, value: T }, d = Mn.updateQueue, d === null ? (d = { lastEffect: null, stores: null }, Mn.updateQueue = d, d.stores = [u]) : (T = d.stores, T === null ? d.stores = [u] : T.push(u));
  }
  function md(u, d, T, k) {
    d.value = T, d.getSnapshot = k, yd(d) && gd(u);
  }
  function vd(u, d, T) {
    return T(function() {
      yd(d) && gd(u);
    });
  }
  function yd(u) {
    var d = u.getSnapshot;
    u = u.value;
    try {
      var T = d();
      return !Oi(u, T);
    } catch {
      return !0;
    }
  }
  function gd(u) {
    var d = Ns(u, 1);
    d !== null && Fo(d, u, 1, -1);
  }
  function xd(u) {
    var d = Vi();
    return typeof u == "function" && (u = u()), d.memoizedState = d.baseState = u, u = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: Ja, lastRenderedState: u }, d.queue = u, u = u.dispatch = Rd.bind(null, Mn, u), [d.memoizedState, u];
  }
  function Za(u, d, T, k) {
    return u = { tag: u, create: d, destroy: T, deps: k, next: null }, d = Mn.updateQueue, d === null ? (d = { lastEffect: null, stores: null }, Mn.updateQueue = d, d.lastEffect = u.next = u) : (T = d.lastEffect, T === null ? d.lastEffect = u.next = u : (k = T.next, T.next = u, u.next = k, d.lastEffect = u)), u;
  }
  function bd() {
    return ai().memoizedState;
  }
  function el(u, d, T, k) {
    var Q = Vi();
    Mn.flags |= u, Q.memoizedState = Za(1 | d, T, void 0, k === void 0 ? null : k);
  }
  function Ds(u, d, T, k) {
    var Q = ai();
    k = k === void 0 ? null : k;
    var ce = void 0;
    if (mt !== null) {
      var ge = mt.memoizedState;
      if (ce = ge.destroy, k !== null && Xa(k, ge.deps)) {
        Q.memoizedState = Za(d, T, ce, k);
        return;
      }
    }
    Mn.flags |= u, Q.memoizedState = Za(1 | d, T, ce, k);
  }
  function Td(u, d) {
    return el(8390656, 8, u, d);
  }
  function Xu(u, d) {
    return Ds(2048, 8, u, d);
  }
  function Ed(u, d) {
    return Ds(4, 2, u, d);
  }
  function Cd(u, d) {
    return Ds(4, 4, u, d);
  }
  function yp(u, d) {
    if (typeof d == "function")
      return u = u(), d(u), function() {
        d(null);
      };
    if (d != null)
      return u = u(), d.current = u, function() {
        d.current = null;
      };
  }
  function Bl(u, d, T) {
    return T = T != null ? T.concat([u]) : null, Ds(4, 4, yp.bind(null, d, u), T);
  }
  function Sd() {
  }
  function zl(u, d) {
    var T = ai();
    d = d === void 0 ? null : d;
    var k = T.memoizedState;
    return k !== null && d !== null && Xa(d, k[1]) ? k[0] : (T.memoizedState = [u, d], u);
  }
  function ga(u, d) {
    var T = ai();
    d = d === void 0 ? null : d;
    var k = T.memoizedState;
    return k !== null && d !== null && Xa(d, k[1]) ? k[0] : (u = u(), T.memoizedState = [u, d], u);
  }
  function li(u, d, T) {
    return qa & 21 ? (Oi(T, d) || (T = Nc(), Mn.lanes |= T, Ls |= T, u.baseState = !0), d) : (u.baseState && (u.baseState = !1, Jn = !0), u.memoizedState = T);
  }
  function ag(u, d) {
    var T = Cn;
    Cn = T !== 0 && 4 > T ? T : 4, u(!0);
    var k = vp.transition;
    vp.transition = {};
    try {
      u(!1), d();
    } finally {
      Cn = T, vp.transition = k;
    }
  }
  function kn() {
    return ai().memoizedState;
  }
  function Pd(u, d, T) {
    var k = Zn(u);
    if (T = { lane: k, action: T, hasEagerState: !1, eagerState: null, next: null }, Vl(u))
      Qu(d, T);
    else if (T = Mm(u, d, T, k), T !== null) {
      var Q = Io();
      Fo(T, u, k, Q), zm(T, d, k);
    }
  }
  function Rd(u, d, T) {
    var k = Zn(u), Q = { lane: k, action: T, hasEagerState: !1, eagerState: null, next: null };
    if (Vl(u))
      Qu(d, Q);
    else {
      var ce = u.alternate;
      if (u.lanes === 0 && (ce === null || ce.lanes === 0) && (ce = d.lastRenderedReducer, ce !== null))
        try {
          var ge = d.lastRenderedState, $e = ce(ge, T);
          if (Q.hasEagerState = !0, Q.eagerState = $e, Oi($e, ge)) {
            var Ne = d.interleaved;
            Ne === null ? (Q.next = Q, dp(d)) : (Q.next = Ne.next, Ne.next = Q), d.interleaved = Q;
            return;
          }
        } catch {
        } finally {
        }
      T = Mm(u, d, Q, k), T !== null && (Q = Io(), Fo(T, u, k, Q), zm(T, d, k));
    }
  }
  function Vl(u) {
    var d = u.alternate;
    return u === Mn || d !== null && d === Mn;
  }
  function Qu(u, d) {
    hs = Wr = !0;
    var T = u.pending;
    T === null ? d.next = d : (d.next = T.next, T.next = d), u.pending = d;
  }
  function zm(u, d, T) {
    if (T & 4194240) {
      var k = d.lanes;
      k &= u.pendingLanes, T |= k, d.lanes = T, Cu(u, T);
    }
  }
  var _d = { readContext: Yn, useCallback: Nn, useContext: Nn, useEffect: Nn, useImperativeHandle: Nn, useInsertionEffect: Nn, useLayoutEffect: Nn, useMemo: Nn, useReducer: Nn, useRef: Nn, useState: Nn, useDebugValue: Nn, useDeferredValue: Nn, useTransition: Nn, useMutableSource: Nn, useSyncExternalStore: Nn, useId: Nn, unstable_isNewReconciler: !1 }, lg = { readContext: Yn, useCallback: function(u, d) {
    return Vi().memoizedState = [u, d === void 0 ? null : d], u;
  }, useContext: Yn, useEffect: Td, useImperativeHandle: function(u, d, T) {
    return T = T != null ? T.concat([u]) : null, el(
      4194308,
      4,
      yp.bind(null, d, u),
      T
    );
  }, useLayoutEffect: function(u, d) {
    return el(4194308, 4, u, d);
  }, useInsertionEffect: function(u, d) {
    return el(4, 2, u, d);
  }, useMemo: function(u, d) {
    var T = Vi();
    return d = d === void 0 ? null : d, u = u(), T.memoizedState = [u, d], u;
  }, useReducer: function(u, d, T) {
    var k = Vi();
    return d = T !== void 0 ? T(d) : d, k.memoizedState = k.baseState = d, u = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: u, lastRenderedState: d }, k.queue = u, u = u.dispatch = Pd.bind(null, Mn, u), [k.memoizedState, u];
  }, useRef: function(u) {
    var d = Vi();
    return u = { current: u }, d.memoizedState = u;
  }, useState: xd, useDebugValue: Sd, useDeferredValue: function(u) {
    return Vi().memoizedState = u;
  }, useTransition: function() {
    var u = xd(!1), d = u[0];
    return u = ag.bind(null, u[1]), Vi().memoizedState = u, [d, u];
  }, useMutableSource: function() {
  }, useSyncExternalStore: function(u, d, T) {
    var k = Mn, Q = Vi();
    if (jn) {
      if (T === void 0)
        throw Error(n(407));
      T = T();
    } else {
      if (T = d(), zn === null)
        throw Error(n(349));
      qa & 30 || hd(k, d, T);
    }
    Q.memoizedState = T;
    var ce = { value: T, getSnapshot: d };
    return Q.queue = ce, Td(vd.bind(
      null,
      k,
      ce,
      u
    ), [u]), k.flags |= 2048, Za(9, md.bind(null, k, ce, T, d), void 0, null), T;
  }, useId: function() {
    var u = Vi(), d = zn.identifierPrefix;
    if (jn) {
      var T = Ms, k = xo;
      T = (k & ~(1 << 32 - ji(k) - 1)).toString(32) + T, d = ":" + d + "R" + T, T = Si++, 0 < T && (d += "H" + T.toString(32)), d += ":";
    } else
      T = Ka++, d = ":" + d + "r" + T.toString(32) + ":";
    return u.memoizedState = d;
  }, unstable_isNewReconciler: !1 }, ug = {
    readContext: Yn,
    useCallback: zl,
    useContext: Yn,
    useEffect: Xu,
    useImperativeHandle: Bl,
    useInsertionEffect: Ed,
    useLayoutEffect: Cd,
    useMemo: ga,
    useReducer: qu,
    useRef: bd,
    useState: function() {
      return qu(Ja);
    },
    useDebugValue: Sd,
    useDeferredValue: function(u) {
      var d = ai();
      return li(d, mt.memoizedState, u);
    },
    useTransition: function() {
      var u = qu(Ja)[0], d = ai().memoizedState;
      return [u, d];
    },
    useMutableSource: fd,
    useSyncExternalStore: pd,
    useId: kn,
    unstable_isNewReconciler: !1
  }, gp = { readContext: Yn, useCallback: zl, useContext: Yn, useEffect: Xu, useImperativeHandle: Bl, useInsertionEffect: Ed, useLayoutEffect: Cd, useMemo: ga, useReducer: Ku, useRef: bd, useState: function() {
    return Ku(Ja);
  }, useDebugValue: Sd, useDeferredValue: function(u) {
    var d = ai();
    return mt === null ? d.memoizedState = u : li(d, mt.memoizedState, u);
  }, useTransition: function() {
    var u = Ku(Ja)[0], d = ai().memoizedState;
    return [u, d];
  }, useMutableSource: fd, useSyncExternalStore: pd, useId: kn, unstable_isNewReconciler: !1 };
  function Ul(u, d) {
    try {
      var T = "", k = d;
      do
        T += Ve(k), k = k.return;
      while (k);
      var Q = T;
    } catch (ce) {
      Q = `
Error generating stack: ` + ce.message + `
` + ce.stack;
    }
    return { value: u, source: d, stack: Q, digest: null };
  }
  function Ju(u, d, T) {
    return { value: u, source: null, stack: T ?? null, digest: d ?? null };
  }
  function wd(u, d) {
    try {
      console.error(d.value);
    } catch (T) {
      setTimeout(function() {
        throw T;
      });
    }
  }
  var cg = typeof WeakMap == "function" ? WeakMap : Map;
  function Vm(u, d, T) {
    T = Os(-1, T), T.tag = 3, T.payload = { element: null };
    var k = d.value;
    return T.callback = function() {
      Od || (Od = !0, il = k), wd(u, d);
    }, T;
  }
  function Zu(u, d, T) {
    T = Os(-1, T), T.tag = 3;
    var k = u.type.getDerivedStateFromError;
    if (typeof k == "function") {
      var Q = d.value;
      T.payload = function() {
        return k(Q);
      }, T.callback = function() {
        wd(u, d);
      };
    }
    var ce = u.stateNode;
    return ce !== null && typeof ce.componentDidCatch == "function" && (T.callback = function() {
      wd(u, d), typeof k != "function" && (ys === null ? ys = /* @__PURE__ */ new Set([this]) : ys.add(this));
      var ge = d.stack;
      this.componentDidCatch(d.value, { componentStack: ge !== null ? ge : "" });
    }), T;
  }
  function Um(u, d, T) {
    var k = u.pingCache;
    if (k === null) {
      k = u.pingCache = new cg();
      var Q = /* @__PURE__ */ new Set();
      k.set(d, Q);
    } else
      Q = k.get(d), Q === void 0 && (Q = /* @__PURE__ */ new Set(), k.set(d, Q));
    Q.has(T) || (Q.add(T), u = yg.bind(null, u, d, T), d.then(u, u));
  }
  function xp(u) {
    do {
      var d;
      if ((d = u.tag === 13) && (d = u.memoizedState, d = d !== null ? d.dehydrated !== null : !0), d)
        return u;
      u = u.return;
    } while (u !== null);
    return null;
  }
  function bp(u, d, T, k, Q) {
    return u.mode & 1 ? (u.flags |= 65536, u.lanes = Q, u) : (u === d ? u.flags |= 65536 : (u.flags |= 128, T.flags |= 131072, T.flags &= -52805, T.tag === 1 && (T.alternate === null ? T.tag = 17 : (d = Os(-1, 1), d.tag = 2, ha(T, d, 1))), T.lanes |= 1), u);
  }
  var dg = B.ReactCurrentOwner, Jn = !1;
  function oo(u, d, T, k) {
    d.child = u === null ? Bm(d, null, T, k) : Fl(d, u.child, T, k);
  }
  function xa(u, d, T, k, Q) {
    T = T.render;
    var ce = d.ref;
    return dr(d, Q), k = ya(u, d, T, k, ce, Q), T = Qa(), u !== null && !Jn ? (d.updateQueue = u.updateQueue, d.flags &= -2053, u.lanes &= ~Q, To(u, d, Q)) : (jn && T && ed(d), d.flags |= 1, oo(u, d, k, Q), d.child);
  }
  function kd(u, d, T, k, Q) {
    if (u === null) {
      var ce = T.type;
      return typeof ce == "function" && !Lp(ce) && ce.defaultProps === void 0 && T.compare === null && T.defaultProps === void 0 ? (d.tag = 15, d.type = ce, ui(u, d, ce, k, Q)) : (u = zd(T.type, null, k, d, d.mode, Q), u.ref = d.ref, u.return = d, d.child = u);
    }
    if (ce = u.child, !(u.lanes & Q)) {
      var ge = ce.memoizedProps;
      if (T = T.compare, T = T !== null ? T : Nu, T(ge, k) && u.ref === d.ref)
        return To(u, d, Q);
    }
    return d.flags |= 1, u = Ca(ce, k), u.ref = d.ref, u.return = d, d.child = u;
  }
  function ui(u, d, T, k, Q) {
    if (u !== null) {
      var ce = u.memoizedProps;
      if (Nu(ce, k) && u.ref === d.ref)
        if (Jn = !1, d.pendingProps = k = ce, (u.lanes & Q) !== 0)
          u.flags & 131072 && (Jn = !0);
        else
          return d.lanes = u.lanes, To(u, d, Q);
    }
    return Hl(u, d, T, k, Q);
  }
  function tl(u, d, T) {
    var k = d.pendingProps, Q = k.children, ce = u !== null ? u.memoizedState : null;
    if (k.mode === "hidden")
      if (!(d.mode & 1))
        d.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, Tn(Xl, Pi), Pi |= T;
      else {
        if (!(T & 1073741824))
          return u = ce !== null ? ce.baseLanes | T : T, d.lanes = d.childLanes = 1073741824, d.memoizedState = { baseLanes: u, cachePool: null, transitions: null }, d.updateQueue = null, Tn(Xl, Pi), Pi |= u, null;
        d.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, k = ce !== null ? ce.baseLanes : T, Tn(Xl, Pi), Pi |= k;
      }
    else
      ce !== null ? (k = ce.baseLanes | T, d.memoizedState = null) : k = T, Tn(Xl, Pi), Pi |= k;
    return oo(u, d, Q, T), d.child;
  }
  function rn(u, d) {
    var T = d.ref;
    (u === null && T !== null || u !== null && u.ref !== T) && (d.flags |= 512, d.flags |= 2097152);
  }
  function Hl(u, d, T, k, Q) {
    var ce = Dn(T) ? ri : Kr.current;
    return ce = Ii(d, ce), dr(d, Q), T = ya(u, d, T, k, ce, Q), k = Qa(), u !== null && !Jn ? (d.updateQueue = u.updateQueue, d.flags &= -2053, u.lanes &= ~Q, To(u, d, Q)) : (jn && k && ed(d), d.flags |= 1, oo(u, d, T, Q), d.child);
  }
  function Tp(u, d, T, k, Q) {
    if (Dn(T)) {
      var ce = !0;
      Zc(d);
    } else
      ce = !1;
    if (dr(d, Q), d.stateNode === null)
      No(u, d), Dm(d, T, k), ld(d, T, k, Q), k = !0;
    else if (u === null) {
      var ge = d.stateNode, $e = d.memoizedProps;
      ge.props = $e;
      var Ne = ge.context, Xe = T.contextType;
      typeof Xe == "object" && Xe !== null ? Xe = Yn(Xe) : (Xe = Dn(T) ? ri : Kr.current, Xe = Ii(d, Xe));
      var Mt = T.getDerivedStateFromProps, or = typeof Mt == "function" || typeof ge.getSnapshotBeforeUpdate == "function";
      or || typeof ge.UNSAFE_componentWillReceiveProps != "function" && typeof ge.componentWillReceiveProps != "function" || ($e !== k || Ne !== Xe) && Im(d, ge, k, Xe), pa = !1;
      var At = d.memoizedState;
      ge.state = At, ma(d, k, ge, Q), Ne = d.memoizedState, $e !== k || At !== Ne || Un.current || pa ? (typeof Mt == "function" && (hp(d, T, Mt, k), Ne = d.memoizedState), ($e = pa || Om(d, T, $e, k, At, Ne, Xe)) ? (or || typeof ge.UNSAFE_componentWillMount != "function" && typeof ge.componentWillMount != "function" || (typeof ge.componentWillMount == "function" && ge.componentWillMount(), typeof ge.UNSAFE_componentWillMount == "function" && ge.UNSAFE_componentWillMount()), typeof ge.componentDidMount == "function" && (d.flags |= 4194308)) : (typeof ge.componentDidMount == "function" && (d.flags |= 4194308), d.memoizedProps = k, d.memoizedState = Ne), ge.props = k, ge.state = Ne, ge.context = Xe, k = $e) : (typeof ge.componentDidMount == "function" && (d.flags |= 4194308), k = !1);
    } else {
      ge = d.stateNode, no(u, d), $e = d.memoizedProps, Xe = d.type === d.elementType ? $e : Ci(d.type, $e), ge.props = Xe, or = d.pendingProps, At = ge.context, Ne = T.contextType, typeof Ne == "object" && Ne !== null ? Ne = Yn(Ne) : (Ne = Dn(T) ? ri : Kr.current, Ne = Ii(d, Ne));
      var yr = T.getDerivedStateFromProps;
      (Mt = typeof yr == "function" || typeof ge.getSnapshotBeforeUpdate == "function") || typeof ge.UNSAFE_componentWillReceiveProps != "function" && typeof ge.componentWillReceiveProps != "function" || ($e !== or || At !== Ne) && Im(d, ge, k, Ne), pa = !1, At = d.memoizedState, ge.state = At, ma(d, k, ge, Q);
      var Pr = d.memoizedState;
      $e !== or || At !== Pr || Un.current || pa ? (typeof yr == "function" && (hp(d, T, yr, k), Pr = d.memoizedState), (Xe = pa || Om(d, T, Xe, k, At, Pr, Ne) || !1) ? (Mt || typeof ge.UNSAFE_componentWillUpdate != "function" && typeof ge.componentWillUpdate != "function" || (typeof ge.componentWillUpdate == "function" && ge.componentWillUpdate(k, Pr, Ne), typeof ge.UNSAFE_componentWillUpdate == "function" && ge.UNSAFE_componentWillUpdate(k, Pr, Ne)), typeof ge.componentDidUpdate == "function" && (d.flags |= 4), typeof ge.getSnapshotBeforeUpdate == "function" && (d.flags |= 1024)) : (typeof ge.componentDidUpdate != "function" || $e === u.memoizedProps && At === u.memoizedState || (d.flags |= 4), typeof ge.getSnapshotBeforeUpdate != "function" || $e === u.memoizedProps && At === u.memoizedState || (d.flags |= 1024), d.memoizedProps = k, d.memoizedState = Pr), ge.props = k, ge.state = Pr, ge.context = Ne, k = Xe) : (typeof ge.componentDidUpdate != "function" || $e === u.memoizedProps && At === u.memoizedState || (d.flags |= 4), typeof ge.getSnapshotBeforeUpdate != "function" || $e === u.memoizedProps && At === u.memoizedState || (d.flags |= 1024), k = !1);
    }
    return Hm(u, d, T, k, ce, Q);
  }
  function Hm(u, d, T, k, Q, ce) {
    rn(u, d);
    var ge = (d.flags & 128) !== 0;
    if (!k && !ge)
      return Q && km(d, T, !1), To(u, d, ce);
    k = d.stateNode, dg.current = d;
    var $e = ge && typeof T.getDerivedStateFromError != "function" ? null : k.render();
    return d.flags |= 1, u !== null && ge ? (d.child = Fl(d, u.child, null, ce), d.child = Fl(d, null, $e, ce)) : oo(u, d, $e, ce), d.memoizedState = k.state, Q && km(d, T, !0), d.child;
  }
  function Wm(u) {
    var d = u.stateNode;
    d.pendingContext ? ua(u, d.pendingContext, d.pendingContext !== d.context) : d.context && ua(u, d.context, !1), mp(u, d.containerInfo);
  }
  function Ad(u, d, T, k, Q) {
    return Ln(), lp(Q), d.flags |= 256, oo(u, d, T, k), d.child;
  }
  var rl = { dehydrated: null, treeContext: null, retryLane: 0 };
  function Ep(u) {
    return { baseLanes: u, cachePool: null, transitions: null };
  }
  function Cp(u, d, T) {
    var k = d.pendingProps, Q = Ur.current, ce = !1, ge = (d.flags & 128) !== 0, $e;
    if (($e = ge) || ($e = u !== null && u.memoizedState === null ? !1 : (Q & 2) !== 0), $e ? (ce = !0, d.flags &= -129) : (u === null || u.memoizedState !== null) && (Q |= 1), Tn(Ur, Q & 1), u === null)
      return rd(d), u = d.memoizedState, u !== null && (u = u.dehydrated, u !== null) ? (d.mode & 1 ? u.data === "$!" ? d.lanes = 8 : d.lanes = 1073741824 : d.lanes = 1, null) : (ge = k.children, u = k.fallback, ce ? (k = d.mode, ce = d.child, ge = { mode: "hidden", children: ge }, !(k & 1) && ce !== null ? (ce.childLanes = 0, ce.pendingProps = ge) : ce = uc(ge, k, 0, null), u = cl(u, k, T, null), ce.return = d, u.return = d, ce.sibling = u, d.child = ce, d.child.memoizedState = Ep(T), d.memoizedState = rl, u) : Sp(d, ge));
    if (Q = u.memoizedState, Q !== null && ($e = Q.dehydrated, $e !== null))
      return fg(u, d, ge, k, $e, Q, T);
    if (ce) {
      ce = k.fallback, ge = d.mode, Q = u.child, $e = Q.sibling;
      var Ne = { mode: "hidden", children: k.children };
      return !(ge & 1) && d.child !== Q ? (k = d.child, k.childLanes = 0, k.pendingProps = Ne, d.deletions = null) : (k = Ca(Q, Ne), k.subtreeFlags = Q.subtreeFlags & 14680064), $e !== null ? ce = Ca($e, ce) : (ce = cl(ce, ge, T, null), ce.flags |= 2), ce.return = d, k.return = d, k.sibling = ce, d.child = k, k = ce, ce = d.child, ge = u.child.memoizedState, ge = ge === null ? Ep(T) : { baseLanes: ge.baseLanes | T, cachePool: null, transitions: ge.transitions }, ce.memoizedState = ge, ce.childLanes = u.childLanes & ~T, d.memoizedState = rl, k;
    }
    return ce = u.child, u = ce.sibling, k = Ca(ce, { mode: "visible", children: k.children }), !(d.mode & 1) && (k.lanes = T), k.return = d, k.sibling = null, u !== null && (T = d.deletions, T === null ? (d.deletions = [u], d.flags |= 16) : T.push(u)), d.child = k, d.memoizedState = null, k;
  }
  function Sp(u, d) {
    return d = uc({ mode: "visible", children: d }, u.mode, 0, null), d.return = u, u.child = d;
  }
  function Wl(u, d, T, k) {
    return k !== null && lp(k), Fl(d, u.child, null, T), u = Sp(d, d.pendingProps.children), u.flags |= 2, d.memoizedState = null, u;
  }
  function fg(u, d, T, k, Q, ce, ge) {
    if (T)
      return d.flags & 256 ? (d.flags &= -257, k = Ju(Error(n(422))), Wl(u, d, ge, k)) : d.memoizedState !== null ? (d.child = u.child, d.flags |= 128, null) : (ce = k.fallback, Q = d.mode, k = uc({ mode: "visible", children: k.children }, Q, 0, null), ce = cl(ce, Q, ge, null), ce.flags |= 2, k.return = d, ce.return = d, k.sibling = ce, d.child = k, d.mode & 1 && Fl(d, u.child, null, ge), d.child.memoizedState = Ep(ge), d.memoizedState = rl, ce);
    if (!(d.mode & 1))
      return Wl(u, d, ge, null);
    if (Q.data === "$!") {
      if (k = Q.nextSibling && Q.nextSibling.dataset, k)
        var $e = k.dgst;
      return k = $e, ce = Error(n(419)), k = Ju(ce, k, void 0), Wl(u, d, ge, k);
    }
    if ($e = (ge & u.childLanes) !== 0, Jn || $e) {
      if (k = zn, k !== null) {
        switch (ge & -ge) {
          case 4:
            Q = 2;
            break;
          case 16:
            Q = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            Q = 32;
            break;
          case 536870912:
            Q = 268435456;
            break;
          default:
            Q = 0;
        }
        Q = Q & (k.suspendedLanes | ge) ? 0 : Q, Q !== 0 && Q !== ce.retryLane && (ce.retryLane = Q, Ns(u, Q), Fo(k, u, Q, -1));
      }
      return Dp(), k = Ju(Error(n(421))), Wl(u, d, ge, k);
    }
    return Q.data === "$?" ? (d.flags |= 128, d.child = u.child, d = gg.bind(null, u), Q._reactRetry = d, null) : (u = ce.treeContext, si = os(Q.nextSibling), Ei = d, jn = !0, Bi = null, u !== null && (ii[Mo++] = xo, ii[Mo++] = Ms, ii[Mo++] = Li, xo = u.id, Ms = u.overflow, Li = d), d = Sp(d, k.children), d.flags |= 4096, d);
  }
  function Pp(u, d, T) {
    u.lanes |= d;
    var k = u.alternate;
    k !== null && (k.lanes |= d), ho(u.return, d, T);
  }
  function $d(u, d, T, k, Q) {
    var ce = u.memoizedState;
    ce === null ? u.memoizedState = { isBackwards: d, rendering: null, renderingStartTime: 0, last: k, tail: T, tailMode: Q } : (ce.isBackwards = d, ce.rendering = null, ce.renderingStartTime = 0, ce.last = k, ce.tail = T, ce.tailMode = Q);
  }
  function Rp(u, d, T) {
    var k = d.pendingProps, Q = k.revealOrder, ce = k.tail;
    if (oo(u, d, k.children, T), k = Ur.current, k & 2)
      k = k & 1 | 2, d.flags |= 128;
    else {
      if (u !== null && u.flags & 128)
        e:
          for (u = d.child; u !== null; ) {
            if (u.tag === 13)
              u.memoizedState !== null && Pp(u, T, d);
            else if (u.tag === 19)
              Pp(u, T, d);
            else if (u.child !== null) {
              u.child.return = u, u = u.child;
              continue;
            }
            if (u === d)
              break e;
            for (; u.sibling === null; ) {
              if (u.return === null || u.return === d)
                break e;
              u = u.return;
            }
            u.sibling.return = u.return, u = u.sibling;
          }
      k &= 1;
    }
    if (Tn(Ur, k), !(d.mode & 1))
      d.memoizedState = null;
    else
      switch (Q) {
        case "forwards":
          for (T = d.child, Q = null; T !== null; )
            u = T.alternate, u !== null && Bn(u) === null && (Q = T), T = T.sibling;
          T = Q, T === null ? (Q = d.child, d.child = null) : (Q = T.sibling, T.sibling = null), $d(d, !1, Q, T, ce);
          break;
        case "backwards":
          for (T = null, Q = d.child, d.child = null; Q !== null; ) {
            if (u = Q.alternate, u !== null && Bn(u) === null) {
              d.child = Q;
              break;
            }
            u = Q.sibling, Q.sibling = T, T = Q, Q = u;
          }
          $d(d, !0, T, null, ce);
          break;
        case "together":
          $d(d, !1, null, null, void 0);
          break;
        default:
          d.memoizedState = null;
      }
    return d.child;
  }
  function No(u, d) {
    !(d.mode & 1) && u !== null && (u.alternate = null, d.alternate = null, d.flags |= 2);
  }
  function To(u, d, T) {
    if (u !== null && (d.dependencies = u.dependencies), Ls |= d.lanes, !(T & d.childLanes))
      return null;
    if (u !== null && d.child !== u.child)
      throw Error(n(153));
    if (d.child !== null) {
      for (u = d.child, T = Ca(u, u.pendingProps), d.child = T, T.return = d; u.sibling !== null; )
        u = u.sibling, T = T.sibling = Ca(u, u.pendingProps), T.return = d;
      T.sibling = null;
    }
    return d.child;
  }
  function Is(u, d, T) {
    switch (d.tag) {
      case 3:
        Wm(d), Ln();
        break;
      case 5:
        Vr(d);
        break;
      case 1:
        Dn(d.type) && Zc(d);
        break;
      case 4:
        mp(d, d.stateNode.containerInfo);
        break;
      case 10:
        var k = d.type._context, Q = d.memoizedProps.value;
        Tn(ps, k._currentValue), k._currentValue = Q;
        break;
      case 13:
        if (k = d.memoizedState, k !== null)
          return k.dehydrated !== null ? (Tn(Ur, Ur.current & 1), d.flags |= 128, null) : T & d.child.childLanes ? Cp(u, d, T) : (Tn(Ur, Ur.current & 1), u = To(u, d, T), u !== null ? u.sibling : null);
        Tn(Ur, Ur.current & 1);
        break;
      case 19:
        if (k = (T & d.childLanes) !== 0, u.flags & 128) {
          if (k)
            return Rp(u, d, T);
          d.flags |= 128;
        }
        if (Q = d.memoizedState, Q !== null && (Q.rendering = null, Q.tail = null, Q.lastEffect = null), Tn(Ur, Ur.current), k)
          break;
        return null;
      case 22:
      case 23:
        return d.lanes = 0, tl(u, d, T);
    }
    return To(u, d, T);
  }
  var ec, nl, Ui, io;
  ec = function(u, d) {
    for (var T = d.child; T !== null; ) {
      if (T.tag === 5 || T.tag === 6)
        u.appendChild(T.stateNode);
      else if (T.tag !== 4 && T.child !== null) {
        T.child.return = T, T = T.child;
        continue;
      }
      if (T === d)
        break;
      for (; T.sibling === null; ) {
        if (T.return === null || T.return === d)
          return;
        T = T.return;
      }
      T.sibling.return = T.return, T = T.sibling;
    }
  }, nl = function() {
  }, Ui = function(u, d, T, k) {
    var Q = u.memoizedProps;
    if (Q !== k) {
      u = d.stateNode, Ya(is.current);
      var ce = null;
      switch (T) {
        case "input":
          Q = je(u, Q), k = je(u, k), ce = [];
          break;
        case "select":
          Q = ye({}, Q, { value: void 0 }), k = ye({}, k, { value: void 0 }), ce = [];
          break;
        case "textarea":
          Q = Gr(u, Q), k = Gr(u, k), ce = [];
          break;
        default:
          typeof Q.onClick != "function" && typeof k.onClick == "function" && (u.onclick = Jc);
      }
      kr(T, k);
      var ge;
      T = null;
      for (Xe in Q)
        if (!k.hasOwnProperty(Xe) && Q.hasOwnProperty(Xe) && Q[Xe] != null)
          if (Xe === "style") {
            var $e = Q[Xe];
            for (ge in $e)
              $e.hasOwnProperty(ge) && (T || (T = {}), T[ge] = "");
          } else
            Xe !== "dangerouslySetInnerHTML" && Xe !== "children" && Xe !== "suppressContentEditableWarning" && Xe !== "suppressHydrationWarning" && Xe !== "autoFocus" && (s.hasOwnProperty(Xe) ? ce || (ce = []) : (ce = ce || []).push(Xe, null));
      for (Xe in k) {
        var Ne = k[Xe];
        if ($e = Q != null ? Q[Xe] : void 0, k.hasOwnProperty(Xe) && Ne !== $e && (Ne != null || $e != null))
          if (Xe === "style")
            if ($e) {
              for (ge in $e)
                !$e.hasOwnProperty(ge) || Ne && Ne.hasOwnProperty(ge) || (T || (T = {}), T[ge] = "");
              for (ge in Ne)
                Ne.hasOwnProperty(ge) && $e[ge] !== Ne[ge] && (T || (T = {}), T[ge] = Ne[ge]);
            } else
              T || (ce || (ce = []), ce.push(
                Xe,
                T
              )), T = Ne;
          else
            Xe === "dangerouslySetInnerHTML" ? (Ne = Ne ? Ne.__html : void 0, $e = $e ? $e.__html : void 0, Ne != null && $e !== Ne && (ce = ce || []).push(Xe, Ne)) : Xe === "children" ? typeof Ne != "string" && typeof Ne != "number" || (ce = ce || []).push(Xe, "" + Ne) : Xe !== "suppressContentEditableWarning" && Xe !== "suppressHydrationWarning" && (s.hasOwnProperty(Xe) ? (Ne != null && Xe === "onScroll" && wn("scroll", u), ce || $e === Ne || (ce = [])) : (ce = ce || []).push(Xe, Ne));
      }
      T && (ce = ce || []).push("style", T);
      var Xe = ce;
      (d.updateQueue = Xe) && (d.flags |= 4);
    }
  }, io = function(u, d, T, k) {
    T !== k && (d.flags |= 4);
  };
  function tc(u, d) {
    if (!jn)
      switch (u.tailMode) {
        case "hidden":
          d = u.tail;
          for (var T = null; d !== null; )
            d.alternate !== null && (T = d), d = d.sibling;
          T === null ? u.tail = null : T.sibling = null;
          break;
        case "collapsed":
          T = u.tail;
          for (var k = null; T !== null; )
            T.alternate !== null && (k = T), T = T.sibling;
          k === null ? d || u.tail === null ? u.tail = null : u.tail.sibling = null : k.sibling = null;
      }
  }
  function Oo(u) {
    var d = u.alternate !== null && u.alternate.child === u.child, T = 0, k = 0;
    if (d)
      for (var Q = u.child; Q !== null; )
        T |= Q.lanes | Q.childLanes, k |= Q.subtreeFlags & 14680064, k |= Q.flags & 14680064, Q.return = u, Q = Q.sibling;
    else
      for (Q = u.child; Q !== null; )
        T |= Q.lanes | Q.childLanes, k |= Q.subtreeFlags, k |= Q.flags, Q.return = u, Q = Q.sibling;
    return u.subtreeFlags |= k, u.childLanes = T, d;
  }
  function pg(u, d, T) {
    var k = d.pendingProps;
    switch (sp(d), d.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return Oo(d), null;
      case 1:
        return Dn(d.type) && Fi(), Oo(d), null;
      case 3:
        return k = d.stateNode, va(), bn(Un), bn(Kr), cd(), k.pendingContext && (k.context = k.pendingContext, k.pendingContext = null), (u === null || u.child === null) && (nd(d) ? d.flags |= 4 : u === null || u.memoizedState.isDehydrated && !(d.flags & 256) || (d.flags |= 1024, Bi !== null && (lc(Bi), Bi = null))), nl(u, d), Oo(d), null;
      case 5:
        nn(d);
        var Q = Ya(Ll.current);
        if (T = d.type, u !== null && d.stateNode != null)
          Ui(u, d, T, k, Q), u.ref !== d.ref && (d.flags |= 512, d.flags |= 2097152);
        else {
          if (!k) {
            if (d.stateNode === null)
              throw Error(n(166));
            return Oo(d), null;
          }
          if (u = Ya(is.current), nd(d)) {
            k = d.stateNode, T = d.type;
            var ce = d.memoizedProps;
            switch (k[ds] = d, k[Ha] = ce, u = (d.mode & 1) !== 0, T) {
              case "dialog":
                wn("cancel", k), wn("close", k);
                break;
              case "iframe":
              case "object":
              case "embed":
                wn("load", k);
                break;
              case "video":
              case "audio":
                for (Q = 0; Q < Fu.length; Q++)
                  wn(Fu[Q], k);
                break;
              case "source":
                wn("error", k);
                break;
              case "img":
              case "image":
              case "link":
                wn(
                  "error",
                  k
                ), wn("load", k);
                break;
              case "details":
                wn("toggle", k);
                break;
              case "input":
                kt(k, ce), wn("invalid", k);
                break;
              case "select":
                k._wrapperState = { wasMultiple: !!ce.multiple }, wn("invalid", k);
                break;
              case "textarea":
                Yr(k, ce), wn("invalid", k);
            }
            kr(T, ce), Q = null;
            for (var ge in ce)
              if (ce.hasOwnProperty(ge)) {
                var $e = ce[ge];
                ge === "children" ? typeof $e == "string" ? k.textContent !== $e && (ce.suppressHydrationWarning !== !0 && Qc(k.textContent, $e, u), Q = ["children", $e]) : typeof $e == "number" && k.textContent !== "" + $e && (ce.suppressHydrationWarning !== !0 && Qc(
                  k.textContent,
                  $e,
                  u
                ), Q = ["children", "" + $e]) : s.hasOwnProperty(ge) && $e != null && ge === "onScroll" && wn("scroll", k);
              }
            switch (T) {
              case "input":
                St(k), Er(k, ce, !0);
                break;
              case "textarea":
                St(k), ar(k);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof ce.onClick == "function" && (k.onclick = Jc);
            }
            k = Q, d.updateQueue = k, k !== null && (d.flags |= 4);
          } else {
            ge = Q.nodeType === 9 ? Q : Q.ownerDocument, u === "http://www.w3.org/1999/xhtml" && (u = wr(T)), u === "http://www.w3.org/1999/xhtml" ? T === "script" ? (u = ge.createElement("div"), u.innerHTML = "<script><\/script>", u = u.removeChild(u.firstChild)) : typeof k.is == "string" ? u = ge.createElement(T, { is: k.is }) : (u = ge.createElement(T), T === "select" && (ge = u, k.multiple ? ge.multiple = !0 : k.size && (ge.size = k.size))) : u = ge.createElementNS(u, T), u[ds] = d, u[Ha] = k, ec(u, d, !1, !1), d.stateNode = u;
            e: {
              switch (ge = Nr(T, k), T) {
                case "dialog":
                  wn("cancel", u), wn("close", u), Q = k;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  wn("load", u), Q = k;
                  break;
                case "video":
                case "audio":
                  for (Q = 0; Q < Fu.length; Q++)
                    wn(Fu[Q], u);
                  Q = k;
                  break;
                case "source":
                  wn("error", u), Q = k;
                  break;
                case "img":
                case "image":
                case "link":
                  wn(
                    "error",
                    u
                  ), wn("load", u), Q = k;
                  break;
                case "details":
                  wn("toggle", u), Q = k;
                  break;
                case "input":
                  kt(u, k), Q = je(u, k), wn("invalid", u);
                  break;
                case "option":
                  Q = k;
                  break;
                case "select":
                  u._wrapperState = { wasMultiple: !!k.multiple }, Q = ye({}, k, { value: void 0 }), wn("invalid", u);
                  break;
                case "textarea":
                  Yr(u, k), Q = Gr(u, k), wn("invalid", u);
                  break;
                default:
                  Q = k;
              }
              kr(T, Q), $e = Q;
              for (ce in $e)
                if ($e.hasOwnProperty(ce)) {
                  var Ne = $e[ce];
                  ce === "style" ? er(u, Ne) : ce === "dangerouslySetInnerHTML" ? (Ne = Ne ? Ne.__html : void 0, Ne != null && Je(u, Ne)) : ce === "children" ? typeof Ne == "string" ? (T !== "textarea" || Ne !== "") && tr(u, Ne) : typeof Ne == "number" && tr(u, "" + Ne) : ce !== "suppressContentEditableWarning" && ce !== "suppressHydrationWarning" && ce !== "autoFocus" && (s.hasOwnProperty(ce) ? Ne != null && ce === "onScroll" && wn("scroll", u) : Ne != null && N(u, ce, Ne, ge));
                }
              switch (T) {
                case "input":
                  St(u), Er(u, k, !1);
                  break;
                case "textarea":
                  St(u), ar(u);
                  break;
                case "option":
                  k.value != null && u.setAttribute("value", "" + et(k.value));
                  break;
                case "select":
                  u.multiple = !!k.multiple, ce = k.value, ce != null ? hr(u, !!k.multiple, ce, !1) : k.defaultValue != null && hr(
                    u,
                    !!k.multiple,
                    k.defaultValue,
                    !0
                  );
                  break;
                default:
                  typeof Q.onClick == "function" && (u.onclick = Jc);
              }
              switch (T) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  k = !!k.autoFocus;
                  break e;
                case "img":
                  k = !0;
                  break e;
                default:
                  k = !1;
              }
            }
            k && (d.flags |= 4);
          }
          d.ref !== null && (d.flags |= 512, d.flags |= 2097152);
        }
        return Oo(d), null;
      case 6:
        if (u && d.stateNode != null)
          io(u, d, u.memoizedProps, k);
        else {
          if (typeof k != "string" && d.stateNode === null)
            throw Error(n(166));
          if (T = Ya(Ll.current), Ya(is.current), nd(d)) {
            if (k = d.stateNode, T = d.memoizedProps, k[ds] = d, (ce = k.nodeValue !== T) && (u = Ei, u !== null))
              switch (u.tag) {
                case 3:
                  Qc(k.nodeValue, T, (u.mode & 1) !== 0);
                  break;
                case 5:
                  u.memoizedProps.suppressHydrationWarning !== !0 && Qc(k.nodeValue, T, (u.mode & 1) !== 0);
              }
            ce && (d.flags |= 4);
          } else
            k = (T.nodeType === 9 ? T : T.ownerDocument).createTextNode(k), k[ds] = d, d.stateNode = k;
        }
        return Oo(d), null;
      case 13:
        if (bn(Ur), k = d.memoizedState, u === null || u.memoizedState !== null && u.memoizedState.dehydrated !== null) {
          if (jn && si !== null && d.mode & 1 && !(d.flags & 128))
            jm(), Ln(), d.flags |= 98560, ce = !1;
          else if (ce = nd(d), k !== null && k.dehydrated !== null) {
            if (u === null) {
              if (!ce)
                throw Error(n(318));
              if (ce = d.memoizedState, ce = ce !== null ? ce.dehydrated : null, !ce)
                throw Error(n(317));
              ce[ds] = d;
            } else
              Ln(), !(d.flags & 128) && (d.memoizedState = null), d.flags |= 4;
            Oo(d), ce = !1;
          } else
            Bi !== null && (lc(Bi), Bi = null), ce = !0;
          if (!ce)
            return d.flags & 65536 ? d : null;
        }
        return d.flags & 128 ? (d.lanes = T, d) : (k = k !== null, k !== (u !== null && u.memoizedState !== null) && k && (d.child.flags |= 8192, d.mode & 1 && (u === null || Ur.current & 1 ? ao === 0 && (ao = 3) : Dp())), d.updateQueue !== null && (d.flags |= 4), Oo(d), null);
      case 4:
        return va(), nl(u, d), u === null && Nl(d.stateNode.containerInfo), Oo(d), null;
      case 10:
        return fa(d.type._context), Oo(d), null;
      case 17:
        return Dn(d.type) && Fi(), Oo(d), null;
      case 19:
        if (bn(Ur), ce = d.memoizedState, ce === null)
          return Oo(d), null;
        if (k = (d.flags & 128) !== 0, ge = ce.rendering, ge === null)
          if (k)
            tc(ce, !1);
          else {
            if (ao !== 0 || u !== null && u.flags & 128)
              for (u = d.child; u !== null; ) {
                if (ge = Bn(u), ge !== null) {
                  for (d.flags |= 128, tc(ce, !1), k = ge.updateQueue, k !== null && (d.updateQueue = k, d.flags |= 4), d.subtreeFlags = 0, k = T, T = d.child; T !== null; )
                    ce = T, u = k, ce.flags &= 14680066, ge = ce.alternate, ge === null ? (ce.childLanes = 0, ce.lanes = u, ce.child = null, ce.subtreeFlags = 0, ce.memoizedProps = null, ce.memoizedState = null, ce.updateQueue = null, ce.dependencies = null, ce.stateNode = null) : (ce.childLanes = ge.childLanes, ce.lanes = ge.lanes, ce.child = ge.child, ce.subtreeFlags = 0, ce.deletions = null, ce.memoizedProps = ge.memoizedProps, ce.memoizedState = ge.memoizedState, ce.updateQueue = ge.updateQueue, ce.type = ge.type, u = ge.dependencies, ce.dependencies = u === null ? null : { lanes: u.lanes, firstContext: u.firstContext }), T = T.sibling;
                  return Tn(Ur, Ur.current & 1 | 2), d.child;
                }
                u = u.sibling;
              }
            ce.tail !== null && yn() > Jl && (d.flags |= 128, k = !0, tc(ce, !1), d.lanes = 4194304);
          }
        else {
          if (!k)
            if (u = Bn(ge), u !== null) {
              if (d.flags |= 128, k = !0, T = u.updateQueue, T !== null && (d.updateQueue = T, d.flags |= 4), tc(ce, !0), ce.tail === null && ce.tailMode === "hidden" && !ge.alternate && !jn)
                return Oo(d), null;
            } else
              2 * yn() - ce.renderingStartTime > Jl && T !== 1073741824 && (d.flags |= 128, k = !0, tc(ce, !1), d.lanes = 4194304);
          ce.isBackwards ? (ge.sibling = d.child, d.child = ge) : (T = ce.last, T !== null ? T.sibling = ge : d.child = ge, ce.last = ge);
        }
        return ce.tail !== null ? (d = ce.tail, ce.rendering = d, ce.tail = d.sibling, ce.renderingStartTime = yn(), d.sibling = null, T = Ur.current, Tn(Ur, k ? T & 1 | 2 : T & 1), d) : (Oo(d), null);
      case 22:
      case 23:
        return Op(), k = d.memoizedState !== null, u !== null && u.memoizedState !== null !== k && (d.flags |= 8192), k && d.mode & 1 ? Pi & 1073741824 && (Oo(d), d.subtreeFlags & 6 && (d.flags |= 8192)) : Oo(d), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(n(156, d.tag));
  }
  function _p(u, d) {
    switch (sp(d), d.tag) {
      case 1:
        return Dn(d.type) && Fi(), u = d.flags, u & 65536 ? (d.flags = u & -65537 | 128, d) : null;
      case 3:
        return va(), bn(Un), bn(Kr), cd(), u = d.flags, u & 65536 && !(u & 128) ? (d.flags = u & -65537 | 128, d) : null;
      case 5:
        return nn(d), null;
      case 13:
        if (bn(Ur), u = d.memoizedState, u !== null && u.dehydrated !== null) {
          if (d.alternate === null)
            throw Error(n(340));
          Ln();
        }
        return u = d.flags, u & 65536 ? (d.flags = u & -65537 | 128, d) : null;
      case 19:
        return bn(Ur), null;
      case 4:
        return va(), null;
      case 10:
        return fa(d.type._context), null;
      case 22:
      case 23:
        return Op(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var rc = !1, so = !1, Gm = typeof WeakSet == "function" ? WeakSet : Set, Cr = null;
  function Gl(u, d) {
    var T = u.ref;
    if (T !== null)
      if (typeof T == "function")
        try {
          T(null);
        } catch (k) {
          Wn(u, d, k);
        }
      else
        T.current = null;
  }
  function nc(u, d, T) {
    try {
      T();
    } catch (k) {
      Wn(u, d, k);
    }
  }
  var Ym = !1;
  function qm(u, d) {
    if (Jf = Ia, u = Gc(), ks(u)) {
      if ("selectionStart" in u)
        var T = { start: u.selectionStart, end: u.selectionEnd };
      else
        e: {
          T = (T = u.ownerDocument) && T.defaultView || window;
          var k = T.getSelection && T.getSelection();
          if (k && k.rangeCount !== 0) {
            T = k.anchorNode;
            var Q = k.anchorOffset, ce = k.focusNode;
            k = k.focusOffset;
            try {
              T.nodeType, ce.nodeType;
            } catch {
              T = null;
              break e;
            }
            var ge = 0, $e = -1, Ne = -1, Xe = 0, Mt = 0, or = u, At = null;
            t:
              for (; ; ) {
                for (var yr; or !== T || Q !== 0 && or.nodeType !== 3 || ($e = ge + Q), or !== ce || k !== 0 && or.nodeType !== 3 || (Ne = ge + k), or.nodeType === 3 && (ge += or.nodeValue.length), (yr = or.firstChild) !== null; )
                  At = or, or = yr;
                for (; ; ) {
                  if (or === u)
                    break t;
                  if (At === T && ++Xe === Q && ($e = ge), At === ce && ++Mt === k && (Ne = ge), (yr = or.nextSibling) !== null)
                    break;
                  or = At, At = or.parentNode;
                }
                or = yr;
              }
            T = $e === -1 || Ne === -1 ? null : { start: $e, end: Ne };
          } else
            T = null;
        }
      T = T || { start: 0, end: 0 };
    } else
      T = null;
    for (Va = { focusedElem: u, selectionRange: T }, Ia = !1, Cr = d; Cr !== null; )
      if (d = Cr, u = d.child, (d.subtreeFlags & 1028) !== 0 && u !== null)
        u.return = d, Cr = u;
      else
        for (; Cr !== null; ) {
          d = Cr;
          try {
            var Pr = d.alternate;
            if (d.flags & 1024)
              switch (d.tag) {
                case 0:
                case 11:
                case 15:
                  break;
                case 1:
                  if (Pr !== null) {
                    var Ar = Pr.memoizedProps, qn = Pr.memoizedState, Ue = d.stateNode, Be = Ue.getSnapshotBeforeUpdate(d.elementType === d.type ? Ar : Ci(d.type, Ar), qn);
                    Ue.__reactInternalSnapshotBeforeUpdate = Be;
                  }
                  break;
                case 3:
                  var Ge = d.stateNode.containerInfo;
                  Ge.nodeType === 1 ? Ge.textContent = "" : Ge.nodeType === 9 && Ge.documentElement && Ge.removeChild(Ge.documentElement);
                  break;
                case 5:
                case 6:
                case 4:
                case 17:
                  break;
                default:
                  throw Error(n(163));
              }
          } catch (lr) {
            Wn(d, d.return, lr);
          }
          if (u = d.sibling, u !== null) {
            u.return = d.return, Cr = u;
            break;
          }
          Cr = d.return;
        }
    return Pr = Ym, Ym = !1, Pr;
  }
  function oc(u, d, T) {
    var k = d.updateQueue;
    if (k = k !== null ? k.lastEffect : null, k !== null) {
      var Q = k = k.next;
      do {
        if ((Q.tag & u) === u) {
          var ce = Q.destroy;
          Q.destroy = void 0, ce !== void 0 && nc(d, T, ce);
        }
        Q = Q.next;
      } while (Q !== k);
    }
  }
  function ic(u, d) {
    if (d = d.updateQueue, d = d !== null ? d.lastEffect : null, d !== null) {
      var T = d = d.next;
      do {
        if ((T.tag & u) === u) {
          var k = T.create;
          T.destroy = k();
        }
        T = T.next;
      } while (T !== d);
    }
  }
  function wp(u) {
    var d = u.ref;
    if (d !== null) {
      var T = u.stateNode;
      switch (u.tag) {
        case 5:
          u = T;
          break;
        default:
          u = T;
      }
      typeof d == "function" ? d(u) : d.current = u;
    }
  }
  function kp(u) {
    var d = u.alternate;
    d !== null && (u.alternate = null, kp(d)), u.child = null, u.deletions = null, u.sibling = null, u.tag === 5 && (d = u.stateNode, d !== null && (delete d[ds], delete d[Ha], delete d[tp], delete d[sg], delete d[rp])), u.stateNode = null, u.return = null, u.dependencies = null, u.memoizedProps = null, u.memoizedState = null, u.pendingProps = null, u.stateNode = null, u.updateQueue = null;
  }
  function Km(u) {
    return u.tag === 5 || u.tag === 3 || u.tag === 4;
  }
  function jd(u) {
    e:
      for (; ; ) {
        for (; u.sibling === null; ) {
          if (u.return === null || Km(u.return))
            return null;
          u = u.return;
        }
        for (u.sibling.return = u.return, u = u.sibling; u.tag !== 5 && u.tag !== 6 && u.tag !== 18; ) {
          if (u.flags & 2 || u.child === null || u.tag === 4)
            continue e;
          u.child.return = u, u = u.child;
        }
        if (!(u.flags & 2))
          return u.stateNode;
      }
  }
  function Yl(u, d, T) {
    var k = u.tag;
    if (k === 5 || k === 6)
      u = u.stateNode, d ? T.nodeType === 8 ? T.parentNode.insertBefore(u, d) : T.insertBefore(u, d) : (T.nodeType === 8 ? (d = T.parentNode, d.insertBefore(u, T)) : (d = T, d.appendChild(u)), T = T._reactRootContainer, T != null || d.onclick !== null || (d.onclick = Jc));
    else if (k !== 4 && (u = u.child, u !== null))
      for (Yl(u, d, T), u = u.sibling; u !== null; )
        Yl(u, d, T), u = u.sibling;
  }
  function ms(u, d, T) {
    var k = u.tag;
    if (k === 5 || k === 6)
      u = u.stateNode, d ? T.insertBefore(u, d) : T.appendChild(u);
    else if (k !== 4 && (u = u.child, u !== null))
      for (ms(u, d, T), u = u.sibling; u !== null; )
        ms(u, d, T), u = u.sibling;
  }
  var In = null, mo = !1;
  function Hi(u, d, T) {
    for (T = T.child; T !== null; )
      ql(u, d, T), T = T.sibling;
  }
  function ql(u, d, T) {
    if (Zi && typeof Zi.onCommitFiberUnmount == "function")
      try {
        Zi.onCommitFiberUnmount(Eu, T);
      } catch {
      }
    switch (T.tag) {
      case 5:
        so || Gl(T, d);
      case 6:
        var k = In, Q = mo;
        In = null, Hi(u, d, T), In = k, mo = Q, In !== null && (mo ? (u = In, T = T.stateNode, u.nodeType === 8 ? u.parentNode.removeChild(T) : u.removeChild(T)) : In.removeChild(T.stateNode));
        break;
      case 18:
        In !== null && (mo ? (u = In, T = T.stateNode, u.nodeType === 8 ? sa(u.parentNode, T) : u.nodeType === 1 && sa(u, T), _u(u)) : sa(In, T.stateNode));
        break;
      case 4:
        k = In, Q = mo, In = T.stateNode.containerInfo, mo = !0, Hi(u, d, T), In = k, mo = Q;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!so && (k = T.updateQueue, k !== null && (k = k.lastEffect, k !== null))) {
          Q = k = k.next;
          do {
            var ce = Q, ge = ce.destroy;
            ce = ce.tag, ge !== void 0 && (ce & 2 || ce & 4) && nc(T, d, ge), Q = Q.next;
          } while (Q !== k);
        }
        Hi(u, d, T);
        break;
      case 1:
        if (!so && (Gl(T, d), k = T.stateNode, typeof k.componentWillUnmount == "function"))
          try {
            k.props = T.memoizedProps, k.state = T.memoizedState, k.componentWillUnmount();
          } catch ($e) {
            Wn(T, d, $e);
          }
        Hi(u, d, T);
        break;
      case 21:
        Hi(u, d, T);
        break;
      case 22:
        T.mode & 1 ? (so = (k = so) || T.memoizedState !== null, Hi(u, d, T), so = k) : Hi(u, d, T);
        break;
      default:
        Hi(u, d, T);
    }
  }
  function Fs(u) {
    var d = u.updateQueue;
    if (d !== null) {
      u.updateQueue = null;
      var T = u.stateNode;
      T === null && (T = u.stateNode = new Gm()), d.forEach(function(k) {
        var Q = xg.bind(null, u, k);
        T.has(k) || (T.add(k), k.then(Q, Q));
      });
    }
  }
  function ss(u, d) {
    var T = d.deletions;
    if (T !== null)
      for (var k = 0; k < T.length; k++) {
        var Q = T[k];
        try {
          var ce = u, ge = d, $e = ge;
          e:
            for (; $e !== null; ) {
              switch ($e.tag) {
                case 5:
                  In = $e.stateNode, mo = !1;
                  break e;
                case 3:
                  In = $e.stateNode.containerInfo, mo = !0;
                  break e;
                case 4:
                  In = $e.stateNode.containerInfo, mo = !0;
                  break e;
              }
              $e = $e.return;
            }
          if (In === null)
            throw Error(n(160));
          ql(ce, ge, Q), In = null, mo = !1;
          var Ne = Q.alternate;
          Ne !== null && (Ne.return = null), Q.return = null;
        } catch (Xe) {
          Wn(Q, d, Xe);
        }
      }
    if (d.subtreeFlags & 12854)
      for (d = d.child; d !== null; )
        Xm(d, u), d = d.sibling;
  }
  function Xm(u, d) {
    var T = u.alternate, k = u.flags;
    switch (u.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (ss(d, u), vs(u), k & 4) {
          try {
            oc(3, u, u.return), ic(3, u);
          } catch (Ar) {
            Wn(u, u.return, Ar);
          }
          try {
            oc(5, u, u.return);
          } catch (Ar) {
            Wn(u, u.return, Ar);
          }
        }
        break;
      case 1:
        ss(d, u), vs(u), k & 512 && T !== null && Gl(T, T.return);
        break;
      case 5:
        if (ss(d, u), vs(u), k & 512 && T !== null && Gl(T, T.return), u.flags & 32) {
          var Q = u.stateNode;
          try {
            tr(Q, "");
          } catch (Ar) {
            Wn(u, u.return, Ar);
          }
        }
        if (k & 4 && (Q = u.stateNode, Q != null)) {
          var ce = u.memoizedProps, ge = T !== null ? T.memoizedProps : ce, $e = u.type, Ne = u.updateQueue;
          if (u.updateQueue = null, Ne !== null)
            try {
              $e === "input" && ce.type === "radio" && ce.name != null && cr(Q, ce), Nr($e, ge);
              var Xe = Nr($e, ce);
              for (ge = 0; ge < Ne.length; ge += 2) {
                var Mt = Ne[ge], or = Ne[ge + 1];
                Mt === "style" ? er(Q, or) : Mt === "dangerouslySetInnerHTML" ? Je(Q, or) : Mt === "children" ? tr(Q, or) : N(Q, Mt, or, Xe);
              }
              switch ($e) {
                case "input":
                  Tr(Q, ce);
                  break;
                case "textarea":
                  tt(Q, ce);
                  break;
                case "select":
                  var At = Q._wrapperState.wasMultiple;
                  Q._wrapperState.wasMultiple = !!ce.multiple;
                  var yr = ce.value;
                  yr != null ? hr(Q, !!ce.multiple, yr, !1) : At !== !!ce.multiple && (ce.defaultValue != null ? hr(
                    Q,
                    !!ce.multiple,
                    ce.defaultValue,
                    !0
                  ) : hr(Q, !!ce.multiple, ce.multiple ? [] : "", !1));
              }
              Q[Ha] = ce;
            } catch (Ar) {
              Wn(u, u.return, Ar);
            }
        }
        break;
      case 6:
        if (ss(d, u), vs(u), k & 4) {
          if (u.stateNode === null)
            throw Error(n(162));
          Q = u.stateNode, ce = u.memoizedProps;
          try {
            Q.nodeValue = ce;
          } catch (Ar) {
            Wn(u, u.return, Ar);
          }
        }
        break;
      case 3:
        if (ss(d, u), vs(u), k & 4 && T !== null && T.memoizedState.isDehydrated)
          try {
            _u(d.containerInfo);
          } catch (Ar) {
            Wn(u, u.return, Ar);
          }
        break;
      case 4:
        ss(d, u), vs(u);
        break;
      case 13:
        ss(d, u), vs(u), Q = u.child, Q.flags & 8192 && (ce = Q.memoizedState !== null, Q.stateNode.isHidden = ce, !ce || Q.alternate !== null && Q.alternate.memoizedState !== null || (jp = yn())), k & 4 && Fs(u);
        break;
      case 22:
        if (Mt = T !== null && T.memoizedState !== null, u.mode & 1 ? (so = (Xe = so) || Mt, ss(d, u), so = Xe) : ss(d, u), vs(u), k & 8192) {
          if (Xe = u.memoizedState !== null, (u.stateNode.isHidden = Xe) && !Mt && u.mode & 1)
            for (Cr = u, Mt = u.child; Mt !== null; ) {
              for (or = Cr = Mt; Cr !== null; ) {
                switch (At = Cr, yr = At.child, At.tag) {
                  case 0:
                  case 11:
                  case 14:
                  case 15:
                    oc(4, At, At.return);
                    break;
                  case 1:
                    Gl(At, At.return);
                    var Pr = At.stateNode;
                    if (typeof Pr.componentWillUnmount == "function") {
                      k = At, T = At.return;
                      try {
                        d = k, Pr.props = d.memoizedProps, Pr.state = d.memoizedState, Pr.componentWillUnmount();
                      } catch (Ar) {
                        Wn(k, T, Ar);
                      }
                    }
                    break;
                  case 5:
                    Gl(At, At.return);
                    break;
                  case 22:
                    if (At.memoizedState !== null) {
                      Ap(or);
                      continue;
                    }
                }
                yr !== null ? (yr.return = At, Cr = yr) : Ap(or);
              }
              Mt = Mt.sibling;
            }
          e:
            for (Mt = null, or = u; ; ) {
              if (or.tag === 5) {
                if (Mt === null) {
                  Mt = or;
                  try {
                    Q = or.stateNode, Xe ? (ce = Q.style, typeof ce.setProperty == "function" ? ce.setProperty("display", "none", "important") : ce.display = "none") : ($e = or.stateNode, Ne = or.memoizedProps.style, ge = Ne != null && Ne.hasOwnProperty("display") ? Ne.display : null, $e.style.display = nr("display", ge));
                  } catch (Ar) {
                    Wn(u, u.return, Ar);
                  }
                }
              } else if (or.tag === 6) {
                if (Mt === null)
                  try {
                    or.stateNode.nodeValue = Xe ? "" : or.memoizedProps;
                  } catch (Ar) {
                    Wn(u, u.return, Ar);
                  }
              } else if ((or.tag !== 22 && or.tag !== 23 || or.memoizedState === null || or === u) && or.child !== null) {
                or.child.return = or, or = or.child;
                continue;
              }
              if (or === u)
                break e;
              for (; or.sibling === null; ) {
                if (or.return === null || or.return === u)
                  break e;
                Mt === or && (Mt = null), or = or.return;
              }
              Mt === or && (Mt = null), or.sibling.return = or.return, or = or.sibling;
            }
        }
        break;
      case 19:
        ss(d, u), vs(u), k & 4 && Fs(u);
        break;
      case 21:
        break;
      default:
        ss(
          d,
          u
        ), vs(u);
    }
  }
  function vs(u) {
    var d = u.flags;
    if (d & 2) {
      try {
        e: {
          for (var T = u.return; T !== null; ) {
            if (Km(T)) {
              var k = T;
              break e;
            }
            T = T.return;
          }
          throw Error(n(160));
        }
        switch (k.tag) {
          case 5:
            var Q = k.stateNode;
            k.flags & 32 && (tr(Q, ""), k.flags &= -33);
            var ce = jd(u);
            ms(u, ce, Q);
            break;
          case 3:
          case 4:
            var ge = k.stateNode.containerInfo, $e = jd(u);
            Yl(u, $e, ge);
            break;
          default:
            throw Error(n(161));
        }
      } catch (Ne) {
        Wn(u, u.return, Ne);
      }
      u.flags &= -3;
    }
    d & 4096 && (u.flags &= -4097);
  }
  function Qm(u, d, T) {
    Cr = u, Kl(u);
  }
  function Kl(u, d, T) {
    for (var k = (u.mode & 1) !== 0; Cr !== null; ) {
      var Q = Cr, ce = Q.child;
      if (Q.tag === 22 && k) {
        var ge = Q.memoizedState !== null || rc;
        if (!ge) {
          var $e = Q.alternate, Ne = $e !== null && $e.memoizedState !== null || so;
          $e = rc;
          var Xe = so;
          if (rc = ge, (so = Ne) && !Xe)
            for (Cr = Q; Cr !== null; )
              ge = Cr, Ne = ge.child, ge.tag === 22 && ge.memoizedState !== null ? Zm(Q) : Ne !== null ? (Ne.return = ge, Cr = Ne) : Zm(Q);
          for (; ce !== null; )
            Cr = ce, Kl(ce), ce = ce.sibling;
          Cr = Q, rc = $e, so = Xe;
        }
        Jm(u);
      } else
        Q.subtreeFlags & 8772 && ce !== null ? (ce.return = Q, Cr = ce) : Jm(u);
    }
  }
  function Jm(u) {
    for (; Cr !== null; ) {
      var d = Cr;
      if (d.flags & 8772) {
        var T = d.alternate;
        try {
          if (d.flags & 8772)
            switch (d.tag) {
              case 0:
              case 11:
              case 15:
                so || ic(5, d);
                break;
              case 1:
                var k = d.stateNode;
                if (d.flags & 4 && !so)
                  if (T === null)
                    k.componentDidMount();
                  else {
                    var Q = d.elementType === d.type ? T.memoizedProps : Ci(d.type, T.memoizedProps);
                    k.componentDidUpdate(Q, T.memoizedState, k.__reactInternalSnapshotBeforeUpdate);
                  }
                var ce = d.updateQueue;
                ce !== null && Ga(d, ce, k);
                break;
              case 3:
                var ge = d.updateQueue;
                if (ge !== null) {
                  if (T = null, d.child !== null)
                    switch (d.child.tag) {
                      case 5:
                        T = d.child.stateNode;
                        break;
                      case 1:
                        T = d.child.stateNode;
                    }
                  Ga(d, ge, T);
                }
                break;
              case 5:
                var $e = d.stateNode;
                if (T === null && d.flags & 4) {
                  T = $e;
                  var Ne = d.memoizedProps;
                  switch (d.type) {
                    case "button":
                    case "input":
                    case "select":
                    case "textarea":
                      Ne.autoFocus && T.focus();
                      break;
                    case "img":
                      Ne.src && (T.src = Ne.src);
                  }
                }
                break;
              case 6:
                break;
              case 4:
                break;
              case 12:
                break;
              case 13:
                if (d.memoizedState === null) {
                  var Xe = d.alternate;
                  if (Xe !== null) {
                    var Mt = Xe.memoizedState;
                    if (Mt !== null) {
                      var or = Mt.dehydrated;
                      or !== null && _u(or);
                    }
                  }
                }
                break;
              case 19:
              case 17:
              case 21:
              case 22:
              case 23:
              case 25:
                break;
              default:
                throw Error(n(163));
            }
          so || d.flags & 512 && wp(d);
        } catch (At) {
          Wn(d, d.return, At);
        }
      }
      if (d === u) {
        Cr = null;
        break;
      }
      if (T = d.sibling, T !== null) {
        T.return = d.return, Cr = T;
        break;
      }
      Cr = d.return;
    }
  }
  function Ap(u) {
    for (; Cr !== null; ) {
      var d = Cr;
      if (d === u) {
        Cr = null;
        break;
      }
      var T = d.sibling;
      if (T !== null) {
        T.return = d.return, Cr = T;
        break;
      }
      Cr = d.return;
    }
  }
  function Zm(u) {
    for (; Cr !== null; ) {
      var d = Cr;
      try {
        switch (d.tag) {
          case 0:
          case 11:
          case 15:
            var T = d.return;
            try {
              ic(4, d);
            } catch (Ne) {
              Wn(d, T, Ne);
            }
            break;
          case 1:
            var k = d.stateNode;
            if (typeof k.componentDidMount == "function") {
              var Q = d.return;
              try {
                k.componentDidMount();
              } catch (Ne) {
                Wn(d, Q, Ne);
              }
            }
            var ce = d.return;
            try {
              wp(d);
            } catch (Ne) {
              Wn(d, ce, Ne);
            }
            break;
          case 5:
            var ge = d.return;
            try {
              wp(d);
            } catch (Ne) {
              Wn(d, ge, Ne);
            }
        }
      } catch (Ne) {
        Wn(d, d.return, Ne);
      }
      if (d === u) {
        Cr = null;
        break;
      }
      var $e = d.sibling;
      if ($e !== null) {
        $e.return = d.return, Cr = $e;
        break;
      }
      Cr = d.return;
    }
  }
  var Md = Math.ceil, sc = B.ReactCurrentDispatcher, $p = B.ReactCurrentOwner, Do = B.ReactCurrentBatchConfig, an = 0, zn = null, Hn = null, vo = 0, Pi = 0, Xl = tn(0), ao = 0, ac = null, Ls = 0, Nd = 0, Ql = 0, ol = null, Vo = null, jp = 0, Jl = 1 / 0, Bs = null, Od = !1, il = null, ys = null, ba = !1, Ta = null, Dd = 0, Zl = 0, Id = null, sl = -1, al = 0;
  function Io() {
    return an & 6 ? yn() : sl !== -1 ? sl : sl = yn();
  }
  function Zn(u) {
    return u.mode & 1 ? an & 2 && vo !== 0 ? vo & -vo : od.transition !== null ? (al === 0 && (al = Nc()), al) : (u = Cn, u !== 0 || (u = window.event, u = u === void 0 ? 16 : jf(u.type)), u) : 1;
  }
  function Fo(u, d, T, k) {
    if (50 < Zl)
      throw Zl = 0, Id = null, Error(n(185));
    Da(u, T, k), (!(an & 2) || u !== zn) && (u === zn && (!(an & 2) && (Nd |= T), ao === 4 && Wi(u, vo)), Lo(u, k), T === 1 && an === 0 && !(d.mode & 1) && (Jl = yn() + 500, po && ni()));
  }
  function Lo(u, d) {
    var T = u.callbackNode;
    Mc(u, d);
    var k = es(u, u === zn ? vo : 0);
    if (k === 0)
      T !== null && zo(T), u.callbackNode = null, u.callbackPriority = 0;
    else if (d = k & -k, u.callbackPriority !== d) {
      if (T != null && zo(T), d === 1)
        u.tag === 0 ? op(ev.bind(null, u)) : np(ev.bind(null, u)), ep(function() {
          !(an & 6) && ni();
        }), T = null;
      else {
        switch (kf(k)) {
          case 1:
            T = Ps;
            break;
          case 4:
            T = sn;
            break;
          case 16:
            T = ta;
            break;
          case 536870912:
            T = Pf;
            break;
          default:
            T = ta;
        }
        T = Fp(T, eu.bind(null, u));
      }
      u.callbackPriority = d, u.callbackNode = T;
    }
  }
  function eu(u, d) {
    if (sl = -1, al = 0, an & 6)
      throw Error(n(327));
    var T = u.callbackNode;
    if (ru() && u.callbackNode !== T)
      return null;
    var k = es(u, u === zn ? vo : 0);
    if (k === 0)
      return null;
    if (k & 30 || k & u.expiredLanes || d)
      d = Ld(u, k);
    else {
      d = k;
      var Q = an;
      an |= 2;
      var ce = Fd();
      (zn !== u || vo !== d) && (Bs = null, Jl = yn() + 500, ll(u, d));
      do
        try {
          mg();
          break;
        } catch ($e) {
          tv(u, $e);
        }
      while (1);
      cp(), sc.current = ce, an = Q, Hn !== null ? d = 0 : (zn = null, vo = 0, d = ao);
    }
    if (d !== 0) {
      if (d === 2 && (Q = _f(u), Q !== 0 && (k = Q, d = Mp(u, Q))), d === 1)
        throw T = ac, ll(u, 0), Wi(u, k), Lo(u, yn()), T;
      if (d === 6)
        Wi(u, k);
      else {
        if (Q = u.current.alternate, !(k & 30) && !Np(Q) && (d = Ld(u, k), d === 2 && (ce = _f(u), ce !== 0 && (k = ce, d = Mp(u, ce))), d === 1))
          throw T = ac, ll(u, 0), Wi(u, k), Lo(u, yn()), T;
        switch (u.finishedWork = Q, u.finishedLanes = k, d) {
          case 0:
          case 1:
            throw Error(n(345));
          case 2:
            ul(u, Vo, Bs);
            break;
          case 3:
            if (Wi(u, k), (k & 130023424) === k && (d = jp + 500 - yn(), 10 < d)) {
              if (es(u, 0) !== 0)
                break;
              if (Q = u.suspendedLanes, (Q & k) !== k) {
                Io(), u.pingedLanes |= u.suspendedLanes & Q;
                break;
              }
              u.timeoutHandle = Ua(ul.bind(null, u, Vo, Bs), d);
              break;
            }
            ul(u, Vo, Bs);
            break;
          case 4:
            if (Wi(u, k), (k & 4194240) === k)
              break;
            for (d = u.eventTimes, Q = -1; 0 < k; ) {
              var ge = 31 - ji(k);
              ce = 1 << ge, ge = d[ge], ge > Q && (Q = ge), k &= ~ce;
            }
            if (k = Q, k = yn() - k, k = (120 > k ? 120 : 480 > k ? 480 : 1080 > k ? 1080 : 1920 > k ? 1920 : 3e3 > k ? 3e3 : 4320 > k ? 4320 : 1960 * Md(k / 1960)) - k, 10 < k) {
              u.timeoutHandle = Ua(ul.bind(null, u, Vo, Bs), k);
              break;
            }
            ul(u, Vo, Bs);
            break;
          case 5:
            ul(u, Vo, Bs);
            break;
          default:
            throw Error(n(329));
        }
      }
    }
    return Lo(u, yn()), u.callbackNode === T ? eu.bind(null, u) : null;
  }
  function Mp(u, d) {
    var T = ol;
    return u.current.memoizedState.isDehydrated && (ll(u, d).flags |= 256), u = Ld(u, d), u !== 2 && (d = Vo, Vo = T, d !== null && lc(d)), u;
  }
  function lc(u) {
    Vo === null ? Vo = u : Vo.push.apply(Vo, u);
  }
  function Np(u) {
    for (var d = u; ; ) {
      if (d.flags & 16384) {
        var T = d.updateQueue;
        if (T !== null && (T = T.stores, T !== null))
          for (var k = 0; k < T.length; k++) {
            var Q = T[k], ce = Q.getSnapshot;
            Q = Q.value;
            try {
              if (!Oi(ce(), Q))
                return !1;
            } catch {
              return !1;
            }
          }
      }
      if (T = d.child, d.subtreeFlags & 16384 && T !== null)
        T.return = d, d = T;
      else {
        if (d === u)
          break;
        for (; d.sibling === null; ) {
          if (d.return === null || d.return === u)
            return !0;
          d = d.return;
        }
        d.sibling.return = d.return, d = d.sibling;
      }
    }
    return !0;
  }
  function Wi(u, d) {
    for (d &= ~Ql, d &= ~Nd, u.suspendedLanes |= d, u.pingedLanes &= ~d, u = u.expirationTimes; 0 < d; ) {
      var T = 31 - ji(d), k = 1 << T;
      u[T] = -1, d &= ~k;
    }
  }
  function ev(u) {
    if (an & 6)
      throw Error(n(327));
    ru();
    var d = es(u, 0);
    if (!(d & 1))
      return Lo(u, yn()), null;
    var T = Ld(u, d);
    if (u.tag !== 0 && T === 2) {
      var k = _f(u);
      k !== 0 && (d = k, T = Mp(u, k));
    }
    if (T === 1)
      throw T = ac, ll(u, 0), Wi(u, d), Lo(u, yn()), T;
    if (T === 6)
      throw Error(n(345));
    return u.finishedWork = u.current.alternate, u.finishedLanes = d, ul(u, Vo, Bs), Lo(u, yn()), null;
  }
  function tu(u, d) {
    var T = an;
    an |= 1;
    try {
      return u(d);
    } finally {
      an = T, an === 0 && (Jl = yn() + 500, po && ni());
    }
  }
  function Ea(u) {
    Ta !== null && Ta.tag === 0 && !(an & 6) && ru();
    var d = an;
    an |= 1;
    var T = Do.transition, k = Cn;
    try {
      if (Do.transition = null, Cn = 1, u)
        return u();
    } finally {
      Cn = k, Do.transition = T, an = d, !(an & 6) && ni();
    }
  }
  function Op() {
    Pi = Xl.current, bn(Xl);
  }
  function ll(u, d) {
    u.finishedWork = null, u.finishedLanes = 0;
    var T = u.timeoutHandle;
    if (T !== -1 && (u.timeoutHandle = -1, wm(T)), Hn !== null)
      for (T = Hn.return; T !== null; ) {
        var k = T;
        switch (sp(k), k.tag) {
          case 1:
            k = k.type.childContextTypes, k != null && Fi();
            break;
          case 3:
            va(), bn(Un), bn(Kr), cd();
            break;
          case 5:
            nn(k);
            break;
          case 4:
            va();
            break;
          case 13:
            bn(Ur);
            break;
          case 19:
            bn(Ur);
            break;
          case 10:
            fa(k.type._context);
            break;
          case 22:
          case 23:
            Op();
        }
        T = T.return;
      }
    if (zn = u, Hn = u = Ca(u.current, null), vo = Pi = d, ao = 0, ac = null, Ql = Nd = Ls = 0, Vo = ol = null, bo !== null) {
      for (d = 0; d < bo.length; d++)
        if (T = bo[d], k = T.interleaved, k !== null) {
          T.interleaved = null;
          var Q = k.next, ce = T.pending;
          if (ce !== null) {
            var ge = ce.next;
            ce.next = Q, k.next = ge;
          }
          T.pending = k;
        }
      bo = null;
    }
    return u;
  }
  function tv(u, d) {
    do {
      var T = Hn;
      try {
        if (cp(), dd.current = _d, Wr) {
          for (var k = Mn.memoizedState; k !== null; ) {
            var Q = k.queue;
            Q !== null && (Q.pending = null), k = k.next;
          }
          Wr = !1;
        }
        if (qa = 0, un = mt = Mn = null, hs = !1, Si = 0, $p.current = null, T === null || T.return === null) {
          ao = 1, ac = d, Hn = null;
          break;
        }
        e: {
          var ce = u, ge = T.return, $e = T, Ne = d;
          if (d = vo, $e.flags |= 32768, Ne !== null && typeof Ne == "object" && typeof Ne.then == "function") {
            var Xe = Ne, Mt = $e, or = Mt.tag;
            if (!(Mt.mode & 1) && (or === 0 || or === 11 || or === 15)) {
              var At = Mt.alternate;
              At ? (Mt.updateQueue = At.updateQueue, Mt.memoizedState = At.memoizedState, Mt.lanes = At.lanes) : (Mt.updateQueue = null, Mt.memoizedState = null);
            }
            var yr = xp(ge);
            if (yr !== null) {
              yr.flags &= -257, bp(yr, ge, $e, ce, d), yr.mode & 1 && Um(ce, Xe, d), d = yr, Ne = Xe;
              var Pr = d.updateQueue;
              if (Pr === null) {
                var Ar = /* @__PURE__ */ new Set();
                Ar.add(Ne), d.updateQueue = Ar;
              } else
                Pr.add(Ne);
              break e;
            } else {
              if (!(d & 1)) {
                Um(ce, Xe, d), Dp();
                break e;
              }
              Ne = Error(n(426));
            }
          } else if (jn && $e.mode & 1) {
            var qn = xp(ge);
            if (qn !== null) {
              !(qn.flags & 65536) && (qn.flags |= 256), bp(qn, ge, $e, ce, d), lp(Ul(Ne, $e));
              break e;
            }
          }
          ce = Ne = Ul(Ne, $e), ao !== 4 && (ao = 2), ol === null ? ol = [ce] : ol.push(ce), ce = ge;
          do {
            switch (ce.tag) {
              case 3:
                ce.flags |= 65536, d &= -d, ce.lanes |= d;
                var Ue = Vm(ce, Ne, d);
                pp(ce, Ue);
                break e;
              case 1:
                $e = Ne;
                var Be = ce.type, Ge = ce.stateNode;
                if (!(ce.flags & 128) && (typeof Be.getDerivedStateFromError == "function" || Ge !== null && typeof Ge.componentDidCatch == "function" && (ys === null || !ys.has(Ge)))) {
                  ce.flags |= 65536, d &= -d, ce.lanes |= d;
                  var lr = Zu(ce, $e, d);
                  pp(ce, lr);
                  break e;
                }
            }
            ce = ce.return;
          } while (ce !== null);
        }
        Ip(T);
      } catch (Mr) {
        d = Mr, Hn === T && T !== null && (Hn = T = T.return);
        continue;
      }
      break;
    } while (1);
  }
  function Fd() {
    var u = sc.current;
    return sc.current = _d, u === null ? _d : u;
  }
  function Dp() {
    (ao === 0 || ao === 3 || ao === 2) && (ao = 4), zn === null || !(Ls & 268435455) && !(Nd & 268435455) || Wi(zn, vo);
  }
  function Ld(u, d) {
    var T = an;
    an |= 2;
    var k = Fd();
    (zn !== u || vo !== d) && (Bs = null, ll(u, d));
    do
      try {
        hg();
        break;
      } catch (Q) {
        tv(u, Q);
      }
    while (1);
    if (cp(), an = T, sc.current = k, Hn !== null)
      throw Error(n(261));
    return zn = null, vo = 0, ao;
  }
  function hg() {
    for (; Hn !== null; )
      rv(Hn);
  }
  function mg() {
    for (; Hn !== null && !ea(); )
      rv(Hn);
  }
  function rv(u) {
    var d = ov(u.alternate, u, Pi);
    u.memoizedProps = u.pendingProps, d === null ? Ip(u) : Hn = d, $p.current = null;
  }
  function Ip(u) {
    var d = u;
    do {
      var T = d.alternate;
      if (u = d.return, d.flags & 32768) {
        if (T = _p(T, d), T !== null) {
          T.flags &= 32767, Hn = T;
          return;
        }
        if (u !== null)
          u.flags |= 32768, u.subtreeFlags = 0, u.deletions = null;
        else {
          ao = 6, Hn = null;
          return;
        }
      } else if (T = pg(T, d, Pi), T !== null) {
        Hn = T;
        return;
      }
      if (d = d.sibling, d !== null) {
        Hn = d;
        return;
      }
      Hn = d = u;
    } while (d !== null);
    ao === 0 && (ao = 5);
  }
  function ul(u, d, T) {
    var k = Cn, Q = Do.transition;
    try {
      Do.transition = null, Cn = 1, vg(u, d, T, k);
    } finally {
      Do.transition = Q, Cn = k;
    }
    return null;
  }
  function vg(u, d, T, k) {
    do
      ru();
    while (Ta !== null);
    if (an & 6)
      throw Error(n(327));
    T = u.finishedWork;
    var Q = u.finishedLanes;
    if (T === null)
      return null;
    if (u.finishedWork = null, u.finishedLanes = 0, T === u.current)
      throw Error(n(177));
    u.callbackNode = null, u.callbackPriority = 0;
    var ce = T.lanes | T.childLanes;
    if (Vy(u, ce), u === zn && (Hn = zn = null, vo = 0), !(T.subtreeFlags & 2064) && !(T.flags & 2064) || ba || (ba = !0, Fp(ta, function() {
      return ru(), null;
    })), ce = (T.flags & 15990) !== 0, T.subtreeFlags & 15990 || ce) {
      ce = Do.transition, Do.transition = null;
      var ge = Cn;
      Cn = 1;
      var $e = an;
      an |= 4, $p.current = null, qm(u, T), Xm(T, u), Yc(Va), Ia = !!Jf, Va = Jf = null, u.current = T, Qm(T), $c(), an = $e, Cn = ge, Do.transition = ce;
    } else
      u.current = T;
    if (ba && (ba = !1, Ta = u, Dd = Q), ce = u.pendingLanes, ce === 0 && (ys = null), Vh(T.stateNode), Lo(u, yn()), d !== null)
      for (k = u.onRecoverableError, T = 0; T < d.length; T++)
        Q = d[T], k(Q.value, { componentStack: Q.stack, digest: Q.digest });
    if (Od)
      throw Od = !1, u = il, il = null, u;
    return Dd & 1 && u.tag !== 0 && ru(), ce = u.pendingLanes, ce & 1 ? u === Id ? Zl++ : (Zl = 0, Id = u) : Zl = 0, ni(), null;
  }
  function ru() {
    if (Ta !== null) {
      var u = kf(Dd), d = Do.transition, T = Cn;
      try {
        if (Do.transition = null, Cn = 16 > u ? 16 : u, Ta === null)
          var k = !1;
        else {
          if (u = Ta, Ta = null, Dd = 0, an & 6)
            throw Error(n(331));
          var Q = an;
          for (an |= 4, Cr = u.current; Cr !== null; ) {
            var ce = Cr, ge = ce.child;
            if (Cr.flags & 16) {
              var $e = ce.deletions;
              if ($e !== null) {
                for (var Ne = 0; Ne < $e.length; Ne++) {
                  var Xe = $e[Ne];
                  for (Cr = Xe; Cr !== null; ) {
                    var Mt = Cr;
                    switch (Mt.tag) {
                      case 0:
                      case 11:
                      case 15:
                        oc(8, Mt, ce);
                    }
                    var or = Mt.child;
                    if (or !== null)
                      or.return = Mt, Cr = or;
                    else
                      for (; Cr !== null; ) {
                        Mt = Cr;
                        var At = Mt.sibling, yr = Mt.return;
                        if (kp(Mt), Mt === Xe) {
                          Cr = null;
                          break;
                        }
                        if (At !== null) {
                          At.return = yr, Cr = At;
                          break;
                        }
                        Cr = yr;
                      }
                  }
                }
                var Pr = ce.alternate;
                if (Pr !== null) {
                  var Ar = Pr.child;
                  if (Ar !== null) {
                    Pr.child = null;
                    do {
                      var qn = Ar.sibling;
                      Ar.sibling = null, Ar = qn;
                    } while (Ar !== null);
                  }
                }
                Cr = ce;
              }
            }
            if (ce.subtreeFlags & 2064 && ge !== null)
              ge.return = ce, Cr = ge;
            else
              e:
                for (; Cr !== null; ) {
                  if (ce = Cr, ce.flags & 2048)
                    switch (ce.tag) {
                      case 0:
                      case 11:
                      case 15:
                        oc(9, ce, ce.return);
                    }
                  var Ue = ce.sibling;
                  if (Ue !== null) {
                    Ue.return = ce.return, Cr = Ue;
                    break e;
                  }
                  Cr = ce.return;
                }
          }
          var Be = u.current;
          for (Cr = Be; Cr !== null; ) {
            ge = Cr;
            var Ge = ge.child;
            if (ge.subtreeFlags & 2064 && Ge !== null)
              Ge.return = ge, Cr = Ge;
            else
              e:
                for (ge = Be; Cr !== null; ) {
                  if ($e = Cr, $e.flags & 2048)
                    try {
                      switch ($e.tag) {
                        case 0:
                        case 11:
                        case 15:
                          ic(9, $e);
                      }
                    } catch (Mr) {
                      Wn($e, $e.return, Mr);
                    }
                  if ($e === ge) {
                    Cr = null;
                    break e;
                  }
                  var lr = $e.sibling;
                  if (lr !== null) {
                    lr.return = $e.return, Cr = lr;
                    break e;
                  }
                  Cr = $e.return;
                }
          }
          if (an = Q, ni(), Zi && typeof Zi.onPostCommitFiberRoot == "function")
            try {
              Zi.onPostCommitFiberRoot(Eu, u);
            } catch {
            }
          k = !0;
        }
        return k;
      } finally {
        Cn = T, Do.transition = d;
      }
    }
    return !1;
  }
  function nv(u, d, T) {
    d = Ul(T, d), d = Vm(u, d, 1), u = ha(u, d, 1), d = Io(), u !== null && (Da(u, 1, d), Lo(u, d));
  }
  function Wn(u, d, T) {
    if (u.tag === 3)
      nv(u, u, T);
    else
      for (; d !== null; ) {
        if (d.tag === 3) {
          nv(d, u, T);
          break;
        } else if (d.tag === 1) {
          var k = d.stateNode;
          if (typeof d.type.getDerivedStateFromError == "function" || typeof k.componentDidCatch == "function" && (ys === null || !ys.has(k))) {
            u = Ul(T, u), u = Zu(d, u, 1), d = ha(d, u, 1), u = Io(), d !== null && (Da(d, 1, u), Lo(d, u));
            break;
          }
        }
        d = d.return;
      }
  }
  function yg(u, d, T) {
    var k = u.pingCache;
    k !== null && k.delete(d), d = Io(), u.pingedLanes |= u.suspendedLanes & T, zn === u && (vo & T) === T && (ao === 4 || ao === 3 && (vo & 130023424) === vo && 500 > yn() - jp ? ll(u, 0) : Ql |= T), Lo(u, d);
  }
  function Bd(u, d) {
    d === 0 && (u.mode & 1 ? (d = Sl, Sl <<= 1, !(Sl & 130023424) && (Sl = 4194304)) : d = 1);
    var T = Io();
    u = Ns(u, d), u !== null && (Da(u, d, T), Lo(u, T));
  }
  function gg(u) {
    var d = u.memoizedState, T = 0;
    d !== null && (T = d.retryLane), Bd(u, T);
  }
  function xg(u, d) {
    var T = 0;
    switch (u.tag) {
      case 13:
        var k = u.stateNode, Q = u.memoizedState;
        Q !== null && (T = Q.retryLane);
        break;
      case 19:
        k = u.stateNode;
        break;
      default:
        throw Error(n(314));
    }
    k !== null && k.delete(d), Bd(u, T);
  }
  var ov;
  ov = function(u, d, T) {
    if (u !== null)
      if (u.memoizedProps !== d.pendingProps || Un.current)
        Jn = !0;
      else {
        if (!(u.lanes & T) && !(d.flags & 128))
          return Jn = !1, Is(u, d, T);
        Jn = !!(u.flags & 131072);
      }
    else
      Jn = !1, jn && d.flags & 1048576 && ip(d, Dl, d.index);
    switch (d.lanes = 0, d.tag) {
      case 2:
        var k = d.type;
        No(u, d), u = d.pendingProps;
        var Q = Ii(d, Kr.current);
        dr(d, T), Q = ya(null, d, k, u, Q, T);
        var ce = Qa();
        return d.flags |= 1, typeof Q == "object" && Q !== null && typeof Q.render == "function" && Q.$$typeof === void 0 ? (d.tag = 1, d.memoizedState = null, d.updateQueue = null, Dn(k) ? (ce = !0, Zc(d)) : ce = !1, d.memoizedState = Q.state !== null && Q.state !== void 0 ? Q.state : null, fp(d), Q.updater = ad, d.stateNode = Q, Q._reactInternals = d, ld(d, k, u, T), d = Hm(null, d, k, !0, ce, T)) : (d.tag = 0, jn && ce && ed(d), oo(null, d, Q, T), d = d.child), d;
      case 16:
        k = d.elementType;
        e: {
          switch (No(u, d), u = d.pendingProps, Q = k._init, k = Q(k._payload), d.type = k, Q = d.tag = Tg(k), u = Ci(k, u), Q) {
            case 0:
              d = Hl(null, d, k, u, T);
              break e;
            case 1:
              d = Tp(null, d, k, u, T);
              break e;
            case 11:
              d = xa(null, d, k, u, T);
              break e;
            case 14:
              d = kd(null, d, k, Ci(k.type, u), T);
              break e;
          }
          throw Error(n(
            306,
            k,
            ""
          ));
        }
        return d;
      case 0:
        return k = d.type, Q = d.pendingProps, Q = d.elementType === k ? Q : Ci(k, Q), Hl(u, d, k, Q, T);
      case 1:
        return k = d.type, Q = d.pendingProps, Q = d.elementType === k ? Q : Ci(k, Q), Tp(u, d, k, Q, T);
      case 3:
        e: {
          if (Wm(d), u === null)
            throw Error(n(387));
          k = d.pendingProps, ce = d.memoizedState, Q = ce.element, no(u, d), ma(d, k, null, T);
          var ge = d.memoizedState;
          if (k = ge.element, ce.isDehydrated)
            if (ce = { element: k, isDehydrated: !1, cache: ge.cache, pendingSuspenseBoundaries: ge.pendingSuspenseBoundaries, transitions: ge.transitions }, d.updateQueue.baseState = ce, d.memoizedState = ce, d.flags & 256) {
              Q = Ul(Error(n(423)), d), d = Ad(u, d, k, T, Q);
              break e;
            } else if (k !== Q) {
              Q = Ul(Error(n(424)), d), d = Ad(u, d, k, T, Q);
              break e;
            } else
              for (si = os(d.stateNode.containerInfo.firstChild), Ei = d, jn = !0, Bi = null, T = Bm(d, null, k, T), d.child = T; T; )
                T.flags = T.flags & -3 | 4096, T = T.sibling;
          else {
            if (Ln(), k === Q) {
              d = To(u, d, T);
              break e;
            }
            oo(u, d, k, T);
          }
          d = d.child;
        }
        return d;
      case 5:
        return Vr(d), u === null && rd(d), k = d.type, Q = d.pendingProps, ce = u !== null ? u.memoizedProps : null, ge = Q.children, zu(k, Q) ? ge = null : ce !== null && zu(k, ce) && (d.flags |= 32), rn(u, d), oo(u, d, ge, T), d.child;
      case 6:
        return u === null && rd(d), null;
      case 13:
        return Cp(u, d, T);
      case 4:
        return mp(d, d.stateNode.containerInfo), k = d.pendingProps, u === null ? d.child = Fl(d, null, k, T) : oo(u, d, k, T), d.child;
      case 11:
        return k = d.type, Q = d.pendingProps, Q = d.elementType === k ? Q : Ci(k, Q), xa(u, d, k, Q, T);
      case 7:
        return oo(u, d, d.pendingProps, T), d.child;
      case 8:
        return oo(u, d, d.pendingProps.children, T), d.child;
      case 12:
        return oo(u, d, d.pendingProps.children, T), d.child;
      case 10:
        e: {
          if (k = d.type._context, Q = d.pendingProps, ce = d.memoizedProps, ge = Q.value, Tn(ps, k._currentValue), k._currentValue = ge, ce !== null)
            if (Oi(ce.value, ge)) {
              if (ce.children === Q.children && !Un.current) {
                d = To(u, d, T);
                break e;
              }
            } else
              for (ce = d.child, ce !== null && (ce.return = d); ce !== null; ) {
                var $e = ce.dependencies;
                if ($e !== null) {
                  ge = ce.child;
                  for (var Ne = $e.firstContext; Ne !== null; ) {
                    if (Ne.context === k) {
                      if (ce.tag === 1) {
                        Ne = Os(-1, T & -T), Ne.tag = 2;
                        var Xe = ce.updateQueue;
                        if (Xe !== null) {
                          Xe = Xe.shared;
                          var Mt = Xe.pending;
                          Mt === null ? Ne.next = Ne : (Ne.next = Mt.next, Mt.next = Ne), Xe.pending = Ne;
                        }
                      }
                      ce.lanes |= T, Ne = ce.alternate, Ne !== null && (Ne.lanes |= T), ho(
                        ce.return,
                        T,
                        d
                      ), $e.lanes |= T;
                      break;
                    }
                    Ne = Ne.next;
                  }
                } else if (ce.tag === 10)
                  ge = ce.type === d.type ? null : ce.child;
                else if (ce.tag === 18) {
                  if (ge = ce.return, ge === null)
                    throw Error(n(341));
                  ge.lanes |= T, $e = ge.alternate, $e !== null && ($e.lanes |= T), ho(ge, T, d), ge = ce.sibling;
                } else
                  ge = ce.child;
                if (ge !== null)
                  ge.return = ce;
                else
                  for (ge = ce; ge !== null; ) {
                    if (ge === d) {
                      ge = null;
                      break;
                    }
                    if (ce = ge.sibling, ce !== null) {
                      ce.return = ge.return, ge = ce;
                      break;
                    }
                    ge = ge.return;
                  }
                ce = ge;
              }
          oo(u, d, Q.children, T), d = d.child;
        }
        return d;
      case 9:
        return Q = d.type, k = d.pendingProps.children, dr(d, T), Q = Yn(Q), k = k(Q), d.flags |= 1, oo(u, d, k, T), d.child;
      case 14:
        return k = d.type, Q = Ci(k, d.pendingProps), Q = Ci(k.type, Q), kd(u, d, k, Q, T);
      case 15:
        return ui(u, d, d.type, d.pendingProps, T);
      case 17:
        return k = d.type, Q = d.pendingProps, Q = d.elementType === k ? Q : Ci(k, Q), No(u, d), d.tag = 1, Dn(k) ? (u = !0, Zc(d)) : u = !1, dr(d, T), Dm(d, k, Q), ld(d, k, Q, T), Hm(null, d, k, !0, u, T);
      case 19:
        return Rp(u, d, T);
      case 22:
        return tl(u, d, T);
    }
    throw Error(n(156, d.tag));
  };
  function Fp(u, d) {
    return on(u, d);
  }
  function bg(u, d, T, k) {
    this.tag = u, this.key = T, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = d, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = k, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function Gi(u, d, T, k) {
    return new bg(u, d, T, k);
  }
  function Lp(u) {
    return u = u.prototype, !(!u || !u.isReactComponent);
  }
  function Tg(u) {
    if (typeof u == "function")
      return Lp(u) ? 1 : 0;
    if (u != null) {
      if (u = u.$$typeof, u === Re)
        return 11;
      if (u === we)
        return 14;
    }
    return 2;
  }
  function Ca(u, d) {
    var T = u.alternate;
    return T === null ? (T = Gi(u.tag, d, u.key, u.mode), T.elementType = u.elementType, T.type = u.type, T.stateNode = u.stateNode, T.alternate = u, u.alternate = T) : (T.pendingProps = d, T.type = u.type, T.flags = 0, T.subtreeFlags = 0, T.deletions = null), T.flags = u.flags & 14680064, T.childLanes = u.childLanes, T.lanes = u.lanes, T.child = u.child, T.memoizedProps = u.memoizedProps, T.memoizedState = u.memoizedState, T.updateQueue = u.updateQueue, d = u.dependencies, T.dependencies = d === null ? null : { lanes: d.lanes, firstContext: d.firstContext }, T.sibling = u.sibling, T.index = u.index, T.ref = u.ref, T;
  }
  function zd(u, d, T, k, Q, ce) {
    var ge = 2;
    if (k = u, typeof u == "function")
      Lp(u) && (ge = 1);
    else if (typeof u == "string")
      ge = 5;
    else
      e:
        switch (u) {
          case de:
            return cl(T.children, Q, ce, d);
          case ve:
            ge = 8, Q |= 8;
            break;
          case Te:
            return u = Gi(12, T, d, Q | 2), u.elementType = Te, u.lanes = ce, u;
          case ke:
            return u = Gi(13, T, d, Q), u.elementType = ke, u.lanes = ce, u;
          case Ae:
            return u = Gi(19, T, d, Q), u.elementType = Ae, u.lanes = ce, u;
          case be:
            return uc(T, Q, ce, d);
          default:
            if (typeof u == "object" && u !== null)
              switch (u.$$typeof) {
                case Pe:
                  ge = 10;
                  break e;
                case Ce:
                  ge = 9;
                  break e;
                case Re:
                  ge = 11;
                  break e;
                case we:
                  ge = 14;
                  break e;
                case he:
                  ge = 16, k = null;
                  break e;
              }
            throw Error(n(130, u == null ? u : typeof u, ""));
        }
    return d = Gi(ge, T, d, Q), d.elementType = u, d.type = k, d.lanes = ce, d;
  }
  function cl(u, d, T, k) {
    return u = Gi(7, u, k, d), u.lanes = T, u;
  }
  function uc(u, d, T, k) {
    return u = Gi(22, u, k, d), u.elementType = be, u.lanes = T, u.stateNode = { isHidden: !1 }, u;
  }
  function cc(u, d, T) {
    return u = Gi(6, u, null, d), u.lanes = T, u;
  }
  function dl(u, d, T) {
    return d = Gi(4, u.children !== null ? u.children : [], u.key, d), d.lanes = T, d.stateNode = { containerInfo: u.containerInfo, pendingChildren: null, implementation: u.implementation }, d;
  }
  function Eg(u, d, T, k, Q) {
    this.tag = d, this.containerInfo = u, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = wf(0), this.expirationTimes = wf(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = wf(0), this.identifierPrefix = k, this.onRecoverableError = Q, this.mutableSourceEagerHydrationData = null;
  }
  function Vd(u, d, T, k, Q, ce, ge, $e, Ne) {
    return u = new Eg(u, d, T, $e, Ne), d === 1 ? (d = 1, ce === !0 && (d |= 8)) : d = 0, ce = Gi(3, null, null, d), u.current = ce, ce.stateNode = u, ce.memoizedState = { element: k, isDehydrated: T, cache: null, transitions: null, pendingSuspenseBoundaries: null }, fp(ce), u;
  }
  function iv(u, d, T) {
    var k = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: ue, key: k == null ? null : "" + k, children: u, containerInfo: d, implementation: T };
  }
  function Bp(u) {
    if (!u)
      return fs;
    u = u._reactInternals;
    e: {
      if (Qr(u) !== u || u.tag !== 1)
        throw Error(n(170));
      var d = u;
      do {
        switch (d.tag) {
          case 3:
            d = d.stateNode.context;
            break e;
          case 1:
            if (Dn(d.type)) {
              d = d.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        d = d.return;
      } while (d !== null);
      throw Error(n(171));
    }
    if (u.tag === 1) {
      var T = u.type;
      if (Dn(T))
        return Hu(u, T, d);
    }
    return d;
  }
  function sv(u, d, T, k, Q, ce, ge, $e, Ne) {
    return u = Vd(T, k, !0, u, Q, ce, ge, $e, Ne), u.context = Bp(null), T = u.current, k = Io(), Q = Zn(T), ce = Os(k, Q), ce.callback = d ?? null, ha(T, ce, Q), u.current.lanes = Q, Da(u, Q, k), Lo(u, k), u;
  }
  function dc(u, d, T, k) {
    var Q = d.current, ce = Io(), ge = Zn(Q);
    return T = Bp(T), d.context === null ? d.context = T : d.pendingContext = T, d = Os(ce, ge), d.payload = { element: u }, k = k === void 0 ? null : k, k !== null && (d.callback = k), u = ha(Q, d, ge), u !== null && (Fo(u, Q, ge, ce), sd(u, Q, ge)), ge;
  }
  function Ud(u) {
    if (u = u.current, !u.child)
      return null;
    switch (u.child.tag) {
      case 5:
        return u.child.stateNode;
      default:
        return u.child.stateNode;
    }
  }
  function av(u, d) {
    if (u = u.memoizedState, u !== null && u.dehydrated !== null) {
      var T = u.retryLane;
      u.retryLane = T !== 0 && T < d ? T : d;
    }
  }
  function zp(u, d) {
    av(u, d), (u = u.alternate) && av(u, d);
  }
  function lv() {
    return null;
  }
  var Vp = typeof reportError == "function" ? reportError : function(u) {
    console.error(u);
  };
  function Hd(u) {
    this._internalRoot = u;
  }
  zs.prototype.render = Hd.prototype.render = function(u) {
    var d = this._internalRoot;
    if (d === null)
      throw Error(n(409));
    dc(u, d, null, null);
  }, zs.prototype.unmount = Hd.prototype.unmount = function() {
    var u = this._internalRoot;
    if (u !== null) {
      this._internalRoot = null;
      var d = u.containerInfo;
      Ea(function() {
        dc(null, u, null, null);
      }), d[js] = null;
    }
  };
  function zs(u) {
    this._internalRoot = u;
  }
  zs.prototype.unstable_scheduleHydration = function(u) {
    if (u) {
      var d = Gh();
      u = { blockedOn: null, target: u, priority: d };
      for (var T = 0; T < Sn.length && d !== 0 && d < Sn[T].priority; T++)
        ;
      Sn.splice(T, 0, u), T === 0 && Yh(u);
    }
  };
  function Up(u) {
    return !(!u || u.nodeType !== 1 && u.nodeType !== 9 && u.nodeType !== 11);
  }
  function Wd(u) {
    return !(!u || u.nodeType !== 1 && u.nodeType !== 9 && u.nodeType !== 11 && (u.nodeType !== 8 || u.nodeValue !== " react-mount-point-unstable "));
  }
  function uv() {
  }
  function Cg(u, d, T, k, Q) {
    if (Q) {
      if (typeof k == "function") {
        var ce = k;
        k = function() {
          var Xe = Ud(ge);
          ce.call(Xe);
        };
      }
      var ge = sv(d, k, u, 0, null, !1, !1, "", uv);
      return u._reactRootContainer = ge, u[js] = ge.current, Nl(u.nodeType === 8 ? u.parentNode : u), Ea(), ge;
    }
    for (; Q = u.lastChild; )
      u.removeChild(Q);
    if (typeof k == "function") {
      var $e = k;
      k = function() {
        var Xe = Ud(Ne);
        $e.call(Xe);
      };
    }
    var Ne = Vd(u, 0, !1, null, null, !1, !1, "", uv);
    return u._reactRootContainer = Ne, u[js] = Ne.current, Nl(u.nodeType === 8 ? u.parentNode : u), Ea(function() {
      dc(d, Ne, T, k);
    }), Ne;
  }
  function Gd(u, d, T, k, Q) {
    var ce = T._reactRootContainer;
    if (ce) {
      var ge = ce;
      if (typeof Q == "function") {
        var $e = Q;
        Q = function() {
          var Ne = Ud(ge);
          $e.call(Ne);
        };
      }
      dc(d, ge, u, Q);
    } else
      ge = Cg(T, d, u, Q, k);
    return Ud(ge);
  }
  Wh = function(u) {
    switch (u.tag) {
      case 3:
        var d = u.stateNode;
        if (d.current.memoizedState.isDehydrated) {
          var T = Oa(d.pendingLanes);
          T !== 0 && (Cu(d, T | 1), Lo(d, yn()), !(an & 6) && (Jl = yn() + 500, ni()));
        }
        break;
      case 13:
        Ea(function() {
          var k = Ns(u, 1);
          if (k !== null) {
            var Q = Io();
            Fo(k, u, 1, Q);
          }
        }), zp(u, 1);
    }
  }, Oc = function(u) {
    if (u.tag === 13) {
      var d = Ns(u, 134217728);
      if (d !== null) {
        var T = Io();
        Fo(d, u, 134217728, T);
      }
      zp(u, 134217728);
    }
  }, _n = function(u) {
    if (u.tag === 13) {
      var d = Zn(u), T = Ns(u, d);
      if (T !== null) {
        var k = Io();
        Fo(T, u, d, k);
      }
      zp(u, d);
    }
  }, Gh = function() {
    return Cn;
  }, Af = function(u, d) {
    var T = Cn;
    try {
      return Cn = u, d();
    } finally {
      Cn = T;
    }
  }, uo = function(u, d, T) {
    switch (d) {
      case "input":
        if (Tr(u, T), d = T.name, T.type === "radio" && d != null) {
          for (T = u; T.parentNode; )
            T = T.parentNode;
          for (T = T.querySelectorAll("input[name=" + JSON.stringify("" + d) + '][type="radio"]'), d = 0; d < T.length; d++) {
            var k = T[d];
            if (k !== u && k.form === u.form) {
              var Q = Lr(k);
              if (!Q)
                throw Error(n(90));
              Qe(k), Tr(k, Q);
            }
          }
        }
        break;
      case "textarea":
        tt(u, T);
        break;
      case "select":
        d = T.value, d != null && hr(u, !!T.multiple, d, !1);
    }
  }, Ji = tu, Zs = Ea;
  var Sg = { usingClientEntryPoint: !1, Events: [Uu, Ol, Lr, Jo, $i, tu] }, nu = { findFiberByHostInstance: Di, bundleType: 0, version: "18.2.0", rendererPackageName: "react-dom" }, Pg = { bundleType: nu.bundleType, version: nu.version, rendererPackageName: nu.rendererPackageName, rendererConfig: nu.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: B.ReactCurrentDispatcher, findHostInstanceByFiber: function(u) {
    return u = An(u), u === null ? null : u.stateNode;
  }, findFiberByHostInstance: nu.findFiberByHostInstance || lv, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.2.0-next-9e3b772b8-20220608" };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var Yd = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!Yd.isDisabled && Yd.supportsFiber)
      try {
        Eu = Yd.inject(Pg), Zi = Yd;
      } catch {
      }
  }
  return reactDom_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Sg, reactDom_production_min.createPortal = function(u, d) {
    var T = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!Up(d))
      throw Error(n(200));
    return iv(u, d, null, T);
  }, reactDom_production_min.createRoot = function(u, d) {
    if (!Up(u))
      throw Error(n(299));
    var T = !1, k = "", Q = Vp;
    return d != null && (d.unstable_strictMode === !0 && (T = !0), d.identifierPrefix !== void 0 && (k = d.identifierPrefix), d.onRecoverableError !== void 0 && (Q = d.onRecoverableError)), d = Vd(u, 1, !1, null, null, T, !1, k, Q), u[js] = d.current, Nl(u.nodeType === 8 ? u.parentNode : u), new Hd(d);
  }, reactDom_production_min.findDOMNode = function(u) {
    if (u == null)
      return null;
    if (u.nodeType === 1)
      return u;
    var d = u._reactInternals;
    if (d === void 0)
      throw typeof u.render == "function" ? Error(n(188)) : (u = Object.keys(u).join(","), Error(n(268, u)));
    return u = An(d), u = u === null ? null : u.stateNode, u;
  }, reactDom_production_min.flushSync = function(u) {
    return Ea(u);
  }, reactDom_production_min.hydrate = function(u, d, T) {
    if (!Wd(d))
      throw Error(n(200));
    return Gd(null, u, d, !0, T);
  }, reactDom_production_min.hydrateRoot = function(u, d, T) {
    if (!Up(u))
      throw Error(n(405));
    var k = T != null && T.hydratedSources || null, Q = !1, ce = "", ge = Vp;
    if (T != null && (T.unstable_strictMode === !0 && (Q = !0), T.identifierPrefix !== void 0 && (ce = T.identifierPrefix), T.onRecoverableError !== void 0 && (ge = T.onRecoverableError)), d = sv(d, null, u, 1, T ?? null, Q, !1, ce, ge), u[js] = d.current, Nl(u), k)
      for (u = 0; u < k.length; u++)
        T = k[u], Q = T._getVersion, Q = Q(T._source), d.mutableSourceEagerHydrationData == null ? d.mutableSourceEagerHydrationData = [T, Q] : d.mutableSourceEagerHydrationData.push(
          T,
          Q
        );
    return new zs(d);
  }, reactDom_production_min.render = function(u, d, T) {
    if (!Wd(d))
      throw Error(n(200));
    return Gd(null, u, d, !1, T);
  }, reactDom_production_min.unmountComponentAtNode = function(u) {
    if (!Wd(u))
      throw Error(n(40));
    return u._reactRootContainer ? (Ea(function() {
      Gd(null, null, u, !1, function() {
        u._reactRootContainer = null, u[js] = null;
      });
    }), !0) : !1;
  }, reactDom_production_min.unstable_batchedUpdates = tu, reactDom_production_min.unstable_renderSubtreeIntoContainer = function(u, d, T, k) {
    if (!Wd(T))
      throw Error(n(200));
    if (u == null || u._reactInternals === void 0)
      throw Error(n(38));
    return Gd(u, d, T, !1, k);
  }, reactDom_production_min.version = "18.2.0-next-9e3b772b8-20220608", reactDom_production_min;
}
var reactDom_development = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactDom_development;
function requireReactDom_development() {
  return hasRequiredReactDom_development || (hasRequiredReactDom_development = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = React__default, t = requireScheduler(), n = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, o = !1;
    function s(i) {
      o = i;
    }
    function l(i) {
      if (!o) {
        for (var a = arguments.length, f = new Array(a > 1 ? a - 1 : 0), b = 1; b < a; b++)
          f[b - 1] = arguments[b];
        p("warn", i, f);
      }
    }
    function c(i) {
      if (!o) {
        for (var a = arguments.length, f = new Array(a > 1 ? a - 1 : 0), b = 1; b < a; b++)
          f[b - 1] = arguments[b];
        p("error", i, f);
      }
    }
    function p(i, a, f) {
      {
        var b = n.ReactDebugCurrentFrame, S = b.getStackAddendum();
        S !== "" && (a += "%s", f = f.concat([S]));
        var O = f.map(function(J) {
          return String(J);
        });
        O.unshift("Warning: " + a), Function.prototype.apply.call(console[i], console, O);
      }
    }
    var m = 0, C = 1, P = 2, w = 3, R = 4, L = 5, M = 6, $ = 7, W = 8, H = 9, V = 10, N = 11, B = 12, K = 13, ue = 14, de = 15, ve = 16, Te = 17, Pe = 18, Ce = 19, Re = 21, ke = 22, Ae = 23, we = 24, he = 25, be = !0, le = !1, fe = !1, ye = !1, Ee = !1, Ie = !0, Fe = !1, De = !1, Ve = !0, Oe = !0, Ze = !0, et = /* @__PURE__ */ new Set(), bt = {}, rr = {};
    function St(i, a) {
      Qe(i, a), Qe(i + "Capture", a);
    }
    function Qe(i, a) {
      bt[i] && c("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", i), bt[i] = a;
      {
        var f = i.toLowerCase();
        rr[f] = i, i === "onDoubleClick" && (rr.ondblclick = i);
      }
      for (var b = 0; b < a.length; b++)
        et.add(a[b]);
    }
    var xt = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", je = Object.prototype.hasOwnProperty;
    function kt(i) {
      {
        var a = typeof Symbol == "function" && Symbol.toStringTag, f = a && i[Symbol.toStringTag] || i.constructor.name || "Object";
        return f;
      }
    }
    function cr(i) {
      try {
        return Tr(i), !1;
      } catch {
        return !0;
      }
    }
    function Tr(i) {
      return "" + i;
    }
    function Er(i, a) {
      if (cr(i))
        return c("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", a, kt(i)), Tr(i);
    }
    function Hr(i) {
      if (cr(i))
        return c("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", kt(i)), Tr(i);
    }
    function Br(i, a) {
      if (cr(i))
        return c("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", a, kt(i)), Tr(i);
    }
    function hr(i, a) {
      if (cr(i))
        return c("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", a, kt(i)), Tr(i);
    }
    function Gr(i) {
      if (cr(i))
        return c("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", kt(i)), Tr(i);
    }
    function Yr(i) {
      if (cr(i))
        return c("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", kt(i)), Tr(i);
    }
    var tt = 0, ar = 1, wr = 2, Sr = 3, Ye = 4, Je = 5, tr = 6, pt = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", ir = pt + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", nr = new RegExp("^[" + pt + "][" + ir + "]*$"), er = {}, pr = {};
    function kr(i) {
      return je.call(pr, i) ? !0 : je.call(er, i) ? !1 : nr.test(i) ? (pr[i] = !0, !0) : (er[i] = !0, c("Invalid attribute name: `%s`", i), !1);
    }
    function Nr(i, a, f) {
      return a !== null ? a.type === tt : f ? !1 : i.length > 2 && (i[0] === "o" || i[0] === "O") && (i[1] === "n" || i[1] === "N");
    }
    function hn(i, a, f, b) {
      if (f !== null && f.type === tt)
        return !1;
      switch (typeof a) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (b)
            return !1;
          if (f !== null)
            return !f.acceptsBooleans;
          var S = i.toLowerCase().slice(0, 5);
          return S !== "data-" && S !== "aria-";
        }
        default:
          return !1;
      }
    }
    function fn(i, a, f, b) {
      if (a === null || typeof a > "u" || hn(i, a, f, b))
        return !0;
      if (b)
        return !1;
      if (f !== null)
        switch (f.type) {
          case Sr:
            return !a;
          case Ye:
            return a === !1;
          case Je:
            return isNaN(a);
          case tr:
            return isNaN(a) || a < 1;
        }
      return !1;
    }
    function uo(i) {
      return vn.hasOwnProperty(i) ? vn[i] : null;
    }
    function mn(i, a, f, b, S, O, J) {
      this.acceptsBooleans = a === wr || a === Sr || a === Ye, this.attributeName = b, this.attributeNamespace = S, this.mustUseProperty = f, this.propertyName = i, this.type = a, this.sanitizeURL = O, this.removeEmptyString = J;
    }
    var vn = {}, mi = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    mi.forEach(function(i) {
      vn[i] = new mn(
        i,
        tt,
        !1,
        // mustUseProperty
        i,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(i) {
      var a = i[0], f = i[1];
      vn[a] = new mn(
        a,
        ar,
        !1,
        // mustUseProperty
        f,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(i) {
      vn[i] = new mn(
        i,
        wr,
        !1,
        // mustUseProperty
        i.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(i) {
      vn[i] = new mn(
        i,
        wr,
        !1,
        // mustUseProperty
        i,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(i) {
      vn[i] = new mn(
        i,
        Sr,
        !1,
        // mustUseProperty
        i.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(i) {
      vn[i] = new mn(
        i,
        Sr,
        !0,
        // mustUseProperty
        i,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(i) {
      vn[i] = new mn(
        i,
        Ye,
        !1,
        // mustUseProperty
        i,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(i) {
      vn[i] = new mn(
        i,
        tr,
        !1,
        // mustUseProperty
        i,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(i) {
      vn[i] = new mn(
        i,
        Je,
        !1,
        // mustUseProperty
        i.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var Jo = /[\-\:]([a-z])/g, $i = function(i) {
      return i[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(i) {
      var a = i.replace(Jo, $i);
      vn[a] = new mn(
        a,
        ar,
        !1,
        // mustUseProperty
        i,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(i) {
      var a = i.replace(Jo, $i);
      vn[a] = new mn(
        a,
        ar,
        !1,
        // mustUseProperty
        i,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(i) {
      var a = i.replace(Jo, $i);
      vn[a] = new mn(
        a,
        ar,
        !1,
        // mustUseProperty
        i,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(i) {
      vn[i] = new mn(
        i,
        ar,
        !1,
        // mustUseProperty
        i.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var Ji = "xlinkHref";
    vn[Ji] = new mn(
      "xlinkHref",
      ar,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(i) {
      vn[i] = new mn(
        i,
        ar,
        !1,
        // mustUseProperty
        i.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var Zs = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, yi = !1;
    function Zo(i) {
      !yi && Zs.test(i) && (yi = !0, c("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(i)));
    }
    function gi(i, a, f, b) {
      if (b.mustUseProperty) {
        var S = b.propertyName;
        return i[S];
      } else {
        Er(f, a), b.sanitizeURL && Zo("" + f);
        var O = b.attributeName, J = null;
        if (b.type === Ye) {
          if (i.hasAttribute(O)) {
            var pe = i.getAttribute(O);
            return pe === "" ? !0 : fn(a, f, b, !1) ? pe : pe === "" + f ? f : pe;
          }
        } else if (i.hasAttribute(O)) {
          if (fn(a, f, b, !1))
            return i.getAttribute(O);
          if (b.type === Sr)
            return f;
          J = i.getAttribute(O);
        }
        return fn(a, f, b, !1) ? J === null ? f : J : J === "" + f ? f : J;
      }
    }
    function ei(i, a, f, b) {
      {
        if (!kr(a))
          return;
        if (!i.hasAttribute(a))
          return f === void 0 ? void 0 : null;
        var S = i.getAttribute(a);
        return Er(f, a), S === "" + f ? f : S;
      }
    }
    function Ao(i, a, f, b) {
      var S = uo(a);
      if (!Nr(a, S, b)) {
        if (fn(a, f, S, b) && (f = null), b || S === null) {
          if (kr(a)) {
            var O = a;
            f === null ? i.removeAttribute(O) : (Er(f, a), i.setAttribute(O, "" + f));
          }
          return;
        }
        var J = S.mustUseProperty;
        if (J) {
          var pe = S.propertyName;
          if (f === null) {
            var me = S.type;
            i[pe] = me === Sr ? !1 : "";
          } else
            i[pe] = f;
          return;
        }
        var Se = S.attributeName, _e = S.attributeNamespace;
        if (f === null)
          i.removeAttribute(Se);
        else {
          var ze = S.type, Le;
          ze === Sr || ze === Ye && f === !0 ? Le = "" : (Er(f, Se), Le = "" + f, S.sanitizeURL && Zo(Le.toString())), _e ? i.setAttributeNS(_e, Se, Le) : i.setAttribute(Se, Le);
        }
      }
    }
    var Fn = Symbol.for("react.element"), Gn = Symbol.for("react.portal"), Bo = Symbol.for("react.fragment"), $o = Symbol.for("react.strict_mode"), Me = Symbol.for("react.profiler"), wt = Symbol.for("react.provider"), ur = Symbol.for("react.context"), jr = Symbol.for("react.forward_ref"), Qr = Symbol.for("react.suspense"), Ir = Symbol.for("react.suspense_list"), $r = Symbol.for("react.memo"), Dr = Symbol.for("react.lazy"), An = Symbol.for("react.scope"), mr = Symbol.for("react.debug_trace_mode"), on = Symbol.for("react.offscreen"), zo = Symbol.for("react.legacy_hidden"), ea = Symbol.for("react.cache"), $c = Symbol.for("react.tracing_marker"), yn = Symbol.iterator, By = "@@iterator";
    function Ps(i) {
      if (i === null || typeof i != "object")
        return null;
      var a = yn && i[yn] || i[By];
      return typeof a == "function" ? a : null;
    }
    var sn = Object.assign, ta = 0, zh, Pf, Eu, Zi, Vh, ji, Uh;
    function Hh() {
    }
    Hh.__reactDisabledLog = !0;
    function zy() {
      {
        if (ta === 0) {
          zh = console.log, Pf = console.info, Eu = console.warn, Zi = console.error, Vh = console.group, ji = console.groupCollapsed, Uh = console.groupEnd;
          var i = {
            configurable: !0,
            enumerable: !0,
            value: Hh,
            writable: !0
          };
          Object.defineProperties(console, {
            info: i,
            log: i,
            warn: i,
            error: i,
            group: i,
            groupCollapsed: i,
            groupEnd: i
          });
        }
        ta++;
      }
    }
    function jc() {
      {
        if (ta--, ta === 0) {
          var i = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: sn({}, i, {
              value: zh
            }),
            info: sn({}, i, {
              value: Pf
            }),
            warn: sn({}, i, {
              value: Eu
            }),
            error: sn({}, i, {
              value: Zi
            }),
            group: sn({}, i, {
              value: Vh
            }),
            groupCollapsed: sn({}, i, {
              value: ji
            }),
            groupEnd: sn({}, i, {
              value: Uh
            })
          });
        }
        ta < 0 && c("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Sl = n.ReactCurrentDispatcher, Oa;
    function es(i, a, f) {
      {
        if (Oa === void 0)
          try {
            throw Error();
          } catch (S) {
            var b = S.stack.trim().match(/\n( *(at )?)/);
            Oa = b && b[1] || "";
          }
        return `
` + Oa + i;
      }
    }
    var Rf = !1, Mc;
    {
      var _f = typeof WeakMap == "function" ? WeakMap : Map;
      Mc = new _f();
    }
    function Nc(i, a) {
      if (!i || Rf)
        return "";
      {
        var f = Mc.get(i);
        if (f !== void 0)
          return f;
      }
      var b;
      Rf = !0;
      var S = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = Sl.current, Sl.current = null, zy();
      try {
        if (a) {
          var J = function() {
            throw Error();
          };
          if (Object.defineProperty(J.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(J, []);
            } catch (Ke) {
              b = Ke;
            }
            Reflect.construct(i, [], J);
          } else {
            try {
              J.call();
            } catch (Ke) {
              b = Ke;
            }
            i.call(J.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ke) {
            b = Ke;
          }
          i();
        }
      } catch (Ke) {
        if (Ke && b && typeof Ke.stack == "string") {
          for (var pe = Ke.stack.split(`
`), me = b.stack.split(`
`), Se = pe.length - 1, _e = me.length - 1; Se >= 1 && _e >= 0 && pe[Se] !== me[_e]; )
            _e--;
          for (; Se >= 1 && _e >= 0; Se--, _e--)
            if (pe[Se] !== me[_e]) {
              if (Se !== 1 || _e !== 1)
                do
                  if (Se--, _e--, _e < 0 || pe[Se] !== me[_e]) {
                    var ze = `
` + pe[Se].replace(" at new ", " at ");
                    return i.displayName && ze.includes("<anonymous>") && (ze = ze.replace("<anonymous>", i.displayName)), typeof i == "function" && Mc.set(i, ze), ze;
                  }
                while (Se >= 1 && _e >= 0);
              break;
            }
        }
      } finally {
        Rf = !1, Sl.current = O, jc(), Error.prepareStackTrace = S;
      }
      var Le = i ? i.displayName || i.name : "", qe = Le ? es(Le) : "";
      return typeof i == "function" && Mc.set(i, qe), qe;
    }
    function wf(i, a, f) {
      return Nc(i, !0);
    }
    function Da(i, a, f) {
      return Nc(i, !1);
    }
    function Vy(i) {
      var a = i.prototype;
      return !!(a && a.isReactComponent);
    }
    function Cu(i, a, f) {
      if (i == null)
        return "";
      if (typeof i == "function")
        return Nc(i, Vy(i));
      if (typeof i == "string")
        return es(i);
      switch (i) {
        case Qr:
          return es("Suspense");
        case Ir:
          return es("SuspenseList");
      }
      if (typeof i == "object")
        switch (i.$$typeof) {
          case jr:
            return Da(i.render);
          case $r:
            return Cu(i.type, a, f);
          case Dr: {
            var b = i, S = b._payload, O = b._init;
            try {
              return Cu(O(S), a, f);
            } catch {
            }
          }
        }
      return "";
    }
    function Cn(i) {
      switch (i._debugOwner && i._debugOwner.type, i._debugSource, i.tag) {
        case L:
          return es(i.type);
        case ve:
          return es("Lazy");
        case K:
          return es("Suspense");
        case Ce:
          return es("SuspenseList");
        case m:
        case P:
        case de:
          return Da(i.type);
        case N:
          return Da(i.type.render);
        case C:
          return wf(i.type);
        default:
          return "";
      }
    }
    function kf(i) {
      try {
        var a = "", f = i;
        do
          a += Cn(f), f = f.return;
        while (f);
        return a;
      } catch (b) {
        return `
Error generating stack: ` + b.message + `
` + b.stack;
      }
    }
    function Wh(i, a, f) {
      var b = i.displayName;
      if (b)
        return b;
      var S = a.displayName || a.name || "";
      return S !== "" ? f + "(" + S + ")" : f;
    }
    function Oc(i) {
      return i.displayName || "Context";
    }
    function _n(i) {
      if (i == null)
        return null;
      if (typeof i.tag == "number" && c("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof i == "function")
        return i.displayName || i.name || null;
      if (typeof i == "string")
        return i;
      switch (i) {
        case Bo:
          return "Fragment";
        case Gn:
          return "Portal";
        case Me:
          return "Profiler";
        case $o:
          return "StrictMode";
        case Qr:
          return "Suspense";
        case Ir:
          return "SuspenseList";
      }
      if (typeof i == "object")
        switch (i.$$typeof) {
          case ur:
            var a = i;
            return Oc(a) + ".Consumer";
          case wt:
            var f = i;
            return Oc(f._context) + ".Provider";
          case jr:
            return Wh(i, i.render, "ForwardRef");
          case $r:
            var b = i.displayName || null;
            return b !== null ? b : _n(i.type) || "Memo";
          case Dr: {
            var S = i, O = S._payload, J = S._init;
            try {
              return _n(J(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    function Gh(i, a, f) {
      var b = a.displayName || a.name || "";
      return i.displayName || (b !== "" ? f + "(" + b + ")" : f);
    }
    function Af(i) {
      return i.displayName || "Context";
    }
    function en(i) {
      var a = i.tag, f = i.type;
      switch (a) {
        case we:
          return "Cache";
        case H:
          var b = f;
          return Af(b) + ".Consumer";
        case V:
          var S = f;
          return Af(S._context) + ".Provider";
        case Pe:
          return "DehydratedFragment";
        case N:
          return Gh(f, f.render, "ForwardRef");
        case $:
          return "Fragment";
        case L:
          return f;
        case R:
          return "Portal";
        case w:
          return "Root";
        case M:
          return "Text";
        case ve:
          return _n(f);
        case W:
          return f === $o ? "StrictMode" : "Mode";
        case ke:
          return "Offscreen";
        case B:
          return "Profiler";
        case Re:
          return "Scope";
        case K:
          return "Suspense";
        case Ce:
          return "SuspenseList";
        case he:
          return "TracingMarker";
        case C:
        case m:
        case Te:
        case P:
        case ue:
        case de:
          if (typeof f == "function")
            return f.displayName || f.name || null;
          if (typeof f == "string")
            return f;
          break;
      }
      return null;
    }
    var Su = n.ReactDebugCurrentFrame, Xn = null, Mi = !1;
    function Ni() {
      {
        if (Xn === null)
          return null;
        var i = Xn._debugOwner;
        if (i !== null && typeof i < "u")
          return en(i);
      }
      return null;
    }
    function Pu() {
      return Xn === null ? "" : kf(Xn);
    }
    function ro() {
      Su.getCurrentStack = null, Xn = null, Mi = !1;
    }
    function Sn(i) {
      Su.getCurrentStack = i === null ? null : Pu, Xn = i, Mi = !1;
    }
    function Uy() {
      return Xn;
    }
    function ts(i) {
      Mi = i;
    }
    function jo(i) {
      return "" + i;
    }
    function ra(i) {
      switch (typeof i) {
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return i;
        case "object":
          return Yr(i), i;
        default:
          return "";
      }
    }
    var Yh = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function Pl(i, a) {
      Yh[a.type] || a.onChange || a.onInput || a.readOnly || a.disabled || a.value == null || c("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), a.onChange || a.readOnly || a.disabled || a.checked == null || c("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function $f(i) {
      var a = i.type, f = i.nodeName;
      return f && f.toLowerCase() === "input" && (a === "checkbox" || a === "radio");
    }
    function qh(i) {
      return i._valueTracker;
    }
    function Ru(i) {
      i._valueTracker = null;
    }
    function _u(i) {
      var a = "";
      return i && ($f(i) ? a = i.checked ? "true" : "false" : a = i.value), a;
    }
    function Rl(i) {
      var a = $f(i) ? "checked" : "value", f = Object.getOwnPropertyDescriptor(i.constructor.prototype, a);
      Yr(i[a]);
      var b = "" + i[a];
      if (!(i.hasOwnProperty(a) || typeof f > "u" || typeof f.get != "function" || typeof f.set != "function")) {
        var S = f.get, O = f.set;
        Object.defineProperty(i, a, {
          configurable: !0,
          get: function() {
            return S.call(this);
          },
          set: function(pe) {
            Yr(pe), b = "" + pe, O.call(this, pe);
          }
        }), Object.defineProperty(i, a, {
          enumerable: f.enumerable
        });
        var J = {
          getValue: function() {
            return b;
          },
          setValue: function(pe) {
            Yr(pe), b = "" + pe;
          },
          stopTracking: function() {
            Ru(i), delete i[a];
          }
        };
        return J;
      }
    }
    function Ia(i) {
      qh(i) || (i._valueTracker = Rl(i));
    }
    function Kh(i) {
      if (!i)
        return !1;
      var a = qh(i);
      if (!a)
        return !0;
      var f = a.getValue(), b = _u(i);
      return b !== f ? (a.setValue(b), !0) : !1;
    }
    function Dc(i) {
      if (i = i || (typeof document < "u" ? document : void 0), typeof i > "u")
        return null;
      try {
        return i.activeElement || i.body;
      } catch {
        return i.body;
      }
    }
    var Ic = !1, wu = !1, Fc = !1, jf = !1;
    function Rs(i) {
      var a = i.type === "checkbox" || i.type === "radio";
      return a ? i.checked != null : i.value != null;
    }
    function ku(i, a) {
      var f = i, b = a.checked, S = sn({}, a, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: b ?? f._wrapperState.initialChecked
      });
      return S;
    }
    function Au(i, a) {
      Pl("input", a), a.checked !== void 0 && a.defaultChecked !== void 0 && !wu && (c("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", Ni() || "A component", a.type), wu = !0), a.value !== void 0 && a.defaultValue !== void 0 && !Ic && (c("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", Ni() || "A component", a.type), Ic = !0);
      var f = i, b = a.defaultValue == null ? "" : a.defaultValue;
      f._wrapperState = {
        initialChecked: a.checked != null ? a.checked : a.defaultChecked,
        initialValue: ra(a.value != null ? a.value : b),
        controlled: Rs(a)
      };
    }
    function Mf(i, a) {
      var f = i, b = a.checked;
      b != null && Ao(f, "checked", b, !1);
    }
    function _l(i, a) {
      var f = i;
      {
        var b = Rs(a);
        !f._wrapperState.controlled && b && !jf && (c("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), jf = !0), f._wrapperState.controlled && !b && !Fc && (c("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), Fc = !0);
      }
      Mf(i, a);
      var S = ra(a.value), O = a.type;
      if (S != null)
        O === "number" ? (S === 0 && f.value === "" || // We explicitly want to coerce to number here if possible.
        // eslint-disable-next-line
        f.value != S) && (f.value = jo(S)) : f.value !== jo(S) && (f.value = jo(S));
      else if (O === "submit" || O === "reset") {
        f.removeAttribute("value");
        return;
      }
      a.hasOwnProperty("value") ? na(f, a.type, S) : a.hasOwnProperty("defaultValue") && na(f, a.type, ra(a.defaultValue)), a.checked == null && a.defaultChecked != null && (f.defaultChecked = !!a.defaultChecked);
    }
    function $u(i, a, f) {
      var b = i;
      if (a.hasOwnProperty("value") || a.hasOwnProperty("defaultValue")) {
        var S = a.type, O = S === "submit" || S === "reset";
        if (O && (a.value === void 0 || a.value === null))
          return;
        var J = jo(b._wrapperState.initialValue);
        f || J !== b.value && (b.value = J), b.defaultValue = J;
      }
      var pe = b.name;
      pe !== "" && (b.name = ""), b.defaultChecked = !b.defaultChecked, b.defaultChecked = !!b._wrapperState.initialChecked, pe !== "" && (b.name = pe);
    }
    function Xh(i, a) {
      var f = i;
      _l(f, a), xi(f, a);
    }
    function xi(i, a) {
      var f = a.name;
      if (a.type === "radio" && f != null) {
        for (var b = i; b.parentNode; )
          b = b.parentNode;
        Er(f, "name");
        for (var S = b.querySelectorAll("input[name=" + JSON.stringify("" + f) + '][type="radio"]'), O = 0; O < S.length; O++) {
          var J = S[O];
          if (!(J === i || J.form !== i.form)) {
            var pe = Rv(J);
            if (!pe)
              throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
            Kh(J), _l(J, pe);
          }
        }
      }
    }
    function na(i, a, f) {
      // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
      (a !== "number" || Dc(i.ownerDocument) !== i) && (f == null ? i.defaultValue = jo(i._wrapperState.initialValue) : i.defaultValue !== jo(f) && (i.defaultValue = jo(f)));
    }
    var Lc = !1, wl = !1, Qh = !1;
    function Bc(i, a) {
      a.value == null && (typeof a.children == "object" && a.children !== null ? e.Children.forEach(a.children, function(f) {
        f != null && (typeof f == "string" || typeof f == "number" || wl || (wl = !0, c("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }) : a.dangerouslySetInnerHTML != null && (Qh || (Qh = !0, c("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))), a.selected != null && !Lc && (c("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), Lc = !0);
    }
    function Nf(i, a) {
      a.value != null && i.setAttribute("value", jo(ra(a.value)));
    }
    var ju = Array.isArray;
    function co(i) {
      return ju(i);
    }
    var zc;
    zc = !1;
    function Jh() {
      var i = Ni();
      return i ? `

Check the render method of \`` + i + "`." : "";
    }
    var Zh = ["value", "defaultValue"];
    function Hy(i) {
      {
        Pl("select", i);
        for (var a = 0; a < Zh.length; a++) {
          var f = Zh[a];
          if (i[f] != null) {
            var b = co(i[f]);
            i.multiple && !b ? c("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", f, Jh()) : !i.multiple && b && c("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", f, Jh());
          }
        }
      }
    }
    function oa(i, a, f, b) {
      var S = i.options;
      if (a) {
        for (var O = f, J = {}, pe = 0; pe < O.length; pe++)
          J["$" + O[pe]] = !0;
        for (var me = 0; me < S.length; me++) {
          var Se = J.hasOwnProperty("$" + S[me].value);
          S[me].selected !== Se && (S[me].selected = Se), Se && b && (S[me].defaultSelected = !0);
        }
      } else {
        for (var _e = jo(ra(f)), ze = null, Le = 0; Le < S.length; Le++) {
          if (S[Le].value === _e) {
            S[Le].selected = !0, b && (S[Le].defaultSelected = !0);
            return;
          }
          ze === null && !S[Le].disabled && (ze = S[Le]);
        }
        ze !== null && (ze.selected = !0);
      }
    }
    function Of(i, a) {
      return sn({}, a, {
        value: void 0
      });
    }
    function em(i, a) {
      var f = i;
      Hy(a), f._wrapperState = {
        wasMultiple: !!a.multiple
      }, a.value !== void 0 && a.defaultValue !== void 0 && !zc && (c("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), zc = !0);
    }
    function Wy(i, a) {
      var f = i;
      f.multiple = !!a.multiple;
      var b = a.value;
      b != null ? oa(f, !!a.multiple, b, !1) : a.defaultValue != null && oa(f, !!a.multiple, a.defaultValue, !0);
    }
    function Gy(i, a) {
      var f = i, b = f._wrapperState.wasMultiple;
      f._wrapperState.wasMultiple = !!a.multiple;
      var S = a.value;
      S != null ? oa(f, !!a.multiple, S, !1) : b !== !!a.multiple && (a.defaultValue != null ? oa(f, !!a.multiple, a.defaultValue, !0) : oa(f, !!a.multiple, a.multiple ? [] : "", !1));
    }
    function Yy(i, a) {
      var f = i, b = a.value;
      b != null && oa(f, !!a.multiple, b, !1);
    }
    var Df = !1;
    function If(i, a) {
      var f = i;
      if (a.dangerouslySetInnerHTML != null)
        throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
      var b = sn({}, a, {
        value: void 0,
        defaultValue: void 0,
        children: jo(f._wrapperState.initialValue)
      });
      return b;
    }
    function tm(i, a) {
      var f = i;
      Pl("textarea", a), a.value !== void 0 && a.defaultValue !== void 0 && !Df && (c("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", Ni() || "A component"), Df = !0);
      var b = a.value;
      if (b == null) {
        var S = a.children, O = a.defaultValue;
        if (S != null) {
          c("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
          {
            if (O != null)
              throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
            if (co(S)) {
              if (S.length > 1)
                throw new Error("<textarea> can only have at most one child.");
              S = S[0];
            }
            O = S;
          }
        }
        O == null && (O = ""), b = O;
      }
      f._wrapperState = {
        initialValue: ra(b)
      };
    }
    function rm(i, a) {
      var f = i, b = ra(a.value), S = ra(a.defaultValue);
      if (b != null) {
        var O = jo(b);
        O !== f.value && (f.value = O), a.defaultValue == null && f.defaultValue !== O && (f.defaultValue = O);
      }
      S != null && (f.defaultValue = jo(S));
    }
    function nm(i, a) {
      var f = i, b = f.textContent;
      b === f._wrapperState.initialValue && b !== "" && b !== null && (f.value = b);
    }
    function Ff(i, a) {
      rm(i, a);
    }
    var _s = "http://www.w3.org/1999/xhtml", qy = "http://www.w3.org/1998/Math/MathML", Lf = "http://www.w3.org/2000/svg";
    function Vc(i) {
      switch (i) {
        case "svg":
          return Lf;
        case "math":
          return qy;
        default:
          return _s;
      }
    }
    function Bf(i, a) {
      return i == null || i === _s ? Vc(a) : i === Lf && a === "foreignObject" ? _s : i;
    }
    var Ky = function(i) {
      return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(a, f, b, S) {
        MSApp.execUnsafeLocalFunction(function() {
          return i(a, f, b, S);
        });
      } : i;
    }, Uc, om = Ky(function(i, a) {
      if (i.namespaceURI === Lf && !("innerHTML" in i)) {
        Uc = Uc || document.createElement("div"), Uc.innerHTML = "<svg>" + a.valueOf().toString() + "</svg>";
        for (var f = Uc.firstChild; i.firstChild; )
          i.removeChild(i.firstChild);
        for (; f.firstChild; )
          i.appendChild(f.firstChild);
        return;
      }
      i.innerHTML = a;
    }), ti = 1, ws = 3, Qn = 8, rs = 9, Fa = 11, Hc = function(i, a) {
      if (a) {
        var f = i.firstChild;
        if (f && f === i.lastChild && f.nodeType === ws) {
          f.nodeValue = a;
          return;
        }
      }
      i.textContent = a;
    }, im = {
      animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
      background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
      borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
      borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
      borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
      borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
      borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
      borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
      borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
      borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
      fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
      gap: ["columnGap", "rowGap"],
      grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
      wordWrap: ["overflowWrap"]
    }, kl = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function sm(i, a) {
      return i + a.charAt(0).toUpperCase() + a.substring(1);
    }
    var am = ["Webkit", "ms", "Moz", "O"];
    Object.keys(kl).forEach(function(i) {
      am.forEach(function(a) {
        kl[sm(a, i)] = kl[i];
      });
    });
    function Wc(i, a, f) {
      var b = a == null || typeof a == "boolean" || a === "";
      return b ? "" : !f && typeof a == "number" && a !== 0 && !(kl.hasOwnProperty(i) && kl[i]) ? a + "px" : (hr(a, i), ("" + a).trim());
    }
    var Al = /([A-Z])/g, Xy = /^ms-/;
    function Qy(i) {
      return i.replace(Al, "-$1").toLowerCase().replace(Xy, "-ms-");
    }
    var lm = function() {
    };
    {
      var um = /^(?:webkit|moz|o)[A-Z]/, cm = /^-ms-/, Mu = /-(.)/g, $l = /;\s*$/, jl = {}, Ml = {}, dm = !1, zf = !1, Vf = function(i) {
        return i.replace(Mu, function(a, f) {
          return f.toUpperCase();
        });
      }, Uf = function(i) {
        jl.hasOwnProperty(i) && jl[i] || (jl[i] = !0, c(
          "Unsupported style property %s. Did you mean %s?",
          i,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          Vf(i.replace(cm, "ms-"))
        ));
      }, fm = function(i) {
        jl.hasOwnProperty(i) && jl[i] || (jl[i] = !0, c("Unsupported vendor-prefixed style property %s. Did you mean %s?", i, i.charAt(0).toUpperCase() + i.slice(1)));
      }, pm = function(i, a) {
        Ml.hasOwnProperty(a) && Ml[a] || (Ml[a] = !0, c(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, i, a.replace($l, "")));
      }, hm = function(i, a) {
        dm || (dm = !0, c("`NaN` is an invalid value for the `%s` css style property.", i));
      }, Jy = function(i, a) {
        zf || (zf = !0, c("`Infinity` is an invalid value for the `%s` css style property.", i));
      };
      lm = function(i, a) {
        i.indexOf("-") > -1 ? Uf(i) : um.test(i) ? fm(i) : $l.test(a) && pm(i, a), typeof a == "number" && (isNaN(a) ? hm(i, a) : isFinite(a) || Jy(i, a));
      };
    }
    var Zy = lm;
    function eg(i) {
      {
        var a = "", f = "";
        for (var b in i)
          if (i.hasOwnProperty(b)) {
            var S = i[b];
            if (S != null) {
              var O = b.indexOf("--") === 0;
              a += f + (O ? b : Qy(b)) + ":", a += Wc(b, S, O), f = ";";
            }
          }
        return a || null;
      }
    }
    function mm(i, a) {
      var f = i.style;
      for (var b in a)
        if (a.hasOwnProperty(b)) {
          var S = b.indexOf("--") === 0;
          S || Zy(b, a[b]);
          var O = Wc(b, a[b], S);
          b === "float" && (b = "cssFloat"), S ? f.setProperty(b, O) : f[b] = O;
        }
    }
    function tg(i) {
      return i == null || typeof i == "boolean" || i === "";
    }
    function Oi(i) {
      var a = {};
      for (var f in i)
        for (var b = im[f] || [f], S = 0; S < b.length; S++)
          a[b[S]] = f;
      return a;
    }
    function Nu(i, a) {
      {
        if (!a)
          return;
        var f = Oi(i), b = Oi(a), S = {};
        for (var O in f) {
          var J = f[O], pe = b[O];
          if (pe && J !== pe) {
            var me = J + "," + pe;
            if (S[me])
              continue;
            S[me] = !0, c("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", tg(i[J]) ? "Removing" : "Updating", J, pe);
          }
        }
      }
    }
    var vm = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
      // NOTE: menuitem's close tag should be omitted, but that causes problems.
    }, ym = sn({
      menuitem: !0
    }, vm), gm = "__html";
    function Gc(i, a) {
      if (a) {
        if (ym[i] && (a.children != null || a.dangerouslySetInnerHTML != null))
          throw new Error(i + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        if (a.dangerouslySetInnerHTML != null) {
          if (a.children != null)
            throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (typeof a.dangerouslySetInnerHTML != "object" || !(gm in a.dangerouslySetInnerHTML))
            throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!a.suppressContentEditableWarning && a.contentEditable && a.children != null && c("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), a.style != null && typeof a.style != "object")
          throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      }
    }
    function ks(i, a) {
      if (i.indexOf("-") === -1)
        return typeof a.is == "string";
      switch (i) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var Yc = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, xm = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, ns = {}, Hf = new RegExp("^(aria)-[" + ir + "]*$"), Ou = new RegExp("^(aria)[A-Z][" + ir + "]*$");
    function Wf(i, a) {
      {
        if (je.call(ns, a) && ns[a])
          return !0;
        if (Ou.test(a)) {
          var f = "aria-" + a.slice(4).toLowerCase(), b = xm.hasOwnProperty(f) ? f : null;
          if (b == null)
            return c("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", a), ns[a] = !0, !0;
          if (a !== b)
            return c("Invalid ARIA attribute `%s`. Did you mean `%s`?", a, b), ns[a] = !0, !0;
        }
        if (Hf.test(a)) {
          var S = a.toLowerCase(), O = xm.hasOwnProperty(S) ? S : null;
          if (O == null)
            return ns[a] = !0, !1;
          if (a !== O)
            return c("Unknown ARIA attribute `%s`. Did you mean `%s`?", a, O), ns[a] = !0, !0;
        }
      }
      return !0;
    }
    function bm(i, a) {
      {
        var f = [];
        for (var b in a) {
          var S = Wf(i, b);
          S || f.push(b);
        }
        var O = f.map(function(J) {
          return "`" + J + "`";
        }).join(", ");
        f.length === 1 ? c("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", O, i) : f.length > 1 && c("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", O, i);
      }
    }
    function qc(i, a) {
      ks(i, a) || bm(i, a);
    }
    var La = !1;
    function Gf(i, a) {
      {
        if (i !== "input" && i !== "textarea" && i !== "select")
          return;
        a != null && a.value === null && !La && (La = !0, i === "select" && a.multiple ? c("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", i) : c("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", i));
      }
    }
    var Yf = function() {
    };
    {
      var fo = {}, qf = /^on./, Tm = /^on[^A-Z]/, Em = new RegExp("^(aria)-[" + ir + "]*$"), Cm = new RegExp("^(aria)[A-Z][" + ir + "]*$");
      Yf = function(i, a, f, b) {
        if (je.call(fo, a) && fo[a])
          return !0;
        var S = a.toLowerCase();
        if (S === "onfocusin" || S === "onfocusout")
          return c("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), fo[a] = !0, !0;
        if (b != null) {
          var O = b.registrationNameDependencies, J = b.possibleRegistrationNames;
          if (O.hasOwnProperty(a))
            return !0;
          var pe = J.hasOwnProperty(S) ? J[S] : null;
          if (pe != null)
            return c("Invalid event handler property `%s`. Did you mean `%s`?", a, pe), fo[a] = !0, !0;
          if (qf.test(a))
            return c("Unknown event handler property `%s`. It will be ignored.", a), fo[a] = !0, !0;
        } else if (qf.test(a))
          return Tm.test(a) && c("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", a), fo[a] = !0, !0;
        if (Em.test(a) || Cm.test(a))
          return !0;
        if (S === "innerhtml")
          return c("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), fo[a] = !0, !0;
        if (S === "aria")
          return c("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), fo[a] = !0, !0;
        if (S === "is" && f !== null && f !== void 0 && typeof f != "string")
          return c("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof f), fo[a] = !0, !0;
        if (typeof f == "number" && isNaN(f))
          return c("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", a), fo[a] = !0, !0;
        var me = uo(a), Se = me !== null && me.type === tt;
        if (Yc.hasOwnProperty(S)) {
          var _e = Yc[S];
          if (_e !== a)
            return c("Invalid DOM property `%s`. Did you mean `%s`?", a, _e), fo[a] = !0, !0;
        } else if (!Se && a !== S)
          return c("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", a, S), fo[a] = !0, !0;
        return typeof f == "boolean" && hn(a, f, me, !1) ? (f ? c('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', f, a, a, f, a) : c('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', f, a, a, f, a, a, a), fo[a] = !0, !0) : Se ? !0 : hn(a, f, me, !1) ? (fo[a] = !0, !1) : ((f === "false" || f === "true") && me !== null && me.type === Sr && (c("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", f, a, f === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', a, f), fo[a] = !0), !0);
      };
    }
    var Sm = function(i, a, f) {
      {
        var b = [];
        for (var S in a) {
          var O = Yf(i, S, a[S], f);
          O || b.push(S);
        }
        var J = b.map(function(pe) {
          return "`" + pe + "`";
        }).join(", ");
        b.length === 1 ? c("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", J, i) : b.length > 1 && c("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", J, i);
      }
    };
    function Pm(i, a, f) {
      ks(i, a) || Sm(i, a, f);
    }
    var As = 1, Du = 2, Ba = 4, rg = As | Du | Ba, Iu = null;
    function Fu(i) {
      Iu !== null && c("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), Iu = i;
    }
    function ng() {
      Iu === null && c("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), Iu = null;
    }
    function Rm(i) {
      return i === Iu;
    }
    function Kc(i) {
      var a = i.target || i.srcElement || window;
      return a.correspondingUseElement && (a = a.correspondingUseElement), a.nodeType === ws ? a.parentNode : a;
    }
    var wn = null, ia = null, $s = null;
    function Nl(i) {
      var a = su(i);
      if (a) {
        if (typeof wn != "function")
          throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var f = a.stateNode;
        if (f) {
          var b = Rv(f);
          wn(a.stateNode, a.type, b);
        }
      }
    }
    function _m(i) {
      wn = i;
    }
    function Xc(i) {
      ia ? $s ? $s.push(i) : $s = [i] : ia = i;
    }
    function Lu() {
      return ia !== null || $s !== null;
    }
    function Bu() {
      if (ia) {
        var i = ia, a = $s;
        if (ia = null, $s = null, Nl(i), a)
          for (var f = 0; f < a.length; f++)
            Nl(a[f]);
      }
    }
    var za = function(i, a) {
      return i(a);
    }, Kf = function() {
    }, Xf = !1;
    function og() {
      var i = Lu();
      i && (Kf(), Bu());
    }
    function Qf(i, a, f) {
      if (Xf)
        return i(a, f);
      Xf = !0;
      try {
        return za(i, a, f);
      } finally {
        Xf = !1, og();
      }
    }
    function Qc(i, a, f) {
      za = i, Kf = f;
    }
    function Jc(i) {
      return i === "button" || i === "input" || i === "select" || i === "textarea";
    }
    function Jf(i, a, f) {
      switch (i) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          return !!(f.disabled && Jc(a));
        default:
          return !1;
      }
    }
    function Va(i, a) {
      var f = i.stateNode;
      if (f === null)
        return null;
      var b = Rv(f);
      if (b === null)
        return null;
      var S = b[a];
      if (Jf(a, i.type, b))
        return null;
      if (S && typeof S != "function")
        throw new Error("Expected `" + a + "` listener to be a function, instead got a value of `" + typeof S + "` type.");
      return S;
    }
    var zu = !1;
    if (xt)
      try {
        var Ua = {};
        Object.defineProperty(Ua, "passive", {
          get: function() {
            zu = !0;
          }
        }), window.addEventListener("test", Ua, Ua), window.removeEventListener("test", Ua, Ua);
      } catch {
        zu = !1;
      }
    function wm(i, a, f, b, S, O, J, pe, me) {
      var Se = Array.prototype.slice.call(arguments, 3);
      try {
        a.apply(f, Se);
      } catch (_e) {
        this.onError(_e);
      }
    }
    var Zf = wm;
    if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
      var ep = document.createElement("react");
      Zf = function(a, f, b, S, O, J, pe, me, Se) {
        if (typeof document > "u" || document === null)
          throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var _e = document.createEvent("Event"), ze = !1, Le = !0, qe = window.event, Ke = Object.getOwnPropertyDescriptor(window, "event");
        function rt() {
          ep.removeEventListener(ct, zr, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = qe);
        }
        var xr = Array.prototype.slice.call(arguments, 3);
        function zr() {
          ze = !0, rt(), f.apply(b, xr), Le = !1;
        }
        var Or, dn = !1, ln = !1;
        function He(We) {
          if (Or = We.error, dn = !0, Or === null && We.colno === 0 && We.lineno === 0 && (ln = !0), We.defaultPrevented && Or != null && typeof Or == "object")
            try {
              Or._suppressLogging = !0;
            } catch {
            }
        }
        var ct = "react-" + (a || "invokeguardedcallback");
        if (window.addEventListener("error", He), ep.addEventListener(ct, zr, !1), _e.initEvent(ct, !1, !1), ep.dispatchEvent(_e), Ke && Object.defineProperty(window, "event", Ke), ze && Le && (dn ? ln && (Or = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : Or = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(Or)), window.removeEventListener("error", He), !ze)
          return rt(), wm.apply(this, arguments);
      };
    }
    var ig = Zf, sa = !1, os = null, Vu = !1, aa = null, ds = {
      onError: function(i) {
        sa = !0, os = i;
      }
    };
    function Ha(i, a, f, b, S, O, J, pe, me) {
      sa = !1, os = null, ig.apply(ds, arguments);
    }
    function js(i, a, f, b, S, O, J, pe, me) {
      if (Ha.apply(this, arguments), sa) {
        var Se = rp();
        Vu || (Vu = !0, aa = Se);
      }
    }
    function tp() {
      if (Vu) {
        var i = aa;
        throw Vu = !1, aa = null, i;
      }
    }
    function sg() {
      return sa;
    }
    function rp() {
      if (sa) {
        var i = os;
        return sa = !1, os = null, i;
      } else
        throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    function Di(i) {
      return i._reactInternals;
    }
    function Uu(i) {
      return i._reactInternals !== void 0;
    }
    function Ol(i, a) {
      i._reactInternals = a;
    }
    var Lr = (
      /*                      */
      0
    ), la = (
      /*                */
      1
    ), $n = (
      /*                    */
      2
    ), tn = (
      /*                       */
      4
    ), bn = (
      /*                */
      16
    ), Tn = (
      /*                 */
      32
    ), fs = (
      /*                     */
      64
    ), Kr = (
      /*                   */
      128
    ), Un = (
      /*            */
      256
    ), ri = (
      /*                          */
      512
    ), Ii = (
      /*                     */
      1024
    ), Dn = (
      /*                      */
      2048
    ), Fi = (
      /*                    */
      4096
    ), ua = (
      /*                   */
      8192
    ), Hu = (
      /*             */
      16384
    ), Zc = Dn | tn | fs | ri | Ii | Hu, km = (
      /*               */
      32767
    ), bi = (
      /*                   */
      32768
    ), po = (
      /*                */
      65536
    ), Wu = (
      /* */
      131072
    ), np = (
      /*                       */
      1048576
    ), op = (
      /*                    */
      2097152
    ), ni = (
      /*                 */
      4194304
    ), ca = (
      /*                */
      8388608
    ), oi = (
      /*               */
      16777216
    ), Wa = (
      /*              */
      33554432
    ), Dl = (
      // TODO: Remove Update flag from before mutation phase by re-landing Visibility
      // flag logic (see #20043)
      tn | Ii | 0
    ), ii = $n | tn | bn | Tn | ri | Fi | ua, Mo = tn | fs | ri | ua, Li = Dn | bn, xo = ni | ca | op, Ms = n.ReactCurrentOwner;
    function Ti(i) {
      var a = i, f = i;
      if (i.alternate)
        for (; a.return; )
          a = a.return;
      else {
        var b = a;
        do
          a = b, (a.flags & ($n | Fi)) !== Lr && (f = a.return), b = a.return;
        while (b);
      }
      return a.tag === w ? f : null;
    }
    function ip(i) {
      if (i.tag === K) {
        var a = i.memoizedState;
        if (a === null) {
          var f = i.alternate;
          f !== null && (a = f.memoizedState);
        }
        if (a !== null)
          return a.dehydrated;
      }
      return null;
    }
    function ed(i) {
      return i.tag === w ? i.stateNode.containerInfo : null;
    }
    function sp(i) {
      return Ti(i) === i;
    }
    function Ei(i) {
      {
        var a = Ms.current;
        if (a !== null && a.tag === C) {
          var f = a, b = f.stateNode;
          b._warnedAboutRefsInRender || c("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", en(f) || "A component"), b._warnedAboutRefsInRender = !0;
        }
      }
      var S = Di(i);
      return S ? Ti(S) === S : !1;
    }
    function si(i) {
      if (Ti(i) !== i)
        throw new Error("Unable to find node on an unmounted component.");
    }
    function jn(i) {
      var a = i.alternate;
      if (!a) {
        var f = Ti(i);
        if (f === null)
          throw new Error("Unable to find node on an unmounted component.");
        return f !== i ? null : i;
      }
      for (var b = i, S = a; ; ) {
        var O = b.return;
        if (O === null)
          break;
        var J = O.alternate;
        if (J === null) {
          var pe = O.return;
          if (pe !== null) {
            b = S = pe;
            continue;
          }
          break;
        }
        if (O.child === J.child) {
          for (var me = O.child; me; ) {
            if (me === b)
              return si(O), i;
            if (me === S)
              return si(O), a;
            me = me.sibling;
          }
          throw new Error("Unable to find node on an unmounted component.");
        }
        if (b.return !== S.return)
          b = O, S = J;
        else {
          for (var Se = !1, _e = O.child; _e; ) {
            if (_e === b) {
              Se = !0, b = O, S = J;
              break;
            }
            if (_e === S) {
              Se = !0, S = O, b = J;
              break;
            }
            _e = _e.sibling;
          }
          if (!Se) {
            for (_e = J.child; _e; ) {
              if (_e === b) {
                Se = !0, b = J, S = O;
                break;
              }
              if (_e === S) {
                Se = !0, S = J, b = O;
                break;
              }
              _e = _e.sibling;
            }
            if (!Se)
              throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (b.alternate !== S)
          throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (b.tag !== w)
        throw new Error("Unable to find node on an unmounted component.");
      return b.stateNode.current === b ? i : a;
    }
    function Bi(i) {
      var a = jn(i);
      return a !== null ? ap(a) : null;
    }
    function ap(i) {
      if (i.tag === L || i.tag === M)
        return i;
      for (var a = i.child; a !== null; ) {
        var f = ap(a);
        if (f !== null)
          return f;
        a = a.sibling;
      }
      return null;
    }
    function Am(i) {
      var a = jn(i);
      return a !== null ? td(a) : null;
    }
    function td(i) {
      if (i.tag === L || i.tag === M)
        return i;
      for (var a = i.child; a !== null; ) {
        if (a.tag !== R) {
          var f = td(a);
          if (f !== null)
            return f;
        }
        a = a.sibling;
      }
      return null;
    }
    var rd = t.unstable_scheduleCallback, $m = t.unstable_cancelCallback, nd = t.unstable_shouldYield, jm = t.unstable_requestPaint, Ln = t.unstable_now, lp = t.unstable_getCurrentPriorityLevel, od = t.unstable_ImmediatePriority, Ci = t.unstable_UserBlockingPriority, ps = t.unstable_NormalPriority, id = t.unstable_LowPriority, da = t.unstable_IdlePriority, up = t.unstable_yieldValue, cp = t.unstable_setDisableYieldValue, fa = null, ho = null, dr = null, Yn = !1, bo = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u";
    function dp(i) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u")
        return !1;
      var a = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (a.isDisabled)
        return !0;
      if (!a.supportsFiber)
        return c("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
      try {
        Ve && (i = sn({}, i, {
          getLaneLabelMap: ha,
          injectProfilingHooks: Os
        })), fa = a.inject(i), ho = a;
      } catch (f) {
        c("React instrumentation encountered an error: %s.", f);
      }
      return !!a.checkDCE;
    }
    function Mm(i, a) {
      if (ho && typeof ho.onScheduleFiberRoot == "function")
        try {
          ho.onScheduleFiberRoot(fa, i, a);
        } catch (f) {
          Yn || (Yn = !0, c("React instrumentation encountered an error: %s", f));
        }
    }
    function Ns(i, a) {
      if (ho && typeof ho.onCommitFiberRoot == "function")
        try {
          var f = (i.current.flags & Kr) === Kr;
          if (Oe) {
            var b;
            switch (a) {
              case No:
                b = od;
                break;
              case To:
                b = Ci;
                break;
              case Is:
                b = ps;
                break;
              case ec:
                b = da;
                break;
              default:
                b = ps;
                break;
            }
            ho.onCommitFiberRoot(fa, i, b, f);
          }
        } catch (S) {
          Yn || (Yn = !0, c("React instrumentation encountered an error: %s", S));
        }
    }
    function pa(i) {
      if (ho && typeof ho.onPostCommitFiberRoot == "function")
        try {
          ho.onPostCommitFiberRoot(fa, i);
        } catch (a) {
          Yn || (Yn = !0, c("React instrumentation encountered an error: %s", a));
        }
    }
    function fp(i) {
      if (ho && typeof ho.onCommitFiberUnmount == "function")
        try {
          ho.onCommitFiberUnmount(fa, i);
        } catch (a) {
          Yn || (Yn = !0, c("React instrumentation encountered an error: %s", a));
        }
    }
    function no(i) {
      if (typeof up == "function" && (cp(i), s(i)), ho && typeof ho.setStrictMode == "function")
        try {
          ho.setStrictMode(fa, i);
        } catch (a) {
          Yn || (Yn = !0, c("React instrumentation encountered an error: %s", a));
        }
    }
    function Os(i) {
      dr = i;
    }
    function ha() {
      {
        for (var i = /* @__PURE__ */ new Map(), a = 1, f = 0; f < Mn; f++) {
          var b = ag(a);
          i.set(a, b), a *= 2;
        }
        return i;
      }
    }
    function sd(i) {
      dr !== null && typeof dr.markCommitStarted == "function" && dr.markCommitStarted(i);
    }
    function pp() {
      dr !== null && typeof dr.markCommitStopped == "function" && dr.markCommitStopped();
    }
    function ma(i) {
      dr !== null && typeof dr.markComponentRenderStarted == "function" && dr.markComponentRenderStarted(i);
    }
    function Ga() {
      dr !== null && typeof dr.markComponentRenderStopped == "function" && dr.markComponentRenderStopped();
    }
    function Nm(i) {
      dr !== null && typeof dr.markComponentPassiveEffectMountStarted == "function" && dr.markComponentPassiveEffectMountStarted(i);
    }
    function hp() {
      dr !== null && typeof dr.markComponentPassiveEffectMountStopped == "function" && dr.markComponentPassiveEffectMountStopped();
    }
    function ad(i) {
      dr !== null && typeof dr.markComponentPassiveEffectUnmountStarted == "function" && dr.markComponentPassiveEffectUnmountStarted(i);
    }
    function Om() {
      dr !== null && typeof dr.markComponentPassiveEffectUnmountStopped == "function" && dr.markComponentPassiveEffectUnmountStopped();
    }
    function Dm(i) {
      dr !== null && typeof dr.markComponentLayoutEffectMountStarted == "function" && dr.markComponentLayoutEffectMountStarted(i);
    }
    function Im() {
      dr !== null && typeof dr.markComponentLayoutEffectMountStopped == "function" && dr.markComponentLayoutEffectMountStopped();
    }
    function ld(i) {
      dr !== null && typeof dr.markComponentLayoutEffectUnmountStarted == "function" && dr.markComponentLayoutEffectUnmountStarted(i);
    }
    function Il() {
      dr !== null && typeof dr.markComponentLayoutEffectUnmountStopped == "function" && dr.markComponentLayoutEffectUnmountStopped();
    }
    function ud(i, a, f) {
      dr !== null && typeof dr.markComponentErrored == "function" && dr.markComponentErrored(i, a, f);
    }
    function Fm(i, a, f) {
      dr !== null && typeof dr.markComponentSuspended == "function" && dr.markComponentSuspended(i, a, f);
    }
    function Lm(i) {
      dr !== null && typeof dr.markLayoutEffectsStarted == "function" && dr.markLayoutEffectsStarted(i);
    }
    function Fl() {
      dr !== null && typeof dr.markLayoutEffectsStopped == "function" && dr.markLayoutEffectsStopped();
    }
    function Bm(i) {
      dr !== null && typeof dr.markPassiveEffectsStarted == "function" && dr.markPassiveEffectsStarted(i);
    }
    function Gu() {
      dr !== null && typeof dr.markPassiveEffectsStopped == "function" && dr.markPassiveEffectsStopped();
    }
    function is(i) {
      dr !== null && typeof dr.markRenderStarted == "function" && dr.markRenderStarted(i);
    }
    function Yu() {
      dr !== null && typeof dr.markRenderYielded == "function" && dr.markRenderYielded();
    }
    function Ll() {
      dr !== null && typeof dr.markRenderStopped == "function" && dr.markRenderStopped();
    }
    function Ya(i) {
      dr !== null && typeof dr.markRenderScheduled == "function" && dr.markRenderScheduled(i);
    }
    function mp(i, a) {
      dr !== null && typeof dr.markForceUpdateScheduled == "function" && dr.markForceUpdateScheduled(i, a);
    }
    function va(i, a) {
      dr !== null && typeof dr.markStateUpdateScheduled == "function" && dr.markStateUpdateScheduled(i, a);
    }
    var Vr = (
      /*                         */
      0
    ), nn = (
      /*                 */
      1
    ), Ur = (
      /*                    */
      2
    ), Bn = (
      /*               */
      8
    ), zi = (
      /*              */
      16
    ), cd = Math.clz32 ? Math.clz32 : qa, dd = Math.log, vp = Math.LN2;
    function qa(i) {
      var a = i >>> 0;
      return a === 0 ? 32 : 31 - (dd(a) / vp | 0) | 0;
    }
    var Mn = 31, mt = (
      /*                        */
      0
    ), un = (
      /*                          */
      0
    ), Wr = (
      /*                        */
      1
    ), hs = (
      /*    */
      2
    ), Si = (
      /*             */
      4
    ), Ka = (
      /*            */
      8
    ), Nn = (
      /*                     */
      16
    ), Xa = (
      /*                */
      32
    ), ya = (
      /*                       */
      4194240
    ), Qa = (
      /*                        */
      64
    ), Vi = (
      /*                        */
      128
    ), ai = (
      /*                        */
      256
    ), Ja = (
      /*                        */
      512
    ), qu = (
      /*                        */
      1024
    ), Ku = (
      /*                        */
      2048
    ), fd = (
      /*                        */
      4096
    ), pd = (
      /*                        */
      8192
    ), hd = (
      /*                        */
      16384
    ), md = (
      /*                       */
      32768
    ), vd = (
      /*                       */
      65536
    ), yd = (
      /*                       */
      131072
    ), gd = (
      /*                       */
      262144
    ), xd = (
      /*                       */
      524288
    ), Za = (
      /*                       */
      1048576
    ), bd = (
      /*                       */
      2097152
    ), el = (
      /*                            */
      130023424
    ), Ds = (
      /*                             */
      4194304
    ), Td = (
      /*                             */
      8388608
    ), Xu = (
      /*                             */
      16777216
    ), Ed = (
      /*                             */
      33554432
    ), Cd = (
      /*                             */
      67108864
    ), yp = Ds, Bl = (
      /*          */
      134217728
    ), Sd = (
      /*                          */
      268435455
    ), zl = (
      /*               */
      268435456
    ), ga = (
      /*                        */
      536870912
    ), li = (
      /*                   */
      1073741824
    );
    function ag(i) {
      {
        if (i & Wr)
          return "Sync";
        if (i & hs)
          return "InputContinuousHydration";
        if (i & Si)
          return "InputContinuous";
        if (i & Ka)
          return "DefaultHydration";
        if (i & Nn)
          return "Default";
        if (i & Xa)
          return "TransitionHydration";
        if (i & ya)
          return "Transition";
        if (i & el)
          return "Retry";
        if (i & Bl)
          return "SelectiveHydration";
        if (i & zl)
          return "IdleHydration";
        if (i & ga)
          return "Idle";
        if (i & li)
          return "Offscreen";
      }
    }
    var kn = -1, Pd = Qa, Rd = Ds;
    function Vl(i) {
      switch (Jn(i)) {
        case Wr:
          return Wr;
        case hs:
          return hs;
        case Si:
          return Si;
        case Ka:
          return Ka;
        case Nn:
          return Nn;
        case Xa:
          return Xa;
        case Qa:
        case Vi:
        case ai:
        case Ja:
        case qu:
        case Ku:
        case fd:
        case pd:
        case hd:
        case md:
        case vd:
        case yd:
        case gd:
        case xd:
        case Za:
        case bd:
          return i & ya;
        case Ds:
        case Td:
        case Xu:
        case Ed:
        case Cd:
          return i & el;
        case Bl:
          return Bl;
        case zl:
          return zl;
        case ga:
          return ga;
        case li:
          return li;
        default:
          return c("Should have found matching lanes. This is a bug in React."), i;
      }
    }
    function Qu(i, a) {
      var f = i.pendingLanes;
      if (f === mt)
        return mt;
      var b = mt, S = i.suspendedLanes, O = i.pingedLanes, J = f & Sd;
      if (J !== mt) {
        var pe = J & ~S;
        if (pe !== mt)
          b = Vl(pe);
        else {
          var me = J & O;
          me !== mt && (b = Vl(me));
        }
      } else {
        var Se = f & ~S;
        Se !== mt ? b = Vl(Se) : O !== mt && (b = Vl(O));
      }
      if (b === mt)
        return mt;
      if (a !== mt && a !== b && // If we already suspended with a delay, then interrupting is fine. Don't
      // bother waiting until the root is complete.
      (a & S) === mt) {
        var _e = Jn(b), ze = Jn(a);
        if (
          // Tests whether the next lane is equal or lower priority than the wip
          // one. This works because the bits decrease in priority as you go left.
          _e >= ze || // Default priority updates should not interrupt transition updates. The
          // only difference between default updates and transition updates is that
          // default updates do not support refresh transitions.
          _e === Nn && (ze & ya) !== mt
        )
          return a;
      }
      (b & Si) !== mt && (b |= f & Nn);
      var Le = i.entangledLanes;
      if (Le !== mt)
        for (var qe = i.entanglements, Ke = b & Le; Ke > 0; ) {
          var rt = xa(Ke), xr = 1 << rt;
          b |= qe[rt], Ke &= ~xr;
        }
      return b;
    }
    function zm(i, a) {
      for (var f = i.eventTimes, b = kn; a > 0; ) {
        var S = xa(a), O = 1 << S, J = f[S];
        J > b && (b = J), a &= ~O;
      }
      return b;
    }
    function _d(i, a) {
      switch (i) {
        case Wr:
        case hs:
        case Si:
          return a + 250;
        case Ka:
        case Nn:
        case Xa:
        case Qa:
        case Vi:
        case ai:
        case Ja:
        case qu:
        case Ku:
        case fd:
        case pd:
        case hd:
        case md:
        case vd:
        case yd:
        case gd:
        case xd:
        case Za:
        case bd:
          return a + 5e3;
        case Ds:
        case Td:
        case Xu:
        case Ed:
        case Cd:
          return kn;
        case Bl:
        case zl:
        case ga:
        case li:
          return kn;
        default:
          return c("Should have found matching lanes. This is a bug in React."), kn;
      }
    }
    function lg(i, a) {
      for (var f = i.pendingLanes, b = i.suspendedLanes, S = i.pingedLanes, O = i.expirationTimes, J = f; J > 0; ) {
        var pe = xa(J), me = 1 << pe, Se = O[pe];
        Se === kn ? ((me & b) === mt || (me & S) !== mt) && (O[pe] = _d(me, a)) : Se <= a && (i.expiredLanes |= me), J &= ~me;
      }
    }
    function ug(i) {
      return Vl(i.pendingLanes);
    }
    function gp(i) {
      var a = i.pendingLanes & ~li;
      return a !== mt ? a : a & li ? li : mt;
    }
    function Ul(i) {
      return (i & Wr) !== mt;
    }
    function Ju(i) {
      return (i & Sd) !== mt;
    }
    function wd(i) {
      return (i & el) === i;
    }
    function cg(i) {
      var a = Wr | Si | Nn;
      return (i & a) === mt;
    }
    function Vm(i) {
      return (i & ya) === i;
    }
    function Zu(i, a) {
      var f = hs | Si | Ka | Nn;
      return (a & f) !== mt;
    }
    function Um(i, a) {
      return (a & i.expiredLanes) !== mt;
    }
    function xp(i) {
      return (i & ya) !== mt;
    }
    function bp() {
      var i = Pd;
      return Pd <<= 1, (Pd & ya) === mt && (Pd = Qa), i;
    }
    function dg() {
      var i = Rd;
      return Rd <<= 1, (Rd & el) === mt && (Rd = Ds), i;
    }
    function Jn(i) {
      return i & -i;
    }
    function oo(i) {
      return Jn(i);
    }
    function xa(i) {
      return 31 - cd(i);
    }
    function kd(i) {
      return xa(i);
    }
    function ui(i, a) {
      return (i & a) !== mt;
    }
    function tl(i, a) {
      return (i & a) === a;
    }
    function rn(i, a) {
      return i | a;
    }
    function Hl(i, a) {
      return i & ~a;
    }
    function Tp(i, a) {
      return i & a;
    }
    function Hm(i) {
      return i;
    }
    function Wm(i, a) {
      return i !== un && i < a ? i : a;
    }
    function Ad(i) {
      for (var a = [], f = 0; f < Mn; f++)
        a.push(i);
      return a;
    }
    function rl(i, a, f) {
      i.pendingLanes |= a, a !== ga && (i.suspendedLanes = mt, i.pingedLanes = mt);
      var b = i.eventTimes, S = kd(a);
      b[S] = f;
    }
    function Ep(i, a) {
      i.suspendedLanes |= a, i.pingedLanes &= ~a;
      for (var f = i.expirationTimes, b = a; b > 0; ) {
        var S = xa(b), O = 1 << S;
        f[S] = kn, b &= ~O;
      }
    }
    function Cp(i, a, f) {
      i.pingedLanes |= i.suspendedLanes & a;
    }
    function Sp(i, a) {
      var f = i.pendingLanes & ~a;
      i.pendingLanes = a, i.suspendedLanes = mt, i.pingedLanes = mt, i.expiredLanes &= a, i.mutableReadLanes &= a, i.entangledLanes &= a;
      for (var b = i.entanglements, S = i.eventTimes, O = i.expirationTimes, J = f; J > 0; ) {
        var pe = xa(J), me = 1 << pe;
        b[pe] = mt, S[pe] = kn, O[pe] = kn, J &= ~me;
      }
    }
    function Wl(i, a) {
      for (var f = i.entangledLanes |= a, b = i.entanglements, S = f; S; ) {
        var O = xa(S), J = 1 << O;
        // Is this one of the newly entangled lanes?
        J & a | // Is this lane transitively entangled with the newly entangled lanes?
        b[O] & a && (b[O] |= a), S &= ~J;
      }
    }
    function fg(i, a) {
      var f = Jn(a), b;
      switch (f) {
        case Si:
          b = hs;
          break;
        case Nn:
          b = Ka;
          break;
        case Qa:
        case Vi:
        case ai:
        case Ja:
        case qu:
        case Ku:
        case fd:
        case pd:
        case hd:
        case md:
        case vd:
        case yd:
        case gd:
        case xd:
        case Za:
        case bd:
        case Ds:
        case Td:
        case Xu:
        case Ed:
        case Cd:
          b = Xa;
          break;
        case ga:
          b = zl;
          break;
        default:
          b = un;
          break;
      }
      return (b & (i.suspendedLanes | a)) !== un ? un : b;
    }
    function Pp(i, a, f) {
      if (bo)
        for (var b = i.pendingUpdatersLaneMap; f > 0; ) {
          var S = kd(f), O = 1 << S, J = b[S];
          J.add(a), f &= ~O;
        }
    }
    function $d(i, a) {
      if (bo)
        for (var f = i.pendingUpdatersLaneMap, b = i.memoizedUpdaters; a > 0; ) {
          var S = kd(a), O = 1 << S, J = f[S];
          J.size > 0 && (J.forEach(function(pe) {
            var me = pe.alternate;
            (me === null || !b.has(me)) && b.add(pe);
          }), J.clear()), a &= ~O;
        }
    }
    function Rp(i, a) {
      return null;
    }
    var No = Wr, To = Si, Is = Nn, ec = ga, nl = un;
    function Ui() {
      return nl;
    }
    function io(i) {
      nl = i;
    }
    function tc(i, a) {
      var f = nl;
      try {
        return nl = i, a();
      } finally {
        nl = f;
      }
    }
    function Oo(i, a) {
      return i !== 0 && i < a ? i : a;
    }
    function pg(i, a) {
      return i === 0 || i > a ? i : a;
    }
    function _p(i, a) {
      return i !== 0 && i < a;
    }
    function rc(i) {
      var a = Jn(i);
      return _p(No, a) ? _p(To, a) ? Ju(a) ? Is : ec : To : No;
    }
    function so(i) {
      var a = i.current.memoizedState;
      return a.isDehydrated;
    }
    var Gm;
    function Cr(i) {
      Gm = i;
    }
    function Gl(i) {
      Gm(i);
    }
    var nc;
    function Ym(i) {
      nc = i;
    }
    var qm;
    function oc(i) {
      qm = i;
    }
    var ic;
    function wp(i) {
      ic = i;
    }
    var kp;
    function Km(i) {
      kp = i;
    }
    var jd = !1, Yl = [], ms = null, In = null, mo = null, Hi = /* @__PURE__ */ new Map(), ql = /* @__PURE__ */ new Map(), Fs = [], ss = [
      "mousedown",
      "mouseup",
      "touchcancel",
      "touchend",
      "touchstart",
      "auxclick",
      "dblclick",
      "pointercancel",
      "pointerdown",
      "pointerup",
      "dragend",
      "dragstart",
      "drop",
      "compositionend",
      "compositionstart",
      "keydown",
      "keypress",
      "keyup",
      "input",
      "textInput",
      // Intentionally camelCase
      "copy",
      "cut",
      "paste",
      "click",
      "change",
      "contextmenu",
      "reset",
      "submit"
    ];
    function Xm(i) {
      return ss.indexOf(i) > -1;
    }
    function vs(i, a, f, b, S) {
      return {
        blockedOn: i,
        domEventName: a,
        eventSystemFlags: f,
        nativeEvent: S,
        targetContainers: [b]
      };
    }
    function Qm(i, a) {
      switch (i) {
        case "focusin":
        case "focusout":
          ms = null;
          break;
        case "dragenter":
        case "dragleave":
          In = null;
          break;
        case "mouseover":
        case "mouseout":
          mo = null;
          break;
        case "pointerover":
        case "pointerout": {
          var f = a.pointerId;
          Hi.delete(f);
          break;
        }
        case "gotpointercapture":
        case "lostpointercapture": {
          var b = a.pointerId;
          ql.delete(b);
          break;
        }
      }
    }
    function Kl(i, a, f, b, S, O) {
      if (i === null || i.nativeEvent !== O) {
        var J = vs(a, f, b, S, O);
        if (a !== null) {
          var pe = su(a);
          pe !== null && nc(pe);
        }
        return J;
      }
      i.eventSystemFlags |= b;
      var me = i.targetContainers;
      return S !== null && me.indexOf(S) === -1 && me.push(S), i;
    }
    function Jm(i, a, f, b, S) {
      switch (a) {
        case "focusin": {
          var O = S;
          return ms = Kl(ms, i, a, f, b, O), !0;
        }
        case "dragenter": {
          var J = S;
          return In = Kl(In, i, a, f, b, J), !0;
        }
        case "mouseover": {
          var pe = S;
          return mo = Kl(mo, i, a, f, b, pe), !0;
        }
        case "pointerover": {
          var me = S, Se = me.pointerId;
          return Hi.set(Se, Kl(Hi.get(Se) || null, i, a, f, b, me)), !0;
        }
        case "gotpointercapture": {
          var _e = S, ze = _e.pointerId;
          return ql.set(ze, Kl(ql.get(ze) || null, i, a, f, b, _e)), !0;
        }
      }
      return !1;
    }
    function Ap(i) {
      var a = hc(i.target);
      if (a !== null) {
        var f = Ti(a);
        if (f !== null) {
          var b = f.tag;
          if (b === K) {
            var S = ip(f);
            if (S !== null) {
              i.blockedOn = S, kp(i.priority, function() {
                qm(f);
              });
              return;
            }
          } else if (b === w) {
            var O = f.stateNode;
            if (so(O)) {
              i.blockedOn = ed(f);
              return;
            }
          }
        }
      }
      i.blockedOn = null;
    }
    function Zm(i) {
      for (var a = ic(), f = {
        blockedOn: null,
        target: i,
        priority: a
      }, b = 0; b < Fs.length && _p(a, Fs[b].priority); b++)
        ;
      Fs.splice(b, 0, f), b === 0 && Ap(f);
    }
    function Md(i) {
      if (i.blockedOn !== null)
        return !1;
      for (var a = i.targetContainers; a.length > 0; ) {
        var f = a[0], b = ol(i.domEventName, i.eventSystemFlags, f, i.nativeEvent);
        if (b === null) {
          var S = i.nativeEvent, O = new S.constructor(S.type, S);
          Fu(O), S.target.dispatchEvent(O), ng();
        } else {
          var J = su(b);
          return J !== null && nc(J), i.blockedOn = b, !1;
        }
        a.shift();
      }
      return !0;
    }
    function sc(i, a, f) {
      Md(i) && f.delete(a);
    }
    function $p() {
      jd = !1, ms !== null && Md(ms) && (ms = null), In !== null && Md(In) && (In = null), mo !== null && Md(mo) && (mo = null), Hi.forEach(sc), ql.forEach(sc);
    }
    function Do(i, a) {
      i.blockedOn === a && (i.blockedOn = null, jd || (jd = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, $p)));
    }
    function an(i) {
      if (Yl.length > 0) {
        Do(Yl[0], i);
        for (var a = 1; a < Yl.length; a++) {
          var f = Yl[a];
          f.blockedOn === i && (f.blockedOn = null);
        }
      }
      ms !== null && Do(ms, i), In !== null && Do(In, i), mo !== null && Do(mo, i);
      var b = function(pe) {
        return Do(pe, i);
      };
      Hi.forEach(b), ql.forEach(b);
      for (var S = 0; S < Fs.length; S++) {
        var O = Fs[S];
        O.blockedOn === i && (O.blockedOn = null);
      }
      for (; Fs.length > 0; ) {
        var J = Fs[0];
        if (J.blockedOn !== null)
          break;
        Ap(J), J.blockedOn === null && Fs.shift();
      }
    }
    var zn = n.ReactCurrentBatchConfig, Hn = !0;
    function vo(i) {
      Hn = !!i;
    }
    function Pi() {
      return Hn;
    }
    function Xl(i, a, f) {
      var b = Vo(a), S;
      switch (b) {
        case No:
          S = ao;
          break;
        case To:
          S = ac;
          break;
        case Is:
        default:
          S = Ls;
          break;
      }
      return S.bind(null, a, f, i);
    }
    function ao(i, a, f, b) {
      var S = Ui(), O = zn.transition;
      zn.transition = null;
      try {
        io(No), Ls(i, a, f, b);
      } finally {
        io(S), zn.transition = O;
      }
    }
    function ac(i, a, f, b) {
      var S = Ui(), O = zn.transition;
      zn.transition = null;
      try {
        io(To), Ls(i, a, f, b);
      } finally {
        io(S), zn.transition = O;
      }
    }
    function Ls(i, a, f, b) {
      Hn && Nd(i, a, f, b);
    }
    function Nd(i, a, f, b) {
      var S = ol(i, a, f, b);
      if (S === null) {
        Mg(i, a, b, Ql, f), Qm(i, b);
        return;
      }
      if (Jm(S, i, a, f, b)) {
        b.stopPropagation();
        return;
      }
      if (Qm(i, b), a & Ba && Xm(i)) {
        for (; S !== null; ) {
          var O = su(S);
          O !== null && Gl(O);
          var J = ol(i, a, f, b);
          if (J === null && Mg(i, a, b, Ql, f), J === S)
            break;
          S = J;
        }
        S !== null && b.stopPropagation();
        return;
      }
      Mg(i, a, b, null, f);
    }
    var Ql = null;
    function ol(i, a, f, b) {
      Ql = null;
      var S = Kc(b), O = hc(S);
      if (O !== null) {
        var J = Ti(O);
        if (J === null)
          O = null;
        else {
          var pe = J.tag;
          if (pe === K) {
            var me = ip(J);
            if (me !== null)
              return me;
            O = null;
          } else if (pe === w) {
            var Se = J.stateNode;
            if (so(Se))
              return ed(J);
            O = null;
          } else
            J !== O && (O = null);
        }
      }
      return Ql = O, null;
    }
    function Vo(i) {
      switch (i) {
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return No;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return To;
        case "message": {
          var a = lp();
          switch (a) {
            case od:
              return No;
            case Ci:
              return To;
            case ps:
            case id:
              return Is;
            case da:
              return ec;
            default:
              return Is;
          }
        }
        default:
          return Is;
      }
    }
    function jp(i, a, f) {
      return i.addEventListener(a, f, !1), f;
    }
    function Jl(i, a, f) {
      return i.addEventListener(a, f, !0), f;
    }
    function Bs(i, a, f, b) {
      return i.addEventListener(a, f, {
        capture: !0,
        passive: b
      }), f;
    }
    function Od(i, a, f, b) {
      return i.addEventListener(a, f, {
        passive: b
      }), f;
    }
    var il = null, ys = null, ba = null;
    function Ta(i) {
      return il = i, ys = Id(), !0;
    }
    function Dd() {
      il = null, ys = null, ba = null;
    }
    function Zl() {
      if (ba)
        return ba;
      var i, a = ys, f = a.length, b, S = Id(), O = S.length;
      for (i = 0; i < f && a[i] === S[i]; i++)
        ;
      var J = f - i;
      for (b = 1; b <= J && a[f - b] === S[O - b]; b++)
        ;
      var pe = b > 1 ? 1 - b : void 0;
      return ba = S.slice(i, pe), ba;
    }
    function Id() {
      return "value" in il ? il.value : il.textContent;
    }
    function sl(i) {
      var a, f = i.keyCode;
      return "charCode" in i ? (a = i.charCode, a === 0 && f === 13 && (a = 13)) : a = f, a === 10 && (a = 13), a >= 32 || a === 13 ? a : 0;
    }
    function al() {
      return !0;
    }
    function Io() {
      return !1;
    }
    function Zn(i) {
      function a(f, b, S, O, J) {
        this._reactName = f, this._targetInst = S, this.type = b, this.nativeEvent = O, this.target = J, this.currentTarget = null;
        for (var pe in i)
          if (i.hasOwnProperty(pe)) {
            var me = i[pe];
            me ? this[pe] = me(O) : this[pe] = O[pe];
          }
        var Se = O.defaultPrevented != null ? O.defaultPrevented : O.returnValue === !1;
        return Se ? this.isDefaultPrevented = al : this.isDefaultPrevented = Io, this.isPropagationStopped = Io, this;
      }
      return sn(a.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var f = this.nativeEvent;
          f && (f.preventDefault ? f.preventDefault() : typeof f.returnValue != "unknown" && (f.returnValue = !1), this.isDefaultPrevented = al);
        },
        stopPropagation: function() {
          var f = this.nativeEvent;
          f && (f.stopPropagation ? f.stopPropagation() : typeof f.cancelBubble != "unknown" && (f.cancelBubble = !0), this.isPropagationStopped = al);
        },
        /**
         * We release all dispatched `SyntheticEvent`s after each event loop, adding
         * them back into the pool. This allows a way to hold onto a reference that
         * won't be added back into the pool.
         */
        persist: function() {
        },
        /**
         * Checks if this event should be released back into the pool.
         *
         * @return {boolean} True if this should not be released, false otherwise.
         */
        isPersistent: al
      }), a;
    }
    var Fo = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(i) {
        return i.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, Lo = Zn(Fo), eu = sn({}, Fo, {
      view: 0,
      detail: 0
    }), Mp = Zn(eu), lc, Np, Wi;
    function ev(i) {
      i !== Wi && (Wi && i.type === "mousemove" ? (lc = i.screenX - Wi.screenX, Np = i.screenY - Wi.screenY) : (lc = 0, Np = 0), Wi = i);
    }
    var tu = sn({}, eu, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: Bd,
      button: 0,
      buttons: 0,
      relatedTarget: function(i) {
        return i.relatedTarget === void 0 ? i.fromElement === i.srcElement ? i.toElement : i.fromElement : i.relatedTarget;
      },
      movementX: function(i) {
        return "movementX" in i ? i.movementX : (ev(i), lc);
      },
      movementY: function(i) {
        return "movementY" in i ? i.movementY : Np;
      }
    }), Ea = Zn(tu), Op = sn({}, tu, {
      dataTransfer: 0
    }), ll = Zn(Op), tv = sn({}, eu, {
      relatedTarget: 0
    }), Fd = Zn(tv), Dp = sn({}, Fo, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), Ld = Zn(Dp), hg = sn({}, Fo, {
      clipboardData: function(i) {
        return "clipboardData" in i ? i.clipboardData : window.clipboardData;
      }
    }), mg = Zn(hg), rv = sn({}, Fo, {
      data: 0
    }), Ip = Zn(rv), ul = Ip, vg = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, ru = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    };
    function nv(i) {
      if (i.key) {
        var a = vg[i.key] || i.key;
        if (a !== "Unidentified")
          return a;
      }
      if (i.type === "keypress") {
        var f = sl(i);
        return f === 13 ? "Enter" : String.fromCharCode(f);
      }
      return i.type === "keydown" || i.type === "keyup" ? ru[i.keyCode] || "Unidentified" : "";
    }
    var Wn = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
    function yg(i) {
      var a = this, f = a.nativeEvent;
      if (f.getModifierState)
        return f.getModifierState(i);
      var b = Wn[i];
      return b ? !!f[b] : !1;
    }
    function Bd(i) {
      return yg;
    }
    var gg = sn({}, eu, {
      key: nv,
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: Bd,
      // Legacy Interface
      charCode: function(i) {
        return i.type === "keypress" ? sl(i) : 0;
      },
      keyCode: function(i) {
        return i.type === "keydown" || i.type === "keyup" ? i.keyCode : 0;
      },
      which: function(i) {
        return i.type === "keypress" ? sl(i) : i.type === "keydown" || i.type === "keyup" ? i.keyCode : 0;
      }
    }), xg = Zn(gg), ov = sn({}, tu, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), Fp = Zn(ov), bg = sn({}, eu, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: Bd
    }), Gi = Zn(bg), Lp = sn({}, Fo, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), Tg = Zn(Lp), Ca = sn({}, tu, {
      deltaX: function(i) {
        return "deltaX" in i ? i.deltaX : (
          // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
          "wheelDeltaX" in i ? -i.wheelDeltaX : 0
        );
      },
      deltaY: function(i) {
        return "deltaY" in i ? i.deltaY : (
          // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
          "wheelDeltaY" in i ? -i.wheelDeltaY : (
            // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
            "wheelDelta" in i ? -i.wheelDelta : 0
          )
        );
      },
      deltaZ: 0,
      // Browsers without "deltaMode" is reporting in raw wheel delta where one
      // notch on the scroll is always +/- 120, roughly equivalent to pixels.
      // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
      // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
      deltaMode: 0
    }), zd = Zn(Ca), cl = [9, 13, 27, 32], uc = 229, cc = xt && "CompositionEvent" in window, dl = null;
    xt && "documentMode" in document && (dl = document.documentMode);
    var Eg = xt && "TextEvent" in window && !dl, Vd = xt && (!cc || dl && dl > 8 && dl <= 11), iv = 32, Bp = String.fromCharCode(iv);
    function sv() {
      St("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), St("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), St("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), St("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
    }
    var dc = !1;
    function Ud(i) {
      return (i.ctrlKey || i.altKey || i.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
      !(i.ctrlKey && i.altKey);
    }
    function av(i) {
      switch (i) {
        case "compositionstart":
          return "onCompositionStart";
        case "compositionend":
          return "onCompositionEnd";
        case "compositionupdate":
          return "onCompositionUpdate";
      }
    }
    function zp(i, a) {
      return i === "keydown" && a.keyCode === uc;
    }
    function lv(i, a) {
      switch (i) {
        case "keyup":
          return cl.indexOf(a.keyCode) !== -1;
        case "keydown":
          return a.keyCode !== uc;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function Vp(i) {
      var a = i.detail;
      return typeof a == "object" && "data" in a ? a.data : null;
    }
    function Hd(i) {
      return i.locale === "ko";
    }
    var zs = !1;
    function Up(i, a, f, b, S) {
      var O, J;
      if (cc ? O = av(a) : zs ? lv(a, b) && (O = "onCompositionEnd") : zp(a, b) && (O = "onCompositionStart"), !O)
        return null;
      Vd && !Hd(b) && (!zs && O === "onCompositionStart" ? zs = Ta(S) : O === "onCompositionEnd" && zs && (J = Zl()));
      var pe = pv(f, O);
      if (pe.length > 0) {
        var me = new Ip(O, a, null, b, S);
        if (i.push({
          event: me,
          listeners: pe
        }), J)
          me.data = J;
        else {
          var Se = Vp(b);
          Se !== null && (me.data = Se);
        }
      }
    }
    function Wd(i, a) {
      switch (i) {
        case "compositionend":
          return Vp(a);
        case "keypress":
          var f = a.which;
          return f !== iv ? null : (dc = !0, Bp);
        case "textInput":
          var b = a.data;
          return b === Bp && dc ? null : b;
        default:
          return null;
      }
    }
    function uv(i, a) {
      if (zs) {
        if (i === "compositionend" || !cc && lv(i, a)) {
          var f = Zl();
          return Dd(), zs = !1, f;
        }
        return null;
      }
      switch (i) {
        case "paste":
          return null;
        case "keypress":
          if (!Ud(a)) {
            if (a.char && a.char.length > 1)
              return a.char;
            if (a.which)
              return String.fromCharCode(a.which);
          }
          return null;
        case "compositionend":
          return Vd && !Hd(a) ? null : a.data;
        default:
          return null;
      }
    }
    function Cg(i, a, f, b, S) {
      var O;
      if (Eg ? O = Wd(a, b) : O = uv(a, b), !O)
        return null;
      var J = pv(f, "onBeforeInput");
      if (J.length > 0) {
        var pe = new ul("onBeforeInput", "beforeinput", null, b, S);
        i.push({
          event: pe,
          listeners: J
        }), pe.data = O;
      }
    }
    function Gd(i, a, f, b, S, O, J) {
      Up(i, a, f, b, S), Cg(i, a, f, b, S);
    }
    var Sg = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    };
    function nu(i) {
      var a = i && i.nodeName && i.nodeName.toLowerCase();
      return a === "input" ? !!Sg[i.type] : a === "textarea";
    }
    /**
     * Checks if an event is supported in the current execution environment.
     *
     * NOTE: This will not work correctly for non-generic events such as `change`,
     * `reset`, `load`, `error`, and `select`.
     *
     * Borrows from Modernizr.
     *
     * @param {string} eventNameSuffix Event name, e.g. "click".
     * @return {boolean} True if the event is supported.
     * @internal
     * @license Modernizr 3.0.0pre (Custom Build) | MIT
     */
    function Pg(i) {
      if (!xt)
        return !1;
      var a = "on" + i, f = a in document;
      if (!f) {
        var b = document.createElement("div");
        b.setAttribute(a, "return;"), f = typeof b[a] == "function";
      }
      return f;
    }
    function Yd() {
      St("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
    }
    function u(i, a, f, b) {
      Xc(b);
      var S = pv(a, "onChange");
      if (S.length > 0) {
        var O = new Lo("onChange", "change", null, f, b);
        i.push({
          event: O,
          listeners: S
        });
      }
    }
    var d = null, T = null;
    function k(i) {
      var a = i.nodeName && i.nodeName.toLowerCase();
      return a === "select" || a === "input" && i.type === "file";
    }
    function Q(i) {
      var a = [];
      u(a, T, i, Kc(i)), Qf(ce, a);
    }
    function ce(i) {
      Ab(i, 0);
    }
    function ge(i) {
      var a = Zd(i);
      if (Kh(a))
        return i;
    }
    function $e(i, a) {
      if (i === "change")
        return a;
    }
    var Ne = !1;
    xt && (Ne = Pg("input") && (!document.documentMode || document.documentMode > 9));
    function Xe(i, a) {
      d = i, T = a, d.attachEvent("onpropertychange", or);
    }
    function Mt() {
      d && (d.detachEvent("onpropertychange", or), d = null, T = null);
    }
    function or(i) {
      i.propertyName === "value" && ge(T) && Q(i);
    }
    function At(i, a, f) {
      i === "focusin" ? (Mt(), Xe(a, f)) : i === "focusout" && Mt();
    }
    function yr(i, a) {
      if (i === "selectionchange" || i === "keyup" || i === "keydown")
        return ge(T);
    }
    function Pr(i) {
      var a = i.nodeName;
      return a && a.toLowerCase() === "input" && (i.type === "checkbox" || i.type === "radio");
    }
    function Ar(i, a) {
      if (i === "click")
        return ge(a);
    }
    function qn(i, a) {
      if (i === "input" || i === "change")
        return ge(a);
    }
    function Ue(i) {
      var a = i._wrapperState;
      !a || !a.controlled || i.type !== "number" || na(i, "number", i.value);
    }
    function Be(i, a, f, b, S, O, J) {
      var pe = f ? Zd(f) : window, me, Se;
      if (k(pe) ? me = $e : nu(pe) ? Ne ? me = qn : (me = yr, Se = At) : Pr(pe) && (me = Ar), me) {
        var _e = me(a, f);
        if (_e) {
          u(i, _e, b, S);
          return;
        }
      }
      Se && Se(a, pe, f), a === "focusout" && Ue(pe);
    }
    function Ge() {
      Qe("onMouseEnter", ["mouseout", "mouseover"]), Qe("onMouseLeave", ["mouseout", "mouseover"]), Qe("onPointerEnter", ["pointerout", "pointerover"]), Qe("onPointerLeave", ["pointerout", "pointerover"]);
    }
    function lr(i, a, f, b, S, O, J) {
      var pe = a === "mouseover" || a === "pointerover", me = a === "mouseout" || a === "pointerout";
      if (pe && !Rm(b)) {
        var Se = b.relatedTarget || b.fromElement;
        if (Se && (hc(Se) || nh(Se)))
          return;
      }
      if (!(!me && !pe)) {
        var _e;
        if (S.window === S)
          _e = S;
        else {
          var ze = S.ownerDocument;
          ze ? _e = ze.defaultView || ze.parentWindow : _e = window;
        }
        var Le, qe;
        if (me) {
          var Ke = b.relatedTarget || b.toElement;
          if (Le = f, qe = Ke ? hc(Ke) : null, qe !== null) {
            var rt = Ti(qe);
            (qe !== rt || qe.tag !== L && qe.tag !== M) && (qe = null);
          }
        } else
          Le = null, qe = f;
        if (Le !== qe) {
          var xr = Ea, zr = "onMouseLeave", Or = "onMouseEnter", dn = "mouse";
          (a === "pointerout" || a === "pointerover") && (xr = Fp, zr = "onPointerLeave", Or = "onPointerEnter", dn = "pointer");
          var ln = Le == null ? _e : Zd(Le), He = qe == null ? _e : Zd(qe), ct = new xr(zr, dn + "leave", Le, b, S);
          ct.target = ln, ct.relatedTarget = He;
          var We = null, sr = hc(S);
          if (sr === f) {
            var br = new xr(Or, dn + "enter", qe, b, S);
            br.target = He, br.relatedTarget = ln, We = br;
          }
          yC(i, ct, We, Le, qe);
        }
      }
    }
    function Mr(i, a) {
      return i === a && (i !== 0 || 1 / i === 1 / a) || i !== i && a !== a;
    }
    var Rr = typeof Object.is == "function" ? Object.is : Mr;
    function Fr(i, a) {
      if (Rr(i, a))
        return !0;
      if (typeof i != "object" || i === null || typeof a != "object" || a === null)
        return !1;
      var f = Object.keys(i), b = Object.keys(a);
      if (f.length !== b.length)
        return !1;
      for (var S = 0; S < f.length; S++) {
        var O = f[S];
        if (!je.call(a, O) || !Rr(i[O], a[O]))
          return !1;
      }
      return !0;
    }
    function Xr(i) {
      for (; i && i.firstChild; )
        i = i.firstChild;
      return i;
    }
    function yo(i) {
      for (; i; ) {
        if (i.nextSibling)
          return i.nextSibling;
        i = i.parentNode;
      }
    }
    function pn(i, a) {
      for (var f = Xr(i), b = 0, S = 0; f; ) {
        if (f.nodeType === ws) {
          if (S = b + f.textContent.length, b <= a && S >= a)
            return {
              node: f,
              offset: a - b
            };
          b = S;
        }
        f = Xr(yo(f));
      }
    }
    function Sa(i) {
      var a = i.ownerDocument, f = a && a.defaultView || window, b = f.getSelection && f.getSelection();
      if (!b || b.rangeCount === 0)
        return null;
      var S = b.anchorNode, O = b.anchorOffset, J = b.focusNode, pe = b.focusOffset;
      try {
        S.nodeType, J.nodeType;
      } catch {
        return null;
      }
      return Rg(i, S, O, J, pe);
    }
    function Rg(i, a, f, b, S) {
      var O = 0, J = -1, pe = -1, me = 0, Se = 0, _e = i, ze = null;
      e:
        for (; ; ) {
          for (var Le = null; _e === a && (f === 0 || _e.nodeType === ws) && (J = O + f), _e === b && (S === 0 || _e.nodeType === ws) && (pe = O + S), _e.nodeType === ws && (O += _e.nodeValue.length), (Le = _e.firstChild) !== null; )
            ze = _e, _e = Le;
          for (; ; ) {
            if (_e === i)
              break e;
            if (ze === a && ++me === f && (J = O), ze === b && ++Se === S && (pe = O), (Le = _e.nextSibling) !== null)
              break;
            _e = ze, ze = _e.parentNode;
          }
          _e = Le;
        }
      return J === -1 || pe === -1 ? null : {
        start: J,
        end: pe
      };
    }
    function JE(i, a) {
      var f = i.ownerDocument || document, b = f && f.defaultView || window;
      if (b.getSelection) {
        var S = b.getSelection(), O = i.textContent.length, J = Math.min(a.start, O), pe = a.end === void 0 ? J : Math.min(a.end, O);
        if (!S.extend && J > pe) {
          var me = pe;
          pe = J, J = me;
        }
        var Se = pn(i, J), _e = pn(i, pe);
        if (Se && _e) {
          if (S.rangeCount === 1 && S.anchorNode === Se.node && S.anchorOffset === Se.offset && S.focusNode === _e.node && S.focusOffset === _e.offset)
            return;
          var ze = f.createRange();
          ze.setStart(Se.node, Se.offset), S.removeAllRanges(), J > pe ? (S.addRange(ze), S.extend(_e.node, _e.offset)) : (ze.setEnd(_e.node, _e.offset), S.addRange(ze));
        }
      }
    }
    function gb(i) {
      return i && i.nodeType === ws;
    }
    function xb(i, a) {
      return !i || !a ? !1 : i === a ? !0 : gb(i) ? !1 : gb(a) ? xb(i, a.parentNode) : "contains" in i ? i.contains(a) : i.compareDocumentPosition ? !!(i.compareDocumentPosition(a) & 16) : !1;
    }
    function ZE(i) {
      return i && i.ownerDocument && xb(i.ownerDocument.documentElement, i);
    }
    function eC(i) {
      try {
        return typeof i.contentWindow.location.href == "string";
      } catch {
        return !1;
      }
    }
    function bb() {
      for (var i = window, a = Dc(); a instanceof i.HTMLIFrameElement; ) {
        if (eC(a))
          i = a.contentWindow;
        else
          return a;
        a = Dc(i.document);
      }
      return a;
    }
    function _g(i) {
      var a = i && i.nodeName && i.nodeName.toLowerCase();
      return a && (a === "input" && (i.type === "text" || i.type === "search" || i.type === "tel" || i.type === "url" || i.type === "password") || a === "textarea" || i.contentEditable === "true");
    }
    function tC() {
      var i = bb();
      return {
        focusedElem: i,
        selectionRange: _g(i) ? nC(i) : null
      };
    }
    function rC(i) {
      var a = bb(), f = i.focusedElem, b = i.selectionRange;
      if (a !== f && ZE(f)) {
        b !== null && _g(f) && oC(f, b);
        for (var S = [], O = f; O = O.parentNode; )
          O.nodeType === ti && S.push({
            element: O,
            left: O.scrollLeft,
            top: O.scrollTop
          });
        typeof f.focus == "function" && f.focus();
        for (var J = 0; J < S.length; J++) {
          var pe = S[J];
          pe.element.scrollLeft = pe.left, pe.element.scrollTop = pe.top;
        }
      }
    }
    function nC(i) {
      var a;
      return "selectionStart" in i ? a = {
        start: i.selectionStart,
        end: i.selectionEnd
      } : a = Sa(i), a || {
        start: 0,
        end: 0
      };
    }
    function oC(i, a) {
      var f = a.start, b = a.end;
      b === void 0 && (b = f), "selectionStart" in i ? (i.selectionStart = f, i.selectionEnd = Math.min(b, i.value.length)) : JE(i, a);
    }
    var iC = xt && "documentMode" in document && document.documentMode <= 11;
    function sC() {
      St("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
    }
    var qd = null, wg = null, Hp = null, kg = !1;
    function aC(i) {
      if ("selectionStart" in i && _g(i))
        return {
          start: i.selectionStart,
          end: i.selectionEnd
        };
      var a = i.ownerDocument && i.ownerDocument.defaultView || window, f = a.getSelection();
      return {
        anchorNode: f.anchorNode,
        anchorOffset: f.anchorOffset,
        focusNode: f.focusNode,
        focusOffset: f.focusOffset
      };
    }
    function lC(i) {
      return i.window === i ? i.document : i.nodeType === rs ? i : i.ownerDocument;
    }
    function Tb(i, a, f) {
      var b = lC(f);
      if (!(kg || qd == null || qd !== Dc(b))) {
        var S = aC(qd);
        if (!Hp || !Fr(Hp, S)) {
          Hp = S;
          var O = pv(wg, "onSelect");
          if (O.length > 0) {
            var J = new Lo("onSelect", "select", null, a, f);
            i.push({
              event: J,
              listeners: O
            }), J.target = qd;
          }
        }
      }
    }
    function uC(i, a, f, b, S, O, J) {
      var pe = f ? Zd(f) : window;
      switch (a) {
        case "focusin":
          (nu(pe) || pe.contentEditable === "true") && (qd = pe, wg = f, Hp = null);
          break;
        case "focusout":
          qd = null, wg = null, Hp = null;
          break;
        case "mousedown":
          kg = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          kg = !1, Tb(i, b, S);
          break;
        case "selectionchange":
          if (iC)
            break;
        case "keydown":
        case "keyup":
          Tb(i, b, S);
      }
    }
    function cv(i, a) {
      var f = {};
      return f[i.toLowerCase()] = a.toLowerCase(), f["Webkit" + i] = "webkit" + a, f["Moz" + i] = "moz" + a, f;
    }
    var Kd = {
      animationend: cv("Animation", "AnimationEnd"),
      animationiteration: cv("Animation", "AnimationIteration"),
      animationstart: cv("Animation", "AnimationStart"),
      transitionend: cv("Transition", "TransitionEnd")
    }, Ag = {}, Eb = {};
    xt && (Eb = document.createElement("div").style, "AnimationEvent" in window || (delete Kd.animationend.animation, delete Kd.animationiteration.animation, delete Kd.animationstart.animation), "TransitionEvent" in window || delete Kd.transitionend.transition);
    function dv(i) {
      if (Ag[i])
        return Ag[i];
      if (!Kd[i])
        return i;
      var a = Kd[i];
      for (var f in a)
        if (a.hasOwnProperty(f) && f in Eb)
          return Ag[i] = a[f];
      return i;
    }
    var Cb = dv("animationend"), Sb = dv("animationiteration"), Pb = dv("animationstart"), Rb = dv("transitionend"), _b = /* @__PURE__ */ new Map(), wb = ["abort", "auxClick", "cancel", "canPlay", "canPlayThrough", "click", "close", "contextMenu", "copy", "cut", "drag", "dragEnd", "dragEnter", "dragExit", "dragLeave", "dragOver", "dragStart", "drop", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "input", "invalid", "keyDown", "keyPress", "keyUp", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "mouseDown", "mouseMove", "mouseOut", "mouseOver", "mouseUp", "paste", "pause", "play", "playing", "pointerCancel", "pointerDown", "pointerMove", "pointerOut", "pointerOver", "pointerUp", "progress", "rateChange", "reset", "resize", "seeked", "seeking", "stalled", "submit", "suspend", "timeUpdate", "touchCancel", "touchEnd", "touchStart", "volumeChange", "scroll", "toggle", "touchMove", "waiting", "wheel"];
    function ou(i, a) {
      _b.set(i, a), St(a, [i]);
    }
    function cC() {
      for (var i = 0; i < wb.length; i++) {
        var a = wb[i], f = a.toLowerCase(), b = a[0].toUpperCase() + a.slice(1);
        ou(f, "on" + b);
      }
      ou(Cb, "onAnimationEnd"), ou(Sb, "onAnimationIteration"), ou(Pb, "onAnimationStart"), ou("dblclick", "onDoubleClick"), ou("focusin", "onFocus"), ou("focusout", "onBlur"), ou(Rb, "onTransitionEnd");
    }
    function dC(i, a, f, b, S, O, J) {
      var pe = _b.get(a);
      if (pe !== void 0) {
        var me = Lo, Se = a;
        switch (a) {
          case "keypress":
            if (sl(b) === 0)
              return;
          case "keydown":
          case "keyup":
            me = xg;
            break;
          case "focusin":
            Se = "focus", me = Fd;
            break;
          case "focusout":
            Se = "blur", me = Fd;
            break;
          case "beforeblur":
          case "afterblur":
            me = Fd;
            break;
          case "click":
            if (b.button === 2)
              return;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            me = Ea;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            me = ll;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            me = Gi;
            break;
          case Cb:
          case Sb:
          case Pb:
            me = Ld;
            break;
          case Rb:
            me = Tg;
            break;
          case "scroll":
            me = Mp;
            break;
          case "wheel":
            me = zd;
            break;
          case "copy":
          case "cut":
          case "paste":
            me = mg;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            me = Fp;
            break;
        }
        var _e = (O & Ba) !== 0;
        {
          var ze = !_e && // TODO: ideally, we'd eventually add all events from
          // nonDelegatedEvents list in DOMPluginEventSystem.
          // Then we can remove this special list.
          // This is a breaking change that can wait until React 18.
          a === "scroll", Le = mC(f, pe, b.type, _e, ze);
          if (Le.length > 0) {
            var qe = new me(pe, Se, null, b, S);
            i.push({
              event: qe,
              listeners: Le
            });
          }
        }
      }
    }
    cC(), Ge(), Yd(), sC(), sv();
    function fC(i, a, f, b, S, O, J) {
      dC(i, a, f, b, S, O);
      var pe = (O & rg) === 0;
      pe && (lr(i, a, f, b, S), Be(i, a, f, b, S), uC(i, a, f, b, S), Gd(i, a, f, b, S));
    }
    var Wp = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "resize", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"], $g = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(Wp));
    function kb(i, a, f) {
      var b = i.type || "unknown-event";
      i.currentTarget = f, js(b, a, void 0, i), i.currentTarget = null;
    }
    function pC(i, a, f) {
      var b;
      if (f)
        for (var S = a.length - 1; S >= 0; S--) {
          var O = a[S], J = O.instance, pe = O.currentTarget, me = O.listener;
          if (J !== b && i.isPropagationStopped())
            return;
          kb(i, me, pe), b = J;
        }
      else
        for (var Se = 0; Se < a.length; Se++) {
          var _e = a[Se], ze = _e.instance, Le = _e.currentTarget, qe = _e.listener;
          if (ze !== b && i.isPropagationStopped())
            return;
          kb(i, qe, Le), b = ze;
        }
    }
    function Ab(i, a) {
      for (var f = (a & Ba) !== 0, b = 0; b < i.length; b++) {
        var S = i[b], O = S.event, J = S.listeners;
        pC(O, J, f);
      }
      tp();
    }
    function hC(i, a, f, b, S) {
      var O = Kc(f), J = [];
      fC(J, i, b, f, O, a), Ab(J, a);
    }
    function Vn(i, a) {
      $g.has(i) || c('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', i);
      var f = !1, b = WS(a), S = gC(i, f);
      b.has(S) || ($b(a, i, Du, f), b.add(S));
    }
    function jg(i, a, f) {
      $g.has(i) && !a && c('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', i);
      var b = 0;
      a && (b |= Ba), $b(f, i, b, a);
    }
    var fv = "_reactListening" + Math.random().toString(36).slice(2);
    function Gp(i) {
      if (!i[fv]) {
        i[fv] = !0, et.forEach(function(f) {
          f !== "selectionchange" && ($g.has(f) || jg(f, !1, i), jg(f, !0, i));
        });
        var a = i.nodeType === rs ? i : i.ownerDocument;
        a !== null && (a[fv] || (a[fv] = !0, jg("selectionchange", !1, a)));
      }
    }
    function $b(i, a, f, b, S) {
      var O = Xl(i, a, f), J = void 0;
      zu && (a === "touchstart" || a === "touchmove" || a === "wheel") && (J = !0), i = i, b ? J !== void 0 ? Bs(i, a, O, J) : Jl(i, a, O) : J !== void 0 ? Od(i, a, O, J) : jp(i, a, O);
    }
    function jb(i, a) {
      return i === a || i.nodeType === Qn && i.parentNode === a;
    }
    function Mg(i, a, f, b, S) {
      var O = b;
      if (!(a & As) && !(a & Du)) {
        var J = S;
        if (b !== null) {
          var pe = b;
          e:
            for (; ; ) {
              if (pe === null)
                return;
              var me = pe.tag;
              if (me === w || me === R) {
                var Se = pe.stateNode.containerInfo;
                if (jb(Se, J))
                  break;
                if (me === R)
                  for (var _e = pe.return; _e !== null; ) {
                    var ze = _e.tag;
                    if (ze === w || ze === R) {
                      var Le = _e.stateNode.containerInfo;
                      if (jb(Le, J))
                        return;
                    }
                    _e = _e.return;
                  }
                for (; Se !== null; ) {
                  var qe = hc(Se);
                  if (qe === null)
                    return;
                  var Ke = qe.tag;
                  if (Ke === L || Ke === M) {
                    pe = O = qe;
                    continue e;
                  }
                  Se = Se.parentNode;
                }
              }
              pe = pe.return;
            }
        }
      }
      Qf(function() {
        return hC(i, a, f, O);
      });
    }
    function Yp(i, a, f) {
      return {
        instance: i,
        listener: a,
        currentTarget: f
      };
    }
    function mC(i, a, f, b, S, O) {
      for (var J = a !== null ? a + "Capture" : null, pe = b ? J : a, me = [], Se = i, _e = null; Se !== null; ) {
        var ze = Se, Le = ze.stateNode, qe = ze.tag;
        if (qe === L && Le !== null && (_e = Le, pe !== null)) {
          var Ke = Va(Se, pe);
          Ke != null && me.push(Yp(Se, Ke, _e));
        }
        if (S)
          break;
        Se = Se.return;
      }
      return me;
    }
    function pv(i, a) {
      for (var f = a + "Capture", b = [], S = i; S !== null; ) {
        var O = S, J = O.stateNode, pe = O.tag;
        if (pe === L && J !== null) {
          var me = J, Se = Va(S, f);
          Se != null && b.unshift(Yp(S, Se, me));
          var _e = Va(S, a);
          _e != null && b.push(Yp(S, _e, me));
        }
        S = S.return;
      }
      return b;
    }
    function Xd(i) {
      if (i === null)
        return null;
      do
        i = i.return;
      while (i && i.tag !== L);
      return i || null;
    }
    function vC(i, a) {
      for (var f = i, b = a, S = 0, O = f; O; O = Xd(O))
        S++;
      for (var J = 0, pe = b; pe; pe = Xd(pe))
        J++;
      for (; S - J > 0; )
        f = Xd(f), S--;
      for (; J - S > 0; )
        b = Xd(b), J--;
      for (var me = S; me--; ) {
        if (f === b || b !== null && f === b.alternate)
          return f;
        f = Xd(f), b = Xd(b);
      }
      return null;
    }
    function Mb(i, a, f, b, S) {
      for (var O = a._reactName, J = [], pe = f; pe !== null && pe !== b; ) {
        var me = pe, Se = me.alternate, _e = me.stateNode, ze = me.tag;
        if (Se !== null && Se === b)
          break;
        if (ze === L && _e !== null) {
          var Le = _e;
          if (S) {
            var qe = Va(pe, O);
            qe != null && J.unshift(Yp(pe, qe, Le));
          } else if (!S) {
            var Ke = Va(pe, O);
            Ke != null && J.push(Yp(pe, Ke, Le));
          }
        }
        pe = pe.return;
      }
      J.length !== 0 && i.push({
        event: a,
        listeners: J
      });
    }
    function yC(i, a, f, b, S) {
      var O = b && S ? vC(b, S) : null;
      b !== null && Mb(i, a, b, O, !1), S !== null && f !== null && Mb(i, f, S, O, !0);
    }
    function gC(i, a) {
      return i + "__" + (a ? "capture" : "bubble");
    }
    var Yi = !1, qp = "dangerouslySetInnerHTML", hv = "suppressContentEditableWarning", iu = "suppressHydrationWarning", Nb = "autoFocus", fc = "children", pc = "style", mv = "__html", Ng, vv, Kp, Ob, yv, Db, Ib;
    Ng = {
      // There are working polyfills for <dialog>. Let people use it.
      dialog: !0,
      // Electron ships a custom <webview> tag to display external web content in
      // an isolated frame and process.
      // This tag is not present in non Electron environments such as JSDom which
      // is often used for testing purposes.
      // @see https://electronjs.org/docs/api/webview-tag
      webview: !0
    }, vv = function(i, a) {
      qc(i, a), Gf(i, a), Pm(i, a, {
        registrationNameDependencies: bt,
        possibleRegistrationNames: rr
      });
    }, Db = xt && !document.documentMode, Kp = function(i, a, f) {
      if (!Yi) {
        var b = gv(f), S = gv(a);
        S !== b && (Yi = !0, c("Prop `%s` did not match. Server: %s Client: %s", i, JSON.stringify(S), JSON.stringify(b)));
      }
    }, Ob = function(i) {
      if (!Yi) {
        Yi = !0;
        var a = [];
        i.forEach(function(f) {
          a.push(f);
        }), c("Extra attributes from the server: %s", a);
      }
    }, yv = function(i, a) {
      a === !1 ? c("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", i, i, i) : c("Expected `%s` listener to be a function, instead got a value of `%s` type.", i, typeof a);
    }, Ib = function(i, a) {
      var f = i.namespaceURI === _s ? i.ownerDocument.createElement(i.tagName) : i.ownerDocument.createElementNS(i.namespaceURI, i.tagName);
      return f.innerHTML = a, f.innerHTML;
    };
    var xC = /\r\n?/g, bC = /\u0000|\uFFFD/g;
    function gv(i) {
      Gr(i);
      var a = typeof i == "string" ? i : "" + i;
      return a.replace(xC, `
`).replace(bC, "");
    }
    function xv(i, a, f, b) {
      var S = gv(a), O = gv(i);
      if (O !== S && (b && (Yi || (Yi = !0, c('Text content did not match. Server: "%s" Client: "%s"', O, S))), f && be))
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function Fb(i) {
      return i.nodeType === rs ? i : i.ownerDocument;
    }
    function TC() {
    }
    function bv(i) {
      i.onclick = TC;
    }
    function EC(i, a, f, b, S) {
      for (var O in b)
        if (b.hasOwnProperty(O)) {
          var J = b[O];
          if (O === pc)
            J && Object.freeze(J), mm(a, J);
          else if (O === qp) {
            var pe = J ? J[mv] : void 0;
            pe != null && om(a, pe);
          } else if (O === fc)
            if (typeof J == "string") {
              var me = i !== "textarea" || J !== "";
              me && Hc(a, J);
            } else
              typeof J == "number" && Hc(a, "" + J);
          else
            O === hv || O === iu || O === Nb || (bt.hasOwnProperty(O) ? J != null && (typeof J != "function" && yv(O, J), O === "onScroll" && Vn("scroll", a)) : J != null && Ao(a, O, J, S));
        }
    }
    function CC(i, a, f, b) {
      for (var S = 0; S < a.length; S += 2) {
        var O = a[S], J = a[S + 1];
        O === pc ? mm(i, J) : O === qp ? om(i, J) : O === fc ? Hc(i, J) : Ao(i, O, J, b);
      }
    }
    function SC(i, a, f, b) {
      var S, O = Fb(f), J, pe = b;
      if (pe === _s && (pe = Vc(i)), pe === _s) {
        if (S = ks(i, a), !S && i !== i.toLowerCase() && c("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", i), i === "script") {
          var me = O.createElement("div");
          me.innerHTML = "<script><\/script>";
          var Se = me.firstChild;
          J = me.removeChild(Se);
        } else if (typeof a.is == "string")
          J = O.createElement(i, {
            is: a.is
          });
        else if (J = O.createElement(i), i === "select") {
          var _e = J;
          a.multiple ? _e.multiple = !0 : a.size && (_e.size = a.size);
        }
      } else
        J = O.createElementNS(pe, i);
      return pe === _s && !S && Object.prototype.toString.call(J) === "[object HTMLUnknownElement]" && !je.call(Ng, i) && (Ng[i] = !0, c("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", i)), J;
    }
    function PC(i, a) {
      return Fb(a).createTextNode(i);
    }
    function RC(i, a, f, b) {
      var S = ks(a, f);
      vv(a, f);
      var O;
      switch (a) {
        case "dialog":
          Vn("cancel", i), Vn("close", i), O = f;
          break;
        case "iframe":
        case "object":
        case "embed":
          Vn("load", i), O = f;
          break;
        case "video":
        case "audio":
          for (var J = 0; J < Wp.length; J++)
            Vn(Wp[J], i);
          O = f;
          break;
        case "source":
          Vn("error", i), O = f;
          break;
        case "img":
        case "image":
        case "link":
          Vn("error", i), Vn("load", i), O = f;
          break;
        case "details":
          Vn("toggle", i), O = f;
          break;
        case "input":
          Au(i, f), O = ku(i, f), Vn("invalid", i);
          break;
        case "option":
          Bc(i, f), O = f;
          break;
        case "select":
          em(i, f), O = Of(i, f), Vn("invalid", i);
          break;
        case "textarea":
          tm(i, f), O = If(i, f), Vn("invalid", i);
          break;
        default:
          O = f;
      }
      switch (Gc(a, O), EC(a, i, b, O, S), a) {
        case "input":
          Ia(i), $u(i, f, !1);
          break;
        case "textarea":
          Ia(i), nm(i);
          break;
        case "option":
          Nf(i, f);
          break;
        case "select":
          Wy(i, f);
          break;
        default:
          typeof O.onClick == "function" && bv(i);
          break;
      }
    }
    function _C(i, a, f, b, S) {
      vv(a, b);
      var O = null, J, pe;
      switch (a) {
        case "input":
          J = ku(i, f), pe = ku(i, b), O = [];
          break;
        case "select":
          J = Of(i, f), pe = Of(i, b), O = [];
          break;
        case "textarea":
          J = If(i, f), pe = If(i, b), O = [];
          break;
        default:
          J = f, pe = b, typeof J.onClick != "function" && typeof pe.onClick == "function" && bv(i);
          break;
      }
      Gc(a, pe);
      var me, Se, _e = null;
      for (me in J)
        if (!(pe.hasOwnProperty(me) || !J.hasOwnProperty(me) || J[me] == null))
          if (me === pc) {
            var ze = J[me];
            for (Se in ze)
              ze.hasOwnProperty(Se) && (_e || (_e = {}), _e[Se] = "");
          } else
            me === qp || me === fc || me === hv || me === iu || me === Nb || (bt.hasOwnProperty(me) ? O || (O = []) : (O = O || []).push(me, null));
      for (me in pe) {
        var Le = pe[me], qe = J != null ? J[me] : void 0;
        if (!(!pe.hasOwnProperty(me) || Le === qe || Le == null && qe == null))
          if (me === pc)
            if (Le && Object.freeze(Le), qe) {
              for (Se in qe)
                qe.hasOwnProperty(Se) && (!Le || !Le.hasOwnProperty(Se)) && (_e || (_e = {}), _e[Se] = "");
              for (Se in Le)
                Le.hasOwnProperty(Se) && qe[Se] !== Le[Se] && (_e || (_e = {}), _e[Se] = Le[Se]);
            } else
              _e || (O || (O = []), O.push(me, _e)), _e = Le;
          else if (me === qp) {
            var Ke = Le ? Le[mv] : void 0, rt = qe ? qe[mv] : void 0;
            Ke != null && rt !== Ke && (O = O || []).push(me, Ke);
          } else
            me === fc ? (typeof Le == "string" || typeof Le == "number") && (O = O || []).push(me, "" + Le) : me === hv || me === iu || (bt.hasOwnProperty(me) ? (Le != null && (typeof Le != "function" && yv(me, Le), me === "onScroll" && Vn("scroll", i)), !O && qe !== Le && (O = [])) : (O = O || []).push(me, Le));
      }
      return _e && (Nu(_e, pe[pc]), (O = O || []).push(pc, _e)), O;
    }
    function wC(i, a, f, b, S) {
      f === "input" && S.type === "radio" && S.name != null && Mf(i, S);
      var O = ks(f, b), J = ks(f, S);
      switch (CC(i, a, O, J), f) {
        case "input":
          _l(i, S);
          break;
        case "textarea":
          rm(i, S);
          break;
        case "select":
          Gy(i, S);
          break;
      }
    }
    function kC(i) {
      {
        var a = i.toLowerCase();
        return Yc.hasOwnProperty(a) && Yc[a] || null;
      }
    }
    function AC(i, a, f, b, S, O, J) {
      var pe, me;
      switch (pe = ks(a, f), vv(a, f), a) {
        case "dialog":
          Vn("cancel", i), Vn("close", i);
          break;
        case "iframe":
        case "object":
        case "embed":
          Vn("load", i);
          break;
        case "video":
        case "audio":
          for (var Se = 0; Se < Wp.length; Se++)
            Vn(Wp[Se], i);
          break;
        case "source":
          Vn("error", i);
          break;
        case "img":
        case "image":
        case "link":
          Vn("error", i), Vn("load", i);
          break;
        case "details":
          Vn("toggle", i);
          break;
        case "input":
          Au(i, f), Vn("invalid", i);
          break;
        case "option":
          Bc(i, f);
          break;
        case "select":
          em(i, f), Vn("invalid", i);
          break;
        case "textarea":
          tm(i, f), Vn("invalid", i);
          break;
      }
      Gc(a, f);
      {
        me = /* @__PURE__ */ new Set();
        for (var _e = i.attributes, ze = 0; ze < _e.length; ze++) {
          var Le = _e[ze].name.toLowerCase();
          switch (Le) {
            case "value":
              break;
            case "checked":
              break;
            case "selected":
              break;
            default:
              me.add(_e[ze].name);
          }
        }
      }
      var qe = null;
      for (var Ke in f)
        if (f.hasOwnProperty(Ke)) {
          var rt = f[Ke];
          if (Ke === fc)
            typeof rt == "string" ? i.textContent !== rt && (f[iu] !== !0 && xv(i.textContent, rt, O, J), qe = [fc, rt]) : typeof rt == "number" && i.textContent !== "" + rt && (f[iu] !== !0 && xv(i.textContent, rt, O, J), qe = [fc, "" + rt]);
          else if (bt.hasOwnProperty(Ke))
            rt != null && (typeof rt != "function" && yv(Ke, rt), Ke === "onScroll" && Vn("scroll", i));
          else if (J && // Convince Flow we've calculated it (it's DEV-only in this method.)
          typeof pe == "boolean") {
            var xr = void 0, zr = pe && Fe ? null : uo(Ke);
            if (f[iu] !== !0) {
              if (!(Ke === hv || Ke === iu || // Controlled attributes are not validated
              // TODO: Only ignore them on controlled tags.
              Ke === "value" || Ke === "checked" || Ke === "selected")) {
                if (Ke === qp) {
                  var Or = i.innerHTML, dn = rt ? rt[mv] : void 0;
                  if (dn != null) {
                    var ln = Ib(i, dn);
                    ln !== Or && Kp(Ke, Or, ln);
                  }
                } else if (Ke === pc) {
                  if (me.delete(Ke), Db) {
                    var He = eg(rt);
                    xr = i.getAttribute("style"), He !== xr && Kp(Ke, xr, He);
                  }
                } else if (pe && !Fe)
                  me.delete(Ke.toLowerCase()), xr = ei(i, Ke, rt), rt !== xr && Kp(Ke, xr, rt);
                else if (!Nr(Ke, zr, pe) && !fn(Ke, rt, zr, pe)) {
                  var ct = !1;
                  if (zr !== null)
                    me.delete(zr.attributeName), xr = gi(i, Ke, rt, zr);
                  else {
                    var We = b;
                    if (We === _s && (We = Vc(a)), We === _s)
                      me.delete(Ke.toLowerCase());
                    else {
                      var sr = kC(Ke);
                      sr !== null && sr !== Ke && (ct = !0, me.delete(sr)), me.delete(Ke);
                    }
                    xr = ei(i, Ke, rt);
                  }
                  var br = Fe;
                  !br && rt !== xr && !ct && Kp(Ke, xr, rt);
                }
              }
            }
          }
        }
      switch (J && // $FlowFixMe - Should be inferred as not undefined.
      me.size > 0 && f[iu] !== !0 && Ob(me), a) {
        case "input":
          Ia(i), $u(i, f, !0);
          break;
        case "textarea":
          Ia(i), nm(i);
          break;
        case "select":
        case "option":
          break;
        default:
          typeof f.onClick == "function" && bv(i);
          break;
      }
      return qe;
    }
    function $C(i, a, f) {
      var b = i.nodeValue !== a;
      return b;
    }
    function Og(i, a) {
      {
        if (Yi)
          return;
        Yi = !0, c("Did not expect server HTML to contain a <%s> in <%s>.", a.nodeName.toLowerCase(), i.nodeName.toLowerCase());
      }
    }
    function Dg(i, a) {
      {
        if (Yi)
          return;
        Yi = !0, c('Did not expect server HTML to contain the text node "%s" in <%s>.', a.nodeValue, i.nodeName.toLowerCase());
      }
    }
    function Ig(i, a, f) {
      {
        if (Yi)
          return;
        Yi = !0, c("Expected server HTML to contain a matching <%s> in <%s>.", a, i.nodeName.toLowerCase());
      }
    }
    function Fg(i, a) {
      {
        if (a === "" || Yi)
          return;
        Yi = !0, c('Expected server HTML to contain a matching text node for "%s" in <%s>.', a, i.nodeName.toLowerCase());
      }
    }
    function jC(i, a, f) {
      switch (a) {
        case "input":
          Xh(i, f);
          return;
        case "textarea":
          Ff(i, f);
          return;
        case "select":
          Yy(i, f);
          return;
      }
    }
    var Xp = function() {
    }, Qp = function() {
    };
    {
      var MC = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"], Lb = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
      ], NC = Lb.concat(["button"]), OC = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"], Bb = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
      };
      Qp = function(i, a) {
        var f = sn({}, i || Bb), b = {
          tag: a
        };
        return Lb.indexOf(a) !== -1 && (f.aTagInScope = null, f.buttonTagInScope = null, f.nobrTagInScope = null), NC.indexOf(a) !== -1 && (f.pTagInButtonScope = null), MC.indexOf(a) !== -1 && a !== "address" && a !== "div" && a !== "p" && (f.listItemTagAutoclosing = null, f.dlItemTagAutoclosing = null), f.current = b, a === "form" && (f.formTag = b), a === "a" && (f.aTagInScope = b), a === "button" && (f.buttonTagInScope = b), a === "nobr" && (f.nobrTagInScope = b), a === "p" && (f.pTagInButtonScope = b), a === "li" && (f.listItemTagAutoclosing = b), (a === "dd" || a === "dt") && (f.dlItemTagAutoclosing = b), f;
      };
      var DC = function(i, a) {
        switch (a) {
          case "select":
            return i === "option" || i === "optgroup" || i === "#text";
          case "optgroup":
            return i === "option" || i === "#text";
          case "option":
            return i === "#text";
          case "tr":
            return i === "th" || i === "td" || i === "style" || i === "script" || i === "template";
          case "tbody":
          case "thead":
          case "tfoot":
            return i === "tr" || i === "style" || i === "script" || i === "template";
          case "colgroup":
            return i === "col" || i === "template";
          case "table":
            return i === "caption" || i === "colgroup" || i === "tbody" || i === "tfoot" || i === "thead" || i === "style" || i === "script" || i === "template";
          case "head":
            return i === "base" || i === "basefont" || i === "bgsound" || i === "link" || i === "meta" || i === "title" || i === "noscript" || i === "noframes" || i === "style" || i === "script" || i === "template";
          case "html":
            return i === "head" || i === "body" || i === "frameset";
          case "frameset":
            return i === "frame";
          case "#document":
            return i === "html";
        }
        switch (i) {
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return a !== "h1" && a !== "h2" && a !== "h3" && a !== "h4" && a !== "h5" && a !== "h6";
          case "rp":
          case "rt":
            return OC.indexOf(a) === -1;
          case "body":
          case "caption":
          case "col":
          case "colgroup":
          case "frameset":
          case "frame":
          case "head":
          case "html":
          case "tbody":
          case "td":
          case "tfoot":
          case "th":
          case "thead":
          case "tr":
            return a == null;
        }
        return !0;
      }, IC = function(i, a) {
        switch (i) {
          case "address":
          case "article":
          case "aside":
          case "blockquote":
          case "center":
          case "details":
          case "dialog":
          case "dir":
          case "div":
          case "dl":
          case "fieldset":
          case "figcaption":
          case "figure":
          case "footer":
          case "header":
          case "hgroup":
          case "main":
          case "menu":
          case "nav":
          case "ol":
          case "p":
          case "section":
          case "summary":
          case "ul":
          case "pre":
          case "listing":
          case "table":
          case "hr":
          case "xmp":
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return a.pTagInButtonScope;
          case "form":
            return a.formTag || a.pTagInButtonScope;
          case "li":
            return a.listItemTagAutoclosing;
          case "dd":
          case "dt":
            return a.dlItemTagAutoclosing;
          case "button":
            return a.buttonTagInScope;
          case "a":
            return a.aTagInScope;
          case "nobr":
            return a.nobrTagInScope;
        }
        return null;
      }, zb = {};
      Xp = function(i, a, f) {
        f = f || Bb;
        var b = f.current, S = b && b.tag;
        a != null && (i != null && c("validateDOMNesting: when childText is passed, childTag should be null"), i = "#text");
        var O = DC(i, S) ? null : b, J = O ? null : IC(i, f), pe = O || J;
        if (pe) {
          var me = pe.tag, Se = !!O + "|" + i + "|" + me;
          if (!zb[Se]) {
            zb[Se] = !0;
            var _e = i, ze = "";
            if (i === "#text" ? /\S/.test(a) ? _e = "Text nodes" : (_e = "Whitespace text nodes", ze = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : _e = "<" + i + ">", O) {
              var Le = "";
              me === "table" && i === "tr" && (Le += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), c("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", _e, me, ze, Le);
            } else
              c("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", _e, me);
          }
        }
      };
    }
    var Tv = "suppressHydrationWarning", Ev = "$", Cv = "/$", Jp = "$?", Zp = "$!", FC = "style", Lg = null, Bg = null;
    function LC(i) {
      var a, f, b = i.nodeType;
      switch (b) {
        case rs:
        case Fa: {
          a = b === rs ? "#document" : "#fragment";
          var S = i.documentElement;
          f = S ? S.namespaceURI : Bf(null, "");
          break;
        }
        default: {
          var O = b === Qn ? i.parentNode : i, J = O.namespaceURI || null;
          a = O.tagName, f = Bf(J, a);
          break;
        }
      }
      {
        var pe = a.toLowerCase(), me = Qp(null, pe);
        return {
          namespace: f,
          ancestorInfo: me
        };
      }
    }
    function BC(i, a, f) {
      {
        var b = i, S = Bf(b.namespace, a), O = Qp(b.ancestorInfo, a);
        return {
          namespace: S,
          ancestorInfo: O
        };
      }
    }
    function Lw(i) {
      return i;
    }
    function zC(i) {
      Lg = Pi(), Bg = tC();
      var a = null;
      return vo(!1), a;
    }
    function VC(i) {
      rC(Bg), vo(Lg), Lg = null, Bg = null;
    }
    function UC(i, a, f, b, S) {
      var O;
      {
        var J = b;
        if (Xp(i, null, J.ancestorInfo), typeof a.children == "string" || typeof a.children == "number") {
          var pe = "" + a.children, me = Qp(J.ancestorInfo, i);
          Xp(null, pe, me);
        }
        O = J.namespace;
      }
      var Se = SC(i, a, f, O);
      return rh(S, Se), qg(Se, a), Se;
    }
    function HC(i, a) {
      i.appendChild(a);
    }
    function WC(i, a, f, b, S) {
      switch (RC(i, a, f, b), a) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          return !!f.autoFocus;
        case "img":
          return !0;
        default:
          return !1;
      }
    }
    function GC(i, a, f, b, S, O) {
      {
        var J = O;
        if (typeof b.children != typeof f.children && (typeof b.children == "string" || typeof b.children == "number")) {
          var pe = "" + b.children, me = Qp(J.ancestorInfo, a);
          Xp(null, pe, me);
        }
      }
      return _C(i, a, f, b);
    }
    function zg(i, a) {
      return i === "textarea" || i === "noscript" || typeof a.children == "string" || typeof a.children == "number" || typeof a.dangerouslySetInnerHTML == "object" && a.dangerouslySetInnerHTML !== null && a.dangerouslySetInnerHTML.__html != null;
    }
    function YC(i, a, f, b) {
      {
        var S = f;
        Xp(null, i, S.ancestorInfo);
      }
      var O = PC(i, a);
      return rh(b, O), O;
    }
    function qC() {
      var i = window.event;
      return i === void 0 ? Is : Vo(i.type);
    }
    var Vg = typeof setTimeout == "function" ? setTimeout : void 0, KC = typeof clearTimeout == "function" ? clearTimeout : void 0, Ug = -1, Vb = typeof Promise == "function" ? Promise : void 0, XC = typeof queueMicrotask == "function" ? queueMicrotask : typeof Vb < "u" ? function(i) {
      return Vb.resolve(null).then(i).catch(QC);
    } : Vg;
    function QC(i) {
      setTimeout(function() {
        throw i;
      });
    }
    function JC(i, a, f, b) {
      switch (a) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          f.autoFocus && i.focus();
          return;
        case "img": {
          f.src && (i.src = f.src);
          return;
        }
      }
    }
    function ZC(i, a, f, b, S, O) {
      wC(i, a, f, b, S), qg(i, S);
    }
    function Ub(i) {
      Hc(i, "");
    }
    function eS(i, a, f) {
      i.nodeValue = f;
    }
    function tS(i, a) {
      i.appendChild(a);
    }
    function rS(i, a) {
      var f;
      i.nodeType === Qn ? (f = i.parentNode, f.insertBefore(a, i)) : (f = i, f.appendChild(a));
      var b = i._reactRootContainer;
      b == null && f.onclick === null && bv(f);
    }
    function nS(i, a, f) {
      i.insertBefore(a, f);
    }
    function oS(i, a, f) {
      i.nodeType === Qn ? i.parentNode.insertBefore(a, f) : i.insertBefore(a, f);
    }
    function iS(i, a) {
      i.removeChild(a);
    }
    function sS(i, a) {
      i.nodeType === Qn ? i.parentNode.removeChild(a) : i.removeChild(a);
    }
    function Hg(i, a) {
      var f = a, b = 0;
      do {
        var S = f.nextSibling;
        if (i.removeChild(f), S && S.nodeType === Qn) {
          var O = S.data;
          if (O === Cv)
            if (b === 0) {
              i.removeChild(S), an(a);
              return;
            } else
              b--;
          else
            (O === Ev || O === Jp || O === Zp) && b++;
        }
        f = S;
      } while (f);
      an(a);
    }
    function aS(i, a) {
      i.nodeType === Qn ? Hg(i.parentNode, a) : i.nodeType === ti && Hg(i, a), an(i);
    }
    function lS(i) {
      i = i;
      var a = i.style;
      typeof a.setProperty == "function" ? a.setProperty("display", "none", "important") : a.display = "none";
    }
    function uS(i) {
      i.nodeValue = "";
    }
    function cS(i, a) {
      i = i;
      var f = a[FC], b = f != null && f.hasOwnProperty("display") ? f.display : null;
      i.style.display = Wc("display", b);
    }
    function dS(i, a) {
      i.nodeValue = a;
    }
    function fS(i) {
      i.nodeType === ti ? i.textContent = "" : i.nodeType === rs && i.documentElement && i.removeChild(i.documentElement);
    }
    function pS(i, a, f) {
      return i.nodeType !== ti || a.toLowerCase() !== i.nodeName.toLowerCase() ? null : i;
    }
    function hS(i, a) {
      return a === "" || i.nodeType !== ws ? null : i;
    }
    function mS(i) {
      return i.nodeType !== Qn ? null : i;
    }
    function Hb(i) {
      return i.data === Jp;
    }
    function Wg(i) {
      return i.data === Zp;
    }
    function vS(i) {
      var a = i.nextSibling && i.nextSibling.dataset, f, b, S;
      return a && (f = a.dgst, b = a.msg, S = a.stck), {
        message: b,
        digest: f,
        stack: S
      };
    }
    function yS(i, a) {
      i._reactRetry = a;
    }
    function Sv(i) {
      for (; i != null; i = i.nextSibling) {
        var a = i.nodeType;
        if (a === ti || a === ws)
          break;
        if (a === Qn) {
          var f = i.data;
          if (f === Ev || f === Zp || f === Jp)
            break;
          if (f === Cv)
            return null;
        }
      }
      return i;
    }
    function eh(i) {
      return Sv(i.nextSibling);
    }
    function gS(i) {
      return Sv(i.firstChild);
    }
    function xS(i) {
      return Sv(i.firstChild);
    }
    function bS(i) {
      return Sv(i.nextSibling);
    }
    function TS(i, a, f, b, S, O, J) {
      rh(O, i), qg(i, f);
      var pe;
      {
        var me = S;
        pe = me.namespace;
      }
      var Se = (O.mode & nn) !== Vr;
      return AC(i, a, f, pe, b, Se, J);
    }
    function ES(i, a, f, b) {
      return rh(f, i), f.mode & nn, $C(i, a);
    }
    function CS(i, a) {
      rh(a, i);
    }
    function SS(i) {
      for (var a = i.nextSibling, f = 0; a; ) {
        if (a.nodeType === Qn) {
          var b = a.data;
          if (b === Cv) {
            if (f === 0)
              return eh(a);
            f--;
          } else
            (b === Ev || b === Zp || b === Jp) && f++;
        }
        a = a.nextSibling;
      }
      return null;
    }
    function Wb(i) {
      for (var a = i.previousSibling, f = 0; a; ) {
        if (a.nodeType === Qn) {
          var b = a.data;
          if (b === Ev || b === Zp || b === Jp) {
            if (f === 0)
              return a;
            f--;
          } else
            b === Cv && f++;
        }
        a = a.previousSibling;
      }
      return null;
    }
    function PS(i) {
      an(i);
    }
    function RS(i) {
      an(i);
    }
    function _S(i) {
      return i !== "head" && i !== "body";
    }
    function wS(i, a, f, b) {
      var S = !0;
      xv(a.nodeValue, f, b, S);
    }
    function kS(i, a, f, b, S, O) {
      if (a[Tv] !== !0) {
        var J = !0;
        xv(b.nodeValue, S, O, J);
      }
    }
    function AS(i, a) {
      a.nodeType === ti ? Og(i, a) : a.nodeType === Qn || Dg(i, a);
    }
    function $S(i, a) {
      {
        var f = i.parentNode;
        f !== null && (a.nodeType === ti ? Og(f, a) : a.nodeType === Qn || Dg(f, a));
      }
    }
    function jS(i, a, f, b, S) {
      (S || a[Tv] !== !0) && (b.nodeType === ti ? Og(f, b) : b.nodeType === Qn || Dg(f, b));
    }
    function NS(i, a, f) {
      Ig(i, a);
    }
    function OS(i, a) {
      Fg(i, a);
    }
    function DS(i, a, f) {
      {
        var b = i.parentNode;
        b !== null && Ig(b, a);
      }
    }
    function IS(i, a) {
      {
        var f = i.parentNode;
        f !== null && Fg(f, a);
      }
    }
    function FS(i, a, f, b, S, O) {
      (O || a[Tv] !== !0) && Ig(f, b);
    }
    function LS(i, a, f, b, S) {
      (S || a[Tv] !== !0) && Fg(f, b);
    }
    function BS(i) {
      c("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", i.nodeName.toLowerCase());
    }
    function zS(i) {
      Gp(i);
    }
    var Qd = Math.random().toString(36).slice(2), Jd = "__reactFiber$" + Qd, Gg = "__reactProps$" + Qd, th = "__reactContainer$" + Qd, Yg = "__reactEvents$" + Qd, VS = "__reactListeners$" + Qd, US = "__reactHandles$" + Qd;
    function HS(i) {
      delete i[Jd], delete i[Gg], delete i[Yg], delete i[VS], delete i[US];
    }
    function rh(i, a) {
      a[Jd] = i;
    }
    function Pv(i, a) {
      a[th] = i;
    }
    function Gb(i) {
      i[th] = null;
    }
    function nh(i) {
      return !!i[th];
    }
    function hc(i) {
      var a = i[Jd];
      if (a)
        return a;
      for (var f = i.parentNode; f; ) {
        if (a = f[th] || f[Jd], a) {
          var b = a.alternate;
          if (a.child !== null || b !== null && b.child !== null)
            for (var S = Wb(i); S !== null; ) {
              var O = S[Jd];
              if (O)
                return O;
              S = Wb(S);
            }
          return a;
        }
        i = f, f = i.parentNode;
      }
      return null;
    }
    function su(i) {
      var a = i[Jd] || i[th];
      return a && (a.tag === L || a.tag === M || a.tag === K || a.tag === w) ? a : null;
    }
    function Zd(i) {
      if (i.tag === L || i.tag === M)
        return i.stateNode;
      throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function Rv(i) {
      return i[Gg] || null;
    }
    function qg(i, a) {
      i[Gg] = a;
    }
    function WS(i) {
      var a = i[Yg];
      return a === void 0 && (a = i[Yg] = /* @__PURE__ */ new Set()), a;
    }
    var Yb = {}, qb = n.ReactDebugCurrentFrame;
    function _v(i) {
      if (i) {
        var a = i._owner, f = Cu(i.type, i._source, a ? a.type : null);
        qb.setExtraStackFrame(f);
      } else
        qb.setExtraStackFrame(null);
    }
    function Vs(i, a, f, b, S) {
      {
        var O = Function.call.bind(je);
        for (var J in i)
          if (O(i, J)) {
            var pe = void 0;
            try {
              if (typeof i[J] != "function") {
                var me = Error((b || "React class") + ": " + f + " type `" + J + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[J] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw me.name = "Invariant Violation", me;
              }
              pe = i[J](a, J, b, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Se) {
              pe = Se;
            }
            pe && !(pe instanceof Error) && (_v(S), c("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", b || "React class", f, J, typeof pe), _v(null)), pe instanceof Error && !(pe.message in Yb) && (Yb[pe.message] = !0, _v(S), c("Failed %s type: %s", f, pe.message), _v(null));
          }
      }
    }
    var Kg = [], wv;
    wv = [];
    var fl = -1;
    function au(i) {
      return {
        current: i
      };
    }
    function ci(i, a) {
      if (fl < 0) {
        c("Unexpected pop.");
        return;
      }
      a !== wv[fl] && c("Unexpected Fiber popped."), i.current = Kg[fl], Kg[fl] = null, wv[fl] = null, fl--;
    }
    function di(i, a, f) {
      fl++, Kg[fl] = i.current, wv[fl] = f, i.current = a;
    }
    var Xg;
    Xg = {};
    var ls = {};
    Object.freeze(ls);
    var pl = au(ls), Pa = au(!1), Qg = ls;
    function ef(i, a, f) {
      return f && Ra(a) ? Qg : pl.current;
    }
    function Kb(i, a, f) {
      {
        var b = i.stateNode;
        b.__reactInternalMemoizedUnmaskedChildContext = a, b.__reactInternalMemoizedMaskedChildContext = f;
      }
    }
    function tf(i, a) {
      {
        var f = i.type, b = f.contextTypes;
        if (!b)
          return ls;
        var S = i.stateNode;
        if (S && S.__reactInternalMemoizedUnmaskedChildContext === a)
          return S.__reactInternalMemoizedMaskedChildContext;
        var O = {};
        for (var J in b)
          O[J] = a[J];
        {
          var pe = en(i) || "Unknown";
          Vs(b, O, "context", pe);
        }
        return S && Kb(i, a, O), O;
      }
    }
    function kv() {
      return Pa.current;
    }
    function Ra(i) {
      {
        var a = i.childContextTypes;
        return a != null;
      }
    }
    function Av(i) {
      ci(Pa, i), ci(pl, i);
    }
    function Jg(i) {
      ci(Pa, i), ci(pl, i);
    }
    function Xb(i, a, f) {
      {
        if (pl.current !== ls)
          throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        di(pl, a, i), di(Pa, f, i);
      }
    }
    function Qb(i, a, f) {
      {
        var b = i.stateNode, S = a.childContextTypes;
        if (typeof b.getChildContext != "function") {
          {
            var O = en(i) || "Unknown";
            Xg[O] || (Xg[O] = !0, c("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", O, O));
          }
          return f;
        }
        var J = b.getChildContext();
        for (var pe in J)
          if (!(pe in S))
            throw new Error((en(i) || "Unknown") + '.getChildContext(): key "' + pe + '" is not defined in childContextTypes.');
        {
          var me = en(i) || "Unknown";
          Vs(S, J, "child context", me);
        }
        return sn({}, f, J);
      }
    }
    function $v(i) {
      {
        var a = i.stateNode, f = a && a.__reactInternalMemoizedMergedChildContext || ls;
        return Qg = pl.current, di(pl, f, i), di(Pa, Pa.current, i), !0;
      }
    }
    function Jb(i, a, f) {
      {
        var b = i.stateNode;
        if (!b)
          throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (f) {
          var S = Qb(i, a, Qg);
          b.__reactInternalMemoizedMergedChildContext = S, ci(Pa, i), ci(pl, i), di(pl, S, i), di(Pa, f, i);
        } else
          ci(Pa, i), di(Pa, f, i);
      }
    }
    function GS(i) {
      {
        if (!sp(i) || i.tag !== C)
          throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var a = i;
        do {
          switch (a.tag) {
            case w:
              return a.stateNode.context;
            case C: {
              var f = a.type;
              if (Ra(f))
                return a.stateNode.__reactInternalMemoizedMergedChildContext;
              break;
            }
          }
          a = a.return;
        } while (a !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    var lu = 0, jv = 1, hl = null, Zg = !1, ex = !1;
    function Zb(i) {
      hl === null ? hl = [i] : hl.push(i);
    }
    function YS(i) {
      Zg = !0, Zb(i);
    }
    function eT() {
      Zg && uu();
    }
    function uu() {
      if (!ex && hl !== null) {
        ex = !0;
        var i = 0, a = Ui();
        try {
          var f = !0, b = hl;
          for (io(No); i < b.length; i++) {
            var S = b[i];
            do
              S = S(f);
            while (S !== null);
          }
          hl = null, Zg = !1;
        } catch (O) {
          throw hl !== null && (hl = hl.slice(i + 1)), rd(od, uu), O;
        } finally {
          io(a), ex = !1;
        }
      }
      return null;
    }
    var rf = [], nf = 0, Mv = null, Nv = 0, gs = [], xs = 0, mc = null, ml = 1, vl = "";
    function qS(i) {
      return yc(), (i.flags & np) !== Lr;
    }
    function KS(i) {
      return yc(), Nv;
    }
    function XS() {
      var i = vl, a = ml, f = a & ~QS(a);
      return f.toString(32) + i;
    }
    function vc(i, a) {
      yc(), rf[nf++] = Nv, rf[nf++] = Mv, Mv = i, Nv = a;
    }
    function tT(i, a, f) {
      yc(), gs[xs++] = ml, gs[xs++] = vl, gs[xs++] = mc, mc = i;
      var b = ml, S = vl, O = Ov(b) - 1, J = b & ~(1 << O), pe = f + 1, me = Ov(a) + O;
      if (me > 30) {
        var Se = O - O % 5, _e = (1 << Se) - 1, ze = (J & _e).toString(32), Le = J >> Se, qe = O - Se, Ke = Ov(a) + qe, rt = pe << qe, xr = rt | Le, zr = ze + S;
        ml = 1 << Ke | xr, vl = zr;
      } else {
        var Or = pe << O, dn = Or | J, ln = S;
        ml = 1 << me | dn, vl = ln;
      }
    }
    function tx(i) {
      yc();
      var a = i.return;
      if (a !== null) {
        var f = 1, b = 0;
        vc(i, f), tT(i, f, b);
      }
    }
    function Ov(i) {
      return 32 - cd(i);
    }
    function QS(i) {
      return 1 << Ov(i) - 1;
    }
    function rx(i) {
      for (; i === Mv; )
        Mv = rf[--nf], rf[nf] = null, Nv = rf[--nf], rf[nf] = null;
      for (; i === mc; )
        mc = gs[--xs], gs[xs] = null, vl = gs[--xs], gs[xs] = null, ml = gs[--xs], gs[xs] = null;
    }
    function JS() {
      return yc(), mc !== null ? {
        id: ml,
        overflow: vl
      } : null;
    }
    function ZS(i, a) {
      yc(), gs[xs++] = ml, gs[xs++] = vl, gs[xs++] = mc, ml = a.id, vl = a.overflow, mc = i;
    }
    function yc() {
      Ho() || c("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    var Uo = null, bs = null, Us = !1, gc = !1, cu = null;
    function eP() {
      Us && c("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function rT() {
      gc = !0;
    }
    function tP() {
      return gc;
    }
    function rP(i) {
      var a = i.stateNode.containerInfo;
      return bs = xS(a), Uo = i, Us = !0, cu = null, gc = !1, !0;
    }
    function nP(i, a, f) {
      return bs = bS(a), Uo = i, Us = !0, cu = null, gc = !1, f !== null && ZS(i, f), !0;
    }
    function nT(i, a) {
      switch (i.tag) {
        case w: {
          AS(i.stateNode.containerInfo, a);
          break;
        }
        case L: {
          var f = (i.mode & nn) !== Vr;
          jS(
            i.type,
            i.memoizedProps,
            i.stateNode,
            a,
            // TODO: Delete this argument when we remove the legacy root API.
            f
          );
          break;
        }
        case K: {
          var b = i.memoizedState;
          b.dehydrated !== null && $S(b.dehydrated, a);
          break;
        }
      }
    }
    function oT(i, a) {
      nT(i, a);
      var f = sw();
      f.stateNode = a, f.return = i;
      var b = i.deletions;
      b === null ? (i.deletions = [f], i.flags |= bn) : b.push(f);
    }
    function nx(i, a) {
      {
        if (gc)
          return;
        switch (i.tag) {
          case w: {
            var f = i.stateNode.containerInfo;
            switch (a.tag) {
              case L:
                var b = a.type;
                a.pendingProps, NS(f, b);
                break;
              case M:
                var S = a.pendingProps;
                OS(f, S);
                break;
            }
            break;
          }
          case L: {
            var O = i.type, J = i.memoizedProps, pe = i.stateNode;
            switch (a.tag) {
              case L: {
                var me = a.type, Se = a.pendingProps, _e = (i.mode & nn) !== Vr;
                FS(
                  O,
                  J,
                  pe,
                  me,
                  Se,
                  // TODO: Delete this argument when we remove the legacy root API.
                  _e
                );
                break;
              }
              case M: {
                var ze = a.pendingProps, Le = (i.mode & nn) !== Vr;
                LS(
                  O,
                  J,
                  pe,
                  ze,
                  // TODO: Delete this argument when we remove the legacy root API.
                  Le
                );
                break;
              }
            }
            break;
          }
          case K: {
            var qe = i.memoizedState, Ke = qe.dehydrated;
            if (Ke !== null)
              switch (a.tag) {
                case L:
                  var rt = a.type;
                  a.pendingProps, DS(Ke, rt);
                  break;
                case M:
                  var xr = a.pendingProps;
                  IS(Ke, xr);
                  break;
              }
            break;
          }
          default:
            return;
        }
      }
    }
    function iT(i, a) {
      a.flags = a.flags & ~Fi | $n, nx(i, a);
    }
    function sT(i, a) {
      switch (i.tag) {
        case L: {
          var f = i.type;
          i.pendingProps;
          var b = pS(a, f);
          return b !== null ? (i.stateNode = b, Uo = i, bs = gS(b), !0) : !1;
        }
        case M: {
          var S = i.pendingProps, O = hS(a, S);
          return O !== null ? (i.stateNode = O, Uo = i, bs = null, !0) : !1;
        }
        case K: {
          var J = mS(a);
          if (J !== null) {
            var pe = {
              dehydrated: J,
              treeContext: JS(),
              retryLane: li
            };
            i.memoizedState = pe;
            var me = aw(J);
            return me.return = i, i.child = me, Uo = i, bs = null, !0;
          }
          return !1;
        }
        default:
          return !1;
      }
    }
    function ox(i) {
      return (i.mode & nn) !== Vr && (i.flags & Kr) === Lr;
    }
    function ix(i) {
      throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function sx(i) {
      if (Us) {
        var a = bs;
        if (!a) {
          ox(i) && (nx(Uo, i), ix()), iT(Uo, i), Us = !1, Uo = i;
          return;
        }
        var f = a;
        if (!sT(i, a)) {
          ox(i) && (nx(Uo, i), ix()), a = eh(f);
          var b = Uo;
          if (!a || !sT(i, a)) {
            iT(Uo, i), Us = !1, Uo = i;
            return;
          }
          oT(b, f);
        }
      }
    }
    function oP(i, a, f) {
      var b = i.stateNode, S = !gc, O = TS(b, i.type, i.memoizedProps, a, f, i, S);
      return i.updateQueue = O, O !== null;
    }
    function iP(i) {
      var a = i.stateNode, f = i.memoizedProps, b = ES(a, f, i);
      if (b) {
        var S = Uo;
        if (S !== null)
          switch (S.tag) {
            case w: {
              var O = S.stateNode.containerInfo, J = (S.mode & nn) !== Vr;
              wS(
                O,
                a,
                f,
                // TODO: Delete this argument when we remove the legacy root API.
                J
              );
              break;
            }
            case L: {
              var pe = S.type, me = S.memoizedProps, Se = S.stateNode, _e = (S.mode & nn) !== Vr;
              kS(
                pe,
                me,
                Se,
                a,
                f,
                // TODO: Delete this argument when we remove the legacy root API.
                _e
              );
              break;
            }
          }
      }
      return b;
    }
    function sP(i) {
      var a = i.memoizedState, f = a !== null ? a.dehydrated : null;
      if (!f)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      CS(f, i);
    }
    function aP(i) {
      var a = i.memoizedState, f = a !== null ? a.dehydrated : null;
      if (!f)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      return SS(f);
    }
    function aT(i) {
      for (var a = i.return; a !== null && a.tag !== L && a.tag !== w && a.tag !== K; )
        a = a.return;
      Uo = a;
    }
    function Dv(i) {
      if (i !== Uo)
        return !1;
      if (!Us)
        return aT(i), Us = !0, !1;
      if (i.tag !== w && (i.tag !== L || _S(i.type) && !zg(i.type, i.memoizedProps))) {
        var a = bs;
        if (a)
          if (ox(i))
            lT(i), ix();
          else
            for (; a; )
              oT(i, a), a = eh(a);
      }
      return aT(i), i.tag === K ? bs = aP(i) : bs = Uo ? eh(i.stateNode) : null, !0;
    }
    function lP() {
      return Us && bs !== null;
    }
    function lT(i) {
      for (var a = bs; a; )
        nT(i, a), a = eh(a);
    }
    function of() {
      Uo = null, bs = null, Us = !1, gc = !1;
    }
    function uT() {
      cu !== null && (nE(cu), cu = null);
    }
    function Ho() {
      return Us;
    }
    function ax(i) {
      cu === null ? cu = [i] : cu.push(i);
    }
    var uP = n.ReactCurrentBatchConfig, cP = null;
    function dP() {
      return uP.transition;
    }
    var Hs = {
      recordUnsafeLifecycleWarnings: function(i, a) {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function(i, a) {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    };
    {
      var fP = function(i) {
        for (var a = null, f = i; f !== null; )
          f.mode & Bn && (a = f), f = f.return;
        return a;
      }, xc = function(i) {
        var a = [];
        return i.forEach(function(f) {
          a.push(f);
        }), a.sort().join(", ");
      }, oh = [], ih = [], sh = [], ah = [], lh = [], uh = [], bc = /* @__PURE__ */ new Set();
      Hs.recordUnsafeLifecycleWarnings = function(i, a) {
        bc.has(i.type) || (typeof a.componentWillMount == "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        a.componentWillMount.__suppressDeprecationWarning !== !0 && oh.push(i), i.mode & Bn && typeof a.UNSAFE_componentWillMount == "function" && ih.push(i), typeof a.componentWillReceiveProps == "function" && a.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && sh.push(i), i.mode & Bn && typeof a.UNSAFE_componentWillReceiveProps == "function" && ah.push(i), typeof a.componentWillUpdate == "function" && a.componentWillUpdate.__suppressDeprecationWarning !== !0 && lh.push(i), i.mode & Bn && typeof a.UNSAFE_componentWillUpdate == "function" && uh.push(i));
      }, Hs.flushPendingUnsafeLifecycleWarnings = function() {
        var i = /* @__PURE__ */ new Set();
        oh.length > 0 && (oh.forEach(function(Le) {
          i.add(en(Le) || "Component"), bc.add(Le.type);
        }), oh = []);
        var a = /* @__PURE__ */ new Set();
        ih.length > 0 && (ih.forEach(function(Le) {
          a.add(en(Le) || "Component"), bc.add(Le.type);
        }), ih = []);
        var f = /* @__PURE__ */ new Set();
        sh.length > 0 && (sh.forEach(function(Le) {
          f.add(en(Le) || "Component"), bc.add(Le.type);
        }), sh = []);
        var b = /* @__PURE__ */ new Set();
        ah.length > 0 && (ah.forEach(function(Le) {
          b.add(en(Le) || "Component"), bc.add(Le.type);
        }), ah = []);
        var S = /* @__PURE__ */ new Set();
        lh.length > 0 && (lh.forEach(function(Le) {
          S.add(en(Le) || "Component"), bc.add(Le.type);
        }), lh = []);
        var O = /* @__PURE__ */ new Set();
        if (uh.length > 0 && (uh.forEach(function(Le) {
          O.add(en(Le) || "Component"), bc.add(Le.type);
        }), uh = []), a.size > 0) {
          var J = xc(a);
          c(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, J);
        }
        if (b.size > 0) {
          var pe = xc(b);
          c(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, pe);
        }
        if (O.size > 0) {
          var me = xc(O);
          c(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, me);
        }
        if (i.size > 0) {
          var Se = xc(i);
          l(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, Se);
        }
        if (f.size > 0) {
          var _e = xc(f);
          l(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, _e);
        }
        if (S.size > 0) {
          var ze = xc(S);
          l(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, ze);
        }
      };
      var Iv = /* @__PURE__ */ new Map(), cT = /* @__PURE__ */ new Set();
      Hs.recordLegacyContextWarning = function(i, a) {
        var f = fP(i);
        if (f === null) {
          c("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        if (!cT.has(i.type)) {
          var b = Iv.get(f);
          (i.type.contextTypes != null || i.type.childContextTypes != null || a !== null && typeof a.getChildContext == "function") && (b === void 0 && (b = [], Iv.set(f, b)), b.push(i));
        }
      }, Hs.flushLegacyContextWarning = function() {
        Iv.forEach(function(i, a) {
          if (i.length !== 0) {
            var f = i[0], b = /* @__PURE__ */ new Set();
            i.forEach(function(O) {
              b.add(en(O) || "Component"), cT.add(O.type);
            });
            var S = xc(b);
            try {
              Sn(f), c(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, S);
            } finally {
              ro();
            }
          }
        });
      }, Hs.discardPendingWarnings = function() {
        oh = [], ih = [], sh = [], ah = [], lh = [], uh = [], Iv = /* @__PURE__ */ new Map();
      };
    }
    function Ws(i, a) {
      if (i && i.defaultProps) {
        var f = sn({}, a), b = i.defaultProps;
        for (var S in b)
          f[S] === void 0 && (f[S] = b[S]);
        return f;
      }
      return a;
    }
    var lx = au(null), ux;
    ux = {};
    var Fv = null, sf = null, cx = null, Lv = !1;
    function Bv() {
      Fv = null, sf = null, cx = null, Lv = !1;
    }
    function dT() {
      Lv = !0;
    }
    function fT() {
      Lv = !1;
    }
    function pT(i, a, f) {
      di(lx, a._currentValue, i), a._currentValue = f, a._currentRenderer !== void 0 && a._currentRenderer !== null && a._currentRenderer !== ux && c("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), a._currentRenderer = ux;
    }
    function dx(i, a) {
      var f = lx.current;
      ci(lx, a), i._currentValue = f;
    }
    function fx(i, a, f) {
      for (var b = i; b !== null; ) {
        var S = b.alternate;
        if (tl(b.childLanes, a) ? S !== null && !tl(S.childLanes, a) && (S.childLanes = rn(S.childLanes, a)) : (b.childLanes = rn(b.childLanes, a), S !== null && (S.childLanes = rn(S.childLanes, a))), b === f)
          break;
        b = b.return;
      }
      b !== f && c("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function pP(i, a, f) {
      hP(i, a, f);
    }
    function hP(i, a, f) {
      var b = i.child;
      for (b !== null && (b.return = i); b !== null; ) {
        var S = void 0, O = b.dependencies;
        if (O !== null) {
          S = b.child;
          for (var J = O.firstContext; J !== null; ) {
            if (J.context === a) {
              if (b.tag === C) {
                var pe = oo(f), me = yl(kn, pe);
                me.tag = Vv;
                var Se = b.updateQueue;
                if (Se !== null) {
                  var _e = Se.shared, ze = _e.pending;
                  ze === null ? me.next = me : (me.next = ze.next, ze.next = me), _e.pending = me;
                }
              }
              b.lanes = rn(b.lanes, f);
              var Le = b.alternate;
              Le !== null && (Le.lanes = rn(Le.lanes, f)), fx(b.return, f, i), O.lanes = rn(O.lanes, f);
              break;
            }
            J = J.next;
          }
        } else if (b.tag === V)
          S = b.type === i.type ? null : b.child;
        else if (b.tag === Pe) {
          var qe = b.return;
          if (qe === null)
            throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
          qe.lanes = rn(qe.lanes, f);
          var Ke = qe.alternate;
          Ke !== null && (Ke.lanes = rn(Ke.lanes, f)), fx(qe, f, i), S = b.sibling;
        } else
          S = b.child;
        if (S !== null)
          S.return = b;
        else
          for (S = b; S !== null; ) {
            if (S === i) {
              S = null;
              break;
            }
            var rt = S.sibling;
            if (rt !== null) {
              rt.return = S.return, S = rt;
              break;
            }
            S = S.return;
          }
        b = S;
      }
    }
    function af(i, a) {
      Fv = i, sf = null, cx = null;
      var f = i.dependencies;
      if (f !== null) {
        var b = f.firstContext;
        b !== null && (ui(f.lanes, a) && Ch(), f.firstContext = null);
      }
    }
    function go(i) {
      Lv && c("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      var a = i._currentValue;
      if (cx !== i) {
        var f = {
          context: i,
          memoizedValue: a,
          next: null
        };
        if (sf === null) {
          if (Fv === null)
            throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          sf = f, Fv.dependencies = {
            lanes: mt,
            firstContext: f
          };
        } else
          sf = sf.next = f;
      }
      return a;
    }
    var Tc = null;
    function px(i) {
      Tc === null ? Tc = [i] : Tc.push(i);
    }
    function mP() {
      if (Tc !== null) {
        for (var i = 0; i < Tc.length; i++) {
          var a = Tc[i], f = a.interleaved;
          if (f !== null) {
            a.interleaved = null;
            var b = f.next, S = a.pending;
            if (S !== null) {
              var O = S.next;
              S.next = b, f.next = O;
            }
            a.pending = f;
          }
        }
        Tc = null;
      }
    }
    function hT(i, a, f, b) {
      var S = a.interleaved;
      return S === null ? (f.next = f, px(a)) : (f.next = S.next, S.next = f), a.interleaved = f, zv(i, b);
    }
    function vP(i, a, f, b) {
      var S = a.interleaved;
      S === null ? (f.next = f, px(a)) : (f.next = S.next, S.next = f), a.interleaved = f;
    }
    function yP(i, a, f, b) {
      var S = a.interleaved;
      return S === null ? (f.next = f, px(a)) : (f.next = S.next, S.next = f), a.interleaved = f, zv(i, b);
    }
    function qi(i, a) {
      return zv(i, a);
    }
    var gP = zv;
    function zv(i, a) {
      i.lanes = rn(i.lanes, a);
      var f = i.alternate;
      f !== null && (f.lanes = rn(f.lanes, a)), f === null && (i.flags & ($n | Fi)) !== Lr && mE(i);
      for (var b = i, S = i.return; S !== null; )
        S.childLanes = rn(S.childLanes, a), f = S.alternate, f !== null ? f.childLanes = rn(f.childLanes, a) : (S.flags & ($n | Fi)) !== Lr && mE(i), b = S, S = S.return;
      if (b.tag === w) {
        var O = b.stateNode;
        return O;
      } else
        return null;
    }
    var mT = 0, vT = 1, Vv = 2, hx = 3, Uv = !1, mx, Hv;
    mx = !1, Hv = null;
    function vx(i) {
      var a = {
        baseState: i.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null,
          interleaved: null,
          lanes: mt
        },
        effects: null
      };
      i.updateQueue = a;
    }
    function yT(i, a) {
      var f = a.updateQueue, b = i.updateQueue;
      if (f === b) {
        var S = {
          baseState: b.baseState,
          firstBaseUpdate: b.firstBaseUpdate,
          lastBaseUpdate: b.lastBaseUpdate,
          shared: b.shared,
          effects: b.effects
        };
        a.updateQueue = S;
      }
    }
    function yl(i, a) {
      var f = {
        eventTime: i,
        lane: a,
        tag: mT,
        payload: null,
        callback: null,
        next: null
      };
      return f;
    }
    function du(i, a, f) {
      var b = i.updateQueue;
      if (b === null)
        return null;
      var S = b.shared;
      if (Hv === S && !mx && (c("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), mx = !0), g_()) {
        var O = S.pending;
        return O === null ? a.next = a : (a.next = O.next, O.next = a), S.pending = a, gP(i, f);
      } else
        return yP(i, S, a, f);
    }
    function Wv(i, a, f) {
      var b = a.updateQueue;
      if (b !== null) {
        var S = b.shared;
        if (xp(f)) {
          var O = S.lanes;
          O = Tp(O, i.pendingLanes);
          var J = rn(O, f);
          S.lanes = J, Wl(i, J);
        }
      }
    }
    function yx(i, a) {
      var f = i.updateQueue, b = i.alternate;
      if (b !== null) {
        var S = b.updateQueue;
        if (f === S) {
          var O = null, J = null, pe = f.firstBaseUpdate;
          if (pe !== null) {
            var me = pe;
            do {
              var Se = {
                eventTime: me.eventTime,
                lane: me.lane,
                tag: me.tag,
                payload: me.payload,
                callback: me.callback,
                next: null
              };
              J === null ? O = J = Se : (J.next = Se, J = Se), me = me.next;
            } while (me !== null);
            J === null ? O = J = a : (J.next = a, J = a);
          } else
            O = J = a;
          f = {
            baseState: S.baseState,
            firstBaseUpdate: O,
            lastBaseUpdate: J,
            shared: S.shared,
            effects: S.effects
          }, i.updateQueue = f;
          return;
        }
      }
      var _e = f.lastBaseUpdate;
      _e === null ? f.firstBaseUpdate = a : _e.next = a, f.lastBaseUpdate = a;
    }
    function xP(i, a, f, b, S, O) {
      switch (f.tag) {
        case vT: {
          var J = f.payload;
          if (typeof J == "function") {
            dT();
            var pe = J.call(O, b, S);
            {
              if (i.mode & Bn) {
                no(!0);
                try {
                  J.call(O, b, S);
                } finally {
                  no(!1);
                }
              }
              fT();
            }
            return pe;
          }
          return J;
        }
        case hx:
          i.flags = i.flags & ~po | Kr;
        case mT: {
          var me = f.payload, Se;
          if (typeof me == "function") {
            dT(), Se = me.call(O, b, S);
            {
              if (i.mode & Bn) {
                no(!0);
                try {
                  me.call(O, b, S);
                } finally {
                  no(!1);
                }
              }
              fT();
            }
          } else
            Se = me;
          return Se == null ? b : sn({}, b, Se);
        }
        case Vv:
          return Uv = !0, b;
      }
      return b;
    }
    function Gv(i, a, f, b) {
      var S = i.updateQueue;
      Uv = !1, Hv = S.shared;
      var O = S.firstBaseUpdate, J = S.lastBaseUpdate, pe = S.shared.pending;
      if (pe !== null) {
        S.shared.pending = null;
        var me = pe, Se = me.next;
        me.next = null, J === null ? O = Se : J.next = Se, J = me;
        var _e = i.alternate;
        if (_e !== null) {
          var ze = _e.updateQueue, Le = ze.lastBaseUpdate;
          Le !== J && (Le === null ? ze.firstBaseUpdate = Se : Le.next = Se, ze.lastBaseUpdate = me);
        }
      }
      if (O !== null) {
        var qe = S.baseState, Ke = mt, rt = null, xr = null, zr = null, Or = O;
        do {
          var dn = Or.lane, ln = Or.eventTime;
          if (tl(b, dn)) {
            if (zr !== null) {
              var ct = {
                eventTime: ln,
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: un,
                tag: Or.tag,
                payload: Or.payload,
                callback: Or.callback,
                next: null
              };
              zr = zr.next = ct;
            }
            qe = xP(i, S, Or, qe, a, f);
            var We = Or.callback;
            if (We !== null && // If the update was already committed, we should not queue its
            // callback again.
            Or.lane !== un) {
              i.flags |= fs;
              var sr = S.effects;
              sr === null ? S.effects = [Or] : sr.push(Or);
            }
          } else {
            var He = {
              eventTime: ln,
              lane: dn,
              tag: Or.tag,
              payload: Or.payload,
              callback: Or.callback,
              next: null
            };
            zr === null ? (xr = zr = He, rt = qe) : zr = zr.next = He, Ke = rn(Ke, dn);
          }
          if (Or = Or.next, Or === null) {
            if (pe = S.shared.pending, pe === null)
              break;
            var br = pe, vr = br.next;
            br.next = null, Or = vr, S.lastBaseUpdate = br, S.shared.pending = null;
          }
        } while (!0);
        zr === null && (rt = qe), S.baseState = rt, S.firstBaseUpdate = xr, S.lastBaseUpdate = zr;
        var qr = S.shared.interleaved;
        if (qr !== null) {
          var Zr = qr;
          do
            Ke = rn(Ke, Zr.lane), Zr = Zr.next;
          while (Zr !== qr);
        } else
          O === null && (S.shared.lanes = mt);
        Oh(Ke), i.lanes = Ke, i.memoizedState = qe;
      }
      Hv = null;
    }
    function bP(i, a) {
      if (typeof i != "function")
        throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + i));
      i.call(a);
    }
    function gT() {
      Uv = !1;
    }
    function Yv() {
      return Uv;
    }
    function xT(i, a, f) {
      var b = a.effects;
      if (a.effects = null, b !== null)
        for (var S = 0; S < b.length; S++) {
          var O = b[S], J = O.callback;
          J !== null && (O.callback = null, bP(J, f));
        }
    }
    var gx = {}, bT = new e.Component().refs, xx, bx, Tx, Ex, Cx, TT, qv, Sx, Px, Rx;
    {
      xx = /* @__PURE__ */ new Set(), bx = /* @__PURE__ */ new Set(), Tx = /* @__PURE__ */ new Set(), Ex = /* @__PURE__ */ new Set(), Sx = /* @__PURE__ */ new Set(), Cx = /* @__PURE__ */ new Set(), Px = /* @__PURE__ */ new Set(), Rx = /* @__PURE__ */ new Set();
      var ET = /* @__PURE__ */ new Set();
      qv = function(i, a) {
        if (!(i === null || typeof i == "function")) {
          var f = a + "_" + i;
          ET.has(f) || (ET.add(f), c("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", a, i));
        }
      }, TT = function(i, a) {
        if (a === void 0) {
          var f = _n(i) || "Component";
          Cx.has(f) || (Cx.add(f), c("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", f));
        }
      }, Object.defineProperty(gx, "_processChildContext", {
        enumerable: !1,
        value: function() {
          throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
      }), Object.freeze(gx);
    }
    function _x(i, a, f, b) {
      var S = i.memoizedState, O = f(b, S);
      {
        if (i.mode & Bn) {
          no(!0);
          try {
            O = f(b, S);
          } finally {
            no(!1);
          }
        }
        TT(a, O);
      }
      var J = O == null ? S : sn({}, S, O);
      if (i.memoizedState = J, i.lanes === mt) {
        var pe = i.updateQueue;
        pe.baseState = J;
      }
    }
    var wx = {
      isMounted: Ei,
      enqueueSetState: function(i, a, f) {
        var b = Di(i), S = wi(), O = xu(b), J = yl(S, O);
        J.payload = a, f != null && (qv(f, "setState"), J.callback = f);
        var pe = du(b, J, O);
        pe !== null && (ko(pe, b, O, S), Wv(pe, b, O)), va(b, O);
      },
      enqueueReplaceState: function(i, a, f) {
        var b = Di(i), S = wi(), O = xu(b), J = yl(S, O);
        J.tag = vT, J.payload = a, f != null && (qv(f, "replaceState"), J.callback = f);
        var pe = du(b, J, O);
        pe !== null && (ko(pe, b, O, S), Wv(pe, b, O)), va(b, O);
      },
      enqueueForceUpdate: function(i, a) {
        var f = Di(i), b = wi(), S = xu(f), O = yl(b, S);
        O.tag = Vv, a != null && (qv(a, "forceUpdate"), O.callback = a);
        var J = du(f, O, S);
        J !== null && (ko(J, f, S, b), Wv(J, f, S)), mp(f, S);
      }
    };
    function CT(i, a, f, b, S, O, J) {
      var pe = i.stateNode;
      if (typeof pe.shouldComponentUpdate == "function") {
        var me = pe.shouldComponentUpdate(b, O, J);
        {
          if (i.mode & Bn) {
            no(!0);
            try {
              me = pe.shouldComponentUpdate(b, O, J);
            } finally {
              no(!1);
            }
          }
          me === void 0 && c("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", _n(a) || "Component");
        }
        return me;
      }
      return a.prototype && a.prototype.isPureReactComponent ? !Fr(f, b) || !Fr(S, O) : !0;
    }
    function TP(i, a, f) {
      var b = i.stateNode;
      {
        var S = _n(a) || "Component", O = b.render;
        O || (a.prototype && typeof a.prototype.render == "function" ? c("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", S) : c("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", S)), b.getInitialState && !b.getInitialState.isReactClassApproved && !b.state && c("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", S), b.getDefaultProps && !b.getDefaultProps.isReactClassApproved && c("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", S), b.propTypes && c("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", S), b.contextType && c("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", S), b.contextTypes && c("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", S), a.contextType && a.contextTypes && !Px.has(a) && (Px.add(a), c("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", S)), typeof b.componentShouldUpdate == "function" && c("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", S), a.prototype && a.prototype.isPureReactComponent && typeof b.shouldComponentUpdate < "u" && c("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", _n(a) || "A pure component"), typeof b.componentDidUnmount == "function" && c("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", S), typeof b.componentDidReceiveProps == "function" && c("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", S), typeof b.componentWillRecieveProps == "function" && c("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", S), typeof b.UNSAFE_componentWillRecieveProps == "function" && c("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", S);
        var J = b.props !== f;
        b.props !== void 0 && J && c("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", S, S), b.defaultProps && c("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", S, S), typeof b.getSnapshotBeforeUpdate == "function" && typeof b.componentDidUpdate != "function" && !Tx.has(a) && (Tx.add(a), c("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", _n(a))), typeof b.getDerivedStateFromProps == "function" && c("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", S), typeof b.getDerivedStateFromError == "function" && c("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", S), typeof a.getSnapshotBeforeUpdate == "function" && c("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", S);
        var pe = b.state;
        pe && (typeof pe != "object" || co(pe)) && c("%s.state: must be set to an object or null", S), typeof b.getChildContext == "function" && typeof a.childContextTypes != "object" && c("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", S);
      }
    }
    function ST(i, a) {
      a.updater = wx, i.stateNode = a, Ol(a, i), a._reactInternalInstance = gx;
    }
    function PT(i, a, f) {
      var b = !1, S = ls, O = ls, J = a.contextType;
      if ("contextType" in a) {
        var pe = (
          // Allow null for conditional declaration
          J === null || J !== void 0 && J.$$typeof === ur && J._context === void 0
        );
        if (!pe && !Rx.has(a)) {
          Rx.add(a);
          var me = "";
          J === void 0 ? me = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof J != "object" ? me = " However, it is set to a " + typeof J + "." : J.$$typeof === wt ? me = " Did you accidentally pass the Context.Provider instead?" : J._context !== void 0 ? me = " Did you accidentally pass the Context.Consumer instead?" : me = " However, it is set to an object with keys {" + Object.keys(J).join(", ") + "}.", c("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", _n(a) || "Component", me);
        }
      }
      if (typeof J == "object" && J !== null)
        O = go(J);
      else {
        S = ef(i, a, !0);
        var Se = a.contextTypes;
        b = Se != null, O = b ? tf(i, S) : ls;
      }
      var _e = new a(f, O);
      if (i.mode & Bn) {
        no(!0);
        try {
          _e = new a(f, O);
        } finally {
          no(!1);
        }
      }
      var ze = i.memoizedState = _e.state !== null && _e.state !== void 0 ? _e.state : null;
      ST(i, _e);
      {
        if (typeof a.getDerivedStateFromProps == "function" && ze === null) {
          var Le = _n(a) || "Component";
          bx.has(Le) || (bx.add(Le), c("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", Le, _e.state === null ? "null" : "undefined", Le));
        }
        if (typeof a.getDerivedStateFromProps == "function" || typeof _e.getSnapshotBeforeUpdate == "function") {
          var qe = null, Ke = null, rt = null;
          if (typeof _e.componentWillMount == "function" && _e.componentWillMount.__suppressDeprecationWarning !== !0 ? qe = "componentWillMount" : typeof _e.UNSAFE_componentWillMount == "function" && (qe = "UNSAFE_componentWillMount"), typeof _e.componentWillReceiveProps == "function" && _e.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? Ke = "componentWillReceiveProps" : typeof _e.UNSAFE_componentWillReceiveProps == "function" && (Ke = "UNSAFE_componentWillReceiveProps"), typeof _e.componentWillUpdate == "function" && _e.componentWillUpdate.__suppressDeprecationWarning !== !0 ? rt = "componentWillUpdate" : typeof _e.UNSAFE_componentWillUpdate == "function" && (rt = "UNSAFE_componentWillUpdate"), qe !== null || Ke !== null || rt !== null) {
            var xr = _n(a) || "Component", zr = typeof a.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            Ex.has(xr) || (Ex.add(xr), c(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, xr, zr, qe !== null ? `
  ` + qe : "", Ke !== null ? `
  ` + Ke : "", rt !== null ? `
  ` + rt : ""));
          }
        }
      }
      return b && Kb(i, S, O), _e;
    }
    function EP(i, a) {
      var f = a.state;
      typeof a.componentWillMount == "function" && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == "function" && a.UNSAFE_componentWillMount(), f !== a.state && (c("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", en(i) || "Component"), wx.enqueueReplaceState(a, a.state, null));
    }
    function RT(i, a, f, b) {
      var S = a.state;
      if (typeof a.componentWillReceiveProps == "function" && a.componentWillReceiveProps(f, b), typeof a.UNSAFE_componentWillReceiveProps == "function" && a.UNSAFE_componentWillReceiveProps(f, b), a.state !== S) {
        {
          var O = en(i) || "Component";
          xx.has(O) || (xx.add(O), c("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", O));
        }
        wx.enqueueReplaceState(a, a.state, null);
      }
    }
    function kx(i, a, f, b) {
      TP(i, a, f);
      var S = i.stateNode;
      S.props = f, S.state = i.memoizedState, S.refs = bT, vx(i);
      var O = a.contextType;
      if (typeof O == "object" && O !== null)
        S.context = go(O);
      else {
        var J = ef(i, a, !0);
        S.context = tf(i, J);
      }
      {
        if (S.state === f) {
          var pe = _n(a) || "Component";
          Sx.has(pe) || (Sx.add(pe), c("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", pe));
        }
        i.mode & Bn && Hs.recordLegacyContextWarning(i, S), Hs.recordUnsafeLifecycleWarnings(i, S);
      }
      S.state = i.memoizedState;
      var me = a.getDerivedStateFromProps;
      if (typeof me == "function" && (_x(i, a, me, f), S.state = i.memoizedState), typeof a.getDerivedStateFromProps != "function" && typeof S.getSnapshotBeforeUpdate != "function" && (typeof S.UNSAFE_componentWillMount == "function" || typeof S.componentWillMount == "function") && (EP(i, S), Gv(i, f, S, b), S.state = i.memoizedState), typeof S.componentDidMount == "function") {
        var Se = tn;
        Se |= ni, (i.mode & zi) !== Vr && (Se |= oi), i.flags |= Se;
      }
    }
    function CP(i, a, f, b) {
      var S = i.stateNode, O = i.memoizedProps;
      S.props = O;
      var J = S.context, pe = a.contextType, me = ls;
      if (typeof pe == "object" && pe !== null)
        me = go(pe);
      else {
        var Se = ef(i, a, !0);
        me = tf(i, Se);
      }
      var _e = a.getDerivedStateFromProps, ze = typeof _e == "function" || typeof S.getSnapshotBeforeUpdate == "function";
      !ze && (typeof S.UNSAFE_componentWillReceiveProps == "function" || typeof S.componentWillReceiveProps == "function") && (O !== f || J !== me) && RT(i, S, f, me), gT();
      var Le = i.memoizedState, qe = S.state = Le;
      if (Gv(i, f, S, b), qe = i.memoizedState, O === f && Le === qe && !kv() && !Yv()) {
        if (typeof S.componentDidMount == "function") {
          var Ke = tn;
          Ke |= ni, (i.mode & zi) !== Vr && (Ke |= oi), i.flags |= Ke;
        }
        return !1;
      }
      typeof _e == "function" && (_x(i, a, _e, f), qe = i.memoizedState);
      var rt = Yv() || CT(i, a, O, f, Le, qe, me);
      if (rt) {
        if (!ze && (typeof S.UNSAFE_componentWillMount == "function" || typeof S.componentWillMount == "function") && (typeof S.componentWillMount == "function" && S.componentWillMount(), typeof S.UNSAFE_componentWillMount == "function" && S.UNSAFE_componentWillMount()), typeof S.componentDidMount == "function") {
          var xr = tn;
          xr |= ni, (i.mode & zi) !== Vr && (xr |= oi), i.flags |= xr;
        }
      } else {
        if (typeof S.componentDidMount == "function") {
          var zr = tn;
          zr |= ni, (i.mode & zi) !== Vr && (zr |= oi), i.flags |= zr;
        }
        i.memoizedProps = f, i.memoizedState = qe;
      }
      return S.props = f, S.state = qe, S.context = me, rt;
    }
    function SP(i, a, f, b, S) {
      var O = a.stateNode;
      yT(i, a);
      var J = a.memoizedProps, pe = a.type === a.elementType ? J : Ws(a.type, J);
      O.props = pe;
      var me = a.pendingProps, Se = O.context, _e = f.contextType, ze = ls;
      if (typeof _e == "object" && _e !== null)
        ze = go(_e);
      else {
        var Le = ef(a, f, !0);
        ze = tf(a, Le);
      }
      var qe = f.getDerivedStateFromProps, Ke = typeof qe == "function" || typeof O.getSnapshotBeforeUpdate == "function";
      !Ke && (typeof O.UNSAFE_componentWillReceiveProps == "function" || typeof O.componentWillReceiveProps == "function") && (J !== me || Se !== ze) && RT(a, O, b, ze), gT();
      var rt = a.memoizedState, xr = O.state = rt;
      if (Gv(a, b, O, S), xr = a.memoizedState, J === me && rt === xr && !kv() && !Yv() && !fe)
        return typeof O.componentDidUpdate == "function" && (J !== i.memoizedProps || rt !== i.memoizedState) && (a.flags |= tn), typeof O.getSnapshotBeforeUpdate == "function" && (J !== i.memoizedProps || rt !== i.memoizedState) && (a.flags |= Ii), !1;
      typeof qe == "function" && (_x(a, f, qe, b), xr = a.memoizedState);
      var zr = Yv() || CT(a, f, pe, b, rt, xr, ze) || // TODO: In some cases, we'll end up checking if context has changed twice,
      // both before and after `shouldComponentUpdate` has been called. Not ideal,
      // but I'm loath to refactor this function. This only happens for memoized
      // components so it's not that common.
      fe;
      return zr ? (!Ke && (typeof O.UNSAFE_componentWillUpdate == "function" || typeof O.componentWillUpdate == "function") && (typeof O.componentWillUpdate == "function" && O.componentWillUpdate(b, xr, ze), typeof O.UNSAFE_componentWillUpdate == "function" && O.UNSAFE_componentWillUpdate(b, xr, ze)), typeof O.componentDidUpdate == "function" && (a.flags |= tn), typeof O.getSnapshotBeforeUpdate == "function" && (a.flags |= Ii)) : (typeof O.componentDidUpdate == "function" && (J !== i.memoizedProps || rt !== i.memoizedState) && (a.flags |= tn), typeof O.getSnapshotBeforeUpdate == "function" && (J !== i.memoizedProps || rt !== i.memoizedState) && (a.flags |= Ii), a.memoizedProps = b, a.memoizedState = xr), O.props = b, O.state = xr, O.context = ze, zr;
    }
    var Ax, $x, jx, Mx, Nx, _T = function(i, a) {
    };
    Ax = !1, $x = !1, jx = {}, Mx = {}, Nx = {}, _T = function(i, a) {
      if (!(i === null || typeof i != "object") && !(!i._store || i._store.validated || i.key != null)) {
        if (typeof i._store != "object")
          throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        i._store.validated = !0;
        var f = en(a) || "Component";
        Mx[f] || (Mx[f] = !0, c('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
      }
    };
    function ch(i, a, f) {
      var b = f.ref;
      if (b !== null && typeof b != "function" && typeof b != "object") {
        if ((i.mode & Bn || De) && // We warn in ReactElement.js if owner and self are equal for string refs
        // because these cannot be automatically converted to an arrow function
        // using a codemod. Therefore, we don't have to warn about string refs again.
        !(f._owner && f._self && f._owner.stateNode !== f._self)) {
          var S = en(i) || "Component";
          jx[S] || (c('A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', b), jx[S] = !0);
        }
        if (f._owner) {
          var O = f._owner, J;
          if (O) {
            var pe = O;
            if (pe.tag !== C)
              throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
            J = pe.stateNode;
          }
          if (!J)
            throw new Error("Missing owner for string ref " + b + ". This error is likely caused by a bug in React. Please file an issue.");
          var me = J;
          Br(b, "ref");
          var Se = "" + b;
          if (a !== null && a.ref !== null && typeof a.ref == "function" && a.ref._stringRef === Se)
            return a.ref;
          var _e = function(ze) {
            var Le = me.refs;
            Le === bT && (Le = me.refs = {}), ze === null ? delete Le[Se] : Le[Se] = ze;
          };
          return _e._stringRef = Se, _e;
        } else {
          if (typeof b != "string")
            throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
          if (!f._owner)
            throw new Error("Element ref was specified as a string (" + b + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
        }
      }
      return b;
    }
    function Kv(i, a) {
      var f = Object.prototype.toString.call(a);
      throw new Error("Objects are not valid as a React child (found: " + (f === "[object Object]" ? "object with keys {" + Object.keys(a).join(", ") + "}" : f) + "). If you meant to render a collection of children, use an array instead.");
    }
    function Xv(i) {
      {
        var a = en(i) || "Component";
        if (Nx[a])
          return;
        Nx[a] = !0, c("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
      }
    }
    function wT(i) {
      var a = i._payload, f = i._init;
      return f(a);
    }
    function kT(i) {
      function a(He, ct) {
        if (i) {
          var We = He.deletions;
          We === null ? (He.deletions = [ct], He.flags |= bn) : We.push(ct);
        }
      }
      function f(He, ct) {
        if (!i)
          return null;
        for (var We = ct; We !== null; )
          a(He, We), We = We.sibling;
        return null;
      }
      function b(He, ct) {
        for (var We = /* @__PURE__ */ new Map(), sr = ct; sr !== null; )
          sr.key !== null ? We.set(sr.key, sr) : We.set(sr.index, sr), sr = sr.sibling;
        return We;
      }
      function S(He, ct) {
        var We = kc(He, ct);
        return We.index = 0, We.sibling = null, We;
      }
      function O(He, ct, We) {
        if (He.index = We, !i)
          return He.flags |= np, ct;
        var sr = He.alternate;
        if (sr !== null) {
          var br = sr.index;
          return br < ct ? (He.flags |= $n, ct) : br;
        } else
          return He.flags |= $n, ct;
      }
      function J(He) {
        return i && He.alternate === null && (He.flags |= $n), He;
      }
      function pe(He, ct, We, sr) {
        if (ct === null || ct.tag !== M) {
          var br = lb(We, He.mode, sr);
          return br.return = He, br;
        } else {
          var vr = S(ct, We);
          return vr.return = He, vr;
        }
      }
      function me(He, ct, We, sr) {
        var br = We.type;
        if (br === Bo)
          return _e(He, ct, We.props.children, sr, We.key);
        if (ct !== null && (ct.elementType === br || // Keep this check inline so it only runs on the false path:
        xE(ct, We) || // Lazy types should reconcile their resolved type.
        // We need to do this after the Hot Reloading check above,
        // because hot reloading has different semantics than prod because
        // it doesn't resuspend. So we can't let the call below suspend.
        typeof br == "object" && br !== null && br.$$typeof === Dr && wT(br) === ct.type)) {
          var vr = S(ct, We.props);
          return vr.ref = ch(He, ct, We), vr.return = He, vr._debugSource = We._source, vr._debugOwner = We._owner, vr;
        }
        var qr = ab(We, He.mode, sr);
        return qr.ref = ch(He, ct, We), qr.return = He, qr;
      }
      function Se(He, ct, We, sr) {
        if (ct === null || ct.tag !== R || ct.stateNode.containerInfo !== We.containerInfo || ct.stateNode.implementation !== We.implementation) {
          var br = ub(We, He.mode, sr);
          return br.return = He, br;
        } else {
          var vr = S(ct, We.children || []);
          return vr.return = He, vr;
        }
      }
      function _e(He, ct, We, sr, br) {
        if (ct === null || ct.tag !== $) {
          var vr = Tu(We, He.mode, sr, br);
          return vr.return = He, vr;
        } else {
          var qr = S(ct, We);
          return qr.return = He, qr;
        }
      }
      function ze(He, ct, We) {
        if (typeof ct == "string" && ct !== "" || typeof ct == "number") {
          var sr = lb("" + ct, He.mode, We);
          return sr.return = He, sr;
        }
        if (typeof ct == "object" && ct !== null) {
          switch (ct.$$typeof) {
            case Fn: {
              var br = ab(ct, He.mode, We);
              return br.ref = ch(He, null, ct), br.return = He, br;
            }
            case Gn: {
              var vr = ub(ct, He.mode, We);
              return vr.return = He, vr;
            }
            case Dr: {
              var qr = ct._payload, Zr = ct._init;
              return ze(He, Zr(qr), We);
            }
          }
          if (co(ct) || Ps(ct)) {
            var Rn = Tu(ct, He.mode, We, null);
            return Rn.return = He, Rn;
          }
          Kv(He, ct);
        }
        return typeof ct == "function" && Xv(He), null;
      }
      function Le(He, ct, We, sr) {
        var br = ct !== null ? ct.key : null;
        if (typeof We == "string" && We !== "" || typeof We == "number")
          return br !== null ? null : pe(He, ct, "" + We, sr);
        if (typeof We == "object" && We !== null) {
          switch (We.$$typeof) {
            case Fn:
              return We.key === br ? me(He, ct, We, sr) : null;
            case Gn:
              return We.key === br ? Se(He, ct, We, sr) : null;
            case Dr: {
              var vr = We._payload, qr = We._init;
              return Le(He, ct, qr(vr), sr);
            }
          }
          if (co(We) || Ps(We))
            return br !== null ? null : _e(He, ct, We, sr, null);
          Kv(He, We);
        }
        return typeof We == "function" && Xv(He), null;
      }
      function qe(He, ct, We, sr, br) {
        if (typeof sr == "string" && sr !== "" || typeof sr == "number") {
          var vr = He.get(We) || null;
          return pe(ct, vr, "" + sr, br);
        }
        if (typeof sr == "object" && sr !== null) {
          switch (sr.$$typeof) {
            case Fn: {
              var qr = He.get(sr.key === null ? We : sr.key) || null;
              return me(ct, qr, sr, br);
            }
            case Gn: {
              var Zr = He.get(sr.key === null ? We : sr.key) || null;
              return Se(ct, Zr, sr, br);
            }
            case Dr:
              var Rn = sr._payload, gn = sr._init;
              return qe(He, ct, We, gn(Rn), br);
          }
          if (co(sr) || Ps(sr)) {
            var lo = He.get(We) || null;
            return _e(ct, lo, sr, br, null);
          }
          Kv(ct, sr);
        }
        return typeof sr == "function" && Xv(ct), null;
      }
      function Ke(He, ct, We) {
        {
          if (typeof He != "object" || He === null)
            return ct;
          switch (He.$$typeof) {
            case Fn:
            case Gn:
              _T(He, We);
              var sr = He.key;
              if (typeof sr != "string")
                break;
              if (ct === null) {
                ct = /* @__PURE__ */ new Set(), ct.add(sr);
                break;
              }
              if (!ct.has(sr)) {
                ct.add(sr);
                break;
              }
              c("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", sr);
              break;
            case Dr:
              var br = He._payload, vr = He._init;
              Ke(vr(br), ct, We);
              break;
          }
        }
        return ct;
      }
      function rt(He, ct, We, sr) {
        for (var br = null, vr = 0; vr < We.length; vr++) {
          var qr = We[vr];
          br = Ke(qr, br, He);
        }
        for (var Zr = null, Rn = null, gn = ct, lo = 0, xn = 0, eo = null; gn !== null && xn < We.length; xn++) {
          gn.index > xn ? (eo = gn, gn = null) : eo = gn.sibling;
          var pi = Le(He, gn, We[xn], sr);
          if (pi === null) {
            gn === null && (gn = eo);
            break;
          }
          i && gn && pi.alternate === null && a(He, gn), lo = O(pi, lo, xn), Rn === null ? Zr = pi : Rn.sibling = pi, Rn = pi, gn = eo;
        }
        if (xn === We.length) {
          if (f(He, gn), Ho()) {
            var Qo = xn;
            vc(He, Qo);
          }
          return Zr;
        }
        if (gn === null) {
          for (; xn < We.length; xn++) {
            var cs = ze(He, We[xn], sr);
            cs !== null && (lo = O(cs, lo, xn), Rn === null ? Zr = cs : Rn.sibling = cs, Rn = cs);
          }
          if (Ho()) {
            var ki = xn;
            vc(He, ki);
          }
          return Zr;
        }
        for (var Ai = b(He, gn); xn < We.length; xn++) {
          var hi = qe(Ai, He, xn, We[xn], sr);
          hi !== null && (i && hi.alternate !== null && Ai.delete(hi.key === null ? xn : hi.key), lo = O(hi, lo, xn), Rn === null ? Zr = hi : Rn.sibling = hi, Rn = hi);
        }
        if (i && Ai.forEach(function(Sf) {
          return a(He, Sf);
        }), Ho()) {
          var Cl = xn;
          vc(He, Cl);
        }
        return Zr;
      }
      function xr(He, ct, We, sr) {
        var br = Ps(We);
        if (typeof br != "function")
          throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
        {
          typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
          We[Symbol.toStringTag] === "Generator" && ($x || c("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), $x = !0), We.entries === br && (Ax || c("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), Ax = !0);
          var vr = br.call(We);
          if (vr)
            for (var qr = null, Zr = vr.next(); !Zr.done; Zr = vr.next()) {
              var Rn = Zr.value;
              qr = Ke(Rn, qr, He);
            }
        }
        var gn = br.call(We);
        if (gn == null)
          throw new Error("An iterable object provided no iterator.");
        for (var lo = null, xn = null, eo = ct, pi = 0, Qo = 0, cs = null, ki = gn.next(); eo !== null && !ki.done; Qo++, ki = gn.next()) {
          eo.index > Qo ? (cs = eo, eo = null) : cs = eo.sibling;
          var Ai = Le(He, eo, ki.value, sr);
          if (Ai === null) {
            eo === null && (eo = cs);
            break;
          }
          i && eo && Ai.alternate === null && a(He, eo), pi = O(Ai, pi, Qo), xn === null ? lo = Ai : xn.sibling = Ai, xn = Ai, eo = cs;
        }
        if (ki.done) {
          if (f(He, eo), Ho()) {
            var hi = Qo;
            vc(He, hi);
          }
          return lo;
        }
        if (eo === null) {
          for (; !ki.done; Qo++, ki = gn.next()) {
            var Cl = ze(He, ki.value, sr);
            Cl !== null && (pi = O(Cl, pi, Qo), xn === null ? lo = Cl : xn.sibling = Cl, xn = Cl);
          }
          if (Ho()) {
            var Sf = Qo;
            vc(He, Sf);
          }
          return lo;
        }
        for (var Bh = b(He, eo); !ki.done; Qo++, ki = gn.next()) {
          var Na = qe(Bh, He, Qo, ki.value, sr);
          Na !== null && (i && Na.alternate !== null && Bh.delete(Na.key === null ? Qo : Na.key), pi = O(Na, pi, Qo), xn === null ? lo = Na : xn.sibling = Na, xn = Na);
        }
        if (i && Bh.forEach(function(Fw) {
          return a(He, Fw);
        }), Ho()) {
          var Iw = Qo;
          vc(He, Iw);
        }
        return lo;
      }
      function zr(He, ct, We, sr) {
        if (ct !== null && ct.tag === M) {
          f(He, ct.sibling);
          var br = S(ct, We);
          return br.return = He, br;
        }
        f(He, ct);
        var vr = lb(We, He.mode, sr);
        return vr.return = He, vr;
      }
      function Or(He, ct, We, sr) {
        for (var br = We.key, vr = ct; vr !== null; ) {
          if (vr.key === br) {
            var qr = We.type;
            if (qr === Bo) {
              if (vr.tag === $) {
                f(He, vr.sibling);
                var Zr = S(vr, We.props.children);
                return Zr.return = He, Zr._debugSource = We._source, Zr._debugOwner = We._owner, Zr;
              }
            } else if (vr.elementType === qr || // Keep this check inline so it only runs on the false path:
            xE(vr, We) || // Lazy types should reconcile their resolved type.
            // We need to do this after the Hot Reloading check above,
            // because hot reloading has different semantics than prod because
            // it doesn't resuspend. So we can't let the call below suspend.
            typeof qr == "object" && qr !== null && qr.$$typeof === Dr && wT(qr) === vr.type) {
              f(He, vr.sibling);
              var Rn = S(vr, We.props);
              return Rn.ref = ch(He, vr, We), Rn.return = He, Rn._debugSource = We._source, Rn._debugOwner = We._owner, Rn;
            }
            f(He, vr);
            break;
          } else
            a(He, vr);
          vr = vr.sibling;
        }
        if (We.type === Bo) {
          var gn = Tu(We.props.children, He.mode, sr, We.key);
          return gn.return = He, gn;
        } else {
          var lo = ab(We, He.mode, sr);
          return lo.ref = ch(He, ct, We), lo.return = He, lo;
        }
      }
      function dn(He, ct, We, sr) {
        for (var br = We.key, vr = ct; vr !== null; ) {
          if (vr.key === br)
            if (vr.tag === R && vr.stateNode.containerInfo === We.containerInfo && vr.stateNode.implementation === We.implementation) {
              f(He, vr.sibling);
              var qr = S(vr, We.children || []);
              return qr.return = He, qr;
            } else {
              f(He, vr);
              break;
            }
          else
            a(He, vr);
          vr = vr.sibling;
        }
        var Zr = ub(We, He.mode, sr);
        return Zr.return = He, Zr;
      }
      function ln(He, ct, We, sr) {
        var br = typeof We == "object" && We !== null && We.type === Bo && We.key === null;
        if (br && (We = We.props.children), typeof We == "object" && We !== null) {
          switch (We.$$typeof) {
            case Fn:
              return J(Or(He, ct, We, sr));
            case Gn:
              return J(dn(He, ct, We, sr));
            case Dr:
              var vr = We._payload, qr = We._init;
              return ln(He, ct, qr(vr), sr);
          }
          if (co(We))
            return rt(He, ct, We, sr);
          if (Ps(We))
            return xr(He, ct, We, sr);
          Kv(He, We);
        }
        return typeof We == "string" && We !== "" || typeof We == "number" ? J(zr(He, ct, "" + We, sr)) : (typeof We == "function" && Xv(He), f(He, ct));
      }
      return ln;
    }
    var lf = kT(!0), AT = kT(!1);
    function PP(i, a) {
      if (i !== null && a.child !== i.child)
        throw new Error("Resuming work not yet implemented.");
      if (a.child !== null) {
        var f = a.child, b = kc(f, f.pendingProps);
        for (a.child = b, b.return = a; f.sibling !== null; )
          f = f.sibling, b = b.sibling = kc(f, f.pendingProps), b.return = a;
        b.sibling = null;
      }
    }
    function RP(i, a) {
      for (var f = i.child; f !== null; )
        tw(f, a), f = f.sibling;
    }
    var dh = {}, fu = au(dh), fh = au(dh), Qv = au(dh);
    function Jv(i) {
      if (i === dh)
        throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
      return i;
    }
    function $T() {
      var i = Jv(Qv.current);
      return i;
    }
    function Ox(i, a) {
      di(Qv, a, i), di(fh, i, i), di(fu, dh, i);
      var f = LC(a);
      ci(fu, i), di(fu, f, i);
    }
    function uf(i) {
      ci(fu, i), ci(fh, i), ci(Qv, i);
    }
    function Dx() {
      var i = Jv(fu.current);
      return i;
    }
    function jT(i) {
      Jv(Qv.current);
      var a = Jv(fu.current), f = BC(a, i.type);
      a !== f && (di(fh, i, i), di(fu, f, i));
    }
    function Ix(i) {
      fh.current === i && (ci(fu, i), ci(fh, i));
    }
    var _P = 0, MT = 1, NT = 1, ph = 2, Gs = au(_P);
    function Fx(i, a) {
      return (i & a) !== 0;
    }
    function cf(i) {
      return i & MT;
    }
    function Lx(i, a) {
      return i & MT | a;
    }
    function wP(i, a) {
      return i | a;
    }
    function pu(i, a) {
      di(Gs, a, i);
    }
    function df(i) {
      ci(Gs, i);
    }
    function kP(i, a) {
      var f = i.memoizedState;
      return f !== null ? f.dehydrated !== null : (i.memoizedProps, !0);
    }
    function Zv(i) {
      for (var a = i; a !== null; ) {
        if (a.tag === K) {
          var f = a.memoizedState;
          if (f !== null) {
            var b = f.dehydrated;
            if (b === null || Hb(b) || Wg(b))
              return a;
          }
        } else if (a.tag === Ce && // revealOrder undefined can't be trusted because it don't
        // keep track of whether it suspended or not.
        a.memoizedProps.revealOrder !== void 0) {
          var S = (a.flags & Kr) !== Lr;
          if (S)
            return a;
        } else if (a.child !== null) {
          a.child.return = a, a = a.child;
          continue;
        }
        if (a === i)
          return null;
        for (; a.sibling === null; ) {
          if (a.return === null || a.return === i)
            return null;
          a = a.return;
        }
        a.sibling.return = a.return, a = a.sibling;
      }
      return null;
    }
    var Ki = (
      /*   */
      0
    ), Eo = (
      /* */
      1
    ), _a = (
      /*  */
      2
    ), Co = (
      /*    */
      4
    ), Wo = (
      /*   */
      8
    ), Bx = [];
    function zx() {
      for (var i = 0; i < Bx.length; i++) {
        var a = Bx[i];
        a._workInProgressVersionPrimary = null;
      }
      Bx.length = 0;
    }
    function AP(i, a) {
      var f = a._getVersion, b = f(a._source);
      i.mutableSourceEagerHydrationData == null ? i.mutableSourceEagerHydrationData = [a, b] : i.mutableSourceEagerHydrationData.push(a, b);
    }
    var gr = n.ReactCurrentDispatcher, hh = n.ReactCurrentBatchConfig, Vx, ff;
    Vx = /* @__PURE__ */ new Set();
    var Ec = mt, Pn = null, So = null, Po = null, ey = !1, mh = !1, vh = 0, $P = 0, jP = 25, vt = null, Ts = null, hu = -1, Ux = !1;
    function En() {
      {
        var i = vt;
        Ts === null ? Ts = [i] : Ts.push(i);
      }
    }
    function fr() {
      {
        var i = vt;
        Ts !== null && (hu++, Ts[hu] !== i && MP(i));
      }
    }
    function pf(i) {
      i != null && !co(i) && c("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", vt, typeof i);
    }
    function MP(i) {
      {
        var a = en(Pn);
        if (!Vx.has(a) && (Vx.add(a), Ts !== null)) {
          for (var f = "", b = 30, S = 0; S <= hu; S++) {
            for (var O = Ts[S], J = S === hu ? i : O, pe = S + 1 + ". " + O; pe.length < b; )
              pe += " ";
            pe += J + `
`, f += pe;
          }
          c(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, a, f);
        }
      }
    }
    function fi() {
      throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
    }
    function Hx(i, a) {
      if (Ux)
        return !1;
      if (a === null)
        return c("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", vt), !1;
      i.length !== a.length && c(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, vt, "[" + a.join(", ") + "]", "[" + i.join(", ") + "]");
      for (var f = 0; f < a.length && f < i.length; f++)
        if (!Rr(i[f], a[f]))
          return !1;
      return !0;
    }
    function hf(i, a, f, b, S, O) {
      Ec = O, Pn = a, Ts = i !== null ? i._debugHookTypes : null, hu = -1, Ux = i !== null && i.type !== a.type, a.memoizedState = null, a.updateQueue = null, a.lanes = mt, i !== null && i.memoizedState !== null ? gr.current = r1 : Ts !== null ? gr.current = t1 : gr.current = e1;
      var J = f(b, S);
      if (mh) {
        var pe = 0;
        do {
          if (mh = !1, vh = 0, pe >= jP)
            throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
          pe += 1, Ux = !1, So = null, Po = null, a.updateQueue = null, hu = -1, gr.current = n1, J = f(b, S);
        } while (mh);
      }
      gr.current = py, a._debugHookTypes = Ts;
      var me = So !== null && So.next !== null;
      if (Ec = mt, Pn = null, So = null, Po = null, vt = null, Ts = null, hu = -1, i !== null && (i.flags & xo) !== (a.flags & xo) && // Disable this warning in legacy mode, because legacy Suspense is weird
      // and creates false positives. To make this work in legacy mode, we'd
      // need to mark fibers that commit in an incomplete state, somehow. For
      // now I'll disable the warning that most of the bugs that would trigger
      // it are either exclusive to concurrent mode or exist in both.
      (i.mode & nn) !== Vr && c("Internal React error: Expected static flag was missing. Please notify the React team."), ey = !1, me)
        throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
      return J;
    }
    function mf() {
      var i = vh !== 0;
      return vh = 0, i;
    }
    function OT(i, a, f) {
      a.updateQueue = i.updateQueue, (a.mode & zi) !== Vr ? a.flags &= ~(Wa | oi | Dn | tn) : a.flags &= ~(Dn | tn), i.lanes = Hl(i.lanes, f);
    }
    function DT() {
      if (gr.current = py, ey) {
        for (var i = Pn.memoizedState; i !== null; ) {
          var a = i.queue;
          a !== null && (a.pending = null), i = i.next;
        }
        ey = !1;
      }
      Ec = mt, Pn = null, So = null, Po = null, Ts = null, hu = -1, vt = null, KT = !1, mh = !1, vh = 0;
    }
    function wa() {
      var i = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return Po === null ? Pn.memoizedState = Po = i : Po = Po.next = i, Po;
    }
    function Es() {
      var i;
      if (So === null) {
        var a = Pn.alternate;
        a !== null ? i = a.memoizedState : i = null;
      } else
        i = So.next;
      var f;
      if (Po === null ? f = Pn.memoizedState : f = Po.next, f !== null)
        Po = f, f = Po.next, So = i;
      else {
        if (i === null)
          throw new Error("Rendered more hooks than during the previous render.");
        So = i;
        var b = {
          memoizedState: So.memoizedState,
          baseState: So.baseState,
          baseQueue: So.baseQueue,
          queue: So.queue,
          next: null
        };
        Po === null ? Pn.memoizedState = Po = b : Po = Po.next = b;
      }
      return Po;
    }
    function IT() {
      return {
        lastEffect: null,
        stores: null
      };
    }
    function Wx(i, a) {
      return typeof a == "function" ? a(i) : a;
    }
    function Gx(i, a, f) {
      var b = wa(), S;
      f !== void 0 ? S = f(a) : S = a, b.memoizedState = b.baseState = S;
      var O = {
        pending: null,
        interleaved: null,
        lanes: mt,
        dispatch: null,
        lastRenderedReducer: i,
        lastRenderedState: S
      };
      b.queue = O;
      var J = O.dispatch = IP.bind(null, Pn, O);
      return [b.memoizedState, J];
    }
    function Yx(i, a, f) {
      var b = Es(), S = b.queue;
      if (S === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      S.lastRenderedReducer = i;
      var O = So, J = O.baseQueue, pe = S.pending;
      if (pe !== null) {
        if (J !== null) {
          var me = J.next, Se = pe.next;
          J.next = Se, pe.next = me;
        }
        O.baseQueue !== J && c("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), O.baseQueue = J = pe, S.pending = null;
      }
      if (J !== null) {
        var _e = J.next, ze = O.baseState, Le = null, qe = null, Ke = null, rt = _e;
        do {
          var xr = rt.lane;
          if (tl(Ec, xr)) {
            if (Ke !== null) {
              var Or = {
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: un,
                action: rt.action,
                hasEagerState: rt.hasEagerState,
                eagerState: rt.eagerState,
                next: null
              };
              Ke = Ke.next = Or;
            }
            if (rt.hasEagerState)
              ze = rt.eagerState;
            else {
              var dn = rt.action;
              ze = i(ze, dn);
            }
          } else {
            var zr = {
              lane: xr,
              action: rt.action,
              hasEagerState: rt.hasEagerState,
              eagerState: rt.eagerState,
              next: null
            };
            Ke === null ? (qe = Ke = zr, Le = ze) : Ke = Ke.next = zr, Pn.lanes = rn(Pn.lanes, xr), Oh(xr);
          }
          rt = rt.next;
        } while (rt !== null && rt !== _e);
        Ke === null ? Le = ze : Ke.next = qe, Rr(ze, b.memoizedState) || Ch(), b.memoizedState = ze, b.baseState = Le, b.baseQueue = Ke, S.lastRenderedState = ze;
      }
      var ln = S.interleaved;
      if (ln !== null) {
        var He = ln;
        do {
          var ct = He.lane;
          Pn.lanes = rn(Pn.lanes, ct), Oh(ct), He = He.next;
        } while (He !== ln);
      } else
        J === null && (S.lanes = mt);
      var We = S.dispatch;
      return [b.memoizedState, We];
    }
    function qx(i, a, f) {
      var b = Es(), S = b.queue;
      if (S === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      S.lastRenderedReducer = i;
      var O = S.dispatch, J = S.pending, pe = b.memoizedState;
      if (J !== null) {
        S.pending = null;
        var me = J.next, Se = me;
        do {
          var _e = Se.action;
          pe = i(pe, _e), Se = Se.next;
        } while (Se !== me);
        Rr(pe, b.memoizedState) || Ch(), b.memoizedState = pe, b.baseQueue === null && (b.baseState = pe), S.lastRenderedState = pe;
      }
      return [pe, O];
    }
    function Bw(i, a, f) {
    }
    function zw(i, a, f) {
    }
    function Kx(i, a, f) {
      var b = Pn, S = wa(), O, J = Ho();
      if (J) {
        if (f === void 0)
          throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        O = f(), ff || O !== f() && (c("The result of getServerSnapshot should be cached to avoid an infinite loop"), ff = !0);
      } else {
        if (O = a(), !ff) {
          var pe = a();
          Rr(O, pe) || (c("The result of getSnapshot should be cached to avoid an infinite loop"), ff = !0);
        }
        var me = $y();
        if (me === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Zu(me, Ec) || FT(b, a, O);
      }
      S.memoizedState = O;
      var Se = {
        value: O,
        getSnapshot: a
      };
      return S.queue = Se, iy(BT.bind(null, b, Se, i), [i]), b.flags |= Dn, yh(Eo | Wo, LT.bind(null, b, Se, O, a), void 0, null), O;
    }
    function ty(i, a, f) {
      var b = Pn, S = Es(), O = a();
      if (!ff) {
        var J = a();
        Rr(O, J) || (c("The result of getSnapshot should be cached to avoid an infinite loop"), ff = !0);
      }
      var pe = S.memoizedState, me = !Rr(pe, O);
      me && (S.memoizedState = O, Ch());
      var Se = S.queue;
      if (xh(BT.bind(null, b, Se, i), [i]), Se.getSnapshot !== a || me || // Check if the susbcribe function changed. We can save some memory by
      // checking whether we scheduled a subscription effect above.
      Po !== null && Po.memoizedState.tag & Eo) {
        b.flags |= Dn, yh(Eo | Wo, LT.bind(null, b, Se, O, a), void 0, null);
        var _e = $y();
        if (_e === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Zu(_e, Ec) || FT(b, a, O);
      }
      return O;
    }
    function FT(i, a, f) {
      i.flags |= Hu;
      var b = {
        getSnapshot: a,
        value: f
      }, S = Pn.updateQueue;
      if (S === null)
        S = IT(), Pn.updateQueue = S, S.stores = [b];
      else {
        var O = S.stores;
        O === null ? S.stores = [b] : O.push(b);
      }
    }
    function LT(i, a, f, b) {
      a.value = f, a.getSnapshot = b, zT(a) && VT(i);
    }
    function BT(i, a, f) {
      var b = function() {
        zT(a) && VT(i);
      };
      return f(b);
    }
    function zT(i) {
      var a = i.getSnapshot, f = i.value;
      try {
        var b = a();
        return !Rr(f, b);
      } catch {
        return !0;
      }
    }
    function VT(i) {
      var a = qi(i, Wr);
      a !== null && ko(a, i, Wr, kn);
    }
    function ry(i) {
      var a = wa();
      typeof i == "function" && (i = i()), a.memoizedState = a.baseState = i;
      var f = {
        pending: null,
        interleaved: null,
        lanes: mt,
        dispatch: null,
        lastRenderedReducer: Wx,
        lastRenderedState: i
      };
      a.queue = f;
      var b = f.dispatch = FP.bind(null, Pn, f);
      return [a.memoizedState, b];
    }
    function Xx(i) {
      return Yx(Wx);
    }
    function Qx(i) {
      return qx(Wx);
    }
    function yh(i, a, f, b) {
      var S = {
        tag: i,
        create: a,
        destroy: f,
        deps: b,
        // Circular
        next: null
      }, O = Pn.updateQueue;
      if (O === null)
        O = IT(), Pn.updateQueue = O, O.lastEffect = S.next = S;
      else {
        var J = O.lastEffect;
        if (J === null)
          O.lastEffect = S.next = S;
        else {
          var pe = J.next;
          J.next = S, S.next = pe, O.lastEffect = S;
        }
      }
      return S;
    }
    function Jx(i) {
      var a = wa();
      {
        var f = {
          current: i
        };
        return a.memoizedState = f, f;
      }
    }
    function ny(i) {
      var a = Es();
      return a.memoizedState;
    }
    function gh(i, a, f, b) {
      var S = wa(), O = b === void 0 ? null : b;
      Pn.flags |= i, S.memoizedState = yh(Eo | a, f, void 0, O);
    }
    function oy(i, a, f, b) {
      var S = Es(), O = b === void 0 ? null : b, J = void 0;
      if (So !== null) {
        var pe = So.memoizedState;
        if (J = pe.destroy, O !== null) {
          var me = pe.deps;
          if (Hx(O, me)) {
            S.memoizedState = yh(a, f, J, O);
            return;
          }
        }
      }
      Pn.flags |= i, S.memoizedState = yh(Eo | a, f, J, O);
    }
    function iy(i, a) {
      return (Pn.mode & zi) !== Vr ? gh(Wa | Dn | ca, Wo, i, a) : gh(Dn | ca, Wo, i, a);
    }
    function xh(i, a) {
      return oy(Dn, Wo, i, a);
    }
    function Zx(i, a) {
      return gh(tn, _a, i, a);
    }
    function sy(i, a) {
      return oy(tn, _a, i, a);
    }
    function e0(i, a) {
      var f = tn;
      return f |= ni, (Pn.mode & zi) !== Vr && (f |= oi), gh(f, Co, i, a);
    }
    function ay(i, a) {
      return oy(tn, Co, i, a);
    }
    function UT(i, a) {
      if (typeof a == "function") {
        var f = a, b = i();
        return f(b), function() {
          f(null);
        };
      } else if (a != null) {
        var S = a;
        S.hasOwnProperty("current") || c("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(S).join(", ") + "}");
        var O = i();
        return S.current = O, function() {
          S.current = null;
        };
      }
    }
    function t0(i, a, f) {
      typeof a != "function" && c("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", a !== null ? typeof a : "null");
      var b = f != null ? f.concat([i]) : null, S = tn;
      return S |= ni, (Pn.mode & zi) !== Vr && (S |= oi), gh(S, Co, UT.bind(null, a, i), b);
    }
    function ly(i, a, f) {
      typeof a != "function" && c("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", a !== null ? typeof a : "null");
      var b = f != null ? f.concat([i]) : null;
      return oy(tn, Co, UT.bind(null, a, i), b);
    }
    function NP(i, a) {
    }
    var uy = NP;
    function r0(i, a) {
      var f = wa(), b = a === void 0 ? null : a;
      return f.memoizedState = [i, b], i;
    }
    function cy(i, a) {
      var f = Es(), b = a === void 0 ? null : a, S = f.memoizedState;
      if (S !== null && b !== null) {
        var O = S[1];
        if (Hx(b, O))
          return S[0];
      }
      return f.memoizedState = [i, b], i;
    }
    function n0(i, a) {
      var f = wa(), b = a === void 0 ? null : a, S = i();
      return f.memoizedState = [S, b], S;
    }
    function dy(i, a) {
      var f = Es(), b = a === void 0 ? null : a, S = f.memoizedState;
      if (S !== null && b !== null) {
        var O = S[1];
        if (Hx(b, O))
          return S[0];
      }
      var J = i();
      return f.memoizedState = [J, b], J;
    }
    function o0(i) {
      var a = wa();
      return a.memoizedState = i, i;
    }
    function HT(i) {
      var a = Es(), f = So, b = f.memoizedState;
      return GT(a, b, i);
    }
    function WT(i) {
      var a = Es();
      if (So === null)
        return a.memoizedState = i, i;
      var f = So.memoizedState;
      return GT(a, f, i);
    }
    function GT(i, a, f) {
      var b = !cg(Ec);
      if (b) {
        if (!Rr(f, a)) {
          var S = bp();
          Pn.lanes = rn(Pn.lanes, S), Oh(S), i.baseState = !0;
        }
        return a;
      } else
        return i.baseState && (i.baseState = !1, Ch()), i.memoizedState = f, f;
    }
    function OP(i, a, f) {
      var b = Ui();
      io(Oo(b, To)), i(!0);
      var S = hh.transition;
      hh.transition = {};
      var O = hh.transition;
      hh.transition._updatedFibers = /* @__PURE__ */ new Set();
      try {
        i(!1), a();
      } finally {
        if (io(b), hh.transition = S, S === null && O._updatedFibers) {
          var J = O._updatedFibers.size;
          J > 10 && l("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), O._updatedFibers.clear();
        }
      }
    }
    function i0() {
      var i = ry(!1), a = i[0], f = i[1], b = OP.bind(null, f), S = wa();
      return S.memoizedState = b, [a, b];
    }
    function YT() {
      var i = Xx(), a = i[0], f = Es(), b = f.memoizedState;
      return [a, b];
    }
    function qT() {
      var i = Qx(), a = i[0], f = Es(), b = f.memoizedState;
      return [a, b];
    }
    var KT = !1;
    function DP() {
      return KT;
    }
    function s0() {
      var i = wa(), a = $y(), f = a.identifierPrefix, b;
      if (Ho()) {
        var S = XS();
        b = ":" + f + "R" + S;
        var O = vh++;
        O > 0 && (b += "H" + O.toString(32)), b += ":";
      } else {
        var J = $P++;
        b = ":" + f + "r" + J.toString(32) + ":";
      }
      return i.memoizedState = b, b;
    }
    function fy() {
      var i = Es(), a = i.memoizedState;
      return a;
    }
    function IP(i, a, f) {
      typeof arguments[3] == "function" && c("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var b = xu(i), S = {
        lane: b,
        action: f,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (XT(i))
        QT(a, S);
      else {
        var O = hT(i, a, S, b);
        if (O !== null) {
          var J = wi();
          ko(O, i, b, J), JT(O, a, b);
        }
      }
      ZT(i, b);
    }
    function FP(i, a, f) {
      typeof arguments[3] == "function" && c("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var b = xu(i), S = {
        lane: b,
        action: f,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (XT(i))
        QT(a, S);
      else {
        var O = i.alternate;
        if (i.lanes === mt && (O === null || O.lanes === mt)) {
          var J = a.lastRenderedReducer;
          if (J !== null) {
            var pe;
            pe = gr.current, gr.current = Ys;
            try {
              var me = a.lastRenderedState, Se = J(me, f);
              if (S.hasEagerState = !0, S.eagerState = Se, Rr(Se, me)) {
                vP(i, a, S, b);
                return;
              }
            } catch {
            } finally {
              gr.current = pe;
            }
          }
        }
        var _e = hT(i, a, S, b);
        if (_e !== null) {
          var ze = wi();
          ko(_e, i, b, ze), JT(_e, a, b);
        }
      }
      ZT(i, b);
    }
    function XT(i) {
      var a = i.alternate;
      return i === Pn || a !== null && a === Pn;
    }
    function QT(i, a) {
      mh = ey = !0;
      var f = i.pending;
      f === null ? a.next = a : (a.next = f.next, f.next = a), i.pending = a;
    }
    function JT(i, a, f) {
      if (xp(f)) {
        var b = a.lanes;
        b = Tp(b, i.pendingLanes);
        var S = rn(b, f);
        a.lanes = S, Wl(i, S);
      }
    }
    function ZT(i, a, f) {
      va(i, a);
    }
    var py = {
      readContext: go,
      useCallback: fi,
      useContext: fi,
      useEffect: fi,
      useImperativeHandle: fi,
      useInsertionEffect: fi,
      useLayoutEffect: fi,
      useMemo: fi,
      useReducer: fi,
      useRef: fi,
      useState: fi,
      useDebugValue: fi,
      useDeferredValue: fi,
      useTransition: fi,
      useMutableSource: fi,
      useSyncExternalStore: fi,
      useId: fi,
      unstable_isNewReconciler: le
    }, e1 = null, t1 = null, r1 = null, n1 = null, ka = null, Ys = null, hy = null;
    {
      var a0 = function() {
        c("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      }, Jr = function() {
        c("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
      };
      e1 = {
        readContext: function(i) {
          return go(i);
        },
        useCallback: function(i, a) {
          return vt = "useCallback", En(), pf(a), r0(i, a);
        },
        useContext: function(i) {
          return vt = "useContext", En(), go(i);
        },
        useEffect: function(i, a) {
          return vt = "useEffect", En(), pf(a), iy(i, a);
        },
        useImperativeHandle: function(i, a, f) {
          return vt = "useImperativeHandle", En(), pf(f), t0(i, a, f);
        },
        useInsertionEffect: function(i, a) {
          return vt = "useInsertionEffect", En(), pf(a), Zx(i, a);
        },
        useLayoutEffect: function(i, a) {
          return vt = "useLayoutEffect", En(), pf(a), e0(i, a);
        },
        useMemo: function(i, a) {
          vt = "useMemo", En(), pf(a);
          var f = gr.current;
          gr.current = ka;
          try {
            return n0(i, a);
          } finally {
            gr.current = f;
          }
        },
        useReducer: function(i, a, f) {
          vt = "useReducer", En();
          var b = gr.current;
          gr.current = ka;
          try {
            return Gx(i, a, f);
          } finally {
            gr.current = b;
          }
        },
        useRef: function(i) {
          return vt = "useRef", En(), Jx(i);
        },
        useState: function(i) {
          vt = "useState", En();
          var a = gr.current;
          gr.current = ka;
          try {
            return ry(i);
          } finally {
            gr.current = a;
          }
        },
        useDebugValue: function(i, a) {
          return vt = "useDebugValue", En(), void 0;
        },
        useDeferredValue: function(i) {
          return vt = "useDeferredValue", En(), o0(i);
        },
        useTransition: function() {
          return vt = "useTransition", En(), i0();
        },
        useMutableSource: function(i, a, f) {
          return vt = "useMutableSource", En(), void 0;
        },
        useSyncExternalStore: function(i, a, f) {
          return vt = "useSyncExternalStore", En(), Kx(i, a, f);
        },
        useId: function() {
          return vt = "useId", En(), s0();
        },
        unstable_isNewReconciler: le
      }, t1 = {
        readContext: function(i) {
          return go(i);
        },
        useCallback: function(i, a) {
          return vt = "useCallback", fr(), r0(i, a);
        },
        useContext: function(i) {
          return vt = "useContext", fr(), go(i);
        },
        useEffect: function(i, a) {
          return vt = "useEffect", fr(), iy(i, a);
        },
        useImperativeHandle: function(i, a, f) {
          return vt = "useImperativeHandle", fr(), t0(i, a, f);
        },
        useInsertionEffect: function(i, a) {
          return vt = "useInsertionEffect", fr(), Zx(i, a);
        },
        useLayoutEffect: function(i, a) {
          return vt = "useLayoutEffect", fr(), e0(i, a);
        },
        useMemo: function(i, a) {
          vt = "useMemo", fr();
          var f = gr.current;
          gr.current = ka;
          try {
            return n0(i, a);
          } finally {
            gr.current = f;
          }
        },
        useReducer: function(i, a, f) {
          vt = "useReducer", fr();
          var b = gr.current;
          gr.current = ka;
          try {
            return Gx(i, a, f);
          } finally {
            gr.current = b;
          }
        },
        useRef: function(i) {
          return vt = "useRef", fr(), Jx(i);
        },
        useState: function(i) {
          vt = "useState", fr();
          var a = gr.current;
          gr.current = ka;
          try {
            return ry(i);
          } finally {
            gr.current = a;
          }
        },
        useDebugValue: function(i, a) {
          return vt = "useDebugValue", fr(), void 0;
        },
        useDeferredValue: function(i) {
          return vt = "useDeferredValue", fr(), o0(i);
        },
        useTransition: function() {
          return vt = "useTransition", fr(), i0();
        },
        useMutableSource: function(i, a, f) {
          return vt = "useMutableSource", fr(), void 0;
        },
        useSyncExternalStore: function(i, a, f) {
          return vt = "useSyncExternalStore", fr(), Kx(i, a, f);
        },
        useId: function() {
          return vt = "useId", fr(), s0();
        },
        unstable_isNewReconciler: le
      }, r1 = {
        readContext: function(i) {
          return go(i);
        },
        useCallback: function(i, a) {
          return vt = "useCallback", fr(), cy(i, a);
        },
        useContext: function(i) {
          return vt = "useContext", fr(), go(i);
        },
        useEffect: function(i, a) {
          return vt = "useEffect", fr(), xh(i, a);
        },
        useImperativeHandle: function(i, a, f) {
          return vt = "useImperativeHandle", fr(), ly(i, a, f);
        },
        useInsertionEffect: function(i, a) {
          return vt = "useInsertionEffect", fr(), sy(i, a);
        },
        useLayoutEffect: function(i, a) {
          return vt = "useLayoutEffect", fr(), ay(i, a);
        },
        useMemo: function(i, a) {
          vt = "useMemo", fr();
          var f = gr.current;
          gr.current = Ys;
          try {
            return dy(i, a);
          } finally {
            gr.current = f;
          }
        },
        useReducer: function(i, a, f) {
          vt = "useReducer", fr();
          var b = gr.current;
          gr.current = Ys;
          try {
            return Yx(i, a, f);
          } finally {
            gr.current = b;
          }
        },
        useRef: function(i) {
          return vt = "useRef", fr(), ny();
        },
        useState: function(i) {
          vt = "useState", fr();
          var a = gr.current;
          gr.current = Ys;
          try {
            return Xx(i);
          } finally {
            gr.current = a;
          }
        },
        useDebugValue: function(i, a) {
          return vt = "useDebugValue", fr(), uy();
        },
        useDeferredValue: function(i) {
          return vt = "useDeferredValue", fr(), HT(i);
        },
        useTransition: function() {
          return vt = "useTransition", fr(), YT();
        },
        useMutableSource: function(i, a, f) {
          return vt = "useMutableSource", fr(), void 0;
        },
        useSyncExternalStore: function(i, a, f) {
          return vt = "useSyncExternalStore", fr(), ty(i, a);
        },
        useId: function() {
          return vt = "useId", fr(), fy();
        },
        unstable_isNewReconciler: le
      }, n1 = {
        readContext: function(i) {
          return go(i);
        },
        useCallback: function(i, a) {
          return vt = "useCallback", fr(), cy(i, a);
        },
        useContext: function(i) {
          return vt = "useContext", fr(), go(i);
        },
        useEffect: function(i, a) {
          return vt = "useEffect", fr(), xh(i, a);
        },
        useImperativeHandle: function(i, a, f) {
          return vt = "useImperativeHandle", fr(), ly(i, a, f);
        },
        useInsertionEffect: function(i, a) {
          return vt = "useInsertionEffect", fr(), sy(i, a);
        },
        useLayoutEffect: function(i, a) {
          return vt = "useLayoutEffect", fr(), ay(i, a);
        },
        useMemo: function(i, a) {
          vt = "useMemo", fr();
          var f = gr.current;
          gr.current = hy;
          try {
            return dy(i, a);
          } finally {
            gr.current = f;
          }
        },
        useReducer: function(i, a, f) {
          vt = "useReducer", fr();
          var b = gr.current;
          gr.current = hy;
          try {
            return qx(i, a, f);
          } finally {
            gr.current = b;
          }
        },
        useRef: function(i) {
          return vt = "useRef", fr(), ny();
        },
        useState: function(i) {
          vt = "useState", fr();
          var a = gr.current;
          gr.current = hy;
          try {
            return Qx(i);
          } finally {
            gr.current = a;
          }
        },
        useDebugValue: function(i, a) {
          return vt = "useDebugValue", fr(), uy();
        },
        useDeferredValue: function(i) {
          return vt = "useDeferredValue", fr(), WT(i);
        },
        useTransition: function() {
          return vt = "useTransition", fr(), qT();
        },
        useMutableSource: function(i, a, f) {
          return vt = "useMutableSource", fr(), void 0;
        },
        useSyncExternalStore: function(i, a, f) {
          return vt = "useSyncExternalStore", fr(), ty(i, a);
        },
        useId: function() {
          return vt = "useId", fr(), fy();
        },
        unstable_isNewReconciler: le
      }, ka = {
        readContext: function(i) {
          return a0(), go(i);
        },
        useCallback: function(i, a) {
          return vt = "useCallback", Jr(), En(), r0(i, a);
        },
        useContext: function(i) {
          return vt = "useContext", Jr(), En(), go(i);
        },
        useEffect: function(i, a) {
          return vt = "useEffect", Jr(), En(), iy(i, a);
        },
        useImperativeHandle: function(i, a, f) {
          return vt = "useImperativeHandle", Jr(), En(), t0(i, a, f);
        },
        useInsertionEffect: function(i, a) {
          return vt = "useInsertionEffect", Jr(), En(), Zx(i, a);
        },
        useLayoutEffect: function(i, a) {
          return vt = "useLayoutEffect", Jr(), En(), e0(i, a);
        },
        useMemo: function(i, a) {
          vt = "useMemo", Jr(), En();
          var f = gr.current;
          gr.current = ka;
          try {
            return n0(i, a);
          } finally {
            gr.current = f;
          }
        },
        useReducer: function(i, a, f) {
          vt = "useReducer", Jr(), En();
          var b = gr.current;
          gr.current = ka;
          try {
            return Gx(i, a, f);
          } finally {
            gr.current = b;
          }
        },
        useRef: function(i) {
          return vt = "useRef", Jr(), En(), Jx(i);
        },
        useState: function(i) {
          vt = "useState", Jr(), En();
          var a = gr.current;
          gr.current = ka;
          try {
            return ry(i);
          } finally {
            gr.current = a;
          }
        },
        useDebugValue: function(i, a) {
          return vt = "useDebugValue", Jr(), En(), void 0;
        },
        useDeferredValue: function(i) {
          return vt = "useDeferredValue", Jr(), En(), o0(i);
        },
        useTransition: function() {
          return vt = "useTransition", Jr(), En(), i0();
        },
        useMutableSource: function(i, a, f) {
          return vt = "useMutableSource", Jr(), En(), void 0;
        },
        useSyncExternalStore: function(i, a, f) {
          return vt = "useSyncExternalStore", Jr(), En(), Kx(i, a, f);
        },
        useId: function() {
          return vt = "useId", Jr(), En(), s0();
        },
        unstable_isNewReconciler: le
      }, Ys = {
        readContext: function(i) {
          return a0(), go(i);
        },
        useCallback: function(i, a) {
          return vt = "useCallback", Jr(), fr(), cy(i, a);
        },
        useContext: function(i) {
          return vt = "useContext", Jr(), fr(), go(i);
        },
        useEffect: function(i, a) {
          return vt = "useEffect", Jr(), fr(), xh(i, a);
        },
        useImperativeHandle: function(i, a, f) {
          return vt = "useImperativeHandle", Jr(), fr(), ly(i, a, f);
        },
        useInsertionEffect: function(i, a) {
          return vt = "useInsertionEffect", Jr(), fr(), sy(i, a);
        },
        useLayoutEffect: function(i, a) {
          return vt = "useLayoutEffect", Jr(), fr(), ay(i, a);
        },
        useMemo: function(i, a) {
          vt = "useMemo", Jr(), fr();
          var f = gr.current;
          gr.current = Ys;
          try {
            return dy(i, a);
          } finally {
            gr.current = f;
          }
        },
        useReducer: function(i, a, f) {
          vt = "useReducer", Jr(), fr();
          var b = gr.current;
          gr.current = Ys;
          try {
            return Yx(i, a, f);
          } finally {
            gr.current = b;
          }
        },
        useRef: function(i) {
          return vt = "useRef", Jr(), fr(), ny();
        },
        useState: function(i) {
          vt = "useState", Jr(), fr();
          var a = gr.current;
          gr.current = Ys;
          try {
            return Xx(i);
          } finally {
            gr.current = a;
          }
        },
        useDebugValue: function(i, a) {
          return vt = "useDebugValue", Jr(), fr(), uy();
        },
        useDeferredValue: function(i) {
          return vt = "useDeferredValue", Jr(), fr(), HT(i);
        },
        useTransition: function() {
          return vt = "useTransition", Jr(), fr(), YT();
        },
        useMutableSource: function(i, a, f) {
          return vt = "useMutableSource", Jr(), fr(), void 0;
        },
        useSyncExternalStore: function(i, a, f) {
          return vt = "useSyncExternalStore", Jr(), fr(), ty(i, a);
        },
        useId: function() {
          return vt = "useId", Jr(), fr(), fy();
        },
        unstable_isNewReconciler: le
      }, hy = {
        readContext: function(i) {
          return a0(), go(i);
        },
        useCallback: function(i, a) {
          return vt = "useCallback", Jr(), fr(), cy(i, a);
        },
        useContext: function(i) {
          return vt = "useContext", Jr(), fr(), go(i);
        },
        useEffect: function(i, a) {
          return vt = "useEffect", Jr(), fr(), xh(i, a);
        },
        useImperativeHandle: function(i, a, f) {
          return vt = "useImperativeHandle", Jr(), fr(), ly(i, a, f);
        },
        useInsertionEffect: function(i, a) {
          return vt = "useInsertionEffect", Jr(), fr(), sy(i, a);
        },
        useLayoutEffect: function(i, a) {
          return vt = "useLayoutEffect", Jr(), fr(), ay(i, a);
        },
        useMemo: function(i, a) {
          vt = "useMemo", Jr(), fr();
          var f = gr.current;
          gr.current = Ys;
          try {
            return dy(i, a);
          } finally {
            gr.current = f;
          }
        },
        useReducer: function(i, a, f) {
          vt = "useReducer", Jr(), fr();
          var b = gr.current;
          gr.current = Ys;
          try {
            return qx(i, a, f);
          } finally {
            gr.current = b;
          }
        },
        useRef: function(i) {
          return vt = "useRef", Jr(), fr(), ny();
        },
        useState: function(i) {
          vt = "useState", Jr(), fr();
          var a = gr.current;
          gr.current = Ys;
          try {
            return Qx(i);
          } finally {
            gr.current = a;
          }
        },
        useDebugValue: function(i, a) {
          return vt = "useDebugValue", Jr(), fr(), uy();
        },
        useDeferredValue: function(i) {
          return vt = "useDeferredValue", Jr(), fr(), WT(i);
        },
        useTransition: function() {
          return vt = "useTransition", Jr(), fr(), qT();
        },
        useMutableSource: function(i, a, f) {
          return vt = "useMutableSource", Jr(), fr(), void 0;
        },
        useSyncExternalStore: function(i, a, f) {
          return vt = "useSyncExternalStore", Jr(), fr(), ty(i, a);
        },
        useId: function() {
          return vt = "useId", Jr(), fr(), fy();
        },
        unstable_isNewReconciler: le
      };
    }
    var mu = t.unstable_now, o1 = 0, my = -1, bh = -1, vy = -1, l0 = !1, yy = !1;
    function i1() {
      return l0;
    }
    function LP() {
      yy = !0;
    }
    function BP() {
      l0 = !1, yy = !1;
    }
    function zP() {
      l0 = yy, yy = !1;
    }
    function s1() {
      return o1;
    }
    function a1() {
      o1 = mu();
    }
    function u0(i) {
      bh = mu(), i.actualStartTime < 0 && (i.actualStartTime = mu());
    }
    function l1(i) {
      bh = -1;
    }
    function gy(i, a) {
      if (bh >= 0) {
        var f = mu() - bh;
        i.actualDuration += f, a && (i.selfBaseDuration = f), bh = -1;
      }
    }
    function Aa(i) {
      if (my >= 0) {
        var a = mu() - my;
        my = -1;
        for (var f = i.return; f !== null; ) {
          switch (f.tag) {
            case w:
              var b = f.stateNode;
              b.effectDuration += a;
              return;
            case B:
              var S = f.stateNode;
              S.effectDuration += a;
              return;
          }
          f = f.return;
        }
      }
    }
    function c0(i) {
      if (vy >= 0) {
        var a = mu() - vy;
        vy = -1;
        for (var f = i.return; f !== null; ) {
          switch (f.tag) {
            case w:
              var b = f.stateNode;
              b !== null && (b.passiveEffectDuration += a);
              return;
            case B:
              var S = f.stateNode;
              S !== null && (S.passiveEffectDuration += a);
              return;
          }
          f = f.return;
        }
      }
    }
    function $a() {
      my = mu();
    }
    function d0() {
      vy = mu();
    }
    function f0(i) {
      for (var a = i.child; a; )
        i.actualDuration += a.actualDuration, a = a.sibling;
    }
    function Cc(i, a) {
      return {
        value: i,
        source: a,
        stack: kf(a),
        digest: null
      };
    }
    function p0(i, a, f) {
      return {
        value: i,
        source: null,
        stack: f ?? null,
        digest: a ?? null
      };
    }
    function VP(i, a) {
      return !0;
    }
    function h0(i, a) {
      try {
        var f = VP(i, a);
        if (f === !1)
          return;
        var b = a.value, S = a.source, O = a.stack, J = O !== null ? O : "";
        if (b != null && b._suppressLogging) {
          if (i.tag === C)
            return;
          console.error(b);
        }
        var pe = S ? en(S) : null, me = pe ? "The above error occurred in the <" + pe + "> component:" : "The above error occurred in one of your React components:", Se;
        if (i.tag === w)
          Se = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;
        else {
          var _e = en(i) || "Anonymous";
          Se = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + _e + ".");
        }
        var ze = me + `
` + J + `

` + ("" + Se);
        console.error(ze);
      } catch (Le) {
        setTimeout(function() {
          throw Le;
        });
      }
    }
    var UP = typeof WeakMap == "function" ? WeakMap : Map;
    function u1(i, a, f) {
      var b = yl(kn, f);
      b.tag = hx, b.payload = {
        element: null
      };
      var S = a.value;
      return b.callback = function() {
        O_(S), h0(i, a);
      }, b;
    }
    function m0(i, a, f) {
      var b = yl(kn, f);
      b.tag = hx;
      var S = i.type.getDerivedStateFromError;
      if (typeof S == "function") {
        var O = a.value;
        b.payload = function() {
          return S(O);
        }, b.callback = function() {
          bE(i), h0(i, a);
        };
      }
      var J = i.stateNode;
      return J !== null && typeof J.componentDidCatch == "function" && (b.callback = function() {
        bE(i), h0(i, a), typeof S != "function" && M_(this);
        var me = a.value, Se = a.stack;
        this.componentDidCatch(me, {
          componentStack: Se !== null ? Se : ""
        }), typeof S != "function" && (ui(i.lanes, Wr) || c("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", en(i) || "Unknown"));
      }), b;
    }
    function c1(i, a, f) {
      var b = i.pingCache, S;
      if (b === null ? (b = i.pingCache = new UP(), S = /* @__PURE__ */ new Set(), b.set(a, S)) : (S = b.get(a), S === void 0 && (S = /* @__PURE__ */ new Set(), b.set(a, S))), !S.has(f)) {
        S.add(f);
        var O = D_.bind(null, i, a, f);
        bo && Dh(i, f), a.then(O, O);
      }
    }
    function HP(i, a, f, b) {
      var S = i.updateQueue;
      if (S === null) {
        var O = /* @__PURE__ */ new Set();
        O.add(f), i.updateQueue = O;
      } else
        S.add(f);
    }
    function WP(i, a) {
      var f = i.tag;
      if ((i.mode & nn) === Vr && (f === m || f === N || f === de)) {
        var b = i.alternate;
        b ? (i.updateQueue = b.updateQueue, i.memoizedState = b.memoizedState, i.lanes = b.lanes) : (i.updateQueue = null, i.memoizedState = null);
      }
    }
    function d1(i) {
      var a = i;
      do {
        if (a.tag === K && kP(a))
          return a;
        a = a.return;
      } while (a !== null);
      return null;
    }
    function f1(i, a, f, b, S) {
      if ((i.mode & nn) === Vr) {
        if (i === a)
          i.flags |= po;
        else {
          if (i.flags |= Kr, f.flags |= Wu, f.flags &= ~(Zc | bi), f.tag === C) {
            var O = f.alternate;
            if (O === null)
              f.tag = Te;
            else {
              var J = yl(kn, Wr);
              J.tag = Vv, du(f, J, Wr);
            }
          }
          f.lanes = rn(f.lanes, Wr);
        }
        return i;
      }
      return i.flags |= po, i.lanes = S, i;
    }
    function GP(i, a, f, b, S) {
      if (f.flags |= bi, bo && Dh(i, S), b !== null && typeof b == "object" && typeof b.then == "function") {
        var O = b;
        WP(f), Ho() && f.mode & nn && rT();
        var J = d1(a);
        if (J !== null) {
          J.flags &= ~Un, f1(J, a, f, i, S), J.mode & nn && c1(i, O, S), HP(J, i, O);
          return;
        } else {
          if (!Ul(S)) {
            c1(i, O, S), q0();
            return;
          }
          var pe = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
          b = pe;
        }
      } else if (Ho() && f.mode & nn) {
        rT();
        var me = d1(a);
        if (me !== null) {
          (me.flags & po) === Lr && (me.flags |= Un), f1(me, a, f, i, S), ax(Cc(b, f));
          return;
        }
      }
      b = Cc(b, f), P_(b);
      var Se = a;
      do {
        switch (Se.tag) {
          case w: {
            var _e = b;
            Se.flags |= po;
            var ze = oo(S);
            Se.lanes = rn(Se.lanes, ze);
            var Le = u1(Se, _e, ze);
            yx(Se, Le);
            return;
          }
          case C:
            var qe = b, Ke = Se.type, rt = Se.stateNode;
            if ((Se.flags & Kr) === Lr && (typeof Ke.getDerivedStateFromError == "function" || rt !== null && typeof rt.componentDidCatch == "function" && !dE(rt))) {
              Se.flags |= po;
              var xr = oo(S);
              Se.lanes = rn(Se.lanes, xr);
              var zr = m0(Se, qe, xr);
              yx(Se, zr);
              return;
            }
            break;
        }
        Se = Se.return;
      } while (Se !== null);
    }
    function YP() {
      return null;
    }
    var Th = n.ReactCurrentOwner, qs = !1, v0, Eh, y0, g0, x0, Sc, b0, xy;
    v0 = {}, Eh = {}, y0 = {}, g0 = {}, x0 = {}, Sc = !1, b0 = {}, xy = {};
    function Ri(i, a, f, b) {
      i === null ? a.child = AT(a, null, f, b) : a.child = lf(a, i.child, f, b);
    }
    function qP(i, a, f, b) {
      a.child = lf(a, i.child, null, b), a.child = lf(a, null, f, b);
    }
    function p1(i, a, f, b, S) {
      if (a.type !== a.elementType) {
        var O = f.propTypes;
        O && Vs(
          O,
          b,
          // Resolved props
          "prop",
          _n(f)
        );
      }
      var J = f.render, pe = a.ref, me, Se;
      af(a, S), ma(a);
      {
        if (Th.current = a, ts(!0), me = hf(i, a, J, b, pe, S), Se = mf(), a.mode & Bn) {
          no(!0);
          try {
            me = hf(i, a, J, b, pe, S), Se = mf();
          } finally {
            no(!1);
          }
        }
        ts(!1);
      }
      return Ga(), i !== null && !qs ? (OT(i, a, S), gl(i, a, S)) : (Ho() && Se && tx(a), a.flags |= la, Ri(i, a, me, S), a.child);
    }
    function h1(i, a, f, b, S) {
      if (i === null) {
        var O = f.type;
        if (Z_(O) && f.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
        f.defaultProps === void 0) {
          var J = O;
          return J = Cf(O), a.tag = de, a.type = J, C0(a, O), m1(i, a, J, b, S);
        }
        {
          var pe = O.propTypes;
          pe && Vs(
            pe,
            b,
            // Resolved props
            "prop",
            _n(O)
          );
        }
        var me = sb(f.type, null, b, a, a.mode, S);
        return me.ref = a.ref, me.return = a, a.child = me, me;
      }
      {
        var Se = f.type, _e = Se.propTypes;
        _e && Vs(
          _e,
          b,
          // Resolved props
          "prop",
          _n(Se)
        );
      }
      var ze = i.child, Le = k0(i, S);
      if (!Le) {
        var qe = ze.memoizedProps, Ke = f.compare;
        if (Ke = Ke !== null ? Ke : Fr, Ke(qe, b) && i.ref === a.ref)
          return gl(i, a, S);
      }
      a.flags |= la;
      var rt = kc(ze, b);
      return rt.ref = a.ref, rt.return = a, a.child = rt, rt;
    }
    function m1(i, a, f, b, S) {
      if (a.type !== a.elementType) {
        var O = a.elementType;
        if (O.$$typeof === Dr) {
          var J = O, pe = J._payload, me = J._init;
          try {
            O = me(pe);
          } catch {
            O = null;
          }
          var Se = O && O.propTypes;
          Se && Vs(
            Se,
            b,
            // Resolved (SimpleMemoComponent has no defaultProps)
            "prop",
            _n(O)
          );
        }
      }
      if (i !== null) {
        var _e = i.memoizedProps;
        if (Fr(_e, b) && i.ref === a.ref && // Prevent bailout if the implementation changed due to hot reload.
        a.type === i.type)
          if (qs = !1, a.pendingProps = b = _e, k0(i, S))
            (i.flags & Wu) !== Lr && (qs = !0);
          else
            return a.lanes = i.lanes, gl(i, a, S);
      }
      return T0(i, a, f, b, S);
    }
    function v1(i, a, f) {
      var b = a.pendingProps, S = b.children, O = i !== null ? i.memoizedState : null;
      if (b.mode === "hidden" || ye)
        if ((a.mode & nn) === Vr) {
          var J = {
            baseLanes: mt,
            cachePool: null,
            transitions: null
          };
          a.memoizedState = J, jy(a, f);
        } else if (ui(f, li)) {
          var ze = {
            baseLanes: mt,
            cachePool: null,
            transitions: null
          };
          a.memoizedState = ze;
          var Le = O !== null ? O.baseLanes : f;
          jy(a, Le);
        } else {
          var pe = null, me;
          if (O !== null) {
            var Se = O.baseLanes;
            me = rn(Se, f);
          } else
            me = f;
          a.lanes = a.childLanes = li;
          var _e = {
            baseLanes: me,
            cachePool: pe,
            transitions: null
          };
          return a.memoizedState = _e, a.updateQueue = null, jy(a, me), null;
        }
      else {
        var qe;
        O !== null ? (qe = rn(O.baseLanes, f), a.memoizedState = null) : qe = f, jy(a, qe);
      }
      return Ri(i, a, S, f), a.child;
    }
    function KP(i, a, f) {
      var b = a.pendingProps;
      return Ri(i, a, b, f), a.child;
    }
    function XP(i, a, f) {
      var b = a.pendingProps.children;
      return Ri(i, a, b, f), a.child;
    }
    function QP(i, a, f) {
      {
        a.flags |= tn;
        {
          var b = a.stateNode;
          b.effectDuration = 0, b.passiveEffectDuration = 0;
        }
      }
      var S = a.pendingProps, O = S.children;
      return Ri(i, a, O, f), a.child;
    }
    function y1(i, a) {
      var f = a.ref;
      (i === null && f !== null || i !== null && i.ref !== f) && (a.flags |= ri, a.flags |= op);
    }
    function T0(i, a, f, b, S) {
      if (a.type !== a.elementType) {
        var O = f.propTypes;
        O && Vs(
          O,
          b,
          // Resolved props
          "prop",
          _n(f)
        );
      }
      var J;
      {
        var pe = ef(a, f, !0);
        J = tf(a, pe);
      }
      var me, Se;
      af(a, S), ma(a);
      {
        if (Th.current = a, ts(!0), me = hf(i, a, f, b, J, S), Se = mf(), a.mode & Bn) {
          no(!0);
          try {
            me = hf(i, a, f, b, J, S), Se = mf();
          } finally {
            no(!1);
          }
        }
        ts(!1);
      }
      return Ga(), i !== null && !qs ? (OT(i, a, S), gl(i, a, S)) : (Ho() && Se && tx(a), a.flags |= la, Ri(i, a, me, S), a.child);
    }
    function g1(i, a, f, b, S) {
      {
        switch (hw(a)) {
          case !1: {
            var O = a.stateNode, J = a.type, pe = new J(a.memoizedProps, O.context), me = pe.state;
            O.updater.enqueueSetState(O, me, null);
            break;
          }
          case !0: {
            a.flags |= Kr, a.flags |= po;
            var Se = new Error("Simulated error coming from DevTools"), _e = oo(S);
            a.lanes = rn(a.lanes, _e);
            var ze = m0(a, Cc(Se, a), _e);
            yx(a, ze);
            break;
          }
        }
        if (a.type !== a.elementType) {
          var Le = f.propTypes;
          Le && Vs(
            Le,
            b,
            // Resolved props
            "prop",
            _n(f)
          );
        }
      }
      var qe;
      Ra(f) ? (qe = !0, $v(a)) : qe = !1, af(a, S);
      var Ke = a.stateNode, rt;
      Ke === null ? (Ty(i, a), PT(a, f, b), kx(a, f, b, S), rt = !0) : i === null ? rt = CP(a, f, b, S) : rt = SP(i, a, f, b, S);
      var xr = E0(i, a, f, rt, qe, S);
      {
        var zr = a.stateNode;
        rt && zr.props !== b && (Sc || c("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", en(a) || "a component"), Sc = !0);
      }
      return xr;
    }
    function E0(i, a, f, b, S, O) {
      y1(i, a);
      var J = (a.flags & Kr) !== Lr;
      if (!b && !J)
        return S && Jb(a, f, !1), gl(i, a, O);
      var pe = a.stateNode;
      Th.current = a;
      var me;
      if (J && typeof f.getDerivedStateFromError != "function")
        me = null, l1();
      else {
        ma(a);
        {
          if (ts(!0), me = pe.render(), a.mode & Bn) {
            no(!0);
            try {
              pe.render();
            } finally {
              no(!1);
            }
          }
          ts(!1);
        }
        Ga();
      }
      return a.flags |= la, i !== null && J ? qP(i, a, me, O) : Ri(i, a, me, O), a.memoizedState = pe.state, S && Jb(a, f, !0), a.child;
    }
    function x1(i) {
      var a = i.stateNode;
      a.pendingContext ? Xb(i, a.pendingContext, a.pendingContext !== a.context) : a.context && Xb(i, a.context, !1), Ox(i, a.containerInfo);
    }
    function JP(i, a, f) {
      if (x1(a), i === null)
        throw new Error("Should have a current fiber. This is a bug in React.");
      var b = a.pendingProps, S = a.memoizedState, O = S.element;
      yT(i, a), Gv(a, b, null, f);
      var J = a.memoizedState;
      a.stateNode;
      var pe = J.element;
      if (S.isDehydrated) {
        var me = {
          element: pe,
          isDehydrated: !1,
          cache: J.cache,
          pendingSuspenseBoundaries: J.pendingSuspenseBoundaries,
          transitions: J.transitions
        }, Se = a.updateQueue;
        if (Se.baseState = me, a.memoizedState = me, a.flags & Un) {
          var _e = Cc(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), a);
          return b1(i, a, pe, f, _e);
        } else if (pe !== O) {
          var ze = Cc(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), a);
          return b1(i, a, pe, f, ze);
        } else {
          rP(a);
          var Le = AT(a, null, pe, f);
          a.child = Le;
          for (var qe = Le; qe; )
            qe.flags = qe.flags & ~$n | Fi, qe = qe.sibling;
        }
      } else {
        if (of(), pe === O)
          return gl(i, a, f);
        Ri(i, a, pe, f);
      }
      return a.child;
    }
    function b1(i, a, f, b, S) {
      return of(), ax(S), a.flags |= Un, Ri(i, a, f, b), a.child;
    }
    function ZP(i, a, f) {
      jT(a), i === null && sx(a);
      var b = a.type, S = a.pendingProps, O = i !== null ? i.memoizedProps : null, J = S.children, pe = zg(b, S);
      return pe ? J = null : O !== null && zg(b, O) && (a.flags |= Tn), y1(i, a), Ri(i, a, J, f), a.child;
    }
    function eR(i, a) {
      return i === null && sx(a), null;
    }
    function tR(i, a, f, b) {
      Ty(i, a);
      var S = a.pendingProps, O = f, J = O._payload, pe = O._init, me = pe(J);
      a.type = me;
      var Se = a.tag = ew(me), _e = Ws(me, S), ze;
      switch (Se) {
        case m:
          return C0(a, me), a.type = me = Cf(me), ze = T0(null, a, me, _e, b), ze;
        case C:
          return a.type = me = Z0(me), ze = g1(null, a, me, _e, b), ze;
        case N:
          return a.type = me = eb(me), ze = p1(null, a, me, _e, b), ze;
        case ue: {
          if (a.type !== a.elementType) {
            var Le = me.propTypes;
            Le && Vs(
              Le,
              _e,
              // Resolved for outer only
              "prop",
              _n(me)
            );
          }
          return ze = h1(
            null,
            a,
            me,
            Ws(me.type, _e),
            // The inner type can have defaults too
            b
          ), ze;
        }
      }
      var qe = "";
      throw me !== null && typeof me == "object" && me.$$typeof === Dr && (qe = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + me + ". " + ("Lazy element type must resolve to a class or function." + qe));
    }
    function rR(i, a, f, b, S) {
      Ty(i, a), a.tag = C;
      var O;
      return Ra(f) ? (O = !0, $v(a)) : O = !1, af(a, S), PT(a, f, b), kx(a, f, b, S), E0(null, a, f, !0, O, S);
    }
    function nR(i, a, f, b) {
      Ty(i, a);
      var S = a.pendingProps, O;
      {
        var J = ef(a, f, !1);
        O = tf(a, J);
      }
      af(a, b);
      var pe, me;
      ma(a);
      {
        if (f.prototype && typeof f.prototype.render == "function") {
          var Se = _n(f) || "Unknown";
          v0[Se] || (c("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", Se, Se), v0[Se] = !0);
        }
        a.mode & Bn && Hs.recordLegacyContextWarning(a, null), ts(!0), Th.current = a, pe = hf(null, a, f, S, O, b), me = mf(), ts(!1);
      }
      if (Ga(), a.flags |= la, typeof pe == "object" && pe !== null && typeof pe.render == "function" && pe.$$typeof === void 0) {
        var _e = _n(f) || "Unknown";
        Eh[_e] || (c("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _e, _e, _e), Eh[_e] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof pe == "object" && pe !== null && typeof pe.render == "function" && pe.$$typeof === void 0
      ) {
        {
          var ze = _n(f) || "Unknown";
          Eh[ze] || (c("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", ze, ze, ze), Eh[ze] = !0);
        }
        a.tag = C, a.memoizedState = null, a.updateQueue = null;
        var Le = !1;
        return Ra(f) ? (Le = !0, $v(a)) : Le = !1, a.memoizedState = pe.state !== null && pe.state !== void 0 ? pe.state : null, vx(a), ST(a, pe), kx(a, f, S, b), E0(null, a, f, !0, Le, b);
      } else {
        if (a.tag = m, a.mode & Bn) {
          no(!0);
          try {
            pe = hf(null, a, f, S, O, b), me = mf();
          } finally {
            no(!1);
          }
        }
        return Ho() && me && tx(a), Ri(null, a, pe, b), C0(a, f), a.child;
      }
    }
    function C0(i, a) {
      {
        if (a && a.childContextTypes && c("%s(...): childContextTypes cannot be defined on a function component.", a.displayName || a.name || "Component"), i.ref !== null) {
          var f = "", b = Ni();
          b && (f += `

Check the render method of \`` + b + "`.");
          var S = b || "", O = i._debugSource;
          O && (S = O.fileName + ":" + O.lineNumber), x0[S] || (x0[S] = !0, c("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", f));
        }
        if (typeof a.getDerivedStateFromProps == "function") {
          var J = _n(a) || "Unknown";
          g0[J] || (c("%s: Function components do not support getDerivedStateFromProps.", J), g0[J] = !0);
        }
        if (typeof a.contextType == "object" && a.contextType !== null) {
          var pe = _n(a) || "Unknown";
          y0[pe] || (c("%s: Function components do not support contextType.", pe), y0[pe] = !0);
        }
      }
    }
    var S0 = {
      dehydrated: null,
      treeContext: null,
      retryLane: un
    };
    function P0(i) {
      return {
        baseLanes: i,
        cachePool: YP(),
        transitions: null
      };
    }
    function oR(i, a) {
      var f = null;
      return {
        baseLanes: rn(i.baseLanes, a),
        cachePool: f,
        transitions: i.transitions
      };
    }
    function iR(i, a, f, b) {
      if (a !== null) {
        var S = a.memoizedState;
        if (S === null)
          return !1;
      }
      return Fx(i, ph);
    }
    function sR(i, a) {
      return Hl(i.childLanes, a);
    }
    function T1(i, a, f) {
      var b = a.pendingProps;
      mw(a) && (a.flags |= Kr);
      var S = Gs.current, O = !1, J = (a.flags & Kr) !== Lr;
      if (J || iR(S, i) ? (O = !0, a.flags &= ~Kr) : (i === null || i.memoizedState !== null) && (S = wP(S, NT)), S = cf(S), pu(a, S), i === null) {
        sx(a);
        var pe = a.memoizedState;
        if (pe !== null) {
          var me = pe.dehydrated;
          if (me !== null)
            return dR(a, me);
        }
        var Se = b.children, _e = b.fallback;
        if (O) {
          var ze = aR(a, Se, _e, f), Le = a.child;
          return Le.memoizedState = P0(f), a.memoizedState = S0, ze;
        } else
          return R0(a, Se);
      } else {
        var qe = i.memoizedState;
        if (qe !== null) {
          var Ke = qe.dehydrated;
          if (Ke !== null)
            return fR(i, a, J, b, Ke, qe, f);
        }
        if (O) {
          var rt = b.fallback, xr = b.children, zr = uR(i, a, xr, rt, f), Or = a.child, dn = i.child.memoizedState;
          return Or.memoizedState = dn === null ? P0(f) : oR(dn, f), Or.childLanes = sR(i, f), a.memoizedState = S0, zr;
        } else {
          var ln = b.children, He = lR(i, a, ln, f);
          return a.memoizedState = null, He;
        }
      }
    }
    function R0(i, a, f) {
      var b = i.mode, S = {
        mode: "visible",
        children: a
      }, O = _0(S, b);
      return O.return = i, i.child = O, O;
    }
    function aR(i, a, f, b) {
      var S = i.mode, O = i.child, J = {
        mode: "hidden",
        children: a
      }, pe, me;
      return (S & nn) === Vr && O !== null ? (pe = O, pe.childLanes = mt, pe.pendingProps = J, i.mode & Ur && (pe.actualDuration = 0, pe.actualStartTime = -1, pe.selfBaseDuration = 0, pe.treeBaseDuration = 0), me = Tu(f, S, b, null)) : (pe = _0(J, S), me = Tu(f, S, b, null)), pe.return = i, me.return = i, pe.sibling = me, i.child = pe, me;
    }
    function _0(i, a, f) {
      return EE(i, a, mt, null);
    }
    function E1(i, a) {
      return kc(i, a);
    }
    function lR(i, a, f, b) {
      var S = i.child, O = S.sibling, J = E1(S, {
        mode: "visible",
        children: f
      });
      if ((a.mode & nn) === Vr && (J.lanes = b), J.return = a, J.sibling = null, O !== null) {
        var pe = a.deletions;
        pe === null ? (a.deletions = [O], a.flags |= bn) : pe.push(O);
      }
      return a.child = J, J;
    }
    function uR(i, a, f, b, S) {
      var O = a.mode, J = i.child, pe = J.sibling, me = {
        mode: "hidden",
        children: f
      }, Se;
      if (
        // In legacy mode, we commit the primary tree as if it successfully
        // completed, even though it's in an inconsistent state.
        (O & nn) === Vr && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        a.child !== J
      ) {
        var _e = a.child;
        Se = _e, Se.childLanes = mt, Se.pendingProps = me, a.mode & Ur && (Se.actualDuration = 0, Se.actualStartTime = -1, Se.selfBaseDuration = J.selfBaseDuration, Se.treeBaseDuration = J.treeBaseDuration), a.deletions = null;
      } else
        Se = E1(J, me), Se.subtreeFlags = J.subtreeFlags & xo;
      var ze;
      return pe !== null ? ze = kc(pe, b) : (ze = Tu(b, O, S, null), ze.flags |= $n), ze.return = a, Se.return = a, Se.sibling = ze, a.child = Se, ze;
    }
    function by(i, a, f, b) {
      b !== null && ax(b), lf(a, i.child, null, f);
      var S = a.pendingProps, O = S.children, J = R0(a, O);
      return J.flags |= $n, a.memoizedState = null, J;
    }
    function cR(i, a, f, b, S) {
      var O = a.mode, J = {
        mode: "visible",
        children: f
      }, pe = _0(J, O), me = Tu(b, O, S, null);
      return me.flags |= $n, pe.return = a, me.return = a, pe.sibling = me, a.child = pe, (a.mode & nn) !== Vr && lf(a, i.child, null, S), me;
    }
    function dR(i, a, f) {
      return (i.mode & nn) === Vr ? (c("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), i.lanes = Wr) : Wg(a) ? i.lanes = Ka : i.lanes = li, null;
    }
    function fR(i, a, f, b, S, O, J) {
      if (f)
        if (a.flags & Un) {
          a.flags &= ~Un;
          var He = p0(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
          return by(i, a, J, He);
        } else {
          if (a.memoizedState !== null)
            return a.child = i.child, a.flags |= Kr, null;
          var ct = b.children, We = b.fallback, sr = cR(i, a, ct, We, J), br = a.child;
          return br.memoizedState = P0(J), a.memoizedState = S0, sr;
        }
      else {
        if (eP(), (a.mode & nn) === Vr)
          return by(
            i,
            a,
            J,
            // TODO: When we delete legacy mode, we should make this error argument
            // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null
          );
        if (Wg(S)) {
          var pe, me, Se;
          {
            var _e = vS(S);
            pe = _e.digest, me = _e.message, Se = _e.stack;
          }
          var ze;
          me ? ze = new Error(me) : ze = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
          var Le = p0(ze, pe, Se);
          return by(i, a, J, Le);
        }
        var qe = ui(J, i.childLanes);
        if (qs || qe) {
          var Ke = $y();
          if (Ke !== null) {
            var rt = fg(Ke, J);
            if (rt !== un && rt !== O.retryLane) {
              O.retryLane = rt;
              var xr = kn;
              qi(i, rt), ko(Ke, i, rt, xr);
            }
          }
          q0();
          var zr = p0(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
          return by(i, a, J, zr);
        } else if (Hb(S)) {
          a.flags |= Kr, a.child = i.child;
          var Or = I_.bind(null, i);
          return yS(S, Or), null;
        } else {
          nP(a, S, O.treeContext);
          var dn = b.children, ln = R0(a, dn);
          return ln.flags |= Fi, ln;
        }
      }
    }
    function C1(i, a, f) {
      i.lanes = rn(i.lanes, a);
      var b = i.alternate;
      b !== null && (b.lanes = rn(b.lanes, a)), fx(i.return, a, f);
    }
    function pR(i, a, f) {
      for (var b = a; b !== null; ) {
        if (b.tag === K) {
          var S = b.memoizedState;
          S !== null && C1(b, f, i);
        } else if (b.tag === Ce)
          C1(b, f, i);
        else if (b.child !== null) {
          b.child.return = b, b = b.child;
          continue;
        }
        if (b === i)
          return;
        for (; b.sibling === null; ) {
          if (b.return === null || b.return === i)
            return;
          b = b.return;
        }
        b.sibling.return = b.return, b = b.sibling;
      }
    }
    function hR(i) {
      for (var a = i, f = null; a !== null; ) {
        var b = a.alternate;
        b !== null && Zv(b) === null && (f = a), a = a.sibling;
      }
      return f;
    }
    function mR(i) {
      if (i !== void 0 && i !== "forwards" && i !== "backwards" && i !== "together" && !b0[i])
        if (b0[i] = !0, typeof i == "string")
          switch (i.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards": {
              c('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', i, i.toLowerCase());
              break;
            }
            case "forward":
            case "backward": {
              c('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', i, i.toLowerCase());
              break;
            }
            default:
              c('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', i);
              break;
          }
        else
          c('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', i);
    }
    function vR(i, a) {
      i !== void 0 && !xy[i] && (i !== "collapsed" && i !== "hidden" ? (xy[i] = !0, c('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', i)) : a !== "forwards" && a !== "backwards" && (xy[i] = !0, c('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', i)));
    }
    function S1(i, a) {
      {
        var f = co(i), b = !f && typeof Ps(i) == "function";
        if (f || b) {
          var S = f ? "array" : "iterable";
          return c("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", S, a, S), !1;
        }
      }
      return !0;
    }
    function yR(i, a) {
      if ((a === "forwards" || a === "backwards") && i !== void 0 && i !== null && i !== !1)
        if (co(i)) {
          for (var f = 0; f < i.length; f++)
            if (!S1(i[f], f))
              return;
        } else {
          var b = Ps(i);
          if (typeof b == "function") {
            var S = b.call(i);
            if (S)
              for (var O = S.next(), J = 0; !O.done; O = S.next()) {
                if (!S1(O.value, J))
                  return;
                J++;
              }
          } else
            c('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', a);
        }
    }
    function w0(i, a, f, b, S) {
      var O = i.memoizedState;
      O === null ? i.memoizedState = {
        isBackwards: a,
        rendering: null,
        renderingStartTime: 0,
        last: b,
        tail: f,
        tailMode: S
      } : (O.isBackwards = a, O.rendering = null, O.renderingStartTime = 0, O.last = b, O.tail = f, O.tailMode = S);
    }
    function P1(i, a, f) {
      var b = a.pendingProps, S = b.revealOrder, O = b.tail, J = b.children;
      mR(S), vR(O, S), yR(J, S), Ri(i, a, J, f);
      var pe = Gs.current, me = Fx(pe, ph);
      if (me)
        pe = Lx(pe, ph), a.flags |= Kr;
      else {
        var Se = i !== null && (i.flags & Kr) !== Lr;
        Se && pR(a, a.child, f), pe = cf(pe);
      }
      if (pu(a, pe), (a.mode & nn) === Vr)
        a.memoizedState = null;
      else
        switch (S) {
          case "forwards": {
            var _e = hR(a.child), ze;
            _e === null ? (ze = a.child, a.child = null) : (ze = _e.sibling, _e.sibling = null), w0(
              a,
              !1,
              // isBackwards
              ze,
              _e,
              O
            );
            break;
          }
          case "backwards": {
            var Le = null, qe = a.child;
            for (a.child = null; qe !== null; ) {
              var Ke = qe.alternate;
              if (Ke !== null && Zv(Ke) === null) {
                a.child = qe;
                break;
              }
              var rt = qe.sibling;
              qe.sibling = Le, Le = qe, qe = rt;
            }
            w0(
              a,
              !0,
              // isBackwards
              Le,
              null,
              // last
              O
            );
            break;
          }
          case "together": {
            w0(
              a,
              !1,
              // isBackwards
              null,
              // tail
              null,
              // last
              void 0
            );
            break;
          }
          default:
            a.memoizedState = null;
        }
      return a.child;
    }
    function gR(i, a, f) {
      Ox(a, a.stateNode.containerInfo);
      var b = a.pendingProps;
      return i === null ? a.child = lf(a, null, b, f) : Ri(i, a, b, f), a.child;
    }
    var R1 = !1;
    function xR(i, a, f) {
      var b = a.type, S = b._context, O = a.pendingProps, J = a.memoizedProps, pe = O.value;
      {
        "value" in O || R1 || (R1 = !0, c("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        var me = a.type.propTypes;
        me && Vs(me, O, "prop", "Context.Provider");
      }
      if (pT(a, S, pe), J !== null) {
        var Se = J.value;
        if (Rr(Se, pe)) {
          if (J.children === O.children && !kv())
            return gl(i, a, f);
        } else
          pP(a, S, f);
      }
      var _e = O.children;
      return Ri(i, a, _e, f), a.child;
    }
    var _1 = !1;
    function bR(i, a, f) {
      var b = a.type;
      b._context === void 0 ? b !== b.Consumer && (_1 || (_1 = !0, c("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : b = b._context;
      var S = a.pendingProps, O = S.children;
      typeof O != "function" && c("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), af(a, f);
      var J = go(b);
      ma(a);
      var pe;
      return Th.current = a, ts(!0), pe = O(J), ts(!1), Ga(), a.flags |= la, Ri(i, a, pe, f), a.child;
    }
    function Ch() {
      qs = !0;
    }
    function Ty(i, a) {
      (a.mode & nn) === Vr && i !== null && (i.alternate = null, a.alternate = null, a.flags |= $n);
    }
    function gl(i, a, f) {
      return i !== null && (a.dependencies = i.dependencies), l1(), Oh(a.lanes), ui(f, a.childLanes) ? (PP(i, a), a.child) : null;
    }
    function TR(i, a, f) {
      {
        var b = a.return;
        if (b === null)
          throw new Error("Cannot swap the root fiber.");
        if (i.alternate = null, a.alternate = null, f.index = a.index, f.sibling = a.sibling, f.return = a.return, f.ref = a.ref, a === b.child)
          b.child = f;
        else {
          var S = b.child;
          if (S === null)
            throw new Error("Expected parent to have a child.");
          for (; S.sibling !== a; )
            if (S = S.sibling, S === null)
              throw new Error("Expected to find the previous sibling.");
          S.sibling = f;
        }
        var O = b.deletions;
        return O === null ? (b.deletions = [i], b.flags |= bn) : O.push(i), f.flags |= $n, f;
      }
    }
    function k0(i, a) {
      var f = i.lanes;
      return !!ui(f, a);
    }
    function ER(i, a, f) {
      switch (a.tag) {
        case w:
          x1(a), a.stateNode, of();
          break;
        case L:
          jT(a);
          break;
        case C: {
          var b = a.type;
          Ra(b) && $v(a);
          break;
        }
        case R:
          Ox(a, a.stateNode.containerInfo);
          break;
        case V: {
          var S = a.memoizedProps.value, O = a.type._context;
          pT(a, O, S);
          break;
        }
        case B:
          {
            var J = ui(f, a.childLanes);
            J && (a.flags |= tn);
            {
              var pe = a.stateNode;
              pe.effectDuration = 0, pe.passiveEffectDuration = 0;
            }
          }
          break;
        case K: {
          var me = a.memoizedState;
          if (me !== null) {
            if (me.dehydrated !== null)
              return pu(a, cf(Gs.current)), a.flags |= Kr, null;
            var Se = a.child, _e = Se.childLanes;
            if (ui(f, _e))
              return T1(i, a, f);
            pu(a, cf(Gs.current));
            var ze = gl(i, a, f);
            return ze !== null ? ze.sibling : null;
          } else
            pu(a, cf(Gs.current));
          break;
        }
        case Ce: {
          var Le = (i.flags & Kr) !== Lr, qe = ui(f, a.childLanes);
          if (Le) {
            if (qe)
              return P1(i, a, f);
            a.flags |= Kr;
          }
          var Ke = a.memoizedState;
          if (Ke !== null && (Ke.rendering = null, Ke.tail = null, Ke.lastEffect = null), pu(a, Gs.current), qe)
            break;
          return null;
        }
        case ke:
        case Ae:
          return a.lanes = mt, v1(i, a, f);
      }
      return gl(i, a, f);
    }
    function w1(i, a, f) {
      if (a._debugNeedsRemount && i !== null)
        return TR(i, a, sb(a.type, a.key, a.pendingProps, a._debugOwner || null, a.mode, a.lanes));
      if (i !== null) {
        var b = i.memoizedProps, S = a.pendingProps;
        if (b !== S || kv() || // Force a re-render if the implementation changed due to hot reload:
        a.type !== i.type)
          qs = !0;
        else {
          var O = k0(i, f);
          if (!O && // If this is the second pass of an error or suspense boundary, there
          // may not be work scheduled on `current`, so we check for this flag.
          (a.flags & Kr) === Lr)
            return qs = !1, ER(i, a, f);
          (i.flags & Wu) !== Lr ? qs = !0 : qs = !1;
        }
      } else if (qs = !1, Ho() && qS(a)) {
        var J = a.index, pe = KS();
        tT(a, pe, J);
      }
      switch (a.lanes = mt, a.tag) {
        case P:
          return nR(i, a, a.type, f);
        case ve: {
          var me = a.elementType;
          return tR(i, a, me, f);
        }
        case m: {
          var Se = a.type, _e = a.pendingProps, ze = a.elementType === Se ? _e : Ws(Se, _e);
          return T0(i, a, Se, ze, f);
        }
        case C: {
          var Le = a.type, qe = a.pendingProps, Ke = a.elementType === Le ? qe : Ws(Le, qe);
          return g1(i, a, Le, Ke, f);
        }
        case w:
          return JP(i, a, f);
        case L:
          return ZP(i, a, f);
        case M:
          return eR(i, a);
        case K:
          return T1(i, a, f);
        case R:
          return gR(i, a, f);
        case N: {
          var rt = a.type, xr = a.pendingProps, zr = a.elementType === rt ? xr : Ws(rt, xr);
          return p1(i, a, rt, zr, f);
        }
        case $:
          return KP(i, a, f);
        case W:
          return XP(i, a, f);
        case B:
          return QP(i, a, f);
        case V:
          return xR(i, a, f);
        case H:
          return bR(i, a, f);
        case ue: {
          var Or = a.type, dn = a.pendingProps, ln = Ws(Or, dn);
          if (a.type !== a.elementType) {
            var He = Or.propTypes;
            He && Vs(
              He,
              ln,
              // Resolved for outer only
              "prop",
              _n(Or)
            );
          }
          return ln = Ws(Or.type, ln), h1(i, a, Or, ln, f);
        }
        case de:
          return m1(i, a, a.type, a.pendingProps, f);
        case Te: {
          var ct = a.type, We = a.pendingProps, sr = a.elementType === ct ? We : Ws(ct, We);
          return rR(i, a, ct, sr, f);
        }
        case Ce:
          return P1(i, a, f);
        case Re:
          break;
        case ke:
          return v1(i, a, f);
      }
      throw new Error("Unknown unit of work tag (" + a.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function vf(i) {
      i.flags |= tn;
    }
    function k1(i) {
      i.flags |= ri, i.flags |= op;
    }
    var A1, A0, $1, j1;
    A1 = function(i, a, f, b) {
      for (var S = a.child; S !== null; ) {
        if (S.tag === L || S.tag === M)
          HC(i, S.stateNode);
        else if (S.tag !== R) {
          if (S.child !== null) {
            S.child.return = S, S = S.child;
            continue;
          }
        }
        if (S === a)
          return;
        for (; S.sibling === null; ) {
          if (S.return === null || S.return === a)
            return;
          S = S.return;
        }
        S.sibling.return = S.return, S = S.sibling;
      }
    }, A0 = function(i, a) {
    }, $1 = function(i, a, f, b, S) {
      var O = i.memoizedProps;
      if (O !== b) {
        var J = a.stateNode, pe = Dx(), me = GC(J, f, O, b, S, pe);
        a.updateQueue = me, me && vf(a);
      }
    }, j1 = function(i, a, f, b) {
      f !== b && vf(a);
    };
    function Sh(i, a) {
      if (!Ho())
        switch (i.tailMode) {
          case "hidden": {
            for (var f = i.tail, b = null; f !== null; )
              f.alternate !== null && (b = f), f = f.sibling;
            b === null ? i.tail = null : b.sibling = null;
            break;
          }
          case "collapsed": {
            for (var S = i.tail, O = null; S !== null; )
              S.alternate !== null && (O = S), S = S.sibling;
            O === null ? !a && i.tail !== null ? i.tail.sibling = null : i.tail = null : O.sibling = null;
            break;
          }
        }
    }
    function Go(i) {
      var a = i.alternate !== null && i.alternate.child === i.child, f = mt, b = Lr;
      if (a) {
        if ((i.mode & Ur) !== Vr) {
          for (var me = i.selfBaseDuration, Se = i.child; Se !== null; )
            f = rn(f, rn(Se.lanes, Se.childLanes)), b |= Se.subtreeFlags & xo, b |= Se.flags & xo, me += Se.treeBaseDuration, Se = Se.sibling;
          i.treeBaseDuration = me;
        } else
          for (var _e = i.child; _e !== null; )
            f = rn(f, rn(_e.lanes, _e.childLanes)), b |= _e.subtreeFlags & xo, b |= _e.flags & xo, _e.return = i, _e = _e.sibling;
        i.subtreeFlags |= b;
      } else {
        if ((i.mode & Ur) !== Vr) {
          for (var S = i.actualDuration, O = i.selfBaseDuration, J = i.child; J !== null; )
            f = rn(f, rn(J.lanes, J.childLanes)), b |= J.subtreeFlags, b |= J.flags, S += J.actualDuration, O += J.treeBaseDuration, J = J.sibling;
          i.actualDuration = S, i.treeBaseDuration = O;
        } else
          for (var pe = i.child; pe !== null; )
            f = rn(f, rn(pe.lanes, pe.childLanes)), b |= pe.subtreeFlags, b |= pe.flags, pe.return = i, pe = pe.sibling;
        i.subtreeFlags |= b;
      }
      return i.childLanes = f, a;
    }
    function CR(i, a, f) {
      if (lP() && (a.mode & nn) !== Vr && (a.flags & Kr) === Lr)
        return lT(a), of(), a.flags |= Un | bi | po, !1;
      var b = Dv(a);
      if (f !== null && f.dehydrated !== null)
        if (i === null) {
          if (!b)
            throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
          if (sP(a), Go(a), (a.mode & Ur) !== Vr) {
            var S = f !== null;
            if (S) {
              var O = a.child;
              O !== null && (a.treeBaseDuration -= O.treeBaseDuration);
            }
          }
          return !1;
        } else {
          if (of(), (a.flags & Kr) === Lr && (a.memoizedState = null), a.flags |= tn, Go(a), (a.mode & Ur) !== Vr) {
            var J = f !== null;
            if (J) {
              var pe = a.child;
              pe !== null && (a.treeBaseDuration -= pe.treeBaseDuration);
            }
          }
          return !1;
        }
      else
        return uT(), !0;
    }
    function M1(i, a, f) {
      var b = a.pendingProps;
      switch (rx(a), a.tag) {
        case P:
        case ve:
        case de:
        case m:
        case N:
        case $:
        case W:
        case B:
        case H:
        case ue:
          return Go(a), null;
        case C: {
          var S = a.type;
          return Ra(S) && Av(a), Go(a), null;
        }
        case w: {
          var O = a.stateNode;
          if (uf(a), Jg(a), zx(), O.pendingContext && (O.context = O.pendingContext, O.pendingContext = null), i === null || i.child === null) {
            var J = Dv(a);
            if (J)
              vf(a);
            else if (i !== null) {
              var pe = i.memoizedState;
              // Check if this is a client root
              (!pe.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
              (a.flags & Un) !== Lr) && (a.flags |= Ii, uT());
            }
          }
          return A0(i, a), Go(a), null;
        }
        case L: {
          Ix(a);
          var me = $T(), Se = a.type;
          if (i !== null && a.stateNode != null)
            $1(i, a, Se, b, me), i.ref !== a.ref && k1(a);
          else {
            if (!b) {
              if (a.stateNode === null)
                throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              return Go(a), null;
            }
            var _e = Dx(), ze = Dv(a);
            if (ze)
              oP(a, me, _e) && vf(a);
            else {
              var Le = UC(Se, b, me, _e, a);
              A1(Le, a, !1, !1), a.stateNode = Le, WC(Le, Se, b, me) && vf(a);
            }
            a.ref !== null && k1(a);
          }
          return Go(a), null;
        }
        case M: {
          var qe = b;
          if (i && a.stateNode != null) {
            var Ke = i.memoizedProps;
            j1(i, a, Ke, qe);
          } else {
            if (typeof qe != "string" && a.stateNode === null)
              throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
            var rt = $T(), xr = Dx(), zr = Dv(a);
            zr ? iP(a) && vf(a) : a.stateNode = YC(qe, rt, xr, a);
          }
          return Go(a), null;
        }
        case K: {
          df(a);
          var Or = a.memoizedState;
          if (i === null || i.memoizedState !== null && i.memoizedState.dehydrated !== null) {
            var dn = CR(i, a, Or);
            if (!dn)
              return a.flags & po ? a : null;
          }
          if ((a.flags & Kr) !== Lr)
            return a.lanes = f, (a.mode & Ur) !== Vr && f0(a), a;
          var ln = Or !== null, He = i !== null && i.memoizedState !== null;
          if (ln !== He && ln) {
            var ct = a.child;
            if (ct.flags |= ua, (a.mode & nn) !== Vr) {
              var We = i === null && (a.memoizedProps.unstable_avoidThisFallback !== !0 || !Ee);
              We || Fx(Gs.current, NT) ? S_() : q0();
            }
          }
          var sr = a.updateQueue;
          if (sr !== null && (a.flags |= tn), Go(a), (a.mode & Ur) !== Vr && ln) {
            var br = a.child;
            br !== null && (a.treeBaseDuration -= br.treeBaseDuration);
          }
          return null;
        }
        case R:
          return uf(a), A0(i, a), i === null && zS(a.stateNode.containerInfo), Go(a), null;
        case V:
          var vr = a.type._context;
          return dx(vr, a), Go(a), null;
        case Te: {
          var qr = a.type;
          return Ra(qr) && Av(a), Go(a), null;
        }
        case Ce: {
          df(a);
          var Zr = a.memoizedState;
          if (Zr === null)
            return Go(a), null;
          var Rn = (a.flags & Kr) !== Lr, gn = Zr.rendering;
          if (gn === null)
            if (Rn)
              Sh(Zr, !1);
            else {
              var lo = R_() && (i === null || (i.flags & Kr) === Lr);
              if (!lo)
                for (var xn = a.child; xn !== null; ) {
                  var eo = Zv(xn);
                  if (eo !== null) {
                    Rn = !0, a.flags |= Kr, Sh(Zr, !1);
                    var pi = eo.updateQueue;
                    return pi !== null && (a.updateQueue = pi, a.flags |= tn), a.subtreeFlags = Lr, RP(a, f), pu(a, Lx(Gs.current, ph)), a.child;
                  }
                  xn = xn.sibling;
                }
              Zr.tail !== null && Ln() > eE() && (a.flags |= Kr, Rn = !0, Sh(Zr, !1), a.lanes = yp);
            }
          else {
            if (!Rn) {
              var Qo = Zv(gn);
              if (Qo !== null) {
                a.flags |= Kr, Rn = !0;
                var cs = Qo.updateQueue;
                if (cs !== null && (a.updateQueue = cs, a.flags |= tn), Sh(Zr, !0), Zr.tail === null && Zr.tailMode === "hidden" && !gn.alternate && !Ho())
                  return Go(a), null;
              } else
                // The time it took to render last row is greater than the remaining
                // time we have to render. So rendering one more row would likely
                // exceed it.
                Ln() * 2 - Zr.renderingStartTime > eE() && f !== li && (a.flags |= Kr, Rn = !0, Sh(Zr, !1), a.lanes = yp);
            }
            if (Zr.isBackwards)
              gn.sibling = a.child, a.child = gn;
            else {
              var ki = Zr.last;
              ki !== null ? ki.sibling = gn : a.child = gn, Zr.last = gn;
            }
          }
          if (Zr.tail !== null) {
            var Ai = Zr.tail;
            Zr.rendering = Ai, Zr.tail = Ai.sibling, Zr.renderingStartTime = Ln(), Ai.sibling = null;
            var hi = Gs.current;
            return Rn ? hi = Lx(hi, ph) : hi = cf(hi), pu(a, hi), Ai;
          }
          return Go(a), null;
        }
        case Re:
          break;
        case ke:
        case Ae: {
          Y0(a);
          var Cl = a.memoizedState, Sf = Cl !== null;
          if (i !== null) {
            var Bh = i.memoizedState, Na = Bh !== null;
            Na !== Sf && // LegacyHidden doesn't do any hiding — it only pre-renders.
            !ye && (a.flags |= ua);
          }
          return !Sf || (a.mode & nn) === Vr ? Go(a) : ui(Ma, li) && (Go(a), a.subtreeFlags & ($n | tn) && (a.flags |= ua)), null;
        }
        case we:
          return null;
        case he:
          return null;
      }
      throw new Error("Unknown unit of work tag (" + a.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function SR(i, a, f) {
      switch (rx(a), a.tag) {
        case C: {
          var b = a.type;
          Ra(b) && Av(a);
          var S = a.flags;
          return S & po ? (a.flags = S & ~po | Kr, (a.mode & Ur) !== Vr && f0(a), a) : null;
        }
        case w: {
          a.stateNode, uf(a), Jg(a), zx();
          var O = a.flags;
          return (O & po) !== Lr && (O & Kr) === Lr ? (a.flags = O & ~po | Kr, a) : null;
        }
        case L:
          return Ix(a), null;
        case K: {
          df(a);
          var J = a.memoizedState;
          if (J !== null && J.dehydrated !== null) {
            if (a.alternate === null)
              throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
            of();
          }
          var pe = a.flags;
          return pe & po ? (a.flags = pe & ~po | Kr, (a.mode & Ur) !== Vr && f0(a), a) : null;
        }
        case Ce:
          return df(a), null;
        case R:
          return uf(a), null;
        case V:
          var me = a.type._context;
          return dx(me, a), null;
        case ke:
        case Ae:
          return Y0(a), null;
        case we:
          return null;
        default:
          return null;
      }
    }
    function N1(i, a, f) {
      switch (rx(a), a.tag) {
        case C: {
          var b = a.type.childContextTypes;
          b != null && Av(a);
          break;
        }
        case w: {
          a.stateNode, uf(a), Jg(a), zx();
          break;
        }
        case L: {
          Ix(a);
          break;
        }
        case R:
          uf(a);
          break;
        case K:
          df(a);
          break;
        case Ce:
          df(a);
          break;
        case V:
          var S = a.type._context;
          dx(S, a);
          break;
        case ke:
        case Ae:
          Y0(a);
          break;
      }
    }
    var O1 = null;
    O1 = /* @__PURE__ */ new Set();
    var Ey = !1, Yo = !1, PR = typeof WeakSet == "function" ? WeakSet : Set, _r = null, yf = null, gf = null;
    function RR(i) {
      Ha(null, function() {
        throw i;
      }), rp();
    }
    var _R = function(i, a) {
      if (a.props = i.memoizedProps, a.state = i.memoizedState, i.mode & Ur)
        try {
          $a(), a.componentWillUnmount();
        } finally {
          Aa(i);
        }
      else
        a.componentWillUnmount();
    };
    function D1(i, a) {
      try {
        vu(Co, i);
      } catch (f) {
        On(i, a, f);
      }
    }
    function $0(i, a, f) {
      try {
        _R(i, f);
      } catch (b) {
        On(i, a, b);
      }
    }
    function wR(i, a, f) {
      try {
        f.componentDidMount();
      } catch (b) {
        On(i, a, b);
      }
    }
    function I1(i, a) {
      try {
        L1(i);
      } catch (f) {
        On(i, a, f);
      }
    }
    function xf(i, a) {
      var f = i.ref;
      if (f !== null)
        if (typeof f == "function") {
          var b;
          try {
            if (Oe && Ze && i.mode & Ur)
              try {
                $a(), b = f(null);
              } finally {
                Aa(i);
              }
            else
              b = f(null);
          } catch (S) {
            On(i, a, S);
          }
          typeof b == "function" && c("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", en(i));
        } else
          f.current = null;
    }
    function Cy(i, a, f) {
      try {
        f();
      } catch (b) {
        On(i, a, b);
      }
    }
    var F1 = !1;
    function kR(i, a) {
      zC(i.containerInfo), _r = a, AR();
      var f = F1;
      return F1 = !1, f;
    }
    function AR() {
      for (; _r !== null; ) {
        var i = _r, a = i.child;
        (i.subtreeFlags & Dl) !== Lr && a !== null ? (a.return = i, _r = a) : $R();
      }
    }
    function $R() {
      for (; _r !== null; ) {
        var i = _r;
        Sn(i);
        try {
          jR(i);
        } catch (f) {
          On(i, i.return, f);
        }
        ro();
        var a = i.sibling;
        if (a !== null) {
          a.return = i.return, _r = a;
          return;
        }
        _r = i.return;
      }
    }
    function jR(i) {
      var a = i.alternate, f = i.flags;
      if ((f & Ii) !== Lr) {
        switch (Sn(i), i.tag) {
          case m:
          case N:
          case de:
            break;
          case C: {
            if (a !== null) {
              var b = a.memoizedProps, S = a.memoizedState, O = i.stateNode;
              i.type === i.elementType && !Sc && (O.props !== i.memoizedProps && c("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", en(i) || "instance"), O.state !== i.memoizedState && c("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", en(i) || "instance"));
              var J = O.getSnapshotBeforeUpdate(i.elementType === i.type ? b : Ws(i.type, b), S);
              {
                var pe = O1;
                J === void 0 && !pe.has(i.type) && (pe.add(i.type), c("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", en(i)));
              }
              O.__reactInternalSnapshotBeforeUpdate = J;
            }
            break;
          }
          case w: {
            {
              var me = i.stateNode;
              fS(me.containerInfo);
            }
            break;
          }
          case L:
          case M:
          case R:
          case Te:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        ro();
      }
    }
    function Ks(i, a, f) {
      var b = a.updateQueue, S = b !== null ? b.lastEffect : null;
      if (S !== null) {
        var O = S.next, J = O;
        do {
          if ((J.tag & i) === i) {
            var pe = J.destroy;
            J.destroy = void 0, pe !== void 0 && ((i & Wo) !== Ki ? ad(a) : (i & Co) !== Ki && ld(a), (i & _a) !== Ki && Ih(!0), Cy(a, f, pe), (i & _a) !== Ki && Ih(!1), (i & Wo) !== Ki ? Om() : (i & Co) !== Ki && Il());
          }
          J = J.next;
        } while (J !== O);
      }
    }
    function vu(i, a) {
      var f = a.updateQueue, b = f !== null ? f.lastEffect : null;
      if (b !== null) {
        var S = b.next, O = S;
        do {
          if ((O.tag & i) === i) {
            (i & Wo) !== Ki ? Nm(a) : (i & Co) !== Ki && Dm(a);
            var J = O.create;
            (i & _a) !== Ki && Ih(!0), O.destroy = J(), (i & _a) !== Ki && Ih(!1), (i & Wo) !== Ki ? hp() : (i & Co) !== Ki && Im();
            {
              var pe = O.destroy;
              if (pe !== void 0 && typeof pe != "function") {
                var me = void 0;
                (O.tag & Co) !== Lr ? me = "useLayoutEffect" : (O.tag & _a) !== Lr ? me = "useInsertionEffect" : me = "useEffect";
                var Se = void 0;
                pe === null ? Se = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof pe.then == "function" ? Se = `

It looks like you wrote ` + me + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + me + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : Se = " You returned: " + pe, c("%s must not return anything besides a function, which is used for clean-up.%s", me, Se);
              }
            }
          }
          O = O.next;
        } while (O !== S);
      }
    }
    function MR(i, a) {
      if ((a.flags & tn) !== Lr)
        switch (a.tag) {
          case B: {
            var f = a.stateNode.passiveEffectDuration, b = a.memoizedProps, S = b.id, O = b.onPostCommit, J = s1(), pe = a.alternate === null ? "mount" : "update";
            i1() && (pe = "nested-update"), typeof O == "function" && O(S, pe, f, J);
            var me = a.return;
            e:
              for (; me !== null; ) {
                switch (me.tag) {
                  case w:
                    var Se = me.stateNode;
                    Se.passiveEffectDuration += f;
                    break e;
                  case B:
                    var _e = me.stateNode;
                    _e.passiveEffectDuration += f;
                    break e;
                }
                me = me.return;
              }
            break;
          }
        }
    }
    function NR(i, a, f, b) {
      if ((f.flags & Mo) !== Lr)
        switch (f.tag) {
          case m:
          case N:
          case de: {
            if (!Yo)
              if (f.mode & Ur)
                try {
                  $a(), vu(Co | Eo, f);
                } finally {
                  Aa(f);
                }
              else
                vu(Co | Eo, f);
            break;
          }
          case C: {
            var S = f.stateNode;
            if (f.flags & tn && !Yo)
              if (a === null)
                if (f.type === f.elementType && !Sc && (S.props !== f.memoizedProps && c("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", en(f) || "instance"), S.state !== f.memoizedState && c("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", en(f) || "instance")), f.mode & Ur)
                  try {
                    $a(), S.componentDidMount();
                  } finally {
                    Aa(f);
                  }
                else
                  S.componentDidMount();
              else {
                var O = f.elementType === f.type ? a.memoizedProps : Ws(f.type, a.memoizedProps), J = a.memoizedState;
                if (f.type === f.elementType && !Sc && (S.props !== f.memoizedProps && c("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", en(f) || "instance"), S.state !== f.memoizedState && c("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", en(f) || "instance")), f.mode & Ur)
                  try {
                    $a(), S.componentDidUpdate(O, J, S.__reactInternalSnapshotBeforeUpdate);
                  } finally {
                    Aa(f);
                  }
                else
                  S.componentDidUpdate(O, J, S.__reactInternalSnapshotBeforeUpdate);
              }
            var pe = f.updateQueue;
            pe !== null && (f.type === f.elementType && !Sc && (S.props !== f.memoizedProps && c("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", en(f) || "instance"), S.state !== f.memoizedState && c("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", en(f) || "instance")), xT(f, pe, S));
            break;
          }
          case w: {
            var me = f.updateQueue;
            if (me !== null) {
              var Se = null;
              if (f.child !== null)
                switch (f.child.tag) {
                  case L:
                    Se = f.child.stateNode;
                    break;
                  case C:
                    Se = f.child.stateNode;
                    break;
                }
              xT(f, me, Se);
            }
            break;
          }
          case L: {
            var _e = f.stateNode;
            if (a === null && f.flags & tn) {
              var ze = f.type, Le = f.memoizedProps;
              JC(_e, ze, Le);
            }
            break;
          }
          case M:
            break;
          case R:
            break;
          case B: {
            {
              var qe = f.memoizedProps, Ke = qe.onCommit, rt = qe.onRender, xr = f.stateNode.effectDuration, zr = s1(), Or = a === null ? "mount" : "update";
              i1() && (Or = "nested-update"), typeof rt == "function" && rt(f.memoizedProps.id, Or, f.actualDuration, f.treeBaseDuration, f.actualStartTime, zr);
              {
                typeof Ke == "function" && Ke(f.memoizedProps.id, Or, xr, zr), $_(f);
                var dn = f.return;
                e:
                  for (; dn !== null; ) {
                    switch (dn.tag) {
                      case w:
                        var ln = dn.stateNode;
                        ln.effectDuration += xr;
                        break e;
                      case B:
                        var He = dn.stateNode;
                        He.effectDuration += xr;
                        break e;
                    }
                    dn = dn.return;
                  }
              }
            }
            break;
          }
          case K: {
            VR(i, f);
            break;
          }
          case Ce:
          case Te:
          case Re:
          case ke:
          case Ae:
          case he:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
      Yo || f.flags & ri && L1(f);
    }
    function OR(i) {
      switch (i.tag) {
        case m:
        case N:
        case de: {
          if (i.mode & Ur)
            try {
              $a(), D1(i, i.return);
            } finally {
              Aa(i);
            }
          else
            D1(i, i.return);
          break;
        }
        case C: {
          var a = i.stateNode;
          typeof a.componentDidMount == "function" && wR(i, i.return, a), I1(i, i.return);
          break;
        }
        case L: {
          I1(i, i.return);
          break;
        }
      }
    }
    function DR(i, a) {
      for (var f = null, b = i; ; ) {
        if (b.tag === L) {
          if (f === null) {
            f = b;
            try {
              var S = b.stateNode;
              a ? lS(S) : cS(b.stateNode, b.memoizedProps);
            } catch (J) {
              On(i, i.return, J);
            }
          }
        } else if (b.tag === M) {
          if (f === null)
            try {
              var O = b.stateNode;
              a ? uS(O) : dS(O, b.memoizedProps);
            } catch (J) {
              On(i, i.return, J);
            }
        } else if (!((b.tag === ke || b.tag === Ae) && b.memoizedState !== null && b !== i)) {
          if (b.child !== null) {
            b.child.return = b, b = b.child;
            continue;
          }
        }
        if (b === i)
          return;
        for (; b.sibling === null; ) {
          if (b.return === null || b.return === i)
            return;
          f === b && (f = null), b = b.return;
        }
        f === b && (f = null), b.sibling.return = b.return, b = b.sibling;
      }
    }
    function L1(i) {
      var a = i.ref;
      if (a !== null) {
        var f = i.stateNode, b;
        switch (i.tag) {
          case L:
            b = f;
            break;
          default:
            b = f;
        }
        if (typeof a == "function") {
          var S;
          if (i.mode & Ur)
            try {
              $a(), S = a(b);
            } finally {
              Aa(i);
            }
          else
            S = a(b);
          typeof S == "function" && c("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", en(i));
        } else
          a.hasOwnProperty("current") || c("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", en(i)), a.current = b;
      }
    }
    function IR(i) {
      var a = i.alternate;
      a !== null && (a.return = null), i.return = null;
    }
    function B1(i) {
      var a = i.alternate;
      a !== null && (i.alternate = null, B1(a));
      {
        if (i.child = null, i.deletions = null, i.sibling = null, i.tag === L) {
          var f = i.stateNode;
          f !== null && HS(f);
        }
        i.stateNode = null, i._debugOwner = null, i.return = null, i.dependencies = null, i.memoizedProps = null, i.memoizedState = null, i.pendingProps = null, i.stateNode = null, i.updateQueue = null;
      }
    }
    function FR(i) {
      for (var a = i.return; a !== null; ) {
        if (z1(a))
          return a;
        a = a.return;
      }
      throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function z1(i) {
      return i.tag === L || i.tag === w || i.tag === R;
    }
    function V1(i) {
      var a = i;
      e:
        for (; ; ) {
          for (; a.sibling === null; ) {
            if (a.return === null || z1(a.return))
              return null;
            a = a.return;
          }
          for (a.sibling.return = a.return, a = a.sibling; a.tag !== L && a.tag !== M && a.tag !== Pe; ) {
            if (a.flags & $n || a.child === null || a.tag === R)
              continue e;
            a.child.return = a, a = a.child;
          }
          if (!(a.flags & $n))
            return a.stateNode;
        }
    }
    function LR(i) {
      var a = FR(i);
      switch (a.tag) {
        case L: {
          var f = a.stateNode;
          a.flags & Tn && (Ub(f), a.flags &= ~Tn);
          var b = V1(i);
          M0(i, b, f);
          break;
        }
        case w:
        case R: {
          var S = a.stateNode.containerInfo, O = V1(i);
          j0(i, O, S);
          break;
        }
        default:
          throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    function j0(i, a, f) {
      var b = i.tag, S = b === L || b === M;
      if (S) {
        var O = i.stateNode;
        a ? oS(f, O, a) : rS(f, O);
      } else if (b !== R) {
        var J = i.child;
        if (J !== null) {
          j0(J, a, f);
          for (var pe = J.sibling; pe !== null; )
            j0(pe, a, f), pe = pe.sibling;
        }
      }
    }
    function M0(i, a, f) {
      var b = i.tag, S = b === L || b === M;
      if (S) {
        var O = i.stateNode;
        a ? nS(f, O, a) : tS(f, O);
      } else if (b !== R) {
        var J = i.child;
        if (J !== null) {
          M0(J, a, f);
          for (var pe = J.sibling; pe !== null; )
            M0(pe, a, f), pe = pe.sibling;
        }
      }
    }
    var qo = null, Xs = !1;
    function BR(i, a, f) {
      {
        var b = a;
        e:
          for (; b !== null; ) {
            switch (b.tag) {
              case L: {
                qo = b.stateNode, Xs = !1;
                break e;
              }
              case w: {
                qo = b.stateNode.containerInfo, Xs = !0;
                break e;
              }
              case R: {
                qo = b.stateNode.containerInfo, Xs = !0;
                break e;
              }
            }
            b = b.return;
          }
        if (qo === null)
          throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        U1(i, a, f), qo = null, Xs = !1;
      }
      IR(f);
    }
    function yu(i, a, f) {
      for (var b = f.child; b !== null; )
        U1(i, a, b), b = b.sibling;
    }
    function U1(i, a, f) {
      switch (fp(f), f.tag) {
        case L:
          Yo || xf(f, a);
        case M: {
          {
            var b = qo, S = Xs;
            qo = null, yu(i, a, f), qo = b, Xs = S, qo !== null && (Xs ? sS(qo, f.stateNode) : iS(qo, f.stateNode));
          }
          return;
        }
        case Pe: {
          qo !== null && (Xs ? aS(qo, f.stateNode) : Hg(qo, f.stateNode));
          return;
        }
        case R: {
          {
            var O = qo, J = Xs;
            qo = f.stateNode.containerInfo, Xs = !0, yu(i, a, f), qo = O, Xs = J;
          }
          return;
        }
        case m:
        case N:
        case ue:
        case de: {
          if (!Yo) {
            var pe = f.updateQueue;
            if (pe !== null) {
              var me = pe.lastEffect;
              if (me !== null) {
                var Se = me.next, _e = Se;
                do {
                  var ze = _e, Le = ze.destroy, qe = ze.tag;
                  Le !== void 0 && ((qe & _a) !== Ki ? Cy(f, a, Le) : (qe & Co) !== Ki && (ld(f), f.mode & Ur ? ($a(), Cy(f, a, Le), Aa(f)) : Cy(f, a, Le), Il())), _e = _e.next;
                } while (_e !== Se);
              }
            }
          }
          yu(i, a, f);
          return;
        }
        case C: {
          if (!Yo) {
            xf(f, a);
            var Ke = f.stateNode;
            typeof Ke.componentWillUnmount == "function" && $0(f, a, Ke);
          }
          yu(i, a, f);
          return;
        }
        case Re: {
          yu(i, a, f);
          return;
        }
        case ke: {
          if (
            // TODO: Remove this dead flag
            f.mode & nn
          ) {
            var rt = Yo;
            Yo = rt || f.memoizedState !== null, yu(i, a, f), Yo = rt;
          } else
            yu(i, a, f);
          break;
        }
        default: {
          yu(i, a, f);
          return;
        }
      }
    }
    function zR(i) {
      i.memoizedState;
    }
    function VR(i, a) {
      var f = a.memoizedState;
      if (f === null) {
        var b = a.alternate;
        if (b !== null) {
          var S = b.memoizedState;
          if (S !== null) {
            var O = S.dehydrated;
            O !== null && RS(O);
          }
        }
      }
    }
    function H1(i) {
      var a = i.updateQueue;
      if (a !== null) {
        i.updateQueue = null;
        var f = i.stateNode;
        f === null && (f = i.stateNode = new PR()), a.forEach(function(b) {
          var S = F_.bind(null, i, b);
          if (!f.has(b)) {
            if (f.add(b), bo)
              if (yf !== null && gf !== null)
                Dh(gf, yf);
              else
                throw Error("Expected finished root and lanes to be set. This is a bug in React.");
            b.then(S, S);
          }
        });
      }
    }
    function UR(i, a, f) {
      yf = f, gf = i, Sn(a), W1(a, i), Sn(a), yf = null, gf = null;
    }
    function Qs(i, a, f) {
      var b = a.deletions;
      if (b !== null)
        for (var S = 0; S < b.length; S++) {
          var O = b[S];
          try {
            BR(i, a, O);
          } catch (me) {
            On(O, a, me);
          }
        }
      var J = Uy();
      if (a.subtreeFlags & ii)
        for (var pe = a.child; pe !== null; )
          Sn(pe), W1(pe, i), pe = pe.sibling;
      Sn(J);
    }
    function W1(i, a, f) {
      var b = i.alternate, S = i.flags;
      switch (i.tag) {
        case m:
        case N:
        case ue:
        case de: {
          if (Qs(a, i), ja(i), S & tn) {
            try {
              Ks(_a | Eo, i, i.return), vu(_a | Eo, i);
            } catch (qr) {
              On(i, i.return, qr);
            }
            if (i.mode & Ur) {
              try {
                $a(), Ks(Co | Eo, i, i.return);
              } catch (qr) {
                On(i, i.return, qr);
              }
              Aa(i);
            } else
              try {
                Ks(Co | Eo, i, i.return);
              } catch (qr) {
                On(i, i.return, qr);
              }
          }
          return;
        }
        case C: {
          Qs(a, i), ja(i), S & ri && b !== null && xf(b, b.return);
          return;
        }
        case L: {
          Qs(a, i), ja(i), S & ri && b !== null && xf(b, b.return);
          {
            if (i.flags & Tn) {
              var O = i.stateNode;
              try {
                Ub(O);
              } catch (qr) {
                On(i, i.return, qr);
              }
            }
            if (S & tn) {
              var J = i.stateNode;
              if (J != null) {
                var pe = i.memoizedProps, me = b !== null ? b.memoizedProps : pe, Se = i.type, _e = i.updateQueue;
                if (i.updateQueue = null, _e !== null)
                  try {
                    ZC(J, _e, Se, me, pe, i);
                  } catch (qr) {
                    On(i, i.return, qr);
                  }
              }
            }
          }
          return;
        }
        case M: {
          if (Qs(a, i), ja(i), S & tn) {
            if (i.stateNode === null)
              throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
            var ze = i.stateNode, Le = i.memoizedProps, qe = b !== null ? b.memoizedProps : Le;
            try {
              eS(ze, qe, Le);
            } catch (qr) {
              On(i, i.return, qr);
            }
          }
          return;
        }
        case w: {
          if (Qs(a, i), ja(i), S & tn && b !== null) {
            var Ke = b.memoizedState;
            if (Ke.isDehydrated)
              try {
                PS(a.containerInfo);
              } catch (qr) {
                On(i, i.return, qr);
              }
          }
          return;
        }
        case R: {
          Qs(a, i), ja(i);
          return;
        }
        case K: {
          Qs(a, i), ja(i);
          var rt = i.child;
          if (rt.flags & ua) {
            var xr = rt.stateNode, zr = rt.memoizedState, Or = zr !== null;
            if (xr.isHidden = Or, Or) {
              var dn = rt.alternate !== null && rt.alternate.memoizedState !== null;
              dn || C_();
            }
          }
          if (S & tn) {
            try {
              zR(i);
            } catch (qr) {
              On(i, i.return, qr);
            }
            H1(i);
          }
          return;
        }
        case ke: {
          var ln = b !== null && b.memoizedState !== null;
          if (
            // TODO: Remove this dead flag
            i.mode & nn
          ) {
            var He = Yo;
            Yo = He || ln, Qs(a, i), Yo = He;
          } else
            Qs(a, i);
          if (ja(i), S & ua) {
            var ct = i.stateNode, We = i.memoizedState, sr = We !== null, br = i;
            if (ct.isHidden = sr, sr && !ln && (br.mode & nn) !== Vr) {
              _r = br;
              for (var vr = br.child; vr !== null; )
                _r = vr, WR(vr), vr = vr.sibling;
            }
            DR(br, sr);
          }
          return;
        }
        case Ce: {
          Qs(a, i), ja(i), S & tn && H1(i);
          return;
        }
        case Re:
          return;
        default: {
          Qs(a, i), ja(i);
          return;
        }
      }
    }
    function ja(i) {
      var a = i.flags;
      if (a & $n) {
        try {
          LR(i);
        } catch (f) {
          On(i, i.return, f);
        }
        i.flags &= ~$n;
      }
      a & Fi && (i.flags &= ~Fi);
    }
    function HR(i, a, f) {
      yf = f, gf = a, _r = i, G1(i, a, f), yf = null, gf = null;
    }
    function G1(i, a, f) {
      for (var b = (i.mode & nn) !== Vr; _r !== null; ) {
        var S = _r, O = S.child;
        if (S.tag === ke && b) {
          var J = S.memoizedState !== null, pe = J || Ey;
          if (pe) {
            N0(i, a, f);
            continue;
          } else {
            var me = S.alternate, Se = me !== null && me.memoizedState !== null, _e = Se || Yo, ze = Ey, Le = Yo;
            Ey = pe, Yo = _e, Yo && !Le && (_r = S, GR(S));
            for (var qe = O; qe !== null; )
              _r = qe, G1(
                qe,
                // New root; bubble back up to here and stop.
                a,
                f
              ), qe = qe.sibling;
            _r = S, Ey = ze, Yo = Le, N0(i, a, f);
            continue;
          }
        }
        (S.subtreeFlags & Mo) !== Lr && O !== null ? (O.return = S, _r = O) : N0(i, a, f);
      }
    }
    function N0(i, a, f) {
      for (; _r !== null; ) {
        var b = _r;
        if ((b.flags & Mo) !== Lr) {
          var S = b.alternate;
          Sn(b);
          try {
            NR(a, S, b, f);
          } catch (J) {
            On(b, b.return, J);
          }
          ro();
        }
        if (b === i) {
          _r = null;
          return;
        }
        var O = b.sibling;
        if (O !== null) {
          O.return = b.return, _r = O;
          return;
        }
        _r = b.return;
      }
    }
    function WR(i) {
      for (; _r !== null; ) {
        var a = _r, f = a.child;
        switch (a.tag) {
          case m:
          case N:
          case ue:
          case de: {
            if (a.mode & Ur)
              try {
                $a(), Ks(Co, a, a.return);
              } finally {
                Aa(a);
              }
            else
              Ks(Co, a, a.return);
            break;
          }
          case C: {
            xf(a, a.return);
            var b = a.stateNode;
            typeof b.componentWillUnmount == "function" && $0(a, a.return, b);
            break;
          }
          case L: {
            xf(a, a.return);
            break;
          }
          case ke: {
            var S = a.memoizedState !== null;
            if (S) {
              Y1(i);
              continue;
            }
            break;
          }
        }
        f !== null ? (f.return = a, _r = f) : Y1(i);
      }
    }
    function Y1(i) {
      for (; _r !== null; ) {
        var a = _r;
        if (a === i) {
          _r = null;
          return;
        }
        var f = a.sibling;
        if (f !== null) {
          f.return = a.return, _r = f;
          return;
        }
        _r = a.return;
      }
    }
    function GR(i) {
      for (; _r !== null; ) {
        var a = _r, f = a.child;
        if (a.tag === ke) {
          var b = a.memoizedState !== null;
          if (b) {
            q1(i);
            continue;
          }
        }
        f !== null ? (f.return = a, _r = f) : q1(i);
      }
    }
    function q1(i) {
      for (; _r !== null; ) {
        var a = _r;
        Sn(a);
        try {
          OR(a);
        } catch (b) {
          On(a, a.return, b);
        }
        if (ro(), a === i) {
          _r = null;
          return;
        }
        var f = a.sibling;
        if (f !== null) {
          f.return = a.return, _r = f;
          return;
        }
        _r = a.return;
      }
    }
    function YR(i, a, f, b) {
      _r = a, qR(a, i, f, b);
    }
    function qR(i, a, f, b) {
      for (; _r !== null; ) {
        var S = _r, O = S.child;
        (S.subtreeFlags & Li) !== Lr && O !== null ? (O.return = S, _r = O) : KR(i, a, f, b);
      }
    }
    function KR(i, a, f, b) {
      for (; _r !== null; ) {
        var S = _r;
        if ((S.flags & Dn) !== Lr) {
          Sn(S);
          try {
            XR(a, S, f, b);
          } catch (J) {
            On(S, S.return, J);
          }
          ro();
        }
        if (S === i) {
          _r = null;
          return;
        }
        var O = S.sibling;
        if (O !== null) {
          O.return = S.return, _r = O;
          return;
        }
        _r = S.return;
      }
    }
    function XR(i, a, f, b) {
      switch (a.tag) {
        case m:
        case N:
        case de: {
          if (a.mode & Ur) {
            d0();
            try {
              vu(Wo | Eo, a);
            } finally {
              c0(a);
            }
          } else
            vu(Wo | Eo, a);
          break;
        }
      }
    }
    function QR(i) {
      _r = i, JR();
    }
    function JR() {
      for (; _r !== null; ) {
        var i = _r, a = i.child;
        if ((_r.flags & bn) !== Lr) {
          var f = i.deletions;
          if (f !== null) {
            for (var b = 0; b < f.length; b++) {
              var S = f[b];
              _r = S, t_(S, i);
            }
            {
              var O = i.alternate;
              if (O !== null) {
                var J = O.child;
                if (J !== null) {
                  O.child = null;
                  do {
                    var pe = J.sibling;
                    J.sibling = null, J = pe;
                  } while (J !== null);
                }
              }
            }
            _r = i;
          }
        }
        (i.subtreeFlags & Li) !== Lr && a !== null ? (a.return = i, _r = a) : ZR();
      }
    }
    function ZR() {
      for (; _r !== null; ) {
        var i = _r;
        (i.flags & Dn) !== Lr && (Sn(i), e_(i), ro());
        var a = i.sibling;
        if (a !== null) {
          a.return = i.return, _r = a;
          return;
        }
        _r = i.return;
      }
    }
    function e_(i) {
      switch (i.tag) {
        case m:
        case N:
        case de: {
          i.mode & Ur ? (d0(), Ks(Wo | Eo, i, i.return), c0(i)) : Ks(Wo | Eo, i, i.return);
          break;
        }
      }
    }
    function t_(i, a) {
      for (; _r !== null; ) {
        var f = _r;
        Sn(f), n_(f, a), ro();
        var b = f.child;
        b !== null ? (b.return = f, _r = b) : r_(i);
      }
    }
    function r_(i) {
      for (; _r !== null; ) {
        var a = _r, f = a.sibling, b = a.return;
        if (B1(a), a === i) {
          _r = null;
          return;
        }
        if (f !== null) {
          f.return = b, _r = f;
          return;
        }
        _r = b;
      }
    }
    function n_(i, a) {
      switch (i.tag) {
        case m:
        case N:
        case de: {
          i.mode & Ur ? (d0(), Ks(Wo, i, a), c0(i)) : Ks(Wo, i, a);
          break;
        }
      }
    }
    function o_(i) {
      switch (i.tag) {
        case m:
        case N:
        case de: {
          try {
            vu(Co | Eo, i);
          } catch (f) {
            On(i, i.return, f);
          }
          break;
        }
        case C: {
          var a = i.stateNode;
          try {
            a.componentDidMount();
          } catch (f) {
            On(i, i.return, f);
          }
          break;
        }
      }
    }
    function i_(i) {
      switch (i.tag) {
        case m:
        case N:
        case de: {
          try {
            vu(Wo | Eo, i);
          } catch (a) {
            On(i, i.return, a);
          }
          break;
        }
      }
    }
    function s_(i) {
      switch (i.tag) {
        case m:
        case N:
        case de: {
          try {
            Ks(Co | Eo, i, i.return);
          } catch (f) {
            On(i, i.return, f);
          }
          break;
        }
        case C: {
          var a = i.stateNode;
          typeof a.componentWillUnmount == "function" && $0(i, i.return, a);
          break;
        }
      }
    }
    function a_(i) {
      switch (i.tag) {
        case m:
        case N:
        case de:
          try {
            Ks(Wo | Eo, i, i.return);
          } catch (a) {
            On(i, i.return, a);
          }
      }
    }
    if (typeof Symbol == "function" && Symbol.for) {
      var Ph = Symbol.for;
      Ph("selector.component"), Ph("selector.has_pseudo_class"), Ph("selector.role"), Ph("selector.test_id"), Ph("selector.text");
    }
    var l_ = [];
    function u_() {
      l_.forEach(function(i) {
        return i();
      });
    }
    var c_ = n.ReactCurrentActQueue;
    function d_(i) {
      {
        var a = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        ), f = typeof jest < "u";
        return f && a !== !1;
      }
    }
    function K1() {
      {
        var i = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        );
        return !i && c_.current !== null && c("The current testing environment is not configured to support act(...)"), i;
      }
    }
    var f_ = Math.ceil, O0 = n.ReactCurrentDispatcher, D0 = n.ReactCurrentOwner, Ko = n.ReactCurrentBatchConfig, Js = n.ReactCurrentActQueue, Ro = (
      /*             */
      0
    ), X1 = (
      /*               */
      1
    ), Xo = (
      /*                */
      2
    ), Cs = (
      /*                */
      4
    ), xl = 0, Rh = 1, Pc = 2, Sy = 3, _h = 4, Q1 = 5, I0 = 6, cn = Ro, _i = null, Kn = null, _o = mt, Ma = mt, F0 = au(mt), wo = xl, wh = null, Py = mt, kh = mt, Ry = mt, Ah = null, Xi = null, L0 = 0, J1 = 500, Z1 = 1 / 0, p_ = 500, bl = null;
    function $h() {
      Z1 = Ln() + p_;
    }
    function eE() {
      return Z1;
    }
    var _y = !1, B0 = null, bf = null, Rc = !1, gu = null, jh = mt, z0 = [], V0 = null, h_ = 50, Mh = 0, U0 = null, H0 = !1, wy = !1, m_ = 50, Tf = 0, ky = null, Nh = kn, Ay = mt, tE = !1;
    function $y() {
      return _i;
    }
    function wi() {
      return (cn & (Xo | Cs)) !== Ro ? Ln() : (Nh !== kn || (Nh = Ln()), Nh);
    }
    function xu(i) {
      var a = i.mode;
      if ((a & nn) === Vr)
        return Wr;
      if ((cn & Xo) !== Ro && _o !== mt)
        return oo(_o);
      var f = dP() !== cP;
      if (f) {
        if (Ko.transition !== null) {
          var b = Ko.transition;
          b._updatedFibers || (b._updatedFibers = /* @__PURE__ */ new Set()), b._updatedFibers.add(i);
        }
        return Ay === un && (Ay = bp()), Ay;
      }
      var S = Ui();
      if (S !== un)
        return S;
      var O = qC();
      return O;
    }
    function v_(i) {
      var a = i.mode;
      return (a & nn) === Vr ? Wr : dg();
    }
    function ko(i, a, f, b) {
      B_(), tE && c("useInsertionEffect must not schedule updates."), H0 && (wy = !0), rl(i, f, b), (cn & Xo) !== mt && i === _i ? U_(a) : (bo && Pp(i, a, f), H_(a), i === _i && ((cn & Xo) === Ro && (kh = rn(kh, f)), wo === _h && bu(i, _o)), Qi(i, b), f === Wr && cn === Ro && (a.mode & nn) === Vr && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
      !Js.isBatchingLegacy && ($h(), eT()));
    }
    function y_(i, a, f) {
      var b = i.current;
      b.lanes = a, rl(i, a, f), Qi(i, f);
    }
    function g_(i) {
      return (
        // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
        // decided not to enable it.
        (cn & Xo) !== Ro
      );
    }
    function Qi(i, a) {
      var f = i.callbackNode;
      lg(i, a);
      var b = Qu(i, i === _i ? _o : mt);
      if (b === mt) {
        f !== null && yE(f), i.callbackNode = null, i.callbackPriority = un;
        return;
      }
      var S = Jn(b), O = i.callbackPriority;
      if (O === S && // Special case related to `act`. If the currently scheduled task is a
      // Scheduler task, rather than an `act` task, cancel it and re-scheduled
      // on the `act` queue.
      !(Js.current !== null && f !== Q0)) {
        f == null && O !== Wr && c("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
        return;
      }
      f != null && yE(f);
      var J;
      if (S === Wr)
        i.tag === lu ? (Js.isBatchingLegacy !== null && (Js.didScheduleLegacyUpdate = !0), YS(oE.bind(null, i))) : Zb(oE.bind(null, i)), Js.current !== null ? Js.current.push(uu) : XC(function() {
          (cn & (Xo | Cs)) === Ro && uu();
        }), J = null;
      else {
        var pe;
        switch (rc(b)) {
          case No:
            pe = od;
            break;
          case To:
            pe = Ci;
            break;
          case Is:
            pe = ps;
            break;
          case ec:
            pe = da;
            break;
          default:
            pe = ps;
            break;
        }
        J = J0(pe, rE.bind(null, i));
      }
      i.callbackPriority = S, i.callbackNode = J;
    }
    function rE(i, a) {
      if (BP(), Nh = kn, Ay = mt, (cn & (Xo | Cs)) !== Ro)
        throw new Error("Should not already be working.");
      var f = i.callbackNode, b = El();
      if (b && i.callbackNode !== f)
        return null;
      var S = Qu(i, i === _i ? _o : mt);
      if (S === mt)
        return null;
      var O = !Zu(i, S) && !Um(i, S) && !a, J = O ? w_(i, S) : My(i, S);
      if (J !== xl) {
        if (J === Pc) {
          var pe = gp(i);
          pe !== mt && (S = pe, J = W0(i, pe));
        }
        if (J === Rh) {
          var me = wh;
          throw _c(i, mt), bu(i, S), Qi(i, Ln()), me;
        }
        if (J === I0)
          bu(i, S);
        else {
          var Se = !Zu(i, S), _e = i.current.alternate;
          if (Se && !b_(_e)) {
            if (J = My(i, S), J === Pc) {
              var ze = gp(i);
              ze !== mt && (S = ze, J = W0(i, ze));
            }
            if (J === Rh) {
              var Le = wh;
              throw _c(i, mt), bu(i, S), Qi(i, Ln()), Le;
            }
          }
          i.finishedWork = _e, i.finishedLanes = S, x_(i, J, S);
        }
      }
      return Qi(i, Ln()), i.callbackNode === f ? rE.bind(null, i) : null;
    }
    function W0(i, a) {
      var f = Ah;
      if (so(i)) {
        var b = _c(i, a);
        b.flags |= Un, BS(i.containerInfo);
      }
      var S = My(i, a);
      if (S !== Pc) {
        var O = Xi;
        Xi = f, O !== null && nE(O);
      }
      return S;
    }
    function nE(i) {
      Xi === null ? Xi = i : Xi.push.apply(Xi, i);
    }
    function x_(i, a, f) {
      switch (a) {
        case xl:
        case Rh:
          throw new Error("Root did not complete. This is a bug in React.");
        case Pc: {
          wc(i, Xi, bl);
          break;
        }
        case Sy: {
          if (bu(i, f), wd(f) && // do not delay if we're inside an act() scope
          !gE()) {
            var b = L0 + J1 - Ln();
            if (b > 10) {
              var S = Qu(i, mt);
              if (S !== mt)
                break;
              var O = i.suspendedLanes;
              if (!tl(O, f)) {
                wi(), Cp(i, O);
                break;
              }
              i.timeoutHandle = Vg(wc.bind(null, i, Xi, bl), b);
              break;
            }
          }
          wc(i, Xi, bl);
          break;
        }
        case _h: {
          if (bu(i, f), Vm(f))
            break;
          if (!gE()) {
            var J = zm(i, f), pe = J, me = Ln() - pe, Se = L_(me) - me;
            if (Se > 10) {
              i.timeoutHandle = Vg(wc.bind(null, i, Xi, bl), Se);
              break;
            }
          }
          wc(i, Xi, bl);
          break;
        }
        case Q1: {
          wc(i, Xi, bl);
          break;
        }
        default:
          throw new Error("Unknown root exit status.");
      }
    }
    function b_(i) {
      for (var a = i; ; ) {
        if (a.flags & Hu) {
          var f = a.updateQueue;
          if (f !== null) {
            var b = f.stores;
            if (b !== null)
              for (var S = 0; S < b.length; S++) {
                var O = b[S], J = O.getSnapshot, pe = O.value;
                try {
                  if (!Rr(J(), pe))
                    return !1;
                } catch {
                  return !1;
                }
              }
          }
        }
        var me = a.child;
        if (a.subtreeFlags & Hu && me !== null) {
          me.return = a, a = me;
          continue;
        }
        if (a === i)
          return !0;
        for (; a.sibling === null; ) {
          if (a.return === null || a.return === i)
            return !0;
          a = a.return;
        }
        a.sibling.return = a.return, a = a.sibling;
      }
      return !0;
    }
    function bu(i, a) {
      a = Hl(a, Ry), a = Hl(a, kh), Ep(i, a);
    }
    function oE(i) {
      if (zP(), (cn & (Xo | Cs)) !== Ro)
        throw new Error("Should not already be working.");
      El();
      var a = Qu(i, mt);
      if (!ui(a, Wr))
        return Qi(i, Ln()), null;
      var f = My(i, a);
      if (i.tag !== lu && f === Pc) {
        var b = gp(i);
        b !== mt && (a = b, f = W0(i, b));
      }
      if (f === Rh) {
        var S = wh;
        throw _c(i, mt), bu(i, a), Qi(i, Ln()), S;
      }
      if (f === I0)
        throw new Error("Root did not complete. This is a bug in React.");
      var O = i.current.alternate;
      return i.finishedWork = O, i.finishedLanes = a, wc(i, Xi, bl), Qi(i, Ln()), null;
    }
    function T_(i, a) {
      a !== mt && (Wl(i, rn(a, Wr)), Qi(i, Ln()), (cn & (Xo | Cs)) === Ro && ($h(), uu()));
    }
    function G0(i, a) {
      var f = cn;
      cn |= X1;
      try {
        return i(a);
      } finally {
        cn = f, cn === Ro && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
        !Js.isBatchingLegacy && ($h(), eT());
      }
    }
    function E_(i, a, f, b, S) {
      var O = Ui(), J = Ko.transition;
      try {
        return Ko.transition = null, io(No), i(a, f, b, S);
      } finally {
        io(O), Ko.transition = J, cn === Ro && $h();
      }
    }
    function Tl(i) {
      gu !== null && gu.tag === lu && (cn & (Xo | Cs)) === Ro && El();
      var a = cn;
      cn |= X1;
      var f = Ko.transition, b = Ui();
      try {
        return Ko.transition = null, io(No), i ? i() : void 0;
      } finally {
        io(b), Ko.transition = f, cn = a, (cn & (Xo | Cs)) === Ro && uu();
      }
    }
    function iE() {
      return (cn & (Xo | Cs)) !== Ro;
    }
    function jy(i, a) {
      di(F0, Ma, i), Ma = rn(Ma, a);
    }
    function Y0(i) {
      Ma = F0.current, ci(F0, i);
    }
    function _c(i, a) {
      i.finishedWork = null, i.finishedLanes = mt;
      var f = i.timeoutHandle;
      if (f !== Ug && (i.timeoutHandle = Ug, KC(f)), Kn !== null)
        for (var b = Kn.return; b !== null; ) {
          var S = b.alternate;
          N1(S, b), b = b.return;
        }
      _i = i;
      var O = kc(i.current, null);
      return Kn = O, _o = Ma = a, wo = xl, wh = null, Py = mt, kh = mt, Ry = mt, Ah = null, Xi = null, mP(), Hs.discardPendingWarnings(), O;
    }
    function sE(i, a) {
      do {
        var f = Kn;
        try {
          if (Bv(), DT(), ro(), D0.current = null, f === null || f.return === null) {
            wo = Rh, wh = a, Kn = null;
            return;
          }
          if (Oe && f.mode & Ur && gy(f, !0), Ve)
            if (Ga(), a !== null && typeof a == "object" && typeof a.then == "function") {
              var b = a;
              Fm(f, b, _o);
            } else
              ud(f, a, _o);
          GP(i, f.return, f, a, _o), cE(f);
        } catch (S) {
          a = S, Kn === f && f !== null ? (f = f.return, Kn = f) : f = Kn;
          continue;
        }
        return;
      } while (!0);
    }
    function aE() {
      var i = O0.current;
      return O0.current = py, i === null ? py : i;
    }
    function lE(i) {
      O0.current = i;
    }
    function C_() {
      L0 = Ln();
    }
    function Oh(i) {
      Py = rn(i, Py);
    }
    function S_() {
      wo === xl && (wo = Sy);
    }
    function q0() {
      (wo === xl || wo === Sy || wo === Pc) && (wo = _h), _i !== null && (Ju(Py) || Ju(kh)) && bu(_i, _o);
    }
    function P_(i) {
      wo !== _h && (wo = Pc), Ah === null ? Ah = [i] : Ah.push(i);
    }
    function R_() {
      return wo === xl;
    }
    function My(i, a) {
      var f = cn;
      cn |= Xo;
      var b = aE();
      if (_i !== i || _o !== a) {
        if (bo) {
          var S = i.memoizedUpdaters;
          S.size > 0 && (Dh(i, _o), S.clear()), $d(i, a);
        }
        bl = Rp(), _c(i, a);
      }
      is(a);
      do
        try {
          __();
          break;
        } catch (O) {
          sE(i, O);
        }
      while (!0);
      if (Bv(), cn = f, lE(b), Kn !== null)
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
      return Ll(), _i = null, _o = mt, wo;
    }
    function __() {
      for (; Kn !== null; )
        uE(Kn);
    }
    function w_(i, a) {
      var f = cn;
      cn |= Xo;
      var b = aE();
      if (_i !== i || _o !== a) {
        if (bo) {
          var S = i.memoizedUpdaters;
          S.size > 0 && (Dh(i, _o), S.clear()), $d(i, a);
        }
        bl = Rp(), $h(), _c(i, a);
      }
      is(a);
      do
        try {
          k_();
          break;
        } catch (O) {
          sE(i, O);
        }
      while (!0);
      return Bv(), lE(b), cn = f, Kn !== null ? (Yu(), xl) : (Ll(), _i = null, _o = mt, wo);
    }
    function k_() {
      for (; Kn !== null && !nd(); )
        uE(Kn);
    }
    function uE(i) {
      var a = i.alternate;
      Sn(i);
      var f;
      (i.mode & Ur) !== Vr ? (u0(i), f = K0(a, i, Ma), gy(i, !0)) : f = K0(a, i, Ma), ro(), i.memoizedProps = i.pendingProps, f === null ? cE(i) : Kn = f, D0.current = null;
    }
    function cE(i) {
      var a = i;
      do {
        var f = a.alternate, b = a.return;
        if ((a.flags & bi) === Lr) {
          Sn(a);
          var S = void 0;
          if ((a.mode & Ur) === Vr ? S = M1(f, a, Ma) : (u0(a), S = M1(f, a, Ma), gy(a, !1)), ro(), S !== null) {
            Kn = S;
            return;
          }
        } else {
          var O = SR(f, a);
          if (O !== null) {
            O.flags &= km, Kn = O;
            return;
          }
          if ((a.mode & Ur) !== Vr) {
            gy(a, !1);
            for (var J = a.actualDuration, pe = a.child; pe !== null; )
              J += pe.actualDuration, pe = pe.sibling;
            a.actualDuration = J;
          }
          if (b !== null)
            b.flags |= bi, b.subtreeFlags = Lr, b.deletions = null;
          else {
            wo = I0, Kn = null;
            return;
          }
        }
        var me = a.sibling;
        if (me !== null) {
          Kn = me;
          return;
        }
        a = b, Kn = a;
      } while (a !== null);
      wo === xl && (wo = Q1);
    }
    function wc(i, a, f) {
      var b = Ui(), S = Ko.transition;
      try {
        Ko.transition = null, io(No), A_(i, a, f, b);
      } finally {
        Ko.transition = S, io(b);
      }
      return null;
    }
    function A_(i, a, f, b) {
      do
        El();
      while (gu !== null);
      if (z_(), (cn & (Xo | Cs)) !== Ro)
        throw new Error("Should not already be working.");
      var S = i.finishedWork, O = i.finishedLanes;
      if (sd(O), S === null)
        return pp(), null;
      if (O === mt && c("root.finishedLanes should not be empty during a commit. This is a bug in React."), i.finishedWork = null, i.finishedLanes = mt, S === i.current)
        throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
      i.callbackNode = null, i.callbackPriority = un;
      var J = rn(S.lanes, S.childLanes);
      Sp(i, J), i === _i && (_i = null, Kn = null, _o = mt), ((S.subtreeFlags & Li) !== Lr || (S.flags & Li) !== Lr) && (Rc || (Rc = !0, V0 = f, J0(ps, function() {
        return El(), null;
      })));
      var pe = (S.subtreeFlags & (Dl | ii | Mo | Li)) !== Lr, me = (S.flags & (Dl | ii | Mo | Li)) !== Lr;
      if (pe || me) {
        var Se = Ko.transition;
        Ko.transition = null;
        var _e = Ui();
        io(No);
        var ze = cn;
        cn |= Cs, D0.current = null, kR(i, S), a1(), UR(i, S, O), VC(i.containerInfo), i.current = S, Lm(O), HR(S, i, O), Fl(), jm(), cn = ze, io(_e), Ko.transition = Se;
      } else
        i.current = S, a1();
      var Le = Rc;
      if (Rc ? (Rc = !1, gu = i, jh = O) : (Tf = 0, ky = null), J = i.pendingLanes, J === mt && (bf = null), Le || hE(i.current, !1), Ns(S.stateNode, b), bo && i.memoizedUpdaters.clear(), u_(), Qi(i, Ln()), a !== null)
        for (var qe = i.onRecoverableError, Ke = 0; Ke < a.length; Ke++) {
          var rt = a[Ke], xr = rt.stack, zr = rt.digest;
          qe(rt.value, {
            componentStack: xr,
            digest: zr
          });
        }
      if (_y) {
        _y = !1;
        var Or = B0;
        throw B0 = null, Or;
      }
      return ui(jh, Wr) && i.tag !== lu && El(), J = i.pendingLanes, ui(J, Wr) ? (LP(), i === U0 ? Mh++ : (Mh = 0, U0 = i)) : Mh = 0, uu(), pp(), null;
    }
    function El() {
      if (gu !== null) {
        var i = rc(jh), a = pg(Is, i), f = Ko.transition, b = Ui();
        try {
          return Ko.transition = null, io(a), j_();
        } finally {
          io(b), Ko.transition = f;
        }
      }
      return !1;
    }
    function $_(i) {
      z0.push(i), Rc || (Rc = !0, J0(ps, function() {
        return El(), null;
      }));
    }
    function j_() {
      if (gu === null)
        return !1;
      var i = V0;
      V0 = null;
      var a = gu, f = jh;
      if (gu = null, jh = mt, (cn & (Xo | Cs)) !== Ro)
        throw new Error("Cannot flush passive effects while already rendering.");
      H0 = !0, wy = !1, Bm(f);
      var b = cn;
      cn |= Cs, QR(a.current), YR(a, a.current, f, i);
      {
        var S = z0;
        z0 = [];
        for (var O = 0; O < S.length; O++) {
          var J = S[O];
          MR(a, J);
        }
      }
      Gu(), hE(a.current, !0), cn = b, uu(), wy ? a === ky ? Tf++ : (Tf = 0, ky = a) : Tf = 0, H0 = !1, wy = !1, pa(a);
      {
        var pe = a.current.stateNode;
        pe.effectDuration = 0, pe.passiveEffectDuration = 0;
      }
      return !0;
    }
    function dE(i) {
      return bf !== null && bf.has(i);
    }
    function M_(i) {
      bf === null ? bf = /* @__PURE__ */ new Set([i]) : bf.add(i);
    }
    function N_(i) {
      _y || (_y = !0, B0 = i);
    }
    var O_ = N_;
    function fE(i, a, f) {
      var b = Cc(f, a), S = u1(i, b, Wr), O = du(i, S, Wr), J = wi();
      O !== null && (rl(O, Wr, J), Qi(O, J));
    }
    function On(i, a, f) {
      if (RR(f), Ih(!1), i.tag === w) {
        fE(i, i, f);
        return;
      }
      var b = null;
      for (b = a; b !== null; ) {
        if (b.tag === w) {
          fE(b, i, f);
          return;
        } else if (b.tag === C) {
          var S = b.type, O = b.stateNode;
          if (typeof S.getDerivedStateFromError == "function" || typeof O.componentDidCatch == "function" && !dE(O)) {
            var J = Cc(f, i), pe = m0(b, J, Wr), me = du(b, pe, Wr), Se = wi();
            me !== null && (rl(me, Wr, Se), Qi(me, Se));
            return;
          }
        }
        b = b.return;
      }
      c(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, f);
    }
    function D_(i, a, f) {
      var b = i.pingCache;
      b !== null && b.delete(a);
      var S = wi();
      Cp(i, f), W_(i), _i === i && tl(_o, f) && (wo === _h || wo === Sy && wd(_o) && Ln() - L0 < J1 ? _c(i, mt) : Ry = rn(Ry, f)), Qi(i, S);
    }
    function pE(i, a) {
      a === un && (a = v_(i));
      var f = wi(), b = qi(i, a);
      b !== null && (rl(b, a, f), Qi(b, f));
    }
    function I_(i) {
      var a = i.memoizedState, f = un;
      a !== null && (f = a.retryLane), pE(i, f);
    }
    function F_(i, a) {
      var f = un, b;
      switch (i.tag) {
        case K:
          b = i.stateNode;
          var S = i.memoizedState;
          S !== null && (f = S.retryLane);
          break;
        case Ce:
          b = i.stateNode;
          break;
        default:
          throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
      }
      b !== null && b.delete(a), pE(i, f);
    }
    function L_(i) {
      return i < 120 ? 120 : i < 480 ? 480 : i < 1080 ? 1080 : i < 1920 ? 1920 : i < 3e3 ? 3e3 : i < 4320 ? 4320 : f_(i / 1960) * 1960;
    }
    function B_() {
      if (Mh > h_)
        throw Mh = 0, U0 = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
      Tf > m_ && (Tf = 0, ky = null, c("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
    }
    function z_() {
      Hs.flushLegacyContextWarning(), Hs.flushPendingUnsafeLifecycleWarnings();
    }
    function hE(i, a) {
      Sn(i), Ny(i, oi, s_), a && Ny(i, Wa, a_), Ny(i, oi, o_), a && Ny(i, Wa, i_), ro();
    }
    function Ny(i, a, f) {
      for (var b = i, S = null; b !== null; ) {
        var O = b.subtreeFlags & a;
        b !== S && b.child !== null && O !== Lr ? b = b.child : ((b.flags & a) !== Lr && f(b), b.sibling !== null ? b = b.sibling : b = S = b.return);
      }
    }
    var Oy = null;
    function mE(i) {
      {
        if ((cn & Xo) !== Ro || !(i.mode & nn))
          return;
        var a = i.tag;
        if (a !== P && a !== w && a !== C && a !== m && a !== N && a !== ue && a !== de)
          return;
        var f = en(i) || "ReactComponent";
        if (Oy !== null) {
          if (Oy.has(f))
            return;
          Oy.add(f);
        } else
          Oy = /* @__PURE__ */ new Set([f]);
        var b = Xn;
        try {
          Sn(i), c("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally {
          b ? Sn(i) : ro();
        }
      }
    }
    var K0;
    {
      var V_ = null;
      K0 = function(i, a, f) {
        var b = CE(V_, a);
        try {
          return w1(i, a, f);
        } catch (O) {
          if (tP() || O !== null && typeof O == "object" && typeof O.then == "function")
            throw O;
          if (Bv(), DT(), N1(i, a), CE(a, b), a.mode & Ur && u0(a), Ha(null, w1, null, i, a, f), sg()) {
            var S = rp();
            typeof S == "object" && S !== null && S._suppressLogging && typeof O == "object" && O !== null && !O._suppressLogging && (O._suppressLogging = !0);
          }
          throw O;
        }
      };
    }
    var vE = !1, X0;
    X0 = /* @__PURE__ */ new Set();
    function U_(i) {
      if (Mi && !DP())
        switch (i.tag) {
          case m:
          case N:
          case de: {
            var a = Kn && en(Kn) || "Unknown", f = a;
            if (!X0.has(f)) {
              X0.add(f);
              var b = en(i) || "Unknown";
              c("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", b, a, a);
            }
            break;
          }
          case C: {
            vE || (c("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), vE = !0);
            break;
          }
        }
    }
    function Dh(i, a) {
      if (bo) {
        var f = i.memoizedUpdaters;
        f.forEach(function(b) {
          Pp(i, b, a);
        });
      }
    }
    var Q0 = {};
    function J0(i, a) {
      {
        var f = Js.current;
        return f !== null ? (f.push(a), Q0) : rd(i, a);
      }
    }
    function yE(i) {
      if (i !== Q0)
        return $m(i);
    }
    function gE() {
      return Js.current !== null;
    }
    function H_(i) {
      {
        if (i.mode & nn) {
          if (!K1())
            return;
        } else if (!d_() || cn !== Ro || i.tag !== m && i.tag !== N && i.tag !== de)
          return;
        if (Js.current === null) {
          var a = Xn;
          try {
            Sn(i), c(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, en(i));
          } finally {
            a ? Sn(i) : ro();
          }
        }
      }
    }
    function W_(i) {
      i.tag !== lu && K1() && Js.current === null && c(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`);
    }
    function Ih(i) {
      tE = i;
    }
    var Ss = null, Ef = null, G_ = function(i) {
      Ss = i;
    };
    function Cf(i) {
      {
        if (Ss === null)
          return i;
        var a = Ss(i);
        return a === void 0 ? i : a.current;
      }
    }
    function Z0(i) {
      return Cf(i);
    }
    function eb(i) {
      {
        if (Ss === null)
          return i;
        var a = Ss(i);
        if (a === void 0) {
          if (i != null && typeof i.render == "function") {
            var f = Cf(i.render);
            if (i.render !== f) {
              var b = {
                $$typeof: jr,
                render: f
              };
              return i.displayName !== void 0 && (b.displayName = i.displayName), b;
            }
          }
          return i;
        }
        return a.current;
      }
    }
    function xE(i, a) {
      {
        if (Ss === null)
          return !1;
        var f = i.elementType, b = a.type, S = !1, O = typeof b == "object" && b !== null ? b.$$typeof : null;
        switch (i.tag) {
          case C: {
            typeof b == "function" && (S = !0);
            break;
          }
          case m: {
            (typeof b == "function" || O === Dr) && (S = !0);
            break;
          }
          case N: {
            (O === jr || O === Dr) && (S = !0);
            break;
          }
          case ue:
          case de: {
            (O === $r || O === Dr) && (S = !0);
            break;
          }
          default:
            return !1;
        }
        if (S) {
          var J = Ss(f);
          if (J !== void 0 && J === Ss(b))
            return !0;
        }
        return !1;
      }
    }
    function bE(i) {
      {
        if (Ss === null || typeof WeakSet != "function")
          return;
        Ef === null && (Ef = /* @__PURE__ */ new WeakSet()), Ef.add(i);
      }
    }
    var Y_ = function(i, a) {
      {
        if (Ss === null)
          return;
        var f = a.staleFamilies, b = a.updatedFamilies;
        El(), Tl(function() {
          tb(i.current, b, f);
        });
      }
    }, q_ = function(i, a) {
      {
        if (i.context !== ls)
          return;
        El(), Tl(function() {
          Fh(a, i, null, null);
        });
      }
    };
    function tb(i, a, f) {
      {
        var b = i.alternate, S = i.child, O = i.sibling, J = i.tag, pe = i.type, me = null;
        switch (J) {
          case m:
          case de:
          case C:
            me = pe;
            break;
          case N:
            me = pe.render;
            break;
        }
        if (Ss === null)
          throw new Error("Expected resolveFamily to be set during hot reload.");
        var Se = !1, _e = !1;
        if (me !== null) {
          var ze = Ss(me);
          ze !== void 0 && (f.has(ze) ? _e = !0 : a.has(ze) && (J === C ? _e = !0 : Se = !0));
        }
        if (Ef !== null && (Ef.has(i) || b !== null && Ef.has(b)) && (_e = !0), _e && (i._debugNeedsRemount = !0), _e || Se) {
          var Le = qi(i, Wr);
          Le !== null && ko(Le, i, Wr, kn);
        }
        S !== null && !_e && tb(S, a, f), O !== null && tb(O, a, f);
      }
    }
    var K_ = function(i, a) {
      {
        var f = /* @__PURE__ */ new Set(), b = new Set(a.map(function(S) {
          return S.current;
        }));
        return rb(i.current, b, f), f;
      }
    };
    function rb(i, a, f) {
      {
        var b = i.child, S = i.sibling, O = i.tag, J = i.type, pe = null;
        switch (O) {
          case m:
          case de:
          case C:
            pe = J;
            break;
          case N:
            pe = J.render;
            break;
        }
        var me = !1;
        pe !== null && a.has(pe) && (me = !0), me ? X_(i, f) : b !== null && rb(b, a, f), S !== null && rb(S, a, f);
      }
    }
    function X_(i, a) {
      {
        var f = Q_(i, a);
        if (f)
          return;
        for (var b = i; ; ) {
          switch (b.tag) {
            case L:
              a.add(b.stateNode);
              return;
            case R:
              a.add(b.stateNode.containerInfo);
              return;
            case w:
              a.add(b.stateNode.containerInfo);
              return;
          }
          if (b.return === null)
            throw new Error("Expected to reach root first.");
          b = b.return;
        }
      }
    }
    function Q_(i, a) {
      for (var f = i, b = !1; ; ) {
        if (f.tag === L)
          b = !0, a.add(f.stateNode);
        else if (f.child !== null) {
          f.child.return = f, f = f.child;
          continue;
        }
        if (f === i)
          return b;
        for (; f.sibling === null; ) {
          if (f.return === null || f.return === i)
            return b;
          f = f.return;
        }
        f.sibling.return = f.return, f = f.sibling;
      }
      return !1;
    }
    var nb;
    {
      nb = !1;
      try {
        var TE = Object.preventExtensions({});
      } catch {
        nb = !0;
      }
    }
    function J_(i, a, f, b) {
      this.tag = i, this.key = f, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = a, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = b, this.flags = Lr, this.subtreeFlags = Lr, this.deletions = null, this.lanes = mt, this.childLanes = mt, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !nb && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
    }
    var us = function(i, a, f, b) {
      return new J_(i, a, f, b);
    };
    function ib(i) {
      var a = i.prototype;
      return !!(a && a.isReactComponent);
    }
    function Z_(i) {
      return typeof i == "function" && !ib(i) && i.defaultProps === void 0;
    }
    function ew(i) {
      if (typeof i == "function")
        return ib(i) ? C : m;
      if (i != null) {
        var a = i.$$typeof;
        if (a === jr)
          return N;
        if (a === $r)
          return ue;
      }
      return P;
    }
    function kc(i, a) {
      var f = i.alternate;
      f === null ? (f = us(i.tag, a, i.key, i.mode), f.elementType = i.elementType, f.type = i.type, f.stateNode = i.stateNode, f._debugSource = i._debugSource, f._debugOwner = i._debugOwner, f._debugHookTypes = i._debugHookTypes, f.alternate = i, i.alternate = f) : (f.pendingProps = a, f.type = i.type, f.flags = Lr, f.subtreeFlags = Lr, f.deletions = null, f.actualDuration = 0, f.actualStartTime = -1), f.flags = i.flags & xo, f.childLanes = i.childLanes, f.lanes = i.lanes, f.child = i.child, f.memoizedProps = i.memoizedProps, f.memoizedState = i.memoizedState, f.updateQueue = i.updateQueue;
      var b = i.dependencies;
      switch (f.dependencies = b === null ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
      }, f.sibling = i.sibling, f.index = i.index, f.ref = i.ref, f.selfBaseDuration = i.selfBaseDuration, f.treeBaseDuration = i.treeBaseDuration, f._debugNeedsRemount = i._debugNeedsRemount, f.tag) {
        case P:
        case m:
        case de:
          f.type = Cf(i.type);
          break;
        case C:
          f.type = Z0(i.type);
          break;
        case N:
          f.type = eb(i.type);
          break;
      }
      return f;
    }
    function tw(i, a) {
      i.flags &= xo | $n;
      var f = i.alternate;
      if (f === null)
        i.childLanes = mt, i.lanes = a, i.child = null, i.subtreeFlags = Lr, i.memoizedProps = null, i.memoizedState = null, i.updateQueue = null, i.dependencies = null, i.stateNode = null, i.selfBaseDuration = 0, i.treeBaseDuration = 0;
      else {
        i.childLanes = f.childLanes, i.lanes = f.lanes, i.child = f.child, i.subtreeFlags = Lr, i.deletions = null, i.memoizedProps = f.memoizedProps, i.memoizedState = f.memoizedState, i.updateQueue = f.updateQueue, i.type = f.type;
        var b = f.dependencies;
        i.dependencies = b === null ? null : {
          lanes: b.lanes,
          firstContext: b.firstContext
        }, i.selfBaseDuration = f.selfBaseDuration, i.treeBaseDuration = f.treeBaseDuration;
      }
      return i;
    }
    function rw(i, a, f) {
      var b;
      return i === jv ? (b = nn, a === !0 && (b |= Bn, b |= zi)) : b = Vr, bo && (b |= Ur), us(w, null, null, b);
    }
    function sb(i, a, f, b, S, O) {
      var J = P, pe = i;
      if (typeof i == "function")
        ib(i) ? (J = C, pe = Z0(pe)) : pe = Cf(pe);
      else if (typeof i == "string")
        J = L;
      else
        e:
          switch (i) {
            case Bo:
              return Tu(f.children, S, O, a);
            case $o:
              J = W, S |= Bn, (S & nn) !== Vr && (S |= zi);
              break;
            case Me:
              return nw(f, S, O, a);
            case Qr:
              return ow(f, S, O, a);
            case Ir:
              return iw(f, S, O, a);
            case on:
              return EE(f, S, O, a);
            case zo:
            case An:
            case ea:
            case $c:
            case mr:
            default: {
              if (typeof i == "object" && i !== null)
                switch (i.$$typeof) {
                  case wt:
                    J = V;
                    break e;
                  case ur:
                    J = H;
                    break e;
                  case jr:
                    J = N, pe = eb(pe);
                    break e;
                  case $r:
                    J = ue;
                    break e;
                  case Dr:
                    J = ve, pe = null;
                    break e;
                }
              var me = "";
              {
                (i === void 0 || typeof i == "object" && i !== null && Object.keys(i).length === 0) && (me += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
                var Se = b ? en(b) : null;
                Se && (me += `

Check the render method of \`` + Se + "`.");
              }
              throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (i == null ? i : typeof i) + "." + me));
            }
          }
      var _e = us(J, f, a, S);
      return _e.elementType = i, _e.type = pe, _e.lanes = O, _e._debugOwner = b, _e;
    }
    function ab(i, a, f) {
      var b = null;
      b = i._owner;
      var S = i.type, O = i.key, J = i.props, pe = sb(S, O, J, b, a, f);
      return pe._debugSource = i._source, pe._debugOwner = i._owner, pe;
    }
    function Tu(i, a, f, b) {
      var S = us($, i, b, a);
      return S.lanes = f, S;
    }
    function nw(i, a, f, b) {
      typeof i.id != "string" && c('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof i.id);
      var S = us(B, i, b, a | Ur);
      return S.elementType = Me, S.lanes = f, S.stateNode = {
        effectDuration: 0,
        passiveEffectDuration: 0
      }, S;
    }
    function ow(i, a, f, b) {
      var S = us(K, i, b, a);
      return S.elementType = Qr, S.lanes = f, S;
    }
    function iw(i, a, f, b) {
      var S = us(Ce, i, b, a);
      return S.elementType = Ir, S.lanes = f, S;
    }
    function EE(i, a, f, b) {
      var S = us(ke, i, b, a);
      S.elementType = on, S.lanes = f;
      var O = {
        isHidden: !1
      };
      return S.stateNode = O, S;
    }
    function lb(i, a, f) {
      var b = us(M, i, null, a);
      return b.lanes = f, b;
    }
    function sw() {
      var i = us(L, null, null, Vr);
      return i.elementType = "DELETED", i;
    }
    function aw(i) {
      var a = us(Pe, null, null, Vr);
      return a.stateNode = i, a;
    }
    function ub(i, a, f) {
      var b = i.children !== null ? i.children : [], S = us(R, b, i.key, a);
      return S.lanes = f, S.stateNode = {
        containerInfo: i.containerInfo,
        pendingChildren: null,
        // Used by persistent updates
        implementation: i.implementation
      }, S;
    }
    function CE(i, a) {
      return i === null && (i = us(P, null, null, Vr)), i.tag = a.tag, i.key = a.key, i.elementType = a.elementType, i.type = a.type, i.stateNode = a.stateNode, i.return = a.return, i.child = a.child, i.sibling = a.sibling, i.index = a.index, i.ref = a.ref, i.pendingProps = a.pendingProps, i.memoizedProps = a.memoizedProps, i.updateQueue = a.updateQueue, i.memoizedState = a.memoizedState, i.dependencies = a.dependencies, i.mode = a.mode, i.flags = a.flags, i.subtreeFlags = a.subtreeFlags, i.deletions = a.deletions, i.lanes = a.lanes, i.childLanes = a.childLanes, i.alternate = a.alternate, i.actualDuration = a.actualDuration, i.actualStartTime = a.actualStartTime, i.selfBaseDuration = a.selfBaseDuration, i.treeBaseDuration = a.treeBaseDuration, i._debugSource = a._debugSource, i._debugOwner = a._debugOwner, i._debugNeedsRemount = a._debugNeedsRemount, i._debugHookTypes = a._debugHookTypes, i;
    }
    function lw(i, a, f, b, S) {
      this.tag = a, this.containerInfo = i, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = Ug, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = un, this.eventTimes = Ad(mt), this.expirationTimes = Ad(kn), this.pendingLanes = mt, this.suspendedLanes = mt, this.pingedLanes = mt, this.expiredLanes = mt, this.mutableReadLanes = mt, this.finishedLanes = mt, this.entangledLanes = mt, this.entanglements = Ad(mt), this.identifierPrefix = b, this.onRecoverableError = S, this.mutableSourceEagerHydrationData = null, this.effectDuration = 0, this.passiveEffectDuration = 0;
      {
        this.memoizedUpdaters = /* @__PURE__ */ new Set();
        for (var O = this.pendingUpdatersLaneMap = [], J = 0; J < Mn; J++)
          O.push(/* @__PURE__ */ new Set());
      }
      switch (a) {
        case jv:
          this._debugRootType = f ? "hydrateRoot()" : "createRoot()";
          break;
        case lu:
          this._debugRootType = f ? "hydrate()" : "render()";
          break;
      }
    }
    function SE(i, a, f, b, S, O, J, pe, me, Se) {
      var _e = new lw(i, a, f, pe, me), ze = rw(a, O);
      _e.current = ze, ze.stateNode = _e;
      {
        var Le = {
          element: b,
          isDehydrated: f,
          cache: null,
          // not enabled yet
          transitions: null,
          pendingSuspenseBoundaries: null
        };
        ze.memoizedState = Le;
      }
      return vx(ze), _e;
    }
    var cb = "18.2.0";
    function uw(i, a, f) {
      var b = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      return Hr(b), {
        // This tag allow us to uniquely identify this as a React Portal
        $$typeof: Gn,
        key: b == null ? null : "" + b,
        children: i,
        containerInfo: a,
        implementation: f
      };
    }
    var db, fb;
    db = !1, fb = {};
    function PE(i) {
      if (!i)
        return ls;
      var a = Di(i), f = GS(a);
      if (a.tag === C) {
        var b = a.type;
        if (Ra(b))
          return Qb(a, b, f);
      }
      return f;
    }
    function cw(i, a) {
      {
        var f = Di(i);
        if (f === void 0) {
          if (typeof i.render == "function")
            throw new Error("Unable to find node on an unmounted component.");
          var b = Object.keys(i).join(",");
          throw new Error("Argument appears to not be a ReactComponent. Keys: " + b);
        }
        var S = Bi(f);
        if (S === null)
          return null;
        if (S.mode & Bn) {
          var O = en(f) || "Component";
          if (!fb[O]) {
            fb[O] = !0;
            var J = Xn;
            try {
              Sn(S), f.mode & Bn ? c("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", a, a, O) : c("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", a, a, O);
            } finally {
              J ? Sn(J) : ro();
            }
          }
        }
        return S.stateNode;
      }
    }
    function RE(i, a, f, b, S, O, J, pe) {
      var me = !1, Se = null;
      return SE(i, a, me, Se, f, b, S, O, J);
    }
    function _E(i, a, f, b, S, O, J, pe, me, Se) {
      var _e = !0, ze = SE(f, b, _e, i, S, O, J, pe, me);
      ze.context = PE(null);
      var Le = ze.current, qe = wi(), Ke = xu(Le), rt = yl(qe, Ke);
      return rt.callback = a ?? null, du(Le, rt, Ke), y_(ze, Ke, qe), ze;
    }
    function Fh(i, a, f, b) {
      Mm(a, i);
      var S = a.current, O = wi(), J = xu(S);
      Ya(J);
      var pe = PE(f);
      a.context === null ? a.context = pe : a.pendingContext = pe, Mi && Xn !== null && !db && (db = !0, c(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, en(Xn) || "Unknown"));
      var me = yl(O, J);
      me.payload = {
        element: i
      }, b = b === void 0 ? null : b, b !== null && (typeof b != "function" && c("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", b), me.callback = b);
      var Se = du(S, me, J);
      return Se !== null && (ko(Se, S, J, O), Wv(Se, S, J)), J;
    }
    function Dy(i) {
      var a = i.current;
      if (!a.child)
        return null;
      switch (a.child.tag) {
        case L:
          return a.child.stateNode;
        default:
          return a.child.stateNode;
      }
    }
    function dw(i) {
      switch (i.tag) {
        case w: {
          var a = i.stateNode;
          if (so(a)) {
            var f = ug(a);
            T_(a, f);
          }
          break;
        }
        case K: {
          Tl(function() {
            var S = qi(i, Wr);
            if (S !== null) {
              var O = wi();
              ko(S, i, Wr, O);
            }
          });
          var b = Wr;
          pb(i, b);
          break;
        }
      }
    }
    function wE(i, a) {
      var f = i.memoizedState;
      f !== null && f.dehydrated !== null && (f.retryLane = Wm(f.retryLane, a));
    }
    function pb(i, a) {
      wE(i, a);
      var f = i.alternate;
      f && wE(f, a);
    }
    function fw(i) {
      if (i.tag === K) {
        var a = Bl, f = qi(i, a);
        if (f !== null) {
          var b = wi();
          ko(f, i, a, b);
        }
        pb(i, a);
      }
    }
    function pw(i) {
      if (i.tag === K) {
        var a = xu(i), f = qi(i, a);
        if (f !== null) {
          var b = wi();
          ko(f, i, a, b);
        }
        pb(i, a);
      }
    }
    function kE(i) {
      var a = Am(i);
      return a === null ? null : a.stateNode;
    }
    var AE = function(i) {
      return null;
    };
    function hw(i) {
      return AE(i);
    }
    var $E = function(i) {
      return !1;
    };
    function mw(i) {
      return $E(i);
    }
    var jE = null, ME = null, NE = null, OE = null, DE = null, IE = null, FE = null, LE = null, BE = null;
    {
      var zE = function(i, a, f) {
        var b = a[f], S = co(i) ? i.slice() : sn({}, i);
        return f + 1 === a.length ? (co(S) ? S.splice(b, 1) : delete S[b], S) : (S[b] = zE(i[b], a, f + 1), S);
      }, VE = function(i, a) {
        return zE(i, a, 0);
      }, UE = function(i, a, f, b) {
        var S = a[b], O = co(i) ? i.slice() : sn({}, i);
        if (b + 1 === a.length) {
          var J = f[b];
          O[J] = O[S], co(O) ? O.splice(S, 1) : delete O[S];
        } else
          O[S] = UE(
            // $FlowFixMe number or string is fine here
            i[S],
            a,
            f,
            b + 1
          );
        return O;
      }, HE = function(i, a, f) {
        if (a.length !== f.length) {
          l("copyWithRename() expects paths of the same length");
          return;
        } else
          for (var b = 0; b < f.length - 1; b++)
            if (a[b] !== f[b]) {
              l("copyWithRename() expects paths to be the same except for the deepest key");
              return;
            }
        return UE(i, a, f, 0);
      }, WE = function(i, a, f, b) {
        if (f >= a.length)
          return b;
        var S = a[f], O = co(i) ? i.slice() : sn({}, i);
        return O[S] = WE(i[S], a, f + 1, b), O;
      }, GE = function(i, a, f) {
        return WE(i, a, 0, f);
      }, hb = function(i, a) {
        for (var f = i.memoizedState; f !== null && a > 0; )
          f = f.next, a--;
        return f;
      };
      jE = function(i, a, f, b) {
        var S = hb(i, a);
        if (S !== null) {
          var O = GE(S.memoizedState, f, b);
          S.memoizedState = O, S.baseState = O, i.memoizedProps = sn({}, i.memoizedProps);
          var J = qi(i, Wr);
          J !== null && ko(J, i, Wr, kn);
        }
      }, ME = function(i, a, f) {
        var b = hb(i, a);
        if (b !== null) {
          var S = VE(b.memoizedState, f);
          b.memoizedState = S, b.baseState = S, i.memoizedProps = sn({}, i.memoizedProps);
          var O = qi(i, Wr);
          O !== null && ko(O, i, Wr, kn);
        }
      }, NE = function(i, a, f, b) {
        var S = hb(i, a);
        if (S !== null) {
          var O = HE(S.memoizedState, f, b);
          S.memoizedState = O, S.baseState = O, i.memoizedProps = sn({}, i.memoizedProps);
          var J = qi(i, Wr);
          J !== null && ko(J, i, Wr, kn);
        }
      }, OE = function(i, a, f) {
        i.pendingProps = GE(i.memoizedProps, a, f), i.alternate && (i.alternate.pendingProps = i.pendingProps);
        var b = qi(i, Wr);
        b !== null && ko(b, i, Wr, kn);
      }, DE = function(i, a) {
        i.pendingProps = VE(i.memoizedProps, a), i.alternate && (i.alternate.pendingProps = i.pendingProps);
        var f = qi(i, Wr);
        f !== null && ko(f, i, Wr, kn);
      }, IE = function(i, a, f) {
        i.pendingProps = HE(i.memoizedProps, a, f), i.alternate && (i.alternate.pendingProps = i.pendingProps);
        var b = qi(i, Wr);
        b !== null && ko(b, i, Wr, kn);
      }, FE = function(i) {
        var a = qi(i, Wr);
        a !== null && ko(a, i, Wr, kn);
      }, LE = function(i) {
        AE = i;
      }, BE = function(i) {
        $E = i;
      };
    }
    function vw(i) {
      var a = Bi(i);
      return a === null ? null : a.stateNode;
    }
    function yw(i) {
      return null;
    }
    function gw() {
      return Xn;
    }
    function xw(i) {
      var a = i.findFiberByHostInstance, f = n.ReactCurrentDispatcher;
      return dp({
        bundleType: i.bundleType,
        version: i.version,
        rendererPackageName: i.rendererPackageName,
        rendererConfig: i.rendererConfig,
        overrideHookState: jE,
        overrideHookStateDeletePath: ME,
        overrideHookStateRenamePath: NE,
        overrideProps: OE,
        overridePropsDeletePath: DE,
        overridePropsRenamePath: IE,
        setErrorHandler: LE,
        setSuspenseHandler: BE,
        scheduleUpdate: FE,
        currentDispatcherRef: f,
        findHostInstanceByFiber: vw,
        findFiberByHostInstance: a || yw,
        // React Refresh
        findHostInstancesForRefresh: K_,
        scheduleRefresh: Y_,
        scheduleRoot: q_,
        setRefreshHandler: G_,
        // Enables DevTools to append owner stacks to error messages in DEV mode.
        getCurrentFiber: gw,
        // Enables DevTools to detect reconciler version rather than renderer version
        // which may not match for third party renderers.
        reconcilerVersion: cb
      });
    }
    var YE = typeof reportError == "function" ? (
      // In modern browsers, reportError will dispatch an error event,
      // emulating an uncaught JavaScript error.
      reportError
    ) : function(i) {
      console.error(i);
    };
    function mb(i) {
      this._internalRoot = i;
    }
    Iy.prototype.render = mb.prototype.render = function(i) {
      var a = this._internalRoot;
      if (a === null)
        throw new Error("Cannot update an unmounted root.");
      {
        typeof arguments[1] == "function" ? c("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : Fy(arguments[1]) ? c("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : typeof arguments[1] < "u" && c("You passed a second argument to root.render(...) but it only accepts one argument.");
        var f = a.containerInfo;
        if (f.nodeType !== Qn) {
          var b = kE(a.current);
          b && b.parentNode !== f && c("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
        }
      }
      Fh(i, a, null, null);
    }, Iy.prototype.unmount = mb.prototype.unmount = function() {
      typeof arguments[0] == "function" && c("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
      var i = this._internalRoot;
      if (i !== null) {
        this._internalRoot = null;
        var a = i.containerInfo;
        iE() && c("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), Tl(function() {
          Fh(null, i, null, null);
        }), Gb(a);
      }
    };
    function bw(i, a) {
      if (!Fy(i))
        throw new Error("createRoot(...): Target container is not a DOM element.");
      qE(i);
      var f = !1, b = !1, S = "", O = YE;
      a != null && (a.hydrate ? l("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : typeof a == "object" && a !== null && a.$$typeof === Fn && c(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`), a.unstable_strictMode === !0 && (f = !0), a.identifierPrefix !== void 0 && (S = a.identifierPrefix), a.onRecoverableError !== void 0 && (O = a.onRecoverableError), a.transitionCallbacks !== void 0 && a.transitionCallbacks);
      var J = RE(i, jv, null, f, b, S, O);
      Pv(J.current, i);
      var pe = i.nodeType === Qn ? i.parentNode : i;
      return Gp(pe), new mb(J);
    }
    function Iy(i) {
      this._internalRoot = i;
    }
    function Tw(i) {
      i && Zm(i);
    }
    Iy.prototype.unstable_scheduleHydration = Tw;
    function Ew(i, a, f) {
      if (!Fy(i))
        throw new Error("hydrateRoot(...): Target container is not a DOM element.");
      qE(i), a === void 0 && c("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
      var b = f ?? null, S = f != null && f.hydratedSources || null, O = !1, J = !1, pe = "", me = YE;
      f != null && (f.unstable_strictMode === !0 && (O = !0), f.identifierPrefix !== void 0 && (pe = f.identifierPrefix), f.onRecoverableError !== void 0 && (me = f.onRecoverableError));
      var Se = _E(a, null, i, jv, b, O, J, pe, me);
      if (Pv(Se.current, i), Gp(i), S)
        for (var _e = 0; _e < S.length; _e++) {
          var ze = S[_e];
          AP(Se, ze);
        }
      return new Iy(Se);
    }
    function Fy(i) {
      return !!(i && (i.nodeType === ti || i.nodeType === rs || i.nodeType === Fa || !Ie));
    }
    function Lh(i) {
      return !!(i && (i.nodeType === ti || i.nodeType === rs || i.nodeType === Fa || i.nodeType === Qn && i.nodeValue === " react-mount-point-unstable "));
    }
    function qE(i) {
      i.nodeType === ti && i.tagName && i.tagName.toUpperCase() === "BODY" && c("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."), nh(i) && (i._reactRootContainer ? c("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : c("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    var Cw = n.ReactCurrentOwner, KE;
    KE = function(i) {
      if (i._reactRootContainer && i.nodeType !== Qn) {
        var a = kE(i._reactRootContainer.current);
        a && a.parentNode !== i && c("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
      }
      var f = !!i._reactRootContainer, b = vb(i), S = !!(b && su(b));
      S && !f && c("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), i.nodeType === ti && i.tagName && i.tagName.toUpperCase() === "BODY" && c("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function vb(i) {
      return i ? i.nodeType === rs ? i.documentElement : i.firstChild : null;
    }
    function XE() {
    }
    function Sw(i, a, f, b, S) {
      if (S) {
        if (typeof b == "function") {
          var O = b;
          b = function() {
            var Le = Dy(J);
            O.call(Le);
          };
        }
        var J = _E(
          a,
          b,
          i,
          lu,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          XE
        );
        i._reactRootContainer = J, Pv(J.current, i);
        var pe = i.nodeType === Qn ? i.parentNode : i;
        return Gp(pe), Tl(), J;
      } else {
        for (var me; me = i.lastChild; )
          i.removeChild(me);
        if (typeof b == "function") {
          var Se = b;
          b = function() {
            var Le = Dy(_e);
            Se.call(Le);
          };
        }
        var _e = RE(
          i,
          lu,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          XE
        );
        i._reactRootContainer = _e, Pv(_e.current, i);
        var ze = i.nodeType === Qn ? i.parentNode : i;
        return Gp(ze), Tl(function() {
          Fh(a, _e, f, b);
        }), _e;
      }
    }
    function Pw(i, a) {
      i !== null && typeof i != "function" && c("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", a, i);
    }
    function Ly(i, a, f, b, S) {
      KE(f), Pw(S === void 0 ? null : S, "render");
      var O = f._reactRootContainer, J;
      if (!O)
        J = Sw(f, a, i, S, b);
      else {
        if (J = O, typeof S == "function") {
          var pe = S;
          S = function() {
            var me = Dy(J);
            pe.call(me);
          };
        }
        Fh(a, J, i, S);
      }
      return Dy(J);
    }
    function Rw(i) {
      {
        var a = Cw.current;
        if (a !== null && a.stateNode !== null) {
          var f = a.stateNode._warnedAboutRefsInRender;
          f || c("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", _n(a.type) || "A component"), a.stateNode._warnedAboutRefsInRender = !0;
        }
      }
      return i == null ? null : i.nodeType === ti ? i : cw(i, "findDOMNode");
    }
    function _w(i, a, f) {
      if (c("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Lh(a))
        throw new Error("Target container is not a DOM element.");
      {
        var b = nh(a) && a._reactRootContainer === void 0;
        b && c("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
      }
      return Ly(null, i, a, !0, f);
    }
    function ww(i, a, f) {
      if (c("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Lh(a))
        throw new Error("Target container is not a DOM element.");
      {
        var b = nh(a) && a._reactRootContainer === void 0;
        b && c("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
      }
      return Ly(null, i, a, !1, f);
    }
    function kw(i, a, f, b) {
      if (c("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Lh(f))
        throw new Error("Target container is not a DOM element.");
      if (i == null || !Uu(i))
        throw new Error("parentComponent must be a valid React Component");
      return Ly(i, a, f, !1, b);
    }
    function Aw(i) {
      if (!Lh(i))
        throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
      {
        var a = nh(i) && i._reactRootContainer === void 0;
        a && c("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
      }
      if (i._reactRootContainer) {
        {
          var f = vb(i), b = f && !su(f);
          b && c("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
        }
        return Tl(function() {
          Ly(null, null, i, !1, function() {
            i._reactRootContainer = null, Gb(i);
          });
        }), !0;
      } else {
        {
          var S = vb(i), O = !!(S && su(S)), J = i.nodeType === ti && Lh(i.parentNode) && !!i.parentNode._reactRootContainer;
          O && c("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", J ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
        }
        return !1;
      }
    }
    Cr(dw), Ym(fw), oc(pw), wp(Ui), Km(tc), (typeof Map != "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach != "function" || typeof Set != "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear != "function" || typeof Set.prototype.forEach != "function") && c("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), _m(jC), Qc(G0, E_, Tl);
    function $w(i, a) {
      var f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!Fy(a))
        throw new Error("Target container is not a DOM element.");
      return uw(i, a, null, f);
    }
    function jw(i, a, f, b) {
      return kw(i, a, f, b);
    }
    var yb = {
      usingClientEntryPoint: !1,
      // Keep in sync with ReactTestUtils.js.
      // This is an array for better minification.
      Events: [su, Zd, Rv, Xc, Bu, G0]
    };
    function Mw(i, a) {
      return yb.usingClientEntryPoint || c('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), bw(i, a);
    }
    function Nw(i, a, f) {
      return yb.usingClientEntryPoint || c('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), Ew(i, a, f);
    }
    function Ow(i) {
      return iE() && c("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), Tl(i);
    }
    var Dw = xw({
      findFiberByHostInstance: hc,
      bundleType: 1,
      version: cb,
      rendererPackageName: "react-dom"
    });
    if (!Dw && xt && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1)) {
      var QE = window.location.protocol;
      /^(https?|file):$/.test(QE) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (QE === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq` : ""), "font-weight:bold");
    }
    reactDom_development.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = yb, reactDom_development.createPortal = $w, reactDom_development.createRoot = Mw, reactDom_development.findDOMNode = Rw, reactDom_development.flushSync = Ow, reactDom_development.hydrate = _w, reactDom_development.hydrateRoot = Nw, reactDom_development.render = ww, reactDom_development.unmountComponentAtNode = Aw, reactDom_development.unstable_batchedUpdates = G0, reactDom_development.unstable_renderSubtreeIntoContainer = jw, reactDom_development.version = cb, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), reactDom_development;
}
function checkDCE() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
    if (process.env.NODE_ENV !== "production")
      throw new Error("^_^");
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (e) {
      console.error(e);
    }
  }
}
process.env.NODE_ENV === "production" ? (checkDCE(), reactDom.exports = requireReactDom_production_min()) : reactDom.exports = requireReactDom_development();
var reactDomExports = reactDom.exports;
const ReactDOM = /* @__PURE__ */ getDefaultExportFromCjs(reactDomExports), config = {
  disabled: !1
};
var timeoutsShape = process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
process.env.NODE_ENV !== "production" && PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]);
const TransitionGroupContext = React__default.createContext(null);
var forceReflow = function(t) {
  return t.scrollTop;
}, UNMOUNTED = "unmounted", EXITED = "exited", ENTERING = "entering", ENTERED = "entered", EXITING = "exiting", Transition = /* @__PURE__ */ function(e) {
  _inheritsLoose$1(t, e);
  function t(o, s) {
    var l;
    l = e.call(this, o, s) || this;
    var c = s, p = c && !c.isMounting ? o.enter : o.appear, m;
    return l.appearStatus = null, o.in ? p ? (m = EXITED, l.appearStatus = ENTERING) : m = ENTERED : o.unmountOnExit || o.mountOnEnter ? m = UNMOUNTED : m = EXITED, l.state = {
      status: m
    }, l.nextCallback = null, l;
  }
  t.getDerivedStateFromProps = function(s, l) {
    var c = s.in;
    return c && l.status === UNMOUNTED ? {
      status: EXITED
    } : null;
  };
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, n.componentDidUpdate = function(s) {
    var l = null;
    if (s !== this.props) {
      var c = this.state.status;
      this.props.in ? c !== ENTERING && c !== ENTERED && (l = ENTERING) : (c === ENTERING || c === ENTERED) && (l = EXITING);
    }
    this.updateStatus(!1, l);
  }, n.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, n.getTimeouts = function() {
    var s = this.props.timeout, l, c, p;
    return l = c = p = s, s != null && typeof s != "number" && (l = s.exit, c = s.enter, p = s.appear !== void 0 ? s.appear : c), {
      exit: l,
      enter: c,
      appear: p
    };
  }, n.updateStatus = function(s, l) {
    if (s === void 0 && (s = !1), l !== null)
      if (this.cancelNextCallback(), l === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var c = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
          c && forceReflow(c);
        }
        this.performEnter(s);
      } else
        this.performExit();
    else
      this.props.unmountOnExit && this.state.status === EXITED && this.setState({
        status: UNMOUNTED
      });
  }, n.performEnter = function(s) {
    var l = this, c = this.props.enter, p = this.context ? this.context.isMounting : s, m = this.props.nodeRef ? [p] : [ReactDOM.findDOMNode(this), p], C = m[0], P = m[1], w = this.getTimeouts(), R = p ? w.appear : w.enter;
    if (!s && !c || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function() {
        l.props.onEntered(C);
      });
      return;
    }
    this.props.onEnter(C, P), this.safeSetState({
      status: ENTERING
    }, function() {
      l.props.onEntering(C, P), l.onTransitionEnd(R, function() {
        l.safeSetState({
          status: ENTERED
        }, function() {
          l.props.onEntered(C, P);
        });
      });
    });
  }, n.performExit = function() {
    var s = this, l = this.props.exit, c = this.getTimeouts(), p = this.props.nodeRef ? void 0 : ReactDOM.findDOMNode(this);
    if (!l || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function() {
        s.props.onExited(p);
      });
      return;
    }
    this.props.onExit(p), this.safeSetState({
      status: EXITING
    }, function() {
      s.props.onExiting(p), s.onTransitionEnd(c.exit, function() {
        s.safeSetState({
          status: EXITED
        }, function() {
          s.props.onExited(p);
        });
      });
    });
  }, n.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, n.safeSetState = function(s, l) {
    l = this.setNextCallback(l), this.setState(s, l);
  }, n.setNextCallback = function(s) {
    var l = this, c = !0;
    return this.nextCallback = function(p) {
      c && (c = !1, l.nextCallback = null, s(p));
    }, this.nextCallback.cancel = function() {
      c = !1;
    }, this.nextCallback;
  }, n.onTransitionEnd = function(s, l) {
    this.setNextCallback(l);
    var c = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this), p = s == null && !this.props.addEndListener;
    if (!c || p) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var m = this.props.nodeRef ? [this.nextCallback] : [c, this.nextCallback], C = m[0], P = m[1];
      this.props.addEndListener(C, P);
    }
    s != null && setTimeout(this.nextCallback, s);
  }, n.render = function() {
    var s = this.state.status;
    if (s === UNMOUNTED)
      return null;
    var l = this.props, c = l.children;
    l.in, l.mountOnEnter, l.unmountOnExit, l.appear, l.enter, l.exit, l.timeout, l.addEndListener, l.onEnter, l.onEntering, l.onEntered, l.onExit, l.onExiting, l.onExited, l.nodeRef;
    var p = _objectWithoutPropertiesLoose$3(l, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof c == "function" ? c(s, p) : React__default.cloneElement(React__default.Children.only(c), p))
    );
  }, t;
}(React__default.Component);
Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element > "u" ? PropTypes.any : function(e, t, n, o, s, l) {
      var c = e[t];
      return PropTypes.instanceOf(c && "ownerDocument" in c ? c.ownerDocument.defaultView.Element : Element)(e, t, n, o, s, l);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(t) {
    var n = timeoutsShape;
    t.addEndListener || (n = n.isRequired);
    for (var o = arguments.length, s = new Array(o > 1 ? o - 1 : 0), l = 1; l < o; l++)
      s[l - 1] = arguments[l];
    return n.apply(void 0, [t].concat(s));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {};
function noop$2() {
}
Transition.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: noop$2,
  onEntering: noop$2,
  onEntered: noop$2,
  onExit: noop$2,
  onExiting: noop$2,
  onExited: noop$2
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
const Transition$1 = Transition;
function _assertThisInitialized(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function getChildMapping(e, t) {
  var n = function(l) {
    return t && isValidElement(l) ? t(l) : l;
  }, o = /* @__PURE__ */ Object.create(null);
  return e && Children.map(e, function(s) {
    return s;
  }).forEach(function(s) {
    o[s.key] = n(s);
  }), o;
}
function mergeChildMappings(e, t) {
  e = e || {}, t = t || {};
  function n(P) {
    return P in t ? t[P] : e[P];
  }
  var o = /* @__PURE__ */ Object.create(null), s = [];
  for (var l in e)
    l in t ? s.length && (o[l] = s, s = []) : s.push(l);
  var c, p = {};
  for (var m in t) {
    if (o[m])
      for (c = 0; c < o[m].length; c++) {
        var C = o[m][c];
        p[o[m][c]] = n(C);
      }
    p[m] = n(m);
  }
  for (c = 0; c < s.length; c++)
    p[s[c]] = n(s[c]);
  return p;
}
function getProp(e, t, n) {
  return n[t] != null ? n[t] : e.props[t];
}
function getInitialChildMapping(e, t) {
  return getChildMapping(e.children, function(n) {
    return cloneElement(n, {
      onExited: t.bind(null, n),
      in: !0,
      appear: getProp(n, "appear", e),
      enter: getProp(n, "enter", e),
      exit: getProp(n, "exit", e)
    });
  });
}
function getNextChildMapping(e, t, n) {
  var o = getChildMapping(e.children), s = mergeChildMappings(t, o);
  return Object.keys(s).forEach(function(l) {
    var c = s[l];
    if (isValidElement(c)) {
      var p = l in t, m = l in o, C = t[l], P = isValidElement(C) && !C.props.in;
      m && (!p || P) ? s[l] = cloneElement(c, {
        onExited: n.bind(null, c),
        in: !0,
        exit: getProp(c, "exit", e),
        enter: getProp(c, "enter", e)
      }) : !m && p && !P ? s[l] = cloneElement(c, {
        in: !1
      }) : m && p && isValidElement(C) && (s[l] = cloneElement(c, {
        onExited: n.bind(null, c),
        in: C.props.in,
        exit: getProp(c, "exit", e),
        enter: getProp(c, "enter", e)
      }));
    }
  }), s;
}
var values = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, defaultProps$1 = {
  component: "div",
  childFactory: function(t) {
    return t;
  }
}, TransitionGroup = /* @__PURE__ */ function(e) {
  _inheritsLoose$1(t, e);
  function t(o, s) {
    var l;
    l = e.call(this, o, s) || this;
    var c = l.handleExited.bind(_assertThisInitialized(l));
    return l.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: c,
      firstRender: !0
    }, l;
  }
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, n.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(s, l) {
    var c = l.children, p = l.handleExited, m = l.firstRender;
    return {
      children: m ? getInitialChildMapping(s, p) : getNextChildMapping(s, c, p),
      firstRender: !1
    };
  }, n.handleExited = function(s, l) {
    var c = getChildMapping(this.props.children);
    s.key in c || (s.props.onExited && s.props.onExited(l), this.mounted && this.setState(function(p) {
      var m = _extends$5({}, p.children);
      return delete m[s.key], {
        children: m
      };
    }));
  }, n.render = function() {
    var s = this.props, l = s.component, c = s.childFactory, p = _objectWithoutPropertiesLoose$3(s, ["component", "childFactory"]), m = this.state.contextValue, C = values(this.state.children).map(c);
    return delete p.appear, delete p.enter, delete p.exit, l === null ? /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
      value: m
    }, C) : /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
      value: m
    }, /* @__PURE__ */ React__default.createElement(l, p, C));
  }, t;
}(React__default.Component);
TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes.func
} : {};
TransitionGroup.defaultProps = defaultProps$1;
const TransitionGroup$1 = TransitionGroup, reflow = (e) => e.scrollTop;
function getTransitionProps(e, t) {
  var n, o;
  const {
    timeout: s,
    easing: l,
    style: c = {}
  } = e;
  return {
    duration: (n = c.transitionDuration) != null ? n : typeof s == "number" ? s : s[t.mode] || 0,
    easing: (o = c.transitionTimingFunction) != null ? o : typeof l == "object" ? l[t.mode] : l,
    delay: c.transitionDelay
  };
}
function getCollapseUtilityClass(e) {
  return generateUtilityClass$1("MuiCollapse", e);
}
generateUtilityClasses$1("MuiCollapse", ["root", "horizontal", "vertical", "entered", "hidden", "wrapper", "wrapperInner"]);
const _excluded$N = ["addEndListener", "children", "className", "collapsedSize", "component", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "orientation", "style", "timeout", "TransitionComponent"], useUtilityClasses$A = (e) => {
  const {
    orientation: t,
    classes: n
  } = e, o = {
    root: ["root", `${t}`],
    entered: ["entered"],
    hidden: ["hidden"],
    wrapper: ["wrapper", `${t}`],
    wrapperInner: ["wrapperInner", `${t}`]
  };
  return composeClasses(o, getCollapseUtilityClass, n);
}, CollapseRoot = E("div", {
  name: "MuiCollapse",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.orientation], n.state === "entered" && t.entered, n.state === "exited" && !n.in && n.collapsedSize === "0px" && t.hidden];
  }
})(({
  theme: e,
  ownerState: t
}) => _extends$5({
  height: 0,
  overflow: "hidden",
  transition: e.transitions.create("height")
}, t.orientation === "horizontal" && {
  height: "auto",
  width: 0,
  transition: e.transitions.create("width")
}, t.state === "entered" && _extends$5({
  height: "auto",
  overflow: "visible"
}, t.orientation === "horizontal" && {
  width: "auto"
}), t.state === "exited" && !t.in && t.collapsedSize === "0px" && {
  visibility: "hidden"
})), CollapseWrapper = E("div", {
  name: "MuiCollapse",
  slot: "Wrapper",
  overridesResolver: (e, t) => t.wrapper
})(({
  ownerState: e
}) => _extends$5({
  // Hack to get children with a negative margin to not falsify the height computation.
  display: "flex",
  width: "100%"
}, e.orientation === "horizontal" && {
  width: "auto",
  height: "100%"
})), CollapseWrapperInner = E("div", {
  name: "MuiCollapse",
  slot: "WrapperInner",
  overridesResolver: (e, t) => t.wrapperInner
})(({
  ownerState: e
}) => _extends$5({
  width: "100%"
}, e.orientation === "horizontal" && {
  width: "auto",
  height: "100%"
})), Collapse = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  const o = useThemeProps({
    props: t,
    name: "MuiCollapse"
  }), {
    addEndListener: s,
    children: l,
    className: c,
    collapsedSize: p = "0px",
    component: m,
    easing: C,
    in: P,
    onEnter: w,
    onEntered: R,
    onEntering: L,
    onExit: M,
    onExited: $,
    onExiting: W,
    orientation: H = "vertical",
    style: V,
    timeout: N = duration.standard,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: B = Transition$1
  } = o, K = _objectWithoutPropertiesLoose$3(o, _excluded$N), ue = _extends$5({}, o, {
    orientation: H,
    collapsedSize: p
  }), de = useUtilityClasses$A(ue), ve = useTheme$1(), Te = useTimeout(), Pe = React$2.useRef(null), Ce = React$2.useRef(), Re = typeof p == "number" ? `${p}px` : p, ke = H === "horizontal", Ae = ke ? "width" : "height", we = React$2.useRef(null), he = useForkRef(n, we), be = (Oe) => (Ze) => {
    if (Oe) {
      const et = we.current;
      Ze === void 0 ? Oe(et) : Oe(et, Ze);
    }
  }, le = () => Pe.current ? Pe.current[ke ? "clientWidth" : "clientHeight"] : 0, fe = be((Oe, Ze) => {
    Pe.current && ke && (Pe.current.style.position = "absolute"), Oe.style[Ae] = Re, w && w(Oe, Ze);
  }), ye = be((Oe, Ze) => {
    const et = le();
    Pe.current && ke && (Pe.current.style.position = "");
    const {
      duration: bt,
      easing: rr
    } = getTransitionProps({
      style: V,
      timeout: N,
      easing: C
    }, {
      mode: "enter"
    });
    if (N === "auto") {
      const St = ve.transitions.getAutoHeightDuration(et);
      Oe.style.transitionDuration = `${St}ms`, Ce.current = St;
    } else
      Oe.style.transitionDuration = typeof bt == "string" ? bt : `${bt}ms`;
    Oe.style[Ae] = `${et}px`, Oe.style.transitionTimingFunction = rr, L && L(Oe, Ze);
  }), Ee = be((Oe, Ze) => {
    Oe.style[Ae] = "auto", R && R(Oe, Ze);
  }), Ie = be((Oe) => {
    Oe.style[Ae] = `${le()}px`, M && M(Oe);
  }), Fe = be($), De = be((Oe) => {
    const Ze = le(), {
      duration: et,
      easing: bt
    } = getTransitionProps({
      style: V,
      timeout: N,
      easing: C
    }, {
      mode: "exit"
    });
    if (N === "auto") {
      const rr = ve.transitions.getAutoHeightDuration(Ze);
      Oe.style.transitionDuration = `${rr}ms`, Ce.current = rr;
    } else
      Oe.style.transitionDuration = typeof et == "string" ? et : `${et}ms`;
    Oe.style[Ae] = Re, Oe.style.transitionTimingFunction = bt, W && W(Oe);
  }), Ve = (Oe) => {
    N === "auto" && Te.start(Ce.current || 0, Oe), s && s(we.current, Oe);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(B, _extends$5({
    in: P,
    onEnter: fe,
    onEntered: Ee,
    onEntering: ye,
    onExit: Ie,
    onExited: Fe,
    onExiting: De,
    addEndListener: Ve,
    nodeRef: we,
    timeout: N === "auto" ? null : N
  }, K, {
    children: (Oe, Ze) => /* @__PURE__ */ jsxRuntimeExports.jsx(CollapseRoot, _extends$5({
      as: m,
      className: clsx$1(de.root, c, {
        entered: de.entered,
        exited: !P && Re === "0px" && de.hidden
      }[Oe]),
      style: _extends$5({
        [ke ? "minWidth" : "minHeight"]: Re
      }, V),
      ref: he
    }, Ze, {
      // `ownerState` is set after `childProps` to override any existing `ownerState` property in `childProps`
      // that might have been forwarded from the Transition component.
      ownerState: _extends$5({}, ue, {
        state: Oe
      }),
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(CollapseWrapper, {
        ownerState: _extends$5({}, ue, {
          state: Oe
        }),
        className: de.wrapper,
        ref: Pe,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(CollapseWrapperInner, {
          ownerState: _extends$5({}, ue, {
            state: Oe
          }),
          className: de.wrapperInner,
          children: l
        })
      })
    }))
  }));
});
process.env.NODE_ENV !== "production" && (Collapse.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes.func,
  /**
   * The content node to be collapsed.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The width (horizontal) or height (vertical) of the container when collapsed.
   * @default '0px'
   */
  collapsedSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef$1,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes.func,
  /**
   * @ignore
   */
  onEntered: PropTypes.func,
  /**
   * @ignore
   */
  onEntering: PropTypes.func,
  /**
   * @ignore
   */
  onExit: PropTypes.func,
  /**
   * @ignore
   */
  onExited: PropTypes.func,
  /**
   * @ignore
   */
  onExiting: PropTypes.func,
  /**
   * The transition orientation.
   * @default 'vertical'
   */
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default duration.standard
   */
  timeout: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
});
Collapse.muiSupportAuto = !0;
const Collapse$1 = Collapse;
function getPaperUtilityClass(e) {
  return generateUtilityClass$1("MuiPaper", e);
}
generateUtilityClasses$1("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const _excluded$M = ["className", "component", "elevation", "square", "variant"], useUtilityClasses$z = (e) => {
  const {
    square: t,
    elevation: n,
    variant: o,
    classes: s
  } = e, l = {
    root: ["root", o, !t && "rounded", o === "elevation" && `elevation${n}`]
  };
  return composeClasses(l, getPaperUtilityClass, s);
}, PaperRoot = E("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], !n.square && t.rounded, n.variant === "elevation" && t[`elevation${n.elevation}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var n;
  return _extends$5({
    backgroundColor: (e.vars || e).palette.background.paper,
    color: (e.vars || e).palette.text.primary,
    transition: e.transitions.create("box-shadow")
  }, !t.square && {
    borderRadius: e.shape.borderRadius
  }, t.variant === "outlined" && {
    border: `1px solid ${(e.vars || e).palette.divider}`
  }, t.variant === "elevation" && _extends$5({
    boxShadow: (e.vars || e).shadows[t.elevation]
  }, !e.vars && e.palette.mode === "dark" && {
    backgroundImage: `linear-gradient(${alpha_1("#fff", getOverlayAlpha$1(t.elevation))}, ${alpha_1("#fff", getOverlayAlpha$1(t.elevation))})`
  }, e.vars && {
    backgroundImage: (n = e.vars.overlays) == null ? void 0 : n[t.elevation]
  }));
}), Paper = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  const o = useThemeProps({
    props: t,
    name: "MuiPaper"
  }), {
    className: s,
    component: l = "div",
    elevation: c = 1,
    square: p = !1,
    variant: m = "elevation"
  } = o, C = _objectWithoutPropertiesLoose$3(o, _excluded$M), P = _extends$5({}, o, {
    component: l,
    elevation: c,
    square: p,
    variant: m
  }), w = useUtilityClasses$z(P);
  return process.env.NODE_ENV !== "production" && useTheme$1().shadows[c] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${c}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${c}]\` is defined.`].join(`
`)), /* @__PURE__ */ jsxRuntimeExports.jsx(PaperRoot, _extends$5({
    as: l,
    ownerState: P,
    className: clsx$1(w.root, s),
    ref: n
  }, C));
});
process.env.NODE_ENV !== "production" && (Paper.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: chainPropTypes(integerPropType, (e) => {
    const {
      elevation: t,
      variant: n
    } = e;
    return t > 0 && n === "outlined" ? new Error(`MUI: Combining \`elevation={${t}}\` with \`variant="${n}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["elevation", "outlined"]), PropTypes.string])
});
const Paper$1 = Paper, AccordionContext = /* @__PURE__ */ React$2.createContext({});
process.env.NODE_ENV !== "production" && (AccordionContext.displayName = "AccordionContext");
const AccordionContext$1 = AccordionContext;
function isHostComponent(e) {
  return typeof e == "string";
}
function appendOwnerState(e, t, n) {
  return e === void 0 || isHostComponent(e) ? t : _extends$5({}, t, {
    ownerState: _extends$5({}, t.ownerState, n)
  });
}
function areArraysEqual(e, t, n = (o, s) => o === s) {
  return e.length === t.length && e.every((o, s) => n(o, t[s]));
}
const defaultContextValue = {
  disableDefaultClasses: !1
}, ClassNameConfiguratorContext = /* @__PURE__ */ React$2.createContext(defaultContextValue);
process.env.NODE_ENV !== "production" && (ClassNameConfiguratorContext.displayName = "ClassNameConfiguratorContext");
function useClassNamesOverride(e) {
  const {
    disableDefaultClasses: t
  } = React$2.useContext(ClassNameConfiguratorContext);
  return (n) => t ? "" : e(n);
}
function extractEventHandlers(e, t = []) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((o) => o.match(/^on[A-Z]/) && typeof e[o] == "function" && !t.includes(o)).forEach((o) => {
    n[o] = e[o];
  }), n;
}
function resolveComponentProps(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
function omitEventHandlers(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((n) => !(n.match(/^on[A-Z]/) && typeof e[n] == "function")).forEach((n) => {
    t[n] = e[n];
  }), t;
}
function mergeSlotProps(e) {
  const {
    getSlotProps: t,
    additionalProps: n,
    externalSlotProps: o,
    externalForwardedProps: s,
    className: l
  } = e;
  if (!t) {
    const L = clsx$1(n == null ? void 0 : n.className, l, s == null ? void 0 : s.className, o == null ? void 0 : o.className), M = _extends$5({}, n == null ? void 0 : n.style, s == null ? void 0 : s.style, o == null ? void 0 : o.style), $ = _extends$5({}, n, s, o);
    return L.length > 0 && ($.className = L), Object.keys(M).length > 0 && ($.style = M), {
      props: $,
      internalRef: void 0
    };
  }
  const c = extractEventHandlers(_extends$5({}, s, o)), p = omitEventHandlers(o), m = omitEventHandlers(s), C = t(c), P = clsx$1(C == null ? void 0 : C.className, n == null ? void 0 : n.className, l, s == null ? void 0 : s.className, o == null ? void 0 : o.className), w = _extends$5({}, C == null ? void 0 : C.style, n == null ? void 0 : n.style, s == null ? void 0 : s.style, o == null ? void 0 : o.style), R = _extends$5({}, C, n, m, p);
  return P.length > 0 && (R.className = P), Object.keys(w).length > 0 && (R.style = w), {
    props: R,
    internalRef: C.ref
  };
}
const _excluded$L = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function useSlotProps(e) {
  var t;
  const {
    elementType: n,
    externalSlotProps: o,
    ownerState: s,
    skipResolvingSlotProps: l = !1
  } = e, c = _objectWithoutPropertiesLoose$3(e, _excluded$L), p = l ? {} : resolveComponentProps(o, s), {
    props: m,
    internalRef: C
  } = mergeSlotProps(_extends$5({}, c, {
    externalSlotProps: p
  })), P = useForkRef(C, p == null ? void 0 : p.ref, (t = e.additionalProps) == null ? void 0 : t.ref);
  return appendOwnerState(n, _extends$5({}, m, {
    ref: P
  }), s);
}
const _excluded$K = ["className", "elementType", "ownerState", "externalForwardedProps", "getSlotOwnerState", "internalForwardedProps"], _excluded2$6 = ["component", "slots", "slotProps"], _excluded3$3 = ["component"];
function useSlot(e, t) {
  const {
    className: n,
    elementType: o,
    ownerState: s,
    externalForwardedProps: l,
    getSlotOwnerState: c,
    internalForwardedProps: p
  } = t, m = _objectWithoutPropertiesLoose$3(t, _excluded$K), {
    component: C,
    slots: P = {
      [e]: void 0
    },
    slotProps: w = {
      [e]: void 0
    }
  } = l, R = _objectWithoutPropertiesLoose$3(l, _excluded2$6), L = P[e] || o, M = resolveComponentProps(w[e], s), $ = mergeSlotProps(_extends$5({
    className: n
  }, m, {
    externalForwardedProps: e === "root" ? R : void 0,
    externalSlotProps: M
  })), {
    props: {
      component: W
    },
    internalRef: H
  } = $, V = _objectWithoutPropertiesLoose$3($.props, _excluded3$3), N = useForkRef(H, M == null ? void 0 : M.ref, t.ref), B = c ? c(V) : {}, K = _extends$5({}, s, B), ue = e === "root" ? W || C : W, de = appendOwnerState(L, _extends$5({}, e === "root" && !C && !P[e] && p, e !== "root" && !P[e] && p, V, ue && {
    as: ue
  }, {
    ref: N
  }), K);
  return Object.keys(B).forEach((ve) => {
    delete de[ve];
  }), [L, de];
}
function getAccordionUtilityClass(e) {
  return generateUtilityClass$1("MuiAccordion", e);
}
const accordionClasses = generateUtilityClasses$1("MuiAccordion", ["root", "rounded", "expanded", "disabled", "gutters", "region"]), accordionClasses$1 = accordionClasses, _excluded$J = ["children", "className", "defaultExpanded", "disabled", "disableGutters", "expanded", "onChange", "square", "slots", "slotProps", "TransitionComponent", "TransitionProps"], useUtilityClasses$y = (e) => {
  const {
    classes: t,
    square: n,
    expanded: o,
    disabled: s,
    disableGutters: l
  } = e;
  return composeClasses({
    root: ["root", !n && "rounded", o && "expanded", s && "disabled", !l && "gutters"],
    region: ["region"]
  }, getAccordionUtilityClass, t);
}, AccordionRoot = E(Paper$1, {
  name: "MuiAccordion",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${accordionClasses$1.region}`]: t.region
    }, t.root, !n.square && t.rounded, !n.disableGutters && t.gutters];
  }
})(({
  theme: e
}) => {
  const t = {
    duration: e.transitions.duration.shortest
  };
  return {
    position: "relative",
    transition: e.transitions.create(["margin"], t),
    overflowAnchor: "none",
    // Keep the same scrolling position
    "&::before": {
      position: "absolute",
      left: 0,
      top: -1,
      right: 0,
      height: 1,
      content: '""',
      opacity: 1,
      backgroundColor: (e.vars || e).palette.divider,
      transition: e.transitions.create(["opacity", "background-color"], t)
    },
    "&:first-of-type": {
      "&::before": {
        display: "none"
      }
    },
    [`&.${accordionClasses$1.expanded}`]: {
      "&::before": {
        opacity: 0
      },
      "&:first-of-type": {
        marginTop: 0
      },
      "&:last-of-type": {
        marginBottom: 0
      },
      "& + &": {
        "&::before": {
          display: "none"
        }
      }
    },
    [`&.${accordionClasses$1.disabled}`]: {
      backgroundColor: (e.vars || e).palette.action.disabledBackground
    }
  };
}, ({
  theme: e,
  ownerState: t
}) => _extends$5({}, !t.square && {
  borderRadius: 0,
  "&:first-of-type": {
    borderTopLeftRadius: (e.vars || e).shape.borderRadius,
    borderTopRightRadius: (e.vars || e).shape.borderRadius
  },
  "&:last-of-type": {
    borderBottomLeftRadius: (e.vars || e).shape.borderRadius,
    borderBottomRightRadius: (e.vars || e).shape.borderRadius,
    // Fix a rendering issue on Edge
    "@supports (-ms-ime-align: auto)": {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0
    }
  }
}, !t.disableGutters && {
  [`&.${accordionClasses$1.expanded}`]: {
    margin: "16px 0"
  }
})), Accordion = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  const o = useThemeProps({
    props: t,
    name: "MuiAccordion"
  }), {
    children: s,
    className: l,
    defaultExpanded: c = !1,
    disabled: p = !1,
    disableGutters: m = !1,
    expanded: C,
    onChange: P,
    square: w = !1,
    slots: R = {},
    slotProps: L = {},
    TransitionComponent: M,
    TransitionProps: $
  } = o, W = _objectWithoutPropertiesLoose$3(o, _excluded$J), [H, V] = useControlled({
    controlled: C,
    default: c,
    name: "Accordion",
    state: "expanded"
  }), N = React$2.useCallback((ke) => {
    V(!H), P && P(ke, !H);
  }, [H, P, V]), [B, ...K] = React$2.Children.toArray(s), ue = React$2.useMemo(() => ({
    expanded: H,
    disabled: p,
    disableGutters: m,
    toggle: N
  }), [H, p, m, N]), de = _extends$5({}, o, {
    square: w,
    disabled: p,
    disableGutters: m,
    expanded: H
  }), ve = useUtilityClasses$y(de), Te = _extends$5({
    transition: M
  }, R), Pe = _extends$5({
    transition: $
  }, L), [Ce, Re] = useSlot("transition", {
    elementType: Collapse$1,
    externalForwardedProps: {
      slots: Te,
      slotProps: Pe
    },
    ownerState: de
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(AccordionRoot, _extends$5({
    className: clsx$1(ve.root, l),
    ref: n,
    ownerState: de,
    square: w
  }, W, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(AccordionContext$1.Provider, {
      value: ue,
      children: B
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(Ce, _extends$5({
      in: H,
      timeout: "auto"
    }, Re, {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
        "aria-labelledby": B.props.id,
        id: B.props["aria-controls"],
        role: "region",
        className: ve.region,
        children: K
      })
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (Accordion.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: chainPropTypes(PropTypes.node.isRequired, (e) => {
    const t = React$2.Children.toArray(e.children)[0];
    return reactIsExports.isFragment(t) ? new Error("MUI: The Accordion doesn't accept a Fragment as a child. Consider providing an array instead.") : /* @__PURE__ */ React$2.isValidElement(t) ? null : new Error("MUI: Expected the first child of Accordion to be a valid element.");
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, expands the accordion by default.
   * @default false
   */
  defaultExpanded: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, it removes the margin between two expanded accordion items and the increase of height.
   * @default false
   */
  disableGutters: PropTypes.bool,
  /**
   * If `true`, expands the accordion, otherwise collapse it.
   * Setting this prop enables control over the accordion.
   */
  expanded: PropTypes.bool,
  /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {boolean} expanded The `expanded` state of the accordion.
   */
  onChange: PropTypes.func,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    transition: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    transition: PropTypes.elementType
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   */
  TransitionProps: PropTypes.object
});
const Accordion$1 = Accordion;
function getAccordionDetailsUtilityClass(e) {
  return generateUtilityClass$1("MuiAccordionDetails", e);
}
generateUtilityClasses$1("MuiAccordionDetails", ["root"]);
const _excluded$I = ["className"], useUtilityClasses$x = (e) => {
  const {
    classes: t
  } = e;
  return composeClasses({
    root: ["root"]
  }, getAccordionDetailsUtilityClass, t);
}, AccordionDetailsRoot = E("div", {
  name: "MuiAccordionDetails",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  padding: e.spacing(1, 2, 2)
})), AccordionDetails = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  const o = useThemeProps({
    props: t,
    name: "MuiAccordionDetails"
  }), {
    className: s
  } = o, l = _objectWithoutPropertiesLoose$3(o, _excluded$I), c = o, p = useUtilityClasses$x(c);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AccordionDetailsRoot, _extends$5({
    className: clsx$1(p.root, s),
    ref: n,
    ownerState: c
  }, l));
});
process.env.NODE_ENV !== "production" && (AccordionDetails.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const AccordionDetails$1 = AccordionDetails;
function Ripple(e) {
  const {
    className: t,
    classes: n,
    pulsate: o = !1,
    rippleX: s,
    rippleY: l,
    rippleSize: c,
    in: p,
    onExited: m,
    timeout: C
  } = e, [P, w] = React$2.useState(!1), R = clsx$1(t, n.ripple, n.rippleVisible, o && n.ripplePulsate), L = {
    width: c,
    height: c,
    top: -(c / 2) + l,
    left: -(c / 2) + s
  }, M = clsx$1(n.child, P && n.childLeaving, o && n.childPulsate);
  return !p && !P && w(!0), React$2.useEffect(() => {
    if (!p && m != null) {
      const $ = setTimeout(m, C);
      return () => {
        clearTimeout($);
      };
    }
  }, [m, p, C]), /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
    className: R,
    style: L,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      className: M
    })
  });
}
process.env.NODE_ENV !== "production" && (Ripple.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: PropTypes.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: PropTypes.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: PropTypes.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: PropTypes.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: PropTypes.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: PropTypes.number,
  /**
   * exit delay
   */
  timeout: PropTypes.number.isRequired
});
const touchRippleClasses = generateUtilityClasses$1("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), touchRippleClasses$1 = touchRippleClasses, _excluded$H = ["center", "classes", "className"];
let _ = (e) => e, _t$1, _t2, _t3, _t4;
const DURATION = 550, DELAY_RIPPLE = 80, enterKeyframe = keyframes(_t$1 || (_t$1 = _`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`)), exitKeyframe = keyframes(_t2 || (_t2 = _`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`)), pulsateKeyframe = keyframes(_t3 || (_t3 = _`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`)), TouchRippleRoot = E("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), TouchRippleRipple = E(Ripple, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})(_t4 || (_t4 = _`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), touchRippleClasses$1.rippleVisible, enterKeyframe, DURATION, ({
  theme: e
}) => e.transitions.easing.easeInOut, touchRippleClasses$1.ripplePulsate, ({
  theme: e
}) => e.transitions.duration.shorter, touchRippleClasses$1.child, touchRippleClasses$1.childLeaving, exitKeyframe, DURATION, ({
  theme: e
}) => e.transitions.easing.easeInOut, touchRippleClasses$1.childPulsate, pulsateKeyframe, ({
  theme: e
}) => e.transitions.easing.easeInOut), TouchRipple = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  const o = useThemeProps({
    props: t,
    name: "MuiTouchRipple"
  }), {
    center: s = !1,
    classes: l = {},
    className: c
  } = o, p = _objectWithoutPropertiesLoose$3(o, _excluded$H), [m, C] = React$2.useState([]), P = React$2.useRef(0), w = React$2.useRef(null);
  React$2.useEffect(() => {
    w.current && (w.current(), w.current = null);
  }, [m]);
  const R = React$2.useRef(!1), L = useTimeout(), M = React$2.useRef(null), $ = React$2.useRef(null), W = React$2.useCallback((B) => {
    const {
      pulsate: K,
      rippleX: ue,
      rippleY: de,
      rippleSize: ve,
      cb: Te
    } = B;
    C((Pe) => [...Pe, /* @__PURE__ */ jsxRuntimeExports.jsx(TouchRippleRipple, {
      classes: {
        ripple: clsx$1(l.ripple, touchRippleClasses$1.ripple),
        rippleVisible: clsx$1(l.rippleVisible, touchRippleClasses$1.rippleVisible),
        ripplePulsate: clsx$1(l.ripplePulsate, touchRippleClasses$1.ripplePulsate),
        child: clsx$1(l.child, touchRippleClasses$1.child),
        childLeaving: clsx$1(l.childLeaving, touchRippleClasses$1.childLeaving),
        childPulsate: clsx$1(l.childPulsate, touchRippleClasses$1.childPulsate)
      },
      timeout: DURATION,
      pulsate: K,
      rippleX: ue,
      rippleY: de,
      rippleSize: ve
    }, P.current)]), P.current += 1, w.current = Te;
  }, [l]), H = React$2.useCallback((B = {}, K = {}, ue = () => {
  }) => {
    const {
      pulsate: de = !1,
      center: ve = s || K.pulsate,
      fakeElement: Te = !1
      // For test purposes
    } = K;
    if ((B == null ? void 0 : B.type) === "mousedown" && R.current) {
      R.current = !1;
      return;
    }
    (B == null ? void 0 : B.type) === "touchstart" && (R.current = !0);
    const Pe = Te ? null : $.current, Ce = Pe ? Pe.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let Re, ke, Ae;
    if (ve || B === void 0 || B.clientX === 0 && B.clientY === 0 || !B.clientX && !B.touches)
      Re = Math.round(Ce.width / 2), ke = Math.round(Ce.height / 2);
    else {
      const {
        clientX: we,
        clientY: he
      } = B.touches && B.touches.length > 0 ? B.touches[0] : B;
      Re = Math.round(we - Ce.left), ke = Math.round(he - Ce.top);
    }
    if (ve)
      Ae = Math.sqrt((2 * Ce.width ** 2 + Ce.height ** 2) / 3), Ae % 2 === 0 && (Ae += 1);
    else {
      const we = Math.max(Math.abs((Pe ? Pe.clientWidth : 0) - Re), Re) * 2 + 2, he = Math.max(Math.abs((Pe ? Pe.clientHeight : 0) - ke), ke) * 2 + 2;
      Ae = Math.sqrt(we ** 2 + he ** 2);
    }
    B != null && B.touches ? M.current === null && (M.current = () => {
      W({
        pulsate: de,
        rippleX: Re,
        rippleY: ke,
        rippleSize: Ae,
        cb: ue
      });
    }, L.start(DELAY_RIPPLE, () => {
      M.current && (M.current(), M.current = null);
    })) : W({
      pulsate: de,
      rippleX: Re,
      rippleY: ke,
      rippleSize: Ae,
      cb: ue
    });
  }, [s, W, L]), V = React$2.useCallback(() => {
    H({}, {
      pulsate: !0
    });
  }, [H]), N = React$2.useCallback((B, K) => {
    if (L.clear(), (B == null ? void 0 : B.type) === "touchend" && M.current) {
      M.current(), M.current = null, L.start(0, () => {
        N(B, K);
      });
      return;
    }
    M.current = null, C((ue) => ue.length > 0 ? ue.slice(1) : ue), w.current = K;
  }, [L]);
  return React$2.useImperativeHandle(n, () => ({
    pulsate: V,
    start: H,
    stop: N
  }), [V, H, N]), /* @__PURE__ */ jsxRuntimeExports.jsx(TouchRippleRoot, _extends$5({
    className: clsx$1(touchRippleClasses$1.root, l.root, c),
    ref: $
  }, p, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(TransitionGroup$1, {
      component: null,
      exit: !0,
      children: m
    })
  }));
});
process.env.NODE_ENV !== "production" && (TouchRipple.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string
});
const TouchRipple$1 = TouchRipple;
function getButtonBaseUtilityClass(e) {
  return generateUtilityClass$1("MuiButtonBase", e);
}
const buttonBaseClasses = generateUtilityClasses$1("MuiButtonBase", ["root", "disabled", "focusVisible"]), buttonBaseClasses$1 = buttonBaseClasses, _excluded$G = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "touchRippleRef", "type"], useUtilityClasses$w = (e) => {
  const {
    disabled: t,
    focusVisible: n,
    focusVisibleClassName: o,
    classes: s
  } = e, c = composeClasses({
    root: ["root", t && "disabled", n && "focusVisible"]
  }, getButtonBaseUtilityClass, s);
  return n && o && (c.root += ` ${o}`), c;
}, ButtonBaseRoot = E("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${buttonBaseClasses$1.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), ButtonBase = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  const o = useThemeProps({
    props: t,
    name: "MuiButtonBase"
  }), {
    action: s,
    centerRipple: l = !1,
    children: c,
    className: p,
    component: m = "button",
    disabled: C = !1,
    disableRipple: P = !1,
    disableTouchRipple: w = !1,
    focusRipple: R = !1,
    LinkComponent: L = "a",
    onBlur: M,
    onClick: $,
    onContextMenu: W,
    onDragLeave: H,
    onFocus: V,
    onFocusVisible: N,
    onKeyDown: B,
    onKeyUp: K,
    onMouseDown: ue,
    onMouseLeave: de,
    onMouseUp: ve,
    onTouchEnd: Te,
    onTouchMove: Pe,
    onTouchStart: Ce,
    tabIndex: Re = 0,
    TouchRippleProps: ke,
    touchRippleRef: Ae,
    type: we
  } = o, he = _objectWithoutPropertiesLoose$3(o, _excluded$G), be = React$2.useRef(null), le = React$2.useRef(null), fe = useForkRef(le, Ae), {
    isFocusVisibleRef: ye,
    onFocus: Ee,
    onBlur: Ie,
    ref: Fe
  } = useIsFocusVisible(), [De, Ve] = React$2.useState(!1);
  C && De && Ve(!1), React$2.useImperativeHandle(s, () => ({
    focusVisible: () => {
      Ve(!0), be.current.focus();
    }
  }), []);
  const [Oe, Ze] = React$2.useState(!1);
  React$2.useEffect(() => {
    Ze(!0);
  }, []);
  const et = Oe && !P && !C;
  React$2.useEffect(() => {
    De && R && !P && Oe && le.current.pulsate();
  }, [P, R, De, Oe]);
  function bt(Je, tr, pt = w) {
    return useEventCallback((ir) => (tr && tr(ir), !pt && le.current && le.current[Je](ir), !0));
  }
  const rr = bt("start", ue), St = bt("stop", W), Qe = bt("stop", H), xt = bt("stop", ve), je = bt("stop", (Je) => {
    De && Je.preventDefault(), de && de(Je);
  }), kt = bt("start", Ce), cr = bt("stop", Te), Tr = bt("stop", Pe), Er = bt("stop", (Je) => {
    Ie(Je), ye.current === !1 && Ve(!1), M && M(Je);
  }, !1), Hr = useEventCallback((Je) => {
    be.current || (be.current = Je.currentTarget), Ee(Je), ye.current === !0 && (Ve(!0), N && N(Je)), V && V(Je);
  }), Br = () => {
    const Je = be.current;
    return m && m !== "button" && !(Je.tagName === "A" && Je.href);
  }, hr = React$2.useRef(!1), Gr = useEventCallback((Je) => {
    R && !hr.current && De && le.current && Je.key === " " && (hr.current = !0, le.current.stop(Je, () => {
      le.current.start(Je);
    })), Je.target === Je.currentTarget && Br() && Je.key === " " && Je.preventDefault(), B && B(Je), Je.target === Je.currentTarget && Br() && Je.key === "Enter" && !C && (Je.preventDefault(), $ && $(Je));
  }), Yr = useEventCallback((Je) => {
    R && Je.key === " " && le.current && De && !Je.defaultPrevented && (hr.current = !1, le.current.stop(Je, () => {
      le.current.pulsate(Je);
    })), K && K(Je), $ && Je.target === Je.currentTarget && Br() && Je.key === " " && !Je.defaultPrevented && $(Je);
  });
  let tt = m;
  tt === "button" && (he.href || he.to) && (tt = L);
  const ar = {};
  tt === "button" ? (ar.type = we === void 0 ? "button" : we, ar.disabled = C) : (!he.href && !he.to && (ar.role = "button"), C && (ar["aria-disabled"] = C));
  const wr = useForkRef(n, Fe, be);
  process.env.NODE_ENV !== "production" && React$2.useEffect(() => {
    et && !le.current && console.error(["MUI: The `component` prop provided to ButtonBase is invalid.", "Please make sure the children prop is rendered in this custom component."].join(`
`));
  }, [et]);
  const Sr = _extends$5({}, o, {
    centerRipple: l,
    component: m,
    disabled: C,
    disableRipple: P,
    disableTouchRipple: w,
    focusRipple: R,
    tabIndex: Re,
    focusVisible: De
  }), Ye = useUtilityClasses$w(Sr);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ButtonBaseRoot, _extends$5({
    as: tt,
    className: clsx$1(Ye.root, p),
    ownerState: Sr,
    onBlur: Er,
    onClick: $,
    onContextMenu: St,
    onFocus: Hr,
    onKeyDown: Gr,
    onKeyUp: Yr,
    onMouseDown: rr,
    onMouseLeave: je,
    onMouseUp: xt,
    onDragLeave: Qe,
    onTouchEnd: cr,
    onTouchMove: Tr,
    onTouchStart: kt,
    ref: wr,
    tabIndex: C ? -1 : Re,
    type: we
  }, ar, he, {
    children: [c, et ? (
      /* TouchRipple is only needed client-side, x2 boost on the server. */
      /* @__PURE__ */ jsxRuntimeExports.jsx(TouchRipple$1, _extends$5({
        ref: fe,
        center: l
      }, ke))
    ) : null]
  }));
});
process.env.NODE_ENV !== "production" && (ButtonBase.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: refType$1,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: PropTypes.bool,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef$1,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: PropTypes.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: PropTypes.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * @ignore
   */
  href: PropTypes.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: PropTypes.elementType,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * @ignore
   */
  onContextMenu: PropTypes.func,
  /**
   * @ignore
   */
  onDragLeave: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,
  /**
   * @ignore
   */
  onMouseDown: PropTypes.func,
  /**
   * @ignore
   */
  onMouseLeave: PropTypes.func,
  /**
   * @ignore
   */
  onMouseUp: PropTypes.func,
  /**
   * @ignore
   */
  onTouchEnd: PropTypes.func,
  /**
   * @ignore
   */
  onTouchMove: PropTypes.func,
  /**
   * @ignore
   */
  onTouchStart: PropTypes.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @default 0
   */
  tabIndex: PropTypes.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: PropTypes.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      pulsate: PropTypes.func.isRequired,
      start: PropTypes.func.isRequired,
      stop: PropTypes.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: PropTypes.oneOfType([PropTypes.oneOf(["button", "reset", "submit"]), PropTypes.string])
});
const ButtonBase$1 = ButtonBase;
function getAccordionSummaryUtilityClass(e) {
  return generateUtilityClass$1("MuiAccordionSummary", e);
}
const accordionSummaryClasses = generateUtilityClasses$1("MuiAccordionSummary", ["root", "expanded", "focusVisible", "disabled", "gutters", "contentGutters", "content", "expandIconWrapper"]), accordionSummaryClasses$1 = accordionSummaryClasses, _excluded$F = ["children", "className", "expandIcon", "focusVisibleClassName", "onClick"], useUtilityClasses$v = (e) => {
  const {
    classes: t,
    expanded: n,
    disabled: o,
    disableGutters: s
  } = e;
  return composeClasses({
    root: ["root", n && "expanded", o && "disabled", !s && "gutters"],
    focusVisible: ["focusVisible"],
    content: ["content", n && "expanded", !s && "contentGutters"],
    expandIconWrapper: ["expandIconWrapper", n && "expanded"]
  }, getAccordionSummaryUtilityClass, t);
}, AccordionSummaryRoot = E(ButtonBase$1, {
  name: "MuiAccordionSummary",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => {
  const n = {
    duration: e.transitions.duration.shortest
  };
  return _extends$5({
    display: "flex",
    minHeight: 48,
    padding: e.spacing(0, 2),
    transition: e.transitions.create(["min-height", "background-color"], n),
    [`&.${accordionSummaryClasses$1.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette.action.focus
    },
    [`&.${accordionSummaryClasses$1.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity
    },
    [`&:hover:not(.${accordionSummaryClasses$1.disabled})`]: {
      cursor: "pointer"
    }
  }, !t.disableGutters && {
    [`&.${accordionSummaryClasses$1.expanded}`]: {
      minHeight: 64
    }
  });
}), AccordionSummaryContent = E("div", {
  name: "MuiAccordionSummary",
  slot: "Content",
  overridesResolver: (e, t) => t.content
})(({
  theme: e,
  ownerState: t
}) => _extends$5({
  display: "flex",
  flexGrow: 1,
  margin: "12px 0"
}, !t.disableGutters && {
  transition: e.transitions.create(["margin"], {
    duration: e.transitions.duration.shortest
  }),
  [`&.${accordionSummaryClasses$1.expanded}`]: {
    margin: "20px 0"
  }
})), AccordionSummaryExpandIconWrapper = E("div", {
  name: "MuiAccordionSummary",
  slot: "ExpandIconWrapper",
  overridesResolver: (e, t) => t.expandIconWrapper
})(({
  theme: e
}) => ({
  display: "flex",
  color: (e.vars || e).palette.action.active,
  transform: "rotate(0deg)",
  transition: e.transitions.create("transform", {
    duration: e.transitions.duration.shortest
  }),
  [`&.${accordionSummaryClasses$1.expanded}`]: {
    transform: "rotate(180deg)"
  }
})), AccordionSummary = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  const o = useThemeProps({
    props: t,
    name: "MuiAccordionSummary"
  }), {
    children: s,
    className: l,
    expandIcon: c,
    focusVisibleClassName: p,
    onClick: m
  } = o, C = _objectWithoutPropertiesLoose$3(o, _excluded$F), {
    disabled: P = !1,
    disableGutters: w,
    expanded: R,
    toggle: L
  } = React$2.useContext(AccordionContext$1), M = (H) => {
    L && L(H), m && m(H);
  }, $ = _extends$5({}, o, {
    expanded: R,
    disabled: P,
    disableGutters: w
  }), W = useUtilityClasses$v($);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(AccordionSummaryRoot, _extends$5({
    focusRipple: !1,
    disableRipple: !0,
    disabled: P,
    component: "div",
    "aria-expanded": R,
    className: clsx$1(W.root, l),
    focusVisibleClassName: clsx$1(W.focusVisible, p),
    onClick: M,
    ref: n,
    ownerState: $
  }, C, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(AccordionSummaryContent, {
      className: W.content,
      ownerState: $,
      children: s
    }), c && /* @__PURE__ */ jsxRuntimeExports.jsx(AccordionSummaryExpandIconWrapper, {
      className: W.expandIconWrapper,
      ownerState: $,
      children: c
    })]
  }));
});
process.env.NODE_ENV !== "production" && (AccordionSummary.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The icon to display as the expand indicator.
   */
  expandIcon: PropTypes.node,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const AccordionSummary$1 = AccordionSummary, GLOBAL_CLASS_PREFIX = "base";
function buildStateClass(e) {
  return `${GLOBAL_CLASS_PREFIX}--${e}`;
}
function buildSlotClass(e, t) {
  return `${GLOBAL_CLASS_PREFIX}-${e}-${t}`;
}
function generateUtilityClass(e, t) {
  const n = globalStateClasses[t];
  return n ? buildStateClass(n) : buildSlotClass(e, t);
}
function generateUtilityClasses(e, t) {
  const n = {};
  return t.forEach((o) => {
    n[o] = generateUtilityClass(e, o);
  }), n;
}
const candidatesSelector = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function getTabIndex(e) {
  const t = parseInt(e.getAttribute("tabindex") || "", 10);
  return Number.isNaN(t) ? e.contentEditable === "true" || (e.nodeName === "AUDIO" || e.nodeName === "VIDEO" || e.nodeName === "DETAILS") && e.getAttribute("tabindex") === null ? 0 : e.tabIndex : t;
}
function isNonTabbableRadio(e) {
  if (e.tagName !== "INPUT" || e.type !== "radio" || !e.name)
    return !1;
  const t = (o) => e.ownerDocument.querySelector(`input[type="radio"]${o}`);
  let n = t(`[name="${e.name}"]:checked`);
  return n || (n = t(`[name="${e.name}"]`)), n !== e;
}
function isNodeMatchingSelectorFocusable(e) {
  return !(e.disabled || e.tagName === "INPUT" && e.type === "hidden" || isNonTabbableRadio(e));
}
function defaultGetTabbable(e) {
  const t = [], n = [];
  return Array.from(e.querySelectorAll(candidatesSelector)).forEach((o, s) => {
    const l = getTabIndex(o);
    l === -1 || !isNodeMatchingSelectorFocusable(o) || (l === 0 ? t.push(o) : n.push({
      documentOrder: s,
      tabIndex: l,
      node: o
    }));
  }), n.sort((o, s) => o.tabIndex === s.tabIndex ? o.documentOrder - s.documentOrder : o.tabIndex - s.tabIndex).map((o) => o.node).concat(t);
}
function defaultIsEnabled() {
  return !0;
}
function FocusTrap(e) {
  const {
    children: t,
    disableAutoFocus: n = !1,
    disableEnforceFocus: o = !1,
    disableRestoreFocus: s = !1,
    getTabbable: l = defaultGetTabbable,
    isEnabled: c = defaultIsEnabled,
    open: p
  } = e, m = React$2.useRef(!1), C = React$2.useRef(null), P = React$2.useRef(null), w = React$2.useRef(null), R = React$2.useRef(null), L = React$2.useRef(!1), M = React$2.useRef(null), $ = useForkRef(t.ref, M), W = React$2.useRef(null);
  React$2.useEffect(() => {
    !p || !M.current || (L.current = !n);
  }, [n, p]), React$2.useEffect(() => {
    if (!p || !M.current)
      return;
    const N = ownerDocument(M.current);
    return M.current.contains(N.activeElement) || (M.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), M.current.setAttribute("tabIndex", "-1")), L.current && M.current.focus()), () => {
      s || (w.current && w.current.focus && (m.current = !0, w.current.focus()), w.current = null);
    };
  }, [p]), React$2.useEffect(() => {
    if (!p || !M.current)
      return;
    const N = ownerDocument(M.current), B = (de) => {
      W.current = de, !(o || !c() || de.key !== "Tab") && N.activeElement === M.current && de.shiftKey && (m.current = !0, P.current && P.current.focus());
    }, K = () => {
      const de = M.current;
      if (de === null)
        return;
      if (!N.hasFocus() || !c() || m.current) {
        m.current = !1;
        return;
      }
      if (de.contains(N.activeElement) || o && N.activeElement !== C.current && N.activeElement !== P.current)
        return;
      if (N.activeElement !== R.current)
        R.current = null;
      else if (R.current !== null)
        return;
      if (!L.current)
        return;
      let ve = [];
      if ((N.activeElement === C.current || N.activeElement === P.current) && (ve = l(M.current)), ve.length > 0) {
        var Te, Pe;
        const Ce = !!((Te = W.current) != null && Te.shiftKey && ((Pe = W.current) == null ? void 0 : Pe.key) === "Tab"), Re = ve[0], ke = ve[ve.length - 1];
        typeof Re != "string" && typeof ke != "string" && (Ce ? ke.focus() : Re.focus());
      } else
        de.focus();
    };
    N.addEventListener("focusin", K), N.addEventListener("keydown", B, !0);
    const ue = setInterval(() => {
      N.activeElement && N.activeElement.tagName === "BODY" && K();
    }, 50);
    return () => {
      clearInterval(ue), N.removeEventListener("focusin", K), N.removeEventListener("keydown", B, !0);
    };
  }, [n, o, s, c, p, l]);
  const H = (N) => {
    w.current === null && (w.current = N.relatedTarget), L.current = !0, R.current = N.target;
    const B = t.props.onFocus;
    B && B(N);
  }, V = (N) => {
    w.current === null && (w.current = N.relatedTarget), L.current = !0;
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React$2.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      tabIndex: p ? 0 : -1,
      onFocus: V,
      ref: C,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ React$2.cloneElement(t, {
      ref: $,
      onFocus: H
    }), /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      tabIndex: p ? 0 : -1,
      onFocus: V,
      ref: P,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" && (FocusTrap.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: elementAcceptingRef$1,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: PropTypes.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: PropTypes.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: PropTypes.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: PropTypes.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: PropTypes.func,
  /**
   * If `true`, focus is locked.
   */
  open: PropTypes.bool.isRequired
});
process.env.NODE_ENV !== "production" && (FocusTrap["propTypes"] = exactProp(FocusTrap.propTypes));
function getContainer$1(e) {
  return typeof e == "function" ? e() : e;
}
const Portal = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  const {
    children: o,
    container: s,
    disablePortal: l = !1
  } = t, [c, p] = React$2.useState(null), m = useForkRef(/* @__PURE__ */ React$2.isValidElement(o) ? o.ref : null, n);
  if (useEnhancedEffect$1(() => {
    l || p(getContainer$1(s) || document.body);
  }, [s, l]), useEnhancedEffect$1(() => {
    if (c && !l)
      return setRef(n, c), () => {
        setRef(n, null);
      };
  }, [n, c, l]), l) {
    if (/* @__PURE__ */ React$2.isValidElement(o)) {
      const C = {
        ref: m
      };
      return /* @__PURE__ */ React$2.cloneElement(o, C);
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(React$2.Fragment, {
      children: o
    });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React$2.Fragment, {
    children: c && /* @__PURE__ */ reactDomExports.createPortal(o, c)
  });
});
process.env.NODE_ENV !== "production" && (Portal.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: PropTypes.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool
});
process.env.NODE_ENV !== "production" && (Portal["propTypes"] = exactProp(Portal.propTypes));
function isOverflowing(e) {
  const t = ownerDocument(e);
  return t.body === e ? ownerWindow(e).innerWidth > t.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
}
function ariaHidden(e, t) {
  t ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden");
}
function getPaddingRight(e) {
  return parseInt(ownerWindow(e).getComputedStyle(e).paddingRight, 10) || 0;
}
function isAriaHiddenForbiddenOnElement(e) {
  const n = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].indexOf(e.tagName) !== -1, o = e.tagName === "INPUT" && e.getAttribute("type") === "hidden";
  return n || o;
}
function ariaHiddenSiblings(e, t, n, o, s) {
  const l = [t, n, ...o];
  [].forEach.call(e.children, (c) => {
    const p = l.indexOf(c) === -1, m = !isAriaHiddenForbiddenOnElement(c);
    p && m && ariaHidden(c, s);
  });
}
function findIndexOf(e, t) {
  let n = -1;
  return e.some((o, s) => t(o) ? (n = s, !0) : !1), n;
}
function handleContainer(e, t) {
  const n = [], o = e.container;
  if (!t.disableScrollLock) {
    if (isOverflowing(o)) {
      const c = getScrollbarSize(ownerDocument(o));
      n.push({
        value: o.style.paddingRight,
        property: "padding-right",
        el: o
      }), o.style.paddingRight = `${getPaddingRight(o) + c}px`;
      const p = ownerDocument(o).querySelectorAll(".mui-fixed");
      [].forEach.call(p, (m) => {
        n.push({
          value: m.style.paddingRight,
          property: "padding-right",
          el: m
        }), m.style.paddingRight = `${getPaddingRight(m) + c}px`;
      });
    }
    let l;
    if (o.parentNode instanceof DocumentFragment)
      l = ownerDocument(o).body;
    else {
      const c = o.parentElement, p = ownerWindow(o);
      l = (c == null ? void 0 : c.nodeName) === "HTML" && p.getComputedStyle(c).overflowY === "scroll" ? c : o;
    }
    n.push({
      value: l.style.overflow,
      property: "overflow",
      el: l
    }, {
      value: l.style.overflowX,
      property: "overflow-x",
      el: l
    }, {
      value: l.style.overflowY,
      property: "overflow-y",
      el: l
    }), l.style.overflow = "hidden";
  }
  return () => {
    n.forEach(({
      value: l,
      el: c,
      property: p
    }) => {
      l ? c.style.setProperty(p, l) : c.style.removeProperty(p);
    });
  };
}
function getHiddenSiblings(e) {
  const t = [];
  return [].forEach.call(e.children, (n) => {
    n.getAttribute("aria-hidden") === "true" && t.push(n);
  }), t;
}
class ModalManager {
  constructor() {
    this.containers = void 0, this.modals = void 0, this.modals = [], this.containers = [];
  }
  add(t, n) {
    let o = this.modals.indexOf(t);
    if (o !== -1)
      return o;
    o = this.modals.length, this.modals.push(t), t.modalRef && ariaHidden(t.modalRef, !1);
    const s = getHiddenSiblings(n);
    ariaHiddenSiblings(n, t.mount, t.modalRef, s, !0);
    const l = findIndexOf(this.containers, (c) => c.container === n);
    return l !== -1 ? (this.containers[l].modals.push(t), o) : (this.containers.push({
      modals: [t],
      container: n,
      restore: null,
      hiddenSiblings: s
    }), o);
  }
  mount(t, n) {
    const o = findIndexOf(this.containers, (l) => l.modals.indexOf(t) !== -1), s = this.containers[o];
    s.restore || (s.restore = handleContainer(s, n));
  }
  remove(t, n = !0) {
    const o = this.modals.indexOf(t);
    if (o === -1)
      return o;
    const s = findIndexOf(this.containers, (c) => c.modals.indexOf(t) !== -1), l = this.containers[s];
    if (l.modals.splice(l.modals.indexOf(t), 1), this.modals.splice(o, 1), l.modals.length === 0)
      l.restore && l.restore(), t.modalRef && ariaHidden(t.modalRef, n), ariaHiddenSiblings(l.container, t.mount, t.modalRef, l.hiddenSiblings, !1), this.containers.splice(s, 1);
    else {
      const c = l.modals[l.modals.length - 1];
      c.modalRef && ariaHidden(c.modalRef, !1);
    }
    return o;
  }
  isTopModal(t) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === t;
  }
}
function getContainer(e) {
  return typeof e == "function" ? e() : e;
}
function getHasTransition(e) {
  return e ? e.props.hasOwnProperty("in") : !1;
}
const defaultManager = new ModalManager();
function useModal(e) {
  const {
    container: t,
    disableEscapeKeyDown: n = !1,
    disableScrollLock: o = !1,
    // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager: s = defaultManager,
    closeAfterTransition: l = !1,
    onTransitionEnter: c,
    onTransitionExited: p,
    children: m,
    onClose: C,
    open: P,
    rootRef: w
  } = e, R = React$2.useRef({}), L = React$2.useRef(null), M = React$2.useRef(null), $ = useForkRef(M, w), [W, H] = React$2.useState(!P), V = getHasTransition(m);
  let N = !0;
  (e["aria-hidden"] === "false" || e["aria-hidden"] === !1) && (N = !1);
  const B = () => ownerDocument(L.current), K = () => (R.current.modalRef = M.current, R.current.mount = L.current, R.current), ue = () => {
    s.mount(K(), {
      disableScrollLock: o
    }), M.current && (M.current.scrollTop = 0);
  }, de = useEventCallback(() => {
    const he = getContainer(t) || B().body;
    s.add(K(), he), M.current && ue();
  }), ve = React$2.useCallback(() => s.isTopModal(K()), [s]), Te = useEventCallback((he) => {
    L.current = he, he && (P && ve() ? ue() : M.current && ariaHidden(M.current, N));
  }), Pe = React$2.useCallback(() => {
    s.remove(K(), N);
  }, [N, s]);
  React$2.useEffect(() => () => {
    Pe();
  }, [Pe]), React$2.useEffect(() => {
    P ? de() : (!V || !l) && Pe();
  }, [P, Pe, V, l, de]);
  const Ce = (he) => (be) => {
    var le;
    (le = he.onKeyDown) == null || le.call(he, be), !(be.key !== "Escape" || be.which === 229 || // Wait until IME is settled.
    !ve()) && (n || (be.stopPropagation(), C && C(be, "escapeKeyDown")));
  }, Re = (he) => (be) => {
    var le;
    (le = he.onClick) == null || le.call(he, be), be.target === be.currentTarget && C && C(be, "backdropClick");
  };
  return {
    getRootProps: (he = {}) => {
      const be = extractEventHandlers(e);
      delete be.onTransitionEnter, delete be.onTransitionExited;
      const le = _extends$5({}, be, he);
      return _extends$5({
        role: "presentation"
      }, le, {
        onKeyDown: Ce(le),
        ref: $
      });
    },
    getBackdropProps: (he = {}) => {
      const be = he;
      return _extends$5({
        "aria-hidden": !0
      }, be, {
        onClick: Re(be),
        open: P
      });
    },
    getTransitionProps: () => {
      const he = () => {
        H(!1), c && c();
      }, be = () => {
        H(!0), p && p(), l && Pe();
      };
      return {
        onEnter: createChainedFunction(he, m == null ? void 0 : m.props.onEnter),
        onExited: createChainedFunction(be, m == null ? void 0 : m.props.onExited)
      };
    },
    rootRef: $,
    portalRef: Te,
    isTopModal: ve,
    exited: W,
    hasTransition: V
  };
}
var top = "top", bottom = "bottom", right = "right", left = "left", auto = "auto", basePlacements = [top, bottom, right, left], start = "start", end = "end", clippingParents = "clippingParents", viewport = "viewport", popper = "popper", reference = "reference", variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(e, t) {
  return e.concat([t + "-" + start, t + "-" + end]);
}, []), placements = /* @__PURE__ */ [].concat(basePlacements, [auto]).reduce(function(e, t) {
  return e.concat([t, t + "-" + start, t + "-" + end]);
}, []), beforeRead = "beforeRead", read = "read", afterRead = "afterRead", beforeMain = "beforeMain", main = "main", afterMain = "afterMain", beforeWrite = "beforeWrite", write = "write", afterWrite = "afterWrite", modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
function getNodeName(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function getWindow(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function isElement(e) {
  var t = getWindow(e).Element;
  return e instanceof t || e instanceof Element;
}
function isHTMLElement$1(e) {
  var t = getWindow(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function isShadowRoot(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = getWindow(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function applyStyles(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var o = t.styles[n] || {}, s = t.attributes[n] || {}, l = t.elements[n];
    !isHTMLElement$1(l) || !getNodeName(l) || (Object.assign(l.style, o), Object.keys(s).forEach(function(c) {
      var p = s[c];
      p === !1 ? l.removeAttribute(c) : l.setAttribute(c, p === !0 ? "" : p);
    }));
  });
}
function effect$2(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(o) {
      var s = t.elements[o], l = t.attributes[o] || {}, c = Object.keys(t.styles.hasOwnProperty(o) ? t.styles[o] : n[o]), p = c.reduce(function(m, C) {
        return m[C] = "", m;
      }, {});
      !isHTMLElement$1(s) || !getNodeName(s) || (Object.assign(s.style, p), Object.keys(l).forEach(function(m) {
        s.removeAttribute(m);
      }));
    });
  };
}
const applyStyles$1 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: applyStyles,
  effect: effect$2,
  requires: ["computeStyles"]
};
function getBasePlacement(e) {
  return e.split("-")[0];
}
var max$1 = Math.max, min$1 = Math.min, round$2 = Math.round;
function getUAString() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
function getBoundingClientRect(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var o = e.getBoundingClientRect(), s = 1, l = 1;
  t && isHTMLElement$1(e) && (s = e.offsetWidth > 0 && round$2(o.width) / e.offsetWidth || 1, l = e.offsetHeight > 0 && round$2(o.height) / e.offsetHeight || 1);
  var c = isElement(e) ? getWindow(e) : window, p = c.visualViewport, m = !isLayoutViewport() && n, C = (o.left + (m && p ? p.offsetLeft : 0)) / s, P = (o.top + (m && p ? p.offsetTop : 0)) / l, w = o.width / s, R = o.height / l;
  return {
    width: w,
    height: R,
    top: P,
    right: C + w,
    bottom: P + R,
    left: C,
    x: C,
    y: P
  };
}
function getLayoutRect(e) {
  var t = getBoundingClientRect(e), n = e.offsetWidth, o = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - o) <= 1 && (o = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: o
  };
}
function contains(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && isShadowRoot(n)) {
    var o = t;
    do {
      if (o && e.isSameNode(o))
        return !0;
      o = o.parentNode || o.host;
    } while (o);
  }
  return !1;
}
function getComputedStyle(e) {
  return getWindow(e).getComputedStyle(e);
}
function isTableElement(e) {
  return ["table", "td", "th"].indexOf(getNodeName(e)) >= 0;
}
function getDocumentElement(e) {
  return ((isElement(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function getParentNode(e) {
  return getNodeName(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (isShadowRoot(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(e)
  );
}
function getTrueOffsetParent(e) {
  return !isHTMLElement$1(e) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(e).position === "fixed" ? null : e.offsetParent;
}
function getContainingBlock(e) {
  var t = /firefox/i.test(getUAString()), n = /Trident/i.test(getUAString());
  if (n && isHTMLElement$1(e)) {
    var o = getComputedStyle(e);
    if (o.position === "fixed")
      return null;
  }
  var s = getParentNode(e);
  for (isShadowRoot(s) && (s = s.host); isHTMLElement$1(s) && ["html", "body"].indexOf(getNodeName(s)) < 0; ) {
    var l = getComputedStyle(s);
    if (l.transform !== "none" || l.perspective !== "none" || l.contain === "paint" || ["transform", "perspective"].indexOf(l.willChange) !== -1 || t && l.willChange === "filter" || t && l.filter && l.filter !== "none")
      return s;
    s = s.parentNode;
  }
  return null;
}
function getOffsetParent(e) {
  for (var t = getWindow(e), n = getTrueOffsetParent(e); n && isTableElement(n) && getComputedStyle(n).position === "static"; )
    n = getTrueOffsetParent(n);
  return n && (getNodeName(n) === "html" || getNodeName(n) === "body" && getComputedStyle(n).position === "static") ? t : n || getContainingBlock(e) || t;
}
function getMainAxisFromPlacement(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function within(e, t, n) {
  return max$1(e, min$1(t, n));
}
function withinMaxClamp(e, t, n) {
  var o = within(e, t, n);
  return o > n ? n : o;
}
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function mergePaddingObject(e) {
  return Object.assign({}, getFreshSideObject(), e);
}
function expandToHashMap(e, t) {
  return t.reduce(function(n, o) {
    return n[o] = e, n;
  }, {});
}
var toPaddingObject = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, mergePaddingObject(typeof t != "number" ? t : expandToHashMap(t, basePlacements));
};
function arrow(e) {
  var t, n = e.state, o = e.name, s = e.options, l = n.elements.arrow, c = n.modifiersData.popperOffsets, p = getBasePlacement(n.placement), m = getMainAxisFromPlacement(p), C = [left, right].indexOf(p) >= 0, P = C ? "height" : "width";
  if (!(!l || !c)) {
    var w = toPaddingObject(s.padding, n), R = getLayoutRect(l), L = m === "y" ? top : left, M = m === "y" ? bottom : right, $ = n.rects.reference[P] + n.rects.reference[m] - c[m] - n.rects.popper[P], W = c[m] - n.rects.reference[m], H = getOffsetParent(l), V = H ? m === "y" ? H.clientHeight || 0 : H.clientWidth || 0 : 0, N = $ / 2 - W / 2, B = w[L], K = V - R[P] - w[M], ue = V / 2 - R[P] / 2 + N, de = within(B, ue, K), ve = m;
    n.modifiersData[o] = (t = {}, t[ve] = de, t.centerOffset = de - ue, t);
  }
}
function effect$1(e) {
  var t = e.state, n = e.options, o = n.element, s = o === void 0 ? "[data-popper-arrow]" : o;
  s != null && (typeof s == "string" && (s = t.elements.popper.querySelector(s), !s) || contains(t.elements.popper, s) && (t.elements.arrow = s));
}
const arrow$1 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: arrow,
  effect: effect$1,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function getVariation(e) {
  return e.split("-")[1];
}
var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(e, t) {
  var n = e.x, o = e.y, s = t.devicePixelRatio || 1;
  return {
    x: round$2(n * s) / s || 0,
    y: round$2(o * s) / s || 0
  };
}
function mapToStyles(e) {
  var t, n = e.popper, o = e.popperRect, s = e.placement, l = e.variation, c = e.offsets, p = e.position, m = e.gpuAcceleration, C = e.adaptive, P = e.roundOffsets, w = e.isFixed, R = c.x, L = R === void 0 ? 0 : R, M = c.y, $ = M === void 0 ? 0 : M, W = typeof P == "function" ? P({
    x: L,
    y: $
  }) : {
    x: L,
    y: $
  };
  L = W.x, $ = W.y;
  var H = c.hasOwnProperty("x"), V = c.hasOwnProperty("y"), N = left, B = top, K = window;
  if (C) {
    var ue = getOffsetParent(n), de = "clientHeight", ve = "clientWidth";
    if (ue === getWindow(n) && (ue = getDocumentElement(n), getComputedStyle(ue).position !== "static" && p === "absolute" && (de = "scrollHeight", ve = "scrollWidth")), ue = ue, s === top || (s === left || s === right) && l === end) {
      B = bottom;
      var Te = w && ue === K && K.visualViewport ? K.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        ue[de]
      );
      $ -= Te - o.height, $ *= m ? 1 : -1;
    }
    if (s === left || (s === top || s === bottom) && l === end) {
      N = right;
      var Pe = w && ue === K && K.visualViewport ? K.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        ue[ve]
      );
      L -= Pe - o.width, L *= m ? 1 : -1;
    }
  }
  var Ce = Object.assign({
    position: p
  }, C && unsetSides), Re = P === !0 ? roundOffsetsByDPR({
    x: L,
    y: $
  }, getWindow(n)) : {
    x: L,
    y: $
  };
  if (L = Re.x, $ = Re.y, m) {
    var ke;
    return Object.assign({}, Ce, (ke = {}, ke[B] = V ? "0" : "", ke[N] = H ? "0" : "", ke.transform = (K.devicePixelRatio || 1) <= 1 ? "translate(" + L + "px, " + $ + "px)" : "translate3d(" + L + "px, " + $ + "px, 0)", ke));
  }
  return Object.assign({}, Ce, (t = {}, t[B] = V ? $ + "px" : "", t[N] = H ? L + "px" : "", t.transform = "", t));
}
function computeStyles(e) {
  var t = e.state, n = e.options, o = n.gpuAcceleration, s = o === void 0 ? !0 : o, l = n.adaptive, c = l === void 0 ? !0 : l, p = n.roundOffsets, m = p === void 0 ? !0 : p, C = {
    placement: getBasePlacement(t.placement),
    variation: getVariation(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: s,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, mapToStyles(Object.assign({}, C, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: c,
    roundOffsets: m
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, mapToStyles(Object.assign({}, C, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: m
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const computeStyles$1 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};
var passive = {
  passive: !0
};
function effect(e) {
  var t = e.state, n = e.instance, o = e.options, s = o.scroll, l = s === void 0 ? !0 : s, c = o.resize, p = c === void 0 ? !0 : c, m = getWindow(t.elements.popper), C = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return l && C.forEach(function(P) {
    P.addEventListener("scroll", n.update, passive);
  }), p && m.addEventListener("resize", n.update, passive), function() {
    l && C.forEach(function(P) {
      P.removeEventListener("scroll", n.update, passive);
    }), p && m.removeEventListener("resize", n.update, passive);
  };
}
const eventListeners = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect,
  data: {}
};
var hash$1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function getOppositePlacement(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return hash$1[t];
  });
}
var hash = {
  start: "end",
  end: "start"
};
function getOppositeVariationPlacement(e) {
  return e.replace(/start|end/g, function(t) {
    return hash[t];
  });
}
function getWindowScroll(e) {
  var t = getWindow(e), n = t.pageXOffset, o = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: o
  };
}
function getWindowScrollBarX(e) {
  return getBoundingClientRect(getDocumentElement(e)).left + getWindowScroll(e).scrollLeft;
}
function getViewportRect(e, t) {
  var n = getWindow(e), o = getDocumentElement(e), s = n.visualViewport, l = o.clientWidth, c = o.clientHeight, p = 0, m = 0;
  if (s) {
    l = s.width, c = s.height;
    var C = isLayoutViewport();
    (C || !C && t === "fixed") && (p = s.offsetLeft, m = s.offsetTop);
  }
  return {
    width: l,
    height: c,
    x: p + getWindowScrollBarX(e),
    y: m
  };
}
function getDocumentRect(e) {
  var t, n = getDocumentElement(e), o = getWindowScroll(e), s = (t = e.ownerDocument) == null ? void 0 : t.body, l = max$1(n.scrollWidth, n.clientWidth, s ? s.scrollWidth : 0, s ? s.clientWidth : 0), c = max$1(n.scrollHeight, n.clientHeight, s ? s.scrollHeight : 0, s ? s.clientHeight : 0), p = -o.scrollLeft + getWindowScrollBarX(e), m = -o.scrollTop;
  return getComputedStyle(s || n).direction === "rtl" && (p += max$1(n.clientWidth, s ? s.clientWidth : 0) - l), {
    width: l,
    height: c,
    x: p,
    y: m
  };
}
function isScrollParent(e) {
  var t = getComputedStyle(e), n = t.overflow, o = t.overflowX, s = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + s + o);
}
function getScrollParent(e) {
  return ["html", "body", "#document"].indexOf(getNodeName(e)) >= 0 ? e.ownerDocument.body : isHTMLElement$1(e) && isScrollParent(e) ? e : getScrollParent(getParentNode(e));
}
function listScrollParents(e, t) {
  var n;
  t === void 0 && (t = []);
  var o = getScrollParent(e), s = o === ((n = e.ownerDocument) == null ? void 0 : n.body), l = getWindow(o), c = s ? [l].concat(l.visualViewport || [], isScrollParent(o) ? o : []) : o, p = t.concat(c);
  return s ? p : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    p.concat(listScrollParents(getParentNode(c)))
  );
}
function rectToClientRect(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function getInnerBoundingClientRect(e, t) {
  var n = getBoundingClientRect(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function getClientRectFromMixedType(e, t, n) {
  return t === viewport ? rectToClientRect(getViewportRect(e, n)) : isElement(t) ? getInnerBoundingClientRect(t, n) : rectToClientRect(getDocumentRect(getDocumentElement(e)));
}
function getClippingParents(e) {
  var t = listScrollParents(getParentNode(e)), n = ["absolute", "fixed"].indexOf(getComputedStyle(e).position) >= 0, o = n && isHTMLElement$1(e) ? getOffsetParent(e) : e;
  return isElement(o) ? t.filter(function(s) {
    return isElement(s) && contains(s, o) && getNodeName(s) !== "body";
  }) : [];
}
function getClippingRect(e, t, n, o) {
  var s = t === "clippingParents" ? getClippingParents(e) : [].concat(t), l = [].concat(s, [n]), c = l[0], p = l.reduce(function(m, C) {
    var P = getClientRectFromMixedType(e, C, o);
    return m.top = max$1(P.top, m.top), m.right = min$1(P.right, m.right), m.bottom = min$1(P.bottom, m.bottom), m.left = max$1(P.left, m.left), m;
  }, getClientRectFromMixedType(e, c, o));
  return p.width = p.right - p.left, p.height = p.bottom - p.top, p.x = p.left, p.y = p.top, p;
}
function computeOffsets(e) {
  var t = e.reference, n = e.element, o = e.placement, s = o ? getBasePlacement(o) : null, l = o ? getVariation(o) : null, c = t.x + t.width / 2 - n.width / 2, p = t.y + t.height / 2 - n.height / 2, m;
  switch (s) {
    case top:
      m = {
        x: c,
        y: t.y - n.height
      };
      break;
    case bottom:
      m = {
        x: c,
        y: t.y + t.height
      };
      break;
    case right:
      m = {
        x: t.x + t.width,
        y: p
      };
      break;
    case left:
      m = {
        x: t.x - n.width,
        y: p
      };
      break;
    default:
      m = {
        x: t.x,
        y: t.y
      };
  }
  var C = s ? getMainAxisFromPlacement(s) : null;
  if (C != null) {
    var P = C === "y" ? "height" : "width";
    switch (l) {
      case start:
        m[C] = m[C] - (t[P] / 2 - n[P] / 2);
        break;
      case end:
        m[C] = m[C] + (t[P] / 2 - n[P] / 2);
        break;
    }
  }
  return m;
}
function detectOverflow(e, t) {
  t === void 0 && (t = {});
  var n = t, o = n.placement, s = o === void 0 ? e.placement : o, l = n.strategy, c = l === void 0 ? e.strategy : l, p = n.boundary, m = p === void 0 ? clippingParents : p, C = n.rootBoundary, P = C === void 0 ? viewport : C, w = n.elementContext, R = w === void 0 ? popper : w, L = n.altBoundary, M = L === void 0 ? !1 : L, $ = n.padding, W = $ === void 0 ? 0 : $, H = mergePaddingObject(typeof W != "number" ? W : expandToHashMap(W, basePlacements)), V = R === popper ? reference : popper, N = e.rects.popper, B = e.elements[M ? V : R], K = getClippingRect(isElement(B) ? B : B.contextElement || getDocumentElement(e.elements.popper), m, P, c), ue = getBoundingClientRect(e.elements.reference), de = computeOffsets({
    reference: ue,
    element: N,
    strategy: "absolute",
    placement: s
  }), ve = rectToClientRect(Object.assign({}, N, de)), Te = R === popper ? ve : ue, Pe = {
    top: K.top - Te.top + H.top,
    bottom: Te.bottom - K.bottom + H.bottom,
    left: K.left - Te.left + H.left,
    right: Te.right - K.right + H.right
  }, Ce = e.modifiersData.offset;
  if (R === popper && Ce) {
    var Re = Ce[s];
    Object.keys(Pe).forEach(function(ke) {
      var Ae = [right, bottom].indexOf(ke) >= 0 ? 1 : -1, we = [top, bottom].indexOf(ke) >= 0 ? "y" : "x";
      Pe[ke] += Re[we] * Ae;
    });
  }
  return Pe;
}
function computeAutoPlacement(e, t) {
  t === void 0 && (t = {});
  var n = t, o = n.placement, s = n.boundary, l = n.rootBoundary, c = n.padding, p = n.flipVariations, m = n.allowedAutoPlacements, C = m === void 0 ? placements : m, P = getVariation(o), w = P ? p ? variationPlacements : variationPlacements.filter(function(M) {
    return getVariation(M) === P;
  }) : basePlacements, R = w.filter(function(M) {
    return C.indexOf(M) >= 0;
  });
  R.length === 0 && (R = w);
  var L = R.reduce(function(M, $) {
    return M[$] = detectOverflow(e, {
      placement: $,
      boundary: s,
      rootBoundary: l,
      padding: c
    })[getBasePlacement($)], M;
  }, {});
  return Object.keys(L).sort(function(M, $) {
    return L[M] - L[$];
  });
}
function getExpandedFallbackPlacements(e) {
  if (getBasePlacement(e) === auto)
    return [];
  var t = getOppositePlacement(e);
  return [getOppositeVariationPlacement(e), t, getOppositeVariationPlacement(t)];
}
function flip(e) {
  var t = e.state, n = e.options, o = e.name;
  if (!t.modifiersData[o]._skip) {
    for (var s = n.mainAxis, l = s === void 0 ? !0 : s, c = n.altAxis, p = c === void 0 ? !0 : c, m = n.fallbackPlacements, C = n.padding, P = n.boundary, w = n.rootBoundary, R = n.altBoundary, L = n.flipVariations, M = L === void 0 ? !0 : L, $ = n.allowedAutoPlacements, W = t.options.placement, H = getBasePlacement(W), V = H === W, N = m || (V || !M ? [getOppositePlacement(W)] : getExpandedFallbackPlacements(W)), B = [W].concat(N).reduce(function(De, Ve) {
      return De.concat(getBasePlacement(Ve) === auto ? computeAutoPlacement(t, {
        placement: Ve,
        boundary: P,
        rootBoundary: w,
        padding: C,
        flipVariations: M,
        allowedAutoPlacements: $
      }) : Ve);
    }, []), K = t.rects.reference, ue = t.rects.popper, de = /* @__PURE__ */ new Map(), ve = !0, Te = B[0], Pe = 0; Pe < B.length; Pe++) {
      var Ce = B[Pe], Re = getBasePlacement(Ce), ke = getVariation(Ce) === start, Ae = [top, bottom].indexOf(Re) >= 0, we = Ae ? "width" : "height", he = detectOverflow(t, {
        placement: Ce,
        boundary: P,
        rootBoundary: w,
        altBoundary: R,
        padding: C
      }), be = Ae ? ke ? right : left : ke ? bottom : top;
      K[we] > ue[we] && (be = getOppositePlacement(be));
      var le = getOppositePlacement(be), fe = [];
      if (l && fe.push(he[Re] <= 0), p && fe.push(he[be] <= 0, he[le] <= 0), fe.every(function(De) {
        return De;
      })) {
        Te = Ce, ve = !1;
        break;
      }
      de.set(Ce, fe);
    }
    if (ve)
      for (var ye = M ? 3 : 1, Ee = function(Ve) {
        var Oe = B.find(function(Ze) {
          var et = de.get(Ze);
          if (et)
            return et.slice(0, Ve).every(function(bt) {
              return bt;
            });
        });
        if (Oe)
          return Te = Oe, "break";
      }, Ie = ye; Ie > 0; Ie--) {
        var Fe = Ee(Ie);
        if (Fe === "break")
          break;
      }
    t.placement !== Te && (t.modifiersData[o]._skip = !0, t.placement = Te, t.reset = !0);
  }
}
const flip$1 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: flip,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function getSideOffsets(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function isAnySideFullyClipped(e) {
  return [top, right, bottom, left].some(function(t) {
    return e[t] >= 0;
  });
}
function hide(e) {
  var t = e.state, n = e.name, o = t.rects.reference, s = t.rects.popper, l = t.modifiersData.preventOverflow, c = detectOverflow(t, {
    elementContext: "reference"
  }), p = detectOverflow(t, {
    altBoundary: !0
  }), m = getSideOffsets(c, o), C = getSideOffsets(p, s, l), P = isAnySideFullyClipped(m), w = isAnySideFullyClipped(C);
  t.modifiersData[n] = {
    referenceClippingOffsets: m,
    popperEscapeOffsets: C,
    isReferenceHidden: P,
    hasPopperEscaped: w
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": P,
    "data-popper-escaped": w
  });
}
const hide$1 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hide
};
function distanceAndSkiddingToXY(e, t, n) {
  var o = getBasePlacement(e), s = [left, top].indexOf(o) >= 0 ? -1 : 1, l = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, c = l[0], p = l[1];
  return c = c || 0, p = (p || 0) * s, [left, right].indexOf(o) >= 0 ? {
    x: p,
    y: c
  } : {
    x: c,
    y: p
  };
}
function offset$1(e) {
  var t = e.state, n = e.options, o = e.name, s = n.offset, l = s === void 0 ? [0, 0] : s, c = placements.reduce(function(P, w) {
    return P[w] = distanceAndSkiddingToXY(w, t.rects, l), P;
  }, {}), p = c[t.placement], m = p.x, C = p.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += m, t.modifiersData.popperOffsets.y += C), t.modifiersData[o] = c;
}
const offset$2 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset$1
};
function popperOffsets(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = computeOffsets({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const popperOffsets$1 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: popperOffsets,
  data: {}
};
function getAltAxis(e) {
  return e === "x" ? "y" : "x";
}
function preventOverflow(e) {
  var t = e.state, n = e.options, o = e.name, s = n.mainAxis, l = s === void 0 ? !0 : s, c = n.altAxis, p = c === void 0 ? !1 : c, m = n.boundary, C = n.rootBoundary, P = n.altBoundary, w = n.padding, R = n.tether, L = R === void 0 ? !0 : R, M = n.tetherOffset, $ = M === void 0 ? 0 : M, W = detectOverflow(t, {
    boundary: m,
    rootBoundary: C,
    padding: w,
    altBoundary: P
  }), H = getBasePlacement(t.placement), V = getVariation(t.placement), N = !V, B = getMainAxisFromPlacement(H), K = getAltAxis(B), ue = t.modifiersData.popperOffsets, de = t.rects.reference, ve = t.rects.popper, Te = typeof $ == "function" ? $(Object.assign({}, t.rects, {
    placement: t.placement
  })) : $, Pe = typeof Te == "number" ? {
    mainAxis: Te,
    altAxis: Te
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, Te), Ce = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, Re = {
    x: 0,
    y: 0
  };
  if (ue) {
    if (l) {
      var ke, Ae = B === "y" ? top : left, we = B === "y" ? bottom : right, he = B === "y" ? "height" : "width", be = ue[B], le = be + W[Ae], fe = be - W[we], ye = L ? -ve[he] / 2 : 0, Ee = V === start ? de[he] : ve[he], Ie = V === start ? -ve[he] : -de[he], Fe = t.elements.arrow, De = L && Fe ? getLayoutRect(Fe) : {
        width: 0,
        height: 0
      }, Ve = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : getFreshSideObject(), Oe = Ve[Ae], Ze = Ve[we], et = within(0, de[he], De[he]), bt = N ? de[he] / 2 - ye - et - Oe - Pe.mainAxis : Ee - et - Oe - Pe.mainAxis, rr = N ? -de[he] / 2 + ye + et + Ze + Pe.mainAxis : Ie + et + Ze + Pe.mainAxis, St = t.elements.arrow && getOffsetParent(t.elements.arrow), Qe = St ? B === "y" ? St.clientTop || 0 : St.clientLeft || 0 : 0, xt = (ke = Ce == null ? void 0 : Ce[B]) != null ? ke : 0, je = be + bt - xt - Qe, kt = be + rr - xt, cr = within(L ? min$1(le, je) : le, be, L ? max$1(fe, kt) : fe);
      ue[B] = cr, Re[B] = cr - be;
    }
    if (p) {
      var Tr, Er = B === "x" ? top : left, Hr = B === "x" ? bottom : right, Br = ue[K], hr = K === "y" ? "height" : "width", Gr = Br + W[Er], Yr = Br - W[Hr], tt = [top, left].indexOf(H) !== -1, ar = (Tr = Ce == null ? void 0 : Ce[K]) != null ? Tr : 0, wr = tt ? Gr : Br - de[hr] - ve[hr] - ar + Pe.altAxis, Sr = tt ? Br + de[hr] + ve[hr] - ar - Pe.altAxis : Yr, Ye = L && tt ? withinMaxClamp(wr, Br, Sr) : within(L ? wr : Gr, Br, L ? Sr : Yr);
      ue[K] = Ye, Re[K] = Ye - Br;
    }
    t.modifiersData[o] = Re;
  }
}
const preventOverflow$1 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: preventOverflow,
  requiresIfExists: ["offset"]
};
function getHTMLElementScroll(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function getNodeScroll(e) {
  return e === getWindow(e) || !isHTMLElement$1(e) ? getWindowScroll(e) : getHTMLElementScroll(e);
}
function isElementScaled(e) {
  var t = e.getBoundingClientRect(), n = round$2(t.width) / e.offsetWidth || 1, o = round$2(t.height) / e.offsetHeight || 1;
  return n !== 1 || o !== 1;
}
function getCompositeRect(e, t, n) {
  n === void 0 && (n = !1);
  var o = isHTMLElement$1(t), s = isHTMLElement$1(t) && isElementScaled(t), l = getDocumentElement(t), c = getBoundingClientRect(e, s, n), p = {
    scrollLeft: 0,
    scrollTop: 0
  }, m = {
    x: 0,
    y: 0
  };
  return (o || !o && !n) && ((getNodeName(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  isScrollParent(l)) && (p = getNodeScroll(t)), isHTMLElement$1(t) ? (m = getBoundingClientRect(t, !0), m.x += t.clientLeft, m.y += t.clientTop) : l && (m.x = getWindowScrollBarX(l))), {
    x: c.left + p.scrollLeft - m.x,
    y: c.top + p.scrollTop - m.y,
    width: c.width,
    height: c.height
  };
}
function order(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), o = [];
  e.forEach(function(l) {
    t.set(l.name, l);
  });
  function s(l) {
    n.add(l.name);
    var c = [].concat(l.requires || [], l.requiresIfExists || []);
    c.forEach(function(p) {
      if (!n.has(p)) {
        var m = t.get(p);
        m && s(m);
      }
    }), o.push(l);
  }
  return e.forEach(function(l) {
    n.has(l.name) || s(l);
  }), o;
}
function orderModifiers(e) {
  var t = order(e);
  return modifierPhases.reduce(function(n, o) {
    return n.concat(t.filter(function(s) {
      return s.phase === o;
    }));
  }, []);
}
function debounce(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function mergeByName(e) {
  var t = e.reduce(function(n, o) {
    var s = n[o.name];
    return n[o.name] = s ? Object.assign({}, s, o, {
      options: Object.assign({}, s.options, o.options),
      data: Object.assign({}, s.data, o.data)
    }) : o, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(o) {
    return !(o && typeof o.getBoundingClientRect == "function");
  });
}
function popperGenerator(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, o = n === void 0 ? [] : n, s = t.defaultOptions, l = s === void 0 ? DEFAULT_OPTIONS : s;
  return function(p, m, C) {
    C === void 0 && (C = l);
    var P = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, l),
      modifiersData: {},
      elements: {
        reference: p,
        popper: m
      },
      attributes: {},
      styles: {}
    }, w = [], R = !1, L = {
      state: P,
      setOptions: function(H) {
        var V = typeof H == "function" ? H(P.options) : H;
        $(), P.options = Object.assign({}, l, P.options, V), P.scrollParents = {
          reference: isElement(p) ? listScrollParents(p) : p.contextElement ? listScrollParents(p.contextElement) : [],
          popper: listScrollParents(m)
        };
        var N = orderModifiers(mergeByName([].concat(o, P.options.modifiers)));
        return P.orderedModifiers = N.filter(function(B) {
          return B.enabled;
        }), M(), L.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!R) {
          var H = P.elements, V = H.reference, N = H.popper;
          if (areValidElements(V, N)) {
            P.rects = {
              reference: getCompositeRect(V, getOffsetParent(N), P.options.strategy === "fixed"),
              popper: getLayoutRect(N)
            }, P.reset = !1, P.placement = P.options.placement, P.orderedModifiers.forEach(function(Pe) {
              return P.modifiersData[Pe.name] = Object.assign({}, Pe.data);
            });
            for (var B = 0; B < P.orderedModifiers.length; B++) {
              if (P.reset === !0) {
                P.reset = !1, B = -1;
                continue;
              }
              var K = P.orderedModifiers[B], ue = K.fn, de = K.options, ve = de === void 0 ? {} : de, Te = K.name;
              typeof ue == "function" && (P = ue({
                state: P,
                options: ve,
                name: Te,
                instance: L
              }) || P);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function() {
        return new Promise(function(W) {
          L.forceUpdate(), W(P);
        });
      }),
      destroy: function() {
        $(), R = !0;
      }
    };
    if (!areValidElements(p, m))
      return L;
    L.setOptions(C).then(function(W) {
      !R && C.onFirstUpdate && C.onFirstUpdate(W);
    });
    function M() {
      P.orderedModifiers.forEach(function(W) {
        var H = W.name, V = W.options, N = V === void 0 ? {} : V, B = W.effect;
        if (typeof B == "function") {
          var K = B({
            state: P,
            name: H,
            instance: L,
            options: N
          }), ue = function() {
          };
          w.push(K || ue);
        }
      });
    }
    function $() {
      w.forEach(function(W) {
        return W();
      }), w = [];
    }
    return L;
  };
}
var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$2, flip$1, preventOverflow$1, arrow$1, hide$1], createPopper = /* @__PURE__ */ popperGenerator({
  defaultModifiers
});
const COMPONENT_NAME = "Popper";
function getPopperUtilityClass(e) {
  return generateUtilityClass(COMPONENT_NAME, e);
}
generateUtilityClasses(COMPONENT_NAME, ["root"]);
const _excluded$E = ["anchorEl", "children", "direction", "disablePortal", "modifiers", "open", "placement", "popperOptions", "popperRef", "slotProps", "slots", "TransitionProps", "ownerState"], _excluded2$5 = ["anchorEl", "children", "container", "direction", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition", "slotProps", "slots"];
function flipPlacement(e, t) {
  if (t === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function resolveAnchorEl$1(e) {
  return typeof e == "function" ? e() : e;
}
function isHTMLElement(e) {
  return e.nodeType !== void 0;
}
function isVirtualElement(e) {
  return !isHTMLElement(e);
}
const useUtilityClasses$u = () => composeClasses({
  root: ["root"]
}, useClassNamesOverride(getPopperUtilityClass)), defaultPopperOptions = {}, PopperTooltip = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  var o;
  const {
    anchorEl: s,
    children: l,
    direction: c,
    disablePortal: p,
    modifiers: m,
    open: C,
    placement: P,
    popperOptions: w,
    popperRef: R,
    slotProps: L = {},
    slots: M = {},
    TransitionProps: $
    // @ts-ignore internal logic
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
  } = t, W = _objectWithoutPropertiesLoose$3(t, _excluded$E), H = React$2.useRef(null), V = useForkRef(H, n), N = React$2.useRef(null), B = useForkRef(N, R), K = React$2.useRef(B);
  useEnhancedEffect$1(() => {
    K.current = B;
  }, [B]), React$2.useImperativeHandle(R, () => N.current, []);
  const ue = flipPlacement(P, c), [de, ve] = React$2.useState(ue), [Te, Pe] = React$2.useState(resolveAnchorEl$1(s));
  React$2.useEffect(() => {
    N.current && N.current.forceUpdate();
  }), React$2.useEffect(() => {
    s && Pe(resolveAnchorEl$1(s));
  }, [s]), useEnhancedEffect$1(() => {
    if (!Te || !C)
      return;
    const we = (le) => {
      ve(le.placement);
    };
    if (process.env.NODE_ENV !== "production" && Te && isHTMLElement(Te) && Te.nodeType === 1) {
      const le = Te.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && le.top === 0 && le.left === 0 && le.right === 0 && le.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let he = [{
      name: "preventOverflow",
      options: {
        altBoundary: p
      }
    }, {
      name: "flip",
      options: {
        altBoundary: p
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: le
      }) => {
        we(le);
      }
    }];
    m != null && (he = he.concat(m)), w && w.modifiers != null && (he = he.concat(w.modifiers));
    const be = createPopper(Te, H.current, _extends$5({
      placement: ue
    }, w, {
      modifiers: he
    }));
    return K.current(be), () => {
      be.destroy(), K.current(null);
    };
  }, [Te, p, m, C, w, ue]);
  const Ce = {
    placement: de
  };
  $ !== null && (Ce.TransitionProps = $);
  const Re = useUtilityClasses$u(), ke = (o = M.root) != null ? o : "div", Ae = useSlotProps({
    elementType: ke,
    externalSlotProps: L.root,
    externalForwardedProps: W,
    additionalProps: {
      role: "tooltip",
      ref: V
    },
    ownerState: t,
    className: Re.root
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ke, _extends$5({}, Ae, {
    children: typeof l == "function" ? l(Ce) : l
  }));
}), Popper$2 = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  const {
    anchorEl: o,
    children: s,
    container: l,
    direction: c = "ltr",
    disablePortal: p = !1,
    keepMounted: m = !1,
    modifiers: C,
    open: P,
    placement: w = "bottom",
    popperOptions: R = defaultPopperOptions,
    popperRef: L,
    style: M,
    transition: $ = !1,
    slotProps: W = {},
    slots: H = {}
  } = t, V = _objectWithoutPropertiesLoose$3(t, _excluded2$5), [N, B] = React$2.useState(!0), K = () => {
    B(!1);
  }, ue = () => {
    B(!0);
  };
  if (!m && !P && (!$ || N))
    return null;
  let de;
  if (l)
    de = l;
  else if (o) {
    const Pe = resolveAnchorEl$1(o);
    de = Pe && isHTMLElement(Pe) ? ownerDocument(Pe).body : ownerDocument(null).body;
  }
  const ve = !P && m && (!$ || N) ? "none" : void 0, Te = $ ? {
    in: P,
    onEnter: K,
    onExited: ue
  } : void 0;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Portal, {
    disablePortal: p,
    container: de,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(PopperTooltip, _extends$5({
      anchorEl: o,
      direction: c,
      disablePortal: p,
      modifiers: C,
      ref: n,
      open: $ ? !N : P,
      placement: w,
      popperOptions: R,
      popperRef: L,
      slotProps: W,
      slots: H
    }, V, {
      style: _extends$5({
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: ve
      }, M),
      TransitionProps: Te,
      children: s
    }))
  });
});
process.env.NODE_ENV !== "production" && (Popper$2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: chainPropTypes(PropTypes.oneOfType([HTMLElementType, PropTypes.object, PropTypes.func]), (e) => {
    if (e.open) {
      const t = resolveAnchorEl$1(e.anchorEl);
      if (t && isHTMLElement(t) && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || isVirtualElement(t) && t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: PropTypes.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: PropTypes.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: PropTypes.arrayOf(PropTypes.shape({
    data: PropTypes.object,
    effect: PropTypes.func,
    enabled: PropTypes.bool,
    fn: PropTypes.func,
    name: PropTypes.any,
    options: PropTypes.object,
    phase: PropTypes.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: PropTypes.arrayOf(PropTypes.string),
    requiresIfExists: PropTypes.arrayOf(PropTypes.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: PropTypes.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: PropTypes.shape({
    modifiers: PropTypes.array,
    onFirstUpdate: PropTypes.func,
    placement: PropTypes.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: PropTypes.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: refType$1,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: PropTypes.bool
});
const INTENTIONAL_DRAG_COUNT_THRESHOLD = 2;
function asc(e, t) {
  return e - t;
}
function findClosest(e, t) {
  var n;
  const {
    index: o
  } = (n = e.reduce((s, l, c) => {
    const p = Math.abs(t - l);
    return s === null || p < s.distance || p === s.distance ? {
      distance: p,
      index: c
    } : s;
  }, null)) != null ? n : {};
  return o;
}
function trackFinger(e, t) {
  if (t.current !== void 0 && e.changedTouches) {
    const n = e;
    for (let o = 0; o < n.changedTouches.length; o += 1) {
      const s = n.changedTouches[o];
      if (s.identifier === t.current)
        return {
          x: s.clientX,
          y: s.clientY
        };
    }
    return !1;
  }
  return {
    x: e.clientX,
    y: e.clientY
  };
}
function valueToPercent(e, t, n) {
  return (e - t) * 100 / (n - t);
}
function percentToValue(e, t, n) {
  return (n - t) * e + t;
}
function getDecimalPrecision(e) {
  if (Math.abs(e) < 1) {
    const n = e.toExponential().split("e-"), o = n[0].split(".")[1];
    return (o ? o.length : 0) + parseInt(n[1], 10);
  }
  const t = e.toString().split(".")[1];
  return t ? t.length : 0;
}
function roundValueToStep(e, t, n) {
  const o = Math.round((e - n) / t) * t + n;
  return Number(o.toFixed(getDecimalPrecision(t)));
}
function setValueIndex({
  values: e,
  newValue: t,
  index: n
}) {
  const o = e.slice();
  return o[n] = t, o.sort(asc);
}
function focusThumb({
  sliderRef: e,
  activeIndex: t,
  setActive: n
}) {
  var o, s;
  const l = ownerDocument(e.current);
  if (!((o = e.current) != null && o.contains(l.activeElement)) || Number(l == null || (s = l.activeElement) == null ? void 0 : s.getAttribute("data-index")) !== t) {
    var c;
    (c = e.current) == null || c.querySelector(`[type="range"][data-index="${t}"]`).focus();
  }
  n && n(t);
}
function areValuesEqual(e, t) {
  return typeof e == "number" && typeof t == "number" ? e === t : typeof e == "object" && typeof t == "object" ? areArraysEqual(e, t) : !1;
}
const axisProps = {
  horizontal: {
    offset: (e) => ({
      left: `${e}%`
    }),
    leap: (e) => ({
      width: `${e}%`
    })
  },
  "horizontal-reverse": {
    offset: (e) => ({
      right: `${e}%`
    }),
    leap: (e) => ({
      width: `${e}%`
    })
  },
  vertical: {
    offset: (e) => ({
      bottom: `${e}%`
    }),
    leap: (e) => ({
      height: `${e}%`
    })
  }
}, Identity$1 = (e) => e;
let cachedSupportsTouchActionNone;
function doesSupportTouchActionNone() {
  return cachedSupportsTouchActionNone === void 0 && (typeof CSS < "u" && typeof CSS.supports == "function" ? cachedSupportsTouchActionNone = CSS.supports("touch-action", "none") : cachedSupportsTouchActionNone = !0), cachedSupportsTouchActionNone;
}
function useSlider(e) {
  const {
    "aria-labelledby": t,
    defaultValue: n,
    disabled: o = !1,
    disableSwap: s = !1,
    isRtl: l = !1,
    marks: c = !1,
    max: p = 100,
    min: m = 0,
    name: C,
    onChange: P,
    onChangeCommitted: w,
    orientation: R = "horizontal",
    rootRef: L,
    scale: M = Identity$1,
    step: $ = 1,
    shiftStep: W = 10,
    tabIndex: H,
    value: V
  } = e, N = React$2.useRef(), [B, K] = React$2.useState(-1), [ue, de] = React$2.useState(-1), [ve, Te] = React$2.useState(!1), Pe = React$2.useRef(0), [Ce, Re] = useControlled({
    controlled: V,
    default: n ?? m,
    name: "Slider"
  }), ke = P && ((Ye, Je, tr) => {
    const pt = Ye.nativeEvent || Ye, ir = new pt.constructor(pt.type, pt);
    Object.defineProperty(ir, "target", {
      writable: !0,
      value: {
        value: Je,
        name: C
      }
    }), P(ir, Je, tr);
  }), Ae = Array.isArray(Ce);
  let we = Ae ? Ce.slice().sort(asc) : [Ce];
  we = we.map((Ye) => Ye == null ? m : clamp$1(Ye, m, p));
  const he = c === !0 && $ !== null ? [...Array(Math.floor((p - m) / $) + 1)].map((Ye, Je) => ({
    value: m + $ * Je
  })) : c || [], be = he.map((Ye) => Ye.value), {
    isFocusVisibleRef: le,
    onBlur: fe,
    onFocus: ye,
    ref: Ee
  } = useIsFocusVisible(), [Ie, Fe] = React$2.useState(-1), De = React$2.useRef(), Ve = useForkRef(Ee, De), Oe = useForkRef(L, Ve), Ze = (Ye) => (Je) => {
    var tr;
    const pt = Number(Je.currentTarget.getAttribute("data-index"));
    ye(Je), le.current === !0 && Fe(pt), de(pt), Ye == null || (tr = Ye.onFocus) == null || tr.call(Ye, Je);
  }, et = (Ye) => (Je) => {
    var tr;
    fe(Je), le.current === !1 && Fe(-1), de(-1), Ye == null || (tr = Ye.onBlur) == null || tr.call(Ye, Je);
  }, bt = (Ye, Je) => {
    const tr = Number(Ye.currentTarget.getAttribute("data-index")), pt = we[tr], ir = be.indexOf(pt);
    let nr = Je;
    if (he && $ == null) {
      const er = be[be.length - 1];
      nr > er ? nr = er : nr < be[0] ? nr = be[0] : nr = nr < pt ? be[ir - 1] : be[ir + 1];
    }
    if (nr = clamp$1(nr, m, p), Ae) {
      s && (nr = clamp$1(nr, we[tr - 1] || -1 / 0, we[tr + 1] || 1 / 0));
      const er = nr;
      nr = setValueIndex({
        values: we,
        newValue: nr,
        index: tr
      });
      let pr = tr;
      s || (pr = nr.indexOf(er)), focusThumb({
        sliderRef: De,
        activeIndex: pr
      });
    }
    Re(nr), Fe(tr), ke && !areValuesEqual(nr, Ce) && ke(Ye, nr, tr), w && w(Ye, nr);
  }, rr = (Ye) => (Je) => {
    var tr;
    if ($ !== null) {
      const pt = Number(Je.currentTarget.getAttribute("data-index")), ir = we[pt];
      let nr = null;
      (Je.key === "ArrowLeft" || Je.key === "ArrowDown") && Je.shiftKey || Je.key === "PageDown" ? nr = Math.max(ir - W, m) : ((Je.key === "ArrowRight" || Je.key === "ArrowUp") && Je.shiftKey || Je.key === "PageUp") && (nr = Math.min(ir + W, p)), nr !== null && (bt(Je, nr), Je.preventDefault());
    }
    Ye == null || (tr = Ye.onKeyDown) == null || tr.call(Ye, Je);
  };
  useEnhancedEffect$1(() => {
    if (o && De.current.contains(document.activeElement)) {
      var Ye;
      (Ye = document.activeElement) == null || Ye.blur();
    }
  }, [o]), o && B !== -1 && K(-1), o && Ie !== -1 && Fe(-1);
  const St = (Ye) => (Je) => {
    var tr;
    (tr = Ye.onChange) == null || tr.call(Ye, Je), bt(Je, Je.target.valueAsNumber);
  }, Qe = React$2.useRef();
  let xt = R;
  l && R === "horizontal" && (xt += "-reverse");
  const je = ({
    finger: Ye,
    move: Je = !1
  }) => {
    const {
      current: tr
    } = De, {
      width: pt,
      height: ir,
      bottom: nr,
      left: er
    } = tr.getBoundingClientRect();
    let pr;
    xt.indexOf("vertical") === 0 ? pr = (nr - Ye.y) / ir : pr = (Ye.x - er) / pt, xt.indexOf("-reverse") !== -1 && (pr = 1 - pr);
    let kr;
    if (kr = percentToValue(pr, m, p), $)
      kr = roundValueToStep(kr, $, m);
    else {
      const hn = findClosest(be, kr);
      kr = be[hn];
    }
    kr = clamp$1(kr, m, p);
    let Nr = 0;
    if (Ae) {
      Je ? Nr = Qe.current : Nr = findClosest(we, kr), s && (kr = clamp$1(kr, we[Nr - 1] || -1 / 0, we[Nr + 1] || 1 / 0));
      const hn = kr;
      kr = setValueIndex({
        values: we,
        newValue: kr,
        index: Nr
      }), s && Je || (Nr = kr.indexOf(hn), Qe.current = Nr);
    }
    return {
      newValue: kr,
      activeIndex: Nr
    };
  }, kt = useEventCallback((Ye) => {
    const Je = trackFinger(Ye, N);
    if (!Je)
      return;
    if (Pe.current += 1, Ye.type === "mousemove" && Ye.buttons === 0) {
      cr(Ye);
      return;
    }
    const {
      newValue: tr,
      activeIndex: pt
    } = je({
      finger: Je,
      move: !0
    });
    focusThumb({
      sliderRef: De,
      activeIndex: pt,
      setActive: K
    }), Re(tr), !ve && Pe.current > INTENTIONAL_DRAG_COUNT_THRESHOLD && Te(!0), ke && !areValuesEqual(tr, Ce) && ke(Ye, tr, pt);
  }), cr = useEventCallback((Ye) => {
    const Je = trackFinger(Ye, N);
    if (Te(!1), !Je)
      return;
    const {
      newValue: tr
    } = je({
      finger: Je,
      move: !0
    });
    K(-1), Ye.type === "touchend" && de(-1), w && w(Ye, tr), N.current = void 0, Er();
  }), Tr = useEventCallback((Ye) => {
    if (o)
      return;
    doesSupportTouchActionNone() || Ye.preventDefault();
    const Je = Ye.changedTouches[0];
    Je != null && (N.current = Je.identifier);
    const tr = trackFinger(Ye, N);
    if (tr !== !1) {
      const {
        newValue: ir,
        activeIndex: nr
      } = je({
        finger: tr
      });
      focusThumb({
        sliderRef: De,
        activeIndex: nr,
        setActive: K
      }), Re(ir), ke && !areValuesEqual(ir, Ce) && ke(Ye, ir, nr);
    }
    Pe.current = 0;
    const pt = ownerDocument(De.current);
    pt.addEventListener("touchmove", kt, {
      passive: !0
    }), pt.addEventListener("touchend", cr, {
      passive: !0
    });
  }), Er = React$2.useCallback(() => {
    const Ye = ownerDocument(De.current);
    Ye.removeEventListener("mousemove", kt), Ye.removeEventListener("mouseup", cr), Ye.removeEventListener("touchmove", kt), Ye.removeEventListener("touchend", cr);
  }, [cr, kt]);
  React$2.useEffect(() => {
    const {
      current: Ye
    } = De;
    return Ye.addEventListener("touchstart", Tr, {
      passive: doesSupportTouchActionNone()
    }), () => {
      Ye.removeEventListener("touchstart", Tr), Er();
    };
  }, [Er, Tr]), React$2.useEffect(() => {
    o && Er();
  }, [o, Er]);
  const Hr = (Ye) => (Je) => {
    var tr;
    if ((tr = Ye.onMouseDown) == null || tr.call(Ye, Je), o || Je.defaultPrevented || Je.button !== 0)
      return;
    Je.preventDefault();
    const pt = trackFinger(Je, N);
    if (pt !== !1) {
      const {
        newValue: nr,
        activeIndex: er
      } = je({
        finger: pt
      });
      focusThumb({
        sliderRef: De,
        activeIndex: er,
        setActive: K
      }), Re(nr), ke && !areValuesEqual(nr, Ce) && ke(Je, nr, er);
    }
    Pe.current = 0;
    const ir = ownerDocument(De.current);
    ir.addEventListener("mousemove", kt, {
      passive: !0
    }), ir.addEventListener("mouseup", cr);
  }, Br = valueToPercent(Ae ? we[0] : m, m, p), hr = valueToPercent(we[we.length - 1], m, p) - Br, Gr = (Ye = {}) => {
    const Je = extractEventHandlers(Ye), tr = {
      onMouseDown: Hr(Je || {})
    }, pt = _extends$5({}, Je, tr);
    return _extends$5({}, Ye, {
      ref: Oe
    }, pt);
  }, Yr = (Ye) => (Je) => {
    var tr;
    (tr = Ye.onMouseOver) == null || tr.call(Ye, Je);
    const pt = Number(Je.currentTarget.getAttribute("data-index"));
    de(pt);
  }, tt = (Ye) => (Je) => {
    var tr;
    (tr = Ye.onMouseLeave) == null || tr.call(Ye, Je), de(-1);
  };
  return {
    active: B,
    axis: xt,
    axisProps,
    dragging: ve,
    focusedThumbIndex: Ie,
    getHiddenInputProps: (Ye = {}) => {
      var Je;
      const tr = extractEventHandlers(Ye), pt = {
        onChange: St(tr || {}),
        onFocus: Ze(tr || {}),
        onBlur: et(tr || {}),
        onKeyDown: rr(tr || {})
      }, ir = _extends$5({}, tr, pt);
      return _extends$5({
        tabIndex: H,
        "aria-labelledby": t,
        "aria-orientation": R,
        "aria-valuemax": M(p),
        "aria-valuemin": M(m),
        name: C,
        type: "range",
        min: e.min,
        max: e.max,
        step: e.step === null && e.marks ? "any" : (Je = e.step) != null ? Je : void 0,
        disabled: o
      }, Ye, ir, {
        style: _extends$5({}, visuallyHidden$1, {
          direction: l ? "rtl" : "ltr",
          // So that VoiceOver's focus indicator matches the thumb's dimensions
          width: "100%",
          height: "100%"
        })
      });
    },
    getRootProps: Gr,
    getThumbProps: (Ye = {}) => {
      const Je = extractEventHandlers(Ye), tr = {
        onMouseOver: Yr(Je || {}),
        onMouseLeave: tt(Je || {})
      };
      return _extends$5({}, Ye, Je, tr);
    },
    marks: he,
    open: ue,
    range: Ae,
    rootRef: Oe,
    trackLeap: hr,
    trackOffset: Br,
    values: we,
    getThumbStyle: (Ye) => ({
      // So the non active thumb doesn't show its label on hover.
      pointerEvents: B !== -1 && B !== Ye ? "none" : void 0
    })
  };
}
const _excluded$D = ["onChange", "maxRows", "minRows", "style", "value"];
function getStyleValue(e) {
  return parseInt(e, 10) || 0;
}
const styles$2 = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
};
function isEmpty$1(e) {
  return e == null || Object.keys(e).length === 0 || e.outerHeightStyle === 0 && !e.overflowing;
}
const TextareaAutosize = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  const {
    onChange: o,
    maxRows: s,
    minRows: l = 1,
    style: c,
    value: p
  } = t, m = _objectWithoutPropertiesLoose$3(t, _excluded$D), {
    current: C
  } = React$2.useRef(p != null), P = React$2.useRef(null), w = useForkRef(n, P), R = React$2.useRef(null), L = React$2.useCallback(() => {
    const W = P.current, V = ownerWindow(W).getComputedStyle(W);
    if (V.width === "0px")
      return {
        outerHeightStyle: 0,
        overflowing: !1
      };
    const N = R.current;
    N.style.width = V.width, N.value = W.value || t.placeholder || "x", N.value.slice(-1) === `
` && (N.value += " ");
    const B = V.boxSizing, K = getStyleValue(V.paddingBottom) + getStyleValue(V.paddingTop), ue = getStyleValue(V.borderBottomWidth) + getStyleValue(V.borderTopWidth), de = N.scrollHeight;
    N.value = "x";
    const ve = N.scrollHeight;
    let Te = de;
    l && (Te = Math.max(Number(l) * ve, Te)), s && (Te = Math.min(Number(s) * ve, Te)), Te = Math.max(Te, ve);
    const Pe = Te + (B === "border-box" ? K + ue : 0), Ce = Math.abs(Te - de) <= 1;
    return {
      outerHeightStyle: Pe,
      overflowing: Ce
    };
  }, [s, l, t.placeholder]), M = React$2.useCallback(() => {
    const W = L();
    if (isEmpty$1(W))
      return;
    const H = P.current;
    H.style.height = `${W.outerHeightStyle}px`, H.style.overflow = W.overflowing ? "hidden" : "";
  }, [L]);
  useEnhancedEffect$1(() => {
    const W = () => {
      M();
    };
    let H;
    const V = () => {
      cancelAnimationFrame(H), H = requestAnimationFrame(() => {
        W();
      });
    }, N = debounce$1(W), B = P.current, K = ownerWindow(B);
    K.addEventListener("resize", N);
    let ue;
    return typeof ResizeObserver < "u" && (ue = new ResizeObserver(process.env.NODE_ENV === "test" ? V : W), ue.observe(B)), () => {
      N.clear(), cancelAnimationFrame(H), K.removeEventListener("resize", N), ue && ue.disconnect();
    };
  }, [L, M]), useEnhancedEffect$1(() => {
    M();
  });
  const $ = (W) => {
    C || M(), o && o(W);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React$2.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx("textarea", _extends$5({
      value: p,
      onChange: $,
      ref: w,
      rows: l
    }, m)), /* @__PURE__ */ jsxRuntimeExports.jsx("textarea", {
      "aria-hidden": !0,
      className: t.className,
      readOnly: !0,
      ref: R,
      tabIndex: -1,
      style: _extends$5({}, styles$2.shadow, c, {
        paddingTop: 0,
        paddingBottom: 0
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (TextareaAutosize.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * Maximum number of rows to display.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display.
   * @default 1
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * @ignore
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  placeholder: PropTypes.string,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * @ignore
   */
  value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.number, PropTypes.string])
});
function getTypographyUtilityClass(e) {
  return generateUtilityClass$1("MuiTypography", e);
}
generateUtilityClasses$1("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]);
const _excluded$C = ["align", "className", "component", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"], useUtilityClasses$t = (e) => {
  const {
    align: t,
    gutterBottom: n,
    noWrap: o,
    paragraph: s,
    variant: l,
    classes: c
  } = e, p = {
    root: ["root", l, e.align !== "inherit" && `align${capitalize$1(t)}`, n && "gutterBottom", o && "noWrap", s && "paragraph"]
  };
  return composeClasses(p, getTypographyUtilityClass, c);
}, TypographyRoot = E("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.variant && t[n.variant], n.align !== "inherit" && t[`align${capitalize$1(n.align)}`], n.noWrap && t.noWrap, n.gutterBottom && t.gutterBottom, n.paragraph && t.paragraph];
  }
})(({
  theme: e,
  ownerState: t
}) => _extends$5({
  margin: 0
}, t.variant === "inherit" && {
  // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
  font: "inherit"
}, t.variant !== "inherit" && e.typography[t.variant], t.align !== "inherit" && {
  textAlign: t.align
}, t.noWrap && {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}, t.gutterBottom && {
  marginBottom: "0.35em"
}, t.paragraph && {
  marginBottom: 16
})), defaultVariantMapping = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, colorTransformations = {
  primary: "primary.main",
  textPrimary: "text.primary",
  secondary: "secondary.main",
  textSecondary: "text.secondary",
  error: "error.main"
}, transformDeprecatedColors = (e) => colorTransformations[e] || e, Typography = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  const o = useThemeProps({
    props: t,
    name: "MuiTypography"
  }), s = transformDeprecatedColors(o.color), l = extendSxProp(_extends$5({}, o, {
    color: s
  })), {
    align: c = "inherit",
    className: p,
    component: m,
    gutterBottom: C = !1,
    noWrap: P = !1,
    paragraph: w = !1,
    variant: R = "body1",
    variantMapping: L = defaultVariantMapping
  } = l, M = _objectWithoutPropertiesLoose$3(l, _excluded$C), $ = _extends$5({}, l, {
    align: c,
    color: s,
    className: p,
    component: m,
    gutterBottom: C,
    noWrap: P,
    paragraph: w,
    variant: R,
    variantMapping: L
  }), W = m || (w ? "p" : L[R] || defaultVariantMapping[R]) || "span", H = useUtilityClasses$t($);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TypographyRoot, _extends$5({
    as: W,
    ref: n,
    ownerState: $,
    className: clsx$1(H.root, p)
  }, M));
});
process.env.NODE_ENV !== "production" && (Typography.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: PropTypes.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: PropTypes.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: PropTypes.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   */
  paragraph: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), PropTypes.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: PropTypes.object
});
const Typography$1 = Typography;
var useThemeWithoutDefault = {};
Object.defineProperty(useThemeWithoutDefault, "__esModule", {
  value: !0
});
var default_1 = useThemeWithoutDefault.default = void 0, React$1 = _interopRequireWildcard$2(React__default), _styledEngine = require$$1;
function _getRequireWildcardCache$2(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache$2 = function(o) {
    return o ? n : t;
  })(e);
}
function _interopRequireWildcard$2(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var n = _getRequireWildcardCache$2(t);
  if (n && n.has(e))
    return n.get(e);
  var o = { __proto__: null }, s = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var l in e)
    if (l !== "default" && Object.prototype.hasOwnProperty.call(e, l)) {
      var c = s ? Object.getOwnPropertyDescriptor(e, l) : null;
      c && (c.get || c.set) ? Object.defineProperty(o, l, c) : o[l] = e[l];
    }
  return o.default = e, n && n.set(e, o), o;
}
function isObjectEmpty$1(e) {
  return Object.keys(e).length === 0;
}
function useTheme(e = null) {
  const t = React$1.useContext(_styledEngine.ThemeContext);
  return !t || isObjectEmpty$1(t) ? e : t;
}
default_1 = useThemeWithoutDefault.default = useTheme;
const _excluded$B = ["anchorEl", "component", "components", "componentsProps", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "transition", "slots", "slotProps"], PopperRoot = E(Popper$2, {
  name: "MuiPopper",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), Popper = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  var o;
  const s = default_1(), l = useThemeProps({
    props: t,
    name: "MuiPopper"
  }), {
    anchorEl: c,
    component: p,
    components: m,
    componentsProps: C,
    container: P,
    disablePortal: w,
    keepMounted: R,
    modifiers: L,
    open: M,
    placement: $,
    popperOptions: W,
    popperRef: H,
    transition: V,
    slots: N,
    slotProps: B
  } = l, K = _objectWithoutPropertiesLoose$3(l, _excluded$B), ue = (o = N == null ? void 0 : N.root) != null ? o : m == null ? void 0 : m.Root, de = _extends$5({
    anchorEl: c,
    container: P,
    disablePortal: w,
    keepMounted: R,
    modifiers: L,
    open: M,
    placement: $,
    popperOptions: W,
    popperRef: H,
    transition: V
  }, K);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PopperRoot, _extends$5({
    as: p,
    direction: s == null ? void 0 : s.direction,
    slots: {
      root: ue
    },
    slotProps: B ?? C
  }, de, {
    ref: n
  }));
});
process.env.NODE_ENV !== "production" && (Popper.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: PropTypes.oneOfType([HTMLElementType, PropTypes.object, PropTypes.func]),
  /**
   * Popper render function or node.
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: PropTypes.shape({
    Root: PropTypes.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  componentsProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: PropTypes.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: PropTypes.arrayOf(PropTypes.shape({
    data: PropTypes.object,
    effect: PropTypes.func,
    enabled: PropTypes.bool,
    fn: PropTypes.func,
    name: PropTypes.any,
    options: PropTypes.object,
    phase: PropTypes.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: PropTypes.arrayOf(PropTypes.string),
    requiresIfExists: PropTypes.arrayOf(PropTypes.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: PropTypes.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: PropTypes.shape({
    modifiers: PropTypes.array,
    onFirstUpdate: PropTypes.func,
    placement: PropTypes.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: PropTypes.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: refType$1,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: PropTypes.bool
});
const Popper$1 = Popper, CancelIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");
function getChipUtilityClass(e) {
  return generateUtilityClass$1("MuiChip", e);
}
const chipClasses = generateUtilityClasses$1("MuiChip", ["root", "sizeSmall", "sizeMedium", "colorError", "colorInfo", "colorPrimary", "colorSecondary", "colorSuccess", "colorWarning", "disabled", "clickable", "clickableColorPrimary", "clickableColorSecondary", "deletable", "deletableColorPrimary", "deletableColorSecondary", "outlined", "filled", "outlinedPrimary", "outlinedSecondary", "filledPrimary", "filledSecondary", "avatar", "avatarSmall", "avatarMedium", "avatarColorPrimary", "avatarColorSecondary", "icon", "iconSmall", "iconMedium", "iconColorPrimary", "iconColorSecondary", "label", "labelSmall", "labelMedium", "deleteIcon", "deleteIconSmall", "deleteIconMedium", "deleteIconColorPrimary", "deleteIconColorSecondary", "deleteIconOutlinedColorPrimary", "deleteIconOutlinedColorSecondary", "deleteIconFilledColorPrimary", "deleteIconFilledColorSecondary", "focusVisible"]), chipClasses$1 = chipClasses, _excluded$A = ["avatar", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant", "tabIndex", "skipFocusWhenDisabled"], useUtilityClasses$s = (e) => {
  const {
    classes: t,
    disabled: n,
    size: o,
    color: s,
    iconColor: l,
    onDelete: c,
    clickable: p,
    variant: m
  } = e, C = {
    root: ["root", m, n && "disabled", `size${capitalize$1(o)}`, `color${capitalize$1(s)}`, p && "clickable", p && `clickableColor${capitalize$1(s)}`, c && "deletable", c && `deletableColor${capitalize$1(s)}`, `${m}${capitalize$1(s)}`],
    label: ["label", `label${capitalize$1(o)}`],
    avatar: ["avatar", `avatar${capitalize$1(o)}`, `avatarColor${capitalize$1(s)}`],
    icon: ["icon", `icon${capitalize$1(o)}`, `iconColor${capitalize$1(l)}`],
    deleteIcon: ["deleteIcon", `deleteIcon${capitalize$1(o)}`, `deleteIconColor${capitalize$1(s)}`, `deleteIcon${capitalize$1(m)}Color${capitalize$1(s)}`]
  };
  return composeClasses(C, getChipUtilityClass, t);
}, ChipRoot = E("div", {
  name: "MuiChip",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      color: o,
      iconColor: s,
      clickable: l,
      onDelete: c,
      size: p,
      variant: m
    } = n;
    return [{
      [`& .${chipClasses$1.avatar}`]: t.avatar
    }, {
      [`& .${chipClasses$1.avatar}`]: t[`avatar${capitalize$1(p)}`]
    }, {
      [`& .${chipClasses$1.avatar}`]: t[`avatarColor${capitalize$1(o)}`]
    }, {
      [`& .${chipClasses$1.icon}`]: t.icon
    }, {
      [`& .${chipClasses$1.icon}`]: t[`icon${capitalize$1(p)}`]
    }, {
      [`& .${chipClasses$1.icon}`]: t[`iconColor${capitalize$1(s)}`]
    }, {
      [`& .${chipClasses$1.deleteIcon}`]: t.deleteIcon
    }, {
      [`& .${chipClasses$1.deleteIcon}`]: t[`deleteIcon${capitalize$1(p)}`]
    }, {
      [`& .${chipClasses$1.deleteIcon}`]: t[`deleteIconColor${capitalize$1(o)}`]
    }, {
      [`& .${chipClasses$1.deleteIcon}`]: t[`deleteIcon${capitalize$1(m)}Color${capitalize$1(o)}`]
    }, t.root, t[`size${capitalize$1(p)}`], t[`color${capitalize$1(o)}`], l && t.clickable, l && o !== "default" && t[`clickableColor${capitalize$1(o)})`], c && t.deletable, c && o !== "default" && t[`deletableColor${capitalize$1(o)}`], t[m], t[`${m}${capitalize$1(o)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  const n = e.palette.mode === "light" ? e.palette.grey[700] : e.palette.grey[300];
  return _extends$5({
    maxWidth: "100%",
    fontFamily: e.typography.fontFamily,
    fontSize: e.typography.pxToRem(13),
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 32,
    color: (e.vars || e).palette.text.primary,
    backgroundColor: (e.vars || e).palette.action.selected,
    borderRadius: 32 / 2,
    whiteSpace: "nowrap",
    transition: e.transitions.create(["background-color", "box-shadow"]),
    // reset cursor explicitly in case ButtonBase is used
    cursor: "unset",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    textDecoration: "none",
    border: 0,
    // Remove `button` border
    padding: 0,
    // Remove `button` padding
    verticalAlign: "middle",
    boxSizing: "border-box",
    [`&.${chipClasses$1.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`& .${chipClasses$1.avatar}`]: {
      marginLeft: 5,
      marginRight: -6,
      width: 24,
      height: 24,
      color: e.vars ? e.vars.palette.Chip.defaultAvatarColor : n,
      fontSize: e.typography.pxToRem(12)
    },
    [`& .${chipClasses$1.avatarColorPrimary}`]: {
      color: (e.vars || e).palette.primary.contrastText,
      backgroundColor: (e.vars || e).palette.primary.dark
    },
    [`& .${chipClasses$1.avatarColorSecondary}`]: {
      color: (e.vars || e).palette.secondary.contrastText,
      backgroundColor: (e.vars || e).palette.secondary.dark
    },
    [`& .${chipClasses$1.avatarSmall}`]: {
      marginLeft: 4,
      marginRight: -4,
      width: 18,
      height: 18,
      fontSize: e.typography.pxToRem(10)
    },
    [`& .${chipClasses$1.icon}`]: _extends$5({
      marginLeft: 5,
      marginRight: -6
    }, t.size === "small" && {
      fontSize: 18,
      marginLeft: 4,
      marginRight: -4
    }, t.iconColor === t.color && _extends$5({
      color: e.vars ? e.vars.palette.Chip.defaultIconColor : n
    }, t.color !== "default" && {
      color: "inherit"
    })),
    [`& .${chipClasses$1.deleteIcon}`]: _extends$5({
      WebkitTapHighlightColor: "transparent",
      color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.26)` : alpha_1(e.palette.text.primary, 0.26),
      fontSize: 22,
      cursor: "pointer",
      margin: "0 5px 0 -6px",
      "&:hover": {
        color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.4)` : alpha_1(e.palette.text.primary, 0.4)
      }
    }, t.size === "small" && {
      fontSize: 16,
      marginRight: 4,
      marginLeft: -4
    }, t.color !== "default" && {
      color: e.vars ? `rgba(${e.vars.palette[t.color].contrastTextChannel} / 0.7)` : alpha_1(e.palette[t.color].contrastText, 0.7),
      "&:hover, &:active": {
        color: (e.vars || e).palette[t.color].contrastText
      }
    })
  }, t.size === "small" && {
    height: 24
  }, t.color !== "default" && {
    backgroundColor: (e.vars || e).palette[t.color].main,
    color: (e.vars || e).palette[t.color].contrastText
  }, t.onDelete && {
    [`&.${chipClasses$1.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : alpha_1(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  }, t.onDelete && t.color !== "default" && {
    [`&.${chipClasses$1.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette[t.color].dark
    }
  });
}, ({
  theme: e,
  ownerState: t
}) => _extends$5({}, t.clickable && {
  userSelect: "none",
  WebkitTapHighlightColor: "transparent",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : alpha_1(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
  },
  [`&.${chipClasses$1.focusVisible}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : alpha_1(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
  },
  "&:active": {
    boxShadow: (e.vars || e).shadows[1]
  }
}, t.clickable && t.color !== "default" && {
  [`&:hover, &.${chipClasses$1.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette[t.color].dark
  }
}), ({
  theme: e,
  ownerState: t
}) => _extends$5({}, t.variant === "outlined" && {
  backgroundColor: "transparent",
  border: e.vars ? `1px solid ${e.vars.palette.Chip.defaultBorder}` : `1px solid ${e.palette.mode === "light" ? e.palette.grey[400] : e.palette.grey[700]}`,
  [`&.${chipClasses$1.clickable}:hover`]: {
    backgroundColor: (e.vars || e).palette.action.hover
  },
  [`&.${chipClasses$1.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`& .${chipClasses$1.avatar}`]: {
    marginLeft: 4
  },
  [`& .${chipClasses$1.avatarSmall}`]: {
    marginLeft: 2
  },
  [`& .${chipClasses$1.icon}`]: {
    marginLeft: 4
  },
  [`& .${chipClasses$1.iconSmall}`]: {
    marginLeft: 2
  },
  [`& .${chipClasses$1.deleteIcon}`]: {
    marginRight: 5
  },
  [`& .${chipClasses$1.deleteIconSmall}`]: {
    marginRight: 3
  }
}, t.variant === "outlined" && t.color !== "default" && {
  color: (e.vars || e).palette[t.color].main,
  border: `1px solid ${e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.7)` : alpha_1(e.palette[t.color].main, 0.7)}`,
  [`&.${chipClasses$1.clickable}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : alpha_1(e.palette[t.color].main, e.palette.action.hoverOpacity)
  },
  [`&.${chipClasses$1.focusVisible}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.focusOpacity})` : alpha_1(e.palette[t.color].main, e.palette.action.focusOpacity)
  },
  [`& .${chipClasses$1.deleteIcon}`]: {
    color: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.7)` : alpha_1(e.palette[t.color].main, 0.7),
    "&:hover, &:active": {
      color: (e.vars || e).palette[t.color].main
    }
  }
})), ChipLabel = E("span", {
  name: "MuiChip",
  slot: "Label",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      size: o
    } = n;
    return [t.label, t[`label${capitalize$1(o)}`]];
  }
})(({
  ownerState: e
}) => _extends$5({
  overflow: "hidden",
  textOverflow: "ellipsis",
  paddingLeft: 12,
  paddingRight: 12,
  whiteSpace: "nowrap"
}, e.variant === "outlined" && {
  paddingLeft: 11,
  paddingRight: 11
}, e.size === "small" && {
  paddingLeft: 8,
  paddingRight: 8
}, e.size === "small" && e.variant === "outlined" && {
  paddingLeft: 7,
  paddingRight: 7
}));
function isDeleteKeyboardEvent(e) {
  return e.key === "Backspace" || e.key === "Delete";
}
const Chip = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  const o = useThemeProps({
    props: t,
    name: "MuiChip"
  }), {
    avatar: s,
    className: l,
    clickable: c,
    color: p = "default",
    component: m,
    deleteIcon: C,
    disabled: P = !1,
    icon: w,
    label: R,
    onClick: L,
    onDelete: M,
    onKeyDown: $,
    onKeyUp: W,
    size: H = "medium",
    variant: V = "filled",
    tabIndex: N,
    skipFocusWhenDisabled: B = !1
    // TODO v6: Rename to `focusableWhenDisabled`.
  } = o, K = _objectWithoutPropertiesLoose$3(o, _excluded$A), ue = React$2.useRef(null), de = useForkRef(ue, n), ve = (fe) => {
    fe.stopPropagation(), M && M(fe);
  }, Te = (fe) => {
    fe.currentTarget === fe.target && isDeleteKeyboardEvent(fe) && fe.preventDefault(), $ && $(fe);
  }, Pe = (fe) => {
    fe.currentTarget === fe.target && (M && isDeleteKeyboardEvent(fe) ? M(fe) : fe.key === "Escape" && ue.current && ue.current.blur()), W && W(fe);
  }, Ce = c !== !1 && L ? !0 : c, Re = Ce || M ? ButtonBase$1 : m || "div", ke = _extends$5({}, o, {
    component: Re,
    disabled: P,
    size: H,
    color: p,
    iconColor: /* @__PURE__ */ React$2.isValidElement(w) && w.props.color || p,
    onDelete: !!M,
    clickable: Ce,
    variant: V
  }), Ae = useUtilityClasses$s(ke), we = Re === ButtonBase$1 ? _extends$5({
    component: m || "div",
    focusVisibleClassName: Ae.focusVisible
  }, M && {
    disableRipple: !0
  }) : {};
  let he = null;
  M && (he = C && /* @__PURE__ */ React$2.isValidElement(C) ? /* @__PURE__ */ React$2.cloneElement(C, {
    className: clsx$1(C.props.className, Ae.deleteIcon),
    onClick: ve
  }) : /* @__PURE__ */ jsxRuntimeExports.jsx(CancelIcon, {
    className: clsx$1(Ae.deleteIcon),
    onClick: ve
  }));
  let be = null;
  s && /* @__PURE__ */ React$2.isValidElement(s) && (be = /* @__PURE__ */ React$2.cloneElement(s, {
    className: clsx$1(Ae.avatar, s.props.className)
  }));
  let le = null;
  return w && /* @__PURE__ */ React$2.isValidElement(w) && (le = /* @__PURE__ */ React$2.cloneElement(w, {
    className: clsx$1(Ae.icon, w.props.className)
  })), process.env.NODE_ENV !== "production" && be && le && console.error("MUI: The Chip component can not handle the avatar and the icon prop at the same time. Pick one."), /* @__PURE__ */ jsxRuntimeExports.jsxs(ChipRoot, _extends$5({
    as: Re,
    className: clsx$1(Ae.root, l),
    disabled: Ce && P ? !0 : void 0,
    onClick: L,
    onKeyDown: Te,
    onKeyUp: Pe,
    ref: de,
    tabIndex: B && P ? -1 : N,
    ownerState: ke
  }, we, K, {
    children: [be || le, /* @__PURE__ */ jsxRuntimeExports.jsx(ChipLabel, {
      className: clsx$1(Ae.label),
      ownerState: ke,
      children: R
    }), he]
  }));
});
process.env.NODE_ENV !== "production" && (Chip.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Avatar element to display.
   */
  avatar: PropTypes.element,
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: unsupportedProp,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If `false`, the chip will not appear clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   * Note: this controls the UI and does not affect the onClick event.
   */
  clickable: PropTypes.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: PropTypes.element,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * Icon element.
   */
  icon: PropTypes.element,
  /**
   * The content of the component.
   */
  label: PropTypes.node,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * Callback fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * If `true`, allows the disabled chip to escape focus.
   * If `false`, allows the disabled chip to receive focus.
   * @default false
   */
  skipFocusWhenDisabled: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @ignore
   */
  tabIndex: PropTypes.number,
  /**
   * The variant to use.
   * @default 'filled'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["filled", "outlined"]), PropTypes.string])
});
const Chip$1 = Chip;
function formControlState({
  props: e,
  states: t,
  muiFormControl: n
}) {
  return t.reduce((o, s) => (o[s] = e[s], n && typeof e[s] > "u" && (o[s] = n[s]), o), {});
}
const FormControlContext = /* @__PURE__ */ React$2.createContext(void 0);
process.env.NODE_ENV !== "production" && (FormControlContext.displayName = "FormControlContext");
const FormControlContext$1 = FormControlContext;
function useFormControl() {
  return React$2.useContext(FormControlContext$1);
}
function GlobalStyles(e) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GlobalStyles$1, _extends$5({}, e, {
    defaultTheme: defaultTheme$2,
    themeId: THEME_ID
  }));
}
process.env.NODE_ENV !== "production" && (GlobalStyles.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The styles you want to apply globally.
   */
  styles: PropTypes.oneOfType([PropTypes.array, PropTypes.func, PropTypes.number, PropTypes.object, PropTypes.string, PropTypes.bool])
});
function hasValue(e) {
  return e != null && !(Array.isArray(e) && e.length === 0);
}
function isFilled(e, t = !1) {
  return e && (hasValue(e.value) && e.value !== "" || t && hasValue(e.defaultValue) && e.defaultValue !== "");
}
function isAdornedStart(e) {
  return e.startAdornment;
}
function getInputBaseUtilityClass(e) {
  return generateUtilityClass$1("MuiInputBase", e);
}
const inputBaseClasses = generateUtilityClasses$1("MuiInputBase", ["root", "formControl", "focused", "disabled", "adornedStart", "adornedEnd", "error", "sizeSmall", "multiline", "colorSecondary", "fullWidth", "hiddenLabel", "readOnly", "input", "inputSizeSmall", "inputMultiline", "inputTypeSearch", "inputAdornedStart", "inputAdornedEnd", "inputHiddenLabel"]), inputBaseClasses$1 = inputBaseClasses, _excluded$z = ["aria-describedby", "autoComplete", "autoFocus", "className", "color", "components", "componentsProps", "defaultValue", "disabled", "disableInjectingGlobalStyles", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "size", "slotProps", "slots", "startAdornment", "type", "value"], rootOverridesResolver = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.formControl && t.formControl, n.startAdornment && t.adornedStart, n.endAdornment && t.adornedEnd, n.error && t.error, n.size === "small" && t.sizeSmall, n.multiline && t.multiline, n.color && t[`color${capitalize$1(n.color)}`], n.fullWidth && t.fullWidth, n.hiddenLabel && t.hiddenLabel];
}, inputOverridesResolver = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.input, n.size === "small" && t.inputSizeSmall, n.multiline && t.inputMultiline, n.type === "search" && t.inputTypeSearch, n.startAdornment && t.inputAdornedStart, n.endAdornment && t.inputAdornedEnd, n.hiddenLabel && t.inputHiddenLabel];
}, useUtilityClasses$r = (e) => {
  const {
    classes: t,
    color: n,
    disabled: o,
    error: s,
    endAdornment: l,
    focused: c,
    formControl: p,
    fullWidth: m,
    hiddenLabel: C,
    multiline: P,
    readOnly: w,
    size: R,
    startAdornment: L,
    type: M
  } = e, $ = {
    root: ["root", `color${capitalize$1(n)}`, o && "disabled", s && "error", m && "fullWidth", c && "focused", p && "formControl", R && R !== "medium" && `size${capitalize$1(R)}`, P && "multiline", L && "adornedStart", l && "adornedEnd", C && "hiddenLabel", w && "readOnly"],
    input: ["input", o && "disabled", M === "search" && "inputTypeSearch", P && "inputMultiline", R === "small" && "inputSizeSmall", C && "inputHiddenLabel", L && "inputAdornedStart", l && "inputAdornedEnd", w && "readOnly"]
  };
  return composeClasses($, getInputBaseUtilityClass, t);
}, InputBaseRoot = E("div", {
  name: "MuiInputBase",
  slot: "Root",
  overridesResolver: rootOverridesResolver
})(({
  theme: e,
  ownerState: t
}) => _extends$5({}, e.typography.body1, {
  color: (e.vars || e).palette.text.primary,
  lineHeight: "1.4375em",
  // 23px
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  position: "relative",
  cursor: "text",
  display: "inline-flex",
  alignItems: "center",
  [`&.${inputBaseClasses$1.disabled}`]: {
    color: (e.vars || e).palette.text.disabled,
    cursor: "default"
  }
}, t.multiline && _extends$5({
  padding: "4px 0 5px"
}, t.size === "small" && {
  paddingTop: 1
}), t.fullWidth && {
  width: "100%"
})), InputBaseComponent = E("input", {
  name: "MuiInputBase",
  slot: "Input",
  overridesResolver: inputOverridesResolver
})(({
  theme: e,
  ownerState: t
}) => {
  const n = e.palette.mode === "light", o = _extends$5({
    color: "currentColor"
  }, e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: n ? 0.42 : 0.5
  }, {
    transition: e.transitions.create("opacity", {
      duration: e.transitions.duration.shorter
    })
  }), s = {
    opacity: "0 !important"
  }, l = e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: n ? 0.42 : 0.5
  };
  return _extends$5({
    font: "inherit",
    letterSpacing: "inherit",
    color: "currentColor",
    padding: "4px 0 5px",
    border: 0,
    boxSizing: "content-box",
    background: "none",
    height: "1.4375em",
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: "transparent",
    display: "block",
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: "100%",
    // Fix IE11 width issue
    animationName: "mui-auto-fill-cancel",
    animationDuration: "10ms",
    "&::-webkit-input-placeholder": o,
    "&::-moz-placeholder": o,
    // Firefox 19+
    "&:-ms-input-placeholder": o,
    // IE11
    "&::-ms-input-placeholder": o,
    // Edge
    "&:focus": {
      outline: 0
    },
    // Reset Firefox invalid required input style
    "&:invalid": {
      boxShadow: "none"
    },
    "&::-webkit-search-decoration": {
      // Remove the padding when type=search.
      WebkitAppearance: "none"
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${inputBaseClasses$1.formControl} &`]: {
      "&::-webkit-input-placeholder": s,
      "&::-moz-placeholder": s,
      // Firefox 19+
      "&:-ms-input-placeholder": s,
      // IE11
      "&::-ms-input-placeholder": s,
      // Edge
      "&:focus::-webkit-input-placeholder": l,
      "&:focus::-moz-placeholder": l,
      // Firefox 19+
      "&:focus:-ms-input-placeholder": l,
      // IE11
      "&:focus::-ms-input-placeholder": l
      // Edge
    },
    [`&.${inputBaseClasses$1.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (e.vars || e).palette.text.disabled
      // Fix opacity Safari bug
    },
    "&:-webkit-autofill": {
      animationDuration: "5000s",
      animationName: "mui-auto-fill"
    }
  }, t.size === "small" && {
    paddingTop: 1
  }, t.multiline && {
    height: "auto",
    resize: "none",
    padding: 0,
    paddingTop: 0
  }, t.type === "search" && {
    // Improve type search style.
    MozAppearance: "textfield"
  });
}), inputGlobalStyles = /* @__PURE__ */ jsxRuntimeExports.jsx(GlobalStyles, {
  styles: {
    "@keyframes mui-auto-fill": {
      from: {
        display: "block"
      }
    },
    "@keyframes mui-auto-fill-cancel": {
      from: {
        display: "block"
      }
    }
  }
}), InputBase = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  var o;
  const s = useThemeProps({
    props: t,
    name: "MuiInputBase"
  }), {
    "aria-describedby": l,
    autoComplete: c,
    autoFocus: p,
    className: m,
    components: C = {},
    componentsProps: P = {},
    defaultValue: w,
    disabled: R,
    disableInjectingGlobalStyles: L,
    endAdornment: M,
    fullWidth: $ = !1,
    id: W,
    inputComponent: H = "input",
    inputProps: V = {},
    inputRef: N,
    maxRows: B,
    minRows: K,
    multiline: ue = !1,
    name: de,
    onBlur: ve,
    onChange: Te,
    onClick: Pe,
    onFocus: Ce,
    onKeyDown: Re,
    onKeyUp: ke,
    placeholder: Ae,
    readOnly: we,
    renderSuffix: he,
    rows: be,
    slotProps: le = {},
    slots: fe = {},
    startAdornment: ye,
    type: Ee = "text",
    value: Ie
  } = s, Fe = _objectWithoutPropertiesLoose$3(s, _excluded$z), De = V.value != null ? V.value : Ie, {
    current: Ve
  } = React$2.useRef(De != null), Oe = React$2.useRef(), Ze = React$2.useCallback((Ye) => {
    process.env.NODE_ENV !== "production" && Ye && Ye.nodeName !== "INPUT" && !Ye.focus && console.error(["MUI: You have provided a `inputComponent` to the input component", "that does not correctly handle the `ref` prop.", "Make sure the `ref` prop is called with a HTMLInputElement."].join(`
`));
  }, []), et = useForkRef(Oe, N, V.ref, Ze), [bt, rr] = React$2.useState(!1), St = useFormControl();
  process.env.NODE_ENV !== "production" && React$2.useEffect(() => {
    if (St)
      return St.registerEffect();
  }, [St]);
  const Qe = formControlState({
    props: s,
    muiFormControl: St,
    states: ["color", "disabled", "error", "hiddenLabel", "size", "required", "filled"]
  });
  Qe.focused = St ? St.focused : bt, React$2.useEffect(() => {
    !St && R && bt && (rr(!1), ve && ve());
  }, [St, R, bt, ve]);
  const xt = St && St.onFilled, je = St && St.onEmpty, kt = React$2.useCallback((Ye) => {
    isFilled(Ye) ? xt && xt() : je && je();
  }, [xt, je]);
  useEnhancedEffect$1(() => {
    Ve && kt({
      value: De
    });
  }, [De, kt, Ve]);
  const cr = (Ye) => {
    if (Qe.disabled) {
      Ye.stopPropagation();
      return;
    }
    Ce && Ce(Ye), V.onFocus && V.onFocus(Ye), St && St.onFocus ? St.onFocus(Ye) : rr(!0);
  }, Tr = (Ye) => {
    ve && ve(Ye), V.onBlur && V.onBlur(Ye), St && St.onBlur ? St.onBlur(Ye) : rr(!1);
  }, Er = (Ye, ...Je) => {
    if (!Ve) {
      const tr = Ye.target || Oe.current;
      if (tr == null)
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : formatMuiErrorMessage$1(1));
      kt({
        value: tr.value
      });
    }
    V.onChange && V.onChange(Ye, ...Je), Te && Te(Ye, ...Je);
  };
  React$2.useEffect(() => {
    kt(Oe.current);
  }, []);
  const Hr = (Ye) => {
    Oe.current && Ye.currentTarget === Ye.target && Oe.current.focus(), Pe && Pe(Ye);
  };
  let Br = H, hr = V;
  ue && Br === "input" && (be ? (process.env.NODE_ENV !== "production" && (K || B) && console.warn("MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set."), hr = _extends$5({
    type: void 0,
    minRows: be,
    maxRows: be
  }, hr)) : hr = _extends$5({
    type: void 0,
    maxRows: B,
    minRows: K
  }, hr), Br = TextareaAutosize);
  const Gr = (Ye) => {
    kt(Ye.animationName === "mui-auto-fill-cancel" ? Oe.current : {
      value: "x"
    });
  };
  React$2.useEffect(() => {
    St && St.setAdornedStart(!!ye);
  }, [St, ye]);
  const Yr = _extends$5({}, s, {
    color: Qe.color || "primary",
    disabled: Qe.disabled,
    endAdornment: M,
    error: Qe.error,
    focused: Qe.focused,
    formControl: St,
    fullWidth: $,
    hiddenLabel: Qe.hiddenLabel,
    multiline: ue,
    size: Qe.size,
    startAdornment: ye,
    type: Ee
  }), tt = useUtilityClasses$r(Yr), ar = fe.root || C.Root || InputBaseRoot, wr = le.root || P.root || {}, Sr = fe.input || C.Input || InputBaseComponent;
  return hr = _extends$5({}, hr, (o = le.input) != null ? o : P.input), /* @__PURE__ */ jsxRuntimeExports.jsxs(React$2.Fragment, {
    children: [!L && inputGlobalStyles, /* @__PURE__ */ jsxRuntimeExports.jsxs(ar, _extends$5({}, wr, !isHostComponent(ar) && {
      ownerState: _extends$5({}, Yr, wr.ownerState)
    }, {
      ref: n,
      onClick: Hr
    }, Fe, {
      className: clsx$1(tt.root, wr.className, m, we && "MuiInputBase-readOnly"),
      children: [ye, /* @__PURE__ */ jsxRuntimeExports.jsx(FormControlContext$1.Provider, {
        value: null,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(Sr, _extends$5({
          ownerState: Yr,
          "aria-invalid": Qe.error,
          "aria-describedby": l,
          autoComplete: c,
          autoFocus: p,
          defaultValue: w,
          disabled: Qe.disabled,
          id: W,
          onAnimationStart: Gr,
          name: de,
          placeholder: Ae,
          readOnly: we,
          required: Qe.required,
          rows: be,
          value: De,
          onKeyDown: Re,
          onKeyUp: ke,
          type: Ee
        }, hr, !isHostComponent(Sr) && {
          as: Br,
          ownerState: _extends$5({}, Yr, hr.ownerState)
        }, {
          ref: et,
          className: clsx$1(tt.input, hr.className, we && "MuiInputBase-readOnly"),
          onBlur: Tr,
          onChange: Er,
          onFocus: cr
        }))
      }), M, he ? he(_extends$5({}, Qe, {
        startAdornment: ye
      })) : null]
    }))]
  });
});
process.env.NODE_ENV !== "production" && (InputBase.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  "aria-describedby": PropTypes.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */
  disableInjectingGlobalStyles: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: elementTypeAcceptingRef$1,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */
  onInvalid: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * @ignore
   */
  renderSuffix: PropTypes.func,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The size of the component.
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
});
const InputBase$1 = InputBase;
function getInputUtilityClass(e) {
  return generateUtilityClass$1("MuiInput", e);
}
const inputClasses = _extends$5({}, inputBaseClasses$1, generateUtilityClasses$1("MuiInput", ["root", "underline", "input"])), inputClasses$1 = inputClasses;
function getOutlinedInputUtilityClass(e) {
  return generateUtilityClass$1("MuiOutlinedInput", e);
}
const outlinedInputClasses = _extends$5({}, inputBaseClasses$1, generateUtilityClasses$1("MuiOutlinedInput", ["root", "notchedOutline", "input"])), outlinedInputClasses$1 = outlinedInputClasses;
function getFilledInputUtilityClass(e) {
  return generateUtilityClass$1("MuiFilledInput", e);
}
const filledInputClasses = _extends$5({}, inputBaseClasses$1, generateUtilityClasses$1("MuiFilledInput", ["root", "underline", "input"])), filledInputClasses$1 = filledInputClasses, ArrowDropDownIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown"), _excluded$y = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"], styles$1 = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, Fade = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  const o = useTheme$1(), s = {
    enter: o.transitions.duration.enteringScreen,
    exit: o.transitions.duration.leavingScreen
  }, {
    addEndListener: l,
    appear: c = !0,
    children: p,
    easing: m,
    in: C,
    onEnter: P,
    onEntered: w,
    onEntering: R,
    onExit: L,
    onExited: M,
    onExiting: $,
    style: W,
    timeout: H = s,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: V = Transition$1
  } = t, N = _objectWithoutPropertiesLoose$3(t, _excluded$y), B = React$2.useRef(null), K = useForkRef(B, p.ref, n), ue = (Ae) => (we) => {
    if (Ae) {
      const he = B.current;
      we === void 0 ? Ae(he) : Ae(he, we);
    }
  }, de = ue(R), ve = ue((Ae, we) => {
    reflow(Ae);
    const he = getTransitionProps({
      style: W,
      timeout: H,
      easing: m
    }, {
      mode: "enter"
    });
    Ae.style.webkitTransition = o.transitions.create("opacity", he), Ae.style.transition = o.transitions.create("opacity", he), P && P(Ae, we);
  }), Te = ue(w), Pe = ue($), Ce = ue((Ae) => {
    const we = getTransitionProps({
      style: W,
      timeout: H,
      easing: m
    }, {
      mode: "exit"
    });
    Ae.style.webkitTransition = o.transitions.create("opacity", we), Ae.style.transition = o.transitions.create("opacity", we), L && L(Ae);
  }), Re = ue(M), ke = (Ae) => {
    l && l(B.current, Ae);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(V, _extends$5({
    appear: c,
    in: C,
    nodeRef: B,
    onEnter: ve,
    onEntered: Te,
    onEntering: de,
    onExit: Ce,
    onExited: Re,
    onExiting: Pe,
    addEndListener: ke,
    timeout: H
  }, N, {
    children: (Ae, we) => /* @__PURE__ */ React$2.cloneElement(p, _extends$5({
      style: _extends$5({
        opacity: 0,
        visibility: Ae === "exited" && !C ? "hidden" : void 0
      }, styles$1[Ae], W, p.props.style),
      ref: K
    }, we))
  }));
});
process.env.NODE_ENV !== "production" && (Fade.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: PropTypes.bool,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef$1.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes.func,
  /**
   * @ignore
   */
  onEntered: PropTypes.func,
  /**
   * @ignore
   */
  onEntering: PropTypes.func,
  /**
   * @ignore
   */
  onExit: PropTypes.func,
  /**
   * @ignore
   */
  onExited: PropTypes.func,
  /**
   * @ignore
   */
  onExiting: PropTypes.func,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
});
const Fade$1 = Fade;
function getBackdropUtilityClass(e) {
  return generateUtilityClass$1("MuiBackdrop", e);
}
generateUtilityClasses$1("MuiBackdrop", ["root", "invisible"]);
const _excluded$x = ["children", "className", "component", "components", "componentsProps", "invisible", "open", "slotProps", "slots", "TransitionComponent", "transitionDuration"], useUtilityClasses$q = (e) => {
  const {
    classes: t,
    invisible: n
  } = e;
  return composeClasses({
    root: ["root", n && "invisible"]
  }, getBackdropUtilityClass, t);
}, BackdropRoot = E("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.invisible && t.invisible];
  }
})(({
  ownerState: e
}) => _extends$5({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent"
}, e.invisible && {
  backgroundColor: "transparent"
})), Backdrop = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  var o, s, l;
  const c = useThemeProps({
    props: t,
    name: "MuiBackdrop"
  }), {
    children: p,
    className: m,
    component: C = "div",
    components: P = {},
    componentsProps: w = {},
    invisible: R = !1,
    open: L,
    slotProps: M = {},
    slots: $ = {},
    TransitionComponent: W = Fade$1,
    transitionDuration: H
  } = c, V = _objectWithoutPropertiesLoose$3(c, _excluded$x), N = _extends$5({}, c, {
    component: C,
    invisible: R
  }), B = useUtilityClasses$q(N), K = (o = M.root) != null ? o : w.root;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(W, _extends$5({
    in: L,
    timeout: H
  }, V, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(BackdropRoot, _extends$5({
      "aria-hidden": !0
    }, K, {
      as: (s = (l = $.root) != null ? l : P.Root) != null ? s : C,
      className: clsx$1(B.root, m, K == null ? void 0 : K.className),
      ownerState: _extends$5({}, N, K == null ? void 0 : K.ownerState),
      classes: B,
      ref: n,
      children: p
    }))
  }));
});
process.env.NODE_ENV !== "production" && (Backdrop.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    root: PropTypes.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: PropTypes.bool,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
});
const Backdrop$1 = Backdrop, boxClasses = generateUtilityClasses$1("MuiBox", ["root"]), boxClasses$1 = boxClasses, defaultTheme = createTheme(), Box = createBox({
  themeId: THEME_ID,
  defaultTheme,
  defaultClassName: boxClasses$1.root,
  generateClassName: ClassNameGenerator$1.generate
});
process.env.NODE_ENV !== "production" && (Box.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const U = Box;
function getButtonUtilityClass(e) {
  return generateUtilityClass$1("MuiButton", e);
}
const buttonClasses = generateUtilityClasses$1("MuiButton", ["root", "text", "textInherit", "textPrimary", "textSecondary", "textSuccess", "textError", "textInfo", "textWarning", "outlined", "outlinedInherit", "outlinedPrimary", "outlinedSecondary", "outlinedSuccess", "outlinedError", "outlinedInfo", "outlinedWarning", "contained", "containedInherit", "containedPrimary", "containedSecondary", "containedSuccess", "containedError", "containedInfo", "containedWarning", "disableElevation", "focusVisible", "disabled", "colorInherit", "textSizeSmall", "textSizeMedium", "textSizeLarge", "outlinedSizeSmall", "outlinedSizeMedium", "outlinedSizeLarge", "containedSizeSmall", "containedSizeMedium", "containedSizeLarge", "sizeMedium", "sizeSmall", "sizeLarge", "fullWidth", "startIcon", "endIcon", "iconSizeSmall", "iconSizeMedium", "iconSizeLarge"]), buttonClasses$1 = buttonClasses, ButtonGroupContext = /* @__PURE__ */ React$2.createContext({});
process.env.NODE_ENV !== "production" && (ButtonGroupContext.displayName = "ButtonGroupContext");
const ButtonGroupContext$1 = ButtonGroupContext, ButtonGroupButtonContext = /* @__PURE__ */ React$2.createContext(void 0);
process.env.NODE_ENV !== "production" && (ButtonGroupButtonContext.displayName = "ButtonGroupButtonContext");
const ButtonGroupButtonContext$1 = ButtonGroupButtonContext, _excluded$w = ["children", "color", "component", "className", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"], useUtilityClasses$p = (e) => {
  const {
    color: t,
    disableElevation: n,
    fullWidth: o,
    size: s,
    variant: l,
    classes: c
  } = e, p = {
    root: ["root", l, `${l}${capitalize$1(t)}`, `size${capitalize$1(s)}`, `${l}Size${capitalize$1(s)}`, t === "inherit" && "colorInherit", n && "disableElevation", o && "fullWidth"],
    label: ["label"],
    startIcon: ["startIcon", `iconSize${capitalize$1(s)}`],
    endIcon: ["endIcon", `iconSize${capitalize$1(s)}`]
  }, m = composeClasses(p, getButtonUtilityClass, c);
  return _extends$5({}, c, m);
}, commonIconStyles = (e) => _extends$5({}, e.size === "small" && {
  "& > *:nth-of-type(1)": {
    fontSize: 18
  }
}, e.size === "medium" && {
  "& > *:nth-of-type(1)": {
    fontSize: 20
  }
}, e.size === "large" && {
  "& > *:nth-of-type(1)": {
    fontSize: 22
  }
}), ButtonRoot = E(ButtonBase$1, {
  shouldForwardProp: (e) => rootShouldForwardProp(e) || e === "classes",
  name: "MuiButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`${n.variant}${capitalize$1(n.color)}`], t[`size${capitalize$1(n.size)}`], t[`${n.variant}Size${capitalize$1(n.size)}`], n.color === "inherit" && t.colorInherit, n.disableElevation && t.disableElevation, n.fullWidth && t.fullWidth];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var n, o;
  const s = e.palette.mode === "light" ? e.palette.grey[300] : e.palette.grey[800], l = e.palette.mode === "light" ? e.palette.grey.A100 : e.palette.grey[700];
  return _extends$5({}, e.typography.button, {
    minWidth: 64,
    padding: "6px 16px",
    borderRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create(["background-color", "box-shadow", "border-color", "color"], {
      duration: e.transitions.duration.short
    }),
    "&:hover": _extends$5({
      textDecoration: "none",
      backgroundColor: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : alpha_1(e.palette.text.primary, e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, t.variant === "text" && t.color !== "inherit" && {
      backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : alpha_1(e.palette[t.color].main, e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, t.variant === "outlined" && t.color !== "inherit" && {
      border: `1px solid ${(e.vars || e).palette[t.color].main}`,
      backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : alpha_1(e.palette[t.color].main, e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, t.variant === "contained" && {
      backgroundColor: e.vars ? e.vars.palette.Button.inheritContainedHoverBg : l,
      boxShadow: (e.vars || e).shadows[4],
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        boxShadow: (e.vars || e).shadows[2],
        backgroundColor: (e.vars || e).palette.grey[300]
      }
    }, t.variant === "contained" && t.color !== "inherit" && {
      backgroundColor: (e.vars || e).palette[t.color].dark,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (e.vars || e).palette[t.color].main
      }
    }),
    "&:active": _extends$5({}, t.variant === "contained" && {
      boxShadow: (e.vars || e).shadows[8]
    }),
    [`&.${buttonClasses$1.focusVisible}`]: _extends$5({}, t.variant === "contained" && {
      boxShadow: (e.vars || e).shadows[6]
    }),
    [`&.${buttonClasses$1.disabled}`]: _extends$5({
      color: (e.vars || e).palette.action.disabled
    }, t.variant === "outlined" && {
      border: `1px solid ${(e.vars || e).palette.action.disabledBackground}`
    }, t.variant === "contained" && {
      color: (e.vars || e).palette.action.disabled,
      boxShadow: (e.vars || e).shadows[0],
      backgroundColor: (e.vars || e).palette.action.disabledBackground
    })
  }, t.variant === "text" && {
    padding: "6px 8px"
  }, t.variant === "text" && t.color !== "inherit" && {
    color: (e.vars || e).palette[t.color].main
  }, t.variant === "outlined" && {
    padding: "5px 15px",
    border: "1px solid currentColor"
  }, t.variant === "outlined" && t.color !== "inherit" && {
    color: (e.vars || e).palette[t.color].main,
    border: e.vars ? `1px solid rgba(${e.vars.palette[t.color].mainChannel} / 0.5)` : `1px solid ${alpha_1(e.palette[t.color].main, 0.5)}`
  }, t.variant === "contained" && {
    color: e.vars ? (
      // this is safe because grey does not change between default light/dark mode
      e.vars.palette.text.primary
    ) : (n = (o = e.palette).getContrastText) == null ? void 0 : n.call(o, e.palette.grey[300]),
    backgroundColor: e.vars ? e.vars.palette.Button.inheritContainedBg : s,
    boxShadow: (e.vars || e).shadows[2]
  }, t.variant === "contained" && t.color !== "inherit" && {
    color: (e.vars || e).palette[t.color].contrastText,
    backgroundColor: (e.vars || e).palette[t.color].main
  }, t.color === "inherit" && {
    color: "inherit",
    borderColor: "currentColor"
  }, t.size === "small" && t.variant === "text" && {
    padding: "4px 5px",
    fontSize: e.typography.pxToRem(13)
  }, t.size === "large" && t.variant === "text" && {
    padding: "8px 11px",
    fontSize: e.typography.pxToRem(15)
  }, t.size === "small" && t.variant === "outlined" && {
    padding: "3px 9px",
    fontSize: e.typography.pxToRem(13)
  }, t.size === "large" && t.variant === "outlined" && {
    padding: "7px 21px",
    fontSize: e.typography.pxToRem(15)
  }, t.size === "small" && t.variant === "contained" && {
    padding: "4px 10px",
    fontSize: e.typography.pxToRem(13)
  }, t.size === "large" && t.variant === "contained" && {
    padding: "8px 22px",
    fontSize: e.typography.pxToRem(15)
  }, t.fullWidth && {
    width: "100%"
  });
}, ({
  ownerState: e
}) => e.disableElevation && {
  boxShadow: "none",
  "&:hover": {
    boxShadow: "none"
  },
  [`&.${buttonClasses$1.focusVisible}`]: {
    boxShadow: "none"
  },
  "&:active": {
    boxShadow: "none"
  },
  [`&.${buttonClasses$1.disabled}`]: {
    boxShadow: "none"
  }
}), ButtonStartIcon = E("span", {
  name: "MuiButton",
  slot: "StartIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.startIcon, t[`iconSize${capitalize$1(n.size)}`]];
  }
})(({
  ownerState: e
}) => _extends$5({
  display: "inherit",
  marginRight: 8,
  marginLeft: -4
}, e.size === "small" && {
  marginLeft: -2
}, commonIconStyles(e))), ButtonEndIcon = E("span", {
  name: "MuiButton",
  slot: "EndIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.endIcon, t[`iconSize${capitalize$1(n.size)}`]];
  }
})(({
  ownerState: e
}) => _extends$5({
  display: "inherit",
  marginRight: -4,
  marginLeft: 8
}, e.size === "small" && {
  marginRight: -2
}, commonIconStyles(e))), Button = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  const o = React$2.useContext(ButtonGroupContext$1), s = React$2.useContext(ButtonGroupButtonContext$1), l = resolveProps(o, t), c = useThemeProps({
    props: l,
    name: "MuiButton"
  }), {
    children: p,
    color: m = "primary",
    component: C = "button",
    className: P,
    disabled: w = !1,
    disableElevation: R = !1,
    disableFocusRipple: L = !1,
    endIcon: M,
    focusVisibleClassName: $,
    fullWidth: W = !1,
    size: H = "medium",
    startIcon: V,
    type: N,
    variant: B = "text"
  } = c, K = _objectWithoutPropertiesLoose$3(c, _excluded$w), ue = _extends$5({}, c, {
    color: m,
    component: C,
    disabled: w,
    disableElevation: R,
    disableFocusRipple: L,
    fullWidth: W,
    size: H,
    type: N,
    variant: B
  }), de = useUtilityClasses$p(ue), ve = V && /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonStartIcon, {
    className: de.startIcon,
    ownerState: ue,
    children: V
  }), Te = M && /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonEndIcon, {
    className: de.endIcon,
    ownerState: ue,
    children: M
  }), Pe = s || "";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ButtonRoot, _extends$5({
    ownerState: ue,
    className: clsx$1(o.className, de.root, P, Pe),
    component: C,
    disabled: w,
    focusRipple: !L,
    focusVisibleClassName: clsx$1(de.focusVisible, $),
    ref: n,
    type: N
  }, K, {
    classes: de,
    children: [ve, p, Te]
  }));
});
process.env.NODE_ENV !== "production" && (Button.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "primary", "secondary", "success", "error", "info", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: PropTypes.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * Element placed after the children.
   */
  endIcon: PropTypes.node,
  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: PropTypes.string,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["small", "medium", "large"]), PropTypes.string]),
  /**
   * Element placed before the children.
   */
  startIcon: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @ignore
   */
  type: PropTypes.oneOfType([PropTypes.oneOf(["button", "reset", "submit"]), PropTypes.string]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["contained", "outlined", "text"]), PropTypes.string])
});
const yt = Button;
function getSwitchBaseUtilityClass(e) {
  return generateUtilityClass$1("PrivateSwitchBase", e);
}
generateUtilityClasses$1("PrivateSwitchBase", ["root", "checked", "disabled", "input", "edgeStart", "edgeEnd"]);
const _excluded$v = ["autoFocus", "checked", "checkedIcon", "className", "defaultChecked", "disabled", "disableFocusRipple", "edge", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"], useUtilityClasses$o = (e) => {
  const {
    classes: t,
    checked: n,
    disabled: o,
    edge: s
  } = e, l = {
    root: ["root", n && "checked", o && "disabled", s && `edge${capitalize$1(s)}`],
    input: ["input"]
  };
  return composeClasses(l, getSwitchBaseUtilityClass, t);
}, SwitchBaseRoot = E(ButtonBase$1)(({
  ownerState: e
}) => _extends$5({
  padding: 9,
  borderRadius: "50%"
}, e.edge === "start" && {
  marginLeft: e.size === "small" ? -3 : -12
}, e.edge === "end" && {
  marginRight: e.size === "small" ? -3 : -12
})), SwitchBaseInput = E("input", {
  shouldForwardProp: rootShouldForwardProp
})({
  cursor: "inherit",
  position: "absolute",
  opacity: 0,
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
}), SwitchBase = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  const {
    autoFocus: o,
    checked: s,
    checkedIcon: l,
    className: c,
    defaultChecked: p,
    disabled: m,
    disableFocusRipple: C = !1,
    edge: P = !1,
    icon: w,
    id: R,
    inputProps: L,
    inputRef: M,
    name: $,
    onBlur: W,
    onChange: H,
    onFocus: V,
    readOnly: N,
    required: B = !1,
    tabIndex: K,
    type: ue,
    value: de
  } = t, ve = _objectWithoutPropertiesLoose$3(t, _excluded$v), [Te, Pe] = useControlled({
    controlled: s,
    default: !!p,
    name: "SwitchBase",
    state: "checked"
  }), Ce = useFormControl(), Re = (fe) => {
    V && V(fe), Ce && Ce.onFocus && Ce.onFocus(fe);
  }, ke = (fe) => {
    W && W(fe), Ce && Ce.onBlur && Ce.onBlur(fe);
  }, Ae = (fe) => {
    if (fe.nativeEvent.defaultPrevented)
      return;
    const ye = fe.target.checked;
    Pe(ye), H && H(fe, ye);
  };
  let we = m;
  Ce && typeof we > "u" && (we = Ce.disabled);
  const he = ue === "checkbox" || ue === "radio", be = _extends$5({}, t, {
    checked: Te,
    disabled: we,
    disableFocusRipple: C,
    edge: P
  }), le = useUtilityClasses$o(be);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(SwitchBaseRoot, _extends$5({
    component: "span",
    className: clsx$1(le.root, c),
    centerRipple: !0,
    focusRipple: !C,
    disabled: we,
    tabIndex: null,
    role: void 0,
    onFocus: Re,
    onBlur: ke,
    ownerState: be,
    ref: n
  }, ve, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(SwitchBaseInput, _extends$5({
      autoFocus: o,
      checked: s,
      defaultChecked: p,
      className: le.input,
      disabled: we,
      id: he ? R : void 0,
      name: $,
      onChange: Ae,
      readOnly: N,
      ref: M,
      required: B,
      ownerState: be,
      tabIndex: K,
      type: ue
    }, ue === "checkbox" && de === void 0 ? {} : {
      value: de
    }, L)), Te ? l : w]
  }));
});
process.env.NODE_ENV !== "production" && (SwitchBase.propTypes = {
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * @ignore
   */
  defaultChecked: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: PropTypes.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: PropTypes.node.isRequired,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,
  /*
   * @ignore
   */
  name: PropTypes.string,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   */
  required: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.object,
  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The input component prop `type`.
   */
  type: PropTypes.string.isRequired,
  /**
   * The value of the component.
   */
  value: PropTypes.any
});
const SwitchBase$1 = SwitchBase, CheckBoxOutlineBlankIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank"), CheckBoxIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox"), IndeterminateCheckBoxIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");
function getCheckboxUtilityClass(e) {
  return generateUtilityClass$1("MuiCheckbox", e);
}
const checkboxClasses = generateUtilityClasses$1("MuiCheckbox", ["root", "checked", "disabled", "indeterminate", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium"]), checkboxClasses$1 = checkboxClasses, _excluded$u = ["checkedIcon", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps", "size", "className"], useUtilityClasses$n = (e) => {
  const {
    classes: t,
    indeterminate: n,
    color: o,
    size: s
  } = e, l = {
    root: ["root", n && "indeterminate", `color${capitalize$1(o)}`, `size${capitalize$1(s)}`]
  }, c = composeClasses(l, getCheckboxUtilityClass, t);
  return _extends$5({}, t, c);
}, CheckboxRoot = E(SwitchBase$1, {
  shouldForwardProp: (e) => rootShouldForwardProp(e) || e === "classes",
  name: "MuiCheckbox",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.indeterminate && t.indeterminate, t[`size${capitalize$1(n.size)}`], n.color !== "default" && t[`color${capitalize$1(n.color)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => _extends$5({
  color: (e.vars || e).palette.text.secondary
}, !t.disableRipple && {
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${t.color === "default" ? e.vars.palette.action.activeChannel : e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : alpha_1(t.color === "default" ? e.palette.action.active : e.palette[t.color].main, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, t.color !== "default" && {
  [`&.${checkboxClasses$1.checked}, &.${checkboxClasses$1.indeterminate}`]: {
    color: (e.vars || e).palette[t.color].main
  },
  [`&.${checkboxClasses$1.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  }
})), defaultCheckedIcon$1 = /* @__PURE__ */ jsxRuntimeExports.jsx(CheckBoxIcon, {}), defaultIcon$1 = /* @__PURE__ */ jsxRuntimeExports.jsx(CheckBoxOutlineBlankIcon, {}), defaultIndeterminateIcon = /* @__PURE__ */ jsxRuntimeExports.jsx(IndeterminateCheckBoxIcon, {}), Checkbox = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  var o, s;
  const l = useThemeProps({
    props: t,
    name: "MuiCheckbox"
  }), {
    checkedIcon: c = defaultCheckedIcon$1,
    color: p = "primary",
    icon: m = defaultIcon$1,
    indeterminate: C = !1,
    indeterminateIcon: P = defaultIndeterminateIcon,
    inputProps: w,
    size: R = "medium",
    className: L
  } = l, M = _objectWithoutPropertiesLoose$3(l, _excluded$u), $ = C ? P : m, W = C ? P : c, H = _extends$5({}, l, {
    color: p,
    indeterminate: C,
    size: R
  }), V = useUtilityClasses$n(H);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxRoot, _extends$5({
    type: "checkbox",
    inputProps: _extends$5({
      "data-indeterminate": C
    }, w),
    icon: /* @__PURE__ */ React$2.cloneElement($, {
      fontSize: (o = $.props.fontSize) != null ? o : R
    }),
    checkedIcon: /* @__PURE__ */ React$2.cloneElement(W, {
      fontSize: (s = W.props.fontSize) != null ? s : R
    }),
    ownerState: H,
    ref: n,
    className: clsx$1(V.root, L)
  }, M, {
    classes: V
  }));
});
process.env.NODE_ENV !== "production" && (Checkbox.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,
  /**
   * The icon to display when the component is checked.
   * @default <CheckBoxIcon />
   */
  checkedIcon: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <CheckBoxOutlineBlankIcon />
   */
  icon: PropTypes.node,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the `input`.
   * @default false
   */
  indeterminate: PropTypes.bool,
  /**
   * The icon to display when the component is indeterminate.
   * @default <IndeterminateCheckBoxIcon />
   */
  indeterminateIcon: PropTypes.node,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense checkbox styling.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: PropTypes.any
});
const Checkbox$1 = Checkbox;
function getModalUtilityClass(e) {
  return generateUtilityClass$1("MuiModal", e);
}
generateUtilityClasses$1("MuiModal", ["root", "hidden", "backdrop"]);
const _excluded$t = ["BackdropComponent", "BackdropProps", "classes", "className", "closeAfterTransition", "children", "container", "component", "components", "componentsProps", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "onBackdropClick", "onClose", "onTransitionEnter", "onTransitionExited", "open", "slotProps", "slots", "theme"], useUtilityClasses$m = (e) => {
  const {
    open: t,
    exited: n,
    classes: o
  } = e;
  return composeClasses({
    root: ["root", !t && n && "hidden"],
    backdrop: ["backdrop"]
  }, getModalUtilityClass, o);
}, ModalRoot = E("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.open && n.exited && t.hidden];
  }
})(({
  theme: e,
  ownerState: t
}) => _extends$5({
  position: "fixed",
  zIndex: (e.vars || e).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0
}, !t.open && t.exited && {
  visibility: "hidden"
})), ModalBackdrop = E(Backdrop$1, {
  name: "MuiModal",
  slot: "Backdrop",
  overridesResolver: (e, t) => t.backdrop
})({
  zIndex: -1
}), Modal = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  var o, s, l, c, p, m;
  const C = useThemeProps({
    name: "MuiModal",
    props: t
  }), {
    BackdropComponent: P = ModalBackdrop,
    BackdropProps: w,
    className: R,
    closeAfterTransition: L = !1,
    children: M,
    container: $,
    component: W,
    components: H = {},
    componentsProps: V = {},
    disableAutoFocus: N = !1,
    disableEnforceFocus: B = !1,
    disableEscapeKeyDown: K = !1,
    disablePortal: ue = !1,
    disableRestoreFocus: de = !1,
    disableScrollLock: ve = !1,
    hideBackdrop: Te = !1,
    keepMounted: Pe = !1,
    onBackdropClick: Ce,
    open: Re,
    slotProps: ke,
    slots: Ae
    // eslint-disable-next-line react/prop-types
  } = C, we = _objectWithoutPropertiesLoose$3(C, _excluded$t), he = _extends$5({}, C, {
    closeAfterTransition: L,
    disableAutoFocus: N,
    disableEnforceFocus: B,
    disableEscapeKeyDown: K,
    disablePortal: ue,
    disableRestoreFocus: de,
    disableScrollLock: ve,
    hideBackdrop: Te,
    keepMounted: Pe
  }), {
    getRootProps: be,
    getBackdropProps: le,
    getTransitionProps: fe,
    portalRef: ye,
    isTopModal: Ee,
    exited: Ie,
    hasTransition: Fe
  } = useModal(_extends$5({}, he, {
    rootRef: n
  })), De = _extends$5({}, he, {
    exited: Ie
  }), Ve = useUtilityClasses$m(De), Oe = {};
  if (M.props.tabIndex === void 0 && (Oe.tabIndex = "-1"), Fe) {
    const {
      onEnter: xt,
      onExited: je
    } = fe();
    Oe.onEnter = xt, Oe.onExited = je;
  }
  const Ze = (o = (s = Ae == null ? void 0 : Ae.root) != null ? s : H.Root) != null ? o : ModalRoot, et = (l = (c = Ae == null ? void 0 : Ae.backdrop) != null ? c : H.Backdrop) != null ? l : P, bt = (p = ke == null ? void 0 : ke.root) != null ? p : V.root, rr = (m = ke == null ? void 0 : ke.backdrop) != null ? m : V.backdrop, St = useSlotProps({
    elementType: Ze,
    externalSlotProps: bt,
    externalForwardedProps: we,
    getSlotProps: be,
    additionalProps: {
      ref: n,
      as: W
    },
    ownerState: De,
    className: clsx$1(R, bt == null ? void 0 : bt.className, Ve == null ? void 0 : Ve.root, !De.open && De.exited && (Ve == null ? void 0 : Ve.hidden))
  }), Qe = useSlotProps({
    elementType: et,
    externalSlotProps: rr,
    additionalProps: w,
    getSlotProps: (xt) => le(_extends$5({}, xt, {
      onClick: (je) => {
        Ce && Ce(je), xt != null && xt.onClick && xt.onClick(je);
      }
    })),
    className: clsx$1(rr == null ? void 0 : rr.className, w == null ? void 0 : w.className, Ve == null ? void 0 : Ve.backdrop),
    ownerState: De
  });
  return !Pe && !Re && (!Fe || Ie) ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(Portal, {
    ref: ye,
    container: $,
    disablePortal: ue,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Ze, _extends$5({}, St, {
      children: [!Te && P ? /* @__PURE__ */ jsxRuntimeExports.jsx(et, _extends$5({}, Qe)) : null, /* @__PURE__ */ jsxRuntimeExports.jsx(FocusTrap, {
        disableEnforceFocus: B,
        disableAutoFocus: N,
        disableRestoreFocus: de,
        isEnabled: Ee,
        open: Re,
        children: /* @__PURE__ */ React$2.cloneElement(M, Oe)
      })]
    }))
  });
});
process.env.NODE_ENV !== "production" && (Modal.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: PropTypes.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: PropTypes.object,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef$1.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: PropTypes.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Backdrop: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    backdrop: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: PropTypes.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: PropTypes.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: PropTypes.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: PropTypes.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: PropTypes.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: PropTypes.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: PropTypes.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: PropTypes.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: PropTypes.shape({
    backdrop: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    backdrop: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const Modal$1 = Modal, dividerClasses = generateUtilityClasses$1("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]), dividerClasses$1 = dividerClasses, _excluded$s = ["disableUnderline", "components", "componentsProps", "fullWidth", "hiddenLabel", "inputComponent", "multiline", "slotProps", "slots", "type"], useUtilityClasses$l = (e) => {
  const {
    classes: t,
    disableUnderline: n
  } = e, s = composeClasses({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, getFilledInputUtilityClass, t);
  return _extends$5({}, t, s);
}, FilledInputRoot = E(InputBaseRoot, {
  shouldForwardProp: (e) => rootShouldForwardProp(e) || e === "classes",
  name: "MuiFilledInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [...rootOverridesResolver(e, t), !n.disableUnderline && t.underline];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var n;
  const o = e.palette.mode === "light", s = o ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", l = o ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", c = o ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", p = o ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return _extends$5({
    position: "relative",
    backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : l,
    borderTopLeftRadius: (e.vars || e).shape.borderRadius,
    borderTopRightRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create("background-color", {
      duration: e.transitions.duration.shorter,
      easing: e.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.hoverBg : c,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : l
      }
    },
    [`&.${filledInputClasses$1.focused}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : l
    },
    [`&.${filledInputClasses$1.disabled}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.disabledBg : p
    }
  }, !t.disableUnderline && {
    "&::after": {
      borderBottom: `2px solid ${(n = (e.vars || e).palette[t.color || "primary"]) == null ? void 0 : n.main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: "absolute",
      right: 0,
      transform: "scaleX(0)",
      transition: e.transitions.create("transform", {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&.${filledInputClasses$1.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: "scaleX(1) translateX(0)"
    },
    [`&.${filledInputClasses$1.error}`]: {
      "&::before, &::after": {
        borderBottomColor: (e.vars || e).palette.error.main
      }
    },
    "&::before": {
      borderBottom: `1px solid ${e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})` : s}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: "absolute",
      right: 0,
      transition: e.transitions.create("border-bottom-color", {
        duration: e.transitions.duration.shorter
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&:hover:not(.${filledInputClasses$1.disabled}, .${filledInputClasses$1.error}):before`]: {
      borderBottom: `1px solid ${(e.vars || e).palette.text.primary}`
    },
    [`&.${filledInputClasses$1.disabled}:before`]: {
      borderBottomStyle: "dotted"
    }
  }, t.startAdornment && {
    paddingLeft: 12
  }, t.endAdornment && {
    paddingRight: 12
  }, t.multiline && _extends$5({
    padding: "25px 12px 8px"
  }, t.size === "small" && {
    paddingTop: 21,
    paddingBottom: 4
  }, t.hiddenLabel && {
    paddingTop: 16,
    paddingBottom: 17
  }, t.hiddenLabel && t.size === "small" && {
    paddingTop: 8,
    paddingBottom: 9
  }));
}), FilledInputInput = E(InputBaseComponent, {
  name: "MuiFilledInput",
  slot: "Input",
  overridesResolver: inputOverridesResolver
})(({
  theme: e,
  ownerState: t
}) => _extends$5({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12
}, !e.vars && {
  "&:-webkit-autofill": {
    WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
    WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
    caretColor: e.palette.mode === "light" ? null : "#fff",
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit"
  }
}, e.vars && {
  "&:-webkit-autofill": {
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit"
  },
  [e.getColorSchemeSelector("dark")]: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px #266798 inset",
      WebkitTextFillColor: "#fff",
      caretColor: "#fff"
    }
  }
}, t.size === "small" && {
  paddingTop: 21,
  paddingBottom: 4
}, t.hiddenLabel && {
  paddingTop: 16,
  paddingBottom: 17
}, t.startAdornment && {
  paddingLeft: 0
}, t.endAdornment && {
  paddingRight: 0
}, t.hiddenLabel && t.size === "small" && {
  paddingTop: 8,
  paddingBottom: 9
}, t.multiline && {
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0
})), FilledInput = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  var o, s, l, c;
  const p = useThemeProps({
    props: t,
    name: "MuiFilledInput"
  }), {
    components: m = {},
    componentsProps: C,
    fullWidth: P = !1,
    // declare here to prevent spreading to DOM
    inputComponent: w = "input",
    multiline: R = !1,
    slotProps: L,
    slots: M = {},
    type: $ = "text"
  } = p, W = _objectWithoutPropertiesLoose$3(p, _excluded$s), H = _extends$5({}, p, {
    fullWidth: P,
    inputComponent: w,
    multiline: R,
    type: $
  }), V = useUtilityClasses$l(p), N = {
    root: {
      ownerState: H
    },
    input: {
      ownerState: H
    }
  }, B = L ?? C ? deepmerge$1(N, L ?? C) : N, K = (o = (s = M.root) != null ? s : m.Root) != null ? o : FilledInputRoot, ue = (l = (c = M.input) != null ? c : m.Input) != null ? l : FilledInputInput;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(InputBase$1, _extends$5({
    slots: {
      root: K,
      input: ue
    },
    componentsProps: B,
    fullWidth: P,
    inputComponent: w,
    multiline: R,
    ref: n,
    type: $
  }, W, {
    classes: V
  }));
});
process.env.NODE_ENV !== "production" && (FilledInput.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: PropTypes.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
});
FilledInput.muiName = "Input";
const FilledInput$1 = FilledInput;
function getFormControlUtilityClasses(e) {
  return generateUtilityClass$1("MuiFormControl", e);
}
generateUtilityClasses$1("MuiFormControl", ["root", "marginNone", "marginNormal", "marginDense", "fullWidth", "disabled"]);
const _excluded$r = ["children", "className", "color", "component", "disabled", "error", "focused", "fullWidth", "hiddenLabel", "margin", "required", "size", "variant"], useUtilityClasses$k = (e) => {
  const {
    classes: t,
    margin: n,
    fullWidth: o
  } = e, s = {
    root: ["root", n !== "none" && `margin${capitalize$1(n)}`, o && "fullWidth"]
  };
  return composeClasses(s, getFormControlUtilityClasses, t);
}, FormControlRoot = E("div", {
  name: "MuiFormControl",
  slot: "Root",
  overridesResolver: ({
    ownerState: e
  }, t) => _extends$5({}, t.root, t[`margin${capitalize$1(e.margin)}`], e.fullWidth && t.fullWidth)
})(({
  ownerState: e
}) => _extends$5({
  display: "inline-flex",
  flexDirection: "column",
  position: "relative",
  // Reset fieldset default style.
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  verticalAlign: "top"
}, e.margin === "normal" && {
  marginTop: 16,
  marginBottom: 8
}, e.margin === "dense" && {
  marginTop: 8,
  marginBottom: 4
}, e.fullWidth && {
  width: "100%"
})), FormControl = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  const o = useThemeProps({
    props: t,
    name: "MuiFormControl"
  }), {
    children: s,
    className: l,
    color: c = "primary",
    component: p = "div",
    disabled: m = !1,
    error: C = !1,
    focused: P,
    fullWidth: w = !1,
    hiddenLabel: R = !1,
    margin: L = "none",
    required: M = !1,
    size: $ = "medium",
    variant: W = "outlined"
  } = o, H = _objectWithoutPropertiesLoose$3(o, _excluded$r), V = _extends$5({}, o, {
    color: c,
    component: p,
    disabled: m,
    error: C,
    fullWidth: w,
    hiddenLabel: R,
    margin: L,
    required: M,
    size: $,
    variant: W
  }), N = useUtilityClasses$k(V), [B, K] = React$2.useState(() => {
    let ke = !1;
    return s && React$2.Children.forEach(s, (Ae) => {
      if (!isMuiElement(Ae, ["Input", "Select"]))
        return;
      const we = isMuiElement(Ae, ["Select"]) ? Ae.props.input : Ae;
      we && isAdornedStart(we.props) && (ke = !0);
    }), ke;
  }), [ue, de] = React$2.useState(() => {
    let ke = !1;
    return s && React$2.Children.forEach(s, (Ae) => {
      isMuiElement(Ae, ["Input", "Select"]) && (isFilled(Ae.props, !0) || isFilled(Ae.props.inputProps, !0)) && (ke = !0);
    }), ke;
  }), [ve, Te] = React$2.useState(!1);
  m && ve && Te(!1);
  const Pe = P !== void 0 && !m ? P : ve;
  let Ce;
  if (process.env.NODE_ENV !== "production") {
    const ke = React$2.useRef(!1);
    Ce = () => (ke.current && console.error(["MUI: There are multiple `InputBase` components inside a FormControl.", "This creates visual inconsistencies, only use one `InputBase`."].join(`
`)), ke.current = !0, () => {
      ke.current = !1;
    });
  }
  const Re = React$2.useMemo(() => ({
    adornedStart: B,
    setAdornedStart: K,
    color: c,
    disabled: m,
    error: C,
    filled: ue,
    focused: Pe,
    fullWidth: w,
    hiddenLabel: R,
    size: $,
    onBlur: () => {
      Te(!1);
    },
    onEmpty: () => {
      de(!1);
    },
    onFilled: () => {
      de(!0);
    },
    onFocus: () => {
      Te(!0);
    },
    registerEffect: Ce,
    required: M,
    variant: W
  }), [B, c, m, C, ue, Pe, w, R, Ce, M, $, W]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormControlContext$1.Provider, {
    value: Re,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormControlRoot, _extends$5({
      as: p,
      ownerState: V,
      className: clsx$1(N.root, l),
      ref: n
    }, H, {
      children: s
    }))
  });
});
process.env.NODE_ENV !== "production" && (FormControl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: PropTypes.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: PropTypes.bool,
  /**
   * If `true`, the component will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: PropTypes.bool,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: PropTypes.oneOf(["dense", "none", "normal"]),
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
});
const FormControl$1 = FormControl, Stack = createStack({
  createStyledComponent: E("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (e, t) => t.root
  }),
  useThemeProps: (e) => useThemeProps({
    props: e,
    name: "MuiStack"
  })
});
process.env.NODE_ENV !== "production" && (Stack.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'column'
   */
  direction: PropTypes.oneOfType([PropTypes.oneOf(["column-reverse", "column", "row-reverse", "row"]), PropTypes.arrayOf(PropTypes.oneOf(["column-reverse", "column", "row-reverse", "row"])), PropTypes.object]),
  /**
   * Add an element between each child.
   */
  divider: PropTypes.node,
  /**
   * Defines the space between immediate children.
   * @default 0
   */
  spacing: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.string]),
  /**
   * The system prop, which allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * If `true`, the CSS flexbox `gap` is used instead of applying `margin` to children.
   *
   * While CSS `gap` removes the [known limitations](https://mui.com/joy-ui/react-stack/#limitations),
   * it is not fully supported in some browsers. We recommend checking https://caniuse.com/?search=flex%20gap before using this flag.
   *
   * To enable this flag globally, follow the [theme's default props](https://mui.com/material-ui/customization/theme-components/#default-props) configuration.
   * @default false
   */
  useFlexGap: PropTypes.bool
});
const Stack$1 = Stack;
function getFormControlLabelUtilityClasses(e) {
  return generateUtilityClass$1("MuiFormControlLabel", e);
}
const formControlLabelClasses = generateUtilityClasses$1("MuiFormControlLabel", ["root", "labelPlacementStart", "labelPlacementTop", "labelPlacementBottom", "disabled", "label", "error", "required", "asterisk"]), formControlLabelClasses$1 = formControlLabelClasses, _excluded$q = ["checked", "className", "componentsProps", "control", "disabled", "disableTypography", "inputRef", "label", "labelPlacement", "name", "onChange", "required", "slotProps", "value"], useUtilityClasses$j = (e) => {
  const {
    classes: t,
    disabled: n,
    labelPlacement: o,
    error: s,
    required: l
  } = e, c = {
    root: ["root", n && "disabled", `labelPlacement${capitalize$1(o)}`, s && "error", l && "required"],
    label: ["label", n && "disabled"],
    asterisk: ["asterisk", s && "error"]
  };
  return composeClasses(c, getFormControlLabelUtilityClasses, t);
}, FormControlLabelRoot = E("label", {
  name: "MuiFormControlLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${formControlLabelClasses$1.label}`]: t.label
    }, t.root, t[`labelPlacement${capitalize$1(n.labelPlacement)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => _extends$5({
  display: "inline-flex",
  alignItems: "center",
  cursor: "pointer",
  // For correct alignment with the text.
  verticalAlign: "middle",
  WebkitTapHighlightColor: "transparent",
  marginLeft: -11,
  marginRight: 16,
  // used for row presentation of radio/checkbox
  [`&.${formControlLabelClasses$1.disabled}`]: {
    cursor: "default"
  }
}, t.labelPlacement === "start" && {
  flexDirection: "row-reverse",
  marginLeft: 16,
  // used for row presentation of radio/checkbox
  marginRight: -11
}, t.labelPlacement === "top" && {
  flexDirection: "column-reverse",
  marginLeft: 16
}, t.labelPlacement === "bottom" && {
  flexDirection: "column",
  marginLeft: 16
}, {
  [`& .${formControlLabelClasses$1.label}`]: {
    [`&.${formControlLabelClasses$1.disabled}`]: {
      color: (e.vars || e).palette.text.disabled
    }
  }
})), AsteriskComponent$1 = E("span", {
  name: "MuiFormControlLabel",
  slot: "Asterisk",
  overridesResolver: (e, t) => t.asterisk
})(({
  theme: e
}) => ({
  [`&.${formControlLabelClasses$1.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), FormControlLabel = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  var o, s;
  const l = useThemeProps({
    props: t,
    name: "MuiFormControlLabel"
  }), {
    className: c,
    componentsProps: p = {},
    control: m,
    disabled: C,
    disableTypography: P,
    label: w,
    labelPlacement: R = "end",
    required: L,
    slotProps: M = {}
  } = l, $ = _objectWithoutPropertiesLoose$3(l, _excluded$q), W = useFormControl(), H = (o = C ?? m.props.disabled) != null ? o : W == null ? void 0 : W.disabled, V = L ?? m.props.required, N = {
    disabled: H,
    required: V
  };
  ["checked", "name", "onChange", "value", "inputRef"].forEach((Te) => {
    typeof m.props[Te] > "u" && typeof l[Te] < "u" && (N[Te] = l[Te]);
  });
  const B = formControlState({
    props: l,
    muiFormControl: W,
    states: ["error"]
  }), K = _extends$5({}, l, {
    disabled: H,
    labelPlacement: R,
    required: V,
    error: B.error
  }), ue = useUtilityClasses$j(K), de = (s = M.typography) != null ? s : p.typography;
  let ve = w;
  return ve != null && ve.type !== Typography$1 && !P && (ve = /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$1, _extends$5({
    component: "span"
  }, de, {
    className: clsx$1(ue.label, de == null ? void 0 : de.className),
    children: ve
  }))), /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControlLabelRoot, _extends$5({
    className: clsx$1(ue.root, c),
    ownerState: K,
    ref: n
  }, $, {
    children: [/* @__PURE__ */ React$2.cloneElement(m, N), V ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack$1, {
      display: "block",
      children: [ve, /* @__PURE__ */ jsxRuntimeExports.jsxs(AsteriskComponent$1, {
        ownerState: K,
        "aria-hidden": !0,
        className: ue.asterisk,
        children: [" ", "*"]
      })]
    }) : ve]
  }));
});
process.env.NODE_ENV !== "production" && (FormControlLabel.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component appears selected.
   */
  checked: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  componentsProps: PropTypes.shape({
    typography: PropTypes.object
  }),
  /**
   * A control element. For instance, it can be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: PropTypes.element.isRequired,
  /**
   * If `true`, the control is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is rendered as it is passed without an additional typography node.
   */
  disableTypography: PropTypes.bool,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,
  /**
   * A text or an element to be used in an enclosing label element.
   */
  label: PropTypes.node,
  /**
   * The position of the label.
   * @default 'end'
   */
  labelPlacement: PropTypes.oneOf(["bottom", "end", "start", "top"]),
  /**
   * @ignore
   */
  name: PropTypes.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: PropTypes.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    typography: PropTypes.object
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The value of the component.
   */
  value: PropTypes.any
});
const FormControlLabel$1 = FormControlLabel;
function getFormGroupUtilityClass(e) {
  return generateUtilityClass$1("MuiFormGroup", e);
}
generateUtilityClasses$1("MuiFormGroup", ["root", "row", "error"]);
const _excluded$p = ["className", "row"], useUtilityClasses$i = (e) => {
  const {
    classes: t,
    row: n,
    error: o
  } = e;
  return composeClasses({
    root: ["root", n && "row", o && "error"]
  }, getFormGroupUtilityClass, t);
}, FormGroupRoot = E("div", {
  name: "MuiFormGroup",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.row && t.row];
  }
})(({
  ownerState: e
}) => _extends$5({
  display: "flex",
  flexDirection: "column",
  flexWrap: "wrap"
}, e.row && {
  flexDirection: "row"
})), FormGroup = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  const o = useThemeProps({
    props: t,
    name: "MuiFormGroup"
  }), {
    className: s,
    row: l = !1
  } = o, c = _objectWithoutPropertiesLoose$3(o, _excluded$p), p = useFormControl(), m = formControlState({
    props: o,
    muiFormControl: p,
    states: ["error"]
  }), C = _extends$5({}, o, {
    row: l,
    error: m.error
  }), P = useUtilityClasses$i(C);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormGroupRoot, _extends$5({
    className: clsx$1(P.root, s),
    ownerState: C,
    ref: n
  }, c));
});
process.env.NODE_ENV !== "production" && (FormGroup.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * Display group of elements in a compact row.
   * @default false
   */
  row: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const FormGroup$1 = FormGroup;
function getFormHelperTextUtilityClasses(e) {
  return generateUtilityClass$1("MuiFormHelperText", e);
}
const formHelperTextClasses = generateUtilityClasses$1("MuiFormHelperText", ["root", "error", "disabled", "sizeSmall", "sizeMedium", "contained", "focused", "filled", "required"]), formHelperTextClasses$1 = formHelperTextClasses;
var _span$3;
const _excluded$o = ["children", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"], useUtilityClasses$h = (e) => {
  const {
    classes: t,
    contained: n,
    size: o,
    disabled: s,
    error: l,
    filled: c,
    focused: p,
    required: m
  } = e, C = {
    root: ["root", s && "disabled", l && "error", o && `size${capitalize$1(o)}`, n && "contained", p && "focused", c && "filled", m && "required"]
  };
  return composeClasses(C, getFormHelperTextUtilityClasses, t);
}, FormHelperTextRoot = E("p", {
  name: "MuiFormHelperText",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.size && t[`size${capitalize$1(n.size)}`], n.contained && t.contained, n.filled && t.filled];
  }
})(({
  theme: e,
  ownerState: t
}) => _extends$5({
  color: (e.vars || e).palette.text.secondary
}, e.typography.caption, {
  textAlign: "left",
  marginTop: 3,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  [`&.${formHelperTextClasses$1.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${formHelperTextClasses$1.error}`]: {
    color: (e.vars || e).palette.error.main
  }
}, t.size === "small" && {
  marginTop: 4
}, t.contained && {
  marginLeft: 14,
  marginRight: 14
})), FormHelperText = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  const o = useThemeProps({
    props: t,
    name: "MuiFormHelperText"
  }), {
    children: s,
    className: l,
    component: c = "p"
  } = o, p = _objectWithoutPropertiesLoose$3(o, _excluded$o), m = useFormControl(), C = formControlState({
    props: o,
    muiFormControl: m,
    states: ["variant", "size", "disabled", "error", "filled", "focused", "required"]
  }), P = _extends$5({}, o, {
    component: c,
    contained: C.variant === "filled" || C.variant === "outlined",
    variant: C.variant,
    size: C.size,
    disabled: C.disabled,
    error: C.error,
    filled: C.filled,
    focused: C.focused,
    required: C.required
  }), w = useUtilityClasses$h(P);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperTextRoot, _extends$5({
    as: c,
    ownerState: P,
    className: clsx$1(w.root, l),
    ref: n
  }, p, {
    children: s === " " ? (
      // notranslate needed while Google Translate will not fix zero-width space issue
      _span$3 || (_span$3 = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
        className: "notranslate",
        children: "​"
      }))
    ) : s
  }));
});
process.env.NODE_ENV !== "production" && (FormHelperText.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: PropTypes.bool,
  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: PropTypes.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(["dense"]),
  /**
   * If `true`, the helper text should use required classes key.
   */
  required: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["filled", "outlined", "standard"]), PropTypes.string])
});
const FormHelperText$1 = FormHelperText;
function getFormLabelUtilityClasses(e) {
  return generateUtilityClass$1("MuiFormLabel", e);
}
const formLabelClasses = generateUtilityClasses$1("MuiFormLabel", ["root", "colorSecondary", "focused", "disabled", "error", "filled", "required", "asterisk"]), formLabelClasses$1 = formLabelClasses, _excluded$n = ["children", "className", "color", "component", "disabled", "error", "filled", "focused", "required"], useUtilityClasses$g = (e) => {
  const {
    classes: t,
    color: n,
    focused: o,
    disabled: s,
    error: l,
    filled: c,
    required: p
  } = e, m = {
    root: ["root", `color${capitalize$1(n)}`, s && "disabled", l && "error", c && "filled", o && "focused", p && "required"],
    asterisk: ["asterisk", l && "error"]
  };
  return composeClasses(m, getFormLabelUtilityClasses, t);
}, FormLabelRoot = E("label", {
  name: "MuiFormLabel",
  slot: "Root",
  overridesResolver: ({
    ownerState: e
  }, t) => _extends$5({}, t.root, e.color === "secondary" && t.colorSecondary, e.filled && t.filled)
})(({
  theme: e,
  ownerState: t
}) => _extends$5({
  color: (e.vars || e).palette.text.secondary
}, e.typography.body1, {
  lineHeight: "1.4375em",
  padding: 0,
  position: "relative",
  [`&.${formLabelClasses$1.focused}`]: {
    color: (e.vars || e).palette[t.color].main
  },
  [`&.${formLabelClasses$1.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${formLabelClasses$1.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), AsteriskComponent = E("span", {
  name: "MuiFormLabel",
  slot: "Asterisk",
  overridesResolver: (e, t) => t.asterisk
})(({
  theme: e
}) => ({
  [`&.${formLabelClasses$1.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), FormLabel = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  const o = useThemeProps({
    props: t,
    name: "MuiFormLabel"
  }), {
    children: s,
    className: l,
    component: c = "label"
  } = o, p = _objectWithoutPropertiesLoose$3(o, _excluded$n), m = useFormControl(), C = formControlState({
    props: o,
    muiFormControl: m,
    states: ["color", "required", "focused", "disabled", "error", "filled"]
  }), P = _extends$5({}, o, {
    color: C.color || "primary",
    component: c,
    disabled: C.disabled,
    error: C.error,
    filled: C.filled,
    focused: C.focused,
    required: C.required
  }), w = useUtilityClasses$g(P);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(FormLabelRoot, _extends$5({
    as: c,
    ownerState: P,
    className: clsx$1(w.root, l),
    ref: n
  }, p, {
    children: [s, C.required && /* @__PURE__ */ jsxRuntimeExports.jsxs(AsteriskComponent, {
      ownerState: P,
      "aria-hidden": !0,
      className: w.asterisk,
      children: [" ", "*"]
    })]
  }));
});
process.env.NODE_ENV !== "production" && (FormLabel.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the label should use filled classes key.
   */
  filled: PropTypes.bool,
  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: PropTypes.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const FormLabel$1 = FormLabel, _excluded$m = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function getScale(e) {
  return `scale(${e}, ${e ** 2})`;
}
const styles = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, isWebKit154 = typeof navigator < "u" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), Grow = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  const {
    addEndListener: o,
    appear: s = !0,
    children: l,
    easing: c,
    in: p,
    onEnter: m,
    onEntered: C,
    onEntering: P,
    onExit: w,
    onExited: R,
    onExiting: L,
    style: M,
    timeout: $ = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: W = Transition$1
  } = t, H = _objectWithoutPropertiesLoose$3(t, _excluded$m), V = useTimeout(), N = React$2.useRef(), B = useTheme$1(), K = React$2.useRef(null), ue = useForkRef(K, l.ref, n), de = (we) => (he) => {
    if (we) {
      const be = K.current;
      he === void 0 ? we(be) : we(be, he);
    }
  }, ve = de(P), Te = de((we, he) => {
    reflow(we);
    const {
      duration: be,
      delay: le,
      easing: fe
    } = getTransitionProps({
      style: M,
      timeout: $,
      easing: c
    }, {
      mode: "enter"
    });
    let ye;
    $ === "auto" ? (ye = B.transitions.getAutoHeightDuration(we.clientHeight), N.current = ye) : ye = be, we.style.transition = [B.transitions.create("opacity", {
      duration: ye,
      delay: le
    }), B.transitions.create("transform", {
      duration: isWebKit154 ? ye : ye * 0.666,
      delay: le,
      easing: fe
    })].join(","), m && m(we, he);
  }), Pe = de(C), Ce = de(L), Re = de((we) => {
    const {
      duration: he,
      delay: be,
      easing: le
    } = getTransitionProps({
      style: M,
      timeout: $,
      easing: c
    }, {
      mode: "exit"
    });
    let fe;
    $ === "auto" ? (fe = B.transitions.getAutoHeightDuration(we.clientHeight), N.current = fe) : fe = he, we.style.transition = [B.transitions.create("opacity", {
      duration: fe,
      delay: be
    }), B.transitions.create("transform", {
      duration: isWebKit154 ? fe : fe * 0.666,
      delay: isWebKit154 ? be : be || fe * 0.333,
      easing: le
    })].join(","), we.style.opacity = 0, we.style.transform = getScale(0.75), w && w(we);
  }), ke = de(R), Ae = (we) => {
    $ === "auto" && V.start(N.current || 0, we), o && o(K.current, we);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(W, _extends$5({
    appear: s,
    in: p,
    nodeRef: K,
    onEnter: Te,
    onEntered: Pe,
    onEntering: ve,
    onExit: Re,
    onExited: ke,
    onExiting: Ce,
    addEndListener: Ae,
    timeout: $ === "auto" ? null : $
  }, H, {
    children: (we, he) => /* @__PURE__ */ React$2.cloneElement(l, _extends$5({
      style: _extends$5({
        opacity: 0,
        transform: getScale(0.75),
        visibility: we === "exited" && !p ? "hidden" : void 0
      }, styles[we], M, l.props.style),
      ref: ue
    }, he))
  }));
});
process.env.NODE_ENV !== "production" && (Grow.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: PropTypes.bool,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef$1.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes.func,
  /**
   * @ignore
   */
  onEntered: PropTypes.func,
  /**
   * @ignore
   */
  onEntering: PropTypes.func,
  /**
   * @ignore
   */
  onExit: PropTypes.func,
  /**
   * @ignore
   */
  onExited: PropTypes.func,
  /**
   * @ignore
   */
  onExiting: PropTypes.func,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
});
Grow.muiSupportAuto = !0;
const Grow$1 = Grow, _excluded$l = ["disableUnderline", "components", "componentsProps", "fullWidth", "inputComponent", "multiline", "slotProps", "slots", "type"], useUtilityClasses$f = (e) => {
  const {
    classes: t,
    disableUnderline: n
  } = e, s = composeClasses({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, getInputUtilityClass, t);
  return _extends$5({}, t, s);
}, InputRoot = E(InputBaseRoot, {
  shouldForwardProp: (e) => rootShouldForwardProp(e) || e === "classes",
  name: "MuiInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [...rootOverridesResolver(e, t), !n.disableUnderline && t.underline];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  let o = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return e.vars && (o = `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})`), _extends$5({
    position: "relative"
  }, t.formControl && {
    "label + &": {
      marginTop: 16
    }
  }, !t.disableUnderline && {
    "&::after": {
      borderBottom: `2px solid ${(e.vars || e).palette[t.color].main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: "absolute",
      right: 0,
      transform: "scaleX(0)",
      transition: e.transitions.create("transform", {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&.${inputClasses$1.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: "scaleX(1) translateX(0)"
    },
    [`&.${inputClasses$1.error}`]: {
      "&::before, &::after": {
        borderBottomColor: (e.vars || e).palette.error.main
      }
    },
    "&::before": {
      borderBottom: `1px solid ${o}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: "absolute",
      right: 0,
      transition: e.transitions.create("border-bottom-color", {
        duration: e.transitions.duration.shorter
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&:hover:not(.${inputClasses$1.disabled}, .${inputClasses$1.error}):before`]: {
      borderBottom: `2px solid ${(e.vars || e).palette.text.primary}`,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        borderBottom: `1px solid ${o}`
      }
    },
    [`&.${inputClasses$1.disabled}:before`]: {
      borderBottomStyle: "dotted"
    }
  });
}), InputInput = E(InputBaseComponent, {
  name: "MuiInput",
  slot: "Input",
  overridesResolver: inputOverridesResolver
})({}), Input = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  var o, s, l, c;
  const p = useThemeProps({
    props: t,
    name: "MuiInput"
  }), {
    disableUnderline: m,
    components: C = {},
    componentsProps: P,
    fullWidth: w = !1,
    inputComponent: R = "input",
    multiline: L = !1,
    slotProps: M,
    slots: $ = {},
    type: W = "text"
  } = p, H = _objectWithoutPropertiesLoose$3(p, _excluded$l), V = useUtilityClasses$f(p), B = {
    root: {
      ownerState: {
        disableUnderline: m
      }
    }
  }, K = M ?? P ? deepmerge$1(M ?? P, B) : B, ue = (o = (s = $.root) != null ? s : C.Root) != null ? o : InputRoot, de = (l = (c = $.input) != null ? c : C.Input) != null ? l : InputInput;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(InputBase$1, _extends$5({
    slots: {
      root: ue,
      input: de
    },
    slotProps: K,
    fullWidth: w,
    inputComponent: R,
    multiline: L,
    ref: n,
    type: W
  }, H, {
    classes: V
  }));
});
process.env.NODE_ENV !== "production" && (Input.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the `input` will not have an underline.
   */
  disableUnderline: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: PropTypes.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
});
Input.muiName = "Input";
const Input$1 = Input;
function getInputAdornmentUtilityClass(e) {
  return generateUtilityClass$1("MuiInputAdornment", e);
}
const inputAdornmentClasses = generateUtilityClasses$1("MuiInputAdornment", ["root", "filled", "standard", "outlined", "positionStart", "positionEnd", "disablePointerEvents", "hiddenLabel", "sizeSmall"]), inputAdornmentClasses$1 = inputAdornmentClasses;
var _span$2;
const _excluded$k = ["children", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"], overridesResolver$1 = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, t[`position${capitalize$1(n.position)}`], n.disablePointerEvents === !0 && t.disablePointerEvents, t[n.variant]];
}, useUtilityClasses$e = (e) => {
  const {
    classes: t,
    disablePointerEvents: n,
    hiddenLabel: o,
    position: s,
    size: l,
    variant: c
  } = e, p = {
    root: ["root", n && "disablePointerEvents", s && `position${capitalize$1(s)}`, c, o && "hiddenLabel", l && `size${capitalize$1(l)}`]
  };
  return composeClasses(p, getInputAdornmentUtilityClass, t);
}, InputAdornmentRoot = E("div", {
  name: "MuiInputAdornment",
  slot: "Root",
  overridesResolver: overridesResolver$1
})(({
  theme: e,
  ownerState: t
}) => _extends$5({
  display: "flex",
  height: "0.01em",
  // Fix IE11 flexbox alignment. To remove at some point.
  maxHeight: "2em",
  alignItems: "center",
  whiteSpace: "nowrap",
  color: (e.vars || e).palette.action.active
}, t.variant === "filled" && {
  // Styles applied to the root element if `variant="filled"`.
  [`&.${inputAdornmentClasses$1.positionStart}&:not(.${inputAdornmentClasses$1.hiddenLabel})`]: {
    marginTop: 16
  }
}, t.position === "start" && {
  // Styles applied to the root element if `position="start"`.
  marginRight: 8
}, t.position === "end" && {
  // Styles applied to the root element if `position="end"`.
  marginLeft: 8
}, t.disablePointerEvents === !0 && {
  // Styles applied to the root element if `disablePointerEvents={true}`.
  pointerEvents: "none"
})), InputAdornment = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  const o = useThemeProps({
    props: t,
    name: "MuiInputAdornment"
  }), {
    children: s,
    className: l,
    component: c = "div",
    disablePointerEvents: p = !1,
    disableTypography: m = !1,
    position: C,
    variant: P
  } = o, w = _objectWithoutPropertiesLoose$3(o, _excluded$k), R = useFormControl() || {};
  let L = P;
  P && R.variant && process.env.NODE_ENV !== "production" && P === R.variant && console.error("MUI: The `InputAdornment` variant infers the variant prop you do not have to provide one."), R && !L && (L = R.variant);
  const M = _extends$5({}, o, {
    hiddenLabel: R.hiddenLabel,
    size: R.size,
    disablePointerEvents: p,
    position: C,
    variant: L
  }), $ = useUtilityClasses$e(M);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormControlContext$1.Provider, {
    value: null,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(InputAdornmentRoot, _extends$5({
      as: c,
      ownerState: M,
      className: clsx$1($.root, l),
      ref: n
    }, w, {
      children: typeof s == "string" && !m ? /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$1, {
        color: "text.secondary",
        children: s
      }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(React$2.Fragment, {
        children: [C === "start" ? (
          /* notranslate needed while Google Translate will not fix zero-width space issue */
          _span$2 || (_span$2 = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
            className: "notranslate",
            children: "​"
          }))
        ) : null, s]
      })
    }))
  });
});
process.env.NODE_ENV !== "production" && (InputAdornment.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the `input` on click.
   * @default false
   */
  disablePointerEvents: PropTypes.bool,
  /**
   * If children is a string then disable wrapping in a Typography component.
   * @default false
   */
  disableTypography: PropTypes.bool,
  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: PropTypes.oneOf(["end", "start"]).isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
});
const Rt = InputAdornment;
function getInputLabelUtilityClasses(e) {
  return generateUtilityClass$1("MuiInputLabel", e);
}
generateUtilityClasses$1("MuiInputLabel", ["root", "focused", "disabled", "error", "required", "asterisk", "formControl", "sizeSmall", "shrink", "animated", "standard", "filled", "outlined"]);
const _excluded$j = ["disableAnimation", "margin", "shrink", "variant", "className"], useUtilityClasses$d = (e) => {
  const {
    classes: t,
    formControl: n,
    size: o,
    shrink: s,
    disableAnimation: l,
    variant: c,
    required: p
  } = e, m = {
    root: ["root", n && "formControl", !l && "animated", s && "shrink", o && o !== "normal" && `size${capitalize$1(o)}`, c],
    asterisk: [p && "asterisk"]
  }, C = composeClasses(m, getInputLabelUtilityClasses, t);
  return _extends$5({}, t, C);
}, InputLabelRoot = E(FormLabel$1, {
  shouldForwardProp: (e) => rootShouldForwardProp(e) || e === "classes",
  name: "MuiInputLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${formLabelClasses$1.asterisk}`]: t.asterisk
    }, t.root, n.formControl && t.formControl, n.size === "small" && t.sizeSmall, n.shrink && t.shrink, !n.disableAnimation && t.animated, n.focused && t.focused, t[n.variant]];
  }
})(({
  theme: e,
  ownerState: t
}) => _extends$5({
  display: "block",
  transformOrigin: "top left",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%"
}, t.formControl && {
  position: "absolute",
  left: 0,
  top: 0,
  // slight alteration to spec spacing to match visual spec result
  transform: "translate(0, 20px) scale(1)"
}, t.size === "small" && {
  // Compensation for the `Input.inputSizeSmall` style.
  transform: "translate(0, 17px) scale(1)"
}, t.shrink && {
  transform: "translate(0, -1.5px) scale(0.75)",
  transformOrigin: "top left",
  maxWidth: "133%"
}, !t.disableAnimation && {
  transition: e.transitions.create(["color", "transform", "max-width"], {
    duration: e.transitions.duration.shorter,
    easing: e.transitions.easing.easeOut
  })
}, t.variant === "filled" && _extends$5({
  // Chrome's autofill feature gives the input field a yellow background.
  // Since the input field is behind the label in the HTML tree,
  // the input field is drawn last and hides the label with an opaque background color.
  // zIndex: 1 will raise the label above opaque background-colors of input.
  zIndex: 1,
  pointerEvents: "none",
  transform: "translate(12px, 16px) scale(1)",
  maxWidth: "calc(100% - 24px)"
}, t.size === "small" && {
  transform: "translate(12px, 13px) scale(1)"
}, t.shrink && _extends$5({
  userSelect: "none",
  pointerEvents: "auto",
  transform: "translate(12px, 7px) scale(0.75)",
  maxWidth: "calc(133% - 24px)"
}, t.size === "small" && {
  transform: "translate(12px, 4px) scale(0.75)"
})), t.variant === "outlined" && _extends$5({
  // see comment above on filled.zIndex
  zIndex: 1,
  pointerEvents: "none",
  transform: "translate(14px, 16px) scale(1)",
  maxWidth: "calc(100% - 24px)"
}, t.size === "small" && {
  transform: "translate(14px, 9px) scale(1)"
}, t.shrink && {
  userSelect: "none",
  pointerEvents: "auto",
  // Theoretically, we should have (8+5)*2/0.75 = 34px
  // but it feels a better when it bleeds a bit on the left, so 32px.
  maxWidth: "calc(133% - 32px)",
  transform: "translate(14px, -9px) scale(0.75)"
}))), InputLabel = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  const o = useThemeProps({
    name: "MuiInputLabel",
    props: t
  }), {
    disableAnimation: s = !1,
    shrink: l,
    className: c
  } = o, p = _objectWithoutPropertiesLoose$3(o, _excluded$j), m = useFormControl();
  let C = l;
  typeof C > "u" && m && (C = m.filled || m.focused || m.adornedStart);
  const P = formControlState({
    props: o,
    muiFormControl: m,
    states: ["size", "variant", "required", "focused"]
  }), w = _extends$5({}, o, {
    disableAnimation: s,
    formControl: m,
    shrink: C,
    size: P.size,
    variant: P.variant,
    required: P.required,
    focused: P.focused
  }), R = useUtilityClasses$d(w);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(InputLabelRoot, _extends$5({
    "data-shrink": C,
    ownerState: w,
    ref: n,
    className: clsx$1(R.root, c)
  }, p, {
    classes: R
  }));
});
process.env.NODE_ENV !== "production" && (InputLabel.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), PropTypes.string]),
  /**
   * If `true`, the transition animation is disabled.
   * @default false
   */
  disableAnimation: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` of this label is focused.
   */
  focused: PropTypes.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(["dense"]),
  /**
   * if `true`, the label will indicate that the `input` is required.
   */
  required: PropTypes.bool,
  /**
   * If `true`, the label is shrunk.
   */
  shrink: PropTypes.bool,
  /**
   * The size of the component.
   * @default 'normal'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["normal", "small"]), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
});
const InputLabel$1 = InputLabel, ListContext = /* @__PURE__ */ React$2.createContext({});
process.env.NODE_ENV !== "production" && (ListContext.displayName = "ListContext");
const ListContext$1 = ListContext;
function getListUtilityClass(e) {
  return generateUtilityClass$1("MuiList", e);
}
generateUtilityClasses$1("MuiList", ["root", "padding", "dense", "subheader"]);
const _excluded$i = ["children", "className", "component", "dense", "disablePadding", "subheader"], useUtilityClasses$c = (e) => {
  const {
    classes: t,
    disablePadding: n,
    dense: o,
    subheader: s
  } = e;
  return composeClasses({
    root: ["root", !n && "padding", o && "dense", s && "subheader"]
  }, getListUtilityClass, t);
}, ListRoot = E("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disablePadding && t.padding, n.dense && t.dense, n.subheader && t.subheader];
  }
})(({
  ownerState: e
}) => _extends$5({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative"
}, !e.disablePadding && {
  paddingTop: 8,
  paddingBottom: 8
}, e.subheader && {
  paddingTop: 0
})), List = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  const o = useThemeProps({
    props: t,
    name: "MuiList"
  }), {
    children: s,
    className: l,
    component: c = "ul",
    dense: p = !1,
    disablePadding: m = !1,
    subheader: C
  } = o, P = _objectWithoutPropertiesLoose$3(o, _excluded$i), w = React$2.useMemo(() => ({
    dense: p
  }), [p]), R = _extends$5({}, o, {
    component: c,
    dense: p,
    disablePadding: m
  }), L = useUtilityClasses$c(R);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ListContext$1.Provider, {
    value: w,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ListRoot, _extends$5({
      as: c,
      className: clsx$1(L.root, l),
      ref: n,
      ownerState: R
    }, P, {
      children: [C, s]
    }))
  });
});
process.env.NODE_ENV !== "production" && (List.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: PropTypes.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: PropTypes.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const List$1 = List, listItemIconClasses = generateUtilityClasses$1("MuiListItemIcon", ["root", "alignItemsFlexStart"]), listItemIconClasses$1 = listItemIconClasses;
function getListItemTextUtilityClass(e) {
  return generateUtilityClass$1("MuiListItemText", e);
}
const listItemTextClasses = generateUtilityClasses$1("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]), listItemTextClasses$1 = listItemTextClasses, _excluded$h = ["children", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"], useUtilityClasses$b = (e) => {
  const {
    classes: t,
    inset: n,
    primary: o,
    secondary: s,
    dense: l
  } = e;
  return composeClasses({
    root: ["root", n && "inset", l && "dense", o && s && "multiline"],
    primary: ["primary"],
    secondary: ["secondary"]
  }, getListItemTextUtilityClass, t);
}, ListItemTextRoot = E("div", {
  name: "MuiListItemText",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${listItemTextClasses$1.primary}`]: t.primary
    }, {
      [`& .${listItemTextClasses$1.secondary}`]: t.secondary
    }, t.root, n.inset && t.inset, n.primary && n.secondary && t.multiline, n.dense && t.dense];
  }
})(({
  ownerState: e
}) => _extends$5({
  flex: "1 1 auto",
  minWidth: 0,
  marginTop: 4,
  marginBottom: 4
}, e.primary && e.secondary && {
  marginTop: 6,
  marginBottom: 6
}, e.inset && {
  paddingLeft: 56
})), ListItemText = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  const o = useThemeProps({
    props: t,
    name: "MuiListItemText"
  }), {
    children: s,
    className: l,
    disableTypography: c = !1,
    inset: p = !1,
    primary: m,
    primaryTypographyProps: C,
    secondary: P,
    secondaryTypographyProps: w
  } = o, R = _objectWithoutPropertiesLoose$3(o, _excluded$h), {
    dense: L
  } = React$2.useContext(ListContext$1);
  let M = m ?? s, $ = P;
  const W = _extends$5({}, o, {
    disableTypography: c,
    inset: p,
    primary: !!M,
    secondary: !!$,
    dense: L
  }), H = useUtilityClasses$b(W);
  return M != null && M.type !== Typography$1 && !c && (M = /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$1, _extends$5({
    variant: L ? "body2" : "body1",
    className: H.primary,
    component: C != null && C.variant ? void 0 : "span",
    display: "block"
  }, C, {
    children: M
  }))), $ != null && $.type !== Typography$1 && !c && ($ = /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$1, _extends$5({
    variant: "body2",
    className: H.secondary,
    color: "text.secondary",
    display: "block"
  }, w, {
    children: $
  }))), /* @__PURE__ */ jsxRuntimeExports.jsxs(ListItemTextRoot, _extends$5({
    className: clsx$1(H.root, l),
    ownerState: W,
    ref: n
  }, R, {
    children: [M, $]
  }));
});
process.env.NODE_ENV !== "production" && (ListItemText.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Alias for the `primary` prop.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   * @default false
   */
  disableTypography: PropTypes.bool,
  /**
   * If `true`, the children are indented.
   * This should be used if there is no left avatar or left icon.
   * @default false
   */
  inset: PropTypes.bool,
  /**
   * The main content element.
   */
  primary: PropTypes.node,
  /**
   * These props will be forwarded to the primary typography component
   * (as long as disableTypography is not `true`).
   */
  primaryTypographyProps: PropTypes.object,
  /**
   * The secondary content element.
   */
  secondary: PropTypes.node,
  /**
   * These props will be forwarded to the secondary typography component
   * (as long as disableTypography is not `true`).
   */
  secondaryTypographyProps: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const ListItemText$1 = ListItemText, _excluded$g = ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"];
function nextItem(e, t, n) {
  return e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : n ? null : e.firstChild;
}
function previousItem(e, t, n) {
  return e === t ? n ? e.firstChild : e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : n ? null : e.lastChild;
}
function textCriteriaMatches(e, t) {
  if (t === void 0)
    return !0;
  let n = e.innerText;
  return n === void 0 && (n = e.textContent), n = n.trim().toLowerCase(), n.length === 0 ? !1 : t.repeating ? n[0] === t.keys[0] : n.indexOf(t.keys.join("")) === 0;
}
function moveFocus(e, t, n, o, s, l) {
  let c = !1, p = s(e, t, t ? n : !1);
  for (; p; ) {
    if (p === e.firstChild) {
      if (c)
        return !1;
      c = !0;
    }
    const m = o ? !1 : p.disabled || p.getAttribute("aria-disabled") === "true";
    if (!p.hasAttribute("tabindex") || !textCriteriaMatches(p, l) || m)
      p = s(e, p, n);
    else
      return p.focus(), !0;
  }
  return !1;
}
const MenuList = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: o,
    autoFocus: s = !1,
    autoFocusItem: l = !1,
    children: c,
    className: p,
    disabledItemsFocusable: m = !1,
    disableListWrap: C = !1,
    onKeyDown: P,
    variant: w = "selectedMenu"
  } = t, R = _objectWithoutPropertiesLoose$3(t, _excluded$g), L = React$2.useRef(null), M = React$2.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  useEnhancedEffect$1(() => {
    s && L.current.focus();
  }, [s]), React$2.useImperativeHandle(o, () => ({
    adjustStyleForScrollbar: (N, B) => {
      const K = !L.current.style.width;
      if (N.clientHeight < L.current.clientHeight && K) {
        const ue = `${getScrollbarSize(ownerDocument(N))}px`;
        L.current.style[B.direction === "rtl" ? "paddingLeft" : "paddingRight"] = ue, L.current.style.width = `calc(100% + ${ue})`;
      }
      return L.current;
    }
  }), []);
  const $ = (N) => {
    const B = L.current, K = N.key, ue = ownerDocument(B).activeElement;
    if (K === "ArrowDown")
      N.preventDefault(), moveFocus(B, ue, C, m, nextItem);
    else if (K === "ArrowUp")
      N.preventDefault(), moveFocus(B, ue, C, m, previousItem);
    else if (K === "Home")
      N.preventDefault(), moveFocus(B, null, C, m, nextItem);
    else if (K === "End")
      N.preventDefault(), moveFocus(B, null, C, m, previousItem);
    else if (K.length === 1) {
      const de = M.current, ve = K.toLowerCase(), Te = performance.now();
      de.keys.length > 0 && (Te - de.lastTime > 500 ? (de.keys = [], de.repeating = !0, de.previousKeyMatched = !0) : de.repeating && ve !== de.keys[0] && (de.repeating = !1)), de.lastTime = Te, de.keys.push(ve);
      const Pe = ue && !de.repeating && textCriteriaMatches(ue, de);
      de.previousKeyMatched && (Pe || moveFocus(B, ue, !1, m, nextItem, de)) ? N.preventDefault() : de.previousKeyMatched = !1;
    }
    P && P(N);
  }, W = useForkRef(L, n);
  let H = -1;
  React$2.Children.forEach(c, (N, B) => {
    if (!/* @__PURE__ */ React$2.isValidElement(N)) {
      H === B && (H += 1, H >= c.length && (H = -1));
      return;
    }
    process.env.NODE_ENV !== "production" && reactIsExports.isFragment(N) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), N.props.disabled || (w === "selectedMenu" && N.props.selected || H === -1) && (H = B), H === B && (N.props.disabled || N.props.muiSkipListHighlight || N.type.muiSkipListHighlight) && (H += 1, H >= c.length && (H = -1));
  });
  const V = React$2.Children.map(c, (N, B) => {
    if (B === H) {
      const K = {};
      return l && (K.autoFocus = !0), N.props.tabIndex === void 0 && w === "selectedMenu" && (K.tabIndex = 0), /* @__PURE__ */ React$2.cloneElement(N, K);
    }
    return N;
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(List$1, _extends$5({
    role: "menu",
    ref: W,
    className: p,
    onKeyDown: $,
    tabIndex: s ? 0 : -1
  }, R, {
    children: V
  }));
});
process.env.NODE_ENV !== "production" && (MenuList.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: PropTypes.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: PropTypes.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: PropTypes.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: PropTypes.bool,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: PropTypes.oneOf(["menu", "selectedMenu"])
});
const MenuList$1 = MenuList;
function getPopoverUtilityClass(e) {
  return generateUtilityClass$1("MuiPopover", e);
}
generateUtilityClasses$1("MuiPopover", ["root", "paper"]);
const _excluded$f = ["onEntering"], _excluded2$4 = ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "className", "container", "elevation", "marginThreshold", "open", "PaperProps", "slots", "slotProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps", "disableScrollLock"], _excluded3$2 = ["slotProps"];
function getOffsetTop(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.height / 2 : t === "bottom" && (n = e.height), n;
}
function getOffsetLeft(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.width / 2 : t === "right" && (n = e.width), n;
}
function getTransformOriginValue(e) {
  return [e.horizontal, e.vertical].map((t) => typeof t == "number" ? `${t}px` : t).join(" ");
}
function resolveAnchorEl(e) {
  return typeof e == "function" ? e() : e;
}
const useUtilityClasses$a = (e) => {
  const {
    classes: t
  } = e;
  return composeClasses({
    root: ["root"],
    paper: ["paper"]
  }, getPopoverUtilityClass, t);
}, PopoverRoot = E(Modal$1, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), PopoverPaper = E(Paper$1, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), Popover = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  var o, s, l;
  const c = useThemeProps({
    props: t,
    name: "MuiPopover"
  }), {
    action: p,
    anchorEl: m,
    anchorOrigin: C = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: P,
    anchorReference: w = "anchorEl",
    children: R,
    className: L,
    container: M,
    elevation: $ = 8,
    marginThreshold: W = 16,
    open: H,
    PaperProps: V = {},
    slots: N,
    slotProps: B,
    transformOrigin: K = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: ue = Grow$1,
    transitionDuration: de = "auto",
    TransitionProps: {
      onEntering: ve
    } = {},
    disableScrollLock: Te = !1
  } = c, Pe = _objectWithoutPropertiesLoose$3(c.TransitionProps, _excluded$f), Ce = _objectWithoutPropertiesLoose$3(c, _excluded2$4), Re = (o = B == null ? void 0 : B.paper) != null ? o : V, ke = React$2.useRef(), Ae = useForkRef(ke, Re.ref), we = _extends$5({}, c, {
    anchorOrigin: C,
    anchorReference: w,
    elevation: $,
    marginThreshold: W,
    externalPaperSlotProps: Re,
    transformOrigin: K,
    TransitionComponent: ue,
    transitionDuration: de,
    TransitionProps: Pe
  }), he = useUtilityClasses$a(we), be = React$2.useCallback(() => {
    if (w === "anchorPosition")
      return process.env.NODE_ENV !== "production" && (P || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), P;
    const xt = resolveAnchorEl(m), je = xt && xt.nodeType === 1 ? xt : ownerDocument(ke.current).body, kt = je.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      const cr = je.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && cr.top === 0 && cr.left === 0 && cr.right === 0 && cr.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: kt.top + getOffsetTop(kt, C.vertical),
      left: kt.left + getOffsetLeft(kt, C.horizontal)
    };
  }, [m, C.horizontal, C.vertical, P, w]), le = React$2.useCallback((xt) => ({
    vertical: getOffsetTop(xt, K.vertical),
    horizontal: getOffsetLeft(xt, K.horizontal)
  }), [K.horizontal, K.vertical]), fe = React$2.useCallback((xt) => {
    const je = {
      width: xt.offsetWidth,
      height: xt.offsetHeight
    }, kt = le(je);
    if (w === "none")
      return {
        top: null,
        left: null,
        transformOrigin: getTransformOriginValue(kt)
      };
    const cr = be();
    let Tr = cr.top - kt.vertical, Er = cr.left - kt.horizontal;
    const Hr = Tr + je.height, Br = Er + je.width, hr = ownerWindow(resolveAnchorEl(m)), Gr = hr.innerHeight - W, Yr = hr.innerWidth - W;
    if (W !== null && Tr < W) {
      const tt = Tr - W;
      Tr -= tt, kt.vertical += tt;
    } else if (W !== null && Hr > Gr) {
      const tt = Hr - Gr;
      Tr -= tt, kt.vertical += tt;
    }
    if (process.env.NODE_ENV !== "production" && je.height > Gr && je.height && Gr && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${je.height - Gr}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), W !== null && Er < W) {
      const tt = Er - W;
      Er -= tt, kt.horizontal += tt;
    } else if (Br > Yr) {
      const tt = Br - Yr;
      Er -= tt, kt.horizontal += tt;
    }
    return {
      top: `${Math.round(Tr)}px`,
      left: `${Math.round(Er)}px`,
      transformOrigin: getTransformOriginValue(kt)
    };
  }, [m, w, be, le, W]), [ye, Ee] = React$2.useState(H), Ie = React$2.useCallback(() => {
    const xt = ke.current;
    if (!xt)
      return;
    const je = fe(xt);
    je.top !== null && (xt.style.top = je.top), je.left !== null && (xt.style.left = je.left), xt.style.transformOrigin = je.transformOrigin, Ee(!0);
  }, [fe]);
  React$2.useEffect(() => (Te && window.addEventListener("scroll", Ie), () => window.removeEventListener("scroll", Ie)), [m, Te, Ie]);
  const Fe = (xt, je) => {
    ve && ve(xt, je), Ie();
  }, De = () => {
    Ee(!1);
  };
  React$2.useEffect(() => {
    H && Ie();
  }), React$2.useImperativeHandle(p, () => H ? {
    updatePosition: () => {
      Ie();
    }
  } : null, [H, Ie]), React$2.useEffect(() => {
    if (!H)
      return;
    const xt = debounce$1(() => {
      Ie();
    }), je = ownerWindow(m);
    return je.addEventListener("resize", xt), () => {
      xt.clear(), je.removeEventListener("resize", xt);
    };
  }, [m, H, Ie]);
  let Ve = de;
  de === "auto" && !ue.muiSupportAuto && (Ve = void 0);
  const Oe = M || (m ? ownerDocument(resolveAnchorEl(m)).body : void 0), Ze = (s = N == null ? void 0 : N.root) != null ? s : PopoverRoot, et = (l = N == null ? void 0 : N.paper) != null ? l : PopoverPaper, bt = useSlotProps({
    elementType: et,
    externalSlotProps: _extends$5({}, Re, {
      style: ye ? Re.style : _extends$5({}, Re.style, {
        opacity: 0
      })
    }),
    additionalProps: {
      elevation: $,
      ref: Ae
    },
    ownerState: we,
    className: clsx$1(he.paper, Re == null ? void 0 : Re.className)
  }), rr = useSlotProps({
    elementType: Ze,
    externalSlotProps: (B == null ? void 0 : B.root) || {},
    externalForwardedProps: Ce,
    additionalProps: {
      ref: n,
      slotProps: {
        backdrop: {
          invisible: !0
        }
      },
      container: Oe,
      open: H
    },
    ownerState: we,
    className: clsx$1(he.root, L)
  }), {
    slotProps: St
  } = rr, Qe = _objectWithoutPropertiesLoose$3(rr, _excluded3$2);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Ze, _extends$5({}, Qe, !isHostComponent(Ze) && {
    slotProps: St,
    disableScrollLock: Te
  }, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(ue, _extends$5({
      appear: !0,
      in: H,
      onEntering: Fe,
      onExited: De,
      timeout: Ve
    }, Pe, {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(et, _extends$5({}, bt, {
        children: R
      }))
    }))
  }));
});
process.env.NODE_ENV !== "production" && (Popover.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: refType$1,
  /**
   * An HTML element, [PopoverVirtualElement](/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: chainPropTypes(PropTypes.oneOfType([HTMLElementType, PropTypes.func]), (e) => {
    if (e.open && (!e.anchorReference || e.anchorReference === "anchorEl")) {
      const t = resolveAnchorEl(e.anchorEl);
      if (t && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${t}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.oneOf(["center", "left", "right"]), PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.oneOf(["bottom", "center", "top"]), PropTypes.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: PropTypes.shape({
    left: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: PropTypes.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: PropTypes.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: integerPropType,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: PropTypes.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: PropTypes.shape({
    component: elementTypeAcceptingRef$1
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    paper: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    paper: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.oneOf(["center", "left", "right"]), PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.oneOf(["bottom", "center", "top"]), PropTypes.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: PropTypes.object
});
const Ct = Popover;
function getMenuUtilityClass(e) {
  return generateUtilityClass$1("MuiMenu", e);
}
generateUtilityClasses$1("MuiMenu", ["root", "paper", "list"]);
const _excluded$e = ["onEntering"], _excluded2$3 = ["autoFocus", "children", "className", "disableAutoFocusItem", "MenuListProps", "onClose", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant", "slots", "slotProps"], RTL_ORIGIN = {
  vertical: "top",
  horizontal: "right"
}, LTR_ORIGIN = {
  vertical: "top",
  horizontal: "left"
}, useUtilityClasses$9 = (e) => {
  const {
    classes: t
  } = e;
  return composeClasses({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, getMenuUtilityClass, t);
}, MenuRoot = E(Ct, {
  shouldForwardProp: (e) => rootShouldForwardProp(e) || e === "classes",
  name: "MuiMenu",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), MenuPaper = E(PopoverPaper, {
  name: "MuiMenu",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), MenuMenuList = E(MenuList$1, {
  name: "MuiMenu",
  slot: "List",
  overridesResolver: (e, t) => t.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), Menu = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  var o, s;
  const l = useThemeProps({
    props: t,
    name: "MuiMenu"
  }), {
    autoFocus: c = !0,
    children: p,
    className: m,
    disableAutoFocusItem: C = !1,
    MenuListProps: P = {},
    onClose: w,
    open: R,
    PaperProps: L = {},
    PopoverClasses: M,
    transitionDuration: $ = "auto",
    TransitionProps: {
      onEntering: W
    } = {},
    variant: H = "selectedMenu",
    slots: V = {},
    slotProps: N = {}
  } = l, B = _objectWithoutPropertiesLoose$3(l.TransitionProps, _excluded$e), K = _objectWithoutPropertiesLoose$3(l, _excluded2$3), ue = useTheme$1(), de = ue.direction === "rtl", ve = _extends$5({}, l, {
    autoFocus: c,
    disableAutoFocusItem: C,
    MenuListProps: P,
    onEntering: W,
    PaperProps: L,
    transitionDuration: $,
    TransitionProps: B,
    variant: H
  }), Te = useUtilityClasses$9(ve), Pe = c && !C && R, Ce = React$2.useRef(null), Re = (fe, ye) => {
    Ce.current && Ce.current.adjustStyleForScrollbar(fe, ue), W && W(fe, ye);
  }, ke = (fe) => {
    fe.key === "Tab" && (fe.preventDefault(), w && w(fe, "tabKeyDown"));
  };
  let Ae = -1;
  React$2.Children.map(p, (fe, ye) => {
    /* @__PURE__ */ React$2.isValidElement(fe) && (process.env.NODE_ENV !== "production" && reactIsExports.isFragment(fe) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), fe.props.disabled || (H === "selectedMenu" && fe.props.selected || Ae === -1) && (Ae = ye));
  });
  const we = (o = V.paper) != null ? o : MenuPaper, he = (s = N.paper) != null ? s : L, be = useSlotProps({
    elementType: V.root,
    externalSlotProps: N.root,
    ownerState: ve,
    className: [Te.root, m]
  }), le = useSlotProps({
    elementType: we,
    externalSlotProps: he,
    ownerState: ve,
    className: Te.paper
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MenuRoot, _extends$5({
    onClose: w,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: de ? "right" : "left"
    },
    transformOrigin: de ? RTL_ORIGIN : LTR_ORIGIN,
    slots: {
      paper: we,
      root: V.root
    },
    slotProps: {
      root: be,
      paper: le
    },
    open: R,
    ref: n,
    transitionDuration: $,
    TransitionProps: _extends$5({
      onEntering: Re
    }, B),
    ownerState: ve
  }, K, {
    classes: M,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuMenuList, _extends$5({
      onKeyDown: ke,
      actions: Ce,
      autoFocus: c && (Ae === -1 || C),
      autoFocusItem: Pe,
      variant: H
    }, P, {
      className: clsx$1(Te.list, P.className),
      children: p
    }))
  }));
});
process.env.NODE_ENV !== "production" && (Menu.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: PropTypes.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: PropTypes.bool,
  /**
   * Props applied to the [`MenuList`](/material-ui/api/menu-list/) element.
   * @default {}
   */
  MenuListProps: PropTypes.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: PropTypes.object,
  /**
   * `classes` prop applied to the [`Popover`](/material-ui/api/popover/) element.
   */
  PopoverClasses: PropTypes.object,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    paper: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    paper: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: PropTypes.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: PropTypes.oneOf(["menu", "selectedMenu"])
});
const Menu$1 = Menu;
function getMenuItemUtilityClass(e) {
  return generateUtilityClass$1("MuiMenuItem", e);
}
const menuItemClasses = generateUtilityClasses$1("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]), menuItemClasses$1 = menuItemClasses, _excluded$d = ["autoFocus", "component", "dense", "divider", "disableGutters", "focusVisibleClassName", "role", "tabIndex", "className"], overridesResolver = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.dense && t.dense, n.divider && t.divider, !n.disableGutters && t.gutters];
}, useUtilityClasses$8 = (e) => {
  const {
    disabled: t,
    dense: n,
    divider: o,
    disableGutters: s,
    selected: l,
    classes: c
  } = e, m = composeClasses({
    root: ["root", n && "dense", t && "disabled", !s && "gutters", o && "divider", l && "selected"]
  }, getMenuItemUtilityClass, c);
  return _extends$5({}, c, m);
}, MenuItemRoot = E(ButtonBase$1, {
  shouldForwardProp: (e) => rootShouldForwardProp(e) || e === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver
})(({
  theme: e,
  ownerState: t
}) => _extends$5({}, e.typography.body1, {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap"
}, !t.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, t.divider && {
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
  backgroundClip: "padding-box"
}, {
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${menuItemClasses$1.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : alpha_1(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${menuItemClasses$1.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : alpha_1(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${menuItemClasses$1.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : alpha_1(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : alpha_1(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${menuItemClasses$1.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${menuItemClasses$1.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  [`& + .${dividerClasses$1.root}`]: {
    marginTop: e.spacing(1),
    marginBottom: e.spacing(1)
  },
  [`& + .${dividerClasses$1.inset}`]: {
    marginLeft: 52
  },
  [`& .${listItemTextClasses$1.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${listItemTextClasses$1.inset}`]: {
    paddingLeft: 36
  },
  [`& .${listItemIconClasses$1.root}`]: {
    minWidth: 36
  }
}, !t.dense && {
  [e.breakpoints.up("sm")]: {
    minHeight: "auto"
  }
}, t.dense && _extends$5({
  minHeight: 32,
  // https://m2.material.io/components/menus#specs > Dense
  paddingTop: 4,
  paddingBottom: 4
}, e.typography.body2, {
  [`& .${listItemIconClasses$1.root} svg`]: {
    fontSize: "1.25rem"
  }
}))), MenuItem = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  const o = useThemeProps({
    props: t,
    name: "MuiMenuItem"
  }), {
    autoFocus: s = !1,
    component: l = "li",
    dense: c = !1,
    divider: p = !1,
    disableGutters: m = !1,
    focusVisibleClassName: C,
    role: P = "menuitem",
    tabIndex: w,
    className: R
  } = o, L = _objectWithoutPropertiesLoose$3(o, _excluded$d), M = React$2.useContext(ListContext$1), $ = React$2.useMemo(() => ({
    dense: c || M.dense || !1,
    disableGutters: m
  }), [M.dense, c, m]), W = React$2.useRef(null);
  useEnhancedEffect$1(() => {
    s && (W.current ? W.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered."));
  }, [s]);
  const H = _extends$5({}, o, {
    dense: $.dense,
    divider: p,
    disableGutters: m
  }), V = useUtilityClasses$8(o), N = useForkRef(W, n);
  let B;
  return o.disabled || (B = w !== void 0 ? w : -1), /* @__PURE__ */ jsxRuntimeExports.jsx(ListContext$1.Provider, {
    value: $,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItemRoot, _extends$5({
      ref: N,
      role: P,
      tabIndex: B,
      component: l,
      focusVisibleClassName: clsx$1(V.focusVisible, C),
      className: clsx$1(V.root, R)
    }, L, {
      ownerState: H,
      classes: V
    }))
  });
});
process.env.NODE_ENV !== "production" && (MenuItem.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: PropTypes.bool,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: PropTypes.bool,
  /**
   * @ignore
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: PropTypes.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: PropTypes.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * @ignore
   */
  role: PropTypes.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @default 0
   */
  tabIndex: PropTypes.number
});
const MenuItem$1 = MenuItem;
function getNativeSelectUtilityClasses(e) {
  return generateUtilityClass$1("MuiNativeSelect", e);
}
const nativeSelectClasses = generateUtilityClasses$1("MuiNativeSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]), nativeSelectClasses$1 = nativeSelectClasses, _excluded$c = ["className", "disabled", "error", "IconComponent", "inputRef", "variant"], useUtilityClasses$7 = (e) => {
  const {
    classes: t,
    variant: n,
    disabled: o,
    multiple: s,
    open: l,
    error: c
  } = e, p = {
    select: ["select", n, o && "disabled", s && "multiple", c && "error"],
    icon: ["icon", `icon${capitalize$1(n)}`, l && "iconOpen", o && "disabled"]
  };
  return composeClasses(p, getNativeSelectUtilityClasses, t);
}, nativeSelectSelectStyles = ({
  ownerState: e,
  theme: t
}) => _extends$5({
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: "none",
  borderRadius: 0,
  // Reset
  cursor: "pointer",
  "&:focus": _extends$5({}, t.vars ? {
    backgroundColor: `rgba(${t.vars.palette.common.onBackgroundChannel} / 0.05)`
  } : {
    backgroundColor: t.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
  }, {
    borderRadius: 0
    // Reset Chrome style
  }),
  // Remove IE11 arrow
  "&::-ms-expand": {
    display: "none"
  },
  [`&.${nativeSelectClasses$1.disabled}`]: {
    cursor: "default"
  },
  "&[multiple]": {
    height: "auto"
  },
  "&:not([multiple]) option, &:not([multiple]) optgroup": {
    backgroundColor: (t.vars || t).palette.background.paper
  },
  // Bump specificity to allow extending custom inputs
  "&&&": {
    paddingRight: 24,
    minWidth: 16
    // So it doesn't collapse.
  }
}, e.variant === "filled" && {
  "&&&": {
    paddingRight: 32
  }
}, e.variant === "outlined" && {
  borderRadius: (t.vars || t).shape.borderRadius,
  "&:focus": {
    borderRadius: (t.vars || t).shape.borderRadius
    // Reset the reset for Chrome style
  },
  "&&&": {
    paddingRight: 32
  }
}), NativeSelectSelect = E("select", {
  name: "MuiNativeSelect",
  slot: "Select",
  shouldForwardProp: rootShouldForwardProp,
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.select, t[n.variant], n.error && t.error, {
      [`&.${nativeSelectClasses$1.multiple}`]: t.multiple
    }];
  }
})(nativeSelectSelectStyles), nativeSelectIconStyles = ({
  ownerState: e,
  theme: t
}) => _extends$5({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: "absolute",
  right: 0,
  top: "calc(50% - .5em)",
  // Center vertically, height is 1em
  pointerEvents: "none",
  // Don't block pointer events on the select under the icon.
  color: (t.vars || t).palette.action.active,
  [`&.${nativeSelectClasses$1.disabled}`]: {
    color: (t.vars || t).palette.action.disabled
  }
}, e.open && {
  transform: "rotate(180deg)"
}, e.variant === "filled" && {
  right: 7
}, e.variant === "outlined" && {
  right: 7
}), NativeSelectIcon = E("svg", {
  name: "MuiNativeSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, n.variant && t[`icon${capitalize$1(n.variant)}`], n.open && t.iconOpen];
  }
})(nativeSelectIconStyles), NativeSelectInput = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  const {
    className: o,
    disabled: s,
    error: l,
    IconComponent: c,
    inputRef: p,
    variant: m = "standard"
  } = t, C = _objectWithoutPropertiesLoose$3(t, _excluded$c), P = _extends$5({}, t, {
    disabled: s,
    variant: m,
    error: l
  }), w = useUtilityClasses$7(P);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React$2.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(NativeSelectSelect, _extends$5({
      ownerState: P,
      className: clsx$1(w.select, o),
      disabled: s,
      ref: p || n
    }, C)), t.multiple ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(NativeSelectIcon, {
      as: c,
      ownerState: P,
      className: w.icon
    })]
  });
});
process.env.NODE_ENV !== "production" && (NativeSelectInput.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The CSS class name of the select element.
   */
  className: PropTypes.string,
  /**
   * If `true`, the select is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: PropTypes.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType.isRequired,
  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: refType$1,
  /**
   * @ignore
   */
  multiple: PropTypes.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The input value.
   */
  value: PropTypes.any,
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(["standard", "outlined", "filled"])
});
const NativeSelectInput$1 = NativeSelectInput;
var _span$1;
const _excluded$b = ["children", "classes", "className", "label", "notched"], NotchedOutlineRoot$1 = E("fieldset", {
  shouldForwardProp: rootShouldForwardProp
})({
  textAlign: "left",
  position: "absolute",
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: "0 8px",
  pointerEvents: "none",
  borderRadius: "inherit",
  borderStyle: "solid",
  borderWidth: 1,
  overflow: "hidden",
  minWidth: "0%"
}), NotchedOutlineLegend = E("legend", {
  shouldForwardProp: rootShouldForwardProp
})(({
  ownerState: e,
  theme: t
}) => _extends$5({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden"
}, !e.withLabel && {
  padding: 0,
  lineHeight: "11px",
  // sync with `height` in `legend` styles
  transition: t.transitions.create("width", {
    duration: 150,
    easing: t.transitions.easing.easeOut
  })
}, e.withLabel && _extends$5({
  display: "block",
  // Fix conflict with normalize.css and sanitize.css
  padding: 0,
  height: 11,
  // sync with `lineHeight` in `legend` styles
  fontSize: "0.75em",
  visibility: "hidden",
  maxWidth: 0.01,
  transition: t.transitions.create("max-width", {
    duration: 50,
    easing: t.transitions.easing.easeOut
  }),
  whiteSpace: "nowrap",
  "& > span": {
    paddingLeft: 5,
    paddingRight: 5,
    display: "inline-block",
    opacity: 0,
    visibility: "visible"
  }
}, e.notched && {
  maxWidth: "100%",
  transition: t.transitions.create("max-width", {
    duration: 100,
    easing: t.transitions.easing.easeOut,
    delay: 50
  })
})));
function NotchedOutline(e) {
  const {
    className: t,
    label: n,
    notched: o
  } = e, s = _objectWithoutPropertiesLoose$3(e, _excluded$b), l = n != null && n !== "", c = _extends$5({}, e, {
    notched: o,
    withLabel: l
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(NotchedOutlineRoot$1, _extends$5({
    "aria-hidden": !0,
    className: t,
    ownerState: c
  }, s, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(NotchedOutlineLegend, {
      ownerState: c,
      children: l ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
        children: n
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        _span$1 || (_span$1 = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
          className: "notranslate",
          children: "​"
        }))
      )
    })
  }));
}
process.env.NODE_ENV !== "production" && (NotchedOutline.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The label.
   */
  label: PropTypes.node,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: PropTypes.bool.isRequired,
  /**
   * @ignore
   */
  style: PropTypes.object
});
const _excluded$a = ["components", "fullWidth", "inputComponent", "label", "multiline", "notched", "slots", "type"], useUtilityClasses$6 = (e) => {
  const {
    classes: t
  } = e, o = composeClasses({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, getOutlinedInputUtilityClass, t);
  return _extends$5({}, t, o);
}, OutlinedInputRoot = E(InputBaseRoot, {
  shouldForwardProp: (e) => rootShouldForwardProp(e) || e === "classes",
  name: "MuiOutlinedInput",
  slot: "Root",
  overridesResolver: rootOverridesResolver
})(({
  theme: e,
  ownerState: t
}) => {
  const n = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return _extends$5({
    position: "relative",
    borderRadius: (e.vars || e).shape.borderRadius,
    [`&:hover .${outlinedInputClasses$1.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${outlinedInputClasses$1.notchedOutline}`]: {
        borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : n
      }
    },
    [`&.${outlinedInputClasses$1.focused} .${outlinedInputClasses$1.notchedOutline}`]: {
      borderColor: (e.vars || e).palette[t.color].main,
      borderWidth: 2
    },
    [`&.${outlinedInputClasses$1.error} .${outlinedInputClasses$1.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.error.main
    },
    [`&.${outlinedInputClasses$1.disabled} .${outlinedInputClasses$1.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.action.disabled
    }
  }, t.startAdornment && {
    paddingLeft: 14
  }, t.endAdornment && {
    paddingRight: 14
  }, t.multiline && _extends$5({
    padding: "16.5px 14px"
  }, t.size === "small" && {
    padding: "8.5px 14px"
  }));
}), NotchedOutlineRoot = E(NotchedOutline, {
  name: "MuiOutlinedInput",
  slot: "NotchedOutline",
  overridesResolver: (e, t) => t.notchedOutline
})(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
  };
}), OutlinedInputInput = E(InputBaseComponent, {
  name: "MuiOutlinedInput",
  slot: "Input",
  overridesResolver: inputOverridesResolver
})(({
  theme: e,
  ownerState: t
}) => _extends$5({
  padding: "16.5px 14px"
}, !e.vars && {
  "&:-webkit-autofill": {
    WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
    WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
    caretColor: e.palette.mode === "light" ? null : "#fff",
    borderRadius: "inherit"
  }
}, e.vars && {
  "&:-webkit-autofill": {
    borderRadius: "inherit"
  },
  [e.getColorSchemeSelector("dark")]: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px #266798 inset",
      WebkitTextFillColor: "#fff",
      caretColor: "#fff"
    }
  }
}, t.size === "small" && {
  padding: "8.5px 14px"
}, t.multiline && {
  padding: 0
}, t.startAdornment && {
  paddingLeft: 0
}, t.endAdornment && {
  paddingRight: 0
})), OutlinedInput = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  var o, s, l, c, p;
  const m = useThemeProps({
    props: t,
    name: "MuiOutlinedInput"
  }), {
    components: C = {},
    fullWidth: P = !1,
    inputComponent: w = "input",
    label: R,
    multiline: L = !1,
    notched: M,
    slots: $ = {},
    type: W = "text"
  } = m, H = _objectWithoutPropertiesLoose$3(m, _excluded$a), V = useUtilityClasses$6(m), N = useFormControl(), B = formControlState({
    props: m,
    muiFormControl: N,
    states: ["color", "disabled", "error", "focused", "hiddenLabel", "size", "required"]
  }), K = _extends$5({}, m, {
    color: B.color || "primary",
    disabled: B.disabled,
    error: B.error,
    focused: B.focused,
    formControl: N,
    fullWidth: P,
    hiddenLabel: B.hiddenLabel,
    multiline: L,
    size: B.size,
    type: W
  }), ue = (o = (s = $.root) != null ? s : C.Root) != null ? o : OutlinedInputRoot, de = (l = (c = $.input) != null ? c : C.Input) != null ? l : OutlinedInputInput;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(InputBase$1, _extends$5({
    slots: {
      root: ue,
      input: de
    },
    renderSuffix: (ve) => /* @__PURE__ */ jsxRuntimeExports.jsx(NotchedOutlineRoot, {
      ownerState: K,
      className: V.notchedOutline,
      label: R != null && R !== "" && B.required ? p || (p = /* @__PURE__ */ jsxRuntimeExports.jsxs(React$2.Fragment, {
        children: [R, " ", "*"]
      })) : R,
      notched: typeof M < "u" ? M : !!(ve.startAdornment || ve.filled || ve.focused)
    }),
    fullWidth: P,
    inputComponent: w,
    multiline: L,
    ref: n,
    type: W
  }, H, {
    classes: _extends$5({}, V, {
      notchedOutline: null
    })
  }));
});
process.env.NODE_ENV !== "production" && (OutlinedInput.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: PropTypes.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,
  /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */
  label: PropTypes.node,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: PropTypes.bool,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
});
OutlinedInput.muiName = "Input";
const OutlinedInput$1 = OutlinedInput, RadioButtonUncheckedIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "RadioButtonUnchecked"), RadioButtonCheckedIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), "RadioButtonChecked"), RadioButtonIconRoot = E("span", {
  shouldForwardProp: rootShouldForwardProp
})({
  position: "relative",
  display: "flex"
}), RadioButtonIconBackground = E(RadioButtonUncheckedIcon)({
  // Scale applied to prevent dot misalignment in Safari
  transform: "scale(1)"
}), RadioButtonIconDot = E(RadioButtonCheckedIcon)(({
  theme: e,
  ownerState: t
}) => _extends$5({
  left: 0,
  position: "absolute",
  transform: "scale(0)",
  transition: e.transitions.create("transform", {
    easing: e.transitions.easing.easeIn,
    duration: e.transitions.duration.shortest
  })
}, t.checked && {
  transform: "scale(1)",
  transition: e.transitions.create("transform", {
    easing: e.transitions.easing.easeOut,
    duration: e.transitions.duration.shortest
  })
}));
function RadioButtonIcon(e) {
  const {
    checked: t = !1,
    classes: n = {},
    fontSize: o
  } = e, s = _extends$5({}, e, {
    checked: t
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(RadioButtonIconRoot, {
    className: n.root,
    ownerState: s,
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(RadioButtonIconBackground, {
      fontSize: o,
      className: n.background,
      ownerState: s
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(RadioButtonIconDot, {
      fontSize: o,
      className: n.dot,
      ownerState: s
    })]
  });
}
process.env.NODE_ENV !== "production" && (RadioButtonIcon.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   */
  fontSize: PropTypes.oneOf(["small", "medium"])
});
const RadioGroupContext = /* @__PURE__ */ React$2.createContext(void 0);
process.env.NODE_ENV !== "production" && (RadioGroupContext.displayName = "RadioGroupContext");
const RadioGroupContext$1 = RadioGroupContext;
function useRadioGroup() {
  return React$2.useContext(RadioGroupContext$1);
}
function getRadioUtilityClass(e) {
  return generateUtilityClass$1("MuiRadio", e);
}
const radioClasses = generateUtilityClasses$1("MuiRadio", ["root", "checked", "disabled", "colorPrimary", "colorSecondary", "sizeSmall"]), radioClasses$1 = radioClasses, _excluded$9 = ["checked", "checkedIcon", "color", "icon", "name", "onChange", "size", "className"], useUtilityClasses$5 = (e) => {
  const {
    classes: t,
    color: n,
    size: o
  } = e, s = {
    root: ["root", `color${capitalize$1(n)}`, o !== "medium" && `size${capitalize$1(o)}`]
  };
  return _extends$5({}, t, composeClasses(s, getRadioUtilityClass, t));
}, RadioRoot = E(SwitchBase$1, {
  shouldForwardProp: (e) => rootShouldForwardProp(e) || e === "classes",
  name: "MuiRadio",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.size !== "medium" && t[`size${capitalize$1(n.size)}`], t[`color${capitalize$1(n.color)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => _extends$5({
  color: (e.vars || e).palette.text.secondary
}, !t.disableRipple && {
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${t.color === "default" ? e.vars.palette.action.activeChannel : e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : alpha_1(t.color === "default" ? e.palette.action.active : e.palette[t.color].main, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, t.color !== "default" && {
  [`&.${radioClasses$1.checked}`]: {
    color: (e.vars || e).palette[t.color].main
  }
}, {
  [`&.${radioClasses$1.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  }
}));
function areEqualValues$1(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
const defaultCheckedIcon = /* @__PURE__ */ jsxRuntimeExports.jsx(RadioButtonIcon, {
  checked: !0
}), defaultIcon = /* @__PURE__ */ jsxRuntimeExports.jsx(RadioButtonIcon, {}), Radio = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  var o, s;
  const l = useThemeProps({
    props: t,
    name: "MuiRadio"
  }), {
    checked: c,
    checkedIcon: p = defaultCheckedIcon,
    color: m = "primary",
    icon: C = defaultIcon,
    name: P,
    onChange: w,
    size: R = "medium",
    className: L
  } = l, M = _objectWithoutPropertiesLoose$3(l, _excluded$9), $ = _extends$5({}, l, {
    color: m,
    size: R
  }), W = useUtilityClasses$5($), H = useRadioGroup();
  let V = c;
  const N = createChainedFunction(w, H && H.onChange);
  let B = P;
  return H && (typeof V > "u" && (V = areEqualValues$1(H.value, l.value)), typeof B > "u" && (B = H.name)), /* @__PURE__ */ jsxRuntimeExports.jsx(RadioRoot, _extends$5({
    type: "radio",
    icon: /* @__PURE__ */ React$2.cloneElement(C, {
      fontSize: (o = defaultIcon.props.fontSize) != null ? o : R
    }),
    checkedIcon: /* @__PURE__ */ React$2.cloneElement(p, {
      fontSize: (s = defaultCheckedIcon.props.fontSize) != null ? s : R
    }),
    ownerState: $,
    classes: W,
    name: B,
    checked: V,
    onChange: N,
    ref: n,
    className: clsx$1(W.root, L)
  }, M));
});
process.env.NODE_ENV !== "production" && (Radio.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,
  /**
   * The icon to display when the component is checked.
   * @default <RadioButtonIcon checked />
   */
  checkedIcon: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <RadioButtonIcon />
   */
  icon: PropTypes.node,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   */
  value: PropTypes.any
});
const Radio$1 = Radio, _excluded$8 = ["actions", "children", "defaultValue", "name", "onChange", "value"], RadioGroup = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: o,
    children: s,
    defaultValue: l,
    name: c,
    onChange: p,
    value: m
  } = t, C = _objectWithoutPropertiesLoose$3(t, _excluded$8), P = React$2.useRef(null), [w, R] = useControlled({
    controlled: m,
    default: l,
    name: "RadioGroup"
  });
  React$2.useImperativeHandle(o, () => ({
    focus: () => {
      let W = P.current.querySelector("input:not(:disabled):checked");
      W || (W = P.current.querySelector("input:not(:disabled)")), W && W.focus();
    }
  }), []);
  const L = useForkRef(n, P), M = useId(c), $ = React$2.useMemo(() => ({
    name: M,
    onChange(W) {
      R(W.target.value), p && p(W, W.target.value);
    },
    value: w
  }), [M, p, R, w]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(RadioGroupContext$1.Provider, {
    value: $,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormGroup$1, _extends$5({
      role: "radiogroup",
      ref: L
    }, C, {
      children: s
    }))
  });
});
process.env.NODE_ENV !== "production" && (RadioGroup.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * The name used to reference the value of the control.
   * If you don't provide this prop, it falls back to a randomly generated name.
   */
  name: PropTypes.string,
  /**
   * Callback fired when a radio button is selected.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {string} value The value of the selected radio button.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * Value of the selected radio button. The DOM API casts this to a string.
   */
  value: PropTypes.any
});
const RadioGroup$1 = RadioGroup;
function getSelectUtilityClasses(e) {
  return generateUtilityClass$1("MuiSelect", e);
}
const selectClasses = generateUtilityClasses$1("MuiSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "focused", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]), selectClasses$1 = selectClasses;
var _span;
const _excluded$7 = ["aria-describedby", "aria-label", "autoFocus", "autoWidth", "children", "className", "defaultOpen", "defaultValue", "disabled", "displayEmpty", "error", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"], SelectSelect = E("div", {
  name: "MuiSelect",
  slot: "Select",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [
      // Win specificity over the input base
      {
        [`&.${selectClasses$1.select}`]: t.select
      },
      {
        [`&.${selectClasses$1.select}`]: t[n.variant]
      },
      {
        [`&.${selectClasses$1.error}`]: t.error
      },
      {
        [`&.${selectClasses$1.multiple}`]: t.multiple
      }
    ];
  }
})(nativeSelectSelectStyles, {
  // Win specificity over the input base
  [`&.${selectClasses$1.select}`]: {
    height: "auto",
    // Resets for multiple select with chips
    minHeight: "1.4375em",
    // Required for select\text-field height consistency
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }
}), SelectIcon = E("svg", {
  name: "MuiSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, n.variant && t[`icon${capitalize$1(n.variant)}`], n.open && t.iconOpen];
  }
})(nativeSelectIconStyles), SelectNativeInput = E("input", {
  shouldForwardProp: (e) => slotShouldForwardProp(e) && e !== "classes",
  name: "MuiSelect",
  slot: "NativeInput",
  overridesResolver: (e, t) => t.nativeInput
})({
  bottom: 0,
  left: 0,
  position: "absolute",
  opacity: 0,
  pointerEvents: "none",
  width: "100%",
  boxSizing: "border-box"
});
function areEqualValues(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
function isEmpty(e) {
  return e == null || typeof e == "string" && !e.trim();
}
const useUtilityClasses$4 = (e) => {
  const {
    classes: t,
    variant: n,
    disabled: o,
    multiple: s,
    open: l,
    error: c
  } = e, p = {
    select: ["select", n, o && "disabled", s && "multiple", c && "error"],
    icon: ["icon", `icon${capitalize$1(n)}`, l && "iconOpen", o && "disabled"],
    nativeInput: ["nativeInput"]
  };
  return composeClasses(p, getSelectUtilityClasses, t);
}, SelectInput = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  var o;
  const {
    "aria-describedby": s,
    "aria-label": l,
    autoFocus: c,
    autoWidth: p,
    children: m,
    className: C,
    defaultOpen: P,
    defaultValue: w,
    disabled: R,
    displayEmpty: L,
    error: M = !1,
    IconComponent: $,
    inputRef: W,
    labelId: H,
    MenuProps: V = {},
    multiple: N,
    name: B,
    onBlur: K,
    onChange: ue,
    onClose: de,
    onFocus: ve,
    onOpen: Te,
    open: Pe,
    readOnly: Ce,
    renderValue: Re,
    SelectDisplayProps: ke = {},
    tabIndex: Ae,
    value: we,
    variant: he = "standard"
  } = t, be = _objectWithoutPropertiesLoose$3(t, _excluded$7), [le, fe] = useControlled({
    controlled: we,
    default: w,
    name: "Select"
  }), [ye, Ee] = useControlled({
    controlled: Pe,
    default: P,
    name: "Select"
  }), Ie = React$2.useRef(null), Fe = React$2.useRef(null), [De, Ve] = React$2.useState(null), {
    current: Oe
  } = React$2.useRef(Pe != null), [Ze, et] = React$2.useState(), bt = useForkRef(n, W), rr = React$2.useCallback((er) => {
    Fe.current = er, er && Ve(er);
  }, []), St = De == null ? void 0 : De.parentNode;
  React$2.useImperativeHandle(bt, () => ({
    focus: () => {
      Fe.current.focus();
    },
    node: Ie.current,
    value: le
  }), [le]), React$2.useEffect(() => {
    P && ye && De && !Oe && (et(p ? null : St.clientWidth), Fe.current.focus());
  }, [De, p]), React$2.useEffect(() => {
    c && Fe.current.focus();
  }, [c]), React$2.useEffect(() => {
    if (!H)
      return;
    const er = ownerDocument(Fe.current).getElementById(H);
    if (er) {
      const pr = () => {
        getSelection().isCollapsed && Fe.current.focus();
      };
      return er.addEventListener("click", pr), () => {
        er.removeEventListener("click", pr);
      };
    }
  }, [H]);
  const Qe = (er, pr) => {
    er ? Te && Te(pr) : de && de(pr), Oe || (et(p ? null : St.clientWidth), Ee(er));
  }, xt = (er) => {
    er.button === 0 && (er.preventDefault(), Fe.current.focus(), Qe(!0, er));
  }, je = (er) => {
    Qe(!1, er);
  }, kt = React$2.Children.toArray(m), cr = (er) => {
    const pr = kt.find((kr) => kr.props.value === er.target.value);
    pr !== void 0 && (fe(pr.props.value), ue && ue(er, pr));
  }, Tr = (er) => (pr) => {
    let kr;
    if (pr.currentTarget.hasAttribute("tabindex")) {
      if (N) {
        kr = Array.isArray(le) ? le.slice() : [];
        const Nr = le.indexOf(er.props.value);
        Nr === -1 ? kr.push(er.props.value) : kr.splice(Nr, 1);
      } else
        kr = er.props.value;
      if (er.props.onClick && er.props.onClick(pr), le !== kr && (fe(kr), ue)) {
        const Nr = pr.nativeEvent || pr, hn = new Nr.constructor(Nr.type, Nr);
        Object.defineProperty(hn, "target", {
          writable: !0,
          value: {
            value: kr,
            name: B
          }
        }), ue(hn, er);
      }
      N || Qe(!1, pr);
    }
  }, Er = (er) => {
    Ce || [
      " ",
      "ArrowUp",
      "ArrowDown",
      // The native select doesn't respond to enter on macOS, but it's recommended by
      // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
      "Enter"
    ].indexOf(er.key) !== -1 && (er.preventDefault(), Qe(!0, er));
  }, Hr = De !== null && ye, Br = (er) => {
    !Hr && K && (Object.defineProperty(er, "target", {
      writable: !0,
      value: {
        value: le,
        name: B
      }
    }), K(er));
  };
  delete be["aria-invalid"];
  let hr, Gr;
  const Yr = [];
  let tt = !1, ar = !1;
  (isFilled({
    value: le
  }) || L) && (Re ? hr = Re(le) : tt = !0);
  const wr = kt.map((er) => {
    if (!/* @__PURE__ */ React$2.isValidElement(er))
      return null;
    process.env.NODE_ENV !== "production" && reactIsExports.isFragment(er) && console.error(["MUI: The Select component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    let pr;
    if (N) {
      if (!Array.isArray(le))
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: The `value` prop must be an array when using the `Select` component with `multiple`." : formatMuiErrorMessage$1(2));
      pr = le.some((kr) => areEqualValues(kr, er.props.value)), pr && tt && Yr.push(er.props.children);
    } else
      pr = areEqualValues(le, er.props.value), pr && tt && (Gr = er.props.children);
    return pr && (ar = !0), /* @__PURE__ */ React$2.cloneElement(er, {
      "aria-selected": pr ? "true" : "false",
      onClick: Tr(er),
      onKeyUp: (kr) => {
        kr.key === " " && kr.preventDefault(), er.props.onKeyUp && er.props.onKeyUp(kr);
      },
      role: "option",
      selected: pr,
      value: void 0,
      // The value is most likely not a valid HTML attribute.
      "data-value": er.props.value
      // Instead, we provide it as a data attribute.
    });
  });
  process.env.NODE_ENV !== "production" && React$2.useEffect(() => {
    if (!ar && !N && le !== "") {
      const er = kt.map((pr) => pr.props.value);
      console.warn([`MUI: You have provided an out-of-range value \`${le}\` for the select ${B ? `(name="${B}") ` : ""}component.`, "Consider providing a value that matches one of the available options or ''.", `The available values are ${er.filter((pr) => pr != null).map((pr) => `\`${pr}\``).join(", ") || '""'}.`].join(`
`));
    }
  }, [ar, kt, N, B, le]), tt && (N ? Yr.length === 0 ? hr = null : hr = Yr.reduce((er, pr, kr) => (er.push(pr), kr < Yr.length - 1 && er.push(", "), er), []) : hr = Gr);
  let Sr = Ze;
  !p && Oe && De && (Sr = St.clientWidth);
  let Ye;
  typeof Ae < "u" ? Ye = Ae : Ye = R ? null : 0;
  const Je = ke.id || (B ? `mui-component-select-${B}` : void 0), tr = _extends$5({}, t, {
    variant: he,
    value: le,
    open: Hr,
    error: M
  }), pt = useUtilityClasses$4(tr), ir = _extends$5({}, V.PaperProps, (o = V.slotProps) == null ? void 0 : o.paper), nr = useId();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React$2.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(SelectSelect, _extends$5({
      ref: rr,
      tabIndex: Ye,
      role: "combobox",
      "aria-controls": nr,
      "aria-disabled": R ? "true" : void 0,
      "aria-expanded": Hr ? "true" : "false",
      "aria-haspopup": "listbox",
      "aria-label": l,
      "aria-labelledby": [H, Je].filter(Boolean).join(" ") || void 0,
      "aria-describedby": s,
      onKeyDown: Er,
      onMouseDown: R || Ce ? null : xt,
      onBlur: Br,
      onFocus: ve
    }, ke, {
      ownerState: tr,
      className: clsx$1(ke.className, pt.select, C),
      id: Je,
      children: isEmpty(hr) ? (
        // notranslate needed while Google Translate will not fix zero-width space issue
        _span || (_span = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
          className: "notranslate",
          children: "​"
        }))
      ) : hr
    })), /* @__PURE__ */ jsxRuntimeExports.jsx(SelectNativeInput, _extends$5({
      "aria-invalid": M,
      value: Array.isArray(le) ? le.join(",") : le,
      name: B,
      ref: Ie,
      "aria-hidden": !0,
      onChange: cr,
      tabIndex: -1,
      disabled: R,
      className: pt.nativeInput,
      autoFocus: c,
      ownerState: tr
    }, be)), /* @__PURE__ */ jsxRuntimeExports.jsx(SelectIcon, {
      as: $,
      className: pt.icon,
      ownerState: tr
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(Menu$1, _extends$5({
      id: `menu-${B || ""}`,
      anchorEl: St,
      open: Hr,
      onClose: je,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      }
    }, V, {
      MenuListProps: _extends$5({
        "aria-labelledby": H,
        role: "listbox",
        "aria-multiselectable": N ? "true" : void 0,
        disableListWrap: !0,
        id: nr
      }, V.MenuListProps),
      slotProps: _extends$5({}, V.slotProps, {
        paper: _extends$5({}, ir, {
          style: _extends$5({
            minWidth: Sr
          }, ir != null ? ir.style : null)
        })
      }),
      children: wr
    }))]
  });
});
process.env.NODE_ENV !== "production" && (SelectInput.propTypes = {
  /**
   * @ignore
   */
  "aria-describedby": PropTypes.string,
  /**
   * @ignore
   */
  "aria-label": PropTypes.string,
  /**
   * @ignore
   */
  autoFocus: PropTypes.bool,
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: PropTypes.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The CSS class name of the select element.
   */
  className: PropTypes.string,
  /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */
  defaultOpen: PropTypes.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the select is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: PropTypes.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: PropTypes.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType.isRequired,
  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: refType$1,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: PropTypes.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: PropTypes.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: PropTypes.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: PropTypes.string,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool,
  /**
   * @ignore
   */
  readOnly: PropTypes.bool,
  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: PropTypes.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: PropTypes.object,
  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * @ignore
   */
  type: PropTypes.any,
  /**
   * The input value.
   */
  value: PropTypes.any,
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(["standard", "outlined", "filled"])
});
const SelectInput$1 = SelectInput, _excluded$6 = ["autoWidth", "children", "classes", "className", "defaultOpen", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"], _excluded2$2 = ["root"], useUtilityClasses$3 = (e) => {
  const {
    classes: t
  } = e;
  return t;
}, styledRootConfig = {
  name: "MuiSelect",
  overridesResolver: (e, t) => t.root,
  shouldForwardProp: (e) => rootShouldForwardProp(e) && e !== "variant",
  slot: "Root"
}, StyledInput = E(Input$1, styledRootConfig)(""), StyledOutlinedInput = E(OutlinedInput$1, styledRootConfig)(""), StyledFilledInput = E(FilledInput$1, styledRootConfig)(""), Select = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  const o = useThemeProps({
    name: "MuiSelect",
    props: t
  }), {
    autoWidth: s = !1,
    children: l,
    classes: c = {},
    className: p,
    defaultOpen: m = !1,
    displayEmpty: C = !1,
    IconComponent: P = ArrowDropDownIcon,
    id: w,
    input: R,
    inputProps: L,
    label: M,
    labelId: $,
    MenuProps: W,
    multiple: H = !1,
    native: V = !1,
    onClose: N,
    onOpen: B,
    open: K,
    renderValue: ue,
    SelectDisplayProps: de,
    variant: ve = "outlined"
  } = o, Te = _objectWithoutPropertiesLoose$3(o, _excluded$6), Pe = V ? NativeSelectInput$1 : SelectInput$1, Ce = useFormControl(), Re = formControlState({
    props: o,
    muiFormControl: Ce,
    states: ["variant", "error"]
  }), ke = Re.variant || ve, Ae = _extends$5({}, o, {
    variant: ke,
    classes: c
  }), we = useUtilityClasses$3(Ae), he = _objectWithoutPropertiesLoose$3(we, _excluded2$2), be = R || {
    standard: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInput, {
      ownerState: Ae
    }),
    outlined: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledOutlinedInput, {
      label: M,
      ownerState: Ae
    }),
    filled: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFilledInput, {
      ownerState: Ae
    })
  }[ke], le = useForkRef(n, be.ref);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React$2.Fragment, {
    children: /* @__PURE__ */ React$2.cloneElement(be, _extends$5({
      // Most of the logic is implemented in `SelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: Pe,
      inputProps: _extends$5({
        children: l,
        error: Re.error,
        IconComponent: P,
        variant: ke,
        type: void 0,
        // We render a select. We can ignore the type provided by the `Input`.
        multiple: H
      }, V ? {
        id: w
      } : {
        autoWidth: s,
        defaultOpen: m,
        displayEmpty: C,
        labelId: $,
        MenuProps: W,
        onClose: N,
        onOpen: B,
        open: K,
        renderValue: ue,
        SelectDisplayProps: _extends$5({
          id: w
        }, de)
      }, L, {
        classes: L ? deepmerge$1(he, L.classes) : he
      }, R ? R.props.inputProps : {})
    }, (H && V || C) && ke === "outlined" ? {
      notched: !0
    } : {}, {
      ref: le,
      className: clsx$1(be.props.className, p, we.root)
    }, !R && {
      variant: ke
    }, Te))
  });
});
process.env.NODE_ENV !== "production" && (Select.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */
  autoWidth: PropTypes.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */
  defaultOpen: PropTypes.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */
  displayEmpty: PropTypes.bool,
  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: PropTypes.elementType,
  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: PropTypes.string,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: PropTypes.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: PropTypes.object,
  /**
   * See [OutlinedInput#label](/material-ui/api/outlined-input/#props)
   */
  label: PropTypes.node,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: PropTypes.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: PropTypes.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: PropTypes.bool,
  /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */
  native: PropTypes.bool,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<Value>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,
  /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: PropTypes.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: PropTypes.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: PropTypes.oneOfType([PropTypes.oneOf([""]), PropTypes.any]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
});
Select.muiName = "Select";
const Select$1 = Select, shouldSpreadAdditionalProps = (e) => !e || !isHostComponent(e), shouldSpreadAdditionalProps$1 = shouldSpreadAdditionalProps;
function getSliderUtilityClass(e) {
  return generateUtilityClass$1("MuiSlider", e);
}
const sliderClasses = generateUtilityClasses$1("MuiSlider", ["root", "active", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "disabled", "dragging", "focusVisible", "mark", "markActive", "marked", "markLabel", "markLabelActive", "rail", "sizeSmall", "thumb", "thumbColorPrimary", "thumbColorSecondary", "thumbColorError", "thumbColorSuccess", "thumbColorInfo", "thumbColorWarning", "track", "trackInverted", "trackFalse", "thumbSizeSmall", "valueLabel", "valueLabelOpen", "valueLabelCircle", "valueLabelLabel", "vertical"]), sliderClasses$1 = sliderClasses, useValueLabelClasses = (e) => {
  const {
    open: t
  } = e;
  return {
    offset: clsx$1(t && sliderClasses$1.valueLabelOpen),
    circle: sliderClasses$1.valueLabelCircle,
    label: sliderClasses$1.valueLabelLabel
  };
};
function SliderValueLabel$1(e) {
  const {
    children: t,
    className: n,
    value: o
  } = e, s = useValueLabelClasses(e);
  return t ? /* @__PURE__ */ React$2.cloneElement(t, {
    className: clsx$1(t.props.className)
  }, /* @__PURE__ */ jsxRuntimeExports.jsxs(React$2.Fragment, {
    children: [t.props.children, /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      className: clsx$1(s.offset, n),
      "aria-hidden": !0,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
        className: s.circle,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
          className: s.label,
          children: o
        })
      })
    })]
  })) : null;
}
process.env.NODE_ENV !== "production" && (SliderValueLabel$1.propTypes = {
  children: PropTypes.element.isRequired,
  className: PropTypes.string,
  value: PropTypes.node
});
const _excluded$5 = ["aria-label", "aria-valuetext", "aria-labelledby", "component", "components", "componentsProps", "color", "classes", "className", "disableSwap", "disabled", "getAriaLabel", "getAriaValueText", "marks", "max", "min", "name", "onChange", "onChangeCommitted", "orientation", "shiftStep", "size", "step", "scale", "slotProps", "slots", "tabIndex", "track", "value", "valueLabelDisplay", "valueLabelFormat"];
function Identity(e) {
  return e;
}
const SliderRoot = E("span", {
  name: "MuiSlider",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[`color${capitalize$1(n.color)}`], n.size !== "medium" && t[`size${capitalize$1(n.size)}`], n.marked && t.marked, n.orientation === "vertical" && t.vertical, n.track === "inverted" && t.trackInverted, n.track === !1 && t.trackFalse];
  }
})(({
  theme: e,
  ownerState: t
}) => _extends$5({
  borderRadius: 12,
  boxSizing: "content-box",
  display: "inline-block",
  position: "relative",
  cursor: "pointer",
  touchAction: "none",
  color: (e.vars || e).palette[t.color].main,
  WebkitTapHighlightColor: "transparent"
}, t.orientation === "horizontal" && _extends$5({
  height: 4,
  width: "100%",
  padding: "13px 0",
  // The primary input mechanism of the device includes a pointing device of limited accuracy.
  "@media (pointer: coarse)": {
    // Reach 42px touch target, about ~8mm on screen.
    padding: "20px 0"
  }
}, t.size === "small" && {
  height: 2
}, t.marked && {
  marginBottom: 20
}), t.orientation === "vertical" && _extends$5({
  height: "100%",
  width: 4,
  padding: "0 13px",
  // The primary input mechanism of the device includes a pointing device of limited accuracy.
  "@media (pointer: coarse)": {
    // Reach 42px touch target, about ~8mm on screen.
    padding: "0 20px"
  }
}, t.size === "small" && {
  width: 2
}, t.marked && {
  marginRight: 44
}), {
  "@media print": {
    colorAdjust: "exact"
  },
  [`&.${sliderClasses$1.disabled}`]: {
    pointerEvents: "none",
    cursor: "default",
    color: (e.vars || e).palette.grey[400]
  },
  [`&.${sliderClasses$1.dragging}`]: {
    [`& .${sliderClasses$1.thumb}, & .${sliderClasses$1.track}`]: {
      transition: "none"
    }
  }
})), SliderRail = E("span", {
  name: "MuiSlider",
  slot: "Rail",
  overridesResolver: (e, t) => t.rail
})(({
  ownerState: e
}) => _extends$5({
  display: "block",
  position: "absolute",
  borderRadius: "inherit",
  backgroundColor: "currentColor",
  opacity: 0.38
}, e.orientation === "horizontal" && {
  width: "100%",
  height: "inherit",
  top: "50%",
  transform: "translateY(-50%)"
}, e.orientation === "vertical" && {
  height: "100%",
  width: "inherit",
  left: "50%",
  transform: "translateX(-50%)"
}, e.track === "inverted" && {
  opacity: 1
})), SliderTrack = E("span", {
  name: "MuiSlider",
  slot: "Track",
  overridesResolver: (e, t) => t.track
})(({
  theme: e,
  ownerState: t
}) => {
  const n = (
    // Same logic as the LinearProgress track color
    e.palette.mode === "light" ? lighten_1(e.palette[t.color].main, 0.62) : darken_1(e.palette[t.color].main, 0.5)
  );
  return _extends$5({
    display: "block",
    position: "absolute",
    borderRadius: "inherit",
    border: "1px solid currentColor",
    backgroundColor: "currentColor",
    transition: e.transitions.create(["left", "width", "bottom", "height"], {
      duration: e.transitions.duration.shortest
    })
  }, t.size === "small" && {
    border: "none"
  }, t.orientation === "horizontal" && {
    height: "inherit",
    top: "50%",
    transform: "translateY(-50%)"
  }, t.orientation === "vertical" && {
    width: "inherit",
    left: "50%",
    transform: "translateX(-50%)"
  }, t.track === !1 && {
    display: "none"
  }, t.track === "inverted" && {
    backgroundColor: e.vars ? e.vars.palette.Slider[`${t.color}Track`] : n,
    borderColor: e.vars ? e.vars.palette.Slider[`${t.color}Track`] : n
  });
}), SliderThumb = E("span", {
  name: "MuiSlider",
  slot: "Thumb",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.thumb, t[`thumbColor${capitalize$1(n.color)}`], n.size !== "medium" && t[`thumbSize${capitalize$1(n.size)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => _extends$5({
  position: "absolute",
  width: 20,
  height: 20,
  boxSizing: "border-box",
  borderRadius: "50%",
  outline: 0,
  backgroundColor: "currentColor",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: e.transitions.create(["box-shadow", "left", "bottom"], {
    duration: e.transitions.duration.shortest
  })
}, t.size === "small" && {
  width: 12,
  height: 12
}, t.orientation === "horizontal" && {
  top: "50%",
  transform: "translate(-50%, -50%)"
}, t.orientation === "vertical" && {
  left: "50%",
  transform: "translate(-50%, 50%)"
}, {
  "&::before": _extends$5({
    position: "absolute",
    content: '""',
    borderRadius: "inherit",
    width: "100%",
    height: "100%",
    boxShadow: (e.vars || e).shadows[2]
  }, t.size === "small" && {
    boxShadow: "none"
  }),
  "&::after": {
    position: "absolute",
    content: '""',
    borderRadius: "50%",
    // 42px is the hit target
    width: 42,
    height: 42,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  },
  [`&:hover, &.${sliderClasses$1.focusVisible}`]: {
    boxShadow: `0px 0px 0px 8px ${e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.16)` : alpha_1(e.palette[t.color].main, 0.16)}`,
    "@media (hover: none)": {
      boxShadow: "none"
    }
  },
  [`&.${sliderClasses$1.active}`]: {
    boxShadow: `0px 0px 0px 14px ${e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.16)` : alpha_1(e.palette[t.color].main, 0.16)}`
  },
  [`&.${sliderClasses$1.disabled}`]: {
    "&:hover": {
      boxShadow: "none"
    }
  }
})), SliderValueLabel = E(SliderValueLabel$1, {
  name: "MuiSlider",
  slot: "ValueLabel",
  overridesResolver: (e, t) => t.valueLabel
})(({
  theme: e,
  ownerState: t
}) => _extends$5({
  [`&.${sliderClasses$1.valueLabelOpen}`]: {
    transform: `${t.orientation === "vertical" ? "translateY(-50%)" : "translateY(-100%)"} scale(1)`
  },
  zIndex: 1,
  whiteSpace: "nowrap"
}, e.typography.body2, {
  fontWeight: 500,
  transition: e.transitions.create(["transform"], {
    duration: e.transitions.duration.shortest
  }),
  transform: `${t.orientation === "vertical" ? "translateY(-50%)" : "translateY(-100%)"} scale(0)`,
  position: "absolute",
  backgroundColor: (e.vars || e).palette.grey[600],
  borderRadius: 2,
  color: (e.vars || e).palette.common.white,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "0.25rem 0.75rem"
}, t.orientation === "horizontal" && {
  top: "-10px",
  transformOrigin: "bottom center",
  "&::before": {
    position: "absolute",
    content: '""',
    width: 8,
    height: 8,
    transform: "translate(-50%, 50%) rotate(45deg)",
    backgroundColor: "inherit",
    bottom: 0,
    left: "50%"
  }
}, t.orientation === "vertical" && {
  right: t.size === "small" ? "20px" : "30px",
  top: "50%",
  transformOrigin: "right center",
  "&::before": {
    position: "absolute",
    content: '""',
    width: 8,
    height: 8,
    transform: "translate(-50%, -50%) rotate(45deg)",
    backgroundColor: "inherit",
    right: -8,
    top: "50%"
  }
}, t.size === "small" && {
  fontSize: e.typography.pxToRem(12),
  padding: "0.25rem 0.5rem"
})), SliderMark = E("span", {
  name: "MuiSlider",
  slot: "Mark",
  shouldForwardProp: (e) => slotShouldForwardProp(e) && e !== "markActive",
  overridesResolver: (e, t) => {
    const {
      markActive: n
    } = e;
    return [t.mark, n && t.markActive];
  }
})(({
  theme: e,
  ownerState: t,
  markActive: n
}) => _extends$5({
  position: "absolute",
  width: 2,
  height: 2,
  borderRadius: 1,
  backgroundColor: "currentColor"
}, t.orientation === "horizontal" && {
  top: "50%",
  transform: "translate(-1px, -50%)"
}, t.orientation === "vertical" && {
  left: "50%",
  transform: "translate(-50%, 1px)"
}, n && {
  backgroundColor: (e.vars || e).palette.background.paper,
  opacity: 0.8
})), SliderMarkLabel = E("span", {
  name: "MuiSlider",
  slot: "MarkLabel",
  shouldForwardProp: (e) => slotShouldForwardProp(e) && e !== "markLabelActive",
  overridesResolver: (e, t) => t.markLabel
})(({
  theme: e,
  ownerState: t,
  markLabelActive: n
}) => _extends$5({}, e.typography.body2, {
  color: (e.vars || e).palette.text.secondary,
  position: "absolute",
  whiteSpace: "nowrap"
}, t.orientation === "horizontal" && {
  top: 30,
  transform: "translateX(-50%)",
  "@media (pointer: coarse)": {
    top: 40
  }
}, t.orientation === "vertical" && {
  left: 36,
  transform: "translateY(50%)",
  "@media (pointer: coarse)": {
    left: 44
  }
}, n && {
  color: (e.vars || e).palette.text.primary
})), useUtilityClasses$2 = (e) => {
  const {
    disabled: t,
    dragging: n,
    marked: o,
    orientation: s,
    track: l,
    classes: c,
    color: p,
    size: m
  } = e, C = {
    root: ["root", t && "disabled", n && "dragging", o && "marked", s === "vertical" && "vertical", l === "inverted" && "trackInverted", l === !1 && "trackFalse", p && `color${capitalize$1(p)}`, m && `size${capitalize$1(m)}`],
    rail: ["rail"],
    track: ["track"],
    mark: ["mark"],
    markActive: ["markActive"],
    markLabel: ["markLabel"],
    markLabelActive: ["markLabelActive"],
    valueLabel: ["valueLabel"],
    thumb: ["thumb", t && "disabled", m && `thumbSize${capitalize$1(m)}`, p && `thumbColor${capitalize$1(p)}`],
    active: ["active"],
    disabled: ["disabled"],
    focusVisible: ["focusVisible"]
  };
  return composeClasses(C, getSliderUtilityClass, c);
}, Forward = ({
  children: e
}) => e, Slider = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  var o, s, l, c, p, m, C, P, w, R, L, M, $, W, H, V, N, B, K, ue, de, ve, Te, Pe;
  const Ce = useThemeProps({
    props: t,
    name: "MuiSlider"
  }), ke = useTheme$1().direction === "rtl", {
    "aria-label": Ae,
    "aria-valuetext": we,
    "aria-labelledby": he,
    // eslint-disable-next-line react/prop-types
    component: be = "span",
    components: le = {},
    componentsProps: fe = {},
    color: ye = "primary",
    classes: Ee,
    className: Ie,
    disableSwap: Fe = !1,
    disabled: De = !1,
    getAriaLabel: Ve,
    getAriaValueText: Oe,
    marks: Ze = !1,
    max: et = 100,
    min: bt = 0,
    orientation: rr = "horizontal",
    shiftStep: St = 10,
    size: Qe = "medium",
    step: xt = 1,
    scale: je = Identity,
    slotProps: kt,
    slots: cr,
    track: Tr = "normal",
    valueLabelDisplay: Er = "off",
    valueLabelFormat: Hr = Identity
  } = Ce, Br = _objectWithoutPropertiesLoose$3(Ce, _excluded$5), hr = _extends$5({}, Ce, {
    isRtl: ke,
    max: et,
    min: bt,
    classes: Ee,
    disabled: De,
    disableSwap: Fe,
    orientation: rr,
    marks: Ze,
    color: ye,
    size: Qe,
    step: xt,
    shiftStep: St,
    scale: je,
    track: Tr,
    valueLabelDisplay: Er,
    valueLabelFormat: Hr
  }), {
    axisProps: Gr,
    getRootProps: Yr,
    getHiddenInputProps: tt,
    getThumbProps: ar,
    open: wr,
    active: Sr,
    axis: Ye,
    focusedThumbIndex: Je,
    range: tr,
    dragging: pt,
    marks: ir,
    values: nr,
    trackOffset: er,
    trackLeap: pr,
    getThumbStyle: kr
  } = useSlider(_extends$5({}, hr, {
    rootRef: n
  }));
  hr.marked = ir.length > 0 && ir.some((Ir) => Ir.label), hr.dragging = pt, hr.focusedThumbIndex = Je;
  const Nr = useUtilityClasses$2(hr), hn = (o = (s = cr == null ? void 0 : cr.root) != null ? s : le.Root) != null ? o : SliderRoot, fn = (l = (c = cr == null ? void 0 : cr.rail) != null ? c : le.Rail) != null ? l : SliderRail, uo = (p = (m = cr == null ? void 0 : cr.track) != null ? m : le.Track) != null ? p : SliderTrack, mn = (C = (P = cr == null ? void 0 : cr.thumb) != null ? P : le.Thumb) != null ? C : SliderThumb, vn = (w = (R = cr == null ? void 0 : cr.valueLabel) != null ? R : le.ValueLabel) != null ? w : SliderValueLabel, mi = (L = (M = cr == null ? void 0 : cr.mark) != null ? M : le.Mark) != null ? L : SliderMark, Jo = ($ = (W = cr == null ? void 0 : cr.markLabel) != null ? W : le.MarkLabel) != null ? $ : SliderMarkLabel, $i = (H = (V = cr == null ? void 0 : cr.input) != null ? V : le.Input) != null ? H : "input", Ji = (N = kt == null ? void 0 : kt.root) != null ? N : fe.root, Zs = (B = kt == null ? void 0 : kt.rail) != null ? B : fe.rail, yi = (K = kt == null ? void 0 : kt.track) != null ? K : fe.track, Zo = (ue = kt == null ? void 0 : kt.thumb) != null ? ue : fe.thumb, gi = (de = kt == null ? void 0 : kt.valueLabel) != null ? de : fe.valueLabel, ei = (ve = kt == null ? void 0 : kt.mark) != null ? ve : fe.mark, Ao = (Te = kt == null ? void 0 : kt.markLabel) != null ? Te : fe.markLabel, Fn = (Pe = kt == null ? void 0 : kt.input) != null ? Pe : fe.input, Gn = useSlotProps({
    elementType: hn,
    getSlotProps: Yr,
    externalSlotProps: Ji,
    externalForwardedProps: Br,
    additionalProps: _extends$5({}, shouldSpreadAdditionalProps$1(hn) && {
      as: be
    }),
    ownerState: _extends$5({}, hr, Ji == null ? void 0 : Ji.ownerState),
    className: [Nr.root, Ie]
  }), Bo = useSlotProps({
    elementType: fn,
    externalSlotProps: Zs,
    ownerState: hr,
    className: Nr.rail
  }), $o = useSlotProps({
    elementType: uo,
    externalSlotProps: yi,
    additionalProps: {
      style: _extends$5({}, Gr[Ye].offset(er), Gr[Ye].leap(pr))
    },
    ownerState: _extends$5({}, hr, yi == null ? void 0 : yi.ownerState),
    className: Nr.track
  }), Me = useSlotProps({
    elementType: mn,
    getSlotProps: ar,
    externalSlotProps: Zo,
    ownerState: _extends$5({}, hr, Zo == null ? void 0 : Zo.ownerState),
    className: Nr.thumb
  }), wt = useSlotProps({
    elementType: vn,
    externalSlotProps: gi,
    ownerState: _extends$5({}, hr, gi == null ? void 0 : gi.ownerState),
    className: Nr.valueLabel
  }), ur = useSlotProps({
    elementType: mi,
    externalSlotProps: ei,
    ownerState: hr,
    className: Nr.mark
  }), jr = useSlotProps({
    elementType: Jo,
    externalSlotProps: Ao,
    ownerState: hr,
    className: Nr.markLabel
  }), Qr = useSlotProps({
    elementType: $i,
    getSlotProps: tt,
    externalSlotProps: Fn,
    ownerState: hr
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(hn, _extends$5({}, Gn, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(fn, _extends$5({}, Bo)), /* @__PURE__ */ jsxRuntimeExports.jsx(uo, _extends$5({}, $o)), ir.filter((Ir) => Ir.value >= bt && Ir.value <= et).map((Ir, $r) => {
      const Dr = valueToPercent(Ir.value, bt, et), An = Gr[Ye].offset(Dr);
      let mr;
      return Tr === !1 ? mr = nr.indexOf(Ir.value) !== -1 : mr = Tr === "normal" && (tr ? Ir.value >= nr[0] && Ir.value <= nr[nr.length - 1] : Ir.value <= nr[0]) || Tr === "inverted" && (tr ? Ir.value <= nr[0] || Ir.value >= nr[nr.length - 1] : Ir.value >= nr[0]), /* @__PURE__ */ jsxRuntimeExports.jsxs(React$2.Fragment, {
        children: [/* @__PURE__ */ jsxRuntimeExports.jsx(mi, _extends$5({
          "data-index": $r
        }, ur, !isHostComponent(mi) && {
          markActive: mr
        }, {
          style: _extends$5({}, An, ur.style),
          className: clsx$1(ur.className, mr && Nr.markActive)
        })), Ir.label != null ? /* @__PURE__ */ jsxRuntimeExports.jsx(Jo, _extends$5({
          "aria-hidden": !0,
          "data-index": $r
        }, jr, !isHostComponent(Jo) && {
          markLabelActive: mr
        }, {
          style: _extends$5({}, An, jr.style),
          className: clsx$1(Nr.markLabel, jr.className, mr && Nr.markLabelActive),
          children: Ir.label
        })) : null]
      }, $r);
    }), nr.map((Ir, $r) => {
      const Dr = valueToPercent(Ir, bt, et), An = Gr[Ye].offset(Dr), mr = Er === "off" ? Forward : vn;
      return (
        /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */
        /* @__PURE__ */ jsxRuntimeExports.jsx(mr, _extends$5({}, !isHostComponent(mr) && {
          valueLabelFormat: Hr,
          valueLabelDisplay: Er,
          value: typeof Hr == "function" ? Hr(je(Ir), $r) : Hr,
          index: $r,
          open: wr === $r || Sr === $r || Er === "on",
          disabled: De
        }, wt, {
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(mn, _extends$5({
            "data-index": $r
          }, Me, {
            className: clsx$1(Nr.thumb, Me.className, Sr === $r && Nr.active, Je === $r && Nr.focusVisible),
            style: _extends$5({}, An, kr($r), Me.style),
            children: /* @__PURE__ */ jsxRuntimeExports.jsx($i, _extends$5({
              "data-index": $r,
              "aria-label": Ve ? Ve($r) : Ae,
              "aria-valuenow": je(Ir),
              "aria-labelledby": he,
              "aria-valuetext": Oe ? Oe(je(Ir), $r) : we,
              value: nr[$r]
            }, Qr))
          }))
        }), $r)
      );
    })]
  }));
});
process.env.NODE_ENV !== "production" && (Slider.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The label of the slider.
   */
  "aria-label": chainPropTypes(PropTypes.string, (e) => Array.isArray(e.value || e.defaultValue) && e["aria-label"] != null ? new Error("MUI: You need to use the `getAriaLabel` prop instead of `aria-label` when using a range slider.") : null),
  /**
   * The id of the element containing a label for the slider.
   */
  "aria-labelledby": PropTypes.string,
  /**
   * A string value that provides a user-friendly name for the current value of the slider.
   */
  "aria-valuetext": chainPropTypes(PropTypes.string, (e) => Array.isArray(e.value || e.defaultValue) && e["aria-valuetext"] != null ? new Error("MUI: You need to use the `getAriaValueText` prop instead of `aria-valuetext` when using a range slider.") : null),
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Mark: PropTypes.elementType,
    MarkLabel: PropTypes.elementType,
    Rail: PropTypes.elementType,
    Root: PropTypes.elementType,
    Thumb: PropTypes.elementType,
    Track: PropTypes.elementType,
    ValueLabel: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    input: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    mark: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    markLabel: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    rail: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    thumb: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    track: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    valueLabel: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
      children: PropTypes.element,
      className: PropTypes.string,
      open: PropTypes.bool,
      style: PropTypes.object,
      value: PropTypes.number,
      valueLabelDisplay: PropTypes.oneOf(["auto", "off", "on"])
    })])
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.number]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the active thumb doesn't swap when moving pointer over a thumb while dragging another thumb.
   * @default false
   */
  disableSwap: PropTypes.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the thumb labels of the slider.
   * This is important for screen reader users.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaLabel: PropTypes.func,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the slider.
   * This is important for screen reader users.
   * @param {number} value The thumb label's value to format.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaValueText: PropTypes.func,
  /**
   * Marks indicate predetermined values to which the user can move the slider.
   * If `true` the marks are spaced according the value of the `step` prop.
   * If an array, it should contain objects with `value` and an optional `label` keys.
   * @default false
   */
  marks: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.node,
    value: PropTypes.number.isRequired
  })), PropTypes.bool]),
  /**
   * The maximum allowed value of the slider.
   * Should not be equal to min.
   * @default 100
   */
  max: PropTypes.number,
  /**
   * The minimum allowed value of the slider.
   * Should not be equal to max.
   * @default 0
   */
  min: PropTypes.number,
  /**
   * Name attribute of the hidden `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback function that is fired when the slider's value changed.
   *
   * @param {Event} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   * @param {number} activeThumb Index of the currently moved thumb.
   */
  onChange: PropTypes.func,
  /**
   * Callback function that is fired when the `mouseup` is triggered.
   *
   * @param {React.SyntheticEvent | Event} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   */
  onChangeCommitted: PropTypes.func,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  /**
   * A transformation function, to change the scale of the slider.
   * @param {any} x
   * @returns {any}
   * @default function Identity(x) {
   *   return x;
   * }
   */
  scale: PropTypes.func,
  /**
   * The granularity with which the slider can step through values when using Page Up/Page Down or Shift + Arrow Up/Arrow Down.
   * @default 10
   */
  shiftStep: PropTypes.number,
  /**
   * The size of the slider.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["small", "medium"]), PropTypes.string]),
  /**
   * The props used for each slot inside the Slider.
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    mark: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    markLabel: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    rail: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    thumb: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    track: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    valueLabel: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
      children: PropTypes.element,
      className: PropTypes.string,
      open: PropTypes.bool,
      style: PropTypes.object,
      value: PropTypes.number,
      valueLabelDisplay: PropTypes.oneOf(["auto", "off", "on"])
    })])
  }),
  /**
   * The components used for each slot inside the Slider.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    mark: PropTypes.elementType,
    markLabel: PropTypes.elementType,
    rail: PropTypes.elementType,
    root: PropTypes.elementType,
    thumb: PropTypes.elementType,
    track: PropTypes.elementType,
    valueLabel: PropTypes.elementType
  }),
  /**
   * The granularity with which the slider can step through values. (A "discrete" slider.)
   * The `min` prop serves as the origin for the valid values.
   * We recommend (max - min) to be evenly divisible by the step.
   *
   * When step is `null`, the thumb can only be slid onto marks provided with the `marks` prop.
   * @default 1
   */
  step: PropTypes.number,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Tab index attribute of the hidden `input` element.
   */
  tabIndex: PropTypes.number,
  /**
   * The track presentation:
   *
   * - `normal` the track will render a bar representing the slider value.
   * - `inverted` the track will render a bar representing the remaining slider value.
   * - `false` the track will render without a bar.
   * @default 'normal'
   */
  track: PropTypes.oneOf(["inverted", "normal", !1]),
  /**
   * The value of the slider.
   * For ranged sliders, provide an array with two values.
   */
  value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.number]),
  /**
   * Controls when the value label is displayed:
   *
   * - `auto` the value label will display when the thumb is hovered or focused.
   * - `on` will display persistently.
   * - `off` will never display.
   * @default 'off'
   */
  valueLabelDisplay: PropTypes.oneOf(["auto", "off", "on"]),
  /**
   * The format function the value label's value.
   *
   * When a function is provided, it should have the following signature:
   *
   * - {number} value The value label's value to format
   * - {number} index The value label's index to format
   * @param {any} x
   * @returns {any}
   * @default function Identity(x) {
   *   return x;
   * }
   */
  valueLabelFormat: PropTypes.oneOfType([PropTypes.func, PropTypes.string])
});
const dt = Slider;
function getTooltipUtilityClass(e) {
  return generateUtilityClass$1("MuiTooltip", e);
}
const tooltipClasses = generateUtilityClasses$1("MuiTooltip", ["popper", "popperInteractive", "popperArrow", "popperClose", "tooltip", "tooltipArrow", "touch", "tooltipPlacementLeft", "tooltipPlacementRight", "tooltipPlacementTop", "tooltipPlacementBottom", "arrow"]), tooltipClasses$1 = tooltipClasses, _excluded$4 = ["arrow", "children", "classes", "components", "componentsProps", "describeChild", "disableFocusListener", "disableHoverListener", "disableInteractive", "disableTouchListener", "enterDelay", "enterNextDelay", "enterTouchDelay", "followCursor", "id", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperComponent", "PopperProps", "slotProps", "slots", "title", "TransitionComponent", "TransitionProps"];
function round$1(e) {
  return Math.round(e * 1e5) / 1e5;
}
const useUtilityClasses$1 = (e) => {
  const {
    classes: t,
    disableInteractive: n,
    arrow: o,
    touch: s,
    placement: l
  } = e, c = {
    popper: ["popper", !n && "popperInteractive", o && "popperArrow"],
    tooltip: ["tooltip", o && "tooltipArrow", s && "touch", `tooltipPlacement${capitalize$1(l.split("-")[0])}`],
    arrow: ["arrow"]
  };
  return composeClasses(c, getTooltipUtilityClass, t);
}, TooltipPopper = E(Popper$1, {
  name: "MuiTooltip",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.popper, !n.disableInteractive && t.popperInteractive, n.arrow && t.popperArrow, !n.open && t.popperClose];
  }
})(({
  theme: e,
  ownerState: t,
  open: n
}) => _extends$5({
  zIndex: (e.vars || e).zIndex.tooltip,
  pointerEvents: "none"
}, !t.disableInteractive && {
  pointerEvents: "auto"
}, !n && {
  pointerEvents: "none"
}, t.arrow && {
  [`&[data-popper-placement*="bottom"] .${tooltipClasses$1.arrow}`]: {
    top: 0,
    marginTop: "-0.71em",
    "&::before": {
      transformOrigin: "0 100%"
    }
  },
  [`&[data-popper-placement*="top"] .${tooltipClasses$1.arrow}`]: {
    bottom: 0,
    marginBottom: "-0.71em",
    "&::before": {
      transformOrigin: "100% 0"
    }
  },
  [`&[data-popper-placement*="right"] .${tooltipClasses$1.arrow}`]: _extends$5({}, t.isRtl ? {
    right: 0,
    marginRight: "-0.71em"
  } : {
    left: 0,
    marginLeft: "-0.71em"
  }, {
    height: "1em",
    width: "0.71em",
    "&::before": {
      transformOrigin: "100% 100%"
    }
  }),
  [`&[data-popper-placement*="left"] .${tooltipClasses$1.arrow}`]: _extends$5({}, t.isRtl ? {
    left: 0,
    marginLeft: "-0.71em"
  } : {
    right: 0,
    marginRight: "-0.71em"
  }, {
    height: "1em",
    width: "0.71em",
    "&::before": {
      transformOrigin: "0 0"
    }
  })
})), TooltipTooltip = E("div", {
  name: "MuiTooltip",
  slot: "Tooltip",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.tooltip, n.touch && t.touch, n.arrow && t.tooltipArrow, t[`tooltipPlacement${capitalize$1(n.placement.split("-")[0])}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => _extends$5({
  backgroundColor: e.vars ? e.vars.palette.Tooltip.bg : alpha_1(e.palette.grey[700], 0.92),
  borderRadius: (e.vars || e).shape.borderRadius,
  color: (e.vars || e).palette.common.white,
  fontFamily: e.typography.fontFamily,
  padding: "4px 8px",
  fontSize: e.typography.pxToRem(11),
  maxWidth: 300,
  margin: 2,
  wordWrap: "break-word",
  fontWeight: e.typography.fontWeightMedium
}, t.arrow && {
  position: "relative",
  margin: 0
}, t.touch && {
  padding: "8px 16px",
  fontSize: e.typography.pxToRem(14),
  lineHeight: `${round$1(16 / 14)}em`,
  fontWeight: e.typography.fontWeightRegular
}, {
  [`.${tooltipClasses$1.popper}[data-popper-placement*="left"] &`]: _extends$5({
    transformOrigin: "right center"
  }, t.isRtl ? _extends$5({
    marginLeft: "14px"
  }, t.touch && {
    marginLeft: "24px"
  }) : _extends$5({
    marginRight: "14px"
  }, t.touch && {
    marginRight: "24px"
  })),
  [`.${tooltipClasses$1.popper}[data-popper-placement*="right"] &`]: _extends$5({
    transformOrigin: "left center"
  }, t.isRtl ? _extends$5({
    marginRight: "14px"
  }, t.touch && {
    marginRight: "24px"
  }) : _extends$5({
    marginLeft: "14px"
  }, t.touch && {
    marginLeft: "24px"
  })),
  [`.${tooltipClasses$1.popper}[data-popper-placement*="top"] &`]: _extends$5({
    transformOrigin: "center bottom",
    marginBottom: "14px"
  }, t.touch && {
    marginBottom: "24px"
  }),
  [`.${tooltipClasses$1.popper}[data-popper-placement*="bottom"] &`]: _extends$5({
    transformOrigin: "center top",
    marginTop: "14px"
  }, t.touch && {
    marginTop: "24px"
  })
})), TooltipArrow = E("span", {
  name: "MuiTooltip",
  slot: "Arrow",
  overridesResolver: (e, t) => t.arrow
})(({
  theme: e
}) => ({
  overflow: "hidden",
  position: "absolute",
  width: "1em",
  height: "0.71em",
  boxSizing: "border-box",
  color: e.vars ? e.vars.palette.Tooltip.bg : alpha_1(e.palette.grey[700], 0.9),
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: "currentColor",
    transform: "rotate(45deg)"
  }
}));
let hystersisOpen = !1;
const hystersisTimer = new Timeout();
let cursorPosition = {
  x: 0,
  y: 0
};
function composeEventHandler(e, t) {
  return (n) => {
    t && t(n), e(n);
  };
}
const Tooltip = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  var o, s, l, c, p, m, C, P, w, R, L, M, $, W, H, V, N, B, K;
  const ue = useThemeProps({
    props: t,
    name: "MuiTooltip"
  }), {
    arrow: de = !1,
    children: ve,
    components: Te = {},
    componentsProps: Pe = {},
    describeChild: Ce = !1,
    disableFocusListener: Re = !1,
    disableHoverListener: ke = !1,
    disableInteractive: Ae = !1,
    disableTouchListener: we = !1,
    enterDelay: he = 100,
    enterNextDelay: be = 0,
    enterTouchDelay: le = 700,
    followCursor: fe = !1,
    id: ye,
    leaveDelay: Ee = 0,
    leaveTouchDelay: Ie = 1500,
    onClose: Fe,
    onOpen: De,
    open: Ve,
    placement: Oe = "bottom",
    PopperComponent: Ze,
    PopperProps: et = {},
    slotProps: bt = {},
    slots: rr = {},
    title: St,
    TransitionComponent: Qe = Grow$1,
    TransitionProps: xt
  } = ue, je = _objectWithoutPropertiesLoose$3(ue, _excluded$4), kt = /* @__PURE__ */ React$2.isValidElement(ve) ? ve : /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
    children: ve
  }), cr = useTheme$1(), Tr = cr.direction === "rtl", [Er, Hr] = React$2.useState(), [Br, hr] = React$2.useState(null), Gr = React$2.useRef(!1), Yr = Ae || fe, tt = useTimeout(), ar = useTimeout(), wr = useTimeout(), Sr = useTimeout(), [Ye, Je] = useControlled({
    controlled: Ve,
    default: !1,
    name: "Tooltip",
    state: "open"
  });
  let tr = Ye;
  if (process.env.NODE_ENV !== "production") {
    const {
      current: mr
    } = React$2.useRef(Ve !== void 0);
    React$2.useEffect(() => {
      Er && Er.disabled && !mr && St !== "" && Er.tagName.toLowerCase() === "button" && console.error(["MUI: You are providing a disabled `button` child to the Tooltip component.", "A disabled element does not fire events.", "Tooltip needs to listen to the child element's events to display the title.", "", "Add a simple wrapper element, such as a `span`."].join(`
`));
    }, [St, Er, mr]);
  }
  const pt = useId(ye), ir = React$2.useRef(), nr = useEventCallback(() => {
    ir.current !== void 0 && (document.body.style.WebkitUserSelect = ir.current, ir.current = void 0), Sr.clear();
  });
  React$2.useEffect(() => nr, [nr]);
  const er = (mr) => {
    hystersisTimer.clear(), hystersisOpen = !0, Je(!0), De && !tr && De(mr);
  }, pr = useEventCallback(
    /**
     * @param {React.SyntheticEvent | Event} event
     */
    (mr) => {
      hystersisTimer.start(800 + Ee, () => {
        hystersisOpen = !1;
      }), Je(!1), Fe && tr && Fe(mr), tt.start(cr.transitions.duration.shortest, () => {
        Gr.current = !1;
      });
    }
  ), kr = (mr) => {
    Gr.current && mr.type !== "touchstart" || (Er && Er.removeAttribute("title"), ar.clear(), wr.clear(), he || hystersisOpen && be ? ar.start(hystersisOpen ? be : he, () => {
      er(mr);
    }) : er(mr));
  }, Nr = (mr) => {
    ar.clear(), wr.start(Ee, () => {
      pr(mr);
    });
  }, {
    isFocusVisibleRef: hn,
    onBlur: fn,
    onFocus: uo,
    ref: mn
  } = useIsFocusVisible(), [, vn] = React$2.useState(!1), mi = (mr) => {
    fn(mr), hn.current === !1 && (vn(!1), Nr(mr));
  }, Jo = (mr) => {
    Er || Hr(mr.currentTarget), uo(mr), hn.current === !0 && (vn(!0), kr(mr));
  }, $i = (mr) => {
    Gr.current = !0;
    const on = kt.props;
    on.onTouchStart && on.onTouchStart(mr);
  }, Ji = (mr) => {
    $i(mr), wr.clear(), tt.clear(), nr(), ir.current = document.body.style.WebkitUserSelect, document.body.style.WebkitUserSelect = "none", Sr.start(le, () => {
      document.body.style.WebkitUserSelect = ir.current, kr(mr);
    });
  }, Zs = (mr) => {
    kt.props.onTouchEnd && kt.props.onTouchEnd(mr), nr(), wr.start(Ie, () => {
      pr(mr);
    });
  };
  React$2.useEffect(() => {
    if (!tr)
      return;
    function mr(on) {
      (on.key === "Escape" || on.key === "Esc") && pr(on);
    }
    return document.addEventListener("keydown", mr), () => {
      document.removeEventListener("keydown", mr);
    };
  }, [pr, tr]);
  const yi = useForkRef(kt.ref, mn, Hr, n);
  !St && St !== 0 && (tr = !1);
  const Zo = React$2.useRef(), gi = (mr) => {
    const on = kt.props;
    on.onMouseMove && on.onMouseMove(mr), cursorPosition = {
      x: mr.clientX,
      y: mr.clientY
    }, Zo.current && Zo.current.update();
  }, ei = {}, Ao = typeof St == "string";
  Ce ? (ei.title = !tr && Ao && !ke ? St : null, ei["aria-describedby"] = tr ? pt : null) : (ei["aria-label"] = Ao ? St : null, ei["aria-labelledby"] = tr && !Ao ? pt : null);
  const Fn = _extends$5({}, ei, je, kt.props, {
    className: clsx$1(je.className, kt.props.className),
    onTouchStart: $i,
    ref: yi
  }, fe ? {
    onMouseMove: gi
  } : {});
  process.env.NODE_ENV !== "production" && (Fn["data-mui-internal-clone-element"] = !0, React$2.useEffect(() => {
    Er && !Er.getAttribute("data-mui-internal-clone-element") && console.error(["MUI: The `children` component of the Tooltip is not forwarding its props correctly.", "Please make sure that props are spread on the same element that the ref is applied to."].join(`
`));
  }, [Er]));
  const Gn = {};
  we || (Fn.onTouchStart = Ji, Fn.onTouchEnd = Zs), ke || (Fn.onMouseOver = composeEventHandler(kr, Fn.onMouseOver), Fn.onMouseLeave = composeEventHandler(Nr, Fn.onMouseLeave), Yr || (Gn.onMouseOver = kr, Gn.onMouseLeave = Nr)), Re || (Fn.onFocus = composeEventHandler(Jo, Fn.onFocus), Fn.onBlur = composeEventHandler(mi, Fn.onBlur), Yr || (Gn.onFocus = Jo, Gn.onBlur = mi)), process.env.NODE_ENV !== "production" && kt.props.title && console.error(["MUI: You have provided a `title` prop to the child of <Tooltip />.", `Remove this title prop \`${kt.props.title}\` or the Tooltip component.`].join(`
`));
  const Bo = React$2.useMemo(() => {
    var mr;
    let on = [{
      name: "arrow",
      enabled: !!Br,
      options: {
        element: Br,
        padding: 4
      }
    }];
    return (mr = et.popperOptions) != null && mr.modifiers && (on = on.concat(et.popperOptions.modifiers)), _extends$5({}, et.popperOptions, {
      modifiers: on
    });
  }, [Br, et]), $o = _extends$5({}, ue, {
    isRtl: Tr,
    arrow: de,
    disableInteractive: Yr,
    placement: Oe,
    PopperComponentProp: Ze,
    touch: Gr.current
  }), Me = useUtilityClasses$1($o), wt = (o = (s = rr.popper) != null ? s : Te.Popper) != null ? o : TooltipPopper, ur = (l = (c = (p = rr.transition) != null ? p : Te.Transition) != null ? c : Qe) != null ? l : Grow$1, jr = (m = (C = rr.tooltip) != null ? C : Te.Tooltip) != null ? m : TooltipTooltip, Qr = (P = (w = rr.arrow) != null ? w : Te.Arrow) != null ? P : TooltipArrow, Ir = appendOwnerState(wt, _extends$5({}, et, (R = bt.popper) != null ? R : Pe.popper, {
    className: clsx$1(Me.popper, et == null ? void 0 : et.className, (L = (M = bt.popper) != null ? M : Pe.popper) == null ? void 0 : L.className)
  }), $o), $r = appendOwnerState(ur, _extends$5({}, xt, ($ = bt.transition) != null ? $ : Pe.transition), $o), Dr = appendOwnerState(jr, _extends$5({}, (W = bt.tooltip) != null ? W : Pe.tooltip, {
    className: clsx$1(Me.tooltip, (H = (V = bt.tooltip) != null ? V : Pe.tooltip) == null ? void 0 : H.className)
  }), $o), An = appendOwnerState(Qr, _extends$5({}, (N = bt.arrow) != null ? N : Pe.arrow, {
    className: clsx$1(Me.arrow, (B = (K = bt.arrow) != null ? K : Pe.arrow) == null ? void 0 : B.className)
  }), $o);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React$2.Fragment, {
    children: [/* @__PURE__ */ React$2.cloneElement(kt, Fn), /* @__PURE__ */ jsxRuntimeExports.jsx(wt, _extends$5({
      as: Ze ?? Popper$1,
      placement: Oe,
      anchorEl: fe ? {
        getBoundingClientRect: () => ({
          top: cursorPosition.y,
          left: cursorPosition.x,
          right: cursorPosition.x,
          bottom: cursorPosition.y,
          width: 0,
          height: 0
        })
      } : Er,
      popperRef: Zo,
      open: Er ? tr : !1,
      id: pt,
      transition: !0
    }, Gn, Ir, {
      popperOptions: Bo,
      children: ({
        TransitionProps: mr
      }) => /* @__PURE__ */ jsxRuntimeExports.jsx(ur, _extends$5({
        timeout: cr.transitions.duration.shorter
      }, mr, $r, {
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(jr, _extends$5({}, Dr, {
          children: [St, de ? /* @__PURE__ */ jsxRuntimeExports.jsx(Qr, _extends$5({}, An, {
            ref: hr
          })) : null]
        }))
      }))
    }))]
  });
});
process.env.NODE_ENV !== "production" && (Tooltip.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, adds an arrow to the tooltip.
   * @default false
   */
  arrow: PropTypes.bool,
  /**
   * Tooltip reference element.
   */
  children: elementAcceptingRef$1.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Arrow: PropTypes.elementType,
    Popper: PropTypes.elementType,
    Tooltip: PropTypes.elementType,
    Transition: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    arrow: PropTypes.object,
    popper: PropTypes.object,
    tooltip: PropTypes.object,
    transition: PropTypes.object
  }),
  /**
   * Set to `true` if the `title` acts as an accessible description.
   * By default the `title` acts as an accessible label for the child.
   * @default false
   */
  describeChild: PropTypes.bool,
  /**
   * Do not respond to focus-visible events.
   * @default false
   */
  disableFocusListener: PropTypes.bool,
  /**
   * Do not respond to hover events.
   * @default false
   */
  disableHoverListener: PropTypes.bool,
  /**
   * Makes a tooltip not interactive, i.e. it will close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   * @default false
   */
  disableInteractive: PropTypes.bool,
  /**
   * Do not respond to long press touch events.
   * @default false
   */
  disableTouchListener: PropTypes.bool,
  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   * @default 100
   */
  enterDelay: PropTypes.number,
  /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   * @default 0
   */
  enterNextDelay: PropTypes.number,
  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   * @default 700
   */
  enterTouchDelay: PropTypes.number,
  /**
   * If `true`, the tooltip follow the cursor over the wrapped element.
   * @default false
   */
  followCursor: PropTypes.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: PropTypes.string,
  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   * @default 0
   */
  leaveDelay: PropTypes.number,
  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   * @default 1500
   */
  leaveTouchDelay: PropTypes.number,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: PropTypes.func,
  /**
   * Callback fired when the component requests to be open.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool,
  /**
   * Tooltip placement.
   * @default 'bottom'
   */
  placement: PropTypes.oneOf(["bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * The component used for the popper.
   * @default Popper
   */
  PopperComponent: PropTypes.elementType,
  /**
   * Props applied to the [`Popper`](/material-ui/api/popper/) element.
   * @default {}
   */
  PopperProps: PropTypes.object,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    arrow: PropTypes.object,
    popper: PropTypes.object,
    tooltip: PropTypes.object,
    transition: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    arrow: PropTypes.elementType,
    popper: PropTypes.elementType,
    tooltip: PropTypes.elementType,
    transition: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
   */
  title: PropTypes.node,
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: PropTypes.object
});
const Tooltip$1 = Tooltip;
function getTextFieldUtilityClass(e) {
  return generateUtilityClass$1("MuiTextField", e);
}
generateUtilityClasses$1("MuiTextField", ["root"]);
const _excluded$3 = ["autoComplete", "autoFocus", "children", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "select", "SelectProps", "type", "value", "variant"], variantComponent = {
  standard: Input$1,
  filled: FilledInput$1,
  outlined: OutlinedInput$1
}, useUtilityClasses = (e) => {
  const {
    classes: t
  } = e;
  return composeClasses({
    root: ["root"]
  }, getTextFieldUtilityClass, t);
}, TextFieldRoot = E(FormControl$1, {
  name: "MuiTextField",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), TextField = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  const o = useThemeProps({
    props: t,
    name: "MuiTextField"
  }), {
    autoComplete: s,
    autoFocus: l = !1,
    children: c,
    className: p,
    color: m = "primary",
    defaultValue: C,
    disabled: P = !1,
    error: w = !1,
    FormHelperTextProps: R,
    fullWidth: L = !1,
    helperText: M,
    id: $,
    InputLabelProps: W,
    inputProps: H,
    InputProps: V,
    inputRef: N,
    label: B,
    maxRows: K,
    minRows: ue,
    multiline: de = !1,
    name: ve,
    onBlur: Te,
    onChange: Pe,
    onFocus: Ce,
    placeholder: Re,
    required: ke = !1,
    rows: Ae,
    select: we = !1,
    SelectProps: he,
    type: be,
    value: le,
    variant: fe = "outlined"
  } = o, ye = _objectWithoutPropertiesLoose$3(o, _excluded$3), Ee = _extends$5({}, o, {
    autoFocus: l,
    color: m,
    disabled: P,
    error: w,
    fullWidth: L,
    multiline: de,
    required: ke,
    select: we,
    variant: fe
  }), Ie = useUtilityClasses(Ee);
  process.env.NODE_ENV !== "production" && we && !c && console.error("MUI: `children` must be passed when using the `TextField` component with `select`.");
  const Fe = {};
  fe === "outlined" && (W && typeof W.shrink < "u" && (Fe.notched = W.shrink), Fe.label = B), we && ((!he || !he.native) && (Fe.id = void 0), Fe["aria-describedby"] = void 0);
  const De = useId($), Ve = M && De ? `${De}-helper-text` : void 0, Oe = B && De ? `${De}-label` : void 0, Ze = variantComponent[fe], et = /* @__PURE__ */ jsxRuntimeExports.jsx(Ze, _extends$5({
    "aria-describedby": Ve,
    autoComplete: s,
    autoFocus: l,
    defaultValue: C,
    fullWidth: L,
    multiline: de,
    name: ve,
    rows: Ae,
    maxRows: K,
    minRows: ue,
    type: be,
    value: le,
    id: De,
    inputRef: N,
    onBlur: Te,
    onChange: Pe,
    onFocus: Ce,
    placeholder: Re,
    inputProps: H
  }, Fe, V));
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(TextFieldRoot, _extends$5({
    className: clsx$1(Ie.root, p),
    disabled: P,
    error: w,
    fullWidth: L,
    ref: n,
    required: ke,
    color: m,
    variant: fe,
    ownerState: Ee
  }, ye, {
    children: [B != null && B !== "" && /* @__PURE__ */ jsxRuntimeExports.jsx(InputLabel$1, _extends$5({
      htmlFor: De,
      id: Oe
    }, W, {
      children: B
    })), we ? /* @__PURE__ */ jsxRuntimeExports.jsx(Select$1, _extends$5({
      "aria-describedby": Ve,
      id: De,
      labelId: Oe,
      value: le,
      input: et
    }, he, {
      children: c
    })) : et, M && /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperText$1, _extends$5({
      id: Ve
    }, R, {
      children: M
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (TextField.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: PropTypes.bool,
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: PropTypes.bool,
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: PropTypes.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The helper text content.
   */
  helperText: PropTypes.node,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: PropTypes.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: PropTypes.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,
  /**
   * The label content.
   */
  label: PropTypes.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: PropTypes.oneOf(["dense", "none", "normal"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a `textarea` element is rendered instead of an input.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Render a [`Select`](/material-ui/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   * @default false
   */
  select: PropTypes.bool,
  /**
   * Props applied to the [`Select`](/material-ui/api/select/) element.
   */
  SelectProps: PropTypes.object,
  /**
   * The size of the component.
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
});
const TextField$1 = TextField, renderButtonIcon = (e) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "button",
  {
    value: e.value,
    className: `buttonicon ${e.fancy ? "fancy" : ""} ${e.disabled ? "disabled" : ""} ${e.active ? "active" : ""} ${e.size} d-flex align-items-center justify-content-center ${e.styleClass}`,
    onClick: (t) => {
      !e.disabled && e.onClick && e.onClick(t);
    },
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconMask, { icon: e.icon, name: e.name })
  }
), ButtonIcon = (e) => e.tooltipTitle ? /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { title: e.tooltipTitle, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: renderButtonIcon(e) }) }) : renderButtonIcon(e), NCBackgroundImage$1 = "", NCBackgroundImage = ({ src: e }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "nc-background-image-container", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mask d-block" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: e, draggable: !1 })
] }), NCBox = ({
  children: e,
  ...t
}) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ...t, children: e }), NCCard$1 = "", NCCard = ({
  children: e,
  transition: t,
  ...n
}) => {
  let o = "nc-card";
  return n.className && (o += ` ${n.className}`), t && (o += " transition-slide"), /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ...n, className: o, children: e }) });
}, NCCardLoading$1 = "", NCCardLoading = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "nc-card-loading", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "nc-loading placeholder-banner mb-2" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "nc-loading placeholder-row" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "nc-loading placeholder-row w-75 my-1" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "nc-loading placeholder-row" })
] });
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var hookCallback;
function hooks() {
  return hookCallback.apply(null, arguments);
}
function setHookCallback(e) {
  hookCallback = e;
}
function isArray$1(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function isObject$2(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function hasOwnProp(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function isObjectEmpty(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var t;
  for (t in e)
    if (hasOwnProp(e, t))
      return !1;
  return !0;
}
function isUndefined$1(e) {
  return e === void 0;
}
function isNumber$1(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function isDate$1(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function map(e, t) {
  var n = [], o, s = e.length;
  for (o = 0; o < s; ++o)
    n.push(t(e[o], o));
  return n;
}
function extend$1(e, t) {
  for (var n in t)
    hasOwnProp(t, n) && (e[n] = t[n]);
  return hasOwnProp(t, "toString") && (e.toString = t.toString), hasOwnProp(t, "valueOf") && (e.valueOf = t.valueOf), e;
}
function createUTC(e, t, n, o) {
  return createLocalOrUTC(e, t, n, o, !0).utc();
}
function defaultParsingFlags() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function getParsingFlags(e) {
  return e._pf == null && (e._pf = defaultParsingFlags()), e._pf;
}
var some;
Array.prototype.some ? some = Array.prototype.some : some = function(e) {
  var t = Object(this), n = t.length >>> 0, o;
  for (o = 0; o < n; o++)
    if (o in t && e.call(this, t[o], o, t))
      return !0;
  return !1;
};
function isValid(e) {
  var t = null, n = !1, o = e._d && !isNaN(e._d.getTime());
  if (o && (t = getParsingFlags(e), n = some.call(t.parsedDateParts, function(s) {
    return s != null;
  }), o = t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && n), e._strict && (o = o && t.charsLeftOver === 0 && t.unusedTokens.length === 0 && t.bigHour === void 0)), Object.isFrozen == null || !Object.isFrozen(e))
    e._isValid = o;
  else
    return o;
  return e._isValid;
}
function createInvalid(e) {
  var t = createUTC(NaN);
  return e != null ? extend$1(getParsingFlags(t), e) : getParsingFlags(t).userInvalidated = !0, t;
}
var momentProperties = hooks.momentProperties = [], updateInProgress = !1;
function copyConfig(e, t) {
  var n, o, s, l = momentProperties.length;
  if (isUndefined$1(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), isUndefined$1(t._i) || (e._i = t._i), isUndefined$1(t._f) || (e._f = t._f), isUndefined$1(t._l) || (e._l = t._l), isUndefined$1(t._strict) || (e._strict = t._strict), isUndefined$1(t._tzm) || (e._tzm = t._tzm), isUndefined$1(t._isUTC) || (e._isUTC = t._isUTC), isUndefined$1(t._offset) || (e._offset = t._offset), isUndefined$1(t._pf) || (e._pf = getParsingFlags(t)), isUndefined$1(t._locale) || (e._locale = t._locale), l > 0)
    for (n = 0; n < l; n++)
      o = momentProperties[n], s = t[o], isUndefined$1(s) || (e[o] = s);
  return e;
}
function Moment(e) {
  copyConfig(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), updateInProgress === !1 && (updateInProgress = !0, hooks.updateOffset(this), updateInProgress = !1);
}
function isMoment(e) {
  return e instanceof Moment || e != null && e._isAMomentObject != null;
}
function warn(e) {
  hooks.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function deprecate(e, t) {
  var n = !0;
  return extend$1(function() {
    if (hooks.deprecationHandler != null && hooks.deprecationHandler(null, e), n) {
      var o = [], s, l, c, p = arguments.length;
      for (l = 0; l < p; l++) {
        if (s = "", typeof arguments[l] == "object") {
          s += `
[` + l + "] ";
          for (c in arguments[0])
            hasOwnProp(arguments[0], c) && (s += c + ": " + arguments[0][c] + ", ");
          s = s.slice(0, -2);
        } else
          s = arguments[l];
        o.push(s);
      }
      warn(
        e + `
Arguments: ` + Array.prototype.slice.call(o).join("") + `
` + new Error().stack
      ), n = !1;
    }
    return t.apply(this, arguments);
  }, t);
}
var deprecations = {};
function deprecateSimple(e, t) {
  hooks.deprecationHandler != null && hooks.deprecationHandler(e, t), deprecations[e] || (warn(t), deprecations[e] = !0);
}
hooks.suppressDeprecationWarnings = !1;
hooks.deprecationHandler = null;
function isFunction$3(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
function set(e) {
  var t, n;
  for (n in e)
    hasOwnProp(e, n) && (t = e[n], isFunction$3(t) ? this[n] = t : this["_" + n] = t);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function mergeConfigs(e, t) {
  var n = extend$1({}, e), o;
  for (o in t)
    hasOwnProp(t, o) && (isObject$2(e[o]) && isObject$2(t[o]) ? (n[o] = {}, extend$1(n[o], e[o]), extend$1(n[o], t[o])) : t[o] != null ? n[o] = t[o] : delete n[o]);
  for (o in e)
    hasOwnProp(e, o) && !hasOwnProp(t, o) && isObject$2(e[o]) && (n[o] = extend$1({}, n[o]));
  return n;
}
function Locale(e) {
  e != null && this.set(e);
}
var keys;
Object.keys ? keys = Object.keys : keys = function(e) {
  var t, n = [];
  for (t in e)
    hasOwnProp(e, t) && n.push(t);
  return n;
};
var defaultCalendar = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function calendar(e, t, n) {
  var o = this._calendar[e] || this._calendar.sameElse;
  return isFunction$3(o) ? o.call(t, n) : o;
}
function zeroFill(e, t, n) {
  var o = "" + Math.abs(e), s = t - o.length, l = e >= 0;
  return (l ? n ? "+" : "" : "-") + Math.pow(10, Math.max(0, s)).toString().substr(1) + o;
}
var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
function addFormatToken(e, t, n, o) {
  var s = o;
  typeof o == "string" && (s = function() {
    return this[o]();
  }), e && (formatTokenFunctions[e] = s), t && (formatTokenFunctions[t[0]] = function() {
    return zeroFill(s.apply(this, arguments), t[1], t[2]);
  }), n && (formatTokenFunctions[n] = function() {
    return this.localeData().ordinal(
      s.apply(this, arguments),
      e
    );
  });
}
function removeFormattingTokens(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function makeFormatFunction(e) {
  var t = e.match(formattingTokens), n, o;
  for (n = 0, o = t.length; n < o; n++)
    formatTokenFunctions[t[n]] ? t[n] = formatTokenFunctions[t[n]] : t[n] = removeFormattingTokens(t[n]);
  return function(s) {
    var l = "", c;
    for (c = 0; c < o; c++)
      l += isFunction$3(t[c]) ? t[c].call(s, e) : t[c];
    return l;
  };
}
function formatMoment(e, t) {
  return e.isValid() ? (t = expandFormat(t, e.localeData()), formatFunctions[t] = formatFunctions[t] || makeFormatFunction(t), formatFunctions[t](e)) : e.localeData().invalidDate();
}
function expandFormat(e, t) {
  var n = 5;
  function o(s) {
    return t.longDateFormat(s) || s;
  }
  for (localFormattingTokens.lastIndex = 0; n >= 0 && localFormattingTokens.test(e); )
    e = e.replace(
      localFormattingTokens,
      o
    ), localFormattingTokens.lastIndex = 0, n -= 1;
  return e;
}
var defaultLongDateFormat = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function longDateFormat(e) {
  var t = this._longDateFormat[e], n = this._longDateFormat[e.toUpperCase()];
  return t || !n ? t : (this._longDateFormat[e] = n.match(formattingTokens).map(function(o) {
    return o === "MMMM" || o === "MM" || o === "DD" || o === "dddd" ? o.slice(1) : o;
  }).join(""), this._longDateFormat[e]);
}
var defaultInvalidDate = "Invalid date";
function invalidDate() {
  return this._invalidDate;
}
var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
function ordinal(e) {
  return this._ordinal.replace("%d", e);
}
var defaultRelativeTime = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function relativeTime(e, t, n, o) {
  var s = this._relativeTime[n];
  return isFunction$3(s) ? s(e, t, n, o) : s.replace(/%d/i, e);
}
function pastFuture(e, t) {
  var n = this._relativeTime[e > 0 ? "future" : "past"];
  return isFunction$3(n) ? n(t) : n.replace(/%s/i, t);
}
var aliases = {
  D: "date",
  dates: "date",
  date: "date",
  d: "day",
  days: "day",
  day: "day",
  e: "weekday",
  weekdays: "weekday",
  weekday: "weekday",
  E: "isoWeekday",
  isoweekdays: "isoWeekday",
  isoweekday: "isoWeekday",
  DDD: "dayOfYear",
  dayofyears: "dayOfYear",
  dayofyear: "dayOfYear",
  h: "hour",
  hours: "hour",
  hour: "hour",
  ms: "millisecond",
  milliseconds: "millisecond",
  millisecond: "millisecond",
  m: "minute",
  minutes: "minute",
  minute: "minute",
  M: "month",
  months: "month",
  month: "month",
  Q: "quarter",
  quarters: "quarter",
  quarter: "quarter",
  s: "second",
  seconds: "second",
  second: "second",
  gg: "weekYear",
  weekyears: "weekYear",
  weekyear: "weekYear",
  GG: "isoWeekYear",
  isoweekyears: "isoWeekYear",
  isoweekyear: "isoWeekYear",
  w: "week",
  weeks: "week",
  week: "week",
  W: "isoWeek",
  isoweeks: "isoWeek",
  isoweek: "isoWeek",
  y: "year",
  years: "year",
  year: "year"
};
function normalizeUnits(e) {
  return typeof e == "string" ? aliases[e] || aliases[e.toLowerCase()] : void 0;
}
function normalizeObjectUnits(e) {
  var t = {}, n, o;
  for (o in e)
    hasOwnProp(e, o) && (n = normalizeUnits(o), n && (t[n] = e[o]));
  return t;
}
var priorities = {
  date: 9,
  day: 11,
  weekday: 11,
  isoWeekday: 11,
  dayOfYear: 4,
  hour: 13,
  millisecond: 16,
  minute: 14,
  month: 8,
  quarter: 7,
  second: 15,
  weekYear: 1,
  isoWeekYear: 1,
  week: 5,
  isoWeek: 5,
  year: 1
};
function getPrioritizedUnits(e) {
  var t = [], n;
  for (n in e)
    hasOwnProp(e, n) && t.push({ unit: n, priority: priorities[n] });
  return t.sort(function(o, s) {
    return o.priority - s.priority;
  }), t;
}
var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
regexes = {};
function addRegexToken(e, t, n) {
  regexes[e] = isFunction$3(t) ? t : function(o, s) {
    return o && n ? n : t;
  };
}
function getParseRegexForToken(e, t) {
  return hasOwnProp(regexes, e) ? regexes[e](t._strict, t._locale) : new RegExp(unescapeFormat(e));
}
function unescapeFormat(e) {
  return regexEscape(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(t, n, o, s, l) {
        return n || o || s || l;
      }
    )
  );
}
function regexEscape(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function absFloor(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function toInt(e) {
  var t = +e, n = 0;
  return t !== 0 && isFinite(t) && (n = absFloor(t)), n;
}
var tokens = {};
function addParseToken(e, t) {
  var n, o = t, s;
  for (typeof e == "string" && (e = [e]), isNumber$1(t) && (o = function(l, c) {
    c[t] = toInt(l);
  }), s = e.length, n = 0; n < s; n++)
    tokens[e[n]] = o;
}
function addWeekParseToken(e, t) {
  addParseToken(e, function(n, o, s, l) {
    s._w = s._w || {}, t(n, s._w, s, l);
  });
}
function addTimeToArrayFromToken(e, t, n) {
  t != null && hasOwnProp(tokens, e) && tokens[e](t, n._a, n, e);
}
function isLeapYear(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
addFormatToken("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? zeroFill(e, 4) : "+" + e;
});
addFormatToken(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
addFormatToken(0, ["YYYY", 4], 0, "year");
addFormatToken(0, ["YYYYY", 5], 0, "year");
addFormatToken(0, ["YYYYYY", 6, !0], 0, "year");
addRegexToken("Y", matchSigned);
addRegexToken("YY", match1to2, match2);
addRegexToken("YYYY", match1to4, match4);
addRegexToken("YYYYY", match1to6, match6);
addRegexToken("YYYYYY", match1to6, match6);
addParseToken(["YYYYY", "YYYYYY"], YEAR);
addParseToken("YYYY", function(e, t) {
  t[YEAR] = e.length === 2 ? hooks.parseTwoDigitYear(e) : toInt(e);
});
addParseToken("YY", function(e, t) {
  t[YEAR] = hooks.parseTwoDigitYear(e);
});
addParseToken("Y", function(e, t) {
  t[YEAR] = parseInt(e, 10);
});
function daysInYear(e) {
  return isLeapYear(e) ? 366 : 365;
}
hooks.parseTwoDigitYear = function(e) {
  return toInt(e) + (toInt(e) > 68 ? 1900 : 2e3);
};
var getSetYear = makeGetSet("FullYear", !0);
function getIsLeapYear() {
  return isLeapYear(this.year());
}
function makeGetSet(e, t) {
  return function(n) {
    return n != null ? (set$1(this, e, n), hooks.updateOffset(this, t), this) : get(this, e);
  };
}
function get(e, t) {
  if (!e.isValid())
    return NaN;
  var n = e._d, o = e._isUTC;
  switch (t) {
    case "Milliseconds":
      return o ? n.getUTCMilliseconds() : n.getMilliseconds();
    case "Seconds":
      return o ? n.getUTCSeconds() : n.getSeconds();
    case "Minutes":
      return o ? n.getUTCMinutes() : n.getMinutes();
    case "Hours":
      return o ? n.getUTCHours() : n.getHours();
    case "Date":
      return o ? n.getUTCDate() : n.getDate();
    case "Day":
      return o ? n.getUTCDay() : n.getDay();
    case "Month":
      return o ? n.getUTCMonth() : n.getMonth();
    case "FullYear":
      return o ? n.getUTCFullYear() : n.getFullYear();
    default:
      return NaN;
  }
}
function set$1(e, t, n) {
  var o, s, l, c, p;
  if (!(!e.isValid() || isNaN(n))) {
    switch (o = e._d, s = e._isUTC, t) {
      case "Milliseconds":
        return void (s ? o.setUTCMilliseconds(n) : o.setMilliseconds(n));
      case "Seconds":
        return void (s ? o.setUTCSeconds(n) : o.setSeconds(n));
      case "Minutes":
        return void (s ? o.setUTCMinutes(n) : o.setMinutes(n));
      case "Hours":
        return void (s ? o.setUTCHours(n) : o.setHours(n));
      case "Date":
        return void (s ? o.setUTCDate(n) : o.setDate(n));
      case "FullYear":
        break;
      default:
        return;
    }
    l = n, c = e.month(), p = e.date(), p = p === 29 && c === 1 && !isLeapYear(l) ? 28 : p, s ? o.setUTCFullYear(l, c, p) : o.setFullYear(l, c, p);
  }
}
function stringGet(e) {
  return e = normalizeUnits(e), isFunction$3(this[e]) ? this[e]() : this;
}
function stringSet(e, t) {
  if (typeof e == "object") {
    e = normalizeObjectUnits(e);
    var n = getPrioritizedUnits(e), o, s = n.length;
    for (o = 0; o < s; o++)
      this[n[o].unit](e[n[o].unit]);
  } else if (e = normalizeUnits(e), isFunction$3(this[e]))
    return this[e](t);
  return this;
}
function mod(e, t) {
  return (e % t + t) % t;
}
var indexOf;
Array.prototype.indexOf ? indexOf = Array.prototype.indexOf : indexOf = function(e) {
  var t;
  for (t = 0; t < this.length; ++t)
    if (this[t] === e)
      return t;
  return -1;
};
function daysInMonth(e, t) {
  if (isNaN(e) || isNaN(t))
    return NaN;
  var n = mod(t, 12);
  return e += (t - n) / 12, n === 1 ? isLeapYear(e) ? 29 : 28 : 31 - n % 7 % 2;
}
addFormatToken("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
addFormatToken("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
addFormatToken("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
addRegexToken("M", match1to2, match1to2NoLeadingZero);
addRegexToken("MM", match1to2, match2);
addRegexToken("MMM", function(e, t) {
  return t.monthsShortRegex(e);
});
addRegexToken("MMMM", function(e, t) {
  return t.monthsRegex(e);
});
addParseToken(["M", "MM"], function(e, t) {
  t[MONTH] = toInt(e) - 1;
});
addParseToken(["MMM", "MMMM"], function(e, t, n, o) {
  var s = n._locale.monthsParse(e, o, n._strict);
  s != null ? t[MONTH] = s : getParsingFlags(n).invalidMonth = e;
});
var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
function localeMonths(e, t) {
  return e ? isArray$1(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(t) ? "format" : "standalone"][e.month()] : isArray$1(this._months) ? this._months : this._months.standalone;
}
function localeMonthsShort(e, t) {
  return e ? isArray$1(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(t) ? "format" : "standalone"][e.month()] : isArray$1(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function handleStrictParse(e, t, n) {
  var o, s, l, c = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], o = 0; o < 12; ++o)
      l = createUTC([2e3, o]), this._shortMonthsParse[o] = this.monthsShort(
        l,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[o] = this.months(l, "").toLocaleLowerCase();
  return n ? t === "MMM" ? (s = indexOf.call(this._shortMonthsParse, c), s !== -1 ? s : null) : (s = indexOf.call(this._longMonthsParse, c), s !== -1 ? s : null) : t === "MMM" ? (s = indexOf.call(this._shortMonthsParse, c), s !== -1 ? s : (s = indexOf.call(this._longMonthsParse, c), s !== -1 ? s : null)) : (s = indexOf.call(this._longMonthsParse, c), s !== -1 ? s : (s = indexOf.call(this._shortMonthsParse, c), s !== -1 ? s : null));
}
function localeMonthsParse(e, t, n) {
  var o, s, l;
  if (this._monthsParseExact)
    return handleStrictParse.call(this, e, t, n);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), o = 0; o < 12; o++) {
    if (s = createUTC([2e3, o]), n && !this._longMonthsParse[o] && (this._longMonthsParse[o] = new RegExp(
      "^" + this.months(s, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[o] = new RegExp(
      "^" + this.monthsShort(s, "").replace(".", "") + "$",
      "i"
    )), !n && !this._monthsParse[o] && (l = "^" + this.months(s, "") + "|^" + this.monthsShort(s, ""), this._monthsParse[o] = new RegExp(l.replace(".", ""), "i")), n && t === "MMMM" && this._longMonthsParse[o].test(e))
      return o;
    if (n && t === "MMM" && this._shortMonthsParse[o].test(e))
      return o;
    if (!n && this._monthsParse[o].test(e))
      return o;
  }
}
function setMonth(e, t) {
  if (!e.isValid())
    return e;
  if (typeof t == "string") {
    if (/^\d+$/.test(t))
      t = toInt(t);
    else if (t = e.localeData().monthsParse(t), !isNumber$1(t))
      return e;
  }
  var n = t, o = e.date();
  return o = o < 29 ? o : Math.min(o, daysInMonth(e.year(), n)), e._isUTC ? e._d.setUTCMonth(n, o) : e._d.setMonth(n, o), e;
}
function getSetMonth(e) {
  return e != null ? (setMonth(this, e), hooks.updateOffset(this, !0), this) : get(this, "Month");
}
function getDaysInMonth() {
  return daysInMonth(this.year(), this.month());
}
function monthsShortRegex(e) {
  return this._monthsParseExact ? (hasOwnProp(this, "_monthsRegex") || computeMonthsParse.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (hasOwnProp(this, "_monthsShortRegex") || (this._monthsShortRegex = defaultMonthsShortRegex), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function monthsRegex(e) {
  return this._monthsParseExact ? (hasOwnProp(this, "_monthsRegex") || computeMonthsParse.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (hasOwnProp(this, "_monthsRegex") || (this._monthsRegex = defaultMonthsRegex), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function computeMonthsParse() {
  function e(m, C) {
    return C.length - m.length;
  }
  var t = [], n = [], o = [], s, l, c, p;
  for (s = 0; s < 12; s++)
    l = createUTC([2e3, s]), c = regexEscape(this.monthsShort(l, "")), p = regexEscape(this.months(l, "")), t.push(c), n.push(p), o.push(p), o.push(c);
  t.sort(e), n.sort(e), o.sort(e), this._monthsRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function createDate(e, t, n, o, s, l, c) {
  var p;
  return e < 100 && e >= 0 ? (p = new Date(e + 400, t, n, o, s, l, c), isFinite(p.getFullYear()) && p.setFullYear(e)) : p = new Date(e, t, n, o, s, l, c), p;
}
function createUTCDate(e) {
  var t, n;
  return e < 100 && e >= 0 ? (n = Array.prototype.slice.call(arguments), n[0] = e + 400, t = new Date(Date.UTC.apply(null, n)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e)) : t = new Date(Date.UTC.apply(null, arguments)), t;
}
function firstWeekOffset(e, t, n) {
  var o = 7 + t - n, s = (7 + createUTCDate(e, 0, o).getUTCDay() - t) % 7;
  return -s + o - 1;
}
function dayOfYearFromWeeks(e, t, n, o, s) {
  var l = (7 + n - o) % 7, c = firstWeekOffset(e, o, s), p = 1 + 7 * (t - 1) + l + c, m, C;
  return p <= 0 ? (m = e - 1, C = daysInYear(m) + p) : p > daysInYear(e) ? (m = e + 1, C = p - daysInYear(e)) : (m = e, C = p), {
    year: m,
    dayOfYear: C
  };
}
function weekOfYear(e, t, n) {
  var o = firstWeekOffset(e.year(), t, n), s = Math.floor((e.dayOfYear() - o - 1) / 7) + 1, l, c;
  return s < 1 ? (c = e.year() - 1, l = s + weeksInYear(c, t, n)) : s > weeksInYear(e.year(), t, n) ? (l = s - weeksInYear(e.year(), t, n), c = e.year() + 1) : (c = e.year(), l = s), {
    week: l,
    year: c
  };
}
function weeksInYear(e, t, n) {
  var o = firstWeekOffset(e, t, n), s = firstWeekOffset(e + 1, t, n);
  return (daysInYear(e) - o + s) / 7;
}
addFormatToken("w", ["ww", 2], "wo", "week");
addFormatToken("W", ["WW", 2], "Wo", "isoWeek");
addRegexToken("w", match1to2, match1to2NoLeadingZero);
addRegexToken("ww", match1to2, match2);
addRegexToken("W", match1to2, match1to2NoLeadingZero);
addRegexToken("WW", match1to2, match2);
addWeekParseToken(
  ["w", "ww", "W", "WW"],
  function(e, t, n, o) {
    t[o.substr(0, 1)] = toInt(e);
  }
);
function localeWeek(e) {
  return weekOfYear(e, this._week.dow, this._week.doy).week;
}
var defaultLocaleWeek = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function localeFirstDayOfWeek() {
  return this._week.dow;
}
function localeFirstDayOfYear() {
  return this._week.doy;
}
function getSetWeek(e) {
  var t = this.localeData().week(this);
  return e == null ? t : this.add((e - t) * 7, "d");
}
function getSetISOWeek(e) {
  var t = weekOfYear(this, 1, 4).week;
  return e == null ? t : this.add((e - t) * 7, "d");
}
addFormatToken("d", 0, "do", "day");
addFormatToken("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
addFormatToken("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
addFormatToken("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
addFormatToken("e", 0, 0, "weekday");
addFormatToken("E", 0, 0, "isoWeekday");
addRegexToken("d", match1to2);
addRegexToken("e", match1to2);
addRegexToken("E", match1to2);
addRegexToken("dd", function(e, t) {
  return t.weekdaysMinRegex(e);
});
addRegexToken("ddd", function(e, t) {
  return t.weekdaysShortRegex(e);
});
addRegexToken("dddd", function(e, t) {
  return t.weekdaysRegex(e);
});
addWeekParseToken(["dd", "ddd", "dddd"], function(e, t, n, o) {
  var s = n._locale.weekdaysParse(e, o, n._strict);
  s != null ? t.d = s : getParsingFlags(n).invalidWeekday = e;
});
addWeekParseToken(["d", "e", "E"], function(e, t, n, o) {
  t[o] = toInt(e);
});
function parseWeekday(e, t) {
  return typeof e != "string" ? e : isNaN(e) ? (e = t.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function parseIsoWeekday(e, t) {
  return typeof e == "string" ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function shiftWeekdays(e, t) {
  return e.slice(t, 7).concat(e.slice(0, t));
}
var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
function localeWeekdays(e, t) {
  var n = isArray$1(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
  return e === !0 ? shiftWeekdays(n, this._week.dow) : e ? n[e.day()] : n;
}
function localeWeekdaysShort(e) {
  return e === !0 ? shiftWeekdays(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function localeWeekdaysMin(e) {
  return e === !0 ? shiftWeekdays(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function handleStrictParse$1(e, t, n) {
  var o, s, l, c = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], o = 0; o < 7; ++o)
      l = createUTC([2e3, 1]).day(o), this._minWeekdaysParse[o] = this.weekdaysMin(
        l,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[o] = this.weekdaysShort(
        l,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[o] = this.weekdays(l, "").toLocaleLowerCase();
  return n ? t === "dddd" ? (s = indexOf.call(this._weekdaysParse, c), s !== -1 ? s : null) : t === "ddd" ? (s = indexOf.call(this._shortWeekdaysParse, c), s !== -1 ? s : null) : (s = indexOf.call(this._minWeekdaysParse, c), s !== -1 ? s : null) : t === "dddd" ? (s = indexOf.call(this._weekdaysParse, c), s !== -1 || (s = indexOf.call(this._shortWeekdaysParse, c), s !== -1) ? s : (s = indexOf.call(this._minWeekdaysParse, c), s !== -1 ? s : null)) : t === "ddd" ? (s = indexOf.call(this._shortWeekdaysParse, c), s !== -1 || (s = indexOf.call(this._weekdaysParse, c), s !== -1) ? s : (s = indexOf.call(this._minWeekdaysParse, c), s !== -1 ? s : null)) : (s = indexOf.call(this._minWeekdaysParse, c), s !== -1 || (s = indexOf.call(this._weekdaysParse, c), s !== -1) ? s : (s = indexOf.call(this._shortWeekdaysParse, c), s !== -1 ? s : null));
}
function localeWeekdaysParse(e, t, n) {
  var o, s, l;
  if (this._weekdaysParseExact)
    return handleStrictParse$1.call(this, e, t, n);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), o = 0; o < 7; o++) {
    if (s = createUTC([2e3, 1]).day(o), n && !this._fullWeekdaysParse[o] && (this._fullWeekdaysParse[o] = new RegExp(
      "^" + this.weekdays(s, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[o] = new RegExp(
      "^" + this.weekdaysShort(s, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[o] = new RegExp(
      "^" + this.weekdaysMin(s, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[o] || (l = "^" + this.weekdays(s, "") + "|^" + this.weekdaysShort(s, "") + "|^" + this.weekdaysMin(s, ""), this._weekdaysParse[o] = new RegExp(l.replace(".", ""), "i")), n && t === "dddd" && this._fullWeekdaysParse[o].test(e))
      return o;
    if (n && t === "ddd" && this._shortWeekdaysParse[o].test(e))
      return o;
    if (n && t === "dd" && this._minWeekdaysParse[o].test(e))
      return o;
    if (!n && this._weekdaysParse[o].test(e))
      return o;
  }
}
function getSetDayOfWeek(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = get(this, "Day");
  return e != null ? (e = parseWeekday(e, this.localeData()), this.add(e - t, "d")) : t;
}
function getSetLocaleDayOfWeek(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? t : this.add(e - t, "d");
}
function getSetISODayOfWeek(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var t = parseIsoWeekday(e, this.localeData());
    return this.day(this.day() % 7 ? t : t - 7);
  } else
    return this.day() || 7;
}
function weekdaysRegex(e) {
  return this._weekdaysParseExact ? (hasOwnProp(this, "_weekdaysRegex") || computeWeekdaysParse.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (hasOwnProp(this, "_weekdaysRegex") || (this._weekdaysRegex = defaultWeekdaysRegex), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function weekdaysShortRegex(e) {
  return this._weekdaysParseExact ? (hasOwnProp(this, "_weekdaysRegex") || computeWeekdaysParse.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (hasOwnProp(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = defaultWeekdaysShortRegex), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function weekdaysMinRegex(e) {
  return this._weekdaysParseExact ? (hasOwnProp(this, "_weekdaysRegex") || computeWeekdaysParse.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (hasOwnProp(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = defaultWeekdaysMinRegex), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function computeWeekdaysParse() {
  function e(P, w) {
    return w.length - P.length;
  }
  var t = [], n = [], o = [], s = [], l, c, p, m, C;
  for (l = 0; l < 7; l++)
    c = createUTC([2e3, 1]).day(l), p = regexEscape(this.weekdaysMin(c, "")), m = regexEscape(this.weekdaysShort(c, "")), C = regexEscape(this.weekdays(c, "")), t.push(p), n.push(m), o.push(C), s.push(p), s.push(m), s.push(C);
  t.sort(e), n.sort(e), o.sort(e), s.sort(e), this._weekdaysRegex = new RegExp("^(" + s.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + o.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function hFormat() {
  return this.hours() % 12 || 12;
}
function kFormat() {
  return this.hours() || 24;
}
addFormatToken("H", ["HH", 2], 0, "hour");
addFormatToken("h", ["hh", 2], 0, hFormat);
addFormatToken("k", ["kk", 2], 0, kFormat);
addFormatToken("hmm", 0, 0, function() {
  return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});
addFormatToken("hmmss", 0, 0, function() {
  return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
});
addFormatToken("Hmm", 0, 0, function() {
  return "" + this.hours() + zeroFill(this.minutes(), 2);
});
addFormatToken("Hmmss", 0, 0, function() {
  return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
});
function meridiem(e, t) {
  addFormatToken(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      t
    );
  });
}
meridiem("a", !0);
meridiem("A", !1);
function matchMeridiem(e, t) {
  return t._meridiemParse;
}
addRegexToken("a", matchMeridiem);
addRegexToken("A", matchMeridiem);
addRegexToken("H", match1to2, match1to2HasZero);
addRegexToken("h", match1to2, match1to2NoLeadingZero);
addRegexToken("k", match1to2, match1to2NoLeadingZero);
addRegexToken("HH", match1to2, match2);
addRegexToken("hh", match1to2, match2);
addRegexToken("kk", match1to2, match2);
addRegexToken("hmm", match3to4);
addRegexToken("hmmss", match5to6);
addRegexToken("Hmm", match3to4);
addRegexToken("Hmmss", match5to6);
addParseToken(["H", "HH"], HOUR);
addParseToken(["k", "kk"], function(e, t, n) {
  var o = toInt(e);
  t[HOUR] = o === 24 ? 0 : o;
});
addParseToken(["a", "A"], function(e, t, n) {
  n._isPm = n._locale.isPM(e), n._meridiem = e;
});
addParseToken(["h", "hh"], function(e, t, n) {
  t[HOUR] = toInt(e), getParsingFlags(n).bigHour = !0;
});
addParseToken("hmm", function(e, t, n) {
  var o = e.length - 2;
  t[HOUR] = toInt(e.substr(0, o)), t[MINUTE] = toInt(e.substr(o)), getParsingFlags(n).bigHour = !0;
});
addParseToken("hmmss", function(e, t, n) {
  var o = e.length - 4, s = e.length - 2;
  t[HOUR] = toInt(e.substr(0, o)), t[MINUTE] = toInt(e.substr(o, 2)), t[SECOND] = toInt(e.substr(s)), getParsingFlags(n).bigHour = !0;
});
addParseToken("Hmm", function(e, t, n) {
  var o = e.length - 2;
  t[HOUR] = toInt(e.substr(0, o)), t[MINUTE] = toInt(e.substr(o));
});
addParseToken("Hmmss", function(e, t, n) {
  var o = e.length - 4, s = e.length - 2;
  t[HOUR] = toInt(e.substr(0, o)), t[MINUTE] = toInt(e.substr(o, 2)), t[SECOND] = toInt(e.substr(s));
});
function localeIsPM(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, getSetHour = makeGetSet("Hours", !0);
function localeMeridiem(e, t, n) {
  return e > 11 ? n ? "pm" : "PM" : n ? "am" : "AM";
}
var baseConfig = {
  calendar: defaultCalendar,
  longDateFormat: defaultLongDateFormat,
  invalidDate: defaultInvalidDate,
  ordinal: defaultOrdinal,
  dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
  relativeTime: defaultRelativeTime,
  months: defaultLocaleMonths,
  monthsShort: defaultLocaleMonthsShort,
  week: defaultLocaleWeek,
  weekdays: defaultLocaleWeekdays,
  weekdaysMin: defaultLocaleWeekdaysMin,
  weekdaysShort: defaultLocaleWeekdaysShort,
  meridiemParse: defaultLocaleMeridiemParse
}, locales = {}, localeFamilies = {}, globalLocale;
function commonPrefix(e, t) {
  var n, o = Math.min(e.length, t.length);
  for (n = 0; n < o; n += 1)
    if (e[n] !== t[n])
      return n;
  return o;
}
function normalizeLocale(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function chooseLocale(e) {
  for (var t = 0, n, o, s, l; t < e.length; ) {
    for (l = normalizeLocale(e[t]).split("-"), n = l.length, o = normalizeLocale(e[t + 1]), o = o ? o.split("-") : null; n > 0; ) {
      if (s = loadLocale(l.slice(0, n).join("-")), s)
        return s;
      if (o && o.length >= n && commonPrefix(l, o) >= n - 1)
        break;
      n--;
    }
    t++;
  }
  return globalLocale;
}
function isLocaleNameSane(e) {
  return !!(e && e.match("^[^/\\\\]*$"));
}
function loadLocale(e) {
  var t = null, n;
  if (locales[e] === void 0 && typeof module < "u" && module && module.exports && isLocaleNameSane(e))
    try {
      t = globalLocale._abbr, n = require, n("./locale/" + e), getSetGlobalLocale(t);
    } catch {
      locales[e] = null;
    }
  return locales[e];
}
function getSetGlobalLocale(e, t) {
  var n;
  return e && (isUndefined$1(t) ? n = getLocale(e) : n = defineLocale(e, t), n ? globalLocale = n : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), globalLocale._abbr;
}
function defineLocale(e, t) {
  if (t !== null) {
    var n, o = baseConfig;
    if (t.abbr = e, locales[e] != null)
      deprecateSimple(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), o = locales[e]._config;
    else if (t.parentLocale != null)
      if (locales[t.parentLocale] != null)
        o = locales[t.parentLocale]._config;
      else if (n = loadLocale(t.parentLocale), n != null)
        o = n._config;
      else
        return localeFamilies[t.parentLocale] || (localeFamilies[t.parentLocale] = []), localeFamilies[t.parentLocale].push({
          name: e,
          config: t
        }), null;
    return locales[e] = new Locale(mergeConfigs(o, t)), localeFamilies[e] && localeFamilies[e].forEach(function(s) {
      defineLocale(s.name, s.config);
    }), getSetGlobalLocale(e), locales[e];
  } else
    return delete locales[e], null;
}
function updateLocale(e, t) {
  if (t != null) {
    var n, o, s = baseConfig;
    locales[e] != null && locales[e].parentLocale != null ? locales[e].set(mergeConfigs(locales[e]._config, t)) : (o = loadLocale(e), o != null && (s = o._config), t = mergeConfigs(s, t), o == null && (t.abbr = e), n = new Locale(t), n.parentLocale = locales[e], locales[e] = n), getSetGlobalLocale(e);
  } else
    locales[e] != null && (locales[e].parentLocale != null ? (locales[e] = locales[e].parentLocale, e === getSetGlobalLocale() && getSetGlobalLocale(e)) : locales[e] != null && delete locales[e]);
  return locales[e];
}
function getLocale(e) {
  var t;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return globalLocale;
  if (!isArray$1(e)) {
    if (t = loadLocale(e), t)
      return t;
    e = [e];
  }
  return chooseLocale(e);
}
function listLocales() {
  return keys(locales);
}
function checkOverflow(e) {
  var t, n = e._a;
  return n && getParsingFlags(e).overflow === -2 && (t = n[MONTH] < 0 || n[MONTH] > 11 ? MONTH : n[DATE] < 1 || n[DATE] > daysInMonth(n[YEAR], n[MONTH]) ? DATE : n[HOUR] < 0 || n[HOUR] > 24 || n[HOUR] === 24 && (n[MINUTE] !== 0 || n[SECOND] !== 0 || n[MILLISECOND] !== 0) ? HOUR : n[MINUTE] < 0 || n[MINUTE] > 59 ? MINUTE : n[SECOND] < 0 || n[SECOND] > 59 ? SECOND : n[MILLISECOND] < 0 || n[MILLISECOND] > 999 ? MILLISECOND : -1, getParsingFlags(e)._overflowDayOfYear && (t < YEAR || t > DATE) && (t = DATE), getParsingFlags(e)._overflowWeeks && t === -1 && (t = WEEK), getParsingFlags(e)._overflowWeekday && t === -1 && (t = WEEKDAY), getParsingFlags(e).overflow = t), e;
}
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], isoTimes = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function configFromISO(e) {
  var t, n, o = e._i, s = extendedIsoRegex.exec(o) || basicIsoRegex.exec(o), l, c, p, m, C = isoDates.length, P = isoTimes.length;
  if (s) {
    for (getParsingFlags(e).iso = !0, t = 0, n = C; t < n; t++)
      if (isoDates[t][1].exec(s[1])) {
        c = isoDates[t][0], l = isoDates[t][2] !== !1;
        break;
      }
    if (c == null) {
      e._isValid = !1;
      return;
    }
    if (s[3]) {
      for (t = 0, n = P; t < n; t++)
        if (isoTimes[t][1].exec(s[3])) {
          p = (s[2] || " ") + isoTimes[t][0];
          break;
        }
      if (p == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!l && p != null) {
      e._isValid = !1;
      return;
    }
    if (s[4])
      if (tzRegex.exec(s[4]))
        m = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = c + (p || "") + (m || ""), configFromStringAndFormat(e);
  } else
    e._isValid = !1;
}
function extractFromRFC2822Strings(e, t, n, o, s, l) {
  var c = [
    untruncateYear(e),
    defaultLocaleMonthsShort.indexOf(t),
    parseInt(n, 10),
    parseInt(o, 10),
    parseInt(s, 10)
  ];
  return l && c.push(parseInt(l, 10)), c;
}
function untruncateYear(e) {
  var t = parseInt(e, 10);
  return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
}
function preprocessRFC2822(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function checkWeekday(e, t, n) {
  if (e) {
    var o = defaultLocaleWeekdaysShort.indexOf(e), s = new Date(
      t[0],
      t[1],
      t[2]
    ).getDay();
    if (o !== s)
      return getParsingFlags(n).weekdayMismatch = !0, n._isValid = !1, !1;
  }
  return !0;
}
function calculateOffset(e, t, n) {
  if (e)
    return obsOffsets[e];
  if (t)
    return 0;
  var o = parseInt(n, 10), s = o % 100, l = (o - s) / 100;
  return l * 60 + s;
}
function configFromRFC2822(e) {
  var t = rfc2822.exec(preprocessRFC2822(e._i)), n;
  if (t) {
    if (n = extractFromRFC2822Strings(
      t[4],
      t[3],
      t[2],
      t[5],
      t[6],
      t[7]
    ), !checkWeekday(t[1], n, e))
      return;
    e._a = n, e._tzm = calculateOffset(t[8], t[9], t[10]), e._d = createUTCDate.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), getParsingFlags(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function configFromString(e) {
  var t = aspNetJsonRegex.exec(e._i);
  if (t !== null) {
    e._d = /* @__PURE__ */ new Date(+t[1]);
    return;
  }
  if (configFromISO(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (configFromRFC2822(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : hooks.createFromInputFallback(e);
}
hooks.createFromInputFallback = deprecate(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function defaults$2(e, t, n) {
  return e ?? t ?? n;
}
function currentDateArray(e) {
  var t = new Date(hooks.now());
  return e._useUTC ? [
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate()
  ] : [t.getFullYear(), t.getMonth(), t.getDate()];
}
function configFromArray(e) {
  var t, n, o = [], s, l, c;
  if (!e._d) {
    for (s = currentDateArray(e), e._w && e._a[DATE] == null && e._a[MONTH] == null && dayOfYearFromWeekInfo(e), e._dayOfYear != null && (c = defaults$2(e._a[YEAR], s[YEAR]), (e._dayOfYear > daysInYear(c) || e._dayOfYear === 0) && (getParsingFlags(e)._overflowDayOfYear = !0), n = createUTCDate(c, 0, e._dayOfYear), e._a[MONTH] = n.getUTCMonth(), e._a[DATE] = n.getUTCDate()), t = 0; t < 3 && e._a[t] == null; ++t)
      e._a[t] = o[t] = s[t];
    for (; t < 7; t++)
      e._a[t] = o[t] = e._a[t] == null ? t === 2 ? 1 : 0 : e._a[t];
    e._a[HOUR] === 24 && e._a[MINUTE] === 0 && e._a[SECOND] === 0 && e._a[MILLISECOND] === 0 && (e._nextDay = !0, e._a[HOUR] = 0), e._d = (e._useUTC ? createUTCDate : createDate).apply(
      null,
      o
    ), l = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[HOUR] = 24), e._w && typeof e._w.d < "u" && e._w.d !== l && (getParsingFlags(e).weekdayMismatch = !0);
  }
}
function dayOfYearFromWeekInfo(e) {
  var t, n, o, s, l, c, p, m, C;
  t = e._w, t.GG != null || t.W != null || t.E != null ? (l = 1, c = 4, n = defaults$2(
    t.GG,
    e._a[YEAR],
    weekOfYear(createLocal(), 1, 4).year
  ), o = defaults$2(t.W, 1), s = defaults$2(t.E, 1), (s < 1 || s > 7) && (m = !0)) : (l = e._locale._week.dow, c = e._locale._week.doy, C = weekOfYear(createLocal(), l, c), n = defaults$2(t.gg, e._a[YEAR], C.year), o = defaults$2(t.w, C.week), t.d != null ? (s = t.d, (s < 0 || s > 6) && (m = !0)) : t.e != null ? (s = t.e + l, (t.e < 0 || t.e > 6) && (m = !0)) : s = l), o < 1 || o > weeksInYear(n, l, c) ? getParsingFlags(e)._overflowWeeks = !0 : m != null ? getParsingFlags(e)._overflowWeekday = !0 : (p = dayOfYearFromWeeks(n, o, s, l, c), e._a[YEAR] = p.year, e._dayOfYear = p.dayOfYear);
}
hooks.ISO_8601 = function() {
};
hooks.RFC_2822 = function() {
};
function configFromStringAndFormat(e) {
  if (e._f === hooks.ISO_8601) {
    configFromISO(e);
    return;
  }
  if (e._f === hooks.RFC_2822) {
    configFromRFC2822(e);
    return;
  }
  e._a = [], getParsingFlags(e).empty = !0;
  var t = "" + e._i, n, o, s, l, c, p = t.length, m = 0, C, P;
  for (s = expandFormat(e._f, e._locale).match(formattingTokens) || [], P = s.length, n = 0; n < P; n++)
    l = s[n], o = (t.match(getParseRegexForToken(l, e)) || [])[0], o && (c = t.substr(0, t.indexOf(o)), c.length > 0 && getParsingFlags(e).unusedInput.push(c), t = t.slice(
      t.indexOf(o) + o.length
    ), m += o.length), formatTokenFunctions[l] ? (o ? getParsingFlags(e).empty = !1 : getParsingFlags(e).unusedTokens.push(l), addTimeToArrayFromToken(l, o, e)) : e._strict && !o && getParsingFlags(e).unusedTokens.push(l);
  getParsingFlags(e).charsLeftOver = p - m, t.length > 0 && getParsingFlags(e).unusedInput.push(t), e._a[HOUR] <= 12 && getParsingFlags(e).bigHour === !0 && e._a[HOUR] > 0 && (getParsingFlags(e).bigHour = void 0), getParsingFlags(e).parsedDateParts = e._a.slice(0), getParsingFlags(e).meridiem = e._meridiem, e._a[HOUR] = meridiemFixWrap(
    e._locale,
    e._a[HOUR],
    e._meridiem
  ), C = getParsingFlags(e).era, C !== null && (e._a[YEAR] = e._locale.erasConvertYear(C, e._a[YEAR])), configFromArray(e), checkOverflow(e);
}
function meridiemFixWrap(e, t, n) {
  var o;
  return n == null ? t : e.meridiemHour != null ? e.meridiemHour(t, n) : (e.isPM != null && (o = e.isPM(n), o && t < 12 && (t += 12), !o && t === 12 && (t = 0)), t);
}
function configFromStringAndArray(e) {
  var t, n, o, s, l, c, p = !1, m = e._f.length;
  if (m === 0) {
    getParsingFlags(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (s = 0; s < m; s++)
    l = 0, c = !1, t = copyConfig({}, e), e._useUTC != null && (t._useUTC = e._useUTC), t._f = e._f[s], configFromStringAndFormat(t), isValid(t) && (c = !0), l += getParsingFlags(t).charsLeftOver, l += getParsingFlags(t).unusedTokens.length * 10, getParsingFlags(t).score = l, p ? l < o && (o = l, n = t) : (o == null || l < o || c) && (o = l, n = t, c && (p = !0));
  extend$1(e, n || t);
}
function configFromObject(e) {
  if (!e._d) {
    var t = normalizeObjectUnits(e._i), n = t.day === void 0 ? t.date : t.day;
    e._a = map(
      [t.year, t.month, n, t.hour, t.minute, t.second, t.millisecond],
      function(o) {
        return o && parseInt(o, 10);
      }
    ), configFromArray(e);
  }
}
function createFromConfig(e) {
  var t = new Moment(checkOverflow(prepareConfig(e)));
  return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t;
}
function prepareConfig(e) {
  var t = e._i, n = e._f;
  return e._locale = e._locale || getLocale(e._l), t === null || n === void 0 && t === "" ? createInvalid({ nullInput: !0 }) : (typeof t == "string" && (e._i = t = e._locale.preparse(t)), isMoment(t) ? new Moment(checkOverflow(t)) : (isDate$1(t) ? e._d = t : isArray$1(n) ? configFromStringAndArray(e) : n ? configFromStringAndFormat(e) : configFromInput(e), isValid(e) || (e._d = null), e));
}
function configFromInput(e) {
  var t = e._i;
  isUndefined$1(t) ? e._d = new Date(hooks.now()) : isDate$1(t) ? e._d = new Date(t.valueOf()) : typeof t == "string" ? configFromString(e) : isArray$1(t) ? (e._a = map(t.slice(0), function(n) {
    return parseInt(n, 10);
  }), configFromArray(e)) : isObject$2(t) ? configFromObject(e) : isNumber$1(t) ? e._d = new Date(t) : hooks.createFromInputFallback(e);
}
function createLocalOrUTC(e, t, n, o, s) {
  var l = {};
  return (t === !0 || t === !1) && (o = t, t = void 0), (n === !0 || n === !1) && (o = n, n = void 0), (isObject$2(e) && isObjectEmpty(e) || isArray$1(e) && e.length === 0) && (e = void 0), l._isAMomentObject = !0, l._useUTC = l._isUTC = s, l._l = n, l._i = e, l._f = t, l._strict = o, createFromConfig(l);
}
function createLocal(e, t, n, o) {
  return createLocalOrUTC(e, t, n, o, !1);
}
var prototypeMin = deprecate(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = createLocal.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : createInvalid();
  }
), prototypeMax = deprecate(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = createLocal.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : createInvalid();
  }
);
function pickBy(e, t) {
  var n, o;
  if (t.length === 1 && isArray$1(t[0]) && (t = t[0]), !t.length)
    return createLocal();
  for (n = t[0], o = 1; o < t.length; ++o)
    (!t[o].isValid() || t[o][e](n)) && (n = t[o]);
  return n;
}
function min() {
  var e = [].slice.call(arguments, 0);
  return pickBy("isBefore", e);
}
function max() {
  var e = [].slice.call(arguments, 0);
  return pickBy("isAfter", e);
}
var now = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, ordering = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function isDurationValid(e) {
  var t, n = !1, o, s = ordering.length;
  for (t in e)
    if (hasOwnProp(e, t) && !(indexOf.call(ordering, t) !== -1 && (e[t] == null || !isNaN(e[t]))))
      return !1;
  for (o = 0; o < s; ++o)
    if (e[ordering[o]]) {
      if (n)
        return !1;
      parseFloat(e[ordering[o]]) !== toInt(e[ordering[o]]) && (n = !0);
    }
  return !0;
}
function isValid$1() {
  return this._isValid;
}
function createInvalid$1() {
  return createDuration(NaN);
}
function Duration(e) {
  var t = normalizeObjectUnits(e), n = t.year || 0, o = t.quarter || 0, s = t.month || 0, l = t.week || t.isoWeek || 0, c = t.day || 0, p = t.hour || 0, m = t.minute || 0, C = t.second || 0, P = t.millisecond || 0;
  this._isValid = isDurationValid(t), this._milliseconds = +P + C * 1e3 + // 1000
  m * 6e4 + // 1000 * 60
  p * 1e3 * 60 * 60, this._days = +c + l * 7, this._months = +s + o * 3 + n * 12, this._data = {}, this._locale = getLocale(), this._bubble();
}
function isDuration(e) {
  return e instanceof Duration;
}
function absRound(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function compareArrays(e, t, n) {
  var o = Math.min(e.length, t.length), s = Math.abs(e.length - t.length), l = 0, c;
  for (c = 0; c < o; c++)
    (n && e[c] !== t[c] || !n && toInt(e[c]) !== toInt(t[c])) && l++;
  return l + s;
}
function offset(e, t) {
  addFormatToken(e, 0, 0, function() {
    var n = this.utcOffset(), o = "+";
    return n < 0 && (n = -n, o = "-"), o + zeroFill(~~(n / 60), 2) + t + zeroFill(~~n % 60, 2);
  });
}
offset("Z", ":");
offset("ZZ", "");
addRegexToken("Z", matchShortOffset);
addRegexToken("ZZ", matchShortOffset);
addParseToken(["Z", "ZZ"], function(e, t, n) {
  n._useUTC = !0, n._tzm = offsetFromString(matchShortOffset, e);
});
var chunkOffset = /([\+\-]|\d\d)/gi;
function offsetFromString(e, t) {
  var n = (t || "").match(e), o, s, l;
  return n === null ? null : (o = n[n.length - 1] || [], s = (o + "").match(chunkOffset) || ["-", 0, 0], l = +(s[1] * 60) + toInt(s[2]), l === 0 ? 0 : s[0] === "+" ? l : -l);
}
function cloneWithOffset(e, t) {
  var n, o;
  return t._isUTC ? (n = t.clone(), o = (isMoment(e) || isDate$1(e) ? e.valueOf() : createLocal(e).valueOf()) - n.valueOf(), n._d.setTime(n._d.valueOf() + o), hooks.updateOffset(n, !1), n) : createLocal(e).local();
}
function getDateOffset(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
hooks.updateOffset = function() {
};
function getSetOffset(e, t, n) {
  var o = this._offset || 0, s;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = offsetFromString(matchShortOffset, e), e === null)
        return this;
    } else
      Math.abs(e) < 16 && !n && (e = e * 60);
    return !this._isUTC && t && (s = getDateOffset(this)), this._offset = e, this._isUTC = !0, s != null && this.add(s, "m"), o !== e && (!t || this._changeInProgress ? addSubtract(
      this,
      createDuration(e - o, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, hooks.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? o : getDateOffset(this);
}
function getSetZone(e, t) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
}
function setOffsetToUTC(e) {
  return this.utcOffset(0, e);
}
function setOffsetToLocal(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(getDateOffset(this), "m")), this;
}
function setOffsetToParsedOffset() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = offsetFromString(matchOffset, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function hasAlignedHourOffset(e) {
  return this.isValid() ? (e = e ? createLocal(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function isDaylightSavingTime() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function isDaylightSavingTimeShifted() {
  if (!isUndefined$1(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, t;
  return copyConfig(e, this), e = prepareConfig(e), e._a ? (t = e._isUTC ? createUTC(e._a) : createLocal(e._a), this._isDSTShifted = this.isValid() && compareArrays(e._a, t.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function isLocal() {
  return this.isValid() ? !this._isUTC : !1;
}
function isUtcOffset() {
  return this.isValid() ? this._isUTC : !1;
}
function isUtc() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function createDuration(e, t) {
  var n = e, o = null, s, l, c;
  return isDuration(e) ? n = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : isNumber$1(e) || !isNaN(+e) ? (n = {}, t ? n[t] = +e : n.milliseconds = +e) : (o = aspNetRegex.exec(e)) ? (s = o[1] === "-" ? -1 : 1, n = {
    y: 0,
    d: toInt(o[DATE]) * s,
    h: toInt(o[HOUR]) * s,
    m: toInt(o[MINUTE]) * s,
    s: toInt(o[SECOND]) * s,
    ms: toInt(absRound(o[MILLISECOND] * 1e3)) * s
    // the millisecond decimal point is included in the match
  }) : (o = isoRegex.exec(e)) ? (s = o[1] === "-" ? -1 : 1, n = {
    y: parseIso(o[2], s),
    M: parseIso(o[3], s),
    w: parseIso(o[4], s),
    d: parseIso(o[5], s),
    h: parseIso(o[6], s),
    m: parseIso(o[7], s),
    s: parseIso(o[8], s)
  }) : n == null ? n = {} : typeof n == "object" && ("from" in n || "to" in n) && (c = momentsDifference(
    createLocal(n.from),
    createLocal(n.to)
  ), n = {}, n.ms = c.milliseconds, n.M = c.months), l = new Duration(n), isDuration(e) && hasOwnProp(e, "_locale") && (l._locale = e._locale), isDuration(e) && hasOwnProp(e, "_isValid") && (l._isValid = e._isValid), l;
}
createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;
function parseIso(e, t) {
  var n = e && parseFloat(e.replace(",", "."));
  return (isNaN(n) ? 0 : n) * t;
}
function positiveMomentsDifference(e, t) {
  var n = {};
  return n.months = t.month() - e.month() + (t.year() - e.year()) * 12, e.clone().add(n.months, "M").isAfter(t) && --n.months, n.milliseconds = +t - +e.clone().add(n.months, "M"), n;
}
function momentsDifference(e, t) {
  var n;
  return e.isValid() && t.isValid() ? (t = cloneWithOffset(t, e), e.isBefore(t) ? n = positiveMomentsDifference(e, t) : (n = positiveMomentsDifference(t, e), n.milliseconds = -n.milliseconds, n.months = -n.months), n) : { milliseconds: 0, months: 0 };
}
function createAdder(e, t) {
  return function(n, o) {
    var s, l;
    return o !== null && !isNaN(+o) && (deprecateSimple(
      t,
      "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), l = n, n = o, o = l), s = createDuration(n, o), addSubtract(this, s, e), this;
  };
}
function addSubtract(e, t, n, o) {
  var s = t._milliseconds, l = absRound(t._days), c = absRound(t._months);
  e.isValid() && (o = o ?? !0, c && setMonth(e, get(e, "Month") + c * n), l && set$1(e, "Date", get(e, "Date") + l * n), s && e._d.setTime(e._d.valueOf() + s * n), o && hooks.updateOffset(e, l || c));
}
var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
function isString$1(e) {
  return typeof e == "string" || e instanceof String;
}
function isMomentInput(e) {
  return isMoment(e) || isDate$1(e) || isString$1(e) || isNumber$1(e) || isNumberOrStringArray(e) || isMomentInputObject(e) || e === null || e === void 0;
}
function isMomentInputObject(e) {
  var t = isObject$2(e) && !isObjectEmpty(e), n = !1, o = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], s, l, c = o.length;
  for (s = 0; s < c; s += 1)
    l = o[s], n = n || hasOwnProp(e, l);
  return t && n;
}
function isNumberOrStringArray(e) {
  var t = isArray$1(e), n = !1;
  return t && (n = e.filter(function(o) {
    return !isNumber$1(o) && isString$1(e);
  }).length === 0), t && n;
}
function isCalendarSpec(e) {
  var t = isObject$2(e) && !isObjectEmpty(e), n = !1, o = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], s, l;
  for (s = 0; s < o.length; s += 1)
    l = o[s], n = n || hasOwnProp(e, l);
  return t && n;
}
function getCalendarFormat(e, t) {
  var n = e.diff(t, "days", !0);
  return n < -6 ? "sameElse" : n < -1 ? "lastWeek" : n < 0 ? "lastDay" : n < 1 ? "sameDay" : n < 2 ? "nextDay" : n < 7 ? "nextWeek" : "sameElse";
}
function calendar$1(e, t) {
  arguments.length === 1 && (arguments[0] ? isMomentInput(arguments[0]) ? (e = arguments[0], t = void 0) : isCalendarSpec(arguments[0]) && (t = arguments[0], e = void 0) : (e = void 0, t = void 0));
  var n = e || createLocal(), o = cloneWithOffset(n, this).startOf("day"), s = hooks.calendarFormat(this, o) || "sameElse", l = t && (isFunction$3(t[s]) ? t[s].call(this, n) : t[s]);
  return this.format(
    l || this.localeData().calendar(s, this, createLocal(n))
  );
}
function clone() {
  return new Moment(this);
}
function isAfter(e, t) {
  var n = isMoment(e) ? e : createLocal(e);
  return this.isValid() && n.isValid() ? (t = normalizeUnits(t) || "millisecond", t === "millisecond" ? this.valueOf() > n.valueOf() : n.valueOf() < this.clone().startOf(t).valueOf()) : !1;
}
function isBefore(e, t) {
  var n = isMoment(e) ? e : createLocal(e);
  return this.isValid() && n.isValid() ? (t = normalizeUnits(t) || "millisecond", t === "millisecond" ? this.valueOf() < n.valueOf() : this.clone().endOf(t).valueOf() < n.valueOf()) : !1;
}
function isBetween(e, t, n, o) {
  var s = isMoment(e) ? e : createLocal(e), l = isMoment(t) ? t : createLocal(t);
  return this.isValid() && s.isValid() && l.isValid() ? (o = o || "()", (o[0] === "(" ? this.isAfter(s, n) : !this.isBefore(s, n)) && (o[1] === ")" ? this.isBefore(l, n) : !this.isAfter(l, n))) : !1;
}
function isSame(e, t) {
  var n = isMoment(e) ? e : createLocal(e), o;
  return this.isValid() && n.isValid() ? (t = normalizeUnits(t) || "millisecond", t === "millisecond" ? this.valueOf() === n.valueOf() : (o = n.valueOf(), this.clone().startOf(t).valueOf() <= o && o <= this.clone().endOf(t).valueOf())) : !1;
}
function isSameOrAfter(e, t) {
  return this.isSame(e, t) || this.isAfter(e, t);
}
function isSameOrBefore(e, t) {
  return this.isSame(e, t) || this.isBefore(e, t);
}
function diff(e, t, n) {
  var o, s, l;
  if (!this.isValid())
    return NaN;
  if (o = cloneWithOffset(e, this), !o.isValid())
    return NaN;
  switch (s = (o.utcOffset() - this.utcOffset()) * 6e4, t = normalizeUnits(t), t) {
    case "year":
      l = monthDiff(this, o) / 12;
      break;
    case "month":
      l = monthDiff(this, o);
      break;
    case "quarter":
      l = monthDiff(this, o) / 3;
      break;
    case "second":
      l = (this - o) / 1e3;
      break;
    case "minute":
      l = (this - o) / 6e4;
      break;
    case "hour":
      l = (this - o) / 36e5;
      break;
    case "day":
      l = (this - o - s) / 864e5;
      break;
    case "week":
      l = (this - o - s) / 6048e5;
      break;
    default:
      l = this - o;
  }
  return n ? l : absFloor(l);
}
function monthDiff(e, t) {
  if (e.date() < t.date())
    return -monthDiff(t, e);
  var n = (t.year() - e.year()) * 12 + (t.month() - e.month()), o = e.clone().add(n, "months"), s, l;
  return t - o < 0 ? (s = e.clone().add(n - 1, "months"), l = (t - o) / (o - s)) : (s = e.clone().add(n + 1, "months"), l = (t - o) / (s - o)), -(n + l) || 0;
}
hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function toString$1() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function toISOString(e) {
  if (!this.isValid())
    return null;
  var t = e !== !0, n = t ? this.clone().utc() : this;
  return n.year() < 0 || n.year() > 9999 ? formatMoment(
    n,
    t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : isFunction$3(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", formatMoment(n, "Z")) : formatMoment(
    n,
    t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function inspect() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", t = "", n, o, s, l;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", t = "Z"), n = "[" + e + '("]', o = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", s = "-MM-DD[T]HH:mm:ss.SSS", l = t + '[")]', this.format(n + o + s + l);
}
function format(e) {
  e || (e = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat);
  var t = formatMoment(this, e);
  return this.localeData().postformat(t);
}
function from(e, t) {
  return this.isValid() && (isMoment(e) && e.isValid() || createLocal(e).isValid()) ? createDuration({ to: this, from: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function fromNow(e) {
  return this.from(createLocal(), e);
}
function to(e, t) {
  return this.isValid() && (isMoment(e) && e.isValid() || createLocal(e).isValid()) ? createDuration({ from: this, to: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function toNow(e) {
  return this.to(createLocal(), e);
}
function locale(e) {
  var t;
  return e === void 0 ? this._locale._abbr : (t = getLocale(e), t != null && (this._locale = t), this);
}
var lang = deprecate(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function localeData() {
  return this._locale;
}
var MS_PER_SECOND = 1e3, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
function mod$1(e, t) {
  return (e % t + t) % t;
}
function localStartOfDate(e, t, n) {
  return e < 100 && e >= 0 ? new Date(e + 400, t, n) - MS_PER_400_YEARS : new Date(e, t, n).valueOf();
}
function utcStartOfDate(e, t, n) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, t, n) - MS_PER_400_YEARS : Date.UTC(e, t, n);
}
function startOf(e) {
  var t, n;
  if (e = normalizeUnits(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (n = this._isUTC ? utcStartOfDate : localStartOfDate, e) {
    case "year":
      t = n(this.year(), 0, 1);
      break;
    case "quarter":
      t = n(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      t = n(this.year(), this.month(), 1);
      break;
    case "week":
      t = n(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      t = n(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      t = n(this.year(), this.month(), this.date());
      break;
    case "hour":
      t = this._d.valueOf(), t -= mod$1(
        t + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
        MS_PER_HOUR
      );
      break;
    case "minute":
      t = this._d.valueOf(), t -= mod$1(t, MS_PER_MINUTE);
      break;
    case "second":
      t = this._d.valueOf(), t -= mod$1(t, MS_PER_SECOND);
      break;
  }
  return this._d.setTime(t), hooks.updateOffset(this, !0), this;
}
function endOf(e) {
  var t, n;
  if (e = normalizeUnits(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (n = this._isUTC ? utcStartOfDate : localStartOfDate, e) {
    case "year":
      t = n(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      t = n(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      t = n(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      t = n(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      t = n(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      t = n(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      t = this._d.valueOf(), t += MS_PER_HOUR - mod$1(
        t + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
        MS_PER_HOUR
      ) - 1;
      break;
    case "minute":
      t = this._d.valueOf(), t += MS_PER_MINUTE - mod$1(t, MS_PER_MINUTE) - 1;
      break;
    case "second":
      t = this._d.valueOf(), t += MS_PER_SECOND - mod$1(t, MS_PER_SECOND) - 1;
      break;
  }
  return this._d.setTime(t), hooks.updateOffset(this, !0), this;
}
function valueOf() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function unix() {
  return Math.floor(this.valueOf() / 1e3);
}
function toDate() {
  return new Date(this.valueOf());
}
function toArray$1() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function toObject() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function toJSON() {
  return this.isValid() ? this.toISOString() : null;
}
function isValid$2() {
  return isValid(this);
}
function parsingFlags() {
  return extend$1({}, getParsingFlags(this));
}
function invalidAt() {
  return getParsingFlags(this).overflow;
}
function creationData() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
addFormatToken("N", 0, 0, "eraAbbr");
addFormatToken("NN", 0, 0, "eraAbbr");
addFormatToken("NNN", 0, 0, "eraAbbr");
addFormatToken("NNNN", 0, 0, "eraName");
addFormatToken("NNNNN", 0, 0, "eraNarrow");
addFormatToken("y", ["y", 1], "yo", "eraYear");
addFormatToken("y", ["yy", 2], 0, "eraYear");
addFormatToken("y", ["yyy", 3], 0, "eraYear");
addFormatToken("y", ["yyyy", 4], 0, "eraYear");
addRegexToken("N", matchEraAbbr);
addRegexToken("NN", matchEraAbbr);
addRegexToken("NNN", matchEraAbbr);
addRegexToken("NNNN", matchEraName);
addRegexToken("NNNNN", matchEraNarrow);
addParseToken(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, t, n, o) {
    var s = n._locale.erasParse(e, o, n._strict);
    s ? getParsingFlags(n).era = s : getParsingFlags(n).invalidEra = e;
  }
);
addRegexToken("y", matchUnsigned);
addRegexToken("yy", matchUnsigned);
addRegexToken("yyy", matchUnsigned);
addRegexToken("yyyy", matchUnsigned);
addRegexToken("yo", matchEraYearOrdinal);
addParseToken(["y", "yy", "yyy", "yyyy"], YEAR);
addParseToken(["yo"], function(e, t, n, o) {
  var s;
  n._locale._eraYearOrdinalRegex && (s = e.match(n._locale._eraYearOrdinalRegex)), n._locale.eraYearOrdinalParse ? t[YEAR] = n._locale.eraYearOrdinalParse(e, s) : t[YEAR] = parseInt(e, 10);
});
function localeEras(e, t) {
  var n, o, s, l = this._eras || getLocale("en")._eras;
  for (n = 0, o = l.length; n < o; ++n) {
    switch (typeof l[n].since) {
      case "string":
        s = hooks(l[n].since).startOf("day"), l[n].since = s.valueOf();
        break;
    }
    switch (typeof l[n].until) {
      case "undefined":
        l[n].until = 1 / 0;
        break;
      case "string":
        s = hooks(l[n].until).startOf("day").valueOf(), l[n].until = s.valueOf();
        break;
    }
  }
  return l;
}
function localeErasParse(e, t, n) {
  var o, s, l = this.eras(), c, p, m;
  for (e = e.toUpperCase(), o = 0, s = l.length; o < s; ++o)
    if (c = l[o].name.toUpperCase(), p = l[o].abbr.toUpperCase(), m = l[o].narrow.toUpperCase(), n)
      switch (t) {
        case "N":
        case "NN":
        case "NNN":
          if (p === e)
            return l[o];
          break;
        case "NNNN":
          if (c === e)
            return l[o];
          break;
        case "NNNNN":
          if (m === e)
            return l[o];
          break;
      }
    else if ([c, p, m].indexOf(e) >= 0)
      return l[o];
}
function localeErasConvertYear(e, t) {
  var n = e.since <= e.until ? 1 : -1;
  return t === void 0 ? hooks(e.since).year() : hooks(e.since).year() + (t - e.offset) * n;
}
function getEraName() {
  var e, t, n, o = this.localeData().eras();
  for (e = 0, t = o.length; e < t; ++e)
    if (n = this.clone().startOf("day").valueOf(), o[e].since <= n && n <= o[e].until || o[e].until <= n && n <= o[e].since)
      return o[e].name;
  return "";
}
function getEraNarrow() {
  var e, t, n, o = this.localeData().eras();
  for (e = 0, t = o.length; e < t; ++e)
    if (n = this.clone().startOf("day").valueOf(), o[e].since <= n && n <= o[e].until || o[e].until <= n && n <= o[e].since)
      return o[e].narrow;
  return "";
}
function getEraAbbr() {
  var e, t, n, o = this.localeData().eras();
  for (e = 0, t = o.length; e < t; ++e)
    if (n = this.clone().startOf("day").valueOf(), o[e].since <= n && n <= o[e].until || o[e].until <= n && n <= o[e].since)
      return o[e].abbr;
  return "";
}
function getEraYear() {
  var e, t, n, o, s = this.localeData().eras();
  for (e = 0, t = s.length; e < t; ++e)
    if (n = s[e].since <= s[e].until ? 1 : -1, o = this.clone().startOf("day").valueOf(), s[e].since <= o && o <= s[e].until || s[e].until <= o && o <= s[e].since)
      return (this.year() - hooks(s[e].since).year()) * n + s[e].offset;
  return this.year();
}
function erasNameRegex(e) {
  return hasOwnProp(this, "_erasNameRegex") || computeErasParse.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function erasAbbrRegex(e) {
  return hasOwnProp(this, "_erasAbbrRegex") || computeErasParse.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function erasNarrowRegex(e) {
  return hasOwnProp(this, "_erasNarrowRegex") || computeErasParse.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function matchEraAbbr(e, t) {
  return t.erasAbbrRegex(e);
}
function matchEraName(e, t) {
  return t.erasNameRegex(e);
}
function matchEraNarrow(e, t) {
  return t.erasNarrowRegex(e);
}
function matchEraYearOrdinal(e, t) {
  return t._eraYearOrdinalRegex || matchUnsigned;
}
function computeErasParse() {
  var e = [], t = [], n = [], o = [], s, l, c, p, m, C = this.eras();
  for (s = 0, l = C.length; s < l; ++s)
    c = regexEscape(C[s].name), p = regexEscape(C[s].abbr), m = regexEscape(C[s].narrow), t.push(c), e.push(p), n.push(m), o.push(c), o.push(p), o.push(m);
  this._erasRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  );
}
addFormatToken(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
addFormatToken(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function addWeekYearFormatToken(e, t) {
  addFormatToken(0, [e, e.length], 0, t);
}
addWeekYearFormatToken("gggg", "weekYear");
addWeekYearFormatToken("ggggg", "weekYear");
addWeekYearFormatToken("GGGG", "isoWeekYear");
addWeekYearFormatToken("GGGGG", "isoWeekYear");
addRegexToken("G", matchSigned);
addRegexToken("g", matchSigned);
addRegexToken("GG", match1to2, match2);
addRegexToken("gg", match1to2, match2);
addRegexToken("GGGG", match1to4, match4);
addRegexToken("gggg", match1to4, match4);
addRegexToken("GGGGG", match1to6, match6);
addRegexToken("ggggg", match1to6, match6);
addWeekParseToken(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, t, n, o) {
    t[o.substr(0, 2)] = toInt(e);
  }
);
addWeekParseToken(["gg", "GG"], function(e, t, n, o) {
  t[o] = hooks.parseTwoDigitYear(e);
});
function getSetWeekYear(e) {
  return getSetWeekYearHelper.call(
    this,
    e,
    this.week(),
    this.weekday() + this.localeData()._week.dow,
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function getSetISOWeekYear(e) {
  return getSetWeekYearHelper.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function getISOWeeksInYear() {
  return weeksInYear(this.year(), 1, 4);
}
function getISOWeeksInISOWeekYear() {
  return weeksInYear(this.isoWeekYear(), 1, 4);
}
function getWeeksInYear() {
  var e = this.localeData()._week;
  return weeksInYear(this.year(), e.dow, e.doy);
}
function getWeeksInWeekYear() {
  var e = this.localeData()._week;
  return weeksInYear(this.weekYear(), e.dow, e.doy);
}
function getSetWeekYearHelper(e, t, n, o, s) {
  var l;
  return e == null ? weekOfYear(this, o, s).year : (l = weeksInYear(e, o, s), t > l && (t = l), setWeekAll.call(this, e, t, n, o, s));
}
function setWeekAll(e, t, n, o, s) {
  var l = dayOfYearFromWeeks(e, t, n, o, s), c = createUTCDate(l.year, 0, l.dayOfYear);
  return this.year(c.getUTCFullYear()), this.month(c.getUTCMonth()), this.date(c.getUTCDate()), this;
}
addFormatToken("Q", 0, "Qo", "quarter");
addRegexToken("Q", match1);
addParseToken("Q", function(e, t) {
  t[MONTH] = (toInt(e) - 1) * 3;
});
function getSetQuarter(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
addFormatToken("D", ["DD", 2], "Do", "date");
addRegexToken("D", match1to2, match1to2NoLeadingZero);
addRegexToken("DD", match1to2, match2);
addRegexToken("Do", function(e, t) {
  return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
});
addParseToken(["D", "DD"], DATE);
addParseToken("Do", function(e, t) {
  t[DATE] = toInt(e.match(match1to2)[0]);
});
var getSetDayOfMonth = makeGetSet("Date", !0);
addFormatToken("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
addRegexToken("DDD", match1to3);
addRegexToken("DDDD", match3);
addParseToken(["DDD", "DDDD"], function(e, t, n) {
  n._dayOfYear = toInt(e);
});
function getSetDayOfYear(e) {
  var t = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? t : this.add(e - t, "d");
}
addFormatToken("m", ["mm", 2], 0, "minute");
addRegexToken("m", match1to2, match1to2HasZero);
addRegexToken("mm", match1to2, match2);
addParseToken(["m", "mm"], MINUTE);
var getSetMinute = makeGetSet("Minutes", !1);
addFormatToken("s", ["ss", 2], 0, "second");
addRegexToken("s", match1to2, match1to2HasZero);
addRegexToken("ss", match1to2, match2);
addParseToken(["s", "ss"], SECOND);
var getSetSecond = makeGetSet("Seconds", !1);
addFormatToken("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
addFormatToken(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
addFormatToken(0, ["SSS", 3], 0, "millisecond");
addFormatToken(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
addFormatToken(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
addFormatToken(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
addFormatToken(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
addFormatToken(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
addFormatToken(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
addRegexToken("S", match1to3, match1);
addRegexToken("SS", match1to3, match2);
addRegexToken("SSS", match1to3, match3);
var token, getSetMillisecond;
for (token = "SSSS"; token.length <= 9; token += "S")
  addRegexToken(token, matchUnsigned);
function parseMs(e, t) {
  t[MILLISECOND] = toInt(("0." + e) * 1e3);
}
for (token = "S"; token.length <= 9; token += "S")
  addParseToken(token, parseMs);
getSetMillisecond = makeGetSet("Milliseconds", !1);
addFormatToken("z", 0, 0, "zoneAbbr");
addFormatToken("zz", 0, 0, "zoneName");
function getZoneAbbr() {
  return this._isUTC ? "UTC" : "";
}
function getZoneName() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var proto = Moment.prototype;
proto.add = add;
proto.calendar = calendar$1;
proto.clone = clone;
proto.diff = diff;
proto.endOf = endOf;
proto.format = format;
proto.from = from;
proto.fromNow = fromNow;
proto.to = to;
proto.toNow = toNow;
proto.get = stringGet;
proto.invalidAt = invalidAt;
proto.isAfter = isAfter;
proto.isBefore = isBefore;
proto.isBetween = isBetween;
proto.isSame = isSame;
proto.isSameOrAfter = isSameOrAfter;
proto.isSameOrBefore = isSameOrBefore;
proto.isValid = isValid$2;
proto.lang = lang;
proto.locale = locale;
proto.localeData = localeData;
proto.max = prototypeMax;
proto.min = prototypeMin;
proto.parsingFlags = parsingFlags;
proto.set = stringSet;
proto.startOf = startOf;
proto.subtract = subtract;
proto.toArray = toArray$1;
proto.toObject = toObject;
proto.toDate = toDate;
proto.toISOString = toISOString;
proto.inspect = inspect;
typeof Symbol < "u" && Symbol.for != null && (proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
proto.toJSON = toJSON;
proto.toString = toString$1;
proto.unix = unix;
proto.valueOf = valueOf;
proto.creationData = creationData;
proto.eraName = getEraName;
proto.eraNarrow = getEraNarrow;
proto.eraAbbr = getEraAbbr;
proto.eraYear = getEraYear;
proto.year = getSetYear;
proto.isLeapYear = getIsLeapYear;
proto.weekYear = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;
proto.quarter = proto.quarters = getSetQuarter;
proto.month = getSetMonth;
proto.daysInMonth = getDaysInMonth;
proto.week = proto.weeks = getSetWeek;
proto.isoWeek = proto.isoWeeks = getSetISOWeek;
proto.weeksInYear = getWeeksInYear;
proto.weeksInWeekYear = getWeeksInWeekYear;
proto.isoWeeksInYear = getISOWeeksInYear;
proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
proto.date = getSetDayOfMonth;
proto.day = proto.days = getSetDayOfWeek;
proto.weekday = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear = getSetDayOfYear;
proto.hour = proto.hours = getSetHour;
proto.minute = proto.minutes = getSetMinute;
proto.second = proto.seconds = getSetSecond;
proto.millisecond = proto.milliseconds = getSetMillisecond;
proto.utcOffset = getSetOffset;
proto.utc = setOffsetToUTC;
proto.local = setOffsetToLocal;
proto.parseZone = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST = isDaylightSavingTime;
proto.isLocal = isLocal;
proto.isUtcOffset = isUtcOffset;
proto.isUtc = isUtc;
proto.isUTC = isUtc;
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;
proto.dates = deprecate(
  "dates accessor is deprecated. Use date instead.",
  getSetDayOfMonth
);
proto.months = deprecate(
  "months accessor is deprecated. Use month instead",
  getSetMonth
);
proto.years = deprecate(
  "years accessor is deprecated. Use year instead",
  getSetYear
);
proto.zone = deprecate(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  getSetZone
);
proto.isDSTShifted = deprecate(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  isDaylightSavingTimeShifted
);
function createUnix(e) {
  return createLocal(e * 1e3);
}
function createInZone() {
  return createLocal.apply(null, arguments).parseZone();
}
function preParsePostFormat(e) {
  return e;
}
var proto$1 = Locale.prototype;
proto$1.calendar = calendar;
proto$1.longDateFormat = longDateFormat;
proto$1.invalidDate = invalidDate;
proto$1.ordinal = ordinal;
proto$1.preparse = preParsePostFormat;
proto$1.postformat = preParsePostFormat;
proto$1.relativeTime = relativeTime;
proto$1.pastFuture = pastFuture;
proto$1.set = set;
proto$1.eras = localeEras;
proto$1.erasParse = localeErasParse;
proto$1.erasConvertYear = localeErasConvertYear;
proto$1.erasAbbrRegex = erasAbbrRegex;
proto$1.erasNameRegex = erasNameRegex;
proto$1.erasNarrowRegex = erasNarrowRegex;
proto$1.months = localeMonths;
proto$1.monthsShort = localeMonthsShort;
proto$1.monthsParse = localeMonthsParse;
proto$1.monthsRegex = monthsRegex;
proto$1.monthsShortRegex = monthsShortRegex;
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;
proto$1.weekdays = localeWeekdays;
proto$1.weekdaysMin = localeWeekdaysMin;
proto$1.weekdaysShort = localeWeekdaysShort;
proto$1.weekdaysParse = localeWeekdaysParse;
proto$1.weekdaysRegex = weekdaysRegex;
proto$1.weekdaysShortRegex = weekdaysShortRegex;
proto$1.weekdaysMinRegex = weekdaysMinRegex;
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;
function get$1(e, t, n, o) {
  var s = getLocale(), l = createUTC().set(o, t);
  return s[n](l, e);
}
function listMonthsImpl(e, t, n) {
  if (isNumber$1(e) && (t = e, e = void 0), e = e || "", t != null)
    return get$1(e, t, n, "month");
  var o, s = [];
  for (o = 0; o < 12; o++)
    s[o] = get$1(e, o, n, "month");
  return s;
}
function listWeekdaysImpl(e, t, n, o) {
  typeof e == "boolean" ? (isNumber$1(t) && (n = t, t = void 0), t = t || "") : (t = e, n = t, e = !1, isNumber$1(t) && (n = t, t = void 0), t = t || "");
  var s = getLocale(), l = e ? s._week.dow : 0, c, p = [];
  if (n != null)
    return get$1(t, (n + l) % 7, o, "day");
  for (c = 0; c < 7; c++)
    p[c] = get$1(t, (c + l) % 7, o, "day");
  return p;
}
function listMonths(e, t) {
  return listMonthsImpl(e, t, "months");
}
function listMonthsShort(e, t) {
  return listMonthsImpl(e, t, "monthsShort");
}
function listWeekdays(e, t, n) {
  return listWeekdaysImpl(e, t, n, "weekdays");
}
function listWeekdaysShort(e, t, n) {
  return listWeekdaysImpl(e, t, n, "weekdaysShort");
}
function listWeekdaysMin(e, t, n) {
  return listWeekdaysImpl(e, t, n, "weekdaysMin");
}
getSetGlobalLocale("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var t = e % 10, n = toInt(e % 100 / 10) === 1 ? "th" : t === 1 ? "st" : t === 2 ? "nd" : t === 3 ? "rd" : "th";
    return e + n;
  }
});
hooks.lang = deprecate(
  "moment.lang is deprecated. Use moment.locale instead.",
  getSetGlobalLocale
);
hooks.langData = deprecate(
  "moment.langData is deprecated. Use moment.localeData instead.",
  getLocale
);
var mathAbs = Math.abs;
function abs() {
  var e = this._data;
  return this._milliseconds = mathAbs(this._milliseconds), this._days = mathAbs(this._days), this._months = mathAbs(this._months), e.milliseconds = mathAbs(e.milliseconds), e.seconds = mathAbs(e.seconds), e.minutes = mathAbs(e.minutes), e.hours = mathAbs(e.hours), e.months = mathAbs(e.months), e.years = mathAbs(e.years), this;
}
function addSubtract$1(e, t, n, o) {
  var s = createDuration(t, n);
  return e._milliseconds += o * s._milliseconds, e._days += o * s._days, e._months += o * s._months, e._bubble();
}
function add$1(e, t) {
  return addSubtract$1(this, e, t, 1);
}
function subtract$1(e, t) {
  return addSubtract$1(this, e, t, -1);
}
function absCeil(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function bubble() {
  var e = this._milliseconds, t = this._days, n = this._months, o = this._data, s, l, c, p, m;
  return e >= 0 && t >= 0 && n >= 0 || e <= 0 && t <= 0 && n <= 0 || (e += absCeil(monthsToDays(n) + t) * 864e5, t = 0, n = 0), o.milliseconds = e % 1e3, s = absFloor(e / 1e3), o.seconds = s % 60, l = absFloor(s / 60), o.minutes = l % 60, c = absFloor(l / 60), o.hours = c % 24, t += absFloor(c / 24), m = absFloor(daysToMonths(t)), n += m, t -= absCeil(monthsToDays(m)), p = absFloor(n / 12), n %= 12, o.days = t, o.months = n, o.years = p, this;
}
function daysToMonths(e) {
  return e * 4800 / 146097;
}
function monthsToDays(e) {
  return e * 146097 / 4800;
}
function as(e) {
  if (!this.isValid())
    return NaN;
  var t, n, o = this._milliseconds;
  if (e = normalizeUnits(e), e === "month" || e === "quarter" || e === "year")
    switch (t = this._days + o / 864e5, n = this._months + daysToMonths(t), e) {
      case "month":
        return n;
      case "quarter":
        return n / 3;
      case "year":
        return n / 12;
    }
  else
    switch (t = this._days + Math.round(monthsToDays(this._months)), e) {
      case "week":
        return t / 7 + o / 6048e5;
      case "day":
        return t + o / 864e5;
      case "hour":
        return t * 24 + o / 36e5;
      case "minute":
        return t * 1440 + o / 6e4;
      case "second":
        return t * 86400 + o / 1e3;
      case "millisecond":
        return Math.floor(t * 864e5) + o;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function makeAs(e) {
  return function() {
    return this.as(e);
  };
}
var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
function clone$1() {
  return createDuration(this);
}
function get$2(e) {
  return e = normalizeUnits(e), this.isValid() ? this[e + "s"]() : NaN;
}
function makeGetter(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
function weeks() {
  return absFloor(this.days() / 7);
}
var round = Math.round, thresholds = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function substituteTimeAgo(e, t, n, o, s) {
  return s.relativeTime(t || 1, !!n, e, o);
}
function relativeTime$1(e, t, n, o) {
  var s = createDuration(e).abs(), l = round(s.as("s")), c = round(s.as("m")), p = round(s.as("h")), m = round(s.as("d")), C = round(s.as("M")), P = round(s.as("w")), w = round(s.as("y")), R = l <= n.ss && ["s", l] || l < n.s && ["ss", l] || c <= 1 && ["m"] || c < n.m && ["mm", c] || p <= 1 && ["h"] || p < n.h && ["hh", p] || m <= 1 && ["d"] || m < n.d && ["dd", m];
  return n.w != null && (R = R || P <= 1 && ["w"] || P < n.w && ["ww", P]), R = R || C <= 1 && ["M"] || C < n.M && ["MM", C] || w <= 1 && ["y"] || ["yy", w], R[2] = t, R[3] = +e > 0, R[4] = o, substituteTimeAgo.apply(null, R);
}
function getSetRelativeTimeRounding(e) {
  return e === void 0 ? round : typeof e == "function" ? (round = e, !0) : !1;
}
function getSetRelativeTimeThreshold(e, t) {
  return thresholds[e] === void 0 ? !1 : t === void 0 ? thresholds[e] : (thresholds[e] = t, e === "s" && (thresholds.ss = t - 1), !0);
}
function humanize(e, t) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var n = !1, o = thresholds, s, l;
  return typeof e == "object" && (t = e, e = !1), typeof e == "boolean" && (n = e), typeof t == "object" && (o = Object.assign({}, thresholds, t), t.s != null && t.ss == null && (o.ss = t.s - 1)), s = this.localeData(), l = relativeTime$1(this, !n, o, s), n && (l = s.pastFuture(+this, l)), s.postformat(l);
}
var abs$1 = Math.abs;
function sign(e) {
  return (e > 0) - (e < 0) || +e;
}
function toISOString$1() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = abs$1(this._milliseconds) / 1e3, t = abs$1(this._days), n = abs$1(this._months), o, s, l, c, p = this.asSeconds(), m, C, P, w;
  return p ? (o = absFloor(e / 60), s = absFloor(o / 60), e %= 60, o %= 60, l = absFloor(n / 12), n %= 12, c = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", m = p < 0 ? "-" : "", C = sign(this._months) !== sign(p) ? "-" : "", P = sign(this._days) !== sign(p) ? "-" : "", w = sign(this._milliseconds) !== sign(p) ? "-" : "", m + "P" + (l ? C + l + "Y" : "") + (n ? C + n + "M" : "") + (t ? P + t + "D" : "") + (s || o || e ? "T" : "") + (s ? w + s + "H" : "") + (o ? w + o + "M" : "") + (e ? w + c + "S" : "")) : "P0D";
}
var proto$2 = Duration.prototype;
proto$2.isValid = isValid$1;
proto$2.abs = abs;
proto$2.add = add$1;
proto$2.subtract = subtract$1;
proto$2.as = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds = asSeconds;
proto$2.asMinutes = asMinutes;
proto$2.asHours = asHours;
proto$2.asDays = asDays;
proto$2.asWeeks = asWeeks;
proto$2.asMonths = asMonths;
proto$2.asQuarters = asQuarters;
proto$2.asYears = asYears;
proto$2.valueOf = valueOf$1;
proto$2._bubble = bubble;
proto$2.clone = clone$1;
proto$2.get = get$2;
proto$2.milliseconds = milliseconds;
proto$2.seconds = seconds;
proto$2.minutes = minutes;
proto$2.hours = hours;
proto$2.days = days;
proto$2.weeks = weeks;
proto$2.months = months;
proto$2.years = years;
proto$2.humanize = humanize;
proto$2.toISOString = toISOString$1;
proto$2.toString = toISOString$1;
proto$2.toJSON = toISOString$1;
proto$2.locale = locale;
proto$2.localeData = localeData;
proto$2.toIsoString = deprecate(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  toISOString$1
);
proto$2.lang = lang;
addFormatToken("X", 0, 0, "unix");
addFormatToken("x", 0, 0, "valueOf");
addRegexToken("x", matchSigned);
addRegexToken("X", matchTimestamp);
addParseToken("X", function(e, t, n) {
  n._d = new Date(parseFloat(e) * 1e3);
});
addParseToken("x", function(e, t, n) {
  n._d = new Date(toInt(e));
});
//! moment.js
hooks.version = "2.30.1";
setHookCallback(createLocal);
hooks.fn = proto;
hooks.min = min;
hooks.max = max;
hooks.now = now;
hooks.utc = createUTC;
hooks.unix = createUnix;
hooks.months = listMonths;
hooks.isDate = isDate$1;
hooks.locale = getSetGlobalLocale;
hooks.invalid = createInvalid;
hooks.duration = createDuration;
hooks.isMoment = isMoment;
hooks.weekdays = listWeekdays;
hooks.parseZone = createInZone;
hooks.localeData = getLocale;
hooks.isDuration = isDuration;
hooks.monthsShort = listMonthsShort;
hooks.weekdaysMin = listWeekdaysMin;
hooks.defineLocale = defineLocale;
hooks.updateLocale = updateLocale;
hooks.locales = listLocales;
hooks.weekdaysShort = listWeekdaysShort;
hooks.normalizeUnits = normalizeUnits;
hooks.relativeTimeRounding = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat = getCalendarFormat;
hooks.prototype = proto;
hooks.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const NCCountdown$1 = "", FORMATTED_COUNTDOWN_FUNCTIONS = {
  d: (e) => Math.floor(e.asDays()),
  h: (e) => Math.floor(e.asHours() % 24),
  m: (e) => Math.floor(e.asMinutes() % 60),
  s: (e) => Math.floor(e.asDays() % 60)
}, DEFAULT_FORMAT = {
  d: "d",
  h: "h",
  m: "m",
  s: "s"
}, NCCountdown = (e) => {
  const [t, n] = useState(), o = hooks(e.datetime), s = e.stringFormat ? e.stringFormat : DEFAULT_FORMAT, l = e.refreshInterval ? e.refreshInterval : 1e3, c = (p) => {
    const m = hooks.utc(), C = hooks.duration(o.diff(m));
    if (C) {
      const P = {};
      for (const [w, R] of Object.entries(s))
        Object.assign(P, { [R]: FORMATTED_COUNTDOWN_FUNCTIONS[w](C) });
      return { ...P };
    }
    p && clearInterval(p);
  };
  return useEffect(() => {
    n(c());
    const p = setInterval(() => {
      n(c(p));
    }, l);
    return () => clearInterval(p);
  }, []), /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "nc-countdown", children: [
    t && Object.entries(t).map(
      ([p, m]) => /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "digit", children: m }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "formatted-text", children: p })
      ] }, p)
    ),
    e.text
  ] });
}, NCDialog$1 = "";
function GoogleIcon(e) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "20", height: "20", fill: "url(#pattern0)" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("defs", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("pattern", { id: "pattern0", patternContentUnits: "objectBoundingBox", width: "1", height: "1", children: /* @__PURE__ */ jsxRuntimeExports.jsx("use", { href: "#image0", transform: "scale(0.00195312)" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("image", { id: "image0", width: "512", height: "512", href: "data:image/png;base64,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" })
    ] })
  ] });
}
function TimesIcon(e) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.586 8L1.293 2.707l1.414-1.414L8 6.586l5.293-5.293 1.414 1.414L9.414 8l5.293 5.293-1.414 1.414L8 9.414l-5.293 5.293-1.414-1.414L6.586 8z", fill: "#fff", stroke: "" }) });
}
const NCDialog = (e) => {
  const t = { top: 0, right: 0, bottom: 0, left: 0 };
  if (e.show === !1)
    return null;
  const n = () => {
    e.setShow(!1);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: "nc-dialog",
      "data-testid": "nc-dialog",
      onClick: () => !e.noClose && n(),
      style: e.position ? e.position : t,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "div",
        {
          className: `dialog-content ${e.noPadding ? "no-padding" : ""}`,
          onClick: (o) => o.stopPropagation(),
          style: {
            backgroundImage: "url(https://assets.next.wolfiesports.com/media/shared-library/background/dialog-background.png)"
          },
          children: [
            !e.noHeader && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "dialog-header", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "dialog-title", children: e.title }),
              !e.noClose && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "dialog-close", onClick: () => n(), children: /* @__PURE__ */ jsxRuntimeExports.jsx(TimesIcon, {}) })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `dialog-body ${e.wildBody ? "w-100 p-0" : ""}`, children: e.children })
          ]
        }
      )
    }
  );
};
var __assign$4 = function() {
  return __assign$4 = Object.assign || function(t) {
    for (var n, o = 1, s = arguments.length; o < s; o++) {
      n = arguments[o];
      for (var l in n)
        Object.prototype.hasOwnProperty.call(n, l) && (t[l] = n[l]);
    }
    return t;
  }, __assign$4.apply(this, arguments);
};
function __rest$1(e, t) {
  var n = {};
  for (var o in e)
    Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var s = 0, o = Object.getOwnPropertySymbols(e); s < o.length; s++)
      t.indexOf(o[s]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[s]) && (n[o[s]] = e[o[s]]);
  return n;
}
function __awaiter(e, t, n, o) {
  function s(l) {
    return l instanceof n ? l : new n(function(c) {
      c(l);
    });
  }
  return new (n || (n = Promise))(function(l, c) {
    function p(P) {
      try {
        C(o.next(P));
      } catch (w) {
        c(w);
      }
    }
    function m(P) {
      try {
        C(o.throw(P));
      } catch (w) {
        c(w);
      }
    }
    function C(P) {
      P.done ? l(P.value) : s(P.value).then(p, m);
    }
    C((o = o.apply(e, t || [])).next());
  });
}
function __generator(e, t) {
  var n = { label: 0, sent: function() {
    if (l[0] & 1)
      throw l[1];
    return l[1];
  }, trys: [], ops: [] }, o, s, l, c;
  return c = { next: p(0), throw: p(1), return: p(2) }, typeof Symbol == "function" && (c[Symbol.iterator] = function() {
    return this;
  }), c;
  function p(C) {
    return function(P) {
      return m([C, P]);
    };
  }
  function m(C) {
    if (o)
      throw new TypeError("Generator is already executing.");
    for (; c && (c = 0, C[0] && (n = 0)), n; )
      try {
        if (o = 1, s && (l = C[0] & 2 ? s.return : C[0] ? s.throw || ((l = s.return) && l.call(s), 0) : s.next) && !(l = l.call(s, C[1])).done)
          return l;
        switch (s = 0, l && (C = [C[0] & 2, l.value]), C[0]) {
          case 0:
          case 1:
            l = C;
            break;
          case 4:
            return n.label++, { value: C[1], done: !1 };
          case 5:
            n.label++, s = C[1], C = [0];
            continue;
          case 7:
            C = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (l = n.trys, !(l = l.length > 0 && l[l.length - 1]) && (C[0] === 6 || C[0] === 2)) {
              n = 0;
              continue;
            }
            if (C[0] === 3 && (!l || C[1] > l[0] && C[1] < l[3])) {
              n.label = C[1];
              break;
            }
            if (C[0] === 6 && n.label < l[1]) {
              n.label = l[1], l = C;
              break;
            }
            if (l && n.label < l[2]) {
              n.label = l[2], n.ops.push(C);
              break;
            }
            l[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        C = t.call(e, n);
      } catch (P) {
        C = [6, P], s = 0;
      } finally {
        o = l = 0;
      }
    if (C[0] & 5)
      throw C[1];
    return { value: C[0] ? C[1] : void 0, done: !0 };
  }
}
function __read(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var o = n.call(e), s, l = [], c;
  try {
    for (; (t === void 0 || t-- > 0) && !(s = o.next()).done; )
      l.push(s.value);
  } catch (p) {
    c = { error: p };
  } finally {
    try {
      s && !s.done && (n = o.return) && n.call(o);
    } finally {
      if (c)
        throw c.error;
    }
  }
  return l;
}
function __spreadArray(e, t, n) {
  if (n || arguments.length === 2)
    for (var o = 0, s = t.length, l; o < s; o++)
      (l || !(o in t)) && (l || (l = Array.prototype.slice.call(t, 0, o)), l[o] = t[o]);
  return e.concat(l || Array.prototype.slice.call(t));
}
typeof SuppressedError == "function" && SuppressedError;
var COMMON_MIME_TYPES = /* @__PURE__ */ new Map([
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
  ["aac", "audio/aac"],
  ["abw", "application/x-abiword"],
  ["arc", "application/x-freearc"],
  ["avif", "image/avif"],
  ["avi", "video/x-msvideo"],
  ["azw", "application/vnd.amazon.ebook"],
  ["bin", "application/octet-stream"],
  ["bmp", "image/bmp"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["cda", "application/x-cdf"],
  ["csh", "application/x-csh"],
  ["css", "text/css"],
  ["csv", "text/csv"],
  ["doc", "application/msword"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["eot", "application/vnd.ms-fontobject"],
  ["epub", "application/epub+zip"],
  ["gz", "application/gzip"],
  ["gif", "image/gif"],
  ["heic", "image/heic"],
  ["heif", "image/heif"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["ico", "image/vnd.microsoft.icon"],
  ["ics", "text/calendar"],
  ["jar", "application/java-archive"],
  ["jpeg", "image/jpeg"],
  ["jpg", "image/jpeg"],
  ["js", "text/javascript"],
  ["json", "application/json"],
  ["jsonld", "application/ld+json"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mjs", "text/javascript"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mpeg", "video/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["opus", "audio/opus"],
  ["otf", "font/otf"],
  ["png", "image/png"],
  ["pdf", "application/pdf"],
  ["php", "application/x-httpd-php"],
  ["ppt", "application/vnd.ms-powerpoint"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["rar", "application/vnd.rar"],
  ["rtf", "application/rtf"],
  ["sh", "application/x-sh"],
  ["svg", "image/svg+xml"],
  ["swf", "application/x-shockwave-flash"],
  ["tar", "application/x-tar"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["ts", "video/mp2t"],
  ["ttf", "font/ttf"],
  ["txt", "text/plain"],
  ["vsd", "application/vnd.visio"],
  ["wav", "audio/wav"],
  ["weba", "audio/webm"],
  ["webm", "video/webm"],
  ["webp", "image/webp"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["xhtml", "application/xhtml+xml"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xml", "application/xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["zip", "application/zip"],
  ["7z", "application/x-7z-compressed"],
  // Others
  ["mkv", "video/x-matroska"],
  ["mov", "video/quicktime"],
  ["msg", "application/vnd.ms-outlook"]
]);
function toFileWithPath(e, t) {
  var n = withMimeType(e);
  if (typeof n.path != "string") {
    var o = e.webkitRelativePath;
    Object.defineProperty(n, "path", {
      value: typeof t == "string" ? t : typeof o == "string" && o.length > 0 ? o : e.name,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return n;
}
function withMimeType(e) {
  var t = e.name, n = t && t.lastIndexOf(".") !== -1;
  if (n && !e.type) {
    var o = t.split(".").pop().toLowerCase(), s = COMMON_MIME_TYPES.get(o);
    s && Object.defineProperty(e, "type", {
      value: s,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return e;
}
var FILES_TO_IGNORE = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  "Thumbs.db"
  // Windows
];
function fromEvent(e) {
  return __awaiter(this, void 0, void 0, function() {
    return __generator(this, function(t) {
      return isObject$1(e) && isDataTransfer(e.dataTransfer) ? [2, getDataTransferFiles(e.dataTransfer, e.type)] : isChangeEvt(e) ? [2, getInputFiles(e)] : Array.isArray(e) && e.every(function(n) {
        return "getFile" in n && typeof n.getFile == "function";
      }) ? [2, getFsHandleFiles(e)] : [2, []];
    });
  });
}
function isDataTransfer(e) {
  return isObject$1(e);
}
function isChangeEvt(e) {
  return isObject$1(e) && isObject$1(e.target);
}
function isObject$1(e) {
  return typeof e == "object" && e !== null;
}
function getInputFiles(e) {
  return fromList(e.target.files).map(function(t) {
    return toFileWithPath(t);
  });
}
function getFsHandleFiles(e) {
  return __awaiter(this, void 0, void 0, function() {
    var t;
    return __generator(this, function(n) {
      switch (n.label) {
        case 0:
          return [4, Promise.all(e.map(function(o) {
            return o.getFile();
          }))];
        case 1:
          return t = n.sent(), [2, t.map(function(o) {
            return toFileWithPath(o);
          })];
      }
    });
  });
}
function getDataTransferFiles(e, t) {
  return __awaiter(this, void 0, void 0, function() {
    var n, o;
    return __generator(this, function(s) {
      switch (s.label) {
        case 0:
          return e.items ? (n = fromList(e.items).filter(function(l) {
            return l.kind === "file";
          }), t !== "drop" ? [2, n] : [4, Promise.all(n.map(toFilePromises))]) : [3, 2];
        case 1:
          return o = s.sent(), [2, noIgnoredFiles(flatten(o))];
        case 2:
          return [2, noIgnoredFiles(fromList(e.files).map(function(l) {
            return toFileWithPath(l);
          }))];
      }
    });
  });
}
function noIgnoredFiles(e) {
  return e.filter(function(t) {
    return FILES_TO_IGNORE.indexOf(t.name) === -1;
  });
}
function fromList(e) {
  if (e === null)
    return [];
  for (var t = [], n = 0; n < e.length; n++) {
    var o = e[n];
    t.push(o);
  }
  return t;
}
function toFilePromises(e) {
  if (typeof e.webkitGetAsEntry != "function")
    return fromDataTransferItem(e);
  var t = e.webkitGetAsEntry();
  return t && t.isDirectory ? fromDirEntry(t) : fromDataTransferItem(e);
}
function flatten(e) {
  return e.reduce(function(t, n) {
    return __spreadArray(__spreadArray([], __read(t), !1), __read(Array.isArray(n) ? flatten(n) : [n]), !1);
  }, []);
}
function fromDataTransferItem(e) {
  var t = e.getAsFile();
  if (!t)
    return Promise.reject("".concat(e, " is not a File"));
  var n = toFileWithPath(t);
  return Promise.resolve(n);
}
function fromEntry(e) {
  return __awaiter(this, void 0, void 0, function() {
    return __generator(this, function(t) {
      return [2, e.isDirectory ? fromDirEntry(e) : fromFileEntry(e)];
    });
  });
}
function fromDirEntry(e) {
  var t = e.createReader();
  return new Promise(function(n, o) {
    var s = [];
    function l() {
      var c = this;
      t.readEntries(function(p) {
        return __awaiter(c, void 0, void 0, function() {
          var m, C, P;
          return __generator(this, function(w) {
            switch (w.label) {
              case 0:
                if (p.length)
                  return [3, 5];
                w.label = 1;
              case 1:
                return w.trys.push([1, 3, , 4]), [4, Promise.all(s)];
              case 2:
                return m = w.sent(), n(m), [3, 4];
              case 3:
                return C = w.sent(), o(C), [3, 4];
              case 4:
                return [3, 6];
              case 5:
                P = Promise.all(p.map(fromEntry)), s.push(P), l(), w.label = 6;
              case 6:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, function(p) {
        o(p);
      });
    }
    l();
  });
}
function fromFileEntry(e) {
  return __awaiter(this, void 0, void 0, function() {
    return __generator(this, function(t) {
      return [2, new Promise(function(n, o) {
        e.file(function(s) {
          var l = toFileWithPath(s, e.fullPath);
          n(l);
        }, function(s) {
          o(s);
        });
      })];
    });
  });
}
var _default = function(e, t) {
  if (e && t) {
    var n = Array.isArray(t) ? t : t.split(","), o = e.name || "", s = (e.type || "").toLowerCase(), l = s.replace(/\/.*$/, "");
    return n.some(function(c) {
      var p = c.trim().toLowerCase();
      return p.charAt(0) === "." ? o.toLowerCase().endsWith(p) : p.endsWith("/*") ? l === p.replace(/\/.*$/, "") : s === p;
    });
  }
  return !0;
};
function _toConsumableArray$1(e) {
  return _arrayWithoutHoles$1(e) || _iterableToArray$1(e) || _unsupportedIterableToArray$1(e) || _nonIterableSpread$1();
}
function _nonIterableSpread$1() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArray$1(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function _arrayWithoutHoles$1(e) {
  if (Array.isArray(e))
    return _arrayLikeToArray$1(e);
}
function ownKeys$1(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function _objectSpread$1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$1(Object(n), !0).forEach(function(o) {
      _defineProperty$2(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ownKeys$1(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function _defineProperty$2(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function _slicedToArray$1(e, t) {
  return _arrayWithHoles$1(e) || _iterableToArrayLimit$1(e, t) || _unsupportedIterableToArray$1(e, t) || _nonIterableRest$1();
}
function _nonIterableRest$1() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$1(e, t) {
  if (e) {
    if (typeof e == "string")
      return _arrayLikeToArray$1(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$1(e, t);
  }
}
function _arrayLikeToArray$1(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = new Array(t); n < t; n++)
    o[n] = e[n];
  return o;
}
function _iterableToArrayLimit$1(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var o = [], s = !0, l = !1, c, p;
    try {
      for (n = n.call(e); !(s = (c = n.next()).done) && (o.push(c.value), !(t && o.length === t)); s = !0)
        ;
    } catch (m) {
      l = !0, p = m;
    } finally {
      try {
        !s && n.return != null && n.return();
      } finally {
        if (l)
          throw p;
      }
    }
    return o;
  }
}
function _arrayWithHoles$1(e) {
  if (Array.isArray(e))
    return e;
}
var FILE_INVALID_TYPE = "file-invalid-type", FILE_TOO_LARGE = "file-too-large", FILE_TOO_SMALL = "file-too-small", TOO_MANY_FILES = "too-many-files", getInvalidTypeRejectionErr = function(t) {
  t = Array.isArray(t) && t.length === 1 ? t[0] : t;
  var n = Array.isArray(t) ? "one of ".concat(t.join(", ")) : t;
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(n)
  };
}, getTooLargeRejectionErr = function(t) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, getTooSmallRejectionErr = function(t) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: "Too many files"
};
function fileAccepted(e, t) {
  var n = e.type === "application/x-moz-file" || _default(e, t);
  return [n, n ? null : getInvalidTypeRejectionErr(t)];
}
function fileMatchSize(e, t, n) {
  if (isDefined(e.size))
    if (isDefined(t) && isDefined(n)) {
      if (e.size > n)
        return [!1, getTooLargeRejectionErr(n)];
      if (e.size < t)
        return [!1, getTooSmallRejectionErr(t)];
    } else {
      if (isDefined(t) && e.size < t)
        return [!1, getTooSmallRejectionErr(t)];
      if (isDefined(n) && e.size > n)
        return [!1, getTooLargeRejectionErr(n)];
    }
  return [!0, null];
}
function isDefined(e) {
  return e != null;
}
function allFilesAccepted(e) {
  var t = e.files, n = e.accept, o = e.minSize, s = e.maxSize, l = e.multiple, c = e.maxFiles, p = e.validator;
  return !l && t.length > 1 || l && c >= 1 && t.length > c ? !1 : t.every(function(m) {
    var C = fileAccepted(m, n), P = _slicedToArray$1(C, 1), w = P[0], R = fileMatchSize(m, o, s), L = _slicedToArray$1(R, 1), M = L[0], $ = p ? p(m) : null;
    return w && M && !$;
  });
}
function isPropagationStopped(e) {
  return typeof e.isPropagationStopped == "function" ? e.isPropagationStopped() : typeof e.cancelBubble < "u" ? e.cancelBubble : !1;
}
function isEvtWithFiles(e) {
  return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function(t) {
    return t === "Files" || t === "application/x-moz-file";
  }) : !!e.target && !!e.target.files;
}
function onDocumentDragOver(e) {
  e.preventDefault();
}
function isIe(e) {
  return e.indexOf("MSIE") !== -1 || e.indexOf("Trident/") !== -1;
}
function isEdge(e) {
  return e.indexOf("Edge/") !== -1;
}
function isIeOrEdge() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return isIe(e) || isEdge(e);
}
function composeEventHandlers() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(o) {
    for (var s = arguments.length, l = new Array(s > 1 ? s - 1 : 0), c = 1; c < s; c++)
      l[c - 1] = arguments[c];
    return t.some(function(p) {
      return !isPropagationStopped(o) && p && p.apply(void 0, [o].concat(l)), isPropagationStopped(o);
    });
  };
}
function canUseFileSystemAccessAPI() {
  return "showOpenFilePicker" in window;
}
function pickerOptionsFromAccept(e) {
  if (isDefined(e)) {
    var t = Object.entries(e).filter(function(n) {
      var o = _slicedToArray$1(n, 2), s = o[0], l = o[1], c = !0;
      return isMIMEType(s) || (console.warn('Skipped "'.concat(s, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.')), c = !1), (!Array.isArray(l) || !l.every(isExt)) && (console.warn('Skipped "'.concat(s, '" because an invalid file extension was provided.')), c = !1), c;
    }).reduce(function(n, o) {
      var s = _slicedToArray$1(o, 2), l = s[0], c = s[1];
      return _objectSpread$1(_objectSpread$1({}, n), {}, _defineProperty$2({}, l, c));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: t
    }];
  }
  return e;
}
function acceptPropAsAcceptAttr(e) {
  if (isDefined(e))
    return Object.entries(e).reduce(function(t, n) {
      var o = _slicedToArray$1(n, 2), s = o[0], l = o[1];
      return [].concat(_toConsumableArray$1(t), [s], _toConsumableArray$1(l));
    }, []).filter(function(t) {
      return isMIMEType(t) || isExt(t);
    }).join(",");
}
function isAbort(e) {
  return e instanceof DOMException && (e.name === "AbortError" || e.code === e.ABORT_ERR);
}
function isSecurityError(e) {
  return e instanceof DOMException && (e.name === "SecurityError" || e.code === e.SECURITY_ERR);
}
function isMIMEType(e) {
  return e === "audio/*" || e === "video/*" || e === "image/*" || e === "text/*" || /\w+\/[-+.\w]+/g.test(e);
}
function isExt(e) {
  return /^.*\.[\w]+$/.test(e);
}
var _excluded$2 = ["children"], _excluded2$1 = ["open"], _excluded3$1 = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], _excluded4 = ["refKey", "onChange", "onClick"];
function _toConsumableArray(e) {
  return _arrayWithoutHoles(e) || _iterableToArray(e) || _unsupportedIterableToArray(e) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArray(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function _arrayWithoutHoles(e) {
  if (Array.isArray(e))
    return _arrayLikeToArray(e);
}
function _slicedToArray(e, t) {
  return _arrayWithHoles(e) || _iterableToArrayLimit(e, t) || _unsupportedIterableToArray(e, t) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray(e, t) {
  if (e) {
    if (typeof e == "string")
      return _arrayLikeToArray(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray(e, t);
  }
}
function _arrayLikeToArray(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = new Array(t); n < t; n++)
    o[n] = e[n];
  return o;
}
function _iterableToArrayLimit(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var o = [], s = !0, l = !1, c, p;
    try {
      for (n = n.call(e); !(s = (c = n.next()).done) && (o.push(c.value), !(t && o.length === t)); s = !0)
        ;
    } catch (m) {
      l = !0, p = m;
    } finally {
      try {
        !s && n.return != null && n.return();
      } finally {
        if (l)
          throw p;
      }
    }
    return o;
  }
}
function _arrayWithHoles(e) {
  if (Array.isArray(e))
    return e;
}
function ownKeys(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function _objectSpread(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys(Object(n), !0).forEach(function(o) {
      _defineProperty$1(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ownKeys(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function _defineProperty$1(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function _objectWithoutProperties(e, t) {
  if (e == null)
    return {};
  var n = _objectWithoutPropertiesLoose$2(e, t), o, s;
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(e);
    for (s = 0; s < l.length; s++)
      o = l[s], !(t.indexOf(o) >= 0) && Object.prototype.propertyIsEnumerable.call(e, o) && (n[o] = e[o]);
  }
  return n;
}
function _objectWithoutPropertiesLoose$2(e, t) {
  if (e == null)
    return {};
  var n = {}, o = Object.keys(e), s, l;
  for (l = 0; l < o.length; l++)
    s = o[l], !(t.indexOf(s) >= 0) && (n[s] = e[s]);
  return n;
}
var Dropzone = /* @__PURE__ */ forwardRef(function(e, t) {
  var n = e.children, o = _objectWithoutProperties(e, _excluded$2), s = useDropzone(o), l = s.open, c = _objectWithoutProperties(s, _excluded2$1);
  return useImperativeHandle(t, function() {
    return {
      open: l
    };
  }, [l]), /* @__PURE__ */ React__default.createElement(Fragment, null, n(_objectSpread(_objectSpread({}, c), {}, {
    open: l
  })));
});
Dropzone.displayName = "Dropzone";
var defaultProps = {
  disabled: !1,
  getFilesFromEvent: fromEvent,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !0,
  autoFocus: !1
};
Dropzone.defaultProps = defaultProps;
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: PropTypes.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: PropTypes.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: PropTypes.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: PropTypes.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: PropTypes.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: PropTypes.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: PropTypes.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: PropTypes.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: PropTypes.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: PropTypes.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: PropTypes.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: PropTypes.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: PropTypes.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: PropTypes.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: PropTypes.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: PropTypes.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: PropTypes.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: PropTypes.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: PropTypes.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: PropTypes.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: PropTypes.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: PropTypes.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: PropTypes.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: PropTypes.func
};
var initialState = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  acceptedFiles: [],
  fileRejections: []
};
function useDropzone() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = _objectSpread(_objectSpread({}, defaultProps), e), n = t.accept, o = t.disabled, s = t.getFilesFromEvent, l = t.maxSize, c = t.minSize, p = t.multiple, m = t.maxFiles, C = t.onDragEnter, P = t.onDragLeave, w = t.onDragOver, R = t.onDrop, L = t.onDropAccepted, M = t.onDropRejected, $ = t.onFileDialogCancel, W = t.onFileDialogOpen, H = t.useFsAccessApi, V = t.autoFocus, N = t.preventDropOnDocument, B = t.noClick, K = t.noKeyboard, ue = t.noDrag, de = t.noDragEventsBubbling, ve = t.onError, Te = t.validator, Pe = useMemo(function() {
    return acceptPropAsAcceptAttr(n);
  }, [n]), Ce = useMemo(function() {
    return pickerOptionsFromAccept(n);
  }, [n]), Re = useMemo(function() {
    return typeof W == "function" ? W : noop$1;
  }, [W]), ke = useMemo(function() {
    return typeof $ == "function" ? $ : noop$1;
  }, [$]), Ae = useRef(null), we = useRef(null), he = useReducer(reducer, initialState), be = _slicedToArray(he, 2), le = be[0], fe = be[1], ye = le.isFocused, Ee = le.isFileDialogActive, Ie = useRef(typeof window < "u" && window.isSecureContext && H && canUseFileSystemAccessAPI()), Fe = function() {
    !Ie.current && Ee && setTimeout(function() {
      if (we.current) {
        var ar = we.current.files;
        ar.length || (fe({
          type: "closeDialog"
        }), ke());
      }
    }, 300);
  };
  useEffect(function() {
    return window.addEventListener("focus", Fe, !1), function() {
      window.removeEventListener("focus", Fe, !1);
    };
  }, [we, Ee, ke, Ie]);
  var De = useRef([]), Ve = function(ar) {
    Ae.current && Ae.current.contains(ar.target) || (ar.preventDefault(), De.current = []);
  };
  useEffect(function() {
    return N && (document.addEventListener("dragover", onDocumentDragOver, !1), document.addEventListener("drop", Ve, !1)), function() {
      N && (document.removeEventListener("dragover", onDocumentDragOver), document.removeEventListener("drop", Ve));
    };
  }, [Ae, N]), useEffect(function() {
    return !o && V && Ae.current && Ae.current.focus(), function() {
    };
  }, [Ae, V, o]);
  var Oe = useCallback(function(tt) {
    ve ? ve(tt) : console.error(tt);
  }, [ve]), Ze = useCallback(function(tt) {
    tt.preventDefault(), tt.persist(), Br(tt), De.current = [].concat(_toConsumableArray(De.current), [tt.target]), isEvtWithFiles(tt) && Promise.resolve(s(tt)).then(function(ar) {
      if (!(isPropagationStopped(tt) && !de)) {
        var wr = ar.length, Sr = wr > 0 && allFilesAccepted({
          files: ar,
          accept: Pe,
          minSize: c,
          maxSize: l,
          multiple: p,
          maxFiles: m,
          validator: Te
        }), Ye = wr > 0 && !Sr;
        fe({
          isDragAccept: Sr,
          isDragReject: Ye,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), C && C(tt);
      }
    }).catch(function(ar) {
      return Oe(ar);
    });
  }, [s, C, Oe, de, Pe, c, l, p, m, Te]), et = useCallback(function(tt) {
    tt.preventDefault(), tt.persist(), Br(tt);
    var ar = isEvtWithFiles(tt);
    if (ar && tt.dataTransfer)
      try {
        tt.dataTransfer.dropEffect = "copy";
      } catch {
      }
    return ar && w && w(tt), !1;
  }, [w, de]), bt = useCallback(function(tt) {
    tt.preventDefault(), tt.persist(), Br(tt);
    var ar = De.current.filter(function(Sr) {
      return Ae.current && Ae.current.contains(Sr);
    }), wr = ar.indexOf(tt.target);
    wr !== -1 && ar.splice(wr, 1), De.current = ar, !(ar.length > 0) && (fe({
      type: "setDraggedFiles",
      isDragActive: !1,
      isDragAccept: !1,
      isDragReject: !1
    }), isEvtWithFiles(tt) && P && P(tt));
  }, [Ae, P, de]), rr = useCallback(function(tt, ar) {
    var wr = [], Sr = [];
    tt.forEach(function(Ye) {
      var Je = fileAccepted(Ye, Pe), tr = _slicedToArray(Je, 2), pt = tr[0], ir = tr[1], nr = fileMatchSize(Ye, c, l), er = _slicedToArray(nr, 2), pr = er[0], kr = er[1], Nr = Te ? Te(Ye) : null;
      if (pt && pr && !Nr)
        wr.push(Ye);
      else {
        var hn = [ir, kr];
        Nr && (hn = hn.concat(Nr)), Sr.push({
          file: Ye,
          errors: hn.filter(function(fn) {
            return fn;
          })
        });
      }
    }), (!p && wr.length > 1 || p && m >= 1 && wr.length > m) && (wr.forEach(function(Ye) {
      Sr.push({
        file: Ye,
        errors: [TOO_MANY_FILES_REJECTION]
      });
    }), wr.splice(0)), fe({
      acceptedFiles: wr,
      fileRejections: Sr,
      type: "setFiles"
    }), R && R(wr, Sr, ar), Sr.length > 0 && M && M(Sr, ar), wr.length > 0 && L && L(wr, ar);
  }, [fe, p, Pe, c, l, m, R, L, M, Te]), St = useCallback(function(tt) {
    tt.preventDefault(), tt.persist(), Br(tt), De.current = [], isEvtWithFiles(tt) && Promise.resolve(s(tt)).then(function(ar) {
      isPropagationStopped(tt) && !de || rr(ar, tt);
    }).catch(function(ar) {
      return Oe(ar);
    }), fe({
      type: "reset"
    });
  }, [s, rr, Oe, de]), Qe = useCallback(function() {
    if (Ie.current) {
      fe({
        type: "openDialog"
      }), Re();
      var tt = {
        multiple: p,
        types: Ce
      };
      window.showOpenFilePicker(tt).then(function(ar) {
        return s(ar);
      }).then(function(ar) {
        rr(ar, null), fe({
          type: "closeDialog"
        });
      }).catch(function(ar) {
        isAbort(ar) ? (ke(ar), fe({
          type: "closeDialog"
        })) : isSecurityError(ar) ? (Ie.current = !1, we.current ? (we.current.value = null, we.current.click()) : Oe(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : Oe(ar);
      });
      return;
    }
    we.current && (fe({
      type: "openDialog"
    }), Re(), we.current.value = null, we.current.click());
  }, [fe, Re, ke, H, rr, Oe, Ce, p]), xt = useCallback(function(tt) {
    !Ae.current || !Ae.current.isEqualNode(tt.target) || (tt.key === " " || tt.key === "Enter" || tt.keyCode === 32 || tt.keyCode === 13) && (tt.preventDefault(), Qe());
  }, [Ae, Qe]), je = useCallback(function() {
    fe({
      type: "focus"
    });
  }, []), kt = useCallback(function() {
    fe({
      type: "blur"
    });
  }, []), cr = useCallback(function() {
    B || (isIeOrEdge() ? setTimeout(Qe, 0) : Qe());
  }, [B, Qe]), Tr = function(ar) {
    return o ? null : ar;
  }, Er = function(ar) {
    return K ? null : Tr(ar);
  }, Hr = function(ar) {
    return ue ? null : Tr(ar);
  }, Br = function(ar) {
    de && ar.stopPropagation();
  }, hr = useMemo(function() {
    return function() {
      var tt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ar = tt.refKey, wr = ar === void 0 ? "ref" : ar, Sr = tt.role, Ye = tt.onKeyDown, Je = tt.onFocus, tr = tt.onBlur, pt = tt.onClick, ir = tt.onDragEnter, nr = tt.onDragOver, er = tt.onDragLeave, pr = tt.onDrop, kr = _objectWithoutProperties(tt, _excluded3$1);
      return _objectSpread(_objectSpread(_defineProperty$1({
        onKeyDown: Er(composeEventHandlers(Ye, xt)),
        onFocus: Er(composeEventHandlers(Je, je)),
        onBlur: Er(composeEventHandlers(tr, kt)),
        onClick: Tr(composeEventHandlers(pt, cr)),
        onDragEnter: Hr(composeEventHandlers(ir, Ze)),
        onDragOver: Hr(composeEventHandlers(nr, et)),
        onDragLeave: Hr(composeEventHandlers(er, bt)),
        onDrop: Hr(composeEventHandlers(pr, St)),
        role: typeof Sr == "string" && Sr !== "" ? Sr : "presentation"
      }, wr, Ae), !o && !K ? {
        tabIndex: 0
      } : {}), kr);
    };
  }, [Ae, xt, je, kt, cr, Ze, et, bt, St, K, ue, o]), Gr = useCallback(function(tt) {
    tt.stopPropagation();
  }, []), Yr = useMemo(function() {
    return function() {
      var tt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ar = tt.refKey, wr = ar === void 0 ? "ref" : ar, Sr = tt.onChange, Ye = tt.onClick, Je = _objectWithoutProperties(tt, _excluded4), tr = _defineProperty$1({
        accept: Pe,
        multiple: p,
        type: "file",
        style: {
          display: "none"
        },
        onChange: Tr(composeEventHandlers(Sr, St)),
        onClick: Tr(composeEventHandlers(Ye, Gr)),
        tabIndex: -1
      }, wr, we);
      return _objectSpread(_objectSpread({}, tr), Je);
    };
  }, [we, n, p, St, o]);
  return _objectSpread(_objectSpread({}, le), {}, {
    isFocused: ye && !o,
    getRootProps: hr,
    getInputProps: Yr,
    rootRef: Ae,
    inputRef: we,
    open: Tr(Qe)
  });
}
function reducer(e, t) {
  switch (t.type) {
    case "focus":
      return _objectSpread(_objectSpread({}, e), {}, {
        isFocused: !0
      });
    case "blur":
      return _objectSpread(_objectSpread({}, e), {}, {
        isFocused: !1
      });
    case "openDialog":
      return _objectSpread(_objectSpread({}, initialState), {}, {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return _objectSpread(_objectSpread({}, e), {}, {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      return _objectSpread(_objectSpread({}, e), {}, {
        isDragActive: t.isDragActive,
        isDragAccept: t.isDragAccept,
        isDragReject: t.isDragReject
      });
    case "setFiles":
      return _objectSpread(_objectSpread({}, e), {}, {
        acceptedFiles: t.acceptedFiles,
        fileRejections: t.fileRejections
      });
    case "reset":
      return _objectSpread({}, initialState);
    default:
      return e;
  }
}
function noop$1() {
}
const NCDropZone$1 = "", NCDropZone = ({
  children: e,
  actionHook: t,
  errorHook: n,
  enableClick: o,
  disabled: s,
  ...l
}) => {
  const c = {
    zone: ""
  }, m = {
    onDrop: useCallback((R) => {
      t(R);
    }, []),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onDropRejected: useCallback((R) => {
      const L = R[0].errors[0].message;
      n && n(L);
    }, [n]),
    noClick: !o
  }, {
    getRootProps: C,
    getInputProps: P,
    isDragActive: w
  } = useDropzone(m);
  return (w || s) && (c.zone = "drop-zone"), w && !s && (c.zone += " dragable"), s && (c.zone += " disabled"), /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: c.zone,
      ...C(),
      ...l,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("input", { accept: "image/*", type: "file", hidden: !0, ...P() }),
        e
      ]
    }
  );
};
/**
 * @remix-run/router v1.15.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function _extends$3() {
  return _extends$3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, _extends$3.apply(this, arguments);
}
var Action;
(function(e) {
  e.Pop = "POP", e.Push = "PUSH", e.Replace = "REPLACE";
})(Action || (Action = {}));
function invariant$1(e, t) {
  if (e === !1 || e === null || typeof e > "u")
    throw new Error(t);
}
function warning(e, t) {
  if (!e) {
    typeof console < "u" && console.warn(t);
    try {
      throw new Error(t);
    } catch {
    }
  }
}
function createPath(e) {
  let {
    pathname: t = "/",
    search: n = "",
    hash: o = ""
  } = e;
  return n && n !== "?" && (t += n.charAt(0) === "?" ? n : "?" + n), o && o !== "#" && (t += o.charAt(0) === "#" ? o : "#" + o), t;
}
function parsePath(e) {
  let t = {};
  if (e) {
    let n = e.indexOf("#");
    n >= 0 && (t.hash = e.substr(n), e = e.substr(0, n));
    let o = e.indexOf("?");
    o >= 0 && (t.search = e.substr(o), e = e.substr(0, o)), e && (t.pathname = e);
  }
  return t;
}
var ResultType;
(function(e) {
  e.data = "data", e.deferred = "deferred", e.redirect = "redirect", e.error = "error";
})(ResultType || (ResultType = {}));
function matchPath(e, t) {
  typeof e == "string" && (e = {
    path: e,
    caseSensitive: !1,
    end: !0
  });
  let [n, o] = compilePath(e.path, e.caseSensitive, e.end), s = t.match(n);
  if (!s)
    return null;
  let l = s[0], c = l.replace(/(.)\/+$/, "$1"), p = s.slice(1);
  return {
    params: o.reduce((C, P, w) => {
      let {
        paramName: R,
        isOptional: L
      } = P;
      if (R === "*") {
        let $ = p[w] || "";
        c = l.slice(0, l.length - $.length).replace(/(.)\/+$/, "$1");
      }
      const M = p[w];
      return L && !M ? C[R] = void 0 : C[R] = (M || "").replace(/%2F/g, "/"), C;
    }, {}),
    pathname: l,
    pathnameBase: c,
    pattern: e
  };
}
function compilePath(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !0), warning(e === "*" || !e.endsWith("*") || e.endsWith("/*"), 'Route path "' + e + '" will be treated as if it were ' + ('"' + e.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + e.replace(/\*$/, "/*") + '".'));
  let o = [], s = "^" + e.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (c, p, m) => (o.push({
    paramName: p,
    isOptional: m != null
  }), m ? "/?([^\\/]+)?" : "/([^\\/]+)"));
  return e.endsWith("*") ? (o.push({
    paramName: "*"
  }), s += e === "*" || e === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$") : n ? s += "\\/*$" : e !== "" && e !== "/" && (s += "(?:(?=\\/|$))"), [new RegExp(s, t ? void 0 : "i"), o];
}
function stripBasename(e, t) {
  if (t === "/")
    return e;
  if (!e.toLowerCase().startsWith(t.toLowerCase()))
    return null;
  let n = t.endsWith("/") ? t.length - 1 : t.length, o = e.charAt(n);
  return o && o !== "/" ? null : e.slice(n) || "/";
}
function resolvePath(e, t) {
  t === void 0 && (t = "/");
  let {
    pathname: n,
    search: o = "",
    hash: s = ""
  } = typeof e == "string" ? parsePath(e) : e;
  return {
    pathname: n ? n.startsWith("/") ? n : resolvePathname(n, t) : t,
    search: normalizeSearch(o),
    hash: normalizeHash(s)
  };
}
function resolvePathname(e, t) {
  let n = t.replace(/\/+$/, "").split("/");
  return e.split("/").forEach((s) => {
    s === ".." ? n.length > 1 && n.pop() : s !== "." && n.push(s);
  }), n.length > 1 ? n.join("/") : "/";
}
function getInvalidPathError(e, t, n, o) {
  return "Cannot include a '" + e + "' character in a manually specified " + ("`to." + t + "` field [" + JSON.stringify(o) + "].  Please separate it out to the ") + ("`to." + n + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
function getPathContributingMatches(e) {
  return e.filter((t, n) => n === 0 || t.route.path && t.route.path.length > 0);
}
function getResolveToMatches(e, t) {
  let n = getPathContributingMatches(e);
  return t ? n.map((o, s) => s === e.length - 1 ? o.pathname : o.pathnameBase) : n.map((o) => o.pathnameBase);
}
function resolveTo(e, t, n, o) {
  o === void 0 && (o = !1);
  let s;
  typeof e == "string" ? s = parsePath(e) : (s = _extends$3({}, e), invariant$1(!s.pathname || !s.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", s)), invariant$1(!s.pathname || !s.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", s)), invariant$1(!s.search || !s.search.includes("#"), getInvalidPathError("#", "search", "hash", s)));
  let l = e === "" || s.pathname === "", c = l ? "/" : s.pathname, p;
  if (c == null)
    p = n;
  else {
    let w = t.length - 1;
    if (!o && c.startsWith("..")) {
      let R = c.split("/");
      for (; R[0] === ".."; )
        R.shift(), w -= 1;
      s.pathname = R.join("/");
    }
    p = w >= 0 ? t[w] : "/";
  }
  let m = resolvePath(s, p), C = c && c !== "/" && c.endsWith("/"), P = (l || c === ".") && n.endsWith("/");
  return !m.pathname.endsWith("/") && (C || P) && (m.pathname += "/"), m;
}
const joinPaths = (e) => e.join("/").replace(/\/\/+/g, "/"), normalizeSearch = (e) => !e || e === "?" ? "" : e.startsWith("?") ? e : "?" + e, normalizeHash = (e) => !e || e === "#" ? "" : e.startsWith("#") ? e : "#" + e, validMutationMethodsArr = ["post", "put", "patch", "delete"];
new Set(validMutationMethodsArr);
const validRequestMethodsArr = ["get", ...validMutationMethodsArr];
new Set(validRequestMethodsArr);
/**
 * React Router v6.22.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function _extends$2() {
  return _extends$2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, _extends$2.apply(this, arguments);
}
const DataRouterContext = /* @__PURE__ */ React$2.createContext(null);
process.env.NODE_ENV !== "production" && (DataRouterContext.displayName = "DataRouter");
const DataRouterStateContext = /* @__PURE__ */ React$2.createContext(null);
process.env.NODE_ENV !== "production" && (DataRouterStateContext.displayName = "DataRouterState");
const AwaitContext = /* @__PURE__ */ React$2.createContext(null);
process.env.NODE_ENV !== "production" && (AwaitContext.displayName = "Await");
const NavigationContext = /* @__PURE__ */ React$2.createContext(null);
process.env.NODE_ENV !== "production" && (NavigationContext.displayName = "Navigation");
const LocationContext = /* @__PURE__ */ React$2.createContext(null);
process.env.NODE_ENV !== "production" && (LocationContext.displayName = "Location");
const RouteContext = /* @__PURE__ */ React$2.createContext({
  outlet: null,
  matches: [],
  isDataRoute: !1
});
process.env.NODE_ENV !== "production" && (RouteContext.displayName = "Route");
const RouteErrorContext = /* @__PURE__ */ React$2.createContext(null);
process.env.NODE_ENV !== "production" && (RouteErrorContext.displayName = "RouteError");
function useHref(e, t) {
  let {
    relative: n
  } = t === void 0 ? {} : t;
  useInRouterContext() || (process.env.NODE_ENV !== "production" ? invariant$1(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useHref() may be used only in the context of a <Router> component."
  ) : invariant$1(!1));
  let {
    basename: o,
    navigator: s
  } = React$2.useContext(NavigationContext), {
    hash: l,
    pathname: c,
    search: p
  } = useResolvedPath(e, {
    relative: n
  }), m = c;
  return o !== "/" && (m = c === "/" ? o : joinPaths([o, c])), s.createHref({
    pathname: m,
    search: p,
    hash: l
  });
}
function useInRouterContext() {
  return React$2.useContext(LocationContext) != null;
}
function useLocation() {
  return useInRouterContext() || (process.env.NODE_ENV !== "production" ? invariant$1(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useLocation() may be used only in the context of a <Router> component."
  ) : invariant$1(!1)), React$2.useContext(LocationContext).location;
}
const navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
function useIsomorphicLayoutEffect(e) {
  React$2.useContext(NavigationContext).static || React$2.useLayoutEffect(e);
}
function useNavigate() {
  let {
    isDataRoute: e
  } = React$2.useContext(RouteContext);
  return e ? useNavigateStable() : useNavigateUnstable();
}
function useNavigateUnstable() {
  useInRouterContext() || (process.env.NODE_ENV !== "production" ? invariant$1(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useNavigate() may be used only in the context of a <Router> component."
  ) : invariant$1(!1));
  let e = React$2.useContext(DataRouterContext), {
    basename: t,
    future: n,
    navigator: o
  } = React$2.useContext(NavigationContext), {
    matches: s
  } = React$2.useContext(RouteContext), {
    pathname: l
  } = useLocation(), c = JSON.stringify(getResolveToMatches(s, n.v7_relativeSplatPath)), p = React$2.useRef(!1);
  return useIsomorphicLayoutEffect(() => {
    p.current = !0;
  }), React$2.useCallback(function(C, P) {
    if (P === void 0 && (P = {}), process.env.NODE_ENV !== "production" && warning(p.current, navigateEffectWarning), !p.current)
      return;
    if (typeof C == "number") {
      o.go(C);
      return;
    }
    let w = resolveTo(C, JSON.parse(c), l, P.relative === "path");
    e == null && t !== "/" && (w.pathname = w.pathname === "/" ? t : joinPaths([t, w.pathname])), (P.replace ? o.replace : o.push)(w, P.state, P);
  }, [t, o, c, l, e]);
}
function useResolvedPath(e, t) {
  let {
    relative: n
  } = t === void 0 ? {} : t, {
    future: o
  } = React$2.useContext(NavigationContext), {
    matches: s
  } = React$2.useContext(RouteContext), {
    pathname: l
  } = useLocation(), c = JSON.stringify(getResolveToMatches(s, o.v7_relativeSplatPath));
  return React$2.useMemo(() => resolveTo(e, JSON.parse(c), l, n === "path"), [e, c, l, n]);
}
var DataRouterHook$1 = /* @__PURE__ */ function(e) {
  return e.UseBlocker = "useBlocker", e.UseRevalidator = "useRevalidator", e.UseNavigateStable = "useNavigate", e;
}(DataRouterHook$1 || {}), DataRouterStateHook$1 = /* @__PURE__ */ function(e) {
  return e.UseBlocker = "useBlocker", e.UseLoaderData = "useLoaderData", e.UseActionData = "useActionData", e.UseRouteError = "useRouteError", e.UseNavigation = "useNavigation", e.UseRouteLoaderData = "useRouteLoaderData", e.UseMatches = "useMatches", e.UseRevalidator = "useRevalidator", e.UseNavigateStable = "useNavigate", e.UseRouteId = "useRouteId", e;
}(DataRouterStateHook$1 || {});
function getDataRouterConsoleError$1(e) {
  return e + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function useDataRouterContext$1(e) {
  let t = React$2.useContext(DataRouterContext);
  return t || (process.env.NODE_ENV !== "production" ? invariant$1(!1, getDataRouterConsoleError$1(e)) : invariant$1(!1)), t;
}
function useRouteContext(e) {
  let t = React$2.useContext(RouteContext);
  return t || (process.env.NODE_ENV !== "production" ? invariant$1(!1, getDataRouterConsoleError$1(e)) : invariant$1(!1)), t;
}
function useCurrentRouteId(e) {
  let t = useRouteContext(e), n = t.matches[t.matches.length - 1];
  return n.route.id || (process.env.NODE_ENV !== "production" ? invariant$1(!1, e + ' can only be used on routes that contain a unique "id"') : invariant$1(!1)), n.route.id;
}
function useRouteId() {
  return useCurrentRouteId(DataRouterStateHook$1.UseRouteId);
}
function useNavigateStable() {
  let {
    router: e
  } = useDataRouterContext$1(DataRouterHook$1.UseNavigateStable), t = useCurrentRouteId(DataRouterStateHook$1.UseNavigateStable), n = React$2.useRef(!1);
  return useIsomorphicLayoutEffect(() => {
    n.current = !0;
  }), React$2.useCallback(function(s, l) {
    l === void 0 && (l = {}), process.env.NODE_ENV !== "production" && warning(n.current, navigateEffectWarning), n.current && (typeof s == "number" ? e.navigate(s) : e.navigate(s, _extends$2({
      fromRouteId: t
    }, l)));
  }, [e, t]);
}
new Promise(() => {
});
/**
 * React Router DOM v6.22.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, _extends$1.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$1(e, t) {
  if (e == null)
    return {};
  var n = {}, o = Object.keys(e), s, l;
  for (l = 0; l < o.length; l++)
    s = o[l], !(t.indexOf(s) >= 0) && (n[s] = e[s]);
  return n;
}
const defaultMethod = "get", defaultEncType = "application/x-www-form-urlencoded";
function isHtmlElement(e) {
  return e != null && typeof e.tagName == "string";
}
function isButtonElement(e) {
  return isHtmlElement(e) && e.tagName.toLowerCase() === "button";
}
function isFormElement(e) {
  return isHtmlElement(e) && e.tagName.toLowerCase() === "form";
}
function isInputElement(e) {
  return isHtmlElement(e) && e.tagName.toLowerCase() === "input";
}
function isModifiedEvent(e) {
  return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
}
function shouldProcessLinkClick(e, t) {
  return e.button === 0 && // Ignore everything but left clicks
  (!t || t === "_self") && // Let browser handle "target=_blank" etc.
  !isModifiedEvent(e);
}
let _formDataSupportsSubmitter = null;
function isFormDataSubmitterSupported() {
  if (_formDataSupportsSubmitter === null)
    try {
      new FormData(
        document.createElement("form"),
        // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0
      ), _formDataSupportsSubmitter = !1;
    } catch {
      _formDataSupportsSubmitter = !0;
    }
  return _formDataSupportsSubmitter;
}
const supportedFormEncTypes = /* @__PURE__ */ new Set(["application/x-www-form-urlencoded", "multipart/form-data", "text/plain"]);
function getFormEncType(e) {
  return e != null && !supportedFormEncTypes.has(e) ? (process.env.NODE_ENV !== "production" && warning(!1, '"' + e + '" is not a valid `encType` for `<Form>`/`<fetcher.Form>` ' + ('and will default to "' + defaultEncType + '"')), null) : e;
}
function getFormSubmissionInfo(e, t) {
  let n, o, s, l, c;
  if (isFormElement(e)) {
    let p = e.getAttribute("action");
    o = p ? stripBasename(p, t) : null, n = e.getAttribute("method") || defaultMethod, s = getFormEncType(e.getAttribute("enctype")) || defaultEncType, l = new FormData(e);
  } else if (isButtonElement(e) || isInputElement(e) && (e.type === "submit" || e.type === "image")) {
    let p = e.form;
    if (p == null)
      throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
    let m = e.getAttribute("formaction") || p.getAttribute("action");
    if (o = m ? stripBasename(m, t) : null, n = e.getAttribute("formmethod") || p.getAttribute("method") || defaultMethod, s = getFormEncType(e.getAttribute("formenctype")) || getFormEncType(p.getAttribute("enctype")) || defaultEncType, l = new FormData(p, e), !isFormDataSubmitterSupported()) {
      let {
        name: C,
        type: P,
        value: w
      } = e;
      if (P === "image") {
        let R = C ? C + "." : "";
        l.append(R + "x", "0"), l.append(R + "y", "0");
      } else
        C && l.append(C, w);
    }
  } else {
    if (isHtmlElement(e))
      throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    n = defaultMethod, o = null, s = defaultEncType, c = e;
  }
  return l && s === "text/plain" && (c = l, l = void 0), {
    action: o,
    method: n.toLowerCase(),
    encType: s,
    formData: l,
    body: c
  };
}
const _excluded$1 = ["onClick", "relative", "reloadDocument", "replace", "state", "target", "to", "preventScrollReset", "unstable_viewTransition"], _excluded2 = ["aria-current", "caseSensitive", "className", "end", "style", "to", "unstable_viewTransition", "children"], _excluded3 = ["fetcherKey", "navigate", "reloadDocument", "replace", "state", "method", "action", "onSubmit", "relative", "preventScrollReset", "unstable_viewTransition"], REACT_ROUTER_VERSION = "6";
try {
  window.__reactRouterVersion = REACT_ROUTER_VERSION;
} catch {
}
const ViewTransitionContext = /* @__PURE__ */ React$2.createContext({
  isTransitioning: !1
});
process.env.NODE_ENV !== "production" && (ViewTransitionContext.displayName = "ViewTransition");
const FetchersContext = /* @__PURE__ */ React$2.createContext(/* @__PURE__ */ new Map());
process.env.NODE_ENV !== "production" && (FetchersContext.displayName = "Fetchers");
process.env.NODE_ENV;
const isBrowser = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i, Link = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  let {
    onClick: o,
    relative: s,
    reloadDocument: l,
    replace: c,
    state: p,
    target: m,
    to: C,
    preventScrollReset: P,
    unstable_viewTransition: w
  } = t, R = _objectWithoutPropertiesLoose$1(t, _excluded$1), {
    basename: L
  } = React$2.useContext(NavigationContext), M, $ = !1;
  if (typeof C == "string" && ABSOLUTE_URL_REGEX.test(C) && (M = C, isBrowser))
    try {
      let N = new URL(window.location.href), B = C.startsWith("//") ? new URL(N.protocol + C) : new URL(C), K = stripBasename(B.pathname, L);
      B.origin === N.origin && K != null ? C = K + B.search + B.hash : $ = !0;
    } catch {
      process.env.NODE_ENV !== "production" && warning(!1, '<Link to="' + C + '"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.');
    }
  let W = useHref(C, {
    relative: s
  }), H = useLinkClickHandler(C, {
    replace: c,
    state: p,
    target: m,
    preventScrollReset: P,
    relative: s,
    unstable_viewTransition: w
  });
  function V(N) {
    o && o(N), N.defaultPrevented || H(N);
  }
  return (
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ React$2.createElement("a", _extends$1({}, R, {
      href: M || W,
      onClick: $ || l ? o : V,
      ref: n,
      target: m
    }))
  );
});
process.env.NODE_ENV !== "production" && (Link.displayName = "Link");
const NavLink = /* @__PURE__ */ React$2.forwardRef(function(t, n) {
  let {
    "aria-current": o = "page",
    caseSensitive: s = !1,
    className: l = "",
    end: c = !1,
    style: p,
    to: m,
    unstable_viewTransition: C,
    children: P
  } = t, w = _objectWithoutPropertiesLoose$1(t, _excluded2), R = useResolvedPath(m, {
    relative: w.relative
  }), L = useLocation(), M = React$2.useContext(DataRouterStateContext), {
    navigator: $,
    basename: W
  } = React$2.useContext(NavigationContext), H = M != null && // Conditional usage is OK here because the usage of a data router is static
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useViewTransitionState(R) && C === !0, V = $.encodeLocation ? $.encodeLocation(R).pathname : R.pathname, N = L.pathname, B = M && M.navigation && M.navigation.location ? M.navigation.location.pathname : null;
  s || (N = N.toLowerCase(), B = B ? B.toLowerCase() : null, V = V.toLowerCase()), B && W && (B = stripBasename(B, W) || B);
  const K = V !== "/" && V.endsWith("/") ? V.length - 1 : V.length;
  let ue = N === V || !c && N.startsWith(V) && N.charAt(K) === "/", de = B != null && (B === V || !c && B.startsWith(V) && B.charAt(V.length) === "/"), ve = {
    isActive: ue,
    isPending: de,
    isTransitioning: H
  }, Te = ue ? o : void 0, Pe;
  typeof l == "function" ? Pe = l(ve) : Pe = [l, ue ? "active" : null, de ? "pending" : null, H ? "transitioning" : null].filter(Boolean).join(" ");
  let Ce = typeof p == "function" ? p(ve) : p;
  return /* @__PURE__ */ React$2.createElement(Link, _extends$1({}, w, {
    "aria-current": Te,
    className: Pe,
    ref: n,
    style: Ce,
    to: m,
    unstable_viewTransition: C
  }), typeof P == "function" ? P(ve) : P);
});
process.env.NODE_ENV !== "production" && (NavLink.displayName = "NavLink");
const Form = /* @__PURE__ */ React$2.forwardRef((e, t) => {
  let {
    fetcherKey: n,
    navigate: o,
    reloadDocument: s,
    replace: l,
    state: c,
    method: p = defaultMethod,
    action: m,
    onSubmit: C,
    relative: P,
    preventScrollReset: w,
    unstable_viewTransition: R
  } = e, L = _objectWithoutPropertiesLoose$1(e, _excluded3), M = useSubmit(), $ = useFormAction(m, {
    relative: P
  }), W = p.toLowerCase() === "get" ? "get" : "post", H = (V) => {
    if (C && C(V), V.defaultPrevented)
      return;
    V.preventDefault();
    let N = V.nativeEvent.submitter, B = (N == null ? void 0 : N.getAttribute("formmethod")) || p;
    M(N || V.currentTarget, {
      fetcherKey: n,
      method: B,
      navigate: o,
      replace: l,
      state: c,
      relative: P,
      preventScrollReset: w,
      unstable_viewTransition: R
    });
  };
  return /* @__PURE__ */ React$2.createElement("form", _extends$1({
    ref: t,
    method: W,
    action: $,
    onSubmit: s ? C : H
  }, L));
});
process.env.NODE_ENV !== "production" && (Form.displayName = "Form");
process.env.NODE_ENV;
var DataRouterHook;
(function(e) {
  e.UseScrollRestoration = "useScrollRestoration", e.UseSubmit = "useSubmit", e.UseSubmitFetcher = "useSubmitFetcher", e.UseFetcher = "useFetcher", e.useViewTransitionState = "useViewTransitionState";
})(DataRouterHook || (DataRouterHook = {}));
var DataRouterStateHook;
(function(e) {
  e.UseFetcher = "useFetcher", e.UseFetchers = "useFetchers", e.UseScrollRestoration = "useScrollRestoration";
})(DataRouterStateHook || (DataRouterStateHook = {}));
function getDataRouterConsoleError(e) {
  return e + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function useDataRouterContext(e) {
  let t = React$2.useContext(DataRouterContext);
  return t || (process.env.NODE_ENV !== "production" ? invariant$1(!1, getDataRouterConsoleError(e)) : invariant$1(!1)), t;
}
function useLinkClickHandler(e, t) {
  let {
    target: n,
    replace: o,
    state: s,
    preventScrollReset: l,
    relative: c,
    unstable_viewTransition: p
  } = t === void 0 ? {} : t, m = useNavigate(), C = useLocation(), P = useResolvedPath(e, {
    relative: c
  });
  return React$2.useCallback((w) => {
    if (shouldProcessLinkClick(w, n)) {
      w.preventDefault();
      let R = o !== void 0 ? o : createPath(C) === createPath(P);
      m(e, {
        replace: R,
        state: s,
        preventScrollReset: l,
        relative: c,
        unstable_viewTransition: p
      });
    }
  }, [C, m, P, o, s, n, e, l, c, p]);
}
function validateClientSideSubmission() {
  if (typeof document > "u")
    throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let fetcherId = 0, getUniqueFetcherId = () => "__" + String(++fetcherId) + "__";
function useSubmit() {
  let {
    router: e
  } = useDataRouterContext(DataRouterHook.UseSubmit), {
    basename: t
  } = React$2.useContext(NavigationContext), n = useRouteId();
  return React$2.useCallback(function(o, s) {
    s === void 0 && (s = {}), validateClientSideSubmission();
    let {
      action: l,
      method: c,
      encType: p,
      formData: m,
      body: C
    } = getFormSubmissionInfo(o, t);
    if (s.navigate === !1) {
      let P = s.fetcherKey || getUniqueFetcherId();
      e.fetch(P, n, s.action || l, {
        preventScrollReset: s.preventScrollReset,
        formData: m,
        body: C,
        formMethod: s.method || c,
        formEncType: s.encType || p,
        unstable_flushSync: s.unstable_flushSync
      });
    } else
      e.navigate(s.action || l, {
        preventScrollReset: s.preventScrollReset,
        formData: m,
        body: C,
        formMethod: s.method || c,
        formEncType: s.encType || p,
        replace: s.replace,
        state: s.state,
        fromRouteId: n,
        unstable_flushSync: s.unstable_flushSync,
        unstable_viewTransition: s.unstable_viewTransition
      });
  }, [e, t, n]);
}
function useFormAction(e, t) {
  let {
    relative: n
  } = t === void 0 ? {} : t, {
    basename: o
  } = React$2.useContext(NavigationContext), s = React$2.useContext(RouteContext);
  s || (process.env.NODE_ENV !== "production" ? invariant$1(!1, "useFormAction must be used inside a RouteContext") : invariant$1(!1));
  let [l] = s.matches.slice(-1), c = _extends$1({}, useResolvedPath(e || ".", {
    relative: n
  })), p = useLocation();
  if (e == null) {
    c.search = p.search;
    let m = new URLSearchParams(c.search);
    m.has("index") && m.get("index") === "" && (m.delete("index"), c.search = m.toString() ? "?" + m.toString() : "");
  }
  return (!e || e === ".") && l.route.index && (c.search = c.search ? c.search.replace(/^\?/, "?index&") : "?index"), o !== "/" && (c.pathname = c.pathname === "/" ? o : joinPaths([o, c.pathname])), createPath(c);
}
function useViewTransitionState(e, t) {
  t === void 0 && (t = {});
  let n = React$2.useContext(ViewTransitionContext);
  n == null && (process.env.NODE_ENV !== "production" ? invariant$1(!1, "`unstable_useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?") : invariant$1(!1));
  let {
    basename: o
  } = useDataRouterContext(DataRouterHook.useViewTransitionState), s = useResolvedPath(e, {
    relative: t.relative
  });
  if (!n.isTransitioning)
    return !1;
  let l = stripBasename(n.currentLocation.pathname, o) || n.currentLocation.pathname, c = stripBasename(n.nextLocation.pathname, o) || n.nextLocation.pathname;
  return matchPath(s.pathname, c) != null || matchPath(s.pathname, l) != null;
}
function invariant(e, t, n) {
  if (n === void 0 && (n = Error), !e)
    throw new n(t);
}
var defaultErrorHandler = function(e) {
  process.env.NODE_ENV !== "production" && console.error(e);
}, defaultWarnHandler = function(e) {
  process.env.NODE_ENV !== "production" && console.warn(e);
}, DEFAULT_INTL_CONFIG = {
  formats: {},
  messages: {},
  timeZone: void 0,
  defaultLocale: "en",
  defaultFormats: {},
  fallbackOnEmptyString: !0,
  onError: defaultErrorHandler,
  onWarn: defaultWarnHandler
};
function invariantIntlContext(e) {
  invariant(e, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
__assign$4(__assign$4({}, DEFAULT_INTL_CONFIG), { textComponent: React$2.Fragment });
function shallowEqual(e, t) {
  if (e === t)
    return !0;
  if (!e || !t)
    return !1;
  var n = Object.keys(e), o = Object.keys(t), s = n.length;
  if (o.length !== s)
    return !1;
  for (var l = 0; l < s; l++) {
    var c = n[l];
    if (e[c] !== t[c] || !Object.prototype.hasOwnProperty.call(t, c))
      return !1;
  }
  return !0;
}
var IntlContext = typeof window < "u" && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = React$2.createContext(null)) : React$2.createContext(null);
IntlContext.Consumer;
IntlContext.Provider;
var Context = IntlContext;
function useIntl() {
  var e = React$2.useContext(Context);
  return invariantIntlContext(e), e;
}
var DisplayName;
(function(e) {
  e.formatDate = "FormattedDate", e.formatTime = "FormattedTime", e.formatNumber = "FormattedNumber", e.formatList = "FormattedList", e.formatDisplayName = "FormattedDisplayName";
})(DisplayName || (DisplayName = {}));
var DisplayNameParts;
(function(e) {
  e.formatDate = "FormattedDateParts", e.formatTime = "FormattedTimeParts", e.formatNumber = "FormattedNumberParts", e.formatList = "FormattedListParts";
})(DisplayNameParts || (DisplayNameParts = {}));
function createFormattedDateTimePartsComponent(e) {
  var t = function(n) {
    var o = useIntl(), s = n.value, l = n.children, c = __rest$1(n, ["value", "children"]), p = typeof s == "string" ? new Date(s || 0) : s, m = e === "formatDate" ? o.formatDateToParts(p, c) : o.formatTimeToParts(p, c);
    return l(m);
  };
  return t.displayName = DisplayNameParts[e], t;
}
function createFormattedComponent(e) {
  var t = function(n) {
    var o = useIntl(), s = n.value, l = n.children, c = __rest$1(
      n,
      ["value", "children"]
    ), p = o[e](s, c);
    if (typeof l == "function")
      return l(p);
    var m = o.textComponent || React$2.Fragment;
    return React$2.createElement(m, null, p);
  };
  return t.displayName = DisplayName[e], t;
}
function areEqual(e, t) {
  var n = e.values, o = __rest$1(e, ["values"]), s = t.values, l = __rest$1(t, ["values"]);
  return shallowEqual(s, n) && shallowEqual(o, l);
}
function FormattedMessage(e) {
  var t = useIntl(), n = t.formatMessage, o = t.textComponent, s = o === void 0 ? React$2.Fragment : o, l = e.id, c = e.description, p = e.defaultMessage, m = e.values, C = e.children, P = e.tagName, w = P === void 0 ? s : P, R = e.ignoreTag, L = { id: l, description: c, defaultMessage: p }, M = n(L, m, {
    ignoreTag: R
  });
  return typeof C == "function" ? C(Array.isArray(M) ? M : [M]) : w ? React$2.createElement(w, null, React$2.Children.toArray(M)) : React$2.createElement(React$2.Fragment, null, M);
}
FormattedMessage.displayName = "FormattedMessage";
var MemoizedFormattedMessage = React$2.memo(FormattedMessage, areEqual);
MemoizedFormattedMessage.displayName = "MemoizedFormattedMessage";
const FormattedMessage$1 = MemoizedFormattedMessage;
createFormattedComponent("formatDate");
createFormattedComponent("formatTime");
createFormattedComponent("formatNumber");
createFormattedComponent("formatList");
createFormattedComponent("formatDisplayName");
createFormattedDateTimePartsComponent("formatDate");
createFormattedDateTimePartsComponent("formatTime");
const NCTypography$1 = "", variantMap = {
  hero: {
    type: "h1",
    className: "hero"
  },
  h1: {
    type: "h1",
    className: ""
  },
  h2: {
    type: "h2",
    className: ""
  },
  h3: {
    type: "h3",
    className: ""
  },
  h4: {
    type: "h4",
    className: ""
  },
  h5: {
    type: "h5",
    className: ""
  },
  h6: {
    type: "h6",
    className: ""
  },
  subtitle1: {
    type: "span",
    className: "subtitle1"
  },
  subtitle2: {
    type: "span",
    className: "subtitle2"
  },
  overtitle: {
    type: "span",
    className: "overtitle"
  },
  caption: {
    type: "span",
    className: "caption"
  },
  span: {
    type: "span",
    className: ""
  },
  body1: {
    type: "span",
    className: "body1"
  },
  body2: {
    type: "span",
    className: "body2"
  },
  string: {
    type: void 0,
    className: ""
  }
}, NCTypography = ({
  children: e,
  variant: t,
  intlObj: n,
  intlID: o,
  intlValues: s,
  ...l
}) => {
  const c = t && variantMap[t].type || React__default.Fragment, p = t && variantMap[t].type && { className: `${variantMap[t].className || ""} ${l.className || ""}` } || {}, m = !(n != null && n.id) && !o ? e : /* @__PURE__ */ jsxRuntimeExports.jsx(
    FormattedMessage$1,
    {
      id: (o == null ? void 0 : o.toString()) || (n == null ? void 0 : n.id),
      values: s || (n == null ? void 0 : n.values),
      description: n == null ? void 0 : n.description,
      defaultMessage: e ? e.toString() : ""
    }
  );
  return React__default.createElement(c, {
    ...l,
    ...p
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, m);
}, NCDropdown$1 = "", NCDropdown = ({ children: e, tab: t, click: n }) => {
  const [o, s] = useState(!1), l = useRef(null);
  return useEffect(() => {
    function c(p) {
      l && l.current && !l.current.contains(p.target) && s(!1);
    }
    return document.addEventListener("mousedown", c), () => {
      document.removeEventListener("mousedown", c);
    };
  }, [l]), /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      ref: l,
      className: `nc-dropdown${n ? "" : " nc-dropdown-hover"}${o ? " nc-dropdown-active" : ""}${t.disabled ? " nc-dropdown-disabled" : ""}`,
      onClick: () => !t.disabled && n ? s(!o) : null,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            className: "nc-dropdown-content-menu",
            children: [
              e,
              /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { width: 16, icon: IconType.Colapse })
            ]
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "nc-dropdown-content", children: t.children && t.children.map((c, p) => {
          const m = c.path.split("/").filter((C) => !C.match("^:.*?$")).join("/");
          return /* @__PURE__ */ jsxRuntimeExports.jsx(
            NavLink,
            {
              className: ({ isActive: C }) => `${C && "nc-dropdown-item-active "}nc-dropdown-item${c.disabled ? " nc-dropdown-item-disabled" : ""}`,
              to: {
                pathname: t.path + m,
                search: location == null ? void 0 : location.search
              },
              end: !0,
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(NCTypography, { variant: "body1", children: c.name })
            },
            c.name + p
          );
        }) })
      ]
    }
  );
}, NCDropdownMenu = (e) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "nc-dropdown-menu d-flex flex-column", children: e.items.map((t) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `cursor-pointer nc-dropdown-menu-item d-flex align-items-center ${t.className}`, onClick: t.onClick, children: [
  t.icon && /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { icon: t.icon, width: 22, height: 22 }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: t.icon ? "ml-2" : "", children: t.name })
] }, t.name)) }), NCImage = (e) => {
  const [t, n] = useState(!1);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "img",
      {
        className: `cursor-pointer ${e.styleName}`,
        src: e.src,
        alt: e.alt,
        onClick: () => n(!0)
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      NCDialog,
      {
        show: t,
        setShow: () => n(!1),
        noPadding: !0,
        noHeader: !0,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "img",
          {
            className: "w-100",
            src: e.src,
            alt: e.alt
          }
        )
      }
    )
  ] });
}, NCLanguageIcon$1 = "", NCLanguageIcon = (e) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "div",
  {
    className: "nc-language-icon d-flex justify-content-center align-items-center text-uppercase cursor-pointer",
    onClick: e.onClick,
    children: e.language
  }
), NCList$1 = "";
function FillRows(e, t) {
  return e.map((n, o) => t(o, n));
}
const NCListTools = {
  fillRows: FillRows
}, NCList = (e) => {
  let t = "";
  return t = e.variant ? ` ${e.variant}` : "", t += e.type ? ` ${e.type}` : "", /* @__PURE__ */ jsxRuntimeExports.jsxs("table", { className: "table color-white" + t, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("thead", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("tr", { children: e.header.filter((n) => n).map((n, o) => /* @__PURE__ */ jsxRuntimeExports.jsx("th", { scope: "col", className: n.thClassName, children: n.thContent }, o)) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("tbody", { children: e.data.filter((n) => n).map((n, o) => /* @__PURE__ */ jsxRuntimeExports.jsx(NCRow, { idx: o, headers: e.header, row: n, selected: e.selected }, o)) })
  ] });
}, NCRow = (e) => {
  var t, n, o, s;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("tr", { className: ((n = (t = e.row) == null ? void 0 : t.tr) == null ? void 0 : n.trClassName) + (((o = e.selected) == null ? void 0 : o.length) && e.selected.includes(e.idx) && " selected" || ((s = e.selected) == null ? void 0 : s.length) && "unselected" || ""), onClick: () => {
    var l, c, p, m, C, P;
    (c = (l = e.row) == null ? void 0 : l.tr) != null && c.actionHook && ((P = (p = e.row) == null ? void 0 : p.tr) == null || P.actionHook(e.idx, (C = (m = e.row) == null ? void 0 : m.tr) == null ? void 0 : C.trData));
  }, children: e.headers.filter((l) => l).map((l, c) => /* @__PURE__ */ jsxRuntimeExports.jsx("td", { className: e.row[l.thId].tdClassName, children: e.row[l.thId].tdContent }, c)) }, e.idx);
}, ICONS = {
  google: /* @__PURE__ */ jsxRuntimeExports.jsx(GoogleIcon, {}),
  notification: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Icon,
    {
      width: 24,
      height: 24,
      icon: IconType.Notification,
      styleName: "nc-notification-button-icon nc-active-icon"
    }
  ),
  mobile: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Icon,
    {
      width: 24,
      height: 24,
      icon: IconType.Mobile,
      styleName: "nc-notification-button-icon nc-active-icon"
    }
  )
}, useIcon = () => ({ getIcon: (t) => ICONS[t] }), NCNotificationButton$1 = "", NCNotificationButton = (e) => {
  const { getIcon: t } = useIcon(), { iconName: n, label: o, action: s } = e;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "nc-notification-button", onClick: s, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "nc-icon-container", children: t(n) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "nc-notification-button-text", children: o })
  ] });
}, NCOverlappingTitle$1 = "", NCOverlappingTitle = (e) => /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "nc-overlapping-title-container", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "nc-overlapping-title", children: e.title }) }) }), NCStepBubble$1 = "", NCStepBubble = ({
  stepNumber: e,
  isFilled: t,
  color: n
}) => {
  const o = n ? { color: n, borderColor: n } : {};
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: "nc-step-bubble",
      style: o,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "nc-step-number", style: o, children: e }),
        t && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "bubble-filled", style: { backgroundColor: n } })
      ]
    }
  );
}, NCThumbnail$1 = "", NCThumbnail = (e) => /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { className: "nc-thumbnail", src: e.timg, draggable: !1 }) }), NCTitle$1 = "", NCTitle = ({ label: e, color: t }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "nc-title-container", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "nc-color-led", style: t ? { background: t } : {} }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: e })
] }), NCToast$1 = "", NCToast = (e) => {
  const { toast: t, onDeleteToast: n } = e;
  return useEffect(() => {
    const o = setInterval(() => {
      n(t.id);
    }, e.duration);
    return t.permanent && clearInterval(o), () => {
      clearInterval(o);
    };
  }, []), /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: `nc-toast-atom ${e.position} ${t.type && t.type} ${t.style && t.style}`,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "d-flex flex-row justify-content-between", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "d-flex flex-row align-items-center", children: [
            t.titleIcon && t.titleIcon,
            /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "toast-title my-auto", children: t.title })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "clickable", onClick: () => n(t.id), children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            Icon,
            {
              icon: IconType.Cross,
              width: 13,
              height: 13,
              styleName: "ml-2"
            }
          ) })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "toast-content", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: t.content }) })
      ]
    }
  );
}, TextArea$1 = "", TextArea = ({
  placeholder: e,
  maxLength: t = 500,
  value: n,
  rows: o = 10,
  setValue: s
}) => {
  const l = (c) => {
    s && s(c.currentTarget.value);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "textarea",
    {
      className: "text-area",
      placeholder: e,
      maxLength: t,
      value: n,
      rows: o,
      onChange: (c) => l(c)
    }
  );
}, NCProgressBar$1 = "", NCProgressBar = (e) => {
  const t = e.ratio ? e.ratio : 0, n = e.height ? `${e.height}px` : "8px";
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: "nc-progress-bar",
      style: { width: `${e.width}`, height: n },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          className: "in-progress",
          style: { width: `${t * 100}%`, background: e == null ? void 0 : e.color }
        }
      )
    }
  );
}, ByeCard$1 = "", TeamCard$1 = "", UserCard$1 = "", ByeCard = (e) => {
  const t = [20, 40, 80], n = [48, 80, 121], o = e.full ? e.isSolo ? e.xs ? t[1] : t[2] : e.xs ? n[1] : n[2] : e.isSolo ? e.xs ? t[0] : t[1] : n[0];
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `nc-bye-card d-flex align-items-center
            ${e.isSolo ? `nc-user-card ${e.xs ? "nc-user-card-xs" : "nc-user-card-lg"}` : `nc-team-card ${e.xs ? "nc-team-card-xs" : "nc-team-card-lg"}`}
            ${e.full ? "full" : ""}
            ${e.full || e.isSolo && !e.xs ? "pl-2 pr-3" : ""}`, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: `avatar-container ${e.isSolo ? "solo" : ""}`,
        style: { width: `${o}px`, height: `${o}px` }
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mx-auto", children: "BYE" })
  ] });
}, Chat$1 = "";
var cjs = { exports: {} }, Draggable$2 = {};
function r(e) {
  var t, n, o = "";
  if (typeof e == "string" || typeof e == "number")
    o += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (n = r(e[t])) && (o && (o += " "), o += n);
    else
      for (t in e)
        e[t] && (o && (o += " "), o += t);
  return o;
}
function clsx() {
  for (var e, t, n = 0, o = ""; n < arguments.length; )
    (e = arguments[n++]) && (t = r(e)) && (o && (o += " "), o += t);
  return o;
}
const clsx_m = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clsx,
  default: clsx
}, Symbol.toStringTag, { value: "Module" })), require$$3 = /* @__PURE__ */ getAugmentedNamespace(clsx_m);
var domFns = {}, shims = {};
Object.defineProperty(shims, "__esModule", {
  value: !0
});
shims.dontSetMe = dontSetMe;
shims.findInArray = findInArray;
shims.int = int;
shims.isFunction = isFunction$2;
shims.isNum = isNum;
function findInArray(e, t) {
  for (let n = 0, o = e.length; n < o; n++)
    if (t.apply(t, [e[n], n, e]))
      return e[n];
}
function isFunction$2(e) {
  return typeof e == "function" || Object.prototype.toString.call(e) === "[object Function]";
}
function isNum(e) {
  return typeof e == "number" && !isNaN(e);
}
function int(e) {
  return parseInt(e, 10);
}
function dontSetMe(e, t, n) {
  if (e[t])
    return new Error("Invalid prop ".concat(t, " passed to ").concat(n, " - do not set this, set it on the child."));
}
var getPrefix$1 = {};
Object.defineProperty(getPrefix$1, "__esModule", {
  value: !0
});
getPrefix$1.browserPrefixToKey = browserPrefixToKey;
getPrefix$1.browserPrefixToStyle = browserPrefixToStyle;
getPrefix$1.default = void 0;
getPrefix$1.getPrefix = getPrefix;
const prefixes = ["Moz", "Webkit", "O", "ms"];
function getPrefix() {
  var e;
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "transform";
  if (typeof window > "u")
    return "";
  const n = (e = window.document) === null || e === void 0 || (e = e.documentElement) === null || e === void 0 ? void 0 : e.style;
  if (!n || t in n)
    return "";
  for (let o = 0; o < prefixes.length; o++)
    if (browserPrefixToKey(t, prefixes[o]) in n)
      return prefixes[o];
  return "";
}
function browserPrefixToKey(e, t) {
  return t ? "".concat(t).concat(kebabToTitleCase(e)) : e;
}
function browserPrefixToStyle(e, t) {
  return t ? "-".concat(t.toLowerCase(), "-").concat(e) : e;
}
function kebabToTitleCase(e) {
  let t = "", n = !0;
  for (let o = 0; o < e.length; o++)
    n ? (t += e[o].toUpperCase(), n = !1) : e[o] === "-" ? n = !0 : t += e[o];
  return t;
}
getPrefix$1.default = getPrefix();
Object.defineProperty(domFns, "__esModule", {
  value: !0
});
domFns.addClassName = addClassName;
domFns.addEvent = addEvent;
domFns.addUserSelectStyles = addUserSelectStyles;
domFns.createCSSTransform = createCSSTransform;
domFns.createSVGTransform = createSVGTransform;
domFns.getTouch = getTouch;
domFns.getTouchIdentifier = getTouchIdentifier;
domFns.getTranslation = getTranslation;
domFns.innerHeight = innerHeight;
domFns.innerWidth = innerWidth;
domFns.matchesSelector = matchesSelector;
domFns.matchesSelectorAndParentsTo = matchesSelectorAndParentsTo;
domFns.offsetXYFromParent = offsetXYFromParent;
domFns.outerHeight = outerHeight;
domFns.outerWidth = outerWidth;
domFns.removeClassName = removeClassName;
domFns.removeEvent = removeEvent;
domFns.removeUserSelectStyles = removeUserSelectStyles;
var _shims$2 = shims, _getPrefix = _interopRequireWildcard$1(getPrefix$1);
function _getRequireWildcardCache$1(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache$1 = function(o) {
    return o ? n : t;
  })(e);
}
function _interopRequireWildcard$1(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var n = _getRequireWildcardCache$1(t);
  if (n && n.has(e))
    return n.get(e);
  var o = {}, s = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var l in e)
    if (l !== "default" && Object.prototype.hasOwnProperty.call(e, l)) {
      var c = s ? Object.getOwnPropertyDescriptor(e, l) : null;
      c && (c.get || c.set) ? Object.defineProperty(o, l, c) : o[l] = e[l];
    }
  return o.default = e, n && n.set(e, o), o;
}
let matchesSelectorFunc = "";
function matchesSelector(e, t) {
  return matchesSelectorFunc || (matchesSelectorFunc = (0, _shims$2.findInArray)(["matches", "webkitMatchesSelector", "mozMatchesSelector", "msMatchesSelector", "oMatchesSelector"], function(n) {
    return (0, _shims$2.isFunction)(e[n]);
  })), (0, _shims$2.isFunction)(e[matchesSelectorFunc]) ? e[matchesSelectorFunc](t) : !1;
}
function matchesSelectorAndParentsTo(e, t, n) {
  let o = e;
  do {
    if (matchesSelector(o, t))
      return !0;
    if (o === n)
      return !1;
    o = o.parentNode;
  } while (o);
  return !1;
}
function addEvent(e, t, n, o) {
  if (!e)
    return;
  const s = {
    capture: !0,
    ...o
  };
  e.addEventListener ? e.addEventListener(t, n, s) : e.attachEvent ? e.attachEvent("on" + t, n) : e["on" + t] = n;
}
function removeEvent(e, t, n, o) {
  if (!e)
    return;
  const s = {
    capture: !0,
    ...o
  };
  e.removeEventListener ? e.removeEventListener(t, n, s) : e.detachEvent ? e.detachEvent("on" + t, n) : e["on" + t] = null;
}
function outerHeight(e) {
  let t = e.clientHeight;
  const n = e.ownerDocument.defaultView.getComputedStyle(e);
  return t += (0, _shims$2.int)(n.borderTopWidth), t += (0, _shims$2.int)(n.borderBottomWidth), t;
}
function outerWidth(e) {
  let t = e.clientWidth;
  const n = e.ownerDocument.defaultView.getComputedStyle(e);
  return t += (0, _shims$2.int)(n.borderLeftWidth), t += (0, _shims$2.int)(n.borderRightWidth), t;
}
function innerHeight(e) {
  let t = e.clientHeight;
  const n = e.ownerDocument.defaultView.getComputedStyle(e);
  return t -= (0, _shims$2.int)(n.paddingTop), t -= (0, _shims$2.int)(n.paddingBottom), t;
}
function innerWidth(e) {
  let t = e.clientWidth;
  const n = e.ownerDocument.defaultView.getComputedStyle(e);
  return t -= (0, _shims$2.int)(n.paddingLeft), t -= (0, _shims$2.int)(n.paddingRight), t;
}
function offsetXYFromParent(e, t, n) {
  const s = t === t.ownerDocument.body ? {
    left: 0,
    top: 0
  } : t.getBoundingClientRect(), l = (e.clientX + t.scrollLeft - s.left) / n, c = (e.clientY + t.scrollTop - s.top) / n;
  return {
    x: l,
    y: c
  };
}
function createCSSTransform(e, t) {
  const n = getTranslation(e, t, "px");
  return {
    [(0, _getPrefix.browserPrefixToKey)("transform", _getPrefix.default)]: n
  };
}
function createSVGTransform(e, t) {
  return getTranslation(e, t, "");
}
function getTranslation(e, t, n) {
  let {
    x: o,
    y: s
  } = e, l = "translate(".concat(o).concat(n, ",").concat(s).concat(n, ")");
  if (t) {
    const c = "".concat(typeof t.x == "string" ? t.x : t.x + n), p = "".concat(typeof t.y == "string" ? t.y : t.y + n);
    l = "translate(".concat(c, ", ").concat(p, ")") + l;
  }
  return l;
}
function getTouch(e, t) {
  return e.targetTouches && (0, _shims$2.findInArray)(e.targetTouches, (n) => t === n.identifier) || e.changedTouches && (0, _shims$2.findInArray)(e.changedTouches, (n) => t === n.identifier);
}
function getTouchIdentifier(e) {
  if (e.targetTouches && e.targetTouches[0])
    return e.targetTouches[0].identifier;
  if (e.changedTouches && e.changedTouches[0])
    return e.changedTouches[0].identifier;
}
function addUserSelectStyles(e) {
  if (!e)
    return;
  let t = e.getElementById("react-draggable-style-el");
  t || (t = e.createElement("style"), t.type = "text/css", t.id = "react-draggable-style-el", t.innerHTML = `.react-draggable-transparent-selection *::-moz-selection {all: inherit;}
`, t.innerHTML += `.react-draggable-transparent-selection *::selection {all: inherit;}
`, e.getElementsByTagName("head")[0].appendChild(t)), e.body && addClassName(e.body, "react-draggable-transparent-selection");
}
function removeUserSelectStyles(e) {
  if (e)
    try {
      if (e.body && removeClassName(e.body, "react-draggable-transparent-selection"), e.selection)
        e.selection.empty();
      else {
        const t = (e.defaultView || window).getSelection();
        t && t.type !== "Caret" && t.removeAllRanges();
      }
    } catch {
    }
}
function addClassName(e, t) {
  e.classList ? e.classList.add(t) : e.className.match(new RegExp("(?:^|\\s)".concat(t, "(?!\\S)"))) || (e.className += " ".concat(t));
}
function removeClassName(e, t) {
  e.classList ? e.classList.remove(t) : e.className = e.className.replace(new RegExp("(?:^|\\s)".concat(t, "(?!\\S)"), "g"), "");
}
var positionFns = {};
Object.defineProperty(positionFns, "__esModule", {
  value: !0
});
positionFns.canDragX = canDragX;
positionFns.canDragY = canDragY;
positionFns.createCoreData = createCoreData;
positionFns.createDraggableData = createDraggableData;
positionFns.getBoundPosition = getBoundPosition;
positionFns.getControlPosition = getControlPosition;
positionFns.snapToGrid = snapToGrid;
var _shims$1 = shims, _domFns$1 = domFns;
function getBoundPosition(e, t, n) {
  if (!e.props.bounds)
    return [t, n];
  let {
    bounds: o
  } = e.props;
  o = typeof o == "string" ? o : cloneBounds(o);
  const s = findDOMNode(e);
  if (typeof o == "string") {
    const {
      ownerDocument: l
    } = s, c = l.defaultView;
    let p;
    if (o === "parent" ? p = s.parentNode : p = l.querySelector(o), !(p instanceof c.HTMLElement))
      throw new Error('Bounds selector "' + o + '" could not find an element.');
    const m = p, C = c.getComputedStyle(s), P = c.getComputedStyle(m);
    o = {
      left: -s.offsetLeft + (0, _shims$1.int)(P.paddingLeft) + (0, _shims$1.int)(C.marginLeft),
      top: -s.offsetTop + (0, _shims$1.int)(P.paddingTop) + (0, _shims$1.int)(C.marginTop),
      right: (0, _domFns$1.innerWidth)(m) - (0, _domFns$1.outerWidth)(s) - s.offsetLeft + (0, _shims$1.int)(P.paddingRight) - (0, _shims$1.int)(C.marginRight),
      bottom: (0, _domFns$1.innerHeight)(m) - (0, _domFns$1.outerHeight)(s) - s.offsetTop + (0, _shims$1.int)(P.paddingBottom) - (0, _shims$1.int)(C.marginBottom)
    };
  }
  return (0, _shims$1.isNum)(o.right) && (t = Math.min(t, o.right)), (0, _shims$1.isNum)(o.bottom) && (n = Math.min(n, o.bottom)), (0, _shims$1.isNum)(o.left) && (t = Math.max(t, o.left)), (0, _shims$1.isNum)(o.top) && (n = Math.max(n, o.top)), [t, n];
}
function snapToGrid(e, t, n) {
  const o = Math.round(t / e[0]) * e[0], s = Math.round(n / e[1]) * e[1];
  return [o, s];
}
function canDragX(e) {
  return e.props.axis === "both" || e.props.axis === "x";
}
function canDragY(e) {
  return e.props.axis === "both" || e.props.axis === "y";
}
function getControlPosition(e, t, n) {
  const o = typeof t == "number" ? (0, _domFns$1.getTouch)(e, t) : null;
  if (typeof t == "number" && !o)
    return null;
  const s = findDOMNode(n), l = n.props.offsetParent || s.offsetParent || s.ownerDocument.body;
  return (0, _domFns$1.offsetXYFromParent)(o || e, l, n.props.scale);
}
function createCoreData(e, t, n) {
  const o = !(0, _shims$1.isNum)(e.lastX), s = findDOMNode(e);
  return o ? {
    node: s,
    deltaX: 0,
    deltaY: 0,
    lastX: t,
    lastY: n,
    x: t,
    y: n
  } : {
    node: s,
    deltaX: t - e.lastX,
    deltaY: n - e.lastY,
    lastX: e.lastX,
    lastY: e.lastY,
    x: t,
    y: n
  };
}
function createDraggableData(e, t) {
  const n = e.props.scale;
  return {
    node: t.node,
    x: e.state.x + t.deltaX / n,
    y: e.state.y + t.deltaY / n,
    deltaX: t.deltaX / n,
    deltaY: t.deltaY / n,
    lastX: e.state.x,
    lastY: e.state.y
  };
}
function cloneBounds(e) {
  return {
    left: e.left,
    top: e.top,
    right: e.right,
    bottom: e.bottom
  };
}
function findDOMNode(e) {
  const t = e.findDOMNode();
  if (!t)
    throw new Error("<DraggableCore>: Unmounted during event!");
  return t;
}
var DraggableCore$2 = {}, log$1 = {};
Object.defineProperty(log$1, "__esModule", {
  value: !0
});
log$1.default = log;
function log() {
}
Object.defineProperty(DraggableCore$2, "__esModule", {
  value: !0
});
DraggableCore$2.default = void 0;
var React = _interopRequireWildcard(React__default), _propTypes = _interopRequireDefault(propTypesExports), _reactDom = _interopRequireDefault(reactDomExports), _domFns = domFns, _positionFns = positionFns, _shims = shims, _log = _interopRequireDefault(log$1);
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : { default: e };
}
function _getRequireWildcardCache(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache = function(o) {
    return o ? n : t;
  })(e);
}
function _interopRequireWildcard(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var n = _getRequireWildcardCache(t);
  if (n && n.has(e))
    return n.get(e);
  var o = {}, s = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var l in e)
    if (l !== "default" && Object.prototype.hasOwnProperty.call(e, l)) {
      var c = s ? Object.getOwnPropertyDescriptor(e, l) : null;
      c && (c.get || c.set) ? Object.defineProperty(o, l, c) : o[l] = e[l];
    }
  return o.default = e, n && n.set(e, o), o;
}
function _defineProperty(e, t, n) {
  return t = _toPropertyKey(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function _toPropertyKey(e) {
  var t = _toPrimitive(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function _toPrimitive(e, t) {
  if (typeof e != "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t || "default");
    if (typeof o != "object")
      return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
const eventsFor = {
  touch: {
    start: "touchstart",
    move: "touchmove",
    stop: "touchend"
  },
  mouse: {
    start: "mousedown",
    move: "mousemove",
    stop: "mouseup"
  }
};
let dragEventFor = eventsFor.mouse, DraggableCore$1 = class extends React.Component {
  constructor() {
    super(...arguments), _defineProperty(this, "dragging", !1), _defineProperty(this, "lastX", NaN), _defineProperty(this, "lastY", NaN), _defineProperty(this, "touchIdentifier", null), _defineProperty(this, "mounted", !1), _defineProperty(this, "handleDragStart", (t) => {
      if (this.props.onMouseDown(t), !this.props.allowAnyClick && typeof t.button == "number" && t.button !== 0)
        return !1;
      const n = this.findDOMNode();
      if (!n || !n.ownerDocument || !n.ownerDocument.body)
        throw new Error("<DraggableCore> not mounted on DragStart!");
      const {
        ownerDocument: o
      } = n;
      if (this.props.disabled || !(t.target instanceof o.defaultView.Node) || this.props.handle && !(0, _domFns.matchesSelectorAndParentsTo)(t.target, this.props.handle, n) || this.props.cancel && (0, _domFns.matchesSelectorAndParentsTo)(t.target, this.props.cancel, n))
        return;
      t.type === "touchstart" && t.preventDefault();
      const s = (0, _domFns.getTouchIdentifier)(t);
      this.touchIdentifier = s;
      const l = (0, _positionFns.getControlPosition)(t, s, this);
      if (l == null)
        return;
      const {
        x: c,
        y: p
      } = l, m = (0, _positionFns.createCoreData)(this, c, p);
      (0, _log.default)("DraggableCore: handleDragStart: %j", m), (0, _log.default)("calling", this.props.onStart), !(this.props.onStart(t, m) === !1 || this.mounted === !1) && (this.props.enableUserSelectHack && (0, _domFns.addUserSelectStyles)(o), this.dragging = !0, this.lastX = c, this.lastY = p, (0, _domFns.addEvent)(o, dragEventFor.move, this.handleDrag), (0, _domFns.addEvent)(o, dragEventFor.stop, this.handleDragStop));
    }), _defineProperty(this, "handleDrag", (t) => {
      const n = (0, _positionFns.getControlPosition)(t, this.touchIdentifier, this);
      if (n == null)
        return;
      let {
        x: o,
        y: s
      } = n;
      if (Array.isArray(this.props.grid)) {
        let p = o - this.lastX, m = s - this.lastY;
        if ([p, m] = (0, _positionFns.snapToGrid)(this.props.grid, p, m), !p && !m)
          return;
        o = this.lastX + p, s = this.lastY + m;
      }
      const l = (0, _positionFns.createCoreData)(this, o, s);
      if ((0, _log.default)("DraggableCore: handleDrag: %j", l), this.props.onDrag(t, l) === !1 || this.mounted === !1) {
        try {
          this.handleDragStop(new MouseEvent("mouseup"));
        } catch {
          const m = document.createEvent("MouseEvents");
          m.initMouseEvent("mouseup", !0, !0, window, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), this.handleDragStop(m);
        }
        return;
      }
      this.lastX = o, this.lastY = s;
    }), _defineProperty(this, "handleDragStop", (t) => {
      if (!this.dragging)
        return;
      const n = (0, _positionFns.getControlPosition)(t, this.touchIdentifier, this);
      if (n == null)
        return;
      let {
        x: o,
        y: s
      } = n;
      if (Array.isArray(this.props.grid)) {
        let m = o - this.lastX || 0, C = s - this.lastY || 0;
        [m, C] = (0, _positionFns.snapToGrid)(this.props.grid, m, C), o = this.lastX + m, s = this.lastY + C;
      }
      const l = (0, _positionFns.createCoreData)(this, o, s);
      if (this.props.onStop(t, l) === !1 || this.mounted === !1)
        return !1;
      const p = this.findDOMNode();
      p && this.props.enableUserSelectHack && (0, _domFns.removeUserSelectStyles)(p.ownerDocument), (0, _log.default)("DraggableCore: handleDragStop: %j", l), this.dragging = !1, this.lastX = NaN, this.lastY = NaN, p && ((0, _log.default)("DraggableCore: Removing handlers"), (0, _domFns.removeEvent)(p.ownerDocument, dragEventFor.move, this.handleDrag), (0, _domFns.removeEvent)(p.ownerDocument, dragEventFor.stop, this.handleDragStop));
    }), _defineProperty(this, "onMouseDown", (t) => (dragEventFor = eventsFor.mouse, this.handleDragStart(t))), _defineProperty(this, "onMouseUp", (t) => (dragEventFor = eventsFor.mouse, this.handleDragStop(t))), _defineProperty(this, "onTouchStart", (t) => (dragEventFor = eventsFor.touch, this.handleDragStart(t))), _defineProperty(this, "onTouchEnd", (t) => (dragEventFor = eventsFor.touch, this.handleDragStop(t)));
  }
  componentDidMount() {
    this.mounted = !0;
    const t = this.findDOMNode();
    t && (0, _domFns.addEvent)(t, eventsFor.touch.start, this.onTouchStart, {
      passive: !1
    });
  }
  componentWillUnmount() {
    this.mounted = !1;
    const t = this.findDOMNode();
    if (t) {
      const {
        ownerDocument: n
      } = t;
      (0, _domFns.removeEvent)(n, eventsFor.mouse.move, this.handleDrag), (0, _domFns.removeEvent)(n, eventsFor.touch.move, this.handleDrag), (0, _domFns.removeEvent)(n, eventsFor.mouse.stop, this.handleDragStop), (0, _domFns.removeEvent)(n, eventsFor.touch.stop, this.handleDragStop), (0, _domFns.removeEvent)(t, eventsFor.touch.start, this.onTouchStart, {
        passive: !1
      }), this.props.enableUserSelectHack && (0, _domFns.removeUserSelectStyles)(n);
    }
  }
  // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
  // the underlying DOM node ourselves. See the README for more information.
  findDOMNode() {
    var t, n;
    return (t = this.props) !== null && t !== void 0 && t.nodeRef ? (n = this.props) === null || n === void 0 || (n = n.nodeRef) === null || n === void 0 ? void 0 : n.current : _reactDom.default.findDOMNode(this);
  }
  render() {
    return /* @__PURE__ */ React.cloneElement(React.Children.only(this.props.children), {
      // Note: mouseMove handler is attached to document so it will still function
      // when the user drags quickly and leaves the bounds of the element.
      onMouseDown: this.onMouseDown,
      onMouseUp: this.onMouseUp,
      // onTouchStart is added on `componentDidMount` so they can be added with
      // {passive: false}, which allows it to cancel. See
      // https://developers.google.com/web/updates/2017/01/scrolling-intervention
      onTouchEnd: this.onTouchEnd
    });
  }
};
DraggableCore$2.default = DraggableCore$1;
_defineProperty(DraggableCore$1, "displayName", "DraggableCore");
_defineProperty(DraggableCore$1, "propTypes", {
  /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */
  allowAnyClick: _propTypes.default.bool,
  children: _propTypes.default.node.isRequired,
  /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */
  disabled: _propTypes.default.bool,
  /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */
  enableUserSelectHack: _propTypes.default.bool,
  /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */
  offsetParent: function(e, t) {
    if (e[t] && e[t].nodeType !== 1)
      throw new Error("Draggable's offsetParent must be a DOM Node.");
  },
  /**
   * `grid` specifies the x and y that dragging should snap to.
   */
  grid: _propTypes.default.arrayOf(_propTypes.default.number),
  /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  handle: _propTypes.default.string,
  /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */
  cancel: _propTypes.default.string,
  /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */
  nodeRef: _propTypes.default.object,
  /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onStart: _propTypes.default.func,
  /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onDrag: _propTypes.default.func,
  /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */
  onStop: _propTypes.default.func,
  /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */
  onMouseDown: _propTypes.default.func,
  /**
   * `scale`, if set, applies scaling while dragging an element
   */
  scale: _propTypes.default.number,
  /**
   * These properties should be defined on the child, not here.
   */
  className: _shims.dontSetMe,
  style: _shims.dontSetMe,
  transform: _shims.dontSetMe
});
_defineProperty(DraggableCore$1, "defaultProps", {
  allowAnyClick: !1,
  // by default only accept left click
  disabled: !1,
  enableUserSelectHack: !0,
  onStart: function() {
  },
  onDrag: function() {
  },
  onStop: function() {
  },
  onMouseDown: function() {
  },
  scale: 1
});
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "DraggableCore", {
    enumerable: !0,
    get: function() {
      return m.default;
    }
  }), e.default = void 0;
  var t = R(React__default), n = P(propTypesExports), o = P(reactDomExports), s = P(require$$3), l = domFns, c = positionFns, p = shims, m = P(DraggableCore$2), C = P(log$1);
  function P(V) {
    return V && V.__esModule ? V : { default: V };
  }
  function w(V) {
    if (typeof WeakMap != "function")
      return null;
    var N = /* @__PURE__ */ new WeakMap(), B = /* @__PURE__ */ new WeakMap();
    return (w = function(K) {
      return K ? B : N;
    })(V);
  }
  function R(V, N) {
    if (!N && V && V.__esModule)
      return V;
    if (V === null || typeof V != "object" && typeof V != "function")
      return { default: V };
    var B = w(N);
    if (B && B.has(V))
      return B.get(V);
    var K = {}, ue = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var de in V)
      if (de !== "default" && Object.prototype.hasOwnProperty.call(V, de)) {
        var ve = ue ? Object.getOwnPropertyDescriptor(V, de) : null;
        ve && (ve.get || ve.set) ? Object.defineProperty(K, de, ve) : K[de] = V[de];
      }
    return K.default = V, B && B.set(V, K), K;
  }
  function L() {
    return L = Object.assign ? Object.assign.bind() : function(V) {
      for (var N = 1; N < arguments.length; N++) {
        var B = arguments[N];
        for (var K in B)
          Object.prototype.hasOwnProperty.call(B, K) && (V[K] = B[K]);
      }
      return V;
    }, L.apply(this, arguments);
  }
  function M(V, N, B) {
    return N = $(N), N in V ? Object.defineProperty(V, N, { value: B, enumerable: !0, configurable: !0, writable: !0 }) : V[N] = B, V;
  }
  function $(V) {
    var N = W(V, "string");
    return typeof N == "symbol" ? N : String(N);
  }
  function W(V, N) {
    if (typeof V != "object" || V === null)
      return V;
    var B = V[Symbol.toPrimitive];
    if (B !== void 0) {
      var K = B.call(V, N || "default");
      if (typeof K != "object")
        return K;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (N === "string" ? String : Number)(V);
  }
  class H extends t.Component {
    // React 16.3+
    // Arity (props, state)
    static getDerivedStateFromProps(N, B) {
      let {
        position: K
      } = N, {
        prevPropsPosition: ue
      } = B;
      return K && (!ue || K.x !== ue.x || K.y !== ue.y) ? ((0, C.default)("Draggable: getDerivedStateFromProps %j", {
        position: K,
        prevPropsPosition: ue
      }), {
        x: K.x,
        y: K.y,
        prevPropsPosition: {
          ...K
        }
      }) : null;
    }
    constructor(N) {
      super(N), M(this, "onDragStart", (B, K) => {
        if ((0, C.default)("Draggable: onDragStart: %j", K), this.props.onStart(B, (0, c.createDraggableData)(this, K)) === !1)
          return !1;
        this.setState({
          dragging: !0,
          dragged: !0
        });
      }), M(this, "onDrag", (B, K) => {
        if (!this.state.dragging)
          return !1;
        (0, C.default)("Draggable: onDrag: %j", K);
        const ue = (0, c.createDraggableData)(this, K), de = {
          x: ue.x,
          y: ue.y,
          slackX: 0,
          slackY: 0
        };
        if (this.props.bounds) {
          const {
            x: Te,
            y: Pe
          } = de;
          de.x += this.state.slackX, de.y += this.state.slackY;
          const [Ce, Re] = (0, c.getBoundPosition)(this, de.x, de.y);
          de.x = Ce, de.y = Re, de.slackX = this.state.slackX + (Te - de.x), de.slackY = this.state.slackY + (Pe - de.y), ue.x = de.x, ue.y = de.y, ue.deltaX = de.x - this.state.x, ue.deltaY = de.y - this.state.y;
        }
        if (this.props.onDrag(B, ue) === !1)
          return !1;
        this.setState(de);
      }), M(this, "onDragStop", (B, K) => {
        if (!this.state.dragging || this.props.onStop(B, (0, c.createDraggableData)(this, K)) === !1)
          return !1;
        (0, C.default)("Draggable: onDragStop: %j", K);
        const de = {
          dragging: !1,
          slackX: 0,
          slackY: 0
        };
        if (!!this.props.position) {
          const {
            x: Te,
            y: Pe
          } = this.props.position;
          de.x = Te, de.y = Pe;
        }
        this.setState(de);
      }), this.state = {
        // Whether or not we are currently dragging.
        dragging: !1,
        // Whether or not we have been dragged before.
        dragged: !1,
        // Current transform x and y.
        x: N.position ? N.position.x : N.defaultPosition.x,
        y: N.position ? N.position.y : N.defaultPosition.y,
        prevPropsPosition: {
          ...N.position
        },
        // Used for compensating for out-of-bounds drags
        slackX: 0,
        slackY: 0,
        // Can only determine if SVG after mounting
        isElementSVG: !1
      }, N.position && !(N.onDrag || N.onStop) && console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
    }
    componentDidMount() {
      typeof window.SVGElement < "u" && this.findDOMNode() instanceof window.SVGElement && this.setState({
        isElementSVG: !0
      });
    }
    componentWillUnmount() {
      this.setState({
        dragging: !1
      });
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() {
      var N, B;
      return (N = (B = this.props) === null || B === void 0 || (B = B.nodeRef) === null || B === void 0 ? void 0 : B.current) !== null && N !== void 0 ? N : o.default.findDOMNode(this);
    }
    render() {
      const {
        axis: N,
        bounds: B,
        children: K,
        defaultPosition: ue,
        defaultClassName: de,
        defaultClassNameDragging: ve,
        defaultClassNameDragged: Te,
        position: Pe,
        positionOffset: Ce,
        scale: Re,
        ...ke
      } = this.props;
      let Ae = {}, we = null;
      const be = !!!Pe || this.state.dragging, le = Pe || ue, fe = {
        // Set left if horizontal drag is enabled
        x: (0, c.canDragX)(this) && be ? this.state.x : le.x,
        // Set top if vertical drag is enabled
        y: (0, c.canDragY)(this) && be ? this.state.y : le.y
      };
      this.state.isElementSVG ? we = (0, l.createSVGTransform)(fe, Ce) : Ae = (0, l.createCSSTransform)(fe, Ce);
      const ye = (0, s.default)(K.props.className || "", de, {
        [ve]: this.state.dragging,
        [Te]: this.state.dragged
      });
      return /* @__PURE__ */ t.createElement(m.default, L({}, ke, {
        onStart: this.onDragStart,
        onDrag: this.onDrag,
        onStop: this.onDragStop
      }), /* @__PURE__ */ t.cloneElement(t.Children.only(K), {
        className: ye,
        style: {
          ...K.props.style,
          ...Ae
        },
        transform: we
      }));
    }
  }
  e.default = H, M(H, "displayName", "Draggable"), M(H, "propTypes", {
    // Accepts all props <DraggableCore> accepts.
    ...m.default.propTypes,
    /**
     * `axis` determines which axis the draggable can move.
     *
     *  Note that all callbacks will still return data as normal. This only
     *  controls flushing to the DOM.
     *
     * 'both' allows movement horizontally and vertically.
     * 'x' limits movement to horizontal axis.
     * 'y' limits movement to vertical axis.
     * 'none' limits all movement.
     *
     * Defaults to 'both'.
     */
    axis: n.default.oneOf(["both", "x", "y", "none"]),
    /**
     * `bounds` determines the range of movement available to the element.
     * Available values are:
     *
     * 'parent' restricts movement within the Draggable's parent node.
     *
     * Alternatively, pass an object with the following properties, all of which are optional:
     *
     * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
     *
     * All values are in px.
     *
     * Example:
     *
     * ```jsx
     *   let App = React.createClass({
     *       render: function () {
     *         return (
     *            <Draggable bounds={{right: 300, bottom: 300}}>
     *              <div>Content</div>
     *           </Draggable>
     *         );
     *       }
     *   });
     * ```
     */
    bounds: n.default.oneOfType([n.default.shape({
      left: n.default.number,
      right: n.default.number,
      top: n.default.number,
      bottom: n.default.number
    }), n.default.string, n.default.oneOf([!1])]),
    defaultClassName: n.default.string,
    defaultClassNameDragging: n.default.string,
    defaultClassNameDragged: n.default.string,
    /**
     * `defaultPosition` specifies the x and y that the dragged item should start at
     *
     * Example:
     *
     * ```jsx
     *      let App = React.createClass({
     *          render: function () {
     *              return (
     *                  <Draggable defaultPosition={{x: 25, y: 25}}>
     *                      <div>I start with transformX: 25px and transformY: 25px;</div>
     *                  </Draggable>
     *              );
     *          }
     *      });
     * ```
     */
    defaultPosition: n.default.shape({
      x: n.default.number,
      y: n.default.number
    }),
    positionOffset: n.default.shape({
      x: n.default.oneOfType([n.default.number, n.default.string]),
      y: n.default.oneOfType([n.default.number, n.default.string])
    }),
    /**
     * `position`, if present, defines the current position of the element.
     *
     *  This is similar to how form elements in React work - if no `position` is supplied, the component
     *  is uncontrolled.
     *
     * Example:
     *
     * ```jsx
     *      let App = React.createClass({
     *          render: function () {
     *              return (
     *                  <Draggable position={{x: 25, y: 25}}>
     *                      <div>I start with transformX: 25px and transformY: 25px;</div>
     *                  </Draggable>
     *              );
     *          }
     *      });
     * ```
     */
    position: n.default.shape({
      x: n.default.number,
      y: n.default.number
    }),
    /**
     * These properties should be defined on the child, not here.
     */
    className: p.dontSetMe,
    style: p.dontSetMe,
    transform: p.dontSetMe
  }), M(H, "defaultProps", {
    ...m.default.defaultProps,
    axis: "both",
    bounds: !1,
    defaultClassName: "react-draggable",
    defaultClassNameDragging: "react-draggable-dragging",
    defaultClassNameDragged: "react-draggable-dragged",
    defaultPosition: {
      x: 0,
      y: 0
    },
    scale: 1
  });
})(Draggable$2);
const {
  default: Draggable,
  DraggableCore
} = Draggable$2;
cjs.exports = Draggable;
cjs.exports.default = Draggable;
cjs.exports.DraggableCore = DraggableCore;
var cjsExports = cjs.exports;
const Draggable$1 = /* @__PURE__ */ getDefaultExportFromCjs(cjsExports), Messages$1 = "", Messages = ({ messages: e, currentUserId: t, fullScreen: n }) => {
  const o = useIntl(), s = /(((?:(http|https|Http|Https|rtsp|Rtsp):\/\/(?:(?:[a-zA-Z0-9\$\-\_\.\+\!\*\'\(\)\,\;\?\&\=]|(?:\%[a-fA-F0-9]{2})){1,64}(?:\:(?:[a-zA-Z0-9\$\-\_\.\+\!\*\'\(\)\,\;\?\&\=]|(?:\%[a-fA-F0-9]{2})){1,25})?\@)?)?((?:(?:[a-zA-Z0-9][a-zA-Z0-9\-]{0,64}\.)+(?:(?:aero|arpa|asia|a[cdefgilmnoqrstuwxz])|(?:biz|b[abdefghijmnorstvwyz])|(?:cat|com|coop|c[acdfghiklmnoruvxyz])|d[ejkmoz]|(?:edu|e[cegrstu])|f[ijkmor]|(?:gov|g[abdefghilmnpqrstuwy])|h[kmnrtu]|(?:info|int|i[delmnoqrst])|(?:jobs|j[emop])|k[eghimnrwyz]|l[abcikrstuvy]|(?:mil|mobi|museum|m[acdghklmnopqrstuvwxyz])|(?:name|net|n[acefgilopruz])|(?:org|om)|(?:pro|p[aefghklmnrstwy])|qa|r[eouw]|s[abcdeghijklmnortuvyz]|(?:tel|travel|t[cdfghjklmnoprtvwz])|u[agkmsyz]|v[aceginu]|w[fs]|y[etu]|z[amw]))|(?:(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9])\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[0-9])))(?:\:\d{1,5})?)(\/(?:(?:[a-zA-Z0-9\;\/\?\:\@\&\=\#\~\-\.\+\!\*\'\(\)\,\_])|(?:\%[a-fA-F0-9]{2}))*)?(?:\b|$))/gi;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `px-3 mt-2 messages-component messages d-flex flex-column flex-column-reverse ${n ? "fullscreen-chat" : ""}`, children: e.map((l) => {
    const c = l.senderName === "ADMIN", p = t && l.sender === t;
    let m = l.content.message, C, P;
    const w = m.match(s);
    if (w == null || w.forEach((R) => {
      m = m.replaceAll(R, `<a style="color:white" href='${R}' target="_blank" rel="noopener noreferrer">${R}<a>`);
    }), c)
      C = o.formatMessage({ id: "chat.referee" });
    else if (!l.senderName)
      C = o.formatMessage({ id: `tournament.${p ? "you" : "opponent"}` });
    else {
      const R = l.senderName.lastIndexOf("#");
      P = R !== -1 ? l.senderName.slice(R) : "", C = R !== -1 ? l.senderName.slice(0, R) : l.senderName;
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `mt-4 ${c ? "referee" : ""} ${p ? "me text-right" : ""}`, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "username", children: C }),
        P && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "code", children: [
          P,
          p && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "ml-1", children: [
            "(",
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              FormattedMessage$1,
              {
                id: "chat.me",
                description: "Chat - Me"
              }
            ),
            ")"
          ] })
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { dangerouslySetInnerHTML: { __html: m }, className: "message mt-2" })
    ] }, l.target);
  }) });
}, Chat = (e) => {
  const t = "tournament-chat-position", n = useIntl(), [o, s] = useState(!0), [l, c] = useState(!0), [p, m] = useState(!1), [C, P] = useState(""), [w, R] = useState(), [L, M] = useState(!1), [$, W] = useState(), [H, V] = useState("bottom-left"), N = React__default.useRef(null), B = useRef(null), K = (be, le) => {
    let Ee = be, Ie = le;
    return Ee > window.innerWidth - 125 && (Ee = window.innerWidth - 125), Ee < -50 && (Ee = -50), Ie > window.innerHeight - 125 && (Ie = window.innerHeight - 125), Ie < -50 && (Ie = -50), { x: Ee, y: Ie };
  }, ue = () => {
    w || (R(!0), c(o), s(!1));
  }, de = (be, le) => {
    w && (we(le.x, le.y), s(l)), localStorage.setItem(t, JSON.stringify({ x: le.x, y: le.y }));
  }, ve = (be) => {
    N && N.current && !N.current.contains(be.target) && s(!1);
  }, Te = (be) => {
    be.ctrlKey && be.code === "Space" && Ce();
  }, Pe = () => {
    (!w || e.fullScreen) && Ce(), R(!1);
  }, Ce = () => {
    p && !o && m(!1), s(!o);
  }, Re = (be) => {
    P(be), M(be.trim().length > 0);
  }, ke = () => {
    L && (e.sendMessage(C), Re(""));
  }, Ae = (be) => {
    be.key === "Enter" && ke();
  }, we = (be, le) => {
    const { x: fe, y: ye } = K(be, le), Ee = ye > window.innerHeight / 2, Ie = fe > window.innerWidth / 2;
    Ee && Ie ? V("top-left") : Ee && !Ie ? V("top-right") : !Ee && Ie ? V("bottom-left") : !Ee && !Ie && V("bottom-right"), W({ x: fe, y: ye });
  }, he = () => {
    $ && we($.x, $.y);
  };
  return useEffect(() => {
    o && B.current && B.current.focus();
  }, [o]), useEffect(() => {
    const be = localStorage.getItem(t);
    let le = window.innerWidth, fe = window.innerHeight;
    if (be) {
      const ye = JSON.parse(be);
      (ye.x || ye.x === 0) && (ye.y || ye.y === 0) && (le = ye.x, fe = ye.y);
    }
    return we(le, fe), document.addEventListener("mousedown", ve), () => {
      document.removeEventListener("mousedown", ve);
    };
  }, []), useEffect(() => (window.addEventListener("keydown", Te), () => {
    window.removeEventListener("keydown", Te);
  }), [Ce]), useEffect(() => {
    e.fullScreen && W({ x: 0, y: 0 });
  }, [e.fullScreen]), useEffect(() => (window.addEventListener("resize", he), () => {
    window.removeEventListener("resize", he);
  }), [$]), useEffect(() => {
    o || m(!0);
  }, [e.messages]), /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: $ && /* @__PURE__ */ jsxRuntimeExports.jsx(Draggable$1, { nodeRef: N, disabled: e.fullScreen, handle: ".comments-icon", position: $, onDrag: ue, onStop: de, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { ref: N, className: `chat position-fixed d-flex ${e.fullScreen ? "fullscreen-chat flex-column-reverse align-items-end w-100" : ""} ${o ? "" : "closed"}`, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        onClick: () => Pe(),
        onTouchEnd: () => e.fullScreen ? null : Pe(),
        className: `icon-container  comments-icon d-flex align-items-center justify-content-center
                                ${p ? "unread" : ""}
                                ${e.fullScreen ? "my-1 mr-2" : ""}`,
        children: [
          p && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "unread-icon" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Icon,
            {
              icon: IconType.Comments,
              width: p ? 27 : 20,
              height: p ? 28 : 21
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `box ${e.fullScreen ? "w-100 d-flex flex-column flex-fill" : H}`, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "d-flex flex-column justify-content-center header px-3 w-100", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "title", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          FormattedMessage$1,
          {
            id: "chat.chatbox",
            description: "Chat - Chatbox"
          }
        ) }),
        !e.fullScreen && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "hint", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          FormattedMessage$1,
          {
            id: "chat.shortcut",
            description: "Chat - Chatbox",
            values: { shortcutKey: "ctrl+space" }
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { onClick: () => s(!1), children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { styleName: "position-absolute", icon: IconType.Close, height: 12, width: 12 }) })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "chat-shadow position-absolute w-100" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Messages, { fullScreen: e.fullScreen || !1, messages: e.messages, currentUserId: e.currentUserId }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "footer mt-3 px-3 pb-2", children: e.isCaptain ? /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "input-text", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          FormattedMessage$1,
          {
            id: "chat.send_your_message",
            description: "Chat - Send your message"
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "d-flex align-items-center", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "input",
            {
              onKeyDown: Ae,
              placeholder: n.formatMessage({ id: "chat.write_message" }),
              value: C,
              onChange: (be) => Re(be.target.value),
              type: "text",
              ref: B
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { onClick: () => ke(), children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { styleName: `ml-2 ${L ? "valid" : ""}`, icon: IconType.Send, width: 19.5, height: 19.5 }) })
        ] })
      ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "input-text-no-captain d-flex justify-content-center", children: n.formatMessage({ id: "only.captain.can.talk" }) }) })
    ] })
  ] }) }) });
};
var AuthFormType = /* @__PURE__ */ ((e) => (e.Login = "Login", e.Register = "Register", e.Forgot = "Forgot", e))(AuthFormType || {}), OptionalFieldType = /* @__PURE__ */ ((e) => (e.FIRSTNAME = "first_name", e.LASTNAME = "last_name", e.PHONENUMBER = "phone", e.BIRTHDATE = "birthdate", e))(OptionalFieldType || {});
const AuthFormDefaultTheme = createTheme({
  palette: {
    primary: {
      main: "#b2f617"
    },
    secondary: {
      main: "#FFFFFF"
    },
    mode: "dark"
  },
  typography: {
    fontFamily: "mollenregular"
  }
});
var NCTheme = /* @__PURE__ */ ((e) => (e[e.Platform = 0] = "Platform", e[e.Grey = 1] = "Grey", e))(NCTheme || {});
const getTheme = (e) => {
  switch (e) {
    case 0:
      return ThemePlatform;
    case 1:
      return ThemeGrey;
    default:
      return ThemePlatform;
  }
}, ThemePlatform = createTheme({
  palette: {
    primary: {
      main: "#b2f617"
    },
    secondary: {
      main: "#292D30"
    },
    mode: "dark"
  },
  typography: {
    fontFamily: "mollenregular"
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: "#1a1a1a"
        }
      }
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: "#1a1a1a"
          }
        }
      }
    }
  }
}), ThemeGrey = createTheme({
  palette: {
    primary: {
      main: "#888c88"
    },
    secondary: {
      main: "#1a1a1a"
    },
    mode: "dark"
  },
  typography: {
    fontFamily: "mollenregular"
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: "#1a1a1a"
        }
      }
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: "#1a1a1a"
          }
        }
      }
    }
  }
}), DatePicker$1 = "", DATETIME_FORMAT = "YYYY-MM-DDTHH:mm", DATE_FORMAT = "YYYY-MM-DD", DatePicker = (e) => {
  const t = useRef(null), n = e.value && !e.withoutTime ? hooks(e.value).format(DATETIME_FORMAT) : hooks(e.value).format(DATE_FORMAT), o = e.initialValue && !e.withoutTime ? hooks(e.initialValue).format(DATETIME_FORMAT) : hooks(e.initialValue).format(DATE_FORMAT), s = (l) => {
    (hooks(Date.now()).unix() > hooks(l.target.value).unix() || !e.withoutTime) && e.dateChanged(hooks(l.target.value).valueOf());
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider, { theme: ThemePlatform, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: "datepicker-container d-flex position-relative",
      onClick: () => {
        var l;
        (l = t.current) == null || l.focus(), "showPicker" in HTMLInputElement.prototype && t.current.showPicker();
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          TextField$1,
          {
            inputRef: t,
            type: `${e.withoutTime ? "date" : "datetime-local"}`,
            className: "datepicker-input nicecactus-input",
            value: n,
            defaultValue: o,
            label: e.label,
            onChange: s,
            InputLabelProps: { shrink: !0 }
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "div",
          {
            className: "icon",
            style: {
              maskImage: "url(https://assets.next.wolfiesports.com/media/icons/calendar.svg)",
              WebkitMaskImage: "url(https://assets.next.wolfiesports.com/media/icons/calendar.svg)"
            }
          }
        )
      ]
    }
  ) }) });
}, AuthForm$1 = "", emailRegex = /.+@.+\.[a-z]{2,3}/, AuthForm = (e) => {
  const t = useIntl(), [n, o] = useState(""), [s, l] = useState(""), [c, p] = useState(""), [m, C] = useState(""), [P, w] = useState(Date.now()), [R, L] = useState(!1), [M, $] = useState(""), [W, H] = useState(""), [V, N] = useState(""), [B, K] = useState(e.agreementList), [ue, de] = useState(e.formType), [ve, Te] = useState(!1);
  useEffect(() => {
    de(e.formType);
  }, [e.formType]), useEffect(() => {
    Ce();
  }, [n, s, c, m, R, M, V, W, B, ue, ve]);
  const Pe = (Fe) => {
    e.onSwitchFormType && e.onSwitchFormType(Fe);
  }, Ce = () => {
    var Fe, De, Ve, Oe;
    if (ve)
      return !0;
    switch (ue) {
      case AuthFormType.Login:
        return M.length === 0 || W.length === 0 || !emailRegex.test(M);
      case AuthFormType.Register:
        return !!(B.find((Ze) => !Ze.checked && Ze.mandatory) || n.length === 0 || M.length === 0 || W.length === 0 || V.length === 0 || W !== V || !emailRegex.test(M) || s.length === 0 && ((Fe = e.optionalFields) != null && Fe.filter((Ze) => Ze.type === OptionalFieldType.FIRSTNAME)[0].mandatory) || c.length === 0 && ((De = e.optionalFields) != null && De.filter((Ze) => Ze.type === OptionalFieldType.LASTNAME)[0].mandatory) || m.length === 0 && ((Ve = e.optionalFields) != null && Ve.filter((Ze) => Ze.type === OptionalFieldType.PHONENUMBER)[0].mandatory) || !R && ((Oe = e.optionalFields) != null && Oe.filter((Ze) => Ze.type === OptionalFieldType.BIRTHDATE)[0].mandatory));
      case AuthFormType.Forgot:
        return M.length === 0 || !emailRegex.test(M);
    }
    return !0;
  }, Re = async (Fe) => {
    Te(!0), await e.onFormSubmit(Fe), Te(!1);
  }, ke = () => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "d-flex flex-column align-items-center", children: e.socialNetworks && e.socialNetworks.map((Fe) => {
    const De = Object.keys(IconType).find((Ve) => IconType[Ve].toLowerCase() === Fe);
    if (De)
      return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "d-flex justify-content-center col-12 my-1", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button$1,
        {
          type: ButtonType.PRIMARY,
          theme: ButtonTheme.CUSTOM,
          size: ButtonSize.MEDIUM,
          styleClass: "col-12 " + Fe,
          containerClass: "col-md-7 col-12",
          icon: { type: IconType[De], width: 24, height: 24 },
          setClick: () => Re({ socialNetwork: Fe, type: AuthFormType.Login }),
          children: Fe
        }
      ) }, Fe);
  }) }), Ae = (Fe) => {
    B[Fe].checked = !B[Fe].checked, K([...B]);
  }, we = () => /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
    B && B.map((Fe, De) => {
      let Ve = Fe.text;
      return typeof Ve == "string" && t.messages[Ve] && (Ve = t.formatMessage({ id: Ve }, Fe.textValues)), /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider, { theme: e.theme ? e.theme : AuthFormDefaultTheme, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormControlLabel$1,
        {
          className: "agreement",
          disabled: ve,
          label: Ve + (Fe.mandatory ? "*" : ""),
          control: /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox$1, { onChange: () => Ae(De), checked: Fe.checked })
        },
        De
      ) }, De);
    }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "disclaimer agreements", children: t.formatMessage({ id: "auth.form.register.mandatory.agreements" }) }),
    ue === AuthFormType.Register && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "disclaimer terms", children: t.formatMessage({ id: "auth.form.register.agreement.terms" }) })
  ] }), he = () => /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider, { theme: e.theme ? e.theme : AuthFormDefaultTheme, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      TextField$1,
      {
        disabled: ve,
        className: "shared-input mb-3 email",
        value: M,
        autoFocus: !0,
        placeholder: t.formatMessage({ id: "auth.form.user.email" }),
        onChange: (Fe) => $(Fe.target.value)
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "d-flex justify-content-center col-12", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button$1,
      {
        type: ButtonType.PRIMARY,
        theme: ButtonTheme.CUSTOM,
        size: ButtonSize.MEDIUM,
        styleClass: "login col-12",
        containerClass: "col-md-6 col-12",
        setClick: () => ye(),
        disabled: Ce(),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: t.formatMessage({ id: ve ? "auth.form.processing" : "auth.form.button.send" }) })
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "text-underline cursor-pointer mx-auto my-1", onClick: () => de(AuthFormType.Login), children: t.formatMessage({ id: "auth.form.login" }) })
  ] }), be = () => /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ThemeProvider, { theme: e.theme ? e.theme : AuthFormDefaultTheme, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        TextField$1,
        {
          disabled: ve,
          className: "shared-input mb-3 email",
          value: M,
          autoFocus: !0,
          type: "email",
          placeholder: t.formatMessage({ id: "auth.form.user.email" }),
          onChange: (Fe) => $(Fe.target.value)
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        TextField$1,
        {
          disabled: ve,
          className: "shared-input mb-3 password",
          value: W,
          type: "password",
          placeholder: t.formatMessage({ id: "auth.form.password" }),
          onChange: (Fe) => H(Fe.target.value)
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "d-flex justify-content-center mt-2 col-12", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button$1,
      {
        type: ButtonType.PRIMARY,
        theme: ButtonTheme.CUSTOM,
        size: ButtonSize.MEDIUM,
        styleClass: "login col-12",
        containerClass: "col-md-6 col-12",
        setClick: () => ye(),
        disabled: Ce(),
        children: t.formatMessage({ id: ve ? "auth.form.processing" : "auth.form.login" })
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "error-message d-flex justify-content-center mt-1", children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: e.errorMessage }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "text-underline cursor-pointer mx-auto my-3", onClick: () => de(AuthFormType.Forgot), children: t.formatMessage({ id: "auth.form.forgot.password.ask" }) }),
    ue === AuthFormType.Login && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-center", children: t.formatMessage({ id: "auth.form.g4g.credentials.sentence" }) })
  ] }), le = () => {
    var Fe;
    return (Fe = e.optionalFields) == null ? void 0 : Fe.map((De, Ve) => De.type !== OptionalFieldType.BIRTHDATE ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      TextField$1,
      {
        disabled: ve,
        className: "shared-input mb-3 w-100",
        value: De.type === OptionalFieldType.FIRSTNAME ? s : De.type === OptionalFieldType.LASTNAME ? c : m,
        autoFocus: !0,
        placeholder: t.formatMessage({ id: `user.account.${De.type}_label` }) + `${De.mandatory ? " *" : ""}`,
        onChange: (Oe) => De.type === OptionalFieldType.FIRSTNAME ? l(Oe.target.value) : De.type === OptionalFieldType.LASTNAME ? p(Oe.target.value) : C(Oe.target.value)
      }
    ) }, Ve) : /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: t.formatMessage({ id: `user.account.${De.type}_label` }) + `${De.mandatory ? " *" : ""}` }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        DatePicker,
        {
          value: P,
          dateChanged: (Oe) => {
            w(Oe), L(!0);
          },
          withoutTime: !0
        }
      )
    ] }, Ve));
  }, fe = () => /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ThemeProvider, { theme: e.theme ? e.theme : AuthFormDefaultTheme, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        TextField$1,
        {
          disabled: ve,
          className: "shared-input mb-3 user-name",
          value: n,
          autoFocus: !0,
          placeholder: t.formatMessage({ id: "auth.form.user.name" }),
          onChange: (Fe) => o(Fe.target.value)
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        TextField$1,
        {
          disabled: ve,
          className: "shared-input mb-3 email",
          value: M,
          type: "email",
          placeholder: t.formatMessage({ id: "auth.form.user.email" }),
          onChange: (Fe) => $(Fe.target.value)
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        TextField$1,
        {
          disabled: ve,
          className: "shared-input mb-3 password",
          type: "password",
          value: W,
          placeholder: t.formatMessage({ id: "auth.form.password" }),
          onChange: (Fe) => H(Fe.target.value)
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        TextField$1,
        {
          disabled: ve,
          className: "shared-input mb-3 password-repeat",
          value: V,
          type: "password",
          placeholder: t.formatMessage({ id: "auth.form.repeat.password" }),
          onChange: (Fe) => N(Fe.target.value)
        }
      ),
      le()
    ] }),
    we(),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "d-flex justify-content-center col-12", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button$1,
      {
        type: ButtonType.PRIMARY,
        theme: ButtonTheme.CUSTOM,
        size: ButtonSize.MEDIUM,
        styleClass: "login col-12",
        containerClass: "col-md-6 col-12",
        setClick: () => ye(),
        disabled: Ce(),
        children: t.formatMessage({ id: ve ? "auth.form.processing" : "auth.form.register" })
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "error-message d-flex justify-content-center mt-1", children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: e.errorMessage }) })
  ] }), ye = () => {
    switch (ue) {
      case AuthFormType.Login:
        Re({ type: ue, email: M, password: W });
        break;
      case AuthFormType.Register:
        Re({
          type: ue,
          userName: n,
          password: W,
          email: M,
          firstName: s,
          lastName: c,
          phoneNumber: m,
          birthDate: P,
          agreementList: e.agreementList
        });
        break;
      case AuthFormType.Forgot:
        Re({ type: ue, email: M });
        break;
    }
  }, Ee = () => {
    switch (ue) {
      case AuthFormType.Login:
        return t.formatMessage({ id: "auth.form.login" });
      case AuthFormType.Register:
        return t.formatMessage({ id: "auth.form.register" });
      case AuthFormType.Forgot:
        return t.formatMessage({ id: "auth.form.password.forgotten" });
    }
  }, Ie = () => {
    switch (ue) {
      case AuthFormType.Login:
        return be();
      case AuthFormType.Register:
        return fe();
      case AuthFormType.Forgot:
        return he();
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "corner-login h-100 d-flex flex-column justify-content-center", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$1, { variant: "h3", className: "d-none d-md-block white mx-auto text-uppercase mb-3 title", children: Ee() }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "d-md-none form-type-selector d-flex mb-3", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          className: `cursor-pointer type mr-2 text-lowercase ${ue !== AuthFormType.Register ? "active" : ""}`,
          onClick: () => Pe(AuthFormType.Login),
          children: t.formatMessage({ id: "auth.form.login" })
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          className: `cursor-pointer type text-lowercase ${ue === AuthFormType.Register ? "active" : ""}`,
          onClick: () => Pe(AuthFormType.Register),
          children: t.formatMessage({ id: "auth.form.register" })
        }
      )
    ] }),
    Ie(),
    ue !== AuthFormType.Forgot && e.socialNetworks && /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "corner-divider", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "divider-line" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "divider-label", children: t.formatMessage({ id: "auth.form.or" }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "divider-line" })
      ] }),
      ke()
    ] })
  ] });
}, Dialog$1 = "", Dialog = (e) => {
  const t = () => {
    e.setShow(!1);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: e.show === !0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: "dialog",
      "data-testid": "dialog",
      onClick: () => t(),
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `dialog__content ${e.noPadding ? "no-padding" : ""}`, onClick: (n) => n.stopPropagation(), children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "dialog__content--background", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "dialog__content--background--zone" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "dialog__content--background--overlay" })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "div",
          {
            className: "dialog__content--close",
            onClick: () => {
              e.setShow(!1);
            },
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(TimesIcon, {})
          }
        ),
        e.headerComponent && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "dialog__content--header", children: e.headerComponent }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "dialog__content--bod", children: e.bodyComponent }),
        e.footerComponent && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "dialog__content--footer", children: e.footerComponent })
      ] })
    }
  ) });
}, DisplaySelector$1 = "";
var DisplayList = /* @__PURE__ */ ((e) => (e[e.List = 0] = "List", e[e.Waffle = 1] = "Waffle", e))(DisplayList || {});
const DisplaySelector = (e) => {
  const [t, n] = useState(
    e.defaultValue || 0
  ), o = (s) => {
    const l = parseInt(s.currentTarget.value);
    n(l), e.actionHook && e.actionHook(l), e.onChange && e.onChange(l);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "display-selector", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ButtonIcon,
      {
        value: 0 .toString(),
        size: ButtonSize.MEDIUM,
        icon: "https://assets.next.wolfiesports.com/media/icons/burgerMenu.svg",
        name: "list",
        active: t === 0,
        onClick: (s) => o(s),
        styleClass: t === 0 ? "selector-active" : ""
      },
      0
      /* List */
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ButtonIcon,
      {
        value: 1 .toString(),
        size: ButtonSize.MEDIUM,
        icon: "https://assets.next.wolfiesports.com/media/icons/waffleMenu.svg",
        name: "waffle",
        active: t === 1,
        onClick: (s) => o(s),
        styleClass: t === 1 ? "selector-active" : ""
      },
      1
      /* Waffle */
    )
  ] });
}, GameList$1 = "", GameList = (e) => {
  const [t, n] = useState(e.selected || e.defaultSelected || [0]);
  useEffect(() => {
    e.selectedChanged && e.selectedChanged(t);
  }, [t]), useEffect(() => {
    e.selected && n(e.selected);
  }, [e.selected]);
  const o = (s) => {
    const l = parseInt(s.currentTarget.value);
    if (e.multiple) {
      const c = t.findIndex((p) => p === l);
      c > -1 ? (t.splice(c, 1), n([...t])) : n([...t, l]);
    } else
      n([l]);
    e.onChange && e.onChange(e.games[l]);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "gamelist", children: e.games.map((s, l) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    ButtonIcon,
    {
      value: l.toString(),
      size: ButtonSize.BIG,
      icon: s.icon,
      name: s.id,
      active: t.includes(l),
      onClick: o,
      fancy: e.fancy,
      tooltipTitle: s.title,
      disabled: e.disabled
    },
    l
  )) });
}, UserCardRounded$1 = "";
var PremiumStatus = /* @__PURE__ */ ((e) => (e.PREMIUM = "PREMIUM", e.NONE = "NONE", e))(PremiumStatus || {}), ContestType = /* @__PURE__ */ ((e) => (e[e.PICTURE = 0] = "PICTURE", e[e.VIDEO = 1] = "VIDEO", e[e.TICKET = 2] = "TICKET", e))(ContestType || {});
class NoGame {
  constructor(t, n, o, s, l) {
    this.active = t, this.icon = n, this.id = o, this.route = s, this.title = l;
  }
}
var TournamentFormat = /* @__PURE__ */ ((e) => (e[e.BRACKET = 0] = "BRACKET", e[e.ROUND_ROBIN = 1] = "ROUND_ROBIN", e[e.DOUBLE_ELIM = 2] = "DOUBLE_ELIM", e[e.ROBIN_BRACKET = 3] = "ROBIN_BRACKET", e))(TournamentFormat || {}), MenuVersion = /* @__PURE__ */ ((e) => (e.CLASSIC = "classic", e.CENTERED_LOGO = "centered_logo", e))(MenuVersion || {});
class ToastModel {
  constructor(t, n, o, s, l, c, p) {
    this.title = t, this.content = n, this.type = o, this.hide = s, this.style = l, this.permanent = c, this.titleIcon = p, this.id = (/* @__PURE__ */ new Date()).valueOf();
  }
}
var NCToastType = /* @__PURE__ */ ((e) => (e.SUCCESS = "success", e.WARNING = "warning", e.ERROR = "error", e.CUSTOM = "custom", e))(NCToastType || {}), ToastPosition = /* @__PURE__ */ ((e) => (e.TOP_RIGHT = "top-right", e.TOP_LEFT = "top-left", e.BOTTOM_LEFT = "bottom-left", e.BOTTOM_RIGHT = "bottom-right", e))(ToastPosition || {}), RewardKind = /* @__PURE__ */ ((e) => (e.CASH = "cash", e.GIFT = "gift", e.COIN = "coin", e))(RewardKind || {}), RewardDistribution = /* @__PURE__ */ ((e) => (e[e.Auto = 0] = "Auto", e[e.Manual = 2] = "Manual", e))(RewardDistribution || {}), SocialEnum = /* @__PURE__ */ ((e) => (e.Facebook = "facebook", e.Twitter = "twitter", e.Twitch = "twitch", e.YouTube = "youTube", e.Discord = "discord", e.Instagram = "instagram", e.Linkedin = "linkedin", e))(SocialEnum || {}), TeamPermission = /* @__PURE__ */ ((e) => (e[e.MEMBER = 0] = "MEMBER", e[e.MANAGER = 1] = "MANAGER", e[e.OWNER = 2] = "OWNER", e))(TeamPermission || {}), RegistrationError = /* @__PURE__ */ ((e) => (e[e.Crash = 0] = "Crash", e[e.NotInTeam = 1] = "NotInTeam", e[e.Unavailable = 2] = "Unavailable", e[e.InvalidUser = 3] = "InvalidUser", e[e.InvalidEmail = 4] = "InvalidEmail", e[e.Banned = 5] = "Banned", e[e.NoGameAccount = 6] = "NoGameAccount", e[e.NotPremium = 7] = "NotPremium", e[e.NoTicketAvailable = 8] = "NoTicketAvailable", e[e.NotInRegistrationHours = 9] = "NotInRegistrationHours", e))(RegistrationError || {});
class Tournament {
  constructor(t, n, o, s, l, c, p, m, C, P, w, R, L, M, $, W, H, V, N, B, K, ue, de, ve, Te, Pe, Ce, Re, ke, Ae, we, he, be) {
    this.auto = t, this.cname = n, this.color = o, this.date = s, this.defaultSetting = l, this.displayFormat = c, this.distribution = p, this.entrance = m, this.featured = C, this.gameName = P, this.gameSlug = w, this.hideBracket = R, this.id = L, this.max = M, this.min = $, this.name = W, this.partner = H, this.pausedUntil = V, this.platforms = N, this.qualifier = B, this.register = K, this.rewards = ue, this.route = de, this.seeding = ve, this.socials = Te, this.state = Pe, this.subpartners = Ce, this.templateId = Re, this.wl = ke, this.settings = Ae, this.matchSettings = we, this.sum = he, this.reason = be, this.isTeam = () => {
      var le;
      return this.settings && ((le = this.settings) == null ? void 0 : le.nbMin) > 1;
    }, this.getRules = () => this.settings ? this.settings.rules : [];
  }
}
var FeatureLevel = /* @__PURE__ */ ((e) => (e[e.None = 0] = "None", e[e.Promoted = 1] = "Promoted", e[e.MainEvent = 2] = "MainEvent", e))(FeatureLevel || {}), SeedingType = /* @__PURE__ */ ((e) => (e[e.CLASSIC = 0] = "CLASSIC", e[e.LIST = 1] = "LIST", e[e.GROUP = 2] = "GROUP", e[e.RANDOM = 3] = "RANDOM", e))(SeedingType || {}), HostType = /* @__PURE__ */ ((e) => (e[e.SAME = 0] = "SAME", e[e.ALTERNATE = 1] = "ALTERNATE", e))(HostType || {}), ScoreType = /* @__PURE__ */ ((e) => (e[e.Score = 0] = "Score", e[e.WinLose = 1] = "WinLose", e[e.Ranking = 2] = "Ranking", e[e.DrawScore = 3] = "DrawScore", e[e.WinDrawLose = 4] = "WinDrawLose", e))(ScoreType || {}), TournamentFee = /* @__PURE__ */ ((e) => (e[e.FREE = 0] = "FREE", e[e.PREMIUM = 1] = "PREMIUM", e[e.PAYMENT = 2] = "PAYMENT", e))(TournamentFee || {}), TournamentState = /* @__PURE__ */ ((e) => (e[e.Scheduled = 0] = "Scheduled", e[e.Generating = 1] = "Generating", e[e.Started = 2] = "Started", e[e.Paused = 3] = "Paused", e[e.Ended = 4] = "Ended", e[e.Cancelled = 5] = "Cancelled", e[e.Error = 6] = "Error", e))(TournamentState || {}), Mode = /* @__PURE__ */ ((e) => (e[e.ModeShuffled = 0] = "ModeShuffled", e[e.ModeAllowed = 1] = "ModeAllowed", e[e.ModeBanned = 2] = "ModeBanned", e[e.ModeUserPick = 3] = "ModeUserPick", e[e.ModeUserBan = 4] = "ModeUserBan", e))(Mode || {});
const convertTournamentToTournamentCard = (e) => {
  var t;
  return {
    name: e.name,
    date: e.date,
    platforms: e.platforms,
    format: ((t = e.settings) == null ? void 0 : t.nbMin) ?? 1,
    partner: e.partner,
    entrance: e.entrance
  };
}, convertTournamentPublicInfoToTournamentCard = (e) => ({
  name: e.name,
  date: e.date,
  platforms: e.platforms,
  format: e.format,
  partner: e.partnerRegion.split("/")[1],
  entrance: e.entrance
}), convertSimilarTournamentToTournamentCard = (e) => ({
  name: e.name,
  date: e.date,
  platforms: e.platforms,
  format: e.format,
  partner: e.partner || e.partnerRegion.split("/")[1] || "",
  entrance: e.entrance
});
var DisplayFormat = /* @__PURE__ */ ((e) => (e[e.SimpleElim = 0] = "SimpleElim", e[e.RoundRobin = 1] = "RoundRobin", e[e.DoubleElim = 2] = "DoubleElim", e))(DisplayFormat || {});
const ProfilePicture$1 = "", ProfilePicture = (e) => {
  let t;
  if (e.size) {
    const s = e.size + "px";
    t = {
      minHeight: s,
      minWidth: s,
      maxHeight: s,
      maxWidth: s
    };
  }
  let n;
  typeof e.isPremium == "boolean" ? n = e.isPremium : n = e.isPremium === PremiumStatus.PREMIUM;
  const o = () => e.avatarId ? `https://assets.next.wolfiesports.com/media/assets/user/profile/${e.avatarId}.png` : `https://assets.next.wolfiesports.com/media/assets/user/profile/0.png?cache=${Date.now()}`;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: `user-avatar position-relative default 
      ${n ? "premium " : ""}
      ${e.isOwner ? "owner" : ""}`,
      style: t,
      onMouseEnter: () => {
        e.onMouseOver && e.onMouseOver(!0);
      },
      onMouseLeave: () => {
        e.onMouseOver && e.onMouseOver(!1);
      },
      children: [
        e.children,
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "img",
          {
            className: `position-absolute sm ${(e.size || 40) < 30 ? "small-border" : "big-border"}`,
            src: o(),
            alt: ""
          }
        )
      ]
    }
  );
}, MemoizedProfilePicture = React__default.memo(ProfilePicture);
var UserCardRoundedSize = /* @__PURE__ */ ((e) => (e.xs = "xs", e.small = "small", e))(UserCardRoundedSize || {});
const UserCardRounded = (e) => {
  var l;
  const t = e.size === "xs" ? 24 : 40, n = useIntl(), o = () => {
    navigator.clipboard.writeText(e.player.account), e.copyGameAccountCallback && e.copyGameAccountCallback();
  };
  let s;
  return e.player.premium ? typeof e.player.premium == "boolean" ? s = e.player.premium : s = ((l = e.player.premium) == null ? void 0 : l.status) === PremiumStatus.PREMIUM : s = !1, /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: `user-card-rounded-component d-flex align-items-center pr-3 ${e.selectable || e.onClick ? "cursor-pointer selectable" : ""} ${e.selected ? "selected" : ""} size-${e.size}`,
      onClick: () => {
        e.onClick && e.onClick(!0);
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          MemoizedProfilePicture,
          {
            size: t,
            avatarId: e.player.avatar,
            isPremium: e.player.premium
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "d-flex flex-column ml-2 details", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "name-wrapper d-flex", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "name text-elipsis", children: e.player.name }),
            s && /* @__PURE__ */ jsxRuntimeExports.jsx(
              Icon,
              {
                styleName: "ml-2",
                icon: IconType.Premium,
                width: 16,
                height: 16
              }
            )
          ] }),
          // eslint-disable-next-line eqeqeq
          e.size === "small" && e.player.elo != null && !e.gameAccount && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "elo", children: [
            "ELO:",
            e.player.elo
          ] }),
          e.gameAccount && /* @__PURE__ */ jsxRuntimeExports.jsx(
            Tooltip$1,
            {
              title: n.formatMessage({ id: "player.copy.game.account" }),
              arrow: !0,
              children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "game-account", onClick: () => o(), children: e.player.account })
            }
          )
        ] }),
        e.selectable && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "ml-auto", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Icon,
          {
            styleName: "ml-2",
            icon: IconType.Close,
            width: 13,
            height: 13
          }
        ) })
      ]
    }
  );
}, HoverUserTeamCard$1 = "", HoverUserTeamCard = (e) => {
  var w, R;
  const t = Object.entries(e.team.players), n = useIntl(), [o, s] = useState(), [l, c] = useState(), p = Object.values(e.team.players)[0], m = e.isSolo && e.userCallback || !e.isSolo && e.teamCallback, C = () => {
    navigator.clipboard.writeText(p.account), e.copyGameAccountCallback && e.copyGameAccountCallback();
  };
  useEffect(() => {
    e.team.players && Object.keys(e.team.players).forEach((L) => {
      if (e.team.players[L].captain) {
        s(e.team.players[L]), c(L);
        return;
      }
    });
  }, [e.team]);
  const P = () => {
    e.isSolo && e.userCallback ? e.userCallback(Object.keys(e.team.players)[0]) : !e.isSolo && e.teamCallback && e.teamCallback(e.team.slug);
  };
  if (e.team) {
    const L = e.noGameAccount && e.hideElo ? UserCardRoundedSize.xs : UserCardRoundedSize.small;
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "hover-user-team-card-component hovered-card text-center", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        className: "hovered-card text-center",
        style: {
          backgroundImage: "url(https://assets.next.wolfiesports.com" + (e.isSolo ? "/media/assets/user/banner/" + Object.values(e.team.players)[0].banner + ".png" : `/teams/${e.team.slug}/medias/BannerImage`) + "), url(https://assets.next.wolfiesports.com" + (e.isSolo ? "/media/assets/user/banner/0.png" : "/media/default/default-team-banner.svg") + ")",
          backgroundSize: "cover",
          backgroundPosition: "top"
        },
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "img",
            {
              className: `avatar mx-auto mb-2 mt-4 ${e.isSolo ? "solo" : "team"} ${m ? "cursor-pointer" : ""}`,
              src: e.isSolo ? "https://assets.next.wolfiesports.com/media/assets/user/profile/" + Object.values(e.team.players)[0].avatar + ".png" : `https://assets.next.wolfiesports.com/teams/${e.team.slug}/medias/ProfileImage`,
              onError: (M) => M.currentTarget.src = e.isSolo ? "https://assets.next.wolfiesports.com/media/assets/user/profile/0.png" : "https://assets.next.wolfiesports.com/media/default/default-team-avatar.png",
              alt: "",
              onClick: P
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "div",
            {
              className: `user-team-card-hover-text d-flex justify-content-center ${m ? "cursor-pointer" : ""}`,
              onClick: P,
              children: [
                e.isSolo ? null : /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "color-grey5 font-weight-bold pr-2 text-uppercase", children: [
                  "[",
                  (w = e.team) == null ? void 0 : w.tag,
                  "]"
                ] }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "color-white", children: (R = e.team) == null ? void 0 : R.name })
              ]
            }
          ),
          e.isSolo ? e.noGameAccount ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "pb-4" }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "color-white justify-content-center user-team-card-hover-text pb-4 mt-4", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "text-uppercase font-weight-bold", children: n.formatMessage({ id: "player.game.account" }) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              Tooltip$1,
              {
                title: n.formatMessage({
                  id: "player.copy.game.account"
                }),
                arrow: !0,
                children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "div",
                  {
                    className: "cursor-pointer",
                    onClick: () => C(),
                    children: p.account
                  }
                )
              }
            )
          ] }) }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "color-white user-team-card-hover-text mt-2 mx-2", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "captain d-flex", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "title ml-2 mr-4 d-flex align-self-center", children: n.formatMessage({ id: "team.captain" }) }),
                o && l && /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "div",
                  {
                    className: "d-flex ml-4 justify-content-center cursor-pointer",
                    onClick: () => {
                      e.userCallback && e.userCallback(l);
                    },
                    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                      UserCardRounded,
                      {
                        player: o,
                        playerId: l,
                        size: L,
                        gameAccount: !e.noGameAccount,
                        copyGameAccountCallback: e.copyGameAccountCallback
                      }
                    )
                  }
                )
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "d-flex ml-2 mt-2", children: n.formatMessage({ id: "team.titular.players" }) })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "user-grid mx-2 mt-2 pb-3", children: t.map((M, $) => /* @__PURE__ */ jsxRuntimeExports.jsx(
              "div",
              {
                className: "d-flex user-container mx-2 my-1 cursor-pointer",
                onClick: () => {
                  e.userCallback && e.userCallback(M[0]);
                },
                children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                  UserCardRounded,
                  {
                    player: M[1],
                    playerId: M[0],
                    size: L,
                    gameAccount: !e.noGameAccount,
                    copyGameAccountCallback: e.copyGameAccountCallback
                  }
                )
              },
              $
            )) })
          ] })
        ]
      }
    ) });
  } else
    return null;
}, NCAccordion$1 = "", NCAccordion = (e) => {
  const t = (o) => ({
    __html: o
  }), n = (o, s, l) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Accordion$1, { classes: { root: "nc-accordion-root" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AccordionSummary$1,
      {
        expandIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {}),
        "aria-controls": "panel1a-content",
        id: "panel1a-header",
        classes: { content: "nc-accordion-summary" },
        style: { color: e.color },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "title", style: { color: e.color }, children: s })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(AccordionDetails$1, { classes: { root: "nc-accordion-details" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: "content",
        dangerouslySetInnerHTML: t(l)
      }
    ) })
  ] }, o);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "nc-accordion", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider, { theme: ThemePlatform, children: e.data.map((o, s) => n(s, o.title, o.content)) }) }) });
}, NCCardList$1 = "", NCCardList = (e) => {
  const t = useRef(null), n = useRef(null), o = e.cardGap || 16, [s, l] = useState(!1), [c, p] = useState(!1), [m, C] = useState(), [P, w] = useState(!1), [R, L] = useState(!1), [M, $] = useState(), { customArrowsStyle: W } = e, H = () => window.matchMedia("(any-hover: none)").matches, [V, N] = useState(), B = H() ? 0 : 500, K = () => {
    const Pe = W ? { ...W } : {
      icon: IconType.GoToPreviousPage,
      height: 24,
      width: 24
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { ...Pe });
  };
  useEffect(() => {
    P ? de() : ue(M);
  }, [P]), useEffect(() => {
    C(K()), ve();
  }, [e.cards]), useEffect(() => (window.addEventListener("resize", ve), () => {
    window.removeEventListener("resize", ve), ue(V), ue(M);
  }), []);
  const ue = (Pe) => {
    Pe && clearTimeout(Pe);
  }, de = (Pe) => {
    var Re;
    Pe || Te(R, e.fullScroll ? (Re = t.current) == null ? void 0 : Re.clientWidth : void 0);
    const Ce = setTimeout(() => {
      var ke;
      Te(R, e.fullScroll ? (ke = t.current) == null ? void 0 : ke.clientWidth : void 0), de(!0);
    }, 100);
    $(Ce);
  }, ve = () => {
    var ke, Ae, we;
    e.scrollHook && t.current && e.scrollHook(t.current.scrollLeft);
    const Pe = ((ke = t.current) == null ? void 0 : ke.scrollLeft) || 0, Ce = ((Ae = t.current) == null ? void 0 : Ae.scrollWidth) || 0, Re = ((we = t.current) == null ? void 0 : we.getBoundingClientRect().width) || 0;
    l(Pe > 0), p(Ce > Re && Math.ceil(Pe + Re) < Ce);
  }, Te = (Pe, Ce) => {
    var ke;
    const Re = ((ke = n.current) == null ? void 0 : ke.clientWidth) || 0;
    if (t.current && Re) {
      const Ae = Re + o / 2;
      t.current.scrollBy({ left: Pe ? -(Ce || Ae) : Ce || Ae, behavior: "smooth" });
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "nc-card-list position-relative", children: [
    s && /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: "left position-absolute d-flex align-items-center cursor-pointer",
        onMouseDown: () => {
          L(!0), w(!0);
        },
        onMouseUp: () => w(!1),
        children: m
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        ref: t,
        className: `scrollable-container d-flex ${s ? "mask-left" : ""} ${c ? "mask-right" : ""}`,
        style: { gap: `${o}px` },
        onScroll: () => ve(),
        children: e.cards.map((Pe, Ce) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          "div",
          {
            ref: Ce === 0 ? n : null,
            className: "card-container",
            onMouseEnter: (Re) => {
              if (e.hoveredCard && t.current) {
                const ke = Re.currentTarget, Ae = setTimeout(() => {
                  e.hoveredCard && t.current && ke && e.hoveredCard(Ce, ke.getBoundingClientRect(), t.current.getBoundingClientRect());
                }, B);
                N(Ae);
              }
            },
            onMouseLeave: () => {
              V && clearTimeout(V);
            },
            onClick: () => {
              e.cardClicked && e.cardClicked(Ce);
            },
            children: Pe
          },
          `card-container-${Ce}`
        ))
      }
    ),
    c && /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: "right position-absolute d-flex align-items-center cursor-pointer",
        onMouseDown: () => {
          L(!1), w(!0);
        },
        onMouseUp: () => w(!1),
        children: m
      }
    )
  ] });
}, NCHoverCard$1 = "", NCHoverCard = (e) => {
  const [t, n] = useState(), [o, s] = useState(e.cardRect.left), [l, c] = useState(), p = e.maxCardWidth || 340, m = window.scrollY, [C, P] = useState(0), w = useRef(null);
  useEffect(() => {
    n(!0);
    const M = e.cardRect.left - p / 4;
    if (M < e.containerRect.left)
      s(e.containerRect.left);
    else {
      const $ = e.containerRect.left + e.containerRect.width - p;
      M > $ ? s($) : s(M);
    }
  }, [e]), useEffect(() => {
    window.onscroll = () => {
      P(m - window.scrollY);
    }, window.onmouseup = (M) => {
      if (w.current) {
        const $ = w.current.getBoundingClientRect();
        (M.pageX < $.left || M.pageX > $.left + $.width || M.pageY < $.top || M.pageX > $.top + $.height) && R();
      }
    };
  }, []), useEffect(() => () => {
    L(l);
  }, [l]);
  const R = () => {
    n(!1);
    const M = setTimeout(() => {
      e.closedHook(!0);
    }, 200);
    c(M);
  }, L = (M) => {
    M && clearTimeout(M);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "nc-hover-card-container", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: `nc-hover-card position-fixed ${t ? "opening" : "closing"}`,
        style: {
          left: t ? o : e.cardRect.left,
          top: t ? e.cardRect.top + e.containerRect.height / 2 : e.cardRect.top,
          marginTop: C
        },
        children: e.card
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        ref: w,
        className: "trigger-box position-fixed cursor-pointer",
        style: {
          left: e.cardRect.left,
          top: e.cardRect.top,
          width: e.cardRect.width,
          height: e.cardRect.height
        },
        onMouseLeave: () => {
          t && R();
        },
        onClick: () => {
          e.onClick && e.onClick();
        }
      }
    )
  ] });
}, NCAnimatedCardList = (e) => {
  const [t, n] = useState(), o = (s, l, c) => {
    const p = e.cards[s];
    if (!p || e.loadingCard)
      return;
    const m = /* @__PURE__ */ jsxRuntimeExports.jsx(
      NCHoverCard,
      {
        card: p,
        cardRect: l,
        containerRect: c,
        maxCardWidth: e.maxCardWidth,
        closedHook: () => n(void 0),
        onClick: () => {
          e.cardClicked && e.cardClicked(s);
        }
      }
    );
    n(m);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      NCCardList,
      {
        cards: e.loadingCard ? Array(e.cards.length || 4).fill(e.loadingCard) : e.cards,
        hoveredCard: o,
        scrollHook: e.scrollHook,
        cardClicked: e.cardClicked,
        fullScroll: e.fullScroll
      }
    ),
    t
  ] });
}, NCAssetNgDialog$1 = "";
function bind(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString } = Object.prototype, { getPrototypeOf } = Object, kindOf = ((e) => (t) => {
  const n = toString.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), kindOfTest = (e) => (e = e.toLowerCase(), (t) => kindOf(t) === e), typeOfTest = (e) => (t) => typeof t === e, { isArray } = Array, isUndefined = typeOfTest("undefined");
function isBuffer(e) {
  return e !== null && !isUndefined(e) && e.constructor !== null && !isUndefined(e.constructor) && isFunction$1(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const isArrayBuffer = kindOfTest("ArrayBuffer");
function isArrayBufferView(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && isArrayBuffer(e.buffer), t;
}
const isString = typeOfTest("string"), isFunction$1 = typeOfTest("function"), isNumber = typeOfTest("number"), isObject = (e) => e !== null && typeof e == "object", isBoolean = (e) => e === !0 || e === !1, isPlainObject = (e) => {
  if (kindOf(e) !== "object")
    return !1;
  const t = getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, isDate = kindOfTest("Date"), isFile = kindOfTest("File"), isBlob = kindOfTest("Blob"), isFileList = kindOfTest("FileList"), isStream = (e) => isObject(e) && isFunction$1(e.pipe), isFormData = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || isFunction$1(e.append) && ((t = kindOf(e)) === "formdata" || // detect form-data instance
  t === "object" && isFunction$1(e.toString) && e.toString() === "[object FormData]"));
}, isURLSearchParams = kindOfTest("URLSearchParams"), trim = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function forEach(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let o, s;
  if (typeof e != "object" && (e = [e]), isArray(e))
    for (o = 0, s = e.length; o < s; o++)
      t.call(null, e[o], o, e);
  else {
    const l = n ? Object.getOwnPropertyNames(e) : Object.keys(e), c = l.length;
    let p;
    for (o = 0; o < c; o++)
      p = l[o], t.call(null, e[p], p, e);
  }
}
function findKey(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let o = n.length, s;
  for (; o-- > 0; )
    if (s = n[o], t === s.toLowerCase())
      return s;
  return null;
}
const _global = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), isContextDefined = (e) => !isUndefined(e) && e !== _global;
function merge() {
  const { caseless: e } = isContextDefined(this) && this || {}, t = {}, n = (o, s) => {
    const l = e && findKey(t, s) || s;
    isPlainObject(t[l]) && isPlainObject(o) ? t[l] = merge(t[l], o) : isPlainObject(o) ? t[l] = merge({}, o) : isArray(o) ? t[l] = o.slice() : t[l] = o;
  };
  for (let o = 0, s = arguments.length; o < s; o++)
    arguments[o] && forEach(arguments[o], n);
  return t;
}
const extend = (e, t, n, { allOwnKeys: o } = {}) => (forEach(t, (s, l) => {
  n && isFunction$1(s) ? e[l] = bind(s, n) : e[l] = s;
}, { allOwnKeys: o }), e), stripBOM = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), inherits = (e, t, n, o) => {
  e.prototype = Object.create(t.prototype, o), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, toFlatObject = (e, t, n, o) => {
  let s, l, c;
  const p = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (s = Object.getOwnPropertyNames(e), l = s.length; l-- > 0; )
      c = s[l], (!o || o(c, e, t)) && !p[c] && (t[c] = e[c], p[c] = !0);
    e = n !== !1 && getPrototypeOf(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, endsWith = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const o = e.indexOf(t, n);
  return o !== -1 && o === n;
}, toArray = (e) => {
  if (!e)
    return null;
  if (isArray(e))
    return e;
  let t = e.length;
  if (!isNumber(t))
    return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, isTypedArray = ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && getPrototypeOf(Uint8Array)), forEachEntry = (e, t) => {
  const o = (e && e[Symbol.iterator]).call(e);
  let s;
  for (; (s = o.next()) && !s.done; ) {
    const l = s.value;
    t.call(e, l[0], l[1]);
  }
}, matchAll = (e, t) => {
  let n;
  const o = [];
  for (; (n = e.exec(t)) !== null; )
    o.push(n);
  return o;
}, isHTMLForm = kindOfTest("HTMLFormElement"), toCamelCase = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, o, s) {
    return o.toUpperCase() + s;
  }
), hasOwnProperty = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), isRegExp = kindOfTest("RegExp"), reduceDescriptors = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), o = {};
  forEach(n, (s, l) => {
    let c;
    (c = t(s, l, e)) !== !1 && (o[l] = c || s);
  }), Object.defineProperties(e, o);
}, freezeMethods = (e) => {
  reduceDescriptors(e, (t, n) => {
    if (isFunction$1(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const o = e[n];
    if (isFunction$1(o)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, toObjectSet = (e, t) => {
  const n = {}, o = (s) => {
    s.forEach((l) => {
      n[l] = !0;
    });
  };
  return isArray(e) ? o(e) : o(String(e).split(t)), n;
}, noop = () => {
}, toFiniteNumber = (e, t) => (e = +e, Number.isFinite(e) ? e : t), ALPHA = "abcdefghijklmnopqrstuvwxyz", DIGIT = "0123456789", ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
}, generateString = (e = 16, t = ALPHABET.ALPHA_DIGIT) => {
  let n = "";
  const { length: o } = t;
  for (; e--; )
    n += t[Math.random() * o | 0];
  return n;
};
function isSpecCompliantForm(e) {
  return !!(e && isFunction$1(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const toJSONObject = (e) => {
  const t = new Array(10), n = (o, s) => {
    if (isObject(o)) {
      if (t.indexOf(o) >= 0)
        return;
      if (!("toJSON" in o)) {
        t[s] = o;
        const l = isArray(o) ? [] : {};
        return forEach(o, (c, p) => {
          const m = n(c, s + 1);
          !isUndefined(m) && (l[p] = m);
        }), t[s] = void 0, l;
      }
    }
    return o;
  };
  return n(e, 0);
}, isAsyncFn = kindOfTest("AsyncFunction"), isThenable = (e) => e && (isObject(e) || isFunction$1(e)) && isFunction$1(e.then) && isFunction$1(e.catch), utils$1 = {
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction: isFunction$1,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty,
  hasOwnProp: hasOwnProperty,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable
};
function AxiosError(e, t, n, o, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), o && (this.request = o), s && (this.response = s);
}
utils$1.inherits(AxiosError, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils$1.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const prototype$1 = AxiosError.prototype, descriptors = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  descriptors[e] = { value: e };
});
Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype$1, "isAxiosError", { value: !0 });
AxiosError.from = (e, t, n, o, s, l) => {
  const c = Object.create(prototype$1);
  return utils$1.toFlatObject(e, c, function(m) {
    return m !== Error.prototype;
  }, (p) => p !== "isAxiosError"), AxiosError.call(c, e.message, t, n, o, s), c.cause = e, c.name = e.name, l && Object.assign(c, l), c;
};
const httpAdapter = null;
function isVisitable(e) {
  return utils$1.isPlainObject(e) || utils$1.isArray(e);
}
function removeBrackets(e) {
  return utils$1.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function renderKey(e, t, n) {
  return e ? e.concat(t).map(function(s, l) {
    return s = removeBrackets(s), !n && l ? "[" + s + "]" : s;
  }).join(n ? "." : "") : t;
}
function isFlatArray(e) {
  return utils$1.isArray(e) && !e.some(isVisitable);
}
const predicates = utils$1.toFlatObject(utils$1, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function toFormData(e, t, n) {
  if (!utils$1.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = utils$1.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function($, W) {
    return !utils$1.isUndefined(W[$]);
  });
  const o = n.metaTokens, s = n.visitor || P, l = n.dots, c = n.indexes, m = (n.Blob || typeof Blob < "u" && Blob) && utils$1.isSpecCompliantForm(t);
  if (!utils$1.isFunction(s))
    throw new TypeError("visitor must be a function");
  function C(M) {
    if (M === null)
      return "";
    if (utils$1.isDate(M))
      return M.toISOString();
    if (!m && utils$1.isBlob(M))
      throw new AxiosError("Blob is not supported. Use a Buffer instead.");
    return utils$1.isArrayBuffer(M) || utils$1.isTypedArray(M) ? m && typeof Blob == "function" ? new Blob([M]) : Buffer.from(M) : M;
  }
  function P(M, $, W) {
    let H = M;
    if (M && !W && typeof M == "object") {
      if (utils$1.endsWith($, "{}"))
        $ = o ? $ : $.slice(0, -2), M = JSON.stringify(M);
      else if (utils$1.isArray(M) && isFlatArray(M) || (utils$1.isFileList(M) || utils$1.endsWith($, "[]")) && (H = utils$1.toArray(M)))
        return $ = removeBrackets($), H.forEach(function(N, B) {
          !(utils$1.isUndefined(N) || N === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            c === !0 ? renderKey([$], B, l) : c === null ? $ : $ + "[]",
            C(N)
          );
        }), !1;
    }
    return isVisitable(M) ? !0 : (t.append(renderKey(W, $, l), C(M)), !1);
  }
  const w = [], R = Object.assign(predicates, {
    defaultVisitor: P,
    convertValue: C,
    isVisitable
  });
  function L(M, $) {
    if (!utils$1.isUndefined(M)) {
      if (w.indexOf(M) !== -1)
        throw Error("Circular reference detected in " + $.join("."));
      w.push(M), utils$1.forEach(M, function(H, V) {
        (!(utils$1.isUndefined(H) || H === null) && s.call(
          t,
          H,
          utils$1.isString(V) ? V.trim() : V,
          $,
          R
        )) === !0 && L(H, $ ? $.concat(V) : [V]);
      }), w.pop();
    }
  }
  if (!utils$1.isObject(e))
    throw new TypeError("data must be an object");
  return L(e), t;
}
function encode$1(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(o) {
    return t[o];
  });
}
function AxiosURLSearchParams(e, t) {
  this._pairs = [], e && toFormData(e, this, t);
}
const prototype = AxiosURLSearchParams.prototype;
prototype.append = function(t, n) {
  this._pairs.push([t, n]);
};
prototype.toString = function(t) {
  const n = t ? function(o) {
    return t.call(this, o, encode$1);
  } : encode$1;
  return this._pairs.map(function(s) {
    return n(s[0]) + "=" + n(s[1]);
  }, "").join("&");
};
function encode(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function buildURL(e, t, n) {
  if (!t)
    return e;
  const o = n && n.encode || encode, s = n && n.serialize;
  let l;
  if (s ? l = s(t, n) : l = utils$1.isURLSearchParams(t) ? t.toString() : new AxiosURLSearchParams(t, n).toString(o), l) {
    const c = e.indexOf("#");
    c !== -1 && (e = e.slice(0, c)), e += (e.indexOf("?") === -1 ? "?" : "&") + l;
  }
  return e;
}
class InterceptorManager {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, o) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: o ? o.synchronous : !1,
      runWhen: o ? o.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    utils$1.forEach(this.handlers, function(o) {
      o !== null && t(o);
    });
  }
}
const InterceptorManager$1 = InterceptorManager, transitionalDefaults = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, URLSearchParams$1 = typeof URLSearchParams < "u" ? URLSearchParams : AxiosURLSearchParams, FormData$1 = typeof FormData < "u" ? FormData : null, Blob$1 = typeof Blob < "u" ? Blob : null, platform$1 = {
  isBrowser: !0,
  classes: {
    URLSearchParams: URLSearchParams$1,
    FormData: FormData$1,
    Blob: Blob$1
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, hasBrowserEnv = typeof window < "u" && typeof document < "u", hasStandardBrowserEnv = ((e) => hasBrowserEnv && ["ReactNative", "NativeScript", "NS"].indexOf(e) < 0)(typeof navigator < "u" && navigator.product), hasStandardBrowserWebWorkerEnv = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), utils = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv,
  hasStandardBrowserEnv,
  hasStandardBrowserWebWorkerEnv
}, Symbol.toStringTag, { value: "Module" })), platform = {
  ...utils,
  ...platform$1
};
function toURLEncodedForm(e, t) {
  return toFormData(e, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(n, o, s, l) {
      return platform.isNode && utils$1.isBuffer(n) ? (this.append(o, n.toString("base64")), !1) : l.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function parsePropPath(e) {
  return utils$1.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function arrayToObject(e) {
  const t = {}, n = Object.keys(e);
  let o;
  const s = n.length;
  let l;
  for (o = 0; o < s; o++)
    l = n[o], t[l] = e[l];
  return t;
}
function formDataToJSON(e) {
  function t(n, o, s, l) {
    let c = n[l++];
    if (c === "__proto__")
      return !0;
    const p = Number.isFinite(+c), m = l >= n.length;
    return c = !c && utils$1.isArray(s) ? s.length : c, m ? (utils$1.hasOwnProp(s, c) ? s[c] = [s[c], o] : s[c] = o, !p) : ((!s[c] || !utils$1.isObject(s[c])) && (s[c] = []), t(n, o, s[c], l) && utils$1.isArray(s[c]) && (s[c] = arrayToObject(s[c])), !p);
  }
  if (utils$1.isFormData(e) && utils$1.isFunction(e.entries)) {
    const n = {};
    return utils$1.forEachEntry(e, (o, s) => {
      t(parsePropPath(o), s, n, 0);
    }), n;
  }
  return null;
}
function stringifySafely(e, t, n) {
  if (utils$1.isString(e))
    try {
      return (t || JSON.parse)(e), utils$1.trim(e);
    } catch (o) {
      if (o.name !== "SyntaxError")
        throw o;
    }
  return (n || JSON.stringify)(e);
}
const defaults = {
  transitional: transitionalDefaults,
  adapter: ["xhr", "http"],
  transformRequest: [function(t, n) {
    const o = n.getContentType() || "", s = o.indexOf("application/json") > -1, l = utils$1.isObject(t);
    if (l && utils$1.isHTMLForm(t) && (t = new FormData(t)), utils$1.isFormData(t))
      return s ? JSON.stringify(formDataToJSON(t)) : t;
    if (utils$1.isArrayBuffer(t) || utils$1.isBuffer(t) || utils$1.isStream(t) || utils$1.isFile(t) || utils$1.isBlob(t))
      return t;
    if (utils$1.isArrayBufferView(t))
      return t.buffer;
    if (utils$1.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let p;
    if (l) {
      if (o.indexOf("application/x-www-form-urlencoded") > -1)
        return toURLEncodedForm(t, this.formSerializer).toString();
      if ((p = utils$1.isFileList(t)) || o.indexOf("multipart/form-data") > -1) {
        const m = this.env && this.env.FormData;
        return toFormData(
          p ? { "files[]": t } : t,
          m && new m(),
          this.formSerializer
        );
      }
    }
    return l || s ? (n.setContentType("application/json", !1), stringifySafely(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || defaults.transitional, o = n && n.forcedJSONParsing, s = this.responseType === "json";
    if (t && utils$1.isString(t) && (o && !this.responseType || s)) {
      const c = !(n && n.silentJSONParsing) && s;
      try {
        return JSON.parse(t);
      } catch (p) {
        if (c)
          throw p.name === "SyntaxError" ? AxiosError.from(p, AxiosError.ERR_BAD_RESPONSE, this, null, this.response) : p;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
utils$1.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  defaults.headers[e] = {};
});
const defaults$1 = defaults, ignoreDuplicateOf = utils$1.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), parseHeaders = (e) => {
  const t = {};
  let n, o, s;
  return e && e.split(`
`).forEach(function(c) {
    s = c.indexOf(":"), n = c.substring(0, s).trim().toLowerCase(), o = c.substring(s + 1).trim(), !(!n || t[n] && ignoreDuplicateOf[n]) && (n === "set-cookie" ? t[n] ? t[n].push(o) : t[n] = [o] : t[n] = t[n] ? t[n] + ", " + o : o);
  }), t;
}, $internals = Symbol("internals");
function normalizeHeader(e) {
  return e && String(e).trim().toLowerCase();
}
function normalizeValue(e) {
  return e === !1 || e == null ? e : utils$1.isArray(e) ? e.map(normalizeValue) : String(e);
}
function parseTokens(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let o;
  for (; o = n.exec(e); )
    t[o[1]] = o[2];
  return t;
}
const isValidHeaderName = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function matchHeaderValue(e, t, n, o, s) {
  if (utils$1.isFunction(o))
    return o.call(this, t, n);
  if (s && (t = n), !!utils$1.isString(t)) {
    if (utils$1.isString(o))
      return t.indexOf(o) !== -1;
    if (utils$1.isRegExp(o))
      return o.test(t);
  }
}
function formatHeader(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, o) => n.toUpperCase() + o);
}
function buildAccessors(e, t) {
  const n = utils$1.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((o) => {
    Object.defineProperty(e, o + n, {
      value: function(s, l, c) {
        return this[o].call(this, t, s, l, c);
      },
      configurable: !0
    });
  });
}
class AxiosHeaders {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, o) {
    const s = this;
    function l(p, m, C) {
      const P = normalizeHeader(m);
      if (!P)
        throw new Error("header name must be a non-empty string");
      const w = utils$1.findKey(s, P);
      (!w || s[w] === void 0 || C === !0 || C === void 0 && s[w] !== !1) && (s[w || m] = normalizeValue(p));
    }
    const c = (p, m) => utils$1.forEach(p, (C, P) => l(C, P, m));
    return utils$1.isPlainObject(t) || t instanceof this.constructor ? c(t, n) : utils$1.isString(t) && (t = t.trim()) && !isValidHeaderName(t) ? c(parseHeaders(t), n) : t != null && l(n, t, o), this;
  }
  get(t, n) {
    if (t = normalizeHeader(t), t) {
      const o = utils$1.findKey(this, t);
      if (o) {
        const s = this[o];
        if (!n)
          return s;
        if (n === !0)
          return parseTokens(s);
        if (utils$1.isFunction(n))
          return n.call(this, s, o);
        if (utils$1.isRegExp(n))
          return n.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = normalizeHeader(t), t) {
      const o = utils$1.findKey(this, t);
      return !!(o && this[o] !== void 0 && (!n || matchHeaderValue(this, this[o], o, n)));
    }
    return !1;
  }
  delete(t, n) {
    const o = this;
    let s = !1;
    function l(c) {
      if (c = normalizeHeader(c), c) {
        const p = utils$1.findKey(o, c);
        p && (!n || matchHeaderValue(o, o[p], p, n)) && (delete o[p], s = !0);
      }
    }
    return utils$1.isArray(t) ? t.forEach(l) : l(t), s;
  }
  clear(t) {
    const n = Object.keys(this);
    let o = n.length, s = !1;
    for (; o--; ) {
      const l = n[o];
      (!t || matchHeaderValue(this, this[l], l, t, !0)) && (delete this[l], s = !0);
    }
    return s;
  }
  normalize(t) {
    const n = this, o = {};
    return utils$1.forEach(this, (s, l) => {
      const c = utils$1.findKey(o, l);
      if (c) {
        n[c] = normalizeValue(s), delete n[l];
        return;
      }
      const p = t ? formatHeader(l) : String(l).trim();
      p !== l && delete n[l], n[p] = normalizeValue(s), o[p] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return utils$1.forEach(this, (o, s) => {
      o != null && o !== !1 && (n[s] = t && utils$1.isArray(o) ? o.join(", ") : o);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const o = new this(t);
    return n.forEach((s) => o.set(s)), o;
  }
  static accessor(t) {
    const o = (this[$internals] = this[$internals] = {
      accessors: {}
    }).accessors, s = this.prototype;
    function l(c) {
      const p = normalizeHeader(c);
      o[p] || (buildAccessors(s, c), o[p] = !0);
    }
    return utils$1.isArray(t) ? t.forEach(l) : l(t), this;
  }
}
AxiosHeaders.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
utils$1.reduceDescriptors(AxiosHeaders.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(o) {
      this[n] = o;
    }
  };
});
utils$1.freezeMethods(AxiosHeaders);
const AxiosHeaders$1 = AxiosHeaders;
function transformData(e, t) {
  const n = this || defaults$1, o = t || n, s = AxiosHeaders$1.from(o.headers);
  let l = o.data;
  return utils$1.forEach(e, function(p) {
    l = p.call(n, l, s.normalize(), t ? t.status : void 0);
  }), s.normalize(), l;
}
function isCancel(e) {
  return !!(e && e.__CANCEL__);
}
function CanceledError(e, t, n) {
  AxiosError.call(this, e ?? "canceled", AxiosError.ERR_CANCELED, t, n), this.name = "CanceledError";
}
utils$1.inherits(CanceledError, AxiosError, {
  __CANCEL__: !0
});
function settle(e, t, n) {
  const o = n.config.validateStatus;
  !n.status || !o || o(n.status) ? e(n) : t(new AxiosError(
    "Request failed with status code " + n.status,
    [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
const cookies = platform.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, o, s, l) {
      const c = [e + "=" + encodeURIComponent(t)];
      utils$1.isNumber(n) && c.push("expires=" + new Date(n).toGMTString()), utils$1.isString(o) && c.push("path=" + o), utils$1.isString(s) && c.push("domain=" + s), l === !0 && c.push("secure"), document.cookie = c.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function isAbsoluteURL(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function combineURLs(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function buildFullPath(e, t) {
  return e && !isAbsoluteURL(t) ? combineURLs(e, t) : t;
}
const isURLSameOrigin = platform.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a");
    let o;
    function s(l) {
      let c = l;
      return t && (n.setAttribute("href", c), c = n.href), n.setAttribute("href", c), {
        href: n.href,
        protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
        host: n.host,
        search: n.search ? n.search.replace(/^\?/, "") : "",
        hash: n.hash ? n.hash.replace(/^#/, "") : "",
        hostname: n.hostname,
        port: n.port,
        pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
      };
    }
    return o = s(window.location.href), function(c) {
      const p = utils$1.isString(c) ? s(c) : c;
      return p.protocol === o.protocol && p.host === o.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  function() {
    return function() {
      return !0;
    };
  }()
);
function parseProtocol(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function speedometer(e, t) {
  e = e || 10;
  const n = new Array(e), o = new Array(e);
  let s = 0, l = 0, c;
  return t = t !== void 0 ? t : 1e3, function(m) {
    const C = Date.now(), P = o[l];
    c || (c = C), n[s] = m, o[s] = C;
    let w = l, R = 0;
    for (; w !== s; )
      R += n[w++], w = w % e;
    if (s = (s + 1) % e, s === l && (l = (l + 1) % e), C - c < t)
      return;
    const L = P && C - P;
    return L ? Math.round(R * 1e3 / L) : void 0;
  };
}
function progressEventReducer(e, t) {
  let n = 0;
  const o = speedometer(50, 250);
  return (s) => {
    const l = s.loaded, c = s.lengthComputable ? s.total : void 0, p = l - n, m = o(p), C = l <= c;
    n = l;
    const P = {
      loaded: l,
      total: c,
      progress: c ? l / c : void 0,
      bytes: p,
      rate: m || void 0,
      estimated: m && c && C ? (c - l) / m : void 0,
      event: s
    };
    P[t ? "download" : "upload"] = !0, e(P);
  };
}
const isXHRAdapterSupported = typeof XMLHttpRequest < "u", xhrAdapter = isXHRAdapterSupported && function(e) {
  return new Promise(function(n, o) {
    let s = e.data;
    const l = AxiosHeaders$1.from(e.headers).normalize();
    let { responseType: c, withXSRFToken: p } = e, m;
    function C() {
      e.cancelToken && e.cancelToken.unsubscribe(m), e.signal && e.signal.removeEventListener("abort", m);
    }
    let P;
    if (utils$1.isFormData(s)) {
      if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv)
        l.setContentType(!1);
      else if ((P = l.getContentType()) !== !1) {
        const [$, ...W] = P ? P.split(";").map((H) => H.trim()).filter(Boolean) : [];
        l.setContentType([$ || "multipart/form-data", ...W].join("; "));
      }
    }
    let w = new XMLHttpRequest();
    if (e.auth) {
      const $ = e.auth.username || "", W = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
      l.set("Authorization", "Basic " + btoa($ + ":" + W));
    }
    const R = buildFullPath(e.baseURL, e.url);
    w.open(e.method.toUpperCase(), buildURL(R, e.params, e.paramsSerializer), !0), w.timeout = e.timeout;
    function L() {
      if (!w)
        return;
      const $ = AxiosHeaders$1.from(
        "getAllResponseHeaders" in w && w.getAllResponseHeaders()
      ), H = {
        data: !c || c === "text" || c === "json" ? w.responseText : w.response,
        status: w.status,
        statusText: w.statusText,
        headers: $,
        config: e,
        request: w
      };
      settle(function(N) {
        n(N), C();
      }, function(N) {
        o(N), C();
      }, H), w = null;
    }
    if ("onloadend" in w ? w.onloadend = L : w.onreadystatechange = function() {
      !w || w.readyState !== 4 || w.status === 0 && !(w.responseURL && w.responseURL.indexOf("file:") === 0) || setTimeout(L);
    }, w.onabort = function() {
      w && (o(new AxiosError("Request aborted", AxiosError.ECONNABORTED, e, w)), w = null);
    }, w.onerror = function() {
      o(new AxiosError("Network Error", AxiosError.ERR_NETWORK, e, w)), w = null;
    }, w.ontimeout = function() {
      let W = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded";
      const H = e.transitional || transitionalDefaults;
      e.timeoutErrorMessage && (W = e.timeoutErrorMessage), o(new AxiosError(
        W,
        H.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        e,
        w
      )), w = null;
    }, platform.hasStandardBrowserEnv && (p && utils$1.isFunction(p) && (p = p(e)), p || p !== !1 && isURLSameOrigin(R))) {
      const $ = e.xsrfHeaderName && e.xsrfCookieName && cookies.read(e.xsrfCookieName);
      $ && l.set(e.xsrfHeaderName, $);
    }
    s === void 0 && l.setContentType(null), "setRequestHeader" in w && utils$1.forEach(l.toJSON(), function(W, H) {
      w.setRequestHeader(H, W);
    }), utils$1.isUndefined(e.withCredentials) || (w.withCredentials = !!e.withCredentials), c && c !== "json" && (w.responseType = e.responseType), typeof e.onDownloadProgress == "function" && w.addEventListener("progress", progressEventReducer(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && w.upload && w.upload.addEventListener("progress", progressEventReducer(e.onUploadProgress)), (e.cancelToken || e.signal) && (m = ($) => {
      w && (o(!$ || $.type ? new CanceledError(null, e, w) : $), w.abort(), w = null);
    }, e.cancelToken && e.cancelToken.subscribe(m), e.signal && (e.signal.aborted ? m() : e.signal.addEventListener("abort", m)));
    const M = parseProtocol(R);
    if (M && platform.protocols.indexOf(M) === -1) {
      o(new AxiosError("Unsupported protocol " + M + ":", AxiosError.ERR_BAD_REQUEST, e));
      return;
    }
    w.send(s || null);
  });
}, knownAdapters = {
  http: httpAdapter,
  xhr: xhrAdapter
};
utils$1.forEach(knownAdapters, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const renderReason = (e) => `- ${e}`, isResolvedHandle = (e) => utils$1.isFunction(e) || e === null || e === !1, adapters = {
  getAdapter: (e) => {
    e = utils$1.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, o;
    const s = {};
    for (let l = 0; l < t; l++) {
      n = e[l];
      let c;
      if (o = n, !isResolvedHandle(n) && (o = knownAdapters[(c = String(n)).toLowerCase()], o === void 0))
        throw new AxiosError(`Unknown adapter '${c}'`);
      if (o)
        break;
      s[c || "#" + l] = o;
    }
    if (!o) {
      const l = Object.entries(s).map(
        ([p, m]) => `adapter ${p} ` + (m === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let c = t ? l.length > 1 ? `since :
` + l.map(renderReason).join(`
`) : " " + renderReason(l[0]) : "as no adapter specified";
      throw new AxiosError(
        "There is no suitable adapter to dispatch the request " + c,
        "ERR_NOT_SUPPORT"
      );
    }
    return o;
  },
  adapters: knownAdapters
};
function throwIfCancellationRequested(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new CanceledError(null, e);
}
function dispatchRequest(e) {
  return throwIfCancellationRequested(e), e.headers = AxiosHeaders$1.from(e.headers), e.data = transformData.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), adapters.getAdapter(e.adapter || defaults$1.adapter)(e).then(function(o) {
    return throwIfCancellationRequested(e), o.data = transformData.call(
      e,
      e.transformResponse,
      o
    ), o.headers = AxiosHeaders$1.from(o.headers), o;
  }, function(o) {
    return isCancel(o) || (throwIfCancellationRequested(e), o && o.response && (o.response.data = transformData.call(
      e,
      e.transformResponse,
      o.response
    ), o.response.headers = AxiosHeaders$1.from(o.response.headers))), Promise.reject(o);
  });
}
const headersToObject = (e) => e instanceof AxiosHeaders$1 ? e.toJSON() : e;
function mergeConfig(e, t) {
  t = t || {};
  const n = {};
  function o(C, P, w) {
    return utils$1.isPlainObject(C) && utils$1.isPlainObject(P) ? utils$1.merge.call({ caseless: w }, C, P) : utils$1.isPlainObject(P) ? utils$1.merge({}, P) : utils$1.isArray(P) ? P.slice() : P;
  }
  function s(C, P, w) {
    if (utils$1.isUndefined(P)) {
      if (!utils$1.isUndefined(C))
        return o(void 0, C, w);
    } else
      return o(C, P, w);
  }
  function l(C, P) {
    if (!utils$1.isUndefined(P))
      return o(void 0, P);
  }
  function c(C, P) {
    if (utils$1.isUndefined(P)) {
      if (!utils$1.isUndefined(C))
        return o(void 0, C);
    } else
      return o(void 0, P);
  }
  function p(C, P, w) {
    if (w in t)
      return o(C, P);
    if (w in e)
      return o(void 0, C);
  }
  const m = {
    url: l,
    method: l,
    data: l,
    baseURL: c,
    transformRequest: c,
    transformResponse: c,
    paramsSerializer: c,
    timeout: c,
    timeoutMessage: c,
    withCredentials: c,
    withXSRFToken: c,
    adapter: c,
    responseType: c,
    xsrfCookieName: c,
    xsrfHeaderName: c,
    onUploadProgress: c,
    onDownloadProgress: c,
    decompress: c,
    maxContentLength: c,
    maxBodyLength: c,
    beforeRedirect: c,
    transport: c,
    httpAgent: c,
    httpsAgent: c,
    cancelToken: c,
    socketPath: c,
    responseEncoding: c,
    validateStatus: p,
    headers: (C, P) => s(headersToObject(C), headersToObject(P), !0)
  };
  return utils$1.forEach(Object.keys(Object.assign({}, e, t)), function(P) {
    const w = m[P] || s, R = w(e[P], t[P], P);
    utils$1.isUndefined(R) && w !== p || (n[P] = R);
  }), n;
}
const VERSION = "1.6.7", validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  validators$1[e] = function(o) {
    return typeof o === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const deprecatedWarnings = {};
validators$1.transitional = function(t, n, o) {
  function s(l, c) {
    return "[Axios v" + VERSION + "] Transitional option '" + l + "'" + c + (o ? ". " + o : "");
  }
  return (l, c, p) => {
    if (t === !1)
      throw new AxiosError(
        s(c, " has been removed" + (n ? " in " + n : "")),
        AxiosError.ERR_DEPRECATED
      );
    return n && !deprecatedWarnings[c] && (deprecatedWarnings[c] = !0, console.warn(
      s(
        c,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(l, c, p) : !0;
  };
};
function assertOptions(e, t, n) {
  if (typeof e != "object")
    throw new AxiosError("options must be an object", AxiosError.ERR_BAD_OPTION_VALUE);
  const o = Object.keys(e);
  let s = o.length;
  for (; s-- > 0; ) {
    const l = o[s], c = t[l];
    if (c) {
      const p = e[l], m = p === void 0 || c(p, l, e);
      if (m !== !0)
        throw new AxiosError("option " + l + " must be " + m, AxiosError.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new AxiosError("Unknown option " + l, AxiosError.ERR_BAD_OPTION);
  }
}
const validator = {
  assertOptions,
  validators: validators$1
}, validators = validator.validators;
class Axios {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new InterceptorManager$1(),
      response: new InterceptorManager$1()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (o) {
      if (o instanceof Error) {
        let s;
        Error.captureStackTrace ? Error.captureStackTrace(s = {}) : s = new Error();
        const l = s.stack ? s.stack.replace(/^.+\n/, "") : "";
        o.stack ? l && !String(o.stack).endsWith(l.replace(/^.+\n.+\n/, "")) && (o.stack += `
` + l) : o.stack = l;
      }
      throw o;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = mergeConfig(this.defaults, n);
    const { transitional: o, paramsSerializer: s, headers: l } = n;
    o !== void 0 && validator.assertOptions(o, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, !1), s != null && (utils$1.isFunction(s) ? n.paramsSerializer = {
      serialize: s
    } : validator.assertOptions(s, {
      encode: validators.function,
      serialize: validators.function
    }, !0)), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let c = l && utils$1.merge(
      l.common,
      l[n.method]
    );
    l && utils$1.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (M) => {
        delete l[M];
      }
    ), n.headers = AxiosHeaders$1.concat(c, l);
    const p = [];
    let m = !0;
    this.interceptors.request.forEach(function($) {
      typeof $.runWhen == "function" && $.runWhen(n) === !1 || (m = m && $.synchronous, p.unshift($.fulfilled, $.rejected));
    });
    const C = [];
    this.interceptors.response.forEach(function($) {
      C.push($.fulfilled, $.rejected);
    });
    let P, w = 0, R;
    if (!m) {
      const M = [dispatchRequest.bind(this), void 0];
      for (M.unshift.apply(M, p), M.push.apply(M, C), R = M.length, P = Promise.resolve(n); w < R; )
        P = P.then(M[w++], M[w++]);
      return P;
    }
    R = p.length;
    let L = n;
    for (w = 0; w < R; ) {
      const M = p[w++], $ = p[w++];
      try {
        L = M(L);
      } catch (W) {
        $.call(this, W);
        break;
      }
    }
    try {
      P = dispatchRequest.call(this, L);
    } catch (M) {
      return Promise.reject(M);
    }
    for (w = 0, R = C.length; w < R; )
      P = P.then(C[w++], C[w++]);
    return P;
  }
  getUri(t) {
    t = mergeConfig(this.defaults, t);
    const n = buildFullPath(t.baseURL, t.url);
    return buildURL(n, t.params, t.paramsSerializer);
  }
}
utils$1.forEach(["delete", "get", "head", "options"], function(t) {
  Axios.prototype[t] = function(n, o) {
    return this.request(mergeConfig(o || {}, {
      method: t,
      url: n,
      data: (o || {}).data
    }));
  };
});
utils$1.forEach(["post", "put", "patch"], function(t) {
  function n(o) {
    return function(l, c, p) {
      return this.request(mergeConfig(p || {}, {
        method: t,
        headers: o ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: l,
        data: c
      }));
    };
  }
  Axios.prototype[t] = n(), Axios.prototype[t + "Form"] = n(!0);
});
const Axios$1 = Axios;
class CancelToken {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(l) {
      n = l;
    });
    const o = this;
    this.promise.then((s) => {
      if (!o._listeners)
        return;
      let l = o._listeners.length;
      for (; l-- > 0; )
        o._listeners[l](s);
      o._listeners = null;
    }), this.promise.then = (s) => {
      let l;
      const c = new Promise((p) => {
        o.subscribe(p), l = p;
      }).then(s);
      return c.cancel = function() {
        o.unsubscribe(l);
      }, c;
    }, t(function(l, c, p) {
      o.reason || (o.reason = new CanceledError(l, c, p), n(o.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new CancelToken(function(s) {
        t = s;
      }),
      cancel: t
    };
  }
}
const CancelToken$1 = CancelToken;
function spread(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function isAxiosError(e) {
  return utils$1.isObject(e) && e.isAxiosError === !0;
}
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(HttpStatusCode).forEach(([e, t]) => {
  HttpStatusCode[t] = e;
});
const HttpStatusCode$1 = HttpStatusCode;
function createInstance(e) {
  const t = new Axios$1(e), n = bind(Axios$1.prototype.request, t);
  return utils$1.extend(n, Axios$1.prototype, t, { allOwnKeys: !0 }), utils$1.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(s) {
    return createInstance(mergeConfig(e, s));
  }, n;
}
const axios = createInstance(defaults$1);
axios.Axios = Axios$1;
axios.CanceledError = CanceledError;
axios.CancelToken = CancelToken$1;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = toFormData;
axios.AxiosError = AxiosError;
axios.Cancel = axios.CanceledError;
axios.all = function(t) {
  return Promise.all(t);
};
axios.spread = spread;
axios.isAxiosError = isAxiosError;
axios.mergeConfig = mergeConfig;
axios.AxiosHeaders = AxiosHeaders$1;
axios.formToJSON = (e) => formDataToJSON(utils$1.isHTMLForm(e) ? new FormData(e) : e);
axios.getAdapter = adapters.getAdapter;
axios.HttpStatusCode = HttpStatusCode$1;
axios.default = axios;
const axios$1 = axios, _NgService = class {
};
_NgService.baseUrl = "https://api.next.wolfiesports.com/ng";
_NgService.token = () => localStorage.getItem("accessToken");
_NgService.createUserGameAccount = async (e, t) => {
  try {
    const n = {
      method: "POST",
      url: `${_NgService.baseUrl}/accounts/${e}/users`,
      data: {
        gamerTag: t
      },
      headers: {
        "x-access-token": _NgService.token() ?? "",
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    return await axios$1(n), !0;
  } catch {
    return !1;
  }
};
_NgService.getGameAccount = async (e) => {
  try {
    return (await axios$1.get(`${_NgService.baseUrl}/public/accounts/${e}`, {
      method: "GET"
    })).data;
  } catch {
    return;
  }
};
_NgService.getUserGameAccount = async (e) => {
  try {
    return (await axios$1.get(`${_NgService.baseUrl}/accounts/${e}/users`, {
      headers: {
        "x-access-token": _NgService.token()
      }
    })).data;
  } catch {
    return;
  }
};
let NgService = _NgService;
const NCAssetNgDialog = (e) => {
  var W, H, V, N, B, K;
  const t = useIntl(), [n, o] = useState(!1), [s, l] = useState(!1), [c, p] = useState(!1), [m, C] = useState(), P = 4, w = !!localStorage.getItem("accessToken");
  useEffect(() => {
    M();
  }, [e.organization.domain, w]);
  const R = (ue) => {
    const de = ue.currentTarget.value.replace(/[^\d.]/g, "");
    C(de), de.length < P && l(!1);
  }, L = (ue) => {
    localStorage.setItem("assetAsked", [...ue, e.tournamentId || e.organization.domain].toString());
  }, M = async () => {
    var de, ve, Te;
    if (!((de = e.organization) != null && de.domain.length) || !w)
      return;
    const ue = ((ve = localStorage.getItem("assetAsked")) == null ? void 0 : ve.split(",")) || [];
    if (e.tournamentId && !ue.includes(e.tournamentId) || !e.tournamentId && !ue.includes(e.organization.domain)) {
      const Pe = `${(Te = e.organization) == null ? void 0 : Te.domain}-asset`, Ce = await NgService.getGameAccount(Pe);
      if (Ce != null && Ce.active) {
        const Re = await NgService.getUserGameAccount(`${e.organization.domain}-asset`);
        if (Re != null && Re.gamerTag) {
          L(ue);
          return;
        } else
          o(!0), L(ue);
      }
    }
  }, $ = async () => {
    var ue;
    m && (await NgService.createUserGameAccount(`${(ue = e.organization) == null ? void 0 : ue.domain}-asset`, m) ? o(!1) : l(!0));
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    NCDialog,
    {
      show: n,
      setShow: (ue) => o(ue),
      title: t.formatMessage({ id: "organization.welcome.title" }, { name: (W = e.organization) == null ? void 0 : W.name }),
      wildBody: !0,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "nc-asset-ng-dialog text-center white", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "my-3", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mb-4", children: t.formatMessage({ id: "organization.welcome.asset" }, { name: (H = e.organization) == null ? void 0 : H.domain }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "d-flex nc-asset-dialog-gap justify-content-center", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              Button$1,
              {
                type: ButtonType.SECONDARY,
                label: t.formatMessage({ id: "ds.no" }),
                setClick: () => o(!1),
                color: (V = e.organization) == null ? void 0 : V.color.primary,
                textColor: "white"
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              Button$1,
              {
                label: t.formatMessage({ id: "ds.yes" }),
                setClick: () => p(!0),
                color: (N = e.organization) == null ? void 0 : N.color.primary
              }
            )
          ] })
        ] }),
        c && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "d-flex flex-column nc-asset-dialog-gap align-items-center my-3 pt-2", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-5", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mb-4", children: t.formatMessage({ id: "organization.welcome.id" }, { name: (B = e.organization) == null ? void 0 : B.domain }) }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "code-input mx-auto d-flex", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: "ID : #" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "input",
                {
                  minLength: P,
                  maxLength: P,
                  placeholder: "____",
                  onChange: R,
                  value: m
                }
              )
            ] })
          ] }),
          s && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "error-container text-left", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "red", children: t.formatMessage({ id: "organization.welcome.error" }) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "white", children: t.formatMessage({ id: "ds.error.id.discord" }) })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button$1,
            {
              label: t.formatMessage({ id: "ds.save" }),
              disabled: (m == null ? void 0 : m.length) !== P || s,
              color: (K = e.organization) == null ? void 0 : K.color.primary,
              type: (m == null ? void 0 : m.length) !== P || s ? ButtonType.SECONDARY : ButtonType.PRIMARY,
              setClick: () => $()
            }
          )
        ] })
      ] })
    }
  );
}, NCBreadcrumb$1 = "", NCBreadcrumb = (e) => {
  const t = e.routes.length - 1 - e.routes.slice().reverse().findIndex((n) => n.enabled);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "nc-breadcrumb", children: e.routes.map((n, o) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: `nc-breadcrumb-item d-flex flex-column align-items-center ${n.enabled ? "enabled" : ""} ${o === t ? "current" : ""}`,
      children: [
        o > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "separator" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            className: `position-relative ${n.ref ? "cursor-pointer" : ""}`,
            onClick: () => {
              var s;
              n.ref && ((s = n.ref.current) == null || s.scrollIntoView({ behavior: "smooth", block: "center" }));
            },
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "label position-absolute", children: n.label }),
              n.enabled && n.checked ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `dot-container position-relative my-2 ${o === 0 ? "first" : ""}`, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { icon: IconType.Success }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `dot my-2 ${o === 0 ? "first" : ""}` })
            ]
          }
        )
      ]
    },
    `${n.label}-${o}`
  )) });
}, NCCornerCalendar$1 = "", enShortWeekdayFormat = new Intl.DateTimeFormat("en", { weekday: "short" }), NCCornerCalendar = (e) => {
  const t = useIntl(), n = (R) => enShortWeekdayFormat.format(R) === "Mon", o = (R) => t.formatDate(R, { weekday: "short" }), l = (() => {
    const R = [], L = new Date(e.year, e.month);
    let M = L;
    for (let $ = 0; $ < 7 && (M = hooks(L).add($, "days").toDate(), !n(M)); $++)
      ;
    for (let $ = 0; $ < 7; $++)
      R.push(o(hooks(M).add($, "days").toDate()));
    return R;
  })(), c = new Date(e.year, e.month), p = (R, L) => {
    L.length > 0 && e.onDateSelected(R, L.map((M) => M.id));
  }, m = (R) => e.events.filter((L) => R.isSame(L.date, "day")), C = () => {
    const R = hooks(c).daysInMonth(), L = [];
    for (let M = 0; M < R; M++) {
      const $ = hooks(c).add(M, "days"), W = m($), H = Array.from(new Set(W.flatMap((V) => V.classNames)));
      L.push(/* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          onClick: () => p($.toDate(), W),
          className: `calendar-item day ${W.length ? "has-events" : ""} ${e.selectedDate && $.isSame(e.selectedDate, "day") ? "selected" : ""} ${H.join(" ")}`,
          children: M + 1
        },
        M
      ));
    }
    return L;
  }, P = () => {
    const R = o(c), L = l.findIndex(($) => $ === R), M = [];
    for (let $ = 0; $ < L; $++)
      M.push(/* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "calendar-item empty-day " }, $));
    return M;
  }, w = () => l.map((R, L) => {
    const M = R.slice(0, 1).toUpperCase();
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "weekday calendar-item", children: e.weekdayFormat === "narrow" ? M : R }, L);
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "nc-corner-calendar", children: [
    w(),
    P(),
    C()
  ] });
}, NCCornerCalendarV1$1 = "";
class TournamentUtilsService {
}
TournamentUtilsService.getReward = (e, t) => {
  const n = e.rewards;
  if (!n)
    return;
  let o;
  if (Object.values(n).length > 0) {
    const s = Object.values(n).flat().map((l) => l.value).reduce((l, c) => l + c);
    (e.sum || s > 0) && (o = t.formatNumber(
      e.sum ? e.sum : s,
      {
        style: "currency",
        currency: n[1][0].cur,
        minimumFractionDigits: 0
      }
    ));
  }
  return o;
};
TournamentUtilsService.gotGift = (e) => e.rewards ? !!Object.values(e.rewards).flat().find((t) => t.kind === RewardKind.GIFT) : !1;
TournamentUtilsService.isTeamTournament = (e) => e.settings ? e.settings.nbMax > 1 : e.matchSettings ? e.matchSettings.default.max > 1 : !1;
const NCTournamentCard$1 = "";
var TournamentCardStyle = /* @__PURE__ */ ((e) => (e[e.HIGHLIGHT1 = 1] = "HIGHLIGHT1", e[e.HIGHLIGHT2 = 2] = "HIGHLIGHT2", e[e.SIMILAR_TOURNAMENT = 3] = "SIMILAR_TOURNAMENT", e))(TournamentCardStyle || {});
const NCTournamentCard = (e) => {
  var ve;
  const t = useIntl(), [n, o] = useState(
    e.tournament.platforms
  ), s = useRef(null), l = {
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  }, c = 16, p = useRef(null), m = useRef(null), [C, P] = useState(0), [w, R] = useState(24), [L, M] = useState(!1), $ = 200, [W, H] = useState(0), V = 20, N = 6;
  useEffect(() => {
    setTimeout(() => {
      if (s != null && s.current) {
        const Te = s.current.clientWidth;
        o(
          Te < e.tournament.platforms.length * c ? [...n.slice(0, Math.floor(Te / c) - 1)] : e.tournament.platforms
        );
      }
    }, $);
  }, [s.current]), useEffect(() => {
    setTimeout(() => {
      if (p.current && m.current) {
        const Te = m.current.offsetWidth, Pe = p.current.offsetWidth, Ce = Pe - Te;
        P(
          p.current.offsetWidth < Te ? 0 : Ce
        ), R(p.current.offsetHeight);
        let Re = (Pe - Te - N) / V;
        Re = Re > 0 && Re < 2 ? 2 : Re, H(Re / 2), M(Re > 0);
      }
    }, $);
  }, [
    p.current,
    m.current,
    (ve = p.current) == null ? void 0 : ve.offsetHeight
  ]);
  const B = () => {
    let Te = !1;
    try {
      Te = e.tournament.format === 1;
    } catch {
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "tournament-infos", children: [
      e.prize && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: e.prize }),
      e.gift && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "d-flex", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { icon: IconType.Gift, width: 16, height: 16 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: t.formatMessage({ id: "tournament.reward.gift" }) })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: t.formatMessage({
        id: `tournament.format.${Te ? "solo" : "team"}`
      }) })
    ] });
  }, K = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "tournament-infos", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: new Intl.DateTimeFormat("default", l).format(
      typeof e.tournament.date == "number" ? new Date(e.tournament.date * 1e3) : new Date(e.tournament.date)
    ) }),
    n && /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        ref: s,
        className: "platform-container d-flex align-items-center",
        children: [
          n.map((Te) => /* @__PURE__ */ jsxRuntimeExports.jsx(
            IconMask,
            {
              icon: `https://assets.next.wolfiesports.com/media/platforms/${Te}.svg`,
              width: c,
              height: c,
              name: "platform"
            },
            Te
          )),
          e.tournament.platforms.length > n.length && /* @__PURE__ */ jsxRuntimeExports.jsx(
            Icon,
            {
              icon: IconType.Plus,
              width: c - 4,
              height: c - 4,
              styleName: "ml-1"
            }
          )
        ]
      }
    )
  ] }), ue = () => e.winner ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "tournament-infos", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "winner", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { icon: IconType.Crown, width: 16, height: 16, styleName: "mr-2" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: e.winner })
  ] }) }) : null, de = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "partner my-2", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mr-2", children: t.formatMessage({ id: "tournament.card.sponsored" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "img",
      {
        src: `https://assets.next.wolfiesports.com/media/organizations/${e.tournament.partner}/LeftMenuIcon`,
        className: "icon-partner"
      }
    )
  ] });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: `nc-tournament-card
                ${e.cardStyle === 1 ? "highlight1" : e.cardStyle === 2 ? "highlight2" : e.cardStyle === 3 ? "similar-tournament" : ""}
                ${e.restricted ? "restricted" : ""}
                ${e.forceSmall ? "small" : ""}`,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "tournament-banner position-relative", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "div",
          {
            className: "banner-image position-absolute",
            style: {
              backgroundImage: e.banner.toString().split(",").map((Te) => `url(${Te})`).toString()
            }
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "tournament-content align-self-center", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "div",
            {
              ref: m,
              className: `marquee-container ${L ? "manual-ellipsis" : ""}`,
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                "div",
                {
                  className: "position-relative marquee-content",
                  style: {
                    width: C,
                    height: w
                  },
                  children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
                    "div",
                    {
                      ref: p,
                      style: { animationDuration: `${W}s` },
                      className: "marquee-slider tournament-infos title position-absolute mt-1",
                      children: [
                        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: e.gameName }),
                        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: e.tournament.name })
                      ]
                    }
                  )
                }
              )
            }
          ),
          !e.restricted && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "tournament-infos text-uppercase entrance mb-2", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { color: e.color ? e.color : "" }, children: t.formatMessage({
            id: `tournament.card.fee.${TournamentFee[e.tournament.entrance.fee].toLowerCase()}`
          }) }) }),
          e.restricted ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "tournament-infos", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: t.formatMessage({ id: "tournament.card.restricted" }) }) }) : B(),
          e.winner ? ue() : K(),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "div",
            {
              className: `additional-infos mb-1 ${e.tournament.partner ? "" : "mt-2"}`,
              children: [
                e.winner && K(),
                e.tournament.partner && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "partner-container d-flex justify-content-between align-items-center", children: [
                  de(),
                  ue()
                ] }),
                e.joinHook && /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "div",
                  {
                    className: `d-flex justify-content-${e.winner ? "end" : "between"}`,
                    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                      Button$1,
                      {
                        theme: e.color ? ButtonTheme.CUSTOM : ButtonTheme.TOURNAMENT,
                        type: !e.color || e.restricted || e.winner ? ButtonType.SECONDARY : ButtonType.PRIMARY,
                        label: t.formatMessage({
                          id: `tournament.card.${e.winner ? "about" : e.restricted ? "moreinfo" : "see"}`
                        }),
                        color: e.color || "",
                        textColor: e.textColor,
                        setClick: (Te) => {
                          e.joinHook && e.joinHook(Te);
                        }
                      }
                    )
                  }
                )
              ]
            }
          )
        ] })
      ]
    }
  );
}, NCCornerCalendarV1 = (e) => {
  const t = useIntl(), [n, o] = useState(), [s, l] = useState([]), [c, p] = useState([]), [m, C] = useState(hooks()), [P, w] = useState(""), R = (B) => {
    e.onOpenEvent && e.onOpenEvent(B);
  }, L = (B, K) => {
    o(B), l(e.events.filter((ue) => K.includes(ue.id)));
  }, M = () => {
    const B = [];
    return e.events.forEach((K) => {
      const ue = hooks(K.date * 1e3);
      B.some((de) => ue.month() === de.month && ue.year() === de.year) || B.push({ month: ue.month(), year: ue.year() });
    }), B.sort(
      (K, ue) => K.month + K.year * 100 - (ue.month + ue.year * 100)
    );
  }, $ = () => {
    if (e.events.length > 0) {
      const B = e.events.reverse().find((K) => hooks(K.date * 1e3) > hooks());
      B && L(hooks(B.date * 1e3).toDate(), [B.id]);
    }
  };
  useEffect(() => {
    e.horizontal || p(M()), $();
  }, [e.events]);
  const W = (B) => {
    w(B > 0 ? "slide-left" : "slide-right"), setTimeout(() => {
      C(m.clone().add(B, "months")), w("");
    }, 130);
  }, H = (B) => {
    switch (e.tournamentInfoStyle) {
      case 1:
        return N(B);
      default:
        return V(B);
    }
  }, V = (B) => {
    const K = new Date(B.date * 1e3);
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "date pb-2", children: t.formatDate(K, { day: "numeric", month: "long" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "time pb-2", children: t.formatDate(K, { hour: "2-digit", minute: "2-digit" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "name pb-4", children: B.name }),
      e.openEventLabel && e.onOpenEvent && /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button$1,
        {
          theme: ButtonTheme.CUSTOM,
          label: e.openEventLabel,
          setClick: () => R(B.id)
        }
      )
    ] });
  }, N = (B) => {
    var Te, Pe, Ce;
    if (!B.tournament)
      return /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, {});
    const K = `https://assets.next.wolfiesports.com/game/${B.tournament.gameSlug}/medias`, ue = [
      (Te = B.tournamentContent) == null ? void 0 : Te.logo,
      `${K}/TournamentMobileBanner`,
      (Pe = B.tournamentContent) == null ? void 0 : Pe.banner,
      `${K}/TournamentBanner`
    ], de = (Ce = e.games) == null ? void 0 : Ce.find(
      (Re) => {
        var ke;
        return Re.slug === ((ke = B.tournament) == null ? void 0 : ke.gameSlug);
      }
    );
    let ve;
    return e.onOpenEvent && (ve = () => {
      var Re;
      (Re = e.onOpenEvent) == null || Re.call(e, B.id);
    }), /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "d-flex justify-content-center w-100", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      NCTournamentCard,
      {
        tournament: convertTournamentToTournamentCard(B.tournament),
        banner: ue,
        gameName: (de == null ? void 0 : de.name) || "",
        prize: TournamentUtilsService.getReward(B.tournament, t),
        joinHook: ve,
        gift: TournamentUtilsService.gotGift(B.tournament)
      }
    ) });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "nc-corner-calendar-v1 d-flex flex-column p-3", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "row", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "col-12 col-md-6 calendars mx-auto", children: e.horizontal ? /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "d-flex justify-content-between", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "div",
            {
              className: "month-switcher cursor-pointer",
              onClick: () => W(-1),
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { icon: IconType.Colapse, styleName: "previous" })
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "month text-center", children: [
            t.formatDate(m.toDate(), { month: "long" }),
            " ",
            m.year()
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "div",
            {
              className: "month-switcher cursor-pointer",
              onClick: () => W(1),
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { icon: IconType.Colapse, styleName: "next" })
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `calendar-container ${P}`, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          NCCornerCalendar,
          {
            month: m.month(),
            year: m.year(),
            events: e.events.map((B) => ({
              ...B,
              date: new Date(B.date * 1e3)
            })),
            selectedDate: n,
            onDateSelected: L,
            weekdayFormat: e.weekdayFormat
          }
        ) })
      ] }) : c.map((B, K) => {
        const ue = hooks().set("month", B.month).set("year", B.year);
        return /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
          K !== 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "divider" }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "month", children: [
            t.formatDate(ue.toDate(), { month: "long" }),
            " ",
            ue.year()
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            NCCornerCalendar,
            {
              month: ue.month(),
              year: ue.year(),
              events: e.events.map((de) => ({
                ...de,
                date: new Date(de.date * 1e3)
              })),
              selectedDate: n,
              onDateSelected: L,
              weekdayFormat: e.weekdayFormat
            }
          )
        ] }, `${B.month}-${B.year}`);
      }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "col-12 col-md-6 d-flex flex-column details align-self-center px-4 mt-3 mt-lg-0", children: [
        e.numberOfEventsMessage && s.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "text-center number-of-events-message", children: [
          s.length,
          " ",
          e.numberOfEventsMessage
        ] }),
        s.map((B, K) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mb-1", children: [
          K !== 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "divider" }),
          H(B)
        ] }, B.id))
      ] })
    ] }),
    !e.hideLegend && e.games.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "divider m-0" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "legend d-flex flex-column flex-sm-row justify-content-around mt-3 mb-4", children: e.games.map((B) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "d-flex", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `circle mr-3 ${B.slug}` }),
        B.name
      ] }, B.slug)) })
    ] })
  ] });
}, useProgressBar = () => {
  const e = useIntl(), [t] = useState(hooks());
  return { calculateProgressRatio: (s, l) => {
    if (t.isAfter(l))
      return 1;
    const p = t.isSameOrAfter(s);
    if (p) {
      const m = hooks(p ? l : s), C = Math.abs(m.diff(t));
      if (C > 0) {
        const P = m.diff(s);
        return 1 - C / P;
      }
    }
    return 0;
  }, calculateTimeLeftText: (s, l) => {
    const c = t.isAfter(l), p = t.isSameOrAfter(s);
    if (!p || !c) {
      const m = hooks(p ? l : s), C = ["days", "hours", "minutes", "seconds"];
      for (const P of C) {
        const w = Math.abs(m.diff(t, P));
        if (w > 1)
          return e.formatMessage(
            { id: `challenge.time-${p ? "left" : "start"}.${P}` },
            { value: w }
          );
      }
    }
    return "";
  } };
}, flatRewards = (e) => e ? Object.values(e).reduce((t, n) => t.concat(n), []) : [], rewardsToString = (e) => {
  var n;
  const t = flatRewards(e);
  if (t && t.length > 0) {
    const o = t.reduce((s, l) => s + l.value, 0);
    return useIntl().formatNumber(
      o,
      {
        style: "currency",
        currency: (n = t[0].cur) == null ? void 0 : n.toUpperCase(),
        currencyDisplay: "symbol",
        minimumFractionDigits: 0
      }
    );
  }
  return "";
}, NCChallengeCard$1 = "", ICON_SIZE = 24, WINNER_ICON_SIZE = 16, CHALLENGE_CARD_DATE_FORMAT = "dddd D MMMM HH:mm", CONTEST_TYPES = {
  [ContestType.PICTURE]: {
    icon: IconType.ArtGallery,
    text: "Picture contest"
  },
  [ContestType.VIDEO]: {
    icon: IconType.Camera,
    text: "Video contest"
  },
  [ContestType.TICKET]: {
    icon: IconType.Ticket,
    text: "Tickets contest"
  }
}, NCChallengeCard = (e) => {
  const { challenge: t } = e, n = useIntl(), [o] = useState(hooks()), [s] = useState(hooks(t.startDate)), [l] = useState(hooks(t.endDate)), [c, p] = useState(0), [m, C] = useState(""), P = n.formatMessage({
    id: "organization.challenges.starts_ends.today"
  }), w = rewardsToString(t.rewards), { calculateProgressRatio: R, calculateTimeLeftText: L } = useProgressBar();
  useEffect(() => {
    p(
      R(t.startDate, t.endDate)
    ), C(
      L(t.startDate, t.endDate)
    );
  }, [t.startDate, t.endDate]);
  const { isAvailableInRegion: M, type: $ } = t, W = () => t.game && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "challenge-game", children: [
    t.game.id && /* @__PURE__ */ jsxRuntimeExports.jsx(
      IconMask,
      {
        icon: `https://assets.next.wolfiesports.com/media/games/${t.game.id}/LogoImage`,
        width: ICON_SIZE,
        height: ICON_SIZE,
        name: "game"
      }
    ),
    t.game.title && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "game-title", children: t.game.title })
  ] }), H = () => {
    var de, ve;
    const ue = Object.assign(
      CONTEST_TYPES[$]
    );
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
      (((de = t.game) == null ? void 0 : de.id) || ((ve = t.game) == null ? void 0 : ve.title)) && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "separator" }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "challenge-contest-type", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { icon: ue.icon, width: ICON_SIZE, height: ICON_SIZE }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "contest-type-text", children: ue.text })
      ] })
    ] });
  }, V = () => w && /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
    t.participants > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "separator" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "challenge-rewards", children: w })
  ] }), N = () => t.winner && /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "separator" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "challenge-winner d-flex", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Icon,
        {
          icon: IconType.Crown,
          width: WINNER_ICON_SIZE,
          height: WINNER_ICON_SIZE
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "winner", children: t.winner })
    ] })
  ] }), B = (ue, de) => `${n.formatMessage(
    { id: ue },
    {
      date: de === o ? P : de.format(CHALLENGE_CARD_DATE_FORMAT)
    }
  )}`, K = () => {
    let ue, de;
    return c < 1 ? s === l ? ue = B(
      "organization.challenges.starts_ends",
      s
    ) : (o <= s && (ue = B(
      "organization.challenges.starts",
      s
    )), de = B("organization.challenges.ends", l)) : de = B("organization.challenges.ended", l), /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
      ue && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: ue }),
      ue && de && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "separator" }),
      de && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: de })
    ] });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: `nc-challenge-card d-flex flex-row ${M ? "" : "not-available"}`,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "challenge-banner", children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { className: "banner-image", src: t.banner }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "challenge-content d-flex flex-column", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "challange-header", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "challange-title d-flex", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: t.i18n.title }),
              !M && /* @__PURE__ */ jsxRuntimeExports.jsx(
                Icon,
                {
                  icon: IconType.UnavailableLocation,
                  width: ICON_SIZE,
                  height: ICON_SIZE
                }
              )
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              Button$1,
              {
                label: "More info",
                styleClass: "challenge-more-info",
                theme: ButtonTheme.CLASSIC,
                type: ButtonType.SECONDARY,
                setClick: () => e.goTo(t.id)
              }
            )
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "challange-info-container", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "d-flex", children: [
            W(),
            H()
          ] }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "challange-date-container", children: K() }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "challenge-ongoing-container", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              NCProgressBar,
              {
                width: "36%",
                ratio: c,
                color: e.color
              }
            ),
            m && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "ongoing-text", children: m })
          ] }),
          t.i18n.description && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "challenge-description", children: t.i18n.description }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "challenge-footer", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "challenge-extra-info d-flex", children: [
              t.participants > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "challenge-participants", children: `${n.formatMessage(
                { id: "organization.challenges.participants" },
                { noParticipants: t.participants }
              )}` }),
              V(),
              N()
            ] }),
            !M && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "unavailable-location-text", children: n.formatMessage({
              id: "organization.challenges.not_available"
            }) })
          ] })
        ] })
      ]
    }
  );
}, NCCheckbox$1 = "", NCCheckbox = (e) => /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider, { theme: ThemePlatform, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "nc-checkbox cursor-pointer d-flex align-items-center m-0", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "checkbox", onChange: (t) => {
    e.checked = !e.checked, e.onChange && e.onChange(t.target.checked);
  }, checked: e.checked || !1 }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "frame", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { icon: IconType.Cross, width: 9, height: 9 }) })
] }) }) }), NCChip$1 = "", NCChip = (e) => {
  const { label: t, checked: n, onChange: o, deletion: s, disabled: l, style: c } = e;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider, { theme: ThemePlatform, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: `nc-chip d-flex align-items-baseline ${l ? "disabled" : ""} ${s ? "deletion active" : n ? "active" : ""} ${c || ""}`,
      onClick: () => o(!n),
      children: [
        t,
        s && /* @__PURE__ */ jsxRuntimeExports.jsx(
          Icon,
          {
            icon: IconType.Close,
            width: 12,
            height: 12
          }
        )
      ]
    }
  ) }) });
}, Ht = "linear-gradient(45deg, #ccc 25%, transparent 25%), linear-gradient(135deg, #ccc 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #ccc 75%), linear-gradient(135deg, transparent 75%, #ccc 75%) /*! @noflip */", $t = "linear-gradient(to top, #000000, transparent), linear-gradient(to right, #ffffff, transparent) /*! @noflip */", It = {
  Button: E(yt)(() => ({
    backgroundSize: "8px 8px",
    backgroundPosition: "0 0, 4px 0, 4px -4px, 0px 4px",
    transition: "none",
    boxShadow: "0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08)",
    border: 0,
    borderRadius: 4,
    width: "24px",
    aspectRatio: "1 / 1",
    height: "24px",
    minWidth: 0
  }))
}, Pt = (e) => {
  const {
    bgColor: t,
    className: n,
    disablePopover: o,
    isBgColorValid: s,
    ...l
  } = e;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    It.Button,
    {
      disableTouchRipple: !0,
      style: {
        backgroundColor: s ? t : void 0,
        backgroundImage: s ? void 0 : Ht,
        cursor: o ? "default" : void 0
      },
      className: `MuiColorInput-Button ${n || ""}`,
      ...l
    }
  );
}, Bt = {
  Container: E("div")(() => ({
    width: 300,
    padding: 8
  }))
}, Ft = ({
  children: e,
  className: t,
  position: n = "start",
  ...o
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  Ct,
  {
    className: `MuiColorInput-Popover ${t || ""}`,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: n === "start" ? "left" : "right"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: n === "start" ? "left" : "right"
    },
    ...o,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(Bt.Container, { children: e })
  }
), Et = {
  Slider: E(dt, {
    shouldForwardProp: (e) => e !== "$rgbaFrom" && e !== "$rgbaTo"
  })(() => ({
    height: 8,
    "& .MuiSlider-rail": {
      opacity: 1,
      // TODO: find better way for perf
      background: "linear-gradient(to right, rgba(var(--rgb-r), var(--rgb-g), var(--rgb-b), 0) 0%, rgba(var(--rgb-r), var(--rgb-g), var(--rgb-b), 1) 100%)"
    },
    "& .MuiSlider-track": {
      color: "transparent",
      border: 0
    },
    "& .MuiSlider-thumb": {
      backgroundColor: "#ffffff",
      border: "3px solid currentColor"
    }
  }))
}, Nt = (e) => {
  const { rgbColor: t, style: n, className: o, ...s } = e, l = {
    "--rgb-r": t.r,
    "--rgb-g": t.g,
    "--rgb-b": t.b,
    ...n
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Et.Slider,
    {
      className: `MuiColorInput-AlphaSlider ${o || ""}`,
      style: l,
      ...s
    }
  );
}, D = {
  up: "ArrowUp",
  down: "ArrowDown",
  left: "ArrowLeft",
  right: "ArrowRight"
}, Vt = {
  ArrowUp: {
    type: "hsvV",
    value: 1
  },
  ArrowDown: {
    type: "hsvV",
    value: -1
  },
  ArrowLeft: {
    type: "hsvS",
    value: -1
  },
  ArrowRight: {
    type: "hsvS",
    value: 1
  }
};
function Tt(e) {
  return e === D.up || e === D.down || e === D.left || e === D.right;
}
function q(e, t, n) {
  return Math.max(t, Math.min(e, n));
}
function nt(e) {
  return typeof e == "number";
}
function st(e, t, n) {
  const o = e.toLocaleString("en", {
    useGrouping: !1,
    minimumFractionDigits: t,
    maximumFractionDigits: n
  });
  return Number(o);
}
function Ot(e, t, n) {
  const o = e.getBoundingClientRect(), s = t - o.left, l = n - o.top;
  return {
    x: q(s / o.width, 0, 1),
    y: q(1 - l / o.height, 0, 1)
  };
}
function Lt(e) {
  const t = React__default.useRef();
  return t.current = e, React__default.useCallback((...n) => {
    var o;
    return (o = t.current) == null ? void 0 : o.call(t, ...n);
  }, []);
}
const at = {
  Space: E("div")(() => ({
    width: "100%",
    height: "180px",
    boxSizing: "border-box",
    outline: 0,
    position: "relative",
    backgroundImage: $t
  })),
  Thumb: E("div")(() => ({
    position: "absolute",
    border: "3px solid #ffffff",
    borderRadius: "50%",
    width: "20px",
    height: "20px",
    marginLeft: "-10px /*! @noflip */",
    marginBottom: "-10px /*! @noflip */",
    outline: 0,
    boxSizing: "border-box",
    willChange: "left, bottom",
    transition: "box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    "&:hover": {
      boxShadow: "0px 0px 0px 4px rgba(255 255 255 / 0.16)"
    },
    "&.MuiColorInput-Thumb-active": {
      boxShadow: "0px 0px 0px 8px rgba(255 255 255 / 0.16)"
    },
    "@media (hover: none)": {
      boxShadow: "none"
    }
  }))
}, Dt = (e) => {
  const { hsv: t, onChange: n, currentHue: o } = e, s = React__default.useRef(!1), l = React__default.useRef(null), [c, p] = React__default.useState(!1), m = Lt(($, W) => {
    if (!l.current)
      return;
    const { x: H, y: V } = Ot(l.current, $, W);
    n({
      s: H,
      v: V
    }), l.current && document.activeElement !== l.current && l.current.focus();
  }), C = React__default.useCallback(() => {
    s.current && (s.current = !1, p(!1));
  }, []), P = React__default.useCallback(($) => {
    s.current && m($.clientX, $.clientY);
  }, []);
  React__default.useEffect(() => (document.addEventListener("pointermove", P, !1), document.addEventListener("pointerup", C, !1), () => {
    document.removeEventListener("pointermove", P, !1), document.removeEventListener("pointerup", C, !1);
  }), [C, P]);
  const w = ($) => {
    $.preventDefault(), s.current = !0, m($.clientX, $.clientY), p(!0);
  }, R = ($) => {
    if (Tt($.key)) {
      $.preventDefault();
      const { type: W, value: H } = Vt[$.key], V = $.shiftKey ? 10 : 1, N = W === "hsvS" ? t.s : t.v, B = q(
        N + H * V * 0.01,
        0,
        1
      );
      p(!0), n({
        s: W === "hsvS" ? B : t.s,
        v: W === "hsvV" ? B : t.v
      });
    }
  }, L = t.s * 100, M = t.v * 100;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    at.Space,
    {
      onPointerDown: w,
      ref: l,
      className: "MuiColorInput-ColorSpace",
      style: {
        backgroundColor: `hsl(${o} 100% 50%)`,
        touchAction: "none"
      },
      role: "slider",
      "aria-valuetext": `Saturation ${st(
        L,
        0,
        0
      )}%, Brightness ${st(M, 0, 0)}%`,
      onKeyDown: R,
      tabIndex: 0,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        at.Thumb,
        {
          "aria-label": "Color space thumb",
          className: c ? "MuiColorInput-Thumb-active" : "",
          style: {
            left: `${L}%`,
            bottom: `${M}%`
          }
        }
      )
    }
  );
}, jt = {
  Slider: E(dt)(() => ({
    height: 8,
    "& .MuiSlider-rail": {
      opacity: 1,
      background: "linear-gradient(to right, rgb(255, 0, 0) 0%, rgb(255, 255, 0) 17%, rgb(0, 255, 0) 33%, rgb(0, 255, 255) 50%, rgb(0, 0, 255) 67%, rgb(255, 0, 255) 83%, rgb(255, 0, 0) 100%) /*! @noflip */"
    },
    "& .MuiSlider-track": {
      color: "transparent",
      border: 0
    },
    "& .MuiSlider-thumb": {
      backgroundColor: "#ffffff",
      border: "3px solid currentColor"
    }
  }))
}, Gt = (e) => {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    jt.Slider,
    {
      className: `MuiColorInput-HueSlider ${t || ""}`,
      ...n
    }
  );
};
function qt(e) {
  return typeof e == "string";
}
function g(e, t) {
  Wt(e) && (e = "100%");
  const n = Kt(e);
  return e = t === 360 ? e : Math.min(t, Math.max(0, parseFloat(e))), n && (e = parseInt(String(e * t), 10) / 100), Math.abs(e - t) < 1e-6 ? 1 : (t === 360 ? e = (e < 0 ? e % t + t : e % t) / parseFloat(String(t)) : e = e % t / parseFloat(String(t)), e);
}
function j(e) {
  return Math.min(1, Math.max(0, e));
}
function Wt(e) {
  return typeof e == "string" && e.indexOf(".") !== -1 && parseFloat(e) === 1;
}
function Kt(e) {
  return typeof e == "string" && e.indexOf("%") !== -1;
}
function gt(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function G(e) {
  return Number(e) <= 1 ? `${Number(e) * 100}%` : e;
}
function I(e) {
  return e.length === 1 ? "0" + e : String(e);
}
function Ut(e, t, n) {
  return {
    r: g(e, 255) * 255,
    g: g(t, 255) * 255,
    b: g(n, 255) * 255
  };
}
function ot(e, t, n) {
  e = g(e, 255), t = g(t, 255), n = g(n, 255);
  const o = Math.max(e, t, n), s = Math.min(e, t, n);
  let l = 0, c = 0;
  const p = (o + s) / 2;
  if (o === s)
    c = 0, l = 0;
  else {
    const m = o - s;
    switch (c = p > 0.5 ? m / (2 - o - s) : m / (o + s), o) {
      case e:
        l = (t - n) / m + (t < n ? 6 : 0);
        break;
      case t:
        l = (n - e) / m + 2;
        break;
      case n:
        l = (e - t) / m + 4;
        break;
    }
    l /= 6;
  }
  return { h: l, s: c, l: p };
}
function z(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * (6 * n) : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function zt(e, t, n) {
  let o, s, l;
  if (e = g(e, 360), t = g(t, 100), n = g(n, 100), t === 0)
    s = n, l = n, o = n;
  else {
    const c = n < 0.5 ? n * (1 + t) : n + t - n * t, p = 2 * n - c;
    o = z(p, c, e + 1 / 3), s = z(p, c, e), l = z(p, c, e - 1 / 3);
  }
  return { r: o * 255, g: s * 255, b: l * 255 };
}
function it(e, t, n) {
  e = g(e, 255), t = g(t, 255), n = g(n, 255);
  const o = Math.max(e, t, n), s = Math.min(e, t, n);
  let l = 0;
  const c = o, p = o - s, m = o === 0 ? 0 : p / o;
  if (o === s)
    l = 0;
  else {
    switch (o) {
      case e:
        l = (t - n) / p + (t < n ? 6 : 0);
        break;
      case t:
        l = (n - e) / p + 2;
        break;
      case n:
        l = (e - t) / p + 4;
        break;
    }
    l /= 6;
  }
  return { h: l, s: m, v: c };
}
function Yt(e, t, n) {
  e = g(e, 360) * 6, t = g(t, 100), n = g(n, 100);
  const o = Math.floor(e), s = e - o, l = n * (1 - t), c = n * (1 - s * t), p = n * (1 - (1 - s) * t), m = o % 6, C = [n, c, l, l, p, n][m], P = [p, n, n, c, l, l][m], w = [l, l, p, n, n, c][m];
  return { r: C * 255, g: P * 255, b: w * 255 };
}
function ht(e, t, n, o) {
  const s = [
    I(Math.round(e).toString(16)),
    I(Math.round(t).toString(16)),
    I(Math.round(n).toString(16))
  ];
  return o && s[0].startsWith(s[0].charAt(1)) && s[1].startsWith(s[1].charAt(1)) && s[2].startsWith(s[2].charAt(1)) ? s[0].charAt(0) + s[1].charAt(0) + s[2].charAt(0) : s.join("");
}
function Xt(e, t, n, o, s) {
  const l = [
    I(Math.round(e).toString(16)),
    I(Math.round(t).toString(16)),
    I(Math.round(n).toString(16)),
    I(Zt(o))
  ];
  return s && l[0].startsWith(l[0].charAt(1)) && l[1].startsWith(l[1].charAt(1)) && l[2].startsWith(l[2].charAt(1)) && l[3].startsWith(l[3].charAt(1)) ? l[0].charAt(0) + l[1].charAt(0) + l[2].charAt(0) + l[3].charAt(0) : l.join("");
}
function Zt(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function ut(e) {
  return x(e) / 255;
}
function x(e) {
  return parseInt(e, 16);
}
function Jt(e) {
  return {
    r: e >> 16,
    g: (e & 65280) >> 8,
    b: e & 255
  };
}
const Z = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function Qt(e) {
  let t = { r: 0, g: 0, b: 0 }, n = 1, o = null, s = null, l = null, c = !1, p = !1;
  return typeof e == "string" && (e = ee(e)), typeof e == "object" && (A(e.r) && A(e.g) && A(e.b) ? (t = Ut(e.r, e.g, e.b), c = !0, p = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : A(e.h) && A(e.s) && A(e.v) ? (o = G(e.s), s = G(e.v), t = Yt(e.h, o, s), c = !0, p = "hsv") : A(e.h) && A(e.s) && A(e.l) && (o = G(e.s), l = G(e.l), t = zt(e.h, o, l), c = !0, p = "hsl"), Object.prototype.hasOwnProperty.call(e, "a") && (n = e.a)), n = gt(n), {
    ok: c,
    format: e.format || p,
    r: Math.min(255, Math.max(t.r, 0)),
    g: Math.min(255, Math.max(t.g, 0)),
    b: Math.min(255, Math.max(t.b, 0)),
    a: n
  };
}
const _t = "[-\\+]?\\d+%?", te = "[-\\+]?\\d*\\.\\d+%?", y = "(?:" + te + ")|(?:" + _t + ")", Y = "[\\s|\\(]+(" + y + ")[,|\\s]+(" + y + ")[,|\\s]+(" + y + ")\\s*\\)?", X = (
  // eslint-disable-next-line prettier/prettier
  "[\\s|\\(]+(" + y + ")[,|\\s]+(" + y + ")[,|\\s]+(" + y + ")[,|\\s]+(" + y + ")\\s*\\)?"
), v = {
  CSS_UNIT: new RegExp(y),
  rgb: new RegExp("rgb" + Y),
  rgba: new RegExp("rgba" + X),
  hsl: new RegExp("hsl" + Y),
  hsla: new RegExp("hsla" + X),
  hsv: new RegExp("hsv" + Y),
  hsva: new RegExp("hsva" + X),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function ee(e) {
  if (e = e.trim().toLowerCase(), e.length === 0)
    return !1;
  let t = !1;
  if (Z[e])
    e = Z[e], t = !0;
  else if (e === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  let n = v.rgb.exec(e);
  return n ? { r: n[1], g: n[2], b: n[3] } : (n = v.rgba.exec(e), n ? { r: n[1], g: n[2], b: n[3], a: n[4] } : (n = v.hsl.exec(e), n ? { h: n[1], s: n[2], l: n[3] } : (n = v.hsla.exec(e), n ? { h: n[1], s: n[2], l: n[3], a: n[4] } : (n = v.hsv.exec(e), n ? { h: n[1], s: n[2], v: n[3] } : (n = v.hsva.exec(e), n ? { h: n[1], s: n[2], v: n[3], a: n[4] } : (n = v.hex8.exec(e), n ? {
    r: x(n[1]),
    g: x(n[2]),
    b: x(n[3]),
    a: ut(n[4]),
    format: t ? "name" : "hex8"
  } : (n = v.hex6.exec(e), n ? {
    r: x(n[1]),
    g: x(n[2]),
    b: x(n[3]),
    format: t ? "name" : "hex"
  } : (n = v.hex4.exec(e), n ? {
    r: x(n[1] + n[1]),
    g: x(n[2] + n[2]),
    b: x(n[3] + n[3]),
    a: ut(n[4] + n[4]),
    format: t ? "name" : "hex8"
  } : (n = v.hex3.exec(e), n ? {
    r: x(n[1] + n[1]),
    g: x(n[2] + n[2]),
    b: x(n[3] + n[3]),
    format: t ? "name" : "hex"
  } : !1)))))))));
}
function A(e) {
  return !!v.CSS_UNIT.exec(String(e));
}
class h {
  constructor(t = "", n = {}) {
    if (t instanceof h)
      return t;
    typeof t == "number" && (t = Jt(t)), this.originalInput = t;
    const o = Qt(t);
    this.originalInput = t, this.r = o.r, this.g = o.g, this.b = o.b, this.a = o.a, this.roundA = Math.round(100 * this.a) / 100, this.format = n.format ?? o.format, this.gradientType = n.gradientType, this.r < 1 && (this.r = Math.round(this.r)), this.g < 1 && (this.g = Math.round(this.g)), this.b < 1 && (this.b = Math.round(this.b)), this.isValid = o.ok;
  }
  isDark() {
    return this.getBrightness() < 128;
  }
  isLight() {
    return !this.isDark();
  }
  /**
   * Returns the perceived brightness of the color, from 0-255.
   */
  getBrightness() {
    const t = this.toRgb();
    return (t.r * 299 + t.g * 587 + t.b * 114) / 1e3;
  }
  /**
   * Returns the perceived luminance of a color, from 0-1.
   */
  getLuminance() {
    const t = this.toRgb();
    let n, o, s;
    const l = t.r / 255, c = t.g / 255, p = t.b / 255;
    return l <= 0.03928 ? n = l / 12.92 : n = Math.pow((l + 0.055) / 1.055, 2.4), c <= 0.03928 ? o = c / 12.92 : o = Math.pow((c + 0.055) / 1.055, 2.4), p <= 0.03928 ? s = p / 12.92 : s = Math.pow((p + 0.055) / 1.055, 2.4), 0.2126 * n + 0.7152 * o + 0.0722 * s;
  }
  /**
   * Returns the alpha value of a color, from 0-1.
   */
  getAlpha() {
    return this.a;
  }
  /**
   * Sets the alpha value on the current color.
   *
   * @param alpha - The new alpha value. The accepted range is 0-1.
   */
  setAlpha(t) {
    return this.a = gt(t), this.roundA = Math.round(100 * this.a) / 100, this;
  }
  /**
   * Returns whether the color is monochrome.
   */
  isMonochrome() {
    const { s: t } = this.toHsl();
    return t === 0;
  }
  /**
   * Returns the object as a HSVA object.
   */
  toHsv() {
    const t = it(this.r, this.g, this.b);
    return { h: t.h * 360, s: t.s, v: t.v, a: this.a };
  }
  /**
   * Returns the hsva values interpolated into a string with the following format:
   * "hsva(xxx, xxx, xxx, xx)".
   */
  toHsvString() {
    const t = it(this.r, this.g, this.b), n = Math.round(t.h * 360), o = Math.round(t.s * 100), s = Math.round(t.v * 100);
    return this.a === 1 ? `hsv(${n}, ${o}%, ${s}%)` : `hsva(${n}, ${o}%, ${s}%, ${this.roundA})`;
  }
  /**
   * Returns the object as a HSLA object.
   */
  toHsl() {
    const t = ot(this.r, this.g, this.b);
    return { h: t.h * 360, s: t.s, l: t.l, a: this.a };
  }
  /**
   * Returns the hsla values interpolated into a string with the following format:
   * "hsla(xxx, xxx, xxx, xx)".
   */
  toHslString() {
    const t = ot(this.r, this.g, this.b), n = Math.round(t.h * 360), o = Math.round(t.s * 100), s = Math.round(t.l * 100);
    return this.a === 1 ? `hsl(${n}, ${o}%, ${s}%)` : `hsla(${n}, ${o}%, ${s}%, ${this.roundA})`;
  }
  /**
   * Returns the hex value of the color.
   * @param allow3Char will shorten hex value to 3 char if possible
   */
  toHex(t = !1) {
    return ht(this.r, this.g, this.b, t);
  }
  /**
   * Returns the hex value of the color -with a # prefixed.
   * @param allow3Char will shorten hex value to 3 char if possible
   */
  toHexString(t = !1) {
    return "#" + this.toHex(t);
  }
  /**
   * Returns the hex 8 value of the color.
   * @param allow4Char will shorten hex value to 4 char if possible
   */
  toHex8(t = !1) {
    return Xt(this.r, this.g, this.b, this.a, t);
  }
  /**
   * Returns the hex 8 value of the color -with a # prefixed.
   * @param allow4Char will shorten hex value to 4 char if possible
   */
  toHex8String(t = !1) {
    return "#" + this.toHex8(t);
  }
  /**
   * Returns the shorter hex value of the color depends on its alpha -with a # prefixed.
   * @param allowShortChar will shorten hex value to 3 or 4 char if possible
   */
  toHexShortString(t = !1) {
    return this.a === 1 ? this.toHexString(t) : this.toHex8String(t);
  }
  /**
   * Returns the object as a RGBA object.
   */
  toRgb() {
    return {
      r: Math.round(this.r),
      g: Math.round(this.g),
      b: Math.round(this.b),
      a: this.a
    };
  }
  /**
   * Returns the RGBA values interpolated into a string with the following format:
   * "RGBA(xxx, xxx, xxx, xx)".
   */
  toRgbString() {
    const t = Math.round(this.r), n = Math.round(this.g), o = Math.round(this.b);
    return this.a === 1 ? `rgb(${t}, ${n}, ${o})` : `rgba(${t}, ${n}, ${o}, ${this.roundA})`;
  }
  /**
   * Returns the object as a RGBA object.
   */
  toPercentageRgb() {
    const t = (n) => `${Math.round(g(n, 255) * 100)}%`;
    return {
      r: t(this.r),
      g: t(this.g),
      b: t(this.b),
      a: this.a
    };
  }
  /**
   * Returns the RGBA relative values interpolated into a string
   */
  toPercentageRgbString() {
    const t = (n) => Math.round(g(n, 255) * 100);
    return this.a === 1 ? `rgb(${t(this.r)}%, ${t(this.g)}%, ${t(this.b)}%)` : `rgba(${t(this.r)}%, ${t(this.g)}%, ${t(this.b)}%, ${this.roundA})`;
  }
  /**
   * The 'real' name of the color -if there is one.
   */
  toName() {
    if (this.a === 0)
      return "transparent";
    if (this.a < 1)
      return !1;
    const t = "#" + ht(this.r, this.g, this.b, !1);
    for (const [n, o] of Object.entries(Z))
      if (t === o)
        return n;
    return !1;
  }
  toString(t) {
    const n = !!t;
    t = t ?? this.format;
    let o = !1;
    const s = this.a < 1 && this.a >= 0;
    return !n && s && (t.startsWith("hex") || t === "name") ? t === "name" && this.a === 0 ? this.toName() : this.toRgbString() : (t === "rgb" && (o = this.toRgbString()), t === "prgb" && (o = this.toPercentageRgbString()), (t === "hex" || t === "hex6") && (o = this.toHexString()), t === "hex3" && (o = this.toHexString(!0)), t === "hex4" && (o = this.toHex8String(!0)), t === "hex8" && (o = this.toHex8String()), t === "name" && (o = this.toName()), t === "hsl" && (o = this.toHslString()), t === "hsv" && (o = this.toHsvString()), o || this.toHexString());
  }
  toNumber() {
    return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
  }
  clone() {
    return new h(this.toString());
  }
  /**
   * Lighten the color a given amount. Providing 100 will always return white.
   * @param amount - valid between 1-100
   */
  lighten(t = 10) {
    const n = this.toHsl();
    return n.l += t / 100, n.l = j(n.l), new h(n);
  }
  /**
   * Brighten the color a given amount, from 0 to 100.
   * @param amount - valid between 1-100
   */
  brighten(t = 10) {
    const n = this.toRgb();
    return n.r = Math.max(0, Math.min(255, n.r - Math.round(255 * -(t / 100)))), n.g = Math.max(0, Math.min(255, n.g - Math.round(255 * -(t / 100)))), n.b = Math.max(0, Math.min(255, n.b - Math.round(255 * -(t / 100)))), new h(n);
  }
  /**
   * Darken the color a given amount, from 0 to 100.
   * Providing 100 will always return black.
   * @param amount - valid between 1-100
   */
  darken(t = 10) {
    const n = this.toHsl();
    return n.l -= t / 100, n.l = j(n.l), new h(n);
  }
  /**
   * Mix the color with pure white, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return white.
   * @param amount - valid between 1-100
   */
  tint(t = 10) {
    return this.mix("white", t);
  }
  /**
   * Mix the color with pure black, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return black.
   * @param amount - valid between 1-100
   */
  shade(t = 10) {
    return this.mix("black", t);
  }
  /**
   * Desaturate the color a given amount, from 0 to 100.
   * Providing 100 will is the same as calling greyscale
   * @param amount - valid between 1-100
   */
  desaturate(t = 10) {
    const n = this.toHsl();
    return n.s -= t / 100, n.s = j(n.s), new h(n);
  }
  /**
   * Saturate the color a given amount, from 0 to 100.
   * @param amount - valid between 1-100
   */
  saturate(t = 10) {
    const n = this.toHsl();
    return n.s += t / 100, n.s = j(n.s), new h(n);
  }
  /**
   * Completely desaturates a color into greyscale.
   * Same as calling `desaturate(100)`
   */
  greyscale() {
    return this.desaturate(100);
  }
  /**
   * Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
   * Values outside of this range will be wrapped into this range.
   */
  spin(t) {
    const n = this.toHsl(), o = (n.h + t) % 360;
    return n.h = o < 0 ? 360 + o : o, new h(n);
  }
  /**
   * Mix the current color a given amount with another color, from 0 to 100.
   * 0 means no mixing (return current color).
   */
  mix(t, n = 50) {
    const o = this.toRgb(), s = new h(t).toRgb(), l = n / 100, c = {
      r: (s.r - o.r) * l + o.r,
      g: (s.g - o.g) * l + o.g,
      b: (s.b - o.b) * l + o.b,
      a: (s.a - o.a) * l + o.a
    };
    return new h(c);
  }
  analogous(t = 6, n = 30) {
    const o = this.toHsl(), s = 360 / n, l = [this];
    for (o.h = (o.h - (s * t >> 1) + 720) % 360; --t; )
      o.h = (o.h + s) % 360, l.push(new h(o));
    return l;
  }
  /**
   * taken from https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js
   */
  complement() {
    const t = this.toHsl();
    return t.h = (t.h + 180) % 360, new h(t);
  }
  monochromatic(t = 6) {
    const n = this.toHsv(), { h: o } = n, { s } = n;
    let { v: l } = n;
    const c = [], p = 1 / t;
    for (; t--; )
      c.push(new h({ h: o, s, v: l })), l = (l + p) % 1;
    return c;
  }
  splitcomplement() {
    const t = this.toHsl(), { h: n } = t;
    return [
      this,
      new h({ h: (n + 72) % 360, s: t.s, l: t.l }),
      new h({ h: (n + 216) % 360, s: t.s, l: t.l })
    ];
  }
  /**
   * Compute how the color would appear on a background
   */
  onBackground(t) {
    const n = this.toRgb(), o = new h(t).toRgb(), s = n.a + o.a * (1 - n.a);
    return new h({
      r: (n.r * n.a + o.r * o.a * (1 - n.a)) / s,
      g: (n.g * n.a + o.g * o.a * (1 - n.a)) / s,
      b: (n.b * n.a + o.b * o.a * (1 - n.a)) / s,
      a: s
    });
  }
  /**
   * Alias for `polyad(3)`
   */
  triad() {
    return this.polyad(3);
  }
  /**
   * Alias for `polyad(4)`
   */
  tetrad() {
    return this.polyad(4);
  }
  /**
   * Get polyad colors, like (for 1, 2, 3, 4, 5, 6, 7, 8, etc...)
   * monad, dyad, triad, tetrad, pentad, hexad, heptad, octad, etc...
   */
  polyad(t) {
    const n = this.toHsl(), { h: o } = n, s = [this], l = 360 / t;
    for (let c = 1; c < t; c++)
      s.push(new h({ h: (o + c * l) % 360, s: n.s, l: n.l }));
    return s;
  }
  /**
   * compare color vs current color
   */
  equals(t) {
    return this.toRgbString() === new h(t).toRgbString();
  }
}
function F(e, t) {
  return e.toString(t);
}
function lt(e, t, n) {
  return new h(e, n);
}
function re(e) {
  return qt(e) ? e : new h(e).toString();
}
const ne = (e) => {
  const { currentColor: t, format: n, onChange: o, isAlphaHidden: s } = e, [l, c] = React__default.useState(
    t.toHsv()
  ), p = (P, w) => {
    if (!nt(w))
      return;
    const R = q(360 * w / 100, 0, 359);
    c((M) => ({
      ...M,
      h: R
    }));
    const L = new h({
      ...l,
      a: t.toHsv().a,
      h: R
    });
    o == null || o(F(L, n));
  }, m = (P, w) => {
    if (!nt(w))
      return;
    const R = t.clone().setAlpha(w);
    o == null || o(F(R, n));
  }, C = ({ s: P, v: w }) => {
    const R = new h({
      h: l.h,
      a: t.toHsv().a,
      s: P,
      v: w
    });
    c((L) => ({
      ...L,
      s: P,
      v: w
    })), o == null || o(F(R, n));
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(U, { className: "MuiColorInput-PopoverBody", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Dt,
      {
        currentHue: l.h,
        hsv: l,
        onChange: C
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(U, { mt: "10px", px: "3px", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Gt,
      {
        min: 0,
        max: 100,
        step: 1,
        onChange: p,
        "aria-label": "hue",
        value: l.h * 100 / 360
      }
    ) }),
    s ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(U, { mt: "10px", px: "3px", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Nt,
      {
        min: 0,
        max: 1,
        step: 0.01,
        "aria-label": "alpha",
        rgbColor: t.toRgb(),
        onChange: m,
        value: t.getAlpha()
      }
    ) })
  ] });
}, se = React__default.forwardRef(
  (e, t) => {
    const { className: n, ...o } = e;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      TextField$1,
      {
        className: `MuiColorInput-TextField ${n || ""}`,
        ref: t,
        ...o
      }
    );
  }
), ae = "black", oe = "rgb";
function ie(e) {
  return typeof e == "object" && !Array.isArray(e) && e !== null;
}
function ft(e, t) {
  typeof t == "function" ? t(e) : t && ie(t) && "current" in t && (t.current = e);
}
const xe = React__default.forwardRef(
  (e, t) => {
    const {
      value: n,
      format: o,
      onChange: s,
      adornmentPosition: l = "start",
      PopoverProps: c,
      Adornment: p = Pt,
      fallbackValue: m,
      isAlphaHidden: C,
      disablePopover: P,
      ...w
    } = e, { onBlur: R, InputProps: L, ...M } = w, { onClose: $, ...W } = c || {}, H = m || ae, V = M.disabled || (L == null ? void 0 : L.disabled) || !1, N = React__default.useRef(null), B = React__default.useRef(null), [K, ue] = React__default.useState(null), de = o || oe, ve = lt(n, H, {
      format: de
    }), [Te, Pe] = React__default.useState(n), [Ce, Re] = React__default.useState(n), ke = (Ve) => {
      Ve.preventDefault(), Ve.stopPropagation(), !V && !P && ue(N.current);
    }, Ae = (Ve) => {
      const Oe = new h(Ve);
      s == null || s(Ve, {
        hex: Oe.isValid ? Oe.toHexString() : "",
        hsv: Oe.isValid ? Oe.toHsvString() : "",
        hsl: Oe.isValid ? Oe.toHslString() : "",
        rgb: Oe.isValid ? Oe.toRgbString() : "",
        hex8: Oe.isValid ? Oe.toHex8String() : ""
      });
    }, we = (Ve) => {
      const Oe = Ve.target.value;
      if (Pe(Oe), Oe === "")
        Re(""), Ae("");
      else {
        const Ze = new h(Oe), et = F(Ze, de);
        Re(et), Ae(et);
      }
    }, he = (...Ve) => {
      $ == null || $(...Ve), ue(null), queueMicrotask(() => {
        var Oe;
        (Oe = B.current) == null || Oe.focus();
      });
    }, be = (Ve) => {
      R == null || R(Ve);
      const Oe = new h(Te);
      if (Oe.isValid)
        Oe.format !== de && Pe(
          F(Oe, de)
        );
      else {
        if (Te === "")
          return;
        const Ze = new h(H), et = F(Ze, de);
        Pe(et), Re(et), Ae(et);
      }
    };
    React__default.useEffect(() => {
      if (n !== Ce) {
        const Ve = lt(n).originalInput;
        Re(Ve), Pe(Ve);
      }
    }, [n, Ce, H]);
    const le = (Ve) => {
      Pe(Ve), Re(Ve), Ae(Ve);
    }, fe = (Ve) => {
      N.current = Ve, t && ft(Ve, t);
    }, ye = (Ve) => {
      B.current = Ve, B && ft(Ve, B);
    }, Ee = !!K, Ie = Ee ? "color-popover" : void 0, Fe = /* @__PURE__ */ jsxRuntimeExports.jsx(Rt, { position: l, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      p,
      {
        disabled: V,
        "aria-describedby": Ie,
        disablePopover: P || !1,
        component: P ? "span" : void 0,
        bgColor: ve.toString(),
        isBgColorValid: !!(Te !== "" && ve.isValid),
        onClick: P ? void 0 : ke
      }
    ) }), De = l === "start" ? {
      startAdornment: Fe
    } : {
      endAdornment: Fe
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        se,
        {
          ref: fe,
          spellCheck: "false",
          type: "text",
          autoComplete: "off",
          onChange: we,
          value: re(Te),
          onBlur: be,
          inputRef: ye,
          disabled: V,
          InputProps: {
            ...De,
            ...L
          },
          ...M
        }
      ),
      P ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(
        Ft,
        {
          id: Ie,
          open: Ee,
          position: l,
          anchorEl: K,
          onClose: he,
          ...W,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            ne,
            {
              onChange: le,
              currentColor: ve,
              format: de,
              isAlphaHidden: C
            }
          )
        }
      )
    ] });
  }
), NCColorPicker = (e) => /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider, { theme: getTheme(e.theme || NCTheme.Platform), children: /* @__PURE__ */ jsxRuntimeExports.jsx(
  xe,
  {
    value: e.color,
    onChange: (t) => e.actionHook("#" + t),
    isAlphaHidden: e.disableAlpha,
    hiddenLabel: e.hideInput
  }
) }) }), NCCookies$1 = "";
var js_cookie = { exports: {} };
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
(function(e, t) {
  (function(n) {
    var o;
    if (e.exports = n(), o = !0, !o) {
      var s = window.Cookies, l = window.Cookies = n();
      l.noConflict = function() {
        return window.Cookies = s, l;
      };
    }
  })(function() {
    function n() {
      for (var l = 0, c = {}; l < arguments.length; l++) {
        var p = arguments[l];
        for (var m in p)
          c[m] = p[m];
      }
      return c;
    }
    function o(l) {
      return l.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function s(l) {
      function c() {
      }
      function p(C, P, w) {
        if (!(typeof document > "u")) {
          w = n({
            path: "/"
          }, c.defaults, w), typeof w.expires == "number" && (w.expires = new Date(/* @__PURE__ */ new Date() * 1 + w.expires * 864e5)), w.expires = w.expires ? w.expires.toUTCString() : "";
          try {
            var R = JSON.stringify(P);
            /^[\{\[]/.test(R) && (P = R);
          } catch {
          }
          P = l.write ? l.write(P, C) : encodeURIComponent(String(P)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), C = encodeURIComponent(String(C)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
          var L = "";
          for (var M in w)
            w[M] && (L += "; " + M, w[M] !== !0 && (L += "=" + w[M].split(";")[0]));
          return document.cookie = C + "=" + P + L;
        }
      }
      function m(C, P) {
        if (!(typeof document > "u")) {
          for (var w = {}, R = document.cookie ? document.cookie.split("; ") : [], L = 0; L < R.length; L++) {
            var M = R[L].split("="), $ = M.slice(1).join("=");
            !P && $.charAt(0) === '"' && ($ = $.slice(1, -1));
            try {
              var W = o(M[0]);
              if ($ = (l.read || l)($, W) || o($), P)
                try {
                  $ = JSON.parse($);
                } catch {
                }
              if (w[W] = $, C === W)
                break;
            } catch {
            }
          }
          return C ? w[C] : w;
        }
      }
      return c.set = p, c.get = function(C) {
        return m(
          C,
          !1
          /* read as raw */
        );
      }, c.getJSON = function(C) {
        return m(
          C,
          !0
          /* read as json */
        );
      }, c.remove = function(C, P) {
        p(C, "", n(P, {
          expires: -1
        }));
      }, c.defaults = {}, c.withConverter = s, c;
    }
    return s(function() {
    });
  });
})(js_cookie);
var js_cookieExports = js_cookie.exports;
const Cookies = /* @__PURE__ */ getDefaultExportFromCjs(js_cookieExports);
var ConditionalWrapper = function(t) {
  var n = t.condition, o = t.wrapper, s = t.children;
  return n ? o(s) : s;
};
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, _extends.apply(this, arguments);
}
function _inheritsLoose(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, _setPrototypeOf(e, t);
}
function _setPrototypeOf(e, t) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(o, s) {
    return o.__proto__ = s, o;
  }, _setPrototypeOf(e, t);
}
function _objectWithoutPropertiesLoose(e, t) {
  if (e == null)
    return {};
  var n = {}, o = Object.keys(e), s, l;
  for (l = 0; l < o.length; l++)
    s = o[l], !(t.indexOf(s) >= 0) && (n[s] = e[s]);
  return n;
}
var POSITION_OPTIONS = {
  TOP: "top",
  BOTTOM: "bottom",
  NONE: "none"
}, SAME_SITE_OPTIONS;
(function(e) {
  e.STRICT = "strict", e.LAX = "lax", e.NONE = "none";
})(SAME_SITE_OPTIONS || (SAME_SITE_OPTIONS = {}));
var VISIBILITY_OPTIONS = {
  HIDDEN: "hidden",
  SHOW: "show",
  BY_COOKIE_VALUE: "byCookieValue"
}, defaultCookieConsentName = "CookieConsent", _excluded = ["children"], DefaultButtonComponent = function(t) {
  var n = t.children, o = _objectWithoutPropertiesLoose(t, _excluded);
  return React__default.createElement("button", Object.assign({}, o), n);
}, defaultCookieConsentProps = {
  disableStyles: !1,
  hideOnAccept: !0,
  hideOnDecline: !0,
  location: POSITION_OPTIONS.BOTTOM,
  visible: VISIBILITY_OPTIONS.BY_COOKIE_VALUE,
  onAccept: function(t) {
  },
  onDecline: function() {
  },
  cookieName: defaultCookieConsentName,
  cookieValue: "true",
  declineCookieValue: "false",
  setDeclineCookie: !0,
  buttonText: "I understand",
  declineButtonText: "I decline",
  debug: !1,
  expires: 365,
  containerClasses: "CookieConsent",
  contentClasses: "",
  buttonClasses: "",
  buttonWrapperClasses: "",
  declineButtonClasses: "",
  buttonId: "rcc-confirm-button",
  declineButtonId: "rcc-decline-button",
  extraCookieOptions: {},
  disableButtonStyles: !1,
  enableDeclineButton: !1,
  flipButtons: !1,
  sameSite: SAME_SITE_OPTIONS.LAX,
  ButtonComponent: DefaultButtonComponent,
  overlay: !1,
  overlayClasses: "",
  onOverlayClick: function() {
  },
  acceptOnOverlayClick: !1,
  ariaAcceptLabel: "Accept cookies",
  ariaDeclineLabel: "Decline cookies",
  acceptOnScroll: !1,
  acceptOnScrollPercentage: 25,
  customContentAttributes: {},
  customContainerAttributes: {},
  customButtonProps: {},
  customDeclineButtonProps: {},
  customButtonWrapperAttributes: {},
  style: {},
  buttonStyle: {},
  declineButtonStyle: {},
  contentStyle: {},
  overlayStyle: {}
}, defaultState = {
  visible: !1,
  style: {
    alignItems: "baseline",
    background: "#353535",
    color: "white",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    left: "0",
    position: "fixed",
    width: "100%",
    zIndex: "999"
  },
  buttonStyle: {
    background: "#ffd42d",
    border: "0",
    borderRadius: "0px",
    boxShadow: "none",
    color: "black",
    cursor: "pointer",
    flex: "0 0 auto",
    padding: "5px 10px",
    margin: "15px"
  },
  declineButtonStyle: {
    background: "#c12a2a",
    border: "0",
    borderRadius: "0px",
    boxShadow: "none",
    color: "#e5e5e5",
    cursor: "pointer",
    flex: "0 0 auto",
    padding: "5px 10px",
    margin: "15px"
  },
  contentStyle: {
    flex: "1 0 300px",
    margin: "15px"
  },
  overlayStyle: {
    position: "fixed",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    zIndex: "999",
    backgroundColor: "rgba(0,0,0,0.3)"
  }
}, getCookieConsentValue = function(t) {
  t === void 0 && (t = defaultCookieConsentName);
  var n = Cookies.get(t);
  return n === void 0 ? Cookies.get(getLegacyCookieName(t)) : n;
}, getLegacyCookieName = function(t) {
  return t + "-legacy";
}, CookieConsent = /* @__PURE__ */ function(e) {
  _inheritsLoose(t, e);
  function t() {
    var o;
    return o = e.apply(this, arguments) || this, o.state = defaultState, o.handleScroll = function() {
      var s = _extends({}, defaultCookieConsentProps, o.props), l = s.acceptOnScrollPercentage, c = document.documentElement, p = document.body, m = "scrollTop", C = "scrollHeight", P = (c[m] || p[m]) / ((c[C] || p[C]) - c.clientHeight) * 100;
      P > l && o.accept(!0);
    }, o.removeScrollListener = function() {
      var s = o.props.acceptOnScroll;
      s && window.removeEventListener("scroll", o.handleScroll);
    }, o;
  }
  var n = t.prototype;
  return n.componentDidMount = function() {
    var s = this.props.debug;
    (this.getCookieValue() === void 0 || s) && (this.setState({
      visible: !0
    }), this.props.acceptOnScroll && window.addEventListener("scroll", this.handleScroll, {
      passive: !0
    }));
  }, n.componentWillUnmount = function() {
    this.removeScrollListener();
  }, n.accept = function(s) {
    var l;
    s === void 0 && (s = !1);
    var c = _extends({}, defaultCookieConsentProps, this.props), p = c.cookieName, m = c.cookieValue, C = c.hideOnAccept, P = c.onAccept;
    this.setCookie(p, m), P((l = s) != null ? l : !1), C && (this.setState({
      visible: !1
    }), this.removeScrollListener());
  }, n.overlayClick = function() {
    var s = _extends({}, defaultCookieConsentProps, this.props), l = s.acceptOnOverlayClick, c = s.onOverlayClick;
    l && this.accept(), c();
  }, n.decline = function() {
    var s = _extends({}, defaultCookieConsentProps, this.props), l = s.cookieName, c = s.declineCookieValue, p = s.hideOnDecline, m = s.onDecline, C = s.setDeclineCookie;
    C && this.setCookie(l, c), m(), p && this.setState({
      visible: !1
    });
  }, n.setCookie = function(s, l) {
    var c = this.props, p = c.extraCookieOptions, m = c.expires, C = c.sameSite, P = this.props.cookieSecurity;
    P === void 0 && (P = window.location ? window.location.protocol === "https:" : !0);
    var w = _extends({
      expires: m
    }, p, {
      sameSite: C,
      secure: P
    });
    C === SAME_SITE_OPTIONS.NONE && Cookies.set(getLegacyCookieName(s), l, w), Cookies.set(s, l, w);
  }, n.getCookieValue = function() {
    var s = this.props.cookieName;
    return getCookieConsentValue(s);
  }, n.render = function() {
    var s = this;
    switch (this.props.visible) {
      case VISIBILITY_OPTIONS.HIDDEN:
        return null;
      case VISIBILITY_OPTIONS.BY_COOKIE_VALUE:
        if (!this.state.visible)
          return null;
        break;
    }
    var l = this.props, c = l.location, p = l.style, m = l.buttonStyle, C = l.declineButtonStyle, P = l.contentStyle, w = l.disableStyles, R = l.buttonText, L = l.declineButtonText, M = l.containerClasses, $ = l.contentClasses, W = l.buttonClasses, H = l.buttonWrapperClasses, V = l.declineButtonClasses, N = l.buttonId, B = l.declineButtonId, K = l.disableButtonStyles, ue = l.enableDeclineButton, de = l.flipButtons, ve = l.ButtonComponent, Te = l.overlay, Pe = l.overlayClasses, Ce = l.overlayStyle, Re = l.ariaAcceptLabel, ke = l.ariaDeclineLabel, Ae = l.customContainerAttributes, we = l.customContentAttributes, he = l.customButtonProps, be = l.customDeclineButtonProps, le = l.customButtonWrapperAttributes, fe = {}, ye = {}, Ee = {}, Ie = {}, Fe = {};
    switch (w ? (fe = Object.assign({}, p), ye = Object.assign({}, m), Ee = Object.assign({}, C), Ie = Object.assign({}, P), Fe = Object.assign({}, Ce)) : (fe = Object.assign({}, _extends({}, this.state.style, p)), Ie = Object.assign({}, _extends({}, this.state.contentStyle, P)), Fe = Object.assign({}, _extends({}, this.state.overlayStyle, Ce)), K ? (ye = Object.assign({}, m), Ee = Object.assign({}, C)) : (ye = Object.assign({}, _extends({}, this.state.buttonStyle, m)), Ee = Object.assign({}, _extends({}, this.state.declineButtonStyle, C)))), c) {
      case POSITION_OPTIONS.TOP:
        fe.top = "0";
        break;
      case POSITION_OPTIONS.BOTTOM:
        fe.bottom = "0";
        break;
    }
    var De = [];
    return ue && De.push(React__default.createElement(ve, Object.assign({
      key: "declineButton",
      style: Ee,
      className: V,
      id: B,
      "aria-label": ke,
      onClick: function() {
        s.decline();
      }
    }, be), L)), De.push(React__default.createElement(ve, Object.assign({
      key: "acceptButton",
      style: ye,
      className: W,
      id: N,
      "aria-label": Re,
      onClick: function() {
        s.accept();
      }
    }, he), R)), de && De.reverse(), React__default.createElement(ConditionalWrapper, {
      condition: Te,
      wrapper: function(Oe) {
        return React__default.createElement("div", {
          style: Fe,
          className: Pe,
          onClick: function() {
            s.overlayClick();
          }
        }, Oe);
      }
    }, React__default.createElement("div", Object.assign({
      className: "" + M,
      style: fe
    }, Ae), React__default.createElement("div", Object.assign({
      style: Ie,
      className: $
    }, we), this.props.children), React__default.createElement("div", Object.assign({
      className: "" + H
    }, le), De.map(function(Ve) {
      return Ve;
    }))));
  }, t;
}(Component);
CookieConsent.defaultProps = defaultCookieConsentProps;
const NCCookies = () => {
  const e = useIntl();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CookieConsent, { buttonText: e.formatMessage({ id: "cookies.got.it" }), children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage$1, { id: "cookies.accept", description: "Accept cookies" }) });
}, NCCookiesConsent$1 = "";
/*! js-cookie v3.0.5 | MIT */
function assign(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var o in n)
      e[o] = n[o];
  }
  return e;
}
var defaultConverter = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function init(e, t) {
  function n(s, l, c) {
    if (!(typeof document > "u")) {
      c = assign({}, t, c), typeof c.expires == "number" && (c.expires = new Date(Date.now() + c.expires * 864e5)), c.expires && (c.expires = c.expires.toUTCString()), s = encodeURIComponent(s).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var p = "";
      for (var m in c)
        c[m] && (p += "; " + m, c[m] !== !0 && (p += "=" + c[m].split(";")[0]));
      return document.cookie = s + "=" + e.write(l, s) + p;
    }
  }
  function o(s) {
    if (!(typeof document > "u" || arguments.length && !s)) {
      for (var l = document.cookie ? document.cookie.split("; ") : [], c = {}, p = 0; p < l.length; p++) {
        var m = l[p].split("="), C = m.slice(1).join("=");
        try {
          var P = decodeURIComponent(m[0]);
          if (c[P] = e.read(C, P), s === P)
            break;
        } catch {
        }
      }
      return s ? c[s] : c;
    }
  }
  return Object.create(
    {
      set: n,
      get: o,
      remove: function(s, l) {
        n(
          s,
          "",
          assign({}, l, {
            expires: -1
          })
        );
      },
      withAttributes: function(s) {
        return init(this.converter, assign({}, this.attributes, s));
      },
      withConverter: function(s) {
        return init(assign({}, this.converter, s), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(t) },
      converter: { value: Object.freeze(e) }
    }
  );
}
var api = init(defaultConverter, { path: "/" });
const NCSwitch$1 = "", NCSwitch = (e) => /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider, { theme: ThemePlatform, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "nc-switch", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "input",
    {
      type: "checkbox",
      onChange: (t) => {
        e.checked = !e.checked, e.onChange(t.target.checked);
      },
      checked: e.checked ?? !1,
      disabled: e.disabled ?? !1
    }
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "slider" })
] }) }) }), NCCookiesConsent = (e) => {
  const t = useIntl(), n = [
    { label: t.formatMessage({ id: "cookies.accept.user" }), name: "user", value: "true", active: !0 },
    { label: t.formatMessage({ id: "cookies.accept.session" }), name: "session", value: "true", active: !0 }
  ], [o, s] = useState(n), l = () => o.every((R) => api.get(R.name)), [c, p] = useState(!l()), m = () => {
    p(!1);
  }, C = (R, L) => {
    api.set(R, L, { expires: 365 });
  }, P = () => {
    o.map((R) => C(R.name, R.active ? R.value : String(R.active))), m();
  }, w = () => {
    o.map((R) => C(R.name, "false")), m();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(NCDialog, { show: c, setShow: () => m(), noClose: !0, noHeader: !0, position: { bottom: 0, left: 0 }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "cookie-consent", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "header", children: /* @__PURE__ */ jsxRuntimeExports.jsx(NCTypography, { variant: "body1", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage$1, { id: "cookies.accept", description: "Accept cookies" }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "content", children: o.map((R, L) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "cookie-option", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(NCTypography, { variant: "body1", children: R.label }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        NCSwitch,
        {
          checked: R.active,
          onChange: (M) => {
            o[L].active = M, s([...o]);
          }
        }
      )
    ] }, R.name)) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "actions", style: { gridTemplateColumns: e.decline ? "auto auto" : "auto" }, children: [
      e.decline && /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { label: t.formatMessage({ id: "cookies.decline.all" }), theme: ButtonTheme.RED, setClick: () => w() }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { label: o.every((R) => R.active) ? t.formatMessage({ id: "cookies.accept.all" }) : t.formatMessage({ id: "cookies.accept.partial" }), setClick: () => P() })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "reject-cookies", children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { onClick: () => w(), children: /* @__PURE__ */ jsxRuntimeExports.jsx(NCTypography, { variant: "body1", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage$1, { id: "cookies.reject.all", description: "Reject cookies" }) }) }) })
  ] }) });
}, NCDefault = () => /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: "todo" }) }), NCFeedCard$1 = "", NCFeedCard = (e) => {
  const [t, n] = useState(), o = () => e.data.tweetId ? /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { icon: IconType.Twitter, width: 18, height: 18 }) : /* @__PURE__ */ jsxRuntimeExports.jsx("img", { className: "icon", src: e.data.icon, alt: "icon" }), s = () => /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "d-flex text-elipsis", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "logo-container d-flex justify-content-center align-items-start", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "img",
      {
        className: "logo",
        src: e.data.logo,
        alt: "logo"
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "ml-3 text-elipsis d-flex flex-column", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "d-flex", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "title text-elipsis", children: e.data.title }),
        e.data.tweetId && /* @__PURE__ */ jsxRuntimeExports.jsx(
          Icon,
          {
            styleName: "px-3",
            icon: IconType.TwitterVerified,
            height: 18,
            width: 18
          }
        )
      ] }),
      e.data.username && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "username text-elipsis", children: [
        e.data.tweetId ? "@" : "",
        e.data.username
      ] })
    ] })
  ] }) }), l = () => {
    if (e.data.tweetId)
      return /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "d-flex flex-row position-relative", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Icon,
          {
            icon: IconType.Share,
            width: 24,
            height: 22,
            onClick: () => n(!t)
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "a",
          {
            href: `https://twitter.com/intent/like?tweet_id=${e.data.tweetId}&original_referer=${window.location.href}`,
            target: "_blank",
            rel: "noreferrer",
            className: "ml-4",
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              Icon,
              {
                icon: IconType.Heart,
                width: 24,
                height: 22
              }
            )
          }
        ),
        t && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "share-menu position-absolute d-flex flex-column pl-2 pr-4 pt-2 pb-1", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage$1, { id: "feed.share.on" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "a",
            {
              href: `https://twitter.com/intent/retweet?tweet_id=${e.data.tweetId}`,
              target: "_blank",
              rel: "noreferrer",
              children: "Twitter"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "a",
            {
              href: `https://facebook.com/dialog/share?app_id=361037704438612&display=popup&href=https://twitter.com/${e.data.username}/status/${e.data.tweetId}`,
              target: "_blank",
              rel: "noreferrer",
              children: "Facebook"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "a",
            {
              href: `https://linkedin.com/shareArticle?mini=true&url=https://twitter.com/${e.data.username}/status/${e.data.tweetId}`,
              target: "_blank",
              rel: "noreferrer",
              children: "LinkedIn"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "a",
            {
              href: `https://tumblr.com/widgets/share/tool?canonicalUrl=https://twitter.com/${e.data.username}/status/${e.data.tweetId}`,
              target: "_blank",
              rel: "noreferrer",
              children: "Tumblr"
            }
          )
        ] })
      ] }) });
  }, c = () => {
    const p = hooks.utc(), m = hooks(e.data.date);
    return p.diff(m, "day") ? `${p.diff(m, "day")}d` : p.diff(m, "hour") ? `${p.diff(m, "hour")}h` : `${p.diff(m, "minute")}min`;
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `nc-feed-card d-flex flex-column ${e.smallCard ? "small" : ""}`, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "py-3 px-2 px-md-3 d-flex justify-content-between sub-part", children: [
      e.data.tweetId ? /* @__PURE__ */ jsxRuntimeExports.jsx(
        "a",
        {
          href: `https://twitter.com/${e.data.username}`,
          target: "_blank",
          rel: "noreferrer",
          className: "text-elipsis",
          children: s()
        }
      ) : s(),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "icon-container", children: o() })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { dangerouslySetInnerHTML: { __html: e.data.content } }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "d-flex justify-content-between py-3 px-2 px-md-3 sub-part", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: l() }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "date", children: c() })
    ] })
  ] });
}, NCFlagSelector$1 = "", NCFlagSelector = (e) => {
  const t = useIntl(), [n, o] = useState(e.selectedFlag || "en"), [s, l] = useState([]), [c, p] = useState(!1), m = (P, w, R) => P === R ? -1 : w === R ? 1 : 0;
  useEffect(() => {
    if (c || !e.languages.length && !s.length)
      return;
    const P = e.languages.sort((w, R) => {
      let L = 0;
      return (L = m(w.code, R.code, "en")) !== 0 || (L = m(w.code, R.code, "fr")) !== 0 ? L : w.code.localeCompare(R.code, "en", { numeric: !0 });
    });
    l(P), p(!0);
  }, [e.languages]);
  const C = (P) => {
    o(P), e.actionHook(P);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider, { theme: ThemePlatform, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flag-selector", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "lang-list", children: s.map(
      (P) => /* @__PURE__ */ jsxRuntimeExports.jsx(
        "span",
        {
          className: `flag clickable ${P.code === n ? "flag-active" : ""}`,
          onClick: () => C(P.code),
          children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: `${e.publicUrl}/lang/${P._id}/medias/ContentImage`, alt: P.name })
        },
        "flag-selector-" + P.code
      )
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("label", { children: e.label || t.formatMessage({
      id: "flag-selector.info.message"
    }) })
  ] }) }) });
}, NCInput$1 = "", NCInput = (e) => {
  const { iconType: t, styleName: n, onChange: o, onChangeV2: s, onBlur: l, iconHook: c } = e, p = useRef(null);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider, { theme: ThemePlatform, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: `d-flex w-100 position-relative ${n || ""}`,
      onClick: () => {
        var m;
        return (m = p.current) == null ? void 0 : m.focus();
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          TextField$1,
          {
            ref: e.ref,
            inputRef: p,
            id: e.id,
            name: e.name,
            autoFocus: e.autofocus,
            className: `w-100 nicecactus-input ${e.disabled ? "disabled" : ""}`,
            value: e.value,
            placeholder: e.placeHolder,
            label: e.label,
            onChange: (m) => {
              var C;
              if (e.type === "number" && ((C = e.inputProps) != null && C.min)) {
                const P = Number(m.currentTarget.value);
                if (P < Number(e.inputProps.min) || P > Number(e.inputProps.max))
                  return;
              }
              o && o(m.currentTarget.value), s && s(m.currentTarget);
            },
            type: e.type,
            disabled: e.disabled || !1,
            onBlur: () => {
              l && l();
            },
            InputProps: { inputProps: e.inputProps }
          }
        ),
        t && /* @__PURE__ */ jsxRuntimeExports.jsx(
          "div",
          {
            className: "nc-input-icon",
            style: {
              maskImage: `url(https://assets.next.wolfiesports.com/media/icons/${t}.svg)`,
              WebkitMaskImage: `url(https://assets.next.wolfiesports.com/media/icons/${t}.svg)`
            },
            onClick: () => {
              c && c();
            }
          }
        )
      ]
    }
  ) }) });
}, NCActions$1 = "", NCActions = ({ actions: e, ...t }) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "nc-action-container", ...t, children: e.map((n, o) => /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { ...n }, o)) }), NCBattleMap$1 = "", NCBattleMap = (e) => {
  const { thumbnail: t } = e;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: t ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "nc-battle-map", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(NCThumbnail, { timg: t }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(NCOverlappingTitle, { title: e.battleMapName })
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "nc-battle-no-map", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: e.battleMapName }) }) });
}, NCRoundBattle$1 = "", NCRoundBattle = (e) => {
  const { round: t } = e, o = `${useIntl().formatMessage({ id: "tournament.stepper.round" })} ${t ? ` ${t}` : ""}: ${e.title}`;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "nc-round-battle", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: o }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(NCBattleMap, { thumbnail: e.thumbnail, battleMapName: e.mapName })
  ] }) });
}, NCRound$1 = "", NCRound = (e) => {
  const { stageHeader: t, battles: n, themeColor: o } = e;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: n.length > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "nc-rounds-battle-container", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "nc-stage-header", children: t }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "nc-rounds-battle", children: n.map(({ id: s, round_map: l, round_mode: c }, p) => {
      const { image: m } = l;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        NCRoundBattle,
        {
          thumbnail: m || "",
          title: c.title,
          mapName: l.title,
          round: p + 1
        },
        `round_${s}_${p}`
      );
    }) })
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "nc-rounds-no-battle-container", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "nc-rounds-no-battle-stage-header", children: t }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "nc-rounds-no-battle-best-of", style: o ? { color: o } : {}, children: `Best of ${e.bestOfFormat}` })
  ] }) });
}, NCMapRounds = (e) => {
  const t = useIntl(), { themeColor: n, getStageHeader: o } = e;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: e.mapRounds.map((s, l) => {
    const { type: c, index: p } = s, m = o ? o(p, c) : void 0;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      NCRound,
      {
        stageHeader: m ? t.formatMessage({ id: `${m}` }, { round: p }) : "undefined",
        battles: s.rounds_battle,
        bestOfFormat: s.best_of_format,
        themeColor: n
      },
      `round_${s.id}_${l}`
    );
  }) });
};
class Media {
  constructor(t, n = !1, o = "", s = (/* @__PURE__ */ new Date()).toDateString(), l = 0, c = "") {
    this.key = t, this.file = n, this.name = o, this.modified = s, this.size = l, this.publicUrl = c;
  }
}
var FileManagerMode = /* @__PURE__ */ ((e) => (e.NORMAL = "NORMAL", e.SELECT = "SELECT", e))(FileManagerMode || {});
const _MediaLibraryService = class Ac {
  static async getMediaLibrary(t = "") {
    try {
      return (await axios$1.get(`${Ac.baseUrl}/media${t}`, {
        headers: {
          "x-access-token": Ac.token()
        }
      })).data;
    } catch (n) {
      throw n.response;
    }
  }
  static async createMedia(t, n) {
    if (!t)
      throw Error;
    try {
      return (await axios$1.post(
        `${Ac.baseUrl}/media${t}`,
        { data: n },
        {
          headers: {
            "x-access-token": Ac.token()
          }
        }
      )).data;
    } catch (o) {
      throw o.response;
    }
  }
  static async deleteMedia(t) {
    if (!t)
      return !1;
    try {
      await axios$1.delete(`${Ac.baseUrl}/media/${t}`, {
        headers: {
          "x-access-token": Ac.token()
        }
      });
    } catch {
      return !1;
    }
    return !0;
  }
};
_MediaLibraryService.baseUrl = "https://api.next.wolfiesports.com/admin";
_MediaLibraryService.token = () => localStorage.getItem("accessToken");
let MediaLibraryService = _MediaLibraryService;
const NCMediaLibrary$1 = "", NCMediaLibrary = (e) => {
  var ve;
  const t = ["image/gif", "image/jpeg", "image/png", "image/svg+xml"], [n, o] = useState(), [s, l] = useState("/"), [c, p] = useState([s]), [m, C] = useState(!1), [P, w] = useState(""), [R, L] = useState(!1), [M, $] = useState({
    header: [
      {
        thId: "name",
        thClassName: "",
        thContent: "name"
      },
      {
        thId: "size",
        thClassName: "",
        thContent: "size"
      },
      {
        thId: "uploaddate",
        thClassName: "",
        thContent: "upload date"
      }
    ],
    data: []
  });
  useEffect(() => {
    W();
  }, []);
  const W = (Te = "") => {
    MediaLibraryService.getMediaLibrary(Te).then((Pe) => {
      H(Pe);
    }).catch((Pe) => console.error(Pe));
  }, H = (Te) => {
    const Pe = Te.map((Ce) => (Ce.publicUrl = e.s3PublicUrl + Ce.publicUrl, Ce)).sort((Ce) => Ce.file ? 1 : -1);
    $({
      header: M.header,
      data: NCListTools.fillRows(Pe, (Ce, Re) => ({
        tr: {
          trData: Re,
          actionHook: V
        },
        name: {
          tdClassName: "",
          tdContent: /* @__PURE__ */ jsxRuntimeExports.jsx(NCTypography, { variant: "body1", children: Re.name })
        },
        size: {
          tdClassName: "",
          tdContent: /* @__PURE__ */ jsxRuntimeExports.jsx(NCTypography, { variant: "body1", children: Re.file ? de(Re.size) : "-" })
        },
        uploaddate: {
          tdClassName: "",
          tdContent: /* @__PURE__ */ jsxRuntimeExports.jsx(NCTypography, { variant: "body1", children: new Date(Re.modified).toLocaleString() })
        }
      }))
    });
  }, V = (Te, Pe) => {
    try {
      o(Pe);
      const Ce = `${Pe.key}`;
      l(Ce), c.push(Ce), p(c), Pe.file || W(Ce);
    } catch (Ce) {
      console.log("ouloulou", Ce);
    }
  }, N = () => {
    o(void 0), s !== "/" ? (c.pop(), l(c[c.length - 1]), W(c[c.length - 1])) : l("/");
  }, B = (Te, Pe) => {
    const Ce = `${Te}${Pe}/`;
    MediaLibraryService.createMedia(Ce, "").then(() => {
      V(0, new Media(Ce));
    });
  }, K = (Te, Pe) => {
    if (Pe && t.includes(Pe.type)) {
      const Ce = new FileReader();
      Ce.onload = (Re) => {
        var ke;
        (ke = Re == null ? void 0 : Re.target) != null && ke.result && MediaLibraryService.createMedia(`${Te}${Pe.name}`, Re.target.result.toString()).then(() => {
          W(Te);
        });
      }, Ce.readAsDataURL(Pe);
    }
  }, ue = () => {
    n && MediaLibraryService.deleteMedia(n.key).then(() => {
      n.file ? W(s) : N(), o(void 0);
    });
  }, de = (Te) => {
    const Pe = ["bytes", "kB", "MB", "GB", "TB"];
    if (Te === 0)
      return "n/a";
    const Ce = Number(Math.floor(Math.log(Te) / Math.log(1024)));
    return Ce === 0 ? Te + " " + Pe[Ce] : (Te / Math.pow(1024, Ce)).toFixed(1) + " " + Pe[Ce];
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "nc-medialibrary", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      NCActions,
      {
        style: {},
        actions: [
          {
            type: ButtonType.TEXT,
            icon: { type: IconType.Back, width: 24, height: 24 },
            label: /* @__PURE__ */ jsxRuntimeExports.jsx(NCTypography, { variant: "body1", children: s }),
            disabled: s === "/",
            setClick: () => N()
          },
          {
            type: ButtonType.TEXT,
            containerClass: "ml-auto",
            icon: { type: IconType.AddFolder, width: 24, height: 24 },
            setClick: () => {
              C(!0);
            }
          },
          {
            type: ButtonType.TEXT,
            icon: { type: IconType.Trashcan, width: 24, height: 24 },
            disabled: !n || !n.file,
            setClick: () => {
              ue();
            }
          }
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(NCDialog, { show: m, setShow: C, title: /* @__PURE__ */ jsxRuntimeExports.jsx(NCTypography, { variant: "h5", children: "Create new folder" }), children: /* @__PURE__ */ jsxRuntimeExports.jsxs(NCBox, { style: {
      gap: "1rem",
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        NCInput,
        {
          placeHolder: "folder name",
          value: P,
          onChange: (Te) => {
            w(Te);
          }
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button$1,
        {
          setClick: () => {
            B(s, P), w(""), C(!1);
          },
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(NCTypography, { children: "Create" })
        }
      )
    ] }) }),
    (M == null ? void 0 : M.header) && (M == null ? void 0 : M.data) && !(n != null && n.file) && /* @__PURE__ */ jsxRuntimeExports.jsx(
      NCDropZone,
      {
        actionHook: (Te) => {
          L(!0);
          for (const Pe of Te)
            K(c[c.length - 1], Pe);
          L(!1);
        },
        errorHook: (Te) => {
          console.log("errorHook", Te);
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(NCBox, { className: "media-scrollbar", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            NCList,
            {
              variant: "nc-list",
              type: "thead-sticky tr-filled",
              header: M.header,
              data: M.data
            }
          ),
          ((ve = M == null ? void 0 : M.data) == null ? void 0 : ve.length) === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
            NCBox,
            {
              style: {
                marginTop: "16rem",
                marginBottom: "16rem",
                textAlign: "center"
              },
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(NCTypography, { variant: "body1", className: "red-color", children: "Sorry, no items in this folder :(" })
            }
          ) : /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, {})
        ] })
      }
    ),
    (n == null ? void 0 : n.file) && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "preview-container d-flex flex-column", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "img",
        {
          src: n.publicUrl,
          alt: n.name,
          style: {
            maxHeight: "350px",
            objectFit: "contain"
          }
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(NCActions, { actions: [
        {
          label: /* @__PURE__ */ jsxRuntimeExports.jsx(NCTypography, { intlID: "media-library.action.choose", children: "Choose another" }),
          type: ButtonType.SECONDARY,
          setClick: () => N()
        },
        {
          label: "Done",
          setClick: () => {
            e.actionHook(n);
          }
        }
      ] })
    ] })
  ] });
}, NCNextSteps$1 = "", NCStep = "", NCNextSteps = ({
  steps: e,
  color: t,
  stepsFilled: n
}) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "nc-next-steps-container", children: e.map(
  (o, s) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "nc-step", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      NCStepBubble,
      {
        stepNumber: s + 1,
        color: t,
        isFilled: n
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "nc-step-description", children: o })
  ] }, `step_${s}`)
) }), NCNotificationButtons$1 = "", NCNotificationButtons = ({ buttons: e }) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "nc-notification-buttons-container", children: e.map((t, n) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  NCNotificationButton,
  {
    ...t
  },
  `notification-button-${n}`
)) }), NCTabs$1 = "", NCTabs = ({
  basename: e,
  tabs: t,
  color: n,
  variant: o,
  ...s
}) => {
  const l = (c, p) => {
    if (c.hide)
      return;
    const m = e ? c.path.replace(":tournamentId", e) : c.path;
    return console.log("NCTabs : ", m), c.children ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      NavLink,
      {
        className: ({ isActive: C }) => `${C && "nc-tab-active "}nc-tab-link nc-tab-sub${c.disabled ? " nc-tab-disabled" : ""}`,
        style: {
          color: n,
          borderColor: n
        },
        to: {
          pathname: m,
          search: location == null ? void 0 : location.search
        },
        onClick: (C) => C.preventDefault(),
        end: !0,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(NCDropdown, { name: c.name, tab: c, click: c.dropdownOnClick, children: /* @__PURE__ */ jsxRuntimeExports.jsx(NCTypography, { variant: `${o === "bo" ? "body1" : "overtitle"}`, children: c.name }) })
      },
      c.name + p
    ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
      NavLink,
      {
        className: ({ isActive: C }) => `${C && "nc-tab-active "}nc-tab-link${c.disabled ? " nc-tab-disabled" : ""}`,
        style: {
          pointerEvents: c.disabled ? "none" : "inherit"
        },
        to: {
          pathname: m,
          search: location == null ? void 0 : location.search
        },
        end: !0,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(NCTypography, { variant: `${o === "bo" ? "body1" : "overtitle"}`, children: c.name })
      },
      c.name + p
    );
  };
  return !t || t.length === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ...s, className: `nc-tabs${o === "bo" ? " tabs-bo" : ""}${s.className ? " " + s.className : ""}`, children: t.map((c, p) => l(c, p)) });
}, amaranth = "#e6224e", black = "#000000", blackLight = "#101010", blue = "#007bff", $blueCornflower = "#5f82ff", $blueLightest = "#a5c8e5", $blueBaltic = "#036e83", cyan = "#00ffd1", greenMint = "#a5ff85", electricLime = "#b2f617", green = "#55c02b", green2 = "#2aa092", green3 = "#35c053", greenDim = "#607d26", grey = "#88929b", grey1 = "#0c0c0c", grey2 = "#1a1a1a", grey3 = "#292d30", grey4 = "#323639", grey5 = "#868c88", grey6 = "#d8d8d8", greyLight = "#868c88", greyLightish = "#393e41", greyMidish = "#2e3336", greyDarkish = "#222222", greyTransparent = "#88929b40", orange = "#fd7e14", orangeVivid = "#ff8001", persimmon = "#ff5b51", red = "#ff3f34", redLightest = "#d3483a", redDarker = "#841e16", redCoral = "#ff3f45", white = "#ffffff", white1 = "#f7f7f7", white2 = "#d3d3d3", yellow = "#faff00", yellowSchool = "#ffde00", nicecactus = electricLime, primary = nicecactus, beginner = "#1fdeb0", novice = "#fff600", intermediate = "#ff7e00", advanced = "#ff0048", discordBackground = "#5865f2", discordForeground = white, twitterBackground = "#2daae1", twitterForeground = white, facebookBackground = "#3c5b9b", facebookForeground = white, instagramForeground = white, googleBackground = "#df4a32", googleForeground = white, twitchBackground = "#65469c", twitchForeground = white, appleBackground = white, appleForeground = black, NCColors = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  $blueBaltic,
  $blueCornflower,
  $blueLightest,
  advanced,
  amaranth,
  appleBackground,
  appleForeground,
  beginner,
  black,
  blackLight,
  blue,
  cyan,
  discordBackground,
  discordForeground,
  electricLime,
  facebookBackground,
  facebookForeground,
  googleBackground,
  googleForeground,
  green,
  green2,
  green3,
  greenDim,
  greenMint,
  grey,
  grey1,
  grey2,
  grey3,
  grey4,
  grey5,
  grey6,
  greyDarkish,
  greyLight,
  greyLightish,
  greyMidish,
  greyTransparent,
  instagramForeground,
  intermediate,
  nicecactus,
  novice,
  orange,
  orangeVivid,
  persimmon,
  primary,
  red,
  redCoral,
  redDarker,
  redLightest,
  twitchBackground,
  twitchForeground,
  twitterBackground,
  twitterForeground,
  white,
  white1,
  white2,
  yellow,
  yellowSchool
}, Symbol.toStringTag, { value: "Module" })), NCBubble$1 = "", NCBubble = (e) => {
  const [t, n] = useState(), { content: o, isActive: s, onClick: l } = e;
  useEffect(() => {
    n(s);
  }, [s]);
  const c = e.size ? e.size : 32, p = {
    width: `${c}px`,
    height: `${c}px`,
    borderColor: e.color ? e.color : grey5
  }, m = o.size ? o.size : 12, C = {
    color: o.color ? o.color : grey6,
    fontSize: `${m}px`
  }, P = e.activeStyle ? e.activeStyle : "default-bubble-active", w = () => {
    const R = !t;
    n(R), l && l(o.text, R);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: `nc-bubble ${l && "clickable"} ${t && P}`,
      style: p,
      onClick: w,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "nc-bubble-content", style: C, children: o.text })
    }
  );
}, dayDate = /* @__PURE__ */ new Date(), DAYS_OF_WEEK = new Array(7).fill(""), getDayOfWeek = (e, t) => (dayDate.setDate(dayDate.getDate() - (dayDate.getDay() + 6) % 7 + e), new Intl.DateTimeFormat(t, { weekday: "long" }).format(dayDate)), getDaysOfWeek = (e = "en", t = 2) => DAYS_OF_WEEK.map((n, o) => getDayOfWeek(o, e).slice(0, t)), convertToDaysOfWeek = (e, t = "en", n = 3) => e.map((o) => getDayOfWeek(o, t).slice(0, n)), NCWeeklyScheduling$1 = "", NCWeeklyScheduling = (e) => {
  const { selectedItems: t, language: n, schedulingId: o } = e, [s, l] = useState(), [c, p] = useState([]);
  return useEffect(() => {
    l(t);
  }, [t]), useEffect(() => {
    p(getDaysOfWeek(n));
  }, [n]), /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "nc-weekly-scheduling-container", children: c.map((m, C) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    NCBubble,
    {
      isActive: s == null ? void 0 : s.includes(String(C)),
      content: { text: m, size: 12 },
      onClick: e.onClick
    },
    `${o}-nc-bubble-${C}`
  )) });
}, NCMediaUpload$1 = "", NCMediaUpload = (e) => {
  const [t, n] = useState(), [o, s] = useState(), l = (H) => {
    const V = new FileReader();
    V.onload = () => {
      const N = V.result;
      N && e.actionHook("blob", N.toString());
    }, V.readAsDataURL(H);
  }, p = {
    onDrop: useCallback((H) => {
      H.forEach((V) => {
        l(V);
      });
    }, []),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onDropRejected: useCallback((H) => {
      const V = H[0].errors[0].message;
      s(`${V}`);
    }, []),
    accept: e.accept,
    minSize: e.minSize,
    maxSize: e.maxSize,
    maxFiles: 1,
    noClick: e.noClick,
    noDrag: e.noDrag,
    disabled: e.disabled
  }, {
    getRootProps: m,
    getInputProps: C,
    isDragActive: P
  } = useDropzone(p), w = `linear-gradient(rgb(36 36 36 / 70%), rgb(36 36 36 / 70%)), url("${t}"), url("${e.currentImg}"), url("${e.currentImage}"), url("${e.defaultImg}")`, R = {
    container: "media-upload-container",
    zone: "drop-zone",
    image: ""
  };
  e.zoneSize && (R.container += ` ${e.zoneSize}`), P && (R.zone += " dragable"), e.disabled && (R.zone += " disabled"), P || (R.image = w);
  const [L, M] = React__default.useState(!1), $ = (H) => {
    e.actionHook("url", H.publicUrl), e.noPreview === !1 && n(H.publicUrl), M(!1);
  }, W = () => !e.mediaLibrary || e.disabled ? {} : {
    onClick: () => {
      M(!0);
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        className: R.container,
        hidden: e.inputMode,
        children: [
          e.labelImg && /* @__PURE__ */ jsxRuntimeExports.jsx("label", { children: e.labelImg }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "div",
            {
              className: R.zone,
              ...m(),
              ...W(),
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("input", { accept: "image/*", type: "file", hidden: !0, ...C() }),
                /* @__PURE__ */ jsxRuntimeExports.jsxs(
                  "div",
                  {
                    className: "image-zone",
                    style: { backgroundImage: R.image },
                    children: [
                      /* @__PURE__ */ jsxRuntimeExports.jsx(
                        NCTypography,
                        {
                          intlID: e.intlId ?? "media-upload.info.message",
                          children: e.infoMsg
                        }
                      ),
                      /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { icon: IconType.Cloud, height: 64, width: 64 }),
                      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "error-msg", children: o })
                    ]
                  }
                )
              ]
            }
          )
        ]
      }
    ),
    e.inputMode === !0 && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ...W(), className: "w-100", children: /* @__PURE__ */ jsxRuntimeExports.jsx(NCInput, { value: t || e.currentImg || "", onChange: () => {
    }, iconType: "clip", disabled: !0 }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(NCDialog, { show: L, setShow: M, children: /* @__PURE__ */ jsxRuntimeExports.jsx(NCMediaLibrary, { s3PublicUrl: e.s3PublicUrl, actionHook: $ }) })
  ] });
}, NCInputMultiple$1 = "", NCInputMultiple = (e) => {
  const [t, n] = useState(e.list);
  useEffect(() => {
    n(e.list);
  }, [e.list]);
  const o = (s, l, c) => {
    const p = [...t];
    switch (c) {
      case 0:
        p[s].logo = l;
        break;
      case 1:
        p[s].name = l;
        break;
      case 2:
        p.splice(s, 1);
        break;
      default:
        p.push({ name: "" });
    }
    n(p), e.onChange(p);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "nc-input-multipule-text d-flex align-items-center", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `w-100 ${e.withMedia ? " row" : ""}`, children: t.map((s, l) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        className: `d-flex align-items-center ${e.withMedia ? " col-6 mb-2" : ""}`,
        children: [
          e.withMedia && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "w-50 mr-4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            NCMediaUpload,
            {
              mediaLibrary: !0,
              s3PublicUrl: "https://assets.next.wolfiesports.com",
              currentImage: s.logo || "https://assets.next.wolfiesports.com/media/default/default-team-banner.svg",
              actionHook: (c, p) => {
                c === "url" && o(
                  l,
                  p,
                  0
                  /* Media */
                );
              }
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            NCInput,
            {
              label: l === 0 ? e.label : "",
              value: s.name,
              styleName: "text-input mt-2",
              onChange: (c) => {
                o(
                  l,
                  c,
                  1
                  /* Name */
                );
              }
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Icon,
            {
              styleName: "trash-icon mt-4 ml-3",
              icon: IconType.Trashcan,
              width: 24,
              height: 24,
              onClick: () => {
                o(
                  l,
                  "",
                  2
                  /* Delete */
                );
              }
            }
          )
        ]
      },
      l
    )) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Icon,
      {
        styleName: "icon mt-4 ml-5",
        icon: IconType.Add,
        width: 24,
        height: 24,
        onClick: () => o(
          0,
          "",
          3
          /* Add */
        )
      }
    )
  ] });
}, NCLineUp$1 = "", NCLineUp = ({
  message: e,
  nextSteps: t
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "nc-line-up-text-container", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "welcome-message", children: e }) }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(NCNextSteps, { steps: t })
] }), NCLoader = () => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "d-flex align-content-center", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "spin-container m-auto", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "spin-loader" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "cactus position-absolute" })
] }) });
var lottie$1 = { exports: {} };
(function(module, exports) {
  typeof navigator < "u" && function(e, t) {
    module.exports = t();
  }(commonjsGlobal, function() {
    var svgNS = "http://www.w3.org/2000/svg", locationHref = "", _useWebWorker = !1, initialDefaultFrame = -999999, setWebWorker = function(t) {
      _useWebWorker = !!t;
    }, getWebWorker = function() {
      return _useWebWorker;
    }, setLocationHref = function(t) {
      locationHref = t;
    }, getLocationHref = function() {
      return locationHref;
    };
    function createTag(e) {
      return document.createElement(e);
    }
    function extendPrototype(e, t) {
      var n, o = e.length, s;
      for (n = 0; n < o; n += 1) {
        s = e[n].prototype;
        for (var l in s)
          Object.prototype.hasOwnProperty.call(s, l) && (t.prototype[l] = s[l]);
      }
    }
    function getDescriptor(e, t) {
      return Object.getOwnPropertyDescriptor(e, t);
    }
    function createProxyFunction(e) {
      function t() {
      }
      return t.prototype = e, t;
    }
    var audioControllerFactory = function() {
      function e(t) {
        this.audios = [], this.audioFactory = t, this._volume = 1, this._isMuted = !1;
      }
      return e.prototype = {
        addAudio: function(n) {
          this.audios.push(n);
        },
        pause: function() {
          var n, o = this.audios.length;
          for (n = 0; n < o; n += 1)
            this.audios[n].pause();
        },
        resume: function() {
          var n, o = this.audios.length;
          for (n = 0; n < o; n += 1)
            this.audios[n].resume();
        },
        setRate: function(n) {
          var o, s = this.audios.length;
          for (o = 0; o < s; o += 1)
            this.audios[o].setRate(n);
        },
        createAudio: function(n) {
          return this.audioFactory ? this.audioFactory(n) : window.Howl ? new window.Howl({
            src: [n]
          }) : {
            isPlaying: !1,
            play: function() {
              this.isPlaying = !0;
            },
            seek: function() {
              this.isPlaying = !1;
            },
            playing: function() {
            },
            rate: function() {
            },
            setVolume: function() {
            }
          };
        },
        setAudioFactory: function(n) {
          this.audioFactory = n;
        },
        setVolume: function(n) {
          this._volume = n, this._updateVolume();
        },
        mute: function() {
          this._isMuted = !0, this._updateVolume();
        },
        unmute: function() {
          this._isMuted = !1, this._updateVolume();
        },
        getVolume: function() {
          return this._volume;
        },
        _updateVolume: function() {
          var n, o = this.audios.length;
          for (n = 0; n < o; n += 1)
            this.audios[n].volume(this._volume * (this._isMuted ? 0 : 1));
        }
      }, function() {
        return new e();
      };
    }(), createTypedArray = function() {
      function e(n, o) {
        var s = 0, l = [], c;
        switch (n) {
          case "int16":
          case "uint8c":
            c = 1;
            break;
          default:
            c = 1.1;
            break;
        }
        for (s = 0; s < o; s += 1)
          l.push(c);
        return l;
      }
      function t(n, o) {
        return n === "float32" ? new Float32Array(o) : n === "int16" ? new Int16Array(o) : n === "uint8c" ? new Uint8ClampedArray(o) : e(n, o);
      }
      return typeof Uint8ClampedArray == "function" && typeof Float32Array == "function" ? t : e;
    }();
    function createSizedArray(e) {
      return Array.apply(null, {
        length: e
      });
    }
    function _typeof$6(e) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$6 = function(n) {
        return typeof n;
      } : _typeof$6 = function(n) {
        return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      }, _typeof$6(e);
    }
    var subframeEnabled = !0, expressionsPlugin = null, expressionsInterfaces = null, idPrefix$1 = "", isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), bmPow = Math.pow, bmSqrt = Math.sqrt, bmFloor = Math.floor, bmMax = Math.max, bmMin = Math.min, BMMath = {};
    (function() {
      var e = ["abs", "acos", "acosh", "asin", "asinh", "atan", "atanh", "atan2", "ceil", "cbrt", "expm1", "clz32", "cos", "cosh", "exp", "floor", "fround", "hypot", "imul", "log", "log1p", "log2", "log10", "max", "min", "pow", "random", "round", "sign", "sin", "sinh", "sqrt", "tan", "tanh", "trunc", "E", "LN10", "LN2", "LOG10E", "LOG2E", "PI", "SQRT1_2", "SQRT2"], t, n = e.length;
      for (t = 0; t < n; t += 1)
        BMMath[e[t]] = Math[e[t]];
    })(), BMMath.random = Math.random, BMMath.abs = function(e) {
      var t = _typeof$6(e);
      if (t === "object" && e.length) {
        var n = createSizedArray(e.length), o, s = e.length;
        for (o = 0; o < s; o += 1)
          n[o] = Math.abs(e[o]);
        return n;
      }
      return Math.abs(e);
    };
    var defaultCurveSegments = 150, degToRads = Math.PI / 180, roundCorner = 0.5519;
    function styleDiv(e) {
      e.style.position = "absolute", e.style.top = 0, e.style.left = 0, e.style.display = "block", e.style.transformOrigin = "0 0", e.style.webkitTransformOrigin = "0 0", e.style.backfaceVisibility = "visible", e.style.webkitBackfaceVisibility = "visible", e.style.transformStyle = "preserve-3d", e.style.webkitTransformStyle = "preserve-3d", e.style.mozTransformStyle = "preserve-3d";
    }
    function BMEnterFrameEvent(e, t, n, o) {
      this.type = e, this.currentTime = t, this.totalTime = n, this.direction = o < 0 ? -1 : 1;
    }
    function BMCompleteEvent(e, t) {
      this.type = e, this.direction = t < 0 ? -1 : 1;
    }
    function BMCompleteLoopEvent(e, t, n, o) {
      this.type = e, this.currentLoop = n, this.totalLoops = t, this.direction = o < 0 ? -1 : 1;
    }
    function BMSegmentStartEvent(e, t, n) {
      this.type = e, this.firstFrame = t, this.totalFrames = n;
    }
    function BMDestroyEvent(e, t) {
      this.type = e, this.target = t;
    }
    function BMRenderFrameErrorEvent(e, t) {
      this.type = "renderFrameError", this.nativeError = e, this.currentTime = t;
    }
    function BMConfigErrorEvent(e) {
      this.type = "configError", this.nativeError = e;
    }
    var createElementID = function() {
      var e = 0;
      return function() {
        return e += 1, idPrefix$1 + "__lottie_element_" + e;
      };
    }();
    function HSVtoRGB(e, t, n) {
      var o, s, l, c, p, m, C, P;
      switch (c = Math.floor(e * 6), p = e * 6 - c, m = n * (1 - t), C = n * (1 - p * t), P = n * (1 - (1 - p) * t), c % 6) {
        case 0:
          o = n, s = P, l = m;
          break;
        case 1:
          o = C, s = n, l = m;
          break;
        case 2:
          o = m, s = n, l = P;
          break;
        case 3:
          o = m, s = C, l = n;
          break;
        case 4:
          o = P, s = m, l = n;
          break;
        case 5:
          o = n, s = m, l = C;
          break;
      }
      return [o, s, l];
    }
    function RGBtoHSV(e, t, n) {
      var o = Math.max(e, t, n), s = Math.min(e, t, n), l = o - s, c, p = o === 0 ? 0 : l / o, m = o / 255;
      switch (o) {
        case s:
          c = 0;
          break;
        case e:
          c = t - n + l * (t < n ? 6 : 0), c /= 6 * l;
          break;
        case t:
          c = n - e + l * 2, c /= 6 * l;
          break;
        case n:
          c = e - t + l * 4, c /= 6 * l;
          break;
      }
      return [c, p, m];
    }
    function addSaturationToRGB(e, t) {
      var n = RGBtoHSV(e[0] * 255, e[1] * 255, e[2] * 255);
      return n[1] += t, n[1] > 1 ? n[1] = 1 : n[1] <= 0 && (n[1] = 0), HSVtoRGB(n[0], n[1], n[2]);
    }
    function addBrightnessToRGB(e, t) {
      var n = RGBtoHSV(e[0] * 255, e[1] * 255, e[2] * 255);
      return n[2] += t, n[2] > 1 ? n[2] = 1 : n[2] < 0 && (n[2] = 0), HSVtoRGB(n[0], n[1], n[2]);
    }
    function addHueToRGB(e, t) {
      var n = RGBtoHSV(e[0] * 255, e[1] * 255, e[2] * 255);
      return n[0] += t / 360, n[0] > 1 ? n[0] -= 1 : n[0] < 0 && (n[0] += 1), HSVtoRGB(n[0], n[1], n[2]);
    }
    var rgbToHex = function() {
      var e = [], t, n;
      for (t = 0; t < 256; t += 1)
        n = t.toString(16), e[t] = n.length === 1 ? "0" + n : n;
      return function(o, s, l) {
        return o < 0 && (o = 0), s < 0 && (s = 0), l < 0 && (l = 0), "#" + e[o] + e[s] + e[l];
      };
    }(), setSubframeEnabled = function(t) {
      subframeEnabled = !!t;
    }, getSubframeEnabled = function() {
      return subframeEnabled;
    }, setExpressionsPlugin = function(t) {
      expressionsPlugin = t;
    }, getExpressionsPlugin = function() {
      return expressionsPlugin;
    }, setExpressionInterfaces = function(t) {
      expressionsInterfaces = t;
    }, getExpressionInterfaces = function() {
      return expressionsInterfaces;
    }, setDefaultCurveSegments = function(t) {
      defaultCurveSegments = t;
    }, getDefaultCurveSegments = function() {
      return defaultCurveSegments;
    }, setIdPrefix = function(t) {
      idPrefix$1 = t;
    };
    function createNS(e) {
      return document.createElementNS(svgNS, e);
    }
    function _typeof$5(e) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$5 = function(n) {
        return typeof n;
      } : _typeof$5 = function(n) {
        return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      }, _typeof$5(e);
    }
    var dataManager = function() {
      var e = 1, t = [], n, o, s = {
        onmessage: function() {
        },
        postMessage: function(L) {
          n({
            data: L
          });
        }
      }, l = {
        postMessage: function(L) {
          s.onmessage({
            data: L
          });
        }
      };
      function c(R) {
        if (window.Worker && window.Blob && getWebWorker()) {
          var L = new Blob(["var _workerSelf = self; self.onmessage = ", R.toString()], {
            type: "text/javascript"
          }), M = URL.createObjectURL(L);
          return new Worker(M);
        }
        return n = R, s;
      }
      function p() {
        o || (o = c(function(L) {
          function M() {
            function W(we, he) {
              var be, le, fe = we.length, ye, Ee, Ie, Fe;
              for (le = 0; le < fe; le += 1)
                if (be = we[le], "ks" in be && !be.completed) {
                  if (be.completed = !0, be.hasMask) {
                    var De = be.masksProperties;
                    for (Ee = De.length, ye = 0; ye < Ee; ye += 1)
                      if (De[ye].pt.k.i)
                        K(De[ye].pt.k);
                      else
                        for (Fe = De[ye].pt.k.length, Ie = 0; Ie < Fe; Ie += 1)
                          De[ye].pt.k[Ie].s && K(De[ye].pt.k[Ie].s[0]), De[ye].pt.k[Ie].e && K(De[ye].pt.k[Ie].e[0]);
                  }
                  be.ty === 0 ? (be.layers = N(be.refId, he), W(be.layers, he)) : be.ty === 4 ? B(be.shapes) : be.ty === 5 && ke(be);
                }
            }
            function H(we, he) {
              if (we) {
                var be = 0, le = we.length;
                for (be = 0; be < le; be += 1)
                  we[be].t === 1 && (we[be].data.layers = N(we[be].data.refId, he), W(we[be].data.layers, he));
              }
            }
            function V(we, he) {
              for (var be = 0, le = he.length; be < le; ) {
                if (he[be].id === we)
                  return he[be];
                be += 1;
              }
              return null;
            }
            function N(we, he) {
              var be = V(we, he);
              return be ? be.layers.__used ? JSON.parse(JSON.stringify(be.layers)) : (be.layers.__used = !0, be.layers) : null;
            }
            function B(we) {
              var he, be = we.length, le, fe;
              for (he = be - 1; he >= 0; he -= 1)
                if (we[he].ty === "sh")
                  if (we[he].ks.k.i)
                    K(we[he].ks.k);
                  else
                    for (fe = we[he].ks.k.length, le = 0; le < fe; le += 1)
                      we[he].ks.k[le].s && K(we[he].ks.k[le].s[0]), we[he].ks.k[le].e && K(we[he].ks.k[le].e[0]);
                else
                  we[he].ty === "gr" && B(we[he].it);
            }
            function K(we) {
              var he, be = we.i.length;
              for (he = 0; he < be; he += 1)
                we.i[he][0] += we.v[he][0], we.i[he][1] += we.v[he][1], we.o[he][0] += we.v[he][0], we.o[he][1] += we.v[he][1];
            }
            function ue(we, he) {
              var be = he ? he.split(".") : [100, 100, 100];
              return we[0] > be[0] ? !0 : be[0] > we[0] ? !1 : we[1] > be[1] ? !0 : be[1] > we[1] ? !1 : we[2] > be[2] ? !0 : be[2] > we[2] ? !1 : null;
            }
            var de = function() {
              var we = [4, 4, 14];
              function he(le) {
                var fe = le.t.d;
                le.t.d = {
                  k: [{
                    s: fe,
                    t: 0
                  }]
                };
              }
              function be(le) {
                var fe, ye = le.length;
                for (fe = 0; fe < ye; fe += 1)
                  le[fe].ty === 5 && he(le[fe]);
              }
              return function(le) {
                if (ue(we, le.v) && (be(le.layers), le.assets)) {
                  var fe, ye = le.assets.length;
                  for (fe = 0; fe < ye; fe += 1)
                    le.assets[fe].layers && be(le.assets[fe].layers);
                }
              };
            }(), ve = function() {
              var we = [4, 7, 99];
              return function(he) {
                if (he.chars && !ue(we, he.v)) {
                  var be, le = he.chars.length;
                  for (be = 0; be < le; be += 1) {
                    var fe = he.chars[be];
                    fe.data && fe.data.shapes && (B(fe.data.shapes), fe.data.ip = 0, fe.data.op = 99999, fe.data.st = 0, fe.data.sr = 1, fe.data.ks = {
                      p: {
                        k: [0, 0],
                        a: 0
                      },
                      s: {
                        k: [100, 100],
                        a: 0
                      },
                      a: {
                        k: [0, 0],
                        a: 0
                      },
                      r: {
                        k: 0,
                        a: 0
                      },
                      o: {
                        k: 100,
                        a: 0
                      }
                    }, he.chars[be].t || (fe.data.shapes.push({
                      ty: "no"
                    }), fe.data.shapes[0].it.push({
                      p: {
                        k: [0, 0],
                        a: 0
                      },
                      s: {
                        k: [100, 100],
                        a: 0
                      },
                      a: {
                        k: [0, 0],
                        a: 0
                      },
                      r: {
                        k: 0,
                        a: 0
                      },
                      o: {
                        k: 100,
                        a: 0
                      },
                      sk: {
                        k: 0,
                        a: 0
                      },
                      sa: {
                        k: 0,
                        a: 0
                      },
                      ty: "tr"
                    })));
                  }
                }
              };
            }(), Te = function() {
              var we = [5, 7, 15];
              function he(le) {
                var fe = le.t.p;
                typeof fe.a == "number" && (fe.a = {
                  a: 0,
                  k: fe.a
                }), typeof fe.p == "number" && (fe.p = {
                  a: 0,
                  k: fe.p
                }), typeof fe.r == "number" && (fe.r = {
                  a: 0,
                  k: fe.r
                });
              }
              function be(le) {
                var fe, ye = le.length;
                for (fe = 0; fe < ye; fe += 1)
                  le[fe].ty === 5 && he(le[fe]);
              }
              return function(le) {
                if (ue(we, le.v) && (be(le.layers), le.assets)) {
                  var fe, ye = le.assets.length;
                  for (fe = 0; fe < ye; fe += 1)
                    le.assets[fe].layers && be(le.assets[fe].layers);
                }
              };
            }(), Pe = function() {
              var we = [4, 1, 9];
              function he(le) {
                var fe, ye = le.length, Ee, Ie;
                for (fe = 0; fe < ye; fe += 1)
                  if (le[fe].ty === "gr")
                    he(le[fe].it);
                  else if (le[fe].ty === "fl" || le[fe].ty === "st")
                    if (le[fe].c.k && le[fe].c.k[0].i)
                      for (Ie = le[fe].c.k.length, Ee = 0; Ee < Ie; Ee += 1)
                        le[fe].c.k[Ee].s && (le[fe].c.k[Ee].s[0] /= 255, le[fe].c.k[Ee].s[1] /= 255, le[fe].c.k[Ee].s[2] /= 255, le[fe].c.k[Ee].s[3] /= 255), le[fe].c.k[Ee].e && (le[fe].c.k[Ee].e[0] /= 255, le[fe].c.k[Ee].e[1] /= 255, le[fe].c.k[Ee].e[2] /= 255, le[fe].c.k[Ee].e[3] /= 255);
                    else
                      le[fe].c.k[0] /= 255, le[fe].c.k[1] /= 255, le[fe].c.k[2] /= 255, le[fe].c.k[3] /= 255;
              }
              function be(le) {
                var fe, ye = le.length;
                for (fe = 0; fe < ye; fe += 1)
                  le[fe].ty === 4 && he(le[fe].shapes);
              }
              return function(le) {
                if (ue(we, le.v) && (be(le.layers), le.assets)) {
                  var fe, ye = le.assets.length;
                  for (fe = 0; fe < ye; fe += 1)
                    le.assets[fe].layers && be(le.assets[fe].layers);
                }
              };
            }(), Ce = function() {
              var we = [4, 4, 18];
              function he(le) {
                var fe, ye = le.length, Ee, Ie;
                for (fe = ye - 1; fe >= 0; fe -= 1)
                  if (le[fe].ty === "sh")
                    if (le[fe].ks.k.i)
                      le[fe].ks.k.c = le[fe].closed;
                    else
                      for (Ie = le[fe].ks.k.length, Ee = 0; Ee < Ie; Ee += 1)
                        le[fe].ks.k[Ee].s && (le[fe].ks.k[Ee].s[0].c = le[fe].closed), le[fe].ks.k[Ee].e && (le[fe].ks.k[Ee].e[0].c = le[fe].closed);
                  else
                    le[fe].ty === "gr" && he(le[fe].it);
              }
              function be(le) {
                var fe, ye, Ee = le.length, Ie, Fe, De, Ve;
                for (ye = 0; ye < Ee; ye += 1) {
                  if (fe = le[ye], fe.hasMask) {
                    var Oe = fe.masksProperties;
                    for (Fe = Oe.length, Ie = 0; Ie < Fe; Ie += 1)
                      if (Oe[Ie].pt.k.i)
                        Oe[Ie].pt.k.c = Oe[Ie].cl;
                      else
                        for (Ve = Oe[Ie].pt.k.length, De = 0; De < Ve; De += 1)
                          Oe[Ie].pt.k[De].s && (Oe[Ie].pt.k[De].s[0].c = Oe[Ie].cl), Oe[Ie].pt.k[De].e && (Oe[Ie].pt.k[De].e[0].c = Oe[Ie].cl);
                  }
                  fe.ty === 4 && he(fe.shapes);
                }
              }
              return function(le) {
                if (ue(we, le.v) && (be(le.layers), le.assets)) {
                  var fe, ye = le.assets.length;
                  for (fe = 0; fe < ye; fe += 1)
                    le.assets[fe].layers && be(le.assets[fe].layers);
                }
              };
            }();
            function Re(we) {
              we.__complete || (Pe(we), de(we), ve(we), Te(we), Ce(we), W(we.layers, we.assets), H(we.chars, we.assets), we.__complete = !0);
            }
            function ke(we) {
              we.t.a.length === 0 && "m" in we.t.p;
            }
            var Ae = {};
            return Ae.completeData = Re, Ae.checkColors = Pe, Ae.checkChars = ve, Ae.checkPathProperties = Te, Ae.checkShapes = Ce, Ae.completeLayers = W, Ae;
          }
          if (l.dataManager || (l.dataManager = M()), l.assetLoader || (l.assetLoader = function() {
            function W(V) {
              var N = V.getResponseHeader("content-type");
              return N && V.responseType === "json" && N.indexOf("json") !== -1 || V.response && _typeof$5(V.response) === "object" ? V.response : V.response && typeof V.response == "string" ? JSON.parse(V.response) : V.responseText ? JSON.parse(V.responseText) : null;
            }
            function H(V, N, B, K) {
              var ue, de = new XMLHttpRequest();
              try {
                de.responseType = "json";
              } catch {
              }
              de.onreadystatechange = function() {
                if (de.readyState === 4)
                  if (de.status === 200)
                    ue = W(de), B(ue);
                  else
                    try {
                      ue = W(de), B(ue);
                    } catch (ve) {
                      K && K(ve);
                    }
              };
              try {
                de.open(["G", "E", "T"].join(""), V, !0);
              } catch {
                de.open(["G", "E", "T"].join(""), N + "/" + V, !0);
              }
              de.send();
            }
            return {
              load: H
            };
          }()), L.data.type === "loadAnimation")
            l.assetLoader.load(L.data.path, L.data.fullPath, function(W) {
              l.dataManager.completeData(W), l.postMessage({
                id: L.data.id,
                payload: W,
                status: "success"
              });
            }, function() {
              l.postMessage({
                id: L.data.id,
                status: "error"
              });
            });
          else if (L.data.type === "complete") {
            var $ = L.data.animation;
            l.dataManager.completeData($), l.postMessage({
              id: L.data.id,
              payload: $,
              status: "success"
            });
          } else
            L.data.type === "loadData" && l.assetLoader.load(L.data.path, L.data.fullPath, function(W) {
              l.postMessage({
                id: L.data.id,
                payload: W,
                status: "success"
              });
            }, function() {
              l.postMessage({
                id: L.data.id,
                status: "error"
              });
            });
        }), o.onmessage = function(R) {
          var L = R.data, M = L.id, $ = t[M];
          t[M] = null, L.status === "success" ? $.onComplete(L.payload) : $.onError && $.onError();
        });
      }
      function m(R, L) {
        e += 1;
        var M = "processId_" + e;
        return t[M] = {
          onComplete: R,
          onError: L
        }, M;
      }
      function C(R, L, M) {
        p();
        var $ = m(L, M);
        o.postMessage({
          type: "loadAnimation",
          path: R,
          fullPath: window.location.origin + window.location.pathname,
          id: $
        });
      }
      function P(R, L, M) {
        p();
        var $ = m(L, M);
        o.postMessage({
          type: "loadData",
          path: R,
          fullPath: window.location.origin + window.location.pathname,
          id: $
        });
      }
      function w(R, L, M) {
        p();
        var $ = m(L, M);
        o.postMessage({
          type: "complete",
          animation: R,
          id: $
        });
      }
      return {
        loadAnimation: C,
        loadData: P,
        completeAnimation: w
      };
    }(), ImagePreloader = function() {
      var e = function() {
        var H = createTag("canvas");
        H.width = 1, H.height = 1;
        var V = H.getContext("2d");
        return V.fillStyle = "rgba(0,0,0,0)", V.fillRect(0, 0, 1, 1), H;
      }();
      function t() {
        this.loadedAssets += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
      }
      function n() {
        this.loadedFootagesCount += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
      }
      function o(H, V, N) {
        var B = "";
        if (H.e)
          B = H.p;
        else if (V) {
          var K = H.p;
          K.indexOf("images/") !== -1 && (K = K.split("/")[1]), B = V + K;
        } else
          B = N, B += H.u ? H.u : "", B += H.p;
        return B;
      }
      function s(H) {
        var V = 0, N = setInterval((function() {
          var B = H.getBBox();
          (B.width || V > 500) && (this._imageLoaded(), clearInterval(N)), V += 1;
        }).bind(this), 50);
      }
      function l(H) {
        var V = o(H, this.assetsPath, this.path), N = createNS("image");
        isSafari ? this.testImageLoaded(N) : N.addEventListener("load", this._imageLoaded, !1), N.addEventListener("error", (function() {
          B.img = e, this._imageLoaded();
        }).bind(this), !1), N.setAttributeNS("http://www.w3.org/1999/xlink", "href", V), this._elementHelper.append ? this._elementHelper.append(N) : this._elementHelper.appendChild(N);
        var B = {
          img: N,
          assetData: H
        };
        return B;
      }
      function c(H) {
        var V = o(H, this.assetsPath, this.path), N = createTag("img");
        N.crossOrigin = "anonymous", N.addEventListener("load", this._imageLoaded, !1), N.addEventListener("error", (function() {
          B.img = e, this._imageLoaded();
        }).bind(this), !1), N.src = V;
        var B = {
          img: N,
          assetData: H
        };
        return B;
      }
      function p(H) {
        var V = {
          assetData: H
        }, N = o(H, this.assetsPath, this.path);
        return dataManager.loadData(N, (function(B) {
          V.img = B, this._footageLoaded();
        }).bind(this), (function() {
          V.img = {}, this._footageLoaded();
        }).bind(this)), V;
      }
      function m(H, V) {
        this.imagesLoadedCb = V;
        var N, B = H.length;
        for (N = 0; N < B; N += 1)
          H[N].layers || (!H[N].t || H[N].t === "seq" ? (this.totalImages += 1, this.images.push(this._createImageData(H[N]))) : H[N].t === 3 && (this.totalFootages += 1, this.images.push(this.createFootageData(H[N]))));
      }
      function C(H) {
        this.path = H || "";
      }
      function P(H) {
        this.assetsPath = H || "";
      }
      function w(H) {
        for (var V = 0, N = this.images.length; V < N; ) {
          if (this.images[V].assetData === H)
            return this.images[V].img;
          V += 1;
        }
        return null;
      }
      function R() {
        this.imagesLoadedCb = null, this.images.length = 0;
      }
      function L() {
        return this.totalImages === this.loadedAssets;
      }
      function M() {
        return this.totalFootages === this.loadedFootagesCount;
      }
      function $(H, V) {
        H === "svg" ? (this._elementHelper = V, this._createImageData = this.createImageData.bind(this)) : this._createImageData = this.createImgData.bind(this);
      }
      function W() {
        this._imageLoaded = t.bind(this), this._footageLoaded = n.bind(this), this.testImageLoaded = s.bind(this), this.createFootageData = p.bind(this), this.assetsPath = "", this.path = "", this.totalImages = 0, this.totalFootages = 0, this.loadedAssets = 0, this.loadedFootagesCount = 0, this.imagesLoadedCb = null, this.images = [];
      }
      return W.prototype = {
        loadAssets: m,
        setAssetsPath: P,
        setPath: C,
        loadedImages: L,
        loadedFootages: M,
        destroy: R,
        getAsset: w,
        createImgData: c,
        createImageData: l,
        imageLoaded: t,
        footageLoaded: n,
        setCacheType: $
      }, W;
    }();
    function BaseEvent() {
    }
    BaseEvent.prototype = {
      triggerEvent: function(t, n) {
        if (this._cbs[t])
          for (var o = this._cbs[t], s = 0; s < o.length; s += 1)
            o[s](n);
      },
      addEventListener: function(t, n) {
        return this._cbs[t] || (this._cbs[t] = []), this._cbs[t].push(n), (function() {
          this.removeEventListener(t, n);
        }).bind(this);
      },
      removeEventListener: function(t, n) {
        if (!n)
          this._cbs[t] = null;
        else if (this._cbs[t]) {
          for (var o = 0, s = this._cbs[t].length; o < s; )
            this._cbs[t][o] === n && (this._cbs[t].splice(o, 1), o -= 1, s -= 1), o += 1;
          this._cbs[t].length || (this._cbs[t] = null);
        }
      }
    };
    var markerParser = function() {
      function e(t) {
        for (var n = t.split(`\r
`), o = {}, s, l = 0, c = 0; c < n.length; c += 1)
          s = n[c].split(":"), s.length === 2 && (o[s[0]] = s[1].trim(), l += 1);
        if (l === 0)
          throw new Error();
        return o;
      }
      return function(t) {
        for (var n = [], o = 0; o < t.length; o += 1) {
          var s = t[o], l = {
            time: s.tm,
            duration: s.dr
          };
          try {
            l.payload = JSON.parse(t[o].cm);
          } catch {
            try {
              l.payload = e(t[o].cm);
            } catch {
              l.payload = {
                name: t[o].cm
              };
            }
          }
          n.push(l);
        }
        return n;
      };
    }(), ProjectInterface = function() {
      function e(t) {
        this.compositions.push(t);
      }
      return function() {
        function t(n) {
          for (var o = 0, s = this.compositions.length; o < s; ) {
            if (this.compositions[o].data && this.compositions[o].data.nm === n)
              return this.compositions[o].prepareFrame && this.compositions[o].data.xt && this.compositions[o].prepareFrame(this.currentFrame), this.compositions[o].compInterface;
            o += 1;
          }
          return null;
        }
        return t.compositions = [], t.currentFrame = 0, t.registerComposition = e, t;
      };
    }(), renderers = {}, registerRenderer = function(t, n) {
      renderers[t] = n;
    };
    function getRenderer(e) {
      return renderers[e];
    }
    function getRegisteredRenderer() {
      if (renderers.canvas)
        return "canvas";
      for (var e in renderers)
        if (renderers[e])
          return e;
      return "";
    }
    function _typeof$4(e) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$4 = function(n) {
        return typeof n;
      } : _typeof$4 = function(n) {
        return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      }, _typeof$4(e);
    }
    var AnimationItem = function() {
      this._cbs = [], this.name = "", this.path = "", this.isLoaded = !1, this.currentFrame = 0, this.currentRawFrame = 0, this.firstFrame = 0, this.totalFrames = 0, this.frameRate = 0, this.frameMult = 0, this.playSpeed = 1, this.playDirection = 1, this.playCount = 0, this.animationData = {}, this.assets = [], this.isPaused = !0, this.autoplay = !1, this.loop = !0, this.renderer = null, this.animationID = createElementID(), this.assetsPath = "", this.timeCompleted = 0, this.segmentPos = 0, this.isSubframeEnabled = getSubframeEnabled(), this.segments = [], this._idle = !0, this._completedLoop = !1, this.projectInterface = ProjectInterface(), this.imagePreloader = new ImagePreloader(), this.audioController = audioControllerFactory(), this.markers = [], this.configAnimation = this.configAnimation.bind(this), this.onSetupError = this.onSetupError.bind(this), this.onSegmentComplete = this.onSegmentComplete.bind(this), this.drawnFrameEvent = new BMEnterFrameEvent("drawnFrame", 0, 0, 0), this.expressionsPlugin = getExpressionsPlugin();
    };
    extendPrototype([BaseEvent], AnimationItem), AnimationItem.prototype.setParams = function(e) {
      (e.wrapper || e.container) && (this.wrapper = e.wrapper || e.container);
      var t = "svg";
      e.animType ? t = e.animType : e.renderer && (t = e.renderer);
      var n = getRenderer(t);
      this.renderer = new n(this, e.rendererSettings), this.imagePreloader.setCacheType(t, this.renderer.globalData.defs), this.renderer.setProjectInterface(this.projectInterface), this.animType = t, e.loop === "" || e.loop === null || e.loop === void 0 || e.loop === !0 ? this.loop = !0 : e.loop === !1 ? this.loop = !1 : this.loop = parseInt(e.loop, 10), this.autoplay = "autoplay" in e ? e.autoplay : !0, this.name = e.name ? e.name : "", this.autoloadSegments = Object.prototype.hasOwnProperty.call(e, "autoloadSegments") ? e.autoloadSegments : !0, this.assetsPath = e.assetsPath, this.initialSegment = e.initialSegment, e.audioFactory && this.audioController.setAudioFactory(e.audioFactory), e.animationData ? this.setupAnimation(e.animationData) : e.path && (e.path.lastIndexOf("\\") !== -1 ? this.path = e.path.substr(0, e.path.lastIndexOf("\\") + 1) : this.path = e.path.substr(0, e.path.lastIndexOf("/") + 1), this.fileName = e.path.substr(e.path.lastIndexOf("/") + 1), this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json")), dataManager.loadAnimation(e.path, this.configAnimation, this.onSetupError));
    }, AnimationItem.prototype.onSetupError = function() {
      this.trigger("data_failed");
    }, AnimationItem.prototype.setupAnimation = function(e) {
      dataManager.completeAnimation(e, this.configAnimation);
    }, AnimationItem.prototype.setData = function(e, t) {
      t && _typeof$4(t) !== "object" && (t = JSON.parse(t));
      var n = {
        wrapper: e,
        animationData: t
      }, o = e.attributes;
      n.path = o.getNamedItem("data-animation-path") ? o.getNamedItem("data-animation-path").value : o.getNamedItem("data-bm-path") ? o.getNamedItem("data-bm-path").value : o.getNamedItem("bm-path") ? o.getNamedItem("bm-path").value : "", n.animType = o.getNamedItem("data-anim-type") ? o.getNamedItem("data-anim-type").value : o.getNamedItem("data-bm-type") ? o.getNamedItem("data-bm-type").value : o.getNamedItem("bm-type") ? o.getNamedItem("bm-type").value : o.getNamedItem("data-bm-renderer") ? o.getNamedItem("data-bm-renderer").value : o.getNamedItem("bm-renderer") ? o.getNamedItem("bm-renderer").value : getRegisteredRenderer() || "canvas";
      var s = o.getNamedItem("data-anim-loop") ? o.getNamedItem("data-anim-loop").value : o.getNamedItem("data-bm-loop") ? o.getNamedItem("data-bm-loop").value : o.getNamedItem("bm-loop") ? o.getNamedItem("bm-loop").value : "";
      s === "false" ? n.loop = !1 : s === "true" ? n.loop = !0 : s !== "" && (n.loop = parseInt(s, 10));
      var l = o.getNamedItem("data-anim-autoplay") ? o.getNamedItem("data-anim-autoplay").value : o.getNamedItem("data-bm-autoplay") ? o.getNamedItem("data-bm-autoplay").value : o.getNamedItem("bm-autoplay") ? o.getNamedItem("bm-autoplay").value : !0;
      n.autoplay = l !== "false", n.name = o.getNamedItem("data-name") ? o.getNamedItem("data-name").value : o.getNamedItem("data-bm-name") ? o.getNamedItem("data-bm-name").value : o.getNamedItem("bm-name") ? o.getNamedItem("bm-name").value : "";
      var c = o.getNamedItem("data-anim-prerender") ? o.getNamedItem("data-anim-prerender").value : o.getNamedItem("data-bm-prerender") ? o.getNamedItem("data-bm-prerender").value : o.getNamedItem("bm-prerender") ? o.getNamedItem("bm-prerender").value : "";
      c === "false" && (n.prerender = !1), n.path ? this.setParams(n) : this.trigger("destroy");
    }, AnimationItem.prototype.includeLayers = function(e) {
      e.op > this.animationData.op && (this.animationData.op = e.op, this.totalFrames = Math.floor(e.op - this.animationData.ip));
      var t = this.animationData.layers, n, o = t.length, s = e.layers, l, c = s.length;
      for (l = 0; l < c; l += 1)
        for (n = 0; n < o; ) {
          if (t[n].id === s[l].id) {
            t[n] = s[l];
            break;
          }
          n += 1;
        }
      if ((e.chars || e.fonts) && (this.renderer.globalData.fontManager.addChars(e.chars), this.renderer.globalData.fontManager.addFonts(e.fonts, this.renderer.globalData.defs)), e.assets)
        for (o = e.assets.length, n = 0; n < o; n += 1)
          this.animationData.assets.push(e.assets[n]);
      this.animationData.__complete = !1, dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
    }, AnimationItem.prototype.onSegmentComplete = function(e) {
      this.animationData = e;
      var t = getExpressionsPlugin();
      t && t.initExpressions(this), this.loadNextSegment();
    }, AnimationItem.prototype.loadNextSegment = function() {
      var e = this.animationData.segments;
      if (!e || e.length === 0 || !this.autoloadSegments) {
        this.trigger("data_ready"), this.timeCompleted = this.totalFrames;
        return;
      }
      var t = e.shift();
      this.timeCompleted = t.time * this.frameRate;
      var n = this.path + this.fileName + "_" + this.segmentPos + ".json";
      this.segmentPos += 1, dataManager.loadData(n, this.includeLayers.bind(this), (function() {
        this.trigger("data_failed");
      }).bind(this));
    }, AnimationItem.prototype.loadSegments = function() {
      var e = this.animationData.segments;
      e || (this.timeCompleted = this.totalFrames), this.loadNextSegment();
    }, AnimationItem.prototype.imagesLoaded = function() {
      this.trigger("loaded_images"), this.checkLoaded();
    }, AnimationItem.prototype.preloadImages = function() {
      this.imagePreloader.setAssetsPath(this.assetsPath), this.imagePreloader.setPath(this.path), this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
    }, AnimationItem.prototype.configAnimation = function(e) {
      if (this.renderer)
        try {
          this.animationData = e, this.initialSegment ? (this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]), this.firstFrame = Math.round(this.initialSegment[0])) : (this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip), this.firstFrame = Math.round(this.animationData.ip)), this.renderer.configAnimation(e), e.assets || (e.assets = []), this.assets = this.animationData.assets, this.frameRate = this.animationData.fr, this.frameMult = this.animationData.fr / 1e3, this.renderer.searchExtraCompositions(e.assets), this.markers = markerParser(e.markers || []), this.trigger("config_ready"), this.preloadImages(), this.loadSegments(), this.updaFrameModifier(), this.waitForFontsLoaded(), this.isPaused && this.audioController.pause();
        } catch (t) {
          this.triggerConfigError(t);
        }
    }, AnimationItem.prototype.waitForFontsLoaded = function() {
      this.renderer && (this.renderer.globalData.fontManager.isLoaded ? this.checkLoaded() : setTimeout(this.waitForFontsLoaded.bind(this), 20));
    }, AnimationItem.prototype.checkLoaded = function() {
      if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== "canvas") && this.imagePreloader.loadedFootages()) {
        this.isLoaded = !0;
        var e = getExpressionsPlugin();
        e && e.initExpressions(this), this.renderer.initItems(), setTimeout((function() {
          this.trigger("DOMLoaded");
        }).bind(this), 0), this.gotoFrame(), this.autoplay && this.play();
      }
    }, AnimationItem.prototype.resize = function(e, t) {
      var n = typeof e == "number" ? e : void 0, o = typeof t == "number" ? t : void 0;
      this.renderer.updateContainerSize(n, o);
    }, AnimationItem.prototype.setSubframe = function(e) {
      this.isSubframeEnabled = !!e;
    }, AnimationItem.prototype.gotoFrame = function() {
      this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame, this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted && (this.currentFrame = this.timeCompleted), this.trigger("enterFrame"), this.renderFrame(), this.trigger("drawnFrame");
    }, AnimationItem.prototype.renderFrame = function() {
      if (!(this.isLoaded === !1 || !this.renderer))
        try {
          this.expressionsPlugin && this.expressionsPlugin.resetFrame(), this.renderer.renderFrame(this.currentFrame + this.firstFrame);
        } catch (e) {
          this.triggerRenderFrameError(e);
        }
    }, AnimationItem.prototype.play = function(e) {
      e && this.name !== e || this.isPaused === !0 && (this.isPaused = !1, this.trigger("_play"), this.audioController.resume(), this._idle && (this._idle = !1, this.trigger("_active")));
    }, AnimationItem.prototype.pause = function(e) {
      e && this.name !== e || this.isPaused === !1 && (this.isPaused = !0, this.trigger("_pause"), this._idle = !0, this.trigger("_idle"), this.audioController.pause());
    }, AnimationItem.prototype.togglePause = function(e) {
      e && this.name !== e || (this.isPaused === !0 ? this.play() : this.pause());
    }, AnimationItem.prototype.stop = function(e) {
      e && this.name !== e || (this.pause(), this.playCount = 0, this._completedLoop = !1, this.setCurrentRawFrameValue(0));
    }, AnimationItem.prototype.getMarkerData = function(e) {
      for (var t, n = 0; n < this.markers.length; n += 1)
        if (t = this.markers[n], t.payload && t.payload.name === e)
          return t;
      return null;
    }, AnimationItem.prototype.goToAndStop = function(e, t, n) {
      if (!(n && this.name !== n)) {
        var o = Number(e);
        if (isNaN(o)) {
          var s = this.getMarkerData(e);
          s && this.goToAndStop(s.time, !0);
        } else
          t ? this.setCurrentRawFrameValue(e) : this.setCurrentRawFrameValue(e * this.frameModifier);
        this.pause();
      }
    }, AnimationItem.prototype.goToAndPlay = function(e, t, n) {
      if (!(n && this.name !== n)) {
        var o = Number(e);
        if (isNaN(o)) {
          var s = this.getMarkerData(e);
          s && (s.duration ? this.playSegments([s.time, s.time + s.duration], !0) : this.goToAndStop(s.time, !0));
        } else
          this.goToAndStop(o, t, n);
        this.play();
      }
    }, AnimationItem.prototype.advanceTime = function(e) {
      if (!(this.isPaused === !0 || this.isLoaded === !1)) {
        var t = this.currentRawFrame + e * this.frameModifier, n = !1;
        t >= this.totalFrames - 1 && this.frameModifier > 0 ? !this.loop || this.playCount === this.loop ? this.checkSegments(t > this.totalFrames ? t % this.totalFrames : 0) || (n = !0, t = this.totalFrames - 1) : t >= this.totalFrames ? (this.playCount += 1, this.checkSegments(t % this.totalFrames) || (this.setCurrentRawFrameValue(t % this.totalFrames), this._completedLoop = !0, this.trigger("loopComplete"))) : this.setCurrentRawFrameValue(t) : t < 0 ? this.checkSegments(t % this.totalFrames) || (this.loop && !(this.playCount-- <= 0 && this.loop !== !0) ? (this.setCurrentRawFrameValue(this.totalFrames + t % this.totalFrames), this._completedLoop ? this.trigger("loopComplete") : this._completedLoop = !0) : (n = !0, t = 0)) : this.setCurrentRawFrameValue(t), n && (this.setCurrentRawFrameValue(t), this.pause(), this.trigger("complete"));
      }
    }, AnimationItem.prototype.adjustSegment = function(e, t) {
      this.playCount = 0, e[1] < e[0] ? (this.frameModifier > 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(-1)), this.totalFrames = e[0] - e[1], this.timeCompleted = this.totalFrames, this.firstFrame = e[1], this.setCurrentRawFrameValue(this.totalFrames - 1e-3 - t)) : e[1] > e[0] && (this.frameModifier < 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(1)), this.totalFrames = e[1] - e[0], this.timeCompleted = this.totalFrames, this.firstFrame = e[0], this.setCurrentRawFrameValue(1e-3 + t)), this.trigger("segmentStart");
    }, AnimationItem.prototype.setSegment = function(e, t) {
      var n = -1;
      this.isPaused && (this.currentRawFrame + this.firstFrame < e ? n = e : this.currentRawFrame + this.firstFrame > t && (n = t - e)), this.firstFrame = e, this.totalFrames = t - e, this.timeCompleted = this.totalFrames, n !== -1 && this.goToAndStop(n, !0);
    }, AnimationItem.prototype.playSegments = function(e, t) {
      if (t && (this.segments.length = 0), _typeof$4(e[0]) === "object") {
        var n, o = e.length;
        for (n = 0; n < o; n += 1)
          this.segments.push(e[n]);
      } else
        this.segments.push(e);
      this.segments.length && t && this.adjustSegment(this.segments.shift(), 0), this.isPaused && this.play();
    }, AnimationItem.prototype.resetSegments = function(e) {
      this.segments.length = 0, this.segments.push([this.animationData.ip, this.animationData.op]), e && this.checkSegments(0);
    }, AnimationItem.prototype.checkSegments = function(e) {
      return this.segments.length ? (this.adjustSegment(this.segments.shift(), e), !0) : !1;
    }, AnimationItem.prototype.destroy = function(e) {
      e && this.name !== e || !this.renderer || (this.renderer.destroy(), this.imagePreloader.destroy(), this.trigger("destroy"), this._cbs = null, this.onEnterFrame = null, this.onLoopComplete = null, this.onComplete = null, this.onSegmentStart = null, this.onDestroy = null, this.renderer = null, this.expressionsPlugin = null, this.imagePreloader = null, this.projectInterface = null);
    }, AnimationItem.prototype.setCurrentRawFrameValue = function(e) {
      this.currentRawFrame = e, this.gotoFrame();
    }, AnimationItem.prototype.setSpeed = function(e) {
      this.playSpeed = e, this.updaFrameModifier();
    }, AnimationItem.prototype.setDirection = function(e) {
      this.playDirection = e < 0 ? -1 : 1, this.updaFrameModifier();
    }, AnimationItem.prototype.setLoop = function(e) {
      this.loop = e;
    }, AnimationItem.prototype.setVolume = function(e, t) {
      t && this.name !== t || this.audioController.setVolume(e);
    }, AnimationItem.prototype.getVolume = function() {
      return this.audioController.getVolume();
    }, AnimationItem.prototype.mute = function(e) {
      e && this.name !== e || this.audioController.mute();
    }, AnimationItem.prototype.unmute = function(e) {
      e && this.name !== e || this.audioController.unmute();
    }, AnimationItem.prototype.updaFrameModifier = function() {
      this.frameModifier = this.frameMult * this.playSpeed * this.playDirection, this.audioController.setRate(this.playSpeed * this.playDirection);
    }, AnimationItem.prototype.getPath = function() {
      return this.path;
    }, AnimationItem.prototype.getAssetsPath = function(e) {
      var t = "";
      if (e.e)
        t = e.p;
      else if (this.assetsPath) {
        var n = e.p;
        n.indexOf("images/") !== -1 && (n = n.split("/")[1]), t = this.assetsPath + n;
      } else
        t = this.path, t += e.u ? e.u : "", t += e.p;
      return t;
    }, AnimationItem.prototype.getAssetData = function(e) {
      for (var t = 0, n = this.assets.length; t < n; ) {
        if (e === this.assets[t].id)
          return this.assets[t];
        t += 1;
      }
      return null;
    }, AnimationItem.prototype.hide = function() {
      this.renderer.hide();
    }, AnimationItem.prototype.show = function() {
      this.renderer.show();
    }, AnimationItem.prototype.getDuration = function(e) {
      return e ? this.totalFrames : this.totalFrames / this.frameRate;
    }, AnimationItem.prototype.updateDocumentData = function(e, t, n) {
      try {
        var o = this.renderer.getElementByPath(e);
        o.updateDocumentData(t, n);
      } catch {
      }
    }, AnimationItem.prototype.trigger = function(e) {
      if (this._cbs && this._cbs[e])
        switch (e) {
          case "enterFrame":
            this.triggerEvent(e, new BMEnterFrameEvent(e, this.currentFrame, this.totalFrames, this.frameModifier));
            break;
          case "drawnFrame":
            this.drawnFrameEvent.currentTime = this.currentFrame, this.drawnFrameEvent.totalTime = this.totalFrames, this.drawnFrameEvent.direction = this.frameModifier, this.triggerEvent(e, this.drawnFrameEvent);
            break;
          case "loopComplete":
            this.triggerEvent(e, new BMCompleteLoopEvent(e, this.loop, this.playCount, this.frameMult));
            break;
          case "complete":
            this.triggerEvent(e, new BMCompleteEvent(e, this.frameMult));
            break;
          case "segmentStart":
            this.triggerEvent(e, new BMSegmentStartEvent(e, this.firstFrame, this.totalFrames));
            break;
          case "destroy":
            this.triggerEvent(e, new BMDestroyEvent(e, this));
            break;
          default:
            this.triggerEvent(e);
        }
      e === "enterFrame" && this.onEnterFrame && this.onEnterFrame.call(this, new BMEnterFrameEvent(e, this.currentFrame, this.totalFrames, this.frameMult)), e === "loopComplete" && this.onLoopComplete && this.onLoopComplete.call(this, new BMCompleteLoopEvent(e, this.loop, this.playCount, this.frameMult)), e === "complete" && this.onComplete && this.onComplete.call(this, new BMCompleteEvent(e, this.frameMult)), e === "segmentStart" && this.onSegmentStart && this.onSegmentStart.call(this, new BMSegmentStartEvent(e, this.firstFrame, this.totalFrames)), e === "destroy" && this.onDestroy && this.onDestroy.call(this, new BMDestroyEvent(e, this));
    }, AnimationItem.prototype.triggerRenderFrameError = function(e) {
      var t = new BMRenderFrameErrorEvent(e, this.currentFrame);
      this.triggerEvent("error", t), this.onError && this.onError.call(this, t);
    }, AnimationItem.prototype.triggerConfigError = function(e) {
      var t = new BMConfigErrorEvent(e, this.currentFrame);
      this.triggerEvent("error", t), this.onError && this.onError.call(this, t);
    };
    var animationManager = function() {
      var e = {}, t = [], n = 0, o = 0, s = 0, l = !0, c = !1;
      function p(he) {
        for (var be = 0, le = he.target; be < o; )
          t[be].animation === le && (t.splice(be, 1), be -= 1, o -= 1, le.isPaused || w()), be += 1;
      }
      function m(he, be) {
        if (!he)
          return null;
        for (var le = 0; le < o; ) {
          if (t[le].elem === he && t[le].elem !== null)
            return t[le].animation;
          le += 1;
        }
        var fe = new AnimationItem();
        return R(fe, he), fe.setData(he, be), fe;
      }
      function C() {
        var he, be = t.length, le = [];
        for (he = 0; he < be; he += 1)
          le.push(t[he].animation);
        return le;
      }
      function P() {
        s += 1, Pe();
      }
      function w() {
        s -= 1;
      }
      function R(he, be) {
        he.addEventListener("destroy", p), he.addEventListener("_active", P), he.addEventListener("_idle", w), t.push({
          elem: be,
          animation: he
        }), o += 1;
      }
      function L(he) {
        var be = new AnimationItem();
        return R(be, null), be.setParams(he), be;
      }
      function M(he, be) {
        var le;
        for (le = 0; le < o; le += 1)
          t[le].animation.setSpeed(he, be);
      }
      function $(he, be) {
        var le;
        for (le = 0; le < o; le += 1)
          t[le].animation.setDirection(he, be);
      }
      function W(he) {
        var be;
        for (be = 0; be < o; be += 1)
          t[be].animation.play(he);
      }
      function H(he) {
        var be = he - n, le;
        for (le = 0; le < o; le += 1)
          t[le].animation.advanceTime(be);
        n = he, s && !c ? window.requestAnimationFrame(H) : l = !0;
      }
      function V(he) {
        n = he, window.requestAnimationFrame(H);
      }
      function N(he) {
        var be;
        for (be = 0; be < o; be += 1)
          t[be].animation.pause(he);
      }
      function B(he, be, le) {
        var fe;
        for (fe = 0; fe < o; fe += 1)
          t[fe].animation.goToAndStop(he, be, le);
      }
      function K(he) {
        var be;
        for (be = 0; be < o; be += 1)
          t[be].animation.stop(he);
      }
      function ue(he) {
        var be;
        for (be = 0; be < o; be += 1)
          t[be].animation.togglePause(he);
      }
      function de(he) {
        var be;
        for (be = o - 1; be >= 0; be -= 1)
          t[be].animation.destroy(he);
      }
      function ve(he, be, le) {
        var fe = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin"))), ye, Ee = fe.length;
        for (ye = 0; ye < Ee; ye += 1)
          le && fe[ye].setAttribute("data-bm-type", le), m(fe[ye], he);
        if (be && Ee === 0) {
          le || (le = "svg");
          var Ie = document.getElementsByTagName("body")[0];
          Ie.innerText = "";
          var Fe = createTag("div");
          Fe.style.width = "100%", Fe.style.height = "100%", Fe.setAttribute("data-bm-type", le), Ie.appendChild(Fe), m(Fe, he);
        }
      }
      function Te() {
        var he;
        for (he = 0; he < o; he += 1)
          t[he].animation.resize();
      }
      function Pe() {
        !c && s && l && (window.requestAnimationFrame(V), l = !1);
      }
      function Ce() {
        c = !0;
      }
      function Re() {
        c = !1, Pe();
      }
      function ke(he, be) {
        var le;
        for (le = 0; le < o; le += 1)
          t[le].animation.setVolume(he, be);
      }
      function Ae(he) {
        var be;
        for (be = 0; be < o; be += 1)
          t[be].animation.mute(he);
      }
      function we(he) {
        var be;
        for (be = 0; be < o; be += 1)
          t[be].animation.unmute(he);
      }
      return e.registerAnimation = m, e.loadAnimation = L, e.setSpeed = M, e.setDirection = $, e.play = W, e.pause = N, e.stop = K, e.togglePause = ue, e.searchAnimations = ve, e.resize = Te, e.goToAndStop = B, e.destroy = de, e.freeze = Ce, e.unfreeze = Re, e.setVolume = ke, e.mute = Ae, e.unmute = we, e.getRegisteredAnimations = C, e;
    }(), BezierFactory = function() {
      var e = {};
      e.getBezierEasing = n;
      var t = {};
      function n(V, N, B, K, ue) {
        var de = ue || ("bez_" + V + "_" + N + "_" + B + "_" + K).replace(/\./g, "p");
        if (t[de])
          return t[de];
        var ve = new H([V, N, B, K]);
        return t[de] = ve, ve;
      }
      var o = 4, s = 1e-3, l = 1e-7, c = 10, p = 11, m = 1 / (p - 1), C = typeof Float32Array == "function";
      function P(V, N) {
        return 1 - 3 * N + 3 * V;
      }
      function w(V, N) {
        return 3 * N - 6 * V;
      }
      function R(V) {
        return 3 * V;
      }
      function L(V, N, B) {
        return ((P(N, B) * V + w(N, B)) * V + R(N)) * V;
      }
      function M(V, N, B) {
        return 3 * P(N, B) * V * V + 2 * w(N, B) * V + R(N);
      }
      function $(V, N, B, K, ue) {
        var de, ve, Te = 0;
        do
          ve = N + (B - N) / 2, de = L(ve, K, ue) - V, de > 0 ? B = ve : N = ve;
        while (Math.abs(de) > l && ++Te < c);
        return ve;
      }
      function W(V, N, B, K) {
        for (var ue = 0; ue < o; ++ue) {
          var de = M(N, B, K);
          if (de === 0)
            return N;
          var ve = L(N, B, K) - V;
          N -= ve / de;
        }
        return N;
      }
      function H(V) {
        this._p = V, this._mSampleValues = C ? new Float32Array(p) : new Array(p), this._precomputed = !1, this.get = this.get.bind(this);
      }
      return H.prototype = {
        get: function(N) {
          var B = this._p[0], K = this._p[1], ue = this._p[2], de = this._p[3];
          return this._precomputed || this._precompute(), B === K && ue === de ? N : N === 0 ? 0 : N === 1 ? 1 : L(this._getTForX(N), K, de);
        },
        // Private part
        _precompute: function() {
          var N = this._p[0], B = this._p[1], K = this._p[2], ue = this._p[3];
          this._precomputed = !0, (N !== B || K !== ue) && this._calcSampleValues();
        },
        _calcSampleValues: function() {
          for (var N = this._p[0], B = this._p[2], K = 0; K < p; ++K)
            this._mSampleValues[K] = L(K * m, N, B);
        },
        /**
             * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
             */
        _getTForX: function(N) {
          for (var B = this._p[0], K = this._p[2], ue = this._mSampleValues, de = 0, ve = 1, Te = p - 1; ve !== Te && ue[ve] <= N; ++ve)
            de += m;
          --ve;
          var Pe = (N - ue[ve]) / (ue[ve + 1] - ue[ve]), Ce = de + Pe * m, Re = M(Ce, B, K);
          return Re >= s ? W(N, Ce, B, K) : Re === 0 ? Ce : $(N, de, de + m, B, K);
        }
      }, e;
    }(), pooling = function() {
      function e(t) {
        return t.concat(createSizedArray(t.length));
      }
      return {
        double: e
      };
    }(), poolFactory = function() {
      return function(e, t, n) {
        var o = 0, s = e, l = createSizedArray(s), c = {
          newElement: p,
          release: m
        };
        function p() {
          var C;
          return o ? (o -= 1, C = l[o]) : C = t(), C;
        }
        function m(C) {
          o === s && (l = pooling.double(l), s *= 2), n && n(C), l[o] = C, o += 1;
        }
        return c;
      };
    }(), bezierLengthPool = function() {
      function e() {
        return {
          addedLength: 0,
          percents: createTypedArray("float32", getDefaultCurveSegments()),
          lengths: createTypedArray("float32", getDefaultCurveSegments())
        };
      }
      return poolFactory(8, e);
    }(), segmentsLengthPool = function() {
      function e() {
        return {
          lengths: [],
          totalLength: 0
        };
      }
      function t(n) {
        var o, s = n.lengths.length;
        for (o = 0; o < s; o += 1)
          bezierLengthPool.release(n.lengths[o]);
        n.lengths.length = 0;
      }
      return poolFactory(8, e, t);
    }();
    function bezFunction() {
      var e = Math;
      function t(R, L, M, $, W, H) {
        var V = R * $ + L * W + M * H - W * $ - H * R - M * L;
        return V > -1e-3 && V < 1e-3;
      }
      function n(R, L, M, $, W, H, V, N, B) {
        if (M === 0 && H === 0 && B === 0)
          return t(R, L, $, W, V, N);
        var K = e.sqrt(e.pow($ - R, 2) + e.pow(W - L, 2) + e.pow(H - M, 2)), ue = e.sqrt(e.pow(V - R, 2) + e.pow(N - L, 2) + e.pow(B - M, 2)), de = e.sqrt(e.pow(V - $, 2) + e.pow(N - W, 2) + e.pow(B - H, 2)), ve;
        return K > ue ? K > de ? ve = K - ue - de : ve = de - ue - K : de > ue ? ve = de - ue - K : ve = ue - K - de, ve > -1e-4 && ve < 1e-4;
      }
      var o = function() {
        return function(R, L, M, $) {
          var W = getDefaultCurveSegments(), H, V, N, B, K, ue = 0, de, ve = [], Te = [], Pe = bezierLengthPool.newElement();
          for (N = M.length, H = 0; H < W; H += 1) {
            for (K = H / (W - 1), de = 0, V = 0; V < N; V += 1)
              B = bmPow(1 - K, 3) * R[V] + 3 * bmPow(1 - K, 2) * K * M[V] + 3 * (1 - K) * bmPow(K, 2) * $[V] + bmPow(K, 3) * L[V], ve[V] = B, Te[V] !== null && (de += bmPow(ve[V] - Te[V], 2)), Te[V] = ve[V];
            de && (de = bmSqrt(de), ue += de), Pe.percents[H] = K, Pe.lengths[H] = ue;
          }
          return Pe.addedLength = ue, Pe;
        };
      }();
      function s(R) {
        var L = segmentsLengthPool.newElement(), M = R.c, $ = R.v, W = R.o, H = R.i, V, N = R._length, B = L.lengths, K = 0;
        for (V = 0; V < N - 1; V += 1)
          B[V] = o($[V], $[V + 1], W[V], H[V + 1]), K += B[V].addedLength;
        return M && N && (B[V] = o($[V], $[0], W[V], H[0]), K += B[V].addedLength), L.totalLength = K, L;
      }
      function l(R) {
        this.segmentLength = 0, this.points = new Array(R);
      }
      function c(R, L) {
        this.partialLength = R, this.point = L;
      }
      var p = function() {
        var R = {};
        return function(L, M, $, W) {
          var H = (L[0] + "_" + L[1] + "_" + M[0] + "_" + M[1] + "_" + $[0] + "_" + $[1] + "_" + W[0] + "_" + W[1]).replace(/\./g, "p");
          if (!R[H]) {
            var V = getDefaultCurveSegments(), N, B, K, ue, de, ve = 0, Te, Pe, Ce = null;
            L.length === 2 && (L[0] !== M[0] || L[1] !== M[1]) && t(L[0], L[1], M[0], M[1], L[0] + $[0], L[1] + $[1]) && t(L[0], L[1], M[0], M[1], M[0] + W[0], M[1] + W[1]) && (V = 2);
            var Re = new l(V);
            for (K = $.length, N = 0; N < V; N += 1) {
              for (Pe = createSizedArray(K), de = N / (V - 1), Te = 0, B = 0; B < K; B += 1)
                ue = bmPow(1 - de, 3) * L[B] + 3 * bmPow(1 - de, 2) * de * (L[B] + $[B]) + 3 * (1 - de) * bmPow(de, 2) * (M[B] + W[B]) + bmPow(de, 3) * M[B], Pe[B] = ue, Ce !== null && (Te += bmPow(Pe[B] - Ce[B], 2));
              Te = bmSqrt(Te), ve += Te, Re.points[N] = new c(Te, Pe), Ce = Pe;
            }
            Re.segmentLength = ve, R[H] = Re;
          }
          return R[H];
        };
      }();
      function m(R, L) {
        var M = L.percents, $ = L.lengths, W = M.length, H = bmFloor((W - 1) * R), V = R * L.addedLength, N = 0;
        if (H === W - 1 || H === 0 || V === $[H])
          return M[H];
        for (var B = $[H] > V ? -1 : 1, K = !0; K; )
          if ($[H] <= V && $[H + 1] > V ? (N = (V - $[H]) / ($[H + 1] - $[H]), K = !1) : H += B, H < 0 || H >= W - 1) {
            if (H === W - 1)
              return M[H];
            K = !1;
          }
        return M[H] + (M[H + 1] - M[H]) * N;
      }
      function C(R, L, M, $, W, H) {
        var V = m(W, H), N = 1 - V, B = e.round((N * N * N * R[0] + (V * N * N + N * V * N + N * N * V) * M[0] + (V * V * N + N * V * V + V * N * V) * $[0] + V * V * V * L[0]) * 1e3) / 1e3, K = e.round((N * N * N * R[1] + (V * N * N + N * V * N + N * N * V) * M[1] + (V * V * N + N * V * V + V * N * V) * $[1] + V * V * V * L[1]) * 1e3) / 1e3;
        return [B, K];
      }
      var P = createTypedArray("float32", 8);
      function w(R, L, M, $, W, H, V) {
        W < 0 ? W = 0 : W > 1 && (W = 1);
        var N = m(W, V);
        H = H > 1 ? 1 : H;
        var B = m(H, V), K, ue = R.length, de = 1 - N, ve = 1 - B, Te = de * de * de, Pe = N * de * de * 3, Ce = N * N * de * 3, Re = N * N * N, ke = de * de * ve, Ae = N * de * ve + de * N * ve + de * de * B, we = N * N * ve + de * N * B + N * de * B, he = N * N * B, be = de * ve * ve, le = N * ve * ve + de * B * ve + de * ve * B, fe = N * B * ve + de * B * B + N * ve * B, ye = N * B * B, Ee = ve * ve * ve, Ie = B * ve * ve + ve * B * ve + ve * ve * B, Fe = B * B * ve + ve * B * B + B * ve * B, De = B * B * B;
        for (K = 0; K < ue; K += 1)
          P[K * 4] = e.round((Te * R[K] + Pe * M[K] + Ce * $[K] + Re * L[K]) * 1e3) / 1e3, P[K * 4 + 1] = e.round((ke * R[K] + Ae * M[K] + we * $[K] + he * L[K]) * 1e3) / 1e3, P[K * 4 + 2] = e.round((be * R[K] + le * M[K] + fe * $[K] + ye * L[K]) * 1e3) / 1e3, P[K * 4 + 3] = e.round((Ee * R[K] + Ie * M[K] + Fe * $[K] + De * L[K]) * 1e3) / 1e3;
        return P;
      }
      return {
        getSegmentsLength: s,
        getNewSegment: w,
        getPointInSegment: C,
        buildBezierData: p,
        pointOnLine2D: t,
        pointOnLine3D: n
      };
    }
    var bez = bezFunction(), initFrame = initialDefaultFrame, mathAbs = Math.abs;
    function interpolateValue(e, t) {
      var n = this.offsetTime, o;
      this.propType === "multidimensional" && (o = createTypedArray("float32", this.pv.length));
      for (var s = t.lastIndex, l = s, c = this.keyframes.length - 1, p = !0, m, C, P; p; ) {
        if (m = this.keyframes[l], C = this.keyframes[l + 1], l === c - 1 && e >= C.t - n) {
          m.h && (m = C), s = 0;
          break;
        }
        if (C.t - n > e) {
          s = l;
          break;
        }
        l < c - 1 ? l += 1 : (s = 0, p = !1);
      }
      P = this.keyframesMetadata[l] || {};
      var w, R, L, M, $, W, H = C.t - n, V = m.t - n, N;
      if (m.to) {
        P.bezierData || (P.bezierData = bez.buildBezierData(m.s, C.s || m.e, m.to, m.ti));
        var B = P.bezierData;
        if (e >= H || e < V) {
          var K = e >= H ? B.points.length - 1 : 0;
          for (R = B.points[K].point.length, w = 0; w < R; w += 1)
            o[w] = B.points[K].point[w];
        } else {
          P.__fnct ? W = P.__fnct : (W = BezierFactory.getBezierEasing(m.o.x, m.o.y, m.i.x, m.i.y, m.n).get, P.__fnct = W), L = W((e - V) / (H - V));
          var ue = B.segmentLength * L, de, ve = t.lastFrame < e && t._lastKeyframeIndex === l ? t._lastAddedLength : 0;
          for ($ = t.lastFrame < e && t._lastKeyframeIndex === l ? t._lastPoint : 0, p = !0, M = B.points.length; p; ) {
            if (ve += B.points[$].partialLength, ue === 0 || L === 0 || $ === B.points.length - 1) {
              for (R = B.points[$].point.length, w = 0; w < R; w += 1)
                o[w] = B.points[$].point[w];
              break;
            } else if (ue >= ve && ue < ve + B.points[$ + 1].partialLength) {
              for (de = (ue - ve) / B.points[$ + 1].partialLength, R = B.points[$].point.length, w = 0; w < R; w += 1)
                o[w] = B.points[$].point[w] + (B.points[$ + 1].point[w] - B.points[$].point[w]) * de;
              break;
            }
            $ < M - 1 ? $ += 1 : p = !1;
          }
          t._lastPoint = $, t._lastAddedLength = ve - B.points[$].partialLength, t._lastKeyframeIndex = l;
        }
      } else {
        var Te, Pe, Ce, Re, ke;
        if (c = m.s.length, N = C.s || m.e, this.sh && m.h !== 1)
          if (e >= H)
            o[0] = N[0], o[1] = N[1], o[2] = N[2];
          else if (e <= V)
            o[0] = m.s[0], o[1] = m.s[1], o[2] = m.s[2];
          else {
            var Ae = createQuaternion(m.s), we = createQuaternion(N), he = (e - V) / (H - V);
            quaternionToEuler(o, slerp(Ae, we, he));
          }
        else
          for (l = 0; l < c; l += 1)
            m.h !== 1 && (e >= H ? L = 1 : e < V ? L = 0 : (m.o.x.constructor === Array ? (P.__fnct || (P.__fnct = []), P.__fnct[l] ? W = P.__fnct[l] : (Te = m.o.x[l] === void 0 ? m.o.x[0] : m.o.x[l], Pe = m.o.y[l] === void 0 ? m.o.y[0] : m.o.y[l], Ce = m.i.x[l] === void 0 ? m.i.x[0] : m.i.x[l], Re = m.i.y[l] === void 0 ? m.i.y[0] : m.i.y[l], W = BezierFactory.getBezierEasing(Te, Pe, Ce, Re).get, P.__fnct[l] = W)) : P.__fnct ? W = P.__fnct : (Te = m.o.x, Pe = m.o.y, Ce = m.i.x, Re = m.i.y, W = BezierFactory.getBezierEasing(Te, Pe, Ce, Re).get, m.keyframeMetadata = W), L = W((e - V) / (H - V)))), N = C.s || m.e, ke = m.h === 1 ? m.s[l] : m.s[l] + (N[l] - m.s[l]) * L, this.propType === "multidimensional" ? o[l] = ke : o = ke;
      }
      return t.lastIndex = s, o;
    }
    function slerp(e, t, n) {
      var o = [], s = e[0], l = e[1], c = e[2], p = e[3], m = t[0], C = t[1], P = t[2], w = t[3], R, L, M, $, W;
      return L = s * m + l * C + c * P + p * w, L < 0 && (L = -L, m = -m, C = -C, P = -P, w = -w), 1 - L > 1e-6 ? (R = Math.acos(L), M = Math.sin(R), $ = Math.sin((1 - n) * R) / M, W = Math.sin(n * R) / M) : ($ = 1 - n, W = n), o[0] = $ * s + W * m, o[1] = $ * l + W * C, o[2] = $ * c + W * P, o[3] = $ * p + W * w, o;
    }
    function quaternionToEuler(e, t) {
      var n = t[0], o = t[1], s = t[2], l = t[3], c = Math.atan2(2 * o * l - 2 * n * s, 1 - 2 * o * o - 2 * s * s), p = Math.asin(2 * n * o + 2 * s * l), m = Math.atan2(2 * n * l - 2 * o * s, 1 - 2 * n * n - 2 * s * s);
      e[0] = c / degToRads, e[1] = p / degToRads, e[2] = m / degToRads;
    }
    function createQuaternion(e) {
      var t = e[0] * degToRads, n = e[1] * degToRads, o = e[2] * degToRads, s = Math.cos(t / 2), l = Math.cos(n / 2), c = Math.cos(o / 2), p = Math.sin(t / 2), m = Math.sin(n / 2), C = Math.sin(o / 2), P = s * l * c - p * m * C, w = p * m * c + s * l * C, R = p * l * c + s * m * C, L = s * m * c - p * l * C;
      return [w, R, L, P];
    }
    function getValueAtCurrentTime() {
      var e = this.comp.renderedFrame - this.offsetTime, t = this.keyframes[0].t - this.offsetTime, n = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
      if (!(e === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= n && e >= n || this._caching.lastFrame < t && e < t))) {
        this._caching.lastFrame >= e && (this._caching._lastKeyframeIndex = -1, this._caching.lastIndex = 0);
        var o = this.interpolateValue(e, this._caching);
        this.pv = o;
      }
      return this._caching.lastFrame = e, this.pv;
    }
    function setVValue(e) {
      var t;
      if (this.propType === "unidimensional")
        t = e * this.mult, mathAbs(this.v - t) > 1e-5 && (this.v = t, this._mdf = !0);
      else
        for (var n = 0, o = this.v.length; n < o; )
          t = e[n] * this.mult, mathAbs(this.v[n] - t) > 1e-5 && (this.v[n] = t, this._mdf = !0), n += 1;
    }
    function processEffectsSequence() {
      if (!(this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length)) {
        if (this.lock) {
          this.setVValue(this.pv);
          return;
        }
        this.lock = !0, this._mdf = this._isFirstFrame;
        var e, t = this.effectsSequence.length, n = this.kf ? this.pv : this.data.k;
        for (e = 0; e < t; e += 1)
          n = this.effectsSequence[e](n);
        this.setVValue(n), this._isFirstFrame = !1, this.lock = !1, this.frameId = this.elem.globalData.frameId;
      }
    }
    function addEffect(e) {
      this.effectsSequence.push(e), this.container.addDynamicProperty(this);
    }
    function ValueProperty(e, t, n, o) {
      this.propType = "unidimensional", this.mult = n || 1, this.data = t, this.v = n ? t.k * n : t.k, this.pv = t.k, this._mdf = !1, this.elem = e, this.container = o, this.comp = e.comp, this.k = !1, this.kf = !1, this.vel = 0, this.effectsSequence = [], this._isFirstFrame = !0, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.addEffect = addEffect;
    }
    function MultiDimensionalProperty(e, t, n, o) {
      this.propType = "multidimensional", this.mult = n || 1, this.data = t, this._mdf = !1, this.elem = e, this.container = o, this.comp = e.comp, this.k = !1, this.kf = !1, this.frameId = -1;
      var s, l = t.k.length;
      for (this.v = createTypedArray("float32", l), this.pv = createTypedArray("float32", l), this.vel = createTypedArray("float32", l), s = 0; s < l; s += 1)
        this.v[s] = t.k[s] * this.mult, this.pv[s] = t.k[s];
      this._isFirstFrame = !0, this.effectsSequence = [], this.getValue = processEffectsSequence, this.setVValue = setVValue, this.addEffect = addEffect;
    }
    function KeyframedValueProperty(e, t, n, o) {
      this.propType = "unidimensional", this.keyframes = t.k, this.keyframesMetadata = [], this.offsetTime = e.data.st, this.frameId = -1, this._caching = {
        lastFrame: initFrame,
        lastIndex: 0,
        value: 0,
        _lastKeyframeIndex: -1
      }, this.k = !0, this.kf = !0, this.data = t, this.mult = n || 1, this.elem = e, this.container = o, this.comp = e.comp, this.v = initFrame, this.pv = initFrame, this._isFirstFrame = !0, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.interpolateValue = interpolateValue, this.effectsSequence = [getValueAtCurrentTime.bind(this)], this.addEffect = addEffect;
    }
    function KeyframedMultidimensionalProperty(e, t, n, o) {
      this.propType = "multidimensional";
      var s, l = t.k.length, c, p, m, C;
      for (s = 0; s < l - 1; s += 1)
        t.k[s].to && t.k[s].s && t.k[s + 1] && t.k[s + 1].s && (c = t.k[s].s, p = t.k[s + 1].s, m = t.k[s].to, C = t.k[s].ti, (c.length === 2 && !(c[0] === p[0] && c[1] === p[1]) && bez.pointOnLine2D(c[0], c[1], p[0], p[1], c[0] + m[0], c[1] + m[1]) && bez.pointOnLine2D(c[0], c[1], p[0], p[1], p[0] + C[0], p[1] + C[1]) || c.length === 3 && !(c[0] === p[0] && c[1] === p[1] && c[2] === p[2]) && bez.pointOnLine3D(c[0], c[1], c[2], p[0], p[1], p[2], c[0] + m[0], c[1] + m[1], c[2] + m[2]) && bez.pointOnLine3D(c[0], c[1], c[2], p[0], p[1], p[2], p[0] + C[0], p[1] + C[1], p[2] + C[2])) && (t.k[s].to = null, t.k[s].ti = null), c[0] === p[0] && c[1] === p[1] && m[0] === 0 && m[1] === 0 && C[0] === 0 && C[1] === 0 && (c.length === 2 || c[2] === p[2] && m[2] === 0 && C[2] === 0) && (t.k[s].to = null, t.k[s].ti = null));
      this.effectsSequence = [getValueAtCurrentTime.bind(this)], this.data = t, this.keyframes = t.k, this.keyframesMetadata = [], this.offsetTime = e.data.st, this.k = !0, this.kf = !0, this._isFirstFrame = !0, this.mult = n || 1, this.elem = e, this.container = o, this.comp = e.comp, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.interpolateValue = interpolateValue, this.frameId = -1;
      var P = t.k[0].s.length;
      for (this.v = createTypedArray("float32", P), this.pv = createTypedArray("float32", P), s = 0; s < P; s += 1)
        this.v[s] = initFrame, this.pv[s] = initFrame;
      this._caching = {
        lastFrame: initFrame,
        lastIndex: 0,
        value: createTypedArray("float32", P)
      }, this.addEffect = addEffect;
    }
    var PropertyFactory = function() {
      function e(n, o, s, l, c) {
        o.sid && (o = n.globalData.slotManager.getProp(o));
        var p;
        if (!o.k.length)
          p = new ValueProperty(n, o, l, c);
        else if (typeof o.k[0] == "number")
          p = new MultiDimensionalProperty(n, o, l, c);
        else
          switch (s) {
            case 0:
              p = new KeyframedValueProperty(n, o, l, c);
              break;
            case 1:
              p = new KeyframedMultidimensionalProperty(n, o, l, c);
              break;
          }
        return p.effectsSequence.length && c.addDynamicProperty(p), p;
      }
      var t = {
        getProp: e
      };
      return t;
    }();
    function DynamicPropertyContainer() {
    }
    DynamicPropertyContainer.prototype = {
      addDynamicProperty: function(t) {
        this.dynamicProperties.indexOf(t) === -1 && (this.dynamicProperties.push(t), this.container.addDynamicProperty(this), this._isAnimated = !0);
      },
      iterateDynamicProperties: function() {
        this._mdf = !1;
        var t, n = this.dynamicProperties.length;
        for (t = 0; t < n; t += 1)
          this.dynamicProperties[t].getValue(), this.dynamicProperties[t]._mdf && (this._mdf = !0);
      },
      initDynamicPropertyContainer: function(t) {
        this.container = t, this.dynamicProperties = [], this._mdf = !1, this._isAnimated = !1;
      }
    };
    var pointPool = function() {
      function e() {
        return createTypedArray("float32", 2);
      }
      return poolFactory(8, e);
    }();
    function ShapePath() {
      this.c = !1, this._length = 0, this._maxLength = 8, this.v = createSizedArray(this._maxLength), this.o = createSizedArray(this._maxLength), this.i = createSizedArray(this._maxLength);
    }
    ShapePath.prototype.setPathData = function(e, t) {
      this.c = e, this.setLength(t);
      for (var n = 0; n < t; )
        this.v[n] = pointPool.newElement(), this.o[n] = pointPool.newElement(), this.i[n] = pointPool.newElement(), n += 1;
    }, ShapePath.prototype.setLength = function(e) {
      for (; this._maxLength < e; )
        this.doubleArrayLength();
      this._length = e;
    }, ShapePath.prototype.doubleArrayLength = function() {
      this.v = this.v.concat(createSizedArray(this._maxLength)), this.i = this.i.concat(createSizedArray(this._maxLength)), this.o = this.o.concat(createSizedArray(this._maxLength)), this._maxLength *= 2;
    }, ShapePath.prototype.setXYAt = function(e, t, n, o, s) {
      var l;
      switch (this._length = Math.max(this._length, o + 1), this._length >= this._maxLength && this.doubleArrayLength(), n) {
        case "v":
          l = this.v;
          break;
        case "i":
          l = this.i;
          break;
        case "o":
          l = this.o;
          break;
        default:
          l = [];
          break;
      }
      (!l[o] || l[o] && !s) && (l[o] = pointPool.newElement()), l[o][0] = e, l[o][1] = t;
    }, ShapePath.prototype.setTripleAt = function(e, t, n, o, s, l, c, p) {
      this.setXYAt(e, t, "v", c, p), this.setXYAt(n, o, "o", c, p), this.setXYAt(s, l, "i", c, p);
    }, ShapePath.prototype.reverse = function() {
      var e = new ShapePath();
      e.setPathData(this.c, this._length);
      var t = this.v, n = this.o, o = this.i, s = 0;
      this.c && (e.setTripleAt(t[0][0], t[0][1], o[0][0], o[0][1], n[0][0], n[0][1], 0, !1), s = 1);
      var l = this._length - 1, c = this._length, p;
      for (p = s; p < c; p += 1)
        e.setTripleAt(t[l][0], t[l][1], o[l][0], o[l][1], n[l][0], n[l][1], p, !1), l -= 1;
      return e;
    }, ShapePath.prototype.length = function() {
      return this._length;
    };
    var shapePool = function() {
      function e() {
        return new ShapePath();
      }
      function t(s) {
        var l = s._length, c;
        for (c = 0; c < l; c += 1)
          pointPool.release(s.v[c]), pointPool.release(s.i[c]), pointPool.release(s.o[c]), s.v[c] = null, s.i[c] = null, s.o[c] = null;
        s._length = 0, s.c = !1;
      }
      function n(s) {
        var l = o.newElement(), c, p = s._length === void 0 ? s.v.length : s._length;
        for (l.setLength(p), l.c = s.c, c = 0; c < p; c += 1)
          l.setTripleAt(s.v[c][0], s.v[c][1], s.o[c][0], s.o[c][1], s.i[c][0], s.i[c][1], c);
        return l;
      }
      var o = poolFactory(4, e, t);
      return o.clone = n, o;
    }();
    function ShapeCollection() {
      this._length = 0, this._maxLength = 4, this.shapes = createSizedArray(this._maxLength);
    }
    ShapeCollection.prototype.addShape = function(e) {
      this._length === this._maxLength && (this.shapes = this.shapes.concat(createSizedArray(this._maxLength)), this._maxLength *= 2), this.shapes[this._length] = e, this._length += 1;
    }, ShapeCollection.prototype.releaseShapes = function() {
      var e;
      for (e = 0; e < this._length; e += 1)
        shapePool.release(this.shapes[e]);
      this._length = 0;
    };
    var shapeCollectionPool = function() {
      var e = {
        newShapeCollection: s,
        release: l
      }, t = 0, n = 4, o = createSizedArray(n);
      function s() {
        var c;
        return t ? (t -= 1, c = o[t]) : c = new ShapeCollection(), c;
      }
      function l(c) {
        var p, m = c._length;
        for (p = 0; p < m; p += 1)
          shapePool.release(c.shapes[p]);
        c._length = 0, t === n && (o = pooling.double(o), n *= 2), o[t] = c, t += 1;
      }
      return e;
    }(), ShapePropertyFactory = function() {
      var e = -999999;
      function t(H, V, N) {
        var B = N.lastIndex, K, ue, de, ve, Te, Pe, Ce, Re, ke, Ae = this.keyframes;
        if (H < Ae[0].t - this.offsetTime)
          K = Ae[0].s[0], de = !0, B = 0;
        else if (H >= Ae[Ae.length - 1].t - this.offsetTime)
          K = Ae[Ae.length - 1].s ? Ae[Ae.length - 1].s[0] : Ae[Ae.length - 2].e[0], de = !0;
        else {
          for (var we = B, he = Ae.length - 1, be = !0, le, fe, ye; be && (le = Ae[we], fe = Ae[we + 1], !(fe.t - this.offsetTime > H)); )
            we < he - 1 ? we += 1 : be = !1;
          if (ye = this.keyframesMetadata[we] || {}, de = le.h === 1, B = we, !de) {
            if (H >= fe.t - this.offsetTime)
              Re = 1;
            else if (H < le.t - this.offsetTime)
              Re = 0;
            else {
              var Ee;
              ye.__fnct ? Ee = ye.__fnct : (Ee = BezierFactory.getBezierEasing(le.o.x, le.o.y, le.i.x, le.i.y).get, ye.__fnct = Ee), Re = Ee((H - (le.t - this.offsetTime)) / (fe.t - this.offsetTime - (le.t - this.offsetTime)));
            }
            ue = fe.s ? fe.s[0] : le.e[0];
          }
          K = le.s[0];
        }
        for (Pe = V._length, Ce = K.i[0].length, N.lastIndex = B, ve = 0; ve < Pe; ve += 1)
          for (Te = 0; Te < Ce; Te += 1)
            ke = de ? K.i[ve][Te] : K.i[ve][Te] + (ue.i[ve][Te] - K.i[ve][Te]) * Re, V.i[ve][Te] = ke, ke = de ? K.o[ve][Te] : K.o[ve][Te] + (ue.o[ve][Te] - K.o[ve][Te]) * Re, V.o[ve][Te] = ke, ke = de ? K.v[ve][Te] : K.v[ve][Te] + (ue.v[ve][Te] - K.v[ve][Te]) * Re, V.v[ve][Te] = ke;
      }
      function n() {
        var H = this.comp.renderedFrame - this.offsetTime, V = this.keyframes[0].t - this.offsetTime, N = this.keyframes[this.keyframes.length - 1].t - this.offsetTime, B = this._caching.lastFrame;
        return B !== e && (B < V && H < V || B > N && H > N) || (this._caching.lastIndex = B < H ? this._caching.lastIndex : 0, this.interpolateShape(H, this.pv, this._caching)), this._caching.lastFrame = H, this.pv;
      }
      function o() {
        this.paths = this.localShapeCollection;
      }
      function s(H, V) {
        if (H._length !== V._length || H.c !== V.c)
          return !1;
        var N, B = H._length;
        for (N = 0; N < B; N += 1)
          if (H.v[N][0] !== V.v[N][0] || H.v[N][1] !== V.v[N][1] || H.o[N][0] !== V.o[N][0] || H.o[N][1] !== V.o[N][1] || H.i[N][0] !== V.i[N][0] || H.i[N][1] !== V.i[N][1])
            return !1;
        return !0;
      }
      function l(H) {
        s(this.v, H) || (this.v = shapePool.clone(H), this.localShapeCollection.releaseShapes(), this.localShapeCollection.addShape(this.v), this._mdf = !0, this.paths = this.localShapeCollection);
      }
      function c() {
        if (this.elem.globalData.frameId !== this.frameId) {
          if (!this.effectsSequence.length) {
            this._mdf = !1;
            return;
          }
          if (this.lock) {
            this.setVValue(this.pv);
            return;
          }
          this.lock = !0, this._mdf = !1;
          var H;
          this.kf ? H = this.pv : this.data.ks ? H = this.data.ks.k : H = this.data.pt.k;
          var V, N = this.effectsSequence.length;
          for (V = 0; V < N; V += 1)
            H = this.effectsSequence[V](H);
          this.setVValue(H), this.lock = !1, this.frameId = this.elem.globalData.frameId;
        }
      }
      function p(H, V, N) {
        this.propType = "shape", this.comp = H.comp, this.container = H, this.elem = H, this.data = V, this.k = !1, this.kf = !1, this._mdf = !1;
        var B = N === 3 ? V.pt.k : V.ks.k;
        this.v = shapePool.clone(B), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.reset = o, this.effectsSequence = [];
      }
      function m(H) {
        this.effectsSequence.push(H), this.container.addDynamicProperty(this);
      }
      p.prototype.interpolateShape = t, p.prototype.getValue = c, p.prototype.setVValue = l, p.prototype.addEffect = m;
      function C(H, V, N) {
        this.propType = "shape", this.comp = H.comp, this.elem = H, this.container = H, this.offsetTime = H.data.st, this.keyframes = N === 3 ? V.pt.k : V.ks.k, this.keyframesMetadata = [], this.k = !0, this.kf = !0;
        var B = this.keyframes[0].s[0].i.length;
        this.v = shapePool.newElement(), this.v.setPathData(this.keyframes[0].s[0].c, B), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.lastFrame = e, this.reset = o, this._caching = {
          lastFrame: e,
          lastIndex: 0
        }, this.effectsSequence = [n.bind(this)];
      }
      C.prototype.getValue = c, C.prototype.interpolateShape = t, C.prototype.setVValue = l, C.prototype.addEffect = m;
      var P = function() {
        var H = roundCorner;
        function V(N, B) {
          this.v = shapePool.newElement(), this.v.setPathData(!0, 4), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.localShapeCollection.addShape(this.v), this.d = B.d, this.elem = N, this.comp = N.comp, this.frameId = -1, this.initDynamicPropertyContainer(N), this.p = PropertyFactory.getProp(N, B.p, 1, 0, this), this.s = PropertyFactory.getProp(N, B.s, 1, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertEllToPath());
        }
        return V.prototype = {
          reset: o,
          getValue: function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertEllToPath());
          },
          convertEllToPath: function() {
            var B = this.p.v[0], K = this.p.v[1], ue = this.s.v[0] / 2, de = this.s.v[1] / 2, ve = this.d !== 3, Te = this.v;
            Te.v[0][0] = B, Te.v[0][1] = K - de, Te.v[1][0] = ve ? B + ue : B - ue, Te.v[1][1] = K, Te.v[2][0] = B, Te.v[2][1] = K + de, Te.v[3][0] = ve ? B - ue : B + ue, Te.v[3][1] = K, Te.i[0][0] = ve ? B - ue * H : B + ue * H, Te.i[0][1] = K - de, Te.i[1][0] = ve ? B + ue : B - ue, Te.i[1][1] = K - de * H, Te.i[2][0] = ve ? B + ue * H : B - ue * H, Te.i[2][1] = K + de, Te.i[3][0] = ve ? B - ue : B + ue, Te.i[3][1] = K + de * H, Te.o[0][0] = ve ? B + ue * H : B - ue * H, Te.o[0][1] = K - de, Te.o[1][0] = ve ? B + ue : B - ue, Te.o[1][1] = K + de * H, Te.o[2][0] = ve ? B - ue * H : B + ue * H, Te.o[2][1] = K + de, Te.o[3][0] = ve ? B - ue : B + ue, Te.o[3][1] = K - de * H;
          }
        }, extendPrototype([DynamicPropertyContainer], V), V;
      }(), w = function() {
        function H(V, N) {
          this.v = shapePool.newElement(), this.v.setPathData(!0, 0), this.elem = V, this.comp = V.comp, this.data = N, this.frameId = -1, this.d = N.d, this.initDynamicPropertyContainer(V), N.sy === 1 ? (this.ir = PropertyFactory.getProp(V, N.ir, 0, 0, this), this.is = PropertyFactory.getProp(V, N.is, 0, 0.01, this), this.convertToPath = this.convertStarToPath) : this.convertToPath = this.convertPolygonToPath, this.pt = PropertyFactory.getProp(V, N.pt, 0, 0, this), this.p = PropertyFactory.getProp(V, N.p, 1, 0, this), this.r = PropertyFactory.getProp(V, N.r, 0, degToRads, this), this.or = PropertyFactory.getProp(V, N.or, 0, 0, this), this.os = PropertyFactory.getProp(V, N.os, 0, 0.01, this), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertToPath());
        }
        return H.prototype = {
          reset: o,
          getValue: function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertToPath());
          },
          convertStarToPath: function() {
            var N = Math.floor(this.pt.v) * 2, B = Math.PI * 2 / N, K = !0, ue = this.or.v, de = this.ir.v, ve = this.os.v, Te = this.is.v, Pe = 2 * Math.PI * ue / (N * 2), Ce = 2 * Math.PI * de / (N * 2), Re, ke, Ae, we, he = -Math.PI / 2;
            he += this.r.v;
            var be = this.data.d === 3 ? -1 : 1;
            for (this.v._length = 0, Re = 0; Re < N; Re += 1) {
              ke = K ? ue : de, Ae = K ? ve : Te, we = K ? Pe : Ce;
              var le = ke * Math.cos(he), fe = ke * Math.sin(he), ye = le === 0 && fe === 0 ? 0 : fe / Math.sqrt(le * le + fe * fe), Ee = le === 0 && fe === 0 ? 0 : -le / Math.sqrt(le * le + fe * fe);
              le += +this.p.v[0], fe += +this.p.v[1], this.v.setTripleAt(le, fe, le - ye * we * Ae * be, fe - Ee * we * Ae * be, le + ye * we * Ae * be, fe + Ee * we * Ae * be, Re, !0), K = !K, he += B * be;
            }
          },
          convertPolygonToPath: function() {
            var N = Math.floor(this.pt.v), B = Math.PI * 2 / N, K = this.or.v, ue = this.os.v, de = 2 * Math.PI * K / (N * 4), ve, Te = -Math.PI * 0.5, Pe = this.data.d === 3 ? -1 : 1;
            for (Te += this.r.v, this.v._length = 0, ve = 0; ve < N; ve += 1) {
              var Ce = K * Math.cos(Te), Re = K * Math.sin(Te), ke = Ce === 0 && Re === 0 ? 0 : Re / Math.sqrt(Ce * Ce + Re * Re), Ae = Ce === 0 && Re === 0 ? 0 : -Ce / Math.sqrt(Ce * Ce + Re * Re);
              Ce += +this.p.v[0], Re += +this.p.v[1], this.v.setTripleAt(Ce, Re, Ce - ke * de * ue * Pe, Re - Ae * de * ue * Pe, Ce + ke * de * ue * Pe, Re + Ae * de * ue * Pe, ve, !0), Te += B * Pe;
            }
            this.paths.length = 0, this.paths[0] = this.v;
          }
        }, extendPrototype([DynamicPropertyContainer], H), H;
      }(), R = function() {
        function H(V, N) {
          this.v = shapePool.newElement(), this.v.c = !0, this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.elem = V, this.comp = V.comp, this.frameId = -1, this.d = N.d, this.initDynamicPropertyContainer(V), this.p = PropertyFactory.getProp(V, N.p, 1, 0, this), this.s = PropertyFactory.getProp(V, N.s, 1, 0, this), this.r = PropertyFactory.getProp(V, N.r, 0, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertRectToPath());
        }
        return H.prototype = {
          convertRectToPath: function() {
            var N = this.p.v[0], B = this.p.v[1], K = this.s.v[0] / 2, ue = this.s.v[1] / 2, de = bmMin(K, ue, this.r.v), ve = de * (1 - roundCorner);
            this.v._length = 0, this.d === 2 || this.d === 1 ? (this.v.setTripleAt(N + K, B - ue + de, N + K, B - ue + de, N + K, B - ue + ve, 0, !0), this.v.setTripleAt(N + K, B + ue - de, N + K, B + ue - ve, N + K, B + ue - de, 1, !0), de !== 0 ? (this.v.setTripleAt(N + K - de, B + ue, N + K - de, B + ue, N + K - ve, B + ue, 2, !0), this.v.setTripleAt(N - K + de, B + ue, N - K + ve, B + ue, N - K + de, B + ue, 3, !0), this.v.setTripleAt(N - K, B + ue - de, N - K, B + ue - de, N - K, B + ue - ve, 4, !0), this.v.setTripleAt(N - K, B - ue + de, N - K, B - ue + ve, N - K, B - ue + de, 5, !0), this.v.setTripleAt(N - K + de, B - ue, N - K + de, B - ue, N - K + ve, B - ue, 6, !0), this.v.setTripleAt(N + K - de, B - ue, N + K - ve, B - ue, N + K - de, B - ue, 7, !0)) : (this.v.setTripleAt(N - K, B + ue, N - K + ve, B + ue, N - K, B + ue, 2), this.v.setTripleAt(N - K, B - ue, N - K, B - ue + ve, N - K, B - ue, 3))) : (this.v.setTripleAt(N + K, B - ue + de, N + K, B - ue + ve, N + K, B - ue + de, 0, !0), de !== 0 ? (this.v.setTripleAt(N + K - de, B - ue, N + K - de, B - ue, N + K - ve, B - ue, 1, !0), this.v.setTripleAt(N - K + de, B - ue, N - K + ve, B - ue, N - K + de, B - ue, 2, !0), this.v.setTripleAt(N - K, B - ue + de, N - K, B - ue + de, N - K, B - ue + ve, 3, !0), this.v.setTripleAt(N - K, B + ue - de, N - K, B + ue - ve, N - K, B + ue - de, 4, !0), this.v.setTripleAt(N - K + de, B + ue, N - K + de, B + ue, N - K + ve, B + ue, 5, !0), this.v.setTripleAt(N + K - de, B + ue, N + K - ve, B + ue, N + K - de, B + ue, 6, !0), this.v.setTripleAt(N + K, B + ue - de, N + K, B + ue - de, N + K, B + ue - ve, 7, !0)) : (this.v.setTripleAt(N - K, B - ue, N - K + ve, B - ue, N - K, B - ue, 1, !0), this.v.setTripleAt(N - K, B + ue, N - K, B + ue - ve, N - K, B + ue, 2, !0), this.v.setTripleAt(N + K, B + ue, N + K - ve, B + ue, N + K, B + ue, 3, !0)));
          },
          getValue: function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertRectToPath());
          },
          reset: o
        }, extendPrototype([DynamicPropertyContainer], H), H;
      }();
      function L(H, V, N) {
        var B;
        if (N === 3 || N === 4) {
          var K = N === 3 ? V.pt : V.ks, ue = K.k;
          ue.length ? B = new C(H, V, N) : B = new p(H, V, N);
        } else
          N === 5 ? B = new R(H, V) : N === 6 ? B = new P(H, V) : N === 7 && (B = new w(H, V));
        return B.k && H.addDynamicProperty(B), B;
      }
      function M() {
        return p;
      }
      function $() {
        return C;
      }
      var W = {};
      return W.getShapeProp = L, W.getConstructorFunction = M, W.getKeyframedConstructorFunction = $, W;
    }();
    /*!
     Transformation Matrix v2.0
     (c) Epistemex 2014-2015
     www.epistemex.com
     By Ken Fyrstenberg
     Contributions by leeoniya.
     License: MIT, header required.
     */
    var Matrix = function() {
      var e = Math.cos, t = Math.sin, n = Math.tan, o = Math.round;
      function s() {
        return this.props[0] = 1, this.props[1] = 0, this.props[2] = 0, this.props[3] = 0, this.props[4] = 0, this.props[5] = 1, this.props[6] = 0, this.props[7] = 0, this.props[8] = 0, this.props[9] = 0, this.props[10] = 1, this.props[11] = 0, this.props[12] = 0, this.props[13] = 0, this.props[14] = 0, this.props[15] = 1, this;
      }
      function l(le) {
        if (le === 0)
          return this;
        var fe = e(le), ye = t(le);
        return this._t(fe, -ye, 0, 0, ye, fe, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function c(le) {
        if (le === 0)
          return this;
        var fe = e(le), ye = t(le);
        return this._t(1, 0, 0, 0, 0, fe, -ye, 0, 0, ye, fe, 0, 0, 0, 0, 1);
      }
      function p(le) {
        if (le === 0)
          return this;
        var fe = e(le), ye = t(le);
        return this._t(fe, 0, ye, 0, 0, 1, 0, 0, -ye, 0, fe, 0, 0, 0, 0, 1);
      }
      function m(le) {
        if (le === 0)
          return this;
        var fe = e(le), ye = t(le);
        return this._t(fe, -ye, 0, 0, ye, fe, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function C(le, fe) {
        return this._t(1, fe, le, 1, 0, 0);
      }
      function P(le, fe) {
        return this.shear(n(le), n(fe));
      }
      function w(le, fe) {
        var ye = e(fe), Ee = t(fe);
        return this._t(ye, Ee, 0, 0, -Ee, ye, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, n(le), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(ye, -Ee, 0, 0, Ee, ye, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function R(le, fe, ye) {
        return !ye && ye !== 0 && (ye = 1), le === 1 && fe === 1 && ye === 1 ? this : this._t(le, 0, 0, 0, 0, fe, 0, 0, 0, 0, ye, 0, 0, 0, 0, 1);
      }
      function L(le, fe, ye, Ee, Ie, Fe, De, Ve, Oe, Ze, et, bt, rr, St, Qe, xt) {
        return this.props[0] = le, this.props[1] = fe, this.props[2] = ye, this.props[3] = Ee, this.props[4] = Ie, this.props[5] = Fe, this.props[6] = De, this.props[7] = Ve, this.props[8] = Oe, this.props[9] = Ze, this.props[10] = et, this.props[11] = bt, this.props[12] = rr, this.props[13] = St, this.props[14] = Qe, this.props[15] = xt, this;
      }
      function M(le, fe, ye) {
        return ye = ye || 0, le !== 0 || fe !== 0 || ye !== 0 ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, le, fe, ye, 1) : this;
      }
      function $(le, fe, ye, Ee, Ie, Fe, De, Ve, Oe, Ze, et, bt, rr, St, Qe, xt) {
        var je = this.props;
        if (le === 1 && fe === 0 && ye === 0 && Ee === 0 && Ie === 0 && Fe === 1 && De === 0 && Ve === 0 && Oe === 0 && Ze === 0 && et === 1 && bt === 0)
          return je[12] = je[12] * le + je[15] * rr, je[13] = je[13] * Fe + je[15] * St, je[14] = je[14] * et + je[15] * Qe, je[15] *= xt, this._identityCalculated = !1, this;
        var kt = je[0], cr = je[1], Tr = je[2], Er = je[3], Hr = je[4], Br = je[5], hr = je[6], Gr = je[7], Yr = je[8], tt = je[9], ar = je[10], wr = je[11], Sr = je[12], Ye = je[13], Je = je[14], tr = je[15];
        return je[0] = kt * le + cr * Ie + Tr * Oe + Er * rr, je[1] = kt * fe + cr * Fe + Tr * Ze + Er * St, je[2] = kt * ye + cr * De + Tr * et + Er * Qe, je[3] = kt * Ee + cr * Ve + Tr * bt + Er * xt, je[4] = Hr * le + Br * Ie + hr * Oe + Gr * rr, je[5] = Hr * fe + Br * Fe + hr * Ze + Gr * St, je[6] = Hr * ye + Br * De + hr * et + Gr * Qe, je[7] = Hr * Ee + Br * Ve + hr * bt + Gr * xt, je[8] = Yr * le + tt * Ie + ar * Oe + wr * rr, je[9] = Yr * fe + tt * Fe + ar * Ze + wr * St, je[10] = Yr * ye + tt * De + ar * et + wr * Qe, je[11] = Yr * Ee + tt * Ve + ar * bt + wr * xt, je[12] = Sr * le + Ye * Ie + Je * Oe + tr * rr, je[13] = Sr * fe + Ye * Fe + Je * Ze + tr * St, je[14] = Sr * ye + Ye * De + Je * et + tr * Qe, je[15] = Sr * Ee + Ye * Ve + Je * bt + tr * xt, this._identityCalculated = !1, this;
      }
      function W(le) {
        var fe = le.props;
        return this.transform(fe[0], fe[1], fe[2], fe[3], fe[4], fe[5], fe[6], fe[7], fe[8], fe[9], fe[10], fe[11], fe[12], fe[13], fe[14], fe[15]);
      }
      function H() {
        return this._identityCalculated || (this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1), this._identityCalculated = !0), this._identity;
      }
      function V(le) {
        for (var fe = 0; fe < 16; ) {
          if (le.props[fe] !== this.props[fe])
            return !1;
          fe += 1;
        }
        return !0;
      }
      function N(le) {
        var fe;
        for (fe = 0; fe < 16; fe += 1)
          le.props[fe] = this.props[fe];
        return le;
      }
      function B(le) {
        var fe;
        for (fe = 0; fe < 16; fe += 1)
          this.props[fe] = le[fe];
      }
      function K(le, fe, ye) {
        return {
          x: le * this.props[0] + fe * this.props[4] + ye * this.props[8] + this.props[12],
          y: le * this.props[1] + fe * this.props[5] + ye * this.props[9] + this.props[13],
          z: le * this.props[2] + fe * this.props[6] + ye * this.props[10] + this.props[14]
        };
      }
      function ue(le, fe, ye) {
        return le * this.props[0] + fe * this.props[4] + ye * this.props[8] + this.props[12];
      }
      function de(le, fe, ye) {
        return le * this.props[1] + fe * this.props[5] + ye * this.props[9] + this.props[13];
      }
      function ve(le, fe, ye) {
        return le * this.props[2] + fe * this.props[6] + ye * this.props[10] + this.props[14];
      }
      function Te() {
        var le = this.props[0] * this.props[5] - this.props[1] * this.props[4], fe = this.props[5] / le, ye = -this.props[1] / le, Ee = -this.props[4] / le, Ie = this.props[0] / le, Fe = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / le, De = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / le, Ve = new Matrix();
        return Ve.props[0] = fe, Ve.props[1] = ye, Ve.props[4] = Ee, Ve.props[5] = Ie, Ve.props[12] = Fe, Ve.props[13] = De, Ve;
      }
      function Pe(le) {
        var fe = this.getInverseMatrix();
        return fe.applyToPointArray(le[0], le[1], le[2] || 0);
      }
      function Ce(le) {
        var fe, ye = le.length, Ee = [];
        for (fe = 0; fe < ye; fe += 1)
          Ee[fe] = Pe(le[fe]);
        return Ee;
      }
      function Re(le, fe, ye) {
        var Ee = createTypedArray("float32", 6);
        if (this.isIdentity())
          Ee[0] = le[0], Ee[1] = le[1], Ee[2] = fe[0], Ee[3] = fe[1], Ee[4] = ye[0], Ee[5] = ye[1];
        else {
          var Ie = this.props[0], Fe = this.props[1], De = this.props[4], Ve = this.props[5], Oe = this.props[12], Ze = this.props[13];
          Ee[0] = le[0] * Ie + le[1] * De + Oe, Ee[1] = le[0] * Fe + le[1] * Ve + Ze, Ee[2] = fe[0] * Ie + fe[1] * De + Oe, Ee[3] = fe[0] * Fe + fe[1] * Ve + Ze, Ee[4] = ye[0] * Ie + ye[1] * De + Oe, Ee[5] = ye[0] * Fe + ye[1] * Ve + Ze;
        }
        return Ee;
      }
      function ke(le, fe, ye) {
        var Ee;
        return this.isIdentity() ? Ee = [le, fe, ye] : Ee = [le * this.props[0] + fe * this.props[4] + ye * this.props[8] + this.props[12], le * this.props[1] + fe * this.props[5] + ye * this.props[9] + this.props[13], le * this.props[2] + fe * this.props[6] + ye * this.props[10] + this.props[14]], Ee;
      }
      function Ae(le, fe) {
        if (this.isIdentity())
          return le + "," + fe;
        var ye = this.props;
        return Math.round((le * ye[0] + fe * ye[4] + ye[12]) * 100) / 100 + "," + Math.round((le * ye[1] + fe * ye[5] + ye[13]) * 100) / 100;
      }
      function we() {
        for (var le = 0, fe = this.props, ye = "matrix3d(", Ee = 1e4; le < 16; )
          ye += o(fe[le] * Ee) / Ee, ye += le === 15 ? ")" : ",", le += 1;
        return ye;
      }
      function he(le) {
        var fe = 1e4;
        return le < 1e-6 && le > 0 || le > -1e-6 && le < 0 ? o(le * fe) / fe : le;
      }
      function be() {
        var le = this.props, fe = he(le[0]), ye = he(le[1]), Ee = he(le[4]), Ie = he(le[5]), Fe = he(le[12]), De = he(le[13]);
        return "matrix(" + fe + "," + ye + "," + Ee + "," + Ie + "," + Fe + "," + De + ")";
      }
      return function() {
        this.reset = s, this.rotate = l, this.rotateX = c, this.rotateY = p, this.rotateZ = m, this.skew = P, this.skewFromAxis = w, this.shear = C, this.scale = R, this.setTransform = L, this.translate = M, this.transform = $, this.multiply = W, this.applyToPoint = K, this.applyToX = ue, this.applyToY = de, this.applyToZ = ve, this.applyToPointArray = ke, this.applyToTriplePoints = Re, this.applyToPointStringified = Ae, this.toCSS = we, this.to2dCSS = be, this.clone = N, this.cloneFromProps = B, this.equals = V, this.inversePoints = Ce, this.inversePoint = Pe, this.getInverseMatrix = Te, this._t = this.transform, this.isIdentity = H, this._identity = !0, this._identityCalculated = !1, this.props = createTypedArray("float32", 16), this.reset();
      };
    }();
    function _typeof$3(e) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$3 = function(n) {
        return typeof n;
      } : _typeof$3 = function(n) {
        return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      }, _typeof$3(e);
    }
    var lottie = {};
    function setLocation(e) {
      setLocationHref(e);
    }
    function searchAnimations() {
      animationManager.searchAnimations();
    }
    function setSubframeRendering(e) {
      setSubframeEnabled(e);
    }
    function setPrefix(e) {
      setIdPrefix(e);
    }
    function loadAnimation(e) {
      return animationManager.loadAnimation(e);
    }
    function setQuality(e) {
      if (typeof e == "string")
        switch (e) {
          case "high":
            setDefaultCurveSegments(200);
            break;
          default:
          case "medium":
            setDefaultCurveSegments(50);
            break;
          case "low":
            setDefaultCurveSegments(10);
            break;
        }
      else
        !isNaN(e) && e > 1 && setDefaultCurveSegments(e);
    }
    function inBrowser() {
      return typeof navigator < "u";
    }
    function installPlugin(e, t) {
      e === "expressions" && setExpressionsPlugin(t);
    }
    function getFactory(e) {
      switch (e) {
        case "propertyFactory":
          return PropertyFactory;
        case "shapePropertyFactory":
          return ShapePropertyFactory;
        case "matrix":
          return Matrix;
        default:
          return null;
      }
    }
    lottie.play = animationManager.play, lottie.pause = animationManager.pause, lottie.setLocationHref = setLocation, lottie.togglePause = animationManager.togglePause, lottie.setSpeed = animationManager.setSpeed, lottie.setDirection = animationManager.setDirection, lottie.stop = animationManager.stop, lottie.searchAnimations = searchAnimations, lottie.registerAnimation = animationManager.registerAnimation, lottie.loadAnimation = loadAnimation, lottie.setSubframeRendering = setSubframeRendering, lottie.resize = animationManager.resize, lottie.goToAndStop = animationManager.goToAndStop, lottie.destroy = animationManager.destroy, lottie.setQuality = setQuality, lottie.inBrowser = inBrowser, lottie.installPlugin = installPlugin, lottie.freeze = animationManager.freeze, lottie.unfreeze = animationManager.unfreeze, lottie.setVolume = animationManager.setVolume, lottie.mute = animationManager.mute, lottie.unmute = animationManager.unmute, lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations, lottie.useWebWorker = setWebWorker, lottie.setIDPrefix = setPrefix, lottie.__getFactory = getFactory, lottie.version = "5.12.2";
    function checkReady() {
      document.readyState === "complete" && (clearInterval(readyStateCheckInterval), searchAnimations());
    }
    function getQueryVariable(e) {
      for (var t = queryString.split("&"), n = 0; n < t.length; n += 1) {
        var o = t[n].split("=");
        if (decodeURIComponent(o[0]) == e)
          return decodeURIComponent(o[1]);
      }
      return null;
    }
    var queryString = "";
    {
      var scripts = document.getElementsByTagName("script"), index = scripts.length - 1, myScript = scripts[index] || {
        src: ""
      };
      queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, "") : "", getQueryVariable("renderer");
    }
    var readyStateCheckInterval = setInterval(checkReady, 100);
    try {
      _typeof$3(exports) !== "object" && (window.bodymovin = lottie);
    } catch (e) {
    }
    var ShapeModifiers = function() {
      var e = {}, t = {};
      e.registerModifier = n, e.getModifier = o;
      function n(s, l) {
        t[s] || (t[s] = l);
      }
      function o(s, l, c) {
        return new t[s](l, c);
      }
      return e;
    }();
    function ShapeModifier() {
    }
    ShapeModifier.prototype.initModifierProperties = function() {
    }, ShapeModifier.prototype.addShapeToModifier = function() {
    }, ShapeModifier.prototype.addShape = function(e) {
      if (!this.closed) {
        e.sh.container.addDynamicProperty(e.sh);
        var t = {
          shape: e.sh,
          data: e,
          localShapeCollection: shapeCollectionPool.newShapeCollection()
        };
        this.shapes.push(t), this.addShapeToModifier(t), this._isAnimated && e.setAsAnimated();
      }
    }, ShapeModifier.prototype.init = function(e, t) {
      this.shapes = [], this.elem = e, this.initDynamicPropertyContainer(e), this.initModifierProperties(e, t), this.frameId = initialDefaultFrame, this.closed = !1, this.k = !1, this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
    }, ShapeModifier.prototype.processKeys = function() {
      this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties());
    }, extendPrototype([DynamicPropertyContainer], ShapeModifier);
    function TrimModifier() {
    }
    extendPrototype([ShapeModifier], TrimModifier), TrimModifier.prototype.initModifierProperties = function(e, t) {
      this.s = PropertyFactory.getProp(e, t.s, 0, 0.01, this), this.e = PropertyFactory.getProp(e, t.e, 0, 0.01, this), this.o = PropertyFactory.getProp(e, t.o, 0, 0, this), this.sValue = 0, this.eValue = 0, this.getValue = this.processKeys, this.m = t.m, this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
    }, TrimModifier.prototype.addShapeToModifier = function(e) {
      e.pathsData = [];
    }, TrimModifier.prototype.calculateShapeEdges = function(e, t, n, o, s) {
      var l = [];
      t <= 1 ? l.push({
        s: e,
        e: t
      }) : e >= 1 ? l.push({
        s: e - 1,
        e: t - 1
      }) : (l.push({
        s: e,
        e: 1
      }), l.push({
        s: 0,
        e: t - 1
      }));
      var c = [], p, m = l.length, C;
      for (p = 0; p < m; p += 1)
        if (C = l[p], !(C.e * s < o || C.s * s > o + n)) {
          var P, w;
          C.s * s <= o ? P = 0 : P = (C.s * s - o) / n, C.e * s >= o + n ? w = 1 : w = (C.e * s - o) / n, c.push([P, w]);
        }
      return c.length || c.push([0, 0]), c;
    }, TrimModifier.prototype.releasePathsData = function(e) {
      var t, n = e.length;
      for (t = 0; t < n; t += 1)
        segmentsLengthPool.release(e[t]);
      return e.length = 0, e;
    }, TrimModifier.prototype.processShapes = function(e) {
      var t, n;
      if (this._mdf || e) {
        var o = this.o.v % 360 / 360;
        if (o < 0 && (o += 1), this.s.v > 1 ? t = 1 + o : this.s.v < 0 ? t = 0 + o : t = this.s.v + o, this.e.v > 1 ? n = 1 + o : this.e.v < 0 ? n = 0 + o : n = this.e.v + o, t > n) {
          var s = t;
          t = n, n = s;
        }
        t = Math.round(t * 1e4) * 1e-4, n = Math.round(n * 1e4) * 1e-4, this.sValue = t, this.eValue = n;
      } else
        t = this.sValue, n = this.eValue;
      var l, c, p = this.shapes.length, m, C, P, w, R, L = 0;
      if (n === t)
        for (c = 0; c < p; c += 1)
          this.shapes[c].localShapeCollection.releaseShapes(), this.shapes[c].shape._mdf = !0, this.shapes[c].shape.paths = this.shapes[c].localShapeCollection, this._mdf && (this.shapes[c].pathsData.length = 0);
      else if (n === 1 && t === 0 || n === 0 && t === 1) {
        if (this._mdf)
          for (c = 0; c < p; c += 1)
            this.shapes[c].pathsData.length = 0, this.shapes[c].shape._mdf = !0;
      } else {
        var M = [], $, W;
        for (c = 0; c < p; c += 1)
          if ($ = this.shapes[c], !$.shape._mdf && !this._mdf && !e && this.m !== 2)
            $.shape.paths = $.localShapeCollection;
          else {
            if (l = $.shape.paths, C = l._length, R = 0, !$.shape._mdf && $.pathsData.length)
              R = $.totalShapeLength;
            else {
              for (P = this.releasePathsData($.pathsData), m = 0; m < C; m += 1)
                w = bez.getSegmentsLength(l.shapes[m]), P.push(w), R += w.totalLength;
              $.totalShapeLength = R, $.pathsData = P;
            }
            L += R, $.shape._mdf = !0;
          }
        var H = t, V = n, N = 0, B;
        for (c = p - 1; c >= 0; c -= 1)
          if ($ = this.shapes[c], $.shape._mdf) {
            for (W = $.localShapeCollection, W.releaseShapes(), this.m === 2 && p > 1 ? (B = this.calculateShapeEdges(t, n, $.totalShapeLength, N, L), N += $.totalShapeLength) : B = [[H, V]], C = B.length, m = 0; m < C; m += 1) {
              H = B[m][0], V = B[m][1], M.length = 0, V <= 1 ? M.push({
                s: $.totalShapeLength * H,
                e: $.totalShapeLength * V
              }) : H >= 1 ? M.push({
                s: $.totalShapeLength * (H - 1),
                e: $.totalShapeLength * (V - 1)
              }) : (M.push({
                s: $.totalShapeLength * H,
                e: $.totalShapeLength
              }), M.push({
                s: 0,
                e: $.totalShapeLength * (V - 1)
              }));
              var K = this.addShapes($, M[0]);
              if (M[0].s !== M[0].e) {
                if (M.length > 1) {
                  var ue = $.shape.paths.shapes[$.shape.paths._length - 1];
                  if (ue.c) {
                    var de = K.pop();
                    this.addPaths(K, W), K = this.addShapes($, M[1], de);
                  } else
                    this.addPaths(K, W), K = this.addShapes($, M[1]);
                }
                this.addPaths(K, W);
              }
            }
            $.shape.paths = W;
          }
      }
    }, TrimModifier.prototype.addPaths = function(e, t) {
      var n, o = e.length;
      for (n = 0; n < o; n += 1)
        t.addShape(e[n]);
    }, TrimModifier.prototype.addSegment = function(e, t, n, o, s, l, c) {
      s.setXYAt(t[0], t[1], "o", l), s.setXYAt(n[0], n[1], "i", l + 1), c && s.setXYAt(e[0], e[1], "v", l), s.setXYAt(o[0], o[1], "v", l + 1);
    }, TrimModifier.prototype.addSegmentFromArray = function(e, t, n, o) {
      t.setXYAt(e[1], e[5], "o", n), t.setXYAt(e[2], e[6], "i", n + 1), o && t.setXYAt(e[0], e[4], "v", n), t.setXYAt(e[3], e[7], "v", n + 1);
    }, TrimModifier.prototype.addShapes = function(e, t, n) {
      var o = e.pathsData, s = e.shape.paths.shapes, l, c = e.shape.paths._length, p, m, C = 0, P, w, R, L, M = [], $, W = !0;
      for (n ? (w = n._length, $ = n._length) : (n = shapePool.newElement(), w = 0, $ = 0), M.push(n), l = 0; l < c; l += 1) {
        for (R = o[l].lengths, n.c = s[l].c, m = s[l].c ? R.length : R.length + 1, p = 1; p < m; p += 1)
          if (P = R[p - 1], C + P.addedLength < t.s)
            C += P.addedLength, n.c = !1;
          else if (C > t.e) {
            n.c = !1;
            break;
          } else
            t.s <= C && t.e >= C + P.addedLength ? (this.addSegment(s[l].v[p - 1], s[l].o[p - 1], s[l].i[p], s[l].v[p], n, w, W), W = !1) : (L = bez.getNewSegment(s[l].v[p - 1], s[l].v[p], s[l].o[p - 1], s[l].i[p], (t.s - C) / P.addedLength, (t.e - C) / P.addedLength, R[p - 1]), this.addSegmentFromArray(L, n, w, W), W = !1, n.c = !1), C += P.addedLength, w += 1;
        if (s[l].c && R.length) {
          if (P = R[p - 1], C <= t.e) {
            var H = R[p - 1].addedLength;
            t.s <= C && t.e >= C + H ? (this.addSegment(s[l].v[p - 1], s[l].o[p - 1], s[l].i[0], s[l].v[0], n, w, W), W = !1) : (L = bez.getNewSegment(s[l].v[p - 1], s[l].v[0], s[l].o[p - 1], s[l].i[0], (t.s - C) / H, (t.e - C) / H, R[p - 1]), this.addSegmentFromArray(L, n, w, W), W = !1, n.c = !1);
          } else
            n.c = !1;
          C += P.addedLength, w += 1;
        }
        if (n._length && (n.setXYAt(n.v[$][0], n.v[$][1], "i", $), n.setXYAt(n.v[n._length - 1][0], n.v[n._length - 1][1], "o", n._length - 1)), C > t.e)
          break;
        l < c - 1 && (n = shapePool.newElement(), W = !0, M.push(n), w = 0);
      }
      return M;
    };
    function PuckerAndBloatModifier() {
    }
    extendPrototype([ShapeModifier], PuckerAndBloatModifier), PuckerAndBloatModifier.prototype.initModifierProperties = function(e, t) {
      this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(e, t.a, 0, null, this), this._isAnimated = !!this.amount.effectsSequence.length;
    }, PuckerAndBloatModifier.prototype.processPath = function(e, t) {
      var n = t / 100, o = [0, 0], s = e._length, l = 0;
      for (l = 0; l < s; l += 1)
        o[0] += e.v[l][0], o[1] += e.v[l][1];
      o[0] /= s, o[1] /= s;
      var c = shapePool.newElement();
      c.c = e.c;
      var p, m, C, P, w, R;
      for (l = 0; l < s; l += 1)
        p = e.v[l][0] + (o[0] - e.v[l][0]) * n, m = e.v[l][1] + (o[1] - e.v[l][1]) * n, C = e.o[l][0] + (o[0] - e.o[l][0]) * -n, P = e.o[l][1] + (o[1] - e.o[l][1]) * -n, w = e.i[l][0] + (o[0] - e.i[l][0]) * -n, R = e.i[l][1] + (o[1] - e.i[l][1]) * -n, c.setTripleAt(p, m, C, P, w, R, l);
      return c;
    }, PuckerAndBloatModifier.prototype.processShapes = function(e) {
      var t, n, o = this.shapes.length, s, l, c = this.amount.v;
      if (c !== 0) {
        var p, m;
        for (n = 0; n < o; n += 1) {
          if (p = this.shapes[n], m = p.localShapeCollection, !(!p.shape._mdf && !this._mdf && !e))
            for (m.releaseShapes(), p.shape._mdf = !0, t = p.shape.paths.shapes, l = p.shape.paths._length, s = 0; s < l; s += 1)
              m.addShape(this.processPath(t[s], c));
          p.shape.paths = p.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    var TransformPropertyFactory = function() {
      var e = [0, 0];
      function t(m) {
        var C = this._mdf;
        this.iterateDynamicProperties(), this._mdf = this._mdf || C, this.a && m.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && m.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && m.skewFromAxis(-this.sk.v, this.sa.v), this.r ? m.rotate(-this.r.v) : m.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.data.p.s ? this.data.p.z ? m.translate(this.px.v, this.py.v, -this.pz.v) : m.translate(this.px.v, this.py.v, 0) : m.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
      }
      function n(m) {
        if (this.elem.globalData.frameId !== this.frameId) {
          if (this._isDirty && (this.precalculateMatrix(), this._isDirty = !1), this.iterateDynamicProperties(), this._mdf || m) {
            var C;
            if (this.v.cloneFromProps(this.pre.props), this.appliedTransformations < 1 && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations < 2 && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && this.appliedTransformations < 3 && this.v.skewFromAxis(-this.sk.v, this.sa.v), this.r && this.appliedTransformations < 4 ? this.v.rotate(-this.r.v) : !this.r && this.appliedTransformations < 4 && this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.autoOriented) {
              var P, w;
              if (C = this.elem.globalData.frameRate, this.p && this.p.keyframes && this.p.getValueAtTime)
                this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t ? (P = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / C, 0), w = this.p.getValueAtTime(this.p.keyframes[0].t / C, 0)) : this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t ? (P = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / C, 0), w = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / C, 0)) : (P = this.p.pv, w = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / C, this.p.offsetTime));
              else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                P = [], w = [];
                var R = this.px, L = this.py;
                R._caching.lastFrame + R.offsetTime <= R.keyframes[0].t ? (P[0] = R.getValueAtTime((R.keyframes[0].t + 0.01) / C, 0), P[1] = L.getValueAtTime((L.keyframes[0].t + 0.01) / C, 0), w[0] = R.getValueAtTime(R.keyframes[0].t / C, 0), w[1] = L.getValueAtTime(L.keyframes[0].t / C, 0)) : R._caching.lastFrame + R.offsetTime >= R.keyframes[R.keyframes.length - 1].t ? (P[0] = R.getValueAtTime(R.keyframes[R.keyframes.length - 1].t / C, 0), P[1] = L.getValueAtTime(L.keyframes[L.keyframes.length - 1].t / C, 0), w[0] = R.getValueAtTime((R.keyframes[R.keyframes.length - 1].t - 0.01) / C, 0), w[1] = L.getValueAtTime((L.keyframes[L.keyframes.length - 1].t - 0.01) / C, 0)) : (P = [R.pv, L.pv], w[0] = R.getValueAtTime((R._caching.lastFrame + R.offsetTime - 0.01) / C, R.offsetTime), w[1] = L.getValueAtTime((L._caching.lastFrame + L.offsetTime - 0.01) / C, L.offsetTime));
              } else
                w = e, P = w;
              this.v.rotate(-Math.atan2(P[1] - w[1], P[0] - w[0]));
            }
            this.data.p && this.data.p.s ? this.data.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
          }
          this.frameId = this.elem.globalData.frameId;
        }
      }
      function o() {
        if (this.appliedTransformations = 0, this.pre.reset(), !this.a.effectsSequence.length)
          this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations = 1;
        else
          return;
        if (!this.s.effectsSequence.length)
          this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.appliedTransformations = 2;
        else
          return;
        if (this.sk)
          if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length)
            this.pre.skewFromAxis(-this.sk.v, this.sa.v), this.appliedTransformations = 3;
          else
            return;
        this.r ? this.r.effectsSequence.length || (this.pre.rotate(-this.r.v), this.appliedTransformations = 4) : !this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length && (this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.appliedTransformations = 4);
      }
      function s() {
      }
      function l(m) {
        this._addDynamicProperty(m), this.elem.addDynamicProperty(m), this._isDirty = !0;
      }
      function c(m, C, P) {
        if (this.elem = m, this.frameId = -1, this.propType = "transform", this.data = C, this.v = new Matrix(), this.pre = new Matrix(), this.appliedTransformations = 0, this.initDynamicPropertyContainer(P || m), C.p && C.p.s ? (this.px = PropertyFactory.getProp(m, C.p.x, 0, 0, this), this.py = PropertyFactory.getProp(m, C.p.y, 0, 0, this), C.p.z && (this.pz = PropertyFactory.getProp(m, C.p.z, 0, 0, this))) : this.p = PropertyFactory.getProp(m, C.p || {
          k: [0, 0, 0]
        }, 1, 0, this), C.rx) {
          if (this.rx = PropertyFactory.getProp(m, C.rx, 0, degToRads, this), this.ry = PropertyFactory.getProp(m, C.ry, 0, degToRads, this), this.rz = PropertyFactory.getProp(m, C.rz, 0, degToRads, this), C.or.k[0].ti) {
            var w, R = C.or.k.length;
            for (w = 0; w < R; w += 1)
              C.or.k[w].to = null, C.or.k[w].ti = null;
          }
          this.or = PropertyFactory.getProp(m, C.or, 1, degToRads, this), this.or.sh = !0;
        } else
          this.r = PropertyFactory.getProp(m, C.r || {
            k: 0
          }, 0, degToRads, this);
        C.sk && (this.sk = PropertyFactory.getProp(m, C.sk, 0, degToRads, this), this.sa = PropertyFactory.getProp(m, C.sa, 0, degToRads, this)), this.a = PropertyFactory.getProp(m, C.a || {
          k: [0, 0, 0]
        }, 1, 0, this), this.s = PropertyFactory.getProp(m, C.s || {
          k: [100, 100, 100]
        }, 1, 0.01, this), C.o ? this.o = PropertyFactory.getProp(m, C.o, 0, 0.01, m) : this.o = {
          _mdf: !1,
          v: 1
        }, this._isDirty = !0, this.dynamicProperties.length || this.getValue(!0);
      }
      c.prototype = {
        applyToMatrix: t,
        getValue: n,
        precalculateMatrix: o,
        autoOrient: s
      }, extendPrototype([DynamicPropertyContainer], c), c.prototype.addDynamicProperty = l, c.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;
      function p(m, C, P) {
        return new c(m, C, P);
      }
      return {
        getTransformProperty: p
      };
    }();
    function RepeaterModifier() {
    }
    extendPrototype([ShapeModifier], RepeaterModifier), RepeaterModifier.prototype.initModifierProperties = function(e, t) {
      this.getValue = this.processKeys, this.c = PropertyFactory.getProp(e, t.c, 0, null, this), this.o = PropertyFactory.getProp(e, t.o, 0, null, this), this.tr = TransformPropertyFactory.getTransformProperty(e, t.tr, this), this.so = PropertyFactory.getProp(e, t.tr.so, 0, 0.01, this), this.eo = PropertyFactory.getProp(e, t.tr.eo, 0, 0.01, this), this.data = t, this.dynamicProperties.length || this.getValue(!0), this._isAnimated = !!this.dynamicProperties.length, this.pMatrix = new Matrix(), this.rMatrix = new Matrix(), this.sMatrix = new Matrix(), this.tMatrix = new Matrix(), this.matrix = new Matrix();
    }, RepeaterModifier.prototype.applyTransforms = function(e, t, n, o, s, l) {
      var c = l ? -1 : 1, p = o.s.v[0] + (1 - o.s.v[0]) * (1 - s), m = o.s.v[1] + (1 - o.s.v[1]) * (1 - s);
      e.translate(o.p.v[0] * c * s, o.p.v[1] * c * s, o.p.v[2]), t.translate(-o.a.v[0], -o.a.v[1], o.a.v[2]), t.rotate(-o.r.v * c * s), t.translate(o.a.v[0], o.a.v[1], o.a.v[2]), n.translate(-o.a.v[0], -o.a.v[1], o.a.v[2]), n.scale(l ? 1 / p : p, l ? 1 / m : m), n.translate(o.a.v[0], o.a.v[1], o.a.v[2]);
    }, RepeaterModifier.prototype.init = function(e, t, n, o) {
      for (this.elem = e, this.arr = t, this.pos = n, this.elemsData = o, this._currentCopies = 0, this._elements = [], this._groups = [], this.frameId = -1, this.initDynamicPropertyContainer(e), this.initModifierProperties(e, t[n]); n > 0; )
        n -= 1, this._elements.unshift(t[n]);
      this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
    }, RepeaterModifier.prototype.resetElements = function(e) {
      var t, n = e.length;
      for (t = 0; t < n; t += 1)
        e[t]._processed = !1, e[t].ty === "gr" && this.resetElements(e[t].it);
    }, RepeaterModifier.prototype.cloneElements = function(e) {
      var t = JSON.parse(JSON.stringify(e));
      return this.resetElements(t), t;
    }, RepeaterModifier.prototype.changeGroupRender = function(e, t) {
      var n, o = e.length;
      for (n = 0; n < o; n += 1)
        e[n]._render = t, e[n].ty === "gr" && this.changeGroupRender(e[n].it, t);
    }, RepeaterModifier.prototype.processShapes = function(e) {
      var t, n, o, s, l, c = !1;
      if (this._mdf || e) {
        var p = Math.ceil(this.c.v);
        if (this._groups.length < p) {
          for (; this._groups.length < p; ) {
            var m = {
              it: this.cloneElements(this._elements),
              ty: "gr"
            };
            m.it.push({
              a: {
                a: 0,
                ix: 1,
                k: [0, 0]
              },
              nm: "Transform",
              o: {
                a: 0,
                ix: 7,
                k: 100
              },
              p: {
                a: 0,
                ix: 2,
                k: [0, 0]
              },
              r: {
                a: 1,
                ix: 6,
                k: [{
                  s: 0,
                  e: 0,
                  t: 0
                }, {
                  s: 0,
                  e: 0,
                  t: 1
                }]
              },
              s: {
                a: 0,
                ix: 3,
                k: [100, 100]
              },
              sa: {
                a: 0,
                ix: 5,
                k: 0
              },
              sk: {
                a: 0,
                ix: 4,
                k: 0
              },
              ty: "tr"
            }), this.arr.splice(0, 0, m), this._groups.splice(0, 0, m), this._currentCopies += 1;
          }
          this.elem.reloadShapes(), c = !0;
        }
        l = 0;
        var C;
        for (o = 0; o <= this._groups.length - 1; o += 1) {
          if (C = l < p, this._groups[o]._render = C, this.changeGroupRender(this._groups[o].it, C), !C) {
            var P = this.elemsData[o].it, w = P[P.length - 1];
            w.transform.op.v !== 0 ? (w.transform.op._mdf = !0, w.transform.op.v = 0) : w.transform.op._mdf = !1;
          }
          l += 1;
        }
        this._currentCopies = p;
        var R = this.o.v, L = R % 1, M = R > 0 ? Math.floor(R) : Math.ceil(R), $ = this.pMatrix.props, W = this.rMatrix.props, H = this.sMatrix.props;
        this.pMatrix.reset(), this.rMatrix.reset(), this.sMatrix.reset(), this.tMatrix.reset(), this.matrix.reset();
        var V = 0;
        if (R > 0) {
          for (; V < M; )
            this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), V += 1;
          L && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, L, !1), V += L);
        } else if (R < 0) {
          for (; V > M; )
            this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !0), V -= 1;
          L && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -L, !0), V -= L);
        }
        o = this.data.m === 1 ? 0 : this._currentCopies - 1, s = this.data.m === 1 ? 1 : -1, l = this._currentCopies;
        for (var N, B; l; ) {
          if (t = this.elemsData[o].it, n = t[t.length - 1].transform.mProps.v.props, B = n.length, t[t.length - 1].transform.mProps._mdf = !0, t[t.length - 1].transform.op._mdf = !0, t[t.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (o / (this._currentCopies - 1)), V !== 0) {
            for ((o !== 0 && s === 1 || o !== this._currentCopies - 1 && s === -1) && this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), this.matrix.transform(W[0], W[1], W[2], W[3], W[4], W[5], W[6], W[7], W[8], W[9], W[10], W[11], W[12], W[13], W[14], W[15]), this.matrix.transform(H[0], H[1], H[2], H[3], H[4], H[5], H[6], H[7], H[8], H[9], H[10], H[11], H[12], H[13], H[14], H[15]), this.matrix.transform($[0], $[1], $[2], $[3], $[4], $[5], $[6], $[7], $[8], $[9], $[10], $[11], $[12], $[13], $[14], $[15]), N = 0; N < B; N += 1)
              n[N] = this.matrix.props[N];
            this.matrix.reset();
          } else
            for (this.matrix.reset(), N = 0; N < B; N += 1)
              n[N] = this.matrix.props[N];
          V += 1, l -= 1, o += s;
        }
      } else
        for (l = this._currentCopies, o = 0, s = 1; l; )
          t = this.elemsData[o].it, n = t[t.length - 1].transform.mProps.v.props, t[t.length - 1].transform.mProps._mdf = !1, t[t.length - 1].transform.op._mdf = !1, l -= 1, o += s;
      return c;
    }, RepeaterModifier.prototype.addShape = function() {
    };
    function RoundCornersModifier() {
    }
    extendPrototype([ShapeModifier], RoundCornersModifier), RoundCornersModifier.prototype.initModifierProperties = function(e, t) {
      this.getValue = this.processKeys, this.rd = PropertyFactory.getProp(e, t.r, 0, null, this), this._isAnimated = !!this.rd.effectsSequence.length;
    }, RoundCornersModifier.prototype.processPath = function(e, t) {
      var n = shapePool.newElement();
      n.c = e.c;
      var o, s = e._length, l, c, p, m, C, P, w = 0, R, L, M, $, W, H;
      for (o = 0; o < s; o += 1)
        l = e.v[o], p = e.o[o], c = e.i[o], l[0] === p[0] && l[1] === p[1] && l[0] === c[0] && l[1] === c[1] ? (o === 0 || o === s - 1) && !e.c ? (n.setTripleAt(l[0], l[1], p[0], p[1], c[0], c[1], w), w += 1) : (o === 0 ? m = e.v[s - 1] : m = e.v[o - 1], C = Math.sqrt(Math.pow(l[0] - m[0], 2) + Math.pow(l[1] - m[1], 2)), P = C ? Math.min(C / 2, t) / C : 0, W = l[0] + (m[0] - l[0]) * P, R = W, H = l[1] - (l[1] - m[1]) * P, L = H, M = R - (R - l[0]) * roundCorner, $ = L - (L - l[1]) * roundCorner, n.setTripleAt(R, L, M, $, W, H, w), w += 1, o === s - 1 ? m = e.v[0] : m = e.v[o + 1], C = Math.sqrt(Math.pow(l[0] - m[0], 2) + Math.pow(l[1] - m[1], 2)), P = C ? Math.min(C / 2, t) / C : 0, M = l[0] + (m[0] - l[0]) * P, R = M, $ = l[1] + (m[1] - l[1]) * P, L = $, W = R - (R - l[0]) * roundCorner, H = L - (L - l[1]) * roundCorner, n.setTripleAt(R, L, M, $, W, H, w), w += 1) : (n.setTripleAt(e.v[o][0], e.v[o][1], e.o[o][0], e.o[o][1], e.i[o][0], e.i[o][1], w), w += 1);
      return n;
    }, RoundCornersModifier.prototype.processShapes = function(e) {
      var t, n, o = this.shapes.length, s, l, c = this.rd.v;
      if (c !== 0) {
        var p, m;
        for (n = 0; n < o; n += 1) {
          if (p = this.shapes[n], m = p.localShapeCollection, !(!p.shape._mdf && !this._mdf && !e))
            for (m.releaseShapes(), p.shape._mdf = !0, t = p.shape.paths.shapes, l = p.shape.paths._length, s = 0; s < l; s += 1)
              m.addShape(this.processPath(t[s], c));
          p.shape.paths = p.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    function floatEqual(e, t) {
      return Math.abs(e - t) * 1e5 <= Math.min(Math.abs(e), Math.abs(t));
    }
    function floatZero(e) {
      return Math.abs(e) <= 1e-5;
    }
    function lerp(e, t, n) {
      return e * (1 - n) + t * n;
    }
    function lerpPoint(e, t, n) {
      return [lerp(e[0], t[0], n), lerp(e[1], t[1], n)];
    }
    function quadRoots(e, t, n) {
      if (e === 0)
        return [];
      var o = t * t - 4 * e * n;
      if (o < 0)
        return [];
      var s = -t / (2 * e);
      if (o === 0)
        return [s];
      var l = Math.sqrt(o) / (2 * e);
      return [s - l, s + l];
    }
    function polynomialCoefficients(e, t, n, o) {
      return [-e + 3 * t - 3 * n + o, 3 * e - 6 * t + 3 * n, -3 * e + 3 * t, e];
    }
    function singlePoint(e) {
      return new PolynomialBezier(e, e, e, e, !1);
    }
    function PolynomialBezier(e, t, n, o, s) {
      s && pointEqual(e, t) && (t = lerpPoint(e, o, 1 / 3)), s && pointEqual(n, o) && (n = lerpPoint(e, o, 2 / 3));
      var l = polynomialCoefficients(e[0], t[0], n[0], o[0]), c = polynomialCoefficients(e[1], t[1], n[1], o[1]);
      this.a = [l[0], c[0]], this.b = [l[1], c[1]], this.c = [l[2], c[2]], this.d = [l[3], c[3]], this.points = [e, t, n, o];
    }
    PolynomialBezier.prototype.point = function(e) {
      return [((this.a[0] * e + this.b[0]) * e + this.c[0]) * e + this.d[0], ((this.a[1] * e + this.b[1]) * e + this.c[1]) * e + this.d[1]];
    }, PolynomialBezier.prototype.derivative = function(e) {
      return [(3 * e * this.a[0] + 2 * this.b[0]) * e + this.c[0], (3 * e * this.a[1] + 2 * this.b[1]) * e + this.c[1]];
    }, PolynomialBezier.prototype.tangentAngle = function(e) {
      var t = this.derivative(e);
      return Math.atan2(t[1], t[0]);
    }, PolynomialBezier.prototype.normalAngle = function(e) {
      var t = this.derivative(e);
      return Math.atan2(t[0], t[1]);
    }, PolynomialBezier.prototype.inflectionPoints = function() {
      var e = this.a[1] * this.b[0] - this.a[0] * this.b[1];
      if (floatZero(e))
        return [];
      var t = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / e, n = t * t - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / e;
      if (n < 0)
        return [];
      var o = Math.sqrt(n);
      return floatZero(o) ? o > 0 && o < 1 ? [t] : [] : [t - o, t + o].filter(function(s) {
        return s > 0 && s < 1;
      });
    }, PolynomialBezier.prototype.split = function(e) {
      if (e <= 0)
        return [singlePoint(this.points[0]), this];
      if (e >= 1)
        return [this, singlePoint(this.points[this.points.length - 1])];
      var t = lerpPoint(this.points[0], this.points[1], e), n = lerpPoint(this.points[1], this.points[2], e), o = lerpPoint(this.points[2], this.points[3], e), s = lerpPoint(t, n, e), l = lerpPoint(n, o, e), c = lerpPoint(s, l, e);
      return [new PolynomialBezier(this.points[0], t, s, c, !0), new PolynomialBezier(c, l, o, this.points[3], !0)];
    };
    function extrema(e, t) {
      var n = e.points[0][t], o = e.points[e.points.length - 1][t];
      if (n > o) {
        var s = o;
        o = n, n = s;
      }
      for (var l = quadRoots(3 * e.a[t], 2 * e.b[t], e.c[t]), c = 0; c < l.length; c += 1)
        if (l[c] > 0 && l[c] < 1) {
          var p = e.point(l[c])[t];
          p < n ? n = p : p > o && (o = p);
        }
      return {
        min: n,
        max: o
      };
    }
    PolynomialBezier.prototype.bounds = function() {
      return {
        x: extrema(this, 0),
        y: extrema(this, 1)
      };
    }, PolynomialBezier.prototype.boundingBox = function() {
      var e = this.bounds();
      return {
        left: e.x.min,
        right: e.x.max,
        top: e.y.min,
        bottom: e.y.max,
        width: e.x.max - e.x.min,
        height: e.y.max - e.y.min,
        cx: (e.x.max + e.x.min) / 2,
        cy: (e.y.max + e.y.min) / 2
      };
    };
    function intersectData(e, t, n) {
      var o = e.boundingBox();
      return {
        cx: o.cx,
        cy: o.cy,
        width: o.width,
        height: o.height,
        bez: e,
        t: (t + n) / 2,
        t1: t,
        t2: n
      };
    }
    function splitData(e) {
      var t = e.bez.split(0.5);
      return [intersectData(t[0], e.t1, e.t), intersectData(t[1], e.t, e.t2)];
    }
    function boxIntersect(e, t) {
      return Math.abs(e.cx - t.cx) * 2 < e.width + t.width && Math.abs(e.cy - t.cy) * 2 < e.height + t.height;
    }
    function intersectsImpl(e, t, n, o, s, l) {
      if (boxIntersect(e, t)) {
        if (n >= l || e.width <= o && e.height <= o && t.width <= o && t.height <= o) {
          s.push([e.t, t.t]);
          return;
        }
        var c = splitData(e), p = splitData(t);
        intersectsImpl(c[0], p[0], n + 1, o, s, l), intersectsImpl(c[0], p[1], n + 1, o, s, l), intersectsImpl(c[1], p[0], n + 1, o, s, l), intersectsImpl(c[1], p[1], n + 1, o, s, l);
      }
    }
    PolynomialBezier.prototype.intersections = function(e, t, n) {
      t === void 0 && (t = 2), n === void 0 && (n = 7);
      var o = [];
      return intersectsImpl(intersectData(this, 0, 1), intersectData(e, 0, 1), 0, t, o, n), o;
    }, PolynomialBezier.shapeSegment = function(e, t) {
      var n = (t + 1) % e.length();
      return new PolynomialBezier(e.v[t], e.o[t], e.i[n], e.v[n], !0);
    }, PolynomialBezier.shapeSegmentInverted = function(e, t) {
      var n = (t + 1) % e.length();
      return new PolynomialBezier(e.v[n], e.i[n], e.o[t], e.v[t], !0);
    };
    function crossProduct(e, t) {
      return [e[1] * t[2] - e[2] * t[1], e[2] * t[0] - e[0] * t[2], e[0] * t[1] - e[1] * t[0]];
    }
    function lineIntersection(e, t, n, o) {
      var s = [e[0], e[1], 1], l = [t[0], t[1], 1], c = [n[0], n[1], 1], p = [o[0], o[1], 1], m = crossProduct(crossProduct(s, l), crossProduct(c, p));
      return floatZero(m[2]) ? null : [m[0] / m[2], m[1] / m[2]];
    }
    function polarOffset(e, t, n) {
      return [e[0] + Math.cos(t) * n, e[1] - Math.sin(t) * n];
    }
    function pointDistance(e, t) {
      return Math.hypot(e[0] - t[0], e[1] - t[1]);
    }
    function pointEqual(e, t) {
      return floatEqual(e[0], t[0]) && floatEqual(e[1], t[1]);
    }
    function ZigZagModifier() {
    }
    extendPrototype([ShapeModifier], ZigZagModifier), ZigZagModifier.prototype.initModifierProperties = function(e, t) {
      this.getValue = this.processKeys, this.amplitude = PropertyFactory.getProp(e, t.s, 0, null, this), this.frequency = PropertyFactory.getProp(e, t.r, 0, null, this), this.pointsType = PropertyFactory.getProp(e, t.pt, 0, null, this), this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
    };
    function setPoint(e, t, n, o, s, l, c) {
      var p = n - Math.PI / 2, m = n + Math.PI / 2, C = t[0] + Math.cos(n) * o * s, P = t[1] - Math.sin(n) * o * s;
      e.setTripleAt(C, P, C + Math.cos(p) * l, P - Math.sin(p) * l, C + Math.cos(m) * c, P - Math.sin(m) * c, e.length());
    }
    function getPerpendicularVector(e, t) {
      var n = [t[0] - e[0], t[1] - e[1]], o = -Math.PI * 0.5, s = [Math.cos(o) * n[0] - Math.sin(o) * n[1], Math.sin(o) * n[0] + Math.cos(o) * n[1]];
      return s;
    }
    function getProjectingAngle(e, t) {
      var n = t === 0 ? e.length() - 1 : t - 1, o = (t + 1) % e.length(), s = e.v[n], l = e.v[o], c = getPerpendicularVector(s, l);
      return Math.atan2(0, 1) - Math.atan2(c[1], c[0]);
    }
    function zigZagCorner(e, t, n, o, s, l, c) {
      var p = getProjectingAngle(t, n), m = t.v[n % t._length], C = t.v[n === 0 ? t._length - 1 : n - 1], P = t.v[(n + 1) % t._length], w = l === 2 ? Math.sqrt(Math.pow(m[0] - C[0], 2) + Math.pow(m[1] - C[1], 2)) : 0, R = l === 2 ? Math.sqrt(Math.pow(m[0] - P[0], 2) + Math.pow(m[1] - P[1], 2)) : 0;
      setPoint(e, t.v[n % t._length], p, c, o, R / ((s + 1) * 2), w / ((s + 1) * 2));
    }
    function zigZagSegment(e, t, n, o, s, l) {
      for (var c = 0; c < o; c += 1) {
        var p = (c + 1) / (o + 1), m = s === 2 ? Math.sqrt(Math.pow(t.points[3][0] - t.points[0][0], 2) + Math.pow(t.points[3][1] - t.points[0][1], 2)) : 0, C = t.normalAngle(p), P = t.point(p);
        setPoint(e, P, C, l, n, m / ((o + 1) * 2), m / ((o + 1) * 2)), l = -l;
      }
      return l;
    }
    ZigZagModifier.prototype.processPath = function(e, t, n, o) {
      var s = e._length, l = shapePool.newElement();
      if (l.c = e.c, e.c || (s -= 1), s === 0)
        return l;
      var c = -1, p = PolynomialBezier.shapeSegment(e, 0);
      zigZagCorner(l, e, 0, t, n, o, c);
      for (var m = 0; m < s; m += 1)
        c = zigZagSegment(l, p, t, n, o, -c), m === s - 1 && !e.c ? p = null : p = PolynomialBezier.shapeSegment(e, (m + 1) % s), zigZagCorner(l, e, m + 1, t, n, o, c);
      return l;
    }, ZigZagModifier.prototype.processShapes = function(e) {
      var t, n, o = this.shapes.length, s, l, c = this.amplitude.v, p = Math.max(0, Math.round(this.frequency.v)), m = this.pointsType.v;
      if (c !== 0) {
        var C, P;
        for (n = 0; n < o; n += 1) {
          if (C = this.shapes[n], P = C.localShapeCollection, !(!C.shape._mdf && !this._mdf && !e))
            for (P.releaseShapes(), C.shape._mdf = !0, t = C.shape.paths.shapes, l = C.shape.paths._length, s = 0; s < l; s += 1)
              P.addShape(this.processPath(t[s], c, p, m));
          C.shape.paths = C.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    function linearOffset(e, t, n) {
      var o = Math.atan2(t[0] - e[0], t[1] - e[1]);
      return [polarOffset(e, o, n), polarOffset(t, o, n)];
    }
    function offsetSegment(e, t) {
      var n, o, s, l, c, p, m;
      m = linearOffset(e.points[0], e.points[1], t), n = m[0], o = m[1], m = linearOffset(e.points[1], e.points[2], t), s = m[0], l = m[1], m = linearOffset(e.points[2], e.points[3], t), c = m[0], p = m[1];
      var C = lineIntersection(n, o, s, l);
      C === null && (C = o);
      var P = lineIntersection(c, p, s, l);
      return P === null && (P = c), new PolynomialBezier(n, C, P, p);
    }
    function joinLines(e, t, n, o, s) {
      var l = t.points[3], c = n.points[0];
      if (o === 3 || pointEqual(l, c))
        return l;
      if (o === 2) {
        var p = -t.tangentAngle(1), m = -n.tangentAngle(0) + Math.PI, C = lineIntersection(l, polarOffset(l, p + Math.PI / 2, 100), c, polarOffset(c, p + Math.PI / 2, 100)), P = C ? pointDistance(C, l) : pointDistance(l, c) / 2, w = polarOffset(l, p, 2 * P * roundCorner);
        return e.setXYAt(w[0], w[1], "o", e.length() - 1), w = polarOffset(c, m, 2 * P * roundCorner), e.setTripleAt(c[0], c[1], c[0], c[1], w[0], w[1], e.length()), c;
      }
      var R = pointEqual(l, t.points[2]) ? t.points[0] : t.points[2], L = pointEqual(c, n.points[1]) ? n.points[3] : n.points[1], M = lineIntersection(R, l, c, L);
      return M && pointDistance(M, l) < s ? (e.setTripleAt(M[0], M[1], M[0], M[1], M[0], M[1], e.length()), M) : l;
    }
    function getIntersection(e, t) {
      var n = e.intersections(t);
      return n.length && floatEqual(n[0][0], 1) && n.shift(), n.length ? n[0] : null;
    }
    function pruneSegmentIntersection(e, t) {
      var n = e.slice(), o = t.slice(), s = getIntersection(e[e.length - 1], t[0]);
      return s && (n[e.length - 1] = e[e.length - 1].split(s[0])[0], o[0] = t[0].split(s[1])[1]), e.length > 1 && t.length > 1 && (s = getIntersection(e[0], t[t.length - 1]), s) ? [[e[0].split(s[0])[0]], [t[t.length - 1].split(s[1])[1]]] : [n, o];
    }
    function pruneIntersections(e) {
      for (var t, n = 1; n < e.length; n += 1)
        t = pruneSegmentIntersection(e[n - 1], e[n]), e[n - 1] = t[0], e[n] = t[1];
      return e.length > 1 && (t = pruneSegmentIntersection(e[e.length - 1], e[0]), e[e.length - 1] = t[0], e[0] = t[1]), e;
    }
    function offsetSegmentSplit(e, t) {
      var n = e.inflectionPoints(), o, s, l, c;
      if (n.length === 0)
        return [offsetSegment(e, t)];
      if (n.length === 1 || floatEqual(n[1], 1))
        return l = e.split(n[0]), o = l[0], s = l[1], [offsetSegment(o, t), offsetSegment(s, t)];
      l = e.split(n[0]), o = l[0];
      var p = (n[1] - n[0]) / (1 - n[0]);
      return l = l[1].split(p), c = l[0], s = l[1], [offsetSegment(o, t), offsetSegment(c, t), offsetSegment(s, t)];
    }
    function OffsetPathModifier() {
    }
    extendPrototype([ShapeModifier], OffsetPathModifier), OffsetPathModifier.prototype.initModifierProperties = function(e, t) {
      this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(e, t.a, 0, null, this), this.miterLimit = PropertyFactory.getProp(e, t.ml, 0, null, this), this.lineJoin = t.lj, this._isAnimated = this.amount.effectsSequence.length !== 0;
    }, OffsetPathModifier.prototype.processPath = function(e, t, n, o) {
      var s = shapePool.newElement();
      s.c = e.c;
      var l = e.length();
      e.c || (l -= 1);
      var c, p, m, C = [];
      for (c = 0; c < l; c += 1)
        m = PolynomialBezier.shapeSegment(e, c), C.push(offsetSegmentSplit(m, t));
      if (!e.c)
        for (c = l - 1; c >= 0; c -= 1)
          m = PolynomialBezier.shapeSegmentInverted(e, c), C.push(offsetSegmentSplit(m, t));
      C = pruneIntersections(C);
      var P = null, w = null;
      for (c = 0; c < C.length; c += 1) {
        var R = C[c];
        for (w && (P = joinLines(s, w, R[0], n, o)), w = R[R.length - 1], p = 0; p < R.length; p += 1)
          m = R[p], P && pointEqual(m.points[0], P) ? s.setXYAt(m.points[1][0], m.points[1][1], "o", s.length() - 1) : s.setTripleAt(m.points[0][0], m.points[0][1], m.points[1][0], m.points[1][1], m.points[0][0], m.points[0][1], s.length()), s.setTripleAt(m.points[3][0], m.points[3][1], m.points[3][0], m.points[3][1], m.points[2][0], m.points[2][1], s.length()), P = m.points[3];
      }
      return C.length && joinLines(s, w, C[0][0], n, o), s;
    }, OffsetPathModifier.prototype.processShapes = function(e) {
      var t, n, o = this.shapes.length, s, l, c = this.amount.v, p = this.miterLimit.v, m = this.lineJoin;
      if (c !== 0) {
        var C, P;
        for (n = 0; n < o; n += 1) {
          if (C = this.shapes[n], P = C.localShapeCollection, !(!C.shape._mdf && !this._mdf && !e))
            for (P.releaseShapes(), C.shape._mdf = !0, t = C.shape.paths.shapes, l = C.shape.paths._length, s = 0; s < l; s += 1)
              P.addShape(this.processPath(t[s], c, m, p));
          C.shape.paths = C.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    function getFontProperties(e) {
      for (var t = e.fStyle ? e.fStyle.split(" ") : [], n = "normal", o = "normal", s = t.length, l, c = 0; c < s; c += 1)
        switch (l = t[c].toLowerCase(), l) {
          case "italic":
            o = "italic";
            break;
          case "bold":
            n = "700";
            break;
          case "black":
            n = "900";
            break;
          case "medium":
            n = "500";
            break;
          case "regular":
          case "normal":
            n = "400";
            break;
          case "light":
          case "thin":
            n = "200";
            break;
        }
      return {
        style: o,
        weight: e.fWeight || n
      };
    }
    var FontManager = function() {
      var e = 5e3, t = {
        w: 0,
        size: 0,
        shapes: [],
        data: {
          shapes: []
        }
      }, n = [];
      n = n.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);
      var o = 127988, s = 917631, l = 917601, c = 917626, p = 65039, m = 8205, C = 127462, P = 127487, w = ["d83cdffb", "d83cdffc", "d83cdffd", "d83cdffe", "d83cdfff"];
      function R(he) {
        var be = he.split(","), le, fe = be.length, ye = [];
        for (le = 0; le < fe; le += 1)
          be[le] !== "sans-serif" && be[le] !== "monospace" && ye.push(be[le]);
        return ye.join(",");
      }
      function L(he, be) {
        var le = createTag("span");
        le.setAttribute("aria-hidden", !0), le.style.fontFamily = be;
        var fe = createTag("span");
        fe.innerText = "giItT1WQy@!-/#", le.style.position = "absolute", le.style.left = "-10000px", le.style.top = "-10000px", le.style.fontSize = "300px", le.style.fontVariant = "normal", le.style.fontStyle = "normal", le.style.fontWeight = "normal", le.style.letterSpacing = "0", le.appendChild(fe), document.body.appendChild(le);
        var ye = fe.offsetWidth;
        return fe.style.fontFamily = R(he) + ", " + be, {
          node: fe,
          w: ye,
          parent: le
        };
      }
      function M() {
        var he, be = this.fonts.length, le, fe, ye = be;
        for (he = 0; he < be; he += 1)
          this.fonts[he].loaded ? ye -= 1 : this.fonts[he].fOrigin === "n" || this.fonts[he].origin === 0 ? this.fonts[he].loaded = !0 : (le = this.fonts[he].monoCase.node, fe = this.fonts[he].monoCase.w, le.offsetWidth !== fe ? (ye -= 1, this.fonts[he].loaded = !0) : (le = this.fonts[he].sansCase.node, fe = this.fonts[he].sansCase.w, le.offsetWidth !== fe && (ye -= 1, this.fonts[he].loaded = !0)), this.fonts[he].loaded && (this.fonts[he].sansCase.parent.parentNode.removeChild(this.fonts[he].sansCase.parent), this.fonts[he].monoCase.parent.parentNode.removeChild(this.fonts[he].monoCase.parent)));
        ye !== 0 && Date.now() - this.initTime < e ? setTimeout(this.checkLoadedFontsBinded, 20) : setTimeout(this.setIsLoadedBinded, 10);
      }
      function $(he, be) {
        var le = document.body && be ? "svg" : "canvas", fe, ye = getFontProperties(he);
        if (le === "svg") {
          var Ee = createNS("text");
          Ee.style.fontSize = "100px", Ee.setAttribute("font-family", he.fFamily), Ee.setAttribute("font-style", ye.style), Ee.setAttribute("font-weight", ye.weight), Ee.textContent = "1", he.fClass ? (Ee.style.fontFamily = "inherit", Ee.setAttribute("class", he.fClass)) : Ee.style.fontFamily = he.fFamily, be.appendChild(Ee), fe = Ee;
        } else {
          var Ie = new OffscreenCanvas(500, 500).getContext("2d");
          Ie.font = ye.style + " " + ye.weight + " 100px " + he.fFamily, fe = Ie;
        }
        function Fe(De) {
          return le === "svg" ? (fe.textContent = De, fe.getComputedTextLength()) : fe.measureText(De).width;
        }
        return {
          measureText: Fe
        };
      }
      function W(he, be) {
        if (!he) {
          this.isLoaded = !0;
          return;
        }
        if (this.chars) {
          this.isLoaded = !0, this.fonts = he.list;
          return;
        }
        if (!document.body) {
          this.isLoaded = !0, he.list.forEach(function(et) {
            et.helper = $(et), et.cache = {};
          }), this.fonts = he.list;
          return;
        }
        var le = he.list, fe, ye = le.length, Ee = ye;
        for (fe = 0; fe < ye; fe += 1) {
          var Ie = !0, Fe, De;
          if (le[fe].loaded = !1, le[fe].monoCase = L(le[fe].fFamily, "monospace"), le[fe].sansCase = L(le[fe].fFamily, "sans-serif"), !le[fe].fPath)
            le[fe].loaded = !0, Ee -= 1;
          else if (le[fe].fOrigin === "p" || le[fe].origin === 3) {
            if (Fe = document.querySelectorAll('style[f-forigin="p"][f-family="' + le[fe].fFamily + '"], style[f-origin="3"][f-family="' + le[fe].fFamily + '"]'), Fe.length > 0 && (Ie = !1), Ie) {
              var Ve = createTag("style");
              Ve.setAttribute("f-forigin", le[fe].fOrigin), Ve.setAttribute("f-origin", le[fe].origin), Ve.setAttribute("f-family", le[fe].fFamily), Ve.type = "text/css", Ve.innerText = "@font-face {font-family: " + le[fe].fFamily + "; font-style: normal; src: url('" + le[fe].fPath + "');}", be.appendChild(Ve);
            }
          } else if (le[fe].fOrigin === "g" || le[fe].origin === 1) {
            for (Fe = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]'), De = 0; De < Fe.length; De += 1)
              Fe[De].href.indexOf(le[fe].fPath) !== -1 && (Ie = !1);
            if (Ie) {
              var Oe = createTag("link");
              Oe.setAttribute("f-forigin", le[fe].fOrigin), Oe.setAttribute("f-origin", le[fe].origin), Oe.type = "text/css", Oe.rel = "stylesheet", Oe.href = le[fe].fPath, document.body.appendChild(Oe);
            }
          } else if (le[fe].fOrigin === "t" || le[fe].origin === 2) {
            for (Fe = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]'), De = 0; De < Fe.length; De += 1)
              le[fe].fPath === Fe[De].src && (Ie = !1);
            if (Ie) {
              var Ze = createTag("link");
              Ze.setAttribute("f-forigin", le[fe].fOrigin), Ze.setAttribute("f-origin", le[fe].origin), Ze.setAttribute("rel", "stylesheet"), Ze.setAttribute("href", le[fe].fPath), be.appendChild(Ze);
            }
          }
          le[fe].helper = $(le[fe], be), le[fe].cache = {}, this.fonts.push(le[fe]);
        }
        Ee === 0 ? this.isLoaded = !0 : setTimeout(this.checkLoadedFonts.bind(this), 100);
      }
      function H(he) {
        if (he) {
          this.chars || (this.chars = []);
          var be, le = he.length, fe, ye = this.chars.length, Ee;
          for (be = 0; be < le; be += 1) {
            for (fe = 0, Ee = !1; fe < ye; )
              this.chars[fe].style === he[be].style && this.chars[fe].fFamily === he[be].fFamily && this.chars[fe].ch === he[be].ch && (Ee = !0), fe += 1;
            Ee || (this.chars.push(he[be]), ye += 1);
          }
        }
      }
      function V(he, be, le) {
        for (var fe = 0, ye = this.chars.length; fe < ye; ) {
          if (this.chars[fe].ch === he && this.chars[fe].style === be && this.chars[fe].fFamily === le)
            return this.chars[fe];
          fe += 1;
        }
        return (typeof he == "string" && he.charCodeAt(0) !== 13 || !he) && console && console.warn && !this._warned && (this._warned = !0, console.warn("Missing character from exported characters list: ", he, be, le)), t;
      }
      function N(he, be, le) {
        var fe = this.getFontByName(be), ye = he;
        if (!fe.cache[ye]) {
          var Ee = fe.helper;
          if (he === " ") {
            var Ie = Ee.measureText("|" + he + "|"), Fe = Ee.measureText("||");
            fe.cache[ye] = (Ie - Fe) / 100;
          } else
            fe.cache[ye] = Ee.measureText(he) / 100;
        }
        return fe.cache[ye] * le;
      }
      function B(he) {
        for (var be = 0, le = this.fonts.length; be < le; ) {
          if (this.fonts[be].fName === he)
            return this.fonts[be];
          be += 1;
        }
        return this.fonts[0];
      }
      function K(he) {
        var be = 0, le = he.charCodeAt(0);
        if (le >= 55296 && le <= 56319) {
          var fe = he.charCodeAt(1);
          fe >= 56320 && fe <= 57343 && (be = (le - 55296) * 1024 + fe - 56320 + 65536);
        }
        return be;
      }
      function ue(he, be) {
        var le = he.toString(16) + be.toString(16);
        return w.indexOf(le) !== -1;
      }
      function de(he) {
        return he === m;
      }
      function ve(he) {
        return he === p;
      }
      function Te(he) {
        var be = K(he);
        return be >= C && be <= P;
      }
      function Pe(he) {
        return Te(he.substr(0, 2)) && Te(he.substr(2, 2));
      }
      function Ce(he) {
        return n.indexOf(he) !== -1;
      }
      function Re(he, be) {
        var le = K(he.substr(be, 2));
        if (le !== o)
          return !1;
        var fe = 0;
        for (be += 2; fe < 5; ) {
          if (le = K(he.substr(be, 2)), le < l || le > c)
            return !1;
          fe += 1, be += 2;
        }
        return K(he.substr(be, 2)) === s;
      }
      function ke() {
        this.isLoaded = !0;
      }
      var Ae = function() {
        this.fonts = [], this.chars = null, this.typekitLoaded = 0, this.isLoaded = !1, this._warned = !1, this.initTime = Date.now(), this.setIsLoadedBinded = this.setIsLoaded.bind(this), this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
      };
      Ae.isModifier = ue, Ae.isZeroWidthJoiner = de, Ae.isFlagEmoji = Pe, Ae.isRegionalCode = Te, Ae.isCombinedCharacter = Ce, Ae.isRegionalFlag = Re, Ae.isVariationSelector = ve, Ae.BLACK_FLAG_CODE_POINT = o;
      var we = {
        addChars: H,
        addFonts: W,
        getCharData: V,
        getFontByName: B,
        measureText: N,
        checkLoadedFonts: M,
        setIsLoaded: ke
      };
      return Ae.prototype = we, Ae;
    }();
    function SlotManager(e) {
      this.animationData = e;
    }
    SlotManager.prototype.getProp = function(e) {
      return this.animationData.slots && this.animationData.slots[e.sid] ? Object.assign(e, this.animationData.slots[e.sid].p) : e;
    };
    function slotFactory(e) {
      return new SlotManager(e);
    }
    function RenderableElement() {
    }
    RenderableElement.prototype = {
      initRenderable: function() {
        this.isInRange = !1, this.hidden = !1, this.isTransparent = !1, this.renderableComponents = [];
      },
      addRenderableComponent: function(t) {
        this.renderableComponents.indexOf(t) === -1 && this.renderableComponents.push(t);
      },
      removeRenderableComponent: function(t) {
        this.renderableComponents.indexOf(t) !== -1 && this.renderableComponents.splice(this.renderableComponents.indexOf(t), 1);
      },
      prepareRenderableFrame: function(t) {
        this.checkLayerLimits(t);
      },
      checkTransparency: function() {
        this.finalTransform.mProp.o.v <= 0 ? !this.isTransparent && this.globalData.renderConfig.hideOnTransparent && (this.isTransparent = !0, this.hide()) : this.isTransparent && (this.isTransparent = !1, this.show());
      },
      /**
         * @function
         * Initializes frame related properties.
         *
         * @param {number} num
         * current frame number in Layer's time
         *
         */
      checkLayerLimits: function(t) {
        this.data.ip - this.data.st <= t && this.data.op - this.data.st > t ? this.isInRange !== !0 && (this.globalData._mdf = !0, this._mdf = !0, this.isInRange = !0, this.show()) : this.isInRange !== !1 && (this.globalData._mdf = !0, this.isInRange = !1, this.hide());
      },
      renderRenderable: function() {
        var t, n = this.renderableComponents.length;
        for (t = 0; t < n; t += 1)
          this.renderableComponents[t].renderFrame(this._isFirstFrame);
      },
      sourceRectAtTime: function() {
        return {
          top: 0,
          left: 0,
          width: 100,
          height: 100
        };
      },
      getLayerSize: function() {
        return this.data.ty === 5 ? {
          w: this.data.textData.width,
          h: this.data.textData.height
        } : {
          w: this.data.width,
          h: this.data.height
        };
      }
    };
    var getBlendMode = function() {
      var e = {
        0: "source-over",
        1: "multiply",
        2: "screen",
        3: "overlay",
        4: "darken",
        5: "lighten",
        6: "color-dodge",
        7: "color-burn",
        8: "hard-light",
        9: "soft-light",
        10: "difference",
        11: "exclusion",
        12: "hue",
        13: "saturation",
        14: "color",
        15: "luminosity"
      };
      return function(t) {
        return e[t] || "";
      };
    }();
    function SliderEffect(e, t, n) {
      this.p = PropertyFactory.getProp(t, e.v, 0, 0, n);
    }
    function AngleEffect(e, t, n) {
      this.p = PropertyFactory.getProp(t, e.v, 0, 0, n);
    }
    function ColorEffect(e, t, n) {
      this.p = PropertyFactory.getProp(t, e.v, 1, 0, n);
    }
    function PointEffect(e, t, n) {
      this.p = PropertyFactory.getProp(t, e.v, 1, 0, n);
    }
    function LayerIndexEffect(e, t, n) {
      this.p = PropertyFactory.getProp(t, e.v, 0, 0, n);
    }
    function MaskIndexEffect(e, t, n) {
      this.p = PropertyFactory.getProp(t, e.v, 0, 0, n);
    }
    function CheckboxEffect(e, t, n) {
      this.p = PropertyFactory.getProp(t, e.v, 0, 0, n);
    }
    function NoValueEffect() {
      this.p = {};
    }
    function EffectsManager(e, t) {
      var n = e.ef || [];
      this.effectElements = [];
      var o, s = n.length, l;
      for (o = 0; o < s; o += 1)
        l = new GroupEffect(n[o], t), this.effectElements.push(l);
    }
    function GroupEffect(e, t) {
      this.init(e, t);
    }
    extendPrototype([DynamicPropertyContainer], GroupEffect), GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties, GroupEffect.prototype.init = function(e, t) {
      this.data = e, this.effectElements = [], this.initDynamicPropertyContainer(t);
      var n, o = this.data.ef.length, s, l = this.data.ef;
      for (n = 0; n < o; n += 1) {
        switch (s = null, l[n].ty) {
          case 0:
            s = new SliderEffect(l[n], t, this);
            break;
          case 1:
            s = new AngleEffect(l[n], t, this);
            break;
          case 2:
            s = new ColorEffect(l[n], t, this);
            break;
          case 3:
            s = new PointEffect(l[n], t, this);
            break;
          case 4:
          case 7:
            s = new CheckboxEffect(l[n], t, this);
            break;
          case 10:
            s = new LayerIndexEffect(l[n], t, this);
            break;
          case 11:
            s = new MaskIndexEffect(l[n], t, this);
            break;
          case 5:
            s = new EffectsManager(l[n], t);
            break;
          default:
            s = new NoValueEffect(l[n]);
            break;
        }
        s && this.effectElements.push(s);
      }
    };
    function BaseElement() {
    }
    BaseElement.prototype = {
      checkMasks: function() {
        if (!this.data.hasMask)
          return !1;
        for (var t = 0, n = this.data.masksProperties.length; t < n; ) {
          if (this.data.masksProperties[t].mode !== "n" && this.data.masksProperties[t].cl !== !1)
            return !0;
          t += 1;
        }
        return !1;
      },
      initExpressions: function() {
        var t = getExpressionInterfaces();
        if (t) {
          var n = t("layer"), o = t("effects"), s = t("shape"), l = t("text"), c = t("comp");
          this.layerInterface = n(this), this.data.hasMask && this.maskManager && this.layerInterface.registerMaskInterface(this.maskManager);
          var p = o.createEffectsInterface(this, this.layerInterface);
          this.layerInterface.registerEffectsInterface(p), this.data.ty === 0 || this.data.xt ? this.compInterface = c(this) : this.data.ty === 4 ? (this.layerInterface.shapeInterface = s(this.shapesData, this.itemsData, this.layerInterface), this.layerInterface.content = this.layerInterface.shapeInterface) : this.data.ty === 5 && (this.layerInterface.textInterface = l(this), this.layerInterface.text = this.layerInterface.textInterface);
        }
      },
      setBlendMode: function() {
        var t = getBlendMode(this.data.bm), n = this.baseElement || this.layerElement;
        n.style["mix-blend-mode"] = t;
      },
      initBaseData: function(t, n, o) {
        this.globalData = n, this.comp = o, this.data = t, this.layerId = createElementID(), this.data.sr || (this.data.sr = 1), this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
      },
      getType: function() {
        return this.type;
      },
      sourceRectAtTime: function() {
      }
    };
    function FrameElement() {
    }
    FrameElement.prototype = {
      /**
         * @function
         * Initializes frame related properties.
         *
         */
      initFrame: function() {
        this._isFirstFrame = !1, this.dynamicProperties = [], this._mdf = !1;
      },
      /**
         * @function
         * Calculates all dynamic values
         *
         * @param {number} num
         * current frame number in Layer's time
         * @param {boolean} isVisible
         * if layers is currently in range
         *
         */
      prepareProperties: function(t, n) {
        var o, s = this.dynamicProperties.length;
        for (o = 0; o < s; o += 1)
          (n || this._isParent && this.dynamicProperties[o].propType === "transform") && (this.dynamicProperties[o].getValue(), this.dynamicProperties[o]._mdf && (this.globalData._mdf = !0, this._mdf = !0));
      },
      addDynamicProperty: function(t) {
        this.dynamicProperties.indexOf(t) === -1 && this.dynamicProperties.push(t);
      }
    };
    function FootageElement(e, t, n) {
      this.initFrame(), this.initRenderable(), this.assetData = t.getAssetData(e.refId), this.footageData = t.imageLoader.getAsset(this.assetData), this.initBaseData(e, t, n);
    }
    FootageElement.prototype.prepareFrame = function() {
    }, extendPrototype([RenderableElement, BaseElement, FrameElement], FootageElement), FootageElement.prototype.getBaseElement = function() {
      return null;
    }, FootageElement.prototype.renderFrame = function() {
    }, FootageElement.prototype.destroy = function() {
    }, FootageElement.prototype.initExpressions = function() {
      var e = getExpressionInterfaces();
      if (e) {
        var t = e("footage");
        this.layerInterface = t(this);
      }
    }, FootageElement.prototype.getFootageData = function() {
      return this.footageData;
    };
    function AudioElement(e, t, n) {
      this.initFrame(), this.initRenderable(), this.assetData = t.getAssetData(e.refId), this.initBaseData(e, t, n), this._isPlaying = !1, this._canPlay = !1;
      var o = this.globalData.getAssetsPath(this.assetData);
      this.audio = this.globalData.audioController.createAudio(o), this._currentTime = 0, this.globalData.audioController.addAudio(this), this._volumeMultiplier = 1, this._volume = 1, this._previousVolume = null, this.tm = e.tm ? PropertyFactory.getProp(this, e.tm, 0, t.frameRate, this) : {
        _placeholder: !0
      }, this.lv = PropertyFactory.getProp(this, e.au && e.au.lv ? e.au.lv : {
        k: [100]
      }, 1, 0.01, this);
    }
    AudioElement.prototype.prepareFrame = function(e) {
      if (this.prepareRenderableFrame(e, !0), this.prepareProperties(e, !0), this.tm._placeholder)
        this._currentTime = e / this.data.sr;
      else {
        var t = this.tm.v;
        this._currentTime = t;
      }
      this._volume = this.lv.v[0];
      var n = this._volume * this._volumeMultiplier;
      this._previousVolume !== n && (this._previousVolume = n, this.audio.volume(n));
    }, extendPrototype([RenderableElement, BaseElement, FrameElement], AudioElement), AudioElement.prototype.renderFrame = function() {
      this.isInRange && this._canPlay && (this._isPlaying ? (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) && this.audio.seek(this._currentTime / this.globalData.frameRate) : (this.audio.play(), this.audio.seek(this._currentTime / this.globalData.frameRate), this._isPlaying = !0));
    }, AudioElement.prototype.show = function() {
    }, AudioElement.prototype.hide = function() {
      this.audio.pause(), this._isPlaying = !1;
    }, AudioElement.prototype.pause = function() {
      this.audio.pause(), this._isPlaying = !1, this._canPlay = !1;
    }, AudioElement.prototype.resume = function() {
      this._canPlay = !0;
    }, AudioElement.prototype.setRate = function(e) {
      this.audio.rate(e);
    }, AudioElement.prototype.volume = function(e) {
      this._volumeMultiplier = e, this._previousVolume = e * this._volume, this.audio.volume(this._previousVolume);
    }, AudioElement.prototype.getBaseElement = function() {
      return null;
    }, AudioElement.prototype.destroy = function() {
    }, AudioElement.prototype.sourceRectAtTime = function() {
    }, AudioElement.prototype.initExpressions = function() {
    };
    function BaseRenderer() {
    }
    BaseRenderer.prototype.checkLayers = function(e) {
      var t, n = this.layers.length, o;
      for (this.completeLayers = !0, t = n - 1; t >= 0; t -= 1)
        this.elements[t] || (o = this.layers[t], o.ip - o.st <= e - this.layers[t].st && o.op - o.st > e - this.layers[t].st && this.buildItem(t)), this.completeLayers = this.elements[t] ? this.completeLayers : !1;
      this.checkPendingElements();
    }, BaseRenderer.prototype.createItem = function(e) {
      switch (e.ty) {
        case 2:
          return this.createImage(e);
        case 0:
          return this.createComp(e);
        case 1:
          return this.createSolid(e);
        case 3:
          return this.createNull(e);
        case 4:
          return this.createShape(e);
        case 5:
          return this.createText(e);
        case 6:
          return this.createAudio(e);
        case 13:
          return this.createCamera(e);
        case 15:
          return this.createFootage(e);
        default:
          return this.createNull(e);
      }
    }, BaseRenderer.prototype.createCamera = function() {
      throw new Error("You're using a 3d camera. Try the html renderer.");
    }, BaseRenderer.prototype.createAudio = function(e) {
      return new AudioElement(e, this.globalData, this);
    }, BaseRenderer.prototype.createFootage = function(e) {
      return new FootageElement(e, this.globalData, this);
    }, BaseRenderer.prototype.buildAllItems = function() {
      var e, t = this.layers.length;
      for (e = 0; e < t; e += 1)
        this.buildItem(e);
      this.checkPendingElements();
    }, BaseRenderer.prototype.includeLayers = function(e) {
      this.completeLayers = !1;
      var t, n = e.length, o, s = this.layers.length;
      for (t = 0; t < n; t += 1)
        for (o = 0; o < s; ) {
          if (this.layers[o].id === e[t].id) {
            this.layers[o] = e[t];
            break;
          }
          o += 1;
        }
    }, BaseRenderer.prototype.setProjectInterface = function(e) {
      this.globalData.projectInterface = e;
    }, BaseRenderer.prototype.initItems = function() {
      this.globalData.progressiveLoad || this.buildAllItems();
    }, BaseRenderer.prototype.buildElementParenting = function(e, t, n) {
      for (var o = this.elements, s = this.layers, l = 0, c = s.length; l < c; )
        s[l].ind == t && (!o[l] || o[l] === !0 ? (this.buildItem(l), this.addPendingElement(e)) : (n.push(o[l]), o[l].setAsParent(), s[l].parent !== void 0 ? this.buildElementParenting(e, s[l].parent, n) : e.setHierarchy(n))), l += 1;
    }, BaseRenderer.prototype.addPendingElement = function(e) {
      this.pendingElements.push(e);
    }, BaseRenderer.prototype.searchExtraCompositions = function(e) {
      var t, n = e.length;
      for (t = 0; t < n; t += 1)
        if (e[t].xt) {
          var o = this.createComp(e[t]);
          o.initExpressions(), this.globalData.projectInterface.registerComposition(o);
        }
    }, BaseRenderer.prototype.getElementById = function(e) {
      var t, n = this.elements.length;
      for (t = 0; t < n; t += 1)
        if (this.elements[t].data.ind === e)
          return this.elements[t];
      return null;
    }, BaseRenderer.prototype.getElementByPath = function(e) {
      var t = e.shift(), n;
      if (typeof t == "number")
        n = this.elements[t];
      else {
        var o, s = this.elements.length;
        for (o = 0; o < s; o += 1)
          if (this.elements[o].data.nm === t) {
            n = this.elements[o];
            break;
          }
      }
      return e.length === 0 ? n : n.getElementByPath(e);
    }, BaseRenderer.prototype.setupGlobalData = function(e, t) {
      this.globalData.fontManager = new FontManager(), this.globalData.slotManager = slotFactory(e), this.globalData.fontManager.addChars(e.chars), this.globalData.fontManager.addFonts(e.fonts, t), this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem), this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem), this.globalData.imageLoader = this.animationItem.imagePreloader, this.globalData.audioController = this.animationItem.audioController, this.globalData.frameId = 0, this.globalData.frameRate = e.fr, this.globalData.nm = e.nm, this.globalData.compSize = {
        w: e.w,
        h: e.h
      };
    };
    var effectTypes = {
      TRANSFORM_EFFECT: "transformEFfect"
    };
    function TransformElement() {
    }
    TransformElement.prototype = {
      initTransform: function() {
        var t = new Matrix();
        this.finalTransform = {
          mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
            o: 0
          },
          _matMdf: !1,
          _localMatMdf: !1,
          _opMdf: !1,
          mat: t,
          localMat: t,
          localOpacity: 1
        }, this.data.ao && (this.finalTransform.mProp.autoOriented = !0), this.data.ty;
      },
      renderTransform: function() {
        if (this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame, this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame, this.hierarchy) {
          var t, n = this.finalTransform.mat, o = 0, s = this.hierarchy.length;
          if (!this.finalTransform._matMdf)
            for (; o < s; ) {
              if (this.hierarchy[o].finalTransform.mProp._mdf) {
                this.finalTransform._matMdf = !0;
                break;
              }
              o += 1;
            }
          if (this.finalTransform._matMdf)
            for (t = this.finalTransform.mProp.v.props, n.cloneFromProps(t), o = 0; o < s; o += 1)
              n.multiply(this.hierarchy[o].finalTransform.mProp.v);
        }
        this.finalTransform._matMdf && (this.finalTransform._localMatMdf = this.finalTransform._matMdf), this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v);
      },
      renderLocalTransform: function() {
        if (this.localTransforms) {
          var t = 0, n = this.localTransforms.length;
          if (this.finalTransform._localMatMdf = this.finalTransform._matMdf, !this.finalTransform._localMatMdf || !this.finalTransform._opMdf)
            for (; t < n; )
              this.localTransforms[t]._mdf && (this.finalTransform._localMatMdf = !0), this.localTransforms[t]._opMdf && !this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v, this.finalTransform._opMdf = !0), t += 1;
          if (this.finalTransform._localMatMdf) {
            var o = this.finalTransform.localMat;
            for (this.localTransforms[0].matrix.clone(o), t = 1; t < n; t += 1) {
              var s = this.localTransforms[t].matrix;
              o.multiply(s);
            }
            o.multiply(this.finalTransform.mat);
          }
          if (this.finalTransform._opMdf) {
            var l = this.finalTransform.localOpacity;
            for (t = 0; t < n; t += 1)
              l *= this.localTransforms[t].opacity * 0.01;
            this.finalTransform.localOpacity = l;
          }
        }
      },
      searchEffectTransforms: function() {
        if (this.renderableEffectsManager) {
          var t = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
          if (t.length) {
            this.localTransforms = [], this.finalTransform.localMat = new Matrix();
            var n = 0, o = t.length;
            for (n = 0; n < o; n += 1)
              this.localTransforms.push(t[n]);
          }
        }
      },
      globalToLocal: function(t) {
        var n = [];
        n.push(this.finalTransform);
        for (var o = !0, s = this.comp; o; )
          s.finalTransform ? (s.data.hasMask && n.splice(0, 0, s.finalTransform), s = s.comp) : o = !1;
        var l, c = n.length, p;
        for (l = 0; l < c; l += 1)
          p = n[l].mat.applyToPointArray(0, 0, 0), t = [t[0] - p[0], t[1] - p[1], 0];
        return t;
      },
      mHelper: new Matrix()
    };
    function MaskElement(e, t, n) {
      this.data = e, this.element = t, this.globalData = n, this.storedData = [], this.masksProperties = this.data.masksProperties || [], this.maskElement = null;
      var o = this.globalData.defs, s, l = this.masksProperties ? this.masksProperties.length : 0;
      this.viewData = createSizedArray(l), this.solidPath = "";
      var c, p = this.masksProperties, m = 0, C = [], P, w, R = createElementID(), L, M, $, W, H = "clipPath", V = "clip-path";
      for (s = 0; s < l; s += 1)
        if ((p[s].mode !== "a" && p[s].mode !== "n" || p[s].inv || p[s].o.k !== 100 || p[s].o.x) && (H = "mask", V = "mask"), (p[s].mode === "s" || p[s].mode === "i") && m === 0 ? (L = createNS("rect"), L.setAttribute("fill", "#ffffff"), L.setAttribute("width", this.element.comp.data.w || 0), L.setAttribute("height", this.element.comp.data.h || 0), C.push(L)) : L = null, c = createNS("path"), p[s].mode === "n")
          this.viewData[s] = {
            op: PropertyFactory.getProp(this.element, p[s].o, 0, 0.01, this.element),
            prop: ShapePropertyFactory.getShapeProp(this.element, p[s], 3),
            elem: c,
            lastPath: ""
          }, o.appendChild(c);
        else {
          m += 1, c.setAttribute("fill", p[s].mode === "s" ? "#000000" : "#ffffff"), c.setAttribute("clip-rule", "nonzero");
          var N;
          if (p[s].x.k !== 0 ? (H = "mask", V = "mask", W = PropertyFactory.getProp(this.element, p[s].x, 0, null, this.element), N = createElementID(), M = createNS("filter"), M.setAttribute("id", N), $ = createNS("feMorphology"), $.setAttribute("operator", "erode"), $.setAttribute("in", "SourceGraphic"), $.setAttribute("radius", "0"), M.appendChild($), o.appendChild(M), c.setAttribute("stroke", p[s].mode === "s" ? "#000000" : "#ffffff")) : ($ = null, W = null), this.storedData[s] = {
            elem: c,
            x: W,
            expan: $,
            lastPath: "",
            lastOperator: "",
            filterId: N,
            lastRadius: 0
          }, p[s].mode === "i") {
            w = C.length;
            var B = createNS("g");
            for (P = 0; P < w; P += 1)
              B.appendChild(C[P]);
            var K = createNS("mask");
            K.setAttribute("mask-type", "alpha"), K.setAttribute("id", R + "_" + m), K.appendChild(c), o.appendChild(K), B.setAttribute("mask", "url(" + getLocationHref() + "#" + R + "_" + m + ")"), C.length = 0, C.push(B);
          } else
            C.push(c);
          p[s].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()), this.viewData[s] = {
            elem: c,
            lastPath: "",
            op: PropertyFactory.getProp(this.element, p[s].o, 0, 0.01, this.element),
            prop: ShapePropertyFactory.getShapeProp(this.element, p[s], 3),
            invRect: L
          }, this.viewData[s].prop.k || this.drawPath(p[s], this.viewData[s].prop.v, this.viewData[s]);
        }
      for (this.maskElement = createNS(H), l = C.length, s = 0; s < l; s += 1)
        this.maskElement.appendChild(C[s]);
      m > 0 && (this.maskElement.setAttribute("id", R), this.element.maskedElement.setAttribute(V, "url(" + getLocationHref() + "#" + R + ")"), o.appendChild(this.maskElement)), this.viewData.length && this.element.addRenderableComponent(this);
    }
    MaskElement.prototype.getMaskProperty = function(e) {
      return this.viewData[e].prop;
    }, MaskElement.prototype.renderFrame = function(e) {
      var t = this.element.finalTransform.mat, n, o = this.masksProperties.length;
      for (n = 0; n < o; n += 1)
        if ((this.viewData[n].prop._mdf || e) && this.drawPath(this.masksProperties[n], this.viewData[n].prop.v, this.viewData[n]), (this.viewData[n].op._mdf || e) && this.viewData[n].elem.setAttribute("fill-opacity", this.viewData[n].op.v), this.masksProperties[n].mode !== "n" && (this.viewData[n].invRect && (this.element.finalTransform.mProp._mdf || e) && this.viewData[n].invRect.setAttribute("transform", t.getInverseMatrix().to2dCSS()), this.storedData[n].x && (this.storedData[n].x._mdf || e))) {
          var s = this.storedData[n].expan;
          this.storedData[n].x.v < 0 ? (this.storedData[n].lastOperator !== "erode" && (this.storedData[n].lastOperator = "erode", this.storedData[n].elem.setAttribute("filter", "url(" + getLocationHref() + "#" + this.storedData[n].filterId + ")")), s.setAttribute("radius", -this.storedData[n].x.v)) : (this.storedData[n].lastOperator !== "dilate" && (this.storedData[n].lastOperator = "dilate", this.storedData[n].elem.setAttribute("filter", null)), this.storedData[n].elem.setAttribute("stroke-width", this.storedData[n].x.v * 2));
        }
    }, MaskElement.prototype.getMaskelement = function() {
      return this.maskElement;
    }, MaskElement.prototype.createLayerSolidPath = function() {
      var e = "M0,0 ";
      return e += " h" + this.globalData.compSize.w, e += " v" + this.globalData.compSize.h, e += " h-" + this.globalData.compSize.w, e += " v-" + this.globalData.compSize.h + " ", e;
    }, MaskElement.prototype.drawPath = function(e, t, n) {
      var o = " M" + t.v[0][0] + "," + t.v[0][1], s, l;
      for (l = t._length, s = 1; s < l; s += 1)
        o += " C" + t.o[s - 1][0] + "," + t.o[s - 1][1] + " " + t.i[s][0] + "," + t.i[s][1] + " " + t.v[s][0] + "," + t.v[s][1];
      if (t.c && l > 1 && (o += " C" + t.o[s - 1][0] + "," + t.o[s - 1][1] + " " + t.i[0][0] + "," + t.i[0][1] + " " + t.v[0][0] + "," + t.v[0][1]), n.lastPath !== o) {
        var c = "";
        n.elem && (t.c && (c = e.inv ? this.solidPath + o : o), n.elem.setAttribute("d", c)), n.lastPath = o;
      }
    }, MaskElement.prototype.destroy = function() {
      this.element = null, this.globalData = null, this.maskElement = null, this.data = null, this.masksProperties = null;
    };
    var filtersFactory = function() {
      var e = {};
      e.createFilter = t, e.createAlphaToLuminanceFilter = n;
      function t(o, s) {
        var l = createNS("filter");
        return l.setAttribute("id", o), s !== !0 && (l.setAttribute("filterUnits", "objectBoundingBox"), l.setAttribute("x", "0%"), l.setAttribute("y", "0%"), l.setAttribute("width", "100%"), l.setAttribute("height", "100%")), l;
      }
      function n() {
        var o = createNS("feColorMatrix");
        return o.setAttribute("type", "matrix"), o.setAttribute("color-interpolation-filters", "sRGB"), o.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"), o;
      }
      return e;
    }(), featureSupport = function() {
      var e = {
        maskType: !0,
        svgLumaHidden: !0,
        offscreenCanvas: typeof OffscreenCanvas < "u"
      };
      return (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) && (e.maskType = !1), /firefox/i.test(navigator.userAgent) && (e.svgLumaHidden = !1), e;
    }(), registeredEffects$1 = {}, idPrefix = "filter_result_";
    function SVGEffects(e) {
      var t, n = "SourceGraphic", o = e.data.ef ? e.data.ef.length : 0, s = createElementID(), l = filtersFactory.createFilter(s, !0), c = 0;
      this.filters = [];
      var p;
      for (t = 0; t < o; t += 1) {
        p = null;
        var m = e.data.ef[t].ty;
        if (registeredEffects$1[m]) {
          var C = registeredEffects$1[m].effect;
          p = new C(l, e.effectsManager.effectElements[t], e, idPrefix + c, n), n = idPrefix + c, registeredEffects$1[m].countsAsEffect && (c += 1);
        }
        p && this.filters.push(p);
      }
      c && (e.globalData.defs.appendChild(l), e.layerElement.setAttribute("filter", "url(" + getLocationHref() + "#" + s + ")")), this.filters.length && e.addRenderableComponent(this);
    }
    SVGEffects.prototype.renderFrame = function(e) {
      var t, n = this.filters.length;
      for (t = 0; t < n; t += 1)
        this.filters[t].renderFrame(e);
    }, SVGEffects.prototype.getEffects = function(e) {
      var t, n = this.filters.length, o = [];
      for (t = 0; t < n; t += 1)
        this.filters[t].type === e && o.push(this.filters[t]);
      return o;
    };
    function registerEffect$1(e, t, n) {
      registeredEffects$1[e] = {
        effect: t,
        countsAsEffect: n
      };
    }
    function SVGBaseElement() {
    }
    SVGBaseElement.prototype = {
      initRendererElement: function() {
        this.layerElement = createNS("g");
      },
      createContainerElements: function() {
        this.matteElement = createNS("g"), this.transformedElement = this.layerElement, this.maskedElement = this.layerElement, this._sizeChanged = !1;
        var t = null;
        if (this.data.td) {
          this.matteMasks = {};
          var n = createNS("g");
          n.setAttribute("id", this.layerId), n.appendChild(this.layerElement), t = n, this.globalData.defs.appendChild(n);
        } else
          this.data.tt ? (this.matteElement.appendChild(this.layerElement), t = this.matteElement, this.baseElement = this.matteElement) : this.baseElement = this.layerElement;
        if (this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), this.data.ty === 0 && !this.data.hd) {
          var o = createNS("clipPath"), s = createNS("path");
          s.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
          var l = createElementID();
          if (o.setAttribute("id", l), o.appendChild(s), this.globalData.defs.appendChild(o), this.checkMasks()) {
            var c = createNS("g");
            c.setAttribute("clip-path", "url(" + getLocationHref() + "#" + l + ")"), c.appendChild(this.layerElement), this.transformedElement = c, t ? t.appendChild(this.transformedElement) : this.baseElement = this.transformedElement;
          } else
            this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + l + ")");
        }
        this.data.bm !== 0 && this.setBlendMode();
      },
      renderElement: function() {
        this.finalTransform._localMatMdf && this.transformedElement.setAttribute("transform", this.finalTransform.localMat.to2dCSS()), this.finalTransform._opMdf && this.transformedElement.setAttribute("opacity", this.finalTransform.localOpacity);
      },
      destroyBaseElement: function() {
        this.layerElement = null, this.matteElement = null, this.maskManager.destroy();
      },
      getBaseElement: function() {
        return this.data.hd ? null : this.baseElement;
      },
      createRenderableComponents: function() {
        this.maskManager = new MaskElement(this.data, this, this.globalData), this.renderableEffectsManager = new SVGEffects(this), this.searchEffectTransforms();
      },
      getMatte: function(t) {
        if (this.matteMasks || (this.matteMasks = {}), !this.matteMasks[t]) {
          var n = this.layerId + "_" + t, o, s, l, c;
          if (t === 1 || t === 3) {
            var p = createNS("mask");
            p.setAttribute("id", n), p.setAttribute("mask-type", t === 3 ? "luminance" : "alpha"), l = createNS("use"), l.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), p.appendChild(l), this.globalData.defs.appendChild(p), !featureSupport.maskType && t === 1 && (p.setAttribute("mask-type", "luminance"), o = createElementID(), s = filtersFactory.createFilter(o), this.globalData.defs.appendChild(s), s.appendChild(filtersFactory.createAlphaToLuminanceFilter()), c = createNS("g"), c.appendChild(l), p.appendChild(c), c.setAttribute("filter", "url(" + getLocationHref() + "#" + o + ")"));
          } else if (t === 2) {
            var m = createNS("mask");
            m.setAttribute("id", n), m.setAttribute("mask-type", "alpha");
            var C = createNS("g");
            m.appendChild(C), o = createElementID(), s = filtersFactory.createFilter(o);
            var P = createNS("feComponentTransfer");
            P.setAttribute("in", "SourceGraphic"), s.appendChild(P);
            var w = createNS("feFuncA");
            w.setAttribute("type", "table"), w.setAttribute("tableValues", "1.0 0.0"), P.appendChild(w), this.globalData.defs.appendChild(s);
            var R = createNS("rect");
            R.setAttribute("width", this.comp.data.w), R.setAttribute("height", this.comp.data.h), R.setAttribute("x", "0"), R.setAttribute("y", "0"), R.setAttribute("fill", "#ffffff"), R.setAttribute("opacity", "0"), C.setAttribute("filter", "url(" + getLocationHref() + "#" + o + ")"), C.appendChild(R), l = createNS("use"), l.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), C.appendChild(l), featureSupport.maskType || (m.setAttribute("mask-type", "luminance"), s.appendChild(filtersFactory.createAlphaToLuminanceFilter()), c = createNS("g"), C.appendChild(R), c.appendChild(this.layerElement), C.appendChild(c)), this.globalData.defs.appendChild(m);
          }
          this.matteMasks[t] = n;
        }
        return this.matteMasks[t];
      },
      setMatte: function(t) {
        this.matteElement && this.matteElement.setAttribute("mask", "url(" + getLocationHref() + "#" + t + ")");
      }
    };
    function HierarchyElement() {
    }
    HierarchyElement.prototype = {
      /**
         * @function
         * Initializes hierarchy properties
         *
         */
      initHierarchy: function() {
        this.hierarchy = [], this._isParent = !1, this.checkParenting();
      },
      /**
         * @function
         * Sets layer's hierarchy.
         * @param {array} hierarch
         * layer's parent list
         *
         */
      setHierarchy: function(t) {
        this.hierarchy = t;
      },
      /**
         * @function
         * Sets layer as parent.
         *
         */
      setAsParent: function() {
        this._isParent = !0;
      },
      /**
         * @function
         * Searches layer's parenting chain
         *
         */
      checkParenting: function() {
        this.data.parent !== void 0 && this.comp.buildElementParenting(this, this.data.parent, []);
      }
    };
    function RenderableDOMElement() {
    }
    (function() {
      var e = {
        initElement: function(n, o, s) {
          this.initFrame(), this.initBaseData(n, o, s), this.initTransform(n, o, s), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide();
        },
        hide: function() {
          if (!this.hidden && (!this.isInRange || this.isTransparent)) {
            var n = this.baseElement || this.layerElement;
            n.style.display = "none", this.hidden = !0;
          }
        },
        show: function() {
          if (this.isInRange && !this.isTransparent) {
            if (!this.data.hd) {
              var n = this.baseElement || this.layerElement;
              n.style.display = "block";
            }
            this.hidden = !1, this._isFirstFrame = !0;
          }
        },
        renderFrame: function() {
          this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderLocalTransform(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
        },
        renderInnerContent: function() {
        },
        prepareFrame: function(n) {
          this._mdf = !1, this.prepareRenderableFrame(n), this.prepareProperties(n, this.isInRange), this.checkTransparency();
        },
        destroy: function() {
          this.innerElem = null, this.destroyBaseElement();
        }
      };
      extendPrototype([RenderableElement, createProxyFunction(e)], RenderableDOMElement);
    })();
    function IImageElement(e, t, n) {
      this.assetData = t.getAssetData(e.refId), this.assetData && this.assetData.sid && (this.assetData = t.slotManager.getProp(this.assetData)), this.initElement(e, t, n), this.sourceRect = {
        top: 0,
        left: 0,
        width: this.assetData.w,
        height: this.assetData.h
      };
    }
    extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], IImageElement), IImageElement.prototype.createContent = function() {
      var e = this.globalData.getAssetsPath(this.assetData);
      this.innerElem = createNS("image"), this.innerElem.setAttribute("width", this.assetData.w + "px"), this.innerElem.setAttribute("height", this.assetData.h + "px"), this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio), this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", e), this.layerElement.appendChild(this.innerElem);
    }, IImageElement.prototype.sourceRectAtTime = function() {
      return this.sourceRect;
    };
    function ProcessedElement(e, t) {
      this.elem = e, this.pos = t;
    }
    function IShapeElement() {
    }
    IShapeElement.prototype = {
      addShapeToModifiers: function(t) {
        var n, o = this.shapeModifiers.length;
        for (n = 0; n < o; n += 1)
          this.shapeModifiers[n].addShape(t);
      },
      isShapeInAnimatedModifiers: function(t) {
        for (var n = 0, o = this.shapeModifiers.length; n < o; )
          if (this.shapeModifiers[n].isAnimatedWithShape(t))
            return !0;
        return !1;
      },
      renderModifiers: function() {
        if (this.shapeModifiers.length) {
          var t, n = this.shapes.length;
          for (t = 0; t < n; t += 1)
            this.shapes[t].sh.reset();
          n = this.shapeModifiers.length;
          var o;
          for (t = n - 1; t >= 0 && (o = this.shapeModifiers[t].processShapes(this._isFirstFrame), !o); t -= 1)
            ;
        }
      },
      searchProcessedElement: function(t) {
        for (var n = this.processedElements, o = 0, s = n.length; o < s; ) {
          if (n[o].elem === t)
            return n[o].pos;
          o += 1;
        }
        return 0;
      },
      addProcessedElement: function(t, n) {
        for (var o = this.processedElements, s = o.length; s; )
          if (s -= 1, o[s].elem === t) {
            o[s].pos = n;
            return;
          }
        o.push(new ProcessedElement(t, n));
      },
      prepareFrame: function(t) {
        this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange);
      }
    };
    var lineCapEnum = {
      1: "butt",
      2: "round",
      3: "square"
    }, lineJoinEnum = {
      1: "miter",
      2: "round",
      3: "bevel"
    };
    function SVGShapeData(e, t, n) {
      this.caches = [], this.styles = [], this.transformers = e, this.lStr = "", this.sh = n, this.lvl = t, this._isAnimated = !!n.k;
      for (var o = 0, s = e.length; o < s; ) {
        if (e[o].mProps.dynamicProperties.length) {
          this._isAnimated = !0;
          break;
        }
        o += 1;
      }
    }
    SVGShapeData.prototype.setAsAnimated = function() {
      this._isAnimated = !0;
    };
    function SVGStyleData(e, t) {
      this.data = e, this.type = e.ty, this.d = "", this.lvl = t, this._mdf = !1, this.closed = e.hd === !0, this.pElem = createNS("path"), this.msElem = null;
    }
    SVGStyleData.prototype.reset = function() {
      this.d = "", this._mdf = !1;
    };
    function DashProperty(e, t, n, o) {
      this.elem = e, this.frameId = -1, this.dataProps = createSizedArray(t.length), this.renderer = n, this.k = !1, this.dashStr = "", this.dashArray = createTypedArray("float32", t.length ? t.length - 1 : 0), this.dashoffset = createTypedArray("float32", 1), this.initDynamicPropertyContainer(o);
      var s, l = t.length || 0, c;
      for (s = 0; s < l; s += 1)
        c = PropertyFactory.getProp(e, t[s].v, 0, 0, this), this.k = c.k || this.k, this.dataProps[s] = {
          n: t[s].n,
          p: c
        };
      this.k || this.getValue(!0), this._isAnimated = this.k;
    }
    DashProperty.prototype.getValue = function(e) {
      if (!(this.elem.globalData.frameId === this.frameId && !e) && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf = this._mdf || e, this._mdf)) {
        var t = 0, n = this.dataProps.length;
        for (this.renderer === "svg" && (this.dashStr = ""), t = 0; t < n; t += 1)
          this.dataProps[t].n !== "o" ? this.renderer === "svg" ? this.dashStr += " " + this.dataProps[t].p.v : this.dashArray[t] = this.dataProps[t].p.v : this.dashoffset[0] = this.dataProps[t].p.v;
      }
    }, extendPrototype([DynamicPropertyContainer], DashProperty);
    function SVGStrokeStyleData(e, t, n) {
      this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(e, t.o, 0, 0.01, this), this.w = PropertyFactory.getProp(e, t.w, 0, null, this), this.d = new DashProperty(e, t.d || {}, "svg", this), this.c = PropertyFactory.getProp(e, t.c, 1, 255, this), this.style = n, this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData);
    function SVGFillStyleData(e, t, n) {
      this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(e, t.o, 0, 0.01, this), this.c = PropertyFactory.getProp(e, t.c, 1, 255, this), this.style = n;
    }
    extendPrototype([DynamicPropertyContainer], SVGFillStyleData);
    function SVGNoStyleData(e, t, n) {
      this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.style = n;
    }
    extendPrototype([DynamicPropertyContainer], SVGNoStyleData);
    function GradientProperty(e, t, n) {
      this.data = t, this.c = createTypedArray("uint8c", t.p * 4);
      var o = t.k.k[0].s ? t.k.k[0].s.length - t.p * 4 : t.k.k.length - t.p * 4;
      this.o = createTypedArray("float32", o), this._cmdf = !1, this._omdf = !1, this._collapsable = this.checkCollapsable(), this._hasOpacity = o, this.initDynamicPropertyContainer(n), this.prop = PropertyFactory.getProp(e, t.k, 1, null, this), this.k = this.prop.k, this.getValue(!0);
    }
    GradientProperty.prototype.comparePoints = function(e, t) {
      for (var n = 0, o = this.o.length / 2, s; n < o; ) {
        if (s = Math.abs(e[n * 4] - e[t * 4 + n * 2]), s > 0.01)
          return !1;
        n += 1;
      }
      return !0;
    }, GradientProperty.prototype.checkCollapsable = function() {
      if (this.o.length / 2 !== this.c.length / 4)
        return !1;
      if (this.data.k.k[0].s)
        for (var e = 0, t = this.data.k.k.length; e < t; ) {
          if (!this.comparePoints(this.data.k.k[e].s, this.data.p))
            return !1;
          e += 1;
        }
      else if (!this.comparePoints(this.data.k.k, this.data.p))
        return !1;
      return !0;
    }, GradientProperty.prototype.getValue = function(e) {
      if (this.prop.getValue(), this._mdf = !1, this._cmdf = !1, this._omdf = !1, this.prop._mdf || e) {
        var t, n = this.data.p * 4, o, s;
        for (t = 0; t < n; t += 1)
          o = t % 4 === 0 ? 100 : 255, s = Math.round(this.prop.v[t] * o), this.c[t] !== s && (this.c[t] = s, this._cmdf = !e);
        if (this.o.length)
          for (n = this.prop.v.length, t = this.data.p * 4; t < n; t += 1)
            o = t % 2 === 0 ? 100 : 1, s = t % 2 === 0 ? Math.round(this.prop.v[t] * 100) : this.prop.v[t], this.o[t - this.data.p * 4] !== s && (this.o[t - this.data.p * 4] = s, this._omdf = !e);
        this._mdf = !e;
      }
    }, extendPrototype([DynamicPropertyContainer], GradientProperty);
    function SVGGradientFillStyleData(e, t, n) {
      this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.initGradientData(e, t, n);
    }
    SVGGradientFillStyleData.prototype.initGradientData = function(e, t, n) {
      this.o = PropertyFactory.getProp(e, t.o, 0, 0.01, this), this.s = PropertyFactory.getProp(e, t.s, 1, null, this), this.e = PropertyFactory.getProp(e, t.e, 1, null, this), this.h = PropertyFactory.getProp(e, t.h || {
        k: 0
      }, 0, 0.01, this), this.a = PropertyFactory.getProp(e, t.a || {
        k: 0
      }, 0, degToRads, this), this.g = new GradientProperty(e, t.g, this), this.style = n, this.stops = [], this.setGradientData(n.pElem, t), this.setGradientOpacity(t, n), this._isAnimated = !!this._isAnimated;
    }, SVGGradientFillStyleData.prototype.setGradientData = function(e, t) {
      var n = createElementID(), o = createNS(t.t === 1 ? "linearGradient" : "radialGradient");
      o.setAttribute("id", n), o.setAttribute("spreadMethod", "pad"), o.setAttribute("gradientUnits", "userSpaceOnUse");
      var s = [], l, c, p;
      for (p = t.g.p * 4, c = 0; c < p; c += 4)
        l = createNS("stop"), o.appendChild(l), s.push(l);
      e.setAttribute(t.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + n + ")"), this.gf = o, this.cst = s;
    }, SVGGradientFillStyleData.prototype.setGradientOpacity = function(e, t) {
      if (this.g._hasOpacity && !this.g._collapsable) {
        var n, o, s, l = createNS("mask"), c = createNS("path");
        l.appendChild(c);
        var p = createElementID(), m = createElementID();
        l.setAttribute("id", m);
        var C = createNS(e.t === 1 ? "linearGradient" : "radialGradient");
        C.setAttribute("id", p), C.setAttribute("spreadMethod", "pad"), C.setAttribute("gradientUnits", "userSpaceOnUse"), s = e.g.k.k[0].s ? e.g.k.k[0].s.length : e.g.k.k.length;
        var P = this.stops;
        for (o = e.g.p * 4; o < s; o += 2)
          n = createNS("stop"), n.setAttribute("stop-color", "rgb(255,255,255)"), C.appendChild(n), P.push(n);
        c.setAttribute(e.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + p + ")"), e.ty === "gs" && (c.setAttribute("stroke-linecap", lineCapEnum[e.lc || 2]), c.setAttribute("stroke-linejoin", lineJoinEnum[e.lj || 2]), e.lj === 1 && c.setAttribute("stroke-miterlimit", e.ml)), this.of = C, this.ms = l, this.ost = P, this.maskId = m, t.msElem = c;
      }
    }, extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData);
    function SVGGradientStrokeStyleData(e, t, n) {
      this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.w = PropertyFactory.getProp(e, t.w, 0, null, this), this.d = new DashProperty(e, t.d || {}, "svg", this), this.initGradientData(e, t, n), this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([SVGGradientFillStyleData, DynamicPropertyContainer], SVGGradientStrokeStyleData);
    function ShapeGroupData() {
      this.it = [], this.prevViewData = [], this.gr = createNS("g");
    }
    function SVGTransformData(e, t, n) {
      this.transform = {
        mProps: e,
        op: t,
        container: n
      }, this.elements = [], this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
    }
    var buildShapeString = function(t, n, o, s) {
      if (n === 0)
        return "";
      var l = t.o, c = t.i, p = t.v, m, C = " M" + s.applyToPointStringified(p[0][0], p[0][1]);
      for (m = 1; m < n; m += 1)
        C += " C" + s.applyToPointStringified(l[m - 1][0], l[m - 1][1]) + " " + s.applyToPointStringified(c[m][0], c[m][1]) + " " + s.applyToPointStringified(p[m][0], p[m][1]);
      return o && n && (C += " C" + s.applyToPointStringified(l[m - 1][0], l[m - 1][1]) + " " + s.applyToPointStringified(c[0][0], c[0][1]) + " " + s.applyToPointStringified(p[0][0], p[0][1]), C += "z"), C;
    }, SVGElementsRenderer = function() {
      var e = new Matrix(), t = new Matrix(), n = {
        createRenderFunction: o
      };
      function o(w) {
        switch (w.ty) {
          case "fl":
            return p;
          case "gf":
            return C;
          case "gs":
            return m;
          case "st":
            return P;
          case "sh":
          case "el":
          case "rc":
          case "sr":
            return c;
          case "tr":
            return s;
          case "no":
            return l;
          default:
            return null;
        }
      }
      function s(w, R, L) {
        (L || R.transform.op._mdf) && R.transform.container.setAttribute("opacity", R.transform.op.v), (L || R.transform.mProps._mdf) && R.transform.container.setAttribute("transform", R.transform.mProps.v.to2dCSS());
      }
      function l() {
      }
      function c(w, R, L) {
        var M, $, W, H, V, N, B = R.styles.length, K = R.lvl, ue, de, ve, Te;
        for (N = 0; N < B; N += 1) {
          if (H = R.sh._mdf || L, R.styles[N].lvl < K) {
            for (de = t.reset(), ve = K - R.styles[N].lvl, Te = R.transformers.length - 1; !H && ve > 0; )
              H = R.transformers[Te].mProps._mdf || H, ve -= 1, Te -= 1;
            if (H)
              for (ve = K - R.styles[N].lvl, Te = R.transformers.length - 1; ve > 0; )
                de.multiply(R.transformers[Te].mProps.v), ve -= 1, Te -= 1;
          } else
            de = e;
          if (ue = R.sh.paths, $ = ue._length, H) {
            for (W = "", M = 0; M < $; M += 1)
              V = ue.shapes[M], V && V._length && (W += buildShapeString(V, V._length, V.c, de));
            R.caches[N] = W;
          } else
            W = R.caches[N];
          R.styles[N].d += w.hd === !0 ? "" : W, R.styles[N]._mdf = H || R.styles[N]._mdf;
        }
      }
      function p(w, R, L) {
        var M = R.style;
        (R.c._mdf || L) && M.pElem.setAttribute("fill", "rgb(" + bmFloor(R.c.v[0]) + "," + bmFloor(R.c.v[1]) + "," + bmFloor(R.c.v[2]) + ")"), (R.o._mdf || L) && M.pElem.setAttribute("fill-opacity", R.o.v);
      }
      function m(w, R, L) {
        C(w, R, L), P(w, R, L);
      }
      function C(w, R, L) {
        var M = R.gf, $ = R.g._hasOpacity, W = R.s.v, H = R.e.v;
        if (R.o._mdf || L) {
          var V = w.ty === "gf" ? "fill-opacity" : "stroke-opacity";
          R.style.pElem.setAttribute(V, R.o.v);
        }
        if (R.s._mdf || L) {
          var N = w.t === 1 ? "x1" : "cx", B = N === "x1" ? "y1" : "cy";
          M.setAttribute(N, W[0]), M.setAttribute(B, W[1]), $ && !R.g._collapsable && (R.of.setAttribute(N, W[0]), R.of.setAttribute(B, W[1]));
        }
        var K, ue, de, ve;
        if (R.g._cmdf || L) {
          K = R.cst;
          var Te = R.g.c;
          for (de = K.length, ue = 0; ue < de; ue += 1)
            ve = K[ue], ve.setAttribute("offset", Te[ue * 4] + "%"), ve.setAttribute("stop-color", "rgb(" + Te[ue * 4 + 1] + "," + Te[ue * 4 + 2] + "," + Te[ue * 4 + 3] + ")");
        }
        if ($ && (R.g._omdf || L)) {
          var Pe = R.g.o;
          for (R.g._collapsable ? K = R.cst : K = R.ost, de = K.length, ue = 0; ue < de; ue += 1)
            ve = K[ue], R.g._collapsable || ve.setAttribute("offset", Pe[ue * 2] + "%"), ve.setAttribute("stop-opacity", Pe[ue * 2 + 1]);
        }
        if (w.t === 1)
          (R.e._mdf || L) && (M.setAttribute("x2", H[0]), M.setAttribute("y2", H[1]), $ && !R.g._collapsable && (R.of.setAttribute("x2", H[0]), R.of.setAttribute("y2", H[1])));
        else {
          var Ce;
          if ((R.s._mdf || R.e._mdf || L) && (Ce = Math.sqrt(Math.pow(W[0] - H[0], 2) + Math.pow(W[1] - H[1], 2)), M.setAttribute("r", Ce), $ && !R.g._collapsable && R.of.setAttribute("r", Ce)), R.e._mdf || R.h._mdf || R.a._mdf || L) {
            Ce || (Ce = Math.sqrt(Math.pow(W[0] - H[0], 2) + Math.pow(W[1] - H[1], 2)));
            var Re = Math.atan2(H[1] - W[1], H[0] - W[0]), ke = R.h.v;
            ke >= 1 ? ke = 0.99 : ke <= -1 && (ke = -0.99);
            var Ae = Ce * ke, we = Math.cos(Re + R.a.v) * Ae + W[0], he = Math.sin(Re + R.a.v) * Ae + W[1];
            M.setAttribute("fx", we), M.setAttribute("fy", he), $ && !R.g._collapsable && (R.of.setAttribute("fx", we), R.of.setAttribute("fy", he));
          }
        }
      }
      function P(w, R, L) {
        var M = R.style, $ = R.d;
        $ && ($._mdf || L) && $.dashStr && (M.pElem.setAttribute("stroke-dasharray", $.dashStr), M.pElem.setAttribute("stroke-dashoffset", $.dashoffset[0])), R.c && (R.c._mdf || L) && M.pElem.setAttribute("stroke", "rgb(" + bmFloor(R.c.v[0]) + "," + bmFloor(R.c.v[1]) + "," + bmFloor(R.c.v[2]) + ")"), (R.o._mdf || L) && M.pElem.setAttribute("stroke-opacity", R.o.v), (R.w._mdf || L) && (M.pElem.setAttribute("stroke-width", R.w.v), M.msElem && M.msElem.setAttribute("stroke-width", R.w.v));
      }
      return n;
    }();
    function SVGShapeElement(e, t, n) {
      this.shapes = [], this.shapesData = e.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.initElement(e, t, n), this.prevViewData = [];
    }
    extendPrototype([BaseElement, TransformElement, SVGBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableDOMElement], SVGShapeElement), SVGShapeElement.prototype.initSecondaryElement = function() {
    }, SVGShapeElement.prototype.identityMatrix = new Matrix(), SVGShapeElement.prototype.buildExpressionInterface = function() {
    }, SVGShapeElement.prototype.createContent = function() {
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes();
    }, SVGShapeElement.prototype.filterUniqueShapes = function() {
      var e, t = this.shapes.length, n, o, s = this.stylesList.length, l, c = [], p = !1;
      for (o = 0; o < s; o += 1) {
        for (l = this.stylesList[o], p = !1, c.length = 0, e = 0; e < t; e += 1)
          n = this.shapes[e], n.styles.indexOf(l) !== -1 && (c.push(n), p = n._isAnimated || p);
        c.length > 1 && p && this.setShapesAsAnimated(c);
      }
    }, SVGShapeElement.prototype.setShapesAsAnimated = function(e) {
      var t, n = e.length;
      for (t = 0; t < n; t += 1)
        e[t].setAsAnimated();
    }, SVGShapeElement.prototype.createStyleElement = function(e, t) {
      var n, o = new SVGStyleData(e, t), s = o.pElem;
      if (e.ty === "st")
        n = new SVGStrokeStyleData(this, e, o);
      else if (e.ty === "fl")
        n = new SVGFillStyleData(this, e, o);
      else if (e.ty === "gf" || e.ty === "gs") {
        var l = e.ty === "gf" ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
        n = new l(this, e, o), this.globalData.defs.appendChild(n.gf), n.maskId && (this.globalData.defs.appendChild(n.ms), this.globalData.defs.appendChild(n.of), s.setAttribute("mask", "url(" + getLocationHref() + "#" + n.maskId + ")"));
      } else
        e.ty === "no" && (n = new SVGNoStyleData(this, e, o));
      return (e.ty === "st" || e.ty === "gs") && (s.setAttribute("stroke-linecap", lineCapEnum[e.lc || 2]), s.setAttribute("stroke-linejoin", lineJoinEnum[e.lj || 2]), s.setAttribute("fill-opacity", "0"), e.lj === 1 && s.setAttribute("stroke-miterlimit", e.ml)), e.r === 2 && s.setAttribute("fill-rule", "evenodd"), e.ln && s.setAttribute("id", e.ln), e.cl && s.setAttribute("class", e.cl), e.bm && (s.style["mix-blend-mode"] = getBlendMode(e.bm)), this.stylesList.push(o), this.addToAnimatedContents(e, n), n;
    }, SVGShapeElement.prototype.createGroupElement = function(e) {
      var t = new ShapeGroupData();
      return e.ln && t.gr.setAttribute("id", e.ln), e.cl && t.gr.setAttribute("class", e.cl), e.bm && (t.gr.style["mix-blend-mode"] = getBlendMode(e.bm)), t;
    }, SVGShapeElement.prototype.createTransformElement = function(e, t) {
      var n = TransformPropertyFactory.getTransformProperty(this, e, this), o = new SVGTransformData(n, n.o, t);
      return this.addToAnimatedContents(e, o), o;
    }, SVGShapeElement.prototype.createShapeElement = function(e, t, n) {
      var o = 4;
      e.ty === "rc" ? o = 5 : e.ty === "el" ? o = 6 : e.ty === "sr" && (o = 7);
      var s = ShapePropertyFactory.getShapeProp(this, e, o, this), l = new SVGShapeData(t, n, s);
      return this.shapes.push(l), this.addShapeToModifiers(l), this.addToAnimatedContents(e, l), l;
    }, SVGShapeElement.prototype.addToAnimatedContents = function(e, t) {
      for (var n = 0, o = this.animatedContents.length; n < o; ) {
        if (this.animatedContents[n].element === t)
          return;
        n += 1;
      }
      this.animatedContents.push({
        fn: SVGElementsRenderer.createRenderFunction(e),
        element: t,
        data: e
      });
    }, SVGShapeElement.prototype.setElementStyles = function(e) {
      var t = e.styles, n, o = this.stylesList.length;
      for (n = 0; n < o; n += 1)
        this.stylesList[n].closed || t.push(this.stylesList[n]);
    }, SVGShapeElement.prototype.reloadShapes = function() {
      this._isFirstFrame = !0;
      var e, t = this.itemsData.length;
      for (e = 0; e < t; e += 1)
        this.prevViewData[e] = this.itemsData[e];
      for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes(), t = this.dynamicProperties.length, e = 0; e < t; e += 1)
        this.dynamicProperties[e].getValue();
      this.renderModifiers();
    }, SVGShapeElement.prototype.searchShapes = function(e, t, n, o, s, l, c) {
      var p = [].concat(l), m, C = e.length - 1, P, w, R = [], L = [], M, $, W;
      for (m = C; m >= 0; m -= 1) {
        if (W = this.searchProcessedElement(e[m]), W ? t[m] = n[W - 1] : e[m]._render = c, e[m].ty === "fl" || e[m].ty === "st" || e[m].ty === "gf" || e[m].ty === "gs" || e[m].ty === "no")
          W ? t[m].style.closed = !1 : t[m] = this.createStyleElement(e[m], s), e[m]._render && t[m].style.pElem.parentNode !== o && o.appendChild(t[m].style.pElem), R.push(t[m].style);
        else if (e[m].ty === "gr") {
          if (!W)
            t[m] = this.createGroupElement(e[m]);
          else
            for (w = t[m].it.length, P = 0; P < w; P += 1)
              t[m].prevViewData[P] = t[m].it[P];
          this.searchShapes(e[m].it, t[m].it, t[m].prevViewData, t[m].gr, s + 1, p, c), e[m]._render && t[m].gr.parentNode !== o && o.appendChild(t[m].gr);
        } else
          e[m].ty === "tr" ? (W || (t[m] = this.createTransformElement(e[m], o)), M = t[m].transform, p.push(M)) : e[m].ty === "sh" || e[m].ty === "rc" || e[m].ty === "el" || e[m].ty === "sr" ? (W || (t[m] = this.createShapeElement(e[m], p, s)), this.setElementStyles(t[m])) : e[m].ty === "tm" || e[m].ty === "rd" || e[m].ty === "ms" || e[m].ty === "pb" || e[m].ty === "zz" || e[m].ty === "op" ? (W ? ($ = t[m], $.closed = !1) : ($ = ShapeModifiers.getModifier(e[m].ty), $.init(this, e[m]), t[m] = $, this.shapeModifiers.push($)), L.push($)) : e[m].ty === "rp" && (W ? ($ = t[m], $.closed = !0) : ($ = ShapeModifiers.getModifier(e[m].ty), t[m] = $, $.init(this, e, m, t), this.shapeModifiers.push($), c = !1), L.push($));
        this.addProcessedElement(e[m], m + 1);
      }
      for (C = R.length, m = 0; m < C; m += 1)
        R[m].closed = !0;
      for (C = L.length, m = 0; m < C; m += 1)
        L[m].closed = !0;
    }, SVGShapeElement.prototype.renderInnerContent = function() {
      this.renderModifiers();
      var e, t = this.stylesList.length;
      for (e = 0; e < t; e += 1)
        this.stylesList[e].reset();
      for (this.renderShape(), e = 0; e < t; e += 1)
        (this.stylesList[e]._mdf || this._isFirstFrame) && (this.stylesList[e].msElem && (this.stylesList[e].msElem.setAttribute("d", this.stylesList[e].d), this.stylesList[e].d = "M0 0" + this.stylesList[e].d), this.stylesList[e].pElem.setAttribute("d", this.stylesList[e].d || "M0 0"));
    }, SVGShapeElement.prototype.renderShape = function() {
      var e, t = this.animatedContents.length, n;
      for (e = 0; e < t; e += 1)
        n = this.animatedContents[e], (this._isFirstFrame || n.element._isAnimated) && n.data !== !0 && n.fn(n.data, n.element, this._isFirstFrame);
    }, SVGShapeElement.prototype.destroy = function() {
      this.destroyBaseElement(), this.shapesData = null, this.itemsData = null;
    };
    function LetterProps(e, t, n, o, s, l) {
      this.o = e, this.sw = t, this.sc = n, this.fc = o, this.m = s, this.p = l, this._mdf = {
        o: !0,
        sw: !!t,
        sc: !!n,
        fc: !!o,
        m: !0,
        p: !0
      };
    }
    LetterProps.prototype.update = function(e, t, n, o, s, l) {
      this._mdf.o = !1, this._mdf.sw = !1, this._mdf.sc = !1, this._mdf.fc = !1, this._mdf.m = !1, this._mdf.p = !1;
      var c = !1;
      return this.o !== e && (this.o = e, this._mdf.o = !0, c = !0), this.sw !== t && (this.sw = t, this._mdf.sw = !0, c = !0), this.sc !== n && (this.sc = n, this._mdf.sc = !0, c = !0), this.fc !== o && (this.fc = o, this._mdf.fc = !0, c = !0), this.m !== s && (this.m = s, this._mdf.m = !0, c = !0), l.length && (this.p[0] !== l[0] || this.p[1] !== l[1] || this.p[4] !== l[4] || this.p[5] !== l[5] || this.p[12] !== l[12] || this.p[13] !== l[13]) && (this.p = l, this._mdf.p = !0, c = !0), c;
    };
    function TextProperty(e, t) {
      this._frameId = initialDefaultFrame, this.pv = "", this.v = "", this.kf = !1, this._isFirstFrame = !0, this._mdf = !1, t.d && t.d.sid && (t.d = e.globalData.slotManager.getProp(t.d)), this.data = t, this.elem = e, this.comp = this.elem.comp, this.keysIndex = 0, this.canResize = !1, this.minimumFontSize = 1, this.effectsSequence = [], this.currentData = {
        ascent: 0,
        boxWidth: this.defaultBoxWidth,
        f: "",
        fStyle: "",
        fWeight: "",
        fc: "",
        j: "",
        justifyOffset: "",
        l: [],
        lh: 0,
        lineWidths: [],
        ls: "",
        of: "",
        s: "",
        sc: "",
        sw: 0,
        t: 0,
        tr: 0,
        sz: 0,
        ps: null,
        fillColorAnim: !1,
        strokeColorAnim: !1,
        strokeWidthAnim: !1,
        yOffset: 0,
        finalSize: 0,
        finalText: [],
        finalLineHeight: 0,
        __complete: !1
      }, this.copyData(this.currentData, this.data.d.k[0].s), this.searchProperty() || this.completeTextData(this.currentData);
    }
    TextProperty.prototype.defaultBoxWidth = [0, 0], TextProperty.prototype.copyData = function(e, t) {
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
      return e;
    }, TextProperty.prototype.setCurrentData = function(e) {
      e.__complete || this.completeTextData(e), this.currentData = e, this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth, this._mdf = !0;
    }, TextProperty.prototype.searchProperty = function() {
      return this.searchKeyframes();
    }, TextProperty.prototype.searchKeyframes = function() {
      return this.kf = this.data.d.k.length > 1, this.kf && this.addEffect(this.getKeyframeValue.bind(this)), this.kf;
    }, TextProperty.prototype.addEffect = function(e) {
      this.effectsSequence.push(e), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.getValue = function(e) {
      if (!((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !e)) {
        this.currentData.t = this.data.d.k[this.keysIndex].s.t;
        var t = this.currentData, n = this.keysIndex;
        if (this.lock) {
          this.setCurrentData(this.currentData);
          return;
        }
        this.lock = !0, this._mdf = !1;
        var o, s = this.effectsSequence.length, l = e || this.data.d.k[this.keysIndex].s;
        for (o = 0; o < s; o += 1)
          n !== this.keysIndex ? l = this.effectsSequence[o](l, l.t) : l = this.effectsSequence[o](this.currentData, l.t);
        t !== l && this.setCurrentData(l), this.v = this.currentData, this.pv = this.v, this.lock = !1, this.frameId = this.elem.globalData.frameId;
      }
    }, TextProperty.prototype.getKeyframeValue = function() {
      for (var e = this.data.d.k, t = this.elem.comp.renderedFrame, n = 0, o = e.length; n <= o - 1 && !(n === o - 1 || e[n + 1].t > t); )
        n += 1;
      return this.keysIndex !== n && (this.keysIndex = n), this.data.d.k[this.keysIndex].s;
    }, TextProperty.prototype.buildFinalText = function(e) {
      for (var t = [], n = 0, o = e.length, s, l, c = !1, p = !1, m = ""; n < o; )
        c = p, p = !1, s = e.charCodeAt(n), m = e.charAt(n), FontManager.isCombinedCharacter(s) ? c = !0 : s >= 55296 && s <= 56319 ? FontManager.isRegionalFlag(e, n) ? m = e.substr(n, 14) : (l = e.charCodeAt(n + 1), l >= 56320 && l <= 57343 && (FontManager.isModifier(s, l) ? (m = e.substr(n, 2), c = !0) : FontManager.isFlagEmoji(e.substr(n, 4)) ? m = e.substr(n, 4) : m = e.substr(n, 2))) : s > 56319 ? (l = e.charCodeAt(n + 1), FontManager.isVariationSelector(s) && (c = !0)) : FontManager.isZeroWidthJoiner(s) && (c = !0, p = !0), c ? (t[t.length - 1] += m, c = !1) : t.push(m), n += m.length;
      return t;
    }, TextProperty.prototype.completeTextData = function(e) {
      e.__complete = !0;
      var t = this.elem.globalData.fontManager, n = this.data, o = [], s, l, c, p = 0, m, C = n.m.g, P = 0, w = 0, R = 0, L = [], M = 0, $ = 0, W, H, V = t.getFontByName(e.f), N, B = 0, K = getFontProperties(V);
      e.fWeight = K.weight, e.fStyle = K.style, e.finalSize = e.s, e.finalText = this.buildFinalText(e.t), l = e.finalText.length, e.finalLineHeight = e.lh;
      var ue = e.tr / 1e3 * e.finalSize, de;
      if (e.sz)
        for (var ve = !0, Te = e.sz[0], Pe = e.sz[1], Ce, Re; ve; ) {
          Re = this.buildFinalText(e.t), Ce = 0, M = 0, l = Re.length, ue = e.tr / 1e3 * e.finalSize;
          var ke = -1;
          for (s = 0; s < l; s += 1)
            de = Re[s].charCodeAt(0), c = !1, Re[s] === " " ? ke = s : (de === 13 || de === 3) && (M = 0, c = !0, Ce += e.finalLineHeight || e.finalSize * 1.2), t.chars ? (N = t.getCharData(Re[s], V.fStyle, V.fFamily), B = c ? 0 : N.w * e.finalSize / 100) : B = t.measureText(Re[s], e.f, e.finalSize), M + B > Te && Re[s] !== " " ? (ke === -1 ? l += 1 : s = ke, Ce += e.finalLineHeight || e.finalSize * 1.2, Re.splice(s, ke === s ? 1 : 0, "\r"), ke = -1, M = 0) : (M += B, M += ue);
          Ce += V.ascent * e.finalSize / 100, this.canResize && e.finalSize > this.minimumFontSize && Pe < Ce ? (e.finalSize -= 1, e.finalLineHeight = e.finalSize * e.lh / e.s) : (e.finalText = Re, l = e.finalText.length, ve = !1);
        }
      M = -ue, B = 0;
      var Ae = 0, we;
      for (s = 0; s < l; s += 1)
        if (c = !1, we = e.finalText[s], de = we.charCodeAt(0), de === 13 || de === 3 ? (Ae = 0, L.push(M), $ = M > $ ? M : $, M = -2 * ue, m = "", c = !0, R += 1) : m = we, t.chars ? (N = t.getCharData(we, V.fStyle, t.getFontByName(e.f).fFamily), B = c ? 0 : N.w * e.finalSize / 100) : B = t.measureText(m, e.f, e.finalSize), we === " " ? Ae += B + ue : (M += B + ue + Ae, Ae = 0), o.push({
          l: B,
          an: B,
          add: P,
          n: c,
          anIndexes: [],
          val: m,
          line: R,
          animatorJustifyOffset: 0
        }), C == 2) {
          if (P += B, m === "" || m === " " || s === l - 1) {
            for ((m === "" || m === " ") && (P -= B); w <= s; )
              o[w].an = P, o[w].ind = p, o[w].extra = B, w += 1;
            p += 1, P = 0;
          }
        } else if (C == 3) {
          if (P += B, m === "" || s === l - 1) {
            for (m === "" && (P -= B); w <= s; )
              o[w].an = P, o[w].ind = p, o[w].extra = B, w += 1;
            P = 0, p += 1;
          }
        } else
          o[p].ind = p, o[p].extra = 0, p += 1;
      if (e.l = o, $ = M > $ ? M : $, L.push(M), e.sz)
        e.boxWidth = e.sz[0], e.justifyOffset = 0;
      else
        switch (e.boxWidth = $, e.j) {
          case 1:
            e.justifyOffset = -e.boxWidth;
            break;
          case 2:
            e.justifyOffset = -e.boxWidth / 2;
            break;
          default:
            e.justifyOffset = 0;
        }
      e.lineWidths = L;
      var he = n.a, be, le;
      H = he.length;
      var fe, ye, Ee = [];
      for (W = 0; W < H; W += 1) {
        for (be = he[W], be.a.sc && (e.strokeColorAnim = !0), be.a.sw && (e.strokeWidthAnim = !0), (be.a.fc || be.a.fh || be.a.fs || be.a.fb) && (e.fillColorAnim = !0), ye = 0, fe = be.s.b, s = 0; s < l; s += 1)
          le = o[s], le.anIndexes[W] = ye, (fe == 1 && le.val !== "" || fe == 2 && le.val !== "" && le.val !== " " || fe == 3 && (le.n || le.val == " " || s == l - 1) || fe == 4 && (le.n || s == l - 1)) && (be.s.rn === 1 && Ee.push(ye), ye += 1);
        n.a[W].s.totalChars = ye;
        var Ie = -1, Fe;
        if (be.s.rn === 1)
          for (s = 0; s < l; s += 1)
            le = o[s], Ie != le.anIndexes[W] && (Ie = le.anIndexes[W], Fe = Ee.splice(Math.floor(Math.random() * Ee.length), 1)[0]), le.anIndexes[W] = Fe;
      }
      e.yOffset = e.finalLineHeight || e.finalSize * 1.2, e.ls = e.ls || 0, e.ascent = V.ascent * e.finalSize / 100;
    }, TextProperty.prototype.updateDocumentData = function(e, t) {
      t = t === void 0 ? this.keysIndex : t;
      var n = this.copyData({}, this.data.d.k[t].s);
      n = this.copyData(n, e), this.data.d.k[t].s = n, this.recalculate(t), this.setCurrentData(n), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.recalculate = function(e) {
      var t = this.data.d.k[e].s;
      t.__complete = !1, this.keysIndex = 0, this._isFirstFrame = !0, this.getValue(t);
    }, TextProperty.prototype.canResizeFont = function(e) {
      this.canResize = e, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.setMinimumFontSize = function(e) {
      this.minimumFontSize = Math.floor(e) || 1, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
    };
    var TextSelectorProp = function() {
      var e = Math.max, t = Math.min, n = Math.floor;
      function o(l, c) {
        this._currentTextLength = -1, this.k = !1, this.data = c, this.elem = l, this.comp = l.comp, this.finalS = 0, this.finalE = 0, this.initDynamicPropertyContainer(l), this.s = PropertyFactory.getProp(l, c.s || {
          k: 0
        }, 0, 0, this), "e" in c ? this.e = PropertyFactory.getProp(l, c.e, 0, 0, this) : this.e = {
          v: 100
        }, this.o = PropertyFactory.getProp(l, c.o || {
          k: 0
        }, 0, 0, this), this.xe = PropertyFactory.getProp(l, c.xe || {
          k: 0
        }, 0, 0, this), this.ne = PropertyFactory.getProp(l, c.ne || {
          k: 0
        }, 0, 0, this), this.sm = PropertyFactory.getProp(l, c.sm || {
          k: 100
        }, 0, 0, this), this.a = PropertyFactory.getProp(l, c.a, 0, 0.01, this), this.dynamicProperties.length || this.getValue();
      }
      o.prototype = {
        getMult: function(c) {
          this._currentTextLength !== this.elem.textProperty.currentData.l.length && this.getValue();
          var p = 0, m = 0, C = 1, P = 1;
          this.ne.v > 0 ? p = this.ne.v / 100 : m = -this.ne.v / 100, this.xe.v > 0 ? C = 1 - this.xe.v / 100 : P = 1 + this.xe.v / 100;
          var w = BezierFactory.getBezierEasing(p, m, C, P).get, R = 0, L = this.finalS, M = this.finalE, $ = this.data.sh;
          if ($ === 2)
            M === L ? R = c >= M ? 1 : 0 : R = e(0, t(0.5 / (M - L) + (c - L) / (M - L), 1)), R = w(R);
          else if ($ === 3)
            M === L ? R = c >= M ? 0 : 1 : R = 1 - e(0, t(0.5 / (M - L) + (c - L) / (M - L), 1)), R = w(R);
          else if ($ === 4)
            M === L ? R = 0 : (R = e(0, t(0.5 / (M - L) + (c - L) / (M - L), 1)), R < 0.5 ? R *= 2 : R = 1 - 2 * (R - 0.5)), R = w(R);
          else if ($ === 5) {
            if (M === L)
              R = 0;
            else {
              var W = M - L;
              c = t(e(0, c + 0.5 - L), M - L);
              var H = -W / 2 + c, V = W / 2;
              R = Math.sqrt(1 - H * H / (V * V));
            }
            R = w(R);
          } else
            $ === 6 ? (M === L ? R = 0 : (c = t(e(0, c + 0.5 - L), M - L), R = (1 + Math.cos(Math.PI + Math.PI * 2 * c / (M - L))) / 2), R = w(R)) : (c >= n(L) && (c - L < 0 ? R = e(0, t(t(M, 1) - (L - c), 1)) : R = e(0, t(M - c, 1))), R = w(R));
          if (this.sm.v !== 100) {
            var N = this.sm.v * 0.01;
            N === 0 && (N = 1e-8);
            var B = 0.5 - N * 0.5;
            R < B ? R = 0 : (R = (R - B) / N, R > 1 && (R = 1));
          }
          return R * this.a.v;
        },
        getValue: function(c) {
          this.iterateDynamicProperties(), this._mdf = c || this._mdf, this._currentTextLength = this.elem.textProperty.currentData.l.length || 0, c && this.data.r === 2 && (this.e.v = this._currentTextLength);
          var p = this.data.r === 2 ? 1 : 100 / this.data.totalChars, m = this.o.v / p, C = this.s.v / p + m, P = this.e.v / p + m;
          if (C > P) {
            var w = C;
            C = P, P = w;
          }
          this.finalS = C, this.finalE = P;
        }
      }, extendPrototype([DynamicPropertyContainer], o);
      function s(l, c, p) {
        return new o(l, c);
      }
      return {
        getTextSelectorProp: s
      };
    }();
    function TextAnimatorDataProperty(e, t, n) {
      var o = {
        propType: !1
      }, s = PropertyFactory.getProp, l = t.a;
      this.a = {
        r: l.r ? s(e, l.r, 0, degToRads, n) : o,
        rx: l.rx ? s(e, l.rx, 0, degToRads, n) : o,
        ry: l.ry ? s(e, l.ry, 0, degToRads, n) : o,
        sk: l.sk ? s(e, l.sk, 0, degToRads, n) : o,
        sa: l.sa ? s(e, l.sa, 0, degToRads, n) : o,
        s: l.s ? s(e, l.s, 1, 0.01, n) : o,
        a: l.a ? s(e, l.a, 1, 0, n) : o,
        o: l.o ? s(e, l.o, 0, 0.01, n) : o,
        p: l.p ? s(e, l.p, 1, 0, n) : o,
        sw: l.sw ? s(e, l.sw, 0, 0, n) : o,
        sc: l.sc ? s(e, l.sc, 1, 0, n) : o,
        fc: l.fc ? s(e, l.fc, 1, 0, n) : o,
        fh: l.fh ? s(e, l.fh, 0, 0, n) : o,
        fs: l.fs ? s(e, l.fs, 0, 0.01, n) : o,
        fb: l.fb ? s(e, l.fb, 0, 0.01, n) : o,
        t: l.t ? s(e, l.t, 0, 0, n) : o
      }, this.s = TextSelectorProp.getTextSelectorProp(e, t.s, n), this.s.t = t.s.t;
    }
    function TextAnimatorProperty(e, t, n) {
      this._isFirstFrame = !0, this._hasMaskedPath = !1, this._frameId = -1, this._textData = e, this._renderType = t, this._elem = n, this._animatorsData = createSizedArray(this._textData.a.length), this._pathData = {}, this._moreOptions = {
        alignment: {}
      }, this.renderedLetters = [], this.lettersChangedFlag = !1, this.initDynamicPropertyContainer(n);
    }
    TextAnimatorProperty.prototype.searchProperties = function() {
      var e, t = this._textData.a.length, n, o = PropertyFactory.getProp;
      for (e = 0; e < t; e += 1)
        n = this._textData.a[e], this._animatorsData[e] = new TextAnimatorDataProperty(this._elem, n, this);
      this._textData.p && "m" in this._textData.p ? (this._pathData = {
        a: o(this._elem, this._textData.p.a, 0, 0, this),
        f: o(this._elem, this._textData.p.f, 0, 0, this),
        l: o(this._elem, this._textData.p.l, 0, 0, this),
        r: o(this._elem, this._textData.p.r, 0, 0, this),
        p: o(this._elem, this._textData.p.p, 0, 0, this),
        m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
      }, this._hasMaskedPath = !0) : this._hasMaskedPath = !1, this._moreOptions.alignment = o(this._elem, this._textData.m.a, 1, 0, this);
    }, TextAnimatorProperty.prototype.getMeasures = function(e, t) {
      if (this.lettersChangedFlag = t, !(!this._mdf && !this._isFirstFrame && !t && (!this._hasMaskedPath || !this._pathData.m._mdf))) {
        this._isFirstFrame = !1;
        var n = this._moreOptions.alignment.v, o = this._animatorsData, s = this._textData, l = this.mHelper, c = this._renderType, p = this.renderedLetters.length, m, C, P, w, R = e.l, L, M, $, W, H, V, N, B, K, ue, de, ve, Te, Pe, Ce;
        if (this._hasMaskedPath) {
          if (Ce = this._pathData.m, !this._pathData.n || this._pathData._mdf) {
            var Re = Ce.v;
            this._pathData.r.v && (Re = Re.reverse()), L = {
              tLength: 0,
              segments: []
            }, w = Re._length - 1;
            var ke;
            for (ve = 0, P = 0; P < w; P += 1)
              ke = bez.buildBezierData(Re.v[P], Re.v[P + 1], [Re.o[P][0] - Re.v[P][0], Re.o[P][1] - Re.v[P][1]], [Re.i[P + 1][0] - Re.v[P + 1][0], Re.i[P + 1][1] - Re.v[P + 1][1]]), L.tLength += ke.segmentLength, L.segments.push(ke), ve += ke.segmentLength;
            P = w, Ce.v.c && (ke = bez.buildBezierData(Re.v[P], Re.v[0], [Re.o[P][0] - Re.v[P][0], Re.o[P][1] - Re.v[P][1]], [Re.i[0][0] - Re.v[0][0], Re.i[0][1] - Re.v[0][1]]), L.tLength += ke.segmentLength, L.segments.push(ke), ve += ke.segmentLength), this._pathData.pi = L;
          }
          if (L = this._pathData.pi, M = this._pathData.f.v, N = 0, V = 1, W = 0, H = !0, ue = L.segments, M < 0 && Ce.v.c)
            for (L.tLength < Math.abs(M) && (M = -Math.abs(M) % L.tLength), N = ue.length - 1, K = ue[N].points, V = K.length - 1; M < 0; )
              M += K[V].partialLength, V -= 1, V < 0 && (N -= 1, K = ue[N].points, V = K.length - 1);
          K = ue[N].points, B = K[V - 1], $ = K[V], de = $.partialLength;
        }
        w = R.length, m = 0, C = 0;
        var Ae = e.finalSize * 1.2 * 0.714, we = !0, he, be, le, fe, ye;
        fe = o.length;
        var Ee, Ie = -1, Fe, De, Ve, Oe = M, Ze = N, et = V, bt = -1, rr, St, Qe, xt, je, kt, cr, Tr, Er = "", Hr = this.defaultPropsArray, Br;
        if (e.j === 2 || e.j === 1) {
          var hr = 0, Gr = 0, Yr = e.j === 2 ? -0.5 : -1, tt = 0, ar = !0;
          for (P = 0; P < w; P += 1)
            if (R[P].n) {
              for (hr && (hr += Gr); tt < P; )
                R[tt].animatorJustifyOffset = hr, tt += 1;
              hr = 0, ar = !0;
            } else {
              for (le = 0; le < fe; le += 1)
                he = o[le].a, he.t.propType && (ar && e.j === 2 && (Gr += he.t.v * Yr), be = o[le].s, Ee = be.getMult(R[P].anIndexes[le], s.a[le].s.totalChars), Ee.length ? hr += he.t.v * Ee[0] * Yr : hr += he.t.v * Ee * Yr);
              ar = !1;
            }
          for (hr && (hr += Gr); tt < P; )
            R[tt].animatorJustifyOffset = hr, tt += 1;
        }
        for (P = 0; P < w; P += 1) {
          if (l.reset(), rr = 1, R[P].n)
            m = 0, C += e.yOffset, C += we ? 1 : 0, M = Oe, we = !1, this._hasMaskedPath && (N = Ze, V = et, K = ue[N].points, B = K[V - 1], $ = K[V], de = $.partialLength, W = 0), Er = "", Tr = "", kt = "", Br = "", Hr = this.defaultPropsArray;
          else {
            if (this._hasMaskedPath) {
              if (bt !== R[P].line) {
                switch (e.j) {
                  case 1:
                    M += ve - e.lineWidths[R[P].line];
                    break;
                  case 2:
                    M += (ve - e.lineWidths[R[P].line]) / 2;
                    break;
                }
                bt = R[P].line;
              }
              Ie !== R[P].ind && (R[Ie] && (M += R[Ie].extra), M += R[P].an / 2, Ie = R[P].ind), M += n[0] * R[P].an * 5e-3;
              var wr = 0;
              for (le = 0; le < fe; le += 1)
                he = o[le].a, he.p.propType && (be = o[le].s, Ee = be.getMult(R[P].anIndexes[le], s.a[le].s.totalChars), Ee.length ? wr += he.p.v[0] * Ee[0] : wr += he.p.v[0] * Ee), he.a.propType && (be = o[le].s, Ee = be.getMult(R[P].anIndexes[le], s.a[le].s.totalChars), Ee.length ? wr += he.a.v[0] * Ee[0] : wr += he.a.v[0] * Ee);
              for (H = !0, this._pathData.a.v && (M = R[0].an * 0.5 + (ve - this._pathData.f.v - R[0].an * 0.5 - R[R.length - 1].an * 0.5) * Ie / (w - 1), M += this._pathData.f.v); H; )
                W + de >= M + wr || !K ? (Te = (M + wr - W) / $.partialLength, De = B.point[0] + ($.point[0] - B.point[0]) * Te, Ve = B.point[1] + ($.point[1] - B.point[1]) * Te, l.translate(-n[0] * R[P].an * 5e-3, -(n[1] * Ae) * 0.01), H = !1) : K && (W += $.partialLength, V += 1, V >= K.length && (V = 0, N += 1, ue[N] ? K = ue[N].points : Ce.v.c ? (V = 0, N = 0, K = ue[N].points) : (W -= $.partialLength, K = null)), K && (B = $, $ = K[V], de = $.partialLength));
              Fe = R[P].an / 2 - R[P].add, l.translate(-Fe, 0, 0);
            } else
              Fe = R[P].an / 2 - R[P].add, l.translate(-Fe, 0, 0), l.translate(-n[0] * R[P].an * 5e-3, -n[1] * Ae * 0.01, 0);
            for (le = 0; le < fe; le += 1)
              he = o[le].a, he.t.propType && (be = o[le].s, Ee = be.getMult(R[P].anIndexes[le], s.a[le].s.totalChars), (m !== 0 || e.j !== 0) && (this._hasMaskedPath ? Ee.length ? M += he.t.v * Ee[0] : M += he.t.v * Ee : Ee.length ? m += he.t.v * Ee[0] : m += he.t.v * Ee));
            for (e.strokeWidthAnim && (Qe = e.sw || 0), e.strokeColorAnim && (e.sc ? St = [e.sc[0], e.sc[1], e.sc[2]] : St = [0, 0, 0]), e.fillColorAnim && e.fc && (xt = [e.fc[0], e.fc[1], e.fc[2]]), le = 0; le < fe; le += 1)
              he = o[le].a, he.a.propType && (be = o[le].s, Ee = be.getMult(R[P].anIndexes[le], s.a[le].s.totalChars), Ee.length ? l.translate(-he.a.v[0] * Ee[0], -he.a.v[1] * Ee[1], he.a.v[2] * Ee[2]) : l.translate(-he.a.v[0] * Ee, -he.a.v[1] * Ee, he.a.v[2] * Ee));
            for (le = 0; le < fe; le += 1)
              he = o[le].a, he.s.propType && (be = o[le].s, Ee = be.getMult(R[P].anIndexes[le], s.a[le].s.totalChars), Ee.length ? l.scale(1 + (he.s.v[0] - 1) * Ee[0], 1 + (he.s.v[1] - 1) * Ee[1], 1) : l.scale(1 + (he.s.v[0] - 1) * Ee, 1 + (he.s.v[1] - 1) * Ee, 1));
            for (le = 0; le < fe; le += 1) {
              if (he = o[le].a, be = o[le].s, Ee = be.getMult(R[P].anIndexes[le], s.a[le].s.totalChars), he.sk.propType && (Ee.length ? l.skewFromAxis(-he.sk.v * Ee[0], he.sa.v * Ee[1]) : l.skewFromAxis(-he.sk.v * Ee, he.sa.v * Ee)), he.r.propType && (Ee.length ? l.rotateZ(-he.r.v * Ee[2]) : l.rotateZ(-he.r.v * Ee)), he.ry.propType && (Ee.length ? l.rotateY(he.ry.v * Ee[1]) : l.rotateY(he.ry.v * Ee)), he.rx.propType && (Ee.length ? l.rotateX(he.rx.v * Ee[0]) : l.rotateX(he.rx.v * Ee)), he.o.propType && (Ee.length ? rr += (he.o.v * Ee[0] - rr) * Ee[0] : rr += (he.o.v * Ee - rr) * Ee), e.strokeWidthAnim && he.sw.propType && (Ee.length ? Qe += he.sw.v * Ee[0] : Qe += he.sw.v * Ee), e.strokeColorAnim && he.sc.propType)
                for (je = 0; je < 3; je += 1)
                  Ee.length ? St[je] += (he.sc.v[je] - St[je]) * Ee[0] : St[je] += (he.sc.v[je] - St[je]) * Ee;
              if (e.fillColorAnim && e.fc) {
                if (he.fc.propType)
                  for (je = 0; je < 3; je += 1)
                    Ee.length ? xt[je] += (he.fc.v[je] - xt[je]) * Ee[0] : xt[je] += (he.fc.v[je] - xt[je]) * Ee;
                he.fh.propType && (Ee.length ? xt = addHueToRGB(xt, he.fh.v * Ee[0]) : xt = addHueToRGB(xt, he.fh.v * Ee)), he.fs.propType && (Ee.length ? xt = addSaturationToRGB(xt, he.fs.v * Ee[0]) : xt = addSaturationToRGB(xt, he.fs.v * Ee)), he.fb.propType && (Ee.length ? xt = addBrightnessToRGB(xt, he.fb.v * Ee[0]) : xt = addBrightnessToRGB(xt, he.fb.v * Ee));
              }
            }
            for (le = 0; le < fe; le += 1)
              he = o[le].a, he.p.propType && (be = o[le].s, Ee = be.getMult(R[P].anIndexes[le], s.a[le].s.totalChars), this._hasMaskedPath ? Ee.length ? l.translate(0, he.p.v[1] * Ee[0], -he.p.v[2] * Ee[1]) : l.translate(0, he.p.v[1] * Ee, -he.p.v[2] * Ee) : Ee.length ? l.translate(he.p.v[0] * Ee[0], he.p.v[1] * Ee[1], -he.p.v[2] * Ee[2]) : l.translate(he.p.v[0] * Ee, he.p.v[1] * Ee, -he.p.v[2] * Ee));
            if (e.strokeWidthAnim && (kt = Qe < 0 ? 0 : Qe), e.strokeColorAnim && (cr = "rgb(" + Math.round(St[0] * 255) + "," + Math.round(St[1] * 255) + "," + Math.round(St[2] * 255) + ")"), e.fillColorAnim && e.fc && (Tr = "rgb(" + Math.round(xt[0] * 255) + "," + Math.round(xt[1] * 255) + "," + Math.round(xt[2] * 255) + ")"), this._hasMaskedPath) {
              if (l.translate(0, -e.ls), l.translate(0, n[1] * Ae * 0.01 + C, 0), this._pathData.p.v) {
                Pe = ($.point[1] - B.point[1]) / ($.point[0] - B.point[0]);
                var Sr = Math.atan(Pe) * 180 / Math.PI;
                $.point[0] < B.point[0] && (Sr += 180), l.rotate(-Sr * Math.PI / 180);
              }
              l.translate(De, Ve, 0), M -= n[0] * R[P].an * 5e-3, R[P + 1] && Ie !== R[P + 1].ind && (M += R[P].an / 2, M += e.tr * 1e-3 * e.finalSize);
            } else {
              switch (l.translate(m, C, 0), e.ps && l.translate(e.ps[0], e.ps[1] + e.ascent, 0), e.j) {
                case 1:
                  l.translate(R[P].animatorJustifyOffset + e.justifyOffset + (e.boxWidth - e.lineWidths[R[P].line]), 0, 0);
                  break;
                case 2:
                  l.translate(R[P].animatorJustifyOffset + e.justifyOffset + (e.boxWidth - e.lineWidths[R[P].line]) / 2, 0, 0);
                  break;
              }
              l.translate(0, -e.ls), l.translate(Fe, 0, 0), l.translate(n[0] * R[P].an * 5e-3, n[1] * Ae * 0.01, 0), m += R[P].l + e.tr * 1e-3 * e.finalSize;
            }
            c === "html" ? Er = l.toCSS() : c === "svg" ? Er = l.to2dCSS() : Hr = [l.props[0], l.props[1], l.props[2], l.props[3], l.props[4], l.props[5], l.props[6], l.props[7], l.props[8], l.props[9], l.props[10], l.props[11], l.props[12], l.props[13], l.props[14], l.props[15]], Br = rr;
          }
          p <= P ? (ye = new LetterProps(Br, kt, cr, Tr, Er, Hr), this.renderedLetters.push(ye), p += 1, this.lettersChangedFlag = !0) : (ye = this.renderedLetters[P], this.lettersChangedFlag = ye.update(Br, kt, cr, Tr, Er, Hr) || this.lettersChangedFlag);
        }
      }
    }, TextAnimatorProperty.prototype.getValue = function() {
      this._elem.globalData.frameId !== this._frameId && (this._frameId = this._elem.globalData.frameId, this.iterateDynamicProperties());
    }, TextAnimatorProperty.prototype.mHelper = new Matrix(), TextAnimatorProperty.prototype.defaultPropsArray = [], extendPrototype([DynamicPropertyContainer], TextAnimatorProperty);
    function ITextElement() {
    }
    ITextElement.prototype.initElement = function(e, t, n) {
      this.lettersChangedFlag = !0, this.initFrame(), this.initBaseData(e, t, n), this.textProperty = new TextProperty(this, e.t, this.dynamicProperties), this.textAnimator = new TextAnimatorProperty(e.t, this.renderType, this), this.initTransform(e, t, n), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide(), this.textAnimator.searchProperties(this.dynamicProperties);
    }, ITextElement.prototype.prepareFrame = function(e) {
      this._mdf = !1, this.prepareRenderableFrame(e), this.prepareProperties(e, this.isInRange);
    }, ITextElement.prototype.createPathShape = function(e, t) {
      var n, o = t.length, s, l = "";
      for (n = 0; n < o; n += 1)
        t[n].ty === "sh" && (s = t[n].ks.k, l += buildShapeString(s, s.i.length, !0, e));
      return l;
    }, ITextElement.prototype.updateDocumentData = function(e, t) {
      this.textProperty.updateDocumentData(e, t);
    }, ITextElement.prototype.canResizeFont = function(e) {
      this.textProperty.canResizeFont(e);
    }, ITextElement.prototype.setMinimumFontSize = function(e) {
      this.textProperty.setMinimumFontSize(e);
    }, ITextElement.prototype.applyTextPropertiesToMatrix = function(e, t, n, o, s) {
      switch (e.ps && t.translate(e.ps[0], e.ps[1] + e.ascent, 0), t.translate(0, -e.ls, 0), e.j) {
        case 1:
          t.translate(e.justifyOffset + (e.boxWidth - e.lineWidths[n]), 0, 0);
          break;
        case 2:
          t.translate(e.justifyOffset + (e.boxWidth - e.lineWidths[n]) / 2, 0, 0);
          break;
      }
      t.translate(o, s, 0);
    }, ITextElement.prototype.buildColor = function(e) {
      return "rgb(" + Math.round(e[0] * 255) + "," + Math.round(e[1] * 255) + "," + Math.round(e[2] * 255) + ")";
    }, ITextElement.prototype.emptyProp = new LetterProps(), ITextElement.prototype.destroy = function() {
    }, ITextElement.prototype.validateText = function() {
      (this.textProperty._mdf || this.textProperty._isFirstFrame) && (this.buildNewText(), this.textProperty._isFirstFrame = !1, this.textProperty._mdf = !1);
    };
    var emptyShapeData = {
      shapes: []
    };
    function SVGTextLottieElement(e, t, n) {
      this.textSpans = [], this.renderType = "svg", this.initElement(e, t, n);
    }
    extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], SVGTextLottieElement), SVGTextLottieElement.prototype.createContent = function() {
      this.data.singleShape && !this.globalData.fontManager.chars && (this.textContainer = createNS("text"));
    }, SVGTextLottieElement.prototype.buildTextContents = function(e) {
      for (var t = 0, n = e.length, o = [], s = ""; t < n; )
        e[t] === String.fromCharCode(13) || e[t] === String.fromCharCode(3) ? (o.push(s), s = "") : s += e[t], t += 1;
      return o.push(s), o;
    }, SVGTextLottieElement.prototype.buildShapeData = function(e, t) {
      if (e.shapes && e.shapes.length) {
        var n = e.shapes[0];
        if (n.it) {
          var o = n.it[n.it.length - 1];
          o.s && (o.s.k[0] = t, o.s.k[1] = t);
        }
      }
      return e;
    }, SVGTextLottieElement.prototype.buildNewText = function() {
      this.addDynamicProperty(this);
      var e, t, n = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(n ? n.l.length : 0), n.fc ? this.layerElement.setAttribute("fill", this.buildColor(n.fc)) : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"), n.sc && (this.layerElement.setAttribute("stroke", this.buildColor(n.sc)), this.layerElement.setAttribute("stroke-width", n.sw)), this.layerElement.setAttribute("font-size", n.finalSize);
      var o = this.globalData.fontManager.getFontByName(n.f);
      if (o.fClass)
        this.layerElement.setAttribute("class", o.fClass);
      else {
        this.layerElement.setAttribute("font-family", o.fFamily);
        var s = n.fWeight, l = n.fStyle;
        this.layerElement.setAttribute("font-style", l), this.layerElement.setAttribute("font-weight", s);
      }
      this.layerElement.setAttribute("aria-label", n.t);
      var c = n.l || [], p = !!this.globalData.fontManager.chars;
      t = c.length;
      var m, C = this.mHelper, P = "", w = this.data.singleShape, R = 0, L = 0, M = !0, $ = n.tr * 1e-3 * n.finalSize;
      if (w && !p && !n.sz) {
        var W = this.textContainer, H = "start";
        switch (n.j) {
          case 1:
            H = "end";
            break;
          case 2:
            H = "middle";
            break;
          default:
            H = "start";
            break;
        }
        W.setAttribute("text-anchor", H), W.setAttribute("letter-spacing", $);
        var V = this.buildTextContents(n.finalText);
        for (t = V.length, L = n.ps ? n.ps[1] + n.ascent : 0, e = 0; e < t; e += 1)
          m = this.textSpans[e].span || createNS("tspan"), m.textContent = V[e], m.setAttribute("x", 0), m.setAttribute("y", L), m.style.display = "inherit", W.appendChild(m), this.textSpans[e] || (this.textSpans[e] = {
            span: null,
            glyph: null
          }), this.textSpans[e].span = m, L += n.finalLineHeight;
        this.layerElement.appendChild(W);
      } else {
        var N = this.textSpans.length, B;
        for (e = 0; e < t; e += 1) {
          if (this.textSpans[e] || (this.textSpans[e] = {
            span: null,
            childSpan: null,
            glyph: null
          }), !p || !w || e === 0) {
            if (m = N > e ? this.textSpans[e].span : createNS(p ? "g" : "text"), N <= e) {
              if (m.setAttribute("stroke-linecap", "butt"), m.setAttribute("stroke-linejoin", "round"), m.setAttribute("stroke-miterlimit", "4"), this.textSpans[e].span = m, p) {
                var K = createNS("g");
                m.appendChild(K), this.textSpans[e].childSpan = K;
              }
              this.textSpans[e].span = m, this.layerElement.appendChild(m);
            }
            m.style.display = "inherit";
          }
          if (C.reset(), w && (c[e].n && (R = -$, L += n.yOffset, L += M ? 1 : 0, M = !1), this.applyTextPropertiesToMatrix(n, C, c[e].line, R, L), R += c[e].l || 0, R += $), p) {
            B = this.globalData.fontManager.getCharData(n.finalText[e], o.fStyle, this.globalData.fontManager.getFontByName(n.f).fFamily);
            var ue;
            if (B.t === 1)
              ue = new SVGCompElement(B.data, this.globalData, this);
            else {
              var de = emptyShapeData;
              B.data && B.data.shapes && (de = this.buildShapeData(B.data, n.finalSize)), ue = new SVGShapeElement(de, this.globalData, this);
            }
            if (this.textSpans[e].glyph) {
              var ve = this.textSpans[e].glyph;
              this.textSpans[e].childSpan.removeChild(ve.layerElement), ve.destroy();
            }
            this.textSpans[e].glyph = ue, ue._debug = !0, ue.prepareFrame(0), ue.renderFrame(), this.textSpans[e].childSpan.appendChild(ue.layerElement), B.t === 1 && this.textSpans[e].childSpan.setAttribute("transform", "scale(" + n.finalSize / 100 + "," + n.finalSize / 100 + ")");
          } else
            w && m.setAttribute("transform", "translate(" + C.props[12] + "," + C.props[13] + ")"), m.textContent = c[e].val, m.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
        }
        w && m && m.setAttribute("d", P);
      }
      for (; e < this.textSpans.length; )
        this.textSpans[e].span.style.display = "none", e += 1;
      this._sizeChanged = !0;
    }, SVGTextLottieElement.prototype.sourceRectAtTime = function() {
      if (this.prepareFrame(this.comp.renderedFrame - this.data.st), this.renderInnerContent(), this._sizeChanged) {
        this._sizeChanged = !1;
        var e = this.layerElement.getBBox();
        this.bbox = {
          top: e.y,
          left: e.x,
          width: e.width,
          height: e.height
        };
      }
      return this.bbox;
    }, SVGTextLottieElement.prototype.getValue = function() {
      var e, t = this.textSpans.length, n;
      for (this.renderedFrame = this.comp.renderedFrame, e = 0; e < t; e += 1)
        n = this.textSpans[e].glyph, n && (n.prepareFrame(this.comp.renderedFrame - this.data.st), n._mdf && (this._mdf = !0));
    }, SVGTextLottieElement.prototype.renderInnerContent = function() {
      if (this.validateText(), (!this.data.singleShape || this._mdf) && (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)) {
        this._sizeChanged = !0;
        var e, t, n = this.textAnimator.renderedLetters, o = this.textProperty.currentData.l;
        t = o.length;
        var s, l, c;
        for (e = 0; e < t; e += 1)
          o[e].n || (s = n[e], l = this.textSpans[e].span, c = this.textSpans[e].glyph, c && c.renderFrame(), s._mdf.m && l.setAttribute("transform", s.m), s._mdf.o && l.setAttribute("opacity", s.o), s._mdf.sw && l.setAttribute("stroke-width", s.sw), s._mdf.sc && l.setAttribute("stroke", s.sc), s._mdf.fc && l.setAttribute("fill", s.fc));
      }
    };
    function ISolidElement(e, t, n) {
      this.initElement(e, t, n);
    }
    extendPrototype([IImageElement], ISolidElement), ISolidElement.prototype.createContent = function() {
      var e = createNS("rect");
      e.setAttribute("width", this.data.sw), e.setAttribute("height", this.data.sh), e.setAttribute("fill", this.data.sc), this.layerElement.appendChild(e);
    };
    function NullElement(e, t, n) {
      this.initFrame(), this.initBaseData(e, t, n), this.initFrame(), this.initTransform(e, t, n), this.initHierarchy();
    }
    NullElement.prototype.prepareFrame = function(e) {
      this.prepareProperties(e, !0);
    }, NullElement.prototype.renderFrame = function() {
    }, NullElement.prototype.getBaseElement = function() {
      return null;
    }, NullElement.prototype.destroy = function() {
    }, NullElement.prototype.sourceRectAtTime = function() {
    }, NullElement.prototype.hide = function() {
    }, extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement], NullElement);
    function SVGRendererBase() {
    }
    extendPrototype([BaseRenderer], SVGRendererBase), SVGRendererBase.prototype.createNull = function(e) {
      return new NullElement(e, this.globalData, this);
    }, SVGRendererBase.prototype.createShape = function(e) {
      return new SVGShapeElement(e, this.globalData, this);
    }, SVGRendererBase.prototype.createText = function(e) {
      return new SVGTextLottieElement(e, this.globalData, this);
    }, SVGRendererBase.prototype.createImage = function(e) {
      return new IImageElement(e, this.globalData, this);
    }, SVGRendererBase.prototype.createSolid = function(e) {
      return new ISolidElement(e, this.globalData, this);
    }, SVGRendererBase.prototype.configAnimation = function(e) {
      this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"), this.svgElement.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"), this.renderConfig.viewBoxSize ? this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize) : this.svgElement.setAttribute("viewBox", "0 0 " + e.w + " " + e.h), this.renderConfig.viewBoxOnly || (this.svgElement.setAttribute("width", e.w), this.svgElement.setAttribute("height", e.h), this.svgElement.style.width = "100%", this.svgElement.style.height = "100%", this.svgElement.style.transform = "translate3d(0,0,0)", this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility), this.renderConfig.width && this.svgElement.setAttribute("width", this.renderConfig.width), this.renderConfig.height && this.svgElement.setAttribute("height", this.renderConfig.height), this.renderConfig.className && this.svgElement.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.svgElement.setAttribute("id", this.renderConfig.id), this.renderConfig.focusable !== void 0 && this.svgElement.setAttribute("focusable", this.renderConfig.focusable), this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio), this.animationItem.wrapper.appendChild(this.svgElement);
      var t = this.globalData.defs;
      this.setupGlobalData(e, t), this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.data = e;
      var n = createNS("clipPath"), o = createNS("rect");
      o.setAttribute("width", e.w), o.setAttribute("height", e.h), o.setAttribute("x", 0), o.setAttribute("y", 0);
      var s = createElementID();
      n.setAttribute("id", s), n.appendChild(o), this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + s + ")"), t.appendChild(n), this.layers = e.layers, this.elements = createSizedArray(e.layers.length);
    }, SVGRendererBase.prototype.destroy = function() {
      this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.layerElement = null, this.globalData.defs = null;
      var e, t = this.layers ? this.layers.length : 0;
      for (e = 0; e < t; e += 1)
        this.elements[e] && this.elements[e].destroy && this.elements[e].destroy();
      this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
    }, SVGRendererBase.prototype.updateContainerSize = function() {
    }, SVGRendererBase.prototype.findIndexByInd = function(e) {
      var t = 0, n = this.layers.length;
      for (t = 0; t < n; t += 1)
        if (this.layers[t].ind === e)
          return t;
      return -1;
    }, SVGRendererBase.prototype.buildItem = function(e) {
      var t = this.elements;
      if (!(t[e] || this.layers[e].ty === 99)) {
        t[e] = !0;
        var n = this.createItem(this.layers[e]);
        if (t[e] = n, getExpressionsPlugin() && (this.layers[e].ty === 0 && this.globalData.projectInterface.registerComposition(n), n.initExpressions()), this.appendElementInPos(n, e), this.layers[e].tt) {
          var o = "tp" in this.layers[e] ? this.findIndexByInd(this.layers[e].tp) : e - 1;
          if (o === -1)
            return;
          if (!this.elements[o] || this.elements[o] === !0)
            this.buildItem(o), this.addPendingElement(n);
          else {
            var s = t[o], l = s.getMatte(this.layers[e].tt);
            n.setMatte(l);
          }
        }
      }
    }, SVGRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; ) {
        var e = this.pendingElements.pop();
        if (e.checkParenting(), e.data.tt)
          for (var t = 0, n = this.elements.length; t < n; ) {
            if (this.elements[t] === e) {
              var o = "tp" in e.data ? this.findIndexByInd(e.data.tp) : t - 1, s = this.elements[o], l = s.getMatte(this.layers[t].tt);
              e.setMatte(l);
              break;
            }
            t += 1;
          }
      }
    }, SVGRendererBase.prototype.renderFrame = function(e) {
      if (!(this.renderedFrame === e || this.destroyed)) {
        e === null ? e = this.renderedFrame : this.renderedFrame = e, this.globalData.frameNum = e, this.globalData.frameId += 1, this.globalData.projectInterface.currentFrame = e, this.globalData._mdf = !1;
        var t, n = this.layers.length;
        for (this.completeLayers || this.checkLayers(e), t = n - 1; t >= 0; t -= 1)
          (this.completeLayers || this.elements[t]) && this.elements[t].prepareFrame(e - this.layers[t].st);
        if (this.globalData._mdf)
          for (t = 0; t < n; t += 1)
            (this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
      }
    }, SVGRendererBase.prototype.appendElementInPos = function(e, t) {
      var n = e.getBaseElement();
      if (n) {
        for (var o = 0, s; o < t; )
          this.elements[o] && this.elements[o] !== !0 && this.elements[o].getBaseElement() && (s = this.elements[o].getBaseElement()), o += 1;
        s ? this.layerElement.insertBefore(n, s) : this.layerElement.appendChild(n);
      }
    }, SVGRendererBase.prototype.hide = function() {
      this.layerElement.style.display = "none";
    }, SVGRendererBase.prototype.show = function() {
      this.layerElement.style.display = "block";
    };
    function ICompElement() {
    }
    extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement], ICompElement), ICompElement.prototype.initElement = function(e, t, n) {
      this.initFrame(), this.initBaseData(e, t, n), this.initTransform(e, t, n), this.initRenderable(), this.initHierarchy(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), (this.data.xt || !t.progressiveLoad) && this.buildAllItems(), this.hide();
    }, ICompElement.prototype.prepareFrame = function(e) {
      if (this._mdf = !1, this.prepareRenderableFrame(e), this.prepareProperties(e, this.isInRange), !(!this.isInRange && !this.data.xt)) {
        if (this.tm._placeholder)
          this.renderedFrame = e / this.data.sr;
        else {
          var t = this.tm.v;
          t === this.data.op && (t = this.data.op - 1), this.renderedFrame = t;
        }
        var n, o = this.elements.length;
        for (this.completeLayers || this.checkLayers(this.renderedFrame), n = o - 1; n >= 0; n -= 1)
          (this.completeLayers || this.elements[n]) && (this.elements[n].prepareFrame(this.renderedFrame - this.layers[n].st), this.elements[n]._mdf && (this._mdf = !0));
      }
    }, ICompElement.prototype.renderInnerContent = function() {
      var e, t = this.layers.length;
      for (e = 0; e < t; e += 1)
        (this.completeLayers || this.elements[e]) && this.elements[e].renderFrame();
    }, ICompElement.prototype.setElements = function(e) {
      this.elements = e;
    }, ICompElement.prototype.getElements = function() {
      return this.elements;
    }, ICompElement.prototype.destroyElements = function() {
      var e, t = this.layers.length;
      for (e = 0; e < t; e += 1)
        this.elements[e] && this.elements[e].destroy();
    }, ICompElement.prototype.destroy = function() {
      this.destroyElements(), this.destroyBaseElement();
    };
    function SVGCompElement(e, t, n) {
      this.layers = e.layers, this.supports3d = !0, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(e, t, n), this.tm = e.tm ? PropertyFactory.getProp(this, e.tm, 0, t.frameRate, this) : {
        _placeholder: !0
      };
    }
    extendPrototype([SVGRendererBase, ICompElement, SVGBaseElement], SVGCompElement), SVGCompElement.prototype.createComp = function(e) {
      return new SVGCompElement(e, this.globalData, this);
    };
    function SVGRenderer(e, t) {
      this.animationItem = e, this.layers = null, this.renderedFrame = -1, this.svgElement = createNS("svg");
      var n = "";
      if (t && t.title) {
        var o = createNS("title"), s = createElementID();
        o.setAttribute("id", s), o.textContent = t.title, this.svgElement.appendChild(o), n += s;
      }
      if (t && t.description) {
        var l = createNS("desc"), c = createElementID();
        l.setAttribute("id", c), l.textContent = t.description, this.svgElement.appendChild(l), n += " " + c;
      }
      n && this.svgElement.setAttribute("aria-labelledby", n);
      var p = createNS("defs");
      this.svgElement.appendChild(p);
      var m = createNS("g");
      this.svgElement.appendChild(m), this.layerElement = m, this.renderConfig = {
        preserveAspectRatio: t && t.preserveAspectRatio || "xMidYMid meet",
        imagePreserveAspectRatio: t && t.imagePreserveAspectRatio || "xMidYMid slice",
        contentVisibility: t && t.contentVisibility || "visible",
        progressiveLoad: t && t.progressiveLoad || !1,
        hideOnTransparent: !(t && t.hideOnTransparent === !1),
        viewBoxOnly: t && t.viewBoxOnly || !1,
        viewBoxSize: t && t.viewBoxSize || !1,
        className: t && t.className || "",
        id: t && t.id || "",
        focusable: t && t.focusable,
        filterSize: {
          width: t && t.filterSize && t.filterSize.width || "100%",
          height: t && t.filterSize && t.filterSize.height || "100%",
          x: t && t.filterSize && t.filterSize.x || "0%",
          y: t && t.filterSize && t.filterSize.y || "0%"
        },
        width: t && t.width,
        height: t && t.height,
        runExpressions: !t || t.runExpressions === void 0 || t.runExpressions
      }, this.globalData = {
        _mdf: !1,
        frameNum: -1,
        defs: p,
        renderConfig: this.renderConfig
      }, this.elements = [], this.pendingElements = [], this.destroyed = !1, this.rendererType = "svg";
    }
    extendPrototype([SVGRendererBase], SVGRenderer), SVGRenderer.prototype.createComp = function(e) {
      return new SVGCompElement(e, this.globalData, this);
    };
    function ShapeTransformManager() {
      this.sequences = {}, this.sequenceList = [], this.transform_key_count = 0;
    }
    ShapeTransformManager.prototype = {
      addTransformSequence: function(t) {
        var n, o = t.length, s = "_";
        for (n = 0; n < o; n += 1)
          s += t[n].transform.key + "_";
        var l = this.sequences[s];
        return l || (l = {
          transforms: [].concat(t),
          finalTransform: new Matrix(),
          _mdf: !1
        }, this.sequences[s] = l, this.sequenceList.push(l)), l;
      },
      processSequence: function(t, n) {
        for (var o = 0, s = t.transforms.length, l = n; o < s && !n; ) {
          if (t.transforms[o].transform.mProps._mdf) {
            l = !0;
            break;
          }
          o += 1;
        }
        if (l)
          for (t.finalTransform.reset(), o = s - 1; o >= 0; o -= 1)
            t.finalTransform.multiply(t.transforms[o].transform.mProps.v);
        t._mdf = l;
      },
      processSequences: function(t) {
        var n, o = this.sequenceList.length;
        for (n = 0; n < o; n += 1)
          this.processSequence(this.sequenceList[n], t);
      },
      getNewKey: function() {
        return this.transform_key_count += 1, "_" + this.transform_key_count;
      }
    };
    var lumaLoader = function() {
      var t = "__lottie_element_luma_buffer", n = null, o = null, s = null;
      function l() {
        var m = createNS("svg"), C = createNS("filter"), P = createNS("feColorMatrix");
        return C.setAttribute("id", t), P.setAttribute("type", "matrix"), P.setAttribute("color-interpolation-filters", "sRGB"), P.setAttribute("values", "0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0"), C.appendChild(P), m.appendChild(C), m.setAttribute("id", t + "_svg"), featureSupport.svgLumaHidden && (m.style.display = "none"), m;
      }
      function c() {
        n || (s = l(), document.body.appendChild(s), n = createTag("canvas"), o = n.getContext("2d"), o.filter = "url(#" + t + ")", o.fillStyle = "rgba(0,0,0,0)", o.fillRect(0, 0, 1, 1));
      }
      function p(m) {
        return n || c(), n.width = m.width, n.height = m.height, o.filter = "url(#" + t + ")", n;
      }
      return {
        load: c,
        get: p
      };
    };
    function createCanvas(e, t) {
      if (featureSupport.offscreenCanvas)
        return new OffscreenCanvas(e, t);
      var n = createTag("canvas");
      return n.width = e, n.height = t, n;
    }
    var assetLoader = function() {
      return {
        loadLumaCanvas: lumaLoader.load,
        getLumaCanvas: lumaLoader.get,
        createCanvas
      };
    }(), registeredEffects = {};
    function CVEffects(e) {
      var t, n = e.data.ef ? e.data.ef.length : 0;
      this.filters = [];
      var o;
      for (t = 0; t < n; t += 1) {
        o = null;
        var s = e.data.ef[t].ty;
        if (registeredEffects[s]) {
          var l = registeredEffects[s].effect;
          o = new l(e.effectsManager.effectElements[t], e);
        }
        o && this.filters.push(o);
      }
      this.filters.length && e.addRenderableComponent(this);
    }
    CVEffects.prototype.renderFrame = function(e) {
      var t, n = this.filters.length;
      for (t = 0; t < n; t += 1)
        this.filters[t].renderFrame(e);
    }, CVEffects.prototype.getEffects = function(e) {
      var t, n = this.filters.length, o = [];
      for (t = 0; t < n; t += 1)
        this.filters[t].type === e && o.push(this.filters[t]);
      return o;
    };
    function registerEffect(e, t) {
      registeredEffects[e] = {
        effect: t
      };
    }
    function CVMaskElement(e, t) {
      this.data = e, this.element = t, this.masksProperties = this.data.masksProperties || [], this.viewData = createSizedArray(this.masksProperties.length);
      var n, o = this.masksProperties.length, s = !1;
      for (n = 0; n < o; n += 1)
        this.masksProperties[n].mode !== "n" && (s = !0), this.viewData[n] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[n], 3);
      this.hasMasks = s, s && this.element.addRenderableComponent(this);
    }
    CVMaskElement.prototype.renderFrame = function() {
      if (this.hasMasks) {
        var e = this.element.finalTransform.mat, t = this.element.canvasContext, n, o = this.masksProperties.length, s, l, c;
        for (t.beginPath(), n = 0; n < o; n += 1)
          if (this.masksProperties[n].mode !== "n") {
            this.masksProperties[n].inv && (t.moveTo(0, 0), t.lineTo(this.element.globalData.compSize.w, 0), t.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h), t.lineTo(0, this.element.globalData.compSize.h), t.lineTo(0, 0)), c = this.viewData[n].v, s = e.applyToPointArray(c.v[0][0], c.v[0][1], 0), t.moveTo(s[0], s[1]);
            var p, m = c._length;
            for (p = 1; p < m; p += 1)
              l = e.applyToTriplePoints(c.o[p - 1], c.i[p], c.v[p]), t.bezierCurveTo(l[0], l[1], l[2], l[3], l[4], l[5]);
            l = e.applyToTriplePoints(c.o[p - 1], c.i[0], c.v[0]), t.bezierCurveTo(l[0], l[1], l[2], l[3], l[4], l[5]);
          }
        this.element.globalData.renderer.save(!0), t.clip();
      }
    }, CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty, CVMaskElement.prototype.destroy = function() {
      this.element = null;
    };
    function CVBaseElement() {
    }
    var operationsMap = {
      1: "source-in",
      2: "source-out",
      3: "source-in",
      4: "source-out"
    };
    CVBaseElement.prototype = {
      createElements: function() {
      },
      initRendererElement: function() {
      },
      createContainerElements: function() {
        if (this.data.tt >= 1) {
          this.buffers = [];
          var t = this.globalData.canvasContext, n = assetLoader.createCanvas(t.canvas.width, t.canvas.height);
          this.buffers.push(n);
          var o = assetLoader.createCanvas(t.canvas.width, t.canvas.height);
          this.buffers.push(o), this.data.tt >= 3 && !document._isProxy && assetLoader.loadLumaCanvas();
        }
        this.canvasContext = this.globalData.canvasContext, this.transformCanvas = this.globalData.transformCanvas, this.renderableEffectsManager = new CVEffects(this), this.searchEffectTransforms();
      },
      createContent: function() {
      },
      setBlendMode: function() {
        var t = this.globalData;
        if (t.blendMode !== this.data.bm) {
          t.blendMode = this.data.bm;
          var n = getBlendMode(this.data.bm);
          t.canvasContext.globalCompositeOperation = n;
        }
      },
      createRenderableComponents: function() {
        this.maskManager = new CVMaskElement(this.data, this), this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
      },
      hideElement: function() {
        !this.hidden && (!this.isInRange || this.isTransparent) && (this.hidden = !0);
      },
      showElement: function() {
        this.isInRange && !this.isTransparent && (this.hidden = !1, this._isFirstFrame = !0, this.maskManager._isFirstFrame = !0);
      },
      clearCanvas: function(t) {
        t.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
      },
      prepareLayer: function() {
        if (this.data.tt >= 1) {
          var t = this.buffers[0], n = t.getContext("2d");
          this.clearCanvas(n), n.drawImage(this.canvasContext.canvas, 0, 0), this.currentTransform = this.canvasContext.getTransform(), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform);
        }
      },
      exitLayer: function() {
        if (this.data.tt >= 1) {
          var t = this.buffers[1], n = t.getContext("2d");
          this.clearCanvas(n), n.drawImage(this.canvasContext.canvas, 0, 0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform);
          var o = this.comp.getElementById("tp" in this.data ? this.data.tp : this.data.ind - 1);
          if (o.renderFrame(!0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.data.tt >= 3 && !document._isProxy) {
            var s = assetLoader.getLumaCanvas(this.canvasContext.canvas), l = s.getContext("2d");
            l.drawImage(this.canvasContext.canvas, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.drawImage(s, 0, 0);
          }
          this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt], this.canvasContext.drawImage(t, 0, 0), this.canvasContext.globalCompositeOperation = "destination-over", this.canvasContext.drawImage(this.buffers[0], 0, 0), this.canvasContext.setTransform(this.currentTransform), this.canvasContext.globalCompositeOperation = "source-over";
        }
      },
      renderFrame: function(t) {
        if (!(this.hidden || this.data.hd) && !(this.data.td === 1 && !t)) {
          this.renderTransform(), this.renderRenderable(), this.renderLocalTransform(), this.setBlendMode();
          var n = this.data.ty === 0;
          this.prepareLayer(), this.globalData.renderer.save(n), this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props), this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity), this.renderInnerContent(), this.globalData.renderer.restore(n), this.exitLayer(), this.maskManager.hasMasks && this.globalData.renderer.restore(!0), this._isFirstFrame && (this._isFirstFrame = !1);
        }
      },
      destroy: function() {
        this.canvasContext = null, this.data = null, this.globalData = null, this.maskManager.destroy();
      },
      mHelper: new Matrix()
    }, CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement, CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;
    function CVShapeData(e, t, n, o) {
      this.styledShapes = [], this.tr = [0, 0, 0, 0, 0, 0];
      var s = 4;
      t.ty === "rc" ? s = 5 : t.ty === "el" ? s = 6 : t.ty === "sr" && (s = 7), this.sh = ShapePropertyFactory.getShapeProp(e, t, s, e);
      var l, c = n.length, p;
      for (l = 0; l < c; l += 1)
        n[l].closed || (p = {
          transforms: o.addTransformSequence(n[l].transforms),
          trNodes: []
        }, this.styledShapes.push(p), n[l].elements.push(p));
    }
    CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;
    function CVShapeElement(e, t, n) {
      this.shapes = [], this.shapesData = e.shapes, this.stylesList = [], this.itemsData = [], this.prevViewData = [], this.shapeModifiers = [], this.processedElements = [], this.transformsManager = new ShapeTransformManager(), this.initElement(e, t, n);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableElement], CVShapeElement), CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement, CVShapeElement.prototype.transformHelper = {
      opacity: 1,
      _opMdf: !1
    }, CVShapeElement.prototype.dashResetter = [], CVShapeElement.prototype.createContent = function() {
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []);
    }, CVShapeElement.prototype.createStyleElement = function(e, t) {
      var n = {
        data: e,
        type: e.ty,
        preTransforms: this.transformsManager.addTransformSequence(t),
        transforms: [],
        elements: [],
        closed: e.hd === !0
      }, o = {};
      if (e.ty === "fl" || e.ty === "st" ? (o.c = PropertyFactory.getProp(this, e.c, 1, 255, this), o.c.k || (n.co = "rgb(" + bmFloor(o.c.v[0]) + "," + bmFloor(o.c.v[1]) + "," + bmFloor(o.c.v[2]) + ")")) : (e.ty === "gf" || e.ty === "gs") && (o.s = PropertyFactory.getProp(this, e.s, 1, null, this), o.e = PropertyFactory.getProp(this, e.e, 1, null, this), o.h = PropertyFactory.getProp(this, e.h || {
        k: 0
      }, 0, 0.01, this), o.a = PropertyFactory.getProp(this, e.a || {
        k: 0
      }, 0, degToRads, this), o.g = new GradientProperty(this, e.g, this)), o.o = PropertyFactory.getProp(this, e.o, 0, 0.01, this), e.ty === "st" || e.ty === "gs") {
        if (n.lc = lineCapEnum[e.lc || 2], n.lj = lineJoinEnum[e.lj || 2], e.lj == 1 && (n.ml = e.ml), o.w = PropertyFactory.getProp(this, e.w, 0, null, this), o.w.k || (n.wi = o.w.v), e.d) {
          var s = new DashProperty(this, e.d, "canvas", this);
          o.d = s, o.d.k || (n.da = o.d.dashArray, n.do = o.d.dashoffset[0]);
        }
      } else
        n.r = e.r === 2 ? "evenodd" : "nonzero";
      return this.stylesList.push(n), o.style = n, o;
    }, CVShapeElement.prototype.createGroupElement = function() {
      var e = {
        it: [],
        prevViewData: []
      };
      return e;
    }, CVShapeElement.prototype.createTransformElement = function(e) {
      var t = {
        transform: {
          opacity: 1,
          _opMdf: !1,
          key: this.transformsManager.getNewKey(),
          op: PropertyFactory.getProp(this, e.o, 0, 0.01, this),
          mProps: TransformPropertyFactory.getTransformProperty(this, e, this)
        }
      };
      return t;
    }, CVShapeElement.prototype.createShapeElement = function(e) {
      var t = new CVShapeData(this, e, this.stylesList, this.transformsManager);
      return this.shapes.push(t), this.addShapeToModifiers(t), t;
    }, CVShapeElement.prototype.reloadShapes = function() {
      this._isFirstFrame = !0;
      var e, t = this.itemsData.length;
      for (e = 0; e < t; e += 1)
        this.prevViewData[e] = this.itemsData[e];
      for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []), t = this.dynamicProperties.length, e = 0; e < t; e += 1)
        this.dynamicProperties[e].getValue();
      this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame);
    }, CVShapeElement.prototype.addTransformToStyleList = function(e) {
      var t, n = this.stylesList.length;
      for (t = 0; t < n; t += 1)
        this.stylesList[t].closed || this.stylesList[t].transforms.push(e);
    }, CVShapeElement.prototype.removeTransformFromStyleList = function() {
      var e, t = this.stylesList.length;
      for (e = 0; e < t; e += 1)
        this.stylesList[e].closed || this.stylesList[e].transforms.pop();
    }, CVShapeElement.prototype.closeStyles = function(e) {
      var t, n = e.length;
      for (t = 0; t < n; t += 1)
        e[t].closed = !0;
    }, CVShapeElement.prototype.searchShapes = function(e, t, n, o, s) {
      var l, c = e.length - 1, p, m, C = [], P = [], w, R, L, M = [].concat(s);
      for (l = c; l >= 0; l -= 1) {
        if (w = this.searchProcessedElement(e[l]), w ? t[l] = n[w - 1] : e[l]._shouldRender = o, e[l].ty === "fl" || e[l].ty === "st" || e[l].ty === "gf" || e[l].ty === "gs")
          w ? t[l].style.closed = !1 : t[l] = this.createStyleElement(e[l], M), C.push(t[l].style);
        else if (e[l].ty === "gr") {
          if (!w)
            t[l] = this.createGroupElement(e[l]);
          else
            for (m = t[l].it.length, p = 0; p < m; p += 1)
              t[l].prevViewData[p] = t[l].it[p];
          this.searchShapes(e[l].it, t[l].it, t[l].prevViewData, o, M);
        } else
          e[l].ty === "tr" ? (w || (L = this.createTransformElement(e[l]), t[l] = L), M.push(t[l]), this.addTransformToStyleList(t[l])) : e[l].ty === "sh" || e[l].ty === "rc" || e[l].ty === "el" || e[l].ty === "sr" ? w || (t[l] = this.createShapeElement(e[l])) : e[l].ty === "tm" || e[l].ty === "rd" || e[l].ty === "pb" || e[l].ty === "zz" || e[l].ty === "op" ? (w ? (R = t[l], R.closed = !1) : (R = ShapeModifiers.getModifier(e[l].ty), R.init(this, e[l]), t[l] = R, this.shapeModifiers.push(R)), P.push(R)) : e[l].ty === "rp" && (w ? (R = t[l], R.closed = !0) : (R = ShapeModifiers.getModifier(e[l].ty), t[l] = R, R.init(this, e, l, t), this.shapeModifiers.push(R), o = !1), P.push(R));
        this.addProcessedElement(e[l], l + 1);
      }
      for (this.removeTransformFromStyleList(), this.closeStyles(C), c = P.length, l = 0; l < c; l += 1)
        P[l].closed = !0;
    }, CVShapeElement.prototype.renderInnerContent = function() {
      this.transformHelper.opacity = 1, this.transformHelper._opMdf = !1, this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame), this.renderShape(this.transformHelper, this.shapesData, this.itemsData, !0);
    }, CVShapeElement.prototype.renderShapeTransform = function(e, t) {
      (e._opMdf || t.op._mdf || this._isFirstFrame) && (t.opacity = e.opacity, t.opacity *= t.op.v, t._opMdf = !0);
    }, CVShapeElement.prototype.drawLayer = function() {
      var e, t = this.stylesList.length, n, o, s, l, c, p, m = this.globalData.renderer, C = this.globalData.canvasContext, P, w;
      for (e = 0; e < t; e += 1)
        if (w = this.stylesList[e], P = w.type, !((P === "st" || P === "gs") && w.wi === 0 || !w.data._shouldRender || w.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
          for (m.save(), c = w.elements, P === "st" || P === "gs" ? (m.ctxStrokeStyle(P === "st" ? w.co : w.grd), m.ctxLineWidth(w.wi), m.ctxLineCap(w.lc), m.ctxLineJoin(w.lj), m.ctxMiterLimit(w.ml || 0)) : m.ctxFillStyle(P === "fl" ? w.co : w.grd), m.ctxOpacity(w.coOp), P !== "st" && P !== "gs" && C.beginPath(), m.ctxTransform(w.preTransforms.finalTransform.props), o = c.length, n = 0; n < o; n += 1) {
            for ((P === "st" || P === "gs") && (C.beginPath(), w.da && (C.setLineDash(w.da), C.lineDashOffset = w.do)), p = c[n].trNodes, l = p.length, s = 0; s < l; s += 1)
              p[s].t === "m" ? C.moveTo(p[s].p[0], p[s].p[1]) : p[s].t === "c" ? C.bezierCurveTo(p[s].pts[0], p[s].pts[1], p[s].pts[2], p[s].pts[3], p[s].pts[4], p[s].pts[5]) : C.closePath();
            (P === "st" || P === "gs") && (m.ctxStroke(), w.da && C.setLineDash(this.dashResetter));
          }
          P !== "st" && P !== "gs" && this.globalData.renderer.ctxFill(w.r), m.restore();
        }
    }, CVShapeElement.prototype.renderShape = function(e, t, n, o) {
      var s, l = t.length - 1, c;
      for (c = e, s = l; s >= 0; s -= 1)
        t[s].ty === "tr" ? (c = n[s].transform, this.renderShapeTransform(e, c)) : t[s].ty === "sh" || t[s].ty === "el" || t[s].ty === "rc" || t[s].ty === "sr" ? this.renderPath(t[s], n[s]) : t[s].ty === "fl" ? this.renderFill(t[s], n[s], c) : t[s].ty === "st" ? this.renderStroke(t[s], n[s], c) : t[s].ty === "gf" || t[s].ty === "gs" ? this.renderGradientFill(t[s], n[s], c) : t[s].ty === "gr" ? this.renderShape(c, t[s].it, n[s].it) : t[s].ty;
      o && this.drawLayer();
    }, CVShapeElement.prototype.renderStyledShape = function(e, t) {
      if (this._isFirstFrame || t._mdf || e.transforms._mdf) {
        var n = e.trNodes, o = t.paths, s, l, c, p = o._length;
        n.length = 0;
        var m = e.transforms.finalTransform;
        for (c = 0; c < p; c += 1) {
          var C = o.shapes[c];
          if (C && C.v) {
            for (l = C._length, s = 1; s < l; s += 1)
              s === 1 && n.push({
                t: "m",
                p: m.applyToPointArray(C.v[0][0], C.v[0][1], 0)
              }), n.push({
                t: "c",
                pts: m.applyToTriplePoints(C.o[s - 1], C.i[s], C.v[s])
              });
            l === 1 && n.push({
              t: "m",
              p: m.applyToPointArray(C.v[0][0], C.v[0][1], 0)
            }), C.c && l && (n.push({
              t: "c",
              pts: m.applyToTriplePoints(C.o[s - 1], C.i[0], C.v[0])
            }), n.push({
              t: "z"
            }));
          }
        }
        e.trNodes = n;
      }
    }, CVShapeElement.prototype.renderPath = function(e, t) {
      if (e.hd !== !0 && e._shouldRender) {
        var n, o = t.styledShapes.length;
        for (n = 0; n < o; n += 1)
          this.renderStyledShape(t.styledShapes[n], t.sh);
      }
    }, CVShapeElement.prototype.renderFill = function(e, t, n) {
      var o = t.style;
      (t.c._mdf || this._isFirstFrame) && (o.co = "rgb(" + bmFloor(t.c.v[0]) + "," + bmFloor(t.c.v[1]) + "," + bmFloor(t.c.v[2]) + ")"), (t.o._mdf || n._opMdf || this._isFirstFrame) && (o.coOp = t.o.v * n.opacity);
    }, CVShapeElement.prototype.renderGradientFill = function(e, t, n) {
      var o = t.style, s;
      if (!o.grd || t.g._mdf || t.s._mdf || t.e._mdf || e.t !== 1 && (t.h._mdf || t.a._mdf)) {
        var l = this.globalData.canvasContext, c = t.s.v, p = t.e.v;
        if (e.t === 1)
          s = l.createLinearGradient(c[0], c[1], p[0], p[1]);
        else {
          var m = Math.sqrt(Math.pow(c[0] - p[0], 2) + Math.pow(c[1] - p[1], 2)), C = Math.atan2(p[1] - c[1], p[0] - c[0]), P = t.h.v;
          P >= 1 ? P = 0.99 : P <= -1 && (P = -0.99);
          var w = m * P, R = Math.cos(C + t.a.v) * w + c[0], L = Math.sin(C + t.a.v) * w + c[1];
          s = l.createRadialGradient(R, L, 0, c[0], c[1], m);
        }
        var M, $ = e.g.p, W = t.g.c, H = 1;
        for (M = 0; M < $; M += 1)
          t.g._hasOpacity && t.g._collapsable && (H = t.g.o[M * 2 + 1]), s.addColorStop(W[M * 4] / 100, "rgba(" + W[M * 4 + 1] + "," + W[M * 4 + 2] + "," + W[M * 4 + 3] + "," + H + ")");
        o.grd = s;
      }
      o.coOp = t.o.v * n.opacity;
    }, CVShapeElement.prototype.renderStroke = function(e, t, n) {
      var o = t.style, s = t.d;
      s && (s._mdf || this._isFirstFrame) && (o.da = s.dashArray, o.do = s.dashoffset[0]), (t.c._mdf || this._isFirstFrame) && (o.co = "rgb(" + bmFloor(t.c.v[0]) + "," + bmFloor(t.c.v[1]) + "," + bmFloor(t.c.v[2]) + ")"), (t.o._mdf || n._opMdf || this._isFirstFrame) && (o.coOp = t.o.v * n.opacity), (t.w._mdf || this._isFirstFrame) && (o.wi = t.w.v);
    }, CVShapeElement.prototype.destroy = function() {
      this.shapesData = null, this.globalData = null, this.canvasContext = null, this.stylesList.length = 0, this.itemsData.length = 0;
    };
    function CVTextElement(e, t, n) {
      this.textSpans = [], this.yOffset = 0, this.fillColorAnim = !1, this.strokeColorAnim = !1, this.strokeWidthAnim = !1, this.stroke = !1, this.fill = !1, this.justifyOffset = 0, this.currentRender = null, this.renderType = "canvas", this.values = {
        fill: "rgba(0,0,0,0)",
        stroke: "rgba(0,0,0,0)",
        sWidth: 0,
        fValue: ""
      }, this.initElement(e, t, n);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement, ITextElement], CVTextElement), CVTextElement.prototype.tHelper = createTag("canvas").getContext("2d"), CVTextElement.prototype.buildNewText = function() {
      var e = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(e.l ? e.l.length : 0);
      var t = !1;
      e.fc ? (t = !0, this.values.fill = this.buildColor(e.fc)) : this.values.fill = "rgba(0,0,0,0)", this.fill = t;
      var n = !1;
      e.sc && (n = !0, this.values.stroke = this.buildColor(e.sc), this.values.sWidth = e.sw);
      var o = this.globalData.fontManager.getFontByName(e.f), s, l, c = e.l, p = this.mHelper;
      this.stroke = n, this.values.fValue = e.finalSize + "px " + this.globalData.fontManager.getFontByName(e.f).fFamily, l = e.finalText.length;
      var m, C, P, w, R, L, M, $, W, H, V = this.data.singleShape, N = e.tr * 1e-3 * e.finalSize, B = 0, K = 0, ue = !0, de = 0;
      for (s = 0; s < l; s += 1) {
        m = this.globalData.fontManager.getCharData(e.finalText[s], o.fStyle, this.globalData.fontManager.getFontByName(e.f).fFamily), C = m && m.data || {}, p.reset(), V && c[s].n && (B = -N, K += e.yOffset, K += ue ? 1 : 0, ue = !1), R = C.shapes ? C.shapes[0].it : [], M = R.length, p.scale(e.finalSize / 100, e.finalSize / 100), V && this.applyTextPropertiesToMatrix(e, p, c[s].line, B, K), W = createSizedArray(M - 1);
        var ve = 0;
        for (L = 0; L < M; L += 1)
          if (R[L].ty === "sh") {
            for (w = R[L].ks.k.i.length, $ = R[L].ks.k, H = [], P = 1; P < w; P += 1)
              P === 1 && H.push(p.applyToX($.v[0][0], $.v[0][1], 0), p.applyToY($.v[0][0], $.v[0][1], 0)), H.push(p.applyToX($.o[P - 1][0], $.o[P - 1][1], 0), p.applyToY($.o[P - 1][0], $.o[P - 1][1], 0), p.applyToX($.i[P][0], $.i[P][1], 0), p.applyToY($.i[P][0], $.i[P][1], 0), p.applyToX($.v[P][0], $.v[P][1], 0), p.applyToY($.v[P][0], $.v[P][1], 0));
            H.push(p.applyToX($.o[P - 1][0], $.o[P - 1][1], 0), p.applyToY($.o[P - 1][0], $.o[P - 1][1], 0), p.applyToX($.i[0][0], $.i[0][1], 0), p.applyToY($.i[0][0], $.i[0][1], 0), p.applyToX($.v[0][0], $.v[0][1], 0), p.applyToY($.v[0][0], $.v[0][1], 0)), W[ve] = H, ve += 1;
          }
        V && (B += c[s].l, B += N), this.textSpans[de] ? this.textSpans[de].elem = W : this.textSpans[de] = {
          elem: W
        }, de += 1;
      }
    }, CVTextElement.prototype.renderInnerContent = function() {
      this.validateText();
      var e = this.canvasContext;
      e.font = this.values.fValue, this.globalData.renderer.ctxLineCap("butt"), this.globalData.renderer.ctxLineJoin("miter"), this.globalData.renderer.ctxMiterLimit(4), this.data.singleShape || this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
      var t, n, o, s, l, c, p = this.textAnimator.renderedLetters, m = this.textProperty.currentData.l;
      n = m.length;
      var C, P = null, w = null, R = null, L, M, $ = this.globalData.renderer;
      for (t = 0; t < n; t += 1)
        if (!m[t].n) {
          if (C = p[t], C && ($.save(), $.ctxTransform(C.p), $.ctxOpacity(C.o)), this.fill) {
            for (C && C.fc ? P !== C.fc && ($.ctxFillStyle(C.fc), P = C.fc) : P !== this.values.fill && (P = this.values.fill, $.ctxFillStyle(this.values.fill)), L = this.textSpans[t].elem, s = L.length, this.globalData.canvasContext.beginPath(), o = 0; o < s; o += 1)
              for (M = L[o], c = M.length, this.globalData.canvasContext.moveTo(M[0], M[1]), l = 2; l < c; l += 6)
                this.globalData.canvasContext.bezierCurveTo(M[l], M[l + 1], M[l + 2], M[l + 3], M[l + 4], M[l + 5]);
            this.globalData.canvasContext.closePath(), $.ctxFill();
          }
          if (this.stroke) {
            for (C && C.sw ? R !== C.sw && (R = C.sw, $.ctxLineWidth(C.sw)) : R !== this.values.sWidth && (R = this.values.sWidth, $.ctxLineWidth(this.values.sWidth)), C && C.sc ? w !== C.sc && (w = C.sc, $.ctxStrokeStyle(C.sc)) : w !== this.values.stroke && (w = this.values.stroke, $.ctxStrokeStyle(this.values.stroke)), L = this.textSpans[t].elem, s = L.length, this.globalData.canvasContext.beginPath(), o = 0; o < s; o += 1)
              for (M = L[o], c = M.length, this.globalData.canvasContext.moveTo(M[0], M[1]), l = 2; l < c; l += 6)
                this.globalData.canvasContext.bezierCurveTo(M[l], M[l + 1], M[l + 2], M[l + 3], M[l + 4], M[l + 5]);
            this.globalData.canvasContext.closePath(), $.ctxStroke();
          }
          C && this.globalData.renderer.restore();
        }
    };
    function CVImageElement(e, t, n) {
      this.assetData = t.getAssetData(e.refId), this.img = t.imageLoader.getAsset(this.assetData), this.initElement(e, t, n);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVImageElement), CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVImageElement.prototype.createContent = function() {
      if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
        var e = createTag("canvas");
        e.width = this.assetData.w, e.height = this.assetData.h;
        var t = e.getContext("2d"), n = this.img.width, o = this.img.height, s = n / o, l = this.assetData.w / this.assetData.h, c, p, m = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
        s > l && m === "xMidYMid slice" || s < l && m !== "xMidYMid slice" ? (p = o, c = p * l) : (c = n, p = c / l), t.drawImage(this.img, (n - c) / 2, (o - p) / 2, c, p, 0, 0, this.assetData.w, this.assetData.h), this.img = e;
      }
    }, CVImageElement.prototype.renderInnerContent = function() {
      this.canvasContext.drawImage(this.img, 0, 0);
    }, CVImageElement.prototype.destroy = function() {
      this.img = null;
    };
    function CVSolidElement(e, t, n) {
      this.initElement(e, t, n);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVSolidElement), CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVSolidElement.prototype.renderInnerContent = function() {
      this.globalData.renderer.ctxFillStyle(this.data.sc), this.globalData.renderer.ctxFillRect(0, 0, this.data.sw, this.data.sh);
    };
    function CanvasRendererBase() {
    }
    extendPrototype([BaseRenderer], CanvasRendererBase), CanvasRendererBase.prototype.createShape = function(e) {
      return new CVShapeElement(e, this.globalData, this);
    }, CanvasRendererBase.prototype.createText = function(e) {
      return new CVTextElement(e, this.globalData, this);
    }, CanvasRendererBase.prototype.createImage = function(e) {
      return new CVImageElement(e, this.globalData, this);
    }, CanvasRendererBase.prototype.createSolid = function(e) {
      return new CVSolidElement(e, this.globalData, this);
    }, CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, CanvasRendererBase.prototype.ctxTransform = function(e) {
      e[0] === 1 && e[1] === 0 && e[4] === 0 && e[5] === 1 && e[12] === 0 && e[13] === 0 || this.canvasContext.transform(e[0], e[1], e[4], e[5], e[12], e[13]);
    }, CanvasRendererBase.prototype.ctxOpacity = function(e) {
      this.canvasContext.globalAlpha *= e < 0 ? 0 : e;
    }, CanvasRendererBase.prototype.ctxFillStyle = function(e) {
      this.canvasContext.fillStyle = e;
    }, CanvasRendererBase.prototype.ctxStrokeStyle = function(e) {
      this.canvasContext.strokeStyle = e;
    }, CanvasRendererBase.prototype.ctxLineWidth = function(e) {
      this.canvasContext.lineWidth = e;
    }, CanvasRendererBase.prototype.ctxLineCap = function(e) {
      this.canvasContext.lineCap = e;
    }, CanvasRendererBase.prototype.ctxLineJoin = function(e) {
      this.canvasContext.lineJoin = e;
    }, CanvasRendererBase.prototype.ctxMiterLimit = function(e) {
      this.canvasContext.miterLimit = e;
    }, CanvasRendererBase.prototype.ctxFill = function(e) {
      this.canvasContext.fill(e);
    }, CanvasRendererBase.prototype.ctxFillRect = function(e, t, n, o) {
      this.canvasContext.fillRect(e, t, n, o);
    }, CanvasRendererBase.prototype.ctxStroke = function() {
      this.canvasContext.stroke();
    }, CanvasRendererBase.prototype.reset = function() {
      if (!this.renderConfig.clearCanvas) {
        this.canvasContext.restore();
        return;
      }
      this.contextData.reset();
    }, CanvasRendererBase.prototype.save = function() {
      this.canvasContext.save();
    }, CanvasRendererBase.prototype.restore = function(e) {
      if (!this.renderConfig.clearCanvas) {
        this.canvasContext.restore();
        return;
      }
      e && (this.globalData.blendMode = "source-over"), this.contextData.restore(e);
    }, CanvasRendererBase.prototype.configAnimation = function(e) {
      if (this.animationItem.wrapper) {
        this.animationItem.container = createTag("canvas");
        var t = this.animationItem.container.style;
        t.width = "100%", t.height = "100%";
        var n = "0px 0px 0px";
        t.transformOrigin = n, t.mozTransformOrigin = n, t.webkitTransformOrigin = n, t["-webkit-transform"] = n, t.contentVisibility = this.renderConfig.contentVisibility, this.animationItem.wrapper.appendChild(this.animationItem.container), this.canvasContext = this.animationItem.container.getContext("2d"), this.renderConfig.className && this.animationItem.container.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.animationItem.container.setAttribute("id", this.renderConfig.id);
      } else
        this.canvasContext = this.renderConfig.context;
      this.contextData.setContext(this.canvasContext), this.data = e, this.layers = e.layers, this.transformCanvas = {
        w: e.w,
        h: e.h,
        sx: 0,
        sy: 0,
        tx: 0,
        ty: 0
      }, this.setupGlobalData(e, document.body), this.globalData.canvasContext = this.canvasContext, this.globalData.renderer = this, this.globalData.isDashed = !1, this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.globalData.transformCanvas = this.transformCanvas, this.elements = createSizedArray(e.layers.length), this.updateContainerSize();
    }, CanvasRendererBase.prototype.updateContainerSize = function(e, t) {
      this.reset();
      var n, o;
      e ? (n = e, o = t, this.canvasContext.canvas.width = n, this.canvasContext.canvas.height = o) : (this.animationItem.wrapper && this.animationItem.container ? (n = this.animationItem.wrapper.offsetWidth, o = this.animationItem.wrapper.offsetHeight) : (n = this.canvasContext.canvas.width, o = this.canvasContext.canvas.height), this.canvasContext.canvas.width = n * this.renderConfig.dpr, this.canvasContext.canvas.height = o * this.renderConfig.dpr);
      var s, l;
      if (this.renderConfig.preserveAspectRatio.indexOf("meet") !== -1 || this.renderConfig.preserveAspectRatio.indexOf("slice") !== -1) {
        var c = this.renderConfig.preserveAspectRatio.split(" "), p = c[1] || "meet", m = c[0] || "xMidYMid", C = m.substr(0, 4), P = m.substr(4);
        s = n / o, l = this.transformCanvas.w / this.transformCanvas.h, l > s && p === "meet" || l < s && p === "slice" ? (this.transformCanvas.sx = n / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = n / (this.transformCanvas.w / this.renderConfig.dpr)) : (this.transformCanvas.sx = o / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.sy = o / (this.transformCanvas.h / this.renderConfig.dpr)), C === "xMid" && (l < s && p === "meet" || l > s && p === "slice") ? this.transformCanvas.tx = (n - this.transformCanvas.w * (o / this.transformCanvas.h)) / 2 * this.renderConfig.dpr : C === "xMax" && (l < s && p === "meet" || l > s && p === "slice") ? this.transformCanvas.tx = (n - this.transformCanvas.w * (o / this.transformCanvas.h)) * this.renderConfig.dpr : this.transformCanvas.tx = 0, P === "YMid" && (l > s && p === "meet" || l < s && p === "slice") ? this.transformCanvas.ty = (o - this.transformCanvas.h * (n / this.transformCanvas.w)) / 2 * this.renderConfig.dpr : P === "YMax" && (l > s && p === "meet" || l < s && p === "slice") ? this.transformCanvas.ty = (o - this.transformCanvas.h * (n / this.transformCanvas.w)) * this.renderConfig.dpr : this.transformCanvas.ty = 0;
      } else
        this.renderConfig.preserveAspectRatio === "none" ? (this.transformCanvas.sx = n / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = o / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.tx = 0, this.transformCanvas.ty = 0) : (this.transformCanvas.sx = this.renderConfig.dpr, this.transformCanvas.sy = this.renderConfig.dpr, this.transformCanvas.tx = 0, this.transformCanvas.ty = 0);
      this.transformCanvas.props = [this.transformCanvas.sx, 0, 0, 0, 0, this.transformCanvas.sy, 0, 0, 0, 0, 1, 0, this.transformCanvas.tx, this.transformCanvas.ty, 0, 1], this.ctxTransform(this.transformCanvas.props), this.canvasContext.beginPath(), this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h), this.canvasContext.closePath(), this.canvasContext.clip(), this.renderFrame(this.renderedFrame, !0);
    }, CanvasRendererBase.prototype.destroy = function() {
      this.renderConfig.clearCanvas && this.animationItem.wrapper && (this.animationItem.wrapper.innerText = "");
      var e, t = this.layers ? this.layers.length : 0;
      for (e = t - 1; e >= 0; e -= 1)
        this.elements[e] && this.elements[e].destroy && this.elements[e].destroy();
      this.elements.length = 0, this.globalData.canvasContext = null, this.animationItem.container = null, this.destroyed = !0;
    }, CanvasRendererBase.prototype.renderFrame = function(e, t) {
      if (!(this.renderedFrame === e && this.renderConfig.clearCanvas === !0 && !t || this.destroyed || e === -1)) {
        this.renderedFrame = e, this.globalData.frameNum = e - this.animationItem._isFirstFrame, this.globalData.frameId += 1, this.globalData._mdf = !this.renderConfig.clearCanvas || t, this.globalData.projectInterface.currentFrame = e;
        var n, o = this.layers.length;
        for (this.completeLayers || this.checkLayers(e), n = o - 1; n >= 0; n -= 1)
          (this.completeLayers || this.elements[n]) && this.elements[n].prepareFrame(e - this.layers[n].st);
        if (this.globalData._mdf) {
          for (this.renderConfig.clearCanvas === !0 ? this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h) : this.save(), n = o - 1; n >= 0; n -= 1)
            (this.completeLayers || this.elements[n]) && this.elements[n].renderFrame();
          this.renderConfig.clearCanvas !== !0 && this.restore();
        }
      }
    }, CanvasRendererBase.prototype.buildItem = function(e) {
      var t = this.elements;
      if (!(t[e] || this.layers[e].ty === 99)) {
        var n = this.createItem(this.layers[e], this, this.globalData);
        t[e] = n, n.initExpressions();
      }
    }, CanvasRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; ) {
        var e = this.pendingElements.pop();
        e.checkParenting();
      }
    }, CanvasRendererBase.prototype.hide = function() {
      this.animationItem.container.style.display = "none";
    }, CanvasRendererBase.prototype.show = function() {
      this.animationItem.container.style.display = "block";
    };
    function CanvasContext() {
      this.opacity = -1, this.transform = createTypedArray("float32", 16), this.fillStyle = "", this.strokeStyle = "", this.lineWidth = "", this.lineCap = "", this.lineJoin = "", this.miterLimit = "", this.id = Math.random();
    }
    function CVContextData() {
      this.stack = [], this.cArrPos = 0, this.cTr = new Matrix();
      var e, t = 15;
      for (e = 0; e < t; e += 1) {
        var n = new CanvasContext();
        this.stack[e] = n;
      }
      this._length = t, this.nativeContext = null, this.transformMat = new Matrix(), this.currentOpacity = 1, this.currentFillStyle = "", this.appliedFillStyle = "", this.currentStrokeStyle = "", this.appliedStrokeStyle = "", this.currentLineWidth = "", this.appliedLineWidth = "", this.currentLineCap = "", this.appliedLineCap = "", this.currentLineJoin = "", this.appliedLineJoin = "", this.appliedMiterLimit = "", this.currentMiterLimit = "";
    }
    CVContextData.prototype.duplicate = function() {
      var e = this._length * 2, t = 0;
      for (t = this._length; t < e; t += 1)
        this.stack[t] = new CanvasContext();
      this._length = e;
    }, CVContextData.prototype.reset = function() {
      this.cArrPos = 0, this.cTr.reset(), this.stack[this.cArrPos].opacity = 1;
    }, CVContextData.prototype.restore = function(e) {
      this.cArrPos -= 1;
      var t = this.stack[this.cArrPos], n = t.transform, o, s = this.cTr.props;
      for (o = 0; o < 16; o += 1)
        s[o] = n[o];
      if (e) {
        this.nativeContext.restore();
        var l = this.stack[this.cArrPos + 1];
        this.appliedFillStyle = l.fillStyle, this.appliedStrokeStyle = l.strokeStyle, this.appliedLineWidth = l.lineWidth, this.appliedLineCap = l.lineCap, this.appliedLineJoin = l.lineJoin, this.appliedMiterLimit = l.miterLimit;
      }
      this.nativeContext.setTransform(n[0], n[1], n[4], n[5], n[12], n[13]), (e || t.opacity !== -1 && this.currentOpacity !== t.opacity) && (this.nativeContext.globalAlpha = t.opacity, this.currentOpacity = t.opacity), this.currentFillStyle = t.fillStyle, this.currentStrokeStyle = t.strokeStyle, this.currentLineWidth = t.lineWidth, this.currentLineCap = t.lineCap, this.currentLineJoin = t.lineJoin, this.currentMiterLimit = t.miterLimit;
    }, CVContextData.prototype.save = function(e) {
      e && this.nativeContext.save();
      var t = this.cTr.props;
      this._length <= this.cArrPos && this.duplicate();
      var n = this.stack[this.cArrPos], o;
      for (o = 0; o < 16; o += 1)
        n.transform[o] = t[o];
      this.cArrPos += 1;
      var s = this.stack[this.cArrPos];
      s.opacity = n.opacity, s.fillStyle = n.fillStyle, s.strokeStyle = n.strokeStyle, s.lineWidth = n.lineWidth, s.lineCap = n.lineCap, s.lineJoin = n.lineJoin, s.miterLimit = n.miterLimit;
    }, CVContextData.prototype.setOpacity = function(e) {
      this.stack[this.cArrPos].opacity = e;
    }, CVContextData.prototype.setContext = function(e) {
      this.nativeContext = e;
    }, CVContextData.prototype.fillStyle = function(e) {
      this.stack[this.cArrPos].fillStyle !== e && (this.currentFillStyle = e, this.stack[this.cArrPos].fillStyle = e);
    }, CVContextData.prototype.strokeStyle = function(e) {
      this.stack[this.cArrPos].strokeStyle !== e && (this.currentStrokeStyle = e, this.stack[this.cArrPos].strokeStyle = e);
    }, CVContextData.prototype.lineWidth = function(e) {
      this.stack[this.cArrPos].lineWidth !== e && (this.currentLineWidth = e, this.stack[this.cArrPos].lineWidth = e);
    }, CVContextData.prototype.lineCap = function(e) {
      this.stack[this.cArrPos].lineCap !== e && (this.currentLineCap = e, this.stack[this.cArrPos].lineCap = e);
    }, CVContextData.prototype.lineJoin = function(e) {
      this.stack[this.cArrPos].lineJoin !== e && (this.currentLineJoin = e, this.stack[this.cArrPos].lineJoin = e);
    }, CVContextData.prototype.miterLimit = function(e) {
      this.stack[this.cArrPos].miterLimit !== e && (this.currentMiterLimit = e, this.stack[this.cArrPos].miterLimit = e);
    }, CVContextData.prototype.transform = function(e) {
      this.transformMat.cloneFromProps(e);
      var t = this.cTr;
      this.transformMat.multiply(t), t.cloneFromProps(this.transformMat.props);
      var n = t.props;
      this.nativeContext.setTransform(n[0], n[1], n[4], n[5], n[12], n[13]);
    }, CVContextData.prototype.opacity = function(e) {
      var t = this.stack[this.cArrPos].opacity;
      t *= e < 0 ? 0 : e, this.stack[this.cArrPos].opacity !== t && (this.currentOpacity !== e && (this.nativeContext.globalAlpha = e, this.currentOpacity = e), this.stack[this.cArrPos].opacity = t);
    }, CVContextData.prototype.fill = function(e) {
      this.appliedFillStyle !== this.currentFillStyle && (this.appliedFillStyle = this.currentFillStyle, this.nativeContext.fillStyle = this.appliedFillStyle), this.nativeContext.fill(e);
    }, CVContextData.prototype.fillRect = function(e, t, n, o) {
      this.appliedFillStyle !== this.currentFillStyle && (this.appliedFillStyle = this.currentFillStyle, this.nativeContext.fillStyle = this.appliedFillStyle), this.nativeContext.fillRect(e, t, n, o);
    }, CVContextData.prototype.stroke = function() {
      this.appliedStrokeStyle !== this.currentStrokeStyle && (this.appliedStrokeStyle = this.currentStrokeStyle, this.nativeContext.strokeStyle = this.appliedStrokeStyle), this.appliedLineWidth !== this.currentLineWidth && (this.appliedLineWidth = this.currentLineWidth, this.nativeContext.lineWidth = this.appliedLineWidth), this.appliedLineCap !== this.currentLineCap && (this.appliedLineCap = this.currentLineCap, this.nativeContext.lineCap = this.appliedLineCap), this.appliedLineJoin !== this.currentLineJoin && (this.appliedLineJoin = this.currentLineJoin, this.nativeContext.lineJoin = this.appliedLineJoin), this.appliedMiterLimit !== this.currentMiterLimit && (this.appliedMiterLimit = this.currentMiterLimit, this.nativeContext.miterLimit = this.appliedMiterLimit), this.nativeContext.stroke();
    };
    function CVCompElement(e, t, n) {
      this.completeLayers = !1, this.layers = e.layers, this.pendingElements = [], this.elements = createSizedArray(this.layers.length), this.initElement(e, t, n), this.tm = e.tm ? PropertyFactory.getProp(this, e.tm, 0, t.frameRate, this) : {
        _placeholder: !0
      };
    }
    extendPrototype([CanvasRendererBase, ICompElement, CVBaseElement], CVCompElement), CVCompElement.prototype.renderInnerContent = function() {
      var e = this.canvasContext;
      e.beginPath(), e.moveTo(0, 0), e.lineTo(this.data.w, 0), e.lineTo(this.data.w, this.data.h), e.lineTo(0, this.data.h), e.lineTo(0, 0), e.clip();
      var t, n = this.layers.length;
      for (t = n - 1; t >= 0; t -= 1)
        (this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
    }, CVCompElement.prototype.destroy = function() {
      var e, t = this.layers.length;
      for (e = t - 1; e >= 0; e -= 1)
        this.elements[e] && this.elements[e].destroy();
      this.layers = null, this.elements = null;
    }, CVCompElement.prototype.createComp = function(e) {
      return new CVCompElement(e, this.globalData, this);
    };
    function CanvasRenderer(e, t) {
      this.animationItem = e, this.renderConfig = {
        clearCanvas: t && t.clearCanvas !== void 0 ? t.clearCanvas : !0,
        context: t && t.context || null,
        progressiveLoad: t && t.progressiveLoad || !1,
        preserveAspectRatio: t && t.preserveAspectRatio || "xMidYMid meet",
        imagePreserveAspectRatio: t && t.imagePreserveAspectRatio || "xMidYMid slice",
        contentVisibility: t && t.contentVisibility || "visible",
        className: t && t.className || "",
        id: t && t.id || "",
        runExpressions: !t || t.runExpressions === void 0 || t.runExpressions
      }, this.renderConfig.dpr = t && t.dpr || 1, this.animationItem.wrapper && (this.renderConfig.dpr = t && t.dpr || window.devicePixelRatio || 1), this.renderedFrame = -1, this.globalData = {
        frameNum: -1,
        _mdf: !1,
        renderConfig: this.renderConfig,
        currentGlobalAlpha: -1
      }, this.contextData = new CVContextData(), this.elements = [], this.pendingElements = [], this.transformMat = new Matrix(), this.completeLayers = !1, this.rendererType = "canvas", this.renderConfig.clearCanvas && (this.ctxTransform = this.contextData.transform.bind(this.contextData), this.ctxOpacity = this.contextData.opacity.bind(this.contextData), this.ctxFillStyle = this.contextData.fillStyle.bind(this.contextData), this.ctxStrokeStyle = this.contextData.strokeStyle.bind(this.contextData), this.ctxLineWidth = this.contextData.lineWidth.bind(this.contextData), this.ctxLineCap = this.contextData.lineCap.bind(this.contextData), this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData), this.ctxMiterLimit = this.contextData.miterLimit.bind(this.contextData), this.ctxFill = this.contextData.fill.bind(this.contextData), this.ctxFillRect = this.contextData.fillRect.bind(this.contextData), this.ctxStroke = this.contextData.stroke.bind(this.contextData), this.save = this.contextData.save.bind(this.contextData));
    }
    extendPrototype([CanvasRendererBase], CanvasRenderer), CanvasRenderer.prototype.createComp = function(e) {
      return new CVCompElement(e, this.globalData, this);
    };
    function HBaseElement() {
    }
    HBaseElement.prototype = {
      checkBlendMode: function() {
      },
      initRendererElement: function() {
        this.baseElement = createTag(this.data.tg || "div"), this.data.hasMask ? (this.svgElement = createNS("svg"), this.layerElement = createNS("g"), this.maskedElement = this.layerElement, this.svgElement.appendChild(this.layerElement), this.baseElement.appendChild(this.svgElement)) : this.layerElement = this.baseElement, styleDiv(this.baseElement);
      },
      createContainerElements: function() {
        this.renderableEffectsManager = new CVEffects(this), this.transformedElement = this.baseElement, this.maskedElement = this.layerElement, this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), this.data.bm !== 0 && this.setBlendMode();
      },
      renderElement: function() {
        var t = this.transformedElement ? this.transformedElement.style : {};
        if (this.finalTransform._matMdf) {
          var n = this.finalTransform.mat.toCSS();
          t.transform = n, t.webkitTransform = n;
        }
        this.finalTransform._opMdf && (t.opacity = this.finalTransform.mProp.o.v);
      },
      renderFrame: function() {
        this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
      },
      destroy: function() {
        this.layerElement = null, this.transformedElement = null, this.matteElement && (this.matteElement = null), this.maskManager && (this.maskManager.destroy(), this.maskManager = null);
      },
      createRenderableComponents: function() {
        this.maskManager = new MaskElement(this.data, this, this.globalData);
      },
      addEffects: function() {
      },
      setMatte: function() {
      }
    }, HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement, HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy, HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting;
    function HSolidElement(e, t, n) {
      this.initElement(e, t, n);
    }
    extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], HSolidElement), HSolidElement.prototype.createContent = function() {
      var e;
      this.data.hasMask ? (e = createNS("rect"), e.setAttribute("width", this.data.sw), e.setAttribute("height", this.data.sh), e.setAttribute("fill", this.data.sc), this.svgElement.setAttribute("width", this.data.sw), this.svgElement.setAttribute("height", this.data.sh)) : (e = createTag("div"), e.style.width = this.data.sw + "px", e.style.height = this.data.sh + "px", e.style.backgroundColor = this.data.sc), this.layerElement.appendChild(e);
    };
    function HShapeElement(e, t, n) {
      this.shapes = [], this.shapesData = e.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.shapesContainer = createNS("g"), this.initElement(e, t, n), this.prevViewData = [], this.currentBBox = {
        x: 999999,
        y: -999999,
        h: 0,
        w: 0
      };
    }
    extendPrototype([BaseElement, TransformElement, HSolidElement, SVGShapeElement, HBaseElement, HierarchyElement, FrameElement, RenderableElement], HShapeElement), HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent, HShapeElement.prototype.createContent = function() {
      var e;
      if (this.baseElement.style.fontSize = 0, this.data.hasMask)
        this.layerElement.appendChild(this.shapesContainer), e = this.svgElement;
      else {
        e = createNS("svg");
        var t = this.comp.data ? this.comp.data : this.globalData.compSize;
        e.setAttribute("width", t.w), e.setAttribute("height", t.h), e.appendChild(this.shapesContainer), this.layerElement.appendChild(e);
      }
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], !0), this.filterUniqueShapes(), this.shapeCont = e;
    }, HShapeElement.prototype.getTransformedPoint = function(e, t) {
      var n, o = e.length;
      for (n = 0; n < o; n += 1)
        t = e[n].mProps.v.applyToPointArray(t[0], t[1], 0);
      return t;
    }, HShapeElement.prototype.calculateShapeBoundingBox = function(e, t) {
      var n = e.sh.v, o = e.transformers, s, l = n._length, c, p, m, C;
      if (!(l <= 1)) {
        for (s = 0; s < l - 1; s += 1)
          c = this.getTransformedPoint(o, n.v[s]), p = this.getTransformedPoint(o, n.o[s]), m = this.getTransformedPoint(o, n.i[s + 1]), C = this.getTransformedPoint(o, n.v[s + 1]), this.checkBounds(c, p, m, C, t);
        n.c && (c = this.getTransformedPoint(o, n.v[s]), p = this.getTransformedPoint(o, n.o[s]), m = this.getTransformedPoint(o, n.i[0]), C = this.getTransformedPoint(o, n.v[0]), this.checkBounds(c, p, m, C, t));
      }
    }, HShapeElement.prototype.checkBounds = function(e, t, n, o, s) {
      this.getBoundsOfCurve(e, t, n, o);
      var l = this.shapeBoundingBox;
      s.x = bmMin(l.left, s.x), s.xMax = bmMax(l.right, s.xMax), s.y = bmMin(l.top, s.y), s.yMax = bmMax(l.bottom, s.yMax);
    }, HShapeElement.prototype.shapeBoundingBox = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, HShapeElement.prototype.tempBoundingBox = {
      x: 0,
      xMax: 0,
      y: 0,
      yMax: 0,
      width: 0,
      height: 0
    }, HShapeElement.prototype.getBoundsOfCurve = function(e, t, n, o) {
      for (var s = [[e[0], o[0]], [e[1], o[1]]], l, c, p, m, C, P, w, R = 0; R < 2; ++R)
        c = 6 * e[R] - 12 * t[R] + 6 * n[R], l = -3 * e[R] + 9 * t[R] - 9 * n[R] + 3 * o[R], p = 3 * t[R] - 3 * e[R], c |= 0, l |= 0, p |= 0, l === 0 && c === 0 || (l === 0 ? (m = -p / c, m > 0 && m < 1 && s[R].push(this.calculateF(m, e, t, n, o, R))) : (C = c * c - 4 * p * l, C >= 0 && (P = (-c + bmSqrt(C)) / (2 * l), P > 0 && P < 1 && s[R].push(this.calculateF(P, e, t, n, o, R)), w = (-c - bmSqrt(C)) / (2 * l), w > 0 && w < 1 && s[R].push(this.calculateF(w, e, t, n, o, R)))));
      this.shapeBoundingBox.left = bmMin.apply(null, s[0]), this.shapeBoundingBox.top = bmMin.apply(null, s[1]), this.shapeBoundingBox.right = bmMax.apply(null, s[0]), this.shapeBoundingBox.bottom = bmMax.apply(null, s[1]);
    }, HShapeElement.prototype.calculateF = function(e, t, n, o, s, l) {
      return bmPow(1 - e, 3) * t[l] + 3 * bmPow(1 - e, 2) * e * n[l] + 3 * (1 - e) * bmPow(e, 2) * o[l] + bmPow(e, 3) * s[l];
    }, HShapeElement.prototype.calculateBoundingBox = function(e, t) {
      var n, o = e.length;
      for (n = 0; n < o; n += 1)
        e[n] && e[n].sh ? this.calculateShapeBoundingBox(e[n], t) : e[n] && e[n].it ? this.calculateBoundingBox(e[n].it, t) : e[n] && e[n].style && e[n].w && this.expandStrokeBoundingBox(e[n].w, t);
    }, HShapeElement.prototype.expandStrokeBoundingBox = function(e, t) {
      var n = 0;
      if (e.keyframes) {
        for (var o = 0; o < e.keyframes.length; o += 1) {
          var s = e.keyframes[o].s;
          s > n && (n = s);
        }
        n *= e.mult;
      } else
        n = e.v * e.mult;
      t.x -= n, t.xMax += n, t.y -= n, t.yMax += n;
    }, HShapeElement.prototype.currentBoxContains = function(e) {
      return this.currentBBox.x <= e.x && this.currentBBox.y <= e.y && this.currentBBox.width + this.currentBBox.x >= e.x + e.width && this.currentBBox.height + this.currentBBox.y >= e.y + e.height;
    }, HShapeElement.prototype.renderInnerContent = function() {
      if (this._renderShapeFrame(), !this.hidden && (this._isFirstFrame || this._mdf)) {
        var e = this.tempBoundingBox, t = 999999;
        if (e.x = t, e.xMax = -t, e.y = t, e.yMax = -t, this.calculateBoundingBox(this.itemsData, e), e.width = e.xMax < e.x ? 0 : e.xMax - e.x, e.height = e.yMax < e.y ? 0 : e.yMax - e.y, this.currentBoxContains(e))
          return;
        var n = !1;
        if (this.currentBBox.w !== e.width && (this.currentBBox.w = e.width, this.shapeCont.setAttribute("width", e.width), n = !0), this.currentBBox.h !== e.height && (this.currentBBox.h = e.height, this.shapeCont.setAttribute("height", e.height), n = !0), n || this.currentBBox.x !== e.x || this.currentBBox.y !== e.y) {
          this.currentBBox.w = e.width, this.currentBBox.h = e.height, this.currentBBox.x = e.x, this.currentBBox.y = e.y, this.shapeCont.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
          var o = this.shapeCont.style, s = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
          o.transform = s, o.webkitTransform = s;
        }
      }
    };
    function HTextElement(e, t, n) {
      this.textSpans = [], this.textPaths = [], this.currentBBox = {
        x: 999999,
        y: -999999,
        h: 0,
        w: 0
      }, this.renderType = "svg", this.isMasked = !1, this.initElement(e, t, n);
    }
    extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], HTextElement), HTextElement.prototype.createContent = function() {
      if (this.isMasked = this.checkMasks(), this.isMasked) {
        this.renderType = "svg", this.compW = this.comp.data.w, this.compH = this.comp.data.h, this.svgElement.setAttribute("width", this.compW), this.svgElement.setAttribute("height", this.compH);
        var e = createNS("g");
        this.maskedElement.appendChild(e), this.innerElem = e;
      } else
        this.renderType = "html", this.innerElem = this.layerElement;
      this.checkParenting();
    }, HTextElement.prototype.buildNewText = function() {
      var e = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(e.l ? e.l.length : 0);
      var t = this.innerElem.style, n = e.fc ? this.buildColor(e.fc) : "rgba(0,0,0,0)";
      t.fill = n, t.color = n, e.sc && (t.stroke = this.buildColor(e.sc), t.strokeWidth = e.sw + "px");
      var o = this.globalData.fontManager.getFontByName(e.f);
      if (!this.globalData.fontManager.chars)
        if (t.fontSize = e.finalSize + "px", t.lineHeight = e.finalSize + "px", o.fClass)
          this.innerElem.className = o.fClass;
        else {
          t.fontFamily = o.fFamily;
          var s = e.fWeight, l = e.fStyle;
          t.fontStyle = l, t.fontWeight = s;
        }
      var c, p, m = e.l;
      p = m.length;
      var C, P, w, R = this.mHelper, L, M = "", $ = 0;
      for (c = 0; c < p; c += 1) {
        if (this.globalData.fontManager.chars ? (this.textPaths[$] ? C = this.textPaths[$] : (C = createNS("path"), C.setAttribute("stroke-linecap", lineCapEnum[1]), C.setAttribute("stroke-linejoin", lineJoinEnum[2]), C.setAttribute("stroke-miterlimit", "4")), this.isMasked || (this.textSpans[$] ? (P = this.textSpans[$], w = P.children[0]) : (P = createTag("div"), P.style.lineHeight = 0, w = createNS("svg"), w.appendChild(C), styleDiv(P)))) : this.isMasked ? C = this.textPaths[$] ? this.textPaths[$] : createNS("text") : this.textSpans[$] ? (P = this.textSpans[$], C = this.textPaths[$]) : (P = createTag("span"), styleDiv(P), C = createTag("span"), styleDiv(C), P.appendChild(C)), this.globalData.fontManager.chars) {
          var W = this.globalData.fontManager.getCharData(e.finalText[c], o.fStyle, this.globalData.fontManager.getFontByName(e.f).fFamily), H;
          if (W ? H = W.data : H = null, R.reset(), H && H.shapes && H.shapes.length && (L = H.shapes[0].it, R.scale(e.finalSize / 100, e.finalSize / 100), M = this.createPathShape(R, L), C.setAttribute("d", M)), this.isMasked)
            this.innerElem.appendChild(C);
          else {
            if (this.innerElem.appendChild(P), H && H.shapes) {
              document.body.appendChild(w);
              var V = w.getBBox();
              w.setAttribute("width", V.width + 2), w.setAttribute("height", V.height + 2), w.setAttribute("viewBox", V.x - 1 + " " + (V.y - 1) + " " + (V.width + 2) + " " + (V.height + 2));
              var N = w.style, B = "translate(" + (V.x - 1) + "px," + (V.y - 1) + "px)";
              N.transform = B, N.webkitTransform = B, m[c].yOffset = V.y - 1;
            } else
              w.setAttribute("width", 1), w.setAttribute("height", 1);
            P.appendChild(w);
          }
        } else if (C.textContent = m[c].val, C.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), this.isMasked)
          this.innerElem.appendChild(C);
        else {
          this.innerElem.appendChild(P);
          var K = C.style, ue = "translate3d(0," + -e.finalSize / 1.2 + "px,0)";
          K.transform = ue, K.webkitTransform = ue;
        }
        this.isMasked ? this.textSpans[$] = C : this.textSpans[$] = P, this.textSpans[$].style.display = "block", this.textPaths[$] = C, $ += 1;
      }
      for (; $ < this.textSpans.length; )
        this.textSpans[$].style.display = "none", $ += 1;
    }, HTextElement.prototype.renderInnerContent = function() {
      this.validateText();
      var e;
      if (this.data.singleShape) {
        if (!this._isFirstFrame && !this.lettersChangedFlag)
          return;
        if (this.isMasked && this.finalTransform._matMdf) {
          this.svgElement.setAttribute("viewBox", -this.finalTransform.mProp.p.v[0] + " " + -this.finalTransform.mProp.p.v[1] + " " + this.compW + " " + this.compH), e = this.svgElement.style;
          var t = "translate(" + -this.finalTransform.mProp.p.v[0] + "px," + -this.finalTransform.mProp.p.v[1] + "px)";
          e.transform = t, e.webkitTransform = t;
        }
      }
      if (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), !(!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag)) {
        var n, o, s = 0, l = this.textAnimator.renderedLetters, c = this.textProperty.currentData.l;
        o = c.length;
        var p, m, C;
        for (n = 0; n < o; n += 1)
          c[n].n ? s += 1 : (m = this.textSpans[n], C = this.textPaths[n], p = l[s], s += 1, p._mdf.m && (this.isMasked ? m.setAttribute("transform", p.m) : (m.style.webkitTransform = p.m, m.style.transform = p.m)), m.style.opacity = p.o, p.sw && p._mdf.sw && C.setAttribute("stroke-width", p.sw), p.sc && p._mdf.sc && C.setAttribute("stroke", p.sc), p.fc && p._mdf.fc && (C.setAttribute("fill", p.fc), C.style.color = p.fc));
        if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
          var P = this.innerElem.getBBox();
          this.currentBBox.w !== P.width && (this.currentBBox.w = P.width, this.svgElement.setAttribute("width", P.width)), this.currentBBox.h !== P.height && (this.currentBBox.h = P.height, this.svgElement.setAttribute("height", P.height));
          var w = 1;
          if (this.currentBBox.w !== P.width + w * 2 || this.currentBBox.h !== P.height + w * 2 || this.currentBBox.x !== P.x - w || this.currentBBox.y !== P.y - w) {
            this.currentBBox.w = P.width + w * 2, this.currentBBox.h = P.height + w * 2, this.currentBBox.x = P.x - w, this.currentBBox.y = P.y - w, this.svgElement.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h), e = this.svgElement.style;
            var R = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
            e.transform = R, e.webkitTransform = R;
          }
        }
      }
    };
    function HCameraElement(e, t, n) {
      this.initFrame(), this.initBaseData(e, t, n), this.initHierarchy();
      var o = PropertyFactory.getProp;
      if (this.pe = o(this, e.pe, 0, 0, this), e.ks.p.s ? (this.px = o(this, e.ks.p.x, 1, 0, this), this.py = o(this, e.ks.p.y, 1, 0, this), this.pz = o(this, e.ks.p.z, 1, 0, this)) : this.p = o(this, e.ks.p, 1, 0, this), e.ks.a && (this.a = o(this, e.ks.a, 1, 0, this)), e.ks.or.k.length && e.ks.or.k[0].to) {
        var s, l = e.ks.or.k.length;
        for (s = 0; s < l; s += 1)
          e.ks.or.k[s].to = null, e.ks.or.k[s].ti = null;
      }
      this.or = o(this, e.ks.or, 1, degToRads, this), this.or.sh = !0, this.rx = o(this, e.ks.rx, 0, degToRads, this), this.ry = o(this, e.ks.ry, 0, degToRads, this), this.rz = o(this, e.ks.rz, 0, degToRads, this), this.mat = new Matrix(), this._prevMat = new Matrix(), this._isFirstFrame = !0, this.finalTransform = {
        mProp: this
      };
    }
    extendPrototype([BaseElement, FrameElement, HierarchyElement], HCameraElement), HCameraElement.prototype.setup = function() {
      var e, t = this.comp.threeDElements.length, n, o, s;
      for (e = 0; e < t; e += 1)
        if (n = this.comp.threeDElements[e], n.type === "3d") {
          o = n.perspectiveElem.style, s = n.container.style;
          var l = this.pe.v + "px", c = "0px 0px 0px", p = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
          o.perspective = l, o.webkitPerspective = l, s.transformOrigin = c, s.mozTransformOrigin = c, s.webkitTransformOrigin = c, o.transform = p, o.webkitTransform = p;
        }
    }, HCameraElement.prototype.createElements = function() {
    }, HCameraElement.prototype.hide = function() {
    }, HCameraElement.prototype.renderFrame = function() {
      var e = this._isFirstFrame, t, n;
      if (this.hierarchy)
        for (n = this.hierarchy.length, t = 0; t < n; t += 1)
          e = this.hierarchy[t].finalTransform.mProp._mdf || e;
      if (e || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
        if (this.mat.reset(), this.hierarchy)
          for (n = this.hierarchy.length - 1, t = n; t >= 0; t -= 1) {
            var o = this.hierarchy[t].finalTransform.mProp;
            this.mat.translate(-o.p.v[0], -o.p.v[1], o.p.v[2]), this.mat.rotateX(-o.or.v[0]).rotateY(-o.or.v[1]).rotateZ(o.or.v[2]), this.mat.rotateX(-o.rx.v).rotateY(-o.ry.v).rotateZ(o.rz.v), this.mat.scale(1 / o.s.v[0], 1 / o.s.v[1], 1 / o.s.v[2]), this.mat.translate(o.a.v[0], o.a.v[1], o.a.v[2]);
          }
        if (this.p ? this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]) : this.mat.translate(-this.px.v, -this.py.v, this.pz.v), this.a) {
          var s;
          this.p ? s = [this.p.v[0] - this.a.v[0], this.p.v[1] - this.a.v[1], this.p.v[2] - this.a.v[2]] : s = [this.px.v - this.a.v[0], this.py.v - this.a.v[1], this.pz.v - this.a.v[2]];
          var l = Math.sqrt(Math.pow(s[0], 2) + Math.pow(s[1], 2) + Math.pow(s[2], 2)), c = [s[0] / l, s[1] / l, s[2] / l], p = Math.sqrt(c[2] * c[2] + c[0] * c[0]), m = Math.atan2(c[1], p), C = Math.atan2(c[0], -c[2]);
          this.mat.rotateY(C).rotateX(-m);
        }
        this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v), this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]), this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0), this.mat.translate(0, 0, this.pe.v);
        var P = !this._prevMat.equals(this.mat);
        if ((P || this.pe._mdf) && this.comp.threeDElements) {
          n = this.comp.threeDElements.length;
          var w, R, L;
          for (t = 0; t < n; t += 1)
            if (w = this.comp.threeDElements[t], w.type === "3d") {
              if (P) {
                var M = this.mat.toCSS();
                L = w.container.style, L.transform = M, L.webkitTransform = M;
              }
              this.pe._mdf && (R = w.perspectiveElem.style, R.perspective = this.pe.v + "px", R.webkitPerspective = this.pe.v + "px");
            }
          this.mat.clone(this._prevMat);
        }
      }
      this._isFirstFrame = !1;
    }, HCameraElement.prototype.prepareFrame = function(e) {
      this.prepareProperties(e, !0);
    }, HCameraElement.prototype.destroy = function() {
    }, HCameraElement.prototype.getBaseElement = function() {
      return null;
    };
    function HImageElement(e, t, n) {
      this.assetData = t.getAssetData(e.refId), this.initElement(e, t, n);
    }
    extendPrototype([BaseElement, TransformElement, HBaseElement, HSolidElement, HierarchyElement, FrameElement, RenderableElement], HImageElement), HImageElement.prototype.createContent = function() {
      var e = this.globalData.getAssetsPath(this.assetData), t = new Image();
      this.data.hasMask ? (this.imageElem = createNS("image"), this.imageElem.setAttribute("width", this.assetData.w + "px"), this.imageElem.setAttribute("height", this.assetData.h + "px"), this.imageElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", e), this.layerElement.appendChild(this.imageElem), this.baseElement.setAttribute("width", this.assetData.w), this.baseElement.setAttribute("height", this.assetData.h)) : this.layerElement.appendChild(t), t.crossOrigin = "anonymous", t.src = e, this.data.ln && this.baseElement.setAttribute("id", this.data.ln);
    };
    function HybridRendererBase(e, t) {
      this.animationItem = e, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
        className: t && t.className || "",
        imagePreserveAspectRatio: t && t.imagePreserveAspectRatio || "xMidYMid slice",
        hideOnTransparent: !(t && t.hideOnTransparent === !1),
        filterSize: {
          width: t && t.filterSize && t.filterSize.width || "400%",
          height: t && t.filterSize && t.filterSize.height || "400%",
          x: t && t.filterSize && t.filterSize.x || "-100%",
          y: t && t.filterSize && t.filterSize.y || "-100%"
        }
      }, this.globalData = {
        _mdf: !1,
        frameNum: -1,
        renderConfig: this.renderConfig
      }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
    }
    extendPrototype([BaseRenderer], HybridRendererBase), HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem, HybridRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; ) {
        var e = this.pendingElements.pop();
        e.checkParenting();
      }
    }, HybridRendererBase.prototype.appendElementInPos = function(e, t) {
      var n = e.getBaseElement();
      if (n) {
        var o = this.layers[t];
        if (!o.ddd || !this.supports3d)
          if (this.threeDElements)
            this.addTo3dContainer(n, t);
          else {
            for (var s = 0, l, c, p; s < t; )
              this.elements[s] && this.elements[s] !== !0 && this.elements[s].getBaseElement && (c = this.elements[s], p = this.layers[s].ddd ? this.getThreeDContainerByPos(s) : c.getBaseElement(), l = p || l), s += 1;
            l ? (!o.ddd || !this.supports3d) && this.layerElement.insertBefore(n, l) : (!o.ddd || !this.supports3d) && this.layerElement.appendChild(n);
          }
        else
          this.addTo3dContainer(n, t);
      }
    }, HybridRendererBase.prototype.createShape = function(e) {
      return this.supports3d ? new HShapeElement(e, this.globalData, this) : new SVGShapeElement(e, this.globalData, this);
    }, HybridRendererBase.prototype.createText = function(e) {
      return this.supports3d ? new HTextElement(e, this.globalData, this) : new SVGTextLottieElement(e, this.globalData, this);
    }, HybridRendererBase.prototype.createCamera = function(e) {
      return this.camera = new HCameraElement(e, this.globalData, this), this.camera;
    }, HybridRendererBase.prototype.createImage = function(e) {
      return this.supports3d ? new HImageElement(e, this.globalData, this) : new IImageElement(e, this.globalData, this);
    }, HybridRendererBase.prototype.createSolid = function(e) {
      return this.supports3d ? new HSolidElement(e, this.globalData, this) : new ISolidElement(e, this.globalData, this);
    }, HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, HybridRendererBase.prototype.getThreeDContainerByPos = function(e) {
      for (var t = 0, n = this.threeDElements.length; t < n; ) {
        if (this.threeDElements[t].startPos <= e && this.threeDElements[t].endPos >= e)
          return this.threeDElements[t].perspectiveElem;
        t += 1;
      }
      return null;
    }, HybridRendererBase.prototype.createThreeDContainer = function(e, t) {
      var n = createTag("div"), o, s;
      styleDiv(n);
      var l = createTag("div");
      if (styleDiv(l), t === "3d") {
        o = n.style, o.width = this.globalData.compSize.w + "px", o.height = this.globalData.compSize.h + "px";
        var c = "50% 50%";
        o.webkitTransformOrigin = c, o.mozTransformOrigin = c, o.transformOrigin = c, s = l.style;
        var p = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
        s.transform = p, s.webkitTransform = p;
      }
      n.appendChild(l);
      var m = {
        container: l,
        perspectiveElem: n,
        startPos: e,
        endPos: e,
        type: t
      };
      return this.threeDElements.push(m), m;
    }, HybridRendererBase.prototype.build3dContainers = function() {
      var e, t = this.layers.length, n, o = "";
      for (e = 0; e < t; e += 1)
        this.layers[e].ddd && this.layers[e].ty !== 3 ? (o !== "3d" && (o = "3d", n = this.createThreeDContainer(e, "3d")), n.endPos = Math.max(n.endPos, e)) : (o !== "2d" && (o = "2d", n = this.createThreeDContainer(e, "2d")), n.endPos = Math.max(n.endPos, e));
      for (t = this.threeDElements.length, e = t - 1; e >= 0; e -= 1)
        this.resizerElem.appendChild(this.threeDElements[e].perspectiveElem);
    }, HybridRendererBase.prototype.addTo3dContainer = function(e, t) {
      for (var n = 0, o = this.threeDElements.length; n < o; ) {
        if (t <= this.threeDElements[n].endPos) {
          for (var s = this.threeDElements[n].startPos, l; s < t; )
            this.elements[s] && this.elements[s].getBaseElement && (l = this.elements[s].getBaseElement()), s += 1;
          l ? this.threeDElements[n].container.insertBefore(e, l) : this.threeDElements[n].container.appendChild(e);
          break;
        }
        n += 1;
      }
    }, HybridRendererBase.prototype.configAnimation = function(e) {
      var t = createTag("div"), n = this.animationItem.wrapper, o = t.style;
      o.width = e.w + "px", o.height = e.h + "px", this.resizerElem = t, styleDiv(t), o.transformStyle = "flat", o.mozTransformStyle = "flat", o.webkitTransformStyle = "flat", this.renderConfig.className && t.setAttribute("class", this.renderConfig.className), n.appendChild(t), o.overflow = "hidden";
      var s = createNS("svg");
      s.setAttribute("width", "1"), s.setAttribute("height", "1"), styleDiv(s), this.resizerElem.appendChild(s);
      var l = createNS("defs");
      s.appendChild(l), this.data = e, this.setupGlobalData(e, s), this.globalData.defs = l, this.layers = e.layers, this.layerElement = this.resizerElem, this.build3dContainers(), this.updateContainerSize();
    }, HybridRendererBase.prototype.destroy = function() {
      this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.animationItem.container = null, this.globalData.defs = null;
      var e, t = this.layers ? this.layers.length : 0;
      for (e = 0; e < t; e += 1)
        this.elements[e] && this.elements[e].destroy && this.elements[e].destroy();
      this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
    }, HybridRendererBase.prototype.updateContainerSize = function() {
      var e = this.animationItem.wrapper.offsetWidth, t = this.animationItem.wrapper.offsetHeight, n = e / t, o = this.globalData.compSize.w / this.globalData.compSize.h, s, l, c, p;
      o > n ? (s = e / this.globalData.compSize.w, l = e / this.globalData.compSize.w, c = 0, p = (t - this.globalData.compSize.h * (e / this.globalData.compSize.w)) / 2) : (s = t / this.globalData.compSize.h, l = t / this.globalData.compSize.h, c = (e - this.globalData.compSize.w * (t / this.globalData.compSize.h)) / 2, p = 0);
      var m = this.resizerElem.style;
      m.webkitTransform = "matrix3d(" + s + ",0,0,0,0," + l + ",0,0,0,0,1,0," + c + "," + p + ",0,1)", m.transform = m.webkitTransform;
    }, HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame, HybridRendererBase.prototype.hide = function() {
      this.resizerElem.style.display = "none";
    }, HybridRendererBase.prototype.show = function() {
      this.resizerElem.style.display = "block";
    }, HybridRendererBase.prototype.initItems = function() {
      if (this.buildAllItems(), this.camera)
        this.camera.setup();
      else {
        var e = this.globalData.compSize.w, t = this.globalData.compSize.h, n, o = this.threeDElements.length;
        for (n = 0; n < o; n += 1) {
          var s = this.threeDElements[n].perspectiveElem.style;
          s.webkitPerspective = Math.sqrt(Math.pow(e, 2) + Math.pow(t, 2)) + "px", s.perspective = s.webkitPerspective;
        }
      }
    }, HybridRendererBase.prototype.searchExtraCompositions = function(e) {
      var t, n = e.length, o = createTag("div");
      for (t = 0; t < n; t += 1)
        if (e[t].xt) {
          var s = this.createComp(e[t], o, this.globalData.comp, null);
          s.initExpressions(), this.globalData.projectInterface.registerComposition(s);
        }
    };
    function HCompElement(e, t, n) {
      this.layers = e.layers, this.supports3d = !e.hasMask, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(e, t, n), this.tm = e.tm ? PropertyFactory.getProp(this, e.tm, 0, t.frameRate, this) : {
        _placeholder: !0
      };
    }
    extendPrototype([HybridRendererBase, ICompElement, HBaseElement], HCompElement), HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements, HCompElement.prototype.createContainerElements = function() {
      this._createBaseContainerElements(), this.data.hasMask ? (this.svgElement.setAttribute("width", this.data.w), this.svgElement.setAttribute("height", this.data.h), this.transformedElement = this.baseElement) : this.transformedElement = this.layerElement;
    }, HCompElement.prototype.addTo3dContainer = function(e, t) {
      for (var n = 0, o; n < t; )
        this.elements[n] && this.elements[n].getBaseElement && (o = this.elements[n].getBaseElement()), n += 1;
      o ? this.layerElement.insertBefore(e, o) : this.layerElement.appendChild(e);
    }, HCompElement.prototype.createComp = function(e) {
      return this.supports3d ? new HCompElement(e, this.globalData, this) : new SVGCompElement(e, this.globalData, this);
    };
    function HybridRenderer(e, t) {
      this.animationItem = e, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
        className: t && t.className || "",
        imagePreserveAspectRatio: t && t.imagePreserveAspectRatio || "xMidYMid slice",
        hideOnTransparent: !(t && t.hideOnTransparent === !1),
        filterSize: {
          width: t && t.filterSize && t.filterSize.width || "400%",
          height: t && t.filterSize && t.filterSize.height || "400%",
          x: t && t.filterSize && t.filterSize.x || "-100%",
          y: t && t.filterSize && t.filterSize.y || "-100%"
        },
        runExpressions: !t || t.runExpressions === void 0 || t.runExpressions
      }, this.globalData = {
        _mdf: !1,
        frameNum: -1,
        renderConfig: this.renderConfig
      }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
    }
    extendPrototype([HybridRendererBase], HybridRenderer), HybridRenderer.prototype.createComp = function(e) {
      return this.supports3d ? new HCompElement(e, this.globalData, this) : new SVGCompElement(e, this.globalData, this);
    };
    var CompExpressionInterface = function() {
      return function(e) {
        function t(n) {
          for (var o = 0, s = e.layers.length; o < s; ) {
            if (e.layers[o].nm === n || e.layers[o].ind === n)
              return e.elements[o].layerInterface;
            o += 1;
          }
          return null;
        }
        return Object.defineProperty(t, "_name", {
          value: e.data.nm
        }), t.layer = t, t.pixelAspect = 1, t.height = e.data.h || e.globalData.compSize.h, t.width = e.data.w || e.globalData.compSize.w, t.pixelAspect = 1, t.frameDuration = 1 / e.globalData.frameRate, t.displayStartTime = 0, t.numLayers = e.layers.length, t;
      };
    }();
    function _typeof$2(e) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$2 = function(n) {
        return typeof n;
      } : _typeof$2 = function(n) {
        return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      }, _typeof$2(e);
    }
    function seedRandom(e, t) {
      var n = this, o = 256, s = 6, l = 52, c = "random", p = t.pow(o, s), m = t.pow(2, l), C = m * 2, P = o - 1, w;
      function R(N, B, K) {
        var ue = [];
        B = B === !0 ? {
          entropy: !0
        } : B || {};
        var de = W($(B.entropy ? [N, V(e)] : N === null ? H() : N, 3), ue), ve = new L(ue), Te = function() {
          for (var Ce = ve.g(s), Re = p, ke = 0; Ce < m; )
            Ce = (Ce + ke) * o, Re *= o, ke = ve.g(1);
          for (; Ce >= C; )
            Ce /= 2, Re /= 2, ke >>>= 1;
          return (Ce + ke) / Re;
        };
        return Te.int32 = function() {
          return ve.g(4) | 0;
        }, Te.quick = function() {
          return ve.g(4) / 4294967296;
        }, Te.double = Te, W(V(ve.S), e), (B.pass || K || function(Pe, Ce, Re, ke) {
          return ke && (ke.S && M(ke, ve), Pe.state = function() {
            return M(ve, {});
          }), Re ? (t[c] = Pe, Ce) : Pe;
        })(Te, de, "global" in B ? B.global : this == t, B.state);
      }
      t["seed" + c] = R;
      function L(N) {
        var B, K = N.length, ue = this, de = 0, ve = ue.i = ue.j = 0, Te = ue.S = [];
        for (K || (N = [K++]); de < o; )
          Te[de] = de++;
        for (de = 0; de < o; de++)
          Te[de] = Te[ve = P & ve + N[de % K] + (B = Te[de])], Te[ve] = B;
        ue.g = function(Pe) {
          for (var Ce, Re = 0, ke = ue.i, Ae = ue.j, we = ue.S; Pe--; )
            Ce = we[ke = P & ke + 1], Re = Re * o + we[P & (we[ke] = we[Ae = P & Ae + Ce]) + (we[Ae] = Ce)];
          return ue.i = ke, ue.j = Ae, Re;
        };
      }
      function M(N, B) {
        return B.i = N.i, B.j = N.j, B.S = N.S.slice(), B;
      }
      function $(N, B) {
        var K = [], ue = _typeof$2(N), de;
        if (B && ue == "object")
          for (de in N)
            try {
              K.push($(N[de], B - 1));
            } catch {
            }
        return K.length ? K : ue == "string" ? N : N + "\0";
      }
      function W(N, B) {
        for (var K = N + "", ue, de = 0; de < K.length; )
          B[P & de] = P & (ue ^= B[P & de] * 19) + K.charCodeAt(de++);
        return V(B);
      }
      function H() {
        try {
          var N = new Uint8Array(o);
          return (n.crypto || n.msCrypto).getRandomValues(N), V(N);
        } catch {
          var B = n.navigator, K = B && B.plugins;
          return [+/* @__PURE__ */ new Date(), n, K, n.screen, V(e)];
        }
      }
      function V(N) {
        return String.fromCharCode.apply(0, N);
      }
      W(t.random(), e);
    }
    function initialize$2(e) {
      seedRandom([], e);
    }
    var propTypes = {
      SHAPE: "shape"
    };
    function _typeof$1(e) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$1 = function(n) {
        return typeof n;
      } : _typeof$1 = function(n) {
        return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      }, _typeof$1(e);
    }
    var ExpressionManager = function() {
      var ob = {}, Math = BMMath, window = null, document = null, XMLHttpRequest = null, fetch = null, frames = null, _lottieGlobal = {};
      initialize$2(BMMath);
      function resetFrame() {
        _lottieGlobal = {};
      }
      function $bm_isInstanceOfArray(e) {
        return e.constructor === Array || e.constructor === Float32Array;
      }
      function isNumerable(e, t) {
        return e === "number" || t instanceof Number || e === "boolean" || e === "string";
      }
      function $bm_neg(e) {
        var t = _typeof$1(e);
        if (t === "number" || e instanceof Number || t === "boolean")
          return -e;
        if ($bm_isInstanceOfArray(e)) {
          var n, o = e.length, s = [];
          for (n = 0; n < o; n += 1)
            s[n] = -e[n];
          return s;
        }
        return e.propType ? e.v : -e;
      }
      var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, "easeIn").get, easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, "easeOut").get, easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, "easeInOut").get;
      function sum(e, t) {
        var n = _typeof$1(e), o = _typeof$1(t);
        if (isNumerable(n, e) && isNumerable(o, t) || n === "string" || o === "string")
          return e + t;
        if ($bm_isInstanceOfArray(e) && isNumerable(o, t))
          return e = e.slice(0), e[0] += t, e;
        if (isNumerable(n, e) && $bm_isInstanceOfArray(t))
          return t = t.slice(0), t[0] = e + t[0], t;
        if ($bm_isInstanceOfArray(e) && $bm_isInstanceOfArray(t)) {
          for (var s = 0, l = e.length, c = t.length, p = []; s < l || s < c; )
            (typeof e[s] == "number" || e[s] instanceof Number) && (typeof t[s] == "number" || t[s] instanceof Number) ? p[s] = e[s] + t[s] : p[s] = t[s] === void 0 ? e[s] : e[s] || t[s], s += 1;
          return p;
        }
        return 0;
      }
      var add = sum;
      function sub(e, t) {
        var n = _typeof$1(e), o = _typeof$1(t);
        if (isNumerable(n, e) && isNumerable(o, t))
          return n === "string" && (e = parseInt(e, 10)), o === "string" && (t = parseInt(t, 10)), e - t;
        if ($bm_isInstanceOfArray(e) && isNumerable(o, t))
          return e = e.slice(0), e[0] -= t, e;
        if (isNumerable(n, e) && $bm_isInstanceOfArray(t))
          return t = t.slice(0), t[0] = e - t[0], t;
        if ($bm_isInstanceOfArray(e) && $bm_isInstanceOfArray(t)) {
          for (var s = 0, l = e.length, c = t.length, p = []; s < l || s < c; )
            (typeof e[s] == "number" || e[s] instanceof Number) && (typeof t[s] == "number" || t[s] instanceof Number) ? p[s] = e[s] - t[s] : p[s] = t[s] === void 0 ? e[s] : e[s] || t[s], s += 1;
          return p;
        }
        return 0;
      }
      function mul(e, t) {
        var n = _typeof$1(e), o = _typeof$1(t), s;
        if (isNumerable(n, e) && isNumerable(o, t))
          return e * t;
        var l, c;
        if ($bm_isInstanceOfArray(e) && isNumerable(o, t)) {
          for (c = e.length, s = createTypedArray("float32", c), l = 0; l < c; l += 1)
            s[l] = e[l] * t;
          return s;
        }
        if (isNumerable(n, e) && $bm_isInstanceOfArray(t)) {
          for (c = t.length, s = createTypedArray("float32", c), l = 0; l < c; l += 1)
            s[l] = e * t[l];
          return s;
        }
        return 0;
      }
      function div(e, t) {
        var n = _typeof$1(e), o = _typeof$1(t), s;
        if (isNumerable(n, e) && isNumerable(o, t))
          return e / t;
        var l, c;
        if ($bm_isInstanceOfArray(e) && isNumerable(o, t)) {
          for (c = e.length, s = createTypedArray("float32", c), l = 0; l < c; l += 1)
            s[l] = e[l] / t;
          return s;
        }
        if (isNumerable(n, e) && $bm_isInstanceOfArray(t)) {
          for (c = t.length, s = createTypedArray("float32", c), l = 0; l < c; l += 1)
            s[l] = e / t[l];
          return s;
        }
        return 0;
      }
      function mod(e, t) {
        return typeof e == "string" && (e = parseInt(e, 10)), typeof t == "string" && (t = parseInt(t, 10)), e % t;
      }
      var $bm_sum = sum, $bm_sub = sub, $bm_mul = mul, $bm_div = div, $bm_mod = mod;
      function clamp(e, t, n) {
        if (t > n) {
          var o = n;
          n = t, t = o;
        }
        return Math.min(Math.max(e, t), n);
      }
      function radiansToDegrees(e) {
        return e / degToRads;
      }
      var radians_to_degrees = radiansToDegrees;
      function degreesToRadians(e) {
        return e * degToRads;
      }
      var degrees_to_radians = radiansToDegrees, helperLengthArray = [0, 0, 0, 0, 0, 0];
      function length(e, t) {
        if (typeof e == "number" || e instanceof Number)
          return t = t || 0, Math.abs(e - t);
        t || (t = helperLengthArray);
        var n, o = Math.min(e.length, t.length), s = 0;
        for (n = 0; n < o; n += 1)
          s += Math.pow(t[n] - e[n], 2);
        return Math.sqrt(s);
      }
      function normalize(e) {
        return div(e, length(e));
      }
      function rgbToHsl(e) {
        var t = e[0], n = e[1], o = e[2], s = Math.max(t, n, o), l = Math.min(t, n, o), c, p, m = (s + l) / 2;
        if (s === l)
          c = 0, p = 0;
        else {
          var C = s - l;
          switch (p = m > 0.5 ? C / (2 - s - l) : C / (s + l), s) {
            case t:
              c = (n - o) / C + (n < o ? 6 : 0);
              break;
            case n:
              c = (o - t) / C + 2;
              break;
            case o:
              c = (t - n) / C + 4;
              break;
          }
          c /= 6;
        }
        return [c, p, m, e[3]];
      }
      function hue2rgb(e, t, n) {
        return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
      }
      function hslToRgb(e) {
        var t = e[0], n = e[1], o = e[2], s, l, c;
        if (n === 0)
          s = o, c = o, l = o;
        else {
          var p = o < 0.5 ? o * (1 + n) : o + n - o * n, m = 2 * o - p;
          s = hue2rgb(m, p, t + 1 / 3), l = hue2rgb(m, p, t), c = hue2rgb(m, p, t - 1 / 3);
        }
        return [s, l, c, e[3]];
      }
      function linear(e, t, n, o, s) {
        if ((o === void 0 || s === void 0) && (o = t, s = n, t = 0, n = 1), n < t) {
          var l = n;
          n = t, t = l;
        }
        if (e <= t)
          return o;
        if (e >= n)
          return s;
        var c = n === t ? 0 : (e - t) / (n - t);
        if (!o.length)
          return o + (s - o) * c;
        var p, m = o.length, C = createTypedArray("float32", m);
        for (p = 0; p < m; p += 1)
          C[p] = o[p] + (s[p] - o[p]) * c;
        return C;
      }
      function random(e, t) {
        if (t === void 0 && (e === void 0 ? (e = 0, t = 1) : (t = e, e = void 0)), t.length) {
          var n, o = t.length;
          e || (e = createTypedArray("float32", o));
          var s = createTypedArray("float32", o), l = BMMath.random();
          for (n = 0; n < o; n += 1)
            s[n] = e[n] + l * (t[n] - e[n]);
          return s;
        }
        e === void 0 && (e = 0);
        var c = BMMath.random();
        return e + c * (t - e);
      }
      function createPath(e, t, n, o) {
        var s, l = e.length, c = shapePool.newElement();
        c.setPathData(!!o, l);
        var p = [0, 0], m, C;
        for (s = 0; s < l; s += 1)
          m = t && t[s] ? t[s] : p, C = n && n[s] ? n[s] : p, c.setTripleAt(e[s][0], e[s][1], C[0] + e[s][0], C[1] + e[s][1], m[0] + e[s][0], m[1] + e[s][1], s, !0);
        return c;
      }
      function initiateExpression(elem, data, property) {
        function noOp(e) {
          return e;
        }
        if (!elem.globalData.renderConfig.runExpressions)
          return noOp;
        var val = data.x, needsVelocity = /velocity(?![\w\d])/.test(val), _needsRandom = val.indexOf("random") !== -1, elemType = elem.data.ty, transform, $bm_transform, content, effect, thisProperty = property;
        thisProperty.valueAtTime = thisProperty.getValueAtTime, Object.defineProperty(thisProperty, "value", {
          get: function() {
            return thisProperty.v;
          }
        }), elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate, elem.comp.displayStartTime = 0;
        var inPoint = elem.data.ip / elem.comp.globalData.frameRate, outPoint = elem.data.op / elem.comp.globalData.frameRate, width = elem.data.sw ? elem.data.sw : 0, height = elem.data.sh ? elem.data.sh : 0, name = elem.data.nm, loopIn, loop_in, loopOut, loop_out, smooth, toWorld, fromWorld, fromComp, toComp, fromCompToSurface, position, rotation, anchorPoint, scale, thisLayer, thisComp, mask, valueAtTime, velocityAtTime, scoped_bm_rt, expression_function = eval("[function _expression_function(){" + val + ";scoped_bm_rt=$bm_rt}]")[0], numKeys = property.kf ? data.k.length : 0, active = !this.data || this.data.hd !== !0, wiggle = (function e(t, n) {
          var o, s, l = this.pv.length ? this.pv.length : 1, c = createTypedArray("float32", l);
          t = 5;
          var p = Math.floor(time * t);
          for (o = 0, s = 0; o < p; ) {
            for (s = 0; s < l; s += 1)
              c[s] += -n + n * 2 * BMMath.random();
            o += 1;
          }
          var m = time * t, C = m - Math.floor(m), P = createTypedArray("float32", l);
          if (l > 1) {
            for (s = 0; s < l; s += 1)
              P[s] = this.pv[s] + c[s] + (-n + n * 2 * BMMath.random()) * C;
            return P;
          }
          return this.pv + c[0] + (-n + n * 2 * BMMath.random()) * C;
        }).bind(this);
        thisProperty.loopIn && (loopIn = thisProperty.loopIn.bind(thisProperty), loop_in = loopIn), thisProperty.loopOut && (loopOut = thisProperty.loopOut.bind(thisProperty), loop_out = loopOut), thisProperty.smooth && (smooth = thisProperty.smooth.bind(thisProperty));
        function loopInDuration(e, t) {
          return loopIn(e, t, !0);
        }
        function loopOutDuration(e, t) {
          return loopOut(e, t, !0);
        }
        this.getValueAtTime && (valueAtTime = this.getValueAtTime.bind(this)), this.getVelocityAtTime && (velocityAtTime = this.getVelocityAtTime.bind(this));
        var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);
        function lookAt(e, t) {
          var n = [t[0] - e[0], t[1] - e[1], t[2] - e[2]], o = Math.atan2(n[0], Math.sqrt(n[1] * n[1] + n[2] * n[2])) / degToRads, s = -Math.atan2(n[1], n[2]) / degToRads;
          return [s, o, 0];
        }
        function easeOut(e, t, n, o, s) {
          return applyEase(easeOutBez, e, t, n, o, s);
        }
        function easeIn(e, t, n, o, s) {
          return applyEase(easeInBez, e, t, n, o, s);
        }
        function ease(e, t, n, o, s) {
          return applyEase(easeInOutBez, e, t, n, o, s);
        }
        function applyEase(e, t, n, o, s, l) {
          s === void 0 ? (s = n, l = o) : t = (t - n) / (o - n), t > 1 ? t = 1 : t < 0 && (t = 0);
          var c = e(t);
          if ($bm_isInstanceOfArray(s)) {
            var p, m = s.length, C = createTypedArray("float32", m);
            for (p = 0; p < m; p += 1)
              C[p] = (l[p] - s[p]) * c + s[p];
            return C;
          }
          return (l - s) * c + s;
        }
        function nearestKey(e) {
          var t, n = data.k.length, o, s;
          if (!data.k.length || typeof data.k[0] == "number")
            o = 0, s = 0;
          else if (o = -1, e *= elem.comp.globalData.frameRate, e < data.k[0].t)
            o = 1, s = data.k[0].t;
          else {
            for (t = 0; t < n - 1; t += 1)
              if (e === data.k[t].t) {
                o = t + 1, s = data.k[t].t;
                break;
              } else if (e > data.k[t].t && e < data.k[t + 1].t) {
                e - data.k[t].t > data.k[t + 1].t - e ? (o = t + 2, s = data.k[t + 1].t) : (o = t + 1, s = data.k[t].t);
                break;
              }
            o === -1 && (o = t + 1, s = data.k[t].t);
          }
          var l = {};
          return l.index = o, l.time = s / elem.comp.globalData.frameRate, l;
        }
        function key(e) {
          var t, n, o;
          if (!data.k.length || typeof data.k[0] == "number")
            throw new Error("The property has no keyframe at index " + e);
          e -= 1, t = {
            time: data.k[e].t / elem.comp.globalData.frameRate,
            value: []
          };
          var s = Object.prototype.hasOwnProperty.call(data.k[e], "s") ? data.k[e].s : data.k[e - 1].e;
          for (o = s.length, n = 0; n < o; n += 1)
            t[n] = s[n], t.value[n] = s[n];
          return t;
        }
        function framesToTime(e, t) {
          return t || (t = elem.comp.globalData.frameRate), e / t;
        }
        function timeToFrames(e, t) {
          return !e && e !== 0 && (e = time), t || (t = elem.comp.globalData.frameRate), e * t;
        }
        function seedRandom(e) {
          BMMath.seedrandom(randSeed + e);
        }
        function sourceRectAtTime() {
          return elem.sourceRectAtTime();
        }
        function substring(e, t) {
          return typeof value == "string" ? t === void 0 ? value.substring(e) : value.substring(e, t) : "";
        }
        function substr(e, t) {
          return typeof value == "string" ? t === void 0 ? value.substr(e) : value.substr(e, t) : "";
        }
        function posterizeTime(e) {
          time = e === 0 ? 0 : Math.floor(time * e) / e, value = valueAtTime(time);
        }
        var time, velocity, value, text, textIndex, textTotal, selectorValue, index = elem.data.ind, hasParent = !!(elem.hierarchy && elem.hierarchy.length), parent, randSeed = Math.floor(Math.random() * 1e6), globalData = elem.globalData;
        function executeExpression(e) {
          return value = e, this.frameExpressionId === elem.globalData.frameId && this.propType !== "textSelector" ? value : (this.propType === "textSelector" && (textIndex = this.textIndex, textTotal = this.textTotal, selectorValue = this.selectorValue), thisLayer || (text = elem.layerInterface.text, thisLayer = elem.layerInterface, thisComp = elem.comp.compInterface, toWorld = thisLayer.toWorld.bind(thisLayer), fromWorld = thisLayer.fromWorld.bind(thisLayer), fromComp = thisLayer.fromComp.bind(thisLayer), toComp = thisLayer.toComp.bind(thisLayer), mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null, fromCompToSurface = fromComp), transform || (transform = elem.layerInterface("ADBE Transform Group"), $bm_transform = transform, transform && (anchorPoint = transform.anchorPoint)), elemType === 4 && !content && (content = thisLayer("ADBE Root Vectors Group")), effect || (effect = thisLayer(4)), hasParent = !!(elem.hierarchy && elem.hierarchy.length), hasParent && !parent && (parent = elem.hierarchy[0].layerInterface), time = this.comp.renderedFrame / this.comp.globalData.frameRate, _needsRandom && seedRandom(randSeed + time), needsVelocity && (velocity = velocityAtTime(time)), expression_function(), this.frameExpressionId = elem.globalData.frameId, scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt, scoped_bm_rt);
        }
        return executeExpression.__preventDeadCodeRemoval = [$bm_transform, anchorPoint, time, velocity, inPoint, outPoint, width, height, name, loop_in, loop_out, smooth, toComp, fromCompToSurface, toWorld, fromWorld, mask, position, rotation, scale, thisComp, numKeys, active, wiggle, loopInDuration, loopOutDuration, comp, lookAt, easeOut, easeIn, ease, nearestKey, key, text, textIndex, textTotal, selectorValue, framesToTime, timeToFrames, sourceRectAtTime, substring, substr, posterizeTime, index, globalData], executeExpression;
      }
      return ob.initiateExpression = initiateExpression, ob.__preventDeadCodeRemoval = [window, document, XMLHttpRequest, fetch, frames, $bm_neg, add, $bm_sum, $bm_sub, $bm_mul, $bm_div, $bm_mod, clamp, radians_to_degrees, degreesToRadians, degrees_to_radians, normalize, rgbToHsl, hslToRgb, linear, random, createPath, _lottieGlobal], ob.resetFrame = resetFrame, ob;
    }(), Expressions = function() {
      var e = {};
      e.initExpressions = t, e.resetFrame = ExpressionManager.resetFrame;
      function t(n) {
        var o = 0, s = [];
        function l() {
          o += 1;
        }
        function c() {
          o -= 1, o === 0 && m();
        }
        function p(C) {
          s.indexOf(C) === -1 && s.push(C);
        }
        function m() {
          var C, P = s.length;
          for (C = 0; C < P; C += 1)
            s[C].release();
          s.length = 0;
        }
        n.renderer.compInterface = CompExpressionInterface(n.renderer), n.renderer.globalData.projectInterface.registerComposition(n.renderer), n.renderer.globalData.pushExpression = l, n.renderer.globalData.popExpression = c, n.renderer.globalData.registerExpressionProperty = p;
      }
      return e;
    }(), MaskManagerInterface = function() {
      function e(n, o) {
        this._mask = n, this._data = o;
      }
      Object.defineProperty(e.prototype, "maskPath", {
        get: function() {
          return this._mask.prop.k && this._mask.prop.getValue(), this._mask.prop;
        }
      }), Object.defineProperty(e.prototype, "maskOpacity", {
        get: function() {
          return this._mask.op.k && this._mask.op.getValue(), this._mask.op.v * 100;
        }
      });
      var t = function(o) {
        var s = createSizedArray(o.viewData.length), l, c = o.viewData.length;
        for (l = 0; l < c; l += 1)
          s[l] = new e(o.viewData[l], o.masksProperties[l]);
        var p = function(C) {
          for (l = 0; l < c; ) {
            if (o.masksProperties[l].nm === C)
              return s[l];
            l += 1;
          }
          return null;
        };
        return p;
      };
      return t;
    }(), ExpressionPropertyInterface = function() {
      var e = {
        pv: 0,
        v: 0,
        mult: 1
      }, t = {
        pv: [0, 0, 0],
        v: [0, 0, 0],
        mult: 1
      };
      function n(c, p, m) {
        Object.defineProperty(c, "velocity", {
          get: function() {
            return p.getVelocityAtTime(p.comp.currentFrame);
          }
        }), c.numKeys = p.keyframes ? p.keyframes.length : 0, c.key = function(C) {
          if (!c.numKeys)
            return 0;
          var P = "";
          "s" in p.keyframes[C - 1] ? P = p.keyframes[C - 1].s : "e" in p.keyframes[C - 2] ? P = p.keyframes[C - 2].e : P = p.keyframes[C - 2].s;
          var w = m === "unidimensional" ? new Number(P) : Object.assign({}, P);
          return w.time = p.keyframes[C - 1].t / p.elem.comp.globalData.frameRate, w.value = m === "unidimensional" ? P[0] : P, w;
        }, c.valueAtTime = p.getValueAtTime, c.speedAtTime = p.getSpeedAtTime, c.velocityAtTime = p.getVelocityAtTime, c.propertyGroup = p.propertyGroup;
      }
      function o(c) {
        (!c || !("pv" in c)) && (c = e);
        var p = 1 / c.mult, m = c.pv * p, C = new Number(m);
        return C.value = m, n(C, c, "unidimensional"), function() {
          return c.k && c.getValue(), m = c.v * p, C.value !== m && (C = new Number(m), C.value = m, n(C, c, "unidimensional")), C;
        };
      }
      function s(c) {
        (!c || !("pv" in c)) && (c = t);
        var p = 1 / c.mult, m = c.data && c.data.l || c.pv.length, C = createTypedArray("float32", m), P = createTypedArray("float32", m);
        return C.value = P, n(C, c, "multidimensional"), function() {
          c.k && c.getValue();
          for (var w = 0; w < m; w += 1)
            P[w] = c.v[w] * p, C[w] = P[w];
          return C;
        };
      }
      function l() {
        return e;
      }
      return function(c) {
        return c ? c.propType === "unidimensional" ? o(c) : s(c) : l;
      };
    }(), TransformExpressionInterface = function() {
      return function(e) {
        function t(c) {
          switch (c) {
            case "scale":
            case "Scale":
            case "ADBE Scale":
            case 6:
              return t.scale;
            case "rotation":
            case "Rotation":
            case "ADBE Rotation":
            case "ADBE Rotate Z":
            case 10:
              return t.rotation;
            case "ADBE Rotate X":
              return t.xRotation;
            case "ADBE Rotate Y":
              return t.yRotation;
            case "position":
            case "Position":
            case "ADBE Position":
            case 2:
              return t.position;
            case "ADBE Position_0":
              return t.xPosition;
            case "ADBE Position_1":
              return t.yPosition;
            case "ADBE Position_2":
              return t.zPosition;
            case "anchorPoint":
            case "AnchorPoint":
            case "Anchor Point":
            case "ADBE AnchorPoint":
            case 1:
              return t.anchorPoint;
            case "opacity":
            case "Opacity":
            case 11:
              return t.opacity;
            default:
              return null;
          }
        }
        Object.defineProperty(t, "rotation", {
          get: ExpressionPropertyInterface(e.r || e.rz)
        }), Object.defineProperty(t, "zRotation", {
          get: ExpressionPropertyInterface(e.rz || e.r)
        }), Object.defineProperty(t, "xRotation", {
          get: ExpressionPropertyInterface(e.rx)
        }), Object.defineProperty(t, "yRotation", {
          get: ExpressionPropertyInterface(e.ry)
        }), Object.defineProperty(t, "scale", {
          get: ExpressionPropertyInterface(e.s)
        });
        var n, o, s, l;
        return e.p ? l = ExpressionPropertyInterface(e.p) : (n = ExpressionPropertyInterface(e.px), o = ExpressionPropertyInterface(e.py), e.pz && (s = ExpressionPropertyInterface(e.pz))), Object.defineProperty(t, "position", {
          get: function() {
            return e.p ? l() : [n(), o(), s ? s() : 0];
          }
        }), Object.defineProperty(t, "xPosition", {
          get: ExpressionPropertyInterface(e.px)
        }), Object.defineProperty(t, "yPosition", {
          get: ExpressionPropertyInterface(e.py)
        }), Object.defineProperty(t, "zPosition", {
          get: ExpressionPropertyInterface(e.pz)
        }), Object.defineProperty(t, "anchorPoint", {
          get: ExpressionPropertyInterface(e.a)
        }), Object.defineProperty(t, "opacity", {
          get: ExpressionPropertyInterface(e.o)
        }), Object.defineProperty(t, "skew", {
          get: ExpressionPropertyInterface(e.sk)
        }), Object.defineProperty(t, "skewAxis", {
          get: ExpressionPropertyInterface(e.sa)
        }), Object.defineProperty(t, "orientation", {
          get: ExpressionPropertyInterface(e.or)
        }), t;
      };
    }(), LayerExpressionInterface = function() {
      function e(C) {
        var P = new Matrix();
        if (C !== void 0) {
          var w = this._elem.finalTransform.mProp.getValueAtTime(C);
          w.clone(P);
        } else {
          var R = this._elem.finalTransform.mProp;
          R.applyToMatrix(P);
        }
        return P;
      }
      function t(C, P) {
        var w = this.getMatrix(P);
        return w.props[12] = 0, w.props[13] = 0, w.props[14] = 0, this.applyPoint(w, C);
      }
      function n(C, P) {
        var w = this.getMatrix(P);
        return this.applyPoint(w, C);
      }
      function o(C, P) {
        var w = this.getMatrix(P);
        return w.props[12] = 0, w.props[13] = 0, w.props[14] = 0, this.invertPoint(w, C);
      }
      function s(C, P) {
        var w = this.getMatrix(P);
        return this.invertPoint(w, C);
      }
      function l(C, P) {
        if (this._elem.hierarchy && this._elem.hierarchy.length) {
          var w, R = this._elem.hierarchy.length;
          for (w = 0; w < R; w += 1)
            this._elem.hierarchy[w].finalTransform.mProp.applyToMatrix(C);
        }
        return C.applyToPointArray(P[0], P[1], P[2] || 0);
      }
      function c(C, P) {
        if (this._elem.hierarchy && this._elem.hierarchy.length) {
          var w, R = this._elem.hierarchy.length;
          for (w = 0; w < R; w += 1)
            this._elem.hierarchy[w].finalTransform.mProp.applyToMatrix(C);
        }
        return C.inversePoint(P);
      }
      function p(C) {
        var P = new Matrix();
        if (P.reset(), this._elem.finalTransform.mProp.applyToMatrix(P), this._elem.hierarchy && this._elem.hierarchy.length) {
          var w, R = this._elem.hierarchy.length;
          for (w = 0; w < R; w += 1)
            this._elem.hierarchy[w].finalTransform.mProp.applyToMatrix(P);
          return P.inversePoint(C);
        }
        return P.inversePoint(C);
      }
      function m() {
        return [1, 1, 1, 1];
      }
      return function(C) {
        var P;
        function w($) {
          L.mask = new MaskManagerInterface($, C);
        }
        function R($) {
          L.effect = $;
        }
        function L($) {
          switch ($) {
            case "ADBE Root Vectors Group":
            case "Contents":
            case 2:
              return L.shapeInterface;
            case 1:
            case 6:
            case "Transform":
            case "transform":
            case "ADBE Transform Group":
              return P;
            case 4:
            case "ADBE Effect Parade":
            case "effects":
            case "Effects":
              return L.effect;
            case "ADBE Text Properties":
              return L.textInterface;
            default:
              return null;
          }
        }
        L.getMatrix = e, L.invertPoint = c, L.applyPoint = l, L.toWorld = n, L.toWorldVec = t, L.fromWorld = s, L.fromWorldVec = o, L.toComp = n, L.fromComp = p, L.sampleImage = m, L.sourceRectAtTime = C.sourceRectAtTime.bind(C), L._elem = C, P = TransformExpressionInterface(C.finalTransform.mProp);
        var M = getDescriptor(P, "anchorPoint");
        return Object.defineProperties(L, {
          hasParent: {
            get: function() {
              return C.hierarchy.length;
            }
          },
          parent: {
            get: function() {
              return C.hierarchy[0].layerInterface;
            }
          },
          rotation: getDescriptor(P, "rotation"),
          scale: getDescriptor(P, "scale"),
          position: getDescriptor(P, "position"),
          opacity: getDescriptor(P, "opacity"),
          anchorPoint: M,
          anchor_point: M,
          transform: {
            get: function() {
              return P;
            }
          },
          active: {
            get: function() {
              return C.isInRange;
            }
          }
        }), L.startTime = C.data.st, L.index = C.data.ind, L.source = C.data.refId, L.height = C.data.ty === 0 ? C.data.h : 100, L.width = C.data.ty === 0 ? C.data.w : 100, L.inPoint = C.data.ip / C.comp.globalData.frameRate, L.outPoint = C.data.op / C.comp.globalData.frameRate, L._name = C.data.nm, L.registerMaskInterface = w, L.registerEffectsInterface = R, L;
      };
    }(), propertyGroupFactory = function() {
      return function(e, t) {
        return function(n) {
          return n = n === void 0 ? 1 : n, n <= 0 ? e : t(n - 1);
        };
      };
    }(), PropertyInterface = function() {
      return function(e, t) {
        var n = {
          _name: e
        };
        function o(s) {
          return s = s === void 0 ? 1 : s, s <= 0 ? n : t(s - 1);
        }
        return o;
      };
    }(), EffectsExpressionInterface = function() {
      var e = {
        createEffectsInterface: t
      };
      function t(s, l) {
        if (s.effectsManager) {
          var c = [], p = s.data.ef, m, C = s.effectsManager.effectElements.length;
          for (m = 0; m < C; m += 1)
            c.push(n(p[m], s.effectsManager.effectElements[m], l, s));
          var P = s.data.ef || [], w = function(L) {
            for (m = 0, C = P.length; m < C; ) {
              if (L === P[m].nm || L === P[m].mn || L === P[m].ix)
                return c[m];
              m += 1;
            }
            return null;
          };
          return Object.defineProperty(w, "numProperties", {
            get: function() {
              return P.length;
            }
          }), w;
        }
        return null;
      }
      function n(s, l, c, p) {
        function m(L) {
          for (var M = s.ef, $ = 0, W = M.length; $ < W; ) {
            if (L === M[$].nm || L === M[$].mn || L === M[$].ix)
              return M[$].ty === 5 ? P[$] : P[$]();
            $ += 1;
          }
          throw new Error();
        }
        var C = propertyGroupFactory(m, c), P = [], w, R = s.ef.length;
        for (w = 0; w < R; w += 1)
          s.ef[w].ty === 5 ? P.push(n(s.ef[w], l.effectElements[w], l.effectElements[w].propertyGroup, p)) : P.push(o(l.effectElements[w], s.ef[w].ty, p, C));
        return s.mn === "ADBE Color Control" && Object.defineProperty(m, "color", {
          get: function() {
            return P[0]();
          }
        }), Object.defineProperties(m, {
          numProperties: {
            get: function() {
              return s.np;
            }
          },
          _name: {
            value: s.nm
          },
          propertyGroup: {
            value: C
          }
        }), m.enabled = s.en !== 0, m.active = m.enabled, m;
      }
      function o(s, l, c, p) {
        var m = ExpressionPropertyInterface(s.p);
        function C() {
          return l === 10 ? c.comp.compInterface(s.p.v) : m();
        }
        return s.p.setGroupProperty && s.p.setGroupProperty(PropertyInterface("", p)), C;
      }
      return e;
    }(), ShapePathInterface = function() {
      return function(t, n, o) {
        var s = n.sh;
        function l(p) {
          return p === "Shape" || p === "shape" || p === "Path" || p === "path" || p === "ADBE Vector Shape" || p === 2 ? l.path : null;
        }
        var c = propertyGroupFactory(l, o);
        return s.setGroupProperty(PropertyInterface("Path", c)), Object.defineProperties(l, {
          path: {
            get: function() {
              return s.k && s.getValue(), s;
            }
          },
          shape: {
            get: function() {
              return s.k && s.getValue(), s;
            }
          },
          _name: {
            value: t.nm
          },
          ix: {
            value: t.ix
          },
          propertyIndex: {
            value: t.ix
          },
          mn: {
            value: t.mn
          },
          propertyGroup: {
            value: o
          }
        }), l;
      };
    }(), ShapeExpressionInterface = function() {
      function e(M, $, W) {
        var H = [], V, N = M ? M.length : 0;
        for (V = 0; V < N; V += 1)
          M[V].ty === "gr" ? H.push(n(M[V], $[V], W)) : M[V].ty === "fl" ? H.push(o(M[V], $[V], W)) : M[V].ty === "st" ? H.push(c(M[V], $[V], W)) : M[V].ty === "tm" ? H.push(p(M[V], $[V], W)) : M[V].ty === "tr" || (M[V].ty === "el" ? H.push(C(M[V], $[V], W)) : M[V].ty === "sr" ? H.push(P(M[V], $[V], W)) : M[V].ty === "sh" ? H.push(ShapePathInterface(M[V], $[V], W)) : M[V].ty === "rc" ? H.push(w(M[V], $[V], W)) : M[V].ty === "rd" ? H.push(R(M[V], $[V], W)) : M[V].ty === "rp" ? H.push(L(M[V], $[V], W)) : M[V].ty === "gf" ? H.push(s(M[V], $[V], W)) : H.push(l(M[V], $[V])));
        return H;
      }
      function t(M, $, W) {
        var H, V = function(K) {
          for (var ue = 0, de = H.length; ue < de; ) {
            if (H[ue]._name === K || H[ue].mn === K || H[ue].propertyIndex === K || H[ue].ix === K || H[ue].ind === K)
              return H[ue];
            ue += 1;
          }
          return typeof K == "number" ? H[K - 1] : null;
        };
        V.propertyGroup = propertyGroupFactory(V, W), H = e(M.it, $.it, V.propertyGroup), V.numProperties = H.length;
        var N = m(M.it[M.it.length - 1], $.it[$.it.length - 1], V.propertyGroup);
        return V.transform = N, V.propertyIndex = M.cix, V._name = M.nm, V;
      }
      function n(M, $, W) {
        var H = function(K) {
          switch (K) {
            case "ADBE Vectors Group":
            case "Contents":
            case 2:
              return H.content;
            default:
              return H.transform;
          }
        };
        H.propertyGroup = propertyGroupFactory(H, W);
        var V = t(M, $, H.propertyGroup), N = m(M.it[M.it.length - 1], $.it[$.it.length - 1], H.propertyGroup);
        return H.content = V, H.transform = N, Object.defineProperty(H, "_name", {
          get: function() {
            return M.nm;
          }
        }), H.numProperties = M.np, H.propertyIndex = M.ix, H.nm = M.nm, H.mn = M.mn, H;
      }
      function o(M, $, W) {
        function H(V) {
          return V === "Color" || V === "color" ? H.color : V === "Opacity" || V === "opacity" ? H.opacity : null;
        }
        return Object.defineProperties(H, {
          color: {
            get: ExpressionPropertyInterface($.c)
          },
          opacity: {
            get: ExpressionPropertyInterface($.o)
          },
          _name: {
            value: M.nm
          },
          mn: {
            value: M.mn
          }
        }), $.c.setGroupProperty(PropertyInterface("Color", W)), $.o.setGroupProperty(PropertyInterface("Opacity", W)), H;
      }
      function s(M, $, W) {
        function H(V) {
          return V === "Start Point" || V === "start point" ? H.startPoint : V === "End Point" || V === "end point" ? H.endPoint : V === "Opacity" || V === "opacity" ? H.opacity : null;
        }
        return Object.defineProperties(H, {
          startPoint: {
            get: ExpressionPropertyInterface($.s)
          },
          endPoint: {
            get: ExpressionPropertyInterface($.e)
          },
          opacity: {
            get: ExpressionPropertyInterface($.o)
          },
          type: {
            get: function() {
              return "a";
            }
          },
          _name: {
            value: M.nm
          },
          mn: {
            value: M.mn
          }
        }), $.s.setGroupProperty(PropertyInterface("Start Point", W)), $.e.setGroupProperty(PropertyInterface("End Point", W)), $.o.setGroupProperty(PropertyInterface("Opacity", W)), H;
      }
      function l() {
        function M() {
          return null;
        }
        return M;
      }
      function c(M, $, W) {
        var H = propertyGroupFactory(de, W), V = propertyGroupFactory(ue, H);
        function N(ve) {
          Object.defineProperty(ue, M.d[ve].nm, {
            get: ExpressionPropertyInterface($.d.dataProps[ve].p)
          });
        }
        var B, K = M.d ? M.d.length : 0, ue = {};
        for (B = 0; B < K; B += 1)
          N(B), $.d.dataProps[B].p.setGroupProperty(V);
        function de(ve) {
          return ve === "Color" || ve === "color" ? de.color : ve === "Opacity" || ve === "opacity" ? de.opacity : ve === "Stroke Width" || ve === "stroke width" ? de.strokeWidth : null;
        }
        return Object.defineProperties(de, {
          color: {
            get: ExpressionPropertyInterface($.c)
          },
          opacity: {
            get: ExpressionPropertyInterface($.o)
          },
          strokeWidth: {
            get: ExpressionPropertyInterface($.w)
          },
          dash: {
            get: function() {
              return ue;
            }
          },
          _name: {
            value: M.nm
          },
          mn: {
            value: M.mn
          }
        }), $.c.setGroupProperty(PropertyInterface("Color", H)), $.o.setGroupProperty(PropertyInterface("Opacity", H)), $.w.setGroupProperty(PropertyInterface("Stroke Width", H)), de;
      }
      function p(M, $, W) {
        function H(N) {
          return N === M.e.ix || N === "End" || N === "end" ? H.end : N === M.s.ix ? H.start : N === M.o.ix ? H.offset : null;
        }
        var V = propertyGroupFactory(H, W);
        return H.propertyIndex = M.ix, $.s.setGroupProperty(PropertyInterface("Start", V)), $.e.setGroupProperty(PropertyInterface("End", V)), $.o.setGroupProperty(PropertyInterface("Offset", V)), H.propertyIndex = M.ix, H.propertyGroup = W, Object.defineProperties(H, {
          start: {
            get: ExpressionPropertyInterface($.s)
          },
          end: {
            get: ExpressionPropertyInterface($.e)
          },
          offset: {
            get: ExpressionPropertyInterface($.o)
          },
          _name: {
            value: M.nm
          }
        }), H.mn = M.mn, H;
      }
      function m(M, $, W) {
        function H(N) {
          return M.a.ix === N || N === "Anchor Point" ? H.anchorPoint : M.o.ix === N || N === "Opacity" ? H.opacity : M.p.ix === N || N === "Position" ? H.position : M.r.ix === N || N === "Rotation" || N === "ADBE Vector Rotation" ? H.rotation : M.s.ix === N || N === "Scale" ? H.scale : M.sk && M.sk.ix === N || N === "Skew" ? H.skew : M.sa && M.sa.ix === N || N === "Skew Axis" ? H.skewAxis : null;
        }
        var V = propertyGroupFactory(H, W);
        return $.transform.mProps.o.setGroupProperty(PropertyInterface("Opacity", V)), $.transform.mProps.p.setGroupProperty(PropertyInterface("Position", V)), $.transform.mProps.a.setGroupProperty(PropertyInterface("Anchor Point", V)), $.transform.mProps.s.setGroupProperty(PropertyInterface("Scale", V)), $.transform.mProps.r.setGroupProperty(PropertyInterface("Rotation", V)), $.transform.mProps.sk && ($.transform.mProps.sk.setGroupProperty(PropertyInterface("Skew", V)), $.transform.mProps.sa.setGroupProperty(PropertyInterface("Skew Angle", V))), $.transform.op.setGroupProperty(PropertyInterface("Opacity", V)), Object.defineProperties(H, {
          opacity: {
            get: ExpressionPropertyInterface($.transform.mProps.o)
          },
          position: {
            get: ExpressionPropertyInterface($.transform.mProps.p)
          },
          anchorPoint: {
            get: ExpressionPropertyInterface($.transform.mProps.a)
          },
          scale: {
            get: ExpressionPropertyInterface($.transform.mProps.s)
          },
          rotation: {
            get: ExpressionPropertyInterface($.transform.mProps.r)
          },
          skew: {
            get: ExpressionPropertyInterface($.transform.mProps.sk)
          },
          skewAxis: {
            get: ExpressionPropertyInterface($.transform.mProps.sa)
          },
          _name: {
            value: M.nm
          }
        }), H.ty = "tr", H.mn = M.mn, H.propertyGroup = W, H;
      }
      function C(M, $, W) {
        function H(B) {
          return M.p.ix === B ? H.position : M.s.ix === B ? H.size : null;
        }
        var V = propertyGroupFactory(H, W);
        H.propertyIndex = M.ix;
        var N = $.sh.ty === "tm" ? $.sh.prop : $.sh;
        return N.s.setGroupProperty(PropertyInterface("Size", V)), N.p.setGroupProperty(PropertyInterface("Position", V)), Object.defineProperties(H, {
          size: {
            get: ExpressionPropertyInterface(N.s)
          },
          position: {
            get: ExpressionPropertyInterface(N.p)
          },
          _name: {
            value: M.nm
          }
        }), H.mn = M.mn, H;
      }
      function P(M, $, W) {
        function H(B) {
          return M.p.ix === B ? H.position : M.r.ix === B ? H.rotation : M.pt.ix === B ? H.points : M.or.ix === B || B === "ADBE Vector Star Outer Radius" ? H.outerRadius : M.os.ix === B ? H.outerRoundness : M.ir && (M.ir.ix === B || B === "ADBE Vector Star Inner Radius") ? H.innerRadius : M.is && M.is.ix === B ? H.innerRoundness : null;
        }
        var V = propertyGroupFactory(H, W), N = $.sh.ty === "tm" ? $.sh.prop : $.sh;
        return H.propertyIndex = M.ix, N.or.setGroupProperty(PropertyInterface("Outer Radius", V)), N.os.setGroupProperty(PropertyInterface("Outer Roundness", V)), N.pt.setGroupProperty(PropertyInterface("Points", V)), N.p.setGroupProperty(PropertyInterface("Position", V)), N.r.setGroupProperty(PropertyInterface("Rotation", V)), M.ir && (N.ir.setGroupProperty(PropertyInterface("Inner Radius", V)), N.is.setGroupProperty(PropertyInterface("Inner Roundness", V))), Object.defineProperties(H, {
          position: {
            get: ExpressionPropertyInterface(N.p)
          },
          rotation: {
            get: ExpressionPropertyInterface(N.r)
          },
          points: {
            get: ExpressionPropertyInterface(N.pt)
          },
          outerRadius: {
            get: ExpressionPropertyInterface(N.or)
          },
          outerRoundness: {
            get: ExpressionPropertyInterface(N.os)
          },
          innerRadius: {
            get: ExpressionPropertyInterface(N.ir)
          },
          innerRoundness: {
            get: ExpressionPropertyInterface(N.is)
          },
          _name: {
            value: M.nm
          }
        }), H.mn = M.mn, H;
      }
      function w(M, $, W) {
        function H(B) {
          return M.p.ix === B ? H.position : M.r.ix === B ? H.roundness : M.s.ix === B || B === "Size" || B === "ADBE Vector Rect Size" ? H.size : null;
        }
        var V = propertyGroupFactory(H, W), N = $.sh.ty === "tm" ? $.sh.prop : $.sh;
        return H.propertyIndex = M.ix, N.p.setGroupProperty(PropertyInterface("Position", V)), N.s.setGroupProperty(PropertyInterface("Size", V)), N.r.setGroupProperty(PropertyInterface("Rotation", V)), Object.defineProperties(H, {
          position: {
            get: ExpressionPropertyInterface(N.p)
          },
          roundness: {
            get: ExpressionPropertyInterface(N.r)
          },
          size: {
            get: ExpressionPropertyInterface(N.s)
          },
          _name: {
            value: M.nm
          }
        }), H.mn = M.mn, H;
      }
      function R(M, $, W) {
        function H(B) {
          return M.r.ix === B || B === "Round Corners 1" ? H.radius : null;
        }
        var V = propertyGroupFactory(H, W), N = $;
        return H.propertyIndex = M.ix, N.rd.setGroupProperty(PropertyInterface("Radius", V)), Object.defineProperties(H, {
          radius: {
            get: ExpressionPropertyInterface(N.rd)
          },
          _name: {
            value: M.nm
          }
        }), H.mn = M.mn, H;
      }
      function L(M, $, W) {
        function H(B) {
          return M.c.ix === B || B === "Copies" ? H.copies : M.o.ix === B || B === "Offset" ? H.offset : null;
        }
        var V = propertyGroupFactory(H, W), N = $;
        return H.propertyIndex = M.ix, N.c.setGroupProperty(PropertyInterface("Copies", V)), N.o.setGroupProperty(PropertyInterface("Offset", V)), Object.defineProperties(H, {
          copies: {
            get: ExpressionPropertyInterface(N.c)
          },
          offset: {
            get: ExpressionPropertyInterface(N.o)
          },
          _name: {
            value: M.nm
          }
        }), H.mn = M.mn, H;
      }
      return function(M, $, W) {
        var H;
        function V(B) {
          if (typeof B == "number")
            return B = B === void 0 ? 1 : B, B === 0 ? W : H[B - 1];
          for (var K = 0, ue = H.length; K < ue; ) {
            if (H[K]._name === B)
              return H[K];
            K += 1;
          }
          return null;
        }
        function N() {
          return W;
        }
        return V.propertyGroup = propertyGroupFactory(V, N), H = e(M, $, V.propertyGroup), V.numProperties = H.length, V._name = "Contents", V;
      };
    }(), TextExpressionInterface = function() {
      return function(e) {
        var t;
        function n(o) {
          switch (o) {
            case "ADBE Text Document":
              return n.sourceText;
            default:
              return null;
          }
        }
        return Object.defineProperty(n, "sourceText", {
          get: function() {
            e.textProperty.getValue();
            var s = e.textProperty.currentData.t;
            return (!t || s !== t.value) && (t = new String(s), t.value = s || new String(s), Object.defineProperty(t, "style", {
              get: function() {
                return {
                  fillColor: e.textProperty.currentData.fc
                };
              }
            })), t;
          }
        }), n;
      };
    }();
    function _typeof(e) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof = function(n) {
        return typeof n;
      } : _typeof = function(n) {
        return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      }, _typeof(e);
    }
    var FootageInterface = function() {
      var e = function(o) {
        var s = "", l = o.getFootageData();
        function c() {
          return s = "", l = o.getFootageData(), p;
        }
        function p(m) {
          if (l[m])
            return s = m, l = l[m], _typeof(l) === "object" ? p : l;
          var C = m.indexOf(s);
          if (C !== -1) {
            var P = parseInt(m.substr(C + s.length), 10);
            return l = l[P], _typeof(l) === "object" ? p : l;
          }
          return "";
        }
        return c;
      }, t = function(o) {
        function s(l) {
          return l === "Outline" ? s.outlineInterface() : null;
        }
        return s._name = "Outline", s.outlineInterface = e(o), s;
      };
      return function(n) {
        function o(s) {
          return s === "Data" ? o.dataInterface : null;
        }
        return o._name = "Data", o.dataInterface = t(n), o;
      };
    }(), interfaces = {
      layer: LayerExpressionInterface,
      effects: EffectsExpressionInterface,
      comp: CompExpressionInterface,
      shape: ShapeExpressionInterface,
      text: TextExpressionInterface,
      footage: FootageInterface
    };
    function getInterface(e) {
      return interfaces[e] || null;
    }
    var expressionHelpers = function() {
      function e(c, p, m) {
        p.x && (m.k = !0, m.x = !0, m.initiateExpression = ExpressionManager.initiateExpression, m.effectsSequence.push(m.initiateExpression(c, p, m).bind(m)));
      }
      function t(c) {
        return c *= this.elem.globalData.frameRate, c -= this.offsetTime, c !== this._cachingAtTime.lastFrame && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < c ? this._cachingAtTime.lastIndex : 0, this._cachingAtTime.value = this.interpolateValue(c, this._cachingAtTime), this._cachingAtTime.lastFrame = c), this._cachingAtTime.value;
      }
      function n(c) {
        var p = -0.01, m = this.getValueAtTime(c), C = this.getValueAtTime(c + p), P = 0;
        if (m.length) {
          var w;
          for (w = 0; w < m.length; w += 1)
            P += Math.pow(C[w] - m[w], 2);
          P = Math.sqrt(P) * 100;
        } else
          P = 0;
        return P;
      }
      function o(c) {
        if (this.vel !== void 0)
          return this.vel;
        var p = -1e-3, m = this.getValueAtTime(c), C = this.getValueAtTime(c + p), P;
        if (m.length) {
          P = createTypedArray("float32", m.length);
          var w;
          for (w = 0; w < m.length; w += 1)
            P[w] = (C[w] - m[w]) / p;
        } else
          P = (C - m) / p;
        return P;
      }
      function s() {
        return this.pv;
      }
      function l(c) {
        this.propertyGroup = c;
      }
      return {
        searchExpressions: e,
        getSpeedAtTime: n,
        getVelocityAtTime: o,
        getValueAtTime: t,
        getStaticValueAtTime: s,
        setGroupProperty: l
      };
    }();
    function addPropertyDecorator() {
      function e(R, L, M) {
        if (!this.k || !this.keyframes)
          return this.pv;
        R = R ? R.toLowerCase() : "";
        var $ = this.comp.renderedFrame, W = this.keyframes, H = W[W.length - 1].t;
        if ($ <= H)
          return this.pv;
        var V, N;
        M ? (L ? V = Math.abs(H - this.elem.comp.globalData.frameRate * L) : V = Math.max(0, H - this.elem.data.ip), N = H - V) : ((!L || L > W.length - 1) && (L = W.length - 1), N = W[W.length - 1 - L].t, V = H - N);
        var B, K, ue;
        if (R === "pingpong") {
          var de = Math.floor(($ - N) / V);
          if (de % 2 !== 0)
            return this.getValueAtTime((V - ($ - N) % V + N) / this.comp.globalData.frameRate, 0);
        } else if (R === "offset") {
          var ve = this.getValueAtTime(N / this.comp.globalData.frameRate, 0), Te = this.getValueAtTime(H / this.comp.globalData.frameRate, 0), Pe = this.getValueAtTime((($ - N) % V + N) / this.comp.globalData.frameRate, 0), Ce = Math.floor(($ - N) / V);
          if (this.pv.length) {
            for (ue = new Array(ve.length), K = ue.length, B = 0; B < K; B += 1)
              ue[B] = (Te[B] - ve[B]) * Ce + Pe[B];
            return ue;
          }
          return (Te - ve) * Ce + Pe;
        } else if (R === "continue") {
          var Re = this.getValueAtTime(H / this.comp.globalData.frameRate, 0), ke = this.getValueAtTime((H - 1e-3) / this.comp.globalData.frameRate, 0);
          if (this.pv.length) {
            for (ue = new Array(Re.length), K = ue.length, B = 0; B < K; B += 1)
              ue[B] = Re[B] + (Re[B] - ke[B]) * (($ - H) / this.comp.globalData.frameRate) / 5e-4;
            return ue;
          }
          return Re + (Re - ke) * (($ - H) / 1e-3);
        }
        return this.getValueAtTime((($ - N) % V + N) / this.comp.globalData.frameRate, 0);
      }
      function t(R, L, M) {
        if (!this.k)
          return this.pv;
        R = R ? R.toLowerCase() : "";
        var $ = this.comp.renderedFrame, W = this.keyframes, H = W[0].t;
        if ($ >= H)
          return this.pv;
        var V, N;
        M ? (L ? V = Math.abs(this.elem.comp.globalData.frameRate * L) : V = Math.max(0, this.elem.data.op - H), N = H + V) : ((!L || L > W.length - 1) && (L = W.length - 1), N = W[L].t, V = N - H);
        var B, K, ue;
        if (R === "pingpong") {
          var de = Math.floor((H - $) / V);
          if (de % 2 === 0)
            return this.getValueAtTime(((H - $) % V + H) / this.comp.globalData.frameRate, 0);
        } else if (R === "offset") {
          var ve = this.getValueAtTime(H / this.comp.globalData.frameRate, 0), Te = this.getValueAtTime(N / this.comp.globalData.frameRate, 0), Pe = this.getValueAtTime((V - (H - $) % V + H) / this.comp.globalData.frameRate, 0), Ce = Math.floor((H - $) / V) + 1;
          if (this.pv.length) {
            for (ue = new Array(ve.length), K = ue.length, B = 0; B < K; B += 1)
              ue[B] = Pe[B] - (Te[B] - ve[B]) * Ce;
            return ue;
          }
          return Pe - (Te - ve) * Ce;
        } else if (R === "continue") {
          var Re = this.getValueAtTime(H / this.comp.globalData.frameRate, 0), ke = this.getValueAtTime((H + 1e-3) / this.comp.globalData.frameRate, 0);
          if (this.pv.length) {
            for (ue = new Array(Re.length), K = ue.length, B = 0; B < K; B += 1)
              ue[B] = Re[B] + (Re[B] - ke[B]) * (H - $) / 1e-3;
            return ue;
          }
          return Re + (Re - ke) * (H - $) / 1e-3;
        }
        return this.getValueAtTime((V - ((H - $) % V + H)) / this.comp.globalData.frameRate, 0);
      }
      function n(R, L) {
        if (!this.k)
          return this.pv;
        if (R = (R || 0.4) * 0.5, L = Math.floor(L || 5), L <= 1)
          return this.pv;
        var M = this.comp.renderedFrame / this.comp.globalData.frameRate, $ = M - R, W = M + R, H = L > 1 ? (W - $) / (L - 1) : 1, V = 0, N = 0, B;
        this.pv.length ? B = createTypedArray("float32", this.pv.length) : B = 0;
        for (var K; V < L; ) {
          if (K = this.getValueAtTime($ + V * H), this.pv.length)
            for (N = 0; N < this.pv.length; N += 1)
              B[N] += K[N];
          else
            B += K;
          V += 1;
        }
        if (this.pv.length)
          for (N = 0; N < this.pv.length; N += 1)
            B[N] /= L;
        else
          B /= L;
        return B;
      }
      function o(R) {
        this._transformCachingAtTime || (this._transformCachingAtTime = {
          v: new Matrix()
        });
        var L = this._transformCachingAtTime.v;
        if (L.cloneFromProps(this.pre.props), this.appliedTransformations < 1) {
          var M = this.a.getValueAtTime(R);
          L.translate(-M[0] * this.a.mult, -M[1] * this.a.mult, M[2] * this.a.mult);
        }
        if (this.appliedTransformations < 2) {
          var $ = this.s.getValueAtTime(R);
          L.scale($[0] * this.s.mult, $[1] * this.s.mult, $[2] * this.s.mult);
        }
        if (this.sk && this.appliedTransformations < 3) {
          var W = this.sk.getValueAtTime(R), H = this.sa.getValueAtTime(R);
          L.skewFromAxis(-W * this.sk.mult, H * this.sa.mult);
        }
        if (this.r && this.appliedTransformations < 4) {
          var V = this.r.getValueAtTime(R);
          L.rotate(-V * this.r.mult);
        } else if (!this.r && this.appliedTransformations < 4) {
          var N = this.rz.getValueAtTime(R), B = this.ry.getValueAtTime(R), K = this.rx.getValueAtTime(R), ue = this.or.getValueAtTime(R);
          L.rotateZ(-N * this.rz.mult).rotateY(B * this.ry.mult).rotateX(K * this.rx.mult).rotateZ(-ue[2] * this.or.mult).rotateY(ue[1] * this.or.mult).rotateX(ue[0] * this.or.mult);
        }
        if (this.data.p && this.data.p.s) {
          var de = this.px.getValueAtTime(R), ve = this.py.getValueAtTime(R);
          if (this.data.p.z) {
            var Te = this.pz.getValueAtTime(R);
            L.translate(de * this.px.mult, ve * this.py.mult, -Te * this.pz.mult);
          } else
            L.translate(de * this.px.mult, ve * this.py.mult, 0);
        } else {
          var Pe = this.p.getValueAtTime(R);
          L.translate(Pe[0] * this.p.mult, Pe[1] * this.p.mult, -Pe[2] * this.p.mult);
        }
        return L;
      }
      function s() {
        return this.v.clone(new Matrix());
      }
      var l = TransformPropertyFactory.getTransformProperty;
      TransformPropertyFactory.getTransformProperty = function(R, L, M) {
        var $ = l(R, L, M);
        return $.dynamicProperties.length ? $.getValueAtTime = o.bind($) : $.getValueAtTime = s.bind($), $.setGroupProperty = expressionHelpers.setGroupProperty, $;
      };
      var c = PropertyFactory.getProp;
      PropertyFactory.getProp = function(R, L, M, $, W) {
        var H = c(R, L, M, $, W);
        H.kf ? H.getValueAtTime = expressionHelpers.getValueAtTime.bind(H) : H.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(H), H.setGroupProperty = expressionHelpers.setGroupProperty, H.loopOut = e, H.loopIn = t, H.smooth = n, H.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(H), H.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(H), H.numKeys = L.a === 1 ? L.k.length : 0, H.propertyIndex = L.ix;
        var V = 0;
        return M !== 0 && (V = createTypedArray("float32", L.a === 1 ? L.k[0].s.length : L.k.length)), H._cachingAtTime = {
          lastFrame: initialDefaultFrame,
          lastIndex: 0,
          value: V
        }, expressionHelpers.searchExpressions(R, L, H), H.k && W.addDynamicProperty(H), H;
      };
      function p(R) {
        return this._cachingAtTime || (this._cachingAtTime = {
          shapeValue: shapePool.clone(this.pv),
          lastIndex: 0,
          lastTime: initialDefaultFrame
        }), R *= this.elem.globalData.frameRate, R -= this.offsetTime, R !== this._cachingAtTime.lastTime && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < R ? this._caching.lastIndex : 0, this._cachingAtTime.lastTime = R, this.interpolateShape(R, this._cachingAtTime.shapeValue, this._cachingAtTime)), this._cachingAtTime.shapeValue;
      }
      var m = ShapePropertyFactory.getConstructorFunction(), C = ShapePropertyFactory.getKeyframedConstructorFunction();
      function P() {
      }
      P.prototype = {
        vertices: function(L, M) {
          this.k && this.getValue();
          var $ = this.v;
          M !== void 0 && ($ = this.getValueAtTime(M, 0));
          var W, H = $._length, V = $[L], N = $.v, B = createSizedArray(H);
          for (W = 0; W < H; W += 1)
            L === "i" || L === "o" ? B[W] = [V[W][0] - N[W][0], V[W][1] - N[W][1]] : B[W] = [V[W][0], V[W][1]];
          return B;
        },
        points: function(L) {
          return this.vertices("v", L);
        },
        inTangents: function(L) {
          return this.vertices("i", L);
        },
        outTangents: function(L) {
          return this.vertices("o", L);
        },
        isClosed: function() {
          return this.v.c;
        },
        pointOnPath: function(L, M) {
          var $ = this.v;
          M !== void 0 && ($ = this.getValueAtTime(M, 0)), this._segmentsLength || (this._segmentsLength = bez.getSegmentsLength($));
          for (var W = this._segmentsLength, H = W.lengths, V = W.totalLength * L, N = 0, B = H.length, K = 0, ue; N < B; ) {
            if (K + H[N].addedLength > V) {
              var de = N, ve = $.c && N === B - 1 ? 0 : N + 1, Te = (V - K) / H[N].addedLength;
              ue = bez.getPointInSegment($.v[de], $.v[ve], $.o[de], $.i[ve], Te, H[N]);
              break;
            } else
              K += H[N].addedLength;
            N += 1;
          }
          return ue || (ue = $.c ? [$.v[0][0], $.v[0][1]] : [$.v[$._length - 1][0], $.v[$._length - 1][1]]), ue;
        },
        vectorOnPath: function(L, M, $) {
          L == 1 ? L = this.v.c : L == 0 && (L = 0.999);
          var W = this.pointOnPath(L, M), H = this.pointOnPath(L + 1e-3, M), V = H[0] - W[0], N = H[1] - W[1], B = Math.sqrt(Math.pow(V, 2) + Math.pow(N, 2));
          if (B === 0)
            return [0, 0];
          var K = $ === "tangent" ? [V / B, N / B] : [-N / B, V / B];
          return K;
        },
        tangentOnPath: function(L, M) {
          return this.vectorOnPath(L, M, "tangent");
        },
        normalOnPath: function(L, M) {
          return this.vectorOnPath(L, M, "normal");
        },
        setGroupProperty: expressionHelpers.setGroupProperty,
        getValueAtTime: expressionHelpers.getStaticValueAtTime
      }, extendPrototype([P], m), extendPrototype([P], C), C.prototype.getValueAtTime = p, C.prototype.initiateExpression = ExpressionManager.initiateExpression;
      var w = ShapePropertyFactory.getShapeProp;
      ShapePropertyFactory.getShapeProp = function(R, L, M, $, W) {
        var H = w(R, L, M, $, W);
        return H.propertyIndex = L.ix, H.lock = !1, M === 3 ? expressionHelpers.searchExpressions(R, L.pt, H) : M === 4 && expressionHelpers.searchExpressions(R, L.ks, H), H.k && R.addDynamicProperty(H), H;
      };
    }
    function initialize$1() {
      addPropertyDecorator();
    }
    function addDecorator() {
      function e() {
        return this.data.d.x ? (this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this), this.addEffect(this.getExpressionValue.bind(this)), !0) : null;
      }
      TextProperty.prototype.getExpressionValue = function(t, n) {
        var o = this.calculateExpression(n);
        if (t.t !== o) {
          var s = {};
          return this.copyData(s, t), s.t = o.toString(), s.__complete = !1, s;
        }
        return t;
      }, TextProperty.prototype.searchProperty = function() {
        var t = this.searchKeyframes(), n = this.searchExpressions();
        return this.kf = t || n, this.kf;
      }, TextProperty.prototype.searchExpressions = e;
    }
    function initialize() {
      addDecorator();
    }
    function SVGComposableEffect() {
    }
    SVGComposableEffect.prototype = {
      createMergeNode: function e(t, n) {
        var o = createNS("feMerge");
        o.setAttribute("result", t);
        var s, l;
        for (l = 0; l < n.length; l += 1)
          s = createNS("feMergeNode"), s.setAttribute("in", n[l]), o.appendChild(s), o.appendChild(s);
        return o;
      }
    };
    var linearFilterValue = "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0";
    function SVGTintFilter(e, t, n, o, s) {
      this.filterManager = t;
      var l = createNS("feColorMatrix");
      l.setAttribute("type", "matrix"), l.setAttribute("color-interpolation-filters", "linearRGB"), l.setAttribute("values", linearFilterValue + " 1 0"), this.linearFilter = l, l.setAttribute("result", o + "_tint_1"), e.appendChild(l), l = createNS("feColorMatrix"), l.setAttribute("type", "matrix"), l.setAttribute("color-interpolation-filters", "sRGB"), l.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), l.setAttribute("result", o + "_tint_2"), e.appendChild(l), this.matrixFilter = l;
      var c = this.createMergeNode(o, [s, o + "_tint_1", o + "_tint_2"]);
      e.appendChild(c);
    }
    extendPrototype([SVGComposableEffect], SVGTintFilter), SVGTintFilter.prototype.renderFrame = function(e) {
      if (e || this.filterManager._mdf) {
        var t = this.filterManager.effectElements[0].p.v, n = this.filterManager.effectElements[1].p.v, o = this.filterManager.effectElements[2].p.v / 100;
        this.linearFilter.setAttribute("values", linearFilterValue + " " + o + " 0"), this.matrixFilter.setAttribute("values", n[0] - t[0] + " 0 0 0 " + t[0] + " " + (n[1] - t[1]) + " 0 0 0 " + t[1] + " " + (n[2] - t[2]) + " 0 0 0 " + t[2] + " 0 0 0 1 0");
      }
    };
    function SVGFillFilter(e, t, n, o) {
      this.filterManager = t;
      var s = createNS("feColorMatrix");
      s.setAttribute("type", "matrix"), s.setAttribute("color-interpolation-filters", "sRGB"), s.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), s.setAttribute("result", o), e.appendChild(s), this.matrixFilter = s;
    }
    SVGFillFilter.prototype.renderFrame = function(e) {
      if (e || this.filterManager._mdf) {
        var t = this.filterManager.effectElements[2].p.v, n = this.filterManager.effectElements[6].p.v;
        this.matrixFilter.setAttribute("values", "0 0 0 0 " + t[0] + " 0 0 0 0 " + t[1] + " 0 0 0 0 " + t[2] + " 0 0 0 " + n + " 0");
      }
    };
    function SVGStrokeEffect(e, t, n) {
      this.initialized = !1, this.filterManager = t, this.elem = n, this.paths = [];
    }
    SVGStrokeEffect.prototype.initialize = function() {
      var e = this.elem.layerElement.children || this.elem.layerElement.childNodes, t, n, o, s;
      for (this.filterManager.effectElements[1].p.v === 1 ? (s = this.elem.maskManager.masksProperties.length, o = 0) : (o = this.filterManager.effectElements[0].p.v - 1, s = o + 1), n = createNS("g"), n.setAttribute("fill", "none"), n.setAttribute("stroke-linecap", "round"), n.setAttribute("stroke-dashoffset", 1), o; o < s; o += 1)
        t = createNS("path"), n.appendChild(t), this.paths.push({
          p: t,
          m: o
        });
      if (this.filterManager.effectElements[10].p.v === 3) {
        var l = createNS("mask"), c = createElementID();
        l.setAttribute("id", c), l.setAttribute("mask-type", "alpha"), l.appendChild(n), this.elem.globalData.defs.appendChild(l);
        var p = createNS("g");
        for (p.setAttribute("mask", "url(" + getLocationHref() + "#" + c + ")"); e[0]; )
          p.appendChild(e[0]);
        this.elem.layerElement.appendChild(p), this.masker = l, n.setAttribute("stroke", "#fff");
      } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
        if (this.filterManager.effectElements[10].p.v === 2)
          for (e = this.elem.layerElement.children || this.elem.layerElement.childNodes; e.length; )
            this.elem.layerElement.removeChild(e[0]);
        this.elem.layerElement.appendChild(n), this.elem.layerElement.removeAttribute("mask"), n.setAttribute("stroke", "#fff");
      }
      this.initialized = !0, this.pathMasker = n;
    }, SVGStrokeEffect.prototype.renderFrame = function(e) {
      this.initialized || this.initialize();
      var t, n = this.paths.length, o, s;
      for (t = 0; t < n; t += 1)
        if (this.paths[t].m !== -1 && (o = this.elem.maskManager.viewData[this.paths[t].m], s = this.paths[t].p, (e || this.filterManager._mdf || o.prop._mdf) && s.setAttribute("d", o.lastPath), e || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || o.prop._mdf)) {
          var l;
          if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
            var c = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01, p = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01, m = s.getTotalLength();
            l = "0 0 0 " + m * c + " ";
            var C = m * (p - c), P = 1 + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01, w = Math.floor(C / P), R;
            for (R = 0; R < w; R += 1)
              l += "1 " + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01 + " ";
            l += "0 " + m * 10 + " 0 0";
          } else
            l = "1 " + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
          s.setAttribute("stroke-dasharray", l);
        }
      if ((e || this.filterManager.effectElements[4].p._mdf) && this.pathMasker.setAttribute("stroke-width", this.filterManager.effectElements[4].p.v * 2), (e || this.filterManager.effectElements[6].p._mdf) && this.pathMasker.setAttribute("opacity", this.filterManager.effectElements[6].p.v), (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) && (e || this.filterManager.effectElements[3].p._mdf)) {
        var L = this.filterManager.effectElements[3].p.v;
        this.pathMasker.setAttribute("stroke", "rgb(" + bmFloor(L[0] * 255) + "," + bmFloor(L[1] * 255) + "," + bmFloor(L[2] * 255) + ")");
      }
    };
    function SVGTritoneFilter(e, t, n, o) {
      this.filterManager = t;
      var s = createNS("feColorMatrix");
      s.setAttribute("type", "matrix"), s.setAttribute("color-interpolation-filters", "linearRGB"), s.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"), e.appendChild(s);
      var l = createNS("feComponentTransfer");
      l.setAttribute("color-interpolation-filters", "sRGB"), l.setAttribute("result", o), this.matrixFilter = l;
      var c = createNS("feFuncR");
      c.setAttribute("type", "table"), l.appendChild(c), this.feFuncR = c;
      var p = createNS("feFuncG");
      p.setAttribute("type", "table"), l.appendChild(p), this.feFuncG = p;
      var m = createNS("feFuncB");
      m.setAttribute("type", "table"), l.appendChild(m), this.feFuncB = m, e.appendChild(l);
    }
    SVGTritoneFilter.prototype.renderFrame = function(e) {
      if (e || this.filterManager._mdf) {
        var t = this.filterManager.effectElements[0].p.v, n = this.filterManager.effectElements[1].p.v, o = this.filterManager.effectElements[2].p.v, s = o[0] + " " + n[0] + " " + t[0], l = o[1] + " " + n[1] + " " + t[1], c = o[2] + " " + n[2] + " " + t[2];
        this.feFuncR.setAttribute("tableValues", s), this.feFuncG.setAttribute("tableValues", l), this.feFuncB.setAttribute("tableValues", c);
      }
    };
    function SVGProLevelsFilter(e, t, n, o) {
      this.filterManager = t;
      var s = this.filterManager.effectElements, l = createNS("feComponentTransfer");
      (s[10].p.k || s[10].p.v !== 0 || s[11].p.k || s[11].p.v !== 1 || s[12].p.k || s[12].p.v !== 1 || s[13].p.k || s[13].p.v !== 0 || s[14].p.k || s[14].p.v !== 1) && (this.feFuncR = this.createFeFunc("feFuncR", l)), (s[17].p.k || s[17].p.v !== 0 || s[18].p.k || s[18].p.v !== 1 || s[19].p.k || s[19].p.v !== 1 || s[20].p.k || s[20].p.v !== 0 || s[21].p.k || s[21].p.v !== 1) && (this.feFuncG = this.createFeFunc("feFuncG", l)), (s[24].p.k || s[24].p.v !== 0 || s[25].p.k || s[25].p.v !== 1 || s[26].p.k || s[26].p.v !== 1 || s[27].p.k || s[27].p.v !== 0 || s[28].p.k || s[28].p.v !== 1) && (this.feFuncB = this.createFeFunc("feFuncB", l)), (s[31].p.k || s[31].p.v !== 0 || s[32].p.k || s[32].p.v !== 1 || s[33].p.k || s[33].p.v !== 1 || s[34].p.k || s[34].p.v !== 0 || s[35].p.k || s[35].p.v !== 1) && (this.feFuncA = this.createFeFunc("feFuncA", l)), (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) && (l.setAttribute("color-interpolation-filters", "sRGB"), e.appendChild(l)), (s[3].p.k || s[3].p.v !== 0 || s[4].p.k || s[4].p.v !== 1 || s[5].p.k || s[5].p.v !== 1 || s[6].p.k || s[6].p.v !== 0 || s[7].p.k || s[7].p.v !== 1) && (l = createNS("feComponentTransfer"), l.setAttribute("color-interpolation-filters", "sRGB"), l.setAttribute("result", o), e.appendChild(l), this.feFuncRComposed = this.createFeFunc("feFuncR", l), this.feFuncGComposed = this.createFeFunc("feFuncG", l), this.feFuncBComposed = this.createFeFunc("feFuncB", l));
    }
    SVGProLevelsFilter.prototype.createFeFunc = function(e, t) {
      var n = createNS(e);
      return n.setAttribute("type", "table"), t.appendChild(n), n;
    }, SVGProLevelsFilter.prototype.getTableValue = function(e, t, n, o, s) {
      for (var l = 0, c = 256, p, m = Math.min(e, t), C = Math.max(e, t), P = Array.call(null, {
        length: c
      }), w, R = 0, L = s - o, M = t - e; l <= 256; )
        p = l / 256, p <= m ? w = M < 0 ? s : o : p >= C ? w = M < 0 ? o : s : w = o + L * Math.pow((p - e) / M, 1 / n), P[R] = w, R += 1, l += 256 / (c - 1);
      return P.join(" ");
    }, SVGProLevelsFilter.prototype.renderFrame = function(e) {
      if (e || this.filterManager._mdf) {
        var t, n = this.filterManager.effectElements;
        this.feFuncRComposed && (e || n[3].p._mdf || n[4].p._mdf || n[5].p._mdf || n[6].p._mdf || n[7].p._mdf) && (t = this.getTableValue(n[3].p.v, n[4].p.v, n[5].p.v, n[6].p.v, n[7].p.v), this.feFuncRComposed.setAttribute("tableValues", t), this.feFuncGComposed.setAttribute("tableValues", t), this.feFuncBComposed.setAttribute("tableValues", t)), this.feFuncR && (e || n[10].p._mdf || n[11].p._mdf || n[12].p._mdf || n[13].p._mdf || n[14].p._mdf) && (t = this.getTableValue(n[10].p.v, n[11].p.v, n[12].p.v, n[13].p.v, n[14].p.v), this.feFuncR.setAttribute("tableValues", t)), this.feFuncG && (e || n[17].p._mdf || n[18].p._mdf || n[19].p._mdf || n[20].p._mdf || n[21].p._mdf) && (t = this.getTableValue(n[17].p.v, n[18].p.v, n[19].p.v, n[20].p.v, n[21].p.v), this.feFuncG.setAttribute("tableValues", t)), this.feFuncB && (e || n[24].p._mdf || n[25].p._mdf || n[26].p._mdf || n[27].p._mdf || n[28].p._mdf) && (t = this.getTableValue(n[24].p.v, n[25].p.v, n[26].p.v, n[27].p.v, n[28].p.v), this.feFuncB.setAttribute("tableValues", t)), this.feFuncA && (e || n[31].p._mdf || n[32].p._mdf || n[33].p._mdf || n[34].p._mdf || n[35].p._mdf) && (t = this.getTableValue(n[31].p.v, n[32].p.v, n[33].p.v, n[34].p.v, n[35].p.v), this.feFuncA.setAttribute("tableValues", t));
      }
    };
    function SVGDropShadowEffect(e, t, n, o, s) {
      var l = t.container.globalData.renderConfig.filterSize, c = t.data.fs || l;
      e.setAttribute("x", c.x || l.x), e.setAttribute("y", c.y || l.y), e.setAttribute("width", c.width || l.width), e.setAttribute("height", c.height || l.height), this.filterManager = t;
      var p = createNS("feGaussianBlur");
      p.setAttribute("in", "SourceAlpha"), p.setAttribute("result", o + "_drop_shadow_1"), p.setAttribute("stdDeviation", "0"), this.feGaussianBlur = p, e.appendChild(p);
      var m = createNS("feOffset");
      m.setAttribute("dx", "25"), m.setAttribute("dy", "0"), m.setAttribute("in", o + "_drop_shadow_1"), m.setAttribute("result", o + "_drop_shadow_2"), this.feOffset = m, e.appendChild(m);
      var C = createNS("feFlood");
      C.setAttribute("flood-color", "#00ff00"), C.setAttribute("flood-opacity", "1"), C.setAttribute("result", o + "_drop_shadow_3"), this.feFlood = C, e.appendChild(C);
      var P = createNS("feComposite");
      P.setAttribute("in", o + "_drop_shadow_3"), P.setAttribute("in2", o + "_drop_shadow_2"), P.setAttribute("operator", "in"), P.setAttribute("result", o + "_drop_shadow_4"), e.appendChild(P);
      var w = this.createMergeNode(o, [o + "_drop_shadow_4", s]);
      e.appendChild(w);
    }
    extendPrototype([SVGComposableEffect], SVGDropShadowEffect), SVGDropShadowEffect.prototype.renderFrame = function(e) {
      if (e || this.filterManager._mdf) {
        if ((e || this.filterManager.effectElements[4].p._mdf) && this.feGaussianBlur.setAttribute("stdDeviation", this.filterManager.effectElements[4].p.v / 4), e || this.filterManager.effectElements[0].p._mdf) {
          var t = this.filterManager.effectElements[0].p.v;
          this.feFlood.setAttribute("flood-color", rgbToHex(Math.round(t[0] * 255), Math.round(t[1] * 255), Math.round(t[2] * 255)));
        }
        if ((e || this.filterManager.effectElements[1].p._mdf) && this.feFlood.setAttribute("flood-opacity", this.filterManager.effectElements[1].p.v / 255), e || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
          var n = this.filterManager.effectElements[3].p.v, o = (this.filterManager.effectElements[2].p.v - 90) * degToRads, s = n * Math.cos(o), l = n * Math.sin(o);
          this.feOffset.setAttribute("dx", s), this.feOffset.setAttribute("dy", l);
        }
      }
    };
    var _svgMatteSymbols = [];
    function SVGMatte3Effect(e, t, n) {
      this.initialized = !1, this.filterManager = t, this.filterElem = e, this.elem = n, n.matteElement = createNS("g"), n.matteElement.appendChild(n.layerElement), n.matteElement.appendChild(n.transformedElement), n.baseElement = n.matteElement;
    }
    SVGMatte3Effect.prototype.findSymbol = function(e) {
      for (var t = 0, n = _svgMatteSymbols.length; t < n; ) {
        if (_svgMatteSymbols[t] === e)
          return _svgMatteSymbols[t];
        t += 1;
      }
      return null;
    }, SVGMatte3Effect.prototype.replaceInParent = function(e, t) {
      var n = e.layerElement.parentNode;
      if (n) {
        for (var o = n.children, s = 0, l = o.length; s < l && o[s] !== e.layerElement; )
          s += 1;
        var c;
        s <= l - 2 && (c = o[s + 1]);
        var p = createNS("use");
        p.setAttribute("href", "#" + t), c ? n.insertBefore(p, c) : n.appendChild(p);
      }
    }, SVGMatte3Effect.prototype.setElementAsMask = function(e, t) {
      if (!this.findSymbol(t)) {
        var n = createElementID(), o = createNS("mask");
        o.setAttribute("id", t.layerId), o.setAttribute("mask-type", "alpha"), _svgMatteSymbols.push(t);
        var s = e.globalData.defs;
        s.appendChild(o);
        var l = createNS("symbol");
        l.setAttribute("id", n), this.replaceInParent(t, n), l.appendChild(t.layerElement), s.appendChild(l);
        var c = createNS("use");
        c.setAttribute("href", "#" + n), o.appendChild(c), t.data.hd = !1, t.show();
      }
      e.setMatte(t.layerId);
    }, SVGMatte3Effect.prototype.initialize = function() {
      for (var e = this.filterManager.effectElements[0].p.v, t = this.elem.comp.elements, n = 0, o = t.length; n < o; )
        t[n] && t[n].data.ind === e && this.setElementAsMask(this.elem, t[n]), n += 1;
      this.initialized = !0;
    }, SVGMatte3Effect.prototype.renderFrame = function() {
      this.initialized || this.initialize();
    };
    function SVGGaussianBlurEffect(e, t, n, o) {
      e.setAttribute("x", "-100%"), e.setAttribute("y", "-100%"), e.setAttribute("width", "300%"), e.setAttribute("height", "300%"), this.filterManager = t;
      var s = createNS("feGaussianBlur");
      s.setAttribute("result", o), e.appendChild(s), this.feGaussianBlur = s;
    }
    SVGGaussianBlurEffect.prototype.renderFrame = function(e) {
      if (e || this.filterManager._mdf) {
        var t = 0.3, n = this.filterManager.effectElements[0].p.v * t, o = this.filterManager.effectElements[1].p.v, s = o == 3 ? 0 : n, l = o == 2 ? 0 : n;
        this.feGaussianBlur.setAttribute("stdDeviation", s + " " + l);
        var c = this.filterManager.effectElements[2].p.v == 1 ? "wrap" : "duplicate";
        this.feGaussianBlur.setAttribute("edgeMode", c);
      }
    };
    function TransformEffect() {
    }
    TransformEffect.prototype.init = function(e) {
      this.effectsManager = e, this.type = effectTypes.TRANSFORM_EFFECT, this.matrix = new Matrix(), this.opacity = -1, this._mdf = !1, this._opMdf = !1;
    }, TransformEffect.prototype.renderFrame = function(e) {
      if (this._opMdf = !1, this._mdf = !1, e || this.effectsManager._mdf) {
        var t = this.effectsManager.effectElements, n = t[0].p.v, o = t[1].p.v, s = t[2].p.v === 1, l = t[3].p.v, c = s ? l : t[4].p.v, p = t[5].p.v, m = t[6].p.v, C = t[7].p.v;
        this.matrix.reset(), this.matrix.translate(-n[0], -n[1], n[2]), this.matrix.scale(c * 0.01, l * 0.01, 1), this.matrix.rotate(-C * degToRads), this.matrix.skewFromAxis(-p * degToRads, (m + 90) * degToRads), this.matrix.translate(o[0], o[1], 0), this._mdf = !0, this.opacity !== t[8].p.v && (this.opacity = t[8].p.v, this._opMdf = !0);
      }
    };
    function SVGTransformEffect(e, t) {
      this.init(t);
    }
    extendPrototype([TransformEffect], SVGTransformEffect);
    function CVTransformEffect(e) {
      this.init(e);
    }
    return extendPrototype([TransformEffect], CVTransformEffect), registerRenderer("canvas", CanvasRenderer), registerRenderer("html", HybridRenderer), registerRenderer("svg", SVGRenderer), ShapeModifiers.registerModifier("tm", TrimModifier), ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier), ShapeModifiers.registerModifier("rp", RepeaterModifier), ShapeModifiers.registerModifier("rd", RoundCornersModifier), ShapeModifiers.registerModifier("zz", ZigZagModifier), ShapeModifiers.registerModifier("op", OffsetPathModifier), setExpressionsPlugin(Expressions), setExpressionInterfaces(getInterface), initialize$1(), initialize(), registerEffect$1(20, SVGTintFilter, !0), registerEffect$1(21, SVGFillFilter, !0), registerEffect$1(22, SVGStrokeEffect, !1), registerEffect$1(23, SVGTritoneFilter, !0), registerEffect$1(24, SVGProLevelsFilter, !0), registerEffect$1(25, SVGDropShadowEffect, !0), registerEffect$1(28, SVGMatte3Effect, !1), registerEffect$1(29, SVGGaussianBlurEffect, !0), registerEffect$1(35, SVGTransformEffect, !1), registerEffect(35, CVTransformEffect), lottie;
  });
})(lottie$1, lottie$1.exports);
var lottieExports = lottie$1.exports;
const lottie = /* @__PURE__ */ getDefaultExportFromCjs(lottieExports), NCLottieAnimation$1 = "", NCLottieAnimation = (e) => {
  const t = React__default.createRef(), n = 0, o = 30;
  return useEffect(() => {
    if (!t.current)
      return;
    const s = lottie.loadAnimation({
      container: t.current,
      renderer: "svg",
      loop: !1,
      autoplay: !1,
      path: e.lottieUrl
    }), l = (p) => {
      const m = window.scrollY, P = (s.totalFrames - n - o) / 100 * (m / (p / 100));
      s.goToAndStop(n + P, !0);
    }, c = () => {
      l(e.animationDuration);
    };
    return document.addEventListener("scroll", c), () => {
      s.destroy(), document.removeEventListener("scroll", c);
    };
  }, [t.current]), /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "nc-lottie-animation", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { height: e.animationDuration + 500 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "animation", style: { top: e.marginTop ? e.marginTop : 0 }, ref: t }) }) });
};
class FormattedDateTime {
  constructor(t = "", n = "") {
    this.date = t, this.time = n;
  }
}
function formatDateTime(e, t) {
  const n = new Date(e), o = {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit"
  }, s = {
    timeStyle: "short"
  }, l = n.toLocaleDateString(
    t || "default",
    o
  ), c = n.toLocaleTimeString([], s);
  return { date: l, time: c };
}
function getTimeFromMinutes(e, t = "HH:mm") {
  if (e < 0 || e > 24 * 60)
    throw new Error();
  return hooks.utc().hours(e / 60 | 0).minutes(e % 60 | 0).format(t);
}
function getMinutesFromTime(e, t = "HH:mm") {
  const n = hooks(e, t);
  return n.hours() * 60 + n.minute();
}
const NCMatchPaused$1 = "", NCMatchPaused = (e) => {
  const { round: t, date: n } = e, o = useIntl(), s = formatDateTime(n);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "nc-match-paused-container", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "nc-match-header-container", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "nc-match-stage", children: o.formatMessage({ id: `${t}` }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "nc-copy-match-id clickable", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Icon,
          {
            icon: IconType.Copy,
            width: 16,
            height: 16,
            styleName: "nc-copy-match-paused-id-icon"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: o.formatMessage({ id: "bracket.match-details.copy-match-id" }) })
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "nc-scheduled-date-container", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "nc-match-scheduled-date", children: s.date }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        NCCountdown,
        {
          datetime: n,
          text: o.formatMessage({ id: "tournament.match.paused.countdown" })
        }
      )
    ] })
  ] }) });
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign$3 = function() {
  return __assign$3 = Object.assign || function(t) {
    for (var n, o = 1, s = arguments.length; o < s; o++) {
      n = arguments[o];
      for (var l in n)
        Object.prototype.hasOwnProperty.call(n, l) && (t[l] = n[l]);
    }
    return t;
  }, __assign$3.apply(this, arguments);
};
function __rest(e, t) {
  var n = {};
  for (var o in e)
    Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var s = 0, o = Object.getOwnPropertySymbols(e); s < o.length; s++)
      t.indexOf(o[s]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[s]) && (n[o[s]] = e[o[s]]);
  return n;
}
var hashFragment = "", observer = null, asyncTimerId = null, scrollFunction = null;
function reset() {
  hashFragment = "", observer !== null && observer.disconnect(), asyncTimerId !== null && (window.clearTimeout(asyncTimerId), asyncTimerId = null);
}
function isInteractiveElement(e) {
  var t = ["BUTTON", "INPUT", "SELECT", "TEXTAREA"], n = ["A", "AREA"];
  return t.includes(e.tagName) && !e.hasAttribute("disabled") || n.includes(e.tagName) && e.hasAttribute("href");
}
function getElAndScroll() {
  var e = null;
  if (hashFragment === "#")
    e = document.body;
  else {
    var t = hashFragment.replace("#", "");
    e = document.getElementById(t), e === null && hashFragment === "#top" && (e = document.body);
  }
  if (e !== null) {
    scrollFunction(e);
    var n = e.getAttribute("tabindex");
    return n === null && !isInteractiveElement(e) && e.setAttribute("tabindex", -1), e.focus({ preventScroll: !0 }), n === null && !isInteractiveElement(e) && (e.blur(), e.removeAttribute("tabindex")), reset(), !0;
  }
  return !1;
}
function hashLinkScroll(e) {
  window.setTimeout(function() {
    getElAndScroll() === !1 && (observer === null && (observer = new MutationObserver(getElAndScroll)), observer.observe(document, {
      attributes: !0,
      childList: !0,
      subtree: !0
    }), asyncTimerId = window.setTimeout(function() {
      reset();
    }, e || 1e4));
  }, 0);
}
function genericHashLink(e) {
  return React__default.forwardRef(function(t, n) {
    var o = "";
    typeof t.to == "string" && t.to.includes("#") ? o = "#" + t.to.split("#").slice(1).join("#") : typeof t.to == "object" && typeof t.to.hash == "string" && (o = t.to.hash);
    var s = {};
    e === NavLink && (s.isActive = function(p, m) {
      return p && p.isExact && m.hash === o;
    });
    function l(p) {
      reset(), hashFragment = t.elementId ? "#" + t.elementId : o, t.onClick && t.onClick(p), hashFragment !== "" && // ignore non-vanilla click events, same as react-router
      // below logic adapted from react-router: https://github.com/ReactTraining/react-router/blob/fc91700e08df8147bd2bb1be19a299cbb14dbcaa/packages/react-router-dom/modules/Link.js#L43-L48
      !p.defaultPrevented && // onClick prevented default
      p.button === 0 && // ignore everything but left clicks
      (!t.target || t.target === "_self") && // let browser handle "target=_blank" etc
      !(p.metaKey || p.altKey || p.ctrlKey || p.shiftKey) && (scrollFunction = t.scroll || function(m) {
        return t.smooth ? m.scrollIntoView({ behavior: "smooth" }) : m.scrollIntoView();
      }, hashLinkScroll(t.timeout));
    }
    var c = __rest(t, ["scroll", "smooth", "timeout", "elementId"]);
    return React__default.createElement(e, __assign$3({}, s, c, { onClick: l, ref: n }), t.children);
  });
}
var HashLink = genericHashLink(Link), NavHashLink = genericHashLink(NavLink);
if (process.env.NODE_ENV !== "production") {
  HashLink.displayName = "HashLink", NavHashLink.displayName = "NavHashLink";
  var propTypes = {
    onClick: PropTypes.func,
    children: PropTypes.node,
    scroll: PropTypes.func,
    timeout: PropTypes.number,
    elementId: PropTypes.string,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  };
  HashLink.propTypes = propTypes, NavHashLink.propTypes = propTypes;
}
const NCMenuAuth$1 = "", NCMenuAuth = (e) => {
  const t = useIntl(), n = () => {
    e.onAction && e.onAction();
  }, o = () => {
    e.onOpenDashboard && (n(), e.onOpenDashboard());
  }, s = () => {
    e.onLogout && (n(), e.onLogout());
  }, l = e.dropdownMenuItems ? e.dropdownMenuItems : [
    {
      name: t.formatMessage({ id: "ds.nc-menu-auth.dashboard" }),
      onClick: o
    },
    {
      name: t.formatMessage({ id: "ds.nc-menu-auth.logout" }),
      onClick: s,
      className: "logout"
    }
  ], c = () => {
    if (!e.user)
      return e.platformMenu ? /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Button$1,
          {
            label: t.formatMessage({ id: "ds.nc-menu-auth.login" }),
            setClick: () => {
              e.onEvent && e.onEvent("login");
            },
            type: ButtonType.SECONDARY,
            styleClass: "border-0"
          }
        ),
        !e.isSideMenu && /* @__PURE__ */ jsxRuntimeExports.jsx(
          Button$1,
          {
            containerClass: "ml-2",
            label: t.formatMessage({ id: "ds.nc-menu-auth.register" }),
            setClick: () => {
              e.onEvent && e.onEvent("register");
            }
          }
        )
      ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "div",
          {
            className: `my-auto ${e.isSideMenu ? "menu-item" : "mr-2 d-none d-md-block"}`,
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              "div",
              {
                className: `login-button ${e.platformMenu ? "primary-color font-weight-bold text-uppercase" : ""}`,
                onClick: () => {
                  e.onEvent && e.onEvent("login");
                },
                children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage$1, { id: "ds.nc-menu-auth.login" })
              }
            )
          }
        ),
        !e.isSideMenu && /* @__PURE__ */ jsxRuntimeExports.jsx(
          "div",
          {
            onClick: () => {
              e.onEvent && e.onEvent("register");
            },
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              Button$1,
              {
                label: t.formatMessage({ id: "ds.nc-menu-auth.register" }),
                theme: ButtonTheme.CUSTOM
              }
            )
          }
        )
      ] });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: `nc-menu-auth d-flex cursor-pointer ${e.isSideMenu ? "side-menu flex-column align-items-center" : "top-menu justify-content-center"}`,
      children: [
        e.user && !e.isSideMenu && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mx-auto", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "dropdown-header-menu", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "user d-flex pointer", children: [
            !e.hideUserInfo && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mr-2 d-sm-flex flex-column align-self-center nick-code-container mt-1 d-none", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "nickname text-elipsis", children: e.user.nickname }),
              /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "code", children: [
                "#",
                e.user.code
              ] })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              MemoProfileImage,
              {
                avatarId: e.avatarId || "0",
                isPremium: e.platformMenu || e.user.isPremium
              }
            )
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "position-fixed menu", children: /* @__PURE__ */ jsxRuntimeExports.jsx(NCDropdownMenu, { items: l }) })
        ] }) }),
        c()
      ]
    }
  );
}, MemoizedNCMenuAuth = React__default.memo(NCMenuAuth), MemoProfileImage = React__default.memo((e) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "profile-picture", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
  ProfilePicture,
  {
    avatarId: e.avatarId || "0",
    isPremium: e.isPremium
  }
) }));
MemoProfileImage.displayName = "profile-image";
const NCMenuLanguageSwitcher = (e) => {
  const [t, n] = useState(!1), o = () => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "d-flex w-100 justify-content-around", children: e.languages.map((l) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    NCLanguageIcon,
    {
      language: l,
      onClick: () => {
        e.onLanguageSelected && e.onLanguageSelected(l);
      }
    },
    l
  )) }), s = () => /* @__PURE__ */ jsxRuntimeExports.jsx(NCLanguageIcon, { language: e.selectedLanguage, onClick: () => n(!t) });
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "nc-menu-language-switcher", children: e.isSideMenu ? o() : s() });
}, NCCornerSideMenu$1 = "", NCCornerSideMenu = (e) => {
  const t = useRef(null);
  return useEffect(() => {
    const n = (o) => {
      e.isOpen && t.current && !t.current.contains(o.target) && e.setIsOpen(!1);
    };
    return document.addEventListener("click", n), () => {
      document.removeEventListener("click", n);
    };
  }, [t, e.isOpen, e.setIsOpen]), /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `nc-corner-side-menu d-flex flex-column ${e.isOpen ? "visible" : ""}`, ref: t, children: e.children });
}, NCCornerMenu$1 = "", NCCornerMenuVersion_1 = (e) => {
  var c, p, m, C, P;
  const t = useIntl(), [n, o] = useState(!1), s = (w) => {
    const R = t.messages[w.name] ? t.formatMessage({ id: w.name }) : w.name;
    return w.href.startsWith("/") ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      HashLink,
      {
        onClick: () => o(!1),
        smooth: !0,
        to: { pathname: w.href, hash: w.hash },
        children: R
      }
    ) : /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: w.href, children: R });
  }, l = (w) => {
    w.nativeEvent.stopImmediatePropagation(), o(!n);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "nc-corner-menu d-flex", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "top-menu-container d-none d-md-flex w-100 px-4", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "d-flex align-items-center", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(HashLink, { smooth: !0, to: { pathname: "/", hash: "#" }, className: "mr-4", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "img",
            {
              src: e.partnerLogo,
              className: "logo d-none d-lg-block",
              alt: "Partner Logo"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "img",
            {
              src: e.partnerLogoSmall,
              className: "logo d-lg-none",
              alt: "Partner Logo"
            }
          )
        ] }),
        !e.hideNcLogo && /* @__PURE__ */ jsxRuntimeExports.jsxs("a", { href: "https://next.wolfiesports.com", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "img",
            {
              src: e.ncLogo,
              className: "logo d-none d-lg-block",
              alt: "Nicecactus Logo"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "img",
            {
              src: e.ncLogoSmall,
              className: "logo d-lg-none",
              alt: "Nicecactus Logo"
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "menu-items d-flex align-items-center justify-content-center text-center", children: (c = e.menuItems) == null ? void 0 : c.map((w) => /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "mx-3", children: s(w) }, w.name)) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "menu-buttons d-flex align-items-center", children: [
        e.language && ((p = e.language.availlableLanguages) == null ? void 0 : p.length) > 1 && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "language-switcher mx-4", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            NCMenuLanguageSwitcher,
            {
              languages: e.language.availlableLanguages,
              selectedLanguage: e.language.selectedLanguage,
              onLanguageSelected: e.language.onLanguageSelected
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "position-fixed menu pt-2", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            NCDropdownMenu,
            {
              items: e.language.availlableLanguages.map((w) => ({
                name: w.toUpperCase(),
                onClick: () => {
                  var R;
                  return (R = e.language) == null ? void 0 : R.onLanguageSelected(w);
                }
              }))
            }
          ) })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          MemoizedNCMenuAuth,
          {
            user: e.user,
            onLogout: e.onLogout,
            onOpenDashboard: e.onOpenDashboard
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "d-md-none top-menu-container w-100 px-2 px-sm-3", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "d-flex align-items-center", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "div",
          {
            className: "side-menu-button cursor-pointer d-flex justify-content-center align-items-center",
            onClick: (w) => l(w),
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { icon: IconType.BurgerMenu })
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(NCCornerSideMenu, { isOpen: n, setIsOpen: o, children: [
          (m = e.menuItems) == null ? void 0 : m.map((w) => /* @__PURE__ */ jsxRuntimeExports.jsx(
            "div",
            {
              className: "menu-item d-flex justify-content-around",
              children: s(w)
            },
            w.name
          )),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            NCMenuAuth,
            {
              onAction: () => o(!1),
              isSideMenu: !0,
              user: e.user,
              onLogout: e.onLogout,
              onOpenDashboard: e.onOpenDashboard
            }
          ),
          e.language && ((P = (C = e.language) == null ? void 0 : C.availlableLanguages) == null ? void 0 : P.length) > 1 && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "nc-side-menu-language-container", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            NCMenuLanguageSwitcher,
            {
              languages: e.language.availlableLanguages,
              selectedLanguage: e.language.selectedLanguage,
              onLanguageSelected: e.language.onLanguageSelected,
              isSideMenu: !0
            }
          ) })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "d-flex justify-content-center", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(HashLink, { smooth: !0, to: { pathname: "/", hash: "#" }, className: "mx-3", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "img",
              {
                src: e.partnerLogo,
                className: "logo d-none d-lg-block",
                alt: "Partner Logo"
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "img",
              {
                src: e.partnerLogoSmall,
                className: "logo d-lg-none",
                alt: "Partner Logo"
              }
            )
          ] }),
          !e.hideNcLogo && /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "https://next.wolfiesports.com", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "img",
            {
              src: e.ncLogo,
              className: "logo",
              alt: "Nicecactus Logo"
            }
          ) })
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "menu-buttons" })
    ] })
  ] });
}, NCCornerMenuV2 = "", NCCornerMenuVersion_2 = (e) => {
  var c, p, m, C, P, w;
  const t = useIntl(), [n, o] = useState(!1), s = (R) => {
    const L = t.messages[R.name] ? t.formatMessage({ id: R.name }) : R.name;
    return R.href.startsWith("/") ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      HashLink,
      {
        onClick: () => o(!1),
        smooth: !0,
        to: { pathname: R.href, hash: R.hash },
        children: L
      }
    ) : /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: R.href, children: L });
  }, l = (R) => {
    R.nativeEvent.stopImmediatePropagation(), o(!n);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "nc-corner-menu-v2 d-flex", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "top-menu-container justify-content-between d-none d-xl-flex w-100", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "menu-logos d-flex align-items-center justify-content-start", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mr-1 my-auto", children: "Powered by" }),
        !e.hideNcLogo && /* @__PURE__ */ jsxRuntimeExports.jsxs("a", { href: "https://next.wolfiesports.com", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "img",
            {
              src: e.ncLogo,
              className: "logo d-none d-lg-block",
              alt: "Nicecactus Logo"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "img",
            {
              src: e.ncLogoSmall,
              className: "logo d-lg-none",
              alt: "Nicecactus Logo"
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "menu-items d-flex align-items-center justify-content-center text-center mx-auto", children: [
        e.menuItems && ((c = e.menuItems) == null ? void 0 : c.map((R, L) => /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: e.menuItems && e.menuItems.length / 2 > L && /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "menu-item-separator-left" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "menu-item mx-3", children: s(R) }, R.name)
        ] }) }, L))),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "menu-item-separator-left" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(HashLink, { smooth: !0, to: { pathname: "/", hash: "#" }, className: "mx-3", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "img",
            {
              src: e.partnerLogo,
              className: "logo d-none d-lg-block",
              alt: "Partner Logo"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "img",
            {
              src: e.partnerLogoSmall,
              className: "logo d-lg-none",
              alt: "Partner Logo"
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "menu-item-separator-right" }),
        e.menuItems && ((p = e.menuItems) == null ? void 0 : p.map((R, L) => /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: e.menuItems && e.menuItems.length / 2 <= L && /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "menu-item mx-3", children: s(R) }, R.name),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "menu-item-separator-right" })
        ] }) }, L)))
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "menu-buttons d-flex align-items-center justify-content-end", children: [
        e.language && ((m = e.language.availlableLanguages) == null ? void 0 : m.length) > 1 && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "language-switcher mx-4", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            NCMenuLanguageSwitcher,
            {
              languages: e.language.availlableLanguages,
              selectedLanguage: e.language.selectedLanguage,
              onLanguageSelected: e.language.onLanguageSelected
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "position-fixed menu pt-2", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            NCDropdownMenu,
            {
              items: e.language.availlableLanguages.map((R) => ({
                name: R.toUpperCase(),
                onClick: () => {
                  var L;
                  return (L = e.language) == null ? void 0 : L.onLanguageSelected(R);
                }
              }))
            }
          ) })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          MemoizedNCMenuAuth,
          {
            user: e.user,
            onLogout: e.onLogout,
            onOpenDashboard: e.onOpenDashboard
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "d-xl-none d-flex justify-content-between top-menu-container w-100 px-2 px-sm-3", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "d-flex align-items-center", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "div",
          {
            className: "side-menu-button cursor-pointer d-flex justify-content-center align-items-center mr-3",
            onClick: (R) => l(R),
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { icon: IconType.BurgerMenu })
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(NCCornerSideMenu, { isOpen: n, setIsOpen: o, children: [
          (C = e.menuItems) == null ? void 0 : C.map((R) => /* @__PURE__ */ jsxRuntimeExports.jsx(
            "div",
            {
              className: "menu-item d-flex justify-content-around",
              children: s(R)
            },
            R.name
          )),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            NCMenuAuth,
            {
              onAction: () => o(!1),
              isSideMenu: !0,
              user: e.user,
              onLogout: e.onLogout,
              onOpenDashboard: e.onOpenDashboard
            }
          ),
          e.language && ((w = (P = e.language) == null ? void 0 : P.availlableLanguages) == null ? void 0 : w.length) > 1 && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "nc-side-menu-language-container", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            NCMenuLanguageSwitcher,
            {
              languages: e.language.availlableLanguages,
              selectedLanguage: e.language.selectedLanguage,
              onLanguageSelected: e.language.onLanguageSelected,
              isSideMenu: !0
            }
          ) })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "d-flex justify-content-center align-items-center", children: [
          !e.hideNcLogo && /* @__PURE__ */ jsxRuntimeExports.jsxs("a", { href: "https://next.wolfiesports.com", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "img",
              {
                src: e.ncLogo,
                className: "logo d-none d-lg-block",
                alt: "Nicecactus Logo"
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "img",
              {
                src: e.ncLogoSmall,
                className: "logo d-lg-none",
                alt: "Nicecactus Logo"
              }
            )
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(HashLink, { smooth: !0, to: { pathname: "/", hash: "#" }, className: "mx-3", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "img",
              {
                src: e.partnerLogo,
                className: "logo d-none d-lg-block",
                alt: "Partner Logo"
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "img",
              {
                src: e.partnerLogoSmall,
                className: "logo d-lg-none",
                alt: "Partner Logo"
              }
            )
          ] })
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "menu-buttons" })
    ] })
  ] });
}, NCCornerMenu = (e) => {
  const t = () => {
    switch (e.variant) {
      case MenuVersion.CENTERED_LOGO:
        return /* @__PURE__ */ jsxRuntimeExports.jsx(NCCornerMenuVersion_2, { ...e });
      case MenuVersion.CLASSIC:
      default:
        return /* @__PURE__ */ jsxRuntimeExports.jsx(NCCornerMenuVersion_1, { ...e });
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: t() });
}, NCMultiMediaUpload$1 = "", NCMultiMediaUpload = ({ s3PublicUrl: e, images: t, actionHook: n }) => /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "multi-media-upload-container", children: t.map((o, s) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  NCMediaUpload,
  {
    labelImg: o.labelImg,
    currentImg: o.currentImg,
    disabled: o.disabled,
    maxSize: o.maxSize,
    zoneSize: o.zoneSize,
    noDrag: o.noDrag,
    noClick: o.noClick,
    mediaLibrary: o.mediaLibrary,
    actionHook: (l, c) => {
      n(o.typeImg, l, c);
    },
    s3PublicUrl: e
  },
  s
)) }) }), SearchBar$1 = "", SearchBar = (e) => {
  const [t, n] = useState(""), [o, s] = useState(
    Object.keys(e.searchFields)[0]
  ), [l, c] = useState(
    e.searchResult || {}
  );
  useEffect(() => {
    n(e.value || "");
  }, [e.value]);
  const p = (P) => {
    e.setOnKeyDown && e.setOnKeyDown(P), !e.overrideKeyDown && P.key === "Enter" && !e.hideStore && m();
  }, m = () => {
    if (e.disabled || !t)
      return;
    const P = t.trim();
    l[o] = P, c({ ...l }), e.setSearchResult && e.setSearchResult(l), e.actionHook && e.actionHook(l), n("");
  }, C = (P) => {
    if (delete l[P], c({ ...l }), e.setSearchResult && e.setSearchResult(l), e.actionHook) {
      if (e.actionHook.length) {
        e.actionHook(l);
        return;
      }
      e.actionHook();
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ThemeProvider, { theme: ThemePlatform, children: [
    !e.hideStore && Object.keys(l).length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "d-flex mt-2", children: Object.keys(l).map((P, w) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      Chip$1,
      {
        label: `${P}: ${l[P]}`,
        onDelete: () => C(P),
        color: "primary",
        className: "ml-2"
      },
      w
    )) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "d-flex w-100 position-relative searchbar-container", children: [
      Object.keys(e.searchFields).length > 1 && /* @__PURE__ */ jsxRuntimeExports.jsx(
        Select$1,
        {
          disabled: e.disabled,
          value: o,
          className: "mx-3",
          onChange: (P) => {
            s(P.target.value), e.onSelectChange && e.onSelectChange(P.target.value);
          },
          children: Object.keys(e.searchFields).map(
            (P, w) => /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem$1, { value: P, children: e.searchFields[P].label }, w)
          )
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        TextField$1,
        {
          value: t,
          placeholder: e.placeHolder,
          name: "searchBar",
          className: "w-100 searchbar-input",
          onChange: (P) => {
            const w = P.currentTarget.value;
            e.onChange && e.onChange(w), n(w), e.typingHook && e.typingHook(w);
          },
          onKeyDown: p,
          inputProps: { autoComplete: "off" },
          onFocus: () => {
            e.focusHook && e.focusHook(!0);
          },
          onBlur: () => {
            e.focusHook && e.focusHook(!1);
          },
          disabled: e.disabled
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          className: "search-button",
          style: {
            maskImage: "url(https://assets.next.wolfiesports.com/media/icons/search.svg)",
            WebkitMaskImage: "url(https://assets.next.wolfiesports.com/media/icons/search.svg)"
          },
          onClick: m
        }
      )
    ] })
  ] }) });
}, NCPreviewSearch$1 = "";
var observerMap = /* @__PURE__ */ new Map(), RootIds = /* @__PURE__ */ new WeakMap(), rootId = 0, unsupportedValue = void 0;
function getRootId(e) {
  return e ? (RootIds.has(e) || (rootId += 1, RootIds.set(e, rootId.toString())), RootIds.get(e)) : "0";
}
function optionsToId(e) {
  return Object.keys(e).sort().filter(
    (t) => e[t] !== void 0
  ).map((t) => `${t}_${t === "root" ? getRootId(e.root) : e[t]}`).toString();
}
function createObserver(e) {
  const t = optionsToId(e);
  let n = observerMap.get(t);
  if (!n) {
    const o = /* @__PURE__ */ new Map();
    let s;
    const l = new IntersectionObserver((c) => {
      c.forEach((p) => {
        var m;
        const C = p.isIntersecting && s.some((P) => p.intersectionRatio >= P);
        e.trackVisibility && typeof p.isVisible > "u" && (p.isVisible = C), (m = o.get(p.target)) == null || m.forEach((P) => {
          P(C, p);
        });
      });
    }, e);
    s = l.thresholds || (Array.isArray(e.threshold) ? e.threshold : [e.threshold || 0]), n = {
      id: t,
      observer: l,
      elements: o
    }, observerMap.set(t, n);
  }
  return n;
}
function observe(e, t, n = {}, o = unsupportedValue) {
  if (typeof window.IntersectionObserver > "u" && o !== void 0) {
    const m = e.getBoundingClientRect();
    return t(o, {
      isIntersecting: o,
      target: e,
      intersectionRatio: typeof n.threshold == "number" ? n.threshold : 0,
      time: 0,
      boundingClientRect: m,
      intersectionRect: m,
      rootBounds: m
    }), () => {
    };
  }
  const { id: s, observer: l, elements: c } = createObserver(n), p = c.get(e) || [];
  return c.has(e) || c.set(e, p), p.push(t), l.observe(e), function() {
    p.splice(p.indexOf(t), 1), p.length === 0 && (c.delete(e), l.unobserve(e)), c.size === 0 && (l.disconnect(), observerMap.delete(s));
  };
}
function useInView({
  threshold: e,
  delay: t,
  trackVisibility: n,
  rootMargin: o,
  root: s,
  triggerOnce: l,
  skip: c,
  initialInView: p,
  fallbackInView: m,
  onChange: C
} = {}) {
  var P;
  const [w, R] = React$2.useState(null), L = React$2.useRef(), [M, $] = React$2.useState({
    inView: !!p,
    entry: void 0
  });
  L.current = C, React$2.useEffect(
    () => {
      if (c || !w)
        return;
      let N;
      return N = observe(
        w,
        (B, K) => {
          $({
            inView: B,
            entry: K
          }), L.current && L.current(B, K), K.isIntersecting && l && N && (N(), N = void 0);
        },
        {
          root: s,
          rootMargin: o,
          threshold: e,
          // @ts-ignore
          trackVisibility: n,
          // @ts-ignore
          delay: t
        },
        m
      ), () => {
        N && N();
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      Array.isArray(e) ? e.toString() : e,
      w,
      s,
      o,
      l,
      c,
      n,
      m,
      t
    ]
  );
  const W = (P = M.entry) == null ? void 0 : P.target, H = React$2.useRef();
  !w && W && !l && !c && H.current !== W && (H.current = W, $({
    inView: !!p,
    entry: void 0
  }));
  const V = [R, M.inView, M.entry];
  return V.ref = V[0], V.inView = V[1], V.entry = V[2], V;
}
const NCPreviewSearch = (e) => {
  const [t, n] = useState(!1), [o, s] = useState(""), { ref: l, inView: c } = useInView();
  return useEffect(() => {
    e.value || s(""), c && e.scrollToBottomTriggerFunc && e.scrollToBottomTriggerFunc();
  }, [e.value, c]), /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider, { theme: ThemePlatform, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `nc-preview-search position-relative ${e.disabled ? "disabled" : ""}`, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      SearchBar,
      {
        searchFields: e.searchFields,
        placeHolder: e.placeHolder,
        hideStore: e.hideStore,
        focusHook: (p) => {
          setTimeout(() => n(p), p ? 0 : 200);
        },
        actionHook: e.actionHook,
        onChange: e.onChange,
        typingHook: (p) => s(p),
        value: e.value,
        disabled: e.disabled
      }
    ),
    t && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `preview-list position-absolute w-100 ${e.disabled ? "disabled" : ""}`, children: [
      e.list.filter((p) => p[e.displayParam].toLowerCase().indexOf(o.toLowerCase()) >= 0).map((p, m) => /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          className: `preview-item text-elipsis w-100 py-1 ${JSON.stringify(e.selected) === JSON.stringify(p) ? "selected" : ""} ${p.style ? p.style : ""}`,
          onClick: () => {
            e.onSelection(p);
          },
          children: p[e.displayParam]
        },
        m
      )),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: l })
    ] })
  ] }) }) });
}, NCMultiSearch = (e) => /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ThemeProvider, { theme: ThemePlatform, children: [
  e.selected.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "d-flex mb-2 row", children: e.list.filter((t) => e.selected.includes(t[e.displayParam])).map(
    (t, n) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mx-3 mb-1", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      NCChip,
      {
        disabled: e.disabled,
        label: t[e.displayParam],
        onChange: () => e.onDelete(t),
        deletion: !0,
        style: t.style
      }
    ) }, n)
  ) }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `nc-preview-search position-relative ${e.disabled ? "disabled" : ""}`, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    NCPreviewSearch,
    {
      searchFields: e.searchFields,
      placeHolder: e.placeHolder,
      hideStore: e.hideStore,
      focusHook: e.focusHook,
      typingHook: e.typingHook,
      onChange: e.onChange,
      actionHook: e.actionHook,
      list: e.hideSelected ? e.list.filter((t) => !e.selected.includes(t[e.displayParam])) : e.list,
      displayParam: e.displayParam,
      onSelection: (t) => {
        e.selected.includes(t[e.compareParam]) || e.onSelection(t);
      },
      value: e.value
    }
  ) })
] }) }), NCParticipantCardList$1 = "", NCParticipantCardList = (e) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "nc-participant-card-list px-4 scrollbar", children: e.list.map((t) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "participant-card px-4 mb-2 row", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "col-8 d-flex align-items-center", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      NCInput,
      {
        styleName: "input-style mr-4",
        value: t.score,
        onChange: (n) => {
          e.triggerOnChange(
            Object.assign(t, { score: Number(n) })
          );
        }
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ProfilePicture,
      {
        avatarId: t.id,
        isPremium: t.isPremium,
        size: 31
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mx-4", children: t.username })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "col-4 d-flex justify-content-end", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    "p",
    {
      className: "view-entry",
      onClick: () => {
        e.onClick && e.onClick(t);
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("u", { children: "view entry" })
    }
  ) })
] }, t.id)) }), TeamPicture$1 = "", TeamPicture = ({
  slug: e,
  size: t = 32
}) => {
  const n = "https://assets.next.wolfiesports.com/media/default/default-team-avatar.png";
  let o;
  if (t) {
    const s = t + "px";
    o = {
      minHeight: s,
      minWidth: s,
      maxHeight: s,
      maxWidth: s
    };
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "img",
    {
      className: "team-picture",
      style: o,
      src: `https://assets.next.wolfiesports.com/team/medias/${e}/ProfileImage?cache=${Date.now()}`,
      defaultValue: n,
      onError: (s) => s.currentTarget.src = n,
      alt: ""
    }
  );
}, MemoizedTeamPicture = React__default.memo(TeamPicture), NCParticipantList$1 = "", NCParticipantList = ({
  list: e,
  selected: t,
  winners: n = [],
  isLeaderboard: o
}) => {
  const s = useIntl(), [l, c] = useState(!1);
  return useEffect(() => {
    c(
      Math.max(
        ...e.filter((p) => p).map((p) => Object.keys(p.players).length)
      ) < 2
    );
  }, [e]), /* @__PURE__ */ jsxRuntimeExports.jsxs("table", { className: "table color-white nc-tournament-list", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("thead", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("tr", { children: [
      o && /* @__PURE__ */ jsxRuntimeExports.jsx("th", { scope: "col", children: s.formatMessage({ id: "tournament.match.position" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("th", { scope: "col", children: s.formatMessage({ id: "tournament.match.participant" }) }),
      o && /* @__PURE__ */ jsxRuntimeExports.jsx("th", { scope: "col", children: s.formatMessage({ id: "tournament.match.score" }) })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("tbody", { children: e.filter((p) => p).map((p, m) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "tr",
      {
        className: p.route === t ? "selected" : "",
        children: [
          o && /* @__PURE__ */ jsxRuntimeExports.jsxs("th", { scope: "row", children: [
            "#",
            m + 1
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("td", { className: "d-flex flex-row align-items-center", children: [
            l ? /* @__PURE__ */ jsxRuntimeExports.jsx(
              ProfilePicture,
              {
                avatarId: Object.keys(p.avatar)[0],
                isPremium: Object.values(p.isPremium)[0],
                size: 32
              }
            ) : /* @__PURE__ */ jsxRuntimeExports.jsx(TeamPicture, { slug: p.slug, size: 32 }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mx-2 my-auto", children: p.name }),
            n.includes(p.route) && /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { icon: IconType.Prize, width: 24, height: 24 })
          ] }),
          o && /* @__PURE__ */ jsxRuntimeExports.jsx("td", { children: p.score })
        ]
      },
      m
    )) })
  ] });
}, NCPartnerCard$1 = "", NCPartnerCard = (e) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "nc-partner-card-component", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("img", { className: "image", src: e.partner.image, alt: e.partner.name }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "text-elipsis name my-2", children: e.partner.name }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "social", children: e.partner.social && Object.keys(e.partner.social).map((t) => {
    const n = t ?? "";
    if (!n || !n.length)
      return;
    const o = Object.keys(IconType).find((s) => IconType[s] === t);
    if (o)
      return /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: n, target: "_blank", rel: "noopener noreferrer", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { icon: IconType[o], width: 18, height: 18 }) }, t);
  }) })
] }), useDynamicText = (e, t) => {
  const [o, s] = useState(""), [l, c] = useState(!1), [p, m] = useState(0), [C, P] = useState(0), w = () => {
    const R = p % e.length, L = e[R];
    s(l ? L.substring(0, o.length - 1) : L.substring(0, o.length + 1));
    let M = 300 - Math.random() * 100;
    l && (M /= 2), !l && o === L ? (M = 2e3, c(!0)) : l && o === "" && (c(!1), m(p + 1), M = 500), P(M);
  };
  return useEffect(() => {
    const R = setTimeout(w, C);
    return () => clearTimeout(R);
  }, [C]), o;
}, NCPremiumCTA$1 = "", NCPremiumCTA = (e) => {
  const t = useIntl(), n = useDynamicText(e.dynamicTextValues);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "position-relative p-0 overflow-hidden nc-premium-cta", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "image-container align-items-md-center justify-content-md-start align-items-start justify-content-center", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mask d-block position-absolute" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("img", { className: "w-100 mt-0 image-premium-cta", src: e.image })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        className: "d-flex flex-column flex-md-row align-items-center justify-content-end mx-3 mx-md-4 mt-5 mb-3 mt-md-3 text-center text-md-left",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "d-flex flex-column text mr-3", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "message", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "mr-1", children: e.dynamicText }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "dynamic", children: n })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "package-description my-3 my-md-0", children: e.staticText })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button$1,
            {
              styleClass: "premium-button",
              label: t.formatMessage({ id: "premium.go_premium" }),
              theme: ButtonTheme.PREMIUM,
              icon: { type: IconType.Premium, width: 24, height: 24 },
              setClick: () => e.setClick()
            }
          )
        ]
      }
    )
  ] });
}, NCPreviewSearchAsync$1 = "", NCPreviewSearchAsync = (e) => {
  const [t, n] = useState(!1), [o, s] = useState(""), [l, c] = useState(), [p, m] = useState(0), [C, P] = useState(!1), w = useRef(null), R = useRef(null), L = useRef([]), { ref: M, inView: $ } = useInView();
  useEffect(() => {
    $ && e.scrollToBottomTriggerFunc && e.scrollToBottomTriggerFunc();
  }, [$]), useEffect(() => {
    L.current = L.current.slice(0, e.list.length);
  }, [e.list]);
  const W = (N) => {
    var B, K, ue, de, ve, Te, Pe, Ce;
    if (N.key === "ArrowUp") {
      N.preventDefault();
      const Re = Math.max(0, p - 1), ke = ((B = L.current[Re]) == null ? void 0 : B.offsetTop) || 0;
      R.current && ke < R.current.scrollTop && ((ue = R.current) == null || ue.scrollTo(
        0,
        ((K = L.current[Re]) == null ? void 0 : K.offsetTop) || 0
      )), m(Re);
    }
    if (N.key === "ArrowDown") {
      N.preventDefault();
      const Re = Math.min(
        e.list.length - 1,
        p + 1
      ), ke = ((de = L.current[Re]) == null ? void 0 : de.offsetHeight) || 0, we = (((ve = L.current[Re]) == null ? void 0 : ve.offsetTop) || 0) + ke;
      R.current && we >= R.current.scrollTop + ((Te = R.current) == null ? void 0 : Te.offsetHeight) && ((Ce = R.current) == null || Ce.scrollTo(
        0,
        we - ((Pe = R.current) == null ? void 0 : Pe.offsetHeight)
      )), m(Re);
    }
    N.key === "Enter" && H();
  }, H = () => {
    o && e.list.length > 0 && (e.onSelection(e.list[p]), m(0), s(""));
  }, V = (N) => {
    n(!0), l && window.clearTimeout(l), c(
      window.setTimeout(() => {
        e.onType(N), n(!1);
      }, e.debounceOnType || 0)
    );
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    ThemeProvider,
    {
      theme: getTheme(e.theme || NCTheme.Platform),
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "div",
        {
          onBlur: () => P(!1),
          className: "nc-preview-search-async w-100 position-relative",
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              TextField$1,
              {
                id: e.id,
                inputRef: w,
                className: "w-100 nc-async-search-input",
                label: e.label,
                onClick: () => {
                  var N;
                  return (N = w.current) == null ? void 0 : N.focus();
                },
                onChange: (N) => {
                  V(N.currentTarget.value), s(N.currentTarget.value);
                },
                value: o,
                onKeyDown: W,
                onFocus: () => P(!0),
                onBlur: (N) => N.stopPropagation(),
                disabled: e.disabled
              }
            ),
            C && o.trim() && /* @__PURE__ */ jsxRuntimeExports.jsxs(
              "div",
              {
                ref: R,
                className: "preview-list position-absolute w-100",
                children: [
                  !t && !e.loading && e.list.map((N, B) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                    "div",
                    {
                      onMouseEnter: () => m(B),
                      ref: (K) => L.current[B] = K,
                      className: `preview-item py-1 ${p === B ? "selected" : ""}`,
                      onClick: () => H(),
                      children: N[e.displayParam]
                    },
                    B
                  )),
                  (t || e.loading) && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "preview-item py-1", children: e.loadingMessage || "Loading" }),
                  !t && !e.loading && o && e.list.length === 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "preview-item py-1", children: e.noResultMessage }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: M })
                ]
              }
            )
          ]
        }
      )
    }
  ) });
}, NCPromotionalBanner$1 = "", NCPromotionalBanner = (e) => {
  var o, s, l;
  const t = (o = e.text) != null && o.length ? useDynamicText(e.text) : void 0, n = () => {
    window.open(e.buttonLink, "_blank");
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: `nc-promo-banner ${e.buttonLink && !e.buttonText ? "clickable" : ""} ${!((s = e.buttonText) != null && s.length) && !((l = e.text) != null && l.length) && "full"}`,
      onClick: () => {
        e.buttonLink && !e.buttonText && n();
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(NCCard, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(NCBackgroundImage, { src: e.image }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "promo-content-container", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "promo-text", children: t }),
          e.buttonText && e.buttonLink && /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button$1,
            {
              label: e.buttonText,
              theme: ButtonTheme.CLASSIC,
              type: ButtonType.PRIMARY,
              size: ButtonSize.MEDIUM,
              setClick: n,
              styleClass: "promo-button"
            }
          )
        ] })
      ] })
    }
  );
}, NCPureAccordion$1 = "", NCPureAccordion = (e) => {
  const [t, n] = useState(!1), [o, s] = useState(0), l = useRef(null);
  return useEffect(() => {
    var c;
    l.current && s((c = l.current) == null ? void 0 : c.offsetHeight);
  }, [l]), /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `nc-pure-accordion ${e.className}`, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `accordion-title d-flex align-items-center px-3 cursor-pointer justify-content-between ${t ? "open" : ""}`, onClick: () => n(!t), children: [
      e.title,
      /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { icon: IconType.Colapse })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `accordion-content-container ${t ? "" : "closed"}`, style: { height: o }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "accordion-content px-4 py-2", ref: l, children: e.children }) })
  ] });
}, NCRadioGroup = (e) => /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider, { theme: ThemePlatform, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "d-flex w-100 position-relative nicecactus-input", children: /* @__PURE__ */ jsxRuntimeExports.jsx(RadioGroup$1, { "aria-label": "gender", name: "gender1", value: e.value, onChange: (t) => {
  e.actionHook(t.target.value);
}, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
  className: "d-flex flex-row flex-wrap",
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: e.fields.map((t, n) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    FormControlLabel$1,
    {
      control: /* @__PURE__ */ jsxRuntimeExports.jsx(Radio$1, {}),
      value: t.value,
      label: t.key,
      disabled: t.disabled,
      className: "nc-radio",
      id: "select-menu-item-" + n
    },
    n
  ))
}) }) }) }) }), NCReminderTools$1 = "", NCReminderTools = ({ text: e, reminderTools: t }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "nc-reminder-tools", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: e }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(NCNotificationButtons, { buttons: t })
] }), NCRoundsBracket$1 = "", STAGE_HEADERS = {
  classic: (e) => e === 1 ? "round.final" : `round.1_${Math.pow(2, e - 1)}`,
  loser_bracket: () => "round.loser",
  third_phase: () => "round.third_place",
  third_place: () => "round.third_place",
  classic_loser_final: () => "round.loser.final"
}, getStageHeader$1 = (e, t) => {
  var n;
  return (n = STAGE_HEADERS[t]) == null ? void 0 : n.call(STAGE_HEADERS, e);
}, NCRoundsBracket = (e) => {
  const t = e.mapRounds.sort(
    (n, o) => n.type.localeCompare(o.type) || o.index - n.index
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    NCMapRounds,
    {
      mapRounds: t,
      getStageHeader: getStageHeader$1,
      themeColor: e.themeColor
    }
  );
}, NCRoundsResult$1 = "", getStageHeader = (e) => e === 1 ? "round.final" : `round.1_${Math.pow(2, e - 1)}`, NCRoundsResult = (e) => {
  const t = e.mapRounds.sort(
    (n, o) => n.type.localeCompare(o.type) || n.index - o.index
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "nc-rounds-result", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "nc-rounds-result-header", children: e.resultHeader }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "rounds-container", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      NCMapRounds,
      {
        mapRounds: t,
        getStageHeader,
        themeColor: e.themeColor
      }
    ) })
  ] });
}, NCRoundsDoubleElimination$1 = "", NCRoundsDoubleElimination = (e) => {
  const { mapRounds: t, themeColor: n } = e, o = useIntl();
  function s(m) {
    return t.filter((C) => C.type === m);
  }
  const l = t.find((m) => m.type === "classic_loser_final"), c = s("classic"), p = s("loser_bracket");
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "nc-rounds-double-elimination", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "grand-final-container", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "grand-final-header", children: o.formatMessage({ id: "round.grand.final" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "grand-final-best-of", children: `Best of ${l == null ? void 0 : l.best_of_format}` })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rounds-result-container", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        NCRoundsResult,
        {
          resultHeader: o.formatMessage({
            id: "tournament.match.map.rounds.double_elim.winner"
          }),
          mapRounds: c,
          themeColor: n
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        NCRoundsResult,
        {
          resultHeader: o.formatMessage({
            id: "tournament.match.map.rounds.double_elim.loser"
          }),
          mapRounds: p,
          themeColor: n
        }
      )
    ] })
  ] });
}, NCScrollTopButton$1 = "", NCScrollTopButton = (e) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "div",
  {
    className: "scroll-top-button-container position-relative rounded-circle",
    style: { width: `${e.size}px`, height: `${e.size}px` },
    onClick: () => {
      e.actionHook(!0);
    },
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "circle high" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "sliding", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { icon: IconType.GoToPreviousPage }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "destination mt-2", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { icon: IconType.GoToPreviousPage }) })
    ]
  }
), ITEM_HEIGHT = 48, ITEM_PADDING_TOP = 8, MENU_DEFAULT_STYLE = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
}, NCSelect = (e) => {
  const [t, n] = useState(), { id: o, multiple: s, selectFields: l, selectedField: c, fieldName: p, fieldValue: m } = e, C = s ? e.menuProps ? e.menuProps : MENU_DEFAULT_STYLE : void 0;
  useEffect(() => {
    n(c || t);
  }, [c]);
  const P = (w) => t && Array.isArray(t) ? t.includes(w) : c && Array.isArray(c) ? c.includes(w) : !1;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider, { theme: ThemePlatform, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `d-flex w-100 position-relative ${e.styleName}`, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Select$1,
    {
      native: !s,
      multiple: s,
      disabled: e.disabled,
      value: t || (s ? [] : ""),
      className: "w-100 nicecactus-input",
      inputProps: { name: e.id, id: `select-${o}` },
      onChange: (w) => {
        const R = w.target.value === "null" ? void 0 : w.target.value;
        n(R), e.actionHook(R);
      },
      input: /* @__PURE__ */ jsxRuntimeExports.jsx(Input$1, {}),
      MenuProps: C,
      renderValue: (w) => {
        const R = w;
        return (R.length > 1 ? R.filter((M) => l.includes(M)) : R).join(", ");
      },
      children: s ? l.map(
        (w) => /* @__PURE__ */ jsxRuntimeExports.jsxs(MenuItem$1, { value: w, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Checkbox$1,
            {
              style: { color: nicecactus },
              checked: P(w)
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemText$1, { primary: w })
        ] }, w)
      ) : /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
        e.defaultOption && /* @__PURE__ */ jsxRuntimeExports.jsx(
          "option",
          {
            id: `select-${o}-option-item-default`,
            label: e.defaultOptionLabel || e.defaultOption.label,
            value: e.defaultOptionLabel || e.defaultOption.value || "null"
          },
          `select-${o}-option-item-default`
        ),
        l.sort(e.orderSelectFields).map(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (w, R) => {
            if (w) {
              const { name: L, value: M } = p && m ? { name: w[p], value: w[m] } : { name: w, value: w }, $ = w.disable ? w.disable : !1;
              return /* @__PURE__ */ jsxRuntimeExports.jsx(
                "option",
                {
                  id: `select-menu-item-${R}`,
                  disabled: $,
                  label: L,
                  value: M,
                  children: L
                },
                `select-${o}-option-${R}`
              );
            }
            return null;
          }
        )
      ] })
    }
  ) }) }) });
}, NCSelector$1 = "", NCSelector = (e) => /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider, { theme: getTheme(e.theme), children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "nicecactus-selector", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
  Select$1,
  {
    className: "w-100",
    disabled: e.disabled,
    value: e.selectedField,
    onChange: (t) => {
      e.actionHook && e.actionHook(t.target.value);
    },
    children: e.selectFields.map((t, n) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
      MenuItem$1,
      {
        value: t[e.fieldValue],
        className: "d-flex d-inline",
        children: [
          t[e.fieldImage] && /* @__PURE__ */ jsxRuntimeExports.jsx(
            "img",
            {
              className: "mr-2",
              src: `https://assets.next.wolfiesports.com/${t[e.fieldImage]}`,
              alt: "",
              height: 24,
              width: 24
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "d-inline", children: [
            e.fieldName,
            " ",
            t[e.fieldValue]
          ] })
        ]
      },
      n
    ))
  }
) }) }) }), NCSlider$1 = "", NCSliderBackground$1 = "", NCSliderBackground = (e) => {
  const t = e.height || 480, [n, o] = useState();
  return useEffect(() => {
    var l;
    let s = e.backgroundUrls || [];
    (l = e.content) != null && l.length && (!s || e.content.length > s.length) && (s = [...s, ...Array(e.content.length - ((s == null ? void 0 : s.length) || 0)).fill("")]), o(s);
  }, [e.backgroundUrls, e.content]), /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      ref: e.scrollableRef,
      className: "nc-slider-background",
      children: n && n.map((s, l) => /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          className: "slide-background",
          style: { backgroundImage: `url(${s})`, height: `${t}px` },
          children: e.content && e.content[l] && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "w-100 h-100", children: e.content[l] }, l)
        },
        `slide-${l}`
      ))
    }
  );
}, NCSliderSelector = (e) => {
  const t = React__default.createRef(), [n, o] = useState(), [s, l] = useState(0), [c, p] = useState(), [m, C] = useState(), [P, w] = useState(), [R, L] = useState(!1), [M, $] = useState(), W = e.height || 480, H = e.slideTimer || 2e3;
  useEffect(() => {
    l(e.selectedSlide ?? 0);
  }, [e.selectedSlide]), useEffect(() => {
    R || !e.autoplay || (ve(), Te());
  }, [s]), useEffect(() => {
    var Pe;
    V(e.scrollableRef), V(t), (Pe = e.goToSlide) == null || Pe.call(e, s);
  }, [s]), useEffect(() => {
    if (n && e.scrollableRef.current && e.scrollableRef.current.scrollLeft !== s * e.scrollableRef.current.clientWidth && p(s * e.scrollableRef.current.clientWidth), !n && e.scrollableRef.current) {
      const Pe = e.scrollableRef.current.clientWidth, Ce = e.scrollableRef.current.scrollLeft, Re = (c || 0) - Ce;
      Math.abs(Re) > Pe * 0.2 ? (ve(), l(s - Math.sign(Re))) : (V(e.scrollableRef), V(t));
    }
  }, [n]), useEffect(() => () => {
    clearTimeout(H);
  }, []);
  const V = (Pe) => {
    var Ce;
    return (Ce = Pe.current) == null ? void 0 : Ce.scrollTo({
      left: s * Pe.current.clientWidth,
      behavior: "smooth"
    });
  }, N = (Pe, Ce) => {
    var Re;
    return (Re = Pe.current) == null ? void 0 : Re.scrollBy({ left: Ce });
  }, B = (Pe) => {
    n && (N(e.scrollableRef, -Pe.movementX), N(t, -Pe.movementX));
  }, K = (Pe) => {
    if (!e.scrollableRef.current || !R)
      return;
    if (!m) {
      C(Pe.touches[0].pageX);
      return;
    }
    const Ce = Pe.touches[0];
    if (Ce) {
      const Re = e.scrollableRef.current.getBoundingClientRect();
      if (Ce.clientX < Re.left || Ce.clientX > Re.left + Re.width || Ce.clientY < Re.top || Ce.clientY > Re.top + Re.height) {
        de();
        return;
      }
    }
    m && (N(e.scrollableRef, m - Ce.pageX), N(t, m - Ce.pageX)), C(Ce.pageX);
  }, ue = () => {
    ve(), L(!0);
  }, de = () => {
    C(void 0), o(!1), L(!1), e.autoplay && (ve(), Te());
  }, ve = () => {
    P && clearTimeout(P);
  }, Te = () => {
    const Pe = setTimeout(() => {
      s + 1 < e.slideCount ? l(s + 1) : l(0);
    }, H);
    w(Pe);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: "nc-slider-selector d-flex position-relative",
      onMouseDown: () => {
        var Pe;
        p((Pe = e.scrollableRef.current) == null ? void 0 : Pe.scrollLeft), o(!0);
      },
      onMouseUp: () => o(!1),
      onMouseLeave: () => de(),
      onMouseEnter: () => ue(),
      onMouseMove: (Pe) => B(Pe),
      onTouchStart: () => {
        var Pe;
        p((Pe = e.scrollableRef.current) == null ? void 0 : Pe.scrollLeft), ue(), o(!0);
      },
      onTouchMove: (Pe) => K(Pe),
      onTouchEnd: () => de(),
      onDragStart: (Pe) => Pe.preventDefault(),
      style: { height: `${W}px` },
      children: [
        e.content && !!e.content.length && /* @__PURE__ */ jsxRuntimeExports.jsx(
          NCSliderBackground,
          {
            scrollableRef: t,
            content: e.content,
            height: e.height
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "slide-selector-container position-absolute mb-4 d-flex", children: [...Array(e.slideCount)].fill(1).map(
          (Pe, Ce) => /* @__PURE__ */ jsxRuntimeExports.jsx(
            "div",
            {
              className: `slide-selector-wrapper cursor-pointer ${Ce === s ? "active" : ""} ${e.style ?? ""}`,
              onMouseEnter: () => {
                e.color && $(Ce);
              },
              onMouseLeave: () => {
                e.color && $(void 0);
              },
              onClick: () => {
                ve(), l(Ce);
              },
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                "div",
                {
                  className: "slide-selector mx-1 my-2",
                  style: Ce === s || M === Ce ? { background: e.color } : {}
                }
              )
            },
            Ce
          )
        ) })
      ]
    }
  );
}, NCSlider = (e) => {
  const t = React__default.createRef(), [n, o] = useState();
  return useEffect(() => {
    var c, p;
    const s = Math.max(((c = e.contentSelector) == null ? void 0 : c.length) || 0, ((p = e.contentBackground) == null ? void 0 : p.length) || 0);
    let l = e.backgroundUrls;
    s > l.length && (l = [...l, ...Array(s - l.length).fill("")]), o(l);
  }, [e]), n != null && n.length ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "nc-slider-component position-relative", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      NCSliderSelector,
      {
        scrollableRef: t,
        slideCount: n.length,
        content: e.contentSelector,
        autoplay: e.autoplay,
        height: e.height,
        slideTimer: e.slideTimer
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "nc-slider-background position-absolute w-100", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      NCSliderBackground,
      {
        scrollableRef: t,
        backgroundUrls: n,
        content: e.contentBackground,
        height: e.height
      }
    ) })
  ] }) : null;
}, NCStepper$1 = "", NCStepper = (e) => /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider, { theme: ThemePlatform, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "nc-stepper d-flex align-items-center w-100", children: Array.from(Array(e.steps).keys()).map((t) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "div",
  {
    className: `step ${t + 1 === e.activeStep ? e.error ? "error" : "active" : t + 1 > e.activeStep ? "" : e.error && t === e.activeStep - 2 ? "done error-line" : "done"} d-flex flex-column align-items-center w-100`,
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "step-inner", children: [
        e.steps !== t + 1 && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: e.error && e.activeStep === t + 1 ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "px-1", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { icon: IconType.Warning, width: 16, height: 16 }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "step-circle" }) }),
        e.steps === t + 1 && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "success", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { icon: IconType.Success, width: 22, height: 22 }) })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "label text-center mt-1", children: e.stepsLabel[t] })
    ]
  },
  t
)) }) }) }), NCTextArea = (e) => /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider, { theme: ThemePlatform, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "d-flex w-100 position-relative nicecactus-input", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
  TextareaAutosize,
  {
    className: "w-100",
    placeholder: e.placeHolder,
    defaultValue: e.defaultValue,
    onChange: (t) => {
      e.actionHook(t.target.value);
    },
    minRows: e.minRows,
    maxRows: e.maxRows,
    disabled: e.disabled,
    value: e.value
  }
) }) }) }), NCTimePicker$1 = "", NC_TIME_PICKER_DEFAULT_LABEL = "--:--", NCTimePicker = (e) => {
  const [t, n] = useState(hooks()), [o, s] = useState(NC_TIME_PICKER_DEFAULT_LABEL), [l, c] = useState(5), [p, m] = useState(""), [C, P] = useState("");
  useEffect(() => {
    if (e.value)
      if (e.value === NC_TIME_PICKER_DEFAULT_LABEL)
        s(NC_TIME_PICKER_DEFAULT_LABEL);
      else {
        const W = hooks(e.value, "HH:mm");
        n(W), s(W.format("HH:mm"));
      }
  }, [e.value]);
  const w = (W) => {
    if (["Control", "Shift", "Tab", "Esc"].includes(W.key))
      return;
    if (m("caret-transparent"), /^[0-9]$/i.test(W.key)) {
      P("");
      let V;
      if (o.length === 5 && o[l] === ":") {
        V = o.slice(0, l + 1) + W.key + o.slice(l + 1);
        const K = (W.target.selectionStart || 0) + 1;
        W.target.setSelectionRange(K, K);
      } else if (o.length === 1 && o[l] === ":")
        V = W.key + "0:";
      else if (o.length < 4 && o[l] === ":")
        if (o[0] === ":" && Number(W.key) > 2) {
          V = "0" + W.key + o.slice(l);
          const K = hooks(V, "HH:mm");
          n(K), s(K.format("HH:mm"));
          return;
        } else
          V = o.slice(0, l + 1) + W.key + o.slice(l + 1);
      else
        o.length === l ? o[0] === ":" ? V = "00:" + W.key + o.slice(l) : V = o.slice(0, l) + W.key + "0" : V = o.slice(0, l) + W.key + o.slice(l);
      const N = hooks(V, "HH:mm");
      n(N), s(N.format("HH:mm"));
      const B = (W.target.selectionStart || 0) + 1;
      B < 6 && (W.target.setSelectionRange(B, B), c(B));
      return;
    }
    if (W.preventDefault(), ["ArrowUp", "ArrowDown"].includes(W.key)) {
      let V;
      if (l > 2)
        V = { minutes: l === 3 ? 10 : 1 };
      else {
        let N = 1;
        if (l === 0) {
          N = 10;
          const B = t.hours() + 10;
          W.key === "ArrowUp" ? B >= 30 ? N = 4 : B >= 24 && (N = 14) : B <= 13 ? N = 4 : B < 20 && (N = 14);
        }
        V = { hours: N };
      }
      P(""), W.target.setSelectionRange(l, l), W.key === "ArrowUp" ? n(t.add(V)) : n(t.subtract(V)), s(t.format("HH:mm"));
      return;
    }
    switch (W.key) {
      case "ArrowLeft": {
        if (C !== "")
          break;
        const V = (W.target.selectionStart || 0) - 1;
        V >= 0 && (W.target.setSelectionRange(V, V), c(V));
        break;
      }
      case "ArrowRight": {
        if (C !== "")
          break;
        const V = (W.target.selectionStart || 0) + 1;
        V < 6 && (W.target.setSelectionRange(V, V), c(V));
        break;
      }
      case "Backspace": {
        if (C !== "")
          break;
        const V = (W.target.selectionStart || 0) - 1;
        if (V < 0)
          break;
        if (W.target.setSelectionRange(V, V), c(V), o[l - 1] === ":") {
          const N = (W.target.selectionStart || 0) - 1;
          W.target.setSelectionRange(N, N), c(N), s(o.slice(0, l - 2) + ":" + o.slice(l));
        } else
          s(o.slice(0, l - 1) + o.slice(l));
        break;
      }
      case "Delete": {
        if (C !== "")
          break;
        if (o[l] === ":") {
          const V = (W.target.selectionStart || 0) + 1;
          W.target.setSelectionRange(V, V), c(V), s(o.slice(0, l) + ":" + o.slice(l + 2));
        } else
          s(o.slice(0, l) + o.slice(l + 1));
        break;
      }
    }
  }, R = (W) => {
    W.preventDefault(), W.target.setSelectionRange(l, l), m(""), e.onChange(o);
  }, L = (W) => {
    const H = W.target.selectionStart;
    H !== null && H >= 0 && c(H);
  }, M = (W) => {
    W.target.value.includes("Invalid date") && (P("invalid-time"), c(0), n(hooks())), e.onChange(W.target.value);
  }, $ = () => {
    const W = hooks(o, "HH:mm");
    W.format("HH:mm") === "Invalid date" ? o === NC_TIME_PICKER_DEFAULT_LABEL ? s("00:00") : (P("invalid-time"), s("invalid date"), c(0), n(hooks())) : W !== t && (n(W), s(W.format("HH:mm"))), e.onChange(o);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `nc-time-picker-container ${p} ${C}`, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      TextField$1,
      {
        type: "time-local",
        className: "time-picker-input nicecactus-input",
        value: o,
        label: e.label,
        onChange: M,
        onKeyDown: w,
        onClick: L,
        onKeyUp: R,
        onBlur: $,
        InputLabelProps: { shrink: !0 }
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { icon: IconType.Clock, width: 16, height: 16 })
  ] });
};
var __assign$2 = globalThis && globalThis.__assign || function() {
  return __assign$2 = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var s in t)
        Object.prototype.hasOwnProperty.call(t, s) && (e[s] = t[s]);
    }
    return e;
  }, __assign$2.apply(this, arguments);
}, eventPropTypes = {
  onActivate: propTypesExports.func,
  onAddUndo: propTypesExports.func,
  onBeforeAddUndo: propTypesExports.func,
  onBeforeExecCommand: propTypesExports.func,
  onBeforeGetContent: propTypesExports.func,
  onBeforeRenderUI: propTypesExports.func,
  onBeforeSetContent: propTypesExports.func,
  onBeforePaste: propTypesExports.func,
  onBlur: propTypesExports.func,
  onChange: propTypesExports.func,
  onClearUndos: propTypesExports.func,
  onClick: propTypesExports.func,
  onContextMenu: propTypesExports.func,
  onCommentChange: propTypesExports.func,
  onCopy: propTypesExports.func,
  onCut: propTypesExports.func,
  onDblclick: propTypesExports.func,
  onDeactivate: propTypesExports.func,
  onDirty: propTypesExports.func,
  onDrag: propTypesExports.func,
  onDragDrop: propTypesExports.func,
  onDragEnd: propTypesExports.func,
  onDragGesture: propTypesExports.func,
  onDragOver: propTypesExports.func,
  onDrop: propTypesExports.func,
  onExecCommand: propTypesExports.func,
  onFocus: propTypesExports.func,
  onFocusIn: propTypesExports.func,
  onFocusOut: propTypesExports.func,
  onGetContent: propTypesExports.func,
  onHide: propTypesExports.func,
  onInit: propTypesExports.func,
  onKeyDown: propTypesExports.func,
  onKeyPress: propTypesExports.func,
  onKeyUp: propTypesExports.func,
  onLoadContent: propTypesExports.func,
  onMouseDown: propTypesExports.func,
  onMouseEnter: propTypesExports.func,
  onMouseLeave: propTypesExports.func,
  onMouseMove: propTypesExports.func,
  onMouseOut: propTypesExports.func,
  onMouseOver: propTypesExports.func,
  onMouseUp: propTypesExports.func,
  onNodeChange: propTypesExports.func,
  onObjectResizeStart: propTypesExports.func,
  onObjectResized: propTypesExports.func,
  onObjectSelected: propTypesExports.func,
  onPaste: propTypesExports.func,
  onPostProcess: propTypesExports.func,
  onPostRender: propTypesExports.func,
  onPreProcess: propTypesExports.func,
  onProgressState: propTypesExports.func,
  onRedo: propTypesExports.func,
  onRemove: propTypesExports.func,
  onReset: propTypesExports.func,
  onSaveContent: propTypesExports.func,
  onSelectionChange: propTypesExports.func,
  onSetAttrib: propTypesExports.func,
  onSetContent: propTypesExports.func,
  onShow: propTypesExports.func,
  onSubmit: propTypesExports.func,
  onUndo: propTypesExports.func,
  onVisualAid: propTypesExports.func,
  onSkinLoadError: propTypesExports.func,
  onThemeLoadError: propTypesExports.func,
  onModelLoadError: propTypesExports.func,
  onPluginLoadError: propTypesExports.func,
  onIconsLoadError: propTypesExports.func,
  onLanguageLoadError: propTypesExports.func,
  onScriptsLoad: propTypesExports.func,
  onScriptsLoadError: propTypesExports.func
}, EditorPropTypes = __assign$2({ apiKey: propTypesExports.string, id: propTypesExports.string, inline: propTypesExports.bool, init: propTypesExports.object, initialValue: propTypesExports.string, onEditorChange: propTypesExports.func, value: propTypesExports.string, tagName: propTypesExports.string, cloudChannel: propTypesExports.string, plugins: propTypesExports.oneOfType([propTypesExports.string, propTypesExports.array]), toolbar: propTypesExports.oneOfType([propTypesExports.string, propTypesExports.array]), disabled: propTypesExports.bool, textareaName: propTypesExports.string, tinymceScriptSrc: propTypesExports.oneOfType([
  propTypesExports.string,
  propTypesExports.arrayOf(propTypesExports.string),
  propTypesExports.arrayOf(propTypesExports.shape({
    src: propTypesExports.string,
    async: propTypesExports.bool,
    defer: propTypesExports.bool
  }))
]), rollback: propTypesExports.oneOfType([propTypesExports.number, propTypesExports.oneOf([!1])]), scriptLoading: propTypesExports.shape({
  async: propTypesExports.bool,
  defer: propTypesExports.bool,
  delay: propTypesExports.number
}) }, eventPropTypes), isFunction = function(e) {
  return typeof e == "function";
}, isEventProp = function(e) {
  return e in eventPropTypes;
}, eventAttrToEventName = function(e) {
  return e.substr(2);
}, configHandlers2 = function(e, t, n, o, s, l, c) {
  var p = Object.keys(s).filter(isEventProp), m = Object.keys(l).filter(isEventProp), C = p.filter(function(w) {
    return l[w] === void 0;
  }), P = m.filter(function(w) {
    return s[w] === void 0;
  });
  C.forEach(function(w) {
    var R = eventAttrToEventName(w), L = c[R];
    n(R, L), delete c[R];
  }), P.forEach(function(w) {
    var R = o(e, w), L = eventAttrToEventName(w);
    c[L] = R, t(L, R);
  });
}, configHandlers = function(e, t, n, o, s) {
  return configHandlers2(
    s,
    e.on.bind(e),
    e.off.bind(e),
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    function(l, c) {
      return function(p) {
        var m;
        return (m = l(c)) === null || m === void 0 ? void 0 : m(p, e);
      };
    },
    t,
    n,
    o
  );
}, unique = 0, uuid = function(e) {
  var t = Date.now(), n = Math.floor(Math.random() * 1e9);
  return unique++, e + "_" + n + unique + String(t);
}, isTextareaOrInput = function(e) {
  return e !== null && (e.tagName.toLowerCase() === "textarea" || e.tagName.toLowerCase() === "input");
}, normalizePluginArray = function(e) {
  return typeof e > "u" || e === "" ? [] : Array.isArray(e) ? e : e.split(" ");
}, mergePlugins = function(e, t) {
  return normalizePluginArray(e).concat(normalizePluginArray(t));
}, isBeforeInputEventAvailable = function() {
  return window.InputEvent && typeof InputEvent.prototype.getTargetRanges == "function";
}, isInDoc = function(e) {
  if (!("isConnected" in Node.prototype)) {
    for (var t = e, n = e.parentNode; n != null; )
      t = n, n = t.parentNode;
    return t === e.ownerDocument;
  }
  return e.isConnected;
}, setMode = function(e, t) {
  e !== void 0 && (e.mode != null && typeof e.mode == "object" && typeof e.mode.set == "function" ? e.mode.set(t) : e.setMode(t));
}, __assign$1 = globalThis && globalThis.__assign || function() {
  return __assign$1 = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var s in t)
        Object.prototype.hasOwnProperty.call(t, s) && (e[s] = t[s]);
    }
    return e;
  }, __assign$1.apply(this, arguments);
}, injectScriptTag = function(e, t, n) {
  var o, s, l = e.createElement("script");
  l.referrerPolicy = "origin", l.type = "application/javascript", l.id = t.id, l.src = t.src, l.async = (o = t.async) !== null && o !== void 0 ? o : !1, l.defer = (s = t.defer) !== null && s !== void 0 ? s : !1;
  var c = function() {
    l.removeEventListener("load", c), l.removeEventListener("error", p), n(t.src);
  }, p = function(m) {
    l.removeEventListener("load", c), l.removeEventListener("error", p), n(t.src, m);
  };
  l.addEventListener("load", c), l.addEventListener("error", p), e.head && e.head.appendChild(l);
}, createDocumentScriptLoader = function(e) {
  var t = {}, n = function(c, p) {
    var m = t[c];
    m.done = !0, m.error = p;
    for (var C = 0, P = m.handlers; C < P.length; C++) {
      var w = P[C];
      w(c, p);
    }
    m.handlers = [];
  }, o = function(c, p, m) {
    var C = function(V) {
      return m !== void 0 ? m(V) : console.error(V);
    };
    if (c.length === 0) {
      C(new Error("At least one script must be provided"));
      return;
    }
    for (var P = 0, w = !1, R = function(V, N) {
      w || (N ? (w = !0, C(N)) : ++P === c.length && p());
    }, L = 0, M = c; L < M.length; L++) {
      var $ = M[L], W = t[$.src];
      if (W)
        W.done ? R($.src, W.error) : W.handlers.push(R);
      else {
        var H = uuid("tiny-");
        t[$.src] = {
          id: H,
          src: $.src,
          done: !1,
          error: null,
          handlers: [R]
        }, injectScriptTag(e, __assign$1({ id: H }, $), n);
      }
    }
  }, s = function() {
    for (var c, p = 0, m = Object.values(t); p < m.length; p++) {
      var C = m[p], P = e.getElementById(C.id);
      P != null && P.tagName === "SCRIPT" && ((c = P.parentNode) === null || c === void 0 || c.removeChild(P));
    }
    t = {};
  }, l = function() {
    return e;
  };
  return {
    loadScripts: o,
    deleteScripts: s,
    getDocument: l
  };
}, createScriptLoader = function() {
  var e = [], t = function(s) {
    var l = e.find(function(c) {
      return c.getDocument() === s;
    });
    return l === void 0 && (l = createDocumentScriptLoader(s), e.push(l)), l;
  }, n = function(s, l, c, p, m) {
    var C = function() {
      return t(s).loadScripts(l, p, m);
    };
    c > 0 ? setTimeout(C, c) : C();
  }, o = function() {
    for (var s = e.pop(); s != null; s = e.pop())
      s.deleteScripts();
  };
  return {
    loadList: n,
    reinitialize: o
  };
}, ScriptLoader = createScriptLoader(), getTinymce = function(e) {
  var t = e;
  return t && t.tinymce ? t.tinymce : null;
}, __extends = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(o, s) {
      o.__proto__ = s;
    } || function(o, s) {
      for (var l in s)
        Object.prototype.hasOwnProperty.call(s, l) && (o[l] = s[l]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function o() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (o.prototype = n.prototype, new o());
  };
}(), __assign = globalThis && globalThis.__assign || function() {
  return __assign = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var s in t)
        Object.prototype.hasOwnProperty.call(t, s) && (e[s] = t[s]);
    }
    return e;
  }, __assign.apply(this, arguments);
}, Editor = (
  /** @class */
  function(e) {
    __extends(t, e);
    function t(n) {
      var o, s, l, c = e.call(this, n) || this;
      return c.rollbackTimer = void 0, c.valueCursor = void 0, c.rollbackChange = function() {
        var p = c.editor, m = c.props.value;
        p && m && m !== c.currentContent && p.undoManager.ignore(function() {
          if (p.setContent(m), c.valueCursor && (!c.inline || p.hasFocus()))
            try {
              p.selection.moveToBookmark(c.valueCursor);
            } catch {
            }
        }), c.rollbackTimer = void 0;
      }, c.handleBeforeInput = function(p) {
        if (c.props.value !== void 0 && c.props.value === c.currentContent && c.editor && (!c.inline || c.editor.hasFocus()))
          try {
            c.valueCursor = c.editor.selection.getBookmark(3);
          } catch {
          }
      }, c.handleBeforeInputSpecial = function(p) {
        (p.key === "Enter" || p.key === "Backspace" || p.key === "Delete") && c.handleBeforeInput(p);
      }, c.handleEditorChange = function(p) {
        var m = c.editor;
        if (m && m.initialized) {
          var C = m.getContent();
          c.props.value !== void 0 && c.props.value !== C && c.props.rollback !== !1 && (c.rollbackTimer || (c.rollbackTimer = window.setTimeout(c.rollbackChange, typeof c.props.rollback == "number" ? c.props.rollback : 200))), C !== c.currentContent && (c.currentContent = C, isFunction(c.props.onEditorChange) && c.props.onEditorChange(C, m));
        }
      }, c.handleEditorChangeSpecial = function(p) {
        (p.key === "Backspace" || p.key === "Delete") && c.handleEditorChange(p);
      }, c.initialise = function(p) {
        var m, C, P;
        p === void 0 && (p = 0);
        var w = c.elementRef.current;
        if (w) {
          if (!isInDoc(w)) {
            if (p === 0)
              setTimeout(function() {
                return c.initialise(1);
              }, 1);
            else if (p < 100)
              setTimeout(function() {
                return c.initialise(p + 1);
              }, 100);
            else
              throw new Error("tinymce can only be initialised when in a document");
            return;
          }
          var R = getTinymce(c.view);
          if (!R)
            throw new Error("tinymce should have been loaded into global scope");
          var L = __assign(__assign({}, c.props.init), { selector: void 0, target: w, readonly: c.props.disabled, inline: c.inline, plugins: mergePlugins((m = c.props.init) === null || m === void 0 ? void 0 : m.plugins, c.props.plugins), toolbar: (C = c.props.toolbar) !== null && C !== void 0 ? C : (P = c.props.init) === null || P === void 0 ? void 0 : P.toolbar, setup: function(M) {
            c.editor = M, c.bindHandlers({}), c.inline && !isTextareaOrInput(w) && M.once("PostRender", function($) {
              M.setContent(c.getInitialValue(), { no_events: !0 });
            }), c.props.init && isFunction(c.props.init.setup) && c.props.init.setup(M);
          }, init_instance_callback: function(M) {
            var $, W, H = c.getInitialValue();
            c.currentContent = ($ = c.currentContent) !== null && $ !== void 0 ? $ : M.getContent(), c.currentContent !== H && (c.currentContent = H, M.setContent(H), M.undoManager.clear(), M.undoManager.add(), M.setDirty(!1));
            var V = (W = c.props.disabled) !== null && W !== void 0 ? W : !1;
            setMode(c.editor, V ? "readonly" : "design"), c.props.init && isFunction(c.props.init.init_instance_callback) && c.props.init.init_instance_callback(M);
          } });
          c.inline || (w.style.visibility = ""), isTextareaOrInput(w) && (w.value = c.getInitialValue()), R.init(L);
        }
      }, c.id = c.props.id || uuid("tiny-react"), c.elementRef = React$2.createRef(), c.inline = (l = (o = c.props.inline) !== null && o !== void 0 ? o : (s = c.props.init) === null || s === void 0 ? void 0 : s.inline) !== null && l !== void 0 ? l : !1, c.boundHandlers = {}, c;
    }
    return Object.defineProperty(t.prototype, "view", {
      get: function() {
        var n, o;
        return (o = (n = this.elementRef.current) === null || n === void 0 ? void 0 : n.ownerDocument.defaultView) !== null && o !== void 0 ? o : window;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.componentDidUpdate = function(n) {
      var o = this, s, l;
      if (this.rollbackTimer && (clearTimeout(this.rollbackTimer), this.rollbackTimer = void 0), this.editor && (this.bindHandlers(n), this.editor.initialized)) {
        if (this.currentContent = (s = this.currentContent) !== null && s !== void 0 ? s : this.editor.getContent(), typeof this.props.initialValue == "string" && this.props.initialValue !== n.initialValue)
          this.editor.setContent(this.props.initialValue), this.editor.undoManager.clear(), this.editor.undoManager.add(), this.editor.setDirty(!1);
        else if (typeof this.props.value == "string" && this.props.value !== this.currentContent) {
          var c = this.editor;
          c.undoManager.transact(function() {
            var m;
            if (!o.inline || c.hasFocus())
              try {
                m = c.selection.getBookmark(3);
              } catch {
              }
            var C = o.valueCursor;
            if (c.setContent(o.props.value), !o.inline || c.hasFocus())
              for (var P = 0, w = [m, C]; P < w.length; P++) {
                var R = w[P];
                if (R)
                  try {
                    c.selection.moveToBookmark(R), o.valueCursor = R;
                    break;
                  } catch {
                  }
              }
          });
        }
        if (this.props.disabled !== n.disabled) {
          var p = (l = this.props.disabled) !== null && l !== void 0 ? l : !1;
          setMode(this.editor, p ? "readonly" : "design");
        }
      }
    }, t.prototype.componentDidMount = function() {
      var n = this, o, s, l, c, p;
      if (getTinymce(this.view) !== null)
        this.initialise();
      else if (Array.isArray(this.props.tinymceScriptSrc) && this.props.tinymceScriptSrc.length === 0)
        (s = (o = this.props).onScriptsLoadError) === null || s === void 0 || s.call(o, new Error("No `tinymce` global is present but the `tinymceScriptSrc` prop was an empty array."));
      else if (!((l = this.elementRef.current) === null || l === void 0) && l.ownerDocument) {
        var m = function() {
          var P, w;
          (w = (P = n.props).onScriptsLoad) === null || w === void 0 || w.call(P), n.initialise();
        }, C = function(P) {
          var w, R;
          (R = (w = n.props).onScriptsLoadError) === null || R === void 0 || R.call(w, P);
        };
        ScriptLoader.loadList(this.elementRef.current.ownerDocument, this.getScriptSources(), (p = (c = this.props.scriptLoading) === null || c === void 0 ? void 0 : c.delay) !== null && p !== void 0 ? p : 0, m, C);
      }
    }, t.prototype.componentWillUnmount = function() {
      var n = this, o = this.editor;
      o && (o.off(this.changeEvents(), this.handleEditorChange), o.off(this.beforeInputEvent(), this.handleBeforeInput), o.off("keypress", this.handleEditorChangeSpecial), o.off("keydown", this.handleBeforeInputSpecial), o.off("NewBlock", this.handleEditorChange), Object.keys(this.boundHandlers).forEach(function(s) {
        o.off(s, n.boundHandlers[s]);
      }), this.boundHandlers = {}, o.remove(), this.editor = void 0);
    }, t.prototype.render = function() {
      return this.inline ? this.renderInline() : this.renderIframe();
    }, t.prototype.changeEvents = function() {
      var n, o, s, l = (s = (o = (n = getTinymce(this.view)) === null || n === void 0 ? void 0 : n.Env) === null || o === void 0 ? void 0 : o.browser) === null || s === void 0 ? void 0 : s.isIE();
      return l ? "change keyup compositionend setcontent CommentChange" : "change input compositionend setcontent CommentChange";
    }, t.prototype.beforeInputEvent = function() {
      return isBeforeInputEventAvailable() ? "beforeinput SelectionChange" : "SelectionChange";
    }, t.prototype.renderInline = function() {
      var n = this.props.tagName, o = n === void 0 ? "div" : n;
      return React$2.createElement(o, {
        ref: this.elementRef,
        id: this.id
      });
    }, t.prototype.renderIframe = function() {
      return React$2.createElement("textarea", {
        ref: this.elementRef,
        style: { visibility: "hidden" },
        name: this.props.textareaName,
        id: this.id
      });
    }, t.prototype.getScriptSources = function() {
      var n, o, s = (n = this.props.scriptLoading) === null || n === void 0 ? void 0 : n.async, l = (o = this.props.scriptLoading) === null || o === void 0 ? void 0 : o.defer;
      if (this.props.tinymceScriptSrc !== void 0)
        return typeof this.props.tinymceScriptSrc == "string" ? [{ src: this.props.tinymceScriptSrc, async: s, defer: l }] : this.props.tinymceScriptSrc.map(function(C) {
          return typeof C == "string" ? { src: C, async: s, defer: l } : C;
        });
      var c = this.props.cloudChannel, p = this.props.apiKey ? this.props.apiKey : "no-api-key", m = "https://cdn.tiny.cloud/1/".concat(p, "/tinymce/").concat(c, "/tinymce.min.js");
      return [{ src: m, async: s, defer: l }];
    }, t.prototype.getInitialValue = function() {
      return typeof this.props.initialValue == "string" ? this.props.initialValue : typeof this.props.value == "string" ? this.props.value : "";
    }, t.prototype.bindHandlers = function(n) {
      var o = this;
      if (this.editor !== void 0) {
        configHandlers(this.editor, n, this.props, this.boundHandlers, function(p) {
          return o.props[p];
        });
        var s = function(p) {
          return p.onEditorChange !== void 0 || p.value !== void 0;
        }, l = s(n), c = s(this.props);
        !l && c ? (this.editor.on(this.changeEvents(), this.handleEditorChange), this.editor.on(this.beforeInputEvent(), this.handleBeforeInput), this.editor.on("keydown", this.handleBeforeInputSpecial), this.editor.on("keyup", this.handleEditorChangeSpecial), this.editor.on("NewBlock", this.handleEditorChange)) : l && !c && (this.editor.off(this.changeEvents(), this.handleEditorChange), this.editor.off(this.beforeInputEvent(), this.handleBeforeInput), this.editor.off("keydown", this.handleBeforeInputSpecial), this.editor.off("keyup", this.handleEditorChangeSpecial), this.editor.off("NewBlock", this.handleEditorChange));
      }
    }, t.propTypes = EditorPropTypes, t.defaultProps = {
      cloudChannel: "6"
    }, t;
  }(React$2.Component)
);
const NCTinyMce = ({ id: e, apiKey: t, onChange: n, editorConfig: o, value: s, disabled: l, s3PublicUrl: c }) => {
  const [p, m] = React__default.useState(!1), C = (L) => {
    w.current.editor.insertContent(`<img src="${L.publicUrl}" alt="${L.name}" />`), m(!1);
  }, P = {
    height: 500,
    external_plugins: {
      ncmedialibrary: "https://esm-dev-public.s3.amazonaws.com/philippe/NCTinyMedia.js"
    },
    plugins: [
      "advlist autolink lists link image charmap print preview anchor",
      "searchreplace visualblocks code fullscreen",
      "insertdatetime media table code help wordcount"
    ],
    toolbar: "undo redo | copy paste | styleselect | bold italic underline | alignleft aligncenter alignright alignjustify | forecolor backcolor | bullist numlist outdent indent | removeformat | help ncmedialibrary",
    skin: "oxide-dark",
    content_css: "dark",
    file_picker_types: "image",
    init_instance_callback: (L) => {
      L.on("ExecCommand", (M) => {
        console.log("The " + M.command + " command was fired.", M);
      });
    },
    ...o
  }, w = useRef(null), R = "html";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Editor,
      {
        ref: w,
        id: e,
        onInit: (L, M) => M.mediaLibrary = () => m(!0),
        apiKey: t,
        init: P,
        value: s,
        onEditorChange: (L, M) => n(M.getContent({ format: R })),
        disabled: l ?? !1
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(NCDialog, { show: p, setShow: m, children: /* @__PURE__ */ jsxRuntimeExports.jsx(NCMediaLibrary, { s3PublicUrl: c, actionHook: C }) })
  ] });
}, NCToastContainer$1 = "", NCToastContainer = ({
  toastList: e,
  position: t,
  duration: n,
  onDeleteToast: o
}) => {
  const [s, l] = useState();
  useEffect(() => {
    l(e);
  }, [e]);
  const c = (p) => o(p);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `nc-toast-container-component ${t}`, children: s == null ? void 0 : s.map((p) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    NCToast,
    {
      toast: p,
      position: t,
      duration: n || 7e3,
      onDeleteToast: c
    },
    p.id
  )) });
}, NCDiscordGuild$1 = "", nFormatter = (e) => e > 9999 && e < 1e6 ? parseFloat((e / 1e3).toFixed(1)) + "K" : e > 1e6 ? parseFloat((e / 1e6).toFixed(1)) + "M" : String(e), NCDiscordGuild = (e) => {
  const { guild: t, membersCount: n } = e, o = useIntl(), s = `https://cdn.discordapp.com/icons/${t.id}/${t.icon}.png`, l = n ? `${nFormatter(n)} ${o.formatMessage({ id: "tournament.discord.members_count" })}` : null;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "nc-discord-guild", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("img", { className: "guild-icon", src: s }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "guild-info-container", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "guild-name", children: t.name.toLocaleLowerCase() }),
      l && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "guild-members", children: l })
    ] })
  ] }) });
}, NCInviteLink$1 = "", NCInviteLink = (e) => /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "nc-invitation-link", onClick: () => {
  window.open(e.link, "_blank");
}, children: e.children }) }), NCTournamentDiscord$1 = "", NCTournamentDiscord = (e) => {
  const { message: t, invites: n } = e;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "nc-tournament-discord", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "nc-join-discord-message", children: t }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `nc-invite-links-container ${n.length === 1 ? "one-invite" : ""}`, children: n.map((o) => {
      const { code: s, approximate_member_count: l } = o, c = `https://discord.com/invite/${s}`;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(NCInviteLink, { link: c, children: /* @__PURE__ */ jsxRuntimeExports.jsx(NCDiscordGuild, { guild: o.guild, membersCount: l }) }, `discord-invite-${s}`);
    }) })
  ] });
}, NCTournamentRounds$1 = "", MAP_ROUNDS_FORMATS = {
  [TournamentFormat.BRACKET]: (e) => /* @__PURE__ */ jsxRuntimeExports.jsx(NCRoundsBracket, { ...e }),
  [TournamentFormat.DOUBLE_ELIM]: (e) => /* @__PURE__ */ jsxRuntimeExports.jsx(NCRoundsDoubleElimination, { ...e })
}, renderTournamentRoundsContent = (e) => {
  var o;
  const { displayFormat: t, ...n } = e;
  return (o = MAP_ROUNDS_FORMATS[t]) == null ? void 0 : o.call(MAP_ROUNDS_FORMATS, { ...n });
}, NCTournamentRounds = (e) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "nc-tournament-rounds", children: renderTournamentRoundsContent(e) }), NCTrainingCard$1 = "", NCTrainingCard = (e) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "nc-training-card m-1", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mb-1", children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: e.image }) }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: e.name })
] }), PlatformList$1 = "";
var IconsPlatforms = /* @__PURE__ */ ((e) => (e.Ps4 = "ps4", e.Ps5 = "ps5", e.Mobile = "mobile", e.Pc = "pc", e.Switch = "switch", e.Xbox = "xbox", e.Pcmobile = "pc-mobile", e))(IconsPlatforms || {});
const PlatformList = ({
  platforms: e,
  onChange: t,
  singlePlatform: n,
  disabled: o = !1
}) => {
  const [s, l] = useState("Various"), [c, p] = useState("Pc"), [m, C] = useState(!1), [P, w] = useState(e), R = [];
  useEffect(() => {
    e.length > 0 && $();
  }, [e]);
  function L(H, V) {
    return Object.keys(H).find((N) => H[N] === V);
  }
  const M = (H) => n ? H !== void 0 ? e.map((V) => ({ ...V, checked: !1 })) : e : P, $ = (H) => {
    var B;
    let V = 0;
    const N = JSON.parse(JSON.stringify(M(H)));
    H !== void 0 && (N[H].checked = !N[H].checked);
    for (let K = 0; K < N.length; K++)
      N[K].checked && (V++, R.push(N[K]));
    if (V > 1)
      p("Pc"), l("Various");
    else {
      const K = ((B = N.find((de) => de.checked)) == null ? void 0 : B.id) || "", ue = L(IconsPlatforms, K) ?? "Pc";
      p(ue), l(K);
    }
    w(N);
  }, W = (H) => {
    n && ($(H), t(R));
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "platform-style ", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        className: "main-button p-2 d-flex align-items-center" + (m ? " color-border" : " d-none"),
        onClick: () => {
          o === !1 && C(!m);
        },
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            IconMask,
            {
              icon: `https://assets.next.wolfiesports.com/media/platforms/${IconsPlatforms[c]}.svg`,
              width: 20,
              height: 20,
              name: "platform",
              styleName: "icons-background"
            },
            IconsPlatforms[c]
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mx-auto", children: s }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            Icon,
            {
              icon: IconType.Colapse,
              width: 12,
              height: 6,
              styleName: "icons-background"
            }
          ) })
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: "platform-dropdown dropdown " + (m ? "" : "d-none"),
        children: P.map((H, V) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            className: `p-1 d-flex align-items-center ${n ? "select-div" : ""} `,
            onClick: () => W(V),
            children: [
              !n && /* @__PURE__ */ jsxRuntimeExports.jsx(
                NCCheckbox,
                {
                  checked: H.checked,
                  onChange: () => {
                    $(V), t(R);
                  }
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "ml-2", children: H.id })
            ]
          },
          V
        ))
      }
    )
  ] });
}, Tabs = (e) => {
  const [t, n] = useState(0), [o, s] = useState(0), l = useRef([]), c = useRef(null), p = useRef(null), m = useRef(null), [C, P] = useState(!1), [w, R] = useState(!1), [L, M] = useState(!1);
  useEffect(() => {
    l.current = l.current.slice(0, e.tabs.length);
  }, []), useEffect(() => {
    H();
  }, [m, c]), useEffect(() => {
    window.addEventListener("resize", H);
  }, []);
  const $ = (ue, de, ve) => (n(de), ve && s(ve), /* @__PURE__ */ jsxRuntimeExports.jsx("div", { onClick: () => e.nav(ue.path), children: "Root" })), W = () => {
    n(0), s(0);
  }, H = () => {
    !m.current || !c.current || (P(
      m.current.offsetWidth > c.current.offsetWidth
    ), V());
  }, V = () => {
    var ue;
    !p.current || !m.current || !c.current || (R(p.current.scrollLeft === 0), M(
      m.current.clientWidth - p.current.scrollLeft < ((ue = c.current) == null ? void 0 : ue.clientWidth)
    ));
  }, N = (ue) => {
    !p.current || !c.current || (p.current.scrollBy(
      ue ? c.current.clientWidth : -c.current.clientWidth || 0,
      0
    ), V());
  }, B = (ue, de = !1) => C ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: `mask-icon pagination-button mt-2 ${de ? "right ml-2" : "mr-2"} ${ue ? "disabled" : ""}`,
      style: {
        maskImage: "url(https://assets.next.wolfiesports.com/media/icons/goToPreviousPage.svg",
        WebkitMaskImage: "url(https://assets.next.wolfiesports.com/media/icons/goToPreviousPage.svg"
      },
      onClick: () => N(de)
    }
  ) : null, K = () => {
    var ue;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: "sub-tabs position-absolute",
        style: { left: o },
        children: e.tabs[t] && e.tabs[t].children && ((ue = e.tabs[t].children) == null ? void 0 : ue.map((de, ve) => !de.hide && /* @__PURE__ */ jsxRuntimeExports.jsx(
          "div",
          {
            className: `sub-tab ${de.disabled ? "disabled" : ""}`,
            onClick: () => {
              de.disabled || W(), !de.disabled && e.nav(e.tabs[t].path + de.path);
            },
            children: de.name
          },
          ve
        )))
      }
    );
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "tabs", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "tabs-body w-100", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { ref: c, className: "tabs-header d-flex mt-3 mb-2", children: [
    B(w),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        ref: p,
        className: "scrollable-container",
        onScroll: () => V(),
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { ref: m, className: "scrollable-items d-flex", children: [
          e.tabs.length > 0 && e.tabs.map((ue, de) => {
            if (ue.hide)
              return;
            const ve = e.basename ? ue.path.replace(":tournamentId", e.basename) : ue.path;
            return /* @__PURE__ */ jsxRuntimeExports.jsx(
              "div",
              {
                ref: (Te) => l.current[de] = Te,
                className: `tab-container d-flex justify-content-center align-items-center position-relative
                                                ${location.pathname.startsWith(
                  ve
                ) ? "active" : ""}
                                                ${ue.disabled ? "disabled" : ""}`,
                onClick: () => {
                  var Te;
                  ue.disabled || $(
                    ue,
                    de,
                    (Te = l.current[de]) == null ? void 0 : Te.offsetLeft
                  );
                },
                style: { color: e.color, borderColor: e.color },
                children: ue.children || ue.disabled ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "h-100 w-100", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "tab-name text-uppercase  mx-auto mt-2", children: ue.name }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "div",
                  {
                    onClick: () => e.nav(`${ve}?${e.location.search}`),
                    className: "h-100 w-100",
                    children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "tab-name text-uppercase  mx-auto mt-2", children: ue.name })
                  }
                )
              },
              ue.name
            );
          }),
          K()
        ] })
      }
    ),
    B(L, !0)
  ] }) }) });
}, TeamBackground = ({
  team: e
}) => {
  const t = "https://assets.next.wolfiesports.com/media/default/default-team-banner.png", n = `https://assets.next.wolfiesports.com/team/medias/${e}/BannerImage`;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: "background-image w-100 h-100 position-absolute",
      style: {
        backgroundImage: `url(${n}?${Date.now()}), url(${t})`
      }
    }
  );
}, MemoizedTeamBackground = React__default.memo(TeamBackground);
var SelectionType = /* @__PURE__ */ ((e) => (e.Close = "close", e.Selected = "selected", e))(SelectionType || {});
const TeamCard = (e) => {
  var l;
  const t = (c) => {
    e.hoverHook && e.hoverHook(c);
  };
  let n = 48;
  e.full && (n = e.xs ? 80 : 112);
  let o, s;
  return e.team.players && Object.keys(e.team.players).forEach((c) => {
    if (e.team.players[c].captain) {
      const p = e.team.players[c];
      s = p.name.slice(-4), o = p.name.slice(0, -5);
      return;
    }
  }), /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: `d-flex position-relative nc-team-card align-items-center
                ${e.xs ? "nc-team-card-xs" : "nc-team-card-lg"}
                ${e.full ? "full p-2" : ""}
                ${e.selectable ? "cursor-pointer pr-2" : "pr-3"}
                ${e.selected ? `card-selected-${e.selectable}` : ""}
            `,
      onMouseEnter: () => t(e.team.slug),
      onMouseLeave: () => t(void 0),
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "div",
          {
            className: "background-texture w-100 h-100 position-absolute",
            style: {
              backgroundImage: "url(https://assets.next.wolfiesports.com/media/shared-library/background/dialog-background.png)"
            }
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(MemoizedTeamBackground, { team: e.team.slug }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(MemoizedTeamPicture, { slug: e.team.slug, size: n }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            className: `d-flex flex-column details mt-1 ${e.full ? "full ml-3" : "ml-2"}`,
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "tag text-elipsis", children: [
                "[",
                e.team.tag,
                "]"
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "name text-elipsis", children: e.team.name }),
              e.full && o && s && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "captain text-elipsis d-flex align-items-center", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Icon,
                  {
                    styleName: "mr-2",
                    icon: IconType.Crown,
                    width: 12,
                    height: 12
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "name", children: o }),
                /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "code ml-1", children: [
                  "#",
                  s
                ] })
              ] }),
              e.date && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "text-elipsis d-flex align-items-center", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Icon,
                  {
                    styleName: "mr-2",
                    icon: IconType.Calendar,
                    width: 12,
                    height: 12
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "name", children: hooks(e.date).format("L") })
              ] }),
              e.teamSize && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "team-size", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { icon: IconType.People, width: 20, height: 20 }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "ml-2", children: ((l = e.team.teamInfo) == null ? void 0 : l.members) || Object.keys(e.team.players).length })
              ] })
            ]
          }
        ),
        e.selectable && e.selectable === "close" && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "ml-auto mt-2 d-flex align-self-start", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Icon,
          {
            styleName: `ml-2 ${e.selected ? "selected" : ""}`,
            icon: IconType.Close,
            width: 12,
            height: 12
          }
        ) })
      ]
    }
  );
}, TeamCardRounded$1 = "", TeamCardRounded = (e) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "div",
  {
    className: `team-card-rounded d-flex align-items-center grey-6 pr-2 ${e.onClick ? "clickable" : ""}`,
    onClick: () => {
      e.onClick && e.onClick(!0);
    },
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(MemoizedTeamPicture, { slug: e.team.slug, size: 24 }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "font-weight-bold tag", children: [
        "[",
        e.team.tag,
        "]"
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "text-elipsis", children: e.team.name })
    ]
  }
), TeamCardSearch$1 = "", TeamCardSearch = (e) => {
  const t = Object.entries(e.team.sn ?? {});
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: `team-card-search white d-flex align-items-center pr-2 ${e.onClick ? "clickable" : ""}`,
      onClick: () => {
        e.onClick && e.onClick();
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(MemoizedTeamPicture, { slug: e.team.slug, size: 64 }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "ml-3", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "d-flex", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "font-weight-bold tag mr-2", children: [
              "[",
              e.team.tag,
              "]"
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "text-elipsis", children: e.team.name })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "d-flex", children: [
            t.map(([n, o], s) => /* @__PURE__ */ jsxRuntimeExports.jsx(
              "a",
              {
                className: `mr-${s + 1 === t.length ? 4 : 2} network-link}`,
                href: o,
                target: "_blank",
                rel: "noopener noreferrer",
                onClick: (l) => l.stopPropagation(),
                children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { icon: IconType[n[0].toUpperCase() + n.slice(1)] || n, width: 22, height: 22 })
              },
              n
            )),
            (e.memberCount && e.memberCount > 0 || Object.keys(e.team.players).length > 0) && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "d-flex align-items-end", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { icon: IconType.People, width: 22, height: 22 }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "ml-2 members", children: e.memberCount ?? Object.keys(e.team.players).length })
            ] })
          ] })
        ] })
      ]
    }
  );
}, UserCard = (e) => {
  var R;
  const t = Object.values(TeamPermission).filter(
    (L) => typeof L == "number" && (!e.noOwnerChange || L !== TeamPermission.OWNER)
  ), [n, o] = useState(e.xs ? void 0 : e.permission), s = e.player.name.lastIndexOf("#"), l = s !== -1 ? e.player.name.slice(s) : "", c = s !== -1 ? e.player.name.slice(0, s) : e.player.name, p = (L) => {
    e.hoverHook && e.hoverHook(L);
  };
  let m;
  e.full ? m = e.xs ? 40 : 80 : m = e.xs ? 20 : 40;
  let C;
  e.player.premium ? typeof e.player.premium == "boolean" ? C = e.player.premium : C = ((R = e.player.premium) == null ? void 0 : R.status) === PremiumStatus.PREMIUM : C = !1;
  const P = () => {
    const L = !e.noOwnerChange || n !== TeamPermission.OWNER ? e.onPermissionChange : void 0;
    return typeof n == "number" ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "permission-selector-container mt-2", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider, { theme: ThemePlatform, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Select$1,
      {
        defaultValue: "",
        renderValue: (M) => w(M),
        value: n.toString(),
        className: "select",
        onClick: (M) => {
          L && M.stopPropagation();
        },
        onChange: (M) => {
          L && L(Number(M.target.value)), o(
            Number(M.target.value)
          );
        },
        disabled: e.disabled || !L,
        children: t && t.map((M, $) => /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem$1, { value: M, className: "menu-test", children: w(M) }, $))
      }
    ) }) }) : null;
  }, w = (L) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      style: {
        display: "flex",
        alignItems: "center"
      },
      className: `permission-container ${e.onClick ? "cursor-pointer" : void 0}`,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Icon,
          {
            icon: L === TeamPermission.OWNER ? IconType.Crown : L === TeamPermission.MANAGER ? IconType.People : IconType.User,
            width: e.xs ? 12 : 16,
            height: e.xs ? 12 : 16,
            color: grey6
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "div",
          {
            style: {
              marginLeft: "8px",
              textTransform: "capitalize"
            },
            className: "mt-auto mr-3",
            children: TeamPermission[L].toLowerCase()
          }
        )
      ]
    }
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: `d-flex nc-user-card position-relative align-items-center pl-2 pr-3
                ${e.xs ? "nc-user-card-xs" : "nc-user-card-lg"}
                ${e.full ? "full" : ""}
                ${C ? "premium" : ""}
                ${e.selectable ? "cursor-pointer pr-2" : "pr-3"}
                ${e.selected ? "user-card-selected" : ""}
                ${e.disabled ? "disabled" : ""}
                ${e.deletable ? "pr-4" : "pr-3"}
                ${e.onClick ? "cursor-pointer" : void 0}
            `,
      onMouseEnter: () => p(e.playerId),
      onMouseLeave: () => p(void 0),
      onClick: e.onClick,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "div",
          {
            className: "background-texture w-100 h-100 position-absolute",
            style: {
              backgroundImage: "url(https://assets.next.wolfiesports.com/media/shared-library/background/dialog-background.png)"
            }
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          MemoizedProfilePicture,
          {
            size: m,
            avatarId: e.player.avatar,
            isPremium: e.player.premium
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(MemoBackgroundImg, { bannerId: e.player.banner }),
        e.full && /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "div",
            {
              className: `d-flex flex-column details ${e.xs ? "details-xs ml-2" : "ml-3"}`,
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "name text-elipsis", children: c }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "code", children: l }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "account text-elipsis", children: e.player.account }),
                P()
              ]
            }
          ),
          C && /* @__PURE__ */ jsxRuntimeExports.jsx(
            Icon,
            {
              styleName: "position-absolute fixed-premium",
              icon: IconType.Premium,
              width: 14,
              height: 14
            }
          )
        ] }),
        !e.full && /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            className: `d-flex flex-row align-items-center details ${e.xs ? "details-xs ml-2" : "ml-3"} `,
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "text-elipsis", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "name", children: c }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "ml-2 code", children: l })
              ] }),
              C && /* @__PURE__ */ jsxRuntimeExports.jsx(
                Icon,
                {
                  styleName: "ml-2",
                  icon: IconType.Premium,
                  width: 14,
                  height: 14
                }
              )
            ]
          }
        ),
        e.deletable && /* @__PURE__ */ jsxRuntimeExports.jsx(
          Icon,
          {
            icon: IconType.Close,
            width: 13,
            height: 13,
            onClick: (L) => {
              L.stopPropagation(), e.onDelete && e.onDelete();
            }
          }
        )
      ]
    }
  );
}, MemoBackgroundImg = React__default.memo(({ bannerId: e }) => {
  const t = "https://assets.next.wolfiesports.com/media/default/default-user-banner.jpg", n = `https://assets.next.wolfiesports.com/media/assets/user/banner/${e}.png`;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: "background-image w-100 h-100 position-absolute",
      style: {
        backgroundImage: `url(${n}?cache=${Date.now()}), url(${t});`
      }
    }
  );
});
MemoBackgroundImg.displayName = "user-brackground-image";
const UserTeamCard$1 = "", UserTeamCard = (e) => {
  var n, o;
  const t = (s) => {
    e.hoverHook && e.hoverHook(s);
  };
  return e.team ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "user-team-card-component hovered-card text-center", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      onMouseEnter: () => t(
        e.isSolo ? Object.keys(e.team.players)[0] : e.team.slug
      ),
      onMouseLeave: () => t(void 0),
      className: "hovered-card text-center",
      style: {
        backgroundImage: "url(https://assets.next.wolfiesports.com" + (e.isSolo ? "/user/" + Object.keys(e.team.players)[0] + "/medias/BannerImage" : `/teams/${e.team.slug}/medias/BannerImage`) + "), url(https://assets.next.wolfiesports.com" + (e.isSolo ? "/media/default/default-user-banner.jpg" : "/media/default/default-team-banner.svg") + ")",
        backgroundSize: "cover",
        backgroundPosition: "top"
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "img",
          {
            className: `avatar mx-auto mb-2 mt-4 ${e.isSolo ? "solo" : "team"}`,
            src: e.isSolo ? "https://assets.next.wolfiesports.com/user/" + Object.keys(e.team.players)[0] + "/medias/ProfileImage" : `https://assets.next.wolfiesports.com/teams/${e.team.slug}/medias/ProfileImage`,
            onError: (s) => s.currentTarget.src = e.isSolo ? "https://assets.next.wolfiesports.com/media/default/default-user-avatar.svg" : "https://assets.next.wolfiesports.com/media/default/default-team-avatar.png",
            alt: ""
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "d-flex justify-content-center", children: [
          e.isSolo ? null : /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "color-grey5 font-weight-bold pr-2 text-uppercase", children: [
            "[",
            (n = e.team) == null ? void 0 : n.tag,
            "]"
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "color-white", children: (o = e.team) == null ? void 0 : o.name })
        ] }),
        e.isSolo ? null : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "user-grid mx-2 mt-2 mb-3", children: Object.keys(e.team.players).map((s) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "d-flex user-container mx-2 my-1", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "img",
            {
              className: "avatar",
              src: "https://assets.next.wolfiesports.com/user/" + s + "/medias/ProfileImage",
              onError: (l) => l.currentTarget.src = "https://assets.next.wolfiesports.com/media/default/default-user-avatar.svg",
              alt: ""
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "name my-auto mx-2", children: e.team.players[s].name })
        ] }, s)) }),
        e.isSolo ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mt-2 mb-3" }) : null
      ]
    }
  ) }) : null;
}, Pagination$1 = "";
function LeftArrowIcon(e) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "svg",
    {
      width: 12,
      height: 14,
      viewBox: "0 0 12 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M9 1L3 7l6 6", stroke: "#868C88" })
    }
  );
}
function RightArrowIcon(e) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "svg",
    {
      width: 12,
      height: 14,
      viewBox: "0 0 12 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M3 1l6 6-6 6", stroke: "#868C88" })
    }
  );
}
function SliderControlIcon(e) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "svg",
    {
      width: 8,
      height: 8,
      viewBox: "0 0 8 8",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { cx: 4, cy: 4, r: 4, fill: "#868C88" })
    }
  );
}
function SliderControlPrimaryIcon(e) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "svg",
    {
      width: 8,
      height: 8,
      viewBox: "0 0 8 8",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { cx: 4, cy: 4, r: 4, fill: "#B2F617" })
    }
  );
}
const Pagination = ({
  collectionSize: e,
  pageSize: t,
  page: n,
  setPage: o
}) => {
  const [s, l] = useState([]);
  useEffect(() => {
    l([...new Array(Math.ceil(e / t))]);
  }, [e]);
  const c = () => Math.ceil(e / t), p = () => {
    o(n === c() - 1 ? 1 : n - 1);
  }, m = () => {
    o(n === c() ? n : n + 1);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "pagination", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("i", { onClick: p, className: "pagination--chevron", children: /* @__PURE__ */ jsxRuntimeExports.jsx(LeftArrowIcon, {}) }),
    s.map((C, P) => n === P + 1 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      "i",
      {
        className: `pagination--circle ${n === P ? "active" : ""}`,
        onClick: () => o(P + 1),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(SliderControlPrimaryIcon, {})
      },
      P
    ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
      "i",
      {
        className: "pagination--circle",
        onClick: () => o(P + 1),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(SliderControlIcon, {})
      },
      P
    )),
    /* @__PURE__ */ jsxRuntimeExports.jsx("i", { className: "pagination--chevron", onClick: m, children: /* @__PURE__ */ jsxRuntimeExports.jsx(RightArrowIcon, {}) })
  ] });
}, TeamProfileCard$1 = "", TeamProfilePicture$1 = "";
var TeamPictureSize = /* @__PURE__ */ ((e) => (e.XS = "pico", e.SMALL = "small", e.LARGE = "large", e))(TeamPictureSize || {});
const TeamProfilePicture = (e) => {
  const [t, n] = useState();
  useEffect(() => {
    n(e.url);
  }, [e.url]);
  const o = e.size ?? "large";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: `ds-team-picture ${o} ${e.isOwner ? "owner" : ""}`,
      onMouseEnter: () => {
        e.onMouseOver && e.onMouseOver(!0);
      },
      onMouseLeave: () => {
        e.onMouseOver && e.onMouseOver(!1);
      },
      children: [
        e.children,
        t && /* @__PURE__ */ jsxRuntimeExports.jsx(
          "img",
          {
            className: "picture",
            src: t,
            onError: (s) => s.currentTarget.src = `${process.env.REACT_APP_S3_URL}/media/default/default-team-avatar.png`,
            alt: e.url
          }
        )
      ]
    }
  );
}, TeamProfileCard = ({
  backgroundImage: e,
  teamPicture: t,
  teamInformations: n,
  onClick: o
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { onClick: o, className: "ds-team-card", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "ds-team-card-background", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "img",
      {
        className: "ds-team-card-background-banner",
        src: e,
        onError: (s) => s.currentTarget.src = process.env.REACT_APP_S3_URL + "/media/default/default-team-banner.svg",
        alt: ""
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "ds-team-card-background-zone" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "ds-team-card-background-overlay" })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "ds-team-card-content", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(TeamProfilePicture, { url: t, size: TeamPictureSize.SMALL }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "ds-team-card-informations", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "ds-team-card-informations-game" }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "ds-team-card-informations-tag", children: [
        "[",
        n.tag,
        "]"
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "ds-team-card-informations-name", children: n.name }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "ds-team-card-informations-date", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Icon,
          {
            icon: IconType.Calendar,
            width: 24,
            height: 24
          }
        ),
        n.creationDate.toLocaleDateString()
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "ds-team-card-informations-owner", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Icon,
          {
            icon: IconType.Crown,
            width: 24,
            height: 24
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
          n.ownerName,
          /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
            "#",
            n.ownerCode
          ] })
        ] })
      ] })
    ] })
  ] })
] }), ProfileBanner$1 = "", ProfileBanner = (e) => {
  let t;
  if (e.size) {
    const o = e.size + "px";
    t = {
      minHeight: o,
      minWidth: o,
      maxHeight: o,
      maxWidth: o
    };
  }
  const n = () => e.bannerId ? `https://assets.next.wolfiesports.com/media/assets/user/banner/${e.bannerId}.png` : `https://assets.next.wolfiesports.com/media/assets/user/banner/0.png?cache=${Date.now()}`;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: `user-banner position-relative default 
      ${e.isOwner ? "owner" : ""}`,
      style: t,
      onMouseEnter: () => {
        e.onMouseOver && e.onMouseOver(!0);
      },
      onMouseLeave: () => {
        e.onMouseOver && e.onMouseOver(!1);
      },
      children: [
        e.children,
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "img",
          {
            className: "position-absolute",
            src: n(),
            alt: ""
          }
        )
      ]
    }
  );
};
React__default.memo(ProfileBanner);
const getMonth = (e, t) => {
  const n = /* @__PURE__ */ new Date();
  return n.setMonth(e), n.toLocaleString(t, { month: "long" });
}, getMonths = (e, t = "en") => e.map((n) => getMonth(n, t)), getAllMonths = (e = "en") => getMonths([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], e), sortByMonth = (e, t = "en") => {
  const n = getAllMonths(t);
  return e.sort(
    (o, s) => n.indexOf(o) - n.indexOf(s)
  );
};
function getTournamentSettings(e) {
  return (e == null ? void 0 : e.default) ?? (e == null ? void 0 : e[0]);
}
export {
  AuthForm,
  AuthFormDefaultTheme,
  AuthFormType,
  Button$1 as Button,
  ButtonIcon,
  ButtonSize,
  ButtonTheme,
  ButtonType,
  ByeCard,
  Chat,
  ContestType,
  DAYS_OF_WEEK,
  DatePicker,
  Dialog,
  DisplayFormat,
  DisplayList,
  DisplaySelector,
  FeatureLevel,
  FileManagerMode,
  FingerIndicator,
  FormattedDateTime,
  GameList,
  HostType,
  HoverUserTeamCard,
  Icon,
  IconMask,
  IconType,
  Media,
  MediaLibraryService,
  MenuVersion,
  Messages,
  Mode,
  NCAccordion,
  NCActions,
  NCAnimatedCardList,
  NCAssetNgDialog,
  NCBackgroundImage,
  NCBox,
  NCBreadcrumb,
  NCCard,
  NCCardList,
  NCCardLoading,
  NCChallengeCard,
  NCCheckbox,
  NCChip,
  NCColorPicker,
  NCColors,
  NCCookies,
  NCCookiesConsent,
  NCCornerCalendar,
  NCCornerCalendarV1,
  NCCornerMenu,
  NCCornerMenuVersion_1,
  NCCornerMenuVersion_2,
  NCCornerSideMenu,
  NCCountdown,
  NCDefault,
  NCDialog,
  NCDropZone,
  NCDropdown,
  NCDropdownMenu,
  NCFeedCard,
  NCFlagSelector,
  NCHoverCard,
  NCImage,
  NCInput,
  NCInputMultiple,
  NCLanguageIcon,
  NCLineUp,
  NCList,
  NCListTools,
  NCLoader,
  NCLottieAnimation,
  NCMapRounds,
  NCMatchPaused,
  NCMediaLibrary,
  NCMediaUpload,
  NCMenuAuth,
  NCMenuLanguageSwitcher,
  NCMultiMediaUpload,
  NCMultiSearch,
  NCNextSteps,
  NCNotificationButton,
  NCNotificationButtons,
  NCOverlappingTitle,
  NCParticipantCardList,
  NCParticipantList,
  NCPartnerCard,
  NCPremiumCTA,
  NCPreviewSearch,
  NCPreviewSearchAsync,
  NCProgressBar,
  NCPromotionalBanner,
  NCPureAccordion,
  NCRadioGroup,
  NCReminderTools,
  NCRound,
  NCRoundsBracket,
  NCRoundsDoubleElimination,
  NCRoundsResult,
  NCRow,
  NCScrollTopButton,
  NCSelect,
  NCSelector,
  NCSlider,
  NCSliderBackground,
  NCSliderSelector,
  NCStepBubble,
  NCStepper,
  NCSwitch,
  NCTabs,
  NCTextArea,
  NCTheme,
  NCThumbnail,
  NCTimePicker,
  NCTinyMce,
  NCTitle,
  NCToast,
  NCToastContainer,
  NCToastType,
  NCTournamentCard,
  NCTournamentDiscord,
  NCTournamentRounds,
  NCTrainingCard,
  NCTypography,
  NCWeeklyScheduling,
  NC_TIME_PICKER_DEFAULT_LABEL,
  NgService,
  NoGame,
  OptionalFieldType,
  Pagination,
  PlatformList,
  PremiumStatus,
  ProfileBanner,
  ProfilePicture,
  RegistrationError,
  RewardDistribution,
  RewardKind,
  ScoreType,
  SearchBar,
  SeedingType,
  SelectionType,
  SocialEnum,
  Tabs,
  TeamBackground,
  TeamCard,
  TeamCardRounded,
  TeamCardSearch,
  TeamPermission,
  TeamPicture,
  TeamPictureSize,
  TeamProfileCard,
  TeamProfilePicture,
  TextArea,
  ThemeGrey,
  ThemePlatform,
  ToastModel,
  ToastPosition,
  Tournament,
  TournamentCardStyle,
  TournamentFee,
  TournamentFormat,
  TournamentState,
  TournamentUtilsService,
  UserCard,
  UserCardRounded,
  UserCardRoundedSize,
  UserTeamCard,
  convertSimilarTournamentToTournamentCard,
  convertToDaysOfWeek,
  convertTournamentPublicInfoToTournamentCard,
  convertTournamentToTournamentCard,
  flatRewards,
  formatDateTime,
  getAllMonths,
  getDaysOfWeek,
  getMinutesFromTime,
  getMonth,
  getMonths,
  getTheme,
  getTimeFromMinutes,
  getTournamentSettings,
  rewardsToString,
  sortByMonth,
  useDynamicText,
  useIcon,
  useProgressBar
};
